class Va {
  /**
   * Gets a valid input type, format and other input properties from schema.
   * @param schema The property schema based on which the input is created.
   * @param propertyName Name of property or null if the input is not created from a property, but from model directly.
   * @param dataBindingPath Path for the data model.
   * Default is "form": The current form. Could be a a longer path e.g. "form.result.employerCalc"
   */
  static getInputMetadata(e, t, n = "form") {
    t = t || "";
    const i = {
      name: t,
      path: null,
      type: e.type,
      format: e.format,
      isEnum: !1
    };
    switch (i.path = i.name ? n ? n + "." + i.name : i.name : n, i.type) {
      case "number":
      case "integer":
      case "boolean":
      case "object":
      case "array":
        break;
      case "string":
        i.isEnum = (e.enum?.length ?? 0) > 0;
        break;
      default:
        return i.type = "error", i.content = `Unhandled data type '${i.type}', format '${i.format}' in '${t || "no property name"}'.`, i;
    }
    return i;
  }
  /**
   * Gets the necessary metadata for generating the inputs for the specified model of type "object".
   * If the schema is not of type "object", returns null.
   * @param schema Schema for which the user interface is generated.
   * @param dataBindingPath Path for the data model.
   * Default is "form": The current form. Could be a a longer path e.g. "form.result.employerCalc"
   */
  static getInputsForObject(e, t = "form") {
    if (e.type === "object")
      return Object.keys(e.properties ?? {}).map((n) => this.getInputMetadata(e, n, t));
  }
  /**
   * Gets input for the schema itself.
   * @param schema Schema for which the input component is generated.
   * @param propertyName Property name in relation to schema. This may be used in language versioning / texts.
   * @param dataBindingPath Path for the data binding within the form.
   */
  static getInputForSelf(e, t, n) {
    return this.getInputMetadata(e, t, n);
  }
  /**
   * Gets the necessary metadata for generating the inputs for the array items.
   * If the schema is not of type "array", returns null.
   * @param schema Schema for which the user interface is generated.
   * @param dataBindingPath Path for the data binding within the form.
   */
  static getInputsForArray(e, t) {
    if (e.type === "array")
      return Va.getInputsForObject(e.items, t) || [Va.getInputForSelf(e.items, void 0, t)];
  }
}
var yi = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Authorization_code = "authorization_code", a.Password = "password", a.Client_credentials = "client_credentials", a.Refresh_token = "refresh_token", a.JwtBearer = "jwtBearer", a))(yi || {}), vi = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Code = "code", a.Token = "token", a))(vi || {}), fi = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Bearer = "bearer", a.Mac = "mac", a))(fi || {}), gi = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Invalid_request = "invalid_request", a.Unauthorized_client = "unauthorized_client", a.Access_denied = "access_denied", a.Unsupported_response_type = "unsupported_response_type", a.Invalid_scope = "invalid_scope", a.Server_error = "server_error", a.Temporarily_unavailable = "temporarily_unavailable", a))(gi || {}), bi = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Sign_in = "sign_in", a.Sign_up = "sign_up", a))(bi || {}), ji = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.DoNotShow = "doNotShow", a.Employment = "employment", a.Insurance = "insurance", a.Salary = "salary", a.Examples = "examples", a.PalkkausGeneral = "palkkausGeneral", a.PalkkausInstructions = "palkkausInstructions", a.Blog = "blog", a.Press = "press", a.PersonEmployer = "personEmployer", a.HouseholdEmployer = "householdEmployer", a.Worker = "worker", a.Employee = "employee", a.Entrepreneur = "entrepreneur", a.Association = "association", a.BusinessOwner = "businessOwner", a.ProductLongDescription = "productLongDescription", a.DocumentTemplates = "documentTemplates", a.InstructionsAndExamples = "instructionsAndExamples", a))(ji || {}), wa = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.UnpaidLeave = "unpaidLeave", a.PersonalReason = "personalReason", a.Illness = "illness", a.PartTimeSickLeave = "partTimeSickLeave", a.ParentalLeave = "parentalLeave", a.SpecialMaternityLeave = "specialMaternityLeave", a.Rehabilitation = "rehabilitation", a.ChildIllness = "childIllness", a.PartTimeChildCareLeave = "partTimeChildCareLeave", a.Training = "training", a.JobAlternationLeave = "jobAlternationLeave", a.StudyLeave = "studyLeave", a.IndustrialAction = "industrialAction", a.InterruptionInWorkProvision = "interruptionInWorkProvision", a.LeaveOfAbsence = "leaveOfAbsence", a.MilitaryRefresherTraining = "militaryRefresherTraining", a.MilitaryService = "militaryService", a.LayOff = "layOff", a.ChildCareLeave = "childCareLeave", a.MidWeekHoliday = "midWeekHoliday", a.AccruedHoliday = "accruedHoliday", a.OccupationalAccident = "occupationalAccident", a.AnnualLeave = "annualLeave", a.PartTimeAbsenceDueToRehabilitation = "partTimeAbsenceDueToRehabilitation", a.Other = "other", a))(wa || {}), Si = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.UnlinkedPrimaryPartner = "unlinkedPrimaryPartner", a.UnlinkedAccountingOnly = "unlinkedAccountingOnly", a.PendingPrimaryPartner = "pendingPrimaryPartner", a.PrimaryPartner = "primaryPartner", a.None = "none", a))(Si || {}), Ti = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Procountor = "procountor", a.VismaNetvisor = "vismaNetvisor", a.VismaFivaldi = "vismaFivaldi", a))(Ti || {}), xi = /* @__PURE__ */ ((a) => (a.Default = "default", a.Accounting = "accounting", a.PeriodicInvoices = "periodicInvoices", a.AccountingAndPeriodicInvoices = "accountingAndPeriodicInvoices", a.IrReports = "irReports", a.AccountingAndIrReports = "accountingAndIrReports", a.PeriodicInvoicesAndIrReports = "periodicInvoicesAndIrReports", a.AccountingAndPeriodicInvoicesAndIrReports = "accountingAndPeriodicInvoicesAndIrReports", a))(xi || {}), Ei = /* @__PURE__ */ ((a) => (a.Debit = "debit", a.Credit = "credit", a.Total = "total", a.GroupHeader = "groupHeader", a.GroupTotal = "groupTotal", a.ChildRow = "childRow", a))(Ei || {}), ba = /* @__PURE__ */ ((a) => (a.Classic = "classic", a.Simple = "simple", a.Mapped = "mapped", a))(ba || {}), Ai = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.OwnedTarget = "ownedTarget", a.ProductTarget = "productTarget", a.SharedTarget = "sharedTarget", a))(Ai || {}), qt = /* @__PURE__ */ ((a) => (a.A = "a", a.B = "b", a.C = "c", a.U = "u", a))(qt || {}), Zt = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.Age_15 = "age_15", a.Age16 = "age16", a.Age17 = "age17", a.Age18_52 = "age18_52", a.Age53_62 = "age53_62", a.Age63_64 = "age63_64", a.Age65_67 = "age65_67", a.Age68AndOVer = "age68AndOVer", a))(Zt || {}), Pi = /* @__PURE__ */ ((a) => (a.MealAllowance = "mealAllowance", a.PartialDailyAllowance = "partialDailyAllowance", a.FullDailyAllowance = "fullDailyAllowance", a.InternationalDailyAllowance = "internationalDailyAllowance", a.TaxExemptReimbursementsAbroad = "taxExemptReimbursementsAbroad", a))(Pi || {}), Ce = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Planned = "planned", a.ManualSalary = "manualSalary", a.ManualCompensation = "manualCompensation", a.ManualBonus = "manualBonus", a.PaidCalc = "paidCalc", a.DraftCalc = "draftCalc", a))(Ce || {}), wi = /* @__PURE__ */ ((a) => (a.Ignored = "ignored", a.Success = "success", a.Warning = "warning", a.Error = "error", a))(wi || {}), Fi = /* @__PURE__ */ ((a) => (a.Ignored = "ignored", a.Success = "success", a.Warning = "warning", a.Error = "error", a))(Fi || {}), ya = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.AccountBase = "accountBase", a.CompanyAccount = "companyAccount", a.PersonAccount = "personAccount", a.WorkerAccount = "workerAccount", a.Certificate = "certificate", a.SessionUserCredential = "sessionUserCredential", a.Onboarding = "onboarding", a.Profile = "profile", a.Calculation = "calculation", a.CalculationPaid = "calculationPaid", a.ESalaryPayment = "eSalaryPayment", a.Payment = "payment", a.EarningsPayment = "earningsPayment", a.Employment = "employment", a.WorkerAbsences = "workerAbsences", a.HolidayYear = "holidayYear", a.Taxcard = "taxcard", a.PayrollDetails = "payrollDetails", a.Invoice = "invoice", a.Report = "report", a.BlobFile = "blobFile", a.PayerSummary = "payerSummary", a.CalendarEvent = "calendarEvent", a.Usecase = "usecase", a.Dataset = "dataset", a.Article = "article", a.MessageThread = "messageThread", a.EmailMessage = "emailMessage", a.AccountProducts = "accountProducts", a.VarmaPensionOrder = "varmaPensionOrder", a.IfInsuranceOrder = "ifInsuranceOrder", a.Historical = "historical", a))(ya || {}), Di = /* @__PURE__ */ ((a) => (a.Default = "default", a.UserFriendly = "userFriendly", a))(Di || {}), ka = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Calculation = "calculation", a.CalculationPaid = "calculationPaid", a.Dataset = "dataset", a.PayrollDetails = "payrollDetails", a.Invoice = "invoice", a.EarningsPaymentReport = "earningsPaymentReport", a.PayerSummaryReport = "payerSummaryReport", a.Employment = "employment", a.MessageThread = "messageThread", a.CalendarEvent = "calendarEvent", a.ListItems = "listItems", a))(ka || {}), Ae = /* @__PURE__ */ ((a) => (a.General = "general", a.Required = "required", a.Invalid = "invalid", a.Warning = "warning", a))(Ae || {}), Ci = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.EmailPwdLocal = "emailPwdLocal", a.Facebook = "facebook", a.Google = "google", a.Microsoft = "microsoft", a.LinkedIn = "linkedIn", a.Auth0Database = "auth0Database", a.X509 = "x509", a.Salaxy = "salaxy", a.Test = "test", a.WebAuthn = "webAuthn", a.MicrosoftOAuth = "microsoftOAuth", a.GoogleOAuth = "googleOAuth", a.InternalLocalhost = "internalLocalhost", a))(Ci || {}), Ii = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.OK = "oK", a.AccessDenied = "accessDenied", a.ExpiredOauthToken = "expiredOauthToken", a.InvalidOAuthToken = "invalidOAuthToken", a.NoOauthToken = "noOauthToken", a))(Ii || {}), Li = /* @__PURE__ */ ((a) => (a.None = "none", a.EmployerAuthorization = "employerAuthorization", a.WorkerContract = "workerContract", a.CompanyContract = "companyContract", a.PartnerContract = "partnerContract", a.Manual = "manual", a.Temporary = "temporary", a))(Li || {}), We = /* @__PURE__ */ ((a) => (a.Icon = "icon", a.Uploaded = "uploaded", a.Gravatar = "gravatar", a))(We || {}), Mi = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.Error = "error", a.PaytrailBatch = "paytrailBatch", a.NetvisorPayment = "netvisorPayment", a.SalaryGrossPayment = "salaryGrossPayment", a.RefundPayment = "refundPayment", a.PartialRefundPayment = "partialRefundPayment", a.DoubleRefundPayment = "doubleRefundPayment", a.TransferToEcfaPayment = "transferToEcfaPayment", a.InsuranceGrossPayment = "insuranceGrossPayment", a.NetSalary = "netSalary", a.SalaryAdvance = "salaryAdvance", a.NetSalaryRepayment = "netSalaryRepayment", a.NetSalaryCorrection = "netSalaryCorrection", a.TaxAccount = "taxAccount", a.Tvr = "tvr", a.TvrRfnd = "tvrRfnd", a.PalkkausFees = "palkkausFees", a.BankFees = "bankFees", a.PaytrailFees = "paytrailFees", a.InsuranceLahiTapiola = "insuranceLahiTapiola", a.Tyel = "tyel", a.TyelEteraContract = "tyelEteraContract", a.TyelEteraTemp = "tyelEteraTemp", a.TyelEteraUnknown = "tyelEteraUnknown", a.TyelEloContract = "tyelEloContract", a.TyelEloTemp = "tyelEloTemp", a.TyelEloInitialImport = "tyelEloInitialImport", a.TyelVarmaContract = "tyelVarmaContract", a.TyelVarmaTemp = "tyelVarmaTemp", a.TyelIlmarinenContract = "tyelIlmarinenContract", a.TyelIlmarinenTemp = "tyelIlmarinenTemp", a.Union = "union", a.UnionRaksa = "unionRaksa", a.Foreclosure = "foreclosure", a.SaldoYearBegin = "saldoYearBegin", a.SaldoYearEnd = "saldoYearEnd", a))(Mi || {}), Ni = /* @__PURE__ */ ((a) => (a.AccommodationBenefit = "accommodationBenefit", a.TelephoneBenefit = "telephoneBenefit", a.MealBenefit = "mealBenefit", a.OtherBenefits = "otherBenefits", a))(Ni || {}), Oi = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.AuthorizationPdf = "authorizationPdf", a.Avatar = "avatar", a.TaxCard = "taxCard", a.ExpensesReceipt = "expensesReceipt", a.Raksaloki = "raksaloki", a.Template = "template", a.EInvoice = "eInvoice", a.Temporary = "temporary", a.Settings = "settings", a.Messages = "messages", a.Record = "record", a.MonthlyReport = "monthlyReport", a.YearlyReport = "yearlyReport", a.CalcReport = "calcReport", a))(Oi || {}), Ri = /* @__PURE__ */ ((a) => (a.UserFiles = "userFiles", a.VersionHistory = "versionHistory", a.SystemFiles = "systemFiles", a.Payload = "payload", a.Reports = "reports", a.CdnImages = "cdnImages", a.Iam = "iam", a.GitContent = "gitContent", a.FileSystemContent = "fileSystemContent", a))(Ri || {}), Ke = /* @__PURE__ */ ((a) => (a.Default = "default", a.Primary = "primary", a.Success = "success", a.Info = "info", a.Warning = "warning", a.Danger = "danger", a))(Ke || {}), Bi = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.BaseSalary = "baseSalary", a.SalaryAdditions = "salaryAdditions", a.Benefits = "benefits", a.Expenses = "expenses", a.Deductions = "deductions", a.OtherNoPayment = "otherNoPayment", a.Totals = "totals", a.Disabled = "disabled", a))(Bi || {}), Vi = /* @__PURE__ */ ((a) => (a.Exclude = "exclude", a.PensionInsurance = "pensionInsurance", a.AccidentInsurance = "accidentInsurance", a.UnemploymentInsurance = "unemploymentInsurance", a.HealthInsurance = "healthInsurance", a.InsurancesDeduction = "insurancesDeduction", a.NoTax = "noTax", a.Tax = "tax", a.TaxDeduction = "taxDeduction", a.CfNoPayment = "cfNoPayment", a.CfPayment = "cfPayment", a.CfDeduction = "cfDeduction", a.CfDeductionAtSalaxy = "cfDeductionAtSalaxy", a))(Vi || {}), Ki = /* @__PURE__ */ ((a) => (a.Default = "default", a.Worker = "worker", a.Employer = "employer", a.Employment = "employment", a.Taxcard = "taxcard", a.Insurances = "insurances", a))(Ki || {}), Ui = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.TotalBenefits = "totalBenefits", a.TotalExpenses = "totalExpenses", a.TotalSocialSecurityEmployer = "totalSocialSecurityEmployer", a.TotalSocialSecurityEmployerDebt = "totalSocialSecurityEmployerDebt", a.TotalSocialSecurityEmployerPayment = "totalSocialSecurityEmployerPayment", a.TotalPension = "totalPension", a.TotalPensionPayment = "totalPensionPayment", a.TotalPensionEmployer = "totalPensionEmployer", a.TotalPensionEmployerDebt = "totalPensionEmployerDebt", a.TotalPensionWorker = "totalPensionWorker", a.TotalUnemployment = "totalUnemployment", a.TotalUnemploymentPayment = "totalUnemploymentPayment", a.TotalUnemploymentEmployer = "totalUnemploymentEmployer", a.TotalUnemploymentEmployerDebt = "totalUnemploymentEmployerDebt", a.TotalUnemploymentWorker = "totalUnemploymentWorker", a.TotalPalkkaus = "totalPalkkaus", a.TotalSalary = "totalSalary", a.TotalTax = "totalTax", a.TotalTaxPayment = "totalTaxPayment", a.TotalPayment = "totalPayment", a.TotalWorkerPayment = "totalWorkerPayment", a.TotalService = "totalService", a))(Ui || {}), pa = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Disabled = "disabled", a.ManualRow = "manualRow", a.WorktimeImport = "worktimeImport", a.PriceEmployment = "priceEmployment", a.PriceCompany = "priceCompany", a.CopyEmployment = "copyEmployment", a.CopyCompany = "copyCompany", a.CustomRowtype = "customRowtype", a))(pa || {}), k = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.Salary = "salary", a.HourlySalary = "hourlySalary", a.MonthlySalary = "monthlySalary", a.TotalWorkerPayment = "totalWorkerPayment", a.TotalEmployerPayment = "totalEmployerPayment", a.Compensation = "compensation", a.Overtime = "overtime", a.TesWorktimeShortening = "tesWorktimeShortening", a.EveningAddition = "eveningAddition", a.NightimeAddition = "nightimeAddition", a.SaturdayAddition = "saturdayAddition", a.SundayWork = "sundayWork", a.OtherAdditions = "otherAdditions", a.PaidSickLeaveSalary = "paidSickLeaveSalary", a.PaidSickLeaveHourlySalary = "paidSickLeaveHourlySalary", a.PaidSickLeaveMonthlySalary = "paidSickLeaveMonthlySalary", a.TrainingSalary = "trainingSalary", a.TrainingHourlySalary = "trainingHourlySalary", a.TrainingMonthlySalary = "trainingMonthlySalary", a.AccomodationBenefit = "accomodationBenefit", a.MealBenefit = "mealBenefit", a.PhoneBenefit = "phoneBenefit", a.CarBenefit = "carBenefit", a.BicycleBenefit = "bicycleBenefit", a.OtherBenefit = "otherBenefit", a.HolidayCompensation = "holidayCompensation", a.HolidayBonus = "holidayBonus", a.HolidaySalary = "holidaySalary", a.DailyAllowance = "dailyAllowance", a.DailyAllowanceHalf = "dailyAllowanceHalf", a.MealCompensation = "mealCompensation", a.MilageOwnCar = "milageOwnCar", a.ToolCompensation = "toolCompensation", a.Expenses = "expenses", a.MilageDaily = "milageDaily", a.MilageOther = "milageOther", a.UnionPayment = "unionPayment", a.Foreclosure = "foreclosure", a.Advance = "advance", a.ForeclosureByPalkkaus = "foreclosureByPalkkaus", a.PrepaidExpenses = "prepaidExpenses", a.OtherDeductions = "otherDeductions", a.DeductibleOfExerciseAndCultureBenefit = "deductibleOfExerciseAndCultureBenefit", a.ChildCareSubsidy = "childCareSubsidy", a.ChainsawReduction = "chainsawReduction", a.NonProfitOrg = "nonProfitOrg", a.SubsidisedCommute = "subsidisedCommute", a.IrIncomeType = "irIncomeType", a.Board = "board", a.Remuneration = "remuneration", a.OtherCompensation = "otherCompensation", a.WorkingTimeCompensation = "workingTimeCompensation", a.EmploymentTermination = "employmentTermination", a.HourlySalaryWithWorkingTimeCompensation = "hourlySalaryWithWorkingTimeCompensation", a.PaidSickLeave = "paidSickLeave", a.Training = "training", a.TaxAtSource = "taxAtSource", a.TaxWithholding = "taxWithholding", a.AbsencePeriod = "absencePeriod", a.ServiceCharge = "serviceCharge", a.Service = "service", a.Totals = "totals", a))(k || {}), G = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Count = "count", a.Percent = "percent", a.Days = "days", a.Kilometers = "kilometers", a.Hours = "hours", a))(G || {}), ia = /* @__PURE__ */ ((a) => (a.Draft = "draft", a.PaymentStarted = "paymentStarted", a.PaymentSucceeded = "paymentSucceeded", a.PaymentCanceled = "paymentCanceled", a.PaymentError = "paymentError", a.PaymentWorkerCopy = "paymentWorkerCopy", a.WorkerRequested = "workerRequested", a.WorkerRequestAccepted = "workerRequestAccepted", a.WorkerRequestDeclined = "workerRequestDeclined", a.PaymentRefunded = "paymentRefunded", a.PaymentRepaired = "paymentRepaired", a.WaitingApproval = "waitingApproval", a.PayrollDraft = "payrollDraft", a.Repair = "repair", a.ProDraft = "proDraft", a.SharedWaiting = "sharedWaiting", a.SharedApproved = "sharedApproved", a.SharedRejected = "sharedRejected", a.History = "history", a.Template = "template", a))(ia || {}), Hi = /* @__PURE__ */ ((a) => (a.All = "all", a.Readonly = "readonly", a.Editable = "editable", a.Sent = "sent", a.Shared = "shared", a.Received = "received", a.Error = "error", a))(Hi || {}), Wi = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Display = "display", a.Email = "email", a.Audio = "audio", a.CreateItem = "createItem", a.Script = "script", a.PaymentDate = "paymentDate", a))(Wi || {}), Yi = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Cancelled = "cancelled", a.Confirmed = "confirmed", a.Tentative = "tentative", a.NeedsAction = "needsAction", a.Completed = "completed", a.InProcess = "inProcess", a))(Yi || {}), $i = /* @__PURE__ */ ((a) => (a.LimitedCarBenefit = "limitedCarBenefit", a.FullCarBenefit = "fullCarBenefit", a))($i || {}), Gi = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.FiOy = "fiOy", a.FiTm = "fiTm", a.FiRy = "fiRy", a.FiYy = "fiYy", a))(Gi || {}), Ka = /* @__PURE__ */ ((a) => (a.Person = "person", a.CustomContact = "customContact", a))(Ka || {}), fa = /* @__PURE__ */ ((a) => (a.Default = "default", a.WorkerAccount = "workerAccount", a.EmployerOverride = "employerOverride", a.Foreign = "foreign", a))(fa || {}), Ji = /* @__PURE__ */ ((a) => (a.None = "none", a.Calculation = "calculation", a.Row = "row", a.Hidden = "hidden", a))(Ji || {}), Ua = /* @__PURE__ */ ((a) => (a.Fi = "fi", a.Ae = "ae", a.At = "at", a.Ba = "ba", a.Bg = "bg", a.By = "by", a.Cn = "cn", a.De = "de", a.Eg = "eg", a.Fr = "fr", a.Gg = "gg", a.Hr = "hr", a.Ie = "ie", a.In = "in", a.Je = "je", a.Kr = "kr", a.Lk = "lk", a.Lv = "lv", a.Me = "me", a.Mx = "mx", a.No = "no", a.Pk = "pk", a.Rs = "rs", a.Sg = "sg", a.Th = "th", a.Tr = "tr", a.Us = "us", a.Vg = "vg", a.Zm = "zm", a.Am = "am", a.Au = "au", a.Bb = "bb", a.Bm = "bm", a.Ca = "ca", a.Cy = "cy", a.Dk = "dk", a.Es = "es", a.Gb = "gb", a.Gr = "gr", a.Hu = "hu", a.Il = "il", a.Is = "is", a.Jp = "jp", a.Ky = "ky", a.Lt = "lt", a.Ma = "ma", a.Mk = "mk", a.My = "my", a.Nz = "nz", a.Pl = "pl", a.Ru = "ru", a.Si = "si", a.Tj = "tj", a.Tz = "tz", a.Uy = "uy", a.Vn = "vn", a.Ar = "ar", a.Az = "az", a.Be = "be", a.Br = "br", a.Ch = "ch", a.Cz = "cz", a.Ee = "ee", a.Ge = "ge", a.Hk = "hk", a.Id = "id", a.Im = "im", a.It = "it", a.Kg = "kg", a.Kz = "kz", a.Lu = "lu", a.Md = "md", a.Mt = "mt", a.Nl = "nl", a.Ph = "ph", a.Ro = "ro", a.Se = "se", a.Sk = "sk", a.Tm = "tm", a.Ua = "ua", a.Uz = "uz", a.Za = "za", a.Other = "other", a))(Ua || {}), zi = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Forecast = "forecast", a.Preview = "preview", a.WaitingPalkkaus = "waitingPalkkaus", a.Unread = "unread", a.Read = "read", a.PaymentStarted = "paymentStarted", a.Warning = "warning", a.Paid = "paid", a.Canceled = "canceled", a.Error = "error", a))(zi || {}), Xi = /* @__PURE__ */ ((a) => (a.Palkkaus = "palkkaus", a.CustomSso = "customSso", a.CustomPalkkaus = "customPalkkaus", a.NoCustomerUi = "noCustomerUi", a))(Xi || {}), _i = /* @__PURE__ */ ((a) => (a.New = "new", a.Scheduled = "scheduled", a.Succeeded = "succeeded", a.Canceled = "canceled", a.Error = "error", a.Invalid = "invalid", a.Sending = "sending", a))(_i || {}), nt = /* @__PURE__ */ ((a) => (a.BankAccount = "bankAccount", a.External = "external", a))(nt || {}), qi = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.Primary = "primary", a.SecondaryCurrent = "secondaryCurrent", a.Archived = "archived", a))(qi || {}), xa = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Auto = "auto", a.Manual = "manual", a.NoTaxCard = "noTaxCard", a.TaxAtSource = "taxAtSource", a))(xa || {}), B = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Salary = "salary", a.HourlySalary = "hourlySalary", a.MonthlySalary = "monthlySalary", a.Compensation = "compensation", a.BoardMember = "boardMember", a.Entrepreneur = "entrepreneur", a.Farmer = "farmer", a.EmployedByStateEmploymentFund = "employedByStateEmploymentFund", a.Athlete = "athlete", a.PerformingArtist = "performingArtist", a.ForeignWorker = "foreignWorker", a.WorkingAbroad = "workingAbroad", a))(B || {}), ae = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.FileExcel = "fileExcel", a.FileCsv = "fileCsv", a.FilePdf = "filePdf", a.FileText = "fileText", a.CopyExcel = "copyExcel", a.CopyCsv = "copyCsv", a.CopyText = "copyText", a.PaymentChannel = "paymentChannel", a.Api = "api", a))(ae || {}), Qt = /* @__PURE__ */ ((a) => (a.Draft = "draft", a.Instance = "instance", a.Template = "template", a))(Qt || {}), Zi = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.ReportAdHoc = "reportAdHoc", a.Import = "import", a.Export = "export", a.Batch = "batch", a))(Zi || {}), Qi = /* @__PURE__ */ ((a) => (a.Assumption = "assumption", a.AgeBased = "ageBased", a.AgeGroupBased = "ageGroupBased", a.MonthCorrect = "monthCorrect", a.Exact = "exact", a.Verified = "verified", a))(Qi || {}), en = /* @__PURE__ */ ((a) => (a.NotDefined = "notDefined", a.Construction = "construction", a.Mll = "mll", a.ChildCare = "childCare", a.Cleaning = "cleaning", a.SantaClaus = "santaClaus", a.Entrepreneur = "entrepreneur", a.Other = "other", a))(en || {}), es = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.Male = "male", a.Female = "female", a))(es || {}), as = /* @__PURE__ */ ((a) => (a.NotDefined = "notDefined", a.I = "i", a.J = "j", a.K = "k", a.M = "m", a.O = "o", a.N = "n", a.P = "p", a.Q = "q", a.R = "r", a.S = "s", a.Other = "other", a))(as || {}), ts = /* @__PURE__ */ ((a) => (a.NotDefined = "notDefined", a.Small = "small", a.Medium = "medium", a.Large = "large", a))(ts || {}), Ze = /* @__PURE__ */ ((a) => (a.EmployedByStateEmploymentFund = "employedByStateEmploymentFund", a.JointOwnerWithPayer = "jointOwnerWithPayer", a.PartialOwner = "partialOwner", a.KeyEmployee = "keyEmployee", a.LeasedEmployeeLivingAbroad = "leasedEmployeeLivingAbroad", a.PersonWorkingInFrontierDistrict = "personWorkingInFrontierDistrict", a.PersonWorkingAbroad = "personWorkingAbroad", a.Athlete = "athlete", a.PerformingArtist = "performingArtist", a.RestrictedPeriodInFinland = "restrictedPeriodInFinland", a.NetOfTaxContract = "netOfTaxContract", a.Organization = "organization", a.PersonWorkingOnAlandFerry = "personWorkingOnAlandFerry", a.EntrepreneurOrFarmerNoPensionRequired = "entrepreneurOrFarmerNoPensionRequired", a.DimplomaticMission = "dimplomaticMission", a.Eppo = "eppo", a.LightEntrepreneur = "lightEntrepreneur", a))(Ze || {}), ns = /* @__PURE__ */ ((a) => (a.Default = "default", a.New = "new", a.Changed = "changed", a.Removed = "removed", a))(ns || {}), is = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.TaxIdentificationNumber = "taxIdentificationNumber", a.ForeignPersonalIdentificationNumber = "foreignPersonalIdentificationNumber", a.Other = "other", a))(is || {}), an = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Forecast = "forecast", a.Preview = "preview", a.WaitingPalkkaus = "waitingPalkkaus", a.Unread = "unread", a.Read = "read", a.WaitingConfirmation = "waitingConfirmation", a.PaymentStarted = "paymentStarted", a.Warning = "warning", a.Paid = "paid", a.Canceled = "canceled", a.Error = "error", a))(an || {}), ss = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Net = "net", a.Tax = "tax", a.TaxWithholding = "taxWithholding", a.TaxSocialSecurity = "taxSocialSecurity", a.TaxAtSource = "taxAtSource", a.Unemployment = "unemployment", a.Pension = "pension", a.Union = "union", a.Foreclosure = "foreclosure", a.Payroll = "payroll", a.Service = "service", a.Fee = "fee", a.Gross = "gross", a.Verification = "verification", a))(ss || {}), rs = /* @__PURE__ */ ((a) => (a.NewYearsDay = "newYearsDay", a.Epiphany = "epiphany", a.GoodFriday = "goodFriday", a.EasterSunday = "easterSunday", a.EasterSaturday = "easterSaturday", a.EasterMonday = "easterMonday", a.MayDay = "mayDay", a.AscensionDay = "ascensionDay", a.Pentecost = "pentecost", a.MidsummerEve = "midsummerEve", a.MidsummerDay = "midsummerDay", a.AllSaintsDay = "allSaintsDay", a.IndependenceDay = "independenceDay", a.ChristmasEve = "christmasEve", a.ChristmasDay = "christmasDay", a.StStephensDay = "stStephensDay", a))(rs || {}), os = /* @__PURE__ */ ((a) => (a.Initial = "initial", a.Manual = "manual", a.CalcDraft = "calcDraft", a.CalcPaid = "calcPaid", a))(os || {}), ls = /* @__PURE__ */ ((a) => (a.None = "none", a.PayForHolidaySalary = "payForHolidaySalary", a.PaySummerBonus = "paySummerBonus", a.PaySelectedDays = "paySelectedDays", a.Pay24Days = "pay24Days", a.PayAllBonus = "payAllBonus", a))(ls || {}), Ha = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Permanent14Days = "permanent14Days", a.Permanent35Hours = "permanent35Hours", a.TemporaryTimeOff = "temporaryTimeOff", a.HolidayCompensation = "holidayCompensation", a.HolidayCompensationIncluded = "holidayCompensationIncluded", a.NoHolidays = "noHolidays", a.Other = "other", a))(Ha || {}), ma = /* @__PURE__ */ ((a) => (a.Official = "official", a.NonBanking = "nonBanking", a.Holiday = "holiday", a))(ma || {}), da = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.NormalMonthlyPay = "normalMonthlyPay", a.AverageDailyPay = "averageDailyPay", a.PercentageBasedPay = "percentageBasedPay", a.AverageHourlyPay = "averageHourlyPay", a.HolidayCompensation = "holidayCompensation", a.OtherPay = "otherPay", a))(da || {}), us = /* @__PURE__ */ ((a) => (a.Open = "open", a.Closed = "closed", a.Printed = "printed", a))(us || {}), ks = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Ok = "ok", a.OkWithModifications = "okWithModifications", a.WillHandleMyself = "willHandleMyself", a))(ks || {}), ms = /* @__PURE__ */ ((a) => (a.None = "none", a.LähiTapiola = "lähiTapiola", a.Pohjola = "pohjola", a.If = "if", a.Fennia = "fennia", a.AVakuutus = "aVakuutus", a.Aktia = "aktia", a.Pohjantähti = "pohjantähti", a.Tryg = "tryg", a.Ålands = "ålands", a.Turva = "turva", a.Redarnas = "redarnas", a.Folksam = "folksam", a.Alandia = "alandia", a.Protector = "protector", a.Other = "other", a.Pending = "pending", a))(ms || {}), Wa = /* @__PURE__ */ ((a) => (a.NotSubjectToEarningsRelatedPensionInsurance = "notSubjectToEarningsRelatedPensionInsurance", a.NotSubjectToAccidentAndOccupationalDiseaseInsurance = "notSubjectToAccidentAndOccupationalDiseaseInsurance", a.NotSubjectToUnemploymentInsurance = "notSubjectToUnemploymentInsurance", a.NotSubjectToHealthInsurance = "notSubjectToHealthInsurance", a.VoluntaryEarningsRelatedPensionInsurance = "voluntaryEarningsRelatedPensionInsurance", a.NoObligationToHealthInsuranceDailyAllowanceContribution = "noObligationToHealthInsuranceDailyAllowanceContribution", a))(Wa || {}), ds = /* @__PURE__ */ ((a) => (a.Default = "default", a.Foreign = "foreign", a.Mixed = "mixed", a))(ds || {}), tn = /* @__PURE__ */ ((a) => (a.InvoiceDate = "invoiceDate", a.DueDate = "dueDate", a.LogicalDate = "logicalDate", a))(tn || {}), cs = /* @__PURE__ */ ((a) => (a.Default = "default", a.Salary = "salary", a.SalaryInPast = "salaryInPast", a))(cs || {}), ps = /* @__PURE__ */ ((a) => (a.NoMoney = "noMoney", a.OneOff = "oneOff", a.UnjustEnrichment = "unjustEnrichment", a))(ps || {}), hs = /* @__PURE__ */ ((a) => (a.IncludeAll = "includeAll", a.IncludePension = "includePension", a.IncludeHealthInsurance = "includeHealthInsurance", a.IncludeUnemployment = "includeUnemployment", a.IncludeAccidentInsurance = "includeAccidentInsurance", a.ExcludeAll = "excludeAll", a.ExcludePension = "excludePension", a.ExcludeHealthInsurance = "excludeHealthInsurance", a.ExcludeUnemployment = "excludeUnemployment", a.ExcludeAccidentInsurance = "excludeAccidentInsurance", a))(hs || {}), ys = /* @__PURE__ */ ((a) => (a.Manual = "manual", a.Usecase = "usecase", a.UsecaseV02 = "usecaseV02", a))(ys || {}), Ee = /* @__PURE__ */ ((a) => (a.Default = "default", a.Fi = "fi", a.Sv = "sv", a.En = "en", a))(Ee || {}), me = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Person = "person", a.Company = "company", a.PersonCreatedByEmployer = "personCreatedByEmployer", a.Partner = "partner", a))(me || {}), vs = /* @__PURE__ */ ((a) => (a.Procuration = "procuration", a.PowerOfAttorney = "powerOfAttorney", a.ApparentAuthority = "apparentAuthority", a.Other = "other", a))(vs || {}), fs = /* @__PURE__ */ ((a) => (a.Draft = "draft", a.WaitingApproval = "waitingApproval", a.Checked = "checked", a.Sent = "sent", a.Handled = "handled", a.Canceled = "canceled", a))(fs || {}), gs = /* @__PURE__ */ ((a) => (a.NewWorkerInsurance = "newWorkerInsurance", a.MoveWorkerInsurance = "moveWorkerInsurance", a.NewEntrepreneurInsurance = "newEntrepreneurInsurance", a.MoveEntrepreneurInsurance = "moveEntrepreneurInsurance", a.Other = "other", a))(gs || {}), bs = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.RemoveAllRows = "removeAllRows", a.RemoveImportedRows = "removeImportedRows", a))(bs || {}), js = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Owner = "owner", a.OtherParty = "otherParty", a.System = "system", a))(js || {}), Ss = /* @__PURE__ */ ((a) => (a.Draft = "draft", a.Active = "active", a.Approved = "approved", a.Rejected = "rejected", a.Archived = "archived", a.Template = "template", a))(Ss || {}), Ts = /* @__PURE__ */ ((a) => (a.Email = "email", a.Sms = "sms", a))(Ts || {}), xs = /* @__PURE__ */ ((a) => (a.Created = "created", a.Open = "open", a.Error = "error", a.Cancel = "cancel", a.Done = "done", a.Expired = "expired", a))(xs || {}), Es = /* @__PURE__ */ ((a) => (a.New = "new", a.Scheduled = "scheduled", a.Succeeded = "succeeded", a.Canceled = "canceled", a.Error = "error", a.Invalid = "invalid", a.Sending = "sending", a))(Es || {}), F = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Test = "test", a.ZeroPayment = "zeroPayment", a.External = "external", a.PalkkausManual = "palkkausManual", a.PalkkausWS = "palkkausWS", a.PalkkausPersonal = "palkkausPersonal", a.PalkkausInvoices = "palkkausInvoices", a.PalkkausPSD = "palkkausPSD", a.PalkkausCfaPaytrail = "palkkausCfaPaytrail", a.PalkkausCfaReference = "palkkausCfaReference", a.PalkkausCfaFinvoice = "palkkausCfaFinvoice", a.PalkkausEcfaPaytrail = "palkkausEcfaPaytrail", a.PalkkausEcfaReference = "palkkausEcfaReference", a.PalkkausEcfaFinvoice = "palkkausEcfaFinvoice", a.PalkkausCfaTest = "palkkausCfaTest", a.AccountorGo = "accountorGo", a.TalenomOnline = "talenomOnline", a.TalenomCfa = "talenomCfa", a.HolviCfa = "holviCfa", a.FinagoSolo = "finagoSolo", a.Procountor = "procountor", a.Kevytyrittaja = "kevytyrittaja", a.VismaNetvisor = "vismaNetvisor", a.Askelma = "askelma", a.Briox = "briox", a.Lemonaid = "lemonaid", a.Laskupiste = "laskupiste", a.Holvi = "holvi", a.Kompassi = "kompassi", a.Domus = "domus", a.PasseliMerit = "passeliMerit", a.Odoo = "odoo", a.Ecom = "ecom", a.Kitsas = "kitsas", a.TalenomManual = "talenomManual", a.Hausvise = "hausvise", a))(F || {}), As = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Sepa = "sepa", a.Siirto = "siirto", a.Test = "test", a))(As || {}), Ps = /* @__PURE__ */ ((a) => (a.New = "new", a.SentToBank = "sentToBank", a.BankTechApproval = "bankTechApproval", a.BankDelivered = "bankDelivered", a.BankPartialError = "bankPartialError", a.BankError = "bankError", a.Paid = "paid", a.Unknown = "unknown", a.Cancelled = "cancelled", a))(Ps || {}), ws = /* @__PURE__ */ ((a) => (a.Draft = "draft", a.PaymentStarted = "paymentStarted", a.PaymentSucceeded = "paymentSucceeded", a.PaymentCanceled = "paymentCanceled", a.PaymentError = "paymentError", a.PaymentAllowed = "paymentAllowed", a.WaitingApproval = "waitingApproval", a.WaitingPartnerApproval = "waitingPartnerApproval", a.Handled = "handled", a.Template = "template", a))(ws || {}), R = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Employee = "employee", a.Entrepreneur = "entrepreneur", a.Farmer = "farmer", a.PartialOwner = "partialOwner", a.Athlete = "athlete", a.Compensation = "compensation", a.BoardRemuneration = "boardRemuneration", a.SmallEntrepreneur = "smallEntrepreneur", a.SmallFarmer = "smallFarmer", a.PublicSector = "publicSector", a))(R || {}), U = /* @__PURE__ */ ((a) => (a.None = "none", a.Etera = "etera", a.Ilmarinen = "ilmarinen", a.Elo = "elo", a.PensionsAlandia = "pensionsAlandia", a.Varma = "varma", a.Veritas = "veritas", a.Apteekkien = "apteekkien", a.Verso = "verso", a.KevaMunicipal = "kevaMunicipal", a.KevaAland = "kevaAland", a.KevaChurch = "kevaChurch", a.KevaKela = "kevaKela", a.KevaState = "kevaState", a.Valio = "valio", a.Other = "other", a))(U || {}), Fs = /* @__PURE__ */ ((a) => (a.Default = "default", a.MonthlyLowerLimit = "monthlyLowerLimit", a))(Fs || {}), Ds = /* @__PURE__ */ ((a) => (a.PaidAtDate = "paidAtDate", a.SalaryDate = "salaryDate", a.WorkDate = "workDate", a.WorkDateStart = "workDateStart", a.WorkDateEnd = "workDateEnd", a))(Ds || {}), it = /* @__PURE__ */ ((a) => (a.Month = "month", a.Quarter = "quarter", a.Year = "year", a.Custom = "custom", a))(it || {}), Cs = /* @__PURE__ */ ((a) => (a.PalkkausFee = "palkkausFee", a.NoFee = "noFee", a.FixedFee = "fixedFee", a))(Cs || {}), Is = /* @__PURE__ */ ((a) => (a.Default = "default", a.PartnerBasic = "partnerBasic", a.PartnerPro = "partnerPro", a))(Is || {}), Ls = /* @__PURE__ */ ((a) => (a.Available = "available", a.All = "all", a))(Ls || {}), nn = /* @__PURE__ */ ((a) => (a.Default = "default", a.CreateRecurrence = "createRecurrence", a))(nn || {}), Ms = /* @__PURE__ */ ((a) => (a.All = "all", a.Monthly = "monthly", a.Yearly = "yearly", a))(Ms || {}), xe = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Example = "example", a.MonthlyDetails = "monthlyDetails", a.TaxMonthly4001 = "taxMonthly4001", a.PayerSummaryReport = "payerSummaryReport", a.MonthlyPension = "monthlyPension", a.MonthlyLiikekirjuri = "monthlyLiikekirjuri", a.MonthlyLiikekirjuriLegacy = "monthlyLiikekirjuriLegacy", a.MonthlyRapko = "monthlyRapko", a.MonthlyAccounting = "monthlyAccounting", a.MonthlyAccountingExcel = "monthlyAccountingExcel", a.YearlyDetails = "yearlyDetails", a.YearEndReport = "yearEndReport", a.YearlyWorkerSummary = "yearlyWorkerSummary", a.TaxYearly7801 = "taxYearly7801", a.Unemployment = "unemployment", a.Insurance = "insurance", a.HouseholdDeduction = "householdDeduction", a.TaxHouseholdDeduction14B = "taxHouseholdDeduction14B", a.TaxHouseholdDeduction14BSpouseA = "taxHouseholdDeduction14BSpouseA", a.TaxHouseholdDeduction14BSpouseB = "taxHouseholdDeduction14BSpouseB", a.SalarySlip = "salarySlip", a.SalarySlipPaid = "salarySlipPaid", a.SalarySlipCopy = "salarySlipCopy", a.ESalarySpecification = "eSalarySpecification", a.EmployerReport = "employerReport", a.PaymentReport = "paymentReport", a.PaymentSummaryReport = "paymentSummaryReport", a.TotalsReport = "totalsReport", a.EarningsPaymentReport = "earningsPaymentReport", a.AccountingReport = "accountingReport", a.Invoice = "invoice", a.InvoiceList = "invoiceList", a.EmploymentContract = "employmentContract", a.Authorization = "authorization", a))(xe || {}), Ns = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Accountant = "accountant", a.TrustedPartner = "trustedPartner", a.AccountantCandidate = "accountantCandidate", a.PricingPartner = "pricingPartner", a.SepaPartner = "sepaPartner", a))(Ns || {}), Os = /* @__PURE__ */ ((a) => (a.Default = "default", a.InPast = "inPast", a))(Os || {}), Re = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.FixedSalary = "fixedSalary", a.HourlySalary = "hourlySalary", a.MonthlySalary = "monthlySalary", a.Compensation = "compensation", a.TotalWorkerPayment = "totalWorkerPayment", a.TotalEmployerPayment = "totalEmployerPayment", a))(Re || {}), Rs = /* @__PURE__ */ ((a) => (a.Tyel = "tyel", a.Yel = "yel", a.Compensation = "compensation", a))(Rs || {}), Bs = /* @__PURE__ */ ((a) => (a.Shared = "shared", a.PartnerOnly = "partnerOnly", a))(Bs || {}), Vs = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Checked = "checked", a.Pending = "pending", a))(Vs || {}), sn = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Url = "url", a.Employer = "employer", a))(sn || {}), Ks = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Salary = "salary", a.DividendsForWorkAsSalary = "dividendsForWorkAsSalary", a.PersonnelFundIncome = "personnelFundIncome", a.SalaryOneOff = "salaryOneOff", a.CompensationForUseEarnedIncome = "compensationForUseEarnedIncome", a.CompensationForUseCapitalIncome = "compensationForUseCapitalIncome", a.CompensationVatResponsible = "compensationVatResponsible", a.Compensation = "compensation", a.DividendsForWorkAsCompensation = "dividendsForWorkAsCompensation", a.AthletePay = "athletePay", a.OtherTaxableIncome = "otherTaxableIncome", a.OtherTaxableIncomeOneOff = "otherTaxableIncomeOneOff", a.EmployeeStockOption = "employeeStockOption", a))(Ks || {}), Us = /* @__PURE__ */ ((a) => (a.AssureWaiting = "assureWaiting", a.Approve = "approve", a.Reject = "reject", a))(Us || {}), rn = /* @__PURE__ */ ((a) => (a.GetDiff = "getDiff", a.NoCheck = "noCheck", a.CommitDiff = "commitDiff", a))(rn || {}), Hs = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.SalaxyCalculation = "salaxyCalculation", a.PreviousEmployerSalaries = "previousEmployerSalaries", a.ExternalSalaries = "externalSalaries", a.SharedCardExtSum = "sharedCardExtSum", a.Diff = "diff", a))(Hs || {}), $e = /* @__PURE__ */ ((a) => (a.New = "new", a.Approved = "approved", a.EmployerAdded = "employerAdded", a.VerifiedVero = "verifiedVero", a.SharedWaiting = "sharedWaiting", a.SharedApproved = "sharedApproved", a.SharedRejected = "sharedRejected", a.SharedRejectedWithoutOpen = "sharedRejectedWithoutOpen", a.Shared = "shared", a))($e || {}), z = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.NoTaxCard = "noTaxCard", a.Auto = "auto", a.DefaultYearly = "defaultYearly", a.Replacement = "replacement", a.NoWithholdingHousehold = "noWithholdingHousehold", a.Others = "others", a.Historical = "historical", a))(z || {}), Ws = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Valid = "valid", a.ValidJanuary = "validJanuary", a.Future = "future", a.Expired = "expired", a))(Ws || {}), Oe = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.NoDeduction = "noDeduction", a.MonthlyDeduction = "monthlyDeduction", a.DailyDeduction = "dailyDeduction", a.FixedValues = "fixedValues", a))(Oe || {}), te = /* @__PURE__ */ ((a) => (a.None = "none", a.Householdwork = "householdwork", a.Carework = "carework", a.HomeImprovement = "homeImprovement", a.OwnPropety = "ownPropety", a.RelativesProperty = "relativesProperty", a.OilHeatingReplacementWork = "oilHeatingReplacementWork", a))(te || {}), Ys = /* @__PURE__ */ ((a) => (a.Default = "default", a.NoZeroSalaryReport = "noZeroSalaryReport", a.NoMonthlyReport = "noMonthlyReport", a.Always = "always", a))(Ys || {}), Qe = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Percentage = "percentage", a.FixedValue = "fixedValue", a))(Qe || {}), $s = /* @__PURE__ */ ((a) => (a.NotSelected = "notSelected", a.ConstructionCarpenter = "constructionCarpenter", a.ConstructionFloor = "constructionFloor", a.ConstructionOther = "constructionOther", a.ConstructionFreeContract = "constructionFreeContract", a))($s || {}), Gs = /* @__PURE__ */ ((a) => (a.ValueZero = "valueZero", a.ValueOne = "valueOne", a.ValueTwo = "valueTwo", a.ValueThree = "valueThree", a.ValueFour = "valueFour", a.ValueFive = "valueFive", a.ValueSix = "valueSix", a.ValueSeven = "valueSeven", a.ValueEight = "valueEight", a.ValueNine = "valueNine", a.ValueTen = "valueTen", a))(Gs || {}), Js = /* @__PURE__ */ ((a) => (a.Text = "text", a.BlobFile = "blobFile", a.Calculation = "calculation", a.Payroll = "payroll", a.WorkerAccount = "workerAccount", a.Email = "email", a.SalaxyEmail = "salaxyEmail", a.Sms = "sms", a.SalaxySms = "salaxySms", a.Timer = "timer", a.TimerEdited = "timerEdited", a.HourlyReport = "hourlyReport", a.TimeReport = "timeReport", a.Absence = "absence", a.AnnualLeave = "annualLeave", a.CalcRow = "calcRow", a.Travel = "travel", a.Expense = "expense", a))(Js || {}), zs = /* @__PURE__ */ ((a) => (a.Default = "default", a.Higher = "higher", a))(zs || {}), Xs = /* @__PURE__ */ ((a) => (a.NotSelected = "notSelected", a.RaksaNormal = "raksaNormal", a.RaksaUnemploymentOnly = "raksaUnemploymentOnly", a.Other = "other", a))(Xs || {}), ce = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Hours = "hours", a.Days = "days", a.Weeks = "weeks", a.Period = "period", a.One = "one", a.Count = "count", a.Percent = "percent", a.Kilometers = "kilometers", a.Euro = "euro", a))(ce || {}), Fa = /* @__PURE__ */ ((a) => (a.ClientScript = "clientScript", a.ClientScriptAsync = "clientScriptAsync", a.ServerScript = "serverScript", a.ServerScriptAsync = "serverScriptAsync", a.WebServiceCall = "webServiceCall", a.PowerAutomateFlow = "powerAutomateFlow", a))(Fa || {}), _s = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Active = "active", a.Default = "default", a.Inactive = "inactive", a))(_s || {}), qs = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.NewYel = "newYel", a.NewTyel = "newTyel", a.Move = "move", a))(qs || {}), Zs = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Entrepreneur = "entrepreneur", a.Company = "company", a))(Zs || {}), de = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.None = "none", a.Vat0000 = "vat0000", a.Vat1000 = "vat1000", a.Vat1400 = "vat1400", a.Vat2400 = "vat2400", a.Vat2550 = "vat2550", a.Other = "other", a))(de || {}), Qs = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Monthly = "monthly", a.Hourly = "hourly", a.PerformanceBased = "performanceBased", a.Other = "other", a))(Qs || {}), on = /* @__PURE__ */ ((a) => (a.None = "none", a.Household = "household", a.Worker = "worker", a.Company = "company", a))(on || {}), er = /* @__PURE__ */ ((a) => (a.Always = "always", a.Silent = "silent", a))(er || {}), ar = /* @__PURE__ */ ((a) => (a.Default = "default", a.Payslip = "payslip", a.Omapalkka = "omapalkka", a))(ar || {}), tr = /* @__PURE__ */ ((a) => (a.None = "none", a.IsActive = "isActive", a.IsEditable = "isEditable", a.IsRemovable = "isRemovable", a.IsOnHold = "isOnHold", a))(tr || {}), nr = /* @__PURE__ */ ((a) => (a.NotChecked = "notChecked", a.Ok = "ok", a.OkWithWarning = "okWithWarning", a.Errors = "errors", a))(nr || {}), ir = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.SalaxyPayment = "salaxyPayment", a.External = "external", a.Correction = "correction", a))(ir || {}), sr = /* @__PURE__ */ ((a) => (a.NotChecked = "notChecked", a.Ok = "ok", a.OkWithModifications = "okWithModifications", a.WillHandleMyself = "willHandleMyself", a.NoYearlyReports = "noYearlyReports", a))(sr || {}), rr = /* @__PURE__ */ ((a) => (a.NoCompanyType = "noCompanyType", a.HousingCooperative = "housingCooperative", a.Condominium = "condominium", a.AsoAssociation = "asoAssociation", a.OpenCompany = "openCompany", a.Association = "association", a.HypoAssociation = "hypoAssociation", a.MutualRealEstateCompany = "mutualRealEstateCompany", a.Ky = "ky", a.Osuuskunta = "osuuskunta", a.CooperativeBank = "cooperativeBank", a.Oy = "oy", a.PublicLimitedCompany = "publicLimitedCompany", a.Foundation = "foundation", a.Branch = "branch", a.SavingsBank = "savingsBank", a.FinancialAssociation = "financialAssociation", a.StateEstablishment = "stateEstablishment", a.InsuranceAssociation = "insuranceAssociation", a.PrivateEntrepreneur = "privateEntrepreneur", a.OtherAssociation = "otherAssociation", a.SpecialPurposeAssociation = "specialPurposeAssociation", a.ForestCareAssociation = "forestCareAssociation", a.OtherFinancialAssociation = "otherFinancialAssociation", a.ReligiousCommunity = "religiousCommunity", a.JointInterestGroups = "jointInterestGroups", a.TaxableGrouping = "taxableGrouping", a.DeathEstate = "deathEstate", a.MutualInsuranceAssociation = "mutualInsuranceAssociation", a.ForeignOrganisation = "foreignOrganisation", a.MunicipalEstablishment = "municipalEstablishment", a.FederationOfMunicipalitiesEstablishment = "federationOfMunicipalitiesEstablishment", a.AlandFederation = "alandFederation", a.EuropeanCooperative = "europeanCooperative", a.EuropeanCooperativeBank = "europeanCooperativeBank", a.ReindeerHerdingCooperative = "reindeerHerdingCooperative", a.Unknown = "unknown", a))(rr || {}), or = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.LimitedCarBenefit = "limitedCarBenefit", a.FullCarBenefit = "fullCarBenefit", a))(or || {}), Ge = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.NoDeduction = "noDeduction", a.SingleDeduction = "singleDeduction", a.PeriodicalDeduction = "periodicalDeduction", a))(Ge || {}), re = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Fixed = "fixed", a.Percentage = "percentage", a.PercentageAndLimits = "percentageAndLimits", a.RaksaNormal = "raksaNormal", a.RaksaUnemploymentOnly = "raksaUnemploymentOnly", a.Other = "other", a))(re || {}), lr = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.KilometreAllowance = "kilometreAllowance", a.DailyAllowance = "dailyAllowance", a.AccomodationAllowance = "accomodationAllowance", a))(lr || {}), Je = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.NoDeduction = "noDeduction", a.SingleDeduction = "singleDeduction", a.PeriodicalDeduction = "periodicalDeduction", a))(Je || {}), oe = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.CateringContract = "cateringContract", a.MealTicket = "mealTicket", a.TaxableAmount = "taxableAmount", a.MealAllowance = "mealAllowance", a.Institute = "institute", a.Teacher = "teacher", a.RestaurantWorker = "restaurantWorker", a.CollectedReimbursement = "collectedReimbursement", a))(oe || {}), Ue = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.FullDailyAllowance = "fullDailyAllowance", a.PartialDailyAllowance = "partialDailyAllowance", a.InternationalDailyAllowance = "internationalDailyAllowance", a.MealAllowance = "mealAllowance", a))(Ue || {}), ln = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a))(ln || {}), ea = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.InitiativeFee = "initiativeFee", a.BonusPay = "bonusPay", a.Commission = "commission", a.PerformanceBonus = "performanceBonus", a.ShareIssueForEmployees = "shareIssueForEmployees", a.ProfitSharingBonus = "profitSharingBonus", a))(ea || {}), ie = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.MeetingFee = "meetingFee", a.LectureFee = "lectureFee", a.PositionOfTrustCompensation = "positionOfTrustCompensation", a.AccruedTimeOffCompensation = "accruedTimeOffCompensation", a.MembershipOfGoverningBodyCompensation = "membershipOfGoverningBodyCompensation", a.MonetaryGiftForEmployees = "monetaryGiftForEmployees", a.UseCompensationAsEarnedIncome = "useCompensationAsEarnedIncome", a.UseCompensationAsCapitalIncome = "useCompensationAsCapitalIncome", a.OtherTaxableIncomeAsEarnedIncome = "otherTaxableIncomeAsEarnedIncome", a.StockOptionsAndGrants = "stockOptionsAndGrants", a.EmployeeInventionCompensation = "employeeInventionCompensation", a.CapitalIncomePayment = "capitalIncomePayment", a.WorkEffortBasedDividendsAsWage = "workEffortBasedDividendsAsWage", a.WorkEffortBasedDividendsAsNonWage = "workEffortBasedDividendsAsNonWage", a.EmployeeStockOption = "employeeStockOption", a.EmployeeStockOptionWithLowerPrice = "employeeStockOptionWithLowerPrice", a.CopyrightRoyaltiesEarnedIncome = "copyrightRoyaltiesEarnedIncome", a.StockGrantPaidInMoney = "stockGrantPaidInMoney", a.EmployeeStockOptionPaidInMoney = "employeeStockOptionPaidInMoney", a))(ie || {}), ur = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.PaidSickLeaveSalary = "paidSickLeaveSalary", a.PaidSickLeaveHourlySalary = "paidSickLeaveHourlySalary", a.PaidSickLeaveMonthlySalary = "paidSickLeaveMonthlySalary", a))(ur || {}), X = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.EmergencyWorkCompensation = "emergencyWorkCompensation", a.EveningWorkCompensation = "eveningWorkCompensation", a.EveningShiftAllowance = "eveningShiftAllowance", a.SaturdayPay = "saturdayPay", a.ExtraWorkPremium = "extraWorkPremium", a.OtherCompensation = "otherCompensation", a.WaitingTimeCompensation = "waitingTimeCompensation", a.SundayWorkCompensation = "sundayWorkCompensation", a.StandByCompensation = "standByCompensation", a.WeeklyRestCompensation = "weeklyRestCompensation", a.OvertimeCompensation = "overtimeCompensation", a.NightWorkAllowance = "nightWorkAllowance", a.NightShiftCompensation = "nightShiftCompensation", a))(X || {}), ta = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Percent = "percent", a.Fixed = "fixed", a))(ta || {}), ca = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.NoticePeriodCompensation = "noticePeriodCompensation", a.MonetaryWorkingTimeBankCompensation = "monetaryWorkingTimeBankCompensation", a.TerminationAndLayOffDamages = "terminationAndLayOffDamages", a.VoluntaryTerminationCompensation = "voluntaryTerminationCompensation", a.PensionPaidByEmployer = "pensionPaidByEmployer", a))(ca || {}), aa = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.Fixed = "fixed", a.Periodic = "periodic", a.NonPeriodic = "nonPeriodic", a))(aa || {}), ga = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.TotalWorkerPayment = "totalWorkerPayment", a.TotalWorkerWorkerPaymentExcludingExpenses = "totalWorkerWorkerPaymentExcludingExpenses", a.TotalWorkerPaymentAndTax = "totalWorkerPaymentAndTax", a.TotalWorkerWorkerPaymentAndTaxExcludingExpenses = "totalWorkerWorkerPaymentAndTaxExcludingExpenses", a))(ga || {}), Ya = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.Ignored = "ignored", a.TimeRatePay = "timeRatePay", a.InitiativeFee = "initiativeFee", a.BonusPay = "bonusPay", a.ComplementaryWagePaidDuringBenefitPeriod = "complementaryWagePaidDuringBenefitPeriod", a.EmergencyWorkCompensation = "emergencyWorkCompensation", a.EveningWorkCompensation = "eveningWorkCompensation", a.EveningShiftAllowance = "eveningShiftAllowance", a.NoticePeriodCompensation = "noticePeriodCompensation", a.KilometreAllowanceTaxable = "kilometreAllowanceTaxable", a.MeetingFee = "meetingFee", a.SaturdayPay = "saturdayPay", a.ExtraWorkPremium = "extraWorkPremium", a.HolidayBonus = "holidayBonus", a.LectureFee = "lectureFee", a.CompensationForTrustPosition = "compensationForTrustPosition", a.OtherCompensation = "otherCompensation", a.WaitingTimeCompensation = "waitingTimeCompensation", a.WorkingConditionCompensation = "workingConditionCompensation", a.PartialPayDuringSickLeave = "partialPayDuringSickLeave", a.Commission = "commission", a.SundayWorkCompensation = "sundayWorkCompensation", a.BenefitArisingFromSyntheticOption = "benefitArisingFromSyntheticOption", a.PerformanceBonus = "performanceBonus", a.MonetaryCompensationFromWorkingTimeBank = "monetaryCompensationFromWorkingTimeBank", a.CompensationForAccruedTimeOff = "compensationForAccruedTimeOff", a.ShareIssueForEmployees = "shareIssueForEmployees", a.ContractPay = "contractPay", a.DamagesInConjunctionWithTermination = "damagesInConjunctionWithTermination", a.StandByCompensation = "standByCompensation", a.VoluntaryCompensationInConjunctionWithTermination = "voluntaryCompensationInConjunctionWithTermination", a.WeeklyRestCompensation = "weeklyRestCompensation", a.ProfitSharingBonus = "profitSharingBonus", a.AnnualHolidayCompensation = "annualHolidayCompensation", a.OvertimeCompensation = "overtimeCompensation", a.NightWorkAllowance = "nightWorkAllowance", a.NightShiftCompensation = "nightShiftCompensation", a.OtherRegularCompensation = "otherRegularCompensation", a.CompensationForUnusedCompensatoryLeave = "compensationForUnusedCompensatoryLeave", a.AccommodationBenefit = "accommodationBenefit", a.InterestBenefitForHousingLoan = "interestBenefitForHousingLoan", a.MealAllowance = "mealAllowance", a.CarBenefit = "carBenefit", a.CompensationForGoverningBodyMembership = "compensationForGoverningBodyMembership", a.ShareOfReserveDrawnFromPersonnelFund = "shareOfReserveDrawnFromPersonnelFund", a.MonetaryGiftForEmployees = "monetaryGiftForEmployees", a.KilometreAllowanceTaxExempt = "kilometreAllowanceTaxExempt", a.TreatmentFeeForMunicipalVeterinarian = "treatmentFeeForMunicipalVeterinarian", a.CompensationForUseEarnedIncome = "compensationForUseEarnedIncome", a.CompensationForUseCapitalIncome = "compensationForUseCapitalIncome", a.OtherTaxableBenefitForEmployees = "otherTaxableBenefitForEmployees", a.OtherTaxableIncomeDeemedEarnedIncome = "otherTaxableIncomeDeemedEarnedIncome", a.OtherFringeBenefit = "otherFringeBenefit", a.KinshipCarersFee = "kinshipCarersFee", a.StockOptions = "stockOptions", a.WagesPaidBySubstitutePayerIncludingSocialInsurance = "wagesPaidBySubstitutePayerIncludingSocialInsurance", a.WagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance = "wagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance", a.WagesPaidBySubstitutePayerIncludingUnemploymentInsurance = "wagesPaidBySubstitutePayerIncludingUnemploymentInsurance", a.WagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance = "wagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance", a.WagesPaidBySubstitutePayerIncludingHealthInsurance = "wagesPaidBySubstitutePayerIncludingHealthInsurance", a.CompensationForEmployeeInvention = "compensationForEmployeeInvention", a.ReimbursementOfPrivateCaretakersExpenses = "reimbursementOfPrivateCaretakersExpenses", a.PrivateCaretakersFee = "privateCaretakersFee", a.ReimbursementOfFamilyDayCareProvidersExpenses = "reimbursementOfFamilyDayCareProvidersExpenses", a.TelephoneBenefit = "telephoneBenefit", a.DailyAllowance = "dailyAllowance", a.CapitalIncomePayment = "capitalIncomePayment", a.MealBenefit = "mealBenefit", a.ReimbursementOfCostsPaidToConciliator = "reimbursementOfCostsPaidToConciliator", a.NonWageCompensationForWork = "nonWageCompensationForWork", a.SupplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund = "supplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund", a.PensionPaidByEmployer = "pensionPaidByEmployer", a.DividendsBasedOnWages = "dividendsBasedOnWages", a.DividendsBasedOnNonWage = "dividendsBasedOnNonWage", a.EmployerSubsidisedCommuterTicketTaxExempt = "employerSubsidisedCommuterTicketTaxExempt", a.EmployerSubsidisedCommuterTicketTaxable = "employerSubsidisedCommuterTicketTaxable", a.EmployeeStockOption = "employeeStockOption", a.WagesTransferredToAthletesSpecialFund = "wagesTransferredToAthletesSpecialFund", a.WagesPaidFromAthletesSpecialFund = "wagesPaidFromAthletesSpecialFund", a.WagesForInsurancePurposes = "wagesForInsurancePurposes", a.TaxableReimbursementOfExpenses = "taxableReimbursementOfExpenses", a.PrivateDayCareAllowanceMunicipalSupplement = "privateDayCareAllowanceMunicipalSupplement", a.PrivateDayCareAllowanceWages = "privateDayCareAllowanceWages", a.PrivateDayCareAllowanceNonWage = "privateDayCareAllowanceNonWage", a.KilometreAllowancePaidByNonProfitOrganisation = "kilometreAllowancePaidByNonProfitOrganisation", a.DailyAllowancePaidByNonProfitOrganisation = "dailyAllowancePaidByNonProfitOrganisation", a.UnjustEnrichment = "unjustEnrichment", a.EmployeeStockOptionLowerMarketPrice = "employeeStockOptionLowerMarketPrice", a.RoyaltyPaidToNonResidentTaxpayer = "royaltyPaidToNonResidentTaxpayer", a.BicycleBenefitTaxExempt = "bicycleBenefitTaxExempt", a.BicycleBenefitTaxable = "bicycleBenefitTaxable", a.ConditionalStockOptions = "conditionalStockOptions", a.CopyrightRoyaltiesEarnedIncome = "copyrightRoyaltiesEarnedIncome", a.StockGrantPaidInMoney = "stockGrantPaidInMoney", a.EmployeeStockOptionPaidInMoney = "employeeStockOptionPaidInMoney", a.EarningsFromJuELEmployerToLightEntrepreneur = "earningsFromJuELEmployerToLightEntrepreneur", a.CompensationCollectedForCarBenefit = "compensationCollectedForCarBenefit", a.WithholdingTax = "withholdingTax", a.ElectedOfficialFee = "electedOfficialFee", a.TaxAtSource = "taxAtSource", a.TaxAtSourceDeduction = "taxAtSourceDeduction", a.WagesPaid = "wagesPaid", a.ReimbursementCollectedForOtherFringeBenefits = "reimbursementCollectedForOtherFringeBenefits", a.OtherItemDeductibleFromNetWage = "otherItemDeductibleFromNetWage", a.NetWage = "netWage", a.EmployerPaidPremiumForCollectiveAdditionalPensionInsurance = "employerPaidPremiumForCollectiveAdditionalPensionInsurance", a.EmployerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution = "employerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution", a.EmployeesHealthInsuranceContribution = "employeesHealthInsuranceContribution", a.EmployeesPensionInsuranceContribution = "employeesPensionInsuranceContribution", a.EmployeesUnemploymentInsuranceContribution = "employeesUnemploymentInsuranceContribution", a.ReimbursementForEmployerSubsidisedCommuterTicket = "reimbursementForEmployerSubsidisedCommuterTicket", a.TaxPaidAbroad = "taxPaidAbroad", a.Distraint = "distraint", a.VoluntaryIndividualPensionInsurancePremium = "voluntaryIndividualPensionInsurancePremium", a.DeductionBeforeWithholding = "deductionBeforeWithholding", a.ReimbursementCollectedForBicycleBenefit = "reimbursementCollectedForBicycleBenefit", a))(Ya || {}), kr = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.TrainingSalary = "trainingSalary", a.TrainingHourlySalary = "trainingHourlySalary", a.TrainingMonthlySalary = "trainingMonthlySalary", a))(kr || {}), mr = /* @__PURE__ */ ((a) => (a.ContentIssues = "contentIssues", a.TechnicalIssues = "technicalIssues", a))(mr || {}), dr = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.NoAccess = "noAccess", a.ReadOnly = "readOnly", a.ReadWrite = "readWrite", a.Owner = "owner", a))(dr || {}), ut;
((a) => {
  ((e) => {
    e.NewReport = "newReport", e.ReplacementReport = "replacementReport";
  })(a.ActionCode || (a.ActionCode = {})), ((e) => {
    e.AddressInHomeCountry = "addressInHomeCountry", e.AddressInTheCountryOfWork = "addressInTheCountryOfWork";
  })(a.AddressType || (a.AddressType = {})), ((e) => {
    e.A = "a", e.B = "b", e.C = "c", e.U = "u";
  })(a.AgeGroupCode || (a.AgeGroupCode = {})), ((e) => {
    e.MealAllowance = "mealAllowance", e.PartialDailyAllowance = "partialDailyAllowance", e.FullDailyAllowance = "fullDailyAllowance", e.InternationalDailyAllowance = "internationalDailyAllowance", e.TaxExemptReimbursementsAbroad = "taxExemptReimbursementsAbroad";
  })(a.AllowanceCode || (a.AllowanceCode = {})), ((e) => {
    e.General = "general", e.Required = "required", e.Invalid = "invalid", e.Warning = "warning";
  })(a.ApiValidationErrorType || (a.ApiValidationErrorType = {})), ((e) => {
    e.AccommodationBenefit = "accommodationBenefit", e.TelephoneBenefit = "telephoneBenefit", e.MealBenefit = "mealBenefit", e.OtherBenefits = "otherBenefits";
  })(a.BenefitCode || (a.BenefitCode = {})), ((e) => {
    e.Undefined = "undefined", e.BaseSalary = "baseSalary", e.SalaryAdditions = "salaryAdditions", e.Benefits = "benefits", e.Expenses = "expenses", e.Deductions = "deductions", e.OtherNoPayment = "otherNoPayment", e.Totals = "totals", e.Disabled = "disabled";
  })(a.CalcGroup || (a.CalcGroup = {})), ((e) => {
    e.LimitedCarBenefit = "limitedCarBenefit", e.FullCarBenefit = "fullCarBenefit";
  })(a.CarBenefitCode || (a.CarBenefitCode = {})), ((e) => {
    e.EarningsPaymentReports = "earningsPaymentReports", e.EmployersSeparateReports = "employersSeparateReports", e.BenefitsPaymentReports = "benefitsPaymentReports", e.RecordSubscription = "recordSubscription", e.Messages = "messages", e.CancellationOfEarningsPaymentReports = "cancellationOfEarningsPaymentReports", e.CancellationOfEmployersSeparateReports = "cancellationOfEmployersSeparateReports", e.CancellationOfBenefitsPaymentReports = "cancellationOfBenefitsPaymentReports", e.CancellationOfARecordSubscription = "cancellationOfARecordSubscription", e.CancellationOfARecordContainingEarningsPaymentReports = "cancellationOfARecordContainingEarningsPaymentReports", e.CancellationOfARecordContainingEmployersSeparateReports = "cancellationOfARecordContainingEmployersSeparateReports", e.CancellationOfARecordContainingBenefitsPaymentReports = "cancellationOfARecordContainingBenefitsPaymentReports", e.CancellationOfARecordContainingARecordSubscription = "cancellationOfARecordContainingARecordSubscription";
  })(a.DeliveryDataType || (a.DeliveryDataType = {})), ((e) => {
    e.New = "new", e.Scheduled = "scheduled", e.Succeeded = "succeeded", e.Canceled = "canceled", e.Error = "error", e.Invalid = "invalid";
  })(a.EarningsPaymentReportStatus || (a.EarningsPaymentReportStatus = {})), ((e) => {
    e.FullTime = "fullTime", e.PartTime = "partTime", e.NotAvailable = "notAvailable";
  })(a.EmploymentCode || (a.EmploymentCode = {})), ((e) => {
    e.EmployeesResignation = "employeesResignation", e.Other = "other", e.TerminationGroundsRelatedToEmployeesPerson = "terminationGroundsRelatedToEmployeesPerson", e.FinancialAndProductionRelatedGrounds = "financialAndProductionRelatedGrounds", e.JointAgreement = "jointAgreement", e.Retirement = "retirement", e.TerminationOfaFixedTermEmployment = "terminationOfaFixedTermEmployment";
  })(a.EmploymentEndingCode || (a.EmploymentEndingCode = {})), ((e) => {
    e.KevaCodes = "kevaCodes", e.BankOfFinlandCodes = "bankOfFinlandCodes", e.IncomesRegisterCodes = "incomesRegisterCodes";
  })(a.EmploymentEndingType || (a.EmploymentEndingType = {})), ((e) => {
    e.KevasGroundsForRegistration = "kevasGroundsForRegistration", e.BankOfFinlandsGroundsForRegistration = "bankOfFinlandsGroundsForRegistration";
  })(a.EmploymentRegType || (a.EmploymentRegType = {})), ((e) => {
    e.NoObligationToSocialInsurance = "noObligationToSocialInsurance", e.NoObligationToHealthInsurance = "noObligationToHealthInsurance", e.NoObligationToEarningsRelatedPensionInsurance = "noObligationToEarningsRelatedPensionInsurance", e.NoObligationToAccidentAndOccupationalDiseaseInsurance = "noObligationToAccidentAndOccupationalDiseaseInsurance", e.NoObligationToUnemploymentInsurance = "noObligationToUnemploymentInsurance", e.NotSubjectToSocialInsurance = "notSubjectToSocialInsurance", e.NotSubjectToEarningsRelatedPensionInsurance = "notSubjectToEarningsRelatedPensionInsurance", e.NotSubjectToAccidentAndOccupationalDiseaseInsurance = "notSubjectToAccidentAndOccupationalDiseaseInsurance", e.NotSubjectToUnemploymentInsurance = "notSubjectToUnemploymentInsurance", e.NotSubjectToHealthInsurance = "notSubjectToHealthInsurance", e.VoluntaryEarningsRelatedPensionInsurance = "voluntaryEarningsRelatedPensionInsurance";
  })(a.ExceptionCode || (a.ExceptionCode = {})), ((e) => {
    e.OnlyInvalidItems = "onlyInvalidItems", e.EntireRecordIsRejected = "entireRecordIsRejected";
  })(a.FaultyControl || (a.FaultyControl = {})), ((e) => {
    e.Male = "male", e.Female = "female";
  })(a.Gender || (a.Gender = {})), ((e) => {
    e.BusinessId = "businessId", e.PersonalIdentificationNumber = "personalIdentificationNumber", e.Vat = "vat", e.Giin = "giin", e.TaxIdentificationNumber = "taxIdentificationNumber", e.FinnishTradeRegistrationNumber = "finnishTradeRegistrationNumber", e.ForeignBusinessRegistrationNumber = "foreignBusinessRegistrationNumber", e.ForeignPersonalIdentificationNumber = "foreignPersonalIdentificationNumber", e.Other = "other";
  })(a.IdType || (a.IdType = {})), ((e) => {
    e.EmployedByStateEmploymentFund = "employedByStateEmploymentFund", e.JointOwnerWithPayer = "jointOwnerWithPayer", e.PartialOwner = "partialOwner", e.KeyEmployee = "keyEmployee", e.LeasedEmployeeLivingAbroad = "leasedEmployeeLivingAbroad", e.PersonWorkingInFrontierDistrict = "personWorkingInFrontierDistrict", e.PersonWorkingAbroad = "personWorkingAbroad", e.Athlete = "athlete", e.PerformingArtist = "performingArtist", e.RestrictedPeriodInFinland = "restrictedPeriodInFinland", e.NetOfTaxContract = "netOfTaxContract", e.Organization = "organization", e.PersonWorkingOnAlandFerry = "personWorkingOnAlandFerry", e.EntrepreneurOrFarmerNoPensionRequired = "entrepreneurOrFarmerNoPensionRequired", e.DimplomaticMission = "dimplomaticMission", e.Eppo = "eppo", e.LightEntrepreneur = "lightEntrepreneur";
  })(a.IncomeEarnerType || (a.IncomeEarnerType = {})), ((e) => {
    e.Send = "send", e.Cancel = "cancel";
  })(a.IrScheduleAction || (a.IrScheduleAction = {})), ((e) => {
    e.SubjectToSocialInsuranceContributions = "subjectToSocialInsuranceContributions", e.SubjectToEarningsRelatedPensionInsuranceContribution = "subjectToEarningsRelatedPensionInsuranceContribution", e.SubjectToHealthInsuranceContribution = "subjectToHealthInsuranceContribution", e.SubjectToUnemploymentInsuranceContribution = "subjectToUnemploymentInsuranceContribution", e.SubjectToAccidentInsuranceAndOccupationalDiseaseInsuranceContribution = "subjectToAccidentInsuranceAndOccupationalDiseaseInsuranceContribution";
  })(a.InsuranceCode || (a.InsuranceCode = {})), ((e) => {
    e.Fi = "fi", e.Sv = "sv", e.En = "en";
  })(a.Language || (a.Language = {})), ((e) => {
    e.Illness = "illness", e.PartTimeSickLeave = "partTimeSickLeave", e.ParentalLeave = "parentalLeave", e.SpecialMaternityLeave = "specialMaternityLeave", e.Rehabilitation = "rehabilitation", e.ChildIllness = "childIllness", e.PartTimeChildCareLeave = "partTimeChildCareLeave", e.Training = "training", e.LeaveOfAbsence = "leaveOfAbsence", e.MilitaryRefresherTraining = "militaryRefresherTraining", e.MidWeekHoliday = "midWeekHoliday", e.AccruedHoliday = "accruedHoliday", e.OccupationalAccident = "occupationalAccident", e.AnnualLeave = "annualLeave", e.PartTimeAbsenceDueToRehabilitation = "partTimeAbsenceDueToRehabilitation", e.Other = "other";
  })(a.PaidAbsenceCauseCode || (a.PaidAbsenceCauseCode = {})), ((e) => {
    e.KevasSubmitterCodes = "kevasSubmitterCodes", e.PayersOwnCodes = "payersOwnCodes", e.GovernmentAgencyIdentifier = "governmentAgencyIdentifier";
  })(a.PayerSubOrgType || (a.PayerSubOrgType = {})), ((e) => {
    e.PublicSector = "publicSector", e.Household = "household", e.TemporaryEmployer = "temporaryEmployer", e.ForeignEmployer = "foreignEmployer", e.State = "state", e.UnincorporatedStateEnterpriseOrGovernmentalInstitution = "unincorporatedStateEnterpriseOrGovernmentalInstitution", e.SpecialisedAgency = "specialisedAgency", e.ForeignGroupCompany = "foreignGroupCompany", e.PoolOfHouseholdEmployers = "poolOfHouseholdEmployers";
  })(a.PayerType || (a.PayerType = {})), ((e) => {
    e.Monthly = "monthly", e.Hourly = "hourly", e.ContractPay = "contractPay";
  })(a.PaymentType || (a.PaymentType = {})), ((e) => {
    e.EmployeesEarningsRelatedPensionInsurance = "employeesEarningsRelatedPensionInsurance", e.PensionInsuranceForFarmers = "pensionInsuranceForFarmers", e.PensionInsuranceForTheSelfEmployed = "pensionInsuranceForTheSelfEmployed";
  })(a.PensionActCode || (a.PensionActCode = {})), ((e) => {
    e.None = "none", e.FinnishCentreForPensions = "finnishCentreForPensions", e.ClergyOfTheOrthodoxChurch = "clergyOfTheOrthodoxChurch", e.KevaMemberOrganisations = "kevaMemberOrganisations", e.KevaÅlandLandskapsregeringsPensionssystem = "kevaÅlandLandskapsregeringsPensionssystem", e.KevaChurch = "kevaChurch", e.BankOfFinland = "bankOfFinland", e.KevaKelaEmploymentPensions = "kevaKelaEmploymentPensions", e.KevaState = "kevaState", e.Seafarers = "seafarers", e.Farmers = "farmers", e.Alandia = "alandia", e.Ilmarinen = "ilmarinen", e.Elo = "elo", e.Varma = "varma", e.Veritas = "veritas", e.Etera = "etera", e.UPM = "uPM", e.Sanoma = "sanoma", e.Sandvik = "sandvik", e.Kontino = "kontino", e.Yleisradio = "yleisradio", e.ABB = "aBB", e.LFashionGroup = "lFashionGroup", e.Honeywell = "honeywell", e.Telia = "telia", e.YaraSuomi = "yaraSuomi", e.Orion = "orion", e.Valio = "valio", e.OP = "oP", e.Verso = "verso", e.Apteekkien = "apteekkien", e.Viabek = "viabek", e.Reka = "reka";
  })(a.PensionProvIdCode || (a.PensionProvIdCode = {})), ((e) => {
    e.StatisticsFinland = "statisticsFinland", e.Keva = "keva", e.BankOfFinland = "bankOfFinland", e.Trafi = "trafi";
  })(a.ProfessionType || (a.ProfessionType = {})), ((e) => {
    e.EarningsRelatedPensionProvider = "earningsRelatedPensionProvider";
  })(a.RefPaymentType || (a.RefPaymentType = {})), ((e) => {
    e.KelaDailyAllowanceApplication = "kelaDailyAllowanceApplication", e.KelaFamilyLeaveCompensation = "kelaFamilyLeaveCompensation";
  })(a.ReimbPaymentType || (a.ReimbPaymentType = {})), ((e) => {
    e.DailyAllowance = "dailyAllowance", e.AccommodationBenefit = "accommodationBenefit", e.CarBenefit = "carBenefit", e.OtherBenefit = "otherBenefit";
  })(a.RemunerationCode || (a.RemunerationCode = {})), ((e) => {
    e.Undefined = "undefined", e.Sent = "sent", e.Canceled = "canceled", e.Error = "error";
  })(a.ReportLogEventType || (a.ReportLogEventType = {})), ((e) => {
    e.ContentIssues = "contentIssues", e.TechnicalIssues = "technicalIssues";
  })(a.ResponsibilityCode || (a.ResponsibilityCode = {})), ((e) => {
    e.UntilFurtherNotice = "untilFurtherNotice", e.FixedTerm = "fixedTerm";
  })(a.TermCode || (a.TermCode = {})), ((e) => {
    e.Unknown = "unknown", e.Ignored = "ignored", e.TimeRatePay = "timeRatePay", e.InitiativeFee = "initiativeFee", e.BonusPay = "bonusPay", e.ComplementaryWagePaidDuringBenefitPeriod = "complementaryWagePaidDuringBenefitPeriod", e.EmergencyWorkCompensation = "emergencyWorkCompensation", e.EveningWorkCompensation = "eveningWorkCompensation", e.EveningShiftAllowance = "eveningShiftAllowance", e.NoticePeriodCompensation = "noticePeriodCompensation", e.KilometreAllowanceTaxable = "kilometreAllowanceTaxable", e.MeetingFee = "meetingFee", e.SaturdayPay = "saturdayPay", e.ExtraWorkPremium = "extraWorkPremium", e.HolidayBonus = "holidayBonus", e.LectureFee = "lectureFee", e.CompensationForTrustPosition = "compensationForTrustPosition", e.OtherCompensation = "otherCompensation", e.WaitingTimeCompensation = "waitingTimeCompensation", e.WorkingConditionCompensation = "workingConditionCompensation", e.PartialPayDuringSickLeave = "partialPayDuringSickLeave", e.Commission = "commission", e.SundayWorkCompensation = "sundayWorkCompensation", e.BenefitArisingFromSyntheticOption = "benefitArisingFromSyntheticOption", e.PerformanceBonus = "performanceBonus", e.MonetaryCompensationFromWorkingTimeBank = "monetaryCompensationFromWorkingTimeBank", e.CompensationForAccruedTimeOff = "compensationForAccruedTimeOff", e.ShareIssueForEmployees = "shareIssueForEmployees", e.ContractPay = "contractPay", e.DamagesInConjunctionWithTermination = "damagesInConjunctionWithTermination", e.StandByCompensation = "standByCompensation", e.VoluntaryCompensationInConjunctionWithTermination = "voluntaryCompensationInConjunctionWithTermination", e.WeeklyRestCompensation = "weeklyRestCompensation", e.ProfitSharingBonus = "profitSharingBonus", e.AnnualHolidayCompensation = "annualHolidayCompensation", e.OvertimeCompensation = "overtimeCompensation", e.NightWorkAllowance = "nightWorkAllowance", e.NightShiftCompensation = "nightShiftCompensation", e.OtherRegularCompensation = "otherRegularCompensation", e.CompensationForUnusedCompensatoryLeave = "compensationForUnusedCompensatoryLeave", e.AccommodationBenefit = "accommodationBenefit", e.InterestBenefitForHousingLoan = "interestBenefitForHousingLoan", e.MealAllowance = "mealAllowance", e.CarBenefit = "carBenefit", e.CompensationForGoverningBodyMembership = "compensationForGoverningBodyMembership", e.ShareOfReserveDrawnFromPersonnelFund = "shareOfReserveDrawnFromPersonnelFund", e.MonetaryGiftForEmployees = "monetaryGiftForEmployees", e.KilometreAllowanceTaxExempt = "kilometreAllowanceTaxExempt", e.TreatmentFeeForMunicipalVeterinarian = "treatmentFeeForMunicipalVeterinarian", e.CompensationForUseEarnedIncome = "compensationForUseEarnedIncome", e.CompensationForUseCapitalIncome = "compensationForUseCapitalIncome", e.OtherTaxableBenefitForEmployees = "otherTaxableBenefitForEmployees", e.OtherTaxableIncomeDeemedEarnedIncome = "otherTaxableIncomeDeemedEarnedIncome", e.OtherFringeBenefit = "otherFringeBenefit", e.KinshipCarersFee = "kinshipCarersFee", e.StockOptions = "stockOptions", e.WagesPaidBySubstitutePayerIncludingSocialInsurance = "wagesPaidBySubstitutePayerIncludingSocialInsurance", e.WagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance = "wagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance", e.WagesPaidBySubstitutePayerIncludingUnemploymentInsurance = "wagesPaidBySubstitutePayerIncludingUnemploymentInsurance", e.WagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance = "wagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance", e.WagesPaidBySubstitutePayerIncludingHealthInsurance = "wagesPaidBySubstitutePayerIncludingHealthInsurance", e.CompensationForEmployeeInvention = "compensationForEmployeeInvention", e.ReimbursementOfPrivateCaretakersExpenses = "reimbursementOfPrivateCaretakersExpenses", e.PrivateCaretakersFee = "privateCaretakersFee", e.ReimbursementOfFamilyDayCareProvidersExpenses = "reimbursementOfFamilyDayCareProvidersExpenses", e.TelephoneBenefit = "telephoneBenefit", e.DailyAllowance = "dailyAllowance", e.CapitalIncomePayment = "capitalIncomePayment", e.MealBenefit = "mealBenefit", e.ReimbursementOfCostsPaidToConciliator = "reimbursementOfCostsPaidToConciliator", e.NonWageCompensationForWork = "nonWageCompensationForWork", e.SupplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund = "supplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund", e.PensionPaidByEmployer = "pensionPaidByEmployer", e.DividendsBasedOnWages = "dividendsBasedOnWages", e.DividendsBasedOnNonWage = "dividendsBasedOnNonWage", e.EmployerSubsidisedCommuterTicketTaxExempt = "employerSubsidisedCommuterTicketTaxExempt", e.EmployerSubsidisedCommuterTicketTaxable = "employerSubsidisedCommuterTicketTaxable", e.EmployeeStockOption = "employeeStockOption", e.WagesTransferredToAthletesSpecialFund = "wagesTransferredToAthletesSpecialFund", e.WagesPaidFromAthletesSpecialFund = "wagesPaidFromAthletesSpecialFund", e.WagesForInsurancePurposes = "wagesForInsurancePurposes", e.TaxableReimbursementOfExpenses = "taxableReimbursementOfExpenses", e.PrivateDayCareAllowanceMunicipalSupplement = "privateDayCareAllowanceMunicipalSupplement", e.PrivateDayCareAllowanceWages = "privateDayCareAllowanceWages", e.PrivateDayCareAllowanceNonWage = "privateDayCareAllowanceNonWage", e.KilometreAllowancePaidByNonProfitOrganisation = "kilometreAllowancePaidByNonProfitOrganisation", e.DailyAllowancePaidByNonProfitOrganisation = "dailyAllowancePaidByNonProfitOrganisation", e.UnjustEnrichment = "unjustEnrichment", e.EmployeeStockOptionLowerMarketPrice = "employeeStockOptionLowerMarketPrice", e.RoyaltyPaidToNonResidentTaxpayer = "royaltyPaidToNonResidentTaxpayer", e.BicycleBenefitTaxExempt = "bicycleBenefitTaxExempt", e.BicycleBenefitTaxable = "bicycleBenefitTaxable", e.ConditionalStockOptions = "conditionalStockOptions", e.CopyrightRoyaltiesEarnedIncome = "copyrightRoyaltiesEarnedIncome", e.StockGrantPaidInMoney = "stockGrantPaidInMoney", e.EmployeeStockOptionPaidInMoney = "employeeStockOptionPaidInMoney", e.EarningsFromJuELEmployerToLightEntrepreneur = "earningsFromJuELEmployerToLightEntrepreneur", e.CompensationCollectedForCarBenefit = "compensationCollectedForCarBenefit", e.WithholdingTax = "withholdingTax", e.ElectedOfficialFee = "electedOfficialFee", e.TaxAtSource = "taxAtSource", e.TaxAtSourceDeduction = "taxAtSourceDeduction", e.WagesPaid = "wagesPaid", e.ReimbursementCollectedForOtherFringeBenefits = "reimbursementCollectedForOtherFringeBenefits", e.OtherItemDeductibleFromNetWage = "otherItemDeductibleFromNetWage", e.NetWage = "netWage", e.EmployerPaidPremiumForCollectiveAdditionalPensionInsurance = "employerPaidPremiumForCollectiveAdditionalPensionInsurance", e.EmployerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution = "employerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution", e.EmployeesHealthInsuranceContribution = "employeesHealthInsuranceContribution", e.EmployeesPensionInsuranceContribution = "employeesPensionInsuranceContribution", e.EmployeesUnemploymentInsuranceContribution = "employeesUnemploymentInsuranceContribution", e.ReimbursementForEmployerSubsidisedCommuterTicket = "reimbursementForEmployerSubsidisedCommuterTicket", e.TaxPaidAbroad = "taxPaidAbroad", e.Distraint = "distraint", e.VoluntaryIndividualPensionInsurancePremium = "voluntaryIndividualPensionInsurancePremium", e.DeductionBeforeWithholding = "deductionBeforeWithholding", e.ReimbursementCollectedForBicycleBenefit = "reimbursementCollectedForBicycleBenefit";
  })(a.TransactionCode || (a.TransactionCode = {})), ((e) => {
    e.Illness = "illness", e.PartTimeSickLeave = "partTimeSickLeave", e.ParentalLeave = "parentalLeave", e.SpecialMaternityLeave = "specialMaternityLeave", e.Rehabilitation = "rehabilitation", e.ChildIllness = "childIllness", e.PartTimeChildCareLeave = "partTimeChildCareLeave", e.Training = "training", e.JobAlternationLeave = "jobAlternationLeave", e.StudyLeave = "studyLeave", e.IndustrialAction = "industrialAction", e.InterruptionInWorkProvision = "interruptionInWorkProvision", e.LeaveOfAbsence = "leaveOfAbsence", e.MilitaryRefresherTraining = "militaryRefresherTraining", e.MilitaryService = "militaryService", e.LayOff = "layOff", e.ChildCareLeave = "childCareLeave", e.Other = "other";
  })(a.UnpaidAbsenceCauseCode || (a.UnpaidAbsenceCauseCode = {})), ((e) => {
    e.Hour = "hour", e.Day = "day", e.Week = "week", e.Period = "period";
  })(a.WageUnitCode || (a.WageUnitCode = {})), ((e) => {
    e.Undefined = "undefined", e.Test = "test", e.ZeroPayment = "zeroPayment", e.External = "external", e.PalkkausManual = "palkkausManual", e.PalkkausWS = "palkkausWS", e.PalkkausPSD = "palkkausPSD", e.PalkkausPersonal = "palkkausPersonal", e.PalkkausInvoices = "palkkausInvoices", e.PalkkausCfaPaytrail = "palkkausCfaPaytrail", e.PalkkausCfaReference = "palkkausCfaReference", e.PalkkausCfaFinvoice = "palkkausCfaFinvoice", e.PalkkausEcfaPaytrail = "palkkausEcfaPaytrail", e.PalkkausEcfaReference = "palkkausEcfaReference", e.PalkkausEcfaFinvoice = "palkkausEcfaFinvoice", e.PalkkausCfaTest = "palkkausCfaTest", e.AccountorGo = "accountorGo", e.TalenomOnline = "talenomOnline", e.TalenomCfa = "talenomCfa", e.HolviCfa = "holviCfa", e.FinagoSolo = "finagoSolo", e.Procountor = "procountor", e.Kevytyrittaja = "kevytyrittaja", e.VismaNetvisor = "vismaNetvisor", e.Askelma = "askelma", e.Briox = "briox", e.Lemonaid = "lemonaid", e.Laskupiste = "laskupiste", e.Holvi = "holvi", e.Kompassi = "kompassi", e.Domus = "domus", e.PasseliMerit = "passeliMerit", e.Odoo = "odoo", e.Ecom = "ecom", e.Kitsas = "kitsas";
  })(a.EarningsPaymentReportExtensionsPaymentChannel || (a.EarningsPaymentReportExtensionsPaymentChannel = {})), ((e) => {
    e.Undefined = "undefined", e.Person = "person", e.Company = "company", e.PersonCreatedByEmployer = "personCreatedByEmployer", e.Partner = "partner";
  })(a.AvatarEntityType || (a.AvatarEntityType = {})), ((e) => {
    e.Icon = "icon", e.Uploaded = "uploaded", e.Gravatar = "gravatar";
  })(a.AvatarPictureType || (a.AvatarPictureType = {})), ((e) => {
    e.Default = "default", e.Primary = "primary", e.Success = "success", e.Info = "info", e.Warning = "warning", e.Danger = "danger";
  })(a.WorkflowEventUi || (a.WorkflowEventUi = {})), ((e) => {
    e.None = "none", e.IsActive = "isActive", e.IsEditable = "isEditable", e.IsRemovable = "isRemovable", e.IsOnHold = "isOnHold";
  })(a.Features || (a.Features = {})), ((e) => {
    e.FromFinlandA1CertificateOrAgreement = "fromFinlandA1CertificateOrAgreement", e.ToFinlandA1CertificateOrAgreement = "toFinlandA1CertificateOrAgreement", e.NonEUEEACountryOrNonSocialSecurityAgreementCountry = "nonEUEEACountryOrNonSocialSecurityAgreementCountry";
  })(a.InternationalDataPostedCertCode || (a.InternationalDataPostedCertCode = {})), ((e) => {
    e.NT1 = "nT1", e.NT2 = "nT2", e.EmployersReportOnPeriodsOfStayInFinland = "employersReportOnPeriodsOfStayInFinland", e.EmployeeLeasingNotice = "employeeLeasingNotice";
  })(a.WorkForm || (a.WorkForm = {})), ((e) => {
    e.Undefined = "undefined", e.Test = "test", e.ZeroPayment = "zeroPayment", e.External = "external", e.PalkkausManual = "palkkausManual", e.PalkkausWS = "palkkausWS", e.PalkkausPSD = "palkkausPSD", e.PalkkausPersonal = "palkkausPersonal", e.PalkkausInvoices = "palkkausInvoices", e.PalkkausCfaPaytrail = "palkkausCfaPaytrail", e.PalkkausCfaReference = "palkkausCfaReference", e.PalkkausCfaFinvoice = "palkkausCfaFinvoice", e.PalkkausEcfaPaytrail = "palkkausEcfaPaytrail", e.PalkkausEcfaReference = "palkkausEcfaReference", e.PalkkausEcfaFinvoice = "palkkausEcfaFinvoice", e.PalkkausCfaTest = "palkkausCfaTest", e.AccountorGo = "accountorGo", e.TalenomOnline = "talenomOnline", e.TalenomCfa = "talenomCfa", e.HolviCfa = "holviCfa", e.FinagoSolo = "finagoSolo", e.Procountor = "procountor", e.Kevytyrittaja = "kevytyrittaja", e.VismaNetvisor = "vismaNetvisor", e.Askelma = "askelma", e.Briox = "briox", e.Lemonaid = "lemonaid", e.Laskupiste = "laskupiste", e.Holvi = "holvi", e.Kompassi = "kompassi", e.Domus = "domus", e.PasseliMerit = "passeliMerit", e.Odoo = "odoo", e.Ecom = "ecom", e.Kitsas = "kitsas";
  })(a.EarningsPaymentDataPaymentChannel || (a.EarningsPaymentDataPaymentChannel = {})), ((e) => {
    e.Unknown = "unknown", e.Received = "received", e.InProcess = "inProcess", e.Valid = "valid", e.RejectedAtReception = "rejectedAtReception", e.RejectedDuringProcessing = "rejectedDuringProcessing", e.Cancelled = "cancelled";
  })(a.StatusResponseDeliveryDataStatus || (a.StatusResponseDeliveryDataStatus = {}));
})(ut || (ut = {}));
var kt;
((a) => {
  ((e) => {
    e.NewReport = "newReport", e.ReplacementReport = "replacementReport";
  })(a.ActionCode || (a.ActionCode = {})), ((e) => {
    e.AddressInHomeCountry = "addressInHomeCountry", e.AddressInTheCountryOfWork = "addressInTheCountryOfWork";
  })(a.AddressType || (a.AddressType = {})), ((e) => {
    e.A = "a", e.B = "b", e.C = "c", e.U = "u";
  })(a.AgeGroupCode || (a.AgeGroupCode = {})), ((e) => {
    e.MealAllowance = "mealAllowance", e.PartialDailyAllowance = "partialDailyAllowance", e.FullDailyAllowance = "fullDailyAllowance", e.InternationalDailyAllowance = "internationalDailyAllowance", e.TaxExemptReimbursementsAbroad = "taxExemptReimbursementsAbroad";
  })(a.AllowanceCode || (a.AllowanceCode = {})), ((e) => {
    e.General = "general", e.Required = "required", e.Invalid = "invalid", e.Warning = "warning";
  })(a.ApiValidationErrorType || (a.ApiValidationErrorType = {})), ((e) => {
    e.AccommodationBenefit = "accommodationBenefit", e.TelephoneBenefit = "telephoneBenefit", e.MealBenefit = "mealBenefit", e.OtherBenefits = "otherBenefits";
  })(a.BenefitCode || (a.BenefitCode = {})), ((e) => {
    e.LimitedCarBenefit = "limitedCarBenefit", e.FullCarBenefit = "fullCarBenefit";
  })(a.CarBenefitCode || (a.CarBenefitCode = {})), ((e) => {
    e.EarningsPaymentReports = "earningsPaymentReports", e.EmployersSeparateReports = "employersSeparateReports", e.BenefitsPaymentReports = "benefitsPaymentReports", e.RecordSubscription = "recordSubscription", e.Messages = "messages", e.CancellationOfEarningsPaymentReports = "cancellationOfEarningsPaymentReports", e.CancellationOfEmployersSeparateReports = "cancellationOfEmployersSeparateReports", e.CancellationOfBenefitsPaymentReports = "cancellationOfBenefitsPaymentReports", e.CancellationOfARecordSubscription = "cancellationOfARecordSubscription", e.CancellationOfARecordContainingEarningsPaymentReports = "cancellationOfARecordContainingEarningsPaymentReports", e.CancellationOfARecordContainingEmployersSeparateReports = "cancellationOfARecordContainingEmployersSeparateReports", e.CancellationOfARecordContainingBenefitsPaymentReports = "cancellationOfARecordContainingBenefitsPaymentReports", e.CancellationOfARecordContainingARecordSubscription = "cancellationOfARecordContainingARecordSubscription";
  })(a.DeliveryDataType || (a.DeliveryDataType = {})), ((e) => {
    e.FullTime = "fullTime", e.PartTime = "partTime", e.NotAvailable = "notAvailable";
  })(a.EmploymentCode || (a.EmploymentCode = {})), ((e) => {
    e.EmployeesResignation = "employeesResignation", e.Other = "other", e.TerminationGroundsRelatedToEmployeesPerson = "terminationGroundsRelatedToEmployeesPerson", e.FinancialAndProductionRelatedGrounds = "financialAndProductionRelatedGrounds", e.JointAgreement = "jointAgreement", e.Retirement = "retirement", e.TerminationOfaFixedTermEmployment = "terminationOfaFixedTermEmployment";
  })(a.EmploymentEndingCode || (a.EmploymentEndingCode = {})), ((e) => {
    e.KevaCodes = "kevaCodes", e.BankOfFinlandCodes = "bankOfFinlandCodes", e.IncomesRegisterCodes = "incomesRegisterCodes";
  })(a.EmploymentEndingType || (a.EmploymentEndingType = {})), ((e) => {
    e.NoObligationToSocialInsurance = "noObligationToSocialInsurance", e.NoObligationToHealthInsurance = "noObligationToHealthInsurance", e.NoObligationToEarningsRelatedPensionInsurance = "noObligationToEarningsRelatedPensionInsurance", e.NoObligationToAccidentAndOccupationalDiseaseInsurance = "noObligationToAccidentAndOccupationalDiseaseInsurance", e.NoObligationToUnemploymentInsurance = "noObligationToUnemploymentInsurance", e.NotSubjectToSocialInsurance = "notSubjectToSocialInsurance", e.NotSubjectToEarningsRelatedPensionInsurance = "notSubjectToEarningsRelatedPensionInsurance", e.NotSubjectToAccidentAndOccupationalDiseaseInsurance = "notSubjectToAccidentAndOccupationalDiseaseInsurance", e.NotSubjectToUnemploymentInsurance = "notSubjectToUnemploymentInsurance", e.NotSubjectToHealthInsurance = "notSubjectToHealthInsurance", e.VoluntaryEarningsRelatedPensionInsurance = "voluntaryEarningsRelatedPensionInsurance";
  })(a.ExceptionCode || (a.ExceptionCode = {})), ((e) => {
    e.OnlyInvalidItems = "onlyInvalidItems", e.EntireRecordIsRejected = "entireRecordIsRejected";
  })(a.FaultyControl || (a.FaultyControl = {})), ((e) => {
    e.Male = "male", e.Female = "female";
  })(a.Gender || (a.Gender = {})), ((e) => {
    e.BusinessId = "businessId", e.PersonalIdentificationNumber = "personalIdentificationNumber", e.Vat = "vat", e.Giin = "giin", e.TaxIdentificationNumber = "taxIdentificationNumber", e.FinnishTradeRegistrationNumber = "finnishTradeRegistrationNumber", e.ForeignBusinessRegistrationNumber = "foreignBusinessRegistrationNumber", e.ForeignPersonalIdentificationNumber = "foreignPersonalIdentificationNumber", e.Other = "other";
  })(a.IdType || (a.IdType = {})), ((e) => {
    e.SubjectToSocialInsuranceContributions = "subjectToSocialInsuranceContributions", e.SubjectToEarningsRelatedPensionInsuranceContribution = "subjectToEarningsRelatedPensionInsuranceContribution", e.SubjectToHealthInsuranceContribution = "subjectToHealthInsuranceContribution", e.SubjectToUnemploymentInsuranceContribution = "subjectToUnemploymentInsuranceContribution", e.SubjectToAccidentInsuranceAndOccupationalDiseaseInsuranceContribution = "subjectToAccidentInsuranceAndOccupationalDiseaseInsuranceContribution";
  })(a.InsuranceCode || (a.InsuranceCode = {})), ((e) => {
    e.Send = "send", e.Cancel = "cancel";
  })(a.IrScheduleAction || (a.IrScheduleAction = {})), ((e) => {
    e.Fi = "fi", e.Sv = "sv", e.En = "en";
  })(a.Language || (a.Language = {})), ((e) => {
    e.Illness = "illness", e.PartTimeSickLeave = "partTimeSickLeave", e.ParentalLeave = "parentalLeave", e.SpecialMaternityLeave = "specialMaternityLeave", e.Rehabilitation = "rehabilitation", e.ChildIllness = "childIllness", e.PartTimeChildCareLeave = "partTimeChildCareLeave", e.Training = "training", e.LeaveOfAbsence = "leaveOfAbsence", e.MilitaryRefresherTraining = "militaryRefresherTraining", e.MidWeekHoliday = "midWeekHoliday", e.AccruedHoliday = "accruedHoliday", e.OccupationalAccident = "occupationalAccident", e.AnnualLeave = "annualLeave", e.PartTimeAbsenceDueToRehabilitation = "partTimeAbsenceDueToRehabilitation", e.Other = "other";
  })(a.PaidAbsenceCauseCode || (a.PaidAbsenceCauseCode = {})), ((e) => {
    e.PublicSector = "publicSector", e.Household = "household", e.TemporaryEmployer = "temporaryEmployer", e.ForeignEmployer = "foreignEmployer", e.State = "state", e.UnincorporatedStateEnterpriseOrGovernmentalInstitution = "unincorporatedStateEnterpriseOrGovernmentalInstitution", e.SpecialisedAgency = "specialisedAgency", e.ForeignGroupCompany = "foreignGroupCompany", e.PoolOfHouseholdEmployers = "poolOfHouseholdEmployers";
  })(a.PayerType || (a.PayerType = {})), ((e) => {
    e.KevasSubmitterCodes = "kevasSubmitterCodes", e.PayersOwnCodes = "payersOwnCodes", e.GovernmentAgencyIdentifier = "governmentAgencyIdentifier";
  })(a.PayerSubOrgType || (a.PayerSubOrgType = {})), ((e) => {
    e.New = "new", e.Scheduled = "scheduled", e.Succeeded = "succeeded", e.Canceled = "canceled", e.Error = "error", e.Invalid = "invalid";
  })(a.PayerSummaryReportStatus || (a.PayerSummaryReportStatus = {})), ((e) => {
    e.Monthly = "monthly", e.Hourly = "hourly", e.ContractPay = "contractPay";
  })(a.PaymentType || (a.PaymentType = {})), ((e) => {
    e.EmployeesEarningsRelatedPensionInsurance = "employeesEarningsRelatedPensionInsurance", e.PensionInsuranceForFarmers = "pensionInsuranceForFarmers", e.PensionInsuranceForTheSelfEmployed = "pensionInsuranceForTheSelfEmployed";
  })(a.PensionActCode || (a.PensionActCode = {})), ((e) => {
    e.None = "none", e.FinnishCentreForPensions = "finnishCentreForPensions", e.ClergyOfTheOrthodoxChurch = "clergyOfTheOrthodoxChurch", e.KevaMemberOrganisations = "kevaMemberOrganisations", e.KevaÅlandLandskapsregeringsPensionssystem = "kevaÅlandLandskapsregeringsPensionssystem", e.KevaChurch = "kevaChurch", e.BankOfFinland = "bankOfFinland", e.KevaKelaEmploymentPensions = "kevaKelaEmploymentPensions", e.KevaState = "kevaState", e.Seafarers = "seafarers", e.Farmers = "farmers", e.Alandia = "alandia", e.Ilmarinen = "ilmarinen", e.Elo = "elo", e.Varma = "varma", e.Veritas = "veritas", e.Etera = "etera", e.UPM = "uPM", e.Sanoma = "sanoma", e.Sandvik = "sandvik", e.Kontino = "kontino", e.Yleisradio = "yleisradio", e.ABB = "aBB", e.LFashionGroup = "lFashionGroup", e.Honeywell = "honeywell", e.Telia = "telia", e.YaraSuomi = "yaraSuomi", e.Orion = "orion", e.Valio = "valio", e.OP = "oP", e.Verso = "verso", e.Apteekkien = "apteekkien", e.Viabek = "viabek", e.Reka = "reka";
  })(a.PensionProvIdCode || (a.PensionProvIdCode = {})), ((e) => {
    e.StatisticsFinland = "statisticsFinland", e.Keva = "keva", e.BankOfFinland = "bankOfFinland", e.Trafi = "trafi";
  })(a.ProfessionType || (a.ProfessionType = {})), ((e) => {
    e.EarningsRelatedPensionProvider = "earningsRelatedPensionProvider";
  })(a.RefPaymentType || (a.RefPaymentType = {})), ((e) => {
    e.KelaDailyAllowanceApplication = "kelaDailyAllowanceApplication", e.KelaFamilyLeaveCompensation = "kelaFamilyLeaveCompensation";
  })(a.ReimbPaymentType || (a.ReimbPaymentType = {})), ((e) => {
    e.DailyAllowance = "dailyAllowance", e.AccommodationBenefit = "accommodationBenefit", e.CarBenefit = "carBenefit", e.OtherBenefit = "otherBenefit";
  })(a.RemunerationCode || (a.RemunerationCode = {})), ((e) => {
    e.Undefined = "undefined", e.Sent = "sent", e.Canceled = "canceled", e.Error = "error";
  })(a.ReportLogEventType || (a.ReportLogEventType = {})), ((e) => {
    e.ContentIssues = "contentIssues", e.TechnicalIssues = "technicalIssues";
  })(a.ResponsibilityCode || (a.ResponsibilityCode = {})), ((e) => {
    e.Undefined = "undefined", e.NoWagesPayable = "noWagesPayable", e.EmployersHealthInsuranceContribution = "employersHealthInsuranceContribution", e.DeductionsToBeMadeFromTheEmployersHealthInsuranceContribution = "deductionsToBeMadeFromTheEmployersHealthInsuranceContribution";
  })(a.SummaryTransactionCode || (a.SummaryTransactionCode = {})), ((e) => {
    e.UntilFurtherNotice = "untilFurtherNotice", e.FixedTerm = "fixedTerm";
  })(a.TermCode || (a.TermCode = {})), ((e) => {
    e.Unknown = "unknown", e.Ignored = "ignored", e.TimeRatePay = "timeRatePay", e.InitiativeFee = "initiativeFee", e.BonusPay = "bonusPay", e.ComplementaryWagePaidDuringBenefitPeriod = "complementaryWagePaidDuringBenefitPeriod", e.EmergencyWorkCompensation = "emergencyWorkCompensation", e.EveningWorkCompensation = "eveningWorkCompensation", e.EveningShiftAllowance = "eveningShiftAllowance", e.NoticePeriodCompensation = "noticePeriodCompensation", e.KilometreAllowanceTaxable = "kilometreAllowanceTaxable", e.MeetingFee = "meetingFee", e.SaturdayPay = "saturdayPay", e.ExtraWorkPremium = "extraWorkPremium", e.HolidayBonus = "holidayBonus", e.LectureFee = "lectureFee", e.CompensationForTrustPosition = "compensationForTrustPosition", e.OtherCompensation = "otherCompensation", e.WaitingTimeCompensation = "waitingTimeCompensation", e.WorkingConditionCompensation = "workingConditionCompensation", e.PartialPayDuringSickLeave = "partialPayDuringSickLeave", e.Commission = "commission", e.SundayWorkCompensation = "sundayWorkCompensation", e.BenefitArisingFromSyntheticOption = "benefitArisingFromSyntheticOption", e.PerformanceBonus = "performanceBonus", e.MonetaryCompensationFromWorkingTimeBank = "monetaryCompensationFromWorkingTimeBank", e.CompensationForAccruedTimeOff = "compensationForAccruedTimeOff", e.ShareIssueForEmployees = "shareIssueForEmployees", e.ContractPay = "contractPay", e.DamagesInConjunctionWithTermination = "damagesInConjunctionWithTermination", e.StandByCompensation = "standByCompensation", e.VoluntaryCompensationInConjunctionWithTermination = "voluntaryCompensationInConjunctionWithTermination", e.WeeklyRestCompensation = "weeklyRestCompensation", e.ProfitSharingBonus = "profitSharingBonus", e.AnnualHolidayCompensation = "annualHolidayCompensation", e.OvertimeCompensation = "overtimeCompensation", e.NightWorkAllowance = "nightWorkAllowance", e.NightShiftCompensation = "nightShiftCompensation", e.OtherRegularCompensation = "otherRegularCompensation", e.CompensationForUnusedCompensatoryLeave = "compensationForUnusedCompensatoryLeave", e.AccommodationBenefit = "accommodationBenefit", e.InterestBenefitForHousingLoan = "interestBenefitForHousingLoan", e.MealAllowance = "mealAllowance", e.CarBenefit = "carBenefit", e.CompensationForGoverningBodyMembership = "compensationForGoverningBodyMembership", e.ShareOfReserveDrawnFromPersonnelFund = "shareOfReserveDrawnFromPersonnelFund", e.MonetaryGiftForEmployees = "monetaryGiftForEmployees", e.KilometreAllowanceTaxExempt = "kilometreAllowanceTaxExempt", e.TreatmentFeeForMunicipalVeterinarian = "treatmentFeeForMunicipalVeterinarian", e.CompensationForUseEarnedIncome = "compensationForUseEarnedIncome", e.CompensationForUseCapitalIncome = "compensationForUseCapitalIncome", e.OtherTaxableBenefitForEmployees = "otherTaxableBenefitForEmployees", e.OtherTaxableIncomeDeemedEarnedIncome = "otherTaxableIncomeDeemedEarnedIncome", e.OtherFringeBenefit = "otherFringeBenefit", e.KinshipCarersFee = "kinshipCarersFee", e.StockOptions = "stockOptions", e.WagesPaidBySubstitutePayerIncludingSocialInsurance = "wagesPaidBySubstitutePayerIncludingSocialInsurance", e.WagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance = "wagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance", e.WagesPaidBySubstitutePayerIncludingUnemploymentInsurance = "wagesPaidBySubstitutePayerIncludingUnemploymentInsurance", e.WagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance = "wagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance", e.WagesPaidBySubstitutePayerIncludingHealthInsurance = "wagesPaidBySubstitutePayerIncludingHealthInsurance", e.CompensationForEmployeeInvention = "compensationForEmployeeInvention", e.ReimbursementOfPrivateCaretakersExpenses = "reimbursementOfPrivateCaretakersExpenses", e.PrivateCaretakersFee = "privateCaretakersFee", e.ReimbursementOfFamilyDayCareProvidersExpenses = "reimbursementOfFamilyDayCareProvidersExpenses", e.TelephoneBenefit = "telephoneBenefit", e.DailyAllowance = "dailyAllowance", e.CapitalIncomePayment = "capitalIncomePayment", e.MealBenefit = "mealBenefit", e.ReimbursementOfCostsPaidToConciliator = "reimbursementOfCostsPaidToConciliator", e.NonWageCompensationForWork = "nonWageCompensationForWork", e.SupplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund = "supplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund", e.PensionPaidByEmployer = "pensionPaidByEmployer", e.DividendsBasedOnWages = "dividendsBasedOnWages", e.DividendsBasedOnNonWage = "dividendsBasedOnNonWage", e.EmployerSubsidisedCommuterTicketTaxExempt = "employerSubsidisedCommuterTicketTaxExempt", e.EmployerSubsidisedCommuterTicketTaxable = "employerSubsidisedCommuterTicketTaxable", e.EmployeeStockOption = "employeeStockOption", e.WagesTransferredToAthletesSpecialFund = "wagesTransferredToAthletesSpecialFund", e.WagesPaidFromAthletesSpecialFund = "wagesPaidFromAthletesSpecialFund", e.WagesForInsurancePurposes = "wagesForInsurancePurposes", e.TaxableReimbursementOfExpenses = "taxableReimbursementOfExpenses", e.PrivateDayCareAllowanceMunicipalSupplement = "privateDayCareAllowanceMunicipalSupplement", e.PrivateDayCareAllowanceWages = "privateDayCareAllowanceWages", e.PrivateDayCareAllowanceNonWage = "privateDayCareAllowanceNonWage", e.KilometreAllowancePaidByNonProfitOrganisation = "kilometreAllowancePaidByNonProfitOrganisation", e.DailyAllowancePaidByNonProfitOrganisation = "dailyAllowancePaidByNonProfitOrganisation", e.UnjustEnrichment = "unjustEnrichment", e.EmployeeStockOptionLowerMarketPrice = "employeeStockOptionLowerMarketPrice", e.RoyaltyPaidToNonResidentTaxpayer = "royaltyPaidToNonResidentTaxpayer", e.BicycleBenefitTaxExempt = "bicycleBenefitTaxExempt", e.BicycleBenefitTaxable = "bicycleBenefitTaxable", e.ConditionalStockOptions = "conditionalStockOptions", e.CopyrightRoyaltiesEarnedIncome = "copyrightRoyaltiesEarnedIncome", e.StockGrantPaidInMoney = "stockGrantPaidInMoney", e.EmployeeStockOptionPaidInMoney = "employeeStockOptionPaidInMoney", e.EarningsFromJuELEmployerToLightEntrepreneur = "earningsFromJuELEmployerToLightEntrepreneur", e.CompensationCollectedForCarBenefit = "compensationCollectedForCarBenefit", e.WithholdingTax = "withholdingTax", e.ElectedOfficialFee = "electedOfficialFee", e.TaxAtSource = "taxAtSource", e.TaxAtSourceDeduction = "taxAtSourceDeduction", e.WagesPaid = "wagesPaid", e.ReimbursementCollectedForOtherFringeBenefits = "reimbursementCollectedForOtherFringeBenefits", e.OtherItemDeductibleFromNetWage = "otherItemDeductibleFromNetWage", e.NetWage = "netWage", e.EmployerPaidPremiumForCollectiveAdditionalPensionInsurance = "employerPaidPremiumForCollectiveAdditionalPensionInsurance", e.EmployerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution = "employerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution", e.EmployeesHealthInsuranceContribution = "employeesHealthInsuranceContribution", e.EmployeesPensionInsuranceContribution = "employeesPensionInsuranceContribution", e.EmployeesUnemploymentInsuranceContribution = "employeesUnemploymentInsuranceContribution", e.ReimbursementForEmployerSubsidisedCommuterTicket = "reimbursementForEmployerSubsidisedCommuterTicket", e.TaxPaidAbroad = "taxPaidAbroad", e.Distraint = "distraint", e.VoluntaryIndividualPensionInsurancePremium = "voluntaryIndividualPensionInsurancePremium", e.DeductionBeforeWithholding = "deductionBeforeWithholding", e.ReimbursementCollectedForBicycleBenefit = "reimbursementCollectedForBicycleBenefit";
  })(a.TransactionCode || (a.TransactionCode = {})), ((e) => {
    e.Illness = "illness", e.PartTimeSickLeave = "partTimeSickLeave", e.ParentalLeave = "parentalLeave", e.SpecialMaternityLeave = "specialMaternityLeave", e.Rehabilitation = "rehabilitation", e.ChildIllness = "childIllness", e.PartTimeChildCareLeave = "partTimeChildCareLeave", e.Training = "training", e.JobAlternationLeave = "jobAlternationLeave", e.StudyLeave = "studyLeave", e.IndustrialAction = "industrialAction", e.InterruptionInWorkProvision = "interruptionInWorkProvision", e.LeaveOfAbsence = "leaveOfAbsence", e.MilitaryRefresherTraining = "militaryRefresherTraining", e.MilitaryService = "militaryService", e.LayOff = "layOff", e.ChildCareLeave = "childCareLeave", e.Other = "other";
  })(a.UnpaidAbsenceCauseCode || (a.UnpaidAbsenceCauseCode = {})), ((e) => {
    e.Hour = "hour", e.Day = "day", e.Week = "week", e.Period = "period";
  })(a.WageUnitCode || (a.WageUnitCode = {})), ((e) => {
    e.Default = "default", e.Primary = "primary", e.Success = "success", e.Info = "info", e.Warning = "warning", e.Danger = "danger";
  })(a.WorkflowEventUi || (a.WorkflowEventUi = {})), ((e) => {
    e.None = "none", e.IsActive = "isActive", e.IsEditable = "isEditable", e.IsRemovable = "isRemovable", e.IsOnHold = "isOnHold";
  })(a.Features || (a.Features = {})), ((e) => {
    e.Undefined = "undefined", e.Person = "person", e.Company = "company", e.PersonCreatedByEmployer = "personCreatedByEmployer", e.Partner = "partner";
  })(a.AvatarEntityType || (a.AvatarEntityType = {})), ((e) => {
    e.Icon = "icon", e.Uploaded = "uploaded", e.Gravatar = "gravatar";
  })(a.AvatarPictureType || (a.AvatarPictureType = {})), ((e) => {
    e.Unknown = "unknown", e.Received = "received", e.InProcess = "inProcess", e.Valid = "valid", e.RejectedAtReception = "rejectedAtReception", e.RejectedDuringProcessing = "rejectedDuringProcessing", e.Cancelled = "cancelled";
  })(a.StatusResponseDeliveryDataStatus || (a.StatusResponseDeliveryDataStatus = {}));
})(kt || (kt = {}));
var cr = /* @__PURE__ */ ((a) => (a.Person = "person", a.Company = "company", a))(cr || {}), pr = /* @__PURE__ */ ((a) => (a.None = "none", a.Household = "household", a.Worker = "worker", a.Company = "company", a))(pr || {}), hr = /* @__PURE__ */ ((a) => (a.CREATE = "create", a.UPDATE = "update", a.DELETE = "delete", a))(hr || {});
const yr = [
  {
    code: 101,
    nameEn: "Total wages",
    nameFi: "Palkka yhteissumma",
    nameSv: "Lön totalt",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: null,
    notSupportedError: "Reporting method 1 (codes 101-106) is not supported in this version",
    descriptionEn: "",
    descriptionFi: "Ei käytössä: Palkkaus.fi-palvelussa ei käytetä ilmoitustapaa 1.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 102,
    nameEn: "Total wages subject to earnings-related pension insurance contribution ",
    nameFi: "Palkkasumma, joka on työeläkevakuutusmaksun alainen ",
    nameSv: "Lönesumma som omfattas av arbetspensionsförsäkringsavgiften ",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: null,
    notSupportedError: "Reporting method 1 (codes 101-106) is not supported in this version",
    descriptionEn: "",
    descriptionFi: "Ei käytössä: Palkkaus.fi-palvelussa ei käytetä ilmoitustapaa 1.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 103,
    nameEn: "Total wages subject to social insurance contributions",
    nameFi: "Palkkasumma, joka on sosiaalivakuutusmaksujen alainen",
    nameSv: "Lönesumma som omfattas av socialförsäkringsavgifter",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: null,
    notSupportedError: "Reporting method 1 (codes 101-106) is not supported in this version",
    descriptionEn: "",
    descriptionFi: "Ei käytössä: Palkkaus.fi-palvelussa ei käytetä ilmoitustapaa 1.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 104,
    nameEn: "Total wages subject to health insurance contribution",
    nameFi: "Palkkasumma, joka on sairausvakuutusmaksun alainen",
    nameSv: "Lönesumma som omfattas av sjukförsäkringsavgiften",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: null,
    notSupportedError: "Reporting method 1 (codes 101-106) is not supported in this version",
    descriptionEn: "",
    descriptionFi: "Ei käytössä: Palkkaus.fi-palvelussa ei käytetä ilmoitustapaa 1.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 105,
    nameEn: "Total wages subject to unemployment insurance contribution",
    nameFi: "Palkkasumma, joka on työttömyysvakuutusmaksun alainen",
    nameSv: "Lönesumma som omfattas av arbetslöshetsförsäkringsavgiften",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !0,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: null,
    notSupportedError: "Reporting method 1 (codes 101-106) is not supported in this version",
    descriptionEn: "",
    descriptionFi: "Ei käytössä: Palkkaus.fi-palvelussa ei käytetä ilmoitustapaa 1.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 106,
    nameEn: "Total wages subject to accident and occupational disease insurance contribution",
    nameFi: "Palkkasumma, joka on työtapaturma- ja ammattitautivakuutusmaksun alainen",
    nameSv: "Lönesumma som omfattas av arbetsolycksfalls- och yrkessjukdomsförsäkringsavgiften",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !0,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: null,
    notSupportedError: "Reporting method 1 (codes 101-106) is not supported in this version",
    descriptionEn: "",
    descriptionFi: "Ei käytössä: Palkkaus.fi-palvelussa ei käytetä ilmoitustapaa 1.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 201,
    nameEn: "Time-rate pay",
    nameFi: "Aikapalkka",
    nameSv: "Tidlön",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "timeRatePay",
    notSupportedError: null,
    descriptionEn: `Wages paid based on the time worked. Time-rate\r
pay can be defined for a calendar month, for example.`,
    descriptionFi: "Palkka, jota maksetaan työhön käytetyn ajan perusteella. Aikapalkka voidaan määritellä esimerkiksi kalenterikuukaudelle.",
    descriptionSv: "Lön som betalas på basis av arbetstiden. Tidlön kan fastställas t.ex. för en kalendermånad.",
    taxAndSideCostsDescrEn: `Tax is withheld and employer's social insurance\r
contributions paid from time-rate pay.`,
    taxAndSideCostsDescrFi: "Aikapalkasta toimitetaan ennakonpidätys ja maksetaan työnantajan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "På tidlön verkställs förskottsinnehållning och betalas arbetsgivares socialförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/wages"
    ],
    calcGrouping: "baseSalary"
  },
  {
    code: 202,
    nameEn: "Initiative fee",
    nameFi: "Aloitepalkkio",
    nameSv: "Initiativarvode",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "initiativeFee",
    notSupportedError: null,
    descriptionEn: `One-off remuneration paid to the originator of an initiative related to the development of operations or\r
a product, for example.`,
    descriptionFi: "Kertapalkkio, joka maksetaan aloitteen tekijälle esimerkiksi toiminnan tai tuotteen kehittämiseen liittyvästä aloitteesta.",
    descriptionSv: "Engångsersättning som betalas till initiativtagare t.ex. i samband med utveckling av verksamheten eller produkter",
    taxAndSideCostsDescrEn: `If the initiative fee is related to work agreed in the\r
employment contract, the fee is treated as wages,\r
i.e., in addition to withholding, social insurance contributions are paid from the fee.\r
If the recipient of the initiative fee is not employed\r
by the payer, or the initiative is not related to the\r
work agreed in the employee's employment contract, no social insurance contributions are paid for\r
the fee. In this kind of situation, tax is withheld from\r
the initiative fee, unless the recipient of the initiative\r
fee is registered in the Prepayment Register.\r
By default, this income type is subject to social insurance contributions.\r
In an exceptional case where the initiative fee is\r
not subject to the above-mentioned contributions,\r
the payer reports the insurance information separately.`,
    taxAndSideCostsDescrFi: `Jos aloitepalkkio liittyy työsopimuksessa sovittuun työhön, palkkiota käsitellään palkkana eli ennakonpidätyksen toimittamisen lisäksi palkkiosta maksetaan sosiaalivakuutusmaksut.\r
\r
Jos aloitepalkkion saaja ei ole palvelussuhteessa palkkion maksajaan tai aloite ei liity työntekijän työsopimuksessa sovittuun työhön, palkkiosta ei makseta sosiaalivakuutusmaksuja. Tällöin aloitepalkkiosta toimitetaan ennakonpidätys, ellei aloitepalkkion saaja kuulu ennakkoperintärekisteriin.\r
\r
Oletuksena tulolajissa on, että se on sosiaalivakuutusmaksujen alainen.\r
\r
Jos poikkeuksellisesti aloitepalkkio ei olisikaan edellä mainittujen maksujen alainen, suorituksen maksaja ilmoittaa vakuuttamistiedon erillisenä tietona.`,
    taxAndSideCostsDescrSv: "Om förslagsbelöningen anknyter till arbete som avtalats i arbetsavtalet, behandlas arvodet som lön, dvs. utöver att förskottsinnehållning verkställs, betalas även socialförsäkringsavgifter på arvodet. Om mottagaren av förslagsbelöning inte står i anställningsförhållande till den som betalar belöningen eller förslaget inte anknyter till det arbete som avtalats i arbetstagarens arbetsavtal, betalas inga socialförsäkringsavgifter på belöningen. På förslagsbelöningen verkställs då förskottsinnehållning, om mottagaren av förslagsbelöningen inte är införd i förskottsuppbördsregistret. I inkomstslaget är det förvalt att inkomsten är underställd socialförsäkringsavgifter. Om förslagsbelöningen undantagsvis inte är underställd ovan nämnda avgifter, anmäler betalaren försäkringsuppgiften separat. Se anvisningen Anmälan av information till inkomstregistret: uppgifter i anslutning till försäkrande.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/renumeration"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 203,
    nameEn: "Bonus pay",
    nameFi: "Bonuspalkka",
    nameSv: "Bonuslön",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "bonusPay",
    notSupportedError: null,
    descriptionEn: `One-off remuneration, the amount of which is partially or fully determined by how well the work result\r
set as the target is achieved. The performance\r
metric can be volume, quality, or some other performance factor.\r
Bonus pay differs from commission by being oneoff in nature, while a commission is a remuneration\r
of a continuous nature. Both of these are based on\r
achieving a pre-set target for a person or a group.\r
Bonus pay differs from profit-sharing bonus in that\r
the profit-sharing bonus is paid without a plan agreed in advance, based on the company's profit.`,
    descriptionFi: `Kertaluonteinen palkkiopalkka, jonka suuruus määräytyy kokonaan tai osittain sen mukaan, kuinka hyvin tavoitteeksi asetettu työtulos saavutetaan. Työtuloksen mittana voi olla määrä, laatu tai jokin muu tulostekijä.\r
\r
Bonuspalkka eroaa provisiopalkasta siten, että bonuspalkka on kertaluonteinen ja provisio on jatkuvaluonteinen palkkiopalkka. Kumpikin näistä perustuu henkilön tai ryhmän ennalta asetetun tavoitteen saavuttamiseen. Bonuspalkka eroaa voittopalkkiosta siten, että voittopalkkio maksetaan ilman ennalta sovittua suunnitelmaa, yrityksen voiton perusteella.`,
    descriptionSv: `Premielön av engångsnatur, vars storlek bestäms helt eller delvis utifrån hur väl det arbetsresultat som ställts upp som mål uppnås. Arbetsresultatet kan mätas med mängd, kvalitet eller någon annan resultatfaktor. Bonuslön skiljer sig från provisionslön på så sätt,\r
att bonuslön är en premielön av engångsnatur och provision är en premielön av kontinuerlig karaktär.\r
Dessa två baserar sig på att nå målsättningen som\r
ställts på förhand åt personen eller gruppen.\r
Bonuslön skiljer sig från vinstarvoden på så sätt, att\r
vinstarvode betalas utan en på förhand avtalad\r
plan och som bildas utifrån företagets vinst.`,
    taxAndSideCostsDescrEn: "Tax is withheld and employer's social insurance contributions are paid from the bonus pay.",
    taxAndSideCostsDescrFi: "Bonuspalkasta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på bonuslön och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/renumeration"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 204,
    nameEn: "Complementary wage/salary paid during benefit period",
    nameFi: "Etuusajalta maksettu täydennyspalkka",
    nameSv: "Kompletteringslön för förmånstid",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "complementaryWagePaidDuringBenefitPeriod",
    notSupportedError: null,
    descriptionEn: `Wages paid to an employee receiving a benefit that\r
cover the difference between full wages and the\r
benefit paid.\r
Such a benefit could be a daily sickness allowance\r
paid by Kela. If the employer pays complementary\r
wages during the benefit period, Kela pays the\r
benefit directly to the employee, not the employer.`,
    descriptionFi: `Etuutta saavalle työntekijälle maksettu palkka, joka kattaa täyden palkan ja maksetun etuuden välisen erotuksen.\r
\r
Maksettu etuus voi olla esimerkiksi Kelan maksama sairauspäiväraha. Kun työnantaja maksaa etuusajalta täydennyspalkkaa, Kela maksaa etuuden suoraan työntekijälle, ei työnantajalle.`,
    descriptionSv: `Lön som betalas till en arbetstagare som erhåller en förmån och som täcker differensen mellan den fulla lönen och den utbetalda förmånen. Den betalda förmånen kan även vara\r
sjukdagpenning som betalas av FPA. När\r
arbetsgivaren betalar kompletteringslön för\r
förmånstid, betalar FPA förmånen direkt till\r
arbetstagaren, inte till arbetsgivaren.`,
    taxAndSideCostsDescrEn: `Tax is withheld and employer's social insurance\r
contributions are paid out of the complementary\r
wages paid during the benefit period.`,
    taxAndSideCostsDescrFi: "Etuusajalta maksetusta täydennyspalkasta toimitetaan ennakonpidätys ja maksetaan työnantajan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "På kompletteringslön för förmånstiden verkställs förskottsinnehållning och betalas arbetsgivarens socialförsäkringsavgifter",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/sickness"
    ],
    calcGrouping: "baseSalary"
  },
  {
    code: 205,
    nameEn: "Emergency work compensation",
    nameFi: "Hätätyökorvaus",
    nameSv: "Ersättning för nödarbete",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "emergencyWorkCompensation",
    notSupportedError: null,
    descriptionEn: `Working time compensation paid for emergency\r
work. Emergency work means work assigned in an\r
emergency situation outside regular working hours.`,
    descriptionFi: "Työaikakorvaus, joka maksetaan hätätyöstä. Hätätyöllä tarkoitetaan hätätilanteessa säännöllisen työajan ylittävänä aikana teetettävää työtä.",
    descriptionSv: "Arbetstidsersättning för nödarbete. Med nödarbete avses arbete som utförs i nödsituationer under tid som överskrider ordinarie arbetstid.",
    taxAndSideCostsDescrEn: `Tax is withheld and employer's social insurance\r
contributions are paid from emergency work compensation.`,
    taxAndSideCostsDescrFi: "Hätätyökorvauksesta toimitetaan ennakonpidätys ja maksetaan työnantajan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "På nödarbete verkställs förskottsinnehållning och betalas arbetsgivares socialförsäkringsavgift",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/workingTimeCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 206,
    nameEn: "Evening work compensation",
    nameFi: "Iltatyökorvaus",
    nameSv: "Kvällsersättning",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "eveningWorkCompensation",
    notSupportedError: null,
    descriptionEn: `Working time compensation paid for evening work.\r
Evening work compensation can be paid for regular\r
working hours, or for time exceeding regular working hours.`,
    descriptionFi: "Työaikakorvaus, joka maksetaan iltatyöstä. Iltatyökorvausta voidaan maksaa säännölliseltä työajalta tai säännöllisen työajan ylittävältä ajalta.",
    descriptionSv: "Arbetstidsersättning för kvällsarbete. Kvällsersättning kan betalas för ordinarie arbetstid eller den tid som överskrider ordinarie arbetstid",
    taxAndSideCostsDescrEn: `Tax is withheld and employer's social insurance\r
contributions are paid from evening work compensation.`,
    taxAndSideCostsDescrFi: "Iltatyökorvauksesta toimitetaan ennakonpidätys ja maksetaan työnantajan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "På kvällsersättning verkställs förskottsinnehållning och betalas arbetsgivares socialförsäkringsavgift.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/workingTimeCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 207,
    nameEn: "Evening shift allowance",
    nameFi: "Iltavuorolisä",
    nameSv: "Kvällsskiftstillägg",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "eveningShiftAllowance",
    notSupportedError: null,
    descriptionEn: "Shift work compensation paid for an evening shift",
    descriptionFi: "Vuorotyökorvaus, joka maksetaan iltavuorosta.",
    descriptionSv: "Ersättning för skiftarbete som betalas för kvällsskift",
    taxAndSideCostsDescrEn: `Tax is withheld and employer's social insurance\r
contributions are paid from the evening shift allowance.`,
    taxAndSideCostsDescrFi: "Iltavuorolisästä toimitetaan ennakonpidätys ja maksetaan työnantajan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "På kostnadsersättningar verkställs förskottsinnehållning och betalas arbetsgivares socialförsäkringsavgift.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/workingTimeCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 208,
    nameEn: "Notice period compensation",
    nameFi: "Irtisanomisajan korvaus",
    nameSv: "Ersättning för uppsägningstid",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "noticePeriodCompensation",
    notSupportedError: null,
    descriptionEn: `Compensation paid by an employer to an employee when employment is terminated without a notice period, i.e., when the notice period is disregarded and the employment is terminated with immediate effect (Employment\r
Contracts Act 6:4). This income type is also\r
used when reporting a compensation paid by\r
the employer, when an employee gives notice\r
due to a lay-off that has lasted over 200 days, and when the employer terminates an employee who has been laid off. \r
\r
This income type is used to report only those items\r
paid when employment is terminated without a notice period. The wages paid for the notice period are reported using other income types, such as the Total\r
wages or Time-rate pay income types.`,
    descriptionFi: `Korvaus, jonka työnantaja maksaa työntekijälle palvelussuhteen päättyessä ilman irtisanomisaikaa eli tilanteessa, jossa jätetään irtisanomisaika noudattamatta ja työsuhde päättyy heti (TSL 6:4). Tulolajilla ilmoitetaan myös korvaus, jonka työnantaja maksaa, kun työntekijä irtisanoutuu yli 200 päivää kestäneen lomautuksen johdosta sekä, kun työnantaja irtisanoo lomautettuna olevan työntekijän.\r
\r
Tulolajilla ilmoitetaan vain sellaiset erät, jotka maksetaan työsuhteen päättyessä ilman irtisanomisaikaa. Irtisanomisajalta maksettu palkka ilmoitetaan muilla palkan suorituslajeilla, esim. Palkka yhteissumma- tai Aikapalkka-tulolajeilla.`,
    descriptionSv: `En ersättning som arbetsgivaren betalar till arbetstagaren när anställningsförhållandet upphör utan uppsägningstid, dvs. i en situation där uppsägningstiden inte iakttas och anställningsförhållandet upphör omedelbart (AAL 6:4). Med inkomstslaget\r
anmäls även ersättning som arbetsgivaren\r
betalar när arbetstagaren säger upp sig på\r
grund av permittering som pågått i över 200\r
dagar samt när arbetsgivaren säger upp en\r
permitterad arbetstagare. Med inkomstslaget anmäls endast sådana poster som\r
betalas när anställningsförhållandet upphör utan\r
uppsägningstid. Lön för uppsägningstiden anmäls\r
med andra prestationsbetalningsslag, t.ex.\r
inkomstslagen lön totalt eller tidlön.`,
    taxAndSideCostsDescrEn: `Tax is withheld but social insurance contributions\r
are not paid from notice period compensation.`,
    taxAndSideCostsDescrFi: "Irtisanomisajan korvauksesta toimitetaan ennakonpidätys, mutta ei makseta sosiaalivakuutusmaksuja.",
    taxAndSideCostsDescrSv: "På ersättning för uppsägningstiden verkställs förskottsinnehållning, men inga socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/employmentTermination"
    ],
    calcGrouping: "baseSalary"
  },
  {
    code: 209,
    nameEn: "Kilometre allowance (taxable)",
    nameFi: "Kilometrikorvaus (veronalainen)",
    nameSv: "Kilometerersättning (skattepliktig)",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "kilometreAllowanceTaxable",
    notSupportedError: null,
    descriptionEn: `Kilometre allowance that does not meet the requirements set for tax-exemption.\r
A taxable kilometre allowance can be paid to both employees and other persons. There are several criteria\r
for the taxability of kilometre allowances. The Tax Administration has defined\r
a maximum amount for the tax-exempt kilometre allowances paid by an employer to an employee;\r
the part exceeding this amount is taxable income. Kilometre allowances paid to a commissioned person\r
are taxable income in their entirety.\r
This income type is used only to report taxable\r
kilometre allowances paid to employees. If a\r
taxable kilometre allowance is paid to a commissioned person or organisation, the allowance is reported as non-wage compensation for work and the\r
cost is added to the amount of non-wage compensation for work (see the description of the Nonwage compensation for work income type).`,
    descriptionFi: `Kilometrikorvaus, joka ei täytä verovapaudelle asetettuja vaatimuksia.\r
\r
Veronalaista kilometrikorvausta voidaan maksaa sekä palvelussuhteessa oleville että muille henkilöille. Kilometrikorvauksen veronalaisuudelle on useita perusteita. Verohallinto on määrittänyt työnantajan palvelussuhteessa maksamille verovapaille kilometrikorvauksille enimmäismäärän, jonka ylittävältä osalta kilometrikorvaus on veronalaista ansiotuloa. Henkilölle toimeksiantosuhteessa maksettava kilometrikorvaus on kokonaan veronalaista ansiotuloa.\r
\r
**Tulolajilla ilmoitetaan vain palvelussuhteessa oleville maksetut veronalaiset kilometrikorvaukset.** Jos veronalainen kilometrikorvaus maksetaan toimeksiantosuhteessa olevalle henkilölle tai yhteisölle, korvaus ilmoitetaan työkorvauksena ja lisätään kustannus työkorvauksen määrää (ks. Työkorvaus-tulolajin selite).`,
    descriptionSv: "På ersättning för uppsägningstiden verkställs förskottsinnehållning, men inga socialförsäkringsavgifter betalas.",
    taxAndSideCostsDescrEn: `Tax is withheld from the income. The default of the\r
income type is that it is subject to social insurance\r
contributions. I`,
    taxAndSideCostsDescrFi: "Tulosta toimitetaan ennakonpidätys ja se on sosiaalivakuutusmaksujen alainen.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på inkomsten. Det förvalda värdet i inkomstslaget är att den omfattas av socialförsäkringsavgifter. Om kilometerersättningen som betalas inte omfattas av någon socialförsäkringsavgift, ska prestationsbetalaren med uppgiften Typ av försäkringsuppgift ange vilken försäkringsavgift inkomsten inte omfattas av",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/expenses",
      "https://palkkaus.fi/usecases/2019/travelExpenses"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 210,
    nameEn: "Meeting fee",
    nameFi: "Kokouspalkkio",
    nameSv: "Mötesarvode",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "meetingFee",
    notSupportedError: null,
    descriptionEn: "A fee paid for participating in a meeting.",
    descriptionFi: "Palkkio, joka maksetaan kokoukseen osallistumisesta.",
    descriptionSv: "Arvode som betalas för deltagande i möte",
    taxAndSideCostsDescrEn: `Tax is withheld from a meeting fee.\r
If the payment of the meeting fee is based on work\r
performed in an employment relationship, social insurance contributions are paid from the meeting\r
fee.\r
If the recipient is not in an employment relationship,\r
the obligation to pay earnings-related pension insurance contribution, the employer's health insurance contribution, and the employee's daily allowance contribution of health insurance from the fee\r
will vary according to the applicable law. If the payment of the meeting fee is not based on work performed in an employment relationship, the employer can, if it so desires, voluntarily take out pension insurance for the income earner.\r
By default, this income type is not subject to social\r
insurance contributions.\r
If the meeting fee is subject to a social insurance\r
contribution, the payer must use the separate Type\r
of insurance information entry to report that the income is subject to a specified insurance contribution.`,
    taxAndSideCostsDescrFi: `Kokouspalkkiosta toimitetaan ennakonpidätys.\r
\r
Jos kokouspalkkion maksaminen perustuu palvelussuhteessa tehtyyn työhön, kokouspalkkiosta maksetaan sosiaalivakuutusmaksut. Jos kokouspalkkion saaja ei ole palvelussuhteessa, palkkion työeläkevakuutusmaksun ja työnantajan sairausvakuutusmaksun sekä työntekijän sairausvakuutuksen päivärahamaksun maksamisvelvollisuus vaihtelevat sovellettavan lain mukaan. Jos kokouspalkkion maksaminen ei perustu palvelusuhteessa tehtyyn työhön, työnantaja voi halutessaan vakuuttaa tulonsaajan vapaaehtoisesti eläkevakuutuksen osalta.\r
\r
Oletuksena tulolajissa on, että se ei ole sosiaalivakuutusmaksujen alainen.\r
\r
Jos kokouspalkkio on jonkun sosiaalivakuutusmaksun alainen, suorituksen maksaja ilmoittaa erillistä Vakuuttamistiedon tyyppi- tietoa käyttäen, että tulo on ilmoitetun vakuutusmaksun alainen.`,
    taxAndSideCostsDescrSv: "På mötesarvode verkställs förskottsinnehållning. Om betalningen av mötesarvode baserar sig på arbete i anställningsförhållande, betalas socialförsäkringsavgifter för mötesarvodet. Om mottagaren av mötesarvodet inte är i anställningsförhållande, varierar skyldigheten att betala arbetspensionsavgift och arbetsgivarens sjukförsäkringsavgift samt dagpenningsavgift för arbetstagarens sjukförsäkring med den lag som tillämpas. Om mötesarvodet inte baserar sig på arbete i anställningsförhållande, kan arbetsgivaren teckna en frivillig pensionsförsäkring åt inkomsttagaren. I inkomstslaget är det förvalt att inkomsten inte är underställd socialförsäkringsavgifter. Om mötesarvodet är underställt någon socialförsäkringsavgift, anmäler betalaren med hjälp av den separata uppgiften Typ av försäkringsuppgift att inkomsten är underställd den angivna försäkringsavgiften.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/board",
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "baseSalary"
  },
  {
    code: 211,
    nameEn: "Saturday pay",
    nameFi: "Lauantaityökorvaus",
    nameSv: "Ersättning för lördagsarbete",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "saturdayPay",
    notSupportedError: null,
    descriptionEn: `Working time compensation paid for work on a Saturday. Saturday pay can be paid for regular working hours or for time exceeding regular working\r
hours.`,
    descriptionFi: "Työaikakorvaus, joka maksetaan lauantaityöstä. Lauantaityökorvausta voidaan maksaa säännölliseltä työajalta tai säännöllisen työajan ylittävältä ajalta.",
    descriptionSv: "Arbetstidsersättning för lördagsarbete. Ersättning för lördagsarbete kan betalas för ordinarie arbetstid eller den tid som överskrider ordinarie arbetstid.",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
are paid from the pay.`,
    taxAndSideCostsDescrFi: "Korvauksesta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på ersättningen och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/workingTimeCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 212,
    nameEn: "Extra work premium",
    nameFi: "Lisätyökorvaus",
    nameSv: "Ersättning för mertidsarbete",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "extraWorkPremium",
    notSupportedError: null,
    descriptionEn: "Working time compensation paid for extra work.",
    descriptionFi: "Työaikakorvaus, joka maksetaan lisätyöstä.",
    descriptionSv: "Arbetstidsersättning för mertidsarbete.",
    taxAndSideCostsDescrEn: `Tax is withheld and the employer's social insurance\r
contributions are paid from the pay.`,
    taxAndSideCostsDescrFi: "Korvauksesta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på ersättningen och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/workingTimeCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 213,
    nameEn: "Holiday bonus",
    nameFi: "Lomaraha",
    nameSv: "Semesterpenning",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "holidayBonus",
    notSupportedError: null,
    descriptionEn: `A bonus paid in addition to annual holiday pay based\r
on an employment contract or collective agreement,\r
the amount of which is determined according to the\r
collective agreement applicable in the field or the\r
number of holiday days earned during the previous\r
holiday credit year.`,
    descriptionFi: `Työsopimuksen tai työ- tai virkaehtosopimuksen perusteella vuosilomapalkan lisäksi maksettava suoritus, jonka suuruus määräytyy alalla sovellettavan työehtosopimuksen tai edellisenä lomanmääräytymisvuonna ansaittujen lomapäivien lukumäärän mukaan.\r
\r
Vuosilomapalkan lisää koskee erittely- ja ilmoitusvelvollisuus riippumatta siitä, käytetäänkö kyseisestä erästä nimitystä lomaraha. Tällainen erittely tarvitaan esimerkiksi Kelaa ja työttömyyskassaa sekä työtapaturman korvauskäsittelyä varten.`,
    descriptionSv: `En prestation som betalas på basis av arbetskollektiveller tjänstekollektivavtalet utöver semesterlönen, vars storlek bestäms enligt det tillämpliga kollektivavtalet eller antalet intjänade semesterdagar under föregående kvalifikationsår. Tillägg till semesterlön omfattas av specificeringsoch anmälningsskyldighet, oavsett om\r
benämningen semesterpenning används om denna\r
post. En sådan specifikation behövs till exempel för\r
FPA och arbetslöshetskassan samt handläggning\r
av ersättning för arbetsolycka`,
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
are paid from the holiday bonus.`,
    taxAndSideCostsDescrFi: "Lomarahasta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på semesterpenning och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/holidays"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 214,
    nameEn: "Lecture fee",
    nameFi: "Luentopalkkio",
    nameSv: "Föreläsningsarvode",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "lectureFee",
    notSupportedError: null,
    descriptionEn: "A fee paid for giving a lecture.",
    descriptionFi: "Palkkio, joka maksetaan luennon pitämisestä.",
    descriptionSv: "Arvode som betalas för att hålla föreläsning",
    taxAndSideCostsDescrEn: `Tax is withheld from the lecture fee.\r
If the payment of the lecture fee is based on work\r
performed in an employment relationship, social insurance contributions are paid from the lecture fee.\r
If the recipient is not in an employment relationship,\r
the obligation to pay a earnings-related pension insurance contribution, the employer's health insurance contribution, and the employee's daily allowance contribution of health insurance from the fee\r
vary according to the applicable law.\r
By default, this income type is not subject to social\r
insurance contributions.\r
If the lecture fee is subject to a social insurance\r
contribution, the payer must use the separate Type\r
of insurance information entry to report that the income is subject to a specified insurance contribution.`,
    taxAndSideCostsDescrFi: `Luentopalkkiosta toimitetaan ennakonpidätys. \r
\r
Jos luentopalkkion maksaminen perustuu palvelussuhteessa tehtyyn työhön, luentopalkkiosta maksetaan sosiaalivakuutusmaksut. \r
\r
Jos luentopalkkion saaja ei ole palvelussuhteessa, palkkion työeläkevakuutusmaksun ja työnantajan sairausvakuutusmaksun sekä työntekijän sairausvakuutuksen päivärahamaksun maksamisvelvollisuus vaihtelevat sovellettavan lain mukaan.\r
\r
Oletuksena tulolajissa on, että se ei ole sosiaalivakuutusmaksujen alainen.\r
\r
Jos luentopalkkio on jonkun sosiaalivakuutusmaksun alainen, suorituksen maksaja ilmoittaa erillistä Vakuuttamistiedon tyyppi- tietoa käyttäen, että tulo on ilmoitetun vakuutusmaksun alainen.`,
    taxAndSideCostsDescrSv: "På föreläsningsarvode verkställs förskottsinnehållning. Om betalningen av föreläsningsarvode baserar sig på arbete i anställningsförhållande, betalas socialförsäkringsavgifter för föreläsningsarvodet. Om mottagaren av föreläsningsarvodet inte är i anställningsförhållande, varierar skyldigheten att betala arbetspensionsförsäkringsavgift och arbetsgivares sjukförsäkringsavgift samt arbetstagares sjukförsäkringsdagpenning efter vilken lag som tillämpas. I inkomstslaget är det förvalt att inkomsten inte är underställd socialförsäkringsavgifter. Om föreläsningsarvodet är underställt någon socialförsäkringsavgift, anmäler betalaren med hjälp av den separata uppgiften Typ av försäkringsuppgift att inkomsten är underställd den angivna försäkringsavgiften.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "baseSalary"
  },
  {
    code: 215,
    nameEn: "Compensation for acting in a position of trust",
    nameFi: "Luottamustoimipalkkio",
    nameSv: "Arvode för förtroendeuppdrag",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !0,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "compensationForTrustPosition",
    notSupportedError: null,
    descriptionEn: `Remuneration paid for acting in a position of trust,\r
with the exception of participating in meetings.`,
    descriptionFi: "Palkkio, joka maksetaan muusta luottamustoimen hoitamisesta kuin kokouksiin osallistumisesta.",
    descriptionSv: "Arvode som betalas för annan skötsel av förtroendeuppdrag än deltagande i möten",
    taxAndSideCostsDescrEn: `Tax is withheld from compensation for acting in a\r
position of trust.\r
When compensation for acting in a position of trust\r
is paid, the recipient is not usually in an employment relationship with the payer; in such cases, social insurance contributions are not paid from the\r
compensation.\r
In the private sector, however, the health insurance\r
contribution is paid from the compensation, for acting in a position of trust. Additionally, the pension\r
insurance contribution is paid, if the payer has\r
taken out voluntary earnings-related pension insurance for the person acting in a position of trust.\r
An earnings-related pension contribution is paid for\r
certain types of public sector compensation for acting in a position of trust.\r
As a default, this income type is subject to the employer's health insurance contribution and the employee's daily allowance contribution of health insurance. However, as a default, the income is not subject to pension insurance contribution, unemployment insurance contribution or accident and\r
occupational disease insurance contribution.\r
If compensation for acting in a position of trust is,\r
for example, subject to pension and unemployment\r
insurance contributions, the payer should report the\r
insurance information separately for these contributions. Similarly, the payer should use the Type of\r
insurance information entry to report if the compensation is not subject to a health insurance contribution.`,
    taxAndSideCostsDescrFi: `Luottamustoimipalkkiosta toimitetaan ennakonpidätys.\r
\r
Luottamustoimipalkkiota maksettaessa palkkion saaja ei yleensä ole palvelussuhteessa palkkion maksajaan, eikä palkkiosta näissä tapauksissa makseta sosiaalivakuutusmaksuja.\r
\r
Yksityisellä sektorilla luottamustoimipalkkiosta maksetaan kuitenkin sairausvakuutusmaksu. Lisäksi maksetaan eläkevakuutusmaksu, jos palkkion maksaja on ottanut luottamustoimen hoitajalle vapaaehtoisen työeläkevakuutuksen. Tietyistä julkisen sektorin luottamustoimipalkkioista maksetaan työeläkevakuutusmaksu.\r
\r
Oletuksena tulolajissa on, että se on työnantajan sairausvakuutusmaksun alainen ja työntekijän sairausvakuutuksen päivärahamaksun alainen. Sitä vastoin oletuksena on, että tulo ei ole eläkevakuutusmaksun, työttömyysvakuutusmaksun eikä työtapaturma- ja ammattitautivakuutusmaksun alainen.\r
\r
Jos luottamustoimipalkkio on esimerkiksi eläke- ja työttömyysvakuutusmaksun alainen, suorituksen maksaja ilmoittaa vakuuttamistiedon erillisenä tietona näiden maksujen osalta. Samoin ilmoitetaan Vakuuttamistiedon tyyppi –tietoa käyttäen, jos luottamustoimipalkkio ei poikkeuksellisesti olisikaan sairausvakuutusmaksun alainen.`,
    taxAndSideCostsDescrSv: `På arvode för förtroendeuppdrag verkställs. förskottsinnehållning.\r
Vid betalning av arvode för förtroendeuppdrag står\r
mottagaren av arvodet i allmänhet inte i\r
anställningsförhållande till den som betalar arvodet,\r
och inga socialförsäkringsavgifter behöver betalas\r
på arvoden i dessa fall.\r
Inom den privata sektorn betalas dock\r
sjukförsäkringsavgift för arvode för\r
förtroendeuppdrag. Dessutom betalas\r
pensionsförsäkringsavgift om betalaren har tecknat\r
frivillig arbetspensionsförsäkring åt\r
förtroendepersonen.\r
På vissa arvoden för förtroendeuppdrag inom den\r
offentliga sektorn betalas\r
arbetspensionsförsäkringsavgift.\r
Det förvalda alternativet i inkomstslaget är att den\r
är underställd arbetsgivarens sjukförsäkringsavgift\r
och dagpenningsavgiften för arbetstagarens\r
sjukförsäkring. Däremot är det förvalt att inkomsten\r
inte är underställd pensions-, arbetslöshets,\r
arbetsolycksfalls- eller\r
yrkesjukdomsförsäkringsavgifter.\r
Om arvodet för förtroendeuppdrag är t.ex.\r
underställt pensions- och\r
arbetslöshetsförsäkringsavgift, anmäler betalaren\r
försäkringsuppgiften separat när det gäller dessa\r
avgifter. Likaså anmäler man med hjälp uppgiften\r
om typ av försäkringsuppgift, om arvodet för\r
förtroendeuppdraget undantagsvis inte är\r
underställd sjukförsäkringsavgift.`,
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/board",
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "baseSalary"
  },
  {
    code: 216,
    nameEn: "Other compensation",
    nameFi: "Muu maksettu lisä",
    nameSv: "Annat betalt tillägg",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "otherCompensation",
    notSupportedError: null,
    descriptionEn: `The total amount of working time and exceptional\r
situation compensations not paid regularly and not\r
included in the earnings from regular working time.\r
These include midweek holiday compensation,\r
start-up grants and any other compensation and\r
bonuses paid in accordance with collective agreements or employment contracts.`,
    descriptionFi: "Muiden maksettujen työaika- ja poikkeustilakorvausten yhteissumma. Näitä ovat mm. aattotyökorvaukset, arkipyhäkorvaukset ja muut mahdolliset työehtosopimusten tai työsopimusten perusteella maksettavat korvaukset ja lisät.",
    descriptionSv: "Totalbeloppet av sådana arbetstids- och undantagssituationsersättningar som inte betalas ut regelbundet och inte räknas till lönen för ordinarie arbetstid. Hit hör bl.a. söckenhelgsersättningar, startpeng samt övriga eventuella ersättningar och tillägg som betalas med stöd av kollektivavtal eller arbetsavtal.",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
paid from the compensation paid.`,
    taxAndSideCostsDescrFi: "Muista maksetuista lisistä toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på övriga betalda tillägg och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/workingTimeCompensation",
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 217,
    nameEn: "Waiting time compensation",
    nameFi: "Odotusajan korvaus",
    nameSv: "Lön för väntetid",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "waitingTimeCompensation",
    notSupportedError: null,
    descriptionEn: `Compensation to which an employee is entitled if\r
the payment of their wages is delayed after the end\r
of the employment relationship. Unless otherwise\r
agreed, the wages must be paid on the last day of\r
the pay period. Waiting time compensation can be\r
paid for no more than six days.`,
    descriptionFi: "Korvaus, johon työntekijällä on oikeus, jos palkanmaksu viivästyy työsuhteen päätyttyä. Ellei toisin sovita, palkka tulee maksaa palkanmaksukauden viimeisenä päivänä. Odotusajan korvausta voidaan maksaa enintään kuudelta päivältä.",
    descriptionSv: "Ersättning som arbetstagaren är berättigad till om löneutbetalningen fördröjs när anställningsförhållandet avslutats Om inte annat avtalas, ska lönen betalas den sista dagen i löneutbetalningsperioden . Lön för väntetid kan betalas för högst sex dagar.",
    taxAndSideCostsDescrEn: `Tax is withheld but social insurance payments are\r
not paid from waiting time compensation.`,
    taxAndSideCostsDescrFi: "Odotusajan korvauksesta toimitetaan ennakonpidätys, mutta ei makseta sosiaalivakuutusmaksuja.",
    taxAndSideCostsDescrSv: "På lön för väntetid verkställs förskottsinnehållning, men inga socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/workingTimeCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 218,
    nameEn: "Working condition compensation",
    nameFi: "Olosuhdelisä",
    nameSv: "Miljötillägg",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "workingConditionCompensation",
    notSupportedError: null,
    descriptionEn: `A wage supplement paid based on the conditions\r
at the location where the work is performed. Working condition compensation is, for example, a supplement paid based on a collective agreement or\r
an employment agreement such as a foaming supplement, cold region bonus and archipelago bonus.`,
    descriptionFi: "Palkanlisä, joka maksetaan työn tekemispaikan olosuhteiden perusteella. Olosuhdelisiä ovat esimerkiksi työehtosopimuksen tai työsopimuksen perusteella maksettavat lisä, kuten vaahdotuslisä, kylmänalueenlisä ja saaristolisä.",
    descriptionSv: "Lönetillägg som betalas på grund av förhållandena på platsen för arbetets utförande. Miljötillägg är till exempel tillägg som betalas med stöd av kollektivavtal eller arbetsavtal så som flotationstillägg, kallområdestillägg och skärgårdstillägg.",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
are paid from working condition compensation.`,
    taxAndSideCostsDescrFi: "Olosuhdelisästä toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på miljötillägg och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/workingTimeCompensation",
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 219,
    nameEn: "Partial pay during sick leave",
    nameFi: "Sairausajan osapalkka",
    nameSv: "Dellön för sjuktiden",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "partialPayDuringSickLeave",
    notSupportedError: null,
    descriptionEn: `Wages for the duration of illness reduced in accordance with the law or a collective agreement. The\r
share of income the person has received, in a reduced amount, during their illness is reported as\r
partial pay during sick leave.`,
    descriptionFi: "Lain tai työ- tai virkaehtosopimukseen mukaisesti alennettu sairausajan palkka. Sairausajan osapalkkana ilmoitetaan se osa tuloista, jonka henkilö on saanut sairaana ollessaan alennettuna.",
    descriptionSv: "Enligt lagen eller kollektivavtal eller tjänstekollektivavtal nedsatt lön för sjukdomstid. Som dellön för sjuktiden anmäls den andel av inkomsterna som personen fått som sänkt lön under sjuktiden",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
paid from partial pay during sick leave.`,
    taxAndSideCostsDescrFi: `Sairausajan osapalkasta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.\r
\r
Jos osapalkkana maksetaan sellaisia eriä, jotka eivät ole sosiaalivakuutusmaksujen alaisia (esimerkiksi vahingonkorvaus päättämistilanteessa), suorituksen maksaja ilmoittaa vakuuttamistiedon erillistä Vakuuttamistiedon tyyppi –tietoa käyttäen.`,
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på dellön för sjuktiden och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/sickness"
    ],
    calcGrouping: "baseSalary"
  },
  {
    code: 220,
    nameEn: "Commission",
    nameFi: "Provisiopalkka",
    nameSv: "Provisionslön",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "commission",
    notSupportedError: null,
    descriptionEn: `Remuneration of a continuous nature forming a\r
permanent part of the wages, the amount of which is agreed in the employment contract.`,
    descriptionFi: "Pysyvän palkan osan muodostava jatkuvaluonteinen palkkiopalkka, jonka määrästä on sovittu työsopimuksessa.",
    descriptionSv: "Kontinuerlig premielön som utgör en bestående del av lönen och vars belopp har avtalats i arbetsavtalet.",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
are paid from the commission.`,
    taxAndSideCostsDescrFi: "Provisiopalkasta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på provisionslön och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/renumeration"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 221,
    nameEn: "Sunday work compensation",
    nameFi: "Sunnuntaityökorvaus",
    nameSv: "Ersättning för söndagsarbete",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "sundayWorkCompensation",
    notSupportedError: null,
    descriptionEn: `Working time compensation paid for work on a\r
Sunday. Sunday pay can be paid for regular working hours, or for time exceeding regular working\r
hours.`,
    descriptionFi: "Sunnuntaityöstä maksettava työaikakorvaus. Sunnuntaityökorvausta voidaan maksaa säännölliseltä työajalta tai säännöllisen työajan ylittävältä ajalta.",
    descriptionSv: "Arbetstidsersättning som betalas för söndagsarbete. Ersättning för söndagsarbete kan betalas för ordinarie arbetstid eller den tid som överskrider ordinarie arbetstid.",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
paid from the pay.`,
    taxAndSideCostsDescrFi: "Korvauksesta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på ersättningen och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/workingTimeCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 222,
    nameEn: "Benefit arising from synthetic option",
    nameFi: "Synteettinen optio",
    nameSv: "Syntetisk option",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "benefitArisingFromSyntheticOption",
    notSupportedError: null,
    descriptionEn: `A privilege based on which the income earner is not\r
entitled to subscribe shares underlying the option at\r
the strike price; instead, the income earner receives\r
the difference between the strike price and the share\r
value as money (net value settlement) at the time of\r
execution. A synthetic option does not affect the subscription of shares.\r
In practice, a synthetic option concerns a monetary\r
payment, the amount of which is determined by the\r
development of the employer company's share price.\r
Instead of a synthetic option, this arrangement may be\r
called a share-based bonus or reward system.`,
    descriptionFi: `Optio-oikeus, jonka perusteella tulonsaaja ei ole oikeutettu merkitsemään option kohde-etuutena olevia osakkeita option toteutushintaan, vaan hän saa toteutushinnan ja toteuttamishetken mukaisen osakkeen arvon erotuksen rahana (nettoarvon tilitys). Synteettinen optio ei oikeuta osakemerkintään.\r
\r
Käytännössä synteettisessä optiossa on kyse rahasuorituksesta, jonka suuruus määräytyy työnantajayhtiön osakekurssin kehityksen perusteella. Synteettinen optio -nimityksen sijaan järjestelyä saatetaan kutsua osakeperusteiseksi bonukseksi tai palkitsemisjärjestelmäksi.`,
    descriptionSv: `Optionsrätt utifrån vilken inkomsttagaren inte är berättigad att teckna de aktier som utgör den underliggande tillgången till inlösningspriset, utan får skillnaden mellan inlösningspriset och värdet på\r
aktien vid inlösningstidpunkten i kontanter\r
(redovisning av nettovärdet). En syntetisk option\r
berättigar inte till aktieteckning.\r
I praktiken handlar en syntetisk option om en\r
penningbetalning vars belopp fastställs enligt\r
utvecklingen för arbetsgivarbolages aktiekurs.\r
I stället för Syntetisk option kan arrangemanget gå\r
under namnet aktiebaserad bonus eller\r
belöningssystem.`,
    taxAndSideCostsDescrEn: `Tax is withheld from a benefit arising from an option,\r
but no social insurance contributions are paid.`,
    taxAndSideCostsDescrFi: "Optiona saatavasta edusta toimitetaan ennakonpidätys, mutta ei makseta sosiaalivakuutusmaksuja.",
    taxAndSideCostsDescrSv: "På förmån för option verkställs förskottsinnehållning, men socialförsäkringsavgifter betalas inte.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/enterprise"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 223,
    nameEn: "Performance bonus",
    nameFi: "Tulospalkkio",
    nameSv: "Resultatpremie",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "performanceBonus",
    notSupportedError: null,
    descriptionEn: `Remuneration paid based on meeting or exceeding\r
the organisation's performance target agreed in advance.`,
    descriptionFi: "Palkka, joka maksetaan organisaation ennalta sovitun tulostavoitteen täyttymisen tai ylittymisen perusteella.",
    descriptionSv: "Lön som betalas utifrån huruvida ett på förhand avtalat resultatmål inom organisationen uppfylls eller överskrids.",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
paid from a performance bonus.`,
    taxAndSideCostsDescrFi: "Tulospalkkiosta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på resultatpremie och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/renumeration"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 224,
    nameEn: "Monetary compensation from a working time bank",
    nameFi: "Työaikapankin rahakorvaus",
    nameSv: "Penningersättning från arbetstidsbank",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "monetaryCompensationFromWorkingTimeBank",
    notSupportedError: null,
    descriptionEn: `Wages paid based on the time saved in a working\r
time bank.\r
Withdrawing wages from a working time bank\r
tends only to be possible in exceptional situations,\r
such as upon termination of employment or when\r
the working time bank is dissolved. In some working time banks, it is also possible to withdraw\r
wages or free time on credit.`,
    descriptionFi: `Palkka, joka maksetaan työaikapankkiin säästetyn ajan perusteella.\r
\r
Työaikapankista voi yleensä nostaa palkkaa vain poikkeustapauksissa kuten palvelussuhteen päättyessä tai työaikapankkia purettaessa. Joissakin työaikapankeissa on mahdollista nostaa palkkaa tai\r
vapaa-aikaa myös velaksi.`,
    descriptionSv: "Lön som betalas på basis av tid som sparats i arbetstidsbanken. I allmänhet kan lön tas ut från arbetstidsbanken endast i undantagsfall, till exempel när anställningsförhållandet avslutas eller när arbetstidsbanken upphör. I vissa arbetstidsbanker kan lön eller ledighet tas ut även på kredit.",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
paid from monetary compensation from a working\r
time bank.`,
    taxAndSideCostsDescrFi: "Työaikapankin rahakorvauksesta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på penningersättning från arbetstidsbank och socialförsäkringsavgifter betalas",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/employmentTermination"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 225,
    nameEn: "Compensation for accrued time off",
    nameFi: "Työajantasauskorvaus",
    nameSv: "Ersättning för arbetstidsutjämning",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "compensationForAccruedTimeOff",
    notSupportedError: null,
    descriptionEn: `Working time compensation paid from the loss of\r
earnings caused by the equalisation of working\r
time with the average weekly working time. Compensation for accrued time off is paid for regular working hours. The accrued holiday compensation is an example of compensation for accrued\r
time off.`,
    descriptionFi: `Työaikakorvaus, joka maksetaan ansionvähentymisestä, joka aiheutuu työajan tasaamisesta keskimääräiseen viikkotyöaikaan. \r
\r
Työajantasauskorvausta maksetaan säännölliseltä työajalta. Esimerkiksi niin sanottu pekkaskorvaus on työajantasauskorvaus.`,
    descriptionSv: "Arbetstidsersättning som betalas för minskade förtjänster och som orsakas av att arbetstiden jämnas ut till genomsnittlig veckoarbetstid Ersättning för arbetstidsutjämning betalas för ordinarie arbetstid. Till exempel är den s.k. Pekkanen-ersättningen är en ersättning för arbetstidsutjämning.",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
paid from such compensation.`,
    taxAndSideCostsDescrFi: "Korvauksesta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på ersättningen och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 226,
    nameEn: "Share issue for employees",
    nameFi: "Työsuhteeseen perustuva osakeanti",
    nameSv: "Aktieemission som grundar sig på arbetsförhållande",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "shareIssueForEmployees",
    notSupportedError: null,
    descriptionEn: `A share issue targeted at the company's personnel.\r
The benefit that arises from the right to subscribe\r
the employer company's shares based on an employment relationship is taxable income.\r
The income type is only used to report the amount\r
of the benefit regarded as taxable earned income.\r
Tax is withheld from a share issue for employees,\r
but the income is not subject to social insurance\r
contributions.`,
    descriptionFi: `Yhtiön omalle henkilökunnalle suunnattu osakeanti. Etu työsuhteeseen perustuvasta oikeudesta merkitä työnantajayrityksen osakkeita on veronalaista ansiotuloa.\r
\r
Jos etu on henkilökunnan enemmistön käytettävissä, tulolajilla ilmoitetaan ainoastaan 10 %:n alennuksen ylittävä osuus. Jos etu ei ole henkilökunnan enemmistön käytettävissä, saatava alennus on palkkaa koko määrältään. Tällöin suorituksen ilmoittamisessa käytetään palkan muita tulolajeja.\r
\r
Merkintäetu koskee myös yhteisön osuuksia.`,
    descriptionSv: `Aktieemission som riktas till bolagets egen personal. En förmån som uppstår på en anställningsförhållande baserad rätt att teckna aktier i arbetsgivarföretaget är skattepliktig\r
förvärvsinkomst. Teckningsförmånen gäller även andelar i samfund.`,
    taxAndSideCostsDescrEn: `If the benefit is not available to the majority of the\r
personnel, the entire discount received is regarded\r
as wages subject to social insurance contributions.\r
In this case, the payer reports the entire amount of\r
the payment using the income type Share issue for\r
employees (226) and specifies that the payment is\r
subject to social insurance contributions with the\r
help of the Type of insurance information data related to the income type. \r
\r
The subscription benefit also applies to shares in\r
an organisation.`,
    taxAndSideCostsDescrFi: `Työsuhteeseen perustuvasta osakeannista toimitetaan ennakonpidätys, mutta tulo ei ole sosiaalivakuutusmaksujen alainen.\r
\r
Jos työsuhteeseen perustuva osakeanti on edellä mainittujen maksujen alainen, suorituksen maksaja ilmoittaa vakuuttamistiedon erillistä Vakuuttamistiedon tyyppi- tietoja käyttäen.`,
    taxAndSideCostsDescrSv: `Medinkomstslaget anmäls endast det\r
förmånsbelopp som utgör skattepliktig\r
förvärvsinkomst. Förskottsinnehållning verkställs\r
på aktieemission som baserar sig på\r
anställningsförhållande, men inkomsten är inte\r
underställd socialförsäkringsavgifter.\r
Om förmånen inte är tillgänglig för majoriteten av\r
personalen, är den erhållna rabatten lön som\r
omfattas av socialförsäkringsavgifter till sitt fulla\r
belopp. Då anmäler betalaren hela\r
prestationsbeloppet med inkomstslaget\r
Aktieemission som grundar sig på\r
arbetsförhållande (226) och anmäler med uppgiften\r
Typ av försäkringsuppgift som hänför sig till\r
inkomstslaget att inkomsten omfattas av\r
socialförsäkringsavgifter`,
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/renumeration"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 227,
    nameEn: "Contract pay ",
    nameFi: "Urakkapalkka ",
    nameSv: "Ackordslön ",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "contractPay",
    notSupportedError: null,
    descriptionEn: `Performance pay, paid based on the performance\r
of a work contract agreed in advance. Contract pay\r
includes both a fixed and variable component.`,
    descriptionFi: "Suorituspalkka, joka maksetaan ennalta sovitun työkokonaisuuden suorittamisen perusteella. Urakkapalkkaan sisältyy sekä kiinteä että muuttuva osa.",
    descriptionSv: "Prestationslön som betalas på basis av utförande av en på förhand avtalad arbetshelhet. I prestationslön ingår en fast och en rörlig del",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
are paid from contract pay.`,
    taxAndSideCostsDescrFi: "Urakkapalkasta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på prestationslön och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/wages"
    ],
    calcGrouping: "baseSalary"
  },
  {
    code: 229,
    nameEn: "Damages in conjunction with termination and lay-off",
    nameFi: "Vahingonkorvaus päättämis- ja lomautustilanteissa",
    nameSv: "Skadestånd vid avslutande av ett anställningsförhållande eller permittering",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "damagesInConjunctionWithTermination",
    notSupportedError: null,
    descriptionEn: `Compensation that the employer is obligated to pay\r
after terminating an employment relationship in violation of the Employment Contracts Act, Act on Civil\r
Servants in Local Government or State Civil Servants'\r
Act. Compensation for the cancellation of an employment contract (ECA 8:1, 55/2001) and compensation\r
for unjustified lay-off are also reported in this section.\r
Damages to be paid due to the groundless termination\r
of an employment relationship can be based on a decision by a court, a reconciliation confirmed by a court, a result of negotiations between the associations representing the parties to the employment relationship,\r
or an agreement between the parties to the employment relationship.\r
Damages in conjunction with termination of employment or lay-off or other comparable compensation are\r
not taxable income, unless they have been received\r
instead of taxable income or as compensation for reduced subsistence. Neither is compensation for neglect of co-operation procedure obligations, as defined\r
in more detail in the related legislation, regarded as\r
taxable income.\r
This income type is used only to report taxable\r
amounts, i.e., not the tax-exempt compensation paid\r
under the Act on Co-operation within Undertakings or\r
the Equality Act. Tax-exempt damages are not reported to the Incomes Register.\r
This income type is not used to report compensation\r
based on the performance of work paid in connection\r
with the termination; instead, it is reported using other\r
income types, such as the Total wages or Time-rate\r
pay income types.`,
    descriptionFi: `Korvaus, jota työnantaja on velvollinen maksamaan, kun työnantaja on päättänyt palvelussuhteen henkilön työsopimuslain, kunnallisesta viranhaltijasta annetun lain tai valtion virkamieslain vastaisesti. Kohdassa ilmoitetaan myös korvaus työsuhteen purkamisesta (TSL 8:1, 55/2001) sekä korvaus perusteettomasta lomauttamisesta.\r
\r
Palvelussuhteen perusteettoman päättämisen johdosta maksettava korvaus voi perustua tuomioistuimen tuomioon, tuomioistuimen vahvistamaan sovintoon, palvelussuhteen osapuolia edustavien järjestöjen väliseen neuvottelutulokseen tai palvelussuhteen osapuolten väliseen sopimukseen.\r
\r
Vahingonkorvaus päättämis- tai lomautustilanteessa tai muu siihen verrattava korvaus ei ole veronalaista tuloa, ellei sitä ole saatu veronalaisen tulon sijaan tai korvaukseksi elatuksen vähentymisestä. Veronalaista tuloa eivät myöskään ole laissa tarkemmin määritellyt hyvitykset yhteistoimintavelvoitteiden laiminlyönneistä.\r
\r
Tulolajilla ilmoitetaan vain veronalaiset määrät eli esimerkiksi ei yhteistoimintalain tai tasa-arvolain nojalla maksettuja verovapaita hyvityksi. Verovapaita vahingonkorvauksia ei ilmoiteta tulorekisteriin.\r
\r
Tulolajilla ei ilmoiteta irtisanomisen yhteydessä maksettavia työsuoritukseen perustuvia korvauksia vaan ne ilmoitetaan muilla palkan suorituslajeilla, esim. Palkka yhteissumma- tai Aikapalkka-tulolajeilla.`,
    descriptionSv: `En ersättning som arbetsgivaren är skyldig att betala när arbetsgivaren har avslutat ett anställningsförhållande för en person i strid med arbetsavtalslagen, lagen om kommunala tjänsteinnehavare eller statstjänstemannalagen. I punkten anmäls även ersättning för hävning av anställningsförhållande (AAL 8:1, 55/2001) samt ersättning för ogrundad permittering. Ersättning som betalas på grund av ogrundat avslutande av anställningsförhållande kan basera sig på dom av en domstol, förlikning som stadfästs av en domstol, resultat av förhandlingar som förts av organisationer som företräder parterna i anställningsförhållandet eller avtal mellan parterna. Skadestånd vid avslutande av ett\r
anställningsförhållande eller permittering är inte skattepliktiga inkomst, om det inte har erhållits i stället\r
för skattepliktig inkomst eller som ersättning för\r
minskade inkomster eller försämrad utkomst.\r
Skattepliktig inkomst är inte heller de i lagen närmare\r
definierade gottgörelser för försummelse av\r
samarbetsskyldigheter. Med inkomstslaget anmäls endast skattepliktiga\r
belopp, inte t.ex. skattefria gottgörelser med stöd av\r
samarbetslagen eller jämställdhetslagen. Skattefria\r
skadestånd anmäls inte till inkomstregistret.\r
Med inkomstslaget anmäls inte ersättningar baserade\r
på arbetsprestation som betalas i samband med\r
uppsägning, utan dessa anmäls med andra\r
lönebetalningsslag, t.ex. inkomstslagen Lön totalt eller\r
Tidlön.`,
    taxAndSideCostsDescrEn: `Tax is withheld, but social insurance payments are\r
not paid from taxable damages.`,
    taxAndSideCostsDescrFi: "Veronalaisesta vahingonkorvauksesta toimitetaan ennakonpidätys, mutta ei makseta sosiaalivakuutusmaksuja.",
    taxAndSideCostsDescrSv: "På skattepliktigt skadestånd verkställs förskottsinnehållning, men socialförsäkringsavgifter betalas inte.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/employmentTermination"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 230,
    nameEn: "Stand-by compensation",
    nameFi: "Varallaolokorvaus",
    nameSv: "Beredskapsersättning",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "standByCompensation",
    notSupportedError: null,
    descriptionEn: `Wages paid to the employee for being available for\r
call-out to work, if required by the employer, to perform duties under their employment.`,
    descriptionFi: "Palkka, joka maksetaan siitä, että työntekijä on tavoitettavissa ja työnantaja voi tarvittaessa kutsua hänet hoitamaan palvelussuhteeseen kuuluvia tehtäviä.",
    descriptionSv: "Lön som betalas för att arbetstagaren är nåbar och arbetsgivaren vid behov kan kalla honom eller henne för att sköta uppgifter som hör till anställningsförhållandet",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
paid from stand-by compensation.`,
    taxAndSideCostsDescrFi: "Varallaolokorvauksesta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på beredskapsersättning och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/workingTimeCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 231,
    nameEn: "Voluntary compensation in conjunction with termination of employment",
    nameFi: "Vapaaehtoinen korvaus päättämistilanteessa",
    nameSv: "Frivillig ersättning vid avslutande av ett anställningsförhållande",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "voluntaryCompensationInConjunctionWithTermination",
    notSupportedError: null,
    descriptionEn: `Compensation voluntarily paid by the employer\r
when employment is terminated or dissolved, or\r
ended by agreement.\r
In situations where employment is terminated, voluntary compensation paid includes CEO's severance compensation (so-called golden parachutes),\r
severance compensation, severance pay, and severance packages. Such compensation can also be\r
non-monetary.`,
    descriptionFi: `Korvaus, jonka työnantaja maksaa vapaaehtoisesti irtisanomis- tai purkamistilanteessa tai silloin, kun palvelussuhde päätetään sopimalla.\r
\r
Päättämistilanteessa maksettavia vapaaehtoisia korvauksia ovat esimerkiksi toimitusjohtajan erokorvaus (niin sanottu kultainen kädenpuristus), erokorvaus, eroraha ja tukipaketti. Korvaus voidaan\r
myöntää myös muuna kuin rahana.`,
    descriptionSv: "Ersättning som arbetsgivaren frivilligt betalar när ett anställningsförhållande sägs upp eller upplöses genom avtal Frivillig ersättning vid avslutande av ett anställningsförhållande är till exempel avgångsvederlag till verkställande direktör (s.k. gyllene fallskärm), avgångsvederlag, avgångspenning och stödpaket. Ersättningen kan även betalas i någon annan form än pengar.",
    taxAndSideCostsDescrEn: `Tax is withheld but social insurance payments are\r
not paid from the compensation.`,
    taxAndSideCostsDescrFi: "Päättämiskorvauksesta toimitetaan ennakonpidätys, mutta ei makseta sosiaalivakuutusmaksuja.",
    taxAndSideCostsDescrSv: "På ersättning vid avslutande verkställs förskottsinnehållning, men socialförsäkringsavgifter betalas inte.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/employmentTermination"
    ],
    calcGrouping: "baseSalary"
  },
  {
    code: 232,
    nameEn: "Weekly rest compensation",
    nameFi: "Viikkolepokorvaus",
    nameSv: "Ersättning för veckovila",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "weeklyRestCompensation",
    notSupportedError: null,
    descriptionEn: "Working time compensation paid for work performed during weekly rest times.",
    descriptionFi: "Työaikakorvaus, jota maksetaan viikkolevon aikana tehdystä työstä.",
    descriptionSv: "Arbetstidsersättning som betalas för utfört arbete under veckovila",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
are paid from weekly rest compensation.`,
    taxAndSideCostsDescrFi: "Viikkolepokorvauksesta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på ersättning för veckovila och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/workingTimeCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 233,
    nameEn: "Profit-sharing bonus",
    nameFi: "Voittopalkkio",
    nameSv: "Vinstarvode",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "profitSharingBonus",
    notSupportedError: null,
    descriptionEn: `Remuneration distributed among employees without an advance plan, by a decision of the annual\r
general meeting and determined based in the company's profits.`,
    descriptionFi: "Työntekijöille ilman ennalta sovittua suunnitelmaa yhtiökokouksen päätöksellä jaettava palkkio, joka muodostuu yrityksen voiton perusteella.",
    descriptionSv: "Premie som utdelas till arbetstagarna genom bolagsstämmans beslut utan en på förhand avtalad plan och som bildas utifrån företagets vinst",
    taxAndSideCostsDescrEn: `Tax is withheld from all profit-sharing bonuses other\r
than those transferred into a personnel fund. No\r
social insurance contributions are paid from a\r
profit-sharing bonus paid by the company into a\r
personnel fund, or profit-sharing bonuses directly\r
withdrawn by the employee as cash in accordance\r
with the personnel fund rules.\r
If the company does not have a personnel fund as\r
defined in the Act on Personnel Funds, no social insurance contributions are paid from the profit-sharing bonus if it is paid to the employee on the basis\r
of a decision by the annual general meeting as a\r
profit distribution or cash profit-sharing bonus, on\r
condition that the profit-sharing bonus is paid to all\r
personnel and is not intended to replace a wage\r
system required under a collective agreement or\r
employment contract. Furthermore, the basis for\r
determining a cash bonus must be in accordance\r
with section 70, subsection 3(10) of the Employees'\r
Pensions Act and section 2, items 2 and 3 of the\r
Act on Personnel Funds, and the amount of the\r
company's free capital must be larger than the total\r
amount of the cash-based profit-sharing bonus and\r
the dividend paid to shareholders as decided by\r
the Annual General Meeting. The Act on Financing of Unemployment Benefits includes a similar provision, as does the Occupational Accidents, Injuries\r
and Diseases Act.\r
By default, this income type is not subject to social\r
insurance contributions.\r
If the profit-sharing bonus is subject to the abovementioned contributions, the payer reports the insurance details using the separate Type of insurance information data group.`,
    taxAndSideCostsDescrFi: `Muista kuin henkilöstörahastoon siirrettävistä voittopalkkiosta toimitetaan ennakonpidätys. Yrityksen henkilöstörahastoon maksamasta voittopalkkiosta tai henkilöstörahastosääntöjen mukaan työntekijän suoraan käteisenä nostamasta voittopalkkiosta ei makseta sosiaalivakuutusmaksuja.\r
\r
Jos yrityksessä ei ole henkilöstörahastolain mukaista henkilöstörahastoa, voittopalkkiosta ei makseta sosiaalivakuutusmaksuja, jos voittopalkkio maksetaan työntekijälle yhtiökokouksen päätöksen perusteella voitonjakona tai käteisenä voittopalkkiona edellyttäen, että käteinen voittopalkkio maksetaan koko henkilöstölle eikä sillä pyritä korvaamaan työehtosopimuksen tai työsopimuksen edellyttämää palkkausjärjestelmää. Lisäksi edellytetään, että käteisen palkkion määräytymisperusteet ovat työntekijän eläkelain 70 §:n 3 momentin 10 kohdan ja henkilöstörahastolain 2 §:n 2 ja 3 kohdan mukaiset ja että yhtiön vapaan pääoman määrä on suurempi kuin yhtiökokouksessa päätettävän käteisen voittopalkkion ja osakkeenomistajille maksettavien osinkojen yhteismäärä. Laissa työttömyysetuuksien rahoituksesta on vastaavanlainen säännös, samoin työtapaturma- ja ammattitautilaissa.\r
\r
Oletuksena tulolajissa on, ettei se ole sosiaalivakuutusmaksujen alainen. \r
\r
Jos voittopalkkio on edellä mainittujen maksujen alainen, suorituksen maksaja ilmoittaa vakuuttamistiedon erillistä Vakuuttamistiedon tyyppi- tietoryhmää käyttäen.`,
    taxAndSideCostsDescrSv: `På andra vinstpremier än sådana som överförs till en personalfond verkställs förskottsinnehållning. På de vinstpremier som företaget betalat till personalfonden eller vinstpremier som arbetstagaren direkt lyft kontant enligt personalfondsstadgarna betalas inte socialförsäkringsavgifter. Om företaget inte har en personalfond som avses i lagen om personalfonder, betalas inte socialförsäkringsavgifter för vinstpremier, om vinstpremien betalas till arbetstagaren med stöd av bolagsstämmans beslut som vinstutdelning eller kontant förutsatt att vinstpremien betalas till hela personalen och syftet inte är att ersätta ett lönesystem som kollektiv- eller arbetsavtalet förutsätter. Dessutom förutsätts att grunderna för fastställandet av kontantpremien är förenliga med 70 § 3 mom. 10 punkten i pensionslagen för arbetstagare och 2 § 2 och 3 punkten i lagen om personalfonder och att bolagets fria egna kapital är större än det sammanlagda beloppet av kontantpremien och dividenden till aktieägarna och som fastställs på bolagsstämman. I lagen om finansiering av arbetslöshetsförmåner och lagen om olycksfall i arbetet och om yrkessjukdomar\r
finns motsvarande bestämmelser.\r
I inkomstslaget är det förvalt att den inte är\r
underställd socialförsäkringsavgifter.\r
Om vinstarvodet är underställd ovan nämnda\r
avgifter, anmäler betalaren försäkringsuppgiften\r
separat med hjälp av uppgiftsgruppen Typ av\r
försäkringsuppgift.`,
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/renumeration"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 234,
    nameEn: "Annual holiday compensation",
    nameFi: "Vuosilomakorvaus",
    nameSv: "Semesterersättning",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "annualHolidayCompensation",
    notSupportedError: null,
    descriptionEn: `Monetary compensation paid instead of granting an\r
annual holiday. Annual holiday compensation may\r
be paid during an employment relationship or when\r
an employment relationship ends.\r
This income type is also used to report the construction sector's holiday bonus. In the collective agreement, the holiday compensation, holiday\r
pay and holiday bonus are combined into a single\r
compensation called holiday bonus, amounting to\r
18.5% of the earnings from the holiday credit year.\r
As a rule, one third of the construction sector's holiday bonus is a holiday bonus and two thirds holiday pay or holiday compensation, depending on\r
whether the employment relationship continues or\r
was terminated.\r
Compensation for additional days off supplementing the annual holiday is reported using income\r
type Other compensation (216)).`,
    descriptionFi: `Vuosiloman antamisen sijaan suoritettava rahallinen korvaus. Vuosilomakorvausta voidaan maksaa työsuhteen aikana tai työsuhteen päättyessä.\r
\r
Tulolajilla ilmoitetaan myös **rakennusalan lomaraha**. Työehtosopimuksessa lomakorvaus, lomapalkka ja lomaraha on yhdistetty lomaraha-nimiseksi korvaukseksi, joka on 18,5 % lomanmääräytymisvuoden ansioista. Pääsääntöisesti rakennusalan lomakorvauksessa on 1/3 lomarahaa ja 2/3 lomapalkkaa tai lomakorvausta riippuen siitä, jatkuuko työsuhde vai päättyikö se.`,
    descriptionSv: "Penningersättning som betalas i stället för att ge semester Semesterersättning kan betalas under anställningsförhållandet eller när anställningsförhållandet avslutas. Med inkomstslaget anmäls också byggbranschens semesterpenning. I kollektivavtalet har semesterersättning, semesterlön och semesterpenning alla sammanslagits till en ersättning, semesterpenning, som är 18,5 % utgående från kvalifikationsårets förtjänst. I regel är 1/3 av byggbranschens semesterersättning semesterpenning och 2/3 semesterlön eller semesterersättning beroende på om arbetsavtalsförhållandet fortsätter eller upphör. Ersättning för extra lediga dagar som kompletterar semestern anmäls med inkomstslaget Annat betalt tillägg (216).",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
are paid from annual holiday compensation.`,
    taxAndSideCostsDescrFi: "Vuosilomakorvauksesta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på semesterersättning och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/holidays"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 235,
    nameEn: "Overtime compensation",
    nameFi: "Ylityökorvaus",
    nameSv: "Övertidsersättning",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "overtimeCompensation",
    notSupportedError: null,
    descriptionEn: `Working time compensation paid for overtime work.\r
Work that is performed at the initiative of the employer during working time exceeding the agreed\r
overtime limit is deemed to be overtime work.`,
    descriptionFi: "Ylityöstä maksettava työaikakorvaus. Ylityönä pidetään työtä, joka tehdään työnantajan aloitteesta sovitun ylityöaikarajan ylittävänä aikana.",
    descriptionSv: "Arbetstidsersättning som betalas för övertidsarbete. Som övertid betraktas ett arbete, som utförs på arbetsgivarens initiativ under den tid som överskrider den avtalade övertidsgränsen.",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
are paid from overtime compensation`,
    taxAndSideCostsDescrFi: "Ylityökorvauksesta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på övertidsersättning och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/workingTimeCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 236,
    nameEn: "Night work allowance",
    nameFi: "Yötyökorvaus",
    nameSv: "Nattersättning",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "nightWorkAllowance",
    notSupportedError: null,
    descriptionEn: "Working time compensation paid for night work",
    descriptionFi: "Työaikakorvaus, jota maksetaan yötyöstä.",
    descriptionSv: "Arbetstidsersättning för nattarbete.",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
are paid from the night work allowance.`,
    taxAndSideCostsDescrFi: "Yötyökorvauksesta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på nattersättning och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/workingTimeCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 237,
    nameEn: "Night shift compensation",
    nameFi: "Yövuorolisä",
    nameSv: "Nattskiftstillägg",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "nightShiftCompensation",
    notSupportedError: null,
    descriptionEn: "Shift work compensation paid for a night shift.",
    descriptionFi: "Vuorotyökorvaus, joka maksetaan yövuorosta.",
    descriptionSv: "Ersättning för skiftarbete som betalas för nattskift",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
paid from night shift compensation.`,
    taxAndSideCostsDescrFi: "Ylivuorolisästä toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på nattskiftstillägg och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/workingTimeCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 238,
    nameEn: "Other regular compensation",
    nameFi: "Muu säännöllinen lisä",
    nameSv: "Annat regelbundet tillägg ",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "otherRegularCompensation",
    notSupportedError: null,
    descriptionEn: "",
    descriptionFi: "Sellaisten työaika- ja poikkeustilakorvausten yhteissumma, joita maksetaan säännöllisesti ja jotka lasketaan säännöllisen työajan ansioon. Muita säännöllisiä lisiä ovat mm. luontoisedusta maksetut rahakorvaukset, aattotyökorvaukset ja muut mahdolliset työehtosopimusten tai työsopimusten perusteella säännöllisesti maksettavat korvaukset ja lisät, kuten kielilisä. Myös harvoin maksettava lisä katsotaan säännölliseksi, jos se kuuluu säännöllisen työajan ansioon.",
    descriptionSv: "Totalbeloppet av sådana arbetstids- och undantagssituationsersättningar som betalas ut regelbundet och räknas till lönen för ordinarie arbetstid. Andra regelbundna tillägg är t.ex. penningersättningar för naturaförmåner, ersättningar för helgaftonsarbete och andra eventuella regelbundna ersättningar och tillägg som betalas ut på basis av villkoren i kollektivavtal eller arbetsavtal, såsom språktillägg. Ett tillägg som betalas ut sporadiskt betraktas också som ett regelbundet tillägg, om tillägget ingår i lönen för ordinarie arbetstid.",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "Säännöllisistä lisistä toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "På regelbundna tillägg ska förskottsinnehållning verkställas och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 239,
    nameEn: "Compensation for unused compensatory leave",
    nameFi: "Vastikevapaan korvaus",
    nameSv: "Ersättning för kompensationsledighet ",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "compensationForUnusedCompensatoryLeave",
    notSupportedError: null,
    descriptionEn: `Compensation used in certain sectors, paid at the\r
end of employment for unused days off. In certain sectors, working accumulates compensatory leave\r
for the worker, allowing the worker to take days off\r
during employment. If the employee has not used\r
their compensatory leave at the end of their employment, compensation is paid for the unused\r
leave.\r
Monetary compensation paid instead of granting an\r
annual holiday is reported using the Annual holiday\r
compensation (234) income type.`,
    descriptionFi: `Tietyillä aloilla käytössä oleva korvaus, jota maksetaan työsuhteen päättyessä pitämättömistä vapaapäivistä. Tietyillä aloilla tehty työ kerryttää tekijälleen vastikevapaata, jota työsuhteen kuluessa pidetään vapaana. Jos työntekijä ei ole pitänyt vapaapäiviä, kun työsuhde päättyy, niistä maksetaan korvausta.\r
\r
Vuosiloman antamisen sijaan suoritettava rahallinen korvaus ilmoitetaan tulolajilla Vuosilomakorvaus (234).`,
    descriptionSv: `En ersättning som används i vissa branscher som betalas ut vid arbetsförhållandets upphörande för lediga dagar som inte tagits ut. Arbete som utförts i vissa branscher ackumulerar\r
kompensationsledighet till arbetsutföraren. Under\r
arbetsförhållandet tar man ut\r
kompensationsledigheten som ledighet. Om\r
arbetstagaren vid arbetsförhållandets upphörande\r
inte har tagit ut sina lediga dagar, betalas\r
ersättning för dessa dagar till arbetstagaren.\r
Penningersättning som betalas i stället för att ge\r
semester anmäls med inkomstslaget\r
Semesterersättning (234).`,
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
paid from the compensation for unused compensatory leave.`,
    taxAndSideCostsDescrFi: "Vastikevapaan korvauksesta toimitetaan ennakon-pidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "På ersättningen för kompensationsledigheten ska förskottsinnehållning verkställas och socialförsäkringsavgifter betalas",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 301,
    nameEn: "Accommodation benefit",
    nameFi: "Asuntoetu",
    nameSv: "Bostadsförmån",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "accommodationBenefit",
    notSupportedError: null,
    descriptionEn: `A fringe benefit established by the employer,\r
providing the employee with an apartment the\r
employer owns or possesses based on a lease\r
relationship related to the employment, or as a\r
benefit included in the pay.\r
An accommodation benefit can be reported separately, but the received benefit must be reported, as\r
at least a total sum, using the Other fringe benefit\r
income type. In such a case, Type of benefit additional data related to the Other fringe benefit income type must be used to report that the income\r
reported with the Other fringe benefit income type\r
includes an accommodation benefit.\r
If the benefit is reported separately, it should not be\r
added to the income reported using the Other\r
fringe benefit income type.\r
The amount of the accommodation benefit must be\r
reported in full, even when the employee has paid\r
a reimbursement for the benefit to the employer\r
equalling the monetary value of the accommodation benefit, with no taxable benefit remaining.`,
    descriptionFi: `Luontoisetu, joka syntyy, kun työnantaja antaa työntekijän käyttöön omistamansa tai hallitsemansa asunnon palvelussuhteeseen liittyvän vuokrasuhteen perusteella tai palkkaan sisältyvänä etuna.\r
\r
Palkkaus.fi-palvelussa asuntoetu ilmoitetaan aina tällä tulolajilla, ei koskaan 'Muu luontoisetu'-tulolajilla.`,
    descriptionSv: "Naturaförmån som uppkommer när arbetsgivaren låter arbetstagaren använda en bostad som arbetsgivaren äger eller besitter enligt ett hyresförhållande baserat på anställningsförhållande eller som en förmån som ingår i lönen Bostadsförmån kan anmälas separat, men den beviljade förmånen ska åtminstone anges som total summa med inkomstslaget Övriga naturaförmåner. Då ska man dessutom med hjälp tilläggsuppgiften Typ av förmån relaterad till inkomstslaget Övriga naturaförmåner anmäla att inkomsten som anmälts med inkomstslaget Övriga naturaförmåner innehåller bostadsförmån. Om förmånen anmäls separat läggs den inte till inkomster som anmäls med inkomstslaget Övriga naturaförmåner. Beloppet av bostadsförmånen ska anmälas till sitt fulla belopp även om arbetstagaren har betalat en ersättning till arbetsgivaren som motsvarar bostadsförmånens penningvärde, och ingen beskattningsbar förmån återstår.",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
are paid from the accommodation benefit.`,
    taxAndSideCostsDescrFi: "Asuntoedusta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på bostadsförmån och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/benefits"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 302,
    nameEn: "Interest benefit for a housing loan",
    nameFi: "Asuntolainan korkoetu",
    nameSv: "Ränteförmån för bostadslån",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "interestBenefitForHousingLoan",
    notSupportedError: null,
    descriptionEn: `A taxable personnel benefit established when\r
the employer collects annual interest from a\r
housing loan it has granted to an employee that\r
is lower than the reference interest rate commonly used in the market.`,
    descriptionFi: "Veronalainen henkilökuntaetu, joka muodostuu silloin, kun työnantaja perii työntekijälle myöntämästään asuntolainasta vuotuista korkoa, joka on alempi kuin yleisesti markkinoilla käytössä oleva viitekorko.",
    descriptionSv: `En skattepliktig personalförmån som uppstår när arbetsgivaren tar ut en årlig ränta på ett bostadslån som arbetsgivaren beviljat arbetstagaren och som är lägre än den referensränta som används allmänt\r
på marknaden`,
    taxAndSideCostsDescrEn: `Interest benefit for a housing loan is subject to\r
withholding but not to social insurance contributions.`,
    taxAndSideCostsDescrFi: "Asuntolainan korkoetu on ennakonpidätyksen alainen, mutta siitä ei makseta sosiaalivakuutusmaksuja.",
    taxAndSideCostsDescrSv: "Ränteförmån för bostadslån är förskottsinnehållningspliktig, men inga socialförsäkringsavgifter betalas för den.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/enterprise"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 303,
    nameEn: "Meal allowance",
    nameFi: "Ateriakorvaus",
    nameSv: "Måltidsersättning",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "mealAllowance",
    notSupportedError: null,
    descriptionEn: `Tax-exempt compensation of meal expenses\r
that are due to a business trip.\r
The meal allowance can be paid exempt from\r
tax, if the employee does not have the opportunity to have a meal at their normal eatingplace during their lunch break and the meal has\r
not been arranged, for example, as a meal that\r
forms part of the course package paid for by the\r
employer. A tax-exempt meal allowance cannot\r
be paid together with a tax-exempt daily allowance for the same business trip.\r
The decisions issued annually by the Tax Administration on tax-exempt allowances for business travel lay down the grounds for meal allowances and their tax-exempt maximum amounts.\r
Report only the amounts of tax-exempt meal allowances here. If the paid allowance exceeds\r
the maximum amounts defined in the decision\r
by the Tax Administration, or is paid in deviation\r
from the grounds laid down in the decision, the\r
payment should be reported as wages subject\r
to social insurance contributions.\r
A meal allowance can be reported separately, but\r
the received allowance must be reported as at\r
least a total sum, using the Daily allowance income\r
type. In such a case, the payer must also use the\r
Type of other reimbursement or benefit additional\r
data related to the income type to report that the allowance reported with the Daily allowance income\r
type includes a meal allowance.\r
If the meal allowance is reported separately, it\r
should not be added to the amounts reported using\r
the Daily allowance income type.`,
    descriptionFi: `Verovapaa kustannusten korvaus ateriointikuluista, jotka johtuvat työmatkasta.\r
\r
Ateriakorvaus voidaan maksaa verovapaasti, jos työntekijällä ei ole mahdollisuutta aterioida ruokailutauon aikana tavanomaisella ruokailupaikallaan, eikä ruokailua ole järjestetty esimerkiksi kurssipakettiin kuuluvana työnantajan kustantamana ruokailuna. **Verovapaata ateriakorvausta ei voi maksaa samasta työmatkasta yhtä aikaa verovapaan päivärahan kanssa.**\r
\r
Ateriakorvauksen perusteista ja verovapaista enimmäismääristä säädetään vuosittain annettavissa Verohallinnon päätöksissä verovapaista matkakustannusten korvauksista.\r
\r
Kohdassa ilmoitetaan vain verovapaiden ateriakorvausten määrät. Jos maksettu korvaus ylittää Verohallinnon päätöksen enimmäismäärät tai maksetaan vastoin päätöksessä säädettyjä perusteita, suoritus ilmoitetaan sosiaalivakuutusmaksujen alaisena palkkana.\r
\r
Ateriakorvaus voidaan ilmoittaa erikseen, mutta saatu korvaus on ilmoitettava vähintään yhteissummana Päiväraha -tulolajilla. Tällöin on lisäksi ilmoitettava tulolajiin liittyvän Korvauksen tyyppi-lisätiedon avulla, että Päiväraha-tulolajilla ilmoitettu korvaus sisältää ateriakorvauksen.\r
\r
Jos ateriakorvaus ilmoitetaan erikseen, sitä ei lisätä enää Päiväraha -tulolajilla ilmoitettaviin määriin.`,
    descriptionSv: "Skattefri kostnadsersättning för måltidskostnader som förorsakas av arbetsresa Måltidsersättningen kan betalas skattefritt om det inte är möjligt för arbetstagaren att inta måltid under matrasten på sitt sedvanliga matställe och måltid har inte ordnats till exempel såsom i ett kurspaket ingående måltid som arbetsgivaren bekostar. Skattefri måltidsersättning kan inte betalas för samma arbetsresa samtidigt med skattefritt dagtraktamente. Bestämmelser om grunderna för måltidsersättning för arbetsresa och skattefria maximibelopp ges årligen i Skatteförvaltningens beslut om skattefria resekostnadsersättningar. I punkten anges endast beloppen av skattefria måltidsersättningar. Om den betalda ersättningen överstiger det maximala beloppet enligt Skatteförvaltningens beslut eller om den betalas i strid med grunderna enligt beslutet, anmäls prestationen som lön underställd socialförsäkringsavgifter. Måltidsersättning kan anmälas separat, men den beviljade ersättningen ska åtminstone anges som total summa med inkomstslaget Dagtraktamenten. Då ska man dessutom med hjälp tilläggsuppgiften Typ av ersättning relaterad till inkomstslaget anmäla att ersättningen som anmälts med inkomstslaget Dagtraktamenten innehåller måltidsersättning. Om måltidsersättningen anmäls separat läggs den inte till belopp som anmäls med inkomstslaget Dagtraktamenten.",
    taxAndSideCostsDescrEn: "No tax is withheld or social insurance contributions are paid from a tax-exempt meal allowance.",
    taxAndSideCostsDescrFi: "Verovapaasta ateriakorvauksesta ei toimiteta ennakonpidätystä eikä makseta sosiaalivakuutusmaksuja.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs inte på skattefria måltidsersättningar och inte heller socialförsäkringsavgifter ska betalas.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/travelExpenses"
    ],
    calcGrouping: "expenses"
  },
  {
    code: 304,
    nameEn: "Car benefit",
    nameFi: "Autoetu",
    nameSv: "Bilförmån",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "carBenefit",
    notSupportedError: null,
    descriptionEn: `A fringe benefit established by the employer,\r
providing the employee or their family with a car\r
that the employer owns or possesses and allowing its private use.\r
The car benefit must be reported even if the employee has paid the employer compensation for the fringe benefit equal to or exceeding the\r
monetary value of the fringe benefit, with no remaining amount to be added to the wages. The\r
collected amount is reported separately using\r
the Compensation collected for car benefit itemisation type.`,
    descriptionFi: `Luontoisetu, joka syntyy, kun työnantaja antaa työntekijän tai tämän perheen käyttöön omistamansa tai hallitsemansa auton, jonka yksityiskäyttö on sallittu.\r
\r
Autoetu on ilmoitettava siinäkin tapauksessa, että työntekijä on maksanut luontoisedusta työnantajalle luontoisedun raha-arvoa vastaavan tai sitä suuremman korvauksen, eikä palkkaan lisättävää määrää ole jäänyt lainkaan. Peritty summa ilmoitetaan erikseen Autoedusta peritty korvaus- erittelylajilla.`,
    descriptionSv: "Naturaförmån som uppkommer när arbetsgivaren ställer till förfogande för en arbetstagare eller dennes familj en bil som arbetsgivaren äger och som det är tillåtet att använda för privat bruk Bilförmån ska anmälas även om arbetstagaren betalat arbetsgivaren ett belopp som motsvarar naturaförmånens penningvärde eller en större ersättning, och ingenting återstår att lägga till lönen. Summan anmäls separat med specificeringsslaget Debiterad ersättning för bilförmån.",
    taxAndSideCostsDescrEn: `Tax is withheld and social insurance contributions\r
are paid from the car benefit.`,
    taxAndSideCostsDescrFi: "Autoedusta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på bilförmån och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/carBenefit",
      "https://palkkaus.fi/usecases/2019/benefits"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 308,
    nameEn: "Compensation for membership of a governing body",
    nameFi: "Hallintoelimen jäsenyydestä maksettu palkkio",
    nameSv: "Arvode för medlemskap i förvaltningsorgan",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "compensationForGoverningBodyMembership",
    notSupportedError: null,
    descriptionEn: `Compensation for acting in a position of trust,\r
paid based on being a member of the company's board of directors or an equivalent governing body.`,
    descriptionFi: `Luottamustoimipalkkio, joka maksetaan yhteisön hallituksen tai vastaavan hallintoelimen jäsenyyden perusteella.\r
\r
Jos henkilölle maksetaan palkkiota hallintoelimen jäsenyydestä, hänelle voidaan maksaa myös verovapaita matkakustannusten korvauksia työmatkasta aiheutuneiden kulujen perusteella, jos verovapaiden korvausten muut edellytykset täyttyvät.`,
    descriptionSv: "Arvode för förtroendeuppdrag som betalas på grund av medlemskap i ett samfunds styrelse eller motsvarande förvaltningsorgan.",
    taxAndSideCostsDescrEn: "If the recipient of compensation paid for membership of a governing body is not in an employment relationship, the payment of earnings-related pension insurance contributions from such compensation is voluntary in the private sector. However, in the public sector, compensation paid for membership of a governing body is subject to social insurance contributions. If, based on the compensation, the employee's earningsrelated pension contribution does not have to be paid according to employment pension legislation, the employer's health insurance contribution and the employee's daily allowance contribution are not paid from the compensation, even if an earnings-related pension insurance contribution was paid voluntarily. This compensation is subject to the accident and occupational disease insurance contribution, if it is paid to a person in an employment relationship. Tax is withheld from compensation paid for membership of a governing body. By default, this income type is compensation paid for membership of a governing body, where such compensation is not subject to social insurance contributions. In sectors other than the public sector, the essential factor with regard to the contribution obligation is whether the compensation was paid in an employment relationship. If the recipient of the compensation is in an employment relationship and the compensation is subject to a social insurance contribution, the payer must use the separate Type of insurance information entry to report that the income is subject to the specified insurance contribution.",
    taxAndSideCostsDescrFi: `Jos hallintoelimen jäsenestä maksettavan palkkion saaja ei ole palvelussuhteessa, työeläkevakuutusmaksujen maksaminen palkkiosta on yksityisellä sektorilla vapaaehtoista. Julkisella alalla hallintoelimen jäsenyydestä maksettavista palkkioista suoritetaan tällöinkin sosiaalivakuutusmaksut. Jos palkkion perusteella ei henkilöön sovellettavien työeläkelakien mukaan ole tarvinnut maksaa työntekijän työeläkemaksua, suorituksesta ei makseta työnantajan sairausvakuutusmaksua eikä työntekijän päivärahamaksua, vaikka työeläkevakuutusmaksu olisikin maksettu vapaaehtoisesti. Palkkio on työtapaturma- ja ammattitautivakuutusmaksun alainen, jos se maksetaan palvelussuhteessa olevalle.\r
\r
Hallintoelimen jäsenyydestä maksettavasta palkkiosta toimitetaan ennakonpidätys.\r
\r
Oletuksena tulolajissa on, että hallintoelimen jäsenyydestä maksettu palkkio ei ole sosiaalivakuutusmaksujen alainen. Olennaista maksuvelvollisuuden kannalta muilla kuin julkisella alalla on se, onko palkkio maksettu työ- tai muussa palvelussuhteessa.\r
\r
Jos palkkionsaaja on palvelusuhteessa ja palkkio on jonkun sosiaalivakuutusmaksun alainen, suorituksen maksaja ilmoittaa erillistä Vakuuttamistiedon tyyppitietoa käyttäen, että tulo on ilmoitetun vakuutusmaksun alainen.`,
    taxAndSideCostsDescrSv: `Om mottagaren av arvode för medlemskap i förvaltningsorgan inte är i anställningsförhållande, är det inom den privata sektorn frivilligt att betala arbetspensionsförsäkringsavgifter på arvodet. På ett arvode för medlemskap i förvaltningsorgan inom den offentliga sektorn betalas då också socialförsäkringsavgifter. Om man enligt de arbetspensionslagar som på basis av arvodet tillämpar på personen inte behöver betala arbetstagarens arbetspensionsavgift, betalas inte arbetsgivarens sjukförsäkringsavgift och inte arbetstagarens dagpenningsavgift för arvodet, även om arbetspensionsförsäkringsavgiften betalats frivilligt. Arvodet är underställt arbetsolycksfallsoch yrkessjukdomsförsäkringsavgift, om det betalas till en person i anställningsförhållande. På ett arvode för medlemskap i förvaltningsorgan verkställs förskottsinnehållning. I inkomstslaget är det förvalt att arvodet för medlemskap i förvaltningsorgan inte är underställt socialförsäkringsavgifter. Det väsentliga med tanke på betalningsskyldigheten i andra sektorer än den offentliga sektorn är om arvodet betalats i arbetseller annat tjänsteförhållande. Om mottagaren av arvodet är i tjänsteförhållande och arvodet är underställt någon socialförsäkringsavgift, anmäler betalaren med hjälp av den separata uppgiften Typ av försäkringsuppgift att inkomsten är underställd den angivna försäkringsavgiften. Om arvode för medlemskap i förvaltningsorgan\r
betalas till en person, kan till personen även\r
betalas skattefria ersättningar för resekostnader\r
utifrån de kostnader som arbetsresan förorsakat,\r
förutsatt att de övriga förutsättningarna för\r
skattefria ersättningar uppfylls.`,
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/board",
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "baseSalary"
  },
  {
    code: 309,
    nameEn: "Share of reserve and surplus drawn from personnel fund (taxable 80%)",
    nameFi: "Henkilöstörahastosta nostettu rahasto-osuus ja ylijäämä (veronalainen 80%)",
    nameSv: "Fondandel och överskott som tagits ut ur en personalfond (skattepliktig till 80 %)",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "shareOfReserveDrawnFromPersonnelFund",
    notSupportedError: null,
    descriptionEn: `A fund unit paid to an employee from a personnel fund. Funds allocated to personnel funds are\r
divided into items withdrawable as fund units\r
and items withdrawable in cash.\r
20% of a fund unit withdrawn from a personnel\r
fund is tax-exempt, and tax is withheld from the\r
80% share of taxable income. For taxation purposes, surplus withdrawn from a personnel fund\r
is treated in the same way as a fund unit withdrawn from a personnel fund. Ks. See the Tax\r
Administration's instructions Taxation of income\r
from a personnel fund\r
(VH/3038/00.01.00./2018).`,
    descriptionFi: `Rahasto-osuus, joka maksetaan työntekijälle henkilöstörahastosta. Henkilörahastoon osoitetut varat jaetaan rahasto-osuutena nostettaviin eriin ja käteisenä nostettaviin eriin.\r
\r
Henkilöstörahastosta nostetusta rahasto-osuudesta 20 % on verovapaata ja 80 %:n veronalaisesta ansiotulo-osuudesta toimitetaan ennakonpidätys. Henkilöstörahastosta nostettua ylijäämää kohdellaan verotuksessa samalla tavalla kuin henkilöstörahastosta nostettua rahasto-osuutta. Ks. Verohallinnon ohje Henkilöstörahastosta saatavien tulojen verotus (A69/200/2014).\r
\r
Tulolajilla ilmoitetaan vain veronalainen osuus.`,
    descriptionSv: "Fondandel som betalas till arbetstagaren ur en personalfond. Medel som anvisats till personalfond delas in i poster som tas ut som fondandelar och poster som tas ut kontant. Av inkomst som erhållits från en personalfond är 20 % skattefri och på andelen på 80 % som utgör skattepliktig förvärvsinkomst verkställs förskottsinnehållning. Överskott som lyfts från en personalfond behandlas i beskattningen på samma sätt som en fondandel som lyfts från en personalfond. Se Se Skatteförvaltningens anvisning Beskattning av inkomster från personalfonder (VH/3038/00.01.00./2018). Endast den skattepliktiga andelen anges för inkomstslaget.",
    taxAndSideCostsDescrEn: `This income type is used to report only the taxable share.\r
Tax is withheld, but social insurance payments\r
are not paid from a withdrawn fund unit. However, social insurance contributions are paid\r
from a fund unit withdrawn for a person in cash\r
rather than paying it into the personnel fund, i.e.,\r
the employer does not pay the amount into the\r
fund but directly to a member.\r
Only items withdrawn from a fund as fund units\r
are reported in this section. If the payment was\r
withdrawn in cash, it is reported as regular\r
wages.`,
    taxAndSideCostsDescrFi: "Nostetusta rahasto-osuudesta toimitetaan ennakonpidätys, mutta ei makseta sosiaalivakuutusmaksuja. Sitä vastoin henkilöstörahastoon maksamisen sijaan suoraan henkilölle käteisenä nostetusta rahastoosuudesta, jota ei makseta rahastoon vaan työnantaja maksaa sen suoraan jäsenelle, maksetaan sosiaalivakuutusmaksut. Kohdassa ilmoitetaan vain rahastosta rahasto-osuutena nostetut erät. Jos suoritus on nostettu käteisenä, se ilmoitetaan tavallisena palkkana.",
    taxAndSideCostsDescrSv: "På uttagna fondandelar verkställs förskottsinnehållning, men inga socialförsäkringsavgifter betalas. I motsats till betalning till personalfonden betalas socialförsäkringsavgifter för fondandelar som en person tar ut kontant. I punkten anges endast poster som tagits ut ur fonden som fondandelar. Om det är kontantuttag anmäls det som vanlig lön.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "benefits"
  },
  {
    code: 310,
    nameEn: "Monetary gift for employees",
    nameFi: "Henkilöstölle annettu rahalahja",
    nameSv: "Penninggåva till personalen",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "monetaryGiftForEmployees",
    notSupportedError: null,
    descriptionEn: `A gift received from the employer as money or a\r
comparable payment.`,
    descriptionFi: "Työnantajalta rahana tai siihen verrattavana suorituksena saatu lahja.",
    descriptionSv: "Penninggåva eller motsvarande prestation av arbetsgivaren.",
    taxAndSideCostsDescrEn: `A monetary gift is considered to be taxable income from which tax must be withheld but which\r
is not subject to social insurance contributions, if\r
the monetary gift was given due to an anniversary concerning the employee.\r
If the monetary gift was given for a reason other\r
than such an anniversary, social insurance contributions must be paid based on the gift.\r
By default, this income type is subject to social\r
insurance contributions. If the monetary gift is not subject to social insurance contributions, the payer should report the\r
insurance details separately using the Type of\r
insurance information data group.`,
    taxAndSideCostsDescrFi: `Rahalahja katsotaan veronalaiseksi tuloksi, josta on toimitettava ennakonpidätys, mutta josta ei makseta sosiaalivakuutusmaksuja, jos rahalahja on annettu työntekijän merkkipäivän johdosta.\r
\r
Jos rahalahja on annettu muutoin kuin työntekijän omana merkkipäivänä, maksetaan suorituksesta sosiaalivakuutusmaksut.\r
\r
Oletuksena tulolajissa on, että tulo on sosiaalivakuutusmaksujen alainen. \r
\r
Jos annettu rahalahja ei ole sosiaalivakuutusmaksujen alainen, suorituksen maksaja ilmoittaa vakuuttamistiedon erikseen Vakuuttamistiedon tyyppi- tietoryhmää käyttäen.`,
    taxAndSideCostsDescrSv: `En penninggåva anses vara skattepliktig inkomst på vilken förskottsinnehållning ska verkställas, men för vilken socialförsäkringsavgifter inte betalas, om penninggåvan har getts med anledning av arbetstagarens bemärkelsedag. Om penninggåvan ges på någon annan dag betalas socialförsäkringsavgifter för betalningen. I inkomstslaget är det förvalt att inkomsten är underställd socialförsäkringsavgifter. Om penninggåvan inte är underställd socialförsäkringsavgifter, anmäler betalaren\r
försäkringsuppgiften separat med hjälp av\r
uppgiftsgruppen Typ av försäkringsuppgift.`,
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 311,
    nameEn: "Kilometre allowance (tax-exempt)",
    nameFi: "Kilometrikorvaus (verovapaa)",
    nameSv: "Kilometerersättning (skattefri)",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "kilometreAllowanceTaxExempt",
    notSupportedError: null,
    descriptionEn: `A kilometre allowance fulfilling the requirements\r
set for tax exemption, paid to a person for their\r
use of a vehicle they own or possess.\r
Tax-exempt kilometre allowance can be paid to\r
persons who are in an employment relationship\r
and to persons who are not in an employment\r
relationship but who are paid wages in accordance with tax legislation, for example as meeting fees.\r
In certain cases, the kilometre allowance paid\r
for the use of a private car can be increased.\r
The grounds for the increase are laid down in\r
section 9(1) of the Tax Administration's decision\r
on expenses. This income type is used to report\r
the total amount of allowances paid, including\r
the increases.\r
If the kilometre allowance has been paid against\r
the criteria prescribed by law or set by a decision of the Tax Administration, no part of it is\r
tax-exempt.\r
If the kilometre allowance has been paid in accordance with a decision by the Tax Administration, but in a larger amount than specified as\r
tax-exempt in the decision, some of the allowance is taxable and some is tax-exempt. Taxable kilometre allowances are reported separately using their own income type or the income\r
types for wages.\r
Compensation paid to an income earner for\r
travel expenses based on a certificate (e.g. a\r
train ticket) issued by a transport operator is taxexempt, and is not reported.\r
Report only the amounts of tax-exempt kilometre allowances here. No tax is withheld or social\r
insurance contributions are paid from these\r
amounts. \r
\r
Reimbursement of travel expenses between\r
residence and place of work in the construction\r
sector`,
    descriptionFi: `Henkilön oman tai hänen hallinnassaan olevan kulkuneuvon käytöstä suoritettava kilometrikorvaus, joka täyttää verovapaudelle asetetut vaatimukset.\r
\r
Verovapaata kilometrikorvausta voidaan maksaa palvelussuhteessa oleville ja henkilöille, jotka eivät ole palvelussuhteessa, mutta joille maksetaan verolainsäädännön mukaista palkkaa, esimerkiksi kokouspalkkion yhteydessä.\r
\r
Jos kilometrikorvaus on maksettu vastoin Verohallinnon päätöksen mukaisia aika- ja kilometrirajoja, ne eivät ole miltään osin verovapaita.\r
\r
Jos kilokorvaukset on maksettu Verohallinnon päätöksen mukaan, mutta suurempina kuin päätöksessä on määrätty verovapaaksi, osa korvauksista on veronalaista ja osa verovapaata. Veronalaiset kilometrikorvaukset ilmoitetaan erikseen omalla tulolajillaan tai palkan tulolajeilla.\r
\r
Liikenteenharjoittajan antaman tositteen (esimerkiksi junalipun) perusteella tulonsaajalle maksetut matkustamiskustannusten korvaukset ovat verovapaita, eikä niitä ilmoiteta.\r
\r
**Rakennusalalla maksettavat asunnon ja työpaikan väliset matkakustannusten korvaukset**\r
\r
Rakennusalan työehtosopimuksen mukaan päivittäisistä asunnon ja erityisen työntekemispaikan välisistä matkoista maksetaan matkakustannusten korvausta (”tossurahaa”) erityisen taulukon mukaan eikä Verohallinnon päätöksen mukaisina kilometrikorvauksina. Työehtosopimuksen mukainen korvaus on kuitenkin pienempi kuin Verohallinnon päätöksen mukaiset kilometrikorvaukset, joten korvaus on verovapaata. \r
\r
Rakennusalan tossurahan yhteydessä ei tarvitse ilmoittaa kilometrimäärää.`,
    descriptionSv: "Kilometerersättning som betalas för användning av ett fordon som personen äger eller disponerar över och som uppfyller kraven på skattefrihet. Skattefri kilometerersättning kan betalas till personer i anställningsförhållande och till personer som inte är i anställningsförhållande, men till vilka annan lön i enlighet med skattelagstiftningen betalas exempelvis i samband med mötesarvode. Kilometerersättningen som betalas för användning av egen bil kan höjas i vissa fall. Grunderna för höjningen beskrivs i 9 § 1 mom. i Skatteförvaltningens kostnadsbeslut. Med inkomstslaget anmäls det totala beloppet av betalda ersättningar jämte förhöjningar. Om kilometerersättningar betalats i strid med lagen eller grunderna i Skatteförvaltningens beslut, är de inte skattefria till någon del. Om kilometerersättningar betalats ut enligt Skatteförvaltningens beslut, men till ett belopp som överstiger skattefriheten enligt beslutet, är en del av ersättningarna skattepliktig och en del skattefri. Skattepliktiga kilometerersättningar anmäls separat under eget inkomstslag eller under inkomstslag för lön. Ersättningar för resekostnader som betalats till inkomsttagaren på basis av ett verifikat (t.ex. tågbiljett) av en trafikant är skattefria och anmäls inte",
    taxAndSideCostsDescrEn: `According to the collective agreement of the construction sector, daily travel expenses between residence and place of work are reimbursed according\r
to a special table, not as kilometre allowances set\r
by a decision of the Tax Administration. However,\r
the reimbursement paid according to the collective\r
agreement is lower than the kilometre allowances\r
set by the decision of the Tax Administration, so\r
the reimbursement is tax-exempt. The number of\r
kilometres does not need to be reported in connection with travel expense reimbursements in the\r
construction sector.`,
    taxAndSideCostsDescrFi: "Kohdassa ilmoitetaan vain verovapaiden kilometrikorvausten määrät. Summasta ei toimiteta ennakonpidätystä eikä makseta sosiaalivakuutusmaksuja.",
    taxAndSideCostsDescrSv: "I punkten anges endast beloppen av skattefria kilometerersättningar. På summan verkställs inte förskottsinnehållning och betalas inte heller socialförsäkringsavgifter",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/travelExpenses"
    ],
    calcGrouping: "expenses"
  },
  {
    code: 312,
    nameEn: "Treatment fee for municipal veterinarian",
    nameFi: "Kunnaneläinlääkärin toimenpidepalkkio",
    nameSv: "Åtgärdsarvode för kommunal veterinär",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "treatmentFeeForMunicipalVeterinarian",
    notSupportedError: "Not supported for companies / associations",
    descriptionEn: "",
    descriptionFi: "Vain kunnat käyttävät tätä tulolajia.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 313,
    nameEn: "Compensation for use, earned income",
    nameFi: "Käyttökorvaus ansiotuloa",
    nameSv: "Bruksersättning som förvärvsinkomst",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "compensationForUseEarnedIncome",
    notSupportedError: null,
    descriptionEn: `Compensation paid for the assignation or right\r
to use a copyright, an industrial property right, or\r
information on industrial, commercial or scientific experience.`,
    descriptionFi: "Korvaus, joka suoritetaan tekijänoikeuden, teollisoikeuden tai teollisia, kaupallisia tai tieteellisiä kokemuksia koskevien tietojen luovuttamisesta tai käyttöoikeudesta.",
    descriptionSv: "En ersättning som betalas för överlåtelse av eller nyttjanderätt till upphovsrätt, industriell äganderätt eller för uppgifter om industriella, kommersiella eller vetenskapliga rön",
    taxAndSideCostsDescrEn: `Compensation for use can be paid to recipients\r
regardless of whether or not they are registered\r
in the prepayment register. Compensation for\r
use is taxable income, and tax is withheld from\r
this if the recipient is not registered in the prepayment register.\r
All compensation for use from which tax has\r
been withheld must be reported using this income type. Compensation for use paid to natural persons must be reported, even if tax has not\r
been withheld from it. Compensation for use\r
paid to natural persons registered in the prepayment register must also be reported.\r
This income type is also used to report the compensation for use paid to a consortium, organisation or joint venture.\r
No social insurance contributions are paid on\r
compensation for use.`,
    taxAndSideCostsDescrFi: `Käyttökorvausta voidaan maksaa ennakkoperintärekisteriin kuuluvalle tai kuulumattomalle korvauksen saajalle. Käyttökorvaus on veronalaista ansiotuloa ja siitä toimitetaan ennakonpidätys, jos korvauksen saaja ei kuulu ennakkoperintärekisteriin.\r
\r
Tulolajilla on ilmoitettava kaikki käyttökorvaukset, joista on toimitettu ennakonpidätys. Luonnollisille henkilöille maksetut käyttökorvaukset on ilmoitettava, vaikka niistä ei ole toimitettu ennakonpidätystä. Myös ennakkoperintärekisteriin merkitylle luonnolliselle henkilölle maksetut käyttökorvaukset on ilmoitettava.\r
\r
Tulolajilla ilmoitetaan myös yhtymän, yhteisön tai yhteenliittymän saamat käyttökorvaukset (mutta niitä ei voi ilmoittaa Palkkaus.fi-palvelussa).\r
\r
Tulolajilla ilmoitetaan lisäksi rajoitetusti verovelvolliselle maksetut rojalti. Jos rojalti eli käyttökorvaus on maksettu rajoitetusti verovelvolliselle luonnolliselle henkilölle, tiedot on ilmoitettava tulorekisteriin, vaikka tulonsaaja olisikin ennakkoperintärekisterissä eikä suorituksesta olisi peritty lähdeveroa.\r
\r
Käyttökorvauksesta ei makseta sosiaalivakuutusmaksuja.`,
    taxAndSideCostsDescrSv: "Bruksersättning kan betalas till en mottagare som finns införd iförskottsuppbördsregistret eller som inte finns införd i det. Bruksersättning utgör skattepliktig förvärvsinkomst på vilken förskottsinnehållning ska verkställas, om mottagaren inte är införd i förskottsuppbördsregistret. Alla bruksersättningar på vilka förskottsinnehållning verkställts ska anmälas för inkomstslaget. Bruksersättningar till fysiska personer ska anmälas även om förskottsinnehållning inte verkställts. Även bruksersättningar till fysiska personer som införts i förskottsuppbördsregistret ska anmälas. Med inkomstslaget anmäls också bruksersättningar som en sammanslutning, ett samfund eller ett konsortium fått. På bruksersättning betalas inte socialförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 314,
    nameEn: "Compensation for use, capital income",
    nameFi: "Käyttökorvaus pääomatuloa",
    nameSv: "Bruksersättning som kapitalinkomst",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "compensationForUseCapitalIncome",
    notSupportedError: null,
    descriptionEn: `Compensation paid for the assignation or right\r
to use a copyright, an industrial property right, or\r
information on industrial, commercial or scientific experience.\r
If a copyright has been transferred as an inheritance or through a last will and testament, or\r
acquired for a payment, compensation received\r
from its use is deemed capital income for the\r
person, in the form of income received from Finland, regardless of the prepayment register entry.`,
    descriptionFi: `Korvaus, joka suoritetaan tekijänoikeuden, teollisoikeuden tai teollisia, kaupallisia tai tieteellisiä kokemuksia koskevien tietojen luovuttamisesta tai käyttöoikeudesta.\r
\r
Jos tekijänoikeus on siirtynyt perintönä tai testamentilla tai se on hankittu vastiketta vastaan, sen käyttämisestä saatu korvaus on henkilölle Suomesta saatuna tulona ennakonpidätyksenalaista pääomatuloa ennakkoperintärekisterimerkinnästä huolimatta.`,
    descriptionSv: "En ersättning som betalas för överlåtelse av eller nyttjanderätt till upphovsrätt, industriell äganderätt eller för uppgifter om industriella, kommersiella eller vetenskapliga rön Om upphovsrätten har överförts som arv eller genom testamente eller skaffats mot vederlag, utgör den ersättning som utgått för användningen av denna, då den är inkomst som erhållits i Finland, innehållspliktig kapitalinkomst trots anteckning i förskottsuppbördsregistret.",
    taxAndSideCostsDescrEn: `All compensation for use from which tax has been withheld is reported using this income\r
type. Compensation for use paid to natural persons must be reported, even if tax has not been\r
withheld from it. Compensation for use paid to\r
natural persons registered in the prepayment\r
register must also be reported.\r
No social insurance contributions are paid on\r
compensation for use`,
    taxAndSideCostsDescrFi: `Tulolajilla ilmoitetaan kaikki käyttökorvaukset, joista on toimitettu ennakonpidätys. Luonnollisille henkilöille maksetut käyttökorvaukset on ilmoitettava, vaikka niistä ei ole toimitettu ennakonpidätystä. Myös ennakkoperintärekisteriin merkitylle luonnolliselle henkilölle maksetut käyttökorvaukset on ilmoitettava.\r
\r
Käyttökorvauksesta ei makseta sosiaalivakuutusmaksuja.`,
    taxAndSideCostsDescrSv: "Alla bruksersättningar på vilka förskottsinnehållning verkställts ska anmälas för inkomstslaget. Bruksersättningar till fysiska personer ska anmälas även om förskottsinnehållning inte verkställts. Även bruksersättningar till fysiska personer som införts i förskottsuppbördsregistret ska anmälas. På bruksersättning betalas inte socialförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 315,
    nameEn: "Other taxable benefit for employees",
    nameFi: "Muu henkilöstölle suunnattu veronalainen etu",
    nameSv: "Annan skattepliktig förmån till personalen",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "otherTaxableBenefitForEmployees",
    notSupportedError: null,
    descriptionEn: `A non-monetary taxable benefit collectively\r
granted by the employer to personnel. A benefit\r
granted for voluntary exercise and culture exceeding the statutory maximum amount of EUR\r
400 is considered taxable benefit, for example.`,
    descriptionFi: `Työnantajan henkilökunnalle kollektiivisesti myöntämä muu kuin rahana annettava veronalainen etu.\r
\r
Veronalaisena etuna pidetään esimerkiksi vuosittain laissa säädetyn enimmäismäärän 400 euroa ylittävää omaehtoiseen liikuntaan ja kulttuuriin annettua etua.`,
    descriptionSv: `En förmån som arbetsgivaren kollektivt beviljar personalen som något annat än pengar. Som skattepliktig förmån betraktas t.ex. förmån för motion och kultur på eget initiativ som överstiger\r
det lagstadgade högsta beloppet på 400 euro om\r
året.`,
    taxAndSideCostsDescrEn: `If the benefit has been granted collectively to all\r
personnel, it is not subject to social insurance\r
contributions. By default, for this income type\r
the benefit is not subject to social insurance\r
contributions.\r
If the benefit has only been granted to some\r
personnel, it is taxable in its entirety and subject\r
to social insurance contributions. The payer\r
then reports the insurance details using the separate Type of insurance information data group.`,
    taxAndSideCostsDescrFi: `Jos etu on annettu kollektiivisesti koko henkilökunnalle, etu ei ole sosiaalivakuutusmaksujen alainen.\r
\r
Oletuksena tulolajissa on, ettei etu ole sosiaalivakuutusmaksujen alainen.\r
\r
Jos etu on annettu vain osalle henkilökuntaa, etu on kokonaisuudessaan veronalainen ja etu on sosiaalivakuutusmaksujen alainen. Tällöin suorituksen maksaja ilmoittaa vakuuttamistiedon erillistä Vakuuttamistiedon tyyppi- tietoryhmää käyttäen.\r
\r
Tulolajia käytetään myös tilanteessa, jossa työnantaja maksaa työntekijälle päivärahaa Verohallinnon päätöstä lievemmin perustein. Tällöin vakuuttamistiedon tyyppi-tiedon avulla voidaan ilmoittaa, jos työnantaja maksaa työntekijälle päivärahaa työehtosopimuksen perusteella Verohallinnon päätöstä lievemmin perustein, jolloin tulo ei ole työeläke-, työttömyyseikä työtapaturma- ja ammattitautivakuutusmaksun alainen.`,
    taxAndSideCostsDescrSv: "Om förmånen har beviljats kollektivt till hela personalen är förmånen inte underställd socialförsäkringsavgifter. I inkomstslaget är det förvalt att förmånen inte är underställd socialförsäkringsavgifter. Om förmånen endast har beviljats till en del av personalen är hela förmånen skattepliktig och underställd socialförsäkringsavgifter. Då anmäler betalaren försäkringsuppgiften separat med hjälp av uppgiftsgruppen Typ av försäkringsuppgift.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/benefits"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 316,
    nameEn: "Other taxable income deemed earned income",
    nameFi: "Muu veronalainen ansiotulo",
    nameSv: "Övriga skattepliktiga förvärvsinkomster",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "otherTaxableIncomeDeemedEarnedIncome",
    notSupportedError: null,
    descriptionEn: `This income type is used to report the total\r
amount of other payments constituting taxable\r
earned income.\r
This income type is used to report taxable occasional remunerations and rewards when the recipient is not in an employment relationship with the\r
payer and the payment is not compensation for\r
work. These include, for example, a benefit\r
granted to a member of a customer company's personnel (e.g. a trip, gift voucher or object), a finder's\r
fee, a so-called vigilance fee paid by a bank, a\r
prize from an art competition, and a competition\r
prize worth over EUR 100 not based on an employment relationship. In the case of a competition\r
prize received for sports, the income is reported\r
using income type: Non-wage compensation for\r
work. Additionally, report Athlete as the type of additional income earner data if the recipient of the\r
prize is not in an employment relationship. For\r
more information on reporting competition prizes,\r
see the instructions Reporting data to the Incomes\r
Register: rewarding employees, payments made to an entrepreneur and other special circumstances,\r
Section 5.14.`,
    descriptionFi: `Tulolajilla ilmoitetaan muiden veronalaisten ansiotuloa olevien suoritusten yhteissumma.\r
\r
Tulolajilla ilmoitetaan veronalaiset satunnaiset palkkiot ja palkinnot silloin, kun saaja ei ole työsuhteessa antajaan eikä suoritus ole työkorvausta. Tällaisia ovat esimerkiksi työsuhteeseen perustumaton kilpailupalkinto, asiakasyrityksen henkilökuntaan kuuluvalle tai muutoin asiakassuhteen perusteella annettu etu (esimerkiksi matka, lahjakortti tai esine), löytöpalkkio, pankin maksama niin sanottu tarkkaavaisuuspalkkio, taidekilpailun palkinto sekä kunnan asukkailleen maksama matkakorvaus.`,
    descriptionSv: "Med inkomstslaget anmäls den totala summan av övriga skattepliktiga förvärvsinkomster. Med inkomstslaget anmäls extraordinära arvoden och belöningar när mottagaren inte står i anställningsförhållande till betalaren och prestationen inte är arbetsersättning. Exempel på sådana är förmån till anställd i ett kundföretag (t.ex. resa, presentkort eller föremål), hittelön, s.k. alerthetsbelöning av en bank, pris i konsttävling och ett tävlingspris på över 100 euro som inte grundar sig på ett anställningsförhållande.",
    taxAndSideCostsDescrEn: "Other taxable income deemed as earned income is subject to withholding but not to social insurance contributions. From the perspective of reporting, it does not matter whether or not tax could be withheld from the income. Taxes need not be withheld from competition prizes if they cannot be deemed to be wages, nonwage compensation for work or compensation for use referred to in the tax prepayment act (ennakkoperintälaki 1118/1996) or athlete's fee.",
    taxAndSideCostsDescrFi: "Muu veronalainen ansiotulo on ennakonpidätyksen alainen, mutta siitä ei makseta sosiaalivakuutusmaksuja. Merkitystä ilmoittamisen kannalta ei ole sillä, onko tulosta voitu toimittaa ennakonpidätys vai ei.",
    taxAndSideCostsDescrSv: "Övrig skattepliktig förvärvsinkomst är förskottsinnehållningspliktig, men inga socialförsäkringsavgifter betalas för den. Det saknar betydelse med tanke på anmälan om förskottsinnehållning har verkställts på inkomsten.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 317,
    nameEn: "Other fringe benefit",
    nameFi: "Muu  luontoisetu",
    nameSv: "Övriga naturaförmåner",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "otherFringeBenefit",
    notSupportedError: null,
    descriptionEn: `This income type is used to report non-monetary\r
taxable benefits granted by the employer, such\r
as the total amount of accommodation, telephone and meal benefits, unless these benefits\r
have not been itemised in their own income\r
types using complementary income types. Other\r
benefits reported using this income type include\r
garage, motorcycle and boat benefit, life and\r
pension insurance premiums deemed as pay,\r
benefit from a non-personalised gift voucher,\r
and fringe benefits received by a person working as a seafarer.\r
If compensation for the benefit is collected from\r
the income earner, the value of the fringe benefit is reported in full using this income type before the collected compensation is deducted.\r
This means that the amount of a fringe benefit\r
must be reported in full, even when the employee has paid or the employer otherwise collected a reimbursement for the fringe benefit\r
equalling the monetary value of the fringe benefit, with no taxable benefit remaining. The reimbursement collected for a fringe benefit reduces\r
the amount of taxable income and the amount of\r
earnings from work on which the social insurance contributions are based.\r
Fringe benefits included in the paid amount\r
must be reported in connection with the Other\r
fringe benefit income type. Select from the following alternatives: accommodation benefit, telephone benefit, meal benefit, other benefits.\r
A meal benefit must be reported with its own income type if the employer collects a reimbursement for the meal benefit from the employee\r
matching its taxable value. In such a case, the meal benefit is not reported using the Other\r
fringe benefit income type.\r
The taxable share of an employer-subsidised\r
commuter ticket must be reported using its own\r
income type, and it cannotbe reported together\r
with other fringe benefits under the Other fringe\r
benefit income type. Correspondingly, a car\r
benefit, bicycle benefit and interest benefit for a\r
housing loan must be reported separately using\r
their own income types.\r
If an accommodation benefit, a telephone benefit or a meal benefit is reported separately using\r
their own income types, such benefits are not\r
added to the income reported using the Other\r
fringe benefit income type.\r
If the taxable value has not been separately\r
confirmed in a decision issued by the Tax Administration, the value of the fringe benefit is its\r
fair value. The benefit must be reported, even if\r
the employee is not paid monetary wages at all,\r
or the monetary wages are not sufficient for the\r
payment of withholding tax in full.`,
    descriptionFi: `Tulolajilla ilmoitetaan työnantajan muuna kuin rahana antamat verotettavat edut, esimeriksi autotalli-, moottoripyörä- ja vene-etu, palkaksi katsotut henki- ja eläkevakuutusmaksut, yksilöimättömästä lahjakortista syntyvä etu ja merimiespalveluksessa olevan henkilön merimiehenä saama luontoisetu.\r
\r
Palkkaus.fi-palvelussa asunto-, auto-, puhelin- ja ravintoetu sekä työsuhdematkalipun erät tulee aina ilmoittaa omalla tulolajillaan. Niitä ei lisätä 'Muu luontoisetu' kohtaan.\r
\r
Jos tulonsaajalta peritään korvaus edusta, luontoisedun arvo ilmoitetaan täysimääräisenä tulolajilla ennen perityn korvauksen vähentämistä.\r
\r
Jos verotusarvoa ei ole erikseen vahvistettu Verohallinnon antamassa päätöksessä, luontoisedun arvo on sen käypä arvo. Etu on ilmoitettava, vaikka työntekijälle ei maksettaisi lainkaan rahapalkkaa tai rahapalkka ei riittäisi ennakonpidätyksen täysimääräiseen toimittamiseen.`,
    descriptionSv: "Med inkomstslaget anmäls skattepliktiga förmåner som arbetsgivaren beviljat i annan form än pengar, t.ex. totalt belopp av bostads-, telefon- och kostförmåner, såvida dessa inte har specificerats som separata inkomstslag med hjälp av kompletterande inkomstslag. Övriga förmåner som anmäls för inkomstslaget är t.ex. garage- och båtförmån, liv- och pensionsförsäkringspremier som betraktas som lön, förmåner baserade på ospecificerade presentkort, naturaförmåner till sjömän i sjömanstjänst. Om man av inkomsttagaren tar ut ersättning för en förmån anmäls naturaförmånens värde till fullt belopp med inkomstslaget innan den debiterade ersättningen avdras. Beloppet av naturaförmånen ska anmälas till sitt fulla belopp även om arbetstagaren har betalat eller arbetsgivaren har tagit ut en ersättning för naturaförmånen som motsvarar naturaförmånens penningvärde, och ingen beskattningsbar förmån återstår. Ersättning för naturaförmånen sänker beloppet på arbetsinkomsten som ligger till grund för socialförsäkringsavgifter och beskattningsbara inkomsten.",
    taxAndSideCostsDescrEn: `Fringe benefits are subject to withholding and to\r
social insurance contributions. If tax could not\r
be withheld from the benefit due to the small\r
amount of monetary wages, withholding is not\r
reported if the payer has not actually withheld\r
the tax.\r
If, exceptionally, the fringe benefit is not subject\r
to the above-mentioned contributions, the payer\r
reports the insurance details using the separate\r
Type of insurance information data group.This\r
situation occurs, for example, when the employer has paid an employee's pension or unemployment insurance contributions on the employee's behalf, in which case a fringe benefit is\r
established for the income earner with regard to\r
the contributions paid by the employer. However, the income is not deemed income from\r
work on which the pension and unemployment\r
insurance contributions are based. Even then,\r
the benefit is subject to a health insurance contribution. See further information about the use\r
of insurance information: Reporting data to the\r
Incomes Register: insurance-related information\r
If the employer has paid the employee contributions on behalf of the employee, and the income`,
    taxAndSideCostsDescrFi: `Luontoisedut ovat ennakonpidätyksen alaisia ja niistä maksetaan sosiaalivakuutusmaksut. Jos edusta ei ole voitu toimittaa ennakonpidätystä rahapalkan vähyyden vuoksi, ennakonpidätystä ei ilmoiteta, jos maksaja ei ole todella perinyt veroa.\r
\r
Jos luontoisetu ei poikkeuksellisesti olisikaan edellä mainittujen maksujen alainen, suorituksen maksaja ilmoittaa vakuuttamistiedon erillistä Vakuuttamistiedon tyyppi -tietoryhmää. Tällainen tilanne on esimerkiksi silloin, kun työnantaja on maksanut työntekijän puolesta tämän eläke- tai työttömyysvakuutusmaksut, jolloin tulonsaajalle muodostuu luontoisetu työantajan maksamien maksujen osalta. Tuloa ei kuitenkaan pidetä eläke- eikä työttömyysvakuutusmaksun perusteena olevana työtulona. Etu on tällöinkin sairausvakuutusmaksun alainen.`,
    taxAndSideCostsDescrSv: "Naturaförmåner är förskottsinnehållningspliktiga, och socialförsäkringsavgifter betalas för dem. Om förskottsinnehållning inte har kunnat verkställas på förmånen på grund av att penninglönen är för liten anmäls förskottsinnehållningen inte om betalaren de facto inte har debiterat skatt. Om naturaförmånen undantagsvis inte är underställd ovan nämnda avgifter, anmäler betalaren försäkringsuppgiften med hjälp av den separata uppgiftsgruppen Försäkringsuppgiftens typ. En sådan situation uppstår om t.ex. arbetsgivaren för arbetstagarens räkning har betalat dennes pensions- eller arbetslöshetsförsäkringsavgifter, varvid en naturaförmån uppstår för de avgifter som arbetsgivaren betalat. Inkomsten betraktas dock inte som arbetsinkomst som utgör grund för pensions- eller arbetslöshetsförsäkringsavgiften. Även då är förmånen underställd sjukförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/benefits"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 319,
    nameEn: "Kinship carer's fee",
    nameFi: "Omaishoitajan palkkio",
    nameSv: "Arvode för närståendevårdare",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "kinshipCarersFee",
    notSupportedError: "Not supported for companies / associations",
    descriptionEn: `Fee paid by the municipality to a kinship carer\r
for arranging treatment and care for an elderly,\r
disabled or ill person at home.`,
    descriptionFi: "Vain kunnat käyttävät tätä tulolajia.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 320,
    nameEn: "Stock options and grants",
    nameFi: "Osakepalkkio",
    nameSv: "Aktiepremie",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "stockOptions",
    notSupportedError: null,
    descriptionEn: `Remuneration paid in shares of the employer\r
company or, instead of the agreed remuneration, an amount paid in euros that equals the\r
value of the shares`,
    descriptionFi: "Palkkio, joka annetaan työnantajayrityksen osakkeina tai sovitun palkkion sijaan rahasummana, joka vastaa osakkeiden arvoa.",
    descriptionSv: "Ett arvode som ges i aktier i arbetsgivarföretaget eller i stället för avtalat arvode som ett penningbelopp som motsvarar värdet av aktierna",
    taxAndSideCostsDescrEn: `Tax is withheld from the remuneration, but no\r
social insurance contributions are paid, if the\r
employee has the possibility, based on an incentive system, to receive the employer company's listed shares (or those of another company\r
in the same group, or a company in some other\r
equivalent financial consortium) and the value of\r
the benefit depends on the development of the\r
value of the shares in question over a period of\r
more than one year in length after the remuneration has been promised. Otherwise, the remuneration is income subject to social insurance\r
contributions.\r
This income type is used to report both the\r
amount granted as shares and the amount paid\r
in money. If part of the stock options and grants\r
is paid in money, the share of the stock options\r
and grants that was not paid in money is reported as a separate amount, with the additional\r
information Payment other than money – Yes.\r
By default, this income type is subject to the\r
pension insurance contribution but not to other\r
social insurance contributions.\r
If the remuneration in stock is subject to social\r
insurance contributions or not subject to the\r
pension insurance contribution, the payer reports the insurance information using the separate Type of insurance information data group.`,
    taxAndSideCostsDescrFi: `Osakepalkkiosta toimitetaan ennakonpidätys, mutta ei makseta sosiaalivakuutusmaksuja, jos työntekijällä on kannustinjärjestelmän perusteella mahdollisuus saada työnantajayrityksen (tai sen kanssa samaan konserniin kuuluvan yhtiön tai muuhun vastaavaan taloudelliseen yhteenliittymään kuuluvan yhtiön) arvopaperipörssissä noteerattuja osakkeita ja edun arvo riippuu kyseisten osakkeiden arvon kehityksestä palkkion lupaamisen jälkeisenä, yli vuoden mittaisena aikana. Muussa kuin edellä mainituissa tapauksissa osakepalkkio on sosiaalivakuutusmaksujen alaista tuloa.\r
\r
Oletuksena tulolajissa on, että se on eläkevakuutusmaksun alainen, mutta ei muiden sosiaalivakuutusmaksujen alainen.\r
\r
Jos osakepalkkio on sosiaalivakuutusmaksujen alainen tai ei ole eläkevakuutusmaksun alainen, suorituksen maksaja ilmoittaa vakuuttamistiedon erillistä Vakuuttamistiedon tyyppi- tietoa käyttäen.`,
    taxAndSideCostsDescrSv: "Med inkomstslaget anmäls både beloppet av aktiepremien som ges i aktier samt det belopp som betalats ut i pengar. Om en del av aktiepremien betalas ut i pengar anges den andel av aktiepremien som inte betalats ut i pengar som ett skilt belopp med tilläggsuppgiften Betalats i annan form än pengar – Ja. I inkomstslaget är det förvalt att inkomsten är underställd pensionsförsäkringsavgift men inte andra socialförsäkringsavgifter. Om aktiearvodet är underställt socialförsäkringsavgifter men inte pensionsförsäkringsavgift, anmäler betalaren försäkringsuppgiften separat med hjälp av uppgiften Typ av försäkringsuppgift.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 321,
    nameEn: "Wages paid by substitute payer: the employer pays for the employer's social insurance contributions (earnings-related pension, health, unemployment, and accident and occupational disease insurance)",
    nameFi: "Sijaismaksajan maksama palkka, josta työnantaja maksaa työnantajan sosiaalivakuutusmaksut (työeläke-, sairaus-, työttömyys- sekä työtapaturma- ja ammattitautivakuutus)",
    nameSv: "Lön som betalats av ställföreträdande betalare för vilken arbetsgivaren betalar arbetsgivarens socialförsäkringsavgifter (arbetspensions-, sjuk-, arbetslöshets- samt arbetsolycksfalls- och yrkessjukdomsförsäkringsavgift)",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "wagesPaidBySubstitutePayerIncludingSocialInsurance",
    notSupportedError: null,
    descriptionEn: `The actual employer reports the total wages on\r
which social insurance contributions are based,\r
which the substitute payer has paid and for\r
which the substitute payer has withheld tax.\r
For taxation purposes, the income does not\r
count as income for the income earner on the\r
basis of data provided by the actual employer;\r
such data is required income-earner specifically,\r
because the person accrues pension based on\r
it.\r
This income type is also used when the actual\r
employer pays the employer's social insurance\r
contributions, based on wages paid as wage security.\r
Although the substitute payer has paid the\r
wages to the income earner, the actual employer is responsible for paying the employer's social insurance contributions. For this reason,\r
the actual employer must report the wages paid\r
by the substitute payer income earner specifically, using the so-called info income types specifically intended for situations involving a substitute payer.\r
For its part, the substitute payer reports the information to the Incomes Register using other\r
income types and the Substitute payer – Yes\r
entry. Tax on the income is levied from the income earner, based on the information provided\r
by the substitute payer. The contributions collected from the employee are levied and paid\r
based on the wages paid by the substitute\r
payer. As a rule, the substitute payer does not\r
pay the employer's social insurance contributions; the actual employer is responsible for paying them.\r
Parties that can be substitute payers include enforcement agencies, Kela, municipalities, Centres for Economic Development, Transport and\r
the Environment, bankruptcy estates and guarantors.\r
The reporting procedure is described in more\r
detail in the instructions Reporting data to the\r
Incomes Register: payments made by substitute\r
payer.`,
    descriptionFi: `Varsinainen työnantaja ilmoittaa sellaiset sosiaalivakuutusmaksujen perusteena olevat palkat yhteensä, jotka sijaismaksaja on maksanut ja joista sijaismaksaja on toimittanut ennakonpidätyksen.\r
\r
HUOM: Kotitalous ilmoittaa Yksityisen hoidon tuen tällä tulolajilla!\r
\r
Varsinaisen työnantajan antaman tiedon perusteella tuloa ei lueta tulonsaajalle verotuksessa tuloksi, mutta tieto tarvitaan tulonsaajakohtaisesti, koska henkilölle karttuu eläkettä maksetun tulon perusteella.\r
\r
Tulolajia käytetään myös silloin, kun varsinainen työnantaja maksaa palkkaturvana maksettujen palkkojen perusteella työnantajan sosiaalivakuutusmaksut.\r
\r
Vaikka sijaismaksaja on maksanut palkan tulonsaajille, varsinainen työnantaja on vastuussa työnantajan sosiaalivakuutusmaksujen maksamisesta. Tämän vuoksi varsinaisen työnantajan on ilmoitettava sijaismaksajan maksamat palkat tulonsaajakohtaisesti käyttäen erityisesti sijaismaksajatilanteita varten tarkoitettuja niin sanottuja infotulolajeja.\r
\r
Sijaismaksaja ilmoittaa tiedot omalta osaltaan tulorekisteriin käyttäen muita tulolajeja sekä ohjaustietoa ”Sijaismaksaja – Kyllä”. Sijaismaksajan tiedon perusteella tulo verotetaan tulonsaajalla. Työntekijältä perittävät maksut peritään ja maksetaan sijaismaksajan maksaman palkan perusteella. Sijaismaksaja ei pääsääntöisesti kuitenkaan maksa työnantajan sosiaalivakuutusmaksuja, vaan niiden maksamisesta on vastuussa varsinainen työnantaja.\r
\r
Sijaismaksajia voivat olla esimerkiksi ulosottovirastot, Kela, kunnat, Elinkeino-. liikenne- ja ympäristökeskukset, konkurssipesät ja takaajat. Ilmoittamista on kuvattu tarkemmin asiakasohjeessa\r
Tietojen ilmoittaminen tulorekisteriin: sijaismaksajan maksamat suoritukset.`,
    descriptionSv: `Den egentliga arbetsgivaren anmäler det totala beloppet av sådana löner som utgör grund för socialförsäkringsavgifter och som den ställföreträdande betalaren har betalat och verkställt förskottsinnehållning på. Utifrån de uppgifter som den egentliga arbetsgivaren inlämnat räknas inkomsten inte som inkomst för inkomsttagaren i beskattningen, men uppgifterna behövs inkomsttagarspecifikt, eftersom personen intjänar pension på basis av den betalda inkomsten. Inkomstslaget används också när den egentliga arbetsgivaren betalar arbetsgivarens socialförsäkringsavgifter för löner som betalats som lönegaranti. Även om den ställföreträdande betalaren har betalat lönen till inkomsttagarna ansvarar den egentliga arbetsgivaren för betalningen av arbetsgivarens socialförsäkringsavgifter. Därför ska den egentliga arbetsgivaren anmäla de löner som den ställföreträdande betalaren betalat inkomsttagarspecifikt med hjälp av s.k. infoinkomstslag som uttryckligen är avsedda för dessa situationer. Den ställföreträdande betalaren anmäler uppgifterna för sin del med hjälp av övriga inkomstslag och styruppgiften Ställföreträdande betalare – Ja. På basis av den ställföreträdande\r
betalaren beskattas inkomsten inkomsttagaren.\r
Arbetstagarens avgifter debiteras och betalas på\r
basis av den lön som den ställföreträdande\r
betalaren betalat. Den ställföreträdande betalaren\r
betalar i regel dock inte arbetsgivarens\r
socialskyddsavgifter, utan den egentliga\r
arbetsgivaren ansvarar för dem.\r
Ställföreträdande betalare kan vara till exempel\r
utsökningsverk, FPA, kommuner, närings-, trafikoch miljöcentraler, konkursbon och borgensmän.`,
    taxAndSideCostsDescrEn: `This income type is subject to employer's social\r
insurance contributions.`,
    taxAndSideCostsDescrFi: "Tulolaji on työnantajan sosiaalivakuutusmaksujen alainen.",
    taxAndSideCostsDescrSv: "Inkomstslaget är underställt arbetsgivarens socialförsäkringsavgifter",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/substitutePayer"
    ],
    calcGrouping: "otherNoPayment"
  },
  {
    code: 322,
    nameEn: "Wages paid by substitute payer: employer pays for employer's earnings-related pension insurance contribution",
    nameFi: "Sijaismaksajan maksama palkka, josta työnantaja maksaa työnantajan työeläkevakuutusmaksun",
    nameSv: "Lön som ställföreträdande betalare betalat och för vilken arbetsgivaren betalar arbetsgivarens arbetspensionsförsäkringsavgift",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "wagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance",
    notSupportedError: null,
    descriptionEn: `The actual employer reports the total wages on\r
which pension insurance contributions are\r
based and that the substitute payer has paid\r
and for which the substitute payer has withheld\r
tax, but the employer is responsible for the related pension insurance contribution.\r
This income type is also used when the actual\r
employer pays the employer's pension insurance contribution based on wages paid as wage\r
security.\r
Parties that can be substitute payers include enforcement agencies, Kela, municipalities, Centres for Economic Development, Transport and\r
the Environment, bankruptcy estates and guarantors.`,
    descriptionFi: `Varsinainen työnantaja ilmoittaa sellaiset eläkevakuutusmaksujen perusteena olevat palkat yhteensä, jotka sijaismaksaja on maksanut ja joista sijaismaksaja on toimittanut ennakonpidätyksen, mutta joista työnantaja vastaa eläkevakuutusmaksusta. \r
\r
Tulolajia käytetään myös silloin, kun varsinainen työnantaja maksaa palkkaturvana maksettujen palkkojen perusteella työnantajan eläkevakuutusmaksun. Sijaismaksajia voivat olla esimerkiksi ulosottovirastot, Kela, kunnat, Elinkeino-. liikenne- ja ympäristökeskukset, konkurssipesät ja takaajat.`,
    descriptionSv: "Den egentliga arbetsgivaren anmäler det totala beloppet av sådana löner som utgör grund för pensionsförsäkringsavgifter och som den ställföreträdande betalaren har betalat och verkställt förskottsinnehållning på, men arbetsgivaren ansvarar för pensionsförsäkringsavgifterna. Inkomstslaget används också i situationer där den egentliga arbetsgivaren betalar arbetsgivarens pensionsförsäkringsavgift för löner som betalats som lönegaranti. Ställföreträdande betalare kan vara till exempel utsökningsverk, FPA, kommuner, närings-, trafikoch miljöcentraler, konkursbon och borgensmän.",
    taxAndSideCostsDescrEn: "This income type is used only when the paid income has been subject solely to the pension insurance contribution.",
    taxAndSideCostsDescrFi: "Tulolajia käytetään vain silloin, jos maksettu tulo on ollut vain eläkevakuutusmaksun alainen.",
    taxAndSideCostsDescrSv: "Inkomstslaget används bara när inkomsten endast varit underställt pensionsförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/substitutePayer"
    ],
    calcGrouping: "otherNoPayment"
  },
  {
    code: 323,
    nameEn: "Wages paid by substitute payer: employer pays for employer's unemployment insurance contribution",
    nameFi: "Sijaismaksajan maksama palkka, josta työnantaja maksaa työnantajan työttömyysvakuutusmaksun",
    nameSv: "Lön som ställföreträdande betalare betalat och för vilken arbetsgivaren betalar arbetsgivarens arbetslöshetsförsäkringsavgift",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !0,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "wagesPaidBySubstitutePayerIncludingUnemploymentInsurance",
    notSupportedError: null,
    descriptionEn: `The actual employer reports the total wages on\r
which unemployment insurance contributions\r
are based, which the substitute payer has paid\r
and for which the substitute payer has withheld\r
tax, but the employer is responsible for the unemployment insurance contribution.\r
This income type is also used when the actual\r
employer pays the employer's unemployment insurance contribution based on wages paid as\r
wage security.\r
Parties that can be substitute payers include enforcement agencies, Kela, municipalities, Centres for Economic Development, Transport and\r
the Environment, bankruptcy estates and guarantors.`,
    descriptionFi: `Varsinainen työnantaja ilmoittaa sellaiset työttömyysvakuutusmaksujen perusteena olevat palkat yhteensä, jotka sijaismaksaja on maksanut ja joista sijaismaksaja on toimittanut ennakonpidätyksen, mutta joista työnantaja vastaa työttömyysvakuutusmaksusta.\r
\r
Tulolajia käytetään myös silloin, kun varsinainen työnantaja maksaa palkkaturvana maksettujen palkkojen perusteella työnantajan työttömyysvakuutusmaksun.\r
\r
Sijaismaksajia voivat olla esimerkiksi ulosottovirastot, Kela, kunnat, Elinkeino-. liikenne- ja ympäristökeskukset, konkurssipesät ja takaajat.`,
    descriptionSv: `Den egentliga arbetsgivaren anmäler det totala beloppet av sådana löner som utgör grund för arbetslöshetsförsäkringsavgifter och som den ställföreträdande betalaren har betalat och\r
verkställt förskottsinnehållning på, men\r
arbetsgivaren ansvarar för\r
arbetslöshetsförsäkringsavgifterna.\r
Inkomstslaget används också i situationer där den\r
egentliga arbetsgivaren betalar arbetsgivarens\r
arbetslöshetsförsäkringsavgifter för löner som\r
betalats som lönegaranti.\r
Ställföreträdande betalare kan vara till exempel\r
utsökningsverk, FPA, kommuner, närings-, trafikoch miljöcentraler, konkursbon och borgensmän`,
    taxAndSideCostsDescrEn: "This income type is used only when the paid income has been subject solely to the unemployment insurance contribution.",
    taxAndSideCostsDescrFi: "Tulolajia käytetään vain silloin, jos maksettu tulo on ollut vain työttömyysvakuutusmaksun alainen.",
    taxAndSideCostsDescrSv: "Inkomstslaget används bara när inkomsten endast varit underställt arbetslöshetsförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/substitutePayer"
    ],
    calcGrouping: "otherNoPayment"
  },
  {
    code: 324,
    nameEn: "Wages paid by substitute payer, employer pays for accident and occupational disease insurance contribution",
    nameFi: "Sijaismaksajan maksama palkka, josta työnantaja maksaa työtapaturma- ja ammattitautivakuutusmaksun",
    nameSv: "Lön som ställföreträdande betalare betalat och för vilken arbetsgivaren betalar arbetsolycksfalls- och yrkessjukdomsförsäkringsavgiften",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !0,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "wagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance",
    notSupportedError: null,
    descriptionEn: `The actual employer reports the total wages on\r
which accident and occupational disease insurance contributions are based, which the substitute payer has paid and for which the substitute\r
payer has withheld tax, but the employer is responsible for the accident and occupational disease insurance contribution.\r
This income type is also used when the actual employer pays the accident and occupational\r
disease insurance contribution based on wages\r
paid as wage security.\r
Parties that can be substitute payers include enforcement agencies, Kela, municipalities, Centres for Economic Development, Transport and\r
the Environment, bankruptcy estates and guarantors.`,
    descriptionFi: `Varsinainen työnantaja ilmoittaa sellaiset työtapaturma- ja ammattitautivakuutusmaksujen perusteena olevat palkat yhteensä, jotka sijaismaksaja on maksanut ja joista sijaismaksaja on toimittanut ennakonpidätyksen, mutta joista työnantaja vastaa työtapaturma- ja ammattitautivakuutusmaksusta.\r
\r
Tulolajia käytetään myös silloin, kun varsinainen työnantaja maksaa palkkaturvana maksettujen palkkojen perusteella työtapaturma- ja ammattitautivakuutusmaksun.\r
\r
Sijaismaksajia voivat olla esimerkiksi ulosottovirastot, Kela, kunnat, Elinkeino-. liikenne- ja ympäristökeskukset, konkurssipesät ja takaajat.`,
    descriptionSv: "Den egentliga arbetsgivaren anmäler det totala beloppet av sådana löner som utgör grund för arbetsolycksfalls- och yrkessjukdomsförsäkringsavgifter och som den ställföreträdande betalaren har betalat och verkställt förskottsinnehållning på, men arbetsgivaren ansvarar för arbetsolycksfalls- och yrkessjukdomsförsäkringsavgifterna. Inkomstslaget används också när den egentliga arbetsgivaren betalar arbetsgivarens arbetsolycksfalls- och yrkessjukdomsförsäkringsavgifter för löner som betalats som lönegaranti. Ställföreträdande betalare kan vara till exempel utsökningsverk, FPA, kommuner, närings-, trafikoch miljöcentraler, konkursbon och borgensmän.",
    taxAndSideCostsDescrEn: `This income type is used only when the paid income has been subject solely to the accident\r
and occupational disease insurance contribution.`,
    taxAndSideCostsDescrFi: "Tulolajia käytetään vain silloin, jos maksettu tulo on ollut vain työtapaturma- ja ammattitautivakuutusmaksun alainen.",
    taxAndSideCostsDescrSv: "Inkomstslaget används bara när inkomsten endast varit underställt arbetsolycksfalls- och yrkessjukdomsförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/substitutePayer"
    ],
    calcGrouping: "otherNoPayment"
  },
  {
    code: 325,
    nameEn: "Wages paid by substitute payer, employer pays for employer's health insurance contribution",
    nameFi: "Sijaismaksajan maksama palkka, josta työnantaja maksaa työnantajan sairausvakuutusmaksun",
    nameSv: "Lön som ställföreträdande betalare betalat och för vilken arbetsgivaren betalar arbetsgivarens sjukförsäkringsavgift",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "wagesPaidBySubstitutePayerIncludingHealthInsurance",
    notSupportedError: null,
    descriptionEn: `The actual employer reports the total wages on\r
which health insurance contributions are based\r
and that the substitute payer has paid and for\r
which the substitute payer has withheld tax, but\r
the employer is responsible for the employer's\r
health insurance contribution.\r
This income type is also used when the actual\r
employer pays the employer's health insurance\r
contribution based on wages paid as wage security.\r
Parties that can be substitute payers include enforcement agencies, Kela, municipalities, Centres for Economic Development, Transport and\r
the Environment, bankruptcy estates and guarantors.`,
    descriptionFi: `Varsinainen työnantaja ilmoittaa sellaiset sairausvakuutusmaksujen perusteena olevat palkat yhteensä, jotka sijaismaksaja on maksanut ja joista sijaismaksaja on toimittanut ennakonpidätyksen, mutta joista työnantaja vastaa työnantajan sairausvakuutusmaksusta.\r
\r
Tulolajia käytetään myös silloin, kun varsinainen työnantaja maksaa palkkaturvana maksettujen palkkojen perusteella työnantajan sairausvakuutusmaksun.\r
\r
Sijaismaksajia voivat olla esimerkiksi ulosottovirastot, Kela, kunnat, Elinkeino-. liikenne- ja ympäristökeskukset, konkurssipesät ja takaajat.`,
    descriptionSv: "Den egentliga arbetsgivaren anmäler det totala beloppet av sådana löner som utgör grund för sjukförsäkringsavgifter och som den ställföreträdande betalaren har betalat och verkställt förskottsinnehållning på, men arbetsgivaren ansvarar för arbetsgivarens sjukförsäkringsavgifter. Inkomstslaget används också i situationer där den egentliga arbetsgivaren betalar arbetsgivarens sjukförsäkringsavgift för löner som betalats som lönegaranti. Ställföreträdande betalare kan vara till exempel utsökningsverk, FPA, kommuner, närings-, trafikoch miljöcentraler, konkursbon och borgensmän.",
    taxAndSideCostsDescrEn: "This income type is used only when the paid income has been subject solely to the health insurance contribution.",
    taxAndSideCostsDescrFi: "Tulolajia käytetään vain silloin, jos maksettu tulo on ollut vain sairausvakuutusmaksun alainen.",
    taxAndSideCostsDescrSv: "Inkomstslaget används bara när inkomsten endast varit underställt sjukförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/substitutePayer"
    ],
    calcGrouping: "otherNoPayment"
  },
  {
    code: 326,
    nameEn: "Compensation for employee invention",
    nameFi: "Palkkio työsuhdekeksinnöstä",
    nameSv: "Arvode för arbetstagares uppfinning",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "compensationForEmployeeInvention",
    notSupportedError: null,
    descriptionEn: "Compensation paid for an employee invention.",
    descriptionFi: "Palkkio, joka maksetaan työsuhdekeksinnöstä.",
    descriptionSv: "Ett arvode som betalas för arbetstagares uppfinning",
    taxAndSideCostsDescrEn: `If the duties of the employee who receives the\r
fee do not include inventions, compensation for\r
the employee invention is handled as compensation for use, i.e., no social insurance contributions are paid from the compensation. In such a situation, tax is withheld from the compensation\r
for the employee invention, unless the recipient\r
of the compensation is registered in the prepayment register.\r
If the income earner's duties agreed in the employment contract include inventions, the compensation is treated as wages, i.e., in addition to\r
tax being withheld, in addition to which social insurance contributions are paid from the compensation.\r
By default, this income type is not subject to social insurance contributions.\r
If compensation for an employee invention is\r
subject to a social insurance contribution, the\r
payer must use the separate Type of insurance\r
information entry to report that the income is\r
subject to the specified insurance contribution.`,
    taxAndSideCostsDescrFi: `Jos palkkion saajan työsuhteeseen kuuluviin tehtäviin ei kuulu keksiminen, palkkiota työsuhdekeksinnöstä käsitellään käyttökorvauksena eli palkkiosta ei makseta sosiaalivakuutusmaksuja. Tällöin työsuhdekeksinnöstä maksettavasta palkkiosta toimitetaan ennakonpidätys, ellei palkkion saaja kuulu ennakkoperintärekisteriin.\r
\r
Jos tulonsaajan työsopimuksessa sovittuihin työtehtäviin kuuluu keksiminen, palkkiota käsitellään palkkana, eli palkkiosta maksetaan ennakonpidätyksen toimittamisen lisäksi sosiaalivakuutusmaksut.\r
\r
Oletuksena tulolajissa on, että se ei ole sosiaalivakuutusmaksujen alainen. \r
\r
Jos palkkio työsuhdekeksinnöstä on jonkun sosiaalivakuutusmaksun alainen, suorituksen maksaja ilmoittaa erillistä Vakuuttamistiedon tyyppi- tietoa käyttäen, että tulo on ilmoitetun vakuutusmaksun alainen.`,
    taxAndSideCostsDescrSv: "Om uppgifterna i ersättningsmottagarens anställningsförhållande inte omfattar uppfinning, behandlas ersättningen för arbetstagares uppfinning som bruksersättning, dvs. socialförsäkringsavgifter betalas inte på ersättningen. På ersättningen för arbetstagares uppfinning verkställs förskottsinnehållning, om inte mottagaren av belöningen är införd i förskottsuppbördsregistret. Om uppfinning ingår i de arbetsuppgifter som avtalats i inkomsttagarens arbetsavtal, behandlas ersättningen som lön, dvs. utöver att förskottsinnehållning verkställs, betalas också socialförsäkringsavgifter på belöningen. I inkomstslaget är det förvalt att inkomsten inte är underställd socialförsäkringsavgifter. Om arvodet för en uppfinning i anställningsförhållande är underställt någon socialförsäkringsavgift, anmäler betalaren med hjälp av den separata uppgiften Typ av försäkringsuppgift att inkomsten är underställd den angivna försäkringsavgiften.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 327,
    nameEn: "Reimbursement of private caretaker's expenses",
    nameFi: "Perhehoitajan kustannusten korvaus",
    nameSv: "Kostnadsersättning för familjevårdare",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "reimbursementOfPrivateCaretakersExpenses",
    notSupportedError: "Not supported for companies / associations",
    descriptionEn: "",
    descriptionFi: "Vain kunnat käyttävät tätä tulolajia.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 328,
    nameEn: "Private caretaker's fee",
    nameFi: "Perhehoitajan palkkio",
    nameSv: "Arvode för familjevårdare",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "privateCaretakersFee",
    notSupportedError: "Not supported for companies / associations",
    descriptionEn: "",
    descriptionFi: "Vain kunnat käyttävät tätä tulolajia.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 329,
    nameEn: "Reimbursement of family day care provider's expenses",
    nameFi: "Perhepäivähoitajan kustannusten korvaus",
    nameSv: "Kostnadsersättning för familjedagvårdare",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "reimbursementOfFamilyDayCareProvidersExpenses",
    notSupportedError: "Not supported for companies / associations",
    descriptionEn: "",
    descriptionFi: "Vain kunnat käyttävät tätä tulolajia.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 330,
    nameEn: "Telephone benefit",
    nameFi: "Puhelinetu",
    nameSv: "Telefonförmån",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "telephoneBenefit",
    notSupportedError: null,
    descriptionEn: `A fringe benefit, established by the employer's\r
payment of the employer's telephone subscription expenses incurred during private use outside working hours.\r
A telephone benefit can be reported separately, but\r
the received benefit must at least be reported as a\r
total sum, using the Other fringe benefit income\r
type. In such a case, the Type of benefit additional\r
data related to the Other fringe benefit income type\r
must be used to report that the income reported\r
using the Other fringe benefit includes a telephone\r
benefit.\r
If the telephone benefit is reported separately, it\r
should not be added to the income reported using\r
the Other fringe benefit income type.\r
The amount of the telephone benefit must be reported in full, even when the employee has paid a\r
reimbursement for the benefit to the employer equalling the monetary value of the telephone benefit, with no taxable benefit remaining.`,
    descriptionFi: `Luontoisetu, joka syntyy, kun työnantaja maksaa työntekijän puhelinliittymän kulut vapaa-ajalla tapahtuvan yksityiskäytön osalta.\r
\r
Palkkaus.fi-palvelussa puhelinetu ilmoitetaan aina tällä tulolajilla, ei koskaan 'Muu luotoisetu'-tulolajilla.`,
    descriptionSv: "Naturaförmån som uppkommer när arbetsgivaren betalar kostnaderna för arbetstagarens telefonabonnemang för privat bruk under fritiden. Telefonförmån kan anmälas separat, men den beviljade förmånen ska åtminstone anges som total summa med inkomstslaget Övriga naturaförmåner. Då ska man dessutom med hjälp tilläggsuppgiften Typ av förmån relaterad till inkomstslaget Övriga naturaförmåner anmäla att inkomsten som anmälts med inkomstslaget Övriga naturaförmåner innehåller telefonförmån. Om telefonförmånen anmäls separat läggs den inte till inkomster som anmäls med inkomstslaget Övriga naturaförmåner. Beloppet av telefonförmånen ska anmälas till sitt fulla belopp även om arbetstagaren har betalat en ersättning till arbetsgivaren som motsvarar telefonförmånens penningvärde, och ingen beskattningsbar förmån återstår.",
    taxAndSideCostsDescrEn: "Tax is withheld and social insurance contributions paid from the telephone benefit.",
    taxAndSideCostsDescrFi: "Puhelinedusta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på telefonförmån och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/benefits"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 331,
    nameEn: "Daily allowance",
    nameFi: "Päiväraha",
    nameSv: "Dagtraktamente ",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "dailyAllowance",
    notSupportedError: null,
    descriptionEn: `A daily allowance is a tax-exempt reimbursement of a reasonable increase in meal and other\r
living costs incurred by the recipient due to a\r
business trip.\r
Enter the total amount of tax-exempt daily allowances and meal allowances here.Income reported using the Daily allowance income type\r
can be\r
• meal allowance,\r
• domestic full daily allowance,\r
• domestic partial daily allowance,\r
• international daily allowance, or\r
• tax-exempt reimbursements of expenses\r
related to work abroad.\r
If reimbursements of expenses related to work\r
abroad have been entered as the type of the\r
daily allowance, enter the following tax-exempt\r
benefits received by the income earner related\r
to work abroad in this section:\r
• the moving and travel costs of the taxpayer and their family member to the\r
country of work and back;\r
• regular private household staff abroad,\r
paid for by the employer; and\r
• primary and secondary education for\r
children, paid for by the employer.\r
This income type is not used to report night\r
travel allowance or border-crossing allowance.\r
These items are not reported to the Incomes\r
Register.\r
Enter only the total amount of tax-exempt daily\r
allowances and meal allowances here. Each\r
year, the Tax Administration will confirm the taxexempt amounts in the decision it issues on taxexempt reimbursements of travel expenses.\r
Meal allowances are entered here only if their\r
own, separate Meal allowance income type was\r
not used for their reporting. If the daily allowances or other allowances mentioned here have been paid on more lenient\r
grounds than the decision by the Tax Administration, the compensation is reported using the\r
Total wages or Other compensation income\r
type, in which case it is also subject to social insurance contributions.\r
If compensation paid on more lenient grounds\r
has been agreed in a collective agreement, it is\r
not subject to pension, unemployment or accident and occupational disease insurance contributions. In such cases, the payer reports the income using the Total wages income type or\r
Other compensation, while also reporting what\r
part of the payment is subject to earnings-related pension, unemployment, accident, and occupational disease insurance contributions.\r
Additional information on the different daily allowances the total amount includes must be provided in connection with the income type.`,
    descriptionFi: `Päiväraha on verovapaa kustannusten korvaus kohtuullisesta ruokailu- ja muiden elantokustannusten lisäyksestä, joka korvauksen saajalle aiheutuu työmatkasta.\r
\r
Kohtaan merkitään verovapaiden päivärahojen ja ateriakorvausten yhteismäärä. Päiväraha-tulolajilla ilmoitettu tulo voi olla:\r
\r
- kotimaan kokopäiväraha,\r
- kotimaan osapäiväraha,\r
- ulkomaan päiväraha tai \r
- ulkomaan työskentelyyn liittyvät verovapaat kustannusten korvaukset.\r
\r
Palkkaus.fi-palvelussa Ateriakorvaukset ilmoitetaan aina erillisellä Ateriakorvaus-tulolajia.\r
\r
Jos päivärahan tyypiksi on merkitty ulkomaan työskentelyyn liittyvät kustannusten korvaukset, kohtaan merkitään seuraavat tulonsaajan saamat verovapaat edut, jotka liittyvät ulkomaan työskentelyyn:\r
\r
- verovelvollisen ja hänen perheenjäsenensä muutto- ja matkakustannukset työntekovaltioon ja takaisin\r
- työnantajan ulkomailla kustantama tavanomainen yksityinen palveluhenkilöstö\r
- työnantajan kustantama lasten perus- ja lukiotason koulutus.\r
\r
Tulolajilla ei ilmoiteta yömatkarahaa eikä rajanylitysrahaa. Näitä eriä ei ilmoiteta tulorekisteriin.\r
\r
Kohtaan merkitään vain verovapaiden päivärahojen ja ateriakorvausten yhteismäärä. Verohallinto vahvistaa vuosittain verovapaat määrät antamallaan päätöksellä verovapaista matkakustannusten korvauksista.\r
\r
Jos päivärahat tai muut kohdassa mainitut korvaukset on maksettu Verohallinnon päätöstä lievemmin perustein, korvaukset ilmoitetaan tulolajilla Palkka yhteissumma tai Muu maksettu lisä, jolloin ne ovat myös sosiaalivakuutusmaksujen alaisia.\r
\r
Jos lievemmin perustein maksetuista korvauksista on sovittu työehtosopimuksella, korvaus ei ole eläke-, työttömyys- eikä työtapaturma- ja ammattitautivakuutusmaksun alainen. Näissä tilanteissa suorituksen\r
maksaja ilmoittaa tulon Palkka yhteissumma-tulolajilla tai Muu henkilöstölle suunnattu veronalainen etu, ja samalla ilmoittaa, mikä osuus suorituksesta on eläkevakuutusmaksun, työttömyysvakuutusmaksun sekä työtapaturma- ja ammattitautivakuutusmaksun alainen.\r
\r
Tulolajin yhteydessä on annettava lisätiedot, mitä eri päivärahoja yhteissumma sisältää.`,
    descriptionSv: `Dagtraktamente är en skattefri kostnadsersättning för skäliga måltids- och andra levnadskostnader som förorsakas ersättningsmottagaren för arbetsresa. I punkten anges det totala beloppet av skattefria dagtraktamenten och måltidsersättningar. Dagtraktamente kan vara • måltidsersättning, • inrikes heldagstraktamente, • inrikes partiellt dagtraktamente, • utlandsdagtraktamente eller • skattefria ersättningar relaterade till arbete i utlandet. Om man valt som typ av dagtraktamente kostnadsersättningar relaterade till utlandsarbete, anges i punkten anges också följande skattefria förmåner relaterade till arbete i utlandet: • den skattskyldiges och familjemedlemmarnas flytt- och resekostnader till arbetsstaten och tillbaka  sedvanlig privat servicepersonal som\r
arbetsgivaren bekostar utomlands\r
• utbildning av barn på grundskole- och\r
gymnasienivå som arbetsgivaren\r
bekostar.\r
Med inkomstslaget anmäls inte nattresepenning\r
eller gränsöverskridningspenning. Dessa poster\r
anmäls inte till inkomstregistret.\r
I punkten anges endast det totala beloppet av\r
skattefria dagtraktamenten och måltidsersättningar.\r
Skatteförvaltningen fastställer årligen de skattefria\r
beloppen genom ett beslut om ersättning för\r
skattefria resekostnader.\r
Måltidsersättningar anges i punkten endast om de\r
inte anmälts separat med inkomstslaget\r
Måltidsersättningar.\r
Om dagtraktamenten eller andra ersättningar som\r
nämns i punkten har betalats på lindrigare grunder\r
än enligt Skatteförvaltningens beslut ska de\r
anmälas med inkomstslagen Lön totalt eller Annat\r
betalt tillägg, varvid de också är underställda\r
socialförsäkringsavgifter.\r
Om bestämmelser på lindrigare grunder finns i\r
kollektivavtal är ersättningen inte underställd\r
pensionsförsäkringsavgifter,\r
arbetslöshetsförsäkringspremier eller\r
försäkringspremie för arbetsolycksfalls- och\r
yrkessjukdomsförsäkring. I dessa situationer\r
anmäler betalaren inkomsten med inkomstslaget\r
Lön totalt eller Annan betald tillägg, och anmäler\r
samtidigt vilken andel av betalningen som är\r
underställd pensionsförsäkringsavgiften,\r
arbetslöshetsförsäkringspremien samt\r
försäkringspremien för arbetsolycksfalls- och\r
yrkessjukdomsförsäkring.\r
I samband med inkomstslaget ska man ange\r
tilläggsuppgifter om vilka olika dagtraktamenten\r
den totala summan innehåller`,
    taxAndSideCostsDescrEn: "Daily allowances are not subject to social insurance contributions.",
    taxAndSideCostsDescrFi: "Päivärahat eivät ole sosiaalivakuutusmaksun alaisia.",
    taxAndSideCostsDescrSv: "Dagtraktamenten är inte underställda socialförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/travelExpenses"
    ],
    calcGrouping: "expenses"
  },
  {
    code: 332,
    nameEn: "Capital income payment",
    nameFi: "Pääomatuloa oleva suoritus",
    nameSv: "Prestation i form av kapitalinkomst",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "capitalIncomePayment",
    notSupportedError: null,
    descriptionEn: `A payment that is capital income for its recipient.\r
For example, interest paid to an employer or a\r
shareholder, such as interest on late payment of\r
wages receivable or a guarantee commission\r
that is capital income.`,
    descriptionFi: "Suoritus, joka on saajalleen pääomatuloa. Tällainen on esimerkiksi työntekijälle tai osakkaalle maksettu korko, kuten palkkasaatavan korko tai pääomatuloa oleva takausprovisio.",
    descriptionSv: "En prestation som är kapitalinkomst för mottagaren. T.ex. ränta på lönefordran eller garantiprovision",
    taxAndSideCostsDescrEn: `Payments are subject to withholding but not to\r
social insurance contributions. Late-payment interest has been exempted from withholding by\r
the Finnish Tax Administration's decision\r
VH/2593/00.01.00/2019).`,
    taxAndSideCostsDescrFi: `Suoritukset ovat ennakonpidätyksen alaisia, mutta eivät sosiaalivakuutusmaksun alaisia. \r
Viivästyskorko on vapautettu Verohallinnon päätöksellä (A136/200/2016) ennakonpidätyksen toimittamisesta.`,
    taxAndSideCostsDescrSv: `Prestationerna är underställda förskottsinnehållning men inte socialförsäkringsavgifter. Dröjsmålsränta\r
har befriats från förskottsinnehållning genom\r
Skatteförvaltningens beslut\r
(VH/2593/00.01.00/2019)`,
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 334,
    nameEn: "Meal benefit",
    nameFi: "Ravintoetu",
    nameSv: "Kostförmån",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "mealBenefit",
    notSupportedError: null,
    descriptionEn: `A fringe benefit established when an employer\r
offers meals to its employee. An employer can\r
subsidise meal costs with a meal ticket or other,\r
similar targeted means of payment, or by arranging catering.\r
The taxable value of a meal benefit is determined as an annually confirmed value in accordance with the decision by the Tax Administration.\r
A meal benefit can be reported separately, but the\r
received benefit must be reported as at least a total\r
sum using the Other fringe benefit income type. In\r
such a case, the Type of benefit additional data related to the Other fringe benefit income type must be used to report that the income reported using\r
the Other fringe benefit includes a meal benefit.\r
If the meal benefit is reported separately, it should\r
not be added to the income reported using the\r
Other fringe benefit income type.\r
If the employer collects a reimbursement corresponding to the taxable value of the meal benefit\r
from the employee, the employer must report the\r
following information to the Incomes Register: Reimbursement for a meal benefit corresponds to taxable value: Yes. In this case, the payer does not\r
need to report the amount of the meal benefit or, if\r
they wish, they can report the taxable value of the\r
meal benefit as the amount. However, the recommendation is that the data item Amount is not reported if a reimbursement equalling the benefit's\r
taxable value has been collected for the meal benefit. If a reimbursement equalling the taxable value\r
of the meal benefit is collected from the employee,\r
the Other fringe benefit income type must not be\r
used.`,
    descriptionFi: `Luontoisetu, joka syntyy, kun työnantaja tarjoaa työntekijälleen aterian. Työnantaja voi tukea ruokailukustannuksia ruokailulipukkeella tai muulla kohdennetulla maksuvälineellä taikka järjestämällä työpaikkaruokailun.\r
\r
Ravintoedun verotusarvo määräytyy Verohallinnon päätöksen mukaisena vuosittain vahvistettavana arvona.\r
\r
Palkkaus.fi-palvelussa ravintoetu ilmoitetaan aina tällä tulolajilla, ei koskaan 'Muu luotoisetu'-tulolajilla.\r
\r
Jos työnantaja perii työntekijältä ravintoedusta sen verotusarvoa vastaavan korvauksen, tulorekisteriin ilmoitetaan tieto Ravintoedusta peritty korvaus vastaa verotusarvoa: Kyllä.`,
    descriptionSv: "Naturaförmån som uppkommer när arbetsgivaren erbjuder arbetstagaren en måltid. Arbetsgivaren kan subventionera måltidskostnader med en måltidsbiljett eller andra riktade betalinstrument eller genom att ordna måltider på arbetsplatsen. Beskattningsvärdet på kostförmånen fastställs årligen av Skatteförvaltningen. Kostförmån kan anmälas separat, men den beviljade förmånen ska åtminstone anges som total summa med inkomstslaget Övriga naturaförmåner. Då ska man dessutom med hjälp tilläggsuppgiften Typ av förmån relaterad till inkomstslaget Övriga naturaförmåner anmäla att inkomsten som anmälts med inkomstslaget Övriga naturaförmåner innehåller kostförmån. Om kostförmånen anmäls separat läggs den inte till inkomster som anmäls med inkomstslaget Övriga naturaförmåner. Om arbetsgivaren tar ut en ersättning för kostförmånen som motsvarar beskattningsvärdet, anmäls till inkomstregistret ”Ersättningen för kostförmån motsvarar beskattningsvärdet: Ja. Betalaren kan då låta bli att anmäla beloppet på kostförmånen eller anmäla kostförmånens beskattningsvärde som belopp. Det rekommenderas emellertid att uppgiften Belopp inte anmäls, om en ersättning som motsvarar beskattningsvärdet har tagits ut för kostförmånen. Om arbetsgivaren tar ut en ersättning för kostförmånen som motsvarar beskattningsvärdet kan inkomstslaget Övriga naturaförmåner inte användas.",
    taxAndSideCostsDescrEn: "Tax is withheld and social insurance contributions are paid from a meal benefit.",
    taxAndSideCostsDescrFi: "Ravintoedusta toimitetaan ennakonpidätys ja maksetaan sosiaalivakuutusmaksut.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på kostförmån och socialförsäkringsavgifter betalas.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/benefits"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 335,
    nameEn: "Reimbursement of costs, paid to conciliator",
    nameFi: "Sovittelijan kulukorvaus",
    nameSv: "Kostnadsersättning för medlare",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "reimbursementOfCostsPaidToConciliator",
    notSupportedError: null,
    descriptionEn: `Taxable reimbursement of costs paid to a voluntary conciliator to cover the costs incurred from\r
the conciliation process.\r
Conciliator's reimbursement of costs is taxable\r
earned income that is taken into consideration\r
as an equal-amount deduction in the recipient's\r
taxation, without a separate account being\r
made by the recipient.`,
    descriptionFi: `Veronalainen kustannusten korvaus, joka maksetaan vapaaehtoiselle sovittelijalle sovittelusta aiheutuneista kustannuksista.\r
\r
Sovittelijan kulukorvaus on veronalaista ansiotuloa, joka otetaan huomioon suorituksen saajan verotuksessa saman suuruisena vähennyksenä ilman suorituksen saajan esittämää eri selvitystä.`,
    descriptionSv: "Skattepliktig kostnadsersättning som betalas till en frivillig medlare för kostnader som förorsakats av medlingen Kostnadsersättning för medlare är skattepliktig förvärvsinkomst som beaktas i betalningsmottagarens beskattning som ett motsvarande avdrag utan separat utredning av betalningsmottagaren.",
    taxAndSideCostsDescrEn: "No tax is withheld or social insurance contributions are paid from the reimbursement of expenses.",
    taxAndSideCostsDescrFi: "Kulukorvauksista ei toimiteta ennakonpidätystä eikä makseta sosiaalivakuutusmaksuja.",
    taxAndSideCostsDescrSv: "På kostnadsersättningen verkställs inte förskottsinnehållning och betalas inte socialförsäkringsavgifter",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/expenses"
    ],
    calcGrouping: "expenses"
  },
  {
    code: 336,
    nameEn: "Non-wage compensation for work",
    nameFi: "Työkorvaus",
    nameSv: "Arbetsersättning",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "nonWageCompensationForWork",
    notSupportedError: null,
    descriptionEn: `Remuneration paid or agreed to be paid for\r
work performed in a non-employment relationship, from which tax must be withheld if the recipient is not registered in the prepayment register, but from which social insurance contributions are not paid as a rule.\r
Non-wage compensation for work can be paid to\r
recipients regardless of whether or not they are\r
registered in the prepayment register. Non-wage\r
compensation for work is taxable income, and\r
tax is withheld from it if the recipient is not registered in the prepayment register. . Compensation paid to a support person is an example of\r
non-wage compensation for work. Compensation paid to a support family is reported using income type Private caretaker's fee (328). Nonwage compensation for work is commonly called\r
a fee.\r
Non-wage compensation for work must be reported if the income earner is not registered in\r
the prepayment register.\r
Because a report must be submitted always\r
when the income earner is not registered in the\r
prepayment register, the recipient may also be\r
other than a natural person, such as an association, limited liability company, general partnership or limited partnership.\r
A report must also be submitted for the nonwage compensation for work when the payer is\r
covered by the public sector pensions act\r
(julkisten alojen eläkelaki 81/2016), and the income earner is a natural person who is registered in the prepayment register but does not\r
have insurance under the self-employed persons' pensions act (yrittäjän eläkelaki\r
1272/2006). \r
\r
Non-wage compensation for work paid to a\r
company with a limited tax liability must be reported, if the payer has collected tax at source\r
from the company. Non-wage compensation for\r
work paid to a natural person with a limited tax\r
liability must always be reported regardless of\r
whether or not tax at source has been collected.\r
For example, a fee paid to an athlete or artist\r
who is a non-resident taxpayer must always be\r
reported.\r
As a rule, no social insurance contributions are\r
paid from non-wage compensation for work. An\r
employer subject to public sector pension legislation pays earnings-related pension insurance\r
contributions based on a private person's commissioning contract, if the commissioned person\r
is not self-employed, i.e., does not have insurance in accordance with the Self-Employed Persons' Pensions Act. Furthermore, the income\r
earner pays the employee's daily allowance\r
contribution of health insurance from non-wage\r
compensation for work. By default, this income\r
type is not subject to social insurance contributions.\r
If the non-wage compensation for work is subject to any social insurance contribution, the\r
payer must use the separate Type of insurance\r
information entry to report that the income is\r
subject to the specified insurance contribution.\r
See the instructions Reporting data to the Incomes Register: insurance-related data.\r
Reimbursement of expenses related to nonwage compensation for work\r
If the fee or other remuneration has been paid as\r
non-wage compensation for work, the recipient\r
cannot be paid reimbursements of expenses that\r
would be included in tax-exempt expenses.\r
Reimbursements of expenses related to nonwage compensation for work are added to the\r
amount of income as a lump sum with the other\r
remuneration. Reimbursements of expenses\r
paid in connection with non-wage compensation\r
for work are not tax-exempt. If a taxable kilometre allowance is paid to a commissioned person\r
or organisation, the allowance is reported as non-wage compensation for work, and the income type Kilometre allowance (taxable) may\r
not be used.\r
If, in connection with non-wage compensation\r
for work, a payer covered by the public sector\r
pensions act pays reimbursements of expenses\r
to a natural person who does not have an insurance under self-employed persons’ pensions\r
acts, the payer must report the reimbursement\r
of expenses, in addition to the fee, on a separate earnings payment report using income type\r
Non-wage compensation for work if the recipient is not registered in the prepayment register.\r
In this case, the fee reported as non-wage compensation for work and the reimbursements of\r
expenses can be reported on a single report,\r
but the share of the fee must be itemised separately on the report and the income type must\r
include the type of insurance information “Subject to pension insurance contribution: Yes'. The\r
share of reimbursement of expenses does not\r
need to be reported if the recipient is registered\r
in the prepayment register.\r
A recipient of non-wage compensation for work\r
can request that travel expenses be deducted\r
on the pre-completed tax return form. However,\r
business operators must deduct travel expenses\r
in their accounting.`,
    descriptionFi: `Muussa kuin palvelussuhteessa tehdystä työstä maksettava tai maksettavaksi sovittu vastike, josta tulee toimittaa ennakonpidätys, jos saaja ei ole ennakkoperintärekisterissä, mutta josta ei pääsääntöisesti makseta sosiaalivakuutusmaksuja.\r
\r
Työkorvausta voidaan maksaa ennakkoperintärekisteriin kuuluvalle tai kuulumattomalle työn suorittajalle. Työkorvaus on veronalaista ansiotuloa ja siitä toimitetaan ennakonpidätys, jos saaja ei kuulu ennakkoperintärekisteriin. Työkorvausta on esimerkiksi tukiperheelle maksettu korvaus.\r
\r
Työkorvauksesta on annettava ilmoitus, jos tulonsaaja ei kuulu ennakkoperintärekisteriin tai, jos maksajana on julkisten alojen eläkelakien piiriin (JuEL) kuuluva suorituksen maksaja ja tulonsaaja on luonnollinen henkilö, joka kuuluu ennakkoperintärekisteriin, mutta hänellä ei ole yrittäjän eläkelakien mukaista vakuutusta. Koska ilmoitus tehdään aina, kun tulonsaaja ei kuulu ennakkoperintärekisteriin, saajana voi olla myös muu kuin luonnollinen henkilö, kuten yhdistys, osakeyhtiö, avoin yhtiö tai kommandiittiyhtiö. Näitä maksuja ei kuitenkaan voi tehdä Palkkaus.fi-palvelun kautta.\r
\r
Rajoitetusti verovelvolliselle yritykselle maksetut työkorvaukset on ilmoitettava, jos maksaja on perinyt yritykseltä lähdeveron. Rajoitetusti verovelvolliselle luonnolliselle henkilölle maksettu työkorvaus on ilmoitettava aina riippumatta siitä, onko lähdeveroa peritty, esimerkiksi rajoitetusti verovelvollisen urheilijan ja taiteilijan saama palkkio on ilmoitettava.\r
\r
**Työkorvauksiin liittyvät kustannusten korvaukset**\r
\r
Jos palkkio tai muu suorituksen määrä on maksettu työkorvauksena, saajalla ei voi olla verovapaisiin kuluihin merkittäviä kustannusten korvauksia.\r
\r
Työkorvauksiin liittyvät kustannusten korvaukset lisätään tulon määrään yhtenä summana muun palkkion kanssa. Työkorvauksen yhteydessä maksetut kustannusten korvaukset eivät ole verovapaita. Jos veronalainen kilometrikorvaus maksetaan toimeksiantosuhteessa olevalle henkilölle tai yhteisölle, korvaus ilmoitetaan työkorvauksena, eikä tulolajia kilometrikorvaus (veronalainen) saa käyttää.\r
\r
Työkorvauksen saaja voi vaatia matkakustannuksia vähennettäväksi esitäytetyllä veroilmoituksellaan. Elinkeinotoiminnan harjoittaja vähentää kuitenkin matkakustannukset kirjanpidossaan.\r
\r
Työkorvauksesta ei yleensä voi ennen ennakonpidätyksen toimittamista vähentää työstä aiheutuneita kustannusten korvauksia. Poikkeuksena ovat vain luonnollisille henkilöille työmatkasta maksetut kustannusten korvaukset, joista ei tarvitse toimittaa ennakonpidätystä, jos niiden perusteet ja määrät ovat sen mukaisia kuin Verohallinnon vuosittain antamassa päätöksessä verovapaista matkakustannusten korvauksista on määrätty. Nämäkään korvaukset eivät ole verovapaita, joten ne ilmoitetaan työkorvauksen yhteissummassa.`,
    descriptionSv: `Vederlag som betalas eller som avtalats att ska betalas för arbete som utförts i annat än anställningsförhållande, på vilket förskottsinnehållning ska verkställas, om mottagaren inte har införts i förskottsuppbördsregistret, men på vilket i regel inte betalas socialförsäkringsavgifter. Arbetsersättning kan betalas till en person som utför arbetet som finns införd i förskottsuppbördsregistret eller som inte finns införd i förskottsuppbördsregistret. Arbetsersättning är skattepliktig förvärvsinkomst på vilken förskottsinnehållning ska verkställas, om mottagaren inte finns införd i förskottsuppbördsregistret. Arbetsersättning är till exempel ersättning som betalats till en stödperson. Arbetsersättning är till exempel ersättning som betalats till en stödperson. Ersättningar som betalats till stödfamiljer anmäls med inkomstslaget Arvode för familjevårdare (328). I allmänspråk\r
används ofta benämningen arvode.\r
Arbetsersättning ska anmälas om inkomsttagaren\r
inte är införd i förskottsuppbördsregistret.\r
Eftersom anmälan alltid lämnas in då\r
inkomsttagaren inte är införd i\r
förskottsuppbördsregistret, kan mottagaren även\r
vara annan än en fysisk person, så som en\r
förening, ett aktiebolag, ett öppet bolag eller ett\r
kommanditbolag.\r
Arbetsersättning ska anmälas om betalaren är en\r
prestationsbetalare som omfattas av\r
pensionslagarna för den offentliga sektorn (OffPL)\r
och inkomsttagaren är en fysisk person som är\r
införd i förskottsuppbördsregistret men saknar\r
försäkring enligt pensionslagarna för företagare.\r
Arbetsersättningar till ett begränsat skattskyldigt\r
företag ska anmälas, om betalaren debiterat\r
företaget källskatt. Arbetsersättning till en\r
begränsat skattskyldig fysisk person ska alltid\r
anmälas oberoende av om källskatt debiterats, till\r
exempel ett arvode som en begränsat skatteskyldig\r
idrottare eller artist fått.`,
    taxAndSideCostsDescrEn: `Before tax is withheld, reimbursements of expenses incurred from work cannot, in general,\r
be deducted from non-wage compensation for\r
work. The only exception is the reimbursement\r
of travel expenses paid to natural persons, from\r
which tax does not need to be withheld if the\r
grounds and amounts of the travel expenses are\r
in accordance with the tax-exempt allowances\r
for business travel laid down in the annual decision issued by the Tax Administration. These allowances are not tax-exempt either, so they are\r
reported in the total amount of the non-wage\r
compensation for work.`,
    taxAndSideCostsDescrFi: "Työkorvauksesta ei pääsääntöisesti makseta sosiaalivakuutusmaksuja. Julkisten alojen eläkelakien piiriin kuuluva työnantaja maksaa yksityishenkilön toimeksiantosopimuksen perusteella työeläkevakuutusmaksut, jos toimeksisaaja ei toimi yrittäjänä eli hänellä ei ole yrittäjän eläkelain mukaista vakuutusta. Lisäksi tulonsaaja maksaa työkorvauksesta työntekijän sairausvakuutuksen päivärahamaksun. Oletuksena tulolajissa on, ettei tulo ole sosiaalivakuutusmaksujen alainen.",
    taxAndSideCostsDescrSv: "På arbetsersättning betalas i regel inte socialförsäkringsavgifter. En arbetsgivare som omfattas av pensionslagen för den offentliga sektorn betalar utifrån ett uppdragsavtal arbetspensionsförsäkringsavgift på arbetsersättning, om uppdragstagaren inte är företagare, dvs. saknar en försäkring i enlighet med lagen om pension för företagare. Dessutom betalar inkomsttagaren dagpenningsavgift för arbetstagarens sjukförsäkring. I inkomstslaget är det förvalt att inkomsten inte är underställd socialförsäkringsavgifter",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/wages"
    ],
    calcGrouping: "baseSalary"
  },
  {
    code: 337,
    nameEn: "Supplementary daily allowance paid by employer-specific health insurance fund",
    nameFi: "Työnantajakohtaisen sairaskassan maksama täydennyspäiväraha",
    nameSv: "Kompletteringsdagpenning som betalats av en arbetsgivarspecifik sjukkassa",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "supplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund",
    notSupportedError: "Not supported for companies / associations",
    descriptionEn: "",
    descriptionFi: "Vain sairauskassat käyttävät tätä tulolajia",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 338,
    nameEn: "Pension paid by employer",
    nameFi: "Työnantajan maksama eläke",
    nameSv: "Pension som arbetsgivaren betalat ut",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "pensionPaidByEmployer",
    notSupportedError: null,
    descriptionEn: "Pension paid by an employer to a former employee or their beneficiary on the basis of a previous employment relationship.",
    descriptionFi: "Eläke, jonka työnantaja maksaa entiselle työntekijälleen tai tämän edunsaajalle aiemman palvelussuhteen perusteella.",
    descriptionSv: "Pension som arbetsgivaren betalar till en tidigare arbetstagare eller dennes förmånstagare på basis av anställningsförhållande.",
    taxAndSideCostsDescrEn: `Such income is subject to withholding. No social\r
insurance contributions are paid from the pension paid by an employer.`,
    taxAndSideCostsDescrFi: "Tulo on ennakonpidätyksen alainen. Työnantajan maksamasta eläkkeestä ei makseta sosiaalivakuutusmaksuja.",
    taxAndSideCostsDescrSv: "Inkomsten är förskottsinnehållningspliktig. På pension som arbetsgivaren betalar betalas inte socialförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/employmentTermination"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 339,
    nameEn: "Dividends/profit surplus based on work effort (wages)",
    nameFi: "Työpanokseen perustuva osinko tai ylijäämä (palkka)",
    nameSv: "Dividend eller överskott (lön) som baserar sig på arbetsinsats",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "dividendsBasedOnWages",
    notSupportedError: null,
    descriptionEn: `Dividends paid to a shareholder as wages, the\r
distribution basis of which is the work effort of\r
the recipient of the dividends or of a person in\r
their sphere of interest.`,
    descriptionFi: "Osakkaalle palkkana maksettava osinko, jonka jakoperusteena on osingonsaajan tai tämän intressipiiriin kuuluvan henkilön työpanos.",
    descriptionSv: "Dividend som betalas till aktieägare som lön, där grunden för utdelningen är en arbetsinsats som dividendtagaren eller någon inom denna persons intressesfär har gjort.",
    taxAndSideCostsDescrEn: `Tax is withheld from dividends based on work\r
effort. Dividends paid to a company shareholder\r
are subject to social insurance contributions.\r
The amount of the dividends acts as the basis of\r
the employee's daily allowance contribution of\r
health insurance.`,
    taxAndSideCostsDescrFi: "Työpanokseen perustuvasta osingosta toimitetaan ennakonpidätys. Yhtiön osakkaalle jaettavasta osingosta ei makseta työeläkevakuutus-, työttömyysvakuutus- eikä työtapaturma- ja ammattitautivakuutuksen maksua, vaikka osinko katsottaisiin työpanokseen perustuvaa osinkoa koskevien erityissäännösten perusteella verotuksessa palkaksi. Työpanokseen perustuvasta osingosta maksetaan työnantajan sairausvakuutusmaksu ja osingon määrä on työntekijän sairausvakuutuksen päivärahamaksun perusteena.",
    taxAndSideCostsDescrSv: "På dividend som grundar sig på arbetsinsats verkställs förskottsinnehållning. På dividend som utdelas till bolagets aktieägare betalas socialförsäkringsavgifter. Dividendbeloppet utgör grund för sjukförsäkringens dagpenningsavgift.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 340,
    nameEn: "Dividends/profit surplus (wages) based on work effort (non-wage)",
    nameFi: "Työpanokseen perustuva osinko tai ylijäämä (työkorvaus)",
    nameSv: "Dividend eller överskott (arbetsersättning) som baserar sig på arbetsinsats",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "dividendsBasedOnNonWage",
    notSupportedError: null,
    descriptionEn: `Dividends paid to a shareholder as non-wage\r
compensation for work, the distribution basis of\r
which is the work effort of the recipient of the\r
dividends or a person in their sphere of interest.\r
A report must be submitted for dividends/profit\r
surplus based on work effort taxed as non-wage\r
compensation for work, even when the recipient\r
is registered in the prepayment register.`,
    descriptionFi: `Osakkaalle työkorvauksena maksettava osinko, jonka jakoperusteena on osingonsaajan tai tämän intressipiiriin kuuluvan henkilön työpanos.\r
\r
Ilmoitus on annettava työkorvauksena verotettavasta työpanokseen perustuvasta osingosta tai ylijäämästä siinäkin tapauksessa, että saaja on merkitty ennakkoperintärekisteriin.`,
    descriptionSv: "Dividend som betalas till aktieägare som arbetsersättning, där grunden för utdelningen är en arbetsinsats som dividendtagaren eller någon inom denna persons intressesfär har gjort. En årsanmälan ska lämnas om en arbetsinsatsdividend eller överskott som beskattas som arbetsersättning också i det fall att mottagaren har införts i förskottsuppbördsregistret.",
    taxAndSideCostsDescrEn: `Tax is withheld from the dividends based on\r
work effort (non-wage), unless the recipient is\r
registered in the prepayment register. No social\r
insurance contributions are paid from the payment. However, the income is subject to the employee's daily allowance contribution of health\r
insurance.`,
    taxAndSideCostsDescrFi: "Työpanokseen perustuvasta osingosta (työkorvausta) toimitetaan ennakonpidätys, ellei saaja ole ennakkoperintärekisterissä. Suorituksesta ei makseta sosiaalivakuutusmaksuja. Tulo on kuitenkin työntekijän sairausvakuutuksen päivärahamaksun alainen.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs på dividend som baserar sig på arbetsinsats (arbetsersättning), om mottagaren inte är införd i förskottsuppbördsregistret. På prestationen betalas inte socialförsäkringsavgifter. Inkomsten är dock underställd dagpenningsavgiften för arbetstagarens sjukförsäkring.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 341,
    nameEn: "Employer-subsidised commuter ticket, tax-exempt share",
    nameFi: "Työsuhdematkalipun verovapaa osuus",
    nameSv: "Skattefri andel av personalbiljett",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: 0,
    transactionCode: "employerSubsidisedCommuterTicketTaxExempt",
    notSupportedError: null,
    descriptionEn: `This income type is used to report the tax-exempt share of a personal public transport ticket paid for an employee by an employer.\r
Part of the value of the employer-subsidised commuter ticket is tax-exempt and part is taxable. The taxable share of the employer-subsidised commuter ticket is a fringe benefit. A personal public transport ticket with a value of no more than EUR 3400, provided by the employer to the employee for commuting between the employee's residence and place of work, is tax-exempt income. If an employee has both an employer-subsidised commuter ticket and a bicycle benefit, their total tax-exempt amount can be at most EUR 3,400.\r
If a tax-exempt employer-subsidised commuter ticket benefit is provided by deducting the benefit from the employee’s monetary wages, the earnings-related pension and unemployment insurance contributions and the accident and occupational disease insurance contributions are calculated based on the amount of the wages before the value of the fringe benefit is deducted. A report must always be submitted for an employer-subsidised commuter ticket, including when there is no taxable benefit or deductible amount.\r
If the income earner buys the ticket themselves, and the employer pays the price of the ticket or part of it to the employee, the entirety of the compensation paid by the employer is considered to be the employee's wages. In such a case, the price of the ticket paid to the employee is reported as wages only.\r
The employer-subsidised commuter ticket mustbe reported as income for the pay period in which the benefit was handled in the payroll accounting for the employee. If a tax-exempt employer-subsidised commuter ticket benefit is not handled in the payroll system at all, the tax-exempt employer-subsidised commuter ticket benefit can be reported once a year. However, the recommendation is that the benefit is reported in the report for the month in which it was given.\r
In the case of employer-subsidised commuter tickets, the amounts of taxable and tax-exempt benefit are estimated on an annual level unlike with other fringe benefits, which are valuated on a monthly level as a rule. If an employer-subsidised commuter ticket is granted once per year, for example at the start of the year, and a reimbursement is collected regularly throughout the entire year, the person would, in practice, incur a taxable benefit at the start of the year, as the payer has not yet had time to collect more than the first month's reimbursement for the benefit.\r
So that the payer does not need to correct submitted reports in a situation described above, the payer can anticipate the situation in advance and divide the tax-exempt share over the entire year, reporting it monthly to the Incomes Register together with the collected reimbursement.\r
If an employer-subsidised commuter ticket is given at the beginning of the year for the entire year and the employment relationship ends during the year, the payer must correct the previously submitted reports. In this case, only the share allocated to the employment period is an employer-subsidised commuter ticket benefit. The payer must enter the share of the ticket not based on an employment relationship as wages, unless a reimbursement is collected for the ticket from the income earner.`,
    descriptionFi: `Tulolajilla ilmoitetaan työnantajan työntekijälle kustantaman julkisen liikenteen henkilökohtainen joukkoliikennelipun verovapaa osuus.\r
Osa työsuhdematkalipun arvosta on verovapaata ja osa veronalaista. Veronalainen osuus työsuhdematkalipusta on luontoisetua. Työnantajan työntekijälle antama enintään 3 400 euron arvoinen joukkoliikenteen henkilökohtainen matkalippu asunnon ja työpaikan välistä matkaa varten on verovapaata tuloa. Jos työntekijä saa sekä työsuhdematkalipun että polkupyöräedun, niiden verovapaa määrä voi olla yhteensä korkeintaan 3 400 euroa.\r
Jos verovapaa työsuhdematkalippuetu annetaan alentamalla työntekijän rahapalkkaa, työeläke- ja työttömyysvakuutusmaksut sekä työtapaturma- ja ammattitautivakuutusmaksu lasketaan palkasta, josta ei ole vähennetty luontoisedun arvoa.\r
Työsuhdematkalipusta on aina annettava ilmoitus, myös silloin kun verotettavaa etua tai vähennettävää määrää ei ole.\r
Jos palkansaaja ostaa matkalipun itse ja työnantaja maksaa työntekijälle matkalipun hinnan tai osan siitä, työnantajan maksama korvaus katsotaan kokonaisuudessaan työntekijän palkaksi. Tällöin työntekijälle maksettu lipun hinta ilmoitetaan vain palkkana.\r
Työsuhdematkalippu ilmoitetaan sen palkanmaksukauden tulona, jona etu on käsitelty työntekijän palkanlaskennassa. Jos verovapaata työsuhdematkalippuetua ei käsitellä palkanlaskentajärjestelmässä lainkaan, voi verovapaan työsuhdematkalippuedun ilmoittaa kerran vuodessa. Suosituksena kuitenkin on, että etu ilmoitetaan sen kuukauden ilmoituksella, jonka aikana se annetaan.\r
Työsuhdematkalipussa veronalaisen ja verovapaan edun määriä arvioidaan vuositasolla, toisin kuin muissa luontoiseduissa, joissa arvostus tapahtuu pääsääntöisesti kuukausitasolla. Jos työsuhdematkalippu annetaan kerran vuodessa, esimerkiksi vuoden alussa ja korvausta peritään säännöllisesti koko vuosi, käytännössä vuoden alussa olisi tilanne, että henkilölle muodostuisi veronalainen etu, koska maksaja ei ole vielä ehtinyt periä kuin ensimmäisen kuukauden korvauksen edusta. Jotta maksajan ei tarvitsisi korjata annettuja ilmoituksia edellä kuvatussa tilanteessa, maksaja voi jo etukäteen ennakoida tilanteen ja jakaa verovapaan osuuden koko vuodelle ja ilmoittaa sen kuukausittain tulorekisteriin samassa yhteydessä perimänsä korvauksen kanssa.\r
Jos työsuhdematkalippuetu on annettu vuoden alussa koko vuodeksi ja työsuhde päättyy kesken vuotta, maksajan on korjattava antamansa ilmoitukset. Tällöin työsuhdematkalippuetua on vain se osuus, joka kohdistuu työssäoloaikaan. Maksajan on merkittävä palkaksi se osuus lipusta, joka ei perustu työsuhteeseen, ellei lipuista peritä tulonsaajalta korvausta.`,
    descriptionSv: `Med inkomstslaget anmäls den skattefria andelen av en personlig kollektivtrafikbiljett som arbetsgivaren betalat för arbetstagaren.\r
En del av personalbiljettens värde är skattefritt och en del är skattepliktigt. Den skattepliktiga andelen av personalbiljetten är en naturaförmån. En personlig kollektivtrafikbiljett som arbetsgivaren ger arbetstagaren för resor mellan bostaden och arbetsplatsen är skattefri inkomst till ett värde av högst 3 400 euro. Om arbetstagaren får både personalbiljett och cykelförmån, kan det skattefria beloppet för dem sammanlagt vara högst 3 400 euro.\r
Om en personalbiljett ges genom att sänka arbetstagarens penninglön, räknas arbetspensions- och arbetslöshetsförsäkringsavgifterna och arbetsolycksfalls- och yrkessjukdomsförsäkringsavgiften utifrån lönen före avdrag av värdet på naturaförmånen.\r
Uppgifter om personalbiljetter ska alltid anmälas även om det inte uppkommit någon beskattningsbar förmån eller något avdragbart belopp.\r
Om löntagaren köper biljetten själv och arbetsgivaren betalar biljettpriset eller en del därav till arbetstagaren, anses andelen som arbetsgivaren betalat i sin helhet utgöra arbetstagarens lön. Då anmäls biljettpriset endast som lön.\r
En personalbiljett anmäls som inkomst för den löneutbetalningsperiod då förmånen behandlats i arbetstagarens löneberäkning. Om\r
skattefria personalbiljettförmåner inte överhuvudtaget behandlas i löneberäkningssystemet kan skattefria personalbiljettförmåner anmälas en gång om året. Det rekommenderas emellertid att förmånen anmäls med anmälan för den månad under vilken den beviljas.\r
Personalbiljettens skattefria och skattepliktiga belopp beräknas på årsnivå i motsats till övriga naturaförmåner, där värderingen i regel sker på månadsnivå. Om en personalbiljett ges en gång per år i början av året och ersättning tas ut regelbundet under hela året, skulle personen i praktiken få en skattepliktig förmån i början av året, eftersom betalaren inte har hunnit debitera mer än en månads ersättning för förmånen. För att betalaren inte ska behöva korrigera inlämnade anmälningar i ovan beskrivna fall, kan betalaren redan på förhand förutse situationen och fördela den skattefria andelen på hela året och anmäla den varje månad till inkomstregistret tillsammans med den ersättning som debiterats.\r
Om en personalbiljettförmån har getts i början av året för hela året och anställningsförhållandet upphör under året, ska betalaren korrigera de anmälningar som hen lämnat in. I dessa fall utgörs personalbiljettförmånen endast av den andel som hänför sig till anställningstiden. Betalaren ska anteckna den andel av biljetten som inte baserar sig på ett anställningsförhållande som lön, om man inte tar ut ersättning av inkomsttagaren för biljetterna.`,
    taxAndSideCostsDescrEn: `No tax is withheld or social insurance contributions are paid from the tax-exempt share.\r
If the tax-exempt share of the employer-subsidised commuter ticket benefit is subject to a social insurance contribution, the payer must use the separate\r
‘Type of insurance information’ entry to report that the income is subject to the specified insurance contribution. This applies, for example, when an employer provides a benefit by deducting it from the employee’s monetary wages.`,
    taxAndSideCostsDescrFi: `Verovapaasta osuudesta ei toimiteta ennakonpidätystä eikä makseta sosiaalivakuutusmaksuja.\r
Jos työsuhdematkalipun verovapaa osuus on jonkin sosiaalivakuutusmaksun alainen, suorituksen maksaja ilmoittaa erillistä Vakuuttamistiedon tyyppi -tietoa käyttäen, että tulo on ilmoitetun vakuutusmaksun alainen. Tällainen tilanne on kyseessä silloin kun työnantaja antaa edun rahapalkkaa alentamalla.`,
    taxAndSideCostsDescrSv: `Förskottsinnehållning verkställs inte på den skattefria andelen och socialförsäkringsavgifter betalas inte.\r
Om den skattefria andelen av personalbiljetten är underställd någon socialförsäkringsavgift, anmäler betalaren med hjälp av den separata uppgiften\r
Typ av försäkringsuppgift att inkomsten är underställd den angivna försäkringsavgiften. Det är fråga om en sådan situation då arbetsgivaren ger förmånen genom att sänka penninglönen.`,
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/subsidisedCommute",
      "https://palkkaus.fi/usecases/2019/benefits"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 342,
    nameEn: "Employer-subsidised commuter ticket, taxable share",
    nameFi: "Työsuhdematkalipun palkaksi katsottu osuus",
    nameSv: "Andel av personalbiljett som betraktas som lön",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "employerSubsidisedCommuterTicketTaxable",
    notSupportedError: null,
    descriptionEn: `This income type is used to report the taxable share of a personal public transport ticket paid for an employee by an employer and deemed to be wages.\r
Part of the value of the employer-subsidised commuter ticket is tax-exempt and part is taxable. The taxable share of the employer-subsidised commuter ticket is a fringe benefit. A personal public transport ticket with a value of no more than EUR 3400, provided by the employer to the employee for commuting between the employee's residence and place of work, is tax-exempt income. If an employee has both an employer-subsidised commuter ticket and a bicycle benefit, their total tax-exempt amount can be at most EUR 3,400. Any share in excess of this amount is a taxable fringe benefit deemed to be wages. A report must always be submitted for an employer-subsidised commuter ticket, including when there is no taxable benefit.\r
Employer-subsidised commuter ticket benefits must be reported as income for the pay period in which the benefit was handled in the payroll accounting for the employee. The taxable and tax-exempt shares of an employer-subsidised commuter ticket must be itemised, because they affect the deductibility of the employee's travel expenses between home and work.\r
The reporting of an employer-subsidised commuter ticket differs from other fringe benefits, similarly to the reporting of a bicycle benefit, because the payer must deduct the reimbursement collected from the employee from the share deemed to be wages. The share of the benefit value from which the employer has already deducted a reimbursement it has possibly collected from the income earner is reported as the share deemed to be wages.\r
If the income earner buys the ticket themselves, and the employer pays the price of the ticket or part of it to the employee, the entirety of the compensation paid by the employer is considered to be the employee's wages. In such a case, the price of the ticket paid to the employee is reported as wages only.\r
The bicycle benefit reduces the maximum taxexempt amount of an employer-subsidised commuter ticket. If an employee has both an employer-subsidised commuter ticket and a bicycle benefit, their total tax-exempt amount can be at most EUR 3,400.\r
The taxable share of an employer-subsidised commuter ticket, deemed to be wages, must only be reported using its own income type. It cannot be reported together with other fringe benefits using the income type of Other fringe benefit.`,
    descriptionFi: `Tulolajilla ilmoitetaan työnantajan työntekijälle kustantaman julkisen liikenteen henkilökohtainen joukkoliikennelipun palkaksi katsottava osuus.\r
Osa työsuhdematkalipun arvosta on verovapaata ja osa veronalaista. Veronalainen osuus työsuhdematkalipusta on luontoisetua. Työnantajan työntekijälle antama enintään 3 400 euron arvoinen joukkoliikenteen henkilökohtainen matkalippu asunnon ja työpaikan välistä matkaa varten on verovapaata tuloa. Jos työntekijä saa sekä työsuhdematkalipun että polkupyöräedun, niiden verovapaa määrä voi olla yhteensä korkeintaan 3 400euroa. Ylimenevä osuus on palkaksi katsottavaa luontoisetua. Työsuhdematkalipusta on aina annettava ilmoitus, myös silloin kun verotettavaa etua ei muodostu.\r
Työsuhdematkalippuetu ilmoitetaan sen palkanmaksukauden tulona, jona etu on käsitelty työntekijän palkanlaskennassa. Työsuhdematkalipun palkaksi katsottava osuus ja verovapaa osuus on eriteltävä, koska ne vaikuttavat työntekijän kodin ja työpaikan välisten matkakulujen vähennyskelpoisuuteen.\r
Työsuhdematkalipun ilmoittaminen poikkeaa muista luontoiseduista samalla tavalla kuin polkupyöräedun ilmoittaminen, koska maksajan on vähennettävä palkaksi katsottavasta osuudesta työntekijältä perimänsä korvaus. Palkaksi katsottavana osuutena ilmoitetaan se osuus edun arvosta, josta työnantaja on jo vähentänyt mahdollisesti tulonsaajalta perimänsä korvauksen.\r
Jos palkansaaja ostaa matkalipun itse ja työnantaja maksaa työntekijälle matkalipun hinnan tai osan siitä, työnantajan maksama korvaus katsotaan kokonaisuudessaan työntekijän palkaksi. Tällöin työntekijälle maksettu lipun hinta ilmoitetaan vain palkkana.\r
Polkupyöräetu vähentää työsuhdematkalipun verovapaata enimmäismäärää. Jos työntekijä saa sekä työsuhdematkalipun että polkupyöräedun, niiden verovapaa määrä voi olla yhteensä korkeintaan 3 400 euroa.\r
Työsuhdematkalipun palkaksi katsottu osuus ilmoitetaan ainoastaan omalla tulolajillaan. Sitä ei voi ilmoittaa yhdessä muiden luontoisetujen kanssa Muu luontoisetu-tulolajilla.`,
    descriptionSv: `Med inkomstslaget anmäls den andel av den personliga kollektivtrafikbiljetten som arbetsgivaren betalat för arbetstagaren som anses vara lön.\r
En del av personalbiljettens värde är skattefritt och en del är skattepliktigt. Den skattepliktiga andelen av personalbiljetten är en naturaförmån. En personlig kollektivtrafikbiljett som arbetsgivaren ger arbetstagaren för resor mellan bostaden och arbetsplatsen är skattefri inkomst till ett värde av högst 3 400 euro. Om arbetstagaren får både personalbiljett och cykelförmån, kan det skattefria beloppet för dem sammanlagt vara högst 3 400 euro. Den överstigande delen är en naturaförmån som kan betraktas som lön. Uppgifter om personalbiljetter ska alltid anmälas även om det inte uppkommit någon beskattningsbar förmån.\r
En personalbiljettförmån anmäls som inkomst för den löneutbetalningsperiod då förmånen behandlats i arbetstagarens löneberäkning.\r
Den andel av personalbiljetten som anses vara lön och den skattefria andelen ska specificeras, eftersom detta påverkar avdragsgiltigheten för arbetstagarens kostnader för resor mellan hemmet och arbetsplatsen.\r
Anmälan av personalbiljett skiljer sig från övriga naturaförmåner på samma sätt som anmälan av cykelförmån, eftersom betalaren ska dra av den ersättning som tas ut av arbetstagaren från den andel som betraktas som lön. Som den andel som betraktas som lön anmäls den andel av värdet på förmånen, från vilken arbetsgivaren redan har avdragit en eventuell ersättning som debiterats inkomsttagaren.\r
Om löntagaren köper biljetten själv och arbetsgivaren betalar biljettpriset eller en del därav till arbetstagaren, anses andelen som arbetsgivaren betalat i sin helhet utgöra arbetstagarens lön. Då anmäls biljettpriset endast som lön.\r
Cykelförmånen minskar det maximala skattefria beloppet för personalbiljetten. Om arbetstagaren får både personalbiljett och cykelförmån, kan det skattefria beloppet för dem sammanlagt vara högst 3 400 euro.\r
Den andel av personalbiljetten som betraktas som lön anmäls endast med ett eget inkomstslag. Den kan inte anmälas tillsammans med andra naturaförmåner med inkomstslaget Övriga naturaförmåner.`,
    taxAndSideCostsDescrEn: "The share regarded as wages is subject to withholding and social insurance contributions.",
    taxAndSideCostsDescrFi: "Palkaksi katsottu osuus on ennakonpidätyksen ja sosiaalivakuutusmaksujen alainen.",
    taxAndSideCostsDescrSv: "Den andel som betraktas som lön är underställd förskottsinnehållning och socialförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/subsidisedCommute",
      "https://palkkaus.fi/usecases/2019/benefits"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 343,
    nameEn: "Employee stock option",
    nameFi: "Työsuhdeoptio",
    nameSv: "Anställningsoption",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "employeeStockOption",
    notSupportedError: null,
    descriptionEn: `Remuneration given in the form of the employer\r
company's stock option.`,
    descriptionFi: "Palkkio, joka annetaan työnantajayrityksen option muodossa.",
    descriptionSv: "Arvode som ges i form av en option i arbetsgivarföretaget.",
    taxAndSideCostsDescrEn: `Tax is withheld from the benefit received from\r
the employee stock option.\r
The employee stock option is subject to income\r
taxation when the option is exercised. No social\r
insurance contributions are collected from an\r
employee stock option when it is exercised. Even if the subscription price was significantly\r
lower than the fair value, but the employee stock\r
option is only exercised more than one year after its issuance, the payment is not deemed to\r
be earnings from work on which social insurance contributions are based. A stock option exercised after more than one year is reported using income type Employee stock option.`,
    taxAndSideCostsDescrFi: `Työsuhdeoptiosta saatavasta edusta toimitetaan ennakonpidätys.\r
\r
Työsuhdeoptio on tuloverotuksen kohteena optiota käytettäessä. Työsuhdeoptiosta ei mene sosiaalivakuutusmaksuja sitä käytettäessä.`,
    taxAndSideCostsDescrSv: "På förmånen som fås från anställningsoptioner verkställs förskottsinnehållning. Anställningsoptionen är föremål för inkomstbeskattning när optionen används. Socialförsäkringsavgifter betalas inte för en anställningsoption när den används. Även om teckningspriset skulle vara betydligt lägre än det gängse värdet, men anställningsoptionen används först när över ett år har gått från det att anställningsoptionen har erhållits, utgör prestationen inte förvärvsinkomst som utgör grund för socialförsäkringsavgift. Om det är fråga om en option som använts först när över ett år har gått anmäls optionen med inkomstslaget Anställningsoption.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 350,
    nameEn: "Wages transferred to athletes' special fund",
    nameFi: "Urheilijarahastoon siirretty palkka",
    nameSv: "Lön som överförs till en idrottsfond",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "wagesTransferredToAthletesSpecialFund",
    notSupportedError: null,
    descriptionEn: `Transfer of income from sports to an athletes'\r
special fund for the deferral of income. An athlete is entitled to transfer some of their income\r
from sports to an athletes' special fund. Such\r
funding is agreed between the athlete, employer and, possibly, the sponsor.\r
Income from sports can comprise the athlete's\r
wages or fees. This income type is used only to\r
report the wages transferred to the fund. The\r
transfer to the athletes' special fund is intended\r
to secure the athlete's post-career livelihood.`,
    descriptionFi: `Urheilutulon siirtäminen urheilijarahastoon tulojen jaksottamista varten. Urheilijalla on oikeus siirtää osa urheilutulosta urheilijarahastoon. Rahastoinnista sovitaan urheilijan, työnantajan ja mahdollisesti sponsorin kesken.\r
\r
Urheilutulo voi muodostua urheilijan palkasta tai palkkiosta. Tulolajilla ilmoitetaan vain rahastoon siirretty palkka. Siirto urheilurahastoon on tarkoitettu urheiluajan jälkeisen toimeentulon turvaamiseen.`,
    descriptionSv: "Överföring av idrottsinkomst till en idrottsfond för periodisering av inkomsterna. Idrottsutövaren har rätt att överföra en del av idrottsinkomsten till en idrottsfond. Om fonderingen avtalas mellan idrottsutövaren, arbetsgivaren och en eventuell sponsor. Idrottsinkomst kan bestå av lön eller arvode för idrottsmän. Med inkomstslaget anmäls endast lön som överförts till fonden. Överföringen till idrottsfonden är avsedd att trygga utkomsten efter tiden för idrottsutövande.",
    taxAndSideCostsDescrEn: `The employer's health insurance contribution is\r
paid from the wages of the athlete that are\r
transferred to the fund. The athlete does not pay\r
tax for the income until the income is paid out\r
from the fund. Tax is not withheld from the\r
funded wages and the health insurance daily allowance contribution paid until the wages are\r
paid to the athlete from the fund.\r
The funding of income from sports does not affect the payment of the insurance premiums\r
specified in the act on accident and pension provision for athletes (laki urheilijan tapaturma- ja\r
eläketurvasta 276/2009).`,
    taxAndSideCostsDescrFi: `Urheilijan palkasta maksetaan työnantajan sairausvakuutusmaksu rahastoon siirrettävän palkan osalta. Urheilija maksaa tulosta veroa vasta silloin, kun tulo\r
maksetaan hänelle rahastosta. Rahastoitavasta palkasta toimitetaan ennakonpidätys ja maksetaan sairausvakuutuksen päivärahamaksu vasta silloin, kun\r
palkka maksetaan rahastosta urheilijalle.\r
\r
Urheilutulon rahastointi ei vaikuta urheilijan tapaturma- ja eläketurvasta annetussa laissa eriteltyjen\r
vakuutusmaksujen maksamiseen.`,
    taxAndSideCostsDescrSv: `På lön för idrottsman betalas arbetsgivares sjukförsäkringsavgift för den del som överförs till fonden. Idrottaren betalar skatt på inkomsten först när den betalas från fonden. På den lön som fonderas verkställs förskottsinnehållning och betalas sjukförsäkringens dagpenningspremie först när lönen betalas från fonden till idrottaren. Fonderingen av idrottsinkomst påverkar inte betalningen av de försäkringspremier som\r
specificeras i lagen om olycksfalls- och\r
pensionsskydd för idrottsutövare.`,
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/athlete"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 351,
    nameEn: "Wages paid from athletes' special fund",
    nameFi: "Urheilijarahastosta maksettu palkka",
    nameSv: "Lön från en idrottsfond",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "wagesPaidFromAthletesSpecialFund",
    notSupportedError: "Not supported for companies / associations",
    descriptionEn: `Withdrawal of sports income from the athletes'\r
special fund for the athlete. The fund withholds\r
tax from the athlete's wages and fees withdrawn\r
from the athletes' special fund when the athlete\r
makes a withdrawal.`,
    descriptionFi: "Vain urheilijarahaston käyttöön: Tulolajilla ilmoitetaan vain rahastosta maksettu palkka.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 352,
    nameEn: "Wages for insurance purposes",
    nameFi: "Vakuutuspalkka",
    nameSv: "Försäkringslön",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !0,
    taxDefault: 0,
    transactionCode: "wagesForInsurancePurposes",
    notSupportedError: "TODO: Check",
    descriptionEn: `Calculated wages that would have to be paid, if\r
work corresponding to work performed abroad\r
were to be performed in Finland. Wages for insurance purposes for work abroad is used as\r
the basis of the determination of contributions\r
and benefits in social insurance, instead of actual wages.\r
Different actors have different rules on when wages for insurance purposes are used to determine contributions and benefits, and when\r
actual wages paid are used instead.\r
For more detailed instructions on this topic, see\r
the application instructions of the Finnish Centre\r
for Pensions: Wages for insurance purposes as\r
earnings from work on which pension is based.`,
    descriptionFi: `HUOM: Palkkaus.fi-perusversio ei tue kaikkia kansainvälisiä tilanteita oikein! Jos maksat palkkoja ulkomailla työskentelevälle henkilölle, ota ensin yhteyttä asiakaspalveluun.\r
\r
Laskennallinen palkka, joka olisi maksettava, jos ulkomailla tehtyä työtä vastaava työ tehtäisiin Suomessa. Vakuutuspalkkaa ulkomaantyössä käytetään sosiaalivakuuttamisessa maksujen ja etuuksien määräytymisen perusteena todellisen palkan sijaan.\r
\r
Eri toimijoiden kesken on omat sääntönsä siitä, milloin määräytymisen perusteena käytetään vakuutuspalkkaa ja milloin todellista maksettua palkkaa. Aiheeseen liittyvä tarkempi ohje löytyy Eläketurvakeskuksen soveltamisohjeista: Vakuutuspalkka eläkkeen perusteena olevana työansiona.`,
    descriptionSv: "Kalkylmässig lön som skulle betalas om det arbete som motsvarar arbete som utförts utomlands utfördes i Finland. Försäkringslön vid utlandsarbete används vid socialförsäkring som grund för att bestämma avgifter och förmåner i stället för den verkliga lönen. Olika aktörer har olika regler för när försäkringslön och när verklig utbetald lön används som bestämningsgrund. En detaljerad anvisning finns i Pensionsskyddscentralens tillämpningsanvisningar: Försäkringslön som grund för pension. I inkomstslaget är det förvalt att inkomsten inte är underställd socialförsäkringsavgifter",
    taxAndSideCostsDescrEn: `By default, this income type is subject to social\r
insurance contributions.\r
If, exceptionally, the wages for insurance purposes are not subject to one or more social insurance contributions, the payer must report the\r
insurance information using the separate Type\r
of insurance information data item.`,
    taxAndSideCostsDescrFi: `Oletuksena tulolajissa on, että se on sosiaalivakuutusmaksujen alainen.\r
\r
Jos vakuutuspalkka ei poikkeuksellisesti olisikaan jonkun tai joidenkin sosiaalivakuutusmaksujen alainen, suorituksen maksaja ilmoittaa vakuuttamistiedon erillistä Vakuuttamistiedon tyyppi- tietoa käyttäen.`,
    taxAndSideCostsDescrSv: "Om försäkringslönen undantagsvis inte är underställt socialförsäkringsavgifter anmäler betalaren försäkringsuppgiften separat med hjälp av uppgiften Försäkringsuppgiftens typ.",
    isSupported: !1,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 353,
    nameEn: "Taxable reimbursement of expenses",
    nameFi: "Veronalainen kustannusten korvaus",
    nameSv: "Skattepliktig kostnadsersättning",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "taxableReimbursementOfExpenses",
    notSupportedError: null,
    descriptionEn: `Taxable reimbursement of expenses means the\r
taxable reimbursement of expenses incurred by\r
a person in the performance of their work. This\r
income type is used to report the total amount of\r
taxable reimbursements of expenses that are\r
not itemised using other income types.\r
Use this income type to report only reimbursements of expenses directly incurred by the income earner in the performance of their work,\r
when the employer has not included these reimbursements in the amount of wages when withholding taxes (section 15 of the tax prepayment\r
act (ennakkoperintälaki 1118/1996). This income type is also used to report the corresponding reimbursement of expenses paid to an athlete. Additionally, this income type is used to report the telephone expenses and other such taxable reimbursements of expenses paid to persons participating in unpaid volunteer work for a\r
non-profit organisation or a public sector payer.\r
The employer can reimburse the income earner\r
for expenses directly incurred in the performance of work. Such expenses include expenses incurred in the acquisition of tools and\r
materials, supplies and protective clothing. In\r
the construction industry, for instance, a tool allowance based on a collective agreement is\r
paid.`,
    descriptionFi: `Veronalaisilla kustannusten korvauksilla tarkoitetaan työn suorittajalle työtehtävien hoitamisesta aiheutuneista kustannuksista maksettavaa veronalaista korvausta. Tulolajilla ilmoitetaan kaikkien sellaisten veronalaisten kustannusten korvausten yhteissumma, jota ei eritellä muilla tulolajeilla.\r
\r
Kohdassa ilmoitetaan vain palkansaajalle maksettuja välittömästi työstä aiheutuneita kustannusten korvauksia, joita työnantaja ei ole lukenut mukaan palkan määrään toimittaessaan ennakonpidätystä (ennakkoperintälain 15 §).\r
\r
Työnantaja voi korvata palkansaajalle työstä välittömästi aiheutuneet kustannukset. Tällaisia ovat muun muassa kustannukset, jotka ovat aiheutuneet työvälineiden ja materiaalin hankkimisesta, tarveaineista ja suoja-asujen hankkimisesta aiheutuvat kustannukset. Esimerkiksi rakennusalalla maksetaan työehtosopimukseen perustuvaa työvälinekorvausta.\r
\r
Työnantaja ei toimita veronalaisista kustannusten korvauksista ennakonpidätystä eikä maksa sosiaalivakuutusmaksuja. Korvaukset ovat kuitenkin palkansaajan veronalaista tuloa. Palkansaajan tulee vaatia todelliset kustannukset vähennettäviksi esitäytetyllä veroilmoituksellaan.\r
\r
Jos työntekijä on hankkinut työnantajan puolesta työvälineitä ja työmateriaaleja, niiden kustannuksia ei ilmoiteta, jos työnantaja on korvannut ne työntekijälle tositetta vastaan.`,
    descriptionSv: "Med skattepliktiga kostnadsersättningar avses skattepliktig ersättning för kostnader för skötseln av arbetet som orsakats den som utfört arbetet. Med inkomstslaget anmäls den totala summan av alla sådana skattepliktiga kostnadsersättningar som inte specificeras med andra inkomstslag. Med inkomstslaget anmäls kostnadsersättningar som betalats till löntagaren och som omedelbart orsakats av arbetet och som arbetsgivaren inte inkluderat i lönen i förskottsinnehållningen (lag om förskottsuppbörd 15 §). Med inkomstslaget anmäls också motsvarande kostnadsersättningar som betalats till idrottare. Med inkomstslaget anmäls dessutom telefonkostnader eller övriga motsvarande skattepliktiga kostnadsersättningar som ett allmännyttigt eller offentligt samfund ersatt för dem som deltar i frivilligarbete utan ersättning. Arbetsgivaren kan till löntagaren ersätta kostnader som omedelbart förorsakats av arbetet. Exempel på sådana kostnader är anskaffning av arbetsredskap och material, ämnen och skyddsdräkter. T.ex. i byggbranschen betalas ersättning för arbetsredskap enligt kollektivavtalet.",
    taxAndSideCostsDescrEn: `The employer does not withhold tax or pay social\r
insurance contributions from taxable reimbursements of expenses.\r
However, reimbursements are taxable income for\r
the income earner. The income earner must request the deduction of the actual expenses on their\r
pre-completed tax return form.\r
If an employee has acquired tools and work materials on behalf of the employer, their expenses\r
are not reported if the employer has reimbursed\r
the employee for them against a receipt.`,
    taxAndSideCostsDescrFi: `Työnantaja ei toimita veronalaisista kustannusten korvauksista ennakonpidätystä eikä maksa sosiaalivakuutusmaksuja.\r
\r
Korvaukset ovat kuitenkin palkansaajan veronalaista tuloa. Palkansaajan tulee vaatia todelliset kustannukset vähennettäviksi esitäytetyllä veroilmoituksellaan.\r
\r
Jos työntekijä on hankkinut työnantajan puolesta työvälineitä ja työmateriaaleja, niiden kustannuksia ei ilmoiteta, jos työnantaja on korvannut ne työntekijälle tositetta vastaan.`,
    taxAndSideCostsDescrSv: "Arbetsgivaren verkställer inte förskottsinnehållning på skattepliktiga kostnadsersättningar och betalar inte socialförsäkringsavgifter. Ersättningarna är dock skattepliktig inkomst för löntagaren. Löntagaren bör yrka på avdrag för de faktiska kostnaderna på den förhandsifyllda skattedeklarationen. Om en arbetstagare har skaffat arbetsredskap och material för arbetsgivarens räkning ska kostnaderna för dem inte anmälas, om arbetsgivaren har ersatt dem till arbetstagaren mot verifikat.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/expenses"
    ],
    calcGrouping: "expenses"
  },
  {
    code: 354,
    nameEn: "Private day care allowance municipal supplement",
    nameFi: "Yksityisen hoidon tuen kuntalisä",
    nameSv: "Kommuntillägg till stöd för privat vård",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "privateDayCareAllowanceMunicipalSupplement",
    notSupportedError: "Not supported for companies / associations",
    descriptionEn: "",
    descriptionFi: "Vain kunnat käyttävät tätä tulolajia.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 355,
    nameEn: "Private day care allowance (wages)",
    nameFi: "Yksityisen hoidon tuki (palkka)",
    nameSv: "Stöd för privat vård (lön)",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "privateDayCareAllowanceWages",
    notSupportedError: "Not supported for companies / associations",
    descriptionEn: "",
    descriptionFi: "Vain Kela käyttää tätä tulolajia.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 356,
    nameEn: "Private day care allowance (non-wage)",
    nameFi: "Yksityisen hoidon tuki (työkorvaus)",
    nameSv: "Stöd för privat vård (arbetsersättning)",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "privateDayCareAllowanceNonWage",
    notSupportedError: "Not supported for companies / associations",
    descriptionEn: "",
    descriptionFi: "Vain Kela käyttää tätä tulolajia.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 357,
    nameEn: "Kilometre allowance paid by non-profit organisation",
    nameFi: "Yleishyödyllisen yhteisön maksama kilometrikorvaus",
    nameSv: "Kilometerersättning som betalats ut av ett allmännyttigt samfund",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "kilometreAllowancePaidByNonProfitOrganisation",
    notSupportedError: null,
    descriptionEn: `A kilometre allowance paid by a non-profit or\r
public sector organisation to a person participating in voluntary work for no remuneration.\r
As of 2019, this income type is also used when\r
a public sector payer (such as the state, a municipality or a parish) pays kilometre allowances\r
to a person participating in volunteer work.\r
Travel for the benefit of and commissioned by a\r
non-profit or public sector organisation is equivalent to business travel, even when the recipient\r
of the allowance is not in an employment relationship with the payer or otherwise receives\r
wages for the work to which the travel is related.\r
This income type is only used to report the reimbursements paid to persons participating in volunteer work. If the tax-exempt reimbursements\r
are connected to the wages paid by the organisation, they are reported using income-type Kilometre allowance (tax-exempt) (311).\r
This income type is used to report only the taxexempt kilometre allowances defined in section\r
71(3) of the income tax act (tuloverolaki\r
1535/1992). According to the related legal provision, the following is tax-exempt income from a\r
reimbursement of travel expenses paid by a\r
non-profit or public sector organisation:\r
• reimbursement of travel expenses that\r
can also be paid for a trip made from\r
the taxpayer's residence. A maximum\r
of EUR 3,000 per calendar year of the\r
reimbursement of travel expenses using means other than public transport\r
is tax-exempt.\r
This income type is used to report only the tax-exempt amounts. If a non-profit or public sector organisation pays more kilometre allowances than stipulated in section 71 (3) of the income tax act\r
(tuloverolaki 1535/1992), the extraneous part is reported as non-wage compensation for work.\r
In certain cases, the payer can increase the kilometre allowance paid for the use of a private\r
car. The grounds for the increase are laid down\r
in section 9(1) of the Tax Administration's decision on expenses. This income type is used to\r
report the total amount of the payment, including\r
the increases.\r
Tax-exempt reimbursements of travel expenses\r
can be paid to recipients of an athlete's or competition judge's fees based on the above-mentioned grounds and limitations, even if they also\r
receive a separate fee as a non-wage compensation for work. The competition or event must\r
be related to the activities of the non-profit organisation. The tax-exempt kilometre allowances paid are reported using income-type Kilometre allowance paid by non-profit organisation.\r
The taxable amount exceeding the tax-exempt\r
kilometre allowance is reported to the Incomes\r
Register as non-wage compensation for work\r
using income-type Non-wage compensation\r
for work.`,
    descriptionFi: `Kilometrikorvaus, jonka yleishyödyllinen yhteisö maksaa korvauksettomaan vapaaehtoistyöhön osallistuvalle.\r
\r
Yleishyödyllisen yhteisön hyväksi sen toimeksiannosta tehty matka rinnastetaan työmatkaan silloinkin, kun suorituksen saaja ei ole palvelussuhteessa maksajaan eikä muutoin saa palkkaa työstä, johon matka liittyy.\r
\r
Tulolajilla ilmoitetaan vain vapaaehtoistyöhön osallistuville maksetut korvaukset. Jos verovapaat korvaukset liittyvät yhteisön maksamaan palkkaan, ne ilmoitetaan tulolajilla Kilometrikorvaus (verovapaa) (311).\r
\r
Tulolajilla ilmoitetaan vain tuloverolain (1535/1992) 71 § 3 momentin mukaiset verovapaat kilometrikorvaukset. Lainkohdan mukaan matkakustannusten korvauksesta, jonka yleishyödyllinen yhteisö maksaa, on verovapaata tuloa: matkustamiskustannusten korvaus, jota voidaan suorittaa myös verovelvollisen asunnolta tehdystä matkasta. Matkustamiskustannusten korvauksesta muulla kuin julkisella kulkuneuvolla tehdystä matkasta on verovapaata enintään 2 000 euroa kalenterivuodelta.\r
\r
Tulolajilla ilmoitetaan vain verovapaat määrät. Jos yleishyödyllinen yhteisö maksaa kilometrikorvauksia enemmän kuin tuloverolain 71 § 3 momentissa säädetään, ylimenevä osa ilmoitetaan työkorvauksena.`,
    descriptionSv: `Kilometerersättning som ett allmännyttigt eller offentligt samfund betalar till dem som deltar i frivilligarbete utan ersättning. Från och med 2019 används inkomstslaget även om ett offentligt samfund (bl.a. staten, kommunen eller församlingen) betalar kilometerersättning till dem som deltar i frivilligarbete utan ersättning. Resor som gjorts på uppdrag av allmännyttiga eller offentliga samfund jämställs med arbetsresa även när betalningsmottagaren inte står i anställningsförhållande till betalaren eller i övrigt får lön för det arbete som resan hänför sig till. Med inkomstslaget anmäls endast de ersättningar\r
som betalats åt frivilligarbetare. Om skattefria\r
ersättningar hänför sig till löner som samfundet betalat, anmäls de med inkomstslaget\r
Kilometerersättning (skattefri) (311).\r
Med inkomstslaget anmäls endast skattefria\r
kilometerersättningar enligt 71 § 3 mom. i\r
inkomstskattelagen (1535/1992). Enligt\r
bestämmelsen är resekostnadsersättning som ett\r
allmännyttigt eller offentligt samfund betalar\r
skattefri inkomst:\r
• resekostnadsersättning som kan betalas\r
också för en resa fån den skattskyldiges\r
bostad. Om ersättningen betalas för en\r
resa som har gjorts med något annat än\r
ett allmänt fortskaffningsmedel, uppgår\r
den skattefria andelen till högst 3 000\r
euro per kalenderår.\r
Endast den skattefria andelen anges för\r
inkomstslaget. Om ett allmännyttigt eller offentligt\r
samfund betalar mer kilometerersättningar än vad\r
som föreskrivs i 71 § 3 mom. i inkomstskattelagen\r
anmäls den överstigande delen som arbetsersättning.\r
Kilometerersättningen som betalas för användning\r
av egen bil kan höjas i vissa fall. Grunderna för\r
höjningen beskrivs i 9 § 1 mom. i\r
Skatteförvaltningens kostnadsbeslut. Med\r
inkomstslaget anmäls det totala beloppet av\r
betalda ersättningar jämte förhöjningar.\r
Det är möjligt att till tävlingsdomare och mottagare\r
av arvode för idrottare betala skattefria ersättningar\r
för resekostnader på ovan nämnda grunder och\r
med ovan nämnda begränsningar, även om\r
mottagaren också får ett separat arvode som\r
arbetsersättning. Tävlingen eller evenemanget ska\r
ha en koppling till det allmännyttiga samfundets\r
verksamhet. Betalda skattefria\r
kilometerersättningar anmäls med inkomstslaget\r
Kilometerersättning som betalats ut av ett\r
allmännyttigt samfund. Det skattepliktiga\r
beloppet som överstiger den skattefria\r
kilometerersättningen anmäls till inkomstregistret\r
som arbetsersättning med inkomstslaget\r
Arbetsersättning.`,
    taxAndSideCostsDescrEn: `No social insurance contributions are paid from the\r
allowance.`,
    taxAndSideCostsDescrFi: "Korvauksesta ei makseta sosiaalivakuutusmaksuja.",
    taxAndSideCostsDescrSv: "På ersättning betalas inte socialförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/nonProfitOrg"
    ],
    calcGrouping: "expenses"
  },
  {
    code: 358,
    nameEn: "Daily allowance paid by non-profit organisation",
    nameFi: "Yleishyödyllisen yhteisön maksama päiväraha",
    nameSv: "Dagtraktamente som betalats ut av ett allmännyttigt samfund",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "dailyAllowancePaidByNonProfitOrganisation",
    notSupportedError: null,
    descriptionEn: `A daily allowance for business travel paid by a\r
non-profit or public sector organisation to a person participating in voluntary work for no remuneration.\r
As of 2019, this income type is also used when\r
a public sector payer (such as the state, a municipality or a parish) pays daily allowances to a\r
person participating in volunteer work.\r
This income type is only used to report the daily\r
allowances paid to persons participating in volunteer work. If the tax-exempt daily allowance is\r
connected to the wages paid by the organisation, it is reported using income type Daily allowance (331).\r
In this section, report only the tax-exempt allowances defined in section 71(3) of the income tax\r
act (tuloverolaki 1535/1992). According to the\r
related legal provision, the following is tax-ex empt income from a reimbursement of travel expenses paid by a non-profit or public sector organisation:\r
• daily allowance for no more than 20\r
days per calendar year\r
• accommodation allowance.\r
This income type is used to report only the tax-exempt amounts. If a non-profit or public sector organisation pays more daily allowances than stipulated in section 71(7) of the income tax act (tuloverolaki 1535/1992), the extraneous part is reported\r
as non-wage compensation for work.\r
Tax-exempt reimbursements of travel expenses\r
can be paid to recipients of an athlete's or competition judge's fees based on the above-mentioned\r
grounds and limitations, even if they also receive a\r
separate fee as a non-wage compensation for\r
work. The competition or event must be related to\r
the activities of the non-profit organisation. The taxexempt daily allowances paid are reported using\r
income-type Daily allowance paid by non-profit organisation. The taxable amount exceeding the taxexempt daily allowance is reported to the Incomes\r
Register as non-wage compensation for work using\r
income-type Non-wage compensation for work.`,
    descriptionFi: `Työmatkapäiväraha, jonka yleishyödyllinen yhteisö maksaa korvauksettomaan vapaaehtoistyöhön osallistuvalle.\r
\r
Tulolajilla ilmoitetaan vain vapaaehtoistyöhön osallistuville maksetut päivärahat. Jos verovapaa päiväraha liittyy yhteisön maksamaan palkkaan, se ilmoitetaan tulolajilla Päiväraha (331).\r
\r
Kohdassa ilmoitetaan vain tuloverolain 71 § 3 momentin mukaiset verovapaat korvaukset. Lainkohdan mukaan matkakustannusten korvauksesta, jonka yleishyödyllinen yhteisö maksaa, on verovapaata tuloa:\r
\r
- päiväraha enintään 20 päivältä kalenterivuodessa\r
- majoittumiskorvaus.\r
\r
Tulolajilla ilmoitetaan vain verovapaat määrät. Jos yleishyödyllinen yhteisö maksaan päivärahaa enemmän kuin tuloverolain 7 § momentissa säädetään, ylimenevä osa ilmoitetaan työkorvauksena.`,
    descriptionSv: `Dagtraktamente för arbetsresa som ett allmännyttigt eller offentligt samfund betalar till den som deltar i frivilligarbete utan ersättning. Från och med 2019 används inkomstslaget även\r
om ett offentligt samfund (bl.a. staten, kommunen\r
eller församlingen) betalar kilometerersättning till\r
dem som deltar i frivilligarbete utan ersättning.\r
Med inkomstslaget anmäls endast de ersättningar\r
som betalats åt frivilligarbetare. Om skattefria\r
ersättningar hänför sig till löner som samfundet\r
betalat, anmäls de med inkomstslaget\r
Dagtraktamente (331).\r
I punkten anges endast skattefria ersättningar\r
enligt 71 § 3 mom. i inkomstskattelagen. Enligt\r
bestämmelsen är resekostnadsersättning som ett\r
allmännyttigt eller offentligt samfund betalar\r
skattefri inkomst:\r
• dagtraktamente för högst 20 dagar per\r
kalenderår\r
• logiersättning.\r
Endast den skattefria andelen anges för\r
inkomstslaget. Om ett allmännyttigt samfund eller\r
offentligt samfund betalar mer dagtraktamenten än\r
vad som föreskrivs i 7 § i inkomstskattelagen anmäls\r
den överstigande delen som arbetsersättning.\r
Det är möjligt att till tävlingsdomare och mottagare av\r
arvode för idrottare betala skattefria ersättningar för\r
resekostnader på ovan nämnda grunder och med\r
ovan nämnda begränsningar, även om mottagaren\r
också får ett separat arvode som arbetsersättning.\r
Tävlingen eller evenemanget ska ha en koppling till\r
det allmännyttiga samfundets verksamhet. Betalda\r
skattefria dagtraktamente anmäls med inkomstslaget\r
Dagtraktamente som betalats ut av ett\r
allmännyttigt samfund. Det skattepliktiga beloppet\r
som överstiger det skattefria beloppet anmäls till\r
inkomstregistret som arbetsersättning med\r
inkomstslaget Arbetsersättning.`,
    taxAndSideCostsDescrEn: `No social insurance contributions are paid from the\r
daily allowance`,
    taxAndSideCostsDescrFi: "Päivärahasta ei makseta sosiaalivakuutusmaksuja.",
    taxAndSideCostsDescrSv: "På dagtraktamente betalas inte socialförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/nonProfitOrg"
    ],
    calcGrouping: "expenses"
  },
  {
    code: 359,
    nameEn: "Unjust enrichment",
    nameFi: "Perusteeton etu",
    nameSv: "Ogrundad förmån",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "unjustEnrichment",
    notSupportedError: "Not supported: Does not fit Palkkaus.fi-process.",
    descriptionEn: `Mistakenly paid payment or benefit to which the\r
income earner is not entitled. An unjust enrichment occurs when, for example, a payment has\r
been made on incorrect grounds, to the wrong\r
person, or in an incorrect amount.`,
    descriptionFi: `Perusteeton etu -tulolajia käytetään vain, jos aiheettomasti maksettu suoritus havaitaan ennen ensimmäisen ilmoituksen lähettämistä, eikä tuloa ole aiemmin ilmoitettu muuna tulona tulorekisteriin.\r
\r
Tämä ei tyypillisesti ole mahdollista Palkkaus.fi-maksuprosessissa. Ota yhteys asiakaspalveluun, jos haluat oikeasti käyttää tätä tyyppiä.`,
    descriptionSv: "Prestation eller förmån som betalats utan grund och som inkomsttagaren inte är berättigad till. Ogrundad förmån uppstår till exempel när prestationen har gjorts på felaktiga grunder, till fel person eller till fel belopp. Det separata inkomstslaget Ogrundad förmån används endast om den ogrundade prestationen upptäcks innan den första anmälan inlämnas, och inkomsten inte tidigare anmälts som annan inkomst till inkomstregistret. Om en ogrundad förmån tidigare felaktigt har anmälts t.ex. med inkomstslaget Lön totalt, ska uppgiften korrigeras med inkomstslaget Lön totalt samtidigt som den separata uppgiften Ogrundad förmån anges.",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "Socialförsäkringsavgifter betalas inte för ogrundad förmån.",
    isSupported: !1,
    paymentDefault: 1,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 361,
    nameEn: "Employee stock option with a subscription price lower than the market price at the time of issue",
    nameFi: "Työsuhdeoptio, jonka merkintähinta on luovutusajankohtana alhaisempi kuin markkinahinta",
    nameSv: "Anställningsoption vars teckningspris är lägre än marknadspriset vid överlåtelsetidpunkten",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "employeeStockOptionLowerMarketPrice",
    notSupportedError: null,
    descriptionEn: `Remuneration that is given in the form of the employer company’s stock option and where the subscription price of the option charged from the employee is clearly lower that the market price of the\r
share on the option issuance date.\r
An undervalued employee stock option is only\r
deemed to be earnings from work on which social\r
insurance contributions are based when the option\r
is exercised within one year after the issuance of\r
the employee stock option. In these situations, the\r
benefit granted is reported to the Incomes Register\r
using income type Employee stock option with a\r
subscription price lower than market price at the\r
time of issue. This situation concerns employee\r
stock option benefits in which both the granting and\r
exercise of the stock option take place while the\r
new provision is in effect, i.e. on 1 January 2021 or\r
later.\r
The difference between the subscription price and\r
the market price on the option issuance date must\r
be reported as the benefit value. The amount of the\r
benefit generated from an undervalued employee\r
stock option is estimated on the option right’s issuance date, but it must be reported to the Incomes\r
Register when the option is exercised.`,
    descriptionFi: `Palkkio, joka annetaan työnantajayrityksen option muodossa ja jossa työntekijältä peritty option merkintähinta option luovutusajankohtana on selvästi alhaisempi kuin osakkeen markkinahinta.\r
\r
Käytettäessä optiota etu ilmoitetaan tulolajilla Työsuhdeoptio.`,
    descriptionSv: `Arvode som ges i form av en option i arbetsgivarföretaget och där det teckningspris som debiterats av arbetstagaren för optionen är betydligt lägre än aktiens marknadspris vid överlåtelsetidpunkten för optionen. Underpris för anställningsoption anses vara\r
arbetsinkomst som ligger till grund för\r
socialförsäkringsavgift endast när optionen används\r
inom ett år från det att anställningsoptionen har getts.\r
I dessa situationer anmäls den erhållna förmånen till\r
inkomstregistret med inkomstslaget Anställningsoption\r
vars teckningspris är lägre än marknadspriset vid\r
överlåtelsetidpunkten. Detta gäller\r
anställningsoptioner där både erhållandet av\r
optionsrätten och dess användning sker medan den\r
nya bestämmelsen är i kraft, dvs. 1.1.2021 eller\r
därefter.\r
Som värde för förmånen anmäls skillnaden mellan\r
teckningspriset och marknadspriset vid\r
överlåtelsetidpunkten för optionen. Förmånsbeloppet\r
som uppkommer av en anställningsoption till underpris\r
bedöms vid överlåtelsetidpunkten för optionsrätten,\r
men det anmäls till inkomstregistret när\r
anställningsoptionen används.`,
    taxAndSideCostsDescrEn: `The income is subject to social insurance contributions. No tax is withheld from the income.\r
When the option is exercised, the benefit obtained\r
from exercising it must be reported using the Employee stock option income type.`,
    taxAndSideCostsDescrFi: `Tulo on työeläke-, työttömyys- sekä työtapaturma- ja ammattitautivakuutusmaksun alainen.\r
\r
Työsuhdeoptioetu ei ole optio-oikeutta luovutettaessa tuloverotuksen alaista eikä siitä määrätä työnantajan sairausvakuutusmaksua. \r
\r
Käytettäessä optiota etu ilmoitetaan tulolajilla Työsuhdeoptio.`,
    taxAndSideCostsDescrSv: "Inkomsten omfattas av socialförsäkringsavgifter. Ingen förskottsinnehållning verkställs på inkomsten. När optionen används, anmäls den förtjänst som fås av användningen dessutom med inkomstslaget Anställningsoption",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 362,
    nameEn: "Royalty paid to a non-resident taxpayer",
    nameFi: "Rajoitetusti verovelvolliselle maksettu rojalti",
    nameSv: "Royalty som betalats till en begränsat skattskyldig",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "royaltyPaidToNonResidentTaxpayer",
    notSupportedError: null,
    descriptionEn: `Compensation paid to a person or an organisation\r
that is a non-resident taxpayer for the use of or\r
right to use a copyright, an industrial property right\r
or other right, or for information on industrial, commercial or scientific experiences.\r
The royalty can be based on\r
• the copyright of a literary, artistic or scientific work;\r
• the right to a photograph;\r
• the use or right to use a patent, a trademark, model, form, drawing, secret formula\r
or manufacturing method; or\r
• information on industrial, commercial or scientific experience.`,
    descriptionFi: `Rajoitetusti verovelvolliselle henkilölle tai yhteisölle maksettava korvaus tekijänoikeuden, teollisoikeuden tai muun oikeuden käyttämisestä tai käyttöoikeudesta tai teollisia, kaupallisia tai tieteellisiä kokemuksia koskevista tiedoista.\r
\r
Rojaltin perusteena voi olla\r
\r
- kirjallisen, taiteellisen tai tieteellisen teoksen tekijänoikeus\r
- oikeus valokuvaan\r
- patentin, tavaramerkin, mallin, muotin, piirustuksen, salaisen kaavan tai valmistustavan käyttäminen tai käyttöoikeus\r
- teollisia, kaupallisia tai tieteellisiä kokemuksia koskevat tiedot.`,
    descriptionSv: `En ersättning som betalas till en begränsat skattskyldig person eller ett begränsat skattskyldigt samfund för användning eller nyttjanderätt av upphovsrätt, industriell äganderätt eller annan rättighet eller för uppgifter om industriella, kommersiella eller vetenskapliga rön. Grunden för royalty kan vara• upphovsrätt till litterärt, konstnärligt eller\r
vetenskapligt verk\r
• rätt till ett fotografi\r
• nyttjande av eller rätt att nyttja patent,\r
varumärke, mönster eller modell, ritning,\r
hemligt recept eller hemlig tillverkningsmetod\r
• uppgifter om industriella, kommersiella eller\r
vetenskapliga rön.`,
    taxAndSideCostsDescrEn: `Tax at source is collected from the royalty, unless\r
tax at source has been waived for the income by a\r
tax treaty. The royalty must be reported to the Incomes Register even if no tax at source has been\r
collected from it.\r
Royalties are not subject to social insurance contributions.`,
    taxAndSideCostsDescrFi: `Rojaltista peritään lähdevero, jollei tuloa ole verosopimuksella vapautettu lähdeverosta. Rojalti on ilmoitettava tulorekisteriin, vaikka siitä ei olisi peritty lähdeveroa.\r
\r
Rojalti ei ole sosiaalivakuutusmaksujen alainen.`,
    taxAndSideCostsDescrSv: "Källskatt tas ut på royaltyn om inkomsten inte genom ett skatteavtal har undantagits från källskatt. Royaltyn ska anmälas till inkomstregistret även om någon källskatt inte skulle ha tagits ut på den. Royaltyn omfattas inte av socialförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "benefits"
  },
  {
    code: 363,
    nameEn: "Tax-exempt share of bicycle benefit",
    nameFi: "Polkupyöräedun verovapaa osuus",
    nameSv: "Skattefri andel av cykelförmånen",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: 0,
    transactionCode: "bicycleBenefitTaxExempt",
    notSupportedError: null,
    descriptionEn: `This income type is used to report the tax-exempt share of a bicycle benefit granted for an\r
employee by an employer and deemed to be\r
wages. A bicycle benefit is created when an employer gives a bicycle they own or control to an\r
employee for private use or otherwise provides\r
an employee with an opportunity to use a bicycle outside working hours.\r
A bicycle benefit is tax-exempt if the value of the\r
benefit is at most EUR 1,200 per year. Any\r
share in excess of this amount is a taxable\r
fringe benefit. If an employee has both a bicycle\r
benefit and an employer-subsidised commuter\r
ticket, their total tax-exempt amount can be at\r
most EUR 3,400.\r
If a tax-exempt bicycle benefit is provided by deducting the benefit from the employee’s monetary wages, the earnings-related pension and\r
unemployment insurance contributions and the\r
accident and occupational disease insurance\r
contributions for 2021 are calculated based on\r
the amount of the wages before the value of the\r
fringe benefit is deducted. Fringe benefits\r
granted as deductions from monetary wages are\r
reported using income types 322–324 in 2021.\r
See more detailed reporting guidanceReporting\r
data to the Incomes Register: fringe benefits\r
and reimbursements of expenses.\r
A report must always be submitted for a bicycle\r
benefit, even when there is no taxable benefit. The taxable and tax-exempt amounts of a bicycle benefit are assessed at an annual level. For\r
the calculation of the benefit amount, see the\r
Tax Administration Guidelines Fringe benefits in\r
taxation (available in Finnish and Swedish, link\r
to Finnish).\r
A tax-exempt bicycle benefit must be reported\r
as income for the pay period in which the benefit\r
was handled in the payroll accounting for the\r
employee. If a tax-exempt bicycle benefit is not\r
handled in the payroll system at all, the tax-exempt bicycle benefit can only be reported once\r
a year. However, the recommendation is that\r
the benefit is reported in the report for the month\r
in which it was given.`,
    descriptionFi: `Tulolajilla ilmoitetaan työnantajan työntekijälle antaman polkupyöräedun verovapaa osuus. Polkupyöräetu syntyy, kun työnantaja antaa omistamansa tai hallitsemansa polkupyörän työntekijän yksityiskäyttöön tai muulla vastaavalla tavalla järjestää työntekijälle mahdollisuuden käyttää polkupyörää vapaaajallaan.\r
\r
Polkupyöräetu on verovapaa, jos edun arvo on enintään 1 200 euroa vuodessa. Ylimenevä osuus on veronalaista luontoisetua. Jos työntekijä saa sekä polkupyöräedun että työsuhdematkalipun, niiden verovapaa määrä voi olla yhteensä korkeintaan 3 400 euroa.\r
\r
Polkupyöräedusta on aina annettava ilmoitus, myös silloin kun verotettavaa etua ei ole.`,
    descriptionSv: `Med detta inkomstslag anmäls den skattefria andelen av en cykelförmån som arbetsgivaren ger en arbetstagare. En cykelförmån uppkommer när arbetsgivaren ställer en cykel som arbetsgivaren äger eller besitter till förfogande för en arbetstagare för privat bruk eller på ett annat motsvarande sätt gör det möjligt för arbetstagaren att använda cykeln på sin fritid. Cykelförmånen är befriad från skatt om förmånens värde inte överstiger 1 200 euro per år. Den överstigande delen är en skattepliktig naturaförmån. Om arbetstagaren får både cykelförmån och personalbiljett, kan det skattefria beloppet för dem sammanlagt vara högst 3 400 euro. Om en skattefri cykelförmån ges genom att sänka\r
arbetstagarens penninglön, räknas arbetspensionsoch arbetslöshetsförsäkringsavgifterna och\r
arbetsolycksfalls- och\r
yrkessjukdomsförsäkringsavgiften utifrån lönen före\r
avdrag av värdet på naturaförmånen. En förmån\r
som ges genom att sänka penninglönen meddelas\r
år 2021 i inkomstslagen 322–324. Se den närmare\r
anmälningsanvisningen: Anmälan av information till\r
inkomstregistret: naturaförmåner och\r
kostnadsersättningar\r
Det ska alltid lämnas in en anmälan om\r
cykelförmånen, även när ingen beskattningsbar\r
förmån existerar.\r
Exempel: En arbetsgivare har gett en arbetstagare en\r
cykelförmån värd 600 euro. Ingen skattepliktig naturaförmån\r
uppkommer.\r
• Med inkomstslaget 363 Skattefri andel av\r
cykelförmån anmäls 600 euro.\r
De skattepliktiga och skattefria beloppen i en\r
cykelförmån bedöms per år. Hur förmånsbeloppet\r
räknas ut beskrivs i Skatteförvaltningens anvisning\r
Naturaförmåner i beskattningen.\r
En skattefri cykelförmån anmäls som inkomst för\r
den löneutbetalningsperiod då förmånen\r
behandlats i löneberäkningen för arbetstagaren.\r
Om skattefria cykelförmåner inte över huvud taget\r
behandlas i löneräkningssystemet, kan skattefria\r
cykelförmåner anmälas en gång om året. Det\r
rekommenderas emellertid att förmånen anmäls\r
med anmälan för den månad under vilken den\r
beviljas.\r
Exempel: Arbetsgivaren ger arbetstagaren en cykelförmån\r
i maj. Förmånens årliga värde är 1 000 euro. Om lön som\r
flutit in under maj emellertid betalas ut i juni, kan\r
cykelförmånen anmälas i maj samtidigt med\r
löneutbetalningen för juni eller separat den 5 juli:\r
• 363 Skattefri andel av cykelförmån: 1 000,00`,
    taxAndSideCostsDescrEn: "No tax is withheld or social insurance contributions are paid from the tax-exempt share.",
    taxAndSideCostsDescrFi: "Verovapaasta osuudesta ei toimiteta ennakonpidätystä eikä makseta sosiaalivakuutusmaksuja.",
    taxAndSideCostsDescrSv: "Förskottsinnehållning verkställs inte på den skattefria andelen och socialförsäkringsavgifter betalas inte.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "benefits"
  },
  {
    code: 364,
    nameEn: "Bicycle benefit, taxable share",
    nameFi: "Polkupyöräedun palkaksi katsottu osuus",
    nameSv: "Andel av cykelförmånen som betraktas som lön",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "bicycleBenefitTaxable",
    notSupportedError: null,
    descriptionEn: `This income type is used to report the taxable\r
share of a bicycle benefit granted to an employee by an employer and deemed to be\r
wages. A bicycle benefit is created when an employer gives a bicycle they own or control to an\r
employee for private use or otherwise provides\r
an employee with an opportunity to use a bicycle outside working hours.\r
EUR 1,200 of the bicycle benefit is tax-exempt\r
and any amount in excess of this limit is a taxable fringe benefit. For the calculation of the benefit amount, see the Tax Administration Guidelines Fringe benefits in taxation (available in\r
Finnish and Swedish, link to Finnish).\r
The taxable share of a bicycle benefit regarded\r
as wages must be reported over the months,\r
during which the employee had access to the\r
benefit.\r
The taxable and tax-exempt shares of a bicycle\r
benefit must be itemised, because they affect\r
the deductibility of the employee’s travel expenses between home and work. \r
\r
The reporting of a bicycle benefit differs from\r
other fringe benefits, similarly to the reporting of\r
an employer-subsidised commuter ticket, because the payer must deduct the reimbursement\r
collected from the employee from the share\r
deemed to be wages. The share of the benefit value from which the employer has already deducted a reimbursement it has possibly collected from the income earner is reported as the\r
share deemed to be wages.\r
The taxable share of the bicycle benefit,\r
deemed to be wages, must only be reported using its own income type. It cannot be reported\r
together with other fringe benefits using the income type of Other fringe benefit.`,
    descriptionFi: `Tulolajilla ilmoitetaan työnantajan työntekijälle antaman polkupyöräedun palkaksi katsottava osuus. Polkupyöräetu syntyy, kun työnantaja antaa omistamansa tai hallitsemansa polkupyörän työntekijän yksityiskäyttöön tai muulla vastaavalla tavalla järjestää työntekijälle mahdollisuuden käyttää polkupyörää vapaaajallaan.\r
\r
Polkupyöräedusta 1 200 euroa on verovapaata ja loput veronalaista luontoisetua.\r
\r
Palkaksi katsottu osuus polkupyöräedusta ilmoitetaan niiltä kuukausilta, kun etu on ollut työntekijän käytettävissä.\r
\r
Polkupyöräedun palkaksi katsottava osuus ja verovapaa osuus on eriteltävä, koska ne vaikuttavat työntekijän kodin ja työpaikan välisten matkakulujen vähennyskelpoisuuteen.`,
    descriptionSv: `Med detta inkomstslag anmäls den andel av en cykelförmån som betraktas som lön och som arbetsgivaren ger en arbetstagare. En cykelförmån uppkommer när arbetsgivaren ställer en cykel som arbetsgivaren äger eller besitter till förfogande för en arbetstagare för privat bruk eller på ett annat motsvarande sätt gör det möjligt för arbetstagaren att använda cykeln på sin fritid. Av cykelförmånen är 1 200 euro skattefritt och resterande del skattepliktig naturaförmån. Hur förmånsbeloppet räknas ut beskrivs i Skatteförvaltningens anvisning Naturaförmåner i beskattningen. Den andel av cykelförmånen som betraktas som lön anmäls för de månader som arbetstagaren haft tillgång till förmånen. Den andel av cykelförmånen som betraktas som lön och den skattefria andelen ska specificeras, eftersom detta påverkar avdragsgiltigheten för arbetstagarens kostnader för resor mellan hemmet och arbetsplatsen. Exempel: En arbetsgivare har gett en arbetstagare en\r
cykelförmån värd 1 500 euro. Arbetsgivaren tar inte ut\r
någon ersättning av arbetstagaren för värdet på förmånen.\r
Arbetstagaren har tillgång till cykeln hela året. Eftersom\r
cykelförmånen är skattepliktig till den del förmånens värde\r
överskrider 1 200 euro per år, uppstår en skattepliktig\r
naturaförmån värd 300 euro. Arbetsgivaren anmäler varje\r
månad 25 euro som det belopp som ska betraktas som lön\r
och 100 euro som en skattefri cykelförmån:\r
• 363 Skattefri andel av cykelförmån: 100,00\r
• 364 Andel av cykelförmån som betraktas som lön:\r
25,00\r
Anmälan av cykelförmån skiljer sig från övriga\r
naturaförmåner på samma sätt som anmälan av\r
personalbiljett, eftersom betalaren ska dra av den\r
ersättning som tagits ut av arbetstagaren från den\r
andel som betraktas som lön. Som den andel som\r
betraktas som lön anmäls den andel av värdet på\r
förmånen, från vilken arbetsgivaren redan har\r
avdragit en eventuell ersättning som debiterats\r
inkomsttagaren.\r
Den andel av cykelförmån som betraktas som lön\r
anmäls endast med ett eget inkomstslag. Den kan\r
inte anmälas tillsammans med andra\r
naturaförmåner med inkomstslaget Övriga\r
naturaförmåner.`,
    taxAndSideCostsDescrEn: "The share regarded as wages is subject to withholding and social insurance contributions.",
    taxAndSideCostsDescrFi: "Palkaksi katsottu osuus on ennakonpidätyksen ja so-siaalivakuutusmaksujen alainen.",
    taxAndSideCostsDescrSv: "Den andel som betraktas som lön är underställd förskottsinnehållning och socialförsäkringsavgifter.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "benefits"
  },
  {
    code: 365,
    nameEn: "Conditional stock options and grants",
    nameFi: "Ehdollinen osakepalkkio",
    nameSv: "Villkorlig aktiepremie",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !0,
    unemploymentInsurance: !0,
    healthInsurance: !0,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "conditionalStockOptions",
    notSupportedError: null,
    descriptionEn: `A stock option which involves a share assignment restriction and a conditional refund obligation or which has generated income subject to \r
social insurance contributions. In this case, the\r
value of the benefit received from the stock option does not depend, deviating from the original\r
plan, on the development of the value of the\r
shares between promising and transferring,\r
which is at most one year in duration.\r
Such a situation may arise if the conditions\r
change, for example, in such a way that an employee’s employment relationship ends during\r
the period of one year and they can keep part of\r
the shares. At the same time, an obligation to\r
pay social insurance contributions arises.\r
Such a stock option is considered to have been\r
given, from the perspective of social insurance\r
contributions, when burdens concerning the\r
stock option end and the stock option remains in\r
the person’s ownership or is otherwise made\r
available to them. Considering taxation, a conditional stock option is, however, considered to\r
have been given already when the person receives the right of ownership to the shares.\r
The amount of the stock option must be reported\r
using the “Conditional stock option” income type for\r
determining social insurance contributions. The\r
stock option to be reported using this income type\r
is not income paid to the income earner in concrete\r
terms, but this information is used as the basis of\r
social insurance contributions. The benefit received\r
by the income earner and the tax withheld from it\r
were already reported using the “Stock options and\r
grants” (320) income type when the income earner\r
received the right of ownership to the stock option.\r
This information is used in taxation, for example. The “Conditional stock option” income type is only\r
used when the stock option involves both a share assignment restriction and a conditional refund obligation. If the stock option only involves one of\r
these two burdens, it must be reported similarly to\r
regular stock options using the “Stock options and\r
grants” (320) income type.`,
    descriptionFi: `Osakepalkkio, johon on liittynyt osakkeiden luovutusrajoitus ja ehdollinen palautusvelvollisuus ja josta on syntynyt sosiaalivakuutusmaksujen alaista tuloa. Tässä tilanteessa palkkiosta saatavan edun arvo ei siis alkuperäisestä suunnitelmasta poiketen riipukaan osakkeiden arvon kehityksestä osakepalkkion lupaamisen ja antamisen välisenä, vähintään vuoden pituisena aikana.\r
\r
Tällainen tilanne voi syntyä olosuhteiden muuttuessa esimerkiksi niin, että työntekijän työsuhde päättyy vuoden määräaikana ja hän saa pitää osan osak-keista. Samalla syntyy velvollisuus maksaa sosiaali-vakuutusmaksut.\r
Tällainen osakepalkkio katsotaan sosiaalivakuutus-maksujen näkökulmasta annetuksi silloin, kun palk-kiota koskevat rasitteet päättyvät ja osakepalkkio jää henkilön omistukseen ja vallintaan. Verotuksen kan-nalta ehdollinenkin osakepalkkio katsotaan kuitenkin annetuksi jo silloin, kun henkilö saa omistusoikeuden osakkeisiin.\r
\r
Palkkion määrä ilmoitetaan tulolajilla Ehdollinen osakepalkkio sosiaalivakuutusmaksujen määräämistä varten. Tulolajilla ilmoitettava osakepalkkio ei ole tulonsaajalle konkreettisesti maksettavaa tuloa, vaan tietoa käytetään sosiaalivakuutusmaksujen perusteena. Tulonsaajan saama etu ja siitä tehty ennakonpidätys on ilmoitettu tulolajilla Osakepalkkio (320) jo silloin, kun tulonsaaja on saanut omistusoikeuden osakepalkkioon. Tätä tietoa käytetään esimerkiksi verotuksessa.\r
\r
Tulolajia Ehdollinen osakepalkkio käytetään vain silloin, kun palkkioon on liittynyt sekä osakkeiden luovutusrajoitus että ehdollinen palautusvelvollisuus. Jos palkkioon on liittynyt vain toinen rasitteista, se ilmoitetaan kuten tavallinen osakepalkkio tulolajilla Osakepalkkio (320).`,
    descriptionSv: `En aktiepremie som omfattas av en överlåtelsebegränsning och en villkorlig återbetalningsskyldighet och som gett inkomst som socialförsäkringsavgifter ska betalas för. Värdet på den förmån som fås från premien i denna situation är inte, till skillnad från den ursprungliga planen, beroende av hur värdet på aktierna utvecklas under en period på minst ett år från det att premien utlovats till det att den getts. En sådan situation kan uppstå om omständigheterna till exempel förändras så att arbetstagarens anställningsförhållande upphör under tidsfristen på ett år och arbetstagaren får behålla en del av aktierna. Samtidigt uppstår en skyldighet att betala socialförsäkringsavgifter. Med tanke på socialförsäkringsavgifterna anses en sådan aktiepremie ha getts när servituten gällande premien upphör och personen äger aktiepremien och kan förfoga över den. Med tanke på beskattningen anses även en villkorlig aktiepremie emellertid ha getts redan när personen erhåller äganderätt till aktierna. Premiens belopp anmäls med inkomstslaget Villkorlig aktiepremie för fastställande av socialförsäkringsavgifter. Den aktiepremie som anmäls med inkomstslaget är inte en konkret inkomst som betalas till inkomsttagaren, utan uppgiften används som grund för socialförsäkringsavgifter. Den förmån som inkomsttagaren erhållit och förskottsinnehållningen på förmånen har anmälts med inkomstslaget Aktiepremie (320) redan när inkomsttagaren har fått äganderätt till aktiepremien.\r
Denna uppgift används exempelvis vid beskattningen.\r
Inkomstslaget Villkorlig aktiepremie används endast\r
när premien omfattas av såväl en\r
överlåtelsebegränsning som en villkorlig\r
återbetalningsskyldighet. Om premien endast\r
omfattas av ett av dessa servitut, anmäls den som en\r
vanlig aktiepremie med inkomstslaget Aktiepremie\r
(320).`,
    taxAndSideCostsDescrEn: `This income type is subject to social insurance\r
contributions.`,
    taxAndSideCostsDescrFi: "Tulolaji on sosiaalivakuutusmaksujen alainen.",
    taxAndSideCostsDescrSv: "Socialförsäkringsavgifter ska betalas för inkomstslaget.",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "benefits"
  },
  {
    code: 366,
    nameEn: "Copyright royalties, earned income",
    nameFi: "Tekijänoikeuskorvaus ansiotuloa",
    nameSv: "Ersättning för upphovsrätt som förvärvsinkomst",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "copyrightRoyaltiesEarnedIncome",
    notSupportedError: null,
    descriptionEn: "Compensation paid for the transfer of a copyright to a written or artistic work or for the right to use the object of a copyright. Compensation can also be paid for the transfer of a right related to a copyright or for the use of an object protected by related rights. A copyright can be transferred in full or in part based on an agreement.",
    descriptionFi: "Korvaus, joka maksetaan kirjallisen tai taiteellisen teoksen tekijänoikeuden luovuttamisesta tai tekijänoikeuden kohteen käyttöoikeudesta. Korvaus voidaan maksaa myös tekijänoikeuden lähioikeuden luovuttamisesta tai lähioikeuksilla suojatun kohteen käyttämisestä. Tekijänoikeus voidaan luovuttaa sopimuksen perusteella osittain tai kokonaan.",
    descriptionSv: "En ersättning som betalas för överlåtelse av upphovsrätt för ett litterärt eller konstnärligt verk eller nyttjanderätt till objektet för upphovsrätten. Ersättningen kan betalas också för överlåtelse av närstående rättigheter till upphovsrätten eller för användning av ett objekt som skyddats med närstående rättigheter. Upphovsrätten kan överlåtas utifrån ett avtal helt eller delvis.",
    taxAndSideCostsDescrEn: `Copyright royalties constitute taxable income, and tax is withheld from them if the recipient is not registered in the prepayment register. \r
Social insurance contributions are not usually paid on copyright royalties. However, if such compensation is based on a copyright established in an employment relationship and the compensation is subject to a social insurance contribution, the payer must indicate this by providing insurance information in conjunction with the income type.`,
    taxAndSideCostsDescrFi: `Tekijänoikeuskorvaus on veronalaista ansiotuloa ja siitä toimitetaan ennakonpidätys, jos korvauksen saaja ei kuulu ennakkoperintärekisteriin. \r
Tekijänoikeuskorvauksesta ei yleensä makseta sosiaalivakuutusmaksuja. Jos korvaus kuitenkin perustuu palvelussuhteessa syntyneeseen tekijänoikeuteen ja korvaus on jonkin sosiaalivakuutusmaksun alainen, suorituksen maksaja ilmoittaa siitä antamalla tulolajin yhteydessä lisäksi vakuuttamistiedon.`,
    taxAndSideCostsDescrSv: `En ersättning för upphovsrätt utgör skattepliktig förvärvsinkomst på vilken förskottsinnehållning ska verkställas, om mottagaren inte är införd i förskottsuppbördsregistret. \r
Socialförsäkringsavgifter betalas i allmänhet inte för en ersättning för upphovsrätt. Om ersättningen dock baserar sig på en upphovsrätt som uppkommit i ett anställningsförhållande och ersättningen är underställd socialförsäkringsavgifter, anmäler utbetalaren av prestationen den genom att i samband med inkomstslaget också uppge försäkringsuppgiften.`,
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 367,
    nameEn: "Stock grant paid in money",
    nameFi: "Rahana maksettu osakepalkkio",
    nameSv: "Aktiepremie som betalats ut i pengar ",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: 1,
    transactionCode: "stockGrantPaidInMoney",
    notSupportedError: null,
    descriptionEn: `A stock grant that is paid in money.\r
The income type is used to report the part of stock grants that is paid in money. The part received in shares must be reported using the income type Stock options and grants (320).`,
    descriptionFi: `Osakepalkkio, joka maksetaan rahana.\r
Tulolajilla ilmoitetaan vain se osuus osakepalkkiosta, joka maksetaan rahana. Osakkeina annettava osuus ilmoitetaan tulolajilla Osakepalkkio (320).`,
    descriptionSv: `Aktiepremie som betalats ut i pengar.\r
Endast den andel av aktiepremien som betalats ut i pengar anges för inkomstslaget. Den andel som ges i aktier anges för inkomstslaget Aktiepremie (320).`,
    taxAndSideCostsDescrEn: `Tax is withheld from the stock grant paid in money.\r
By default, this income type is subject to the pension insurance contribution but not to other social insurance contributions.\r
If a payment reported using this income type differs from the default, the payer must report it by specifying insurance information in conjunction with the income type.`,
    taxAndSideCostsDescrFi: `Rahana maksetusta osakepalkkiosta toimitetaan ennakonpidätys.\r
Oletuksena tulolajissa on, että se on eläkevakuutusmaksun alainen, mutta ei muiden sosiaalivakuutusmaksujen alainen. Jos tulolajilla ilmoitettu suoritus poikkeaa oletuksesta, suorituksen maksaja ilmoittaa siitä antamalla tulolajin yhteydessä lisäksi vakuuttamistiedon.`,
    taxAndSideCostsDescrSv: `Förskottsinnehållning verkställs på aktiepremier som betalats ut i pengar.\r
I inkomstslaget är det förvalt att inkomsten är underställd pensionsförsäkringsavgift men inte andra socialförsäkringsavgifter.\r
Om en prestation som anmälts med ett inkomstslag avviker från det förvalda alternativet anmäler prestationsbetalaren detta genom att dessutom ge en försäkringsuppgift i samband med inkomstslaget.`,
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 368,
    nameEn: "Employee stock option paid in money",
    nameFi: "Rahana maksettu työsuhdeoptio",
    nameSv: "Anställningsoption som betalats ut i pengar",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 1,
    transactionCode: "employeeStockOptionPaidInMoney",
    notSupportedError: null,
    descriptionEn: `An employee stock option that is paid in money.\r
The income type is used to report the part of an employee stock option that is paid in money. The part given in other than money must be reported using the income type Employee stock option (343). If required, the income type Employee stock option with a subscription price lower than the market price at the time of issue (361) can also be used.`,
    descriptionFi: `Työsuhdeoptio, joka maksetaan rahana.\r
Tulolajilla ilmoitetaan vain se osuus työsuhdeoptiosta, joka maksetaan rahana. Muuna kuin rahana annettava osuus ilmoitetaan tulolajilla Työsuhdeoptio (343). Tarvittaessa käytetään myös tulolajia Työsuhdeoptio, jonka merkintähinta on luovutusajankohtana alempi kuin markkinahinta (361).`,
    descriptionSv: `Anställningsoption som betalats ut i pengar.\r
Endast den andel av anställningsoptionen som betalats ut i pengar anges för inkomstslaget. Den andel som inte ges i pengar anges för inkomstslaget Anställningsoption (343). Vid behov används även inkomstslagen En anställningsoption vars teckningspris är lägre än marknadspriset vid överlåtelsetidpunkten (361).`,
    taxAndSideCostsDescrEn: `Tax is withheld from an employee stock option paid in money. The employee stock option is subject to income taxation when the option is exercised.\r
No social insurance contributions are collected from an employee stock option when it is exercised. Even if the subscription price was significantly lower than the fair value, but the employee stock option is only exercised more than one year after its issuance, the payment is not deemed to be earnings from work on which social insurance contributions are based. A stock option exercised after more than one year is reported using income type Employee stock option.`,
    taxAndSideCostsDescrFi: `Rahana maksetusta työsuhdeoptiosta toimitetaan ennakonpidätys. Työsuhdeoptio on tuloverotuksen kohteena optiota käytettäessä.\r
Työsuhdeoptiosta ei mene sosiaalivakuutusmaksuja sitä käytettäessä. Vaikka merkintähinta olisi merkittävästi alhaisempi kuin käypä arvo, mutta työsuhdeoptio käytetään vasta yli vuoden kuluttua sen antamisesta, ei suoritus ole sosiaalivakuutusmaksujen perusteena olevaa työansiota. Jos kyse on yli vuoden kuluttua käytetystä optiosta, se ilmoitetaan tulolajilla Työsuhdeoptio.`,
    taxAndSideCostsDescrSv: `Förskottsinnehållning verkställs på anställningsoption som betalats ut i pengar. Anställningsoptionen är föremål för inkomstbeskattning när optionen används.\r
Socialförsäkringsavgifter betalas inte för en anställningsoption när den används. Även om teckningspriset skulle vara betydligt lägre än det gängse värdet, men anställningsoptionen används först när över ett år har gått från det att anställningsoptionen har erhållits, utgör prestationen inte förvärvsinkomst som utgör grund för socialförsäkringsavgift. Om det är fråga om en option som använts först när över ett år har gått anmäls optionen med inkomstslaget Anställningsoption.`,
    isSupported: !0,
    paymentDefault: 1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/otherCompensation"
    ],
    calcGrouping: "salaryAdditions"
  },
  {
    code: 369,
    nameEn: "Earnings from work paid by a JuEL employer to a worker-client of an invoicing service",
    nameFi: "JuEL-työnantajan maksama työansio, jonka työn suorittaja on laskuttanut laskutuspalveluyrityksen kautta",
    nameSv: "Förvärvsinkomst som en arbetsgivare som omfattas av OffPL betalat och som arbetets utförare har fakturerat via ett faktureringsföretag",
    isNegativeSupported: !1,
    pensionInsurance: !0,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "earningsFromJuELEmployerToLightEntrepreneur",
    notSupportedError: "The JuEL payer that commissioned the work  reports the income separately using this info income type.",
    descriptionEn: "Earnings from such work which a payer within the scope of the public sector pensions act (julkisten alojen eläkelaki (JuEL) 81/2016) has commissioned from the individual and which the individual performing the work invoices from the JuEL payer through an invoicing service company. In these situations, the individual performing the work is often called a self-employed “light entrepreneur”. This income type is only used when the individual performing the work has no YEL or MYEL insurance, and they are insured in accordance with JuEL.",
    descriptionFi: "Työansio sellaisesta työstä, jonka on henkilöltä tilannut julkisten alojen eläkelain (JuEL) piiriin kuuluva maksaja ja jonka henkilö eli työn suorittaja laskuttaa JuEL-maksajalta laskutuspalveluyrityksen kautta. Näissä tilanteissa työn suorittajaa kutsutaan usein kevytyrittäjäksi. Tulolajia käytetään vain silloin, kun työn suorittajalla ei ole omaa YEL- tai MYEL-vakuutusta ja hänet vakuutetaan JuEL:n mukaan.",
    descriptionSv: "Arbetsinkomst för arbete som en betalare som omfattas av pensionslagen för den offentliga sektorn (OffPL) har beställt hos en person och för vilken personen, det vill säga den som utför arbetet, fakturerar OffPL-betalaren via ett faktureringsföretag. I en sådan situation kallas den som utför arbetet ofta för lättföretagare. Inkomstslaget används endast när den som utför arbetet inte har en egen FöPL-försäkring eller LFöPL-försäkring och hen försäkras enligt OffPL.",
    taxAndSideCostsDescrEn: "The income type is subject to pension insurance contributions.",
    taxAndSideCostsDescrFi: "Tulolaji on eläkevakuutusmaksun alainen.",
    taxAndSideCostsDescrSv: "Pensionsförsäkringspremie ska betalas för inkomstslaget.",
    isSupported: !1,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 401,
    nameEn: "Compensation collected for car benefit",
    nameFi: "Autoedusta peritty korvaus",
    nameSv: "Ersättning för bilförmån",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: -1,
    transactionCode: "compensationCollectedForCarBenefit",
    notSupportedError: null,
    descriptionEn: `The deductible of a fringe benefit paid by the\r
employee from the taxable value of the car\r
benefit.\r
The deductible of the car benefit decreases\r
the amount of earnings and taxable benefit on\r
which social insurance contributions are\r
based or eliminates it entirely. If the deductible of the car benefit is lower than the taxable value of the car benefit, the difference between the value of the car benefit and the\r
compensation collected for the car benefit is\r
taxable wages of the employee. If the deductible is equal to the taxable value of the car\r
benefit, no taxable benefit is established.\r
Even then, the collected compensation must\r
be reported. The amount of the benefit must\r
also be reported using the ‘Car benefit’ income type.\r
The amount of the car benefit is reported in\r
full using the Car benefit income type, and\r
the deductible collected from the employee is\r
reported using the Compensation collected\r
for car benefit income type.\r
The car benefit must be reported even if the\r
payer has collected from the income earner\r
compensation for the fringe benefit equal to\r
or exceeding the monetary value of the fringe\r
benefit, with no remaining amount to be\r
added to the wages.`,
    descriptionFi: `Luontoisedun omavastuuosuus, jonka työntekijä maksaa autoedun verotusarvosta.\r
\r
Autoedun omavastuuosuus alentaa verotettavaa etua tai poistaa sen kokonaan. Jos autoedun omavastuuosuus on autoedun verotusarvoa alempi, autoedun arvon ja autoedusta perityn korvauksen erotus on työntekijän veronalaista palkkaa. Jos omavastuuosuus vastaa autoedun verotusarvoa, verotettavaa etua ei synny. Tällöinkin peritty korvaus on ilmoitettava. Tällöin on lisäksi ilmoitettava edun määrä Autoetu-tulolajilla.\r
\r
Autoedun arvo ilmoitetaan täysimääräisenä Autoetu-tulolajilla ja Autoedusta peritty korvaustulolajilla työntekijältä perityn omavastuuosuuden määrä. \r
\r
Autoetu on ilmoitettava siinäkin tapauksessa, että suorituksen maksaja on perinyt tulonsaajalta luontoisedusta luontoisedun rahaarvoa vastaavan tai sitä suuremman korvauksen, eikä palkkaan lisättävää määrää ole jäänyt lainkaan.\r
\r
Työnantaja voi periä autoedun omavastuuosuuden työntekijän nettopalkasta.`,
    descriptionSv: "Självriskandel av naturaförmån som arbetstagaren betalar för penningvärdet av bilförmån. Självriskandelen av bilförmånen minskar den arbetsinkomst som ligger till grund för socialförsäkringsavgifter och det beskattningsbara förmånsbeloppet eller avlägsnar den helt. Om självriskandelen av bilförmånen är lägre än bilförmånens beskattningsvärde, utgör differensen mellan beskattningsvärdet och den ersättning som tas ut för bilförmånen skattepliktig lön för arbetstagaren. Om självriskandelen motsvarar beskattningsvärdet av bilförmånen, uppkommer ingen beskattningsbar förmån. Även då ska ersättningen anmälas. Då ska dessutom ersättningen anmälas med inkomstslaget Bilförmån. Värdet på bilförmånen anmäls till fullt belopp med inkomstslaget Bilförmån och Ersättning för bilförmån anmäls den självriskandel som debiterats arbetstagaren. Bilförmån ska anmälas även i det fall att arbetsgivaren tagit ut av arbetstagaren ett belopp på naturaförmånen som motsvarar naturaförmånens penningvärde eller en större ersättning, och ingenting återstår att lägga till lönen.",
    taxAndSideCostsDescrEn: `The employer may collect the deductible of\r
the car benefit from the net wages of the employee.`,
    taxAndSideCostsDescrFi: "Ilmoitettu summa vähentää ennakonpidätyksen ja sosiaalimaksujen pohjana olevaa palkkaa ja vähennetään oletuksena asiakasvaratilin kautta maksetusta palkasta.",
    taxAndSideCostsDescrSv: "Arbetsgivaren kan debitera självriskandelen för bilförmånen av arbetstagarens nettolön.",
    isSupported: !0,
    paymentDefault: -1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/carBenefit",
      "https://palkkaus.fi/usecases/2019/benefits"
    ],
    calcGrouping: "deductions"
  },
  {
    code: 402,
    nameEn: "Withholding tax",
    nameFi: "Ennakonpidätys",
    nameSv: "Förskottsinnehållning",
    isNegativeSupported: !0,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "withholdingTax",
    notSupportedError: null,
    descriptionEn: `A prepayment whereby the payer deducts the\r
tax calculated according to the withholding\r
tax rate from the monetary amount paid to a\r
taxpayer.\r
The withholding tax can be reported as a total\r
amount in the report, even if several income\r
types were reported.`,
    descriptionFi: `Ennakkoperintä, jossa suorituksen maksaja vähentää verovelvolliselle maksettavasta rahamäärästä ennakonpidätysprosentin mukaan lasketun veron.\r
\r
Ennakonpidätys voidaan ilmoittaa ilmoituksella yhteissummana, vaikka tulolajeja olisi ilmoitettu useita.`,
    descriptionSv: "Förskottsuppbörd där betalaren drar av skatt som beräknats enligt förskottsinnehållningsprocenten från det belopp som betalas till den skattskyldige. Förskottsinnehållning kan anmälas som total summa, även om flera inkomstslag anmälts.",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 403,
    nameEn: "Elected official fee",
    nameFi: "Luottamushenkilömaksu",
    nameSv: "Avgift för förtroendevald",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "electedOfficialFee",
    notSupportedError: "Not supported for companies / associations",
    descriptionEn: `A fee that can be collected from the meeting\r
fees of elected municipal officials to be paid to\r
political parties.`,
    descriptionFi: "Luottamushenkilömaksua voivat ilmoittaa vain kunta ja kuntayhtymä.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 404,
    nameEn: "Tax at source",
    nameFi: "Lähdevero",
    nameSv: "Källskatt",
    isNegativeSupported: !0,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "taxAtSource",
    notSupportedError: null,
    descriptionEn: "The final tax collected from a payment made to a non-resident taxpayer that the payer is obligated to collect from the income in connection with its payment.",
    descriptionFi: "Lopullinen rajoitetusti verovelvolliselle maksetusta suorituksesta perittävä vero, jonka tulon maksaja on velvollinen perimään tulosta sen maksamisen yhteydessä.",
    descriptionSv: "En slutgiltig skatt på betalning till en begränsat skattskyldig som den som betalar inkomsten är skyldig att bära upp på inkomsten när den betalas.",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "deductions"
  },
  {
    code: 405,
    nameEn: "Tax at source deduction",
    nameFi: "Lähdeverovähennys",
    nameSv: "Källskatteavdrag",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "taxAtSourceDeduction",
    notSupportedError: null,
    descriptionEn: "A deduction made from the total amount of monetary wages and fringe benefits before tax at source is collected.",
    descriptionFi: "Rahapalkan ja luontoisetujen yhteismäärästä ennen lähdeveron perimistä tehtävä vähennys.",
    descriptionSv: "Avdrag som görs på det sammanlagda beloppet på penninglön och naturaförmåner innan källskatten tas ut.",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 406,
    nameEn: "Wages paid",
    nameFi: "Maksettava palkka",
    nameSv: "Lön som ska betalas ut",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "wagesPaid",
    notSupportedError: null,
    descriptionEn: `Cash wages paid to the employee after withholding tax, the employer's social insurance\r
contributions and other deductible items have\r
been deducted.\r
The other deductible items may include reimbursement collected from the employee for\r
fringe benefits, unemployment fund and trade\r
union membership fees collected by the employer, and enforcement payments.\r
Expense items that are the employer's responsibility, such as hotel payments on business travel, ticket expenses or any occupational health care payments, are not reported\r
using the Wages paid income type.`,
    descriptionFi: `Rahapalkka, joka maksetaan ennakonpidätyksen, työntekijän sosiaalivakuutusmaksujen ja muiden vähennettävien erien vähentämisen jälkeen työntekijälle.\r
\r
Muihin vähennettäviin eriin voivat kuulua esimerkiksi luontoiseduista työntekijältä perittävät maksut, työnantajan pidättämät työttömyyskassan ja ammattiliiton jäsenmaksut sekä ulosottomaksut.\r
\r
Työnantajalle kuuluvia kulueriä, kuten esim. työmatkoilta maksettavia hotellimaksuja, matkalippukuluja tai mahdollisia työterveydenhuollon maksuja ei ilmoiteta Maksettava palkka-tulolajilla.`,
    descriptionSv: "Penninglön som betalas efter förskottsinnehållning, arbetstagarens socialförsäkringsavgifter och andra andelar som ska dras av till arbetstagaren. Övriga andelar som ska dras av kan omfatta till exempel avgifter som tas ut av arbetstagaren för naturaförmåner, medlemsavgifter som arbetsgivaren innehåller för arbetslöshetskassa och fackavgifter samt utsökningsavgifter. Kostnader som hör till arbetsgivaren, såsom hotellavgifter, biljettkostnader eller eventuella företagshälsovårdsavgifter anmäls inte med inkomstslaget Lön som ska betalas ut.",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 407,
    nameEn: "Reimbursement collected for other fringe benefits",
    nameFi: "Muista luontoiseduista peritty korvaus",
    nameSv: "Ersättning för andra naturaförmåner",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: -1,
    transactionCode: "reimbursementCollectedForOtherFringeBenefits",
    notSupportedError: null,
    descriptionEn: `The share of the value of a fringe benefit paid\r
by the employee.\r
In this section, report the amount collected\r
from the employee for fringe benefits other\r
than a car benefit or employer-subsidised\r
commuter ticket benefit.\r
The amount of the fringe benefit is reported in\r
full using the appropriate income type, and\r
the deductible collected from the employee is\r
reported using the ‘Reimbursement collected\r
for other fringe benefits’ income type.\r
Even if the employer has collected or the employee otherwise has paid a reimbursement\r
for a fringe benefit to the employer equalling\r
the monetary value of the fringe benefit, the\r
fringe benefit and the reimbursement collected must be separately reported to the Incomes Register in full. The reimbursement\r
collected for a fringe benefit reduces the\r
amount of taxable income and the amount of\r
earnings from work on which the social insurance contributions are based. If the reimbursement collected for a meal benefit equals the taxable value, the collected reimbursement is not reported using the itemisation type Reimbursement collected for other\r
fringe benefits. In such a case, only the`,
    descriptionFi: `Osuus luontoisedun arvosta, jonka työntekijä maksaa itse.\r
\r
Kohdassa ilmoitetaan summa, joka työntekijältä on peritty muista luontoiseduista kuin autoedusta tai työsuhdematkalippuedusta.\r
\r
Luontoisedun arvo ilmoitetaan täysimääräisenä omalla tulolajillaan ja Muista luontoiseduista peritty korvaus-tulolajilla työntekijältä perityn omavastuuosuuden määrä.\r
\r
Jos ravintoedusta peritty korvaus vastaa verotusarvoa, perittyä korvausta ei ilmoiteta Muusta luontoisedusta peritty korvaus-erittelylajilla. Tällöin käytetään vain tietoa Ravintoedusta peritty korvaus vastaa verotusarvoa – ”Kyllä (true)”.\r
\r
Työnantaja voi periä korvauksen luontoiseduista työntekijän nettopalkasta.`,
    descriptionSv: `Andel av naturaförmånens värde som arbetstagaren betalar själv I punkten anges den summa som av arbetstagaren tagits ut för andra naturaförmåner än bilförmån eller personalbiljett. Värdet på naturaförmånen anmäls till fullt belopp med eget inkomstslag och med inkomstslaget Ersättning för andra naturaförmåner anmäls den självriskandel som debiterats arbetstagaren. Även om arbetsgivaren debiterat eller arbetstagaren annars betalat till arbetsgivaren ett belopp som motsvarar naturaförmånens penningvärde anmäls naturaförmånen och den debiterade ersättningen separat till sitt fulla belopp till inkomstregistret. Ersättning för naturaförmånen sänker beloppet på arbetsinkomsten som ligger till grund för socialförsäkringsavgifter och beskattningsbara inkomsten. Exempel: Arbetstagaren har fått ladda sin elbil under arbetsdagen i arbetsgivarens parkeringshall på arbetsgivarens bekostnad. Detta utgör en månatlig förmån på 30 euro för arbetstagaren. Arbetsgivaren tar ut från arbetstagarens nettolön det belopp som motsvarar förmånens beskattningsvärde, 30 euro. Betalaren anmäler till inkomstregistret: • 317 Övriga naturaförmåner 30.00 o Typ av förmån: Annan förmån • 407 Ersättning för andra naturaförmåner 30.00 Om ersättningen för kostförmånen motsvarar\r
beskattningsvärdet anmäls den debiterade\r
ersättningen inte med specifikationsslaget\r
Ersättning som debiterats övriga\r
naturaförmåner. Då används endast uppgiften\r
Ersättningen för kostförmånen motsvarar\r
beskattningsvärdet - ”Ja (true)”.\r
Arbetsgivaren kan debitera ersättningen för\r
naturaförmåner av arbetstagarens nettolön.`,
    taxAndSideCostsDescrEn: `Reimbursement for meal benefit corresponds to\r
the taxable value – Yes (true) entry is made.\r
The employer may collect the reimbursement\r
for fringe benefits from the net wages of the\r
employee.\r
If a fringe benefit reported using income type\r
Other fringe benefit is not subject to social insurance contributions, and the payer has reported this using the Type of insurance information data group, the corresponding Type of\r
insurance information data must also be\r
added to the Reimbursement collected for\r
other fringe benefits income type to the extent\r
the collected reimbursement targets the part not\r
subject to social insurance contributions. Although the default assumption for this income\r
type is that it is not subject to social insurance\r
contributions, the payer must confirm the data on\r
the report in the manner described above.`,
    taxAndSideCostsDescrFi: `Ilmoitettu summa vähentää oletuksena ennakonpidätyksen ja sosiaalimaksujen pohjana olevaa palkkaa ja vähennetään asiakasvaratilin kautta maksetusta palkasta.\r
\r
Jos Muu luontoisetu -tulolajilla ilmoitettu luontoisetu ei ole sosiaalivakuutusmaksujen alainen ja suorituksen maksaja on ilmoittanut tämän käyttämällä Vakuuttamistiedon tyyppi - tietoryhmää, vastaava Vakuuttamistiedon tyyppi -tieto on lisättävä myös Muista luontoiseduista peritty korvaus -tulolajiin siltä osin, kun peritty korvaus kohdistuu siihen osaan etua, joka ei ole sosiaalivakuutusmaksujen alainen, ks. asiakasohje Tietojen ilmoittaminen tulorekisteriin: luontoisedut ja kustannusten korvaukset.`,
    taxAndSideCostsDescrSv: "Om naturaförmånen som anmälts med inkomstslaget Övriga naturaförmåner inte är underställd socialförsäkringsavgifter och prestationsbetalaren har anmält detta med uppgiftsgruppen Försäkringsuppgiftens typ, måste den motsvarande uppgiften Försäkringsuppgiftens typ läggas till inkomstslaget Ersättning för andra naturaförmåner till den del som ersättningen hänför sig till del av förmånen som inte är underställd socialförsäkringsavgifter. Även om förvalet för inkomstslaget är att prestationen inte är underställd socialförsäkringsavgifter, ska betalaren med anmälan bekräfta uppgifterna på ovannämnda sättet.",
    isSupported: !0,
    paymentDefault: -1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/benefits"
    ],
    calcGrouping: "deductions"
  },
  {
    code: 408,
    nameEn: "Other item deductible from net wage or salary",
    nameFi: "Nettopalkasta vähennettävä muu erä",
    nameSv: "Övriga poster som ska dras av från nettolönen",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "otherItemDeductibleFromNetWage",
    notSupportedError: null,
    descriptionEn: `Items the payer deducts from the net wage or\r
salary before paying it to the income earner.\r
Items may be deducted from the net wage by\r
law or agreement. Deductions made by law\r
include debt recovery payments. The employer may set off its own receivables from\r
the employee's wages. Fees may be deducted from the employee's net wages, if the\r
employer and employee have agreed on their\r
collection. Items deductible from a net wage\r
include unemployment fund and trade union\r
membership fees, and parking garage fees.`,
    descriptionFi: `Erät, jotka palkan maksaja vähentää nettopalkasta ennen kuin maksaa suorituksen tulonsaajalle.\r
\r
Nettopalkasta voidaan vähentää suorituksia lain tai sopimuksen perusteella. Lain perusteella tehtäviä vähennyksiä ovat esimeriksi ulosmittaukset. Työnantaja voi kuitata omia saataviaan työntekijän palkasta. Työntekijän nettopalkasta voidaan vähentää maksuja, joiden perimisestä on työnantajan ja työntekijän kesken sovittu. Nettopalkasta vähennettäviä eriä ovat esim. työttömyyskassan ja ammattiyhdistysten jäsenmaksut sekä pysäköintihallimaksut.\r
\r
Jos ulosmittaus on jo ilmoitettu erikseen, ei sitä ilmoiteta enää tällä erittelylajilla yhteissummassa.`,
    descriptionSv: "Poster som lönebetalaren avdrar från nettolönen innan prestationen betalas till inkomsttagaren. Prestationer kan avdras från nettolönen med stöd av lag eller avtal. Lagstadgade avdrag är t.ex. utmätningar. Arbetsgivaren kan kvitta egna fordringar mot arbetstagarens lön. Från arbetstagarens nettolön kan avdras betalningar som arbetsgivaren och arbetstagaren avtalat om. Poster som avdras från nettolönen är t.ex. medlemsavgifter till arbetslöshetskassa och fackförening samt parkeringshallsavgifter.",
    taxAndSideCostsDescrEn: `If the debt recovery payment has already\r
been separately reported, it is not included in\r
the total amount of this itemisation type.`,
    taxAndSideCostsDescrFi: "Vähennetään nettopalkasta - ei vaikuta ennakonpidätykseen tai sosiaalimaksuihin.",
    taxAndSideCostsDescrSv: "Om utmätning redan anmälts separat, anmäls den i den totala summan med detta specifikationsslag.",
    isSupported: !0,
    paymentDefault: -1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/deductions"
    ],
    calcGrouping: "deductions"
  },
  {
    code: 409,
    nameEn: "Net wage or salary",
    nameFi: "Nettopalkka",
    nameSv: "Nettolön",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "netWage",
    notSupportedError: null,
    descriptionEn: `Wages from which tax has been withheld and\r
the employee's social insurance contributions\r
have been paid.\r
The net wage is different to the wage paid to\r
the employee.`,
    descriptionFi: `Palkka, josta on toimitettu ennakonpidätys ja maksettu työntekijän sosiaalivakuutusmaksut. \r
\r
Nettopalkka on eri asia kuin työntekijälle maksettava palkka.`,
    descriptionSv: "Lön på vilken förskottsinnehållning har verkställts och arbetstagarens socialförsäkringsavgifter har betalats. Med nettolön avses inte samma sak som med lön som betalas till arbetstagaren.",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 410,
    nameEn: "Employer-paid premium for collective additional pension insurance",
    nameFi: "Työnantajan maksaman kollektiivisen lisäeläkevakuutuksen maksu",
    nameSv: "Kollektiv tilläggspensionsförsäkringsavgift som betalats av arbetsgivaren",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "employerPaidPremiumForCollectiveAdditionalPensionInsurance",
    notSupportedError: null,
    descriptionEn: `The employer's share of the additional pension insurance premium paid to cover a collective additional pension.\r
The premium is reported only if the employee\r
pays part of the premiums. If the employer pays the collective additional pension insurance premiums in full, this information is not\r
reported on the earnings payment report.\r
Only the premiums of collective additional\r
pension insurance policies taken out on 6\r
May 2004 or later are reported here. If the\r
employee has been insured prior to 6 May\r
2004, the premiums collected are reported\r
only in the Employee's earnings-related pension insurance contribution section.\r
The contributions are also reported in that\r
section when a new employee has joined a\r
collective insurance policy after 6 May 2004,\r
but the employer has taken the policy out\r
prior to that date.`,
    descriptionFi: `Työnantajan osuus kollektiivisen lisäeläkkeen kattamiseksi maksettavasta lisäeläkevakuutuksen maksusta.\r
\r
Maksu ilmoitetaan vain, jos työntekijä maksaa itse osan maksuista. Jos työnantaja maksaa kollektiivisen lisäeläketurvan maksut kokonaan, tietoja ei ilmoiteta laisinkaan palkkatietoilmoituksella. \r
\r
Kohdassa ilmoitetaan vain 6.5.2004 tai sen jälkeen otetun kollektiivisen lisäeläketurvan maksut. Jos työntekijä on ollut vakuutettuna ennen 6.5.2004, häneltä perityt maksut ilmoitetaan vain Työntekijän työeläkevakuutusmaksu-kohdassa.\r
\r
Maksut ilmoitetaan tässä kohdassa myös silloin, kun uusi työntekijä on tullut 6.5.2004 jälkeen mukaan työnantajan ennen tuota päivää ottamaan kollektiiviseen vakuutusjärjestelmään.`,
    descriptionSv: `Arbetsgivarens andel av avgiften för tilläggspensionsförsäkring för att täcka den kollektiva tilläggspensionen Avgiften anmäls endast om arbetstagaren betalar en del av den. Om arbetsgivaren betalar hela avgiften för kollektivt tilläggspensionsskydd anmäls uppgiften inte anmälan om löneuppgifter. I punkten anges endast avgifter för kollektivt tilläggspensionsskydd som tecknats 6.5.2004 eller därefter. Om arbetstagaren har varit försäkrad före 6.5.2004, anmäls avgifter som arbetstagaren debiterats endast i punkten\r
Arbetstagarens arbetspensionsförsäkringsavgift.\r
Avgifterna anmäls i punkten också när en ny\r
arbetstagare blir delaktig av en kollektiv\r
försäkring som arbetsgivaren tecknat före\r
6.5.2004.`,
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/pension"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 411,
    nameEn: "Employer-paid premium for collective additional pension insurance, employee's contribution",
    nameFi: "Työnantajan maksaman kollektiivisen lisäeläkevakuutuksen työntekijältä peritty osuus",
    nameSv: "Andel av kollektiv tilläggspensionsförsäkringsavgift som betalats av arbetsgivaren och som debiteras arbetstagaren",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "employerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution",
    notSupportedError: null,
    descriptionEn: `The employee's share of the additional pension insurance premium paid to cover a collective additional pension.\r
The premium is reported only if the employee\r
pays part of the premiums. If the employer\r
pays the collective additional pension insurance premiums in full, this data is not reported on the earnings payment report.\r
Only the premiums of collective additional\r
pension insurance policies taken out on 6\r
May 2004 or later are reported here. If the\r
employee has been insured prior to 6 May\r
2004, the premiums collected are reported\r
only in the Employee's earnings-related pension insurance contributions section. \r
The contributions are also reported in that\r
section when a new employee has joined a\r
collective insurance policy after 6 May 2004,\r
but the employer has taken the policy out\r
prior to that date.`,
    descriptionFi: `Työntekijän osuus kollektiivisen lisäeläkkeen kattamiseksi maksettavasta lisäeläkevakuutuksen maksusta.\r
\r
Maksu ilmoitetaan vain, jos työntekijä maksaa itse osan maksuista. Jos työnantaja maksaa kollektiivisen lisäeläketurvan maksut kokonaan, tietoja ei ilmoiteta lainkaan palkkatietoilmoituksella. \r
\r
Kohdassa ilmoitetaan vain 6.5.2004 tai sen jälkeen otetun kollektiivisen lisäeläketurvan maksut. Jos työntekijä on ollut vakuutettuna ennen 6.5.2004, häneltä perityt maksut ilmoitetaan vain Työntekijän työeläkevakuutusmaksut-kohdassa.\r
\r
Maksut ilmoitetaan kohdassa myös silloin, kun uusi työntekijä on tullut 6.5.2004 jälkeen mukaan työnantajan ennen tuota päivää ottamaan kollektiiviseen vakuutusjärjestelmään.`,
    descriptionSv: "Arbetstagarens andel av avgiften för tilläggspensionsförsäkring för att täcka den kollektiva tilläggspensionen. Avgiften anmäls endast om arbetstagaren betalar en del av den. Om arbetsgivaren betalar hela avgiften för kollektivt tilläggspensionsskydd anmäls uppgiften inte anmälan om löneuppgifter. I punkten anges endast avgifter för kollektivt tilläggspensionsskydd som tecknats 6.5.2004 eller därefter. Om arbetstagaren har varit försäkrad före 6.5.2004, anmäls avgifter som arbetstagaren debiterats endast i punkten arbetstagarens arbetspensionsförsäkringsavgift. Avgifterna anmäls i punkten också när en ny arbetstagare blir delaktig av en kollektiv försäkring som",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "Vähennetään oletuksena nettopalkasta. Ei vaikuta ennakonpidätykseen tai sosiaalimaksuihin.",
    taxAndSideCostsDescrSv: "",
    isSupported: !0,
    paymentDefault: -1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/pension"
    ],
    calcGrouping: "deductions"
  },
  {
    code: 412,
    nameEn: "Employee's health insurance contribution",
    nameFi: "Työntekijän sairausvakuutusmaksu",
    nameSv: "Arbetstagarens sjukförsäkringsavgift",
    isNegativeSupported: !0,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "employeesHealthInsuranceContribution",
    notSupportedError: null,
    descriptionEn: `A share of the health insurance premium via which the employee participates in financing earned income insurance.\r
In the case of resident taxpayers, the health insurance contribution is always included in withholding tax, and the employee's health insurance contribution should not be separately\r
reported for resident taxpayers. The health insurance contribution of a non-resident taxpayer must be collected separately in addition to tax at source, unless the\r
non-resident taxpayer wants to be taxed in accordance with the Tax Procedure Act, in which case the health insurance contribution is included in the withholding tax or prepayment of tax.\r
The employee's health insurance contribution includes the daily allowance contribution of health insurance and the health care contribution of health insurance. The amounts of the\r
contributions are confirmed annually by Government decree.`,
    descriptionFi: `Yleisesti verovelvollisella tulonsaajalla sairausvakuutusmaksu sisältyy aina ennakonpidätykseen, eikä yleisesti verovelvollisten osalta tule ilmoittaa erikseen työntekijän sairausvakuutusmaksua.\r
\r
Rajoitetusti verovelvollisen sairausvakuutusmaksu on perittävä erikseen lähdeveron lisäksi, ellei rajoitetusti verovelvollinen ole hakeutunut verotusmenettelystä annetun lain mukaiseen verotukseen, jolloin sairausvakuutusmaksu sisältyy ennakonpidätykseen tai ennakkoveroon.`,
    descriptionSv: "En del av sjukförsäkringsavgiften med vilken arbetstagaren deltar i finansieringen av arbetsinkomstförsäkringen. Sjukförsäkringsavgift för allmänt skattskyldiga inkomsttagare ingår alltid i förskottsinnehållningen, och arbetstagarens sjukförsäkringsavgift ska inte anmälas separat för allmänt skattskyldiga. Sjukförsäkringspremien för begränsat skattskyldiga ska tas ut separat utöver källskatt om inte den begränsat skattskyldige har sökt sig till beskattning i enlighet med lagen om beskattningsförfarande, då beskattningen ingår i förskottsuppbörden. I arbetstagarens sjukförsäkringsavgift ingår sjukförsäkringens dagpenningsavgift och sjukförsäkringens sjukvårdsavgift. Beloppen fastställs årligen genom statsrådets förordning.",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "deductions"
  },
  {
    code: 413,
    nameEn: "Employee's pension insurance contribution",
    nameFi: "Työntekijän työeläkevakuutusmaksu",
    nameSv: "Arbetspensionsförsäkringsavgift för arbetstagare",
    isNegativeSupported: !0,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "employeesPensionInsuranceContribution",
    notSupportedError: null,
    descriptionEn: `Earnings-related pension insurance contribution determined based on the gross wage,\r
through which the employee participates in\r
the financing of the earnings-related pension.\r
The employee's earnings-related pension insurance contribution is deducted from the employee's net wages.`,
    descriptionFi: `Bruttopalkan perusteella määräytyvä työeläkevakuutusmaksu, jolla työntekijä osallistuu työeläkevakuutuksen rahoittamiseen.\r
\r
Työntekijän työeläkevakuutusmaksu vähennetään työntekijän nettopalkasta.`,
    descriptionSv: `Arbetspensionsförsäkringsavgift som bestäms enligt bruttolönen, med vilken arbetstagaren\r
deltar i finansieringen av\r
arbetspensionsförsäkringen.\r
Arbetstagarens arbetspensionsförsäkringsavgift\r
dras av från arbetstagarens nettolön.`,
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 414,
    nameEn: "Employee's unemployment insurance contribution",
    nameFi: "Työntekijän työttömyysvakuutusmaksu",
    nameSv: "Arbetstagarens arbetslöshetsförsäkringsavgift",
    isNegativeSupported: !0,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "employeesUnemploymentInsuranceContribution",
    notSupportedError: null,
    descriptionEn: `An unemployment insurance contribution determined based on the gross wage, through\r
which the employee participates in the financing of the unemployment insurance.\r
The employee's unemployment insurance\r
contribution is deducted from the employee's\r
net wages.`,
    descriptionFi: `Bruttopalkan perusteella määräytyvä työttömyysvakuutusmaksu, jolla työntekijä osallistuu työttömyysvakuutuksen rahoittamiseen.\r
\r
Työntekijän työttömyysvakuutusmaksu vähennetään työntekijän nettopalkasta.`,
    descriptionSv: "Arbetslöshetsförsäkringsavgift som bestäms enligt bruttolönen, med vilken arbetstagaren deltar i finansieringen av arbetslöshetsförsäkringen. Arbetstagarens arbetslöshetsförsäkringspremie dras av från arbetstagarens nettolön.",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 415,
    nameEn: "Reimbursement for employer-subsidised commuter ticket",
    nameFi: "Työsuhdematkalipusta peritty korvaus",
    nameSv: "Ersättning för personalbiljett",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "reimbursementForEmployerSubsidisedCommuterTicket",
    notSupportedError: null,
    descriptionEn: `The deductible of a fringe benefit paid by the employee from the euro value of an employer-subsidised commuter ticket.\r
Part of the value of the employer-subsidised commuter ticket is tax-exempt and part is taxable. The taxable share of the employer-subsidised commuter ticket is a fringe benefit. A personal public transport ticket with a value of no more than EUR 3400, provided by the employer to the employee for commuting between the employee's residence and place of work, is tax-exempt income. A report must always be submitted for an employer-subsidised commuter ticket, including when there is no taxable benefit.If the income earner buys the ticket themselves, and the employer pays the price of the ticket or part of it to the employee, the entirety of the compensation paid by the employer is considered to be the employee's wages. In such a case, the price of the ticket paid to the employee is reported as wages only.\r
The employer may collect the deductible of the employer-subsidised commuter ticket from the net wages of the employee.\r
The employer must deduct the reimbursement collected from the employee from the taxable share of the employer-subsidised commuter ticket deemed to be wages. The remaining amount must be reported as the taxable share deemed to be wages.\r
If no benefit deemed to be wages is created, the employer must deduct the reimbursement collected from the employee from the tax-exempt share of the employer-subsidised commuter ticket. The remaining amount must be reported as the tax-exempt share of the employer-subsidised commuter ticket.\r
In the case of employer-subsidised commuter tickets, the amounts of taxable and tax-exempt benefit are estimated on an annual level unlike other fringe benefits, which are valuated on a monthly level. If an employer-subsidised commuter ticket is granted once per year, for example at the start of the year, and a reimbursement is collected regularly throughout the entire year, the person would, in practice, incur a taxable benefit at the start of the year, as the payer has not yet had time to collect more than the first month's reimbursement for the benefit. So that the payer does not need to correct submitted reports in a situation described above, the payer can anticipate the situation in advance and divide the tax-exempt share over the entire year, reporting it monthly to the Incomes Register together with the collected reimbursement.`,
    descriptionFi: `Luontoisedun omavastuuosuus, jonka työntekijä maksaa työsuhdematkalipun euromääräisestä arvosta.\r
Osa työsuhdematkalipun arvosta on verovapaata ja osa veronalaista. Veronalainen osuus työsuhdematkalipusta on luontoisetua.\r
Työnantajan työntekijälle antama enintään 3 400 euron arvoinen joukkoliikenteen henkilökohtainen matkalippu asunnon ja työpaikan välistä matkaa varten on verovapaata tuloa. Työsuhdematkalipusta on aina annettava ilmoitus, myös silloin kun verotettavaa etua ei ole.\r
Jos palkansaaja ostaa matkalipun itse ja työnantaja maksaa työntekijälle matkalipun hinnan tai osan siitä, työnantajan maksama korvaus katsotaan kokonaisuudessaan työntekijän palkaksi. Tällöin työntekijälle maksettu lipun hinta ilmoitetaan vain palkkana. Työnantaja voi periä työsuhdematkalipun omavastuuosuuden työntekijän nettopalkasta.\r
Työnantajan on vähennettävä työsuhdematkalipun palkaksi katsottavasta osuudesta työntekijältä perimänsä korvaus. Palkaksi katsottavana osuutena ilmoitetaan jäljelle jäävä määrä.\r
Jos palkaksi katsottavaa etua ei muodostu, työnantajan on vähennettävä työntekijältä perimänsä korvaus työsuhdematkalipun verovapaasta osuudesta. Työsuhdematkalipun verovapaana osuutena ilmoitetaan jäljelle jäävä määrä.\r
Työsuhdematkalipussa veronalaisen ja verovapaan edun määriä arvioidaan vuositasolla, toisin kuin muissa luontoiseduissa, joissa arvostus tapahtuu kuukausitasolla. Jos työsuhdematkalippu annetaan kerran vuodessa, esimerkiksi vuoden alussa ja korvausta peritään säännöllisesti koko vuosi, käytännössä vuoden alussa olisi tilanne, että henkilölle muodostuisi veronalainen etu, koska maksaja ei ole vielä ehtinyt periä kuin ensimmäisen kuukauden korvauksen edusta. Jotta maksajan ei tarvitsisi korjata annettuja ilmoituksia edellä kuvatussa tilanteessa, maksaja voi jo etukäteen ennakoida tilanteen ja jakaa verovapaan osuuden koko vuodelle ja ilmoittaa sen kuukausittain tulorekisteriin samassa yhteydessä perimänsä korvauksen kanssa.`,
    descriptionSv: `Självriskandel av naturaförmån som arbetstagaren betalar för penningvärdet av personalbiljett.\r
En del av personalbiljettens värde är skattefritt och en del är skattepliktigt. Den skattepliktiga andelen av personalbiljetten är en naturaförmån.\r
En personlig kollektivtrafikbiljett som arbetsgivaren ger arbetstagaren för resor mellan bostaden och arbetsplatsen är skattefri inkomst till ett värde av högst 3 400 euro. Uppgifter om personalbiljetter ska alltid anmälas även om det inte uppkommit någon beskattningsbar förmån.\r
Om löntagaren köper biljetten själv och arbetsgivaren betalar biljettpriset eller en del därav till arbetstagaren, anses andelen som arbetsgivaren betalat i sin helhet utgöra arbetstagarens lön. Då anmäls biljettpriset endast som lön.\r
Arbetsgivaren kan debitera självriskandelen för personalbiljetten av arbetstagarens nettolön.\r
Arbetsgivaren ska dra av den ersättning som debiterats av arbetstagaren från den andel av personalbiljetten som betraktas som lön. Som andel som betraktas som lön anmäls det återstående beloppet.\r
Om ingen förmån som kan betraktas som lön uppkommer, ska arbetsgivaren dra av den ersättning som debiteras av arbetstagaren från personalbiljettens skattefria andel. Som personalbiljettens skattefria andel anmäls det återstående beloppet.\r
Personalbiljettens skattefria och skattepliktiga belopp beräknas på årsnivå i motsats till övriga naturaförmåner, där värderingen i regel sker på månadsnivå. Om en personalbiljett ges en gång per år i början av året och ersättning tas ut regelbundet under hela året, skulle personen i praktiken få en skattepliktig förmån i början av året, eftersom betalaren inte har hunnit debitera mer än en månads ersättning för förmånen. För att betalaren inte ska behöva korrigera inlämnade anmälningar i ovan beskrivna fall, kan betalaren redan på förhand förutse situationen och fördela den skattefria andelen på hela året och anmäla den varje månad till inkomstregistret tillsammans med den ersättning som debiterats.`,
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !0,
    paymentDefault: -1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/subsidisedCommute",
      "https://palkkaus.fi/usecases/2019/benefits"
    ],
    calcGrouping: "deductions"
  },
  {
    code: 416,
    nameEn: "Tax paid abroad",
    nameFi: "Ulkomaille maksettu vero",
    nameSv: "Skatt som betalats till utlandet",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "taxPaidAbroad",
    notSupportedError: "International scenarios are not supported inthis version.",
    descriptionEn: "",
    descriptionFi: "Palkkaus.fi-perusversio ei tue kaikkia kansainvälisiä tilanteita oikein! Jos maksat palkkoja ulkomailla työskentelevälle henkilölle, ota ensin yhteyttä asiakaspalveluun.",
    descriptionSv: "",
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !1,
    paymentDefault: 0,
    usecases: [],
    calcGrouping: "disabled"
  },
  {
    code: 417,
    nameEn: "Distraint",
    nameFi: "Ulosmittaus",
    nameSv: "Utmätning",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "distraint",
    notSupportedError: null,
    descriptionEn: `An amount withheld in order to make a debt\r
recovery payment. The garnished amount is\r
calculated from net income.`,
    descriptionFi: `Perittäväksi tulleen velan maksamiseksi tehtävä pidätys. Ulosmitattava määrä lasketaan nettotulosta.\r
\r
Ulosmitattaessa velallisen ja hänen perheensä toimeentuloa varten tulee kuitenkin jättää suojaosuus.`,
    descriptionSv: `Innehållning som görs för skuld som ska indrivas Det belopp som utmäts beräknas utifrån nettoinkomsten. Vid utmätning ska dock ett skyddat belopp\r
lämnas kvar för gäldenärens och hans eller\r
hennes familjs utkomst.`,
    taxAndSideCostsDescrEn: `However, a protected share must be left during garnishment for the livelihood of the\r
debtor and their family.`,
    taxAndSideCostsDescrFi: "Vähennetään oletuksena nettopalkasta. Ei vaikuta ennakonpidätykseen tai sosiaalimaksuihin.",
    taxAndSideCostsDescrSv: "",
    isSupported: !0,
    paymentDefault: -1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/deductions"
    ],
    calcGrouping: "deductions"
  },
  {
    code: 418,
    nameEn: "Voluntary individual pension insurance premium",
    nameFi: "Vapaaehtoisen yksilöllisen eläkevakuutuksen maksu",
    nameSv: "Försäkringsavgift för en individuell, frivillig pensionsförsäkring",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "voluntaryIndividualPensionInsurancePremium",
    notSupportedError: null,
    descriptionEn: `Premium of a pension insurance taken out for\r
a specific person to complement statutory\r
pension provision. The voluntary individual\r
pension insurance premium may be continuous or a one-off payment.\r
Enter the premiums of the voluntary individual\r
pension insurance taken for the employee\r
here. Similarly, also report the premiums of\r
an individual pension insurance taken out for\r
a partner in a general partnership, a general\r
partner in a limited partnership, or a shareholder in a limited liability company that does\r
not have an earnings-related pension insurance.\r
If the premiums of voluntary individual pension insurance taken out by the employer exceed EUR 8,500, they are taxable income\r
from which the employer's social insurance\r
contributions are also paid. If the premiums\r
exceed EUR 8,500 per year, the payer reports the extraneous premiums as other\r
fringe benefits.\r
Example: The employer pays EUR 12,000 per year\r
in premiums for voluntary individual pension insurance it has taken out for an employee. The employee\r
reports the information as follows:\r
• Voluntary individual pension insurance premium EUR 8,500.\r
• Other taxable fringe benefits EUR 3,500.\r
Enter only the premiums of the voluntary individual pension insurance here. If, on the employee's behalf, the employer has paid the\r
employee's mandatory pension insurance\r
contributions, unemployment insurance contributions and the premiums of voluntary pension insurance taken out by the employee,\r
these are reported using the ‘Other fringe benefits’ income type.`,
    descriptionFi: `Lakisääteistä eläketurvaa täydentävän tietylle henkilölle kohdistetun eläkevakuutuksen maksu. Vapaaehtoisen yksilöllisen eläkevakuutuksen maksu voi olla jatkuva tai kertamaksullinen.\r
\r
Kohtaan merkitään työntekijälle otetun vapaaehtoisen yksilöllisen eläkevakuutuksen maksut. Samoin ilmoitetaan myös sellaisen yksilöllisen eläkevakuutuksen maksut, joka on otettu avoimen yhtiön yhtiömiehelle, kommandiittiyhtiön vastuunalaiselle yhtiömiehelle tai sellaisen osakeyhtiön osakkaalle, joka ei ole työeläkevakuutettu.\r
\r
Jos työnantajan ottaman vapaaehtoisen yksilöllisen eläkevakuutuksen maksut ylittävät 8 500 euroa, ne ovat veronalaista tuloa, joista maksetaan myös työnantajan sosiaalivakuutusmaksut. Jos maksut ylittävät 8 500 euroa vuodessa, suorituksen maksaja ilmoittaa ylimenevät maksut muuna luontoisetuina. \r
\r
Esimerkki: Työnantaja maksaa työntekijälle ottamansa vapaaehtoisen yksilöllisen eläkevakuutuksen maksuja vuodessa 12000 euroa. Työnantaja ilmoittaa tiedot seuraavasti:\r
\r
- Vapaaehtoisen yksilöllisen eläkevakuutuksen maksu 8 500 euroa.\r
- Muu verotettava luontoisetu 3 500 euroa.\r
\r
Kohtaan merkitään vain vapaaehtoisen yksilöllisen eläkevakuutuksen maksut. Jos työnantaja on maksanut työntekijän puolesta työntekijän pakollisia eläkevakuutusmaksuja, työttömyysvakuutusmaksuja ja työntekijän itsensä ottaman vapaaehtoisen eläkevakuutuksen maksuja, nämä ilmoitetaan Muu luontoisetu-tulolajilla.`,
    descriptionSv: `Premie för en pensionsförsäkring som kompletterar det lagstadgade pensionsskyddet och som riktas till en bestämd person. Försäkringspremien för en individuell, frivillig pensionsförsäkring kan vara kontinuerlig eller betalas en gång. I punkten anges avgifterna för en individuell, frivillig pensionsförsäkring som tecknats för arbetstagaren. Dessutom anges avgifterna för sådana individuella pensionsförsäkringar som tecknats för bolagsman i öppet bolag, ansvarig bolagsman i kommanditbolag eller delägare i ett aktiebolag som inte har arbetspensionsförsäkring. Om arbetsgivarens avgifter för den frivilliga individuella pensionsförsäkringen överstiger 8 500 euro, är de skattepliktig inkomst för vilken även arbetsgivarens socialförsäkringsavgifter\r
ska betalas. Om avgifterna överstiger 8 500\r
euro om året anmäler betalaren de överstigande\r
avgifterna som övriga naturaförmåner.\r
Exempel: Arbetsgivaren betalar 12 000 euro om året för\r
en individuell, frivillig pensionsförsäkring som tecknats\r
för en arbetstagare. Arbetsgivaren anmäler uppgifterna\r
på följande sätt:\r
• Försäkringsavgift för en individuell, frivillig\r
pensionsförsäkring 8 500 euro.\r
• Annan skattepliktig naturaförmån 3 500 euro.\r
I punkten anges endast avgifterna för den\r
individuella, frivilliga pensionsförsäkringen. Om\r
arbetsgivaren för arbetstagarens räkning betalat\r
arbetstagarens obligatoriska\r
pensionsförsäkringsavgifter,\r
arbetslöshetsförsäkringsavgifter och avgifter för\r
en frivillig pensionsförsäkring som arbetstagaren\r
själv tecknat anmäls dessa med inkomstslaget\r
Övriga naturaförmåner.`,
    taxAndSideCostsDescrEn: "",
    taxAndSideCostsDescrFi: "",
    taxAndSideCostsDescrSv: "",
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/pension"
    ],
    calcGrouping: "benefits"
  },
  {
    code: 419,
    nameEn: "Deduction before withholding",
    nameFi: "Vähennys ennen ennakonpidätystä",
    nameSv: "Avdrag före förskottsinnehållning",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !0,
    taxDefault: -1,
    transactionCode: "deductionBeforeWithholding",
    notSupportedError: null,
    descriptionEn: `A direct expense incurred when performing\r
work, which is paid by the employee and deducted from gross wages by the employer before determining the withholding tax. Such expenses include expenses paid by the income\r
earner that are incurred from the use of a\r
chainsaw, and other expenses arising from\r
tools. Similarly, business travel expenses are\r
such expenses, if the employer does not pay\r
tax-exempt allowance for them in addition to\r
wages.\r
The maximum amount of deduction that can\r
be reported is the amount of the payment.\r
Enter the deduction made before withholding\r
tax in this section. The share of the deductions must also be included in the wages reported using an income type.\r
Example: The employee has paid EUR 4,500 in expenses incurred from the use of a chainsaw. The annual wages paid to the employee are EUR 20,000, of\r
which the share of work performed with a chainsaw\r
is EUR 14,000. The employee has requested the deduction of operating expenses according to the 40%\r
rule, before the collection of tax to be prepaid from\r
the wages paid for work performed with a chainsaw,\r
i.e., EUR 5,600. Tax has been withheld from EUR\r
14,400 (20,000 - 5,600) in accordance with section\r
15 of the tax prepayment act (ennakkoperintälaki\r
1118/1996).\r
EUR 20,000 is reported using the Wages income\r
type, and EUR 5,600 is reported using the itemisation type Deduction before withholding. The employee must request a chainsaw deduction on their\r
pre-completed tax return form, and provide an account of the amount of wages paid for work performed with a chainsaw. In final taxation, the deduction is calculated from the share of the wages paid\r
for work performed with a chainsaw (EUR 14,000).\r
If the employer has paid the expenses incurred by\r
the use of a chainsaw, see the instructions for reporting this in the section: Taxable reimbursement of expenses.\r
Example: A folk musician is promised EUR 200 for a\r
gig. Travel and travel expenses do not affect the\r
gross amount paid. The travel expenses are thus not\r
reimbursed.\r
The employer can calculate the amount from which\r
to withhold tax by deducting the same amount as the tax-exempt reimbursable amount, based on an account given by the employee. For example, amounts\r
corresponding to travel expenses of 51 km x 43\r
cents per kilometre, or 21.93 cents, and a partial\r
daily allowance of EUR 20, leaving EUR 158.07 as\r
the amount subject to withholding. The employer's\r
health insurance contribution is also paid from the\r
same amount.\r
EUR 200 is reported using the Wages income type,\r
and EUR 41.93 is reported using the itemisation type\r
Deduction before withholding. No entries are made\r
using the income types of tax-exempt reimbursements of travel expenses.\r
The employee must request the deductions in their\r
tax return, and the deduction is usually lower than in\r
connection with withholding.\r
In certain situations laid down in the law, the\r
payer can also deduct such costs from the\r
athlete's fee before withholding that were paid\r
by the athlete himself or herself and that were\r
directly incurred from sports. Such a deduction made by the payer is reported using the\r
income type Deduction before withholding.\r
The share of the deductions must also be included in the fee reported using the Nonwage compensation for work income type.\r
The maximum amount of deduction that can\r
be reported is the amount of the payment\r
even if the expenses incurred by the athlete\r
are greater than the fee.\r
If the payer makes the deduction from income\r
that is not subject to social insurance contributions, the payer must submit the Type of insurance information entry for the Deduction before withholding income type. The default for\r
the Deduction before withholding income type is\r
that it is not subject to social insurance contributions. Regardless of this, the payer must provide\r
the Type of insurance information entry (Subject\r
to social insurance contributions: No) if the deduction is made from income that is not subject\r
to social insurance contributions.\r
Example: A third-party lecturer is paid a lecture fee of\r
EUR 1,000. The lecture fee is not subject to social insurance contributions. The lecturer has incurred EUR 150\r
in travel expenses. The payer does not separately reimburse the expenses; instead, the payer deducts the\r
amount of the expenses before withholding taxes. The\r
person's withholding rate is 30%. The payer withholds\r
taxes from EUR 850 and reports the data to the Incomes\r
Register as follows: • 214 Lecture fee: 1000.00\r
• 402 Withholding tax: 255.00\r
• 419 Deduction before withholding: 150.00\r
o Type of insurance information: Subject\r
to social insurance contributions –\r
Grounds for insurance contribution: No\r
If a single transaction includes the payment of\r
wages subject to social insurance contributions and such wages in accordance with section 13 of the tax prepayment act (ennakkoperintälaki 1118/1996) on which social insurance contributions are not based, and expenses which are deducted before withholding are allocated to either income, the payer\r
must specify the Type of insurance information. This allows the deduction to be allocated to the correct income type.\r
If, in a single transaction, the payer deducts expenses from income subject to social insurance\r
contributions and income from which no social\r
insurance contributions are paid, the payer must\r
report the deductions separately. Type of insurance information (Subject to social insurance\r
contributions: No) must be specified for the deduction made from income from which no social\r
insurance contributions are paid.\r
Example: A person is paid EUR 2,900 in monthly wages\r
and EUR 300 in waiting time compensation. The waiting\r
time compensation is not subject to social insurance\r
contributions. The person's withholding rate is 20%. The\r
person has EUR 45 in expenses allocated to the waiting\r
time compensation and EUR 100 in expenses allocated\r
to the time-rate pay. The employer deducts both parts\r
from the person's income prior to withholding taxes. The\r
payer reports the data to the Incomes Register as follows:\r
• 201 Time-rate pay: 2900.00\r
• 217 Waiting time compensation: 300.00\r
• 402 Withholding tax: 611.00\r
• 419 Deduction before withholding: 100.00\r
• 419 Deduction before withholding: 45.00\r
o Type of insurance information: Subject\r
to social insurance contributions –\r
Grounds for insurance contribution: No`,
    descriptionFi: `Työntekijän itsensä maksama työn tekemisestä aiheutunut välitön kustannus, jonka työnantaja vähentää bruttopalkasta ennen ennakonpidätyksen osuuden määrittämistä. Tällaisia kustannuksia ovat muun muassa palkansaajan maksamat kustannukset moottorisahan käytöstä ja muut työvälineistä aiheutuneet kustannukset. Samoin tällaisia kustannuksia ovat myös menot työmatkoista, jos työnantaja ei maksa niistä verovapaita korvauksia palkan lisäksi.\r
\r
Kohtaan merkitään vähennys, joka on tehty ennen ennakonpidätyksen toimittamista. Vähennysten osuuden tulee sisältyä myös tulolajilla ilmoitettuun palkkaan.\r
\r
**Esimerkki**: Työntekijä on maksanut itse moottorisahan käytöstä aiheutuneet 4 500 euron kustannukset. Työntekijälle maksettu koko vuoden palkka on 20 000 euroa, josta sahatyön osuus on 14 000 euroa. Työntekijä on vaatinut ennakkoperinnässä vähennystä käyttökustannuksista 40 %:n mukaisesti sahatyöstä maksetun palkan määrästä eli 5 600 euroa. Ennakonpidätys on toimitettu ennakkoperintälain (1118/1996) 15 § mukaisesti 14 400 eurosta (20 000 - 5 600).\r
\r
Palkan tulolajilla ilmoitetaan 20 000 euroa ja Vähennys ennen ennakonpidätystä -erittelylajilla ilmoitetaan 5 600 euroa. Työntekijän tulee vaatia esitäytetyllä veroilmoituksellaan moottorisahavähennystä ja selvittää sahatyöstä maksetun palkan määrä. Lopullisessa verotuksessa vähennys lasketaan sahatyöstä maksetun palkan (14 000 euroa) osuudesta.\r
\r
Jos työnantaja on maksanut moottorisahan käytöstä aiheutuneet kustannukset, katso ilmoittaminen kohdasta: Veronalaiset kustannusten korvaukset. \r
\r
**Esimerkki**: Pelimannille luvataan soittokeikasta 200 euroa. Matkustaminen ja matkustamisen kustannukset eivät vaikuta maksettavaan bruttomäärään. Matkakustannuksia ei siis korvata.\r
\r
Työnantaja voi laskea määrän, josta toimittaa ennakonpidätyksen siten, että vähentää työntekijän antaman selvityksen perusteella saman määrän, jonka voisi korvata verovapaasti. Esimerkiksi matkustamiskustannuksia 51 km x 41 snt/km eli 20,91 snt ja osapäivärahan 19 euroa vastaavat määrät, jolloin pidätyksenalaiseksi määräksi jää 160,09 euroa. Samasta määrästä maksetaan myös työnantajan sairausvakuutusmaksu. \r
\r
Palkan tulolajilla ilmoitetaan 200 euroa, Vähennys ennen ennakonpidätystä -erittelylajilla ilmoitetaan 39,91 euroa. Verovapaiden matkakustannusten korvausten tulolajeilla ei tehdä merkintöjä. \r
\r
Työntekijän on vaadittava vähennyksiä veroilmoituksessaan ja vähennys on yleensä alempi kuin ennakonpidätyksen yhteydessä.`,
    descriptionSv: `Direkt kostnad för utförande av arbetet som arbetstagaren betalar själv och som arbetsgivaren drar av från bruttolönen innan förskottsinnehållningens andel bestäms. Exempel på sådana kostnader är kostnader som löntagaren betalat för användning av motorsåg och andra arbetsredskap. Kostnader av den här typen är också utgifter för arbetsresor, om arbetsgivaren inte betalar skattefria ersättningar för dem utöver lönen. Som avdragsbelopp kan man anmäla ett belopp som är högst lika stor som prestationen. I punkten antecknas det avdrag som gjorts före verkställandet av förskottsinnehållningen. Avdragens andel ska även ingå i lönen som anmälts med inkomstslaget. Exempel: En arbetstagare har själv betalat kostnader på 4 500 euro som åsamkats honom för användningen av motorsåg. Arbetstagarens lön för hela året är 20 000 euro, varav sågarbetets andel är 14 000 euro. Arbetstagaren har yrkat på avdrag för driftskostnaderna vid förskottsuppbörden enligt 40 procent av den lön som betalats för sågarbetet, dvs. 5 600 euro. I enlighet med 15 § i lagen om förskottsuppbörd (1118/1996) har förskottsinnehållning verkställts på 14 400 euro (20 000 – 5 600). Med inkomstslaget Lön anmäls 20 000 euro och med\r
specifikationsslaget Avdrag före förskottsinnehållning 5\r
600 euro. Arbetstagaren bör yrka på avdrag för\r
användningen av motorsågen på den förhandsifyllda\r
skattedeklarationen och redogöra för beloppet av den\r
lön som betalats för sågarbetet. I den slutliga\r
beskattningen beräknas avdraget på den andel av lönen\r
som betalats för sågarbetet (14 000 euro).\r
Om arbetsgivaren har betalat kostnaderna för\r
användningen av motorsågen, kan du ta del av punkten:\r
Skattepliktiga kostnadsersättningar.\r
Exempel: En musiker utlovas 200 euro för en spelning.\r
Resorna och resekostnaderna påverkar inte det betalda\r
bruttobeloppet. Resekostnader ersätts med andra ord\r
inte.\r
Arbetsgivaren kan räkna ut det belopp på vilket\r
förskottsinnehållning verkställs så att den på basis av\r
arbetstagarens utredning avdrar samma belopp som\r
kan ersättas skattefritt. T.ex. belopp som motsvarar\r
resekostnader 51 km x 43 cent/km dvs. 21,93 cent och\r
partiellt dagtraktamente 20 euro, varvid\r
innehållningsbeloppet är 158,07 euro. Av detta belopp\r
betalas också arbetsgivarens sjukförsäkringsavgift.\r
Med inkomstslaget Lön anmäls 200 euro och med\r
specifikationsslaget Avdrag före förskottsinnehållning\r
41,93 euro. Inga anteckningar görs i inkomstslagen för\r
ersättningar för skattefria resekostnader.\r
Arbetstagaren ska yrka på avdragen i sin\r
skattedeklaration, och avdraget är i allmänhet lägre än i\r
samband med förskottsinnehållningen.\r
Betalaren kan i vissa lagstadgade situationer dra\r
av från en idrottares arvoden innan\r
förskottsinnehållningen verkställs sådana\r
kostnader som idrottaren själv har betalat och\r
som har direkt orsakats av idrott. Ett sådant\r
avdrag som betalaren genomfört anmäls med\r
inkomstslaget Avdrag före förskottsinnehållning.\r
Avdragens andel ska även ingå i lönen som\r
anmälts med inkomstslaget Arbetsersättning.\r
Som avdragsbelopp kan man anmäla ett belopp\r
som är högst lika stor som prestationen, även\r
om de kostnader som åsamkats idrottaren skulle\r
vara högre än arvodet.`,
    taxAndSideCostsDescrEn: `If the deduction before withholding is made from\r
income subject to all social insurance contributions, the payer does not need to specify the\r
Type of insurance information unless the payer also pays some other income not subject to social insurance contributions in the same transaction.\r
Example: A person is paid EUR 3,500 as monthly\r
wages. Her withholding rate is 25%. In her work, she\r
uses her own tools for which the employer does not pay\r
a separate compensation. The payer deducts EUR 30\r
for the use of the employee's own tools before withholding and withholds taxes from EUR 3,470. Because the\r
monthly wages paid are subject to all social insurance\r
contributions, the payer does not need to specify the\r
Type of insurance information.\r
The payer reports the data to the Incomes Register as\r
follows:\r
• 201 Time-rate pay: 3500.00\r
• 402 Withholding tax: 867.50\r
• 419 Deduction before withholding: 30.00`,
    taxAndSideCostsDescrFi: `Ilmoitettu summa vähentää ennakonpidätyksen ja sosiaalimaksujen pohjana olevaa palkkaa ja vähennetään oletuksena asiakasvaratilin kautta maksetusta palkasta.\r
\r
Jos samalla maksukerralla maksetaan sosiaalivakuutusmaksun alaista palkkaa ja sellaista EPL 13 §:n muista palkkaa, joka ei ole sosiaalivakuutusmaksujen perusteena ja jompaankumpaan tuloon kohdistuu kuluja, jotka vähennetään ennen ennakonpidätyksen toimittamista, maksajan on annettava tiedot palkoista kahdella eri ilmoituksella ja eriteltävä, kumpaan tuloon vähennys kohdistuu.`,
    taxAndSideCostsDescrSv: `Om betalaren gör ett avdrag från en sådan inkomst som inte är underställd socialförsäkringsavgifter, ska betalaren ange uppgiften Typ av försäkringsuppgift för inkomstslaget Avdrag före förskottsinnehållning. Det förvalda värdet för inkomstslaget Avdrag före förskottsinnehållning är att inkomstslaget inte är underställd socialförsäkringsavgifter. Trots det ska betalaren ange uppgiften Typ av försäkringsuppgift\r
(Underställd socialförsäkringsavgifter: Nej), om\r
avdraget görs från inkomst som inte är underställd\r
socialförsäkringsavgifter.`,
    isSupported: !0,
    paymentDefault: 0,
    usecases: [
      "https://palkkaus.fi/usecases/2019/deductions"
    ],
    calcGrouping: "deductions"
  },
  {
    code: 420,
    nameEn: "Reimbursement collected for bicycle benefit",
    nameFi: "Polkupyöräedusta peritty korvaus",
    nameSv: "Ersättning för cykelförmån",
    isNegativeSupported: !1,
    pensionInsurance: !1,
    accidentInsurance: !1,
    unemploymentInsurance: !1,
    healthInsurance: !1,
    insuranceInformationAllowed: !1,
    taxDefault: 0,
    transactionCode: "reimbursementCollectedForBicycleBenefit",
    notSupportedError: null,
    descriptionEn: `The deductible of a fringe benefit paid by the\r
employee from the euro value of a bicycle\r
benefit.\r
Part of the value of the bicycle benefit is taxexempt and part is taxable. EUR 1,200 of the\r
bicycle benefit is tax-exempt and any amount\r
in excess of this limit is a taxable fringe benefit. A report must always be submitted for a bicycle benefit, even when there is no taxable\r
benefit. Reimbursement collected for the benefit reduces the taxable amount of the benefit.\r
The employer may collect the deductible ofthe bicycle benefit from the net wages of the\r
employee.\r
The reporting of a bicycle benefit differs from\r
other fringe benefits, similarly to the reporting\r
of an employer-subsidised commuter ticket,\r
because the employer must deduct the reimbursement collected from the employee from\r
the share deemed to be wages. The remaining amount must be reported as the taxable\r
share deemed to be wages.`,
    descriptionFi: `Luontoisedun omavastuuosuus, jonka työntekijä maksaa polkupyöräedun euromääräisestä arvosta.\r
\r
Osa polkupyöräedun arvosta on verovapaata ja osa veronalaista. Polkupyöräedusta 1 200 euroa on verovapaata, ja ylittävä osa on veronalaista luontoisetua. Polkupyöräedusta on aina annettava ilmoitus, myös silloin kun verotettavaa etua ei ole. Edusta peritty korvaus alentaa verotettavan edun määrää.\r
\r
Työnantaja voi periä polkupyöräedun omavastuuosuuden työntekijän nettopalkasta.\r
\r
Polkupyöräedun ilmoittaminen poikkeaa muista luontoiseduista samalla tavalla kuin työsuhdematkalipun ilmoittaminen, koska työnantajan on vähennettävä polkupyöräedun palkaksi katsottavasta osuudesta työntekijältä perimänsä korvaus. Palkaksi katsottavana osuutena ilmoitetaan jäljelle jäävä määrä.`,
    descriptionSv: `Självriskandel för naturaförmån som arbetstagaren betalar för penningvärdet av cykelförmånen. En del av cykelförmånens värde är skattefritt och en del är skattepliktigt. Av cykelförmånen är 1 200 euro skattefritt och den överstigande delen skattepliktig naturaförmån. Det ska alltid lämnas in en anmälan om cykelförmånen, även när ingen beskattningsbar förmån existerar. Den ersättning som debiterats för förmånen minskar det beskattningsbara förmånsbeloppet. Arbetsgivaren kan ta ut självriskandelen för cykelförmånen av arbetstagarens nettolön. Anmälan av cykelförmån skiljer sig från övriga\r
naturaförmåner på samma sätt som anmälan av\r
personalbiljett, eftersom arbetsgivaren ska dra\r
av den ersättning som tas ut av arbetstagaren\r
från den andel av cykelförmånen som betraktas\r
som lön. Som andel som betraktas som lön\r
anmäls det återstående beloppet.`,
    taxAndSideCostsDescrEn: `If no benefit deemed to be wages is created,\r
the employer must deduct the reimbursement\r
collected from the employee from the tax-exempt share of the bicycle benefit. The remaining amount must be reported as the tax-exempt share of the bicycle benefit.`,
    taxAndSideCostsDescrFi: "Vähennetään oletuksena nettopalkasta. Ei vaikuta ennakonpidätykseen tai sosiaalimaksuihin, sillä summa pitää olla jo vähennetty kohdasta 364 'Polkupyöräedun palkaksi katsottu osuus'.",
    taxAndSideCostsDescrSv: "",
    isSupported: !0,
    paymentDefault: -1,
    usecases: [
      "https://palkkaus.fi/usecases/2019/benefits"
    ],
    calcGrouping: "deductions"
  }
], ui = { SALAXY: { CORE: { CalculationMappers: { preview: "Esikatselu", defaultMaterial: "Vakioaineisto" }, Taxcard2019Logic: { netSalary: "Käteen jäävä osuus", checkNewTaxcard: "Tarkista uusi verokortti", addNewTaxcard: "Uusi verokortti", noTaxcard: "Ei verokorttia", taxPercentBasic: "perusprosentti", taxPercentAdditional: "lisäprosentti", chartTitle: "Maksetut palkat ja vuosikohtainen tuloraja" }, WorkerTimeline: { shortMessages: { calculation: { workerRequested: "Lähetit palkkapyynnön työnantajalle {{name}}", workerRequestDeclined: "{{name}} hylkäsi lähettämäsi palkkalaskelman", workerRequestAccepted: "{{name}} hyväksyi lähettämäsi palkkalaskelman", draft: "Loit palkkalaskelman luonnoksen", paymentWorkerCopy: "{{name}} maksoi sinulle palkkaa", default: "TODO: calculation status {{status}}" }, personAccount: "Loit tunnuksen Palkkaus.fi-palveluun", employmentDefault: "{{name}} lisäsi sinut työntekijäksi", taxcard: { shared: "Jaoit verokortin", sharedApproved: "{{name}} hyväksyi jakamasi verokortin", sharedRejected: "{{name}} hylkäsi jakamasi verokortin", sharedWaiting: "{{name}} katsoi jakamasi verokortin (odottaa hyväksyntää)", approved: "{{name}} lisäsi uuden verokortin", verifiedVero: "Työnantajalle {{name}} haettiin verokortti verottajalta", default: "Verokortti: {{status}}" }, workerInvitation: "Palkanmaksu odottaa verokorttiasi.", timelineType: "Tietue: {{type}}" } }, HolidaysLogic: { draft: "Luonnos", paid: "Maksettu", bonus: "Lomaraha", salaryPeriod: "Palkkakausi", startSaldo: { displayName: "Käytettävissä olevat", description: "Lomanmääräytymisvuodella kertyneet lomat" }, total: { displayName: "Yhteensä", description: "Käytetyt/maksetut lomat" }, endSaldo: { displayName: "Maksettavaa tai siirrettävää", description: "Seuraavalle lomavuodelle tai maksettavaa" }, bonusStartSaldo: { displayName: "Käytettävissä olevat", description: "Lomanmääräytymisvuodella kertyneet lomat" }, bonusTotal: { displayName: "Yhteensä", description: "Käytetyt/maksetut lomarahat" }, bonusEndSaldo: { displayName: "Maksettavaa", description: "Maksettavaa lomarahaa" }, holidayYear: { day: "pv", accrualEndSaldo: "Lomapäivien kertymä", plannedSummerLeaves: "Kesälomat", plannedWinterLeaves: "Talvilomat", paidHolidays: "Lomapalkat ja -rahat" } }, IncomeTypesLogic: { incomeTypeMetaData: { desription: "Tätä riviä ei ilmoiteta tulorekisteriin. Tällaisia rivejä ovat esimerkiksi palkan yhteydessä.", taxAndSidecostsDescr: "Rivin summasta ai vähennetä ennakonpidätystä eikä työnantajan sosiaalivakuutusmaksuja." } }, WorkerMappers: { preview: "Esikatselu", defaultMaterial: "Vakioaineisto" }, CalcWorktime: { salaryPeriod: "Palkkakausi", startAndEndDates: "Alku- ja loppupäivät" }, Usecases: { travel: { shortText: "Matkalasku", description: "Matkalasku km-korvauksineen ja päivärahoineen niin, että tiedot ilmoitetaan automaattisesti tulorekisteriin ja kirjanpitoon.", legend: "Matkalaskun tiedot", startDate: "Matkan alku", endDate: "Matkan loppu", status: "Tila", rows: "Matkalaskun rivit", addRow: "Liää matkalaskun rivi" }, history: { shortText: "Palkkahistoria", title: "Muualla maksettu palkka", introText: "Tällä lomakkeella lisätä tai muokata muissa palkanmaksuohjelmissa laskettu ja maksettuja palkkoja, jotka on jo ilmoitettu tulorekisteriin.", description: "Muussa palkanmaksuohjelmissa laskettu ja maksettu palkka, joka on jo ilmoitettu tulorekisteriin.", legend: "Palkka-aineiston tiedot", status: "Tila", rows: "Palkkarivit", tableLegend: "Kumulatiivisen palkkalaskelman rivit", tableDescription: { html: "Alla näet kumulatiivisen palkkalaskelman rivit <strong>Vuoden alusta</strong>. Tähdellä* merkityt ovat näkyvissä myös edelliselle vuodelle." }, totalGrossSalary: "Bruttopalkka ilman luontoisetuja", benefits: "Luontoisedut", holidayCompensation: "Lomakorvaus", holidayBonus: "Lomaraha", holidaySalary: "Loma-ajan palkka", totalTaxable: "Ennakonpid. alainen ansio", tax: "Ennakonpidätys", pension: "Työeläkemaksu", unemploymentInsurance: "Työttömyysvakuutusmaksu", deductions: "Kaikki vähennykset palkasta", totalExpenses: "Verovapaat kustannukset", salaryPayment: "Rahana maksettu palkka" }, expenses: { title: "Kulukorvaus", shortText: "Kulukorvaukset", description: "Maksa kulukorvaus km-korvauksineen ja päivärahoineen niin, että tiedot ilmoitetaan automaattisesti tulorekisteriin ja kirjanpitoon.", legend: "Kuluaineiston tiedot", startDate: "Periodin alku", endDate: "Periodin loppu", status: "Tila", rows: "Kilukorvauksen rivit", addRow: "Liää Kilukorvauksen rivi" }, calcRow: { shortText: "Pikalaskuri", description: "Nopea rivipohjainen laskuri - kun tiedät mitä olet tekemässä.", legend: "Palkka-aineiston tiedot", rows: "Palkkarivit" }, default: { shortText: "Ohjaava laskuri", description: "Perinteinen peruslaskuri, joka ohjaa läpi palkkalaskelman luomisen 4 helpolla askeleella." } }, yearlyTaxfreeYears: { milage: { car: "Auto", carLimitedBenefit: "Auto, käyttöetu", custom: "Muu korvaus", carAdditions: { trailer: "Perävaunu", caravan: "Asuntovaunu", canteen: "Taukotupa", largeMachinery: "Suuret koneet", docInTheCar: "Koira autossa", contstructionSite: "Metsäautotie tms. suljettu työmaa" }, other: { motorboatUpTo50Hp: "Moottorivene, enintään 50 hv", motorboatOver50Hp: "Moottorivene, yli 50 hv", snowMobile: "Moottorikelkka", quadbike: "Mönkijä", motorcycle: "Moottoripyörä", moped: "Mopo", otherTransport: "Muu kulkuneuvo" } }, countries: { Afghanistan: "Afganistan", Albania: "Albania", Algeria: "Algeria", Andorra: "Andorra", Angola: "Angola", AntiquaAndBarbuda: "Antigua ja Barbuda", Argentina: "Argentiina", Armenia: "Armenia", Aruba: "Aruba", Australia: "Australia", Austria: "Itävalta", Azerbaidzhan: "Azerbaidžan", Azores: "Azorit", Bahamas: "Bahama", Bahrain: "Bahrain", Bangladesh: "Bangladesh", Barbados: "Barbados", Belarus: "Valko-Venäjä", Belgium: "Belgia", Belize: "Belize", Benin: "Benin", Bermuda: "Bermuda", Bhutan: "Bhutan", Bolivia: "Bolivia", BosniaAndHercegovina: "Bosnia ja Hertsegovina", Botswana: "Botswana", Brazil: "Brasilia", Brunei: "Brunei", Bulgaria: "Bulgaria", BurkinaFaso: "Burkina Faso", Burundi: "Burundi", Cambodia: "Kambodža", Cameroon: "Kamerun", Canada: "Kanada", CanaryIslands: "Kanarian saaret", CapeVerde: "Kap Verde", CentralAfricanRepublic: "Keski-Afrikan tasavalta", Chad: "Tšad", Chile: "Chile", China: "Kiina", HongKong: "Kiina: Hongkong", Colombia: "Kolumbia", Comoros: "Komorit", CongoBrazzaville: "Kongo (Kongo-Brazzaville)", CongoKinshasa: "Kongon demokraattinen tasavalta (Kongo-Kinshasa)", CookIslands: "Cookinsaaret", CostaRica: "Costa Rica", Croatia: "Kroatia", Cuba: "Kuuba", Curaçao: "Curaçao", Cyprus: "Kypros", CzechRepublic: "Tšekki", Denmark: "Tanska", Djibouti: "Djibouti", Dominica: "Dominica", DominicanRepublic: "Dominikaaninen tasavalta", EastTimor: "Itä-Timor", Ecuador: "Ecuador", Egypt: "Egypti", ElSalvador: "El Salvador", Eritrea: "Eritrea", Estonia: "Viro", Eswatini: "Eswatini", Ethiopia: "Etiopia", FaroeIslands: "Färsaaret", Fiji: "Fidži", France: "Ranska", Gabon: "Gabom", Gambia: "Gambia", Georgia: "Georgia", Germany: "Saksa", Ghana: "Ghana", Greece: "Kreikka", Greenland: "Grönlanti", Grenada: "Grenada", Guadeloupe: "Guadeloupe", Guatemala: "Guatemala", Guinea: "Guinea", GuineaBissau: "Guinea-Bissau", Guyana: "Guyana", Haiti: "Haiti", Honduras: "Honduras", Hungary: "Unkari", Iceland: "Islanti", India: "Intia", Indonesia: "Indonesia", Iran: "Iran", Iraq: "Irak", Ireland: "Irlanti", Israel: "Israel", Italy: "Italia", IvoryCoast: "Norsunluurannikko", Jamaica: "Jamaika", Japan: "Japani", Jordania: "Jordania", Kazakhstan: "Kazakstan", Kenya: "Kenia", NorthKorea: "Korean demokraattinen kansantasavalta(Pohjois-Korea)", SouthKorea: "Korean tasavalta (Etelä-Korea)", Kosovo: "Kosovo", Kuwait: "Kuwait", Kyrgystan: "Kirgisia", Laos: "Laos", Latvia: "Latvia", Lebanon: "Libanon", Lesotho: "Lesotho", Liberia: "Liberia", Libya: "Libya", Liechtenstein: "Liechtenstein", Lithuania: "Liettua", Luxembourg: "Luxemburg", Madagascar: "Madagaskar", Madeira: "Madeira", Malawi: "Malawi", Malaysia: "Malesia", Maldives: "Malediivit", Mali: "Mali", Malta: "Malta", MarshallIslands: "Marshallinsaaret", Martinique: "Martinique", Mauritania: "Mauritania", Mauritius: "Mauritius", Mexico: "Meksiko", Micronesia: "Mikronesia", Moldova: "Moldova", Monaco: "Monaco", Mongolia: "Mongolia", Montenegro: "Montenegro", Morocco: "Marokko", Mozambique: "Mosambik", Myanmar: "Myanmar (Burma)", Namibia: "Namibia", Nepal: "Nepal", Netherlands: "Alankomaat", NewZealand: "Uusi-Seelanti", Nicaragua: "Nicaragua", Niger: "Niger", Nigeria: "Nigeria", NorthMacedonia: "Pohjois-Makedonia", Norway: "Norja", Oman: "Oman", Pakistan: "Pakistan", Palau: "Palau", Palestinianterritory: "Palestiinalaisalue", Panama: "Panama", PapuaNewGuinea: "Papua-Uusi-Guinea", Paraguay: "Paraguay", Peru: "Peru", Philippines: "Filippiinit", Poland: "Puola", Portugal: "Portugal", PuertoRico: "Puerto Rico", Qatar: "Qatar", Romania: "Romania", RussianFederation: "Venäjä", Moscow: "Venäjä: Moskova", StPetersburg: "Venäjä: Pietari", Rwanda: "Ruanda", SaintKittsAndNevis: "Saint Kitts ja Nevis", SaintLucia: "Saint Lucia", SaintVincentAndTheGrenadines: "Saint Vincent ja Grenadiinit", Samoa: "Samoa", SanMarino: "San Marino", SaoTomeAndPrincipe: "São Tomé ja Príncipe", SaudiArabia: "Saudi-Arabia", Senegal: "Senegal", Serbia: "Serbia", Seychelles: "Seychellit", SierraLeone: "Sierra Leone", Singapore: "Singapore", Slovakia: "Slovakia", Slovenia: "Slovenia", SolomonIslands: "Salomonsaaret", Somalia: "Somalia", SouthAfrica: "Etelä-Afrikka", SouthSudan: "Etelä-Sudan", Spain: "Espanja", SriLanka: "Sri Lanka", Sudan: "Sudan", Suriname: "Suriname", Sweden: "Ruotsi", Switzerland: "Sveitsi", Syria: "Syria", Tadzhikistan: "Tadžikistan", Taiwan: "Taiwan", Tanzania: "Tansania", Thailand: "Thaimaa", Togo: "Togo", Tonga: "Tonga", TrinidadAndTobago: "Trinidad ja Tobago", Tunisia: "Tunisia", Turkey: "Turkki", Istanbul: "Turkki: Istanbul", Turkmenistan: "Turkmenistan", Uganda: "Uganda", Ukraine: "Ukraina", UnitedArabEmirates: "Arabiemiirikunnat", UnitedKingdom: "Britannia", LondonAndEdinburgh: "Britannia: Lontoo ja Edinburgh", UnitedStates: "Yhdysvallat", NewYorkLosAngelesWashington: "Yhdysvallat: New York, Los Angeles, Washington", Uruguay: "Uruguay", Uzbekistan: "Uzbekistan", Vanuatu: "Vanuatu", Venezuela: "Venezuela", Vietnam: "Vietnam", VirginIslands: "Neitsytsaaret (USA)", Yemen: "Jemen", Zimbabwe: "Zimbabwe", Zambia: "Sambia", Other: "Maa, jota ei ole erikseen mainittu" } } }, DOCS: { authorization: { common: { headerTitle: "Palkkaus.fi-palvelun valtakirja", title: "Valtakirja", authorizer: "Valtuuttaja", name: "Nimi", personalId: "Henkilötunnus", telephone: "Puhelinnumero", email: "Sähköpostiosoite", proxy: "Valtuutettu", payrollFinland: { officialName: "Suomen Palkanlaskenta Oy", serviceName: "Palkkaus.fi", address: "Kirkkokatu 1", zip: "00170", city: "Helsinki", companyIdLabel: "Y-tunnus", customerServiceLabel: "Asiakaspalvelu", customerServiceEmail: "aspa@palkkaus.fi" }, companyId: "Y-tunnus", contanctInfoSeeBelow: "Yhteystiedot valtakirjan alareunassa", body: { introPersonal: "Valtuutettu voi hoitaa puolestani palkkaamiseen, palkanmaksuun ja mahdollisesti saamiini palkkoihin liittyviä velvoitteita ja maksuja suhteessa viranomaisiin ja muihin tahoihin kuten esimerkiksi", introCompany: "Valtuutettu voi hoitaa valtuuttajan puolesta palkkaamiseen, palkanmaksuun ja palkkoihin liittyviä velvoitteita ja maksuja suhteessa viranomaisiin ja muihin palkkaamiseen liittyviin tahoihin kuten", subjects: { workers: "Työntekijät", workerAndEmployer: "Työntekijä ja työnantaja", tax: "Verohallinto ja tulorekisteri", taxHousehold: "Verohallinto ja tulorekisteri (sisältäen myös kotitalousvähennys)", pension: "Työeläkeyhtiöt", insurance: "Vakuutusyhtiöt", unemployment: "Työllisyysrahasto", unemploymentFunds: "Työttömyyskassat", banks: "Pankit ja maksuvälittäjät (liittyen tarvittaviin tilityksiin ja maksuihin)", union: "Työntekijäjärjestöt (työntekijän jäsenmaksu)" }, validIndefinitely: "Valtuutus on voimassa toistaiseksi alkaen", validIndefinitelyCompany: "Allekirjoituksellani vakuutan, että minulla on oikeus antaa tämä valtuutus valtuutetulle. Valtuutus on voimassa toistaiseksi alkaen", validIndefinitelyPrint: "Valtuutus on voimassa toistaiseksi.", signedAtPalkkaus: "Palkkaus.fi-palvelussa", signaturePrint: "Allekirjoitus (aika, paikka, nimenselvennys)" } }, palkkamylly: { headerTitle: "Palkkamyllyn valtakirja", signedAtPalkkamylly: "Palkkamylly.fi-sivustolla" } } }, EMAIL: { MailAfterPaymentHandledEmployer: { body: `Hei!\r
\r
Työntekijäsi on nyt saanut palkkansa, palkkalaskelma on täällä:\r
\r
[{0}]({0})\r
\r
Jos koet, että Palkkaus.fi on hyvä juttu, kerro meistä ystävillesi.\r
\r
Voit mennä [Facebook-sivuillemme tästä](https://www.facebook.com/Palkkaus). Twitterissä [olemme täällä](https://twitter.com/Palkkaus).\r
\r
[www.palkkaus.fi](https://www.palkkaus.fi)`, subject: "Maksoit palkan työntekijällesi" }, MailAfterPaymentHandledWorker: { body: `Hei!\r
\r
Sinulle on juuri maksettu palkkaa!\r
\r
Työnantajasi {0} {1} on maksanut palkan ja voit hakea sähköisen palkkatositteen Palkkaus.fi-palvelusta täältä:\r
\r
[{2}]({2})\r
\r
Nettopalkka on pankkitililläsi palkkatositteessa ilmoitettuna palkkapäivänä. \r
Jos et pääse itse hakemaan palkkatositetta palvelusta, työnantajasi voi toimittaa sen sinulle.\r
\r
[www.palkkaus.fi](https://www.palkkaus.fi)`, subject: "Sinulle on juuri maksettu palkkaa!" }, MailAfterPaymentHandledWorkerNew: { body: `Hei!\r
\r
Sinulle on juuri maksettu palkkaa!\r
\r
Työnantajasi {0} {1} on maksanut palkan. Voit hakea palkkatositteen sähköisesti Palkkaus.fi-palvelusta täältä. Palvelun käyttäminen tietoturvallisesti edellyttää kirjautumista ja tunnistautumista pankkitunnuksilla:\r
\r
[{2}]({2})\r
\r
Nettopalkka on pankkitililläsi palkkatositteessa ilmoitettuna palkkapäivänä.\r
Jos et pääse itse hakemaan palkkatositetta palvelusta, työnantajasi voi toimittaa sen sinulle.\r
\r
[www.palkkaus.fi](https://www.palkkaus.fi)`, subject: "Sinulle on juuri maksettu palkkaa!" }, SalaryRequestSentWorkerPalkkamylly: { body: `{0} on lähettänyt sinulle palkkalaskelman Palkkamylly-palveluun.\r
\r
{5}\r
\r
Palkkamyllyssä voit hyväksyä ja kuitata maksetuksi työntekijän toimittaman palkkalaskelman työnantajana. Palkkamyllyn kautta hoituu työnantajasuoritukset kätevästi: nettopalkka työntekijälle, ennakonpidätys Verohallinnolle, työeläkemaksut työeläkeyhtiölle ja työttömyysvakuutusmaksut Työllisyysrahastolle. Tieto maksetuista palkoista siirtyy Tulorekisteriin Palkkamyllyn kautta automaattisesti, kun palkkalaskelma on kuitattu maksetuksi. Maksut maksetaan asiakkaan oman verkkopankin kautta.\r
\r
Kirjaudu Palkkamylly-palveluun tästä linkistä:\r
\r
[{4}]({4})\r
\r
Jos et ole käyttänyt Palkkamyllyä työnantajana, valitse ensin Luo Tunnus.  \r
Kun kirjaudut Palkkamyllyyn, löydät palkkalaskelman etusivulta kohdasta "Saapuneet palkkalaskelmat". \r
\r
Lue tästä linkistä, miten palkanmaksu Palkkamyllyssä toimii:\r
\r
[{6}]({6})`, subject: "Työntekijäsi on lähettänyt palkkalaskelman" }, SalaryRequestSentWorkerCompany: { body: `{0} on lähettänyt sinulle palkkalaskelman Palkkaus.fi-palvelusta.\r
\r
- Palkkalaskelmassa bruttopalkka on {1} euroa.\r
- Kokonaiskustannus sinulle työnantajana on {2} euroa.\r
- Bruttopalkasta maksetaan verot, vähennykset ja korvaukset, jolloin työntekijälle maksetaan {3} euroa.\r
\r
{5}\r
\r
Voit hyväksyä palkkalaskelman työnantajana ja maksaa sen suoraan palvelussa.\r
\r
Kirjaudu Palkkaus.fi-palveluun tästä linkistä:\r
\r
[{4}]({4})\r
\r
Kun kirjaudut Palkkaus.fi-tilillesi, löydät palkkalaskelman palvelusta valitsemalla\r
työpöydältä Palkkalaskelmat -> Vastaanotetut.  \r
\r
Lue täältä ohje palkan maksamiseen Palkkaus.fi:ssä:  \r
\r
[Palkkalaskelman vastaanottaminen yrityksenä](https://help.palkkaus.fi/hc/fi/articles/360008942318)`, subject: "Työntekijäsi on lähettänyt palkkalaskelman" }, MailMonthlyReports: { body: `<p></p>\r
<p><b><span>Kirjanpitoraportit palkoista {0} - Palkkaus.fi: {3}</span></b></p>\r
<p><span>Hyvä asiakkaamme,</span></p>\r
<p>Liitteenä raportti {1}n palkkojen osalta toimitettavaksi kirjanpitoosi. Raportilla on Palkkaus.fi:n kautta maksettujen palkkojen kirjanpidon erittelyt.</p>\r
<p>Kuukausiraportit on ladattu myös palvelun Raportit-osioon.</p>\r
<p>Lähetämme raportit yhteysosoitteeksi merkittyyn sähköpostiin sekä kirjanpitäjällesi, mikäli yhteystiedot on laitettu palveluumme.</p>\r
<p>\r
    <b>Lähetämme raportin valitun oletustilikartan mukaisesti Excel-muodossa. Palkkaus.fi-oletusraportti pohjaa liikekirjuriin. Voit halutessasi vaihtaa oletustilikartan ohjelman asetuksissa, ja käytössäsi on useiden eri kirjanpito-ohjelmien tilikartat.</b>\r
</p>\r
<p>Ohjeet löytyvät tukisivustolta: <a href="https://help.palkkaus.fi/hc/fi/articles/4419457954961"\r
        target="_blank">Oletustilikartan vaihtaminen yrityksen asetuksissa</a></p>\r
<p>Muut raportit, kuten palkanmaksujen erittelyt, löydät myös Raportit-osiosta.</p>\r
<p>&nbsp;</p>\r
<p>\r
    <b><span>Tulorekisteri</span></b>\r
</p>\r
<p>Palkkaus.fi tekee automaattisesti palkkatietoilmoituksen tulorekisteriin\r
    palvelussa maksetuista palkoista. Teemme myös erillisilmoituksen kuukausittain automaattisesti.</p>\r
<p>Jos\r
    yrityksesi on työnantajarekisterissä, teemme myös Ei palkanmaksua -ilmoituksen niiltä kuukausilta, jolloin et ole\r
    maksanut palkkaa palvelussamme. Voit halutessasi muuttaa erillisilmoitusten lähettämisen asetuksia\r
    palvelussa.</p>\r
<p>Huomaathan, että tulorekisteri-ilmoitus tehdään sen päivän perusteella, jolloin nettopalkka maksetaan työntekijälle (palkkapäivä). Kirjanpitoraportit puolestaan muodostuvat sen perusteella, milloin palkan kokonaiskustannus on maksettu palvelussa (maksupäivä).</p>\r
<p>&nbsp;</p>\r
<p>\r
    <b><span>Tilitoimistosi kannattaa ottaa Palkkaus.fi käyttöön</span></b>\r
</p>\r
<p>Myös tilitoimisto voi käyttää Palkkaus.fi:tä ja hallinnoida omien asiakkaidensa palkkatietoja. Tilitoimisto näkee asiakkaan maksamat palkat ohjelmasta, voi laskea palkkoja itse ja saa haettua tarvitsemansa raportit itselleen sopivaan aikaan.</p>\r
<p>Lue lisää <a href="https://www.palkkaus.fi/tilitoimisto" target="_blank"> tilitoimiston\r
        palvelusta</a></p>\r
<p></p>\r
<p><span>Ystävällisin terveisin</span></p>\r
<p>\r
    <span>Palkkaus.fi<span> -tiimi</span></span>\r
</p>\r
<p></p>\r
<div>\r
    <font face="Times New Roman,serif" size="3"> <span style="font-size:12pt">\r
            <font face="Calibri,sans-serif" size="2" color="#1F497D"><span style="font-size:11pt">--</span>\r
            </font>\r
        </span></font>\r
</div>\r
<div>\r
    <font face="Times New Roman,serif" size="3"><span style="font-size:12pt">\r
            <font face="Calibri,sans-serif" size="2" color="#1F497D"><span style="font-size:11pt">Palkkaus.fi /\r
                    Asiakaspalvelu</span></font>\r
        </span></font>\r
</div>\r
<div>\r
    <font face="Times New Roman,serif" size="3"><span style="font-size:12pt"><a href="mailto:aspa@palkkaus.fi"\r
                target="_blank">\r
                <font face="Calibri,sans-serif" size="2"><span style="font-size:11pt">aspa@palkkaus.fi</span>\r
                </font>\r
            </a></span></font>\r
</div>\r
<div>\r
    <font face="Times New Roman,serif" size="3"> <span style="font-size:12pt"> <a href="http://www.palkkaus.fi/"\r
                target="_blank">\r
                <font face="Calibri,sans-serif" size="2"><span style="font-size:11pt">www.palkkaus.fi</span>\r
                </font>\r
            </a>\r
            <font face="Calibri,sans-serif" size="2" color="#1F497D"> <span style="font-size:11pt"> &nbsp;–\r
                    Uuden sukupolven palkanmaksuohjelma </span> </font>\r
        </span> </font>\r
</div>`, subject: "Kirjanpitoraportit palkoista {0} - Palkkaus.fi: {1}" }, SmsVerification: { body: "Vahvistuskoodi {0}", subject: "Puhelinnumeron todennus" }, MessageFromEmployee: { body: "Viesti työntekijältä" }, SharedCalcReminderPalkkamylly: { body: `Hei!\r
\r
Sinulla on hyväksymättömiä tai maksamattomia palkkalaskelmia Palkkamyllyssä.\r
\r
Kirjaudu käyttäjätilillesi ja hoida palkkalaskelmat.\r
\r
Terveisin,\r
\r
Palkkamylly-palkanmaksupalvelu\r
`, subject: "Palkkamyllyssä on palkkalaskelmia käsittelemättä" }, EprReminderPalkkamylly: { body: `Hei!\r
\r
Maksoit palkkaa Palkkamylly-palvelulla {0}. Palvelu tekee tulorekisteriin palkanmaksuun liittyvät tulorekisteri-ilmoitukset ylihuomenna.\r
\r
Jos et vielä tehnyt Palkkamyllystä saamiasi maksuja verkkopankissasi, kirjaudu välittömästi Palkkamyllyyn ja tee palkanmaksuun liittyvät maksut heti.\r
\r
Jos olet jo maksanut palkkaan liittyvät laskut, niin sinun ei tarvitse enää tehdä mitään.\r
\r
Terveisin,\r
\r
Palkkamylly-palkanmaksupalvelu\r
`, subject: "Viranomaisilmoitukset palkoista lähetetään kohta!" } }, ENUM: { ApiItemType: { undefined: { label: "Valitse..." }, calculation: { label: "Laskelma" }, calculationPaid: { label: "Maksettu laskelma" }, payrollDetails: { label: "Palkkalista" }, invoice: { label: "Lasku / palkanmaksu" }, earningsPaymentReport: { label: "Palkkatietoilmoitus tulorekisteriin" }, payerSummaryReport: { label: "Kuukausi-ilmoitus tulorekisteriin" }, employment: { label: "Työsuhde" }, messageThread: { label: "Viestiketju" }, calendarEvent: { label: "Kalenteritapahtuma" }, listItems: { label: "Lista (OData)" } }, CalendarActionType: { undefined: { label: "Valitse..." }, display: { label: "Notifikaatio" }, email: { label: "Sähköposti" }, audio: { label: "Ei käytössä: Ääniviesti" }, createItem: { label: "Tietueen luonti" }, script: { label: "Automaattinen skripti" }, paymentDate: { label: "Palkkapäivä" } }, Weekday: { day1: { label: "Maanantai", short: "Ma" }, day2: { label: "Tiistai", short: "Ti" }, day3: { label: "Keskiviikko", short: "Ke" }, day4: { label: "Torstai", short: "To" }, day5: { label: "Perjantai", short: "Pe" }, day6: { label: "Lauantai", short: "La" }, day7: { label: "Sunnuntai", short: "Su" } }, CalendarMonth: { month1: { label: "Tammikuu", short: "tammi" }, month2: { label: "Helmikuu", short: "helmi" }, month3: { label: "Maaliskuu", short: "maalis" }, month4: { label: "Huhtikuu", short: "huhti" }, month5: { label: "Toukokuu", short: "touko" }, month6: { label: "Kesäkuu", short: "kesä" }, month7: { label: "Heinäkuu", short: "heinä" }, month8: { label: "Elokuu", short: "elo" }, month9: { label: "Syyskuu", short: "syys" }, month10: { label: "Lokakuu", short: "loka" }, month11: { label: "Marraskuu", short: "marras" }, month12: { label: "Joulukuu", short: "joulu" } }, AbcSection: { association: { label: "Yhdistyksille" }, blog: { label: "Blogi" }, businessOwner: { label: "Yrittäjä" }, documentTemplates: { label: "Dokumenttipohjat ja lomakkeet" }, doNotShow: { label: "Ei näytetä käyttäjälle (vain Admin)" }, employee: { label: "Työntekijä" }, employment: { label: "Työsuhde ja työsopimus" }, entrepreneur: { label: "Yritys tai yhteisö" }, examples: { label: "Esimerkkejä palkkaustilanteista" }, householdEmployer: { label: "Kotitalous" }, instructionsAndExamples: { label: "Käyttöohjeet" }, insurance: { label: "Vakuutukset ja eläke" }, palkkausGeneral: { label: "Tietoa Palkkaus.fi -palvelusta" }, palkkausInstructions: { label: "Käyttöohjeita" }, personEmployer: { label: "Kotitalous työnantajana" }, press: { label: "Tiedotteet ja materiaali" }, productLongDescription: { label: "Tuotekuvaus" }, salary: { label: "Palkanlaskenta ja palkanmaksu" }, undefined: { label: "Uudet artikkelit / ei määritetty" }, worker: { label: "Työntekijälle" } }, AbsenceCauseCode: { undefined: { label: "Ei määritetty" }, accruedHoliday: { label: "Pekkasvapaa" }, annualLeave: { label: "Vuosiloma" }, childCareLeave: { label: "Hoitovapaa" }, childIllness: { label: "Lapsen sairaus tai pakottava perhesyy" }, illness: { label: "Sairaus" }, industrialAction: { label: "Lakko tai työsulku" }, interruptionInWorkProvision: { label: "Työtarjonnan keskeytyminen" }, jobAlternationLeave: { label: "Vuorotteluvapaa" }, layOff: { label: "Lomautus" }, leaveOfAbsence: { label: "Virkavapaa" }, midWeekHoliday: { label: "Arkipyhä" }, militaryRefresherTraining: { label: "Kertausharjoitus" }, militaryService: { label: "Varusmiespalvelus tai siviilipalvelus" }, occupationalAccident: { label: "Työtapaturma" }, other: { label: "Muu syy" }, parentalLeave: { label: "Äitiys-, isyys- ja vanhempainvapaa" }, partTimeAbsenceDueToRehabilitation: { label: "Osittainen poissaolo kuntoutuksen vuoksi" }, partTimeChildCareLeave: { label: "Osittainen hoitovapaa" }, partTimeSickLeave: { label: "Osa-aikainen sairauspoissaolo" }, personalReason: { label: "Henkilökohtainen muu syy" }, rehabilitation: { label: "Kuntoutus" }, specialMaternityLeave: { label: "Erityisäitiysvapaa" }, studyLeave: { label: "Opintovapaa" }, training: { label: "Koulutus" }, unpaidLeave: { label: "Palkaton loma / vapaa" } }, AgeGroupCode: { a: { label: "Ikäryhmä A" }, b: { label: "Ikäryhmä B" }, c: { label: "Ikäryhmä C" }, u: { label: "Ikäryhmä U" } }, AgeRange: { age_15: { label: "-15v" }, age16: { label: "16v" }, age17: { label: "17v" }, age18_52: { label: "18-52v" }, age53_62: { label: "53-62v" }, age63_64: { label: "63-64v" }, age65_67: { label: "65-67v" }, age68AndOVer: { label: "68v-" }, unknown: { label: "Ei tiedossa" } }, AllowanceCode: { expensesWorkingAbroad: { label: "Ulkomaan työskentelyyn liittyvät verovapaat korvaukset" }, fullDailyAllowance: { label: "Kokopäiväraha" }, internationalDailyAllowance: { label: "Ulkomaan päiväraha" }, mealAllowance: { label: "Ateriakorvaus" }, partialDailyAllowance: { label: "Osapäiväraha" } }, AnnualLeavePaymentKind: { draftCalc: { description: "Palkkalaskelman luonnos, jossa lomaan liittyviä maksuja", label: "Palkkalaskelman luonnos" }, endSaldo: { description: "Seuraavalle lomavuodelle tai maksettavaa", label: "Maksettavaa tai siirrettävää" }, info: { description: "Lomavuodella ei ole maksuja", label: "Ei rivejä" }, manualBonus: { description: "Lomaraha maksettuna erikseen erillisenä korjauksena", label: "Lomaraha" }, manualCompensation: { description: "Korvattavat lomapäivät ja niiden korvaus manuaalisena korjauksena", label: "Lomakorvaus" }, manualSalary: { description: "Pidetyt lomapäivät ja niiden palkka manuaalisena korjauksena", label: "Loma-ajan palkka" }, paidCalc: { description: "Palkkaus.fi-palvelussa maksettu palkka, jossa lomaan liittyviä maksuja", label: "Maksettu palkkalaskelma" }, startSaldo: { description: "Lomanmääräytymisvuodella kertyneet lomat", label: "Käytettävissä olevat" }, total: { description: "Käytetyt/maksetut lomapäivät, -rahat ja korvaukset", label: "Yhteensä" }, undefined: { description: "Rivin tyyppiä ei ole valittu", label: "Valitse..." } }, ApiTestErrorType: { default: { label: "Oletus" }, userFriendly: { label: "User Friendly" } }, ApiValidationErrorType: { general: { label: "Yleisvirhe" }, invalid: { label: "Virhe" }, required: { label: "Arvo puuttuu" }, warning: { label: "Varoitus" } }, AuthenticationMethod: { auth0Database: { label: "Sähköpostitunnistus" }, emailPwdLocal: { label: "Tietokanta" }, facebook: { label: "Facebook -tili" }, google: { label: "Google / Gmail authentication" }, internalLocalhost: {}, linkedIn: { label: "LinkedIn authentication" }, microsoft: { label: "Microsoft -tili" }, salaxy: { label: "Salaxy" }, test: {}, undefined: { label: "Tuntematon" }, x509: { label: "Sertifikaatti" }, webAuthn: { label: "Pääsyavain" }, googleOAuth: { label: "Google" }, microsoftOAuth: { label: "Microsoft" } }, AuthorizationStatus: { accessDenied: { label: "Pääsy kielletty" }, expiredOauthToklabel: "Istunto vanheutunut", invalidOAuthToklabel: "Virhe tunnistuksessa", noOauthToklabel: "Virhe tunnistuksessa (ei tokenia)", undefined: { label: "Ei määritetty" } }, AuthorizationType: { companyContract: { label: "Työnantajan sopimus" }, employerAuthorization: { label: "Valtakirja" }, manual: { label: "Valtakirja toimitettu erikseen" }, none: { label: "Ei tunnistettu" }, temporary: { label: "Temp tunnistus" }, workerContract: { label: "Työntekijän sopimus" }, partnerContract: { label: "Kumppanin hyväksymä työnantajan sopimus" } }, AvatarPictureType: { icon: { label: "Kuvake" }, uploaded: { label: "Kuva omalta koneelta" } }, BlobFileType: { authorizationPdf: { label: "Valtakirja" }, avatar: { label: "Ikoni" }, calcReport: {}, expensesReceipt: { label: "Kulukuitti" }, monthlyReport: { label: "Kuukausiraportti" }, raksaloki: { label: "Kulukuitti" }, taxCard: { label: "Verokortti" }, template: { label: "Kaavain" }, unknown: {}, yearlyReport: { label: "Vuosiraportti" } }, BlobRepository: { cdnImages: { label: "Content Delivery Network (CDN)" }, fileSystemContent: { label: "Content in local file system (localhost/dev/test only)" }, gitContent: { label: "Content in GIT" }, payload: { label: "Payload of large objects" }, reports: { label: "Backoffice reports" }, systemFiles: { label: "System Files" }, userFiles: { label: "User Files" }, versionHistory: { label: "Version History" } }, BoardKind: { undefined: { description: "Oletusarvo", label: "Oletusarvo" } }, BootstrapStyle: { default: { label: "Oletus" }, primary: { label: "Aktiivinen" }, success: { label: "Valmis" }, info: { label: "Tiedoksi" }, warning: { label: "Varoitus" }, danger: { label: "Virhe" } }, CalculationFlag: { accidentInsurance: { label: "Työtapaturma- ja ammattitautivakuutusmaksun alainen" }, cfDeduction: { label: "Vähennetään maksusta asiakasvaratililla" }, cfDeductionAtSalaxy: { label: "Vähennetään nettomaksusta asiakasvaratililtä työntekijälle" }, cfNoPayment: { label: "Ei makseta asiakasvaratilin kautta" }, cfPayment: { label: "Maksetaan asiakasvaratilin kautta" }, exclude: { label: "Ei käytetä laskelmalla" }, healthInsurance: { label: "Sairausvakuutusmaksun alainen" }, noTax: { label: "Ei vaikuta ennakonpidätykseen" }, pensionInsurance: { label: "Työeläkevakuutusmaksun alainen" }, tax: { label: "Lasketaan ennakonpidätykseen" }, taxDeduction: { label: "Vähentää ennakonpidätrystä" }, unemploymentInsurance: { label: "Työttömyysvakuutusmaksun alainen" } }, CalculationRowSource: { undefined: { label: "Oletusrivi" }, disabled: { label: "Ei käytössä" }, manualRow: { label: "Käsin lisätty rivi" }, worktimeImport: { label: "Työtuntien tuonti" }, priceEmployment: { label: "Hinta (työsuhteen oletus)" }, priceCompany: { label: "Hinta (yhtiön oletus)" }, copyEmployment: { label: "Kopioi työsuhteesta" }, copyCompany: { label: "Kopioi yhtiön asetuksista" }, customRowtype: { label: "Räätälöity palkkalaji" } }, CalculationRowType: { absencePeriod: { description: "Poissaolo", iconText: "PO", label: "Poissaolo" }, accomodationBenefit: { amountLabel: "Kuukausia", description: "Työnantajan maksaman asunnon verotusarvo.", iconText: "as", label: "Asuntoetu", priceLabel: "Asuntoetu / kk" }, advance: { description: "Palkasta on saatettu jo maksaa ennakkoa. Tällöin tämä osuus vähennetään maksettavasta nettomaksusta.", iconText: "adv", label: "Palkkaennakko", priceLabel: "Maksettu ennakko" }, bicycleBenefit: { description: "Polkupyöräetu vähennyksineen", iconText: "bic", label: "Polkupyöräetu", moreInfo: "Polkupyöräetu muodostuu, kun työnantaja antaa polkupyörän työntekijän yksityiskäyttöön. Pyörä voi olla työnantajan omistama tai hankittu leasingsopimuksella. Polkupyöräedusta on kyse myös silloin, jos työnantaja muulla vastaavalla tavalla järjestää työntekijälle mahdollisuuden käyttää polkupyörää vapaa-ajallaan. Polkupyöräedusta 1 200 euroa vuodessa on verovapaata tuloa, ja loput veronalaista luontoisetua.", priceLabel: "Polkupyöräedun arvo" }, board: { description: "Hallintoelimen jäsenyydestä maksettu palkkio", iconText: "hal", label: "Hallituspalkkio", moreInfo: "Luottamustoimipalkkio, joka maksetaan yhteisön hallituksen tai vastaavan hallintoelimen jäsenyyden perusteella. " }, carBenefit: { description: "Autoetu lisätietoineen ja vähennyksineen", iconText: "auto", label: "Autoetu", moreInfo: `Autoedulla tarkoitetaan verotettavaa etua, jonka työntekijä saa, jos saa käyttää työnantajan omistamaa tai hallinnoimaa (esim. leasing-auto) autoa työajojen lisäksi yksityisajoihin.\r
\r
Autoetu on palkanlisänä tiukasti säännelty. Sen arvo lasketaan verottajan laskentakaavalla ja sekä arvo että laskennan perusteet tulee ilmoittaa tulorekisteriin. Ilmoitus pitää tehdä myös silloin, jos työntekijä maksaa verotusarvosta korvauksen, jolloin verotettavaa tuloa ei synny. Ilmoitus tehdään lähtökohtaisesti palkkakausittain tai vähintään kuukausittain, jos muuta palkkaa ei makseta. Kilometrikohtaisessa laskennassa ilmoituksen saa vaihtoehtoisesti tehdä vain vuoden lopussa.\r
\r
Laskentakaava perustuu kahteen luokkaan: vapaa autoetu ja käyttöetu:\r
\r
- Vapaassa autoedussa työnantaja huolehtii kaikista auton käyttöön liittyvistä kustannuksista, kuten polttonesteistä, vakuutuksista, veroista, huolloista ja korjauksista.\r
- Käyttöedussa auton käyttäjä maksaa yksityisajojensa polttoainekustannukset, sopimuksen mukaan mahd. myös muita kustannuksia.\r
\r
Lisäksi laskentakaavaan tarvitaan auton hinta, lisävarusteiden hinta sekä ikäryhmä A, B tai C. Tyypillisesti arvo lasketaan kiinteällä 18 000 kilometrin vuosittaisella yksityisajolla. Jos yksityisajot ovat ilmiselvästi suuremmat, tulisi käyttää kilometreihin perustuvaa menetelmää. \r
\r
Autoedun verotusarvon laskuri löytyy osoitteesta: https://www.vero.fi/autoetulaskuri\r
\r
Vaihtoehtoisesti verotusarvon voi laskea kilometripohjaisesti. Tämä on edullisempaa, jos yksityisajon kilometrit ovat vähäiset, mutta erittäin työlästä, koska silloin yksityisajoista tulee pitää ajopäiväkirjaa ja nämä kilometrit pitää raportoida verottajalle. Jos käytetään kilometrikohtaista laskentaa, autoedun voi ilmoittaa vain kerran vuodessa: tyypillisesti vuoden viimeisellä palkkalaskelmalla.`, priceLabel: "Autoedun verotusarvo" }, chainsawReduction: { description: "Moottorisahavähennys erikoistapauksena (Ennakkoperintälaki 15 §, Ennakkoperintäasetus 18 §)", label: "Valitse...", priceLabel: "Määrä" }, childCareSubsidy: { description: "KELA:n ja kuntien työntekijälle suoraan maksama tuki lastenhoidosta.", iconText: "Kela", label: "Yksityisen hoidon tuki", moreInfo: "KELA:n maksama yksityisen hoidon tuki vaikuttaa sivukuihin, sillä työnantaja maksaa esim. työeläkkeen myös siltä osin. Tämä summa tulee riveinä työnantajan maksaman palkan päälle.", priceLabel: "KELA maksaa" }, compensation: { description: "Työstä, tehtävästä tai palveluksesta maksettu korvaus, joka ei ole palkkaa.", iconText: "T", label: "Työkorvaus", priceLabel: "Työkorvaus" }, dailyAllowance: { amountLabel: "Päiviä", description: "Päiväraha: kokopäiväraha (oletus) sekä muut päivärahat", iconText: "pv", label: "Päiväraha", moreInfo: `Päiväraha on korvaus kohtuullisesta ruokailu- ja muiden elinkustannusten lisäyksestä, jotka palkansaajalle aiheutuu työmatkasta. Kuitenkaan näihin kustannuksiin ei kuulu matkustamisesta (liput, kilometrit) eikä majoittumisesta aiheutuvia kustannuksia: Ne maksetaan tyypillisesti erikseen kuittien perusteella tai kilometrikorvauksina.\r
\r
Verohallinto määrittää päivärahan enimmäismäärät vuosittain. Usein käytetään näitä enimmäismääriä, mutta tämä ei ole mikään yleispätevä sääntö. Verottoman enimmäismäärän yrittävät summat tulee maksaa verotettavana palkkana tai työkorvauksena.\r
\r
Päivärahan saaminen edellyttää työ- tai virkamatkaa, joka suuntautuu yli 15 kilometriä työpaikalta tai kotoa riippuen siitä, kummasta alkaen matka tehdään. Osapäivärahaa maksetaan kotimaassa yli kuusi tuntia ja kokopäivärahaa yli 10 tuntia kestävältä työmatkalta. Päivärahan sijaan on myös mahdollista maksaa ateriakorvausta. Ateriakorvauksen saamisen edellytyksenä on, ettei matka oikeuta päivärahaan tai sitä ei muutoin makseta.`, priceLabel: "Euroa / päivä", btnText: "Päiväraha" }, dailyAllowanceHalf: { amountLabel: "Päiviä", description: "Päiväraha, kun työmatka on yli 6-10 tuntia.", iconText: "20", label: "Osapäiväraha", moreInfo: "Päivärahaa maksetaan 19 euroa, jos työmatka on yli 6 tuntia. Matkakohde pitää olla 15 km päässä joko asunnosta tai varsinaisesta työpaikasta.", priceLabel: "Euroa / päivä" }, deductibleOfExerciseAndCultureBenefit: { description: "Liikunta- ja kulttuuri-edun omavastuu (vähennetään nettopalkasta)", iconText: "cul", label: "Liikunta- ja kulttuuri -edun omavastuu", priceLabel: "Vähennys", moreInfo: `Erät, jotka palkan maksaja vähentää nettopalkasta ennen kuin maksaa suorituksen tulonsaajalle.\r
\r
Nettopalkasta voidaan vähentää suorituksia lain tai sopimuksen perusteella. Lain perusteella tehtäviä vähennyksiä ovat esimeriksi ulosmittaukset. Työnantaja voi kuitata omia saataviaan työntekijän palkasta. Työntekijän nettopalkasta voidaan vähentää maksuja, joiden perimisestä on työnantajan ja työntekijän kesken sovittu. Nettopalkasta vähennettäviä eriä ovat esim. työttömyyskassan ja ammattiyhdistysten jäsenmaksut sekä pysäköintihallimaksut.\r
\r
Jos ulosmittaus on jo ilmoitettu erikseen, ei sitä ilmoiteta enää tällä erittelylajilla yhteissummassa.
Vähennetään nettopalkasta - ei vaikuta ennakonpidätykseen tai sosiaalimaksuihin.` }, employmentTermination: { description: "Tulorekisterin tulolajeissa oleva työsuhteen päättämiseen liittyvä korvaus", iconText: "off", label: "Työsuhteen päättäminen" }, eveningAddition: { amountLabel: "Tuntia", description: "Korvaus iltatyöstä työsopimuksen tai työehtosopimuksen mukaan.", iconText: "ilta", label: "Iltalisä", priceLabel: "Lisä (per tunti)" }, expenses: { description: "Kulukorvaukset (esim. taksi, tarvikkeet) maksetaan yleensä kuittien perusteella.", iconText: "kulu", label: "Kulukorvaus", priceLabel: "Kulukorvaus", btnText: "Kulu" }, foreclosure: { description: "Työnantajan suoraan ulosottomiehelle maksama ulosottopidätys. Tehdään palkasta maksukiellon perusteella.", iconText: "ulos", label: "Ulosmittaus (työnantaja)", moreInfo: `Velallisen suojaosuuteen, 22,63 euroa päivässä, lisätään 8,12 euroa päivässä jokaisen hänen elatuksensa varassa olevan henkilön osalta. Velallisen elatuksen varassa olevien henkilöiden lukumäärä on mainittu maksukiellossa, jonka ulosottoviranomainen on lähettänyt palkan tai muun tulon maksajalle.\r
Suojaosuus lasketaan kertomalla päiväkohtainen suojaosuus palkanmaksukauden päivien lukumäärällä. Jos palkka tai muu tulo maksetaan kalenterikuukaudelta, päivien lukumäärä on aina 30.\r
Ulosmitattava määrä:\r
1. Jos palkka on pienempi kuin suojaosuus, siitä ei ulosmitata mitään.\r
2. Jos palkka ylittää suojaosuuden, mutta on enintään kaksi kertaa suojaosuus, ulosmitataan suojaosuuden ylittävästä palkasta kaksi kolmasosaa (tulorajaulosmittaus 2/3 x (palkka – suojaosuus)).\r
3. Jos palkka on suurempi kuin kaksi kertaa suojaosuus, mutta enintään neljä kertaa suojaosuus, ulosmitataan nettopalkasta yksi kolmasosa (1/3).\r
4. Jos palkka on suurempi kuin neljä kertaa velallisen suojaosuuden määrä ulosmitataan yksi kolmasosa neljä kertaa velallisen suojaosuuden määrää vastaavasta palkanosasta ja lisäksi neljä viidesosaa sen ylittävästä palkanosasta. Palkasta ulosmitataan kuitenkin enintään puolet.\r
`, priceLabel: "Summa" }, foreclosureByPalkkaus: { description: "Palkkaus.fi-palvelun maksama ulosottopidätys. Tehdään palkasta ulosottomiehen lähettämän maksukiellon perusteella.", label: "Ulosmittaus (Palkkaus.fi)" }, holidayBonus: { amountLabel: "Prosentti", description: "Työehtosopimuksissa (TES) määritetty lomaraha (ent. lomaltapaluuraha).", iconText: "bonus", label: "Lomaraha", priceLabel: "Loma-ajan palkka" }, holidayCompensation: { amountLabel: "Prosentti", description: "Korvaus loma-ajan palkasta, jos lomaa ei pidetä.", iconText: "%", label: "Lomakorvaus", priceLabel: "Palkkasumma" }, holidaySalary: { description: "Palkka loma-ajalta.", iconText: "loma", label: "Loma-ajan palkka", priceLabel: "Loma-ajan palkka" }, hourlySalary: { amountLabel: "Tunteja", description: "Palkanmaksu tehtyjen tuntien perusteella.", iconText: "h", label: "Tuntipalkka", priceLabel: "Tuntipalkka" }, hourlySalaryWithWorkingTimeCompensation: { amountLabel: "Tunteja", description: "Tuntipalkka ja lisä tehtyjen tuntien perusteella.", iconText: "h%", label: "Tuntipalkka ja lisä", priceLabel: "Tuntipalkka" }, irIncomeType: { description: "Erikseen syötetty tulorekisterin tulolaji, mikä ei sisälly muihin laskelman riveihin.", iconText: "katre", label: "Muu tulorekisterin tulolaji", moreInfo: "Laskelma luo automaattisesti tulorekisterin tulolajit kullekin riville rivin tyypin perusteella. Tällä palkkalajilla voi erikseen syöttää tulorekisterin tulolajin, mikä ei sisälly muihin laskelman riveihin." }, mealBenefit: { amountLabel: "Aterioita", description: "Työnantaja työntekijälleen tarjoama ateria. Myös lounassetelit.", iconText: "rav", label: "Ravintoetu", moreInfo: `Ravintoetu on luontoisetu, joka syntyy, kun työnantaja tarjoaa työntekijälleen aterian. Työnantaja voi tukea ruokailukustannuksia ruokailulipukkeella (Lounasseteli) tai muulla kohdennetulla maksuvälineellä taikka järjestämällä työpaikkaruokailun (sopimusruokailu).\r
\r
Ravintoedun verotusarvo määräytyy Verohallinnon päätöksen mukaisena vuosittain vahvistettavana arvona.\r
\r
Vaihtoehtona ravintoedulle on ateriakorvaus, joka maksetaan työmatkalla. Sen maksaminen edellyttää, että työmatkasta ei suoriteta päivärahaa ja että palkansaajalla ei työn vuoksi ole mahdollisuutta ruokailutauon aikana aterioida tavanomaisella ruokailupaikallaan. Ateriakorvaus on veroton etu (maksetaan työntekijälle), kun erilaiset ravintoedut ovat luontoisetuja (yritys maksaa kulun ja siitä osa on työntekijältä verotettavaa tuloa).\r
\r
Jos työntekijän palkanmaksupäivä on esimerkiksi kuukauden puolivälissä, tieto ravintoedun määrästä annetaan tulorekisteriin ennen kuin on varmuutta ravintoedun kokonaismäärästä kyseisenä kuukautena (esimerkiksi mahdolliset poissaolot eivät ole työnantajan tiedossa). Tämän vuoksi on katsottu riittäväksi, että ravintoetu täsmäytetään oikean suuruiseksi viimeistään seuraavalla palkkatietoilmoituksella. \r
\r
Joulukuun ravintoedun määrä on korjattava antamalla joulukuulle korvaava ilmoitus, jotta ravintoedun määrä korjaantuu oikealle verovuodelle. Tästä täsmäyksestä Palkkaus.fi antaa erillinen ohjeistuksen ennen vuodenvaihdetta.\r
\r
Jos ravintoetu toteutetaan saldoon perustuvaa maksuvälinettä käyttäen (esimerkiksi maksukortti), täsmäytys on tehtävä vähintään vuoden viimeisellä palkkatietoilmoituksella.`, priceLabel: "Arvo" }, mealCompensation: { amountLabel: "Päiviä", description: "Ateriakorvauksen voi maksaa työmatkoilta, joilta ei makseta päivärahaa.", iconText: "ater", label: "Ateriakorvaus", priceLabel: "Korvaus / päivä" }, milageDaily: { amountLabel: "Päiviä", description: "Kilometrikorvaus määritetään monissa TES:ssa päiväkohtaisina summina.", iconText: "km", label: "Kilometrikorvaus, päiväkohtainen", moreInfo: "Esim. Rakennusalan työehtosopimuksissa on päiväkohtaiset taulukot, joiden perusteella maksetaan kilometrikorvauksia.", priceLabel: "Korvaus / päivä" }, milageOther: { amountLabel: "Päiviä", description: "Kilometrikorvaus jollain muulla perusteella.", iconText: "km", label: "Kilometrikorvaus, muu peruste", priceLabel: "Korvaus / päivä" }, milageOwnCar: { amountLabel: "Kilometriä", description: "Kilometrikorvaus oman auton käytöstä.", iconText: "km", label: "Kilometrikorvaus, oma auto", priceLabel: "Korvaus / km", btnText: "Kilometrikorvaus" }, monthlySalary: { amountLabel: "Kuukausia", description: "Kiinteä kuukausipalkka.", iconText: "kk", label: "Kuukausipalkka", priceLabel: "Kuukausipalkka" }, nightimeAddition: { amountLabel: "Tuntia", description: "Korvaus yötyöstä työsopimuksen tai työehtosopimuksen mukaan.", iconText: "YÖ", label: "Yölisä", priceLabel: "Lisä (per tunti)" }, nonProfitOrg: { description: "Yleishyödylliset yhteisön vapaaehtoistyöhön osallistuvalle maksama päiväraha tai kilometrikorvaus.", iconText: "NPO", label: "Yleishyödyllisen yhteisön päiväraha ja km-korvaus", moreInfo: `Yleishyödylliset yhteisöt voivat maksaa korvauksettomaan vapaaehtoistyöhön osallistuvalle päivärahaa tai kilometrikorvausta.\r
\r
HUOM: Tällä käyttöliittymällä ilmoitetaan vain vapaaehtoistyöhön liittyvät korvaukset. Jos korvaukset liittyvät työsuhteeseen / palkkaan, korvaukset tulee ilmoittaa erikseen kohdissa Kilometrikorvaus ja Päiväraha (kokopäiväraha tai osapäiväraha). Jos yhdistys ei ole verottajan määrittelemällä tavalla yleishyödyllinen, työsuhteen ulkopuoliset korvaukset, myös vapaaehtoistyöstä, tulee tilittää ennakonpidätyksen alaisena työkorvauksena. Vastaanottaja voi sitten vähentää ne omassa verotuksessaan.\r
\r
Ilmoitettava tulo on määritetty tuloverolain 71 § 3 momentissa: \r
\r
Päivärahan voi maksaa enintään 20 päivältä per kalenterivuosi ja lisäksi majoittumiskorvaus (tositteen perusteella).\r
\r
Kilometrikorvausten osalta voidaan maksaa matkustamiskustannusten korvaus. Toisin kuin tavallisessa kilometrikorvauksessa, tämä voidaan maksaa myös verovelvollisen asunnolta tehdystä matkasta. Muulla kuin julkisella kulkuneuvolla tehdystä matkasta on verovapaata enintään 3 000 euroa kalenterivuodelta.\r
\r
Tässä kohdassa ilmoitetaan vain verovapaat määrät. Jos yleishyödyllinen yhteisö maksaan päivärahaa enemmän kuin yllä, ylimenevä osa ilmoitetaan työkorvauksena. Palkkaus.fi ei tarkkaile näitä rajoja, vaan työnantajan tulee huolehtia tästä itse.` }, otherAdditions: { description: "Muut sovitut aikaperusteiset lisät.", iconText: "lis", label: "Muut lisät", priceLabel: "Euroa" }, otherBenefit: { amountLabel: "Kuukausia", description: "Muu työnantajan maksama verotettava etu.", iconText: "etu", label: "Muu etu", priceLabel: "Muu etu € / kk" }, otherCompensation: { description: "Tulorekisterin tulolajeissa oleva muu korvaus tai palkkio", iconText: "muu", label: "Muu palkkio tai korvaus" }, otherDeductions: { description: "Muu vähennys, joka pienentää työntekijälle maksettavan nettopalkan määrää.", iconText: "muu", label: "Muu vähennys", priceLabel: "Vähennys" }, overtime: { amountLabel: "Prosentti", description: "Ylityökorvaukset", iconText: "yli", label: "Ylityöt", priceLabel: "Palkkasumma" }, paidSickLeave: { description: "Sairausajan palkka", iconText: "Sp", label: "Palkallinen sairauspoissaolo" }, paidSickLeaveHourlySalary: { amountLabel: "Tunteja", description: "Sairausajan palkka, palkanmaksu tehtyjen tuntien perusteella.", iconText: "Sh", label: "Palkallinen sairauspoissaolo, tuntipalkka", priceLabel: "Tuntipalkka" }, paidSickLeaveMonthlySalary: { amountLabel: "Kuukausia", description: "Sairausajan palkka, kiinteä kuukausipalkka.", iconText: "Skk", label: "Palkallinen sairauspoissaolo, kuukausipalkka", priceLabel: "Kuukausipalkka" }, paidSickLeaveSalary: { description: "Sairausajan palkka, kertakorvaus.", iconText: "Sp", label: "Palkallinen sairauspoissaolo, kertakorvaus", priceLabel: "Palkka tai palkkio" }, phoneBenefit: { amountLabel: "Kuukausia", description: "Puhelimen verotusarvo, jonka verottaja määrittää vuosittain.", iconText: "20", label: "Puhelinetu", priceLabel: "Puhelinetu / kk" }, prepaidExpenses: { description: "Kulukorvaus, mikä on jo maksettu ennakkoon työntekijälle. Vähentää työntekijälle maksettavien kulukorvausten määrää.", iconText: "ek", label: "Ennakkoon maksettu kulukorvaus", priceLabel: "Maksettu ennakko" }, remuneration: { description: "Tulorekisterin tulolajeissa oleva kertaluonteinen palkkio", iconText: "ker", label: "Kertaluonteinen palkkio" }, salary: { description: "Kertakorvaus työstä. Suorituspalkka, joka maksetaan ennalta sovitun työkokonaisuuden suorittamisen perusteella. Urakkapalkkaan sisältyy sekä kiinteä että muuttuva osa.", iconText: "P", label: "Urakkapalkka (palkka tai palkkio)", priceLabel: "Palkka tai palkkio", btnText: "Palkkio" }, saturdayAddition: { amountLabel: "Prosentti", description: "Lisä lauantaina tehdystä työstä työ- tai työehtosopimuksen mukaan.", iconText: "LA", label: "Lauantailisä", priceLabel: "Palkkasumma" }, service: { description: "Erillinen palvelumaksu", iconText: "P", label: "Palvelumaksu", priceLabel: "Palvelumaksu" }, subsidisedCommute: { description: "Työnantajan työntekijälle kustantaman ja hankkima julkisen liikenteen henkilökohtainen joukkoliikennelippu, josta osa on verovapaata.", iconText: "bus", label: "Työsuhdematkalippu", moreInfo: `Työsuhdematkalippu on työnantajan työntekijälle kustantaman ja hankkima julkisen liikenteen henkilökohtainen joukkoliikennelippu. Osa työsuhdematkalipun arvosta on verovapaata ja osa veronalaista: Verovapaata on 0 - 3 400€ vuonna 2022. Palkkaus.fi-palvelu laskee verovapaan ja veronalaisen palkan lipun hinnan perusteella. Lisäksi otetaan huomioon työntekijän mahdollisesti työnantajalle maksama korvaus. Kaikki nämä tiedot täytyy ilmoittaa erikseen verottajalle / tulorekisteriin. \r
\r
Jos palkansaaja ostaa matkalipun itse ja työnantaja maksaa työntekijälle matkalipun hinnan tai osan siitä, työnantajan maksama korvaus katsotaan kokonaisuudessaan työntekijän palkaksi. Tällöin työntekijälle maksettu lipun hinta ilmoitetaan vain palkkana.\r
\r
Matkalippu on yleensä voimassa vuoden ja siksi työsuhdematkalipussa veronalaisen ja verovapaan edun määriä arvioidaan vuositasolla (toisin kuin muissa luontoiseduissa kuukausitasolla). \r
\r
Jos kuitenkin korvausta peritään työntekijän palkasta säännöllisesti koko vuosi (esim. kerran kuussa) voi maksaja jo etukäteen ennakoida tilanteen ja jakaa verovapaan osuuden koko vuodelle ja ilmoittaa sen kuukausittain tulorekisteriin samassa yhteydessä perimänsä korvauksen kanssa. Tämä siitä huolimatta, että työsuhdematkalippu annettaisiin kerran vuodessa.\r
\r
Jos haluat toteuttaa tämän jaon, sinun tulee asettaa kohta ”Jaetaanko korvaus palkkajaksoihin?” arvoksi Kyllä ja määrittää jaksojen määrä (oletus 12 kuukautta). Palkkaus.fi-palvelu ei tässä versiossa tarkkaile, että vuodessa kaikki jaksot tulee ilmoitettua oikein, joten sinun tulee vuoden lopussa tarkistaa, että kaikki työsuhdematkalipun osat on ilmoitettu. Erityisen huolellisesti pitää tarkistaa, jos vaihdat jaksojen määrää kesken vuotta (ei suositeltavaa). Ota tarvittaessa yhteyttä Palkanlaskijaasi tai Palkkaus.fi-asiakaspalveluun.`, priceLabel: "Lipun hinta" }, sundayWork: { description: "Lain määrittämä 100% korotus sunnuntailta ja pyhäpäiviltä.", iconText: "SU", label: "Sunnuntai- / pyhätyö", priceLabel: "Palkkasumma" }, tesWorktimeShortening: { amountLabel: "Prosentti", description: "Erillinen palkanosa on määritetty rakennusalan työehtosopimuksissa.", iconText: "TES", label: "Erillinen palkan osa (Raksa)", moreInfo: 'Ne ovat pääosin yleissitovia ja koskevat myös yksityishenkilöä. Entinen työajan lyhennysraha / "pekkaset".', priceLabel: "Palkkasumma" }, toolCompensation: { amountLabel: "Päiviä", description: "Työvälinekorvaus on määritetty joissakin työehtosopimuksissa (esim. Raksa TES).", iconText: "tool", label: "Työvälinekorvaus", priceLabel: "Korvaus / päivä" }, totalEmployerPayment: { description: "Laskee palkan kokonaiskustannuksena: Mitä palkanmaksu maksaa sivukuluineen työnantajalle. Lopputulos on kertakorvaus.", iconText: "sum", label: "Kokonaiskustannus" }, totals: { label: "Yhteensä" }, totalWorkerPayment: { description: "Palkan laskenta annetun summan perusteella", iconText: "net", label: "Nettopalkka", moreInfo: "Palkan laskenta annetun summan perusteella" }, training: { description: "Koulutusajan palkka", iconText: "Kp", label: "Koulutus" }, trainingHourlySalary: { amountLabel: "Tunteja", description: "Koulutusajan palkka, palkanmaksu tehtyjen tuntien perusteella.", iconText: "Kh", label: "Koulutusaika, tuntipalkka", priceLabel: "Tuntipalkka" }, trainingMonthlySalary: { amountLabel: "Kuukausia", description: "Koulutusajan palkka, kiinteä kuukausipalkka.", iconText: "Kkk", label: "Koulutusaika, kuukausipalkka", priceLabel: "Kuukausipalkka" }, trainingSalary: { description: "Koulutusajan palkka, kertakorvaus.", iconText: "Kp", label: "Koulutusaika, kertakorvaus", priceLabel: "Palkka tai palkkio" }, unionPayment: { description: "Työnantajan tulee maksaa AY-jäsenmaksu suoraan liitolle, jos työntekijä näin toivoo.", iconText: "AY", label: "Ay-jäsenmaksu", moreInfo: `Työnantaja voi vähentää AY-jäsenmaksun suoraan työntekijän palkasta ja tilittää sen ammattiliitolle. Vähentäminen tapahtuu työntekijän pyynnöstä / suostumuksella. AY jäsenmaksu vähennetään työntekijän nettopalkasta.

Menettelystä on saatettu sopia työehtosopimuksessa, jolloin AY-jäsenmaksun tilittäminen saattaa olla työnantajan velvollisuus. Siitä, koskeeko velvollisuus vain järjestäytyneitä työnantajia, ei tätä kirjoitettaessa ole täyttä varmuutta: Asiasta on eri mielipiteitä ja siitä ei ole oikeustapausta.

Tyypillisesti tilanne on Palkkaus.fi-asiakkailla (pienillä yrityksillä) harvinainen ja siksi AY-jäsenmaksuja ei toistaiseksi hoideta Palkkaus.fi-palvelun kautta: Työnantajan tulee itse hoitaa jäsenmaksun tilitys suoraan liittoon. Näin vähennettävä summa vähennetään Palkkaus.fi-palvelun asiakasvaratilille maksettavasta summasta. Lisätietoja ilmoittamisesta ja maksamisesta saat kyseisestä liitosta.` }, unknown: { amountLabel: "Määrä", description: "Rivin tyyppiä ei ole vielä määritetty.", iconText: "?", label: "Valitse...", priceLabel: "Hinta" }, workingTimeCompensation: { description: "Tulorekisterin tulolajeissa oleva aikaperusteinen lisä ", iconText: "lisä", label: "Aikaperusteinen lisä" }, taxAtSource: { description: "Lähdevero ja lähdeverovähennys (rajoitetusti verovelvollinen)", iconText: "tax", label: "Lähdevero", priceLabel: "Palkkasumma", amountLabel: "Prosentti" }, taxWithholding: { description: "Ennakkoperintä, jossa suorituksen maksaja vähentää verovelvolliselle maksettavasta rahamäärästä ennakonpidätysprosentin mukaan lasketun veron.", iconText: "tax", label: "Ennakonpidätys" } }, CalculationRowUnit: { count: { label: "kpl" }, days: { label: "päivää" }, kilometers: { label: "km" }, percent: { label: "%" }, undefined: { label: "-" }, hours: { label: "h" } }, CalculationStatus: { draft: { label: "Luonnos" }, paymentCanceled: { label: "Maksu peruttu" }, paymentError: { label: "Virheitä" }, paymentRefunded: { label: "Maksu palautettu" }, paymentStarted: { label: "Maksu aloitettu" }, paymentSucceeded: { label: "Maksettu" }, paymentWorkerCopy: { label: "Työntekijän kopio" }, payrollDraft: { label: "Luonnos" }, proDraft: { label: "Oma luonnos (pro)" }, sharedApproved: { label: "Hyväksytty jaettu laskelma" }, sharedRejected: { label: "Hylätty jaettu laskelma" }, sharedWaiting: { label: "Vastaanotettu jaettu laskelma" }, history: { label: "Palkkahistoria (muualla laskettu)" }, template: { label: "Toistuva laskelma" }, workerRequestAccepted: { label: "Työntekijän tekemä, hyväksytty" }, workerRequestDeclined: { label: "Työntekijän tekemä, hylätty" }, workerRequested: { label: "Työntekijän tekemä" }, waitingApproval: { label: "Yrityksen tarkistuksessa" }, repair: { label: "Laskelman korjaus" }, paymentRepaired: { label: "Korvattu" } }, CarBenefitCode: { fullCarBenefit: { label: "Vapaa autoetu" }, limitedCarBenefit: { label: "Käyttöetu" } }, CarBenefitKind: { fullCarBenefit: { description: "Työnantaja huolehtii kaikista auton käyttöön liittyvistä kustannuksista", label: "Vapaa autoetu" }, limitedCarBenefit: { description: "Auton käyttäjä maksaa yksityisajojensa polttoainekustannukset", label: "Käyttöetu" }, undefined: { description: "Autoedun tyypin valinta on pakollinen", label: "Ei valintaa" } }, CompanyType: { fiOy: { label: "Osakeyhtiö, myös asunto-osakeyhtiö ja Oyj" }, fiRy: { label: "Yhdistys" }, fiTm: { label: "Yksityinen elinkeinonharjoittaja tai Maatalousyrittäjä" }, fiYy: { label: "Muu, esim. Kommandiittiyhtiö, Avoin yhtiö," }, unknown: {} }, ContractPartyType: { customContact: { label: "Custom Contact" } }, DailyAllowanceKind: { fullDailyAllowance: { description: "Päiväraha, kun työmatka on yli 10 tuntia.", label: "Kokopäiväraha" }, internationalDailyAllowance: { description: "Päiväraha ulkomaanmatkoilla", label: "Ulkomaan päiväraha" }, mealAllowance: { description: "Ateriakorvauksen voi maksaa työmatkoilta, joilta ei makseta päivärahaa. Ateriakorvauksen enimmäismäärä on 10,75€ per ateria, 2 ateriaa per päivä (21,50 € per päivä).", label: "Ateriakorvaus" }, partialDailyAllowance: { description: "Päiväraha, kun työmatka on 6-10 tuntia.", label: "Osapäiväraha" }, undefined: { description: "Ei valintaa, oletus kokopäiväraha", label: "Ei valintaa" } }, DateOfBirthAccuracy: { ageBased: { label: "Iän perusteella" }, ageGroupBased: { label: "Ikäluokan perusteella" }, assumption: { label: "Oletus" }, exact: { label: "Täsmällinen päivämäärä" }, monthCorrect: { label: "Kuukausi oikea" }, verified: { label: "Vahvistettu" } }, EmployerType: { fullTimeEmployer: { label: "Jatkuva sopimus tai yli 8178€ / 6kk" }, miniEmployer: { label: "Alle 1400€ / vuosi" }, smallEmployer: { label: "Väh. 1400€ / vuosi" }, tyelOwnContractEmployer: { label: "TyEL-vuosisopimus tai hoitaa itse." }, unknown: { label: "Ei tiedossa" } }, EmploymentContract: { annualLeave: { label: "Vuosiloma" }, benefitsException: { label: "Benefits" }, noticeException: { label: "Irtisanomisaika" }, otherTerms: { label: "Muut sopimusehdot" } }, EmploymentRelationTaxcard: { undefined: { label: "Ei valintaa" }, manual: { label: "Syötä verokortin tiedot käsin" }, auto: { label: "Hae automaattisesti verottajalta (API)" }, latest: { label: "Käytä viimeisintä lisättyä verokorttia" }, taxAtSource: { label: "Lähdevero" }, noTaxCard: { label: "Ei verokorttia (60%)" } }, EmploymentRelationType: { athlete: { label: "Urheilija", salaryRowMessage: "Urheilijan palkka" }, boardMember: { label: "Hallituksen jäsen" }, compensation: { label: "Suoritus työkorvauksena" }, employedByStateEmploymentFund: { label: "Valtion työllisyysmäärärahoilla työllistetty (palkkatuki)" }, entrepreneur: { label: "Yrittäjä tai yrittäjän perheenjäsen" }, entrepreneurNew: { label: "Yrittäjä, osaomistaja tai yrittäjän perheenjäsen" }, farmer: { label: "Maatalousyrittäjä tai perheenjäsen" }, hourlySalary: { label: "Tuntipalkkainen työntekijä" }, foreignWorker: { label: "Ulkomainen työntekijä (Suomessa)" }, workingAbroad: { label: "Lähetetty työntekijä (Ulkomailla)" }, monthlySalary: { label: "Kuukausipalkkainen työntekijä" }, performingArtist: { label: "Esiintyvä taiteilija" }, salary: { label: "Keikkatyöntekijä (kertaluonteinen työ)" }, undefined: { label: "Muu" } }, EmploymentRelationStatus: { unknown: { label: "Tuntematon" }, primary: { label: "Ensisijainen" }, secondaryCurrent: { label: "Toissijainen" }, archived: { label: "Arkistoitu" } }, EmploymentSalaryType: { hourlyPay: { label: "tuntipalkka", metricAbbrev: "/h" }, montlyPay: { label: "kuukausipalkka", metricAbbrev: "/kk" }, otherPay: { label: "muu" }, unknown: { label: "Valitse..." } }, EmploymentTerminationKind: { monetaryWorkingTimeBankCompensation: { description: "Palkka, joka maksetaan työaikapankkiin säästetyn ajan perusteella.", label: "Työaikapankin rahakorvaus" }, noticePeriodCompensation: { description: "Korvaus, jonka työnantaja maksaa työntekijälle palvelussuhteen päättyessä ilman irtisanomisaikaa eli tilanteessa, jossa jätetään irtisanomisaika noudattamatta ja työsuhde päättyy heti (TSL 6:4). Tulolajilla ilmoitetaan myös korvaus, jonka työnantaja maksaa, kun työntekijä irtisanoutuu yli 200 päivää kestäneen lomautuksen johdosta sekä, kun työnantaja irtisanoo lomautettuna olevan työntekijän.", label: "Irtisanomisajan korvaus" }, pensionPaidByEmployer: { description: "Eläke, jonka työnantaja maksaa entiselle työntekijälleen tai tämän edunsaajalle aiemman palvelussuhteen perusteella.", label: "Työnantajan maksama eläke" }, terminationAndLayOffDamages: { description: "Korvaus, jota työnantaja on velvollinen maksamaan, kun työnantaja on päättänyt palvelussuhteen henkilön työsopimuslain, kunnallisesta viranhaltijasta annetun lain tai valtion virkamieslain vastaisesti. Kohdassa ilmoitetaan myös korvaus työsuhteen purkamisesta (TSL 8:1, 55/2001) sekä korvaus perusteettomasta lomauttamisesta.", label: "Vahingonkorvaus päättämis- ja lomautustilanteissa" }, undefined: { description: "Ei valintaa", label: "Ei valintaa" }, voluntaryTerminationCompensation: { description: "Korvaus, jonka työnantaja maksaa vapaaehtoisesti irtisanomis- tai purkamistilanteessa tai silloin, kun palvelussuhde päätetään sopimalla.", label: "Vapaaehtoinen korvaus päättämistilanteessa" } }, EmploymentType: { fullTime: { label: "Toistaiseksi voimassaoleva" }, job: { label: "Kertaluonteinen työ" }, partTime: { label: "Määräaikainen" }, unknown: { label: "Valitse..." } }, EmploymentWorkHoursType: { hourPerThreeWeeks: { label: "3 viikon jaksossa" }, hourPerTwoWeeks: { label: "2 viikon jaksossa" }, hoursPerDay: { label: "tuntia/vuorokaudessa" }, hoursPerWeek: { label: "tuntia/viikkossa" } }, ExportMethod: { fileExcel: { label: "Excel-tiedosto", workflowMessage: "Excel tiedostoon" }, fileCsv: { label: "Csv-tiedosto", workflowMessage: "Csv tiedostoon" }, filePdf: { label: "Pdf-tiedosto", workflowMessage: "Pdf / tuloste" }, fileText: { label: "Tekstitiedosto", workflowMessage: "Teksti tiedostoon" }, copyExcel: { label: "Excel copy-paste", workflowMessage: "Excel leikepöydälle" }, copyCsv: { label: "Csv copy-paste", workflowMessage: "Csv leikepöydälle" }, copyText: { label: "Tekstin copy-paste", workflowMessage: "Teksti leikepöydälle" }, paymentChannel: { label: "Maksukanava" }, api: { label: "Rajapinta" }, fileSepa: { label: "S€PA-tiedosto v02", workflowMessage: "Sepa-tiedosto v02" }, fileSepaV03: { label: "S€PA-tiedosto v03", workflowMessage: "Sepa-tiedosto v03" }, copySepa: { label: "S€PA copy-paste v02", workflowMessage: "Sepa copy-paste v02" }, copySepaV03: { label: "S€PA copy-paste v03", workflowMessage: "Sepa copy-paste v03" }, finvoiceFile: { label: "Finvoice-tiedosto", workflowMessage: "Finvoice-tiedosto" } }, ForeclosureKind: { fixed: { description: "Ulosottoon tilitetään kiinteä summa", label: "Ulosmittaus, kiinteä summa" }, periodic: { description: "Ulosottoon tilitettävä määrä lasketaan määräajoin maksettavan palkan perusteella", label: "Ulosmittaus, määräajoin maks. palkka" }, nonPeriodic: { description: "Ulosottoon tilitettävä määrä lasketaan muuten kuin määräajoin maksettavan palkan perusteella", label: "Ulosmittaus, ei määräajoin maks. palkka" }, undefined: { description: "Ei valintaa, oletus kiinteä summa", label: "Ei valintaa" } }, FrameworkAgreement: { childCare: { description: "Jatkuva lastenhoitaja ja siihen liittyvät tuet", label: "Muu lastenhoito" }, cleaning: { description: "Siivous- ja kiinteistöalan työ", label: "Siivous- ja kiinteistöala" }, construction: { description: "Työtä rakennusalan työehtosopimuksen mukaan", label: "Rakennus- ja remonttityö" }, entrepreneur: { description: "Yrittäjän oma palkka", label: "Yrittäjä" }, mll: { description: "MLL:n lastenhoitajan palkka", label: "MLL suositukset" }, notDefined: { description: "Työehtosopimusta tai suositusta ei ole määritetty", label: "Ei määritetty" }, other: { description: "Muu työ - ei työehtosopimusta", label: "Muu työ" }, santaClaus: { description: "Joulupukin kotikäynti jouluaattona", label: "Joulupukki kotiin" } }, Gender: { female: { label: "Nainen" }, male: { label: "Mies" }, unknown: { label: "-" } }, HelttiIndustry: { i: { label: "Majoitus- ja ravitsemistoiminta" }, j: { label: "Informaatio ja viestintä" }, k: { label: "Rahoitus- ja vakuutustoiminta" }, m: { label: "Ammatillinen, tieteellinen ja tekninen toiminta" }, n: { label: "Hallinto- ja tukipalvelutoiminta" }, notDefined: { label: "Ei valintaa" }, o: { label: "Julkinen hallinto ja maanpuolustus" }, other: { label: "Muu toimiala" }, q: { label: "Terveys- ja sosiaalipalvelut" }, r: { label: "Taiteet, viihde ja virkistys" }, s: { label: "Muu palvelutoiminta" } }, HelttiProductPackage: { large: { label: "Tuloskunto" }, medium: { label: "Kasvuyritys" }, notDefined: { label: "Ei sopimusta" }, small: { label: "Start-up" } }, HolidayAccrualKind: { calculation: { label: "Palkkalaskelma" }, holiday: { label: "Pidetty loma" }, holidayCompensated: { label: "Lomakorvaus" }, manual: { label: "Käsin syötetty kuukausikertymä" }, saldo: { label: "Lomavuoden alku- tai loppusaldo" } }, HolidayBonusPaymentMethod: { none: { label: "Ei lomarahaa" }, pay24Days: { label: "Kesäloma 24 päivää (ei huomioi lomasuunnitelmia)" }, payAllBonus: { label: "Kaikki kerralla (kesäloman yhteydessä)" }, payForHolidaySalary: { label: "Maksetun loma-ajan palkan mukaan (oletus)" }, paySummerBonus: { label: "Suunnitellut kesälomat (max 24pv)" }, paySelectedDays: { label: "Maksetaan valituilta päiviltä" } }, HolidayCode: { holidayCompensation: { description: "Lomia ei kerrytetä, vaan lomakorvaus (+mahd. lomaraha) maksetaan heti palkan yhteydessä. Tyypillistä rakennusalalla ja muissa keikkatöissä.", label: "Lomakorvaus palkanmaksun yhteydessä" }, holidayCompensationIncluded: { description: "Lomia ei kerrytetä, vaan lomakorvaus on sovittu osaksi kokonaispalkkaa. Tämä on mahdollista vain poikkeustilanteissa, lähinnä kotitalouksilla.", label: "Lomakorvaus osa kokonaispalkkaa" }, noHolidays: { description: "Maksun saajalla ei ole lomaoikeutta. Esim. hallituksen jäsen, työkorvauksella työskentelevät, joskus toimitusjohtaja.", label: "Ei lomaoikeutta" }, permanent14Days: { description: "Työntekijä työskentelee työsopimuksen mukaan kaikkina kuukausina vähintään 14 päivää / kk", label: "14 päivän sääntö" }, permanent35Hours: { description: "Työntekijä työskentelee vähintään yhtenä kuukautena vuodessa 35 tuntia / kk, mutta ei kuulu 14 päivän säännön piiriin.", label: "35 tunnin sääntö" }, temporaryTimeOff: { description: "Työntekijä ei kuulu 14 päivän tai 35 tunnin säännön piiriin.", label: "Vapaan ansaintasääntö" }, undefined: { description: "Loma-ajan kertymistä ei ole määritetty", label: "Lisää lomakirjanpito" }, other: { description: "Kertymä päivitetään käsin tai integraatiolla toisesta järjestelmästä.", label: "Manuaalinen" } }, HolidayPayCalculation: { normalMonthlyPay: { label: "Kuukausipalkka", description: "Kuukausipalkkaan perustuva vuosilomapalkka" }, averageDailyPay: { label: "Keskipäiväpalkka (loma KPA)", description: "Keskipäiväpalkkaan perustuva vuosilomapalkka" }, percentageBasedPay: { label: "Prosenttiperusteinen", description: "Prosenttiperusteinen vuosilomapalkka" }, averageHourlyPay: { label: "Keskituntiansio (loma KTA)", description: "Tuntipalkkaan perustuva vuosilomapalkka" }, holidayCompensation: { label: "Lomakorvaus", description: "Lomakorvaukseen perustuva vuosilomapalkka" }, otherPay: { label: "Manuaalinen", description: "" }, undefined: { label: "Valitse..." } }, HolidayYearInitType: { createEmpty: { label: "Luo uusi tyhjä lomavuosi" }, createFromCalcs: { label: "Luo lomavuosi ja lisää lomapäivät maksettujen laskelmien perusteella" }, createMonths: { label: "Luo lomavuosi ja lisää kaikki kuukaudet" }, ignore: { label: "Älä lisää tai poista lomavuotta" } }, HouseHoldUseCaseTree: { childCare: { description: "Tilapäinen tai jatkuva", kela: { description: "Lastenhoitaja kotona.", label: "Yksityisen hoidon tuki" }, label: "Lastenhoito", mll: { description: "Palkka MLL:n suosituksen mukaan.", label: "Tilapäinen lastenhoito" }, other: { description: "Muu jatkuva tai tilapäinen lastenhoito", label: "Muu lastenhoito" } }, cleaning: { 51530: { description: "Kiinteistöhuollon työntekijät", label: "Kiinteistöhuolto" }, 53221: { description: "Kotityöpalvelutyöntekijän työ", label: "Kotityöpalvelu" }, 61132: { description: "Puutarha- ja kasvihuonetyöntekijät", label: "Puutarhanhoito" }, 91110: { description: "Siivoustyö tai kotiapulainen", label: "Kotisiivous tai kotiapulainen" }, description: "Kodin siivous ja kunnossapito", label: "Kotisiivous", other: { description: "Kodin muut työt", label: "Muut" } }, construction: { label: "Rakennus- ja remonttityö", description: "Rakennusalan työehtosopimus.", carpenter: { description: "Kirvesmiehet, muurarit, laattatyöt, kattotyöt", label: "Talonrakennus" }, floor: { description: "Lattianpäällystys", label: "Lattiatyöt" }, new: { description: "Uudisrakennukset, ei kotital.vähennystä", label: "Uudisrakentaminen" }, painter: { description: "Rakennusmaalarit ym.", label: "Maalaaminen" }, renovation: { description: "Kotital.vähennyksen alainen remontointi", label: "Remontointi" }, other: { description: "Muu kuin yllä kuvattu työ", label: "Muu työ" } }, other: { 51530: { label: "Kiinteistöhuollon työntekijät" }, 53112: { label: "Perhepäivähoitajat (sis. kotitalousten lastenhoitajat)" }, 53212: { label: "Kehitysvammaisten hoitajat" }, 53213: { label: "Sosiaalialan hoitajat" }, 53221: { label: "Kotityöpalvelutyöntekijät" }, 53222: { label: "Henkilökohtaiset avustajat, omaishoitajat ym." }, 61112: { label: "Peltoviljelytyönjohtajat ja -työntekijät" }, 61132: { label: "Puutarha- ja kasvihuonetyönjohtajat ja - työntekijät" }, 62100: { label: "Metsurit ja metsätyöntekijät" }, 71110: { label: "Talonrakentajat (sis. remonttimiehet)" }, 71150: { label: "Kirvesmiehet ja rakennuspuusepät" }, 71210: { label: "Kattoasentajat ja -korjaajat" }, 71310: { label: "Rakennusmaalarit ym." }, 91110: { label: "Kotiapulaiset ja -siivoojat" }, description: "Yleinen palkkalaskuri", label: "Muu työ", undefined: { label: "Muu työ" } } }, HouseholdYearStatus: { undefined: { label: "Ei tarkistettu" }, ok: { label: "Hyväksytty" }, okWithModifications: { label: "Puutteita/virheitä" }, willHandleMyself: { label: "Hoidan itse" } }, HouseholdYearProcessingStatus: { open: { label: "Avoin" }, closed: { label: "Lukittu" }, printed: { label: "Tulostettu" } }, InsuranceCompany: { aktia: { label: "Aktia" }, alandia: { label: "Alandia" }, aVakuutus: { label: "A-Vakuutus" }, fennia: { label: "Fennia" }, folksam: { label: "Folksam" }, if: { label: "If" }, lähiTapiola: { label: "LähiTapiola" }, none: { label: "Ei yhtiötä" }, other: { label: "Muu vakuutusyhtiö" }, pohjantähti: { label: "Pohjantähti" }, pohjola: { label: "OP Vakuutus" }, redarnas: { label: "Redarnas" }, tryg: { label: "Tryg" }, turva: { label: "Turva" }, ålands: { label: "Ålands Ömsesidiga Försäkringsbolag" }, protector: { label: "Protector" }, pending: { label: "Pending" } }, InvoiceStatus: { canceled: { description: "Maksu on peruttu", label: "Maksu peruttu" }, error: { description: "Maksujärjestelmä on merkinnyt maksun virheelliseksi", label: "Virhetila" }, forecast: { description: "Tämä lasku on Palkkaus.fi arvio: Varsinainen lasku tulee muusta kanavasta.", label: "Arvio" }, paid: { description: "Maksukanava on antanut maksukuittauksen: Maksu maksetaan 99% todennäköisyydellä. 100% varmuuden saat maksukanavasta.", label: "Maksettu" }, paymentStarted: { description: "Maksuprosessi on aloitettu, esim. maksu on lähetetty pankkiin.", label: "Maksu aloitettu" }, preview: { description: "Esikatselulasku on tämänhetkinen tilanne. Laskuun saattaa olla tulossa vielä uusia eriä.", label: "Esikatselu" }, read: { description: "Lasku on lähetetty maksujärjestelmään", label: "Käsittelyssä" }, undefined: { description: "Luonnos, ei maksujonossa", label: "Valitse..." }, unread: { description: "Laskua ei vielä ole lähetetty maksujärjestelmään", label: "Ei käsitelty" }, waitingConfirmation: { description: "Odottaa maksun manuaalista vahvistusta yrittäjältä / tilitoimistolta. Tulorekisteri-ilmoitus lähetetään vasta tämän jälkeen.", label: "Odottaa vahvistusta" }, waitingPalkkaus: { description: "Palkkalaskelma on otettu tarkistukseen, koska siinä saattaa olla virheitä. Maksu lähtee tarkistuksen jälkeen, yleensä seuraavana arkipäivänä.", label: "Tarkistuksessa" } }, InvoiceType: { net: { label: "Palkka" }, tax: { label: "Työnantajasuoritus (vero)" }, taxWithholding: { label: "Ennakonpidätys" }, taxSocialSecurity: { label: "SAVA-maksu" }, unemployment: { label: "Työttömyysvakuutusmaksu" }, pension: { label: "Työeläkemaksu" }, union: { label: "AY-jäsenmaksu" }, foreclosure: { label: "Ulosmittaus" }, gross: { label: "Palkkaus.fi - palkanmaksu" }, verification: { label: "Avausmaksu" }, payroll: { label: "Palkkaus.fi - palkkiot ja palvelumaksut" }, fee: { label: "Palkkaus.fi - palkkio" }, service: { label: "Palkkaus.fi - palvelumaksu" } }, IrFlags: { noMoney: { label: "Maksettu muuna kuin rahana (NoMoney)" }, oneOff: { label: "Kertakorvaus (OneOff)" }, unjustEnrichment: { label: "Perusteeton etu (UnjustEnrichment)" } }, IrInsuranceExceptions: { excludeAccidentInsurance: { label: "Poista työtapaturma- ja ammattitautivakuutusmaksun alaisuus" }, excludeAll: { label: "Poista kaikkien sosiaalivakuutusmaksujen alaisuus" }, excludeHealthInsurance: { label: "Poista sairausvakuutusmaksun alaisuus" }, excludePension: { label: "Poista työeläkevakuutusmaksun alaisuus" }, excludeUnemployment: { label: "Poista työttömyysvakuutusmaksun alaisuus" }, includeAccidentInsurance: { label: "Lisää työtapaturma- ja ammattitautivakuutusmaksun alaisuus" }, includeAll: { label: "Lisää kaikkien sosiaalivakuutusmaksujen alaisuus" }, includeHealthInsurance: { label: "Lisää sairausvakuutusmaksun alaisuus" }, includePension: { label: "Lisää työeläkevakuutusmaksun alaisuus" }, includeUnemployment: { label: "Lisää työttömyysvakuutusmaksun alaisuus" } }, Language: { default: { label: "Oletus (yhtiön kieli)" }, fi: { label: "Suomi" }, en: { label: "English" }, sv: { label: "Svenska" } }, LegalEntityType: { company: { label: "Y-tunnus" }, partner: { label: "Kumppani" }, person: { label: "Henkilö" }, personCreatedByEmployer: { label: "Työntekijä (TA:n)" }, undefined: { label: "Tuntematon" } }, MealBenefitKind: { cateringContract: { description: "Työnantajan järjestämä sopimusruokailu, jonka kustannus työnantajalle on verottajan vuosittain määrittämissä rajoissa (vuonna 2021/2022 6,90€ - 10,90€/7,15€ - 11,30€). Arvostetaan verotuksessa 6,80€/6,90€ per ruokailu.", label: "Sopimusruokailu", descriptionWithYearlyNumbers: "Työnantajan järjestämä sopimusruokailu, jonka kustannus työnantajalle on verottajan vuosittain määrittämissä rajoissa (vuonna {{previous.year}} / {{current.year}} {{previous.sideCosts.mealTicketLowerLimitFormatted}} - {{previous.sideCosts.mealTicketUpperLimitFormatted}} / {{current.sideCosts.mealTicketLowerLimitFormatted}} - {{current.sideCosts.mealTicketUpperLimitFormatted}}). Arvostetaan verotuksessa {{previous.sideCosts.mealBenefitCateringContractFormatted}} / {{current.sideCosts.mealBenefitCateringContractFormatted}} per ruokailu." }, institute: { description: "Sairaalan, koulun, päiväkodin tai muun vastaavan laitoksen henkilökuntaan kuuluvan laitosruokailun yhteydessä saaman ravintoedun raha-arvona pidetään 2021/2022 5,18€/5,36€ ateriaa kohden.", label: "Sairaalan, koulun, päiväkodin tms. ruokailu", descriptionWithYearlyNumbers: "Sairaalan, koulun, päiväkodin tai muun vastaavan laitoksen henkilökuntaan kuuluvan laitosruokailun yhteydessä saaman ravintoedun raha-arvona pidetään {{previous.year}} / {{current.year}} {{previous.sideCosts.mealBenefitInstituteFormatted}} / {{current.sideCosts.mealBenefitInstituteFormatted}} ateriaa kohden." }, mealAllowance: { description: `Ateriakorvauksen on veroton korvaus (muut tämän sivun valinnat ovat ravintoetuja / luontoisetuja). Sen maksaminen edellyttää, että työmatkasta ei suoriteta päivärahaa ja että palkansaajalla ei työn vuoksi ole mahdollisuutta ruokailutauon aikana aterioida tavanomaisella ruokailupaikallaan. 
Luonnollisesti näiltä päiviltä ei voi käyttää muuta ravintoetua. Ateriakorvauksen enimmäismäärä on 2021/2022 11,00€/11,25€ per ateria, 2 ateriaa per päivä (22,00€/22,50€ per päivä).`, label: "Ateriakorvaus", descriptionWithYearlyNumbers: `Ateriakorvauksen on veroton korvaus (muut tämän sivun valinnat ovat ravintoetuja / luontoisetuja). Sen maksaminen edellyttää, että työmatkasta ei suoriteta päivärahaa ja että palkansaajalla ei työn vuoksi ole mahdollisuutta ruokailutauon aikana aterioida tavanomaisella ruokailupaikallaan. 
Luonnollisesti näiltä päiviltä ei voi käyttää muuta ravintoetua. Ateriakorvauksen enimmäismäärä on {{previous.year}} / {{current.year}} {{previous.sideCosts.taxFreeMealAllowanceFormatted}} / {{current.sideCosts.taxFreeMealAllowanceFormatted}} per ateria, 2 ateriaa per päivä (22,00€/22,50€ per päivä).` }, mealTicket: { description: "Ruokailulipuke (Lounasseteli tai vast.) tai maksukortille ladattava tapahtuma, jonka kustannus työnantajalle on verottajan vuosittain määrittämissä rajoissa (vuonna 2021/2022 6,90€ - 10,90€/7,15€ - 11,30€). Arvostetaan verotuksessa 75 % nimellisarvosta.", label: "Ruokailulipuke", descriptionWithYearlyNumbers: "Ruokailulipuke (Lounasseteli tai vast.) tai maksukortille ladattava tapahtuma, jonka kustannus työnantajalle on verottajan vuosittain määrittämissä rajoissa (vuonna {{previous.year}} / {{current.year}} {{previous.sideCosts.mealTicketLowerLimitFormatted}} - {{previous.sideCosts.mealTicketUpperLimitFormatted}} / {{current.sideCosts.mealTicketLowerLimitFormatted}} - {{current.sideCosts.mealTicketUpperLimitFormatted}}). Arvostetaan verotuksessa 75 % nimellisarvosta." }, restaurantWorker: { description: "Hotelli- ja ravintola-alan henkilökunnan ja lentohenkilöstön lennon aikana saaman ravintoedun raha-arvona pidetään 2021/2022 5,87€/6,08€ ateriaa kohden.", label: "Hotelli- ja ravintola-alan ravintoetu", descriptionWithYearlyNumbers: "Hotelli- ja ravintola-alan henkilökunnan ja lentohenkilöstön lennon aikana saaman ravintoedun raha-arvona pidetään {{previous.year}} / {{current.year}} {{previous.sideCosts.mealBenefitRestaurantWorkerFormatted}} / {{current.sideCosts.mealBenefitRestaurantWorkerFormatted}} ateriaa kohden." }, taxableAmount: { description: `Jos ravintoedun hankkimisesta työnantajalle aiheutuneiden kustannusten määrä on yli tai alle verottajan vuosittain määrittämien rajojen (2021/2022 6,90€ - 10,90€/7,15€ - 11,30€) tai jos etu muuten ylittää rajata (esim. enemmän ruokailuja kuin työpäiviä), edun arvona pidetään suoria kustannuksia / nimellisarvoa.
Käytä tätä valintaa myös, jos et halua käyttää automaattista verotusarvon laskentaa muissa kohdissa.`, label: "Ravintoetu, verotusarvo", descriptionWithYearlyNumbers: `Jos ravintoedun hankkimisesta työnantajalle aiheutuneiden kustannusten määrä on yli tai alle verottajan vuosittain määrittämien rajojen ( {{previous.year}} / {{current.year}} {{previous.sideCosts.mealTicketLowerLimitFormatted}} - {{previous.sideCosts.mealTicketUpperLimitFormatted}} / {{current.sideCosts.mealTicketLowerLimitFormatted}} - {{current.sideCosts.mealTicketUpperLimitFormatted}}) tai jos etu muuten ylittää rajata (esim. enemmän ruokailuja kuin työpäiviä), edun arvona pidetään suoria kustannuksia / nimellisarvoa.
Käytä tätä valintaa myös, jos et halua käyttää automaattista verotusarvon laskentaa muissa kohdissa.` }, teacher: { description: "Koulun, päiväkodin tai vastaavan laitoksen henkilökunnan oppilaiden tai hoidettavien ruokailun valvonnan yhteydessä saaman ravintoedun arvo on 2021/2022 4,14€/4,29€ ateriaa kohden.", label: "Ruokailu valvonnan yhteydessä", descriptionWithYearlyNumbers: "Koulun, päiväkodin tai vastaavan laitoksen henkilökunnan oppilaiden tai hoidettavien ruokailun valvonnan yhteydessä saaman ravintoedun arvo on {{previous.year}} / {{current.year}} {{previous.sideCosts.mealBenefitTeacherFormatted}} / {{current.sideCosts.mealBenefitTeacherFormatted}} ateriaa kohden." }, collectedReimbursement: { description: `Jos ravintoedun hankkimisesta työnantajalle aiheutuneiden kustannusten määrä on yli tai alle verottajan vuosittain määrittämien rajojen (2021/2022 6,90€ - 10,90€/7,15€ - 11,30€) tai jos etu muuten ylittää rajata (esim. enemmän ruokailuja kuin työpäiviä), edun arvona pidetään suoria kustannuksia / nimellisarvoa.
Käytä tätä valintaa myös, jos et halua käyttää automaattista verotusarvon laskentaa muissa kohdissa.`, label: "Vain verotusarvoa vastaava vähennys palkasta", descriptionWithYearlyNumbers: `Jos ravintoedun hankkimisesta työnantajalle aiheutuneiden kustannusten määrä on yli tai alle verottajan vuosittain määrittämien rajojen ( {{previous.year}} / {{current.year}} {{previous.sideCosts.mealTicketLowerLimitFormatted}} - {{previous.sideCosts.mealTicketUpperLimitFormatted}} / {{current.sideCosts.mealTicketLowerLimitFormatted}} - {{current.sideCosts.mealTicketUpperLimitFormatted}}) tai jos etu muuten ylittää rajata (esim. enemmän ruokailuja kuin työpäiviä), edun arvona pidetään suoria kustannuksia / nimellisarvoa.
Käytä tätä valintaa myös, jos et halua käyttää automaattista verotusarvon laskentaa muissa kohdissa.` }, undefined: { description: 'Ei valintaa, oletus "Verotusarvo".', label: "Ei valintaa", descriptionWithYearlyNumbers: "Ei valintaa" } }, MessageType: { email: { label: "Sähköposti" }, sms: { label: "Tekstiviesti" } }, NonProfitOrgKind: { accomodationAllowance: { description: "Majoittumiskorvaus (tositteen perusteella). ", label: "Majoittumiskorvaus" }, dailyAllowance: { description: "Päivärahan voi maksaa enintään 20 päivältä per kalenterivuosi ja lisäksi majoittumiskorvaus (kts alla).", label: "Päiväraha" }, kilometreAllowance: { description: "Matkakustannusten korvaus. Muulla kuin julkisella kulkuneuvolla tehdystä matkasta on verovapaata enintään 3 000 euroa kalenterivuodelta.", label: "Kilometrikorvaus" }, undefined: { description: "Tyyppiä ei määritetty, oletus kilometrikorvaus", label: "Tyyppiä ei määritetty" } }, OnboardingStatus: { created: { label: "Luotu" }, done: { label: "Valmis" }, oplabel: "Käynnissä" }, OtherCompensationKind: { accruedTimeOffCompensation: { description: "Työaikakorvaus, joka maksetaan ansionvähentymisestä, joka aiheutuu työajan tasaamisesta keskimääräiseen viikkotyöaikaan.", label: "Työajantasauskorvaus" }, capitalIncomePayment: { description: "Suoritus, joka on saajalleen pääomatuloa. Tällainen on esimerkiksi työntekijälle tai osakkaalle maksettu korko, kuten palkkasaatavan korko tai pääomatuloa oleva takausprovisio.", label: "Pääomatuloa oleva suoritus" }, employeeInventionCompensation: { description: "Palkkio, joka maksetaan työsuhdekeksinnöstä.", label: "Palkkio työsuhdekeksinnöstä" }, employeeStockOption: { description: "Palkkio, joka annetaan työnantajayrityksen option muodossa.", label: "Työsuhdeoptio" }, employeeStockOptionWithLowerPrice: { description: "Palkkio, joka annetaan työnantajayrityksen option muodossa ja jossa työntekijältä peritty option merkintähinta option luovutusajankohtana on selvästi alhaisempi kuin osakkeen markkinahinta.", label: "Työsuhdeoptio, jonka merkintähinta on luovutusajankohtana alhaisempi kuin markkinahinta" }, lectureFee: { description: "Palkkio, joka maksetaan luennon pitämisestä.", label: "Luentopalkkio" }, meetingFee: { description: "Palkkio, joka maksetaan kokoukseen osallistumisesta.", label: "Kokouspalkkio" }, membershipOfGoverningBodyCompensation: { description: "Luottamustoimipalkkio, joka maksetaan yhteisön hallituksen tai vastaavan hallintoelimen jäsenyyden perusteella.", label: "Hallintoelimen jäsenyydestä maksettu palkkio" }, monetaryGiftForEmployees: { description: "Työnantajalta rahana tai siihen verrattavana suorituksena saatu lahja.", label: "Henkilöstölle annettu rahalahja" }, otherTaxableIncomeAsEarnedIncome: { description: "Tulolajilla ilmoitetaan muiden veronalaisten ansiotuloa olevien suoritusten yhteissumma.", label: "Muu veronalainen ansiotulo" }, positionOfTrustCompensation: { description: "Palkkio, joka maksetaan muusta luottamustoimen hoitamisesta kuin kokouksiin osallistumisesta.", label: "Luottamustoimipalkkio" }, stockOptionsAndGrants: { description: "Palkkio, joka annetaan työnantajayrityksen osakkeina tai sovitun palkkion sijaan rahasummana, joka vastaa osakkeiden arvoa.", label: "Osakepalkkio" }, undefined: { description: "Ei valintaa", label: "Ei valintaa" }, useCompensationAsCapitalIncome: { description: "Korvaus, joka suoritetaan tekijänoikeuden, teollisoikeuden tai teollisia, kaupallisia tai tieteellisiä kokemuksia koskevien tietojen luovuttamisesta tai käyttöoikeudesta.", label: "Käyttökorvaus pääomatuloa" }, useCompensationAsEarnedIncome: { description: "Korvaus, joka suoritetaan tekijänoikeuden, teollisoikeuden tai teollisia, kaupallisia tai tieteellisiä kokemuksia koskevien tietojen luovuttamisesta tai käyttöoikeudesta.", label: "Käyttökorvaus ansiotuloa" }, workEffortBasedDividendsAsNonWage: { description: "Osakkaalle työkorvauksena maksettava osinko, jonka jakoperusteena on osingonsaajan tai tämän intressipiiriin kuuluvan henkilön työpanos.", label: "Työpanokseen perustuva osinko tai ylijäämä (työkorvaus)" }, workEffortBasedDividendsAsWage: { description: "Osakkaalle palkkana maksettava osinko, jonka jakoperusteena on osingonsaajan tai tämän intressipiiriin kuuluvan henkilön työpanos.", label: "Työpanokseen perustuva osinko tai ylijäämä (palkka)" }, copyrightRoyaltiesEarnedIncome: { description: "Korvaus, joka maksetaan kirjallisen tai taiteellisen teoksen tekijänoikeuden luovuttamisesta tai tekijänoikeuden kohteen käyttöoikeudesta. Korvaus voidaan maksaa myös tekijänoikeuden lähioikeuden luovuttamisesta tai lähioikeuksilla suojatun kohteen käyttämisestä. Tekijänoikeus voidaan luovuttaa sopimuksen perusteella osittain tai kokonaan.", label: "Tekijänoikeuskorvaus ansiotuloa" }, stockGrantPaidInMoney: { description: "Osakepalkkio, joka maksetaan rahana. Tulolajilla ilmoitetaan vain se osuus osakepalkkiosta, joka maksetaan rahana. Osakkeina annettava osuus ilmoitetaan tulolajilla Osakepalkkio (320).", label: "Rahana maksettu osakepalkkio" }, employeeStockOptionPaidInMoney: { description: "Työsuhdeoptio, joka maksetaan rahana. Tulolajilla ilmoitetaan vain se osuus työsuhdeoptiosta, joka maksetaan rahana. Muuna kuin rahana annettava osuus ilmoitetaan tulolajilla Työsuhdeoptio (343). Tarvittaessa käytetään myös tulolajia Työsuhdeoptio, jonka merkintähinta on luovutusajankohtana alempi kuin markkinahinta (361).", label: "Rahana maksettu työsuhdeoptio" } }, PalkkausCampaignPricing: { campaignAfterFirstUse: { label: "Campaign After First Use" }, campaignFirstUse: { label: "Campaign First Use" }, companyFreeTrial: { label: "Company Free Trial" } }, PartnerSite: { careDotCom: { label: "Care Dot Com" }, palkkaapakolainlabel: "Palkkaapakolainen", palkkausEmployerFillIn: { label: "Palkkaus Employer Fill In" }, palkkausIdentified: { label: "Palkkaus Identified" }, refugeeJobs: { label: "Refugee Jobs" } }, PaymentChannel: { undefined: { description: "Maksutapaa ei ole määritetty. Tyypillisesti tämä on virhetilanne.", label: "Valitse maksutapa..." }, test: { description: "Maksumenetelmä testaamiseen. Erilliset laskut (nettopalkka, ennakonpidätys jne.) Toimii vain testiympäristössä.", label: "Testimaksu" }, zeroPayment: { description: "Maksun summa on nolla. Tätä maksua ei lähetetä maksukanavaan, vaan se merkitään suoraan maksetuksi.", label: "Nollamaksu (ei maksettavaa)" }, external: { description: "Maksu on jo maksettu Palkkaus.fi palvelun ulkopuolella (tai tullaan maksamaan). Maksusta tehdään kuitenkin ilmoitus tulorekisteriin.", label: "Jo maksettu / ulkopuolinen" }, palkkausManual: { description: "Maksuaineisto luodaan erillisinä laskuina Maksut-listaan. Sieltä ne voidaan tulostaa PDF-tiedostona, kopoida verkkopankkiin tai ladata SEPA-maksuaineistona.", label: "Maksuaineiston luonti" }, palkkausWS: { description: "Palkasta, ennakonpidätyksestä jne. luodaan erilliset laskut ja ne lähetetään pankkien WS-kanavaan. Vaatii sopimuksen pankin kanssa.", label: "Maksut suoraan pankkiin" }, palkkausPSD: { description: "Palkasta, ennakonpidätyksestä jne. luodaan erilliset PSD maksut.", label: "PSD maksut" }, palkkausPersonal: { description: "Maksut luodaan erillisinä laskuina Maksut-listaan. Sieltä ne voidaan tulostaa PDF-tiedostona tai kopioida verkkopankkiin.", label: "Maksujen luonti" }, palkkausInvoices: { description: "Laskujen luonti palkkalaskelmista.", label: "Laskujen luonti" }, kitsas: { description: "Laskujen luonti palkkalaskelmista.", label: "Kitsas" }, palkkausCfaPaytrail: { description: "Palkka, ennakonpidätys ja työeläke yhdellä helpolla verkkomaksulla Palkkaus.fi asiakasvaratilin kautta.", label: "Paytrail verkkomaksu (yksi maksu)" }, palkkausCfaReference: { description: "PDF-paperilasku, jonka voit maksaa missä tahansa verkkopankissa tai ohjelmassa. Palkka, ennakonpidätys ja työeläke yhdessä laskussa Palkkaus.fi asiakasvaratilin kautta.", label: "Yksi tilisiirto viitenumerolla" }, palkkausCfaFinvoice: { description: "Lähetä itsellesi verkkolasku, jossa palkka, ennakonpidätys ja työeläke on yhdessä helpossa laskussa. Maksa esim. kirjanpito-ohjelmassasi. Maksu tapahtuu Palkkaus.fi asiakasvaratilin kautta.", label: "Verkkolasku (yksi maksu)" }, palkkausEcfaPaytrail: { description: "Palkka, ennakonpidätys ja työeläke yhdellä helpolla verkkomaksulla Palkkaus.fi asiakasvaratilin kautta.", label: "Paytrail verkkomaksu (yksi maksu)" }, palkkausEcfaReference: { description: "PDF-paperilasku, jonka voit maksaa missä tahansa verkkopankissa tai ohjelmassa. Palkka, ennakonpidätys ja työeläke yhdessä laskussa Palkkaus.fi asiakasvaratilin kautta.", label: "Yksi tilisiirto viitenumerolla" }, palkkausEcfaFinvoice: { description: "Lähetä itsellesi verkkolasku, jossa palkka, ennakonpidätys ja työeläke on yhdessä helpossa laskussa. Maksa esim. kirjanpito-ohjelmassasi. Maksu tapahtuu Palkkaus.fi asiakasvaratilin kautta.", label: "Verkkolasku (yksi maksu)" }, palkkausCfaTest: { description: "Testimaksu asiakasvaratilin kautta (yksi maksu). Toimii vain testiympäristössä.", label: "Asiakasvaratilin testimaksu" }, accountorGo: { description: "Laskujen lähetys suoraan Accountor Go -palveluun. Käytössä vain Accountor Go -palvelun kautta.", label: "Accountor Go" }, talenomCfa: { description: "Laskujen lähetys Talenom Online -palveluun verkkolaskuna. Käytössä vain Talenom Online -palvelun kautta.", label: "Talenom verkkolasku" }, talenomOnline: { description: "Laskujen lähetys suoraan Easor App -sovellukseen. Käytössä vain Easor App -sovelluksen kautta.", label: "Easor App" }, holviCfa: { description: "Palkka, ennakonpidätys ja työeläke yhdellä helpolla Holvi-maksulla Palkkaus.fi asiakasvaratilin kautta. Käytössä vain Holvi-palvelun kautta.", label: "Holvi" }, finagoSolo: { description: "Laskujen lähetys Finago Soloon. Käytössä vain Finago Solo -palvelun kautta.", label: "Finago Solo" }, procountor: { description: "Laskujen lähetys Procountoriin", label: "Procountor" }, kevytyrittaja: { description: "Laskujen lähetys Talenom Kevytyrittäjä -palveluun. Käytössä vain Talenom Kevytyrittäjä -sovelluksen kautta.", label: "Kevytyrittäjä" }, vismaNetvisor: { description: "Laskujen lähetys Visma Netvisor -ohjelmistoon", label: "Visma Netvisor" }, askelma: { description: "Laskujen lähetys Askelma -ohjelmistoon", label: "Askelma" }, briox: { description: "Laskujen lähetys Briox -ohjelmistoon", label: "Briox" }, lemonaid: { description: "Laskujen lähetys Lemonaid -ohjelmaan", label: "Lemonaid" }, laskupiste: { description: "Laskujen lähetys Laskupisteelle", label: "Laskupiste" }, passeliMerit: { description: "Laskujen lähetys Passeli Meritiin", label: "Passeli Merit" }, odoo: { description: "Laskujen lähetys Odoon", label: "Odoo" }, hausvise: { description: "Hausvise maksuaineiston luonti", label: "Hausvise" }, ecom: { description: "Laskujen lähetys Ecomiin", label: "Ecom" }, kompassi: { description: "Laskujen lähetys Kompassiin", label: "Kompassi" }, domus: { description: "Laskujen lähetys Domukseen", label: "Domus" }, holvi: { description: "Laskujen lähetys Holviin", label: "Holvi-tili" }, talenomManual: { description: "Maksuaineisto luodaan erillisinä laskuina Maksut-listaan. Sieltä ne voidaan tulostaa PDF-tiedostona, kopoida verkkopankkiin tai ladata SEPA-maksuaineistona.", label: "Easor maksuaineiston luonti" } }, PaymentStatus: { bankDelivered: { label: "Pankki hyväksynyt" }, bankError: { label: "Virhe pankissa" }, bankPartialError: { label: "Virhe pankissa" }, bankTechApproval: { label: "Pankki vastaanottanut" }, cancelled: { label: "Peruttu" }, new: { label: "Uusi" }, paid: { label: "Maksettu" }, sentToBank: { label: "Lähetetty pankkiin" }, unknown: { label: "Tuntematon" } }, PayrollStatus: { draft: { label: "Luonnos" }, paymentCanceled: { label: "Maksu peruttu" }, paymentError: { label: "Virheitä" }, paymentStarted: { label: "Maksu aloitettu" }, paymentSucceeded: { label: "Maksettu" }, template: { label: "Toistuva palkkalista" }, handled: { label: "Hoidettu" }, waitingApproval: { label: "Yrityksen tarkistuksessa" }, paymentAllowed: { label: "Valmis maksuun" }, waitingPartnerApproval: { label: "Tilitoimiston käsittelyssä" } }, PensionCalculation: { athlete: { label: "Urheilijan eläke", labelWithEnumLabel: "Työeläkesopimus: Urheilijan eläke", labelForIncome: "Urheilijan eläkkeen alaista" }, boardRemuneration: { label: "Hallituspalkkio", labelWithEnumLabel: "Työeläkesopimus: Ei (hallituspalkkio)", labelForIncome: "Hallituspalkkio" }, compensation: { label: "Työkorvaus", labelWithEnumLabel: "Työeläkesopimus: Ei (työkorvaus)", labelForIncome: "Työkorvaus" }, employee: { label: "TyEL", labelWithEnumLabel: "Työeläkesopimus: TyEL", labelForIncome: "TyEL:n alaista" }, entrepreneur: { label: "YEL", labelWithEnumLabel: "Työeläkesopimus: YEL", labelForIncome: "YEL:n alaista" }, farmer: { label: "MYEL", labelWithEnumLabel: "Työeläkesopimus: MyEL", labelForIncome: "MYEL:n alaista" }, partialOwner: { description: `Osaomistajan palkka\r
Yrityksen osaomistajat maksavat pienempää palkansaajan työttömyysvakuutusmaksua kuin työntekijät.\r
•	Osaomistajan työnantajan työttömyysvakuutusmaksu on 0,5 % palkkasummasta.\r
•	Palkansaajan, joka on myös osaomistaja, työttömyysvakuutusmaksuprosentti on 0,78 %. Työnantaja pidättää sen palkasta palkanmaksun yhteydessä.\r
Jos et ole ole yrityksessä johtavassa asemassa, mutta työskentelet yrityksessä tai yhteisössä, olet osaomistaja, jos jokin seuraavista ehdoista täyttyy: \r
•	sinulla itselläsi on vähintään 50 % kyseisen yrityksen tai yhteisön osakepääomasta, äänivallasta tai muusta määräämisvallasta \r
•	perheenjäsenelläsi on vähintään 50 % kyseisen yrityksen tai yhteisön osakepääomasta, äänivallasta tai muusta määräämisvallasta\r
•	sinulla on yhdessä perheenjäsentesi kanssa vähintään 50 % osakepääomasta, äänivallasta tai muusta määräämisvallasta. \r
Jos olet johtavassa asemassa mutta et ole yrittäjä, voit olla työttömyysturvalain mukaan osaomistaja, jos työskentelet yrityksessä ja jompikumpi seuraavista ehdoista täyttyy:\r
•	sinulla on vähintään 15 % osakepääomasta, äänivallasta tai muusta määräämisvallasta\r
•	perheenjäsenilläsi tai teillä yhdessä on vähintään 30 % osakepääomasta, äänivallasta tai muusta määräämisvallasta\r
Työllisyysrahaston sivulla voi testata onko osaomistaja vai palkansaaja\r
https://www.tyollisyysrahasto.fi/tyottomyysvakuusmaksut/tyottomyysvakuutusmaksuvelvollisuus/#osaomistaja\r
Osaomistajan käsite on määritelty työttömyysturvalaissa (1290/2002). \r
`, label: "TyEL, osaomistaja", labelWithEnumLabel: "Työeläkesopimus: TyEL, osaomistaja", labelForIncome: "TyEL:n alaista, osaomistaja" }, smallEntrepreneur: { description: "Valitse sovellettavan eläketurvan tavaksi “YEL, ei vakuuttamisvelvollisuutta”, jos olet yrittäjä, mutta sinulla ei ole velvoitetta ottaa YEL-vakuutusta. Tällöin ei myöskään makseta palkan sivukuluja, kuten sairausvakuutusmaksua. Jos et tiedä oletko YEL-velvollinen, voit kysyä sitä suoraan työeläkeyhtiöltä.", label: "YEL, ei vakuuttamisvelvollisuutta", labelWithEnumLabel: "Työeläkesopimus: YEL, ei vakuuttamisvelvollisuutta", labelForIncome: "YEL, ei vakuuttamisvelvollisuutta" }, smallFarmer: { description: `Tulonsaaja täyttää maatalousyrittäjän eläkelain 3 §:ssä säädetyt edellytykset, mutta jolla ei ole mainitun lain perusteella vakuuttamisvelvollisuutta.

Vakuuttamisvelvollisuus ei koske:
1) maatalousyrittäjän toimintaa ennen 18 vuoden iän täyttämistä seuraavan kalenterikuukauden alkua eikä toimintaa, joka jatkuu sen kalenterikuukauden jälkeen, jolloin vuonna 1957 tai sitä ennen syntynyt maatalousyrittäjä täyttää 68 vuotta, vuosina 1958–1961 syntynyt maatalousyrittäjä täyttää 69 vuotta ja vuonna 1962 ja sen jälkeen syntynyt maatalousyrittäjä täyttää 70 vuotta (vakuuttamisvelvollisuuden yläikäraja); (29.1.2016/75)
2) maatalousyrittäjän toimintaa, joka ei ole jatkunut 18 vuoden iän täyttämistä seuraavan kalenterikuukauden alun jälkeen yhdenjaksoisesti vähintään neljää kuukautta;
3) maatalousyrittäjän toimintaa, joka on alkanut tai jatkunut sen jälkeen, kun hän on siirtynyt työeläkelakien mukaiselle vanhuuseläkkeelle;
4) maatalousyrittäjää, jonka työtulo tässä laissa tarkoitetusta maatalousyrittäjätoiminnasta on arvioitava pienemmäksi kuin 2 752,07 euroa vuodessa;
5) maatilatalouden, kalastuksen tai poronhoidon yhteydessä harjoitettua toimintaa, jota on pidettävä eri yrityksenä;
6) ansiotyötä, jonka perusteella maatalousyrittäjällä on oikeus eläkkeeseen muun työeläkelain mukaan; eikä
7) maatalousyrittäjää, johon ei sovelleta Suomen lainsäädäntöä EU:n sosiaaliturvan perusasetuksen tai sosiaaliturvasopimuksen sovellettavaa lainsäädäntöä koskevien määräysten perusteella. (14.5.2010/357)

Vakuuttamisvelvollisuus ei koske apurahansaajan työtä:
1) ennen 18 vuoden iän täyttämistä seuraavan kalenterikuukauden alkua, eikä työtä, joka jatkuu sen kalenterikuukauden jälkeen, jolloin vuonna 1957 tai sitä ennen syntynyt apurahansaaja täyttää 68 vuotta, vuosina 1958–1961 syntynyt apurahansaaja täyttää 69 vuotta ja vuonna 1962 ja sen jälkeen syntynyt apurahansaaja täyttää 70 vuotta (vakuuttamisvelvollisuuden yläikäraja); (29.1.2016/75)
2) joka ei ole jatkunut 18 vuoden iän täyttämistä seuraavan kalenterikuukauden alun jälkeen yhdenjaksoisesti vähintään neljä kuukautta;
3) joka on alkanut tai jatkunut sen jälkeen, kun hän on siirtynyt työeläkelakien mukaiselle vanhuuseläkkeelle;
4) ajalta, jona apurahansaajalle arvioitava vuotuinen työtulo on pienempi kuin 2 752,07 euroa;
5) jos apurahansaajaan ei sovelleta Suomen sosiaaliturvalainsäädäntöä EU:n sosiaaliturvan perusasetuksen tai sosiaaliturvasopimuksen sovellettavaa lainsäädäntöä koskevien määräysten perusteella. (14.5.2010/357)`, label: "MYEL, ei vakuuttamisvelvollisuutta", labelWithEnumLabel: "Työeläkesopimus: MYEL, ei vakuuttamisvelvollisuutta", labelForIncome: "MYEL, ei vakuuttamisvelvollisuutta" }, publicSector: { label: "JuEL", labelWithEnumLabel: "Työeläkesopimus: JuEL", labelForIncome: "JuEL:n alaista" }, undefined: { label: "(Ei valittu vielä)", labelWithEnumLabel: "Työeläkesopimus: Ei valittu", labelForIncome: "Ei eläkevalintaa" } }, PensionCompany: { apteekkien: { label: "Apteekkien Eläkekassa" }, elo: { label: "Elo" }, etera: { label: "Etera" }, ilmarinen: { label: "Ilmarinen" }, none: { label: "Ei yhtiötä" }, other: { label: "Muu yhtiö" }, pensionsAlandia: { label: "Alandia" }, valio: { label: "Valion Eläkekassa" }, varma: { label: "Varma" }, veritas: { label: "Veritas" }, verso: { label: "Verso" }, kevaMunicipal: { label: "Keva - kunta" }, kevaAland: { label: "Keva - Ahvenanmaa" }, kevaChurch: { label: "Keva - kirkko" }, kevaKela: { label: "Keva - Kela" }, kevaState: { label: "Keva - valtio" } }, PeriodType: { custom: { label: "Muu periodi" }, month: { label: "Kuukausi" }, quarter: { label: "Neljännesvuosi" }, year: { label: "Kalenterivuosi" } }, PricingModel: { fixedFee: { label: "Kiinteä palkkio" }, noFee: { label: "Ei palkkiota" }, palkkausFee: { label: "Palkkaus.fi-palkkio" } }, Product: { accounting: { description: "Palkkalaskelmien tiedot helposti kirjanpitäjälle", label: "Kirjanpitoraportit", status: "Ei käytössä" }, baseService: { description: "Digiajan palkanmaksupalvelu", label: "Palkkaus.fi-tili", status: "Palkkaamisen peruspalvelut" }, healthCareHeltti: { description: "Tuottavammat ja terveemmät työntekijät", label: "Työterveyshuolto", status: "Ei sopimusta" }, insurance: { description: "Tapaturmavakuutus vakuuttaa työntekijäsi", label: "Työtapaturmavakuutus", status: "Ei sopimusta. HUOM: työnantajan 1400 € :n vuosisääntö!" }, pension: { description: "TyEL-vakuutus on työntekijän eläketurva", label: "TyEL-eläkevakuutus", status: "Ei sopimusta: TyEL maksetaan tilapäisenä työnantajana" }, pensionEntrepreneur: { description: "YEL-vakuutus on yrittäjän eläketurva", label: "Yrittäjän eläke", status: "Ei YEL-sopimusta" }, tax: { description: "Ennakonpidätykset ja sava-maksu", label: "Yhteydet verottajaan", status: "Ennakonpidätys ja ilmoitukset" }, taxCard: { description: "Työntekijän verokortti ja sen käsittely", label: "Verokortti (TT)", status: "Ei verokorttia" }, unemployment: { description: "Työttömyysturva rahoitetaan TVR-maksuilla", label: "Työttömyysvakuutus (TVR)", status: "Ilmoitukset TVR:lle", statusTVR: "Ilmoitukset TVR:lle" } }, ProductListFilter: { all: { label: "All products, even the currently non-available." }, available: { label: "Available products for this user" } }, RemunerationKind: { bonusPay: { description: "Kertaluonteinen palkkiopalkka, jonka suuruus määräytyy kokonaan tai osittain sen mukaan, kuinka hyvin tavoitteeksi asetettu työtulos saavutetaan. Työtuloksen mittana voi olla määrä, laatu tai jokin muu tulostekijä.", label: "Bonuspalkka" }, commission: { description: "Pysyvän palkan osan muodostava jatkuvaluonteinen palkkiopalkka, jonka määrästä on sovittu työsopimuksessa.", label: "Provisiopalkka" }, initiativeFee: { description: "Kertapalkkio, joka maksetaan aloitteen tekijälle esimerkiksi toiminnan tai tuotteen kehittämiseen liittyvästä aloitteesta.", label: "Aloitepalkkio" }, performanceBonus: { description: "Palkka, joka maksetaan organisaation ennalta sovitun tulostavoitteen täyttymisen tai ylittymisen perusteella.", label: "Tulospalkkio" }, profitSharingBonus: { description: "Työntekijöille ilman ennalta sovittua suunnitelmaa yhtiökokouksen päätöksellä jaettava palkkio, joka muodostuu yrityksen voiton perusteella.", label: "Voittopalkkio" }, shareIssueForEmployees: { description: "Yhtiön omalle henkilökunnalle suunnattu osakeanti. Etu työsuhteeseen perustuvasta oikeudesta merkitä työnantajayrityksen osakkeita on veronalaista ansiotuloa.", label: "Työsuhteeseen perustuva osakeanti" }, undefined: { description: "Ei valintaa", label: "Ei valintaa" } }, ReportType: { employerReport: { label: "Työnantajan laskelma" }, employmentContract: { label: "Työsopimus" }, example: { label: "Esimerkki" }, householdDeduction: { label: "Kotitalousvähennys" }, insurance: { label: "Vakuutus" }, monthlyDetails: { label: "Kuukausittaisia tietoja" }, monthlyLiikekirjuri: {}, monthlyPension: { label: "Kuukausittainen eläke" }, monthlyRapko: {}, paymentReport: { label: "Maksuraportti" }, paymentSummaryReport: { label: "Maksuraportti (kooste)" }, salarySlip: { label: "Työntekijän palkkalaskelma" }, salarySlipPaid: { label: "Työntekijän palkkalaskelma, maksettu" }, taxHouseholdDeduction14B: {}, taxHouseholdDeduction14BSpouseA: {}, taxHouseholdDeduction14BSpouseB: {}, taxMonthly4001: { label: "Kuukausittainen vero" }, taxYearly7801: { label: "Vuosittainen vero" }, undefined: { label: "Ei määritelty" }, unemployment: { label: "Työttömyys" }, yearEndReport: { label: "Loppuvuoden raportti" }, yearlyDetails: { label: "Vuosittaisia tietoja" }, yearlyWorkerSummary: {}, accountingReport: { label: "Kirjanpitoaineisto" }, eSalarySpecification: { label: "Verkkopalkka" }, totalsReport: { label: "Tarkastusraportti" } }, SalaryKind: { compensation: { label: "Korvaus", labels: { household: "Työkorvaus" } }, fixedSalary: { label: "Kiinteä palkka" }, hourlySalary: { label: "Tuntipalkka" }, monthlySalary: { label: "Kuukausipalkka" }, salary: { label: "Urakkapalkka" }, totalEmployerPayment: {}, totalWorkerPayment: {}, undefined: { label: "Ei määritelty" } }, SalaryPeriod: { notDefined: { label: "Not Defined" } }, SalaryPerMonthRange: { noPensionRequired: { label: "Alle 57,10 €" }, normal: { label: "57,10 € tai yli" }, unknown: { label: "Ei tiedossa" } }, SalaryPerYearRange: { noMonthlyReporting: { label: "201 - 1500 €" }, noReportingNecessary: { label: "1 - 200 €" }, normal: { label: "Yli 1500 €" }, zeroSalary: {} }, ServiceModel: { partnerOnly: { label: "Tilitoimistokäyttö" }, shared: { label: "Yhteiskäyttö" } }, SubsidisedCommuteKind: { noDeduction: { description: "Ei vähennystä työntekijän palkasta", label: "Ei vähennystä" }, periodicalDeduction: { description: "Vähennys työntekijän palkasta jaetaan palkkakausiin (oletus 12 kuukautta).", label: "Vähennys jaetaan palkkakausille" }, singleDeduction: { description: "Vähennys työntekijän palkasta otetaan kerralla (tästä palkkalaskelmasta)", label: "Vähennys palkasta kerralla" }, undefined: { description: 'Ei valintaa, oletus "Ei vähennystä"', label: "Ei valintaa" } }, BicycleBenefitKind: { noDeduction: { description: "Ei vähennystä työntekijän palkasta", label: "Ei vähennystä" }, periodicalDeduction: { description: "Vähennys työntekijän palkasta jaetaan palkkakausiin (oletus 12 kuukautta).", label: "Vähennys jaetaan palkkakausille" }, singleDeduction: { description: "Vähennys työntekijän palkasta otetaan kerralla (tästä palkkalaskelmasta)", label: "Vähennys palkasta kerralla" }, undefined: { description: 'Ei valintaa, oletus "Ei vähennystä"', label: "Ei valintaa" } }, TaxCardIncomeType: { externalSalaries: { label: "Ulkopuoliset palkat" }, previousEmployerSalaries: { description: "Merkitse tähän työntekijän edellisten työnantajien kuluvana verovuonna maksamat palkat yhteensä euroina.", label: "Edellisten työnantajien maksamat palkat" }, salaxyCalculation: { label: "Salaxy laskelma" }, unknown: { label: "Tuntematon" } }, TaxcardKind: { defaultYearly: { label: "Alkuperäinen verokortti" }, auto: { label: "Automaattisesti päivittyvä verokortti" }, historical: { label: "Vanha verokortti" }, noTaxCard: { label: "Ei verokorttia (60%)" }, noWithholdingHousehold: { label: "Ei ennakonpidätystä (alle 1500€)" }, others: { label: "Muu verokortti" }, replacement: { label: "Muutosverokortti" }, undefined: { label: "Verokorttia ei ole määritetty" } }, TaxcardState: { employerAdded: { label: "Työnantajan lisäämä" }, expired: { label: "Vanhentunut" }, new: { label: "Uusi verokortti" }, replaced: { label: "Korvattu (ei käytössä)" }, shared: { label: "Työntekijän jakama" }, sharedApproved: { label: "Työnantajan hyväksymä" }, sharedRejected: { label: "Työnantaja hylännyt" }, sharedRejectedWithoutOpen: { label: "Työnantaja hylännyt avaamatta" }, sharedWaiting: { label: "Odottaa hyväksyntää" }, verifiedVero: { label: "Haettu Verolta" } }, TaxcardValidity: { expired: { label: "Vanhentunut" }, future: { label: "Tuleva" }, undefined: { label: "Virhe" }, valid: { label: "Voimassa" }, validJanuary: { label: "Tammikuun voimassa" } }, TaxDeductionWorkCategories: { carework: { label: "Hoiva- tai hoitotyö" }, homeImprovement: { label: "Asunnon kunnossapito- tai perusparannustyö" }, householdwork: { label: "Kotitaloustyö" }, none: { label: "Ei valintaa" }, ownPropety: { label: "Omassa käytössä oleva asunto tai vapaa-ajan asunto" }, relativesProperty: { label: "Vanhempien, isovanhempien yms. käytössä oleva asunto tai vapaa-ajan asunto." } }, TesSubtype: { constructionCarpenter: { label: "Construction Carpenter" }, constructionFloor: { label: "Construction Floor" }, constructionFreeContract: { label: "Construction Free Contract" }, constructionOther: { label: "Construction Other" }, notSelected: { label: "Not Selected" } }, TestEnum: { valueEight: { label: "Value Eight" }, valueFive: { label: "Value Five" }, valueFour: { label: "Value Four" }, valueNine: { label: "Value Nine" }, valueOne: { label: "Value One" }, valueSevlabel: "Value Seven", valueSix: { label: "Value Six" }, valueThree: { label: "Value Three" }, valueTlabel: "Value Ten", valueTwo: { label: "Value Two" }, valueZero: { label: "Value Zero" } }, UnionPaymentKind: { fixed: { description: "Yleinen kiinteä AY-jäsenmaksu.", label: "AY-jäsenmaksu, kiinteä summa" }, percentage: { description: "Yleinen jäsenmaksu, lasketaan %-osuudella palkasta.", label: "AY-jäsenmaksu, %-osuus palkasta" }, percentageAndLimits: { description: "Yleinen jäsenmaksu, lasketaan %-osuudella palkasta annetuissa rajoissa.", label: "AY-jäsenmaksu, %-osuus palkasta annetuissa rajoissa" }, other: { description: "Muu liitto", label: "AY-jäsenmaksu, muu liitto" }, raksaNormal: { description: "Rakennusliiton normaalijäsenyys", label: "AY-jäsenmaksu, Rakennusliitto A-jäsen" }, raksaUnemploymentOnly: { description: "Rakennusliiton jäsenyys vain työttömyyskassassa", label: "AY-jäsenmaksu, Rakennusliitto OA- tai TA-jäsen" }, undefined: { description: "AY-jäsenmaksun tyyppiä ei valittu", label: "Ei jäsenyyttä" } }, UnionPaymentType: { notSelected: { label: "Ei jäsenyyttä" }, other: { label: "Muu liitto..." }, raksaNormal: { label: "Rakennusliitto, A-jäsen" }, raksaUnemploymentOnly: { label: "Rakennusliitto, OA- tai TA-jäsen" } }, WageBasis: { hourly: { label: "Tuntipalkka" }, monthly: { label: "Kuukausipalkka" }, other: { label: "Muu" }, performanceBased: { label: "Suorituspalkka" }, undefined: { label: "Valitse..." } }, WebSiteUserRole: { company: { label: "Yrittäjä" }, household: { label: "Työnantaja (kotitalous)" }, none: { label: "Valitse rooli..." }, worker: { label: "Työntekijä" } }, TotalWorkerPaymentKind: { totalWorkerPayment: { description: "Rahapalkka ja kulukorvaukset", label: "Rahapalkka ja kulukorvaukset" }, totalWorkerWorkerPaymentExcludingExpenses: { description: "Rahapalkka, ei sisällä kulukorvauksia", label: "Rahapalkka, ei sisällä kulukorvauksia" }, totalWorkerPaymentAndTax: { description: "Rahapalkka ja ennakonpidätys", label: "Rahapalkka ja ennakonpidätys" }, totalWorkerWorkerPaymentAndTaxExcludingExpenses: { description: "Rahapalkka ja ennakonpidätys, ei sisällä kulukorvauksia", label: "Rahapalkka ja ennakonpidätys, ei sisällä kulukorvauksia" }, undefined: { description: "Ei valintaa", label: "Ei valintaa" } }, WorkingTimeCompensationKind: { emergencyWorkCompensation: { description: "Työaikakorvaus, joka maksetaan hätätyöstä. Hätätyöllä tarkoitetaan hätätilanteessa säännöllisen työajan ylittävänä aikana teetettävää työtä.", label: "Hätätyökorvaus" }, eveningShiftAllowance: { description: "Vuorotyökorvaus, joka maksetaan iltavuorosta.", label: "Iltavuorolisä" }, eveningWorkCompensation: { description: "Työaikakorvaus, joka maksetaan iltatyöstä. Iltatyökorvausta voidaan maksaa säännölliseltä työajalta tai säännöllisen työajan ylittävältä ajalta.", label: "Iltatyökorvaus" }, extraWorkPremium: { description: "Työaikakorvaus, joka maksetaan lisätyöstä.", label: "Lisätyökorvaus" }, nightShiftCompensation: { description: "Vuorotyökorvaus, joka maksetaan yövuorosta.", label: "Yövuorolisä" }, nightWorkAllowance: { description: "Työaikakorvaus, jota maksetaan yötyöstä.", label: "Yötyökorvaus" }, otherCompensation: { description: `Muiden maksettujen työaika- ja poikkeustilakorvausten yhteissumma. Näitä ovat mm. aattotyökorvaukset, arkipyhäkorvaukset ja muut mahdolliset työehtosopimusten tai työsopimusten perusteella
 maksettavat korvaukset ja lisät.`, label: "Muu maksettu lisä" }, overtimeCompensation: { description: "Ylityöstä maksettava työaikakorvaus. Ylityönä pidetään työtä, joka tehdään työnantajan aloitteesta sovitun ylityöaikarajan ylittävänä aikana.", label: "Ylityökorvaus" }, saturdayPay: { description: `Työaikakorvaus, joka maksetaan lauantaityöstä.
 Lauantaityökorvausta voidaan maksaa säännölliseltä työajalta tai säännöllisen työajan ylittävältä ajalta.`, label: "Lauantaityökorvaus" }, standByCompensation: { description: "Palkka, joka maksetaan siitä, että työntekijä on tavoitettavissa ja työnantaja voi tarvittaessa kutsua hänet hoitamaan palvelussuhteeseen kuuluvia tehtäviä.", label: "Varallaolokorvaus" }, sundayWorkCompensation: { description: "Sunnuntaityöstä maksettava työaikakorvaus. Sunnuntaityökorvausta voidaan maksaa säännölliseltä työajalta tai säännöllisen työajan ylittävältä ajalta.", label: "Sunnuntaityökorvaus" }, undefined: { description: "Ei valintaa", label: "Ei valintaa" }, waitingTimeCompensation: { description: `Korvaus, johon työntekijällä on oikeus, jos palkanmaksu viivästyy työsuhteen päätyttyä. Ellei toisin sovita, palkka tulee maksaa palkanmaksukauden
 viimeisenä päivänä. Odotusajan korvausta voidaan
 maksaa enintään kuudelta päivältä.`, label: "Odotusajan korvaus" }, weeklyRestCompensation: { description: "Työaikakorvaus, jota maksetaan viikkolevon aikana tehdystä työstä.", label: "Viikkolepokorvaus" } }, YtjCompanyType: { alandFederation: { label: "Ahvenanmaan liikelaitos" }, asoAssociation: { label: "Asumisoikeusyhdistys" }, association: { label: "Aatteellinen yhdistys" }, condominium: { label: "Asunto-osakeyhtiö" }, cooperativeBank: { label: "Osuuspankki" }, europeanCooperative: { label: "Eurooppaosuuskunta" }, europeanCooperativeBank: { label: "Eurooppaosuuspankki" }, federationOfMunicipalitiesEstablishment: { label: "Kuntainliiton liikelaitos" }, financialAssociation: { label: "Taloudellinen yhdistys" }, forestCareAssociation: { label: "Metsänhoitoyhdistys" }, foundation: { label: "Säätiö" }, housingCooperative: { label: "Asunto-osuuskunta" }, hypoAssociation: { label: "Hypoteekkiyhdistys" }, insuranceAssociation: { label: "Vakuutusyhdistys" }, ky: { label: "Kommandiittiyhtiö" }, municipalEstablishment: { label: "Kunnallinen liikelaitos" }, mutualInsuranceAssociation: { label: "Keskinäinen vahinkovak.yhdistys" }, noCompanyType: { label: "Ei yritysmuotoa" }, openCompany: { label: "Avoin yhtiö" }, otherAssociation: { label: "Muu yhdistys" }, otherFinancialAssociation: { label: "Muu taloudellinen yhdistys" }, oy: { label: "Osakeyhtiö" }, privateEntrepreneur: { label: "Yksityinen elinkeinonharjoittaja l. toiminimi" }, reindeerHerdingCooperative: { label: "Paliskunta" }, savingsBank: { label: "Säästöpankki" }, specialPurposeAssociation: { label: "Erityislainsäädäntöön perustuva yhdistys" }, stateEstablishment: { label: "Valtion liikelaitos" }, unknown: { label: "Tuntematon yritysmuoto" } }, Holiday: {}, IncomeEarnerType: { athlete: { label: "Urheilija" }, employedByStateEmploymentFund: { label: "Valtion työllisyysmäärärahoilla työllistetty" }, entrepreneurOrFarmerNoPensionRequired: { label: "Yrittäjä, ei YEL- tai MYEL-vakuuttamisvelvollisuutta" }, jointOwnerWithPayer: { label: "Osakasasemassa maksajaan" }, keyEmployee: { label: "Avainhenkilö" }, leasedEmployeeLivingAbroad: { label: "Ulkomailla asuva vuokratyöntekijä" }, netOfTaxContract: { label: "Työnantaja maksaa työntekijän puolesta verot (nettopalkkasopimus)" }, organization: { label: "Yhteisö" }, partialOwner: { label: "Osaomistaja" }, performingArtist: { label: "Esiintyvä taiteilija" }, personWorkingAbroad: { label: "Ulkomailla työskentelevä henkilö" }, personWorkingInFrontierDistrict: { label: "Rajakunnassa työskentelevä henkilö" }, personWorkingOnAlandFerry: { label: "Ahvenanmaan maantielautalla työskentelevä henkilö" }, restrictedPeriodInFinland: { label: "Tulonsaaja on oleskellut Suomessa enintään 183 päivää verosopimuksessa tarkoitettuna ajanjaksona" }, dimplomaticMission: { label: "Diplomaattisen edustuston maksamaa palkkaa saava henkilö" }, eppo: { label: "EPPO-lain mukaista vakuutuspalkkaa saava henkilö" }, lightEntrepreneur: { label: "Kevytyrittäjä. Laskutuspalvelua käyttävä henkilö, jolla ei ole Y-tunnusta" } }, OAuthError: { "<any>access_denied": { label: "Access_denied" }, "<any>invalid_request": { label: "Invalid_request" }, "<any>invalid_scope": { label: "Invalid_scope" }, "<any>server_error": { label: "Server_error" }, "<any>temporarily_unavailable": { label: "Temporarily_unavailable" }, "<any>unauthorized_client": { label: "Unauthorized_client" }, "<any>undefined": { label: "Undefined" }, "<any>unsupported_response_type": { label: "Unsupported_response_type" } }, OAuthGrantType: { "<any>authorization_code": { label: "Authorization_code" }, "<any>client_credentials": { label: "Client_credentials" }, "<any>jwtBearer": { label: "JwtBearer" }, "<any>password": { label: "Password" }, "<any>refresh_token": { label: "Refresh_token" }, "<any>undefined": { label: "Undefined" } }, OAuthResponseType: { "<any>code": { label: "Code" }, "<any>token": { label: "Token" }, "<any>undefined": { label: "Undefined" } }, OAuthSalaxyAuthorizeMode: { "<any>sign_in": { label: "Sign_in" }, "<any>sign_up": { label: "Sign_up" }, "<any>undefined": { label: "Undefined" } }, OAuthTokenType: { "<any>bearer": { label: "Bearer" }, "<any>mac": { label: "Mac" }, "<any>undefined": { label: "Undefined" } }, SettingsStatus: { checked: { label: "Ok" }, pending: { label: "Käsittelyssä" }, undefined: { label: "-" } }, TaxReportHandling: { always: { label: "Palkkaus.fi lähettää työnantajan erillisilmoituksen siinäkin tapauksessa, jossa työnantaja ei ole maksanut palkkoja viimeisen 12 kuukauden aikana" }, default: { label: "Palkkaus.fi lähettää kaikki ilmoitukset. Ei palkanmaksua -ilmoitus lähetetään 12 kuukauden ajan viimeisimmästä palkanmaksusta." }, noMonthlyReport: { label: "Palkkaus.fi ei lähetä työnantajan erillisilmoitusta" }, noZeroSalaryReport: { label: "Palkkaus.fi ei lähetä Nollailmoitusta" } }, WorkerSalaryNotification: { always: { label: "Työntekijälle lähetetään aina sähköpostilla viesti palkanmaksusta." }, silent: { label: "Työntekijälle ei lähetetä viestiä palkanmaksusta." } }, WorkerSalarySlipDeliveryMethod: { default: { label: "Oletus: PDF-tiedosto Palkkaus.fi -palvelussa." }, payslip: { label: "Verkkopalkan lähetys työntekijän pankkiin" }, omapalkka: { label: "Palkkalaskelmien lähetys Omapalkkaan" } }, Unit: { hours: { label: "Tuntia", shortIndicator: "h" }, days: { label: "Päivää", shortIndicator: "pv" }, weeks: { label: "Viikkoa", shortIndicator: "vko" }, period: { label: "Jakso", shortIndicator: "jakso" }, one: { label: "Yksi", shortIndicator: "" }, count: { label: "Määrä", shortIndicator: "kpl" }, percent: { label: "Prosenttia", shortIndicator: "%" }, kilometers: { label: "Kilometriä", shortIndicator: "km" }, euro: { label: "Euroa", shortIndicator: "€" } }, UsecaseStatus: { undefined: { label: "Ei arvoa" }, default: { label: "Oletus ja voimassa" }, active: { label: "Voimassa" }, inactive: { label: "Ei voimassa" } }, UnemploymentPayrollLimitStatus: { default: { label: "Palkkasummarajaa ei ole ylitetty" }, higher: { label: "Palkkasummaraja korotetulle prosentille on ylittynyt" } }, MessageThreadStatus: { draft: { label: "Muokattavissa" }, active: { label: "Lähetetty" }, approved: { label: "Hyväksytty" }, rejected: { label: "Hylätty" }, archived: { label: "Arkistoitu" }, template: { label: "Viestipohja" } }, ThreadedMessageType: { timer: { label: "Kellokortti" }, hourlyReport: { label: "Tuntiraportti" }, timeReport: { label: "Työaikaraportti" }, annualLeave: { label: "Vuosiloma" }, absence: { label: "Poissaolo" }, calcRow: { label: "Palkkalaskelmarivi" }, travel: { label: "Matkalasku" }, expense: { label: "Kulukorvaus" } }, EmploymentRelationSalaryPaymentMethod: { bankAccount: { label: "Maksu työntekijän pankkitilille" }, external: { label: "Maksetaan Palkkaus-palvelun ulkopuolella" } }, CostAccountingDimensionScope: { none: { label: "Ei rajoitettu" }, calculation: { label: "Käytetään vain laskelmilla" }, row: { label: "Käytetään vain riveillä" }, hidden: { label: "Piilotettu" } }, PeriodDateKind: { paidAtDate: { label: "Työnantajan suoritus" }, salaryDate: { label: "Työntekijän palkkapäivä" }, workDate: { label: "Työn palkkakausi" }, workDateStart: { label: "Työn palkkakauden alkupäivä" }, workDateEnd: { label: "Työn palkkakauden loppupäivä" } }, Culture: { fi: { label: "Suomalainen", description: "Suomalainen (12,34 / 1.2.2020)" }, en: { label: "Kansainvälinen", description: "Kansainvälinen (12.34 / 2020-02-01)" } }, FormsParty: { undefined: { label: "Ei arvoa" }, worker: { label: "Työntekijä" }, employer: { label: "Työnantaja" }, accountant: { label: "Tilitoimisto" } }, FormsWorkflowRole: { undefined: { label: "Ei arvoa" }, initiator: { label: "Aloittaja" }, approvaer: { label: "Hyväksyjä" }, payer: { label: "Maksaja" } }, PensionRule: { default: { label: "Oletus" }, monthlyLowerLimit: { label: "Huomioi laskelmakohtainen ansion alaraja" } }, SitemapVisibility: { default: { label: "Oletus" }, visible: { label: "Näkyvissä" }, hidden: { label: "Piilotettu" }, readOnly: { label: "Vain luku" }, hiddenReadOnly: { label: "Piilotettu ja vain luku" }, disabled: { label: "Pois käytöstä" } }, Role: { undefined: { label: "Ei määritelty" }, accountant: { label: "Tilitoimisto" }, trustedPartner: { label: "Luotettu kumppani" }, accountantCandidate: { label: "Vahvistamaton tilitoimisto" }, pricingPartner: { label: "Hinnoittelukumppani" }, sepaPartner: { label: "SEPA-sopimuskumppani" } }, IdentityVerification: { employerAuthorization: { label: "Valtakirja" }, workerContract: { label: " TT-sopimus" }, manual: { label: "Manual valtakirja" }, temporary: { label: "Temp tunnistus" }, siirto: { label: "Siirto valtuutus" } }, ExpensesVatRate: { undefined: { label: "Arvonlisäveroa ei määritetty" }, tax255: { label: "25,5 % - Yleinen verokanta", description: "Yleinen verokanta. Tämä on useimpien tavaroiden ja palveluiden verokanta." }, tax24: { label: "24 % - Yleinen verokanta", description: "Yleinen verokanta. Tämä on useimpien tavaroiden ja palveluiden verokanta." }, tax14: { label: "14 % - Elintarvikkeet, ravintola- ja ateriapalvelut", description: "Elintarvikkeet, rehut, ravintola- ja ateriapalvelut. Huomaa, että alempi 14 %:n verokanta ei koske alkoholijuomien ja tupakkatuotteiden myyntiä eikä tarjoilua." }, tax10: { label: "10 % - Kirjat, kulttuuri, henkilökuljetus ja majoitus", description: "Kirjat, sanoma- ja aikakauslehdet, lääkkeet, liikuntapalvelut, elokuvanäytökset, kulttuuri- ja viihdetilaisuuksien sisäänpääsymaksut, henkilökuljetukset, majoituspalvelut, televisio- ja yleisradiotoiminnasta saadut korvaukset." }, tax0: { label: "0 % - Nollaverokanta", description: "Arvonlisäverottomien vesialusten myynti, vuokraus ja rahtaus sekä näihin aluksiin kohdistuvat työsuoritukset, jäsenlehtien ja mainosten veroton myynti yleishyödyllisille yhteisöille, varastointimenettelyihin liittyvä veroton myynti (verovarasto alvissa), vienti EU-alueen ulkopuolelle, tavaran myynti EU-maihin arvonlisäverovelvollisille ostajille (ohje alv eu-tavarakaupassa), muut kansainväliseen kauppaan liittyvät tavaroiden ja palvelujen myynnit, esim. veroton myynti diplomaateille ja kansainvälisille järjestöille." }, none: { label: "Ei ALV:tä" }, other: { label: "Muu ALV-prosentti" }, multiple: { label: "Useita ALV-kantoja" } }, VatRate: { none: { label: "Ei ALV:tä" }, vat2550: { label: "25,5 %" }, vat2400: { label: "24 %" }, vat1400: { label: "14 %" }, vat1000: { label: "10 %" }, vat0000: { label: " 0 %" }, other: { label: "Muu" } }, PaidSickLeaveKind: { undefined: { description: "Ei valintaa", label: "Ei valintaa" }, paidSickLeaveSalary: { description: "Sairausajan palkka, kertakorvaus.", label: "Palkallinen sairauspoissaolo, kertakorvaus" }, paidSickLeaveHourlySalary: { description: "Sairausajan palkka, palkanmaksu tehtyjen tuntien perusteella.", label: "Palkallinen sairauspoissaolo, tuntipalkka" }, paidSickLeaveMonthlySalary: { description: "Sairausajan palkka, kiinteä kuukausipalkka.", label: "Palkallinen sairauspoissaolo, kuukausipalkka" } }, TrainingKind: { undefined: { description: "Ei valintaa", label: "Ei valintaa" }, trainingSalary: { description: "Koulutusajan palkka, kertakorvaus.", label: "Koulutusaika, kertakorvaus" }, trainingHourlySalary: { description: "Koulutusajan palkka, palkanmaksu tehtyjen tuntien perusteella.", label: "Koulutusaika, tuntipalkka" }, trainingMonthlySalary: { description: "Koulutusajan palkka, kiinteä kuukausipalkka.", label: "Koulutusaika, kuukausipalkka" } }, InternationalSocialSecurityType: { default: { label: "Suomen sosiaaliturva" }, foreign: { label: "Ei suomen sosiaaliturvassa" }, mixed: { label: "Osittainen Suomen sosiaaliturva" } }, InternationalSocialSecurityException: { notSubjectToEarningsRelatedPensionInsurance: { label: "Työeläkevakuutus: Ei kuulu Suomen sosiaaliturvan soveltamispiiriin" }, notSubjectToAccidentAndOccupationalDiseaseInsurance: { label: "Työtapaturma- ja ammattitautivakuutus: Ei kuulu Suomen sosiaaliturvan soveltamispiiriin" }, notSubjectToUnemploymentInsurance: { label: "Työttömyysvakuutus: Ei kuulu Suomen sosiaaliturvan soveltamispiiriin" }, notSubjectToHealthInsurance: { label: "Sairausvakuutus: Ei kuulu Suomen sosiaaliturvan soveltamispiiriin" }, voluntaryEarningsRelatedPensionInsurance: { label: "Vapaaehtoinen vakuuttaminen Suomessa (työeläkevakuutus)" }, noObligationToHealthInsuranceDailyAllowanceContribution: { label: "Päivärahamaksu (sairausvakuutus): Ei vakuuttamisvelvollisuutta" } }, Country: { fi: { label: "Suomi" }, ae: { label: "Arabiemiraatit" }, at: { label: "Itävalta" }, ba: { label: "Bosnia ja Hertsegovina" }, bg: { label: "Bulgaria" }, by: { label: "Valko-Venäjä" }, cn: { label: "Kiina" }, de: { label: "Saksa" }, eg: { label: "Egypti" }, fr: { label: "Ranska" }, gg: { label: "Guernsey" }, hr: { label: "Kroatia" }, ie: { label: "Irlanti" }, in: { label: "Intia" }, je: { label: "Jersey" }, kr: { label: "Korean tasavalta" }, lk: { label: "Sri Lanka" }, lv: { label: "Latvia" }, me: { label: "Montenegro" }, mx: { label: "Meksiko" }, no: { label: "Norja" }, pk: { label: "Pakistan" }, rs: { label: "Serbia" }, sg: { label: "Singapore" }, th: { label: "Thaimaa" }, tr: { label: "Turkki" }, us: { label: "Amerikan yhdysvallat" }, vg: { label: "Brittiläiset Neitsytsaaret" }, zm: { label: "Sambia" }, am: { label: "Armenia" }, au: { label: "Australia" }, bb: { label: "Barbados" }, bm: { label: "Bermuda" }, ca: { label: "Kanada" }, cy: { label: "Kypros" }, dk: { label: "Tanska" }, es: { label: "Espanja" }, gb: { label: "Iso-Britannia" }, gr: { label: "Kreikka" }, hu: { label: "Unkari" }, il: { label: "Israel" }, is: { label: "Islanti" }, jp: { label: "Japani" }, ky: { label: "Caymansaaret" }, lt: { label: "Liettua" }, ma: { label: "Marokko" }, mk: { label: "Makedonia" }, my: { label: "Malesia" }, nz: { label: "Uusi-Seelanti" }, pl: { label: "Puola" }, ru: { label: "Venäjä" }, si: { label: "Slovenia" }, tj: { label: "Tadžikistan" }, tz: { label: "Tansania" }, uy: { label: "Uruguay" }, vn: { label: "Vietnam" }, ar: { label: "Argentiina" }, az: { label: "Azerbaidžan" }, be: { label: "Belgia" }, br: { label: "Brasilia" }, ch: { label: "Sveitsi" }, cz: { label: "Tšekki" }, ee: { label: "Viro" }, ge: { label: "Georgia" }, hk: { label: "Hongkong" }, id: { label: "Indonesia" }, im: { label: "Mansaari" }, it: { label: "Italia" }, kg: { label: "Kirgisia" }, kz: { label: "Kazakstan" }, lu: { label: "Luxemburg" }, md: { label: "Moldova" }, mt: { label: "Malta" }, nl: { label: "Alankomaat" }, ph: { label: "Filippiinit" }, ro: { label: "Romania" }, se: { label: "Ruotsi" }, sk: { label: "Slovakia" }, tm: { label: "Turkmenistan" }, ua: { label: "Ukraina" }, uz: { label: "Uzbekistan" }, za: { label: "Etelä-Afrikka" }, other: { label: "Muu..." } }, TaxAtSourceKind: { label: "Lähdevero", description: "Lähdevero ja lähdeverovähennys (rajoitetusti verovelvollinen)", undefined: { label: "Valitse..." }, noDeduction: { label: "Ei vähennystä" }, monthlyDeduction: { label: "Vähennys, euroa kuukaudessa" }, dailyDeduction: { label: "Vähennys, euroa päivässä" }, fixedValues: { label: "Kiinteät arvot" } }, InternationalIdentifier: { undefined: { label: "Valitse..." }, taxIdentificationNumber: { label: "Verotunniste (TIN)" }, foreignPersonalIdentificationNumber: { label: "Ulkomainen henkilötunnus" }, other: { label: "Muu tunnus" } }, TaxWithholdingKind: { label: "Ennakonpidätyksen laskentatapa", undefined: { label: "Valitse..." }, percentage: { label: "Ennnakonpidätysprosentti" }, fixedValue: { label: "Kiinteä ennakonpidätyksen määrä" } }, SalaryDateKind: { default: { label: "Normaali palkanmaksu", description: "Nettopalkkaa ei ole vielä maksettu työntekijälle.", descriptionCfa: "<p>Nettopalkkaa ei ole vielä maksettu työntekijälle.</p><ul> <li ><b>Tulorekisteri:</b> Palkka ilmoitetaan tulorekisteriin valitulle palkkapäivälle, kun maksu Palkkaus.fi:lle on tehty.</li> <li ><b>Nettopalkka ja veromaksut:</b> Jos maksu Palkkaus.fi:lle sisältää nettopalkkoja, työnantajasuorituksia (verot ja sairausvakuutusmaksut) tai eläkemaksuja, Palkkaus.fi tilittää ne asianomaisille tahoille. Muussa tapauksessa työnantajan pitää itse maksaa ne, jolloin lasku työnantajasuorituksista on Omaverossa.</li> <li ><b>Muut sivukulut:</b> Työttömyysvakuutusmaksuista aina ja mahdollisista eläkemaksuista yhtiöt lähettävät erikseen laskut palkkatietoilmoituksen perusteella, jos näitä eriä ei ole maksussa mukana.</li></ul>", descriptionNonCfa: "<p>Nettopalkkaa ei ole vielä maksettu työntekijälle. Kun palkan nettopalkkalasku kuitataan maksetuksi</p><ul> <li ><b>Tulorekisteri:</b> Palkka ilmoitetaan tulorekisteriin valitulle palkkapäivälle.</li> <li ><b>Veromaksut:</b> Työnantajasuorituksista (verot ja sairausvakuutusmaksut) muodostuu lasku palkkapäivää seuraavan kuun 6. päivä. Työnantajasuoritusten lasku näkyy myös Omaverossa.</li> <li ><b>Muut sivukulut:</b> Mahdollisista työeläkemaksuista ja työttömyysvakuutusmaksuista yhtiöt lähettävät erikseen laskut palkkatietoilmoituksen perusteella.</li></ul>" }, inPast: { label: "Takautuva palkka", description: "Nettopalkka on jo maksettu työntekijälle. Palkka ilmoitetaan tulorekisteriin valitulle palkkapäivälle. Huomioithan, että myöhässä tehdystä ilmoituksesta voi seurata myöhästymismaksuja eri viranomaisilta.", descriptionCfa: "<p>Nettopalkka on jo maksettu työntekijälle.</p><ul> <li ><b>Tulorekisteri:</b> Palkka ilmoitetaan tulorekisteriin valitulle palkkapäivälle, kun maksu Palkkaus.fi:lle on tehty.</li> <li ><b>Veromaksut:</b> Työnantajasuoritusten (verot ja sairausvakuutusmaksut) lasku näkyy vain Omaverossa.</li> <li ><b>Muut sivukulut:</b> Mahdollisista eläkemaksuista ja työttömyysvakuutusmaksuista yhtiöt lähettävät erikseen laskut palkkatietoilmoituksen perusteella.</li> <li >Huomioithan, että myöhässä tehdystä ilmoituksesta voi seurata myöhästymismaksuja eri viranomaisilta.</li></ul>", descriptionNonCfa: "<p>Nettopalkka on jo maksettu työntekijälle. Palkan nettopalkkalasku kuitataan kuitataan automaattisesti maksetuksi</p><ul> <li ><b>Tulorekisteri:</b> Palkka ilmoitetaan tulorekisteriin valitulle palkkapäivälle.</li> <li ><b>Veromaksut:</b> Jos palkkapäivä on kuluvalla tai vielä raportoimattomalla edellisellä kuulla (ennen kuluvan kuun 5. päivää), työnantajasuorituksista (verot ja sairausvakuutusmaksut) muodostuu lasku normaaliin tapaan. Muussa tapauksessa työnantajasuoritusten lasku näkyy vain Omaverossa.</li> <li ><b>Muut sivukulut:</b> Mahdollisista työeläkemaksuista ja työttömyysvakuutusmaksuista yhtiöt lähettävät erikseen laskut palkkatietoilmoituksen perusteella.</li> <li >Huomioithan, että myöhässä tehdystä ilmoituksesta voi seurata myöhästymismaksuja eri viranomaisilta.</li></ul>" } }, CalcGroup: { baseSalary: { label: "Rahapalkka" }, salaryAdditions: { label: "Lisät" }, benefits: { label: "Edut" }, deductions: { label: "Vähennykset" }, expenses: { label: "Kulukorvaukset" } }, SystemMessage: { reportChecked: { label: "Uusi" }, reportInvalid: { label: "Epäkelpo" }, reportScheduled: { label: "Ajastettu" }, reportDelivered: { label: "Ilmoitettu" }, reportCanceled: { label: "Peruttu" }, reportError: { label: "Virhe" }, issue: { label: "Virhe" } } }, ENUM_IR: { EarningsPaymentReportStatus: { new: { label: "Uusi" }, succeeded: { label: "Onnistuneesti lähetetty" }, canceled: { label: "Mitätöity" }, error: { label: "Virheellinen" }, invalid: { label: "Tarkastettava" }, scheduled: { label: "Ajastettu" } }, PayerSummaryReportStatus: { new: { label: "Uusi" }, succeeded: { label: "Onnistuneesti lähetetty" }, canceled: { label: "Mitätöity" }, error: { label: "Virheellinen" }, invalid: { label: "Tarkastettava" }, scheduled: { label: "Ajastettu" } }, SummaryTransactionCode: { noWagesPayable: { label: "Ei palkanmaksua", description: "Tieto annetaan, jos maksajalla ei ole kyseisen kuukauden aikana ollut laisinkaan palkanmaksua. Jos maksaja on maksanut palkkaa ko. kuukauden aikana, tietoa ei anneta. Ei palkanmaksua -tieto voidaan ilmoittaa kuudelta kalenterikuukaudelta etukäteen, jos tiedetään, ettei seuraavan puolen vuoden aikana ole tarkoitus palkata ketään. Tieto on annettava vain, jos maksaja on rekisteröitynyt säännöllisesti palkkoja maksavaksi työnantajaksi Verohallinnon työnantajarekisteriin. Ei palkanmaksua-tietoa ei voida antaa aliorganisaatioittain. Tieto annetaan vain, jos suorituksen maksaja ei ole maksanut miltään osin palkkaa ko. kuukauden aikana." }, employersHealthInsuranceContribution: { label: "Sairausvakuutusmaksu", description: "Maksaja ilmoittaa kyseisen kuukauden aikana maksamisensa palkkojen perusteella laskemansa työnantajan sairausvakuutusmaksun määrän. Kohdassa ei ilmoiteta palkkojen yhteismäärää, vaan palkoista lasketun työnantajan sairausvakuutusmaksun yhteismäärä ilmoituskuukauden ajalta. Summasta ei vähennetä Työnantajan sairausvakuutusmaksusta tehtävät vähennykset -tulolajilla ilmoitettuja vähennyksiä." }, deductionsToBeMadeFromTheEmployersHealthInsuranceContribution: { label: "Vähennykset SAVA-maksusta", description: "Tiedossa ilmoitetaan maksajan oma-aloitteisesti sairausvakuutusmaksuista tehdyt vähennykset. Työnantaja voi tehdä vähennyksen esimerkiksi silloin, jos se on maksanut työntekijälle palkkaa ja samaan aikaan työnantajalle on maksettu lakiin perustuvaa eläkettä, päivärahaa tai muuta ansionmenetystä korvaavaa etuutta, joka on myönnetty työntekijälle. Työnantajalla on oikeus saada maksamansa työnantajan sairausvakuutusmaksu Verohallinnolta takaisin siltä osin, kuin se vastaa työnantajalle maksettua suoritusta." } }, ReportLogEventType: { undefined: { label: "Määrittämätön" }, sent: { label: "Lähetetty" }, canceled: { label: "Mitätöity" }, error: { label: "Virheellinen" } }, DeliveryDataType: { earningsPaymentReports: { label: "Palkkatietoilmoitukset" }, employersSeparateReports: { label: "Työnantajan erillisilmoitukset" }, benefitsPaymentReports: { label: "Etuustietoilmoitukset" }, recordSubscription: { label: "Aineistotilaus" }, cancellationOfEarningsPaymentReports: { label: "Palkkatietoilmoitusten mitätöiminen" }, cancellationOfEmployersSeparateReports: { label: "Työnantajan erillisilmoitusten mitätöiminen" }, cancellationOfBenefitsPaymentReports: { label: "Etuustietoilmoitusten mitätöiminen" }, cancellationOfARecordSubscription: { label: "Aineistotilauksen mitätöiminen" }, cancellationOfARecordContainingEarningsPaymentReports: { label: "Palkkatietoilmoituksia sisältävän aineiston mitätöiminen" }, cancellationOfARecordContainingEmployersSeparateReports: { label: "Työnantajan erillisilmoituksia sisältävän aineiston mitätöiminen" }, cancellationOfARecordContainingBenefitsPaymentReports: { label: "Etuustietoilmoituksia sisältävän aineiston mitätöiminen" }, cancellationOfARecordContainingARecordSubscription: { label: "Aineistotilauksen sisältävän aineiston mitätöiminen" } }, IdType: { businessId: { label: "Y-tunnus" }, personalIdentificationNumber: { label: "Henkilötunnus (suomalainen)" }, vat: { label: "Alv-tunniste (VAT)" }, giin: { label: "GIIN-tunniste" }, taxIdentificationNumber: { label: "Verotunniste(TIN)" }, finnishTradeRegistrationNumber: { label: "Kaupparekisteritunnus" }, foreignBusinessRegistrationNumber: { label: "Ulkomainen yritystunnus" }, foreignPersonalIdentificationNumber: { label: "Ulkomainen henkilötunnus" }, other: { label: "Muu tunnus" } }, ResponsibilityCode: { contentIssues: { label: "Sisällölliset asiat" }, technicalIssues: { label: "Tekniset asiat" } }, PayerType: { publicSector: { label: "Julkisyhteisö" }, household: { label: "Kotitalous" }, temporaryEmployer: { label: "Tilapäinen työnantaja" }, foreignEmployer: { label: "Ulkomainen työnantaja" }, state: { label: "Valtio" }, unincorporatedStateEnterpriseOrGovernmentalInstitution: { label: "Valtion liikelaitos tai erillishallinnollinen valtion laitos" }, specialisedAgency: { label: "Kansainvälinen erityisjärjestö" }, foreignGroupCompany: { label: "Ulkomainen konserniyhtiö" }, poolOfHouseholdEmployers: { label: "Kotitalouksien työnantajarinki" } }, PayerSubOrgType: { kevasSubmitterCodes: { label: "Kevan ilmoittajakoodisto" }, payersOwnCodes: { label: "Maksajan oma koodisto" }, governmentAgencyIdentifier: { label: "Virastotunniste" } }, AddressType: { addressInHomeCountry: { label: "Osoite kotivaltiossa" }, addressInTheCountryOfWork: { label: "Osoite työskentelyvaltiossa" } }, ProfessionType: { statisticsFinland: { label: "Tilastokeskuksen ammattiluokitus (TK10)" }, keva: { label: "Kevan nimikkeistö" }, bankOfFinland: { label: "Suomen Pankin nimikkeistö" }, trafi: { label: "Trafin nimikkeistö" } }, EmploymentCode: { fullTime: { label: "Kokoaikainen" }, partTime: { label: "Osa-aikainen" }, notAvailable: { label: "Tietoa ei ole saatavilla" } }, TermCode: { untilFurtherNotice: { label: "Toistaiseksi voimassa oleva" }, fixedTerm: { label: "Määräaikainen" } }, PaymentType: { monthly: { label: "Kuukausipalkka" }, hourly: { label: "Tuntipalkka" }, contractPay: { label: "Urakkapalkka" } }, EmploymentEndingType: { kevaCodes: { label: "Kevan koodisto" }, bankOfFinlandCodes: { label: "Suomen Pankin koodisto" }, incomesRegisterCodes: { label: "Tulorekisterin koodisto" } }, EmploymentRegType: { kevasGroundsForRegistration: { label: "Kevan rekisteröinnin peruste" }, bankOfFinlandsGroundsForRegistration: { label: "Suomen Pankin rekisteröinnin peruste" } }, PensionActCode: { employeesEarningsRelatedPensionInsurance: { label: "Työntekijän työeläkevakuutus" }, pensionInsuranceForFarmers: { label: "Maatalousyrittäjän eläkevakuutus (MYEL)" }, pensionInsuranceForTheSelfEmployed: { label: "Yrittäjän eläkevakuutus (YEL)" } }, PensionProvIdCode: { none: { label: "Ei valintaa" }, finnishCentreForPensions: { label: "Eläketurvakeskus" }, clergyOfTheOrthodoxChurch: { label: "Ortodoksisen kirkon papiston eläkekassa" }, kevaMemberOrganisations: { label: "Kevan jäsenyhteisöt" }, kevaÅlandLandskapsregeringsPensionssystem: { label: "Keva - Åland landskapsregerings pensionssystem" }, kevaChurch: { label: "Keva - kirkko" }, bankOfFinland: { label: "Suomen Pankki" }, kevaKelaEmploymentPensions: { label: "Keva - Kelan toimisuhde-eläkkeet" }, kevaState: { label: "Keva - valtio" }, seafarers: { label: "Merimieseläkekassa" }, farmers: { label: "Maatalousyrittäjien eläkelaitos" }, alandia: { label: "Ålandia" }, ilmarinen: { label: "Keskinäinen Eläkevakuutusyhtiö Ilmarinen" }, elo: { label: "Keskinäinen Työeläkevakuutusyhtiö Elo" }, varma: { label: "Keskinäinen työeläkevakuutusyhtiö Varma" }, veritas: { label: "Eläkevakuutusosakeyhtiö Veritas" }, uPM: { label: "UPM Sellutehtaiden eläkesäätiö" }, sanoma: { label: "Sanoman Eläkesäätiö" }, sandvik: { label: "Sandvik Eläkesäätiö" }, kontino: { label: "Kontinon yhteiseläkesäätiö" }, yleisradio: { label: "Yleisradion eläkesäätiö" }, aBB: { label: "ABB Eläkesäätiö" }, lFashionGroup: { label: "L-Fashion Group Oy:n eläkesäätiö" }, honeywell: { label: "Honeywell Oy:n Henkilökunnan Eläkesäätiö" }, telia: { label: "Telian Eläkesäätiö" }, yaraSuomi: { label: "Yara Suomen Eläkesäätiö" }, orion: { label: "Orionin Eläkesäätiö" }, valio: { label: "Valion Eläkekassa" }, oP: { label: "OP-Eläkekassa" }, verso: { label: "Eläkekassa Verso" }, apteekkien: { label: "Apteekkien Eläkekassa" }, viabek: { label: "Liikennepalvelualojen Eläkekassa Viabek" }, reka: { label: "Reka Eläkekassa" } }, PaidAbsenceCauseCode: { illness: { label: "Sairaus" }, partTimeSickLeave: { label: "Osa-aikainen sairauspoissaolo" }, parentalLeave: { label: "Äitiys-, isyys- ja vanhempainvapaa" }, specialMaternityLeave: { label: "Erityisäitiysvapaa" }, rehabilitation: { label: "Kuntoutus" }, childIllness: { label: "Lapsen sairaus tai pakottava perhesyy" }, partTimeChildCareLeave: { label: "Osittainen hoitovapaa" }, training: { label: "Koulutus" }, leaveOfAbsence: { label: "Virkavapaa" }, militaryRefresherTraining: { label: "Kertausharjoitus" }, midWeekHoliday: { label: "Arkipyhä" }, accruedHoliday: { label: "Pekkasvapaa" }, occupationalAccident: { label: "Työtapaturma" }, annualLeave: { label: "Vuosiloma" }, partTimeAbsenceDueToRehabilitation: { label: "Osittainen poissaolo kuntoutuksen vuoksi" }, other: { label: "Muu syy" } }, UnpaidAbsenceCauseCode: { illness: { label: "Sairaus" }, partTimeSickLeave: { label: "Osa-aikainen sairauspoissaolo" }, parentalLeave: { label: "Äitiys-, isyys- ja vanhempainvapaa" }, specialMaternityLeave: { label: "Erityisäitiysvapaa" }, rehabilitation: { label: "Kuntoutus" }, childIllness: { label: "Lapsen sairaus tai pakottava perhesyy" }, partTimeChildCareLeave: { label: "Osittainen hoitovapaa" }, training: { label: "Koulutus" }, jobAlternationLeave: { label: "Vuorotteluvapaa" }, studyLeave: { label: "Opintovapaa" }, industrialAction: { label: "Lakko tai työsulku" }, interruptionInWorkProvision: { label: "Työtarjonnan keskeytyminen" }, leaveOfAbsence: { label: "Virkavapaa" }, militaryRefresherTraining: { label: "Kertausharjoitus" }, militaryService: { label: "Varusmiespalvelus tai siviilipalvelus" }, layOff: { label: "Lomautus" }, childCareLeave: { label: "Hoitovapaa" }, other: { label: "Muu syy" } }, AllowanceCode: { mealAllowance: { label: "Ateriakorvaus" }, partialDailyAllowance: { label: "Osapäiväraha" }, fullDailyAllowance: { label: "Kokopäiväraha" }, internationalDailyAllowance: { label: "Ulkomaan päiväraha" }, taxExemptReimbursementsAbroad: { label: "Ulkomaan työskentelyyn liittyvät verovapaat korvaukset" } }, BenefitCode: { accommodationBenefit: { label: "Asuntoetu" }, telephoneBenefit: { label: "Puhelinetu" }, mealBenefit: { label: "Ravintoetu" }, otherBenefits: { label: "Muut edut" } }, InsuranceCode: { subjectToSocialInsuranceContributions: { label: "Sosiaalivakuutusmaksujen alainen (koodit 2-6)" }, subjectToEarningsRelatedPensionInsuranceContribution: { label: "Työeläkevakuutusmaksun alainen" }, subjectToHealthInsuranceContribution: { label: "Sairausvakuutusmaksun alainen" }, subjectToUnemploymentInsuranceContribution: { label: "Työttömyysvakuutusmaksun alainen" }, subjectToAccidentInsuranceAndOccupationalDiseaseInsuranceContribution: { label: "Työtapaturma- ja ammattitautivakuutusmaksun alainen" } }, WageUnitCode: { hour: { label: "Tunti" }, day: { label: "Päivä" }, week: { label: "Viikko" }, period: { label: "Jakso" } }, ReimbPaymentType: { kelaDailyAllowanceApplication: { label: "Kela, päivärahahakemus" }, kelaFamilyLeaveCompensation: { label: "Kela, perhevapaakorvaus" } }, ScheduleAction: { send: { label: "Lähetä" }, cancel: { label: "Mitätöi" } }, ActionCode: { newReport: { label: "Uusi ilmoitus" }, replacementReport: { label: "Korvaava ilmoitus" } } }, MODEL: { AccountingData: { period: { title: "Kausi" } }, AccountingDataSummary: { calculationCount: { title: "Palkkoja" }, workerCount: { title: "Työntekijöitä" }, totalGrossSalary: { title: "Palkat" }, totalPayment: { title: "Maksut" } }, AccountingSettings: { title: "Kirjanpito", descr: "Kirjanpidon tilikartta ja raportit", targets: { title: "Tilikartat" }, defaultPeriodDateKind: { title: "Raportin kauden määräytyminen" }, reportDelivery: { title: "Kirjanpitoraportin lähetys yritykselle" }, accountantReportDelivery: { title: "Kirjanpitoraportin lähetys kirjanpitäjälle" }, defaultTargetId: { title: "Oletustilikartta" } }, AccountingReportDelivery: { isEnabled: { title: "Voimassa" }, address: { title: "Sähköpostiosoite", descr: "Sähköpostiosoite raporttien lähetystä varten" } }, CalcInfo: { occupationCode: { title: "Työn tyyppi" }, salarySlipMessage: { title: "Viesti työntekijälle" }, workDescription: { title: "Kuvaus palkkalaskelmaan" }, workStartDate: { title: "Alkupäivä" }, workEndDate: { title: "Loppupäivä" } }, CalcTax: { fixedTaxAmount: { title: "Ennakonpidätys" } }, CalcWorktime: { bonus: { title: "Lomaraha" }, workDays: { title: "Työpäiviä kaudella" } }, DateRange: { title: "Kausi", start: { title: "Alku" }, end: { title: "Loppu" }, daysCount: { title: "Päiviä jaksolla" }, days: { title: "Päiviä jaksolla" } }, WorkflowEvent: { assignedTo: { title: "Vastuuhenkilö" } }, WorkerListItem: { createdAt: { title: "Luotu" }, updatedAt: { title: "Päivitetty" } }, MessageData: { title: { title: "Aihe" }, ownerUnreadCount: { title: "Lukematta" }, otherPartyUnreadCount: { title: "Lukematta", tableHeading: "...asiakkaalla" }, partnerMessageAssignedTo: { title: "Vastuuhenkilö" } }, MessageListItem: { createdAt: { title: "Luotu" }, updatedAt: { title: "Päivitetty" }, salaryDate: { title: "Palkkapäivä" }, startAt: { tableHeading: "Viimeisin viesti" }, messages: { title: "Viestit", tableHeading: "Tarkistettu" }, sender: "Lähettäjä" }, CalculationListItem: { endAt: { tableHeading: "Pvm" }, grossSalary: { title: "Palkka" }, payment: { title: "Maksu" }, status: { title: "Tila" }, messages: { title: "Viestit", tableHeading: "Tarkistettu", tableHeadingValidation: "Tarkistusviestit" }, salaryDate: { title: "Palkkapäivä" }, shortText: { title: "Kuvaus" } }, CalculationData: { usecaseUri: { title: "Käyttötapaus" }, partnerMessageAssignedTo: { title: "Vastuuhenkilö" }, workerPayment: { title: "Maksu työntekijälle" }, taxPayment: { title: "Ennakonpidätys" }, workStartDate: { title: "Palkkakauden alku" }, workEndDate: { title: "Palkkakauden loppu" } }, CalcWorkflow: { paymentDate: { title: "Laskennallinen palkkapäivä" }, requestedSalaryDate: { title: "Palkkapäivä" }, status: { title: "Tila" }, salaryDateKind: { title: "Palkkapäivän valinta" } }, PaymentPeriod: { title: "Palkanmaksukausi" }, TaxcardListItem: { startAt: { title: "Voimassa" }, endAt: { title: "Saakka", tableHeading: "..loppu" } }, TaxcardData: { forYear: { title: "Vuosi" }, totalIncome: { title: "Maksettu" }, incomeLimit: { title: "Tuloraja" }, taxPercent: { title: "Veroprosentti" }, taxPercent2: { title: "Lisäprosentti" } }, PayrollListItem: { status: { title: "Tila" }, messages: { title: "Viestit", tableHeading: "Tarkistettu", tableHeadingValidation: "Tarkistusviestit", tableHeadingNotChecked: "Ei tarkistettu", tableHeadingIssues: "Huomiot", tableHeadingNoIssues: "Ei huomioita" } }, InvoiceData: { channel: { title: "Aineiston kanava", tableHeading: "Kanava" }, dueDate: { title: "Maksun eräpäivä", tableHeading: "Eräpäivä" }, date: { title: "Laskun päivä" } }, InvoiceListItem: { status: { title: "Aineiston tila" }, startAt: { title: "Laskun päivä" }, endAt: { title: "Eräpäivä" }, createdAt: { title: "Luotu" }, updatedAt: { title: "Päivitetty" }, payment: { title: "Laskun summa", tableHeading: "Aineiston summa" }, reference: { title: "Viite" }, messages: { title: "Viestit" } }, PayrollData: { title: { title: "Kuvaus" }, partnerMessageAssignedTo: { title: "Vastuuhenkilö" } }, EarningsPaymentListItem: { createdAt: { title: "Luotu" }, endAt: { title: "Lähetysaika" }, updatedAt: { title: "Päivitetty" }, status: { title: "Tila" }, salaryDate: { title: "Palkkapäivä" }, payment: { title: "Maksu" }, grossSalary: { title: "Brutto" }, messages: { title: "Viestit", tableHeading: "Tarkistettu" } }, EarningsPaymentData: { partnerMessageAssignedTo: { title: "Vastuuhenkilö" }, firstDeliveredAt: { title: "Ensimmäinen lähetys" }, lastDeliveredAt: { title: "Viimeisin lähetys" }, scheduledFor: { title: "Tuleva lähetys" } }, PayerSummaryListItem: { createdAt: { title: "Luotu" }, endAt: { title: "Lähetysaika" }, updatedAt: { title: "Päivitetty" }, status: { title: "Tila" }, salaryDate: { title: "Palkkapäivä" }, payment: { title: "Sava-maksu" }, grossSalary: { title: "Brutto" }, messages: { title: "Viestit", tableHeading: "Tarkistettu" }, logicalDate: { tableHeading: "Kuukausi" } }, PayerSummaryData: { partnerMessageAssignedTo: { title: "Vastuuhenkilö" }, firstDeliveredAt: { title: "Ensimmäinen lähetys" }, lastDeliveredAt: { title: "Viimeisin lähetys" }, scheduledFor: { title: "Tuleva lähetys" }, transactionCode: { title: "Ilmoituksen tyyppi" }, socialSecurityDeduction: { title: "Vähennys" } }, HouseholdYearListItem: { backOfficeStatus: { title: "Käsittelyn tila" }, createdAt: { title: "Luotu" }, updatedAt: { title: "Päivitetty" }, endAt: { title: "Viimeisin tallennus" }, logicalDate: { tableHeading: "Vuosi" }, shortText: { title: "Viesti" }, status: { title: "Vastaus" }, messages: { title: "Viestit", tableHeading: "Huom!" } }, HouseholdYearData: { partnerMessageAssignedTo: { title: "Vastuuhenkilö" } }, Payer: { title: "Maksajan tiedot" }, PayerSummary: { status: { title: "Tila" } }, SubstitutePayer: { title: "Sijaismaksaja" }, Employment: { title: "Palvelussuhdetiedot" }, IncomeEarner: { title: "Tulonsaajan tiedot" }, PensionInsurance: { title: "Työeläkevakuutus" }, AccidentInsurance: { title: "Työtapaturmavakuutus" }, AccountingTargetSettings: { id: { title: "Tunniste" }, method: { title: "Raportin oletustyyppi" }, availableMethods: { title: "Raportin tyypit" }, avatar: { title: "Avatar" }, data: { title: "Data" }, channel: { title: "Kirjanpitokanava" }, webHookUrl: { title: "Web-osoite API-notifikaatiolle" } }, CalculationSettings: { pensionContracts: { title: "Eläkevakuutukset" }, insuranceContracts: { title: "Työtapaturma- ja ammattitautivakuutukset" }, employmentInsurance: { title: "Työttömyysvakuutusmaksut" } }, UnemploymentInsuranceSettings: { payrollLimitStatus: { title: "Palkkasummarajat" } }, CustomerFundsSettings: { isWorkerSelfHandling: { title: "Työnantaja maksaa suoraan nettopalkan" }, isPensionSelfHandling: { title: "Työnantaja maksaa suoraan eläkevakuutuksen" }, isTaxAndSocialSecuritySelfHandling: { title: "Työnantaja maksaa suoraan verot" } }, IncomesRegisterSettings: { irReporting: { title: "Kuukausittainen ilmoittaminen", editLabel: "Kuukausittainen ilmoittaminen" }, taxReferenceNumber: { title: "Veromaksujen viitenumero" } }, InsuranceContract: { title: "Tapaturmavakuutus", insurancePercent: { title: "Tapaturm.vak.maksun arvio-%", descr: "Vakuutusmaksu arvioidaan laskemalla annettu %-osuus palkasta" }, groupLifeInsurancePercent: { title: "Ryhmäh.vak.maksun arvio-%", descr: "Vakuutusmaksu arvioidaan laskemalla annettu %-osuus palkasta" }, company: { title: "Yhtiö", editLabel: "Valitse yhtiö" }, id: { title: "Tunniste" }, status: { title: "Tila" }, contractNumber: { title: "Sopimusnumero" }, startDate: { title: "Alkamispäivä" }, endDate: { title: "Päättymispäivä" }, isPartnerInsurance: { title: "Yhteistyökumppani" } }, InvoiceSettings: { title: "Laskutusasetukset settings", eInvoiceIntermediator: { title: "Välittäjä" }, eInvoiceReceiver: { title: "Verkkolaskuosoite" }, sepaBankPartyId: { title: "SEPA-maksatustunnus" }, ibanNumber: { title: "Tilinumero" } }, MessagingSettings: { title: "Viestintäasetukset", denyServiceModel: { title: "Ohita palvelumalli" }, partnerMessages: { title: "Viestit tilitoimistolle" }, workerSalaryNotifications: { title: "Viesti palkanmaksusta työntekijälle" }, workerSalarySlipDeliveryMethods: { title: "Palkkalaskelman toimitustapa työntekijälle" } }, PartnerServiceModel: { title: "Palvelumalli", package: { title: "Paketti" }, features: { title: "Aktivoidut palvelut" }, pricing: { title: "Hinnoittelu" }, branding: { title: "Brändi" }, site: { title: "Sivuston ominaisuudet" } }, PaymentChannelSettings: { channel: { title: "Maksukanava" }, isEnabled: { title: "Valittu" }, isAvailable: { title: "Valittavissa" }, data: { title: "Data" }, accountingTargetId: { title: "Kohteen tunniste" } }, PaymentSettings: { title: "Maksuasetukset", channels: { title: "Maksukanavat" }, customerFunds: { title: "Asiakasvara-asetukset" }, defaultChannel: { title: "Oletuskanava" }, denyServiceModel: { title: "Ohita palvelumalli" }, invoice: { title: "Verkkolaskuasetukset" } }, PensionContract: { title: "Työeläkevakuutus", company: { title: "Yhtiö", editLabel: "Valitse yhtiö" }, id: { title: "Tunniste" }, status: { title: "Tila" }, contractNumber: { title: "Sopimusnumero" }, startDate: { title: "Alkamispäivä" }, endDate: { title: "Päättymispäivä" }, pensionDiscountPercent: { title: "Työeläk.maksun ale-%", descr: "Työeläkeyhtiön antama alennus prosenttiyksikköinä työeläkemaksuun. Alennus kohdistuu työnantajan osuuteen työeläkevakuutusmaksusta." }, pensionPercent: { title: "Asiakaskohtainen työeläkemaksu-%", descr: "Voit syöttää tähän yhtiökohtaisen työeläkemaksuprosentin, jos työeläkeyhtiö on antanut sellaisen ja haluat käyttää sitä laskennassa ohjelmassa. Huomaathan, että kenttään tulee syöttää työeläkemaksun kokonaisprosentti ja ohjelma laskee automaattisesti työntekijän osuuden tämän iän perusteella. Kenttään syötetty prosentti vaikuttaa ensisijaisesti kirjanpitoon. Työeläkeyhtiö laskuttaa yhtiötä aina todellisen prosentin perusteella, joka saattaa vaihdella kuukausittain. Mahdolliset erotukset asiakasvaratilin kautta tilitetyissä maksuissa työeläkeyhtiö laskuttaa tai palauttaa suoraan asiakkaalle. Jos haluat syöttää voimassaoloajan työeläkemaksuprosentille, ole yhteydessä asiakaspalveluun." }, pensionDefaultPercent: { title: "Oletus-% työeläkemaksulle" }, subOrgCode: { title: "Aliorganisaation tunniste" } }, PrimaryPartnerSettings: { accountId: { title: "Palkkaus-tilin tunniste" }, info: { title: "Tiedot" }, type: { title: "Tyyppi" }, serviceModel: { title: "Palvelumalli" }, serviceModelId: { title: "Palvelumallin id" } }, ServiceModelAccounting: { title: "Kirjanpito", defaultTargetId: { title: "Oletustilikartta" }, targets: { title: "Tilikartat" }, defaultPeriodDateKind: { title: "Kauden määräytyminen" } }, ServiceModelBranding: { title: "Brändi", logo: { title: "Logo" }, skin: { title: "Tyylitiedosto" } }, ServiceModel: { title: "Palvelumalli", id: { title: "Id" }, name: { title: "Nimi" } }, ServiceModelFeatures: { title: "Aktivoitavat palvelut", messaging: { title: "Viestit" }, forms: { title: "Aineiston lähetys" }, accounting: { title: "Kirjanpito" }, payments: { title: "Maksaminen" }, reporting: { title: "Tulosteet" }, usecase: { title: "Räätälöinnit" }, costAccounting: { title: "Laskentakohteet" }, holiday: { title: "Lomalaskenta" } }, ServiceModelPayments: { title: "Maksaminen", defaultChannel: { title: "Oletusmaksutapa" }, channels: { title: "Maksutavat" } }, ServiceModelPricing: { title: "Hinnoittelu", pricingModel: { title: "Hinnoittelumalli" }, fixedFee: { title: "Kiinteä hinta" } }, ServiceModelSite: { title: "Sivuston ominaisuudet", webApp: { title: "Sovellus / sivusto" }, webAppName: { title: "Sovelluksen / sivuston nimi" }, webAppUrl: { title: "Sivuston osoite" }, texts: { title: "Tekstit" }, sitemap: { title: "Sivukartta" } }, ServiceModelHoliday: { title: "Lomalaskenta", holidayPaySettings: { title: "Vuosilomapalkan laskennan asetukset" }, holidayAccrualSettings: { title: "Lomakertymien asetukset" } }, ServiceModelUsecase: { title: "Käyttötapausten asetukset", usecases: { title: "Räätälöinnit" } }, ServiceModelMessaging: { title: "Viestintä", partnerMessages: { title: "Viestit tilitoimistolle" }, workerSalaryNotifications: { title: "Viesti palkanmaksusta työntekijälle" } }, UsecaseInSettings: { title: "Käyttötapaus", label: { title: "Käyttötapauksen kuvaus" }, uri: { title: "Käyttötapauksen tunniste (uri)" }, itemType: { title: "Käyttötapauksen kohde" }, isDefault: { title: "Oletustapaus" } }, UsecaseSettings: { title: "Käyttötapausten asetukset", denyServiceModel: { title: "Ohita palvelumalli" }, usecases: { title: "Räätälöinnit" } }, Dimensions: { title: "Laskentakohteet", costCenter: { title: "Kustannuspaikat" } }, UsecaseRow: { title: "Laskentakohteet", costCenter: { title: "Kustannuspaikat" } }, PercentDimension: { id: { title: "Kustannuspaikka" }, percent: { title: "Prosenttia" } }, CostAccountingSettings: { title: "Laskentakohteet", descr: "Ota käyttöön Laskentakohteet palkkalaskelmille ja palkkariveille.", denyServiceModel: { title: "Ohita palvelumalli" }, dimensions: { title: "Laskentakohdedimensiot" } }, ServiceModelCostAccounting: { title: "Laskentakohteet", descr: "Ota käyttöön laskentakohteet palkkalaskelmille ja palkkariveille.", dimensions: { title: "Laskentakohdedimensiot" } }, CostAccountingDimensionDefinition: { title: "Laskentakohdedimensio", id: { title: "Tunnus" }, label: { title: "Otsikko" }, options: { title: "Valintalista" }, allowCostSharing: { title: "Kustannusten jako" }, isRequired: { title: "Pakollinen kenttä" }, scope: { title: "Näkyvyys" } }, CostAccountingDimensionOption: { title: "Dimension arvo", value: { title: "Arvo" }, text: { title: "Kuvaus" }, scope: { title: "Näkyvyys" } }, FormsWorkflow: { title: "Työnkulku", label: { title: "Työnkulun kuvaus" }, initiator: { title: "Aloittaja" }, approver: { title: "Hyväksyjä" }, payer: { title: "Maksaja" }, activeRole: { title: "Aktiivinen rooli" } }, FormsSettings: { title: "Aineiston lähetys ja työnkulut", denyServiceModel: { title: "Ohita palvelumalli" }, workflows: { title: "Työnkulut" } }, ServiceModelForms: { title: "Aineiston lähetys ja työnkulut", workflows: { title: "Työnkulut" } }, PersonAccount: { identity: { firstName: { title: "Etunimi" }, lastName: { title: "Sukunimi" }, officialId: { title: "Henkilötunnus" }, ibanNumber: { title: "Tilinumero (IBAN)" } }, contact: { email: { title: "Sähköpostiosoite" }, telephone: { title: "Puhelinnumero" }, street: { title: "Katuosoite" }, postalCode: { title: "Postinumero" }, city: { title: "Kaupunki" }, countryCode: { title: "Maa" } }, verificationPin: { title: "Tekstiviestistä saamasi puhelinnumeron vahvistuskoodi" } }, UnionPaymentUsecase: { paymentPercentage: { title: "Jäsenmaksun määrä" }, recipientFullName: { title: "Ammattiyhdistys" }, iban: { title: "Pankkitili (iban) maksun luontia varten" }, referenceNumber: { title: "Pankkiviite maksun luontia varten" } }, ForeclosureUsecase: { periodLength: { title: "Palkanmaksukauden pituus" }, protectedPortionBase: { title: "Velallisen suojaosuus" }, protectedPortionDependant: { title: "Suojaosuuden lisä/huollettava" }, dependantsCount: { title: "Huollettavien määrä" }, incomeFromOtherSources: { title: "Muualta saatu tulo/kk" }, additionalAmountLeftToDebtor: { title: "Velalliselle jätettävä määrä/kk" }, referenceNumber: { title: "RF-pankkiviite maksun luontia varten" } }, TotalWorkerPaymentUsecase: { kind: { title: "Summan sisältämät erät" }, rowType: { title: "Palkkalaji" }, message: { title: "Palkkarivin kuvaus" } }, CarBenefitUsecase: { kind: { title: "Autoedun tyyppi" }, ageGroup: { title: "Auton ikäryhmä" }, isKilometersBased: { title: "Kilometripohjainen" }, kilometers: { title: "Kilometrit" }, deduction: { title: "Vähennys palkasta" }, emissionsValue: { title: "Auton päästöarvo (0-100)" } }, SubsidisedCommuteUsecase: { kind: { title: "Vähennys työntekijän palkasta" }, deduction: { title: "Palkasta peritty korvaus" }, periodDivider: { title: "Kausien määrä (oletus 12kk)" } }, BicycleBenefitUsecase: { kind: { title: "Vähennys työntekijän palkasta" }, deduction: { title: "Palkasta peritty korvaus" }, periodDivider: { title: "Kausien määrä (oletus 12kk)" } }, NonProfitOrgUsecase: { kind: { title: "Korvauksen tyyppi" } }, DailyAllowanceUsecase: { kind: { title: "Korvauksen tyyppi" } }, MealBenefitUsecase: { kind: { title: "Edun tyyppi" }, taxablePrice: { title: "Verotusarvo yhteensä" }, isTaxValue: { title: "Peritäänkö työntekijältä korvausta ravintoedusta?" }, deduction: { title: "Määrä yhteensä, joka peritään työntekijältä" } }, RemunerationUsecase: { kind: { title: "Tulolaji" } }, OtherCompensationUsecase: { kind: { title: "Tulolaji" } }, WorkingTimeCompensationUsecase: { kind: { title: "Tulolaji" } }, EmploymentTerminationUsecase: { kind: { title: "Tulolaji" } }, HourlySalaryWithWorkingTimeCompensationUsecase: { kind: { title: "Tuntipohjainen korvaus" } }, AbsenceCauseCode: { causeCode: { title: "Syy" }, isPaid: { title: "Palkallinen" }, isHolidayAccrual: { title: "Lomakertymät" }, notes: { title: "Huomiot" } }, WorkerAbsencePeriod: { absencesId: { title: "Syy" }, worker: { title: "Työntekijä" }, period: { title: "Poissaolon kausi" }, causeCode: { title: "Syy" }, isPaid: { title: "Palkallinen" }, isHolidayAccrual: { title: "Lomakertymät" }, bonusDaysCount: { title: "Lomarahapäivät" }, notes: { title: "Huomiot" } }, AbsencePeriodUsecase: { applyPricing: { title: "Hinnoittelu", labelTrue: "Hae hinta työsuhteen oletusriveiltä tai lomavuodelta", labelFalse: "Syötä hinta käsin" } }, PaidSickLeaveUsecase: { kind: { title: "Palkan/palkkion laji" } }, TrainingUsecase: { kind: { title: "Palkan/palkkion laji" } }, WorkPeriodUsecase: { kind: { title: "Kauden tyyppi" } }, EmploymentRelationInternational: { country: { title: "Asuinvaltio" }, contactCountry: { title: "Maa" }, idType: { title: "Tunniste asuinvaltiossa" }, foreignId: { title: "Tunniste" }, taxAtSource: { title: "Lähdevero" }, socialSecurity: { title: "Sosiaaliturva" }, socialSecurityExceptions: { title: "Vakuuttamisen poikkeustilanteen tyyppi" } }, PayrollInput: { salaryDateKind: { title: "Palkkapäivän valinta" } }, HolidaySpecificationForYear: { code: { title: "Loman kertyminen" }, holidayPayCalculation: { title: "Vuosilomapalkan laskentatapa" }, compensation: { title: "Lomakorvaus-%" }, holidayPayPercent: { title: "Vuosilomapalkka-%" }, employmentPeriod: { title: "Lomalaskennassa käytettävän työsuhteen" } }, HolidayPay: { averageDailyPayDailySalary: { title: "Laskettu lomapäivän palkka" }, averageDailyPayManual: { title: "Syötetty keskipäiväpalkka (loma KPA)" }, averageDailyPay: { title: "Laskettu keskipäiväpalkka (loma KPA)" }, averageDailyPayBase: { title: "Lomanmääräytysmisvuoden ansio" }, averageDailyPayDays: { title: "Työssäolopäivät" }, averageDailyPayMultiplier: { title: "Keskipäiväpalkan kerroin(loma KPA)" }, averageHourlyPayDailySalary: { title: "Laskettu lomapäivän palkka" }, averageHourlyPayManual: { title: "Syötetty keskituntiansio (loma KTA)" }, averageHourlyPay: { title: "Laskettu keskituntiansio (loma KTA)" }, averageHourlyPayBase: { title: "Lomanmääräytysmisvuoden ansio" }, averageHourlyPayHours: { title: "Työtuntien määrä" }, averageHourlyPayMultiplier: { title: "Keskituntiansion kerroin (loma KTA)" }, normalMonthlyPayDailySalary: { title: "Laskettu lomapäivän palkka" }, normalMonthlyPayManual: { title: "Syötetty kuukausipalkka" }, normalMonthlyPay: { title: "Kuukausipalkka työsuhteelta" }, percentageBasedPayDailySalary: { title: "Laskettu lomapäivän palkka" }, percentageBasedPayManual: { title: "Syötetty prosenttiperusteinen vuosilomapalkka" }, percentageBasedPay: { title: "Laskettu prosenttiperusteinen vuosilomapalkka" }, percentageBasedPayBase: { title: "Lomanmääräytysmisvuoden ansio" }, compensationPayDailySalary: { title: "Laskettu lomapäivän korvaus" }, compensationPayManual: { title: "Syötetty lomakorvaus yhteensä" }, compensationPay: { title: "Laskettu lomakorvaus yhteensä" }, compensationPayBase: { title: "Työssäoloajan palkat" }, otherPay: { title: "Syötetty lomapäivän palkka" }, accrual: { title: "Lomakertymä" } }, HolidayPaySettings: { title: "Vuosilomapalkan laskenta", holidayPayCalculation: { title: "Vuosilomapalkan laskentatapa" }, multipliers: { title: "Kertoimet" }, workingTimeTypes: { title: "Työaikaa kerryttävät rivit" }, overtimeTypes: { title: "Ylityöaikaa kerryttävät rivit" }, salaryTypes: { title: "Vuosilomapalkkaa kerryttävät rivit" } }, HolidayAccrualSettings: { title: "Lomakertymien asetukset", code: { title: "Loman kertyminen" }, workingTimeTypes: { title: "Lomaa kerryttävät rivit" } }, HolidaySettings: { title: "Lomalaskenta", denyServiceModel: { title: "Ohita palvelumalli" }, holidayPaySettings: { title: "Vuosilomapalkan laskennan asetukset" }, holidayAccrualSettings: { title: "Lomakertymien asetukset" } } }, MODEL_IR: { DeliveryData: { title: "Aineiston tiedot", deliveryId: { title: "Aineistoviite" }, deliveryDataType: { title: "Tyyppi" }, timestamp: { title: "Muodostamishetki" }, contactPersons: { title: "Yhteyshenkilöt" }, reportDate: { title: "Ilmoituspäivä" } }, EarningsPayment: { id: { title: "Tunniste" }, createdAt: { title: "Muodostettu" }, updatedAt: { title: "Päivitetty" }, owner: { title: "Omistaja" }, partner: { title: "Partneri" }, status: { title: "Lähetyksen tila" }, irStatus: { title: "Tulorekisteritila" }, reportLog: { title: "Tulorekisteritapahtumat" }, scheduledFor: { title: "Ajastus" }, isModified: { title: "Muokattu tulorekisterilähetyksen jälkeen" } }, ContactPerson: { title: "Yhteyshenkilö", email: { title: "Sähköposti" }, name: { title: "Nimi" }, telephone: { title: "Puhelinnumero" }, responsibilityCode: { title: "Vastuualue" } }, Id: { code: { title: "Tunniste" }, type: { title: "Tyyppi" }, countryCode: { title: "Maakoodi" }, countryName: { title: "Maan nimi" } }, PaymentPeriod: { title: "Palkanmaksukausi ja maksu- tai ilmoituspäivä", paymentDate: { title: "Suorituksen maksupäivä tai muu ilmoituspäivä" }, startDate: { title: "Alkupäivä" }, endDate: { title: "Loppupäivä" } }, Payer: { title: "Maksaja", subOrgs: { title: "Maksajan aliorganisaatiot" }, payerIds: { title: "Maksajan tunnisteet" }, pensionInsurances: { title: "Työeläkevakuutukset" }, accidentInsurances: { title: "Työtapaturmavakuutukset" } }, PayerBasic: { companyName: { title: "Yrityksen nimi" }, missingId: { title: "Maksajalla ei ole asiakastunnistetta" } }, PayerOther: { payerTypes: { title: "Maksajan tyypit" } }, Address: { co: { title: "c/o-tarkenne" }, street: { title: "Katuosoite" }, poBox: { title: "PL" }, postalCode: { title: "Postinumero" }, postOffice: { title: "Postitoimipaikka" }, countryCode: { title: "Maakoodi" }, countryName: { title: "Maan nimi" } }, TypedAddress: { title: "Tulonsaajan osoite", co: { title: "c/o-tarkenne" }, street: { title: "Katuosoite" }, poBox: { title: "PL" }, postalCode: { title: "Postinumero" }, postOffice: { title: "Postitoimipaikka" }, countryCode: { title: "Maakoodi" }, countryName: { title: "Maan nimi" }, addressType: { title: "Osoitteen tyyppi" } }, SubstitutePayer: { title: "Sijaismaksaja", acts: { title: "Maksaja toimii sijaismaksajana" }, employerName: { title: "Varsinaisen työnantajan nimi" }, wageSec: { title: "Maksettu palkkaturvana" } }, IncomeEarner: { title: "Tulonsaaja", incomeEarnerIds: { title: "Tulonsaajan tunnisteet" }, addresses: { title: "Tulonsaajan osoitteet " }, professions: { title: "Ammattiluokat" }, employmentRegs: { title: "Palvelussuhteen rekisteröinti" } }, IncomeEarnerOther: { incomeEarnerTypes: { title: "Tulonsaajan lisätiedot" }, payments: { title: "Maksujen tiedot" } }, Payment: { paymentType: { title: "Maksutiedon tyyppi" }, paymentRef: { title: "Maksun viitenumero" }, paymentSpecifier: { title: "Maksun tarkenne" } }, IncomeEarnerBasic: { missingId: { title: "Tulonsaajalla ei ole asiakastunnistetta" }, companyName: { title: "Yrityksen nimi" }, firstName: { title: "Etunimi" }, lastName: { title: "Sukunimi" }, birthDate: { title: "Syntymäaika" }, gender: { title: "Sukupuoli" } }, Profession: { code: { title: "Ammattiluokan tai nimikkeen tunniste" }, type: { title: "Ammattiluokan tai nimikkeistön tyyppi" }, title: { index: "Ammattiluokka tai -nimike", title: "Ammattinimike (vapaamuotoinen)" } }, Employment: { title: "Palvelussuhdetiedot", employed: { title: "Palvelussuhteessa" }, employmentCode: { title: "Palvelussuhteen tyyppi" }, termCode: { title: "Palvelussuhteen kesto" }, partTime: { title: "Osa-aikaisuuden prosentti" }, hoursPerWeek: { title: "Säännöllinen sovittu viikkotyöaika" }, paymentTypes: { title: "Palkkauksen muodot" }, employmentPeriods: { title: "Palvelussuhteen voimassaolo" }, employmentEndings: { title: "Palvelussuhteen päättyminen" } }, Period: { title: "Palvelussuhteen voimassaoloaika", startDate: { title: "Alkupäivä" }, endDate: { title: "Loppupäivä" } }, EmploymentEnding: { title: "Palvelussuhteen päättyminen", code: { title: "Palvelussuhteen päättymisen syykoodi" }, type: { title: "Palvelussuhteen päättymisen syykoodisto" } }, EmploymentReg: { title: "Palvelussuhteen rekisteröinti", code: { title: "Rekisteröinnin perusteen tunniste" }, type: { title: "Rekisteröinnin perusteen tyyppi" } }, PensionInsurance: { title: "Työeläkevakuutus", pensionActCode: { title: "Tieto työeläkevakuutuksesta" }, pensionProvIdCode: { title: "Työeläkelaitoksen yhtiötunnus" }, pensionPolicyNo: { title: "Eläkejärjestelynumero" } }, AccidentInsurance: { title: "Työtapaturmavakuutus", accInsPolicyNo: { title: "Työtapaturmavakuutuksen vakuutusnumero" } }, Absence: { absenceRepStartDate: { title: "Poissaolojen ilmoitusjakson alkupäivä" }, absenceRepEndDate: { title: "Poissaolojen ilmoitusjakson loppupäivä" } }, UnpaidAbsence: { unpaidAbsencePeriods: { title: "Palkaton poissaolo" } }, UnpaidAbsencePeriod: { title: "Poissaolojakso", startDate: { title: "Alkupäivä" }, endDate: { title: "Loppupäivä" }, absenceDays: { title: "Poissaolopäivien lukumäärä" }, causeCode: { title: "Poissaolon syy" } }, PaidAbsence: { paidAbsencePeriods: { title: "Palkallinen poissaolo" } }, PaidAbsencePeriod: { title: "Poissaolojakso", startDate: { title: "Alkupäivä" }, endDate: { title: "Loppupäivä" }, absenceDays: { title: "Poissaolopäivien lukumäärä" }, absenceUntil: { title: "Poissaolo jatkuu, mihin asti" }, causeCode: { title: "Poissaolon syy" }, amount: { title: "Palkan määrä palkalliselta poissaoloajalta" }, paidAbsencePeriodInfo: { title: "Korvaushakemuksen lisätiedot" }, reimbApp: { title: "Korvaushakemustiedot" } }, ReimbPayment: { title: "Korvaushakemustiedot", paymentType: { title: "Maksutiedon tyyppi" }, paymentRef: { title: "Maksun viitenumero" }, paymentSpecifier: { title: "Maksun tarkenne" } }, Report: { transactions: { title: "Tulolajit" } }, Transaction: { title: "Tulolaji", dailyAllowance: { title: "Päiväraha" }, earningPeriods: { title: "Ansaintakaudet" }, insuranceData: { title: "Vakuuttamistiedot" }, otherBenefit: { title: "Muu luontoisetu" }, unitWages: { title: "Palkan yksikkö" }, carBenefit: { title: "Autoetu" }, kmAllowance: { title: "Kilometrikorvaus (verovapaa) " }, mealBenefit: { title: "Ravintoetu" }, recoveryData: { title: "Takaisinperinnän lisätiedot" }, sailorIncome: { title: "Merityötulo" }, sixMonthRule: { title: "6 kk sääntö" }, transactionBasic: { title: "Tulolajin yleistiedot" } }, SubOrg: { title: "Aliorganisaatio", type: { title: "Aliorganisaation tunnisteen tyyppi" }, code: { title: "Aliorganisaation tunniste" } }, EarningPeriod: { title: "Ansaintakausi", startDate: { title: "Alkupäivä" }, endDate: { title: "Loppupäivä" } }, TransactionInclusion: { title: "Vakuuttamistieto", insuranceCode: { title: "Vakuuttamistiedon tyyppi" }, included: { title: "Vakuutusmaksun perusteena" } }, UnitWage: { title: "Yksikköpalkka", unitPrice: { title: "Yksikköhinta" }, unitAmount: { title: "Yksiköiden määrä " }, unitCode: { title: "Yksikkö" } }, CarBenefit: { carBenefitCode: { title: "Autoedun tyyppi" }, ageGroupCode: { title: "Auton ikäryhmä" }, kilometers: { title: "Auton kilometrimäärä" }, emissionsValue: { title: "Auton päästöarvo (0-100)" } }, KmAllowance: { title: "Kilometrikorvaus (verovapaa)", kilometers: { title: "Kilometrien määrä" } }, MealBenefit: { title: "Ravintoetu", taxValue: { title: "Ravintoedusta peritty korvaus vastaa verotusarvoa" } }, RecoveryData: { title: "Takaisinperinnän lisätiedot", recoveryDate: { title: "Takaisinperintäpäivä" }, taxAtSource: { title: "Takaisinperittyyn määrään kohdistuva lähdevero" }, withhold: { title: "Takaisinperittyyn määrään kohdistuva ennakonpidätys" }, origPaymentPeriods: { title: "Alkuperäiset palkanmaksukaudet" } }, OrigPaymentPeriod: { title: "Alkuperäinen palkanmaksukausi", paymentDate: { title: "Maksupäivä" }, startDate: { title: "Alkupäivä" }, endDate: { title: "Loppupäivä" } }, SailorIncome: { title: "Merityötulo", crossTradeTime: { title: "Cross-trade-aika" }, sailorIncomeProp: { title: "Suoritus maksettu merityötulona " }, withdrawalPeriod: { title: "Nostettavissaolokausi" } }, WithdrawalPeriod: { title: "Nostettavissaolokausi", startDate: { title: "Alkupäivä" }, endDate: { title: "Loppupäivä" } }, SixMonthRule: { title: "6 KK sääntö", applicable: { title: "Kuuden kuukauden sääntö soveltuu " }, countryCode: { title: "Maakoodi" }, countryName: { title: "Maan nimi" } }, TransactionBasic: { title: "Tulolajin yleistiedot", transactionCode: { title: "Tulolajin koodi" }, amount: { title: "Määrä" }, noMoney: { title: "Maksettu muuna kuin rahana" }, oneOff: { title: "Kertakorvaus" }, recovery: { title: "Takaisinperintä" }, unjustEnrichment: { title: "Perusteeton etu" } }, ApiValidation: { title: "Validointi", isValid: { title: "Validi" }, hasAllRequiredFields: { title: "Kaikki pakolliset kentät" }, errors: { title: "Virheet" } }, ApiValidationError: { title: "Validointivirhe", code: { title: "Koodi" }, key: { title: "Avain" }, msg: { title: "Viesti" }, type: { title: "Tyyppi" } }, PayerSummary: { title: "Erillisilmoitus", id: { title: "Tunniste" }, createdAt: { title: "Muodostettu" }, updatedAt: { title: "Päivitetty" }, owner: { title: "Omistaja" }, partner: { title: "Partneri" }, status: { title: "Lähetyksen tila" }, irStatus: { title: "Tulorekisteritila" }, reportLog: { title: "Tulorekisteritapahtumat" }, scheduledFor: { title: "Ajastus" }, isModified: { title: "Muokattu tulorekisterilähetyksen jälkeen" } }, ReportLogEntry: { title: "Tulorekisteritapahtuma", irTimestamp: { title: "Tulorekisterin aikaleima" }, eventType: { title: "Tapahtumatyyppi" }, reportId: { title: "Raporttitunnus" }, irReportId: { title: "Tulorekisterin raporttitunnus" }, irDeliveryId: { title: "Toimitustunnus" }, irResponseId: { title: "Vastaustunnus" }, irVersion: { title: "Tulorekisteriversio" }, user: { title: "Käyttäjä" }, versionId: { title: "Versiotunnus" }, message: { title: "Viesti" } }, ApiScheduleObject: { title: "Jono-objekti", id: { title: "Raporttitunnus" }, startAt: { title: "Ajastus" }, action: { title: "Operaatio" } }, PaymentMonth: { title: "Kohdekausi", year: { title: "Vuosi" }, month: { title: "Kuukausi" } }, ReportData: { title: "Palvelun tiedot", actionCode: { title: "Toimenpiteen tyyppi" }, irReportId: { title: "Tulorekisterin ilmoitusviite" }, reportId: { title: "Maksajan ilmoitusviite" }, reportVersion: { title: "Ilmoituksen versionumero" } } }, NG1: { ApiCrudObjectComponent: { id: "Id", owner: "Omistaja", readOnly: "Read-only", partner: "Partner", name: "Nimi", description: "Kuvaus", entityType: "Tyyppi", status: "Status", deleteDialog: "Haluatko varmasti poistaa tämän tietueen?" }, BrandListComponent: { partner: "Kumppani" }, DatepickerComponent: { validationErrorDefault: "Virheellinen päivämäärä, oletus: d.M.yyyy" }, ImportStagingComponent: { dialog: { commitPayroll: "Lähetetään palkkalistaa...", recalculating: "Lasketaan uudelleen..." }, toolbar: { removeFilter: "Poista filtteri", selectPayroll: "Valitse palkkalista", commitPayroll: "Lähetä palkkalistaan", recalculateAll: "Laske hinnat uudelleen" }, list: { title: "Nimi", personalId: "Henkilötunnus (tyyppi)", grossSalary: "Palkka", netSalary: "Netto", calcCount: "Laskelmia", total: "Yhteensä" }, status: { all: "Kaikki", preview: "Esikatselu", new: "Uusi (hyväksytty)", deleted: "Poistettu", error: "Virheitä", committed: "Lähetetty", ignored: "Ei huomioida", edited: "Muokattu" }, details: { period: "Periodi ja palkkapäivä:", payroll: "Palkkalista:", noPayroll: "Ei palkkalistaa", notTheSameAsSelectedPayroll: "Ei päänäkymässä valittu palkkalista!", rawRows: "Rivit (sisään tulevat)", allRows: "Kaikki rivit", rows: "Laskelman rivit", calculator: "Laskuri", salarySlips: "Palkkalaskelmat", reports: "Raportit", debug: "Raakadata", recalculate: "Laske uudelleen", commitPayroll: "Lähetä palkkalistaan" }, salarySlipList: { status: "Tila", id: "ID", grossSalary: "Brutto", netSalary: "Netto", salaryDate: "Palkkapäivä", period: "Palkkakausi", payrollLink: "linkki...", type: { preview: "Luonnokset", committed: "Palkkalistassa", all: "Kaikki", distinct: "Aktiivisin versio" } }, statusGroup: { todo: "Käsiteltävät", waitingCommit: "Odottaa lähetystä" }, payrollView: { title: "Tuonnin tila", btnMoreInfo: "Katso tarkemmin..." } }, InvoicesComponent: { channel: "Kanava", dueDate: "Eräpäivä", invoiceDate: "Laskun päivä", invoices: "Laskut", noInvoices: "Ei laskuja", receiverAndType: "Saaja ja laskun tyyppi", receiver: "Laskun saaja", selectChannelBtn: "Valitse maksun tyyppi (filter)", showAllPaymentMethods: "Näytä kaikki maksutavat", view: "Näkymä: ", status: "Tila", statusAll: "Kaikki maksut", statusWaitingConfirmation: "Maksamista odottavat", statusPaid: "Maksetut ja perutut", statusForecast: "Arviot ja esikatselut", sum: "Summa", loadedSecondsAgo: { html: "Ladattu <strong>{{ loadedTime }}s</strong> sitten" }, refreshListBtn: "Päivitä listat", payer: "Maksaja", paid: "Maksettu", iban: "Laskun IBAN", noIbanNumber: "Ei tilinumeroa", createInvoiceBtn: "Luo", markAsPaidBtn: "Luo ja kuittaa", createInvoices: "Luo ja lataa aineisto tai..", markAsPaid: "Luo, lataa ja kuittaa maksetuksi", markAsPaidOnly: "Merkitse maksetuksi", detailsBtn: "Yksityiskohdat", invoiceType: "Aineiston tyyppi", all: "Kaikki" }, InvoicesPanelComponent: { invoices: "Laskut", noInvoices: "Ei laskuja", paid: "Maksettu" }, CfaPaymentOverviewComponent: { lead: "Tarkista alla olevat tiedot ja jatka maksuun", days: "päivää", totalPayments: "Maksu yhteensä", calculations: "Laskelmia", palkkausCfaPaytrailInfo: "Verkkopankkimaksamiseen liittyvän maksunvälityspalvelun toteuttaa Paytrail Oyj (2122839-7) yhteistyössä suomalaisten pankkien ja luottolaitosten kanssa. Käyttäjän kannalta palvelu toimii aivan kuten perinteinen verkkomaksaminenkin.", palkkausCfaPaytrailInfoAlt: "HUOM: nettopalkan saapuminen työntekijän tilille saattaa kestää 4 pankkipäivää, riippuen vastaanottajan pankista. Huomioithan nämä ajat maksaessasi. Ajat johtuvat pankkien välisistä palveluista ja sopimuksista, eikä Palkkaus.fi pysty vaikuttamaan niihin." }, EmailSharingComponent: { title: "Sähköposti työnantajalle", emailTo: "Sähköposti", emailCC: "Sähköpostin kopio / CC", message: "Viesti työnantajalle", sendEmail: "Lähetä linkki sähköpostilla", body: { html: "Voit lähettää linkin sisältävän sähköpostin työnantajallesi syöttämällä työnantajan sähköpostiosoitteen alla olevaan <b>Sähköposti</b> -kenttään. Voit lisätä myös oman osoitteesi <b>Sähköpostin kopio / CC</b> -kenttään, jolloin saat lähetetystä sähköpostista kopion. <b>Viesti työnantajalle</b> -kenttään voit lisätä esim. ne ehdot, jotka on työstä sovittu. Sähköposti lähtee työnantajalle, kun painat <b>Lähetä linkki sähköpostilla</b> -painiketta." } }, ExportComponent: { exportLengths: { all: "Kaikki rivit", current: "Esikatselussa olevat rivit", short: "Viimeiset 1000 riviä", long: "Viimeiset 10 000 riviä" }, export: { creating: "Luodaan...", noRows: "Ei rivejä", rowsCopiedOnClipboard: "riviä kopioitu leikepöydälle.", noFormatSupportTitle: "Ei vielä toteutettu", noFormatSupportDescription: "Tätä tiedostotyyppiä ei ole toteutettu." }, creatingRows: "Luodaan objekteille rivejä..." }, IrEprComponent: { searchWorker: "Hae työntekijää", status: "Tila", salaryDate: "Palkkapäivä", sendTime: "Lähetysaika", payment: "Maksettava", grossSalary: "Brutto", irModified: "Ilmoitusta on muokattu käsin", modified: "Muokattu", delayed: "Myöhässä", firstDelivery: "Ensimmäinen lähetys", latestDelivery: "Viimeisin / tuleva lähetys" }, IrPsrComponent: { searchWorker: "Hae työntekijää", notificationType: "Ilmoituksen tyyppi", status: "Tila", month: "Kuukausi", sendTime: "Lähetysaika", savaPayment: "SAVA-maksu", expense: "Vähennys", modified: "Muokattu", delayed: "Myöhässä", firstDelivery: "Ensimmäinen lähetys", latestDelivery: "Viimeisin / tuleva lähetys" }, InvoiceEditComponent: { error: "Laskua ei löydy", heading: "Lähetä tilan päivityspyyntö maksukanavaan", headingAlt: "Päivitä maksun tila", headingInfo: "Testilomake tilan päivityspyynnön lähettämiseen. Alla voit myös poistaa laskun.", headingInfoAlt: "Kun olet maksanut laskun, voit kirjata sen tästä maksetuksi", channel: "Kanava", invoiceStatus: "Maksun tila", sendRequest: "Lähetä pyyntö", updateStatusBtn: "Päivitä tila", deleteInvoice: "Poista lasku", deleteInvoiceWithCals: "Poista lasku ja siihen liittyvät laskelmat" }, InvoicePreviewComponent: { fullInvoice: "Koko lasku", tableInvoice: "Vain taulukko", error: "Laskua ei löydy", showFile: "Näytä tiedosto", refresh: "Päivitä", recipient: "Maksun saaja", payer: "Maksaja", date: "Päivämäärä", dueDate: "Eräpäivä", referenceNumber: "Viitenumero", iban: "Saajan pankkitili", status: "Status", description: "Kuvaus", articleIdAccounting: { html: "Tuotteen nimi (koodi)<br />Tiliöinti" }, count: "Määrä", priceExVat: "Hinta (alv0)", vatPercent: "Alv %", total: "Yhteensä", totalExVat: "Yhteensä ALV 0%", totalVat: "ALV Yhteensä", invoiceTotal: "Maksettava yhteensä" }, InvoicesCreateTableComponent: { receiverInvoiceType: "Saaja ja laskun tyyppi", comingToPay: "Tulossa maksuun", invoiceDate: { html: "Laskun päivä<br /> Eräpäivä" }, invoiceSum: "Laskun summa", dueDateTypePreview: "Maksu luodaan myöhemmin", dueDateTypeZero: "Ei maksua: Merkitään suoraan maksetuksi", sendsInvoice: "lähettää laskun", dueDateTypeDefault: "Maksetaan nyt", dueDateTypePaid: "Maksettu aiemmin", totalSalaries: "Palkkoja yhteensä", payInvoice: "Maksa maksu", cancelInvoice: "Peruuta maksu", PalkkausInvoicesTaxPreviewText: "Maksetaan nyt tai kun kaikki kuukauden palkat on maksettu" }, InvoicesCreateComponent: { uiStatusInvalid: "Verokortti puuttuu tai muu laskelmavirhe. Tarkista laskelma!", uiStatusLoading: "Ladataan maksutietoja...", updateView: "Päivitä näkymä", invalid: "Laskelmaa ei voi maksaa", validationError: "Verokortti puuttuu tai muu laskelmavirhe. Tarkista laskelma!", uiStatusCreated: { invoicesCreated: { html: "Palkoista on jo luotu alustavat laskut. Laskuja ei ole vielä lähetetty maksuun. <strong>Lähetä laskut maksuun klikkaamalla 'Lähetä maksuun'-nappia</strong>" }, inProgress: { html: "<strong>Laskujen maksu aloitettu:</strong> Laskujen tilan näet alla olevasta listasta." }, paid: "Laskut on maksettu", exceptions: "Laskuissa on virheitä. Tarkista tilanne laskukohtaisesti alta.", canceled: "Laskuja on peruttu. Tarkista tilanne laskukohtaisesti alta.", paymentStarted: "Laskut on lähetetty maksuun", calcPaid: "Palkkalaskelma on maksettu" }, uiStatusDefault: "Maksutapaa ei ole valittu. Valitse maksutapa laskelmassa/palkkalistassa.", uiStatusUserCanceled: "Käsittely peruttu", PaymentChannel: { zeroPaymentInfo: "Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen.", zeroPaymentIntro: "Kaikki maksut ovat nollamaksuja tai sivukulujen laskuja, jotka luodaan/maksetaan vasta myöhemmin. Merkitse nettopalkat maksetuksi painamalla Maksa -nappia.", createPaymentInfo: "Luo maksut painamalla Maksa -nappia.", createNetPaymentInfo: "Luo maksut nettopalkoista painamalla Maksa -nappia.", createPayments: "Luo maksut", createInvoices: "Luo laskut", createPaymentMaterial: "Luo maksuaineisto", sendForPayment: "Lähetä maksuun", createAndMarkPaid: "Luo ja kuittaa maksut", checkPayment: "Tarkista maksun tila", markPaid: "Merkitse maksetuksi", creatingInvoices: "Luodaan laskuja...", paymentDialogOpened: "Maksuikkuna avattu...", default: { paymentMethod: "Maksumenetelmä" }, undefined: { intro: '<div><p class="lead">Maksumenetelmä <strong>{{ channel }}</strong> ei ole tuettu tässä palvelussa tai sinun tilitoimistosi / kirjanpito-ohjelmasi kautta. Valitse jokin toinen maksumenetelmä.</p></div>', title: "Maksumenetelmää ei ole valittu" }, test: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukuluista saat laskut automaattisesti hyväksyttäväksi kuun vaihteen jälkeen.</p><p><strong>Luo maksut nettopalkoista painamalla 'Luo maksut' -nappia.</strong></p></div>" }, zeroPayment: { intro: '<div><p class="lead"><strong>Maksutapa ei mahdollinen!</strong> Tämä maksumenetelmä on vain tilanteisiin, jossa käytetään jotain muuta maksumenetelmää ja maksun loppusumma olisi nolla. Et voi valita maksumenetelmää suoraan</p></div>', introWhenValid: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen.</p><p><strong>Kaikki maksut ovat nollamaksuja tai sivukulujen laskuja, jotka luodaan/maksetaan vasta myöhemmin. Merkitse nettopalkat maksetuksi painamalla 'Merkitse maksetuksi' -nappia.</strong></p></div>", successAlertHeading: "Laskelmat merkitty maksetuksi (nollamaksu)", successAlertText: "Laskelma(t) on merkitty maksetuiksi ja niistä tehdään tulorekisteri-ilmoitus viiden päivän kuluessa." }, external: { intro: "TODO: Not implemented" }, palkkausManual: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen.</p><p><strong>Luo maksut nettopalkoista painamalla 'Luo maksut' -nappia.</strong></p></div>", heading: "Maksujen luonti SEPA- tai viitesiirtoaineistoja varten", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu Maksut -listalle. Merkitse lasku maksetuksi, kun olet maksanut laskua vastaavan summan. Laskut sivukuluista tulevat Maksut-listalle automaattisesti kuun vaihteen jälkeen. Palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset maksetuksi merkityistä nettopalkoista." }, palkkausManualAndFixed: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen.</p><p><strong>Luo maksut nettopalkoista painamalla 'Luo ja kuittaa maksut' -nappia.</strong></p></div>", heading: "Maksujen luonti SEPA- tai viitesiirtoaineistoja varten", successAlertHeading: "Maksun luonti onnistui", successAlertText: `Lasku(t) nettopalkasta on nyt luotu ja kuitattu suoraan maksetuksi.

Löydät nettolaskut takautuvista palkoista valitsemalla maksulistauksesta Maksetut ja perutut. Laskut sivukuluista tulevat Maksut-listalle automaattisesti kuun vaihteen jälkeen. Takautuvan palkan kohdistuessa kaudelle, joka on jo suljettu, pitää työnantajasuoritukset hoitaa suoraan Omaverossa. Palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset maksetuksi merkityistä nettopalkoista palkkapäivän mukaan. Huomioithan, että myöhässä tehdystä ilmoituksesta voi seurata myöhästymismaksuja eri viranomaisilta.` }, palkkausWS: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä maksuista eräpäivineen.</p><p><strong>Luo maksut nettopalkoista painamalla 'Luo maksut' -nappia.</strong></p></div>", heading: "Maksujen luonti pankin WS-kanavaan", successAlertHeading: "Maksun/maksujen luonti onnistui", successAlertText: "Maksu(t) nettopalkasta on nyt luotu WS-kanavaan. Maksut verottajalle luodaan WS-kanavaan automaattisesti kuun vaihteen jälkeen. Palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset maksetuksi merkityistä nettopalkoista." }, palkkausPSD: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä maksuista eräpäivineen.</p><p><strong>Luo maksut nettopalkoista painamalla 'Luo maksut' -nappia.</strong></p></div>", heading: "PSD maksujen luonti", successAlertHeading: "Maksun/maksujen luonti onnistui", successAlertText: "Maksu(t) nettopalkasta on nyt luotu. Maksut verottajalle luodaan automaattisesti kuun vaihteen jälkeen. Palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset maksetuksi merkityistä nettopalkoista." }, palkkausPersonal: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen.</p><p><strong>Luo maksut nettopalkoista painamalla 'Luo maksut' -nappia.</strong></p></div>", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Laskut nettopalkasta ja verosta on nyt luotu Maksut -listalle. Merkitse nettopalkan lasku maksetuksi, kun olet maksanut laskua vastaavan summan. Palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset maksetuksi merkityistä nettopalkoista." }, palkkausInvoices: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen.</p><p><strong>Luo laskut painamalla 'Luo laskut' -nappia.</strong></p></div>", heading: "Laskujen luonti palkkalaskelmista", successAlertHeading: "Haluatko maksaa palkat heti?", successAlertText: `<div><p class='lead'>
Palkasta on nyt luotu laskut, mutta niitä ei vielä ole laitettu maksuun.
Haluatko maksaa palkat ja/tai sivukulut nyt vai syöttää lisää laskelmia?
</p>
<p><strong>HUOM:</strong> Palkat ilmoitetaan tulorekisteriin vasta, kun nettopalkka on merkitty maksetuksi.</p></div>`, successAlertOk: "Maksa laskut nyt", successAlertCancel: "Syötä lisää palkkoja" }, kitsas: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen.</p><p><strong>Luo laskut painamalla 'Luo laskut' -nappia.</strong></p></div>", heading: "Laskujen luonti palkkalaskelmista", successAlertHeading: "Haluatko maksaa palkat heti?", successAlertText: `<div><p class='lead'>
Palkasta on nyt luotu laskut, mutta niitä ei vielä ole laitettu maksuun.
Haluatko maksaa palkat ja/tai sivukulut nyt vai syöttää lisää laskelmia?
</p>
<p><strong>HUOM:</strong> Palkat ilmoitetaan tulorekisteriin vasta, kun nettopalkka on merkitty maksetuksi.</p></div>`, successAlertOk: "Maksa laskut nyt", successAlertCancel: "Syötä lisää palkkoja" }, palkkausCfaPaytrail: { intro: "TODO: Not implemented" }, palkkausCfaReference: { intro: "TODO: Not implemented" }, palkkausCfaFinvoice: { intro: "TODO: Not implemented" }, palkkausEcfaPaytrail: { intro: "TODO: Not implemented" }, palkkausEcfaReference: { intro: "TODO: Not implemented" }, palkkausEcfaFinvoice: { intro: "TODO: Not implemented" }, palkkausCfaTest: { intro: "TODO: Not implemented" }, accountorGo: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukuluista saat laskut automaattisesti hyväksyttäväksi kuun vaihteen jälkeen Accountor Go -palvelun Maksut-osioon.</p><p><strong>Luo maksut nettopalkoista painamalla 'Luo maksut' -nappia ja käy hyväksymässä ne Accountor Go -palvelun Maksut-osiossa.</strong></p></div>", heading: "Palkkojen maksu Accountor Go-palvelussa", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu Accountor Go -palvelun Maksut-osioon. Käy hyväksymässä lasku kohdasta 'Avoimet maksut'. Lasku näkyy siellä noin 2 minuutin sisällä. Laskut sivukuluista tulevat Avoimet maksut -osioon automaattisesti kuun vaihteen jälkeen. Palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset palkanmaksuista.", notZeroPayment: { lead: "Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukuluista saat laskut automaattisesti hyväksyttäväksi kuun vaihteen jälkeen Accountor Go -palvelun Maksut-osioon.", info: "Luo maksut nettopalkoista painamalla Maksa -nappia ja käy hyväksymässä ne Accountor Go -palvelun Maksut-osiossa." }, zeroPayment: { info: "Kaikki maksut ovat nollamaksuja tai sivukulujen laskuja, jotka luodaan/maksetaan vasta myöhemmin. Merkitse nettopalkat maksetuksi painamalla Maksa -nappia.", successAlertHeading: "Laskelmat merkitty maksetuksi (nollamaksu)", successAlertText: "Laskelma(t) on merkitty maksetuiksi ja niistä tehdään tulorekisteri-ilmoitus viiden päivän kuluessa." } }, talenomOnline: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkasta ja mahdollisista ulosottomaksuista muodostetaan heti laskut hyväksyttäväksi Easor App -sovellukseen. Sivukulujen sekä ay-jäsenmaksujen laskut valmistuvat palkanmaksupäivää seuraavan kuun alussa ja siirtyvät samaan tapaan Easor App -sovellukseen hyväksyttäväksi ja maksettavaksi.</p><p><strong>Luo laskut ja lähetä ne Easor App -sovellukseen painamalla 'Lähetä maksuun' -painiketta.</strong></p></div>", heading: "Palkkojen maksu Easor App -sovelluksessa", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu Easor App -sovellukseen. Laskut sivukuluista tulevat Easor App -sovellukseen automaattisesti kuun vaihteen jälkeen. Huomioi, että nettopalkkojen laskun maksamisen jälkeen palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset palkanmaksuista." }, holviCfa: { intro: "TODO: Not implemented" }, finagoSolo: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukuluista saat laskut automaattisesti hyväksyttäväksi kuun vaihteen jälkeen Procountor Solon Maksut-osioon.</p><p><strong>Luo maksut nettopalkoista painamalla 'Luo maksut' -nappia ja käy hyväksymässä ne Procountor Solon Maksut-osiossa.</strong></p></div>", heading: "Palkkojen maksu Procountor Solossa", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu Procountor Solo Maksut-osioon. Käy hyväksymässä lasku kohdasta 'Avoimet maksut'. Lasku näkyy siellä noin 2 minuutin sisällä. Laskut sivukuluista tulevat Avoimet maksut -osioon automaattisesti kuun vaihteen jälkeen. Palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset palkanmaksuista.", notZeroPayment: { lead: "Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukuluista saat laskut automaattisesti hyväksyttäväksi kuun vaihteen jälkeen Procountor Solon Maksut-osioon.", info: "Luo maksut nettopalkoista painamalla Maksa -nappia ja käy hyväksymässä ne Procountor Solon Maksut-osiossa." }, zeroPayment: { info: "Kaikki maksut ovat nollamaksuja tai sivukulujen laskuja, jotka luodaan/maksetaan vasta myöhemmin. Merkitse nettopalkat maksetuksi painamalla Maksa -nappia." } }, procountor: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukulujen laskut valmistuvat seuraavan kuun alussa ja ne pitää käydä tällöin hyväksymässä.</p><p><strong>Luo maksut nettopalkoista ja lähetä ne Procountoriin painamalla 'Luo maksut' -nappia.</strong></p></div>" }, kevytyrittaja: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukuluista saat laskut automaattisesti hyväksyttäväksi kuun vaihteen jälkeen Talenom Kevytyrittäjä -palveluun.</p><p><strong>Luo maksut nettopalkoista painamalla 'Luo maksut' -nappia.</strong></p></div>", heading: "Palkkojen maksu Talenom Kevytyrittäjä -palvelussa", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu Talenom Kevytyrittäjä -Palveluun. Laskut sivukuluista tulevat Talenom Kevytyrittäjä -palveluun automaattisesti kuun vaihteen jälkeen. Palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset palkanmaksuista.", notZeroPayment: { lead: "Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukuluista saat laskut automaattisesti hyväksyttäväksi kuun vaihteen jälkeen Talenom Kevytyrittäjä -palveluun." } }, vismaNetvisor: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukulujen laskut valmistuvat seuraavan kuun alussa ja ne pitää käydä tällöin hyväksymässä.</p><p><strong>Luo maksut nettopalkoista ja lähetä ne Visma Netvisoriin painamalla 'Luo maksut' -nappia.</strong></p></div>" }, askelma: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukulujen laskut valmistuvat seuraavan kuun alussa ja ne pitää käydä tällöin hyväksymässä.</p><p><strong>Luo maksut nettopalkoista ja lähetä ne Askelmaan painamalla 'Luo maksut' -nappia.</strong></p></div>", heading: "Palkkojen maksu Askelma -palvelussa", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu Askelma-palveluun. Mene ostoreskontraan, hae palkat maksuun ja palkkapäivän jälkeen kuittaa palkat tulorekisteriin ostoreskontran tulorekisteriin kuittaamattomat -haun kautta. Kuun vaihteen jälkeen hae ostoreskontraan lasku verottajan maksuista." }, briox: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukulujen laskut valmistuvat seuraavan kuun alussa ja ne pitää käydä tällöin hyväksymässä.</p><p><strong>Luo maksut nettopalkoista ja lähetä ne Brioxiin painamalla 'Luo maksut' -nappia.</strong></p></div>", heading: "Palkkojen maksu Briox -palvelussa", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu Briox -Palveluun. Laskut sivukuluista tulevat Briox -palveluun automaattisesti kuun vaihteen jälkeen. Huomioi, että nettopalkkojen laskun maksamisen jälkeen palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset palkanmaksuista." }, lemonaid: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukulujen laskut valmistuvat seuraavan kuun alussa ja ne pitää käydä tällöin hyväksymässä.</p><p><strong>Luo maksut nettopalkoista ja lähetä ne Lemonaidiin painamalla 'Luo maksut' -nappia.</strong></p></div>", heading: "Palkkojen maksu Lemonaid -ohjelmassa", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu Lemonaid -ohjelmalle. Laskut sivukuluista tulevat Lemonaid -ohjelmaan automaattisesti kuun vaihteen jälkeen. Huomioi, että nettopalkkojen laskun maksamisen jälkeen palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset palkanmaksuista." }, laskupiste: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukulujen laskut valmistuvat seuraavan kuun alussa ja ne pitää käydä tällöin hyväksymässä.</p><p><strong>Luo maksut nettopalkoista ja lähetä ne Laskupisteeseen painamalla 'Luo maksut' -nappia.</strong></p></div>", heading: "Palkkojen maksu Laskupisteessä", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu ja ne tulevat näkyviin Laskupisteeseen viiden minuutin kuluessa. Laskut sivukuluista tulevat Laskupisteeseen automaattisesti kuun vaihteen jälkeen. Huomioi, että nettopalkkojen laskun maksamisen jälkeen palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset palkanmaksuista." }, passeliMerit: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukulujen laskut valmistuvat seuraavan kuun alussa ja ne pitää käydä tällöin hyväksymässä.</p><p><strong>Luo maksut nettopalkoista ja lähetä ne Passeli Meritiin painamalla 'Luo maksut' -nappia.</strong></p></div>", heading: "Palkkojen maksu Passeli Meritissä", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu ja ne tulevat näkyviin Passeli Meritiin hetken kuluttua. Laskut sivukuluista tulevat Passeli Meritiin automaattisesti kuun vaihteen jälkeen. Huomioi, että nettopalkkojen laskun maksamisen jälkeen palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset palkanmaksuista." }, odoo: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukulujen laskut valmistuvat seuraavan kuun alussa ja ne pitää käydä tällöin hyväksymässä.</p><p><strong>Luo maksut nettopalkoista ja lähetä ne Odoon painamalla 'Luo maksut' -nappia.</strong></p></div>", heading: "Palkkojen maksu Odoossa", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu ja ne tulevat näkyviin Odoon hetken kuluttua. Laskut sivukuluista tulevat Odoon automaattisesti kuun vaihteen jälkeen. Huomioi, että nettopalkkojen laskun maksamisen jälkeen palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset palkanmaksuista." }, hausvise: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukulujen maksuaineisto valmistuu seuraavan kuun alussa ja ne pitää käydä tällöin hyväksymässä.</p><p><strong>Luo maksuaineisto nettopalkoista painamalla 'Luo maksuaineisto' -nappia.</strong></p></div>", heading: "Hausvise - maksuaineiston luonti", successAlertHeading: "Maksuaineiston luonti onnistui", successAlertText: "Maksuaineisto nettopalkasta on nyt luotu. Maksuaineisto sivukuluista luodaan automaattisesti kuun vaihteen jälkeen. Huomioi, että nettopalkkojen laskun maksamisen jälkeen palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset palkanmaksuista." }, ecom: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukulujen laskut valmistuvat seuraavan kuun alussa ja ne pitää käydä tällöin hyväksymässä.</p><p><strong>Luo maksut nettopalkoista ja lähetä ne Ecomiin painamalla 'Luo maksut' -nappia.</strong></p></div>", heading: "Palkkojen maksu Ecomissa", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu ja ne tulevat näkyviin Ecomiin hetken kuluttua. Laskut sivukuluista tulevat Ecomiin automaattisesti kuun vaihteen jälkeen. Huomioi, että nettopalkkojen laskun maksamisen jälkeen palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset palkanmaksuista." }, kompassi: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukulujen laskut valmistuvat seuraavan kuun alussa ja ne pitää käydä tällöin hyväksymässä.</p><p><strong>Luo maksut nettopalkoista ja lähetä ne Kompassiin painamalla 'Luo maksut' -nappia.</strong></p></div>", heading: "Palkkojen maksu Kompassissa", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu ja ne tulevat näkyviin Kompassiin hetken kuluttua. Laskut sivukuluista tulevat Kompassiin automaattisesti kuun vaihteen jälkeen. Huomioi, että nettopalkkojen laskun maksamisen jälkeen palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset palkanmaksuista." }, domus: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukulujen laskut valmistuvat seuraavan kuun alussa ja ne pitää käydä tällöin hyväksymässä.</p><p><strong>Luo maksut nettopalkoista ja lähetä ne Domukseen painamalla 'Lähetä maksuun' -nappia.</strong></p></div>", heading: "Palkkojen maksu Domuksessa", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu ja ne tulevat näkyviin Domukseen hetken kuluttua. Laskut sivukuluista tulevat Domukseen automaattisesti kuun vaihteen jälkeen. Huomioi, että nettopalkkojen laskun maksamisen jälkeen palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset palkanmaksuista." }, holvi: { intro: "<div><p>Alla näet yhteenvedon palkanmaksuihin liittyvistä laskuista eräpäivineen. Nettopalkka maksetaan työntekijälle heti tai sovitun palkkapäivän mukaan. Sivukulujen laskut valmistuvat seuraavan kuun alussa ja ne pitää käydä tällöin hyväksymässä.</p><p><strong>Luo maksut nettopalkoista ja lähetä ne Holviin painamalla 'Lähetä maksuun' -nappia.</strong></p></div>", heading: "Palkkojen maksu Holvissa", successAlertHeading: "Maksun luonti onnistui", successAlertText: "Lasku(t) nettopalkasta on nyt luotu Holviin. Laskut sivukuluista tulevat Holviin automaattisesti kuun vaihteen jälkeen. Huomioi, että nettopalkkojen laskun maksamisen jälkeen palvelu tekee myös tarvittavat tulorekisteri-ilmoitukset palkanmaksuista." } } }, InvoicesService: { saving: "Tallennetaan laskelmaa", creatingPayment: "Luodaan laskua", sending: "Lähetetään", logic: { title: { holviCfa: "Palkan maksaminen", talenomCfa: "Maksaminen Talenom-onlinessa", palkkausInvoices: "Laskujen esikatselu", default: "Maksun esikatselu" }, okButtonText: { holviCfa: "Luo maksu", talenomCfa: "Maksa Talenom-onlinessa", palkkausInvoices: "Luo laskut", isCfaChannel: "Maksa", default: "Lähetä maksuun" }, instructions: { holviCfa: 'Voit luoda maksun Holvin palveluun. Maksun luonnin jälkeen laskelma(t) siirtyvät "maksu aloitettu" tilaan. Kun vahvistat luotuja maksuja, laskelmat siirtyvät "maksettu" tilaan.', talenomCfa: 'Voit maksaa laskelma(t) Talenom-onlinessa. Palvelu lähettää sähköisen laskun Talenom-onlineen ja laskelmat siirtyvät "maksu aloitettu" tilaan.' } }, canceledPayment: { default: "Haluatko varmasti perua palkanmaksun?", cancelCantReopen: "Haluatko varmasti perua palkanmaksun? Peruttua laskelmaa ei voi avata uudelleen.", cancelPaymentAndIr: "Peru maksu ja tulorekisteri-ilmoitus", closeWithoutCancel: "Sulje perumatta" }, paymentConfirmation: { realyWantToMarkPaid: "Haluatko varmasti merkitä palkan maksetuksi?", markPaid: "Merkitse maksetuksi", close: "Sulje ilman merkintää" }, missingSignatureAlert: { signatureMissing: "Valtakirjan allekirjoitus puuttuu", creationCompleteBeforePay: "Ennen kuin lähdet maksamaan, sinun täytyy viedä tilin luonti loppuun asti", signSignature: "ja allekirjoittaa valtakirja.", continueToSignature: "Jatka allekirjoitukseen (vaatii pankkitunnukset)?", continue: "Jatka", close: "Sulje" }, eprWarningForPayment: { isDelayed: "Annetulle palkkapäivälle tehtävä palkkatietoilmoitus myöhästyy, koska ilmoitus pitää tehdä 5 päivän kuluessa palkkapäivästä. Ota huomioon, että tästä saattaa seurata myöhästymismaksu." }, eprWarningForCancellation: { isDelayed: "Palkanmaksusta tehdyt tulorekisteri-ilmoitukset perutaan automaattisesti.", infoText: "Jos maksat palkan uudestaan samalle palkkapäivälle, ota huomioon, että uudesta palkkatietoilmoituksesta saattaa seurata myöhästymismaksu." }, isPaid: { payment: "Maksu", paid: "Laskelma/palkkalista on maksettu.", cantCreatePayment: "Maksua ei voitu luoda", cantCreatePaymentAlreadyPaid: "Maksua ei voitu luoda. Tarkista, onko laskelma/palkkalista jo maksettu." }, createInvoice: { cantCreateInvoice: "Maksua ei voitu luoda", cantCreateInvoiceCheck: "Maksua ei voitu luoda. Tarkista, onko laskelma/palkkalista jo maksettu." }, sendEInvoice: { ajax: { title: "Verkkolasku on lähetetty", msg: "Maksu on lähetetty verkkolaskuna osoitteeseen", error: { title: "Verkkolaskua ei lähetetty", msg: "Maksua ei voitu lähettää verkkolaskuna" }, operatorStatus: "Status operaattorilta" }, paymentChannel: { palkkausCfaTest: { paying: "Maksetaan" }, holviCfa: { paying: "Luodaan maksua Holviin", salariesMovedToPay: "Palkka/palkat on nyt siirretty maksuun", holviConfirm: "Mene Holvin Tapahtumat-sivulle ja vahvista maksu", afterConfirmation: "Maksun vahvistuksen jälkeen työntekijän nettopalkka", accountsToWorker: "tilittyy työntekijän tilille 2–4 pankkipäivän kuluessa", palkkausIr: "Palkkaus.fi tekee tulorekisteri-ilmoitukset ja tilittää maksut eri tahoille" }, talenomCfa: { paying: "Luodaan maksua Talenom-onlineen", salariesMovedToPay: "Lähetys onnistui", talenomConfirm: "Maksusta on lähetetty lasku Talenom Online -palveluun", afterConfirmation: "Maksun päivittymisessä voi kestää 1-15 minuuttia", confirm: "Käy vielä hyväksymässä maksu Talenom Online -palvelussa" } } }, paytrail: { invoicePaid: { heading: "Maksu", text: "Laskelma/palkkalista on jo maksettu" }, invoiceMissing: { heading: "Maksua ei voitu luoda", text: "Maksua ei voitu luoda. Tarkista, onko laskelma/palkkalista jo maksettu" } }, palkkausPersonalInvoice: { updatingPaymentStatus: "Päivitetään maksun tilaa", isPayroll: { heading: "Palkkalista ja kotitaloudet", text: "Palkkalistan käyttöä ei tueta toistaiseksi kotitalouksien palkanmaksussa" }, createInvoice: { heading: "Maksun tilaa ei voitu päivittää", text: "Maksun tilaa ei voitu päivittää. Tarkista, onko maksu peruttu" } } }, ODataActionsComponent: { toExcel: "Exceliin", export: "Tietojen vienti", import: "Tietojen tuonti", getDefaults: { copyExcel: "Excel copy-paste", fileExcel: "Excel-tiedosto", copyCsv: "CSV copy-paste", fileCsv: "CSV-tiedosto" } }, ODataFooterComponent: { showing: "Näytetään", rows: "riviä", downloadMore: "Lataa lisää", showAll: "Näytä kaikki", showingRows: "Näytetään rivit", total: "yhteensä", nextPage: "Seuraava sivu", getNoItemsMessage: { anon: "Tämä listaus vaatii kirjautumisen. Kirjaudu sisään!", loadError: "Listan lataamisessa tapahtui virhe. Tarkista internet-yhteys, navigoi vasemmasta reunasta jollekin muulle sivulle ja tähän uudelleen. Jos ongelma jatkuu, ota yhteyttä asiakaspalveluun.", noItems: "Listassa ei ole yhtään riviä." } }, ODataCalendarEventComponent: { description: "Kuvaus", categories: "Kategoriat", period: "Periodi", duration: "Kesto", step1Title: "Perustiedot", step2Title: "Muistutukset ja viestit", step3Title: "Esikatselu", showDetailsDialogTitle: "Uusi kalenteritapahtuma", showDetailsDialogTitle2: "Muokkaa tapahtumaa", getEventDurationError: "Virhe: Loppu on ennen alkua.", calendarClickNoDescription: "Ei kuvausta", calendarClickDuration: "ajastus", reoccuringEvent: "Toistuva tapahtuma", event: "Tapahtuma", notificationEnabledSummary: "Muista hyväksyä palkkalista", showEditEventTitle: "Automaattinen palkkalista: Ajastus ja muistutukset" }, AccountingReportComponent: { accountingReports: "Kirjanpitoraportti", loadingReport: "Ladataan raporttia" }, AccountingReportBuilder: { dataType: { label: "Kirjaustapa", accrualBasis: "Suoriteperuste", cashBasis: "Maksuperuste" }, queryType: { label: "Raportin laskelmat", periodQuery: "Kausi", periodQueryMonth: "Kuukausi", periodQueryCustom: "Muu aikaväli", selectMonth: "Valitse kuukausi", selectQuarter: "Valitse neljänneksellä oleva kuukausi", selectYear: "Valitse vuosi", selectStartDate: "Valitse kauden aloituspäivä", selectEndDate: "Valitse kauden päättymispäivä", selectionQuery: "Valitse laskelmat" }, getRows: "Hae rivit", button: { addPaidCalc: "Lisää maksettu laskelma", addDraftCalc: "Lisää luonnoslaskelma" } }, AccountNumbersComponent: { title: "Valitse tili", accountNumber: "Tilinumero", description: "Selite", choose: "Valitse" }, CumulativeReportPeriodSelection: { title: "Valitse kausi", periodLabel: "Kausi", enumOptionYear: "Vuosi", enumOptionMonth: "Kuukausi", enumOptionAll: "Kaikki", enumOptionCustom: "Muu aikaväli", periodDateKindLabel: "Kauden määräytyminen", salaryDateEnum: "Työntekijän palkkapäivä", paidAtDateEnum: "Työnantajan suoritus", workDateEnum: "Työn palkkakausi", month: "kuukautta", chooseMonthLabel: "Valitse kuukausi", year: "vuosi", chooseYearLabel: "Valitse vuosi", refDateCustomLabel: "Valitse kauden aloituspäivä", endDateCustomLabel: "Valitse kauden päättymispäivä", workersLabel: "Työntekijät", chosen: "Valittu", all: "Kaikki", more: "Lisää" }, CumulativeReportSaveTemplate: { title: "Raporttipohja", isNewLabel: "Uusi/muokkaa", isNewLabelTrue: "Luo uusi raporttipohja nykyisestä raportista", isNewLabelFalse: "Muokkaa nykyistä raporttipohjaa", currentLabel: "Raporttipohjan nimi" }, EntryCodesComponent: { title: "Valitse rivityyppi ja -koodi", entryCodeGroupLabel: "Rivityyppi", incomeTypeLabel: "Tulolaji", totalTypeLabel: "Laskettu erä" }, FlagsComponent: { title: "Valitse valintaliput", flag: "Lippu", description: "Selite", prefix: "Ryhmä" }, InputIncomeType: { getRowLabelNotFound: "Tulolajia ei löydy: ", getPlaceholder: "Hae Tulorekisterin tulolajeista..." }, InputOccupationType: { getPlaceholder: "Kirjoita hakusana luokitukselle..." }, InputCollectiveBargainAgreement: { getPlaceholder: "Kirjoita hakusana työehtosopimukselle..." }, IncomeTypeCodeEditorComponent: { title: "Tulolajieditori", carBenefitTypeLabel: "Autoedun tyyppi", noSelection: "Ei valintaa", carBenefitLimited: "Käyttöetu", carBenefitFull: "Vapaa autoetu", carBenefitAgeGroupCodeLabel: "Autoedun ikävalinta", carBenefitKilometersLabel: "Kilometrit", carBenefitEmissionsValueLabel: "Auton päästöarvo (0-100)", mealBenefitLabel: "Ravintoetu vastaa verotusarvoa", mealBenefitTrue: "Kyllä", mealBenefitFalse: "Ei", dailyAllowanceTypeLabel: "Päivärahan tyyppi", add: "Lisää", partialDailyAllowanceEnum: "Osapäiväraha", fullDailyAllowanceEnum: "Kokopäiväraha", internationalDailyAllowanceEnum: "Ulkomaan päiväraha" }, IrImportAbsencesDialogComponent: { heading: "Valitse poissaolot", absences: "Poissaolot", wholeAbsence: "Koko poissaolo", isHolidayAccrual: { html: "Palkattomat palkkakaudelle<br /> Lomakertymää vähentää" }, isPaid: "Palkallinen.", notPaid: "Ei palkkaa.", isAccrual: "Työssäolon veroinen.", notAccrual: "Ei työssäolon veroinen." }, IrScheduleSendDialogComponent: { heading: "Lähetyksen ajastus", dateLabel: "Päivämäärä", timeLabel: "Kellonaika", dateTimeLabel: "Lähetyshetki" }, AccountAuthorizationPersonComponent: { identificationTitle: "Tunnistautuminen", notIdentified: "Et ole vielä tunnistautunut", identifyBtn: "Tunnistaudu", haveIdentified: "Olet tunnistautunut", credentialLabel: "Tunniste:", authorizationTypeLabel: "Valtuutus:", userInfoTitle: "Käyttäjätiedot", userNameLabel: "Käyttäjätunnus:", authMethodLabel: "Kirjautumistapa", termsAndPrivacyTitle: "Tietosuoja ja käyttöehdot", termsLabel: "Palkkaus.fi:n käyttöehdot", termsBtn: { html: '<a href="https://www.palkkaus.fi/kayttoehdot/" target="_blank">Lue</a>' }, privacyLabel: "Sopimus henkilötietojen käsittelystä", privacyBtn: { html: '<a href="https://www.palkkaus.fi/sopimus-henkilotietojen-kasittelysta/" target="_blank">Lue</a>' }, privacyStatementLabel: "Palkkaus.fi:n tietosuojaseloste", privacyStatementBtn: { html: '<a href="https://www.palkkaus.fi/tietosuoja/" target="_blank">Lue</a>' } }, AccountAvatarEditPersonComponent: { avatarLabel: "Kuva", avatarTypeLabel: "Kuvan tyyppi", optionChoose: "Valitse kuvan tyyppi", optionIcon: "Kuvake", optionUploaded: "Kuva omalta koneelta", optionGravatar: "Gravatar", gravatarInfo: { html: "Gravatar-kuva on linkitetty sähköpostiosoitteeseen ja sähköpostiosoitteen omistaja voi itse vaihtaa kuvan osoitteessa www.gravatar.com. Sitä käytetään myös monissa muissa palveluissa: blogeissa, keskustelufoorumeilla jne." }, initialsLabel: "Nimikirjaimet", colorLabel: "Väri", uploadImageLabel: "Lataa kuva koneelta", uploadImage: { html: "Klikkaa tästä ja lataa kuva<br>(maks. 10MB)<br />" }, preferredImageSize: "Suositeltu kuvan koko: 120px x 50px", colorBrown: "Ruskea", colorLime: "Lime", colorDarkGreen: "Tummanvihreä", colorPink: "Pinkki", avatarDescription: { html: "Kuva ei ole pakollinen tieto palkanmaksussa." } }, AccountContactEditPersonComponent: { addressInfo: "Osoite ei ole pakollinen palkanmaksussa.", verificationPinLabel: "Tekstiviestistä saamasi puhelinnumeron vahvistuskoodi", verificationPinInfo: "Puhelinnumeroa käytetään kevyeen tunnistautumiseen. Siksi numeron vaihtaminen vaatii varmistuksen tekstiviestillä.", orderVerificationBtn: "Tilaa koodi", addressLabel: "Osoite", requestContactVerificationPin: { alertTitle: "Koodi lähetetty", alertText: "Vahvistuskoodi on lähetetty antamaasi numeroon." } }, AccountDetailsEditPersonComponent: { nameLabel: "Nimi", nameDecription: { html: "Nimen muokkaaminen vaatii aina pankki&shy;tunnistuksen. Tämä hoidetaan rekisteröinnin ohjatulla toiminnolla." }, launchWizardBtn: "Aloita muutos", personalIdDescription: { html: "Palkkaus.fi-tili on aina kiinnitetty henkilötunnukseen. Jos henkilötunnuksesi muuttuu, kirjaudu ulos ja luo uusi Palkkaus.fi-tili uudella henkilötunnuksella tai ota yhteys asiakaspalveluumme." } }, AccountDetailsPersonComponent: { personalInfoTabHeading: "Henkilötiedot", contactInfoTabHeading: "Yhteystiedot", avatarTabHeading: "Kuva", authorizationTabHeading: "Tunnistautuminen", insurancesTabHeading: "Vakuutukset" }, AccountInfoPersonComponent: { noSelection: "Työntekijää ei ole valittu" }, AccountInfoComponent: { panelTitle: "Palkkaus.fi-tilin tiedot", companyName: "Yrityksen nimi", companyType: "Yhtiömuoto", legalEntityType: "Tilin tyyppi", authorizationType: "Valtuutus", palkkausAccount: "Palkkaus.fi-tili", email: "Sähköposti", phone: "Puhelinnumero", address: "Osoite", ibanNumber: "Pankkitili", description: { html: "Jokaisella käyttäjällä on palvelussamme Palkkaus.fi-tili. Palkkaus.fi-tiliin tallennetaan palkanmaksua varten tiedot sekä kaikki maksutapahtumat. Voit muokata tietojasi <a href='{{ accountWizardUrl }}'>ohjatusta toiminnosta täältä</a> (vaatii pankkitunnukset)." }, lead: { infoText: "Jokaisella yrityksellä (kuten myös kotitaloustyönantajalla ja työntekijällä) on palvelussamme Palkkaus.fi-tili. Palkkaus.fi-tiliin tallennetaan palkanmaksua varten tiedot sekä kaikki maksutapahtumat. Voit muokata tietojasi", buttonText: "ohjatusta toiminnosta täältä", infoTextAlt: "(vaatii pankkitunnukset)." }, officialId: "Y-tunnus", changeAvatar: "Vaihda kuvake", editContactInfo: "Muokkaa yhteystietoja" }, AccountingReportQueryComponent: { reportCalcsLabel: "Raportin laskelmat", periodQueryEnum: "Kausi", selectionQueryEnum: "Valitse laskelmat", addPaidCalcs: "Lisää maksettu laskelma", addDraftCalcs: "Lisää luonnoslaskelma", periodDateKindLabel: "Kauden määräytyminen", paidAtDateEnum: "Maksupäivä (työnantajan suorittama maksu)", salaryDateEnum: "Palkkapäivä (tulorekisteriin raportoitu päivä)", period: "Kausi", monthEnum: "Kuukausi", customEnum: "Muu aikaväli", monthPlaceHolder: "kuukautta", refDateMonthLabel: "Valitse kuukausi", refDateQuarterLabel: "Valitse neljänneksellä oleva kuukausi", yearPlaceholder: "vuosi", refDateYearLabel: "Valitse vuosi", refDateCustomLabel: "Valitse kauden aloituspäivä", endDateCustomLabel: "Valitse kauden päättymispäivä", status: "Tila", date: "Pvm", salary: "Palkka", payment: "Maksu", notSelected: "(Työntekijää ei ole valittu)", queryRows: "Hae rivit" }, AccountingReportRowsComponent: { accountNumber: "Ehdotustili", accountName: "Selite", saldo: "Yhteensä", calculation: "Laskelma", description: "Kuvaus", vatPercent: "Alv %", sum: "Summa", projectNumber: "Projektinumero", costCenter: "Kustannuspaikka" }, AccountingReportToolsComponent: { target: "Kohde", settingsAddMoreTargets: "Asetukset: Lisää kohteita", createExport: "Luo aineisto", showRowsAndExports: "Näytä tilit ja viennit", showOnlyRows: "Näytä vain tilit", exportLabel: "Luo aineisto valituista", schemes: { default: { label: "Vakioaineisto" }, compact: { label: "Suppea aineisto" }, extended: { label: "Laaja aineisto" } }, status: "Tila", accountingData: "Kirjanpitoaineisto" }, CumulativeReportComponent: { chooseData: "Valitse data", selectPeriod: "Valitse kausi", selectCalcs: "Valitse palkkalaskelmat", selectPayrolls: "Valitse palkkalistat", reportTemplates: "Raporttipohjat", saveTemplate: "Tallenna pohjaksi" }, AccountingReportsComponent: { year: "vuosi", period: "Kausi", salaries: "Palkat", payments: "Maksut", salariesAlt: "Palkkoja", workers: "Työntekijöitä", material: "Aineisto", responsiblePerson: "Vastuuhenkilö", chooseAll: "Valitse kaikki", unselect: "Poista valinnat", pce: "kpl", createMaterial: "Luo aineisto", notSelected: "(Työntekijää ei ole valittu)", accountingReports: "Kirjanpidon raportit", showFilters: "Näytä suodattimet", mm: "kk", noAccountingReports: "Ei kirjanpitoraportteja", calcs: "Laskelmat", workersAlt: "Työntekijät" }, AccountingReportsPanelComponent: { accountingReports: "Kirjanpidon raportit", showFilters: "Näytä suodattimet", mm: "kk", noAccountingReports: "Ei kirjanpitoraportteja", calcs: "Laskelmat", workersAlt: "Työntekijät" }, AccountingTargetDetailsComponent: { accountingTargetLegend: "Tiliöintipohjan tiedot", noTemplate: "Tämä tiliöintimalli on alkuperäinen: se ei perustu mihinkään tiliöintipohjaan.", hasTemplate: "Tämä tiliöintimalli on merkitty tiliöintipohjaksi.", readOnly: "Tätä tiliöintimallia ei voi muokata. Luo muokattava malli kopioimalla.", name: "Nimi", id: "ID", excelCsv: "Excel/Csv", excelCsvFormat: "Excel/Csv-muoto", availableMethods: "Vientitapa", exportMethod: "Vientitapa", exportMethods: "Vientitavat", channel: "Kirjanpitokanava", logoUrl: "Logo", tabs: { overview: "Perustiedot", chartOfAccounts: "Tilikartta (koko kirjanpito)", usedAccounts: "Käytetyt tilit (palkkojen tiliöinti)", guidelines: "Ohjeet", rules: "Tiliöintisäännöt", accountingQuery: "Kirjanpitokysely" }, pasteFromClipboard: "Liitä leikepöydältä", createTargetCoAFromAccounts: "Luo tilikartta uusi tilikartta tilikarttapohjasta", readFile: "Lataa tiedosto", accountNumber: "Tilinumero", ruleCount: "Sääntöjen määrä", noAccountNumberFound: "Tilinumeroa ei löydy tuodulta tilikartalta", changeAccount: "Vaihda tiliä", guidelinesInfo: { html: '<p class="lead"><strong>Tiliöintimalli</strong> määrittelee miten palkkalaskelman rivit ja sivukulut (eläkemaksut, työttömyysvakuutusmaksut, SAVA-maksut ja verot) viedään kirjanpitoon. Määrittely tehdään taulukkomuodossa, missä kullekin rivin tulolajille ja sivukulutyypille määritetään sekä credit- että debet-tili.</p><p>Kirjanpidot tiliöinnit etusivun alta löytyvät käytettävissä olevat tiliöintimallit. Ne sisältävät sekä järjestelmän vakiomalleja että mahdollisesti käyttäjän luomia omia malleja.</p><p>Jos vakiomallin kirjaukset eivät sovi käyttäjän tarpeisiin, voidaan <strong>uusi tiliöintimalli luoda kopioimalla vakiomalli.</strong> Vakiomalleja ei voi muokata tai poistaa. Kopioitua mallia voidaan muokata tilien sekä vientisääntöjen osalta <ul><li>Mallille voidaan antaa kuvaava nimi.</li><li>Vakiomallilta kopioituneita rivejä voidaan ottaa käyttöön/poistaa käytöstä.</li><li>Uusi rivejä voidaan lisätä kopioimalla vakiomallin rivi.</li><li>Tilikartalla voidaan muuttaa tilinumeroa ja tilin kuvausta.</li><li>Tilikartalle voidaan lisätä uusia tilejä.</li><li>Voit ladata oman tilikartan pohjaksi.</li></ul></p><p><strong>Tiliöintisäännöt</strong> -välilehdellä kullekin rivin tulolajille ja sivukulutyypille määritetään sekä credit- että debet-tili. Credit- ja debet-tilin valinta on mahdollista tehdä vain niistä tileistä, mitkä on listattu <strong>Käytetyt tilit</strong>-välilehdellä. Samaa tilinumeroa olevat viennit voidaan haluttaessa ryhmittelyn (ryhmän id ja kuvaus) avulla jäsentää omiksi ryhmikseen. Jokainen kirjanpitovienti perustuu siihen, että kullekin rivityypille ja sivukulutyypille löytyy määrittelyrivi. Rivin valinta tapahtuu seuraavilla säännöillä:<ol><li>Haetaan riveistä kaikki ne rivit, missä on laskelman rivin tulolajia tai sivukulutyyppiä vastaava arvo.</li><li>Jos rivi ei ole käytössä, sitä ei oteta mukaan.</li><li>Tarkistetaan valintalippujen vastaavuus: valitaan se rivi, missä on eniten samoja valintalippuja kuin laskelman rivillä tai sivukululla. Jos löytyy useampi rivi, missä on samat valintaliput, valitaan näistä se rivi, missä valintalippujen lukumäärä on pienin.</li><li>Rivin perusteella tehdään kirjaus. Jos Kirjaa-valinta ei ole päällä, riviä ei kirjata.</li></ol></p>' }, sortDefault: "Järjestä tulolajeittain", sortByAccountPairs: "Ryhmittele tilipareittain", sortByAccount: "Ryhmittele tileittäin", accounts: "Tilit", sorting: "Järjestely", editorQuery: { selectedAmount: "Valittu", addDraftBtn: "Lisää luonnoslaskelma", status: "Tila", date: "Pv", salary: "Palkka", payment: "Maksu", notSelected: "(Työntekijää ei ole valittu)", unselect: "Poista valinta", fetchRowsBtn: "Hae rivit" }, rulesTables: { incomeTypeHead: "Tulolaji tai laskettu erä", additionalSelectionsHead: "Lisävalinnat", includeHead: "Kirjaa", enabledHead: "Käytössä", debetHead: "Debet-tili / ryhmittely", creditHead: "Kredit-tili / ryhmittely", included: "Kirjataan", excluded: "Ei kirjata", enabled: "Käytössä", disabled: "Ei käytössä", debitUndefined: "Debit-tili ei määritetty", creditUndefined: "Kredit-tili ei määritetty", notIncluded: "Ei kirjanpitoon", editRule: "Muokkaa sääntöä", copyAsNewRule: "Kopioi uudeksi säännöksi", changeIncomeTypeBtn: "Vaihda tulolaji tai laskettu erä", editAdditionalsBtn: "Muokkaa lisävalintoja", changeAccountBtn: "Vaihda tili", grouping: "Ryhmittely", changeGroupingBtn: "Vaihda ryhmittely", addGrouping: "Lisää ryhmittely (tiliöintiteksti)", calcRowBtnPS: "laskelman rivi", incomeTypeBtnPS: "tulolaji", accountsHead: "Tilit" }, filters: { rowsToShow: "Näytä", all: "Kaikki tilit", includedAndEnabled: "Kirjaavat tilit", error: "Virheelliset tilit", showNormal: "Näytä muokkausnäkymä", showDistinct: "Näytä tiliyhteenveto", noRows: "Valitulla suodattimella ei löytynyt rivejä" } }, AccountingTargetsComponent: { exportDefinition: "Viennin määrittely", targetChannel: "Kohde / kanava", owner: "Omistaja", status: "Status" }, AccountingTargetSettings: { title: "Kirjanpitokohde", intro: "Valitse käytettävä oletuskohde. Voit myös lisätä kohteita.", accountingLegend: "Kirjanpito", serviceModelLegend: "Palvelumalli", overwriteServiceModel: "Ohita palvelumalli", defaultTarget: "Oletuskohde" }, AccountantComponent: { title: "Kirjanpitäjä / tilitoimisto", intro: "Lisää tähän kirjanpitäjäsi yhteystiedot tai tilitoimistokumppani, jolle annetaan pääsy suoraan Palkkaus.fi palveluun kirjanpidon ja palkkatietojen hakemiseksi.", addPrimaryPartner: "Lisää tilitoimistokumppani", intro2: "Näet nykyisen kirjanpitäjäsi/tilitoimistosi tiedot alla. Voit muuttaa tai poistaa tietoja.", name: "Nimi", officialId: "Y-tunnus", email: "Sähköposti", phone: "Puhelinnumero", accountantType: "Tilitoimiston oikeudet", primaryPartner: "Tilitoimistokumppanin oikeudet", pendingPrimaryPartner: "Odottaa tilitoimistokumppanin vahvistusta", unlinkedPrimaryPartner: "Uutta tilitoimistokumppania pyydetty", unlinkedAccountingOnly: "Tilitoimistokumppani ilman pääsyä Palkkaus.fi palveluun", showConfirmPartnerRemovalTitle: "Poista tilitoimistokumppani", showConfirmPartnerRemovalDesciption: "Poiston jälkeen tilitoimistollasi ei ole pääsyä raportteihisi. Haluatko varmasti poistaa kumppanin?" }, AuthInfoHeadersComponent: { partners: { integrations: { introTitle: "Ohjelmistokumppanit", introLead: "Tällä sivulla näet kaikki ohjelmistokumppanipalvelut, jotka sinulla on käytössä. Aktivoi lisäpalveluita klikkaamalla kumppanikorttia" }, accountantsTitle: "Tilitoimistot", introTitle: "Kumppanipalvelut", introLead: "Tällä sivulla näet kaikki kumppanipalvelut, jotka sinulla on käytössä. Aktivoi ja muuta palveluita klikkaamalla kumppanikorttia.", accountants: { introTitle: "Tilitoimistokumppanit", introLead: "Tällä sivulla näet mahdollisen tilitoimistopalvelun, joka sinulla on käytössä. Muuta kumppania klikkaamalla kumppanikorttia." } }, askelma: { cta: "Lisätietoja Askelmasta", description: "Askelma on kustannustehokas ja helppokäyttöinen taloushallinnon pilvipalvelu yrityksen ja tilitoimiston yhteiskäyttöön.", link: "http://askelma.com/" }, easoft: { cta: "Lisätietoja Easoftista", description: "Easoft on helppo­käyttöinen toiminnanohjaus­järjestelmä projektin­hallintaan.", link: "https://easoft.fi/" }, ecom: { cta: "Lisätietoja Ecomista", description: "Tarjoamme kattavan LVIS- ja rakennusalan taloudenhallinta- ja toiminnanohjausratkaisun, joka sisältää laskutuksen ja ostolaskujen maksun, helpon projektien ja keikkatöiden hallinnan, räätälöitävät lisäpalvelut ja integraatiot sekä työaikakirjauksiin perustuvan palkanlaskennan.", link: "https://ecom.fi/" }, domus: { cta: "Lisätietoja Domuksesta", description: "Domus-isännöintijärjestelmällä siirrät taloyhtiön aidosti nykyaikaan.", link: "https://confirma.fi/" }, briox: { cta: "Lisätietoja Brioxista", description: "Briox Oy kehittää ja myy yritysjärjestelmiä pienille ja keskisuurille yrityksille sekä tilitoimistoille. Ohjelmatarjonta käsittää mm. kirjanpidon, laskutuksen, myyntituen ja tuntikirjanpidon. Lisäksi se on täysin verkkopohjainen ja käytettävissä miltä tahansa Internetiin kytketyltä laitteelta.", link: "http://briox.fi/" }, nocfo: { cta: "Lisätietoja NOCFOsta", description: "Moderni ja ilmainen kirjanpito-ohjelma pienyrityksille ja -yhdistyksille yhtiömuodosta riippumatta. Sähköinen arkisto tositteille.", link: "https://nocfo.io/" }, passeliMerit: { cta: "Lisätietoja Passeli Meritistä", description: "Passeli Merit on tehokas ja helppokäyttöinen taloushallinnon ohjelma, joka sopii lähes kaikille toimialoille. Se automatisoi kirjanpidon ja laskutuksen, tehden työstä nopeampaa ja vaivattomampaa.", link: "https://www.passeli.fi/passelimerit" }, duunimylly: { cta: "Lisätietoja Duunimyllystä", description: "Duunimylly on Rakennusliiton ja Palkkaus.fi:n yhteistyössä toteuttama.", link: "https://raksa.palkkaus.fi/#/index/" }, holvi: { cta: "Lisätietoja Holvista", description: "Holvi on yrittäjäystävällinen verkkopankki, joka tarjoaa yrittäjälle kaikki tarvittavat taloudenhallintaratkaisut.", link: "https://about.holvi.com/" }, isolta: { cta: "Lisätietoja Isolta Arhimedeksestä", description: "Isolta Arkhimedes on laskutusohjelma yrittäjälle. Se tarjoaa yrittäjän tärkeimmät työkalut laskutukseen kirjanpitoon sekä palkanlaskennan.", link: "https://www.isolta.fi/" }, accountor: { cta: "Lisätietoja Accountor Gosta", description: "Accountor Go on kiinteähintainen kirjanpitopalvelu sooloyrittäjälle. Saat sekä ammattikirjanpitäjän että työkalun käyttöösi kiinteällä kuukausihinnalla.", link: "https://go.accountor.fi/" }, finago: { cta: "Lisätietoja Finago Solosta", description: "Finagolta saat helppokäyttöiset ja luotettavat taloushallinnon ohjelmistot, jotka toimivat pilvipalveluna. Ohjelmistot sopivat niin yrityksille kuin tilitoimistoille. Joustavuutta yritysten erilaisiin tarpeisiin!", link: "https://finago.com/fi/" }, onnistuyrittajana: { cta: "Lisätietoja OnnistuYrittäjänä-palvelusta", description: "OnnistuYrittäjänä on aloittavan yrittäjän tuki kaikkeen yrittäjyyteen liittyvissä asioissa.", link: "https://onnistuyrittajana.palkkaus.fi/#/" }, sporttisaitti: { cta: "Lisätietoja Sporttisaitista", description: "Sporttisaitti on urheiluseuroille tarkoitettu palvelu, joka yhdistää yhdistyksen kotisivut, jäsenluettelon, laskutuksen ja viestinnän. Sporttisaitin kautta voit nyt myös maksaa palkkaa yhdistyksesi työntekijöille tai palkkioita jäsenille.", link: "https://www.sporttisaitti.com/" }, lemontree: { cta: "Lisätietoja Lemon Treestä", description: "Tilitoimisto Lemon Tree on pienen yrityksen ystävä. Lemon Treen kanssa kirjanpitoasioiden hoito on helppoa, mukavaa ja edullista.", link: "https://lemontree.fi/" }, talousavain: { cta: "Lisätietoja Talousavain.netistä", description: `Talousavain.net tarjoaa Suomen laajuisesti taloushallinnonpalvelua niille, joita kiinnostaa säästää aikaa, vaivaa ja rahaa! Meiltä saat osaavan asiantuntijanpalvelun yrityksellesi, sekä tukea liiketoimintasi kehittämiseen ajasta ja paikasta riippumatta! Autamme uudet yrittäjät vaivattomasti liiketoiminnassaan liikkeelle. Autamme sinua Palkkaus.fi palvelun käytössä ja hoidamme halutessasi kaiken palkanmaksuun liittyvän. Palkkauksen käyttäjille tarjoamme myös kirjanpidon palvelut alkaen 49 eur / kk (ALV0).  Meillä voit myös aina kokeilla palvelujamme kuukauden ajan tyytyväisyystakuulla.
`, link: "https://www.talousavain.net" }, makinen: { description: "Pentti Mäkinen kuvaus", link: "http://www.kirjanpidot.fi/", cta: "Lisätietoja" }, talenom: { description: "Palkkaus.fi-palkanmaksu on käytettävissä Easor App -sovelluksen käyttäjille suoraan Easorin verkkopalvelusta osana kirjanpidon palveluita.", cta: "Lisätietoja Easorista", link: "https://www.talenom.fi/" }, treamer: { cta: "Lisätietoja Treamerista", description: "Treamer on moderni työnvälityspalvelu, josta löydät helposti itsellesi työntekijöitä.", link: "https://www.treamer.com/" }, yhdistysavain: { cta: "Lisätietoja Yhdistysavaimesta", description: "Yhdistysavain on urheiluseuroille tarkoitettu palvelu, johon voi keskittää yhdistyksen kotisivut, jäsenluettelon, laskutuksen ja viestinnän. Yhdistysavaimen kautta voit nyt myös maksaa palkkaa yhdistyksesi työntekijöille tai palkkioita jäsenille.", link: "https://www.yhdistysavain.fi/" } }, AuthorizationDialogsComponent: { askelma: { html: `<fieldset>
<legend>Askelma</legend>
<p><p>Klikkaamalla alla olevaa vipua voit antaa Askelma-tilillesi käyttöoikeuden Palkkaus.fi-tilin tietoihisi.</p>
<p>Huomaathan että tämä tarkoittaa että silloin Askelma-tililtäsi on pääsy kaikkiin tietoihin, kuten työntekijöiden tietoihin ja palkkalaskelmiin.</p>
 <p>Voit poistaa käyttöoikeuden milloin vain klikkaamalla alla olevaa vipua.</p>
</fieldset>` }, easoft: { html: `<fieldset>
<legend>Easoft</legend>
<p><p>Klikkaamalla alla olevaa vipua voit antaa Easoft-tilillesi käyttöoikeuden Palkkaus.fi-tilin tietoihisi.</p>
<p>Huomaathan että tämä tarkoittaa että silloin Easoft-tililtäsi on pääsy kaikkiin tietoihin, kuten työntekijöiden tietoihin ja palkkalaskelmiin.</p>
 <p>Voit poistaa käyttöoikeuden milloin vain klikkaamalla alla olevaa vipua.</p>
</fieldset>` }, domus: { html: `<fieldset>
<legend>Domus</legend>
<p><p>Klikkaamalla alla olevaa vipua voit antaa Domus-tilillesi käyttöoikeuden Palkkaus.fi-tilin tietoihisi.</p>
<p>Huomaathan että tämä tarkoittaa että silloin Domus-tililtäsi on pääsy kaikkiin tietoihin, kuten työntekijöiden tietoihin ja palkkalaskelmiin.</p>
 <p>Voit poistaa käyttöoikeuden milloin vain klikkaamalla alla olevaa vipua.</p>
</fieldset>` }, briox: { html: `<fieldset>
<legend>Briox</legend>
<p>Klikkaamalla alleolevaa vipua voit antaa Briox-tilillesi käyttöoikeuden Palkkaus.fi-tilin tietoihisi.</p>
<p>Huomaathan että tämä tarkoittaa että silloin Briox-tililtäsi on pääsy kaikkiin tietoihin, kuten työntekijöiden tietoihin ja palkkalaskelmiin.</p>
 <p>Voit poistaa käyttöoikeuden milloin vain klikkaamalla alla olevaa vipua.</p>
</fieldset>` }, duunimylly: { html: `<fieldset>\r
    <legend>Duunimylly</legend>\r
    <p>Pääset Duunimyllyyn <a href="https://raksa.palkkaus.fi/#/index/">täältä</a>.</p>\r
    <p>\r
        Kirjaudu Duunimyllyyn samalla käyttäjätunnuksella, jolla kirjaudut Palkkaus.fi:hin. Duunimyllyyn kirjautumista varten ei siksi tarvitse antaa erillistä oikeutusta.\r
    </p>\r
</fieldset>` }, holvi: { html: `<fieldset>
    <legend>Holvi</legend>
    <p>Klikkaamalla alleolevaa vipua voit antaa Holvi-tilillesi käyttöoikeuden Palkkaus.fi-tilin tietoihisi.</p>
    <p>Huomaathan että tämä tarkoittaa että silloin Holvi-tililtäsi on pääsy kaikkiin tietoihin, kuten työntekijöiden tietoihin ja palkkalaskelmiin.</p>
    <p>Voit poistaa käyttöoikeuden milloin vain klikkaamalla alla olevaa vipua.</p>
</fieldset>` }, isolta: { html: `<fieldset>
    <legend>Isolta Arkhimedes</legend>
    <p>Klikkaamalla alleolevaa vipua voit antaa Isolta-tilillesi käyttöoikeuden Palkkaus.fi-tilin tietoihisi.
</p><p>
Huomaathan että tämä tarkoittaa että silloin Isolta-tililtäsi on pääsy kaikkiin tietoihin, kuten työntekijöiden tietoihin ja palkkalaskelmiin.
</p><p>Voit poistaa käyttöoikeuden milloin vain klikkaamalla alla olevaa vipua</p>
</fieldset>` }, accountor: { html: `<fieldset>
    <legend>Acountor Go</legend>
    <p>Klikkaamalla alleolevaa vipua voit antaa Accountor Go -tilillesi käyttöoikeuden Palkkaus.fi-tilin tietoihisi.
</p><p>
Huomaathan että tämä tarkoittaa että silloin Accountor Go -tililtäsi on pääsy kaikkiin tietoihin, kuten työntekijöiden tietoihin ja palkkalaskelmiin.
</p><p>Voit poistaa käyttöoikeuden milloin vain klikkaamalla alla olevaa vipua</p>
</fieldset>` }, finago: { html: `<fieldset>\r
    <legend>Finago Solo</legend>\r
    <p>Klikkaamalla alleolevaa vipua voit antaa Finago Solo -tilillesi käyttöoikeuden Palkkaus.fi-tilin tietoihisi.\r
</p><p>\r
Huomaathan että tämä tarkoittaa että silloin Finago Solo -tililtäsi on pääsy kaikkiin tietoihin, kuten työntekijöiden tietoihin ja palkkalaskelmiin.\r
</p><p>Voit poistaa käyttöoikeuden milloin vain klikkaamalla alla olevaa vipua</p>\r
</fieldset>` }, onnistuyrittajana: { html: `<fieldset>
    <legend>OnnistuYrittäjänä</legend>
    <p>Pääset OnnistuYrittäjänä-palveluun <a href="https://onnistuyrittajana.palkkaus.fi/#/">täältä</a>.</p>
    <p>
        Kirjaudu OnnistuYrittäjänä-palveluun samalla käyttäjätunnuksella, jolla kirjaudut Palkkaus.fi:hin. OnnistuYrittäjänä-palveluun kirjautumista varten ei siksi tarvitse antaa erillistä oikeutusta.
    </p>
</fieldset>` }, sporttisaitti: { html: `<fieldset>
    <legend>Sporttisaitti</legend>
    <p>Klikkaamalla alla olevaa vipua voit antaa Sporttisaitti-tilillesi käyttöoikeuden Palkkaus.fi-tilin tietoihisi.</p>
    <p>Huomaathan että tällöin Sporttisaitti-tililtäsi on pääsy kaikkiin tietoihin, kuten työntekijöiden tietoihin ja palkkalaskelmiin.</p>
    <p>Voit poistaa käyttöoikeuden milloin vain klikkaamalla alla olevaa vipua.</p>
</fieldset>` }, lemontree: { html: `<fieldset>
    <legend>Lemon Tree</legend>
    <p>Klikkaamalla alleolevaa vipua voit antaa Lemon Tree -tilitoimistolle käyttöoikeuden Palkkaus.fi-tilin tietoihisi.</p>
    <p>Huomaathan että tämä tarkoittaa että silloin Lemon Treellä on pääsy kaikkiin tietoihin, kuten työntekijöiden tietoihin ja palkkalaskelmiin.</p>
    <p>Voit poistaa käyttöoikeuden milloin vain klikkaamalla alla olevaa vipua.</p>
</fieldset>` }, talousavain: { html: `<fieldset>
    <legend>Talousavain.net</legend>
    <p>Klikkaamalla alleolevaa vipua voit antaa Talousavain.net-tilitoimistolle käyttöoikeuden Palkkaus.fi-tilin tietoihisi.</p>
    <p>Huomaathan että tämä tarkoittaa että silloin Talousavain.netillä on pääsy kaikkiin tietoihin, kuten työntekijöiden tietoihin ja palkkalaskelmiin.</p>
    <p>Voit poistaa käyttöoikeuden milloin vain klikkaamalla alla olevaa vipua.</p>
</fieldset>` }, treamer: { html: `<fieldset>
    <legend>Treamer</legend>
    <p>Pääset Treameriin <a href="https://www.treamer.com/" target="_blank">täältä</a>.</p>
    <p>
        Treamer-palvelu luo uusia palkkalaskelmia ja työntekijöiden tiedot tulevat Treamerista. Treamer-palvelulle ei tällä hetkellä anneta Palkkaus.fi-palvelussa tai muissa palveluissa tekemiäsi laskelmia tai työntekijöiden tietoja, siksi Treamer-palvelulle
        ei tarvitse antaa erillistä oikeutusta.
    </p>
</fieldset>` }, talenom: { html: `<fieldset>
    <legend>Easor App</legend>
 <p>
       Klikkaamalla alla olevaa nappia, voit antaa Easor App -sovellukselle oikeuden palkanmaksun tietoihin. Tämän jälkeen voi käyttää palkanmaksua suoraan Easor App -sovelluksessa. Voit myös poistaa käyttöoikeuden klikkaamalla nappia uudestaan.</p>
</fieldset>` }, makinen: { html: `<fieldset>
    <legend>Yrityspalvelu Pentti Mäkinen Oy</legend>
    <p>Lue lisää <a href="http://www.kirjanpidot.fi/" target="_blank">täältä</a>.</p>
    <p>
       Pentti Mäkisen vuonna 1986 perustama Yrityspalvelu tarjoaa asiakkailleen modernit taloushallinnon työkalut yrityksen talouden seurantaan. Näin asiakkaillemme jää paremmin aikaa keskittyä omaan ydinosaamiseensa.</p>
</fieldset>` }, yhdistysavain: { html: `<fieldset>\r
    <legend>Yhdistysavain</legend>\r
    <p>Klikkaamalla alleolevaa vipua voit antaa Yhdistysavain-tilillesi käyttöoikeuden Palkkaus.fi-tilin tietoihisi.</p>\r
    <p>Huomaathan että tämä tarkoittaa että silloin Yhdistysavain-tililtäsi on pääsy kaikkiin tietoihin, kuten työntekijöiden tietoihin ja palkkalaskelmiin.</p>\r
    <p>Voit poistaa käyttöoikeuden milloin vain klikkaamalla alla olevaa vipua.</p>\r
</fieldset>` } }, CalcUsecase: { showAdditionalInfo: "Näytä lisätietoja", editWorker: "Muokkaa työntekijää", checkAutomaticTaxCard: "Tarkista automaattinen verokortti", recalculate: "Laske uudelleen", reports: "Raportit", usecase: "Käyttötapaus", cancelPayment: "Peruuta maksu", copy: "Kopioi uudeksi", showPaymentInfo: "Näytä maksun tiedot", deleteCalc: "Poista laskelma", selectCalculationType: "Valitse laskelman tyyppi", default: "Oletus" }, CalcComponent: { introWorker: "Voit lähettää valmiin palkkalaskelman työnantajallesi maksettavaksi. Täytä tarvittavat tiedot laskelmalle alla olevalla laskurilla ja jaa laskelma työnantajallesi.", panelWorker: { heading: "1. Työntekijä", overview: { html: "Valitse<br />työntekijä!" }, noSelection: "Työntekijää ei ole valittu" }, panelHouseHold: { heading: "2. Tehtävä työ", overview: { html: "Valitse<br />tehtävä työ" } }, panelWorkTime: { heading: " 2. Palkka- ja työpäivät jne.", overview: { html: "Valitse<br />työpäivät!", salaryDate: "Palkkapäivä", now: "heti", leavesDays: "Lomapäivät", absencesDays: "Palkattomat poissaolot", paidAbsencesDays: "Palkalliset poissaolot", accruedDays: "Kuukaudelle ansaittu loma" } }, panelSalary: { heading: " 3. Palkka" }, panelExpenses: { heading: " 4. Vähennykset, kulut jne.", householdExpense: "Kotitalousvähennys", noHouseholdExpenses: "Ei kotitalousvähennystä" }, versions: { creator: "Tekijä", date: "Päiväys", selectVersion: "Valitse versio", otherRows: "Lisärivit", message: "Lisätiedot" }, getDatesRangeText: "Täytä työn alku- ja loppupäivät!", getUsecaseText: "Täytä työpäivien määrä sekä valitse tehtävä työ!", getUsecaseText2: "Täytä myös työpäivien määrä!", getUsecaseTextNumberOfDays: "päivää", dialog: { showNewTaxcardDialog: "Työntekijää ei ole valittuna tai työntekijällä ei ole henkilötunnusta.", showWorkerEditDialogLoading: "Päivitetään laskelmaa...", sendToProSending: "Lähetetään", sendToProSendingDescr: "Lähetetään palkkalistaa tilitoimistolle.", sendToProMessage: "Viesti yritykseltä: ", sendToProMessageChecked: "Yritys tarkistanut", deleteCalc: "Haluatko varmasti poistaa palkkalaskelman?" }, saveNotAuthenticatedDisplayName: "Rekisteröimätön", workerSectionDefaultInfo: "Oletustiedot", resultSectionCalculation: "Palkkalaskelma" }, EmploymentTaxCardComponent: { active: "Käytössä", waiting: "Uusi työntekijältä", rejected: "Hylätty", replaced: "Korvattu uudella", approveSharedTitle: "Ei jaettua verokorttia", approveSharedText: "Työntekijällä ei ole jaettua verokorttia, jonka voisi hyväksyä / hylätä." }, DatepickerPopupComponent: { placeholder: "p.k.vvvv", placeholderMonths: "kuukautta" }, CalcChartComponent: { createChartEmployer: { seriesLabel: { totalGrossSalary: "Palkka ", salaryAdditions: "Palkan lisät ", allSideCosts: "Sivukulut ", totalExpenses: "Kulut " } }, createChartWorker: { seriesLabel: { salaryPayment: "Työntekijän nettopalkka ", tax: "Ennakonpidätys ", workerSideCosts: "Työntekijän sivukulut ", totalExpenses: "Kulut ja edut " } } }, CalcDetailsExpensesComponent: { advancePayment: { info: "on saatettu jo maksaa ennakkoa. Tällöin tämä osuus vähennetään maksettavasta nettomaksusta.", infoCompensation: "Työkorvauksesta", infoSalary: "Palkasta", title: "Ennakko", titleAlt: "Palkkaennakko" }, benefits: { accomodationBenefit: "Asuntoetu", benefitExpenses: "Verolliset etuudet", mealBenefit: "Ravintoetu", otherBenefit: "Muu etu", phoneBenefit: "Puhelinetu", title: "Luontoisedut", titleAlt: "Edut" }, calcHasNoExpenses: "Laskelmalla ei ole kuluja, etuja tai vähennyksiä.", childCareExpense: { description: "Syötä alle yksityisen hoidon tuen määrä. KELA maksaa yksityisen hoidon tuen suoraan työntekijälle ja tekee siitä osuudesta ennakonpidätykset, sava-maksut jne. lasketaan kuitenkin myös tälle summalle.", label: "Tuen määrä", title: "Yksityisen hoidon tuki" }, compensations: { compensation: "Kulukorvaus", dailyAllowance: { description: "Päivärahaa maksetaan 40 euroa, jos työmatka on yli 10 tuntia. Matkakohde pitää olla 15km päässä joko asunnosta tai varsinaisesta työpaikaasta.", title: "Kokopäiväraha" }, dailyAllowanceHalf: { description: "Päivärahaa maksetaan 19 euroa, jos työmatka on yli 6 tuntia. Matkakohde pitää olla 15km päässä joko asunnosta tai varsinaisesta työpaikaasta.", title: "Osapäiväraha" }, description: "Kulukorvaukset (esim. taksi, tarvikkeet) maksetaan yleensä kuittien perusteella.", mealCompensation: { description: "Ateriakorvauksen voi maksaa työmatkoilta, joilta ei makseta päivärahaa.", title: "Ateriakorvaus" }, milageDaily: { description: "Kilometrikorvaus määritetään monissa TES:ssä - esim. rakennusalallla - päiväkohtaisina summina.", title: "Kilometrikorvaus, päiväkohtainen", titleAlt: "Kilometrikorvaus: Päivät" }, milageOther: { description: "Kilometrikorvaus jollain muulla perusteella.", title: "Kilometrikorvaus, muu peruste", titleAlt: "Muu kilometrikorvaus" }, milageOwnCar: { description: "Kilometrikorvaus oman auton käytöstä.", title: "Kilometrikorvaus, oma auto" }, title: "Kulukorvaukset", toolCompensation: { description: "Työvälinekorvaus on määritetty joissakin työehtosopimuksissa (esim. Raksa TES).", title: "Työvälinekorvaus" } }, deductions: "Vähennykset", deductionsAlt: "Vähennykset, kulut jne.", description: { html: `<div class='calc-detail-empty-row'></div><h3 class='uppercase'>Lisätäänkö kuluja, etuja, tukia, vähennyksiä tms.?</h3><p>Vasemman reunan nappuloista voit lisätä:</p><ul><li>kulukorvauksia</li><li>luontoisetuja</li><li>...sekä tukia, maksuja, vähennyksiä ja muita erikoistapauksia.</li></ul><p>Joistakin työehtosopimuksista - esim. raksa - näitä lasketaan TES:n mukaisesti, kun syötät tiedot kohdassa "Työn kuvaus".</p>`, md: `### Lisätäänkö kuluja, etuja, tukia, vähennyksiä tms.? ###\r
\r
Vasemman reunan nappuloista voit lisätä:\r
* kulukorvauksia\r
* luontoisetuja\r
* ...sekä tukia, maksuja, vähennyksiä ja muita erikoistapauksia.\r
\r
Joistakin työehtosopimuksista - esim. raksa - näitä lasketaan TES:n mukaisesti, kun syötät tiedot kohdassa "Työn kuvaus".` }, employerPays: "Työnantaja maksaa", expenseAndBenefit: "Kulu / luontoisetu", expensesAndBenefits: "Kulut ja luontoisetuudet", foreclosurePayment: { info: "saattaa olla ulosoton alaista. Tällöin ulosoton osuus vähennetään maksettavasta nettomaksusta.", infoCompensation: "Työkorvaus", infoSalary: "Palkka", title: "Ulosotto", titleCustServ: "Ulosotto (aspan lisäämä)" }, householdDeduction: { description: "Työ lasketaan kotitalousvähennykseen.", md: `#### Mistä tiedän kuuluuko työ kotitalousvähennykseen ####\r
\r
Jos olet epävarma, niin [tällä verottajan sivulla](https://www.vero.fi/henkiloasiakkaat/verokortti-ja-veroilmoitus/tulot-ja-vahennykset/kotitalousvahennys/) on kuvattu tarkemmin kotitalousvähennystä. Huomaa alalaidan linkit eri työtyyppeihin.\r
\r
[Tällä toisella sivulla on pitkä lista](https://www.vero.fi/henkiloasiakkaat/verokortti-ja-veroilmoitus/tulot-ja-vahennykset/kotitalousvahennys/taulukko_kysytyimmista_kotitalousvahenn2/) eri töistä.\r
\r
Jos vielä olet epävarma, <a href="mailto:aspa@palkkaus.fi">kysy asiaa asiakaspalvelustamme</a>\r
#### Onko työ kotitalousvähennyksen alaista? ####`, title: "Kotitalousvähennys" }, title: "Lisät/Edut/Tuet", titleAdditions: "Lisät", unionPayment: { description: { html: "Jos työntekijä pyytää, tulee työnantajan vähentää AY-jäsenmaksu ja maksaa se liitolle. <strong>Palkkaus.fi hoitaa AY-maksun suoraan Rakennusliitolle.</strong> Muiden liittojen maksut työnantajan pitää maksaa itse - lisäämme summat vain palkkalaskelmaan." }, descriptionOther: "peritään työntekijältä (työnantaja tilittää itse).", descriptionRaksa: "peritään työntekijältä (Palkkaus.fi tilittää).", label: "AY-jäsenyys", optionNo: "Ei jäsenyyttä", optionOther: "Muu liitto...", optionRaksa: "Rakennusliitto, A-jäsen (1,6%)", optionUnemployment: "Rakennusliitto, OA- tai TA-jäsen (0,60%)", percent: "AY-maksun prosentti", title: "AY-jäsenmaksu", titleShort: "AY-maksu" } }, CalcDetailsSalaryComponent: { workerNotDefined: "Työntekijää ei ole määritetty", compensation: { description: "Työstä, tehtävästä tai palveluksesta maksettu korvaus, joka ei ole palkkaa. Työstä vähennetään ennakonpidätys, mutta ei muita sivukuluja (TyEL, TVR jne.)", title: "Työkorvaus" }, description: { md: `### Paljonko maksetaan palkkaa? ###\r
\r
Palkan voi määrittää eri tavoin:\r
* **Kertakorvaus** - esim. rakennusmiehen urakkapalkka - on yksikertaisin tapaus.\r
* **Kuukausi- tai tuntipalkka**\r
* **Netto- tai kokonais&shy;kustannus&shy;laskurilla** voit laskea palkan käteen maksettavan summan tai kokonaiskustannuksen perusteella.\r
\r
Lisäksi voit määritellä palkasta riippuvaisia <strong>lisiä</strong>, kuten ylitöitä, lomakorvauksia jne.\r
                ` }, mllChildCare: { description: "Tällä lomakkeella voit helposti syöttää MLL:n suositusten mukaisen lastenhoitajan palkan.", title: "MLL:n lastenhoitajan palkka", workDoneOn: "Työ tehdään", workDoneOnSunday: "sunnuntai tai pyhäpäivä (19,00 €/tunti)", workDoneOnWeek: "arkipäiväivänä (9,50 €/tunti)", workHours: "Tuntien määrä (min. 2h)" }, paymentNet: { calculator: "Nettomaksulaskuri", description: "Nettomaksulaskuri laskee palkan sillä perusteella paljonko työntekijälle maksetaan käteen.", title: "Nettopalkka" }, paymentTotal: { description: "Kokonaiskustannuslaskuri laskee palkan sillä perusteella paljonko työnantajan kokonaiskustannus tästä palkanmaksusta olisi kaikkine sivukuluineen.", title: "Kokonaiskustannus" }, reportTitle: "Palkka ja palkan lisät", salaryAdditions: { eveningAdditions: { description: "Nämä lisät vaihtelevat työ- ja tyehtosopimusten mukaan - ne on usein laskettu prosentteina palkasta.", label: "Tyyppi", optionEvening: "Iltavuorolisä", optionNight: "Yövuorolisä", optionSat: "Lauantailisä", title: "Ilta-, yö- ja lauantailisät" }, holidayBonus: "Lomaraha", holidayCompensation: "Lomakorvaus", holidaySalary: "Loma-ajan palkka", otherAddition: "Muu lisä", otherAdditions: "Muut lisät", overtime: "Ylityöt", sundayAddition: "Sunnuntai- / pyhätyö", title: "Palkasta laskettavat lisät", worktimeShortening: "Erillinen palkan osa" }, salaryHourly: { hours: "Tunteja", title: "Tuntipalkka" }, salaryMonthly: { months: "Kuukausia", title: "Kuukausipalkka" }, salarySimple: { description: "Yksinkertaisin palkanmaksun tapaus on kertakorvaus. Esim. kesätyöntekijälle sovitaan maksettavaksi 200 euroa.", salary: "Palkka", title: "Kertakorvaus" }, title: "Palkan yksityiskohdat" }, CalcDetailsWorkComponent: { description: { chooseRole: "Valitse joko yrittäjän palkka tai muu työntekijän palkka. Yrittäjän palkkaa maksaessasi huomaa valinta maksetaanko eläke TyEL vai YEL-vakuutukseen.", chooseTime: "Työn kesto (alku- ja loppupäivämäärät) sekä työpäivien määrä kannattaa syöttää aina palkkalaskelmia varten.", title: "Mitä työtä tehdään?" }, isWorkYel: "Onko palkka YEL:n alaista?", isWorkYelContract: "YEL:n alaista", reportDuration: "Työn kesto", reportTime: "Ajalta", reportTitle: "Työn tiedot", title: "Työn kuvaus", workCleaning: { description: { md: `### Siivous- ja kiinteistöala ###

Siivous- ja kiinteistöalan työehtosopimus (TES) on yleissitova, joten yksityishenkilönkin pitää toimia sen mukaisesti. 
Sitä sovelletaan esim. siivoustöihin ja omakotitalon tai mökin ympäristössä tehtäviin hoitotöihin (esim. lumityöt ja pihan hoito).

Muista määrittää lomakorvaus Vähennykset-osiosta.

Jos työntekijä on sinulla töissä yli 14pv/kk tai yli 35h/kk, niin huomioithan, että hänelle kertyy myös lomapäiviä. 
Työn kokonaishintaan on kuuluttava TESin mukaiset lisät. Myös TESin mukaisia palkkatasoja pitää noudattaa.

TESistä lisää tietoa löydät [tästä linkistä](https://www.palkkaus.fi/abc/siivous-ja-kiinteistoalan-tyoehtosopimus/). 

` }, title: "Siivous ja kodinhoito" }, workConstruction: { labelAgreementUnitPerDay: "Matkakorvaus (€/pv)", labelToolExpense: "Päivittäinen työkalu- ja matkakorvaus", labelToolExpenseTes: "Työkalukorvaus", labelToolUnitPerDay: "Työkalukorvaus (€/pv)", labelTravelExpense: "Matkakorvaus", labelTravelUnitPerDay: "Korvattavat km/pv", optionAgreement: "Erikseen sovitun päiväkorvauksen mukaan", optionCarpenter: "Kirvesmies", optionFloor: "Lattianpäällystys", optionOther: "Muut", optionTesIs: "TES-erät sovittu kokonaiskorvaukseen", optionTesNot: "TES-erät lisätään palkkaan", optionTesTable: "TES-taulukon perusteella", title: "Rakennus- ja remontointi", unitDays: "Työpäivien määrä" }, workDays: "Työpäivien määrä", workDescription: "Työn kuvaus", workEndDate: "Työn loppupäivä", workEndStartDate: "Työ tehty ajalla", workMllChildCare: { md: `### MLL:n lastenhoitaja ###\r
\r
Palkka-kohdassa on erillinen lomake, joka on suunniteltu helpottamaan MLL:n lastenhoidon palkanmaksua yhdelle päivälle.\r
Lue lisää [MLL:n lastenhoidosta täältä](/Cms/Articles/Case_MLL).\r
\r
Jos maksat samalle lastenhoitajalle palkkoja useammalta päivältä, määritä se erikseen kohdasta "Työntekijän palkka", kenttä "Työpäivien määrä".\r
`, title: "MLL:n lastenhoitaja" }, workOtherChildCare: { description: "Pitkäaikainen lastenhoito. Valitessasi tämän TES:n näet Vähennykset-osiossa Yksityisen hoidon tuki-valinnan.", title: "Muu lastenhoito" }, workSantaClaus: { md: `### Palkkaus.fi tarjoaa joulupukin palkanmaksun ###\r
Joulupukin palkanmaksusta Palkkaus.fi ei ota palvelumaksua lainkaan.\r
\r
Oletus on, että joulupukki käy kotona jouluaattona - yhtenä päivänä.\r
\r
Verottajan mukaan joulupukin palkasta ei voi tehdä kotitalousvähennystä. Sorry!\r
`, title: "Joulupukki" }, workStartDate: "Työn alkupäivä", workTes: "Valitse työehtosopimus (TES)", workTyel: "Työntekijän palkka (TyEL)", workYel: "Yrittäjän palkka (YEL)" }, CalcDetailsWorkerComponent: { employmentEdit: "Työsuhteen muokkaus", notLoggedIn: "Et ole kirjautunut palveluun: Laskurin demotilassa voit käyttää esimerkkityöntekijää.", job: "Tehtävä työ:", workDescription: "Kuvaus palkkalaskelmaan", salarySlipMessage: "Viesti työntekijälle", jobType: "Työn tyyppi", reporting: "Raportointi", costCenter: "Kustannuspaikka", addSharedTaxCard: "Lisää jaettu verokortti", editAccount: "Muokkaa omia tietoja", checkTaxcard: "Tarkista verokortti", taxCardChecked: "Verokortti on tarkistettu", checkAutomaticTaxcard: "Tarkista autom. verokortti", newTaxcard: "Uusi verokortti", workerEdit: "Työntekijän muokkaus", resetWorker: "Vaihda toiseen työntekijään...", addWorker: { description: { html: "Jos haluat syöttää sisään <strong>oikean henkilön tiedot</strong> - joko omasi tai jonkun muun - pyydämme sinua <strong>kirjautumaan sisään</strong> ensin sivun oikeasta yläreunasta.<br><br>Tämä on tärkeää tietoturvan ja yksityisyydensuojan takia." }, title: "Lisää työntekijä" }, description: { md: `### Kenelle maksetaan? ###

Valitse työntekijä vasemmalta. Työn&shy;tekijän ikä ja palkan määrä kuukaudessa / vuodessa vaikuttavat sivukuihin.

Vasemmalta voit valita **esimerkki&shy;työntekijän** kokeiluja varten, tai oikean henkilön Palkkaus.fi-palvelusta.

Jos haluat syöttää sisään **oikean henkilön tiedot** - joko omasi tai jonkun muun - pyydämme sinua **kirjautumaan sisään** ensin sivun oikeasta yläreunasta.

Valitse työntekijä vasemman reunan napeista.
` }, exampleWorkers: { description: "Voit valita alta jonkin esimerkkihenkilöistä, voit myöhemmin muuttaa henkilön asetuksia ja ennen kuin palkka maksetaan oikeasti, kysymme työntekijän tietoja.", title: "Esimerkkityöntekijät" }, meWorker: { description: "Tästä voit laittaa määrittää itsesi työntekijäksi. Olennaiset tiedot, kuten ikäsi otetaan omista käyttäjätiedoistasi.", title: "Valitse itsesi" }, myWorkers: { description: { html: "Valitse joku omista työntekijöistäsi. Voit muokata ja luoda uusia työntekijöitä <a href='#/workers/index'>Työntekijälistassa täällä</a>" }, title: "Omat työntekijät" }, newWorker: { cta: "Luo uusi työntekijä", description: "Luo kokonaan uusi työntekijä ja syötä tälle työntekijälle henkilötiedot. Tiedot tallennetaan profiilisi työntekijäluetteloon.", title: "Uusi työntekijä" }, searchWorkers: { description: "Hae henkilö Palkkaus.fi -palveluun rekisteröityneistä työntekijöistä, jotka ovat merkinneet osaajaprofiilinsa julkiseksi.", publicProfile: "Julkinen osaajaprofiili", searchWorker: "Hae työntekijä", title: "Hae Palkkaus.fi -palvelusta" }, selectWorker: "Valitse työntekijä", workerInfo: { ageRange: "Ikäryhmä", name: "Nimi", taxCard: "Verokortti", taxPercent: "Ennakonpidätys", taxPercentExample: { html: "Veroprosentti {{taxPercent}} % on esimerkki. Verokorttia ei ole määritetty." }, title: "Työntekijän tiedot" } }, CalcDetailsWorktimeProComponent: { lead: { text: "Tällä välilehdellä on nähtävissä kaikki poissaolojen ja lomalaskennan parametrit. Tyypillisesti nämä ovat vain tilitoimistojen käyttöön - tavallisen yrityskäyttäjän ei tarvitse niitä muuttaa." }, basicInfo: "Perustiedot", absencesDays: "Palkattomat poissaolot", leavesDays: "Lomapäiviä", leavesDailySalary: "Lomapäivän palkka", workDays: "Työpäivät", monthlyOrWeeklySalary: "Kuukausi- tai viikkopalkka", monthlySalary: "Kuukausipalkka", absencesDaySalary: "Poissaolopäivän vähennys / pv", isHourlySalary: "Tunti- tai suoritusperusteinen", hourlySalary: "Tunti- tai suoritusperuste", hourlyLabel: "Kyllä", holidayCompensation: "Lomakorvaus", yearlyLeaveDays: "Lomapäiviä vuodessa", totalHolidaySalary: "Loma-ajan palkka", alreadyPaid: "Jo maksettu", holidays: "Lomakertymät", headerMonth: "Kuukausi", headerHolidays: "Kertymä", headerAway: "Pois", headerDate: "Pv", headerHours: "h", holidayCalculationNotInUse: "Lomalaskenta ei käytössä", holidayYearSettings: "Lomavuoden asetukset", employmentPeriod: "Työsuhteen kesto", wageBasis: "Palkan peruste", holidayCode: "Loman kertyminen", accrualFixed: "Kiinteä lomakertymä", compensation: "Lomakorvaus", bonusMethod: "Lomarahan maksu", bonus: "Lomaraha" }, CalcDetailsDialogComponent: { workType: "Työn tyyppi (vähennyksen peruste)", allSalaries: { title: "Palkka / palkkio ja lisät" }, allExpenses: { title: "Kulut, luontoisedut ja vähennykset" }, expenses: { title: "Kulukorvaukset", intro: "Kulukorvauksista ei lähtökohtaisesti makseta veroja tai sivukuluja. Useat kulukorvaukset pitää kuitenkin ilmoittaa verottajalle (esim. kilometrikorvaukset ja päivärahat)." }, benefits: { title: "Luontoisedut", title2: "Verolliset etuudet (luontoisedut)", intro: "Luontoisetuja verotetaan käytännössä samalla tavalla kuin tavallista palkkaa, joka otetaan huomioon työntekijän verotuksessa ja joiden verotusarvot verottaja päättää vuosittain." }, deductions: { householdDetuction: "Kotitalousvähennys", label: "Kyllä, ilmoitetaan kotitalousvähennykseen", title: "Vähennykset", intro: "Palkasta voidaan tehdä erilaisia vähennyksiä. Huomioithan, että voit tehdä korkeintaan nettopalkan suuruisen vähennyksen." }, salaries: { title: "Palkat, lisät ja lomat", title2: "Palkka tai palkkio", intro: "Valitse palkkalaji, jota olet maksamassa työntekijällesi. Varsinaisen palkan lisäksi voit valita erilaisia lisiä, kuten ylityöt, lomakorvaukset ja lomarahat." }, all: { title: "Valitse palkkalaji" } }, CalcEditorComponent: { title: "Laskelman muokkaus", workerTitle: "Työntekijä", employerTitle: "Omat tiedot", paymentInfo: { title: "Maksun tiedot", salaryDateLabel: "Palkkapäivä", paymentDateLabel: "Maksupäivä", salaryPeriodLabel: "Palkkakausi", workDaysLabel: "Työpäiviä", paymentChannel: "Maksumenetelmä", status: "Tila" }, messages: { title: "Viestit ja kuvaukset", occupationTypeLabel: "Työn tyyppi", workDescriptionLabel: "Kuvaus palkkalaskelmaan", salarySlipMessageLabel: "Viesti työntekijälle" }, householdDeduction: { title: "Kotitalousvähennys", noDeduction: "Ei kotitalousvähennystä", deductionCategory: { select: "Valitse työn tyyppi...", none: "Ei valintaa", householdwork: "Kotitaloustyö", carework: "Hoiva- ja hoitotyö", homeImprovement: "Asunnon/loma-asunnon kunnossapito- tai korjaustyö", oilHeatingReplacementWork: "Öljylämmityksestä luopuminen" }, deductionProperty: { select: "Valitse työn sijainti...", none: "Ei valintaa", ownProperty: "Omassa käytössä oleva asunto tai vapaa-ajan asunto", relativesProperty: "Vanhempien, isovanhempien yms. käytössä oleva asunto tai vapaa-ajan asunto" } }, calcRowsTitle: "Laskelman rivit", originalHeading: "Alkuperäinen", editedHeading: "Muokattu", diffHeading: "Eroraportti", diffAccountingHeading: "Kirjanpidon erot", diffCfa: "Asiakasmaksujen erot" }, CalcEmploymentComponent: { dialog: { workerAccountIdChangedTitle: "Haetaan tietoja", workerAccountIdChangedDescr: "Haetaan työntekijän tietoja..." } }, CalcListComponent: { checked: "Tarkastettu", issues: "Huomiot", allCalculations: "Kaikki laskelmat", notSelected: "(Työntekijää ei ole valittu)", payment: "Maksu", salary: "Palkka", tax: "Vero", tyel: "TYEL", net: "Netto", total: "Yhteensä", salaryPeriod: "Palkkakausi", worktime: "Lomat ja poissaolot", status: { title: "Tila", draft: "Luonnos", paid: "Maksettu", paymentStarted: "Maksu aloitettu", sharedWaiting: "Odottaa käsittelyä", sharedRejected: "Hylätty", sharedApproved: "Hyväksytty" }, payrollService: "Palkkapalvelu", selfService: "Itsepalvelu", date: "Pvm", search: "Tekstihaku", calculation: "Laskelma", payroll: "Palkkalista", selectedAmount: "Valittu", select: "Valitse", unselect: "Poista valinta", statusIsPaid: "Maksettu", statusIsSketch: "Luonnos", worker: "Työntekijä", intro: { html: `Työntekijäsi voi kirjautua Palkkaus.fi-palveluun ja lähettää yrityksellesi palkkalaskelman maksettavaksi.\r
Näin voit luoda prosessin, jossa työntekijäsi kirjaa itse tuntinsa ja esim. kilometrikorvaukset. <b> Tarkista laskelmien oikeellisuus ennen niiden maksamista.</b>` }, panel: { paid: { heading: "Maksetut" }, draft: { heading: "Luonnokset" }, all: { heading: "Kaikki laskelmat" }, paymentStarted: { heading: "Maksu aloitettu" }, sent: { heading: "Lähetetyt" }, sentAndDraft: { heading: "Lähetetyt ja luonnokset" }, received: { heading: "Vastaanotetut" }, shared: { heading: "Vastaanotetut" } } }, CalculationsPanelComponent: { showFilters: "Näytä suodattimet", newCalc: "Uusi laskelma", status: "Tila", accepted: "Hyväksytty", declined: "Hylätty", waiting: "Odottaa", sent: "Lähetetty", draft: "Luonnos", showWholeList: "Näytä koko lista", sentAlt: "Lähetetyt", drafts: "Luonnokset", allPaid: "Kaikki maksetut", allSent: "Kaikki lähetetyt", allDrafts: "Kaikki luonnokset" }, CalculationsSentComponent: { noEmployee: "Ei työnantajaa", waitingForAcception: "Odottaa hyväksyntää", declined: "Hylätty", accepted: "Hyväksytty" }, CalculationsSharedComponent: { waitingForHandling: "Odottaa käsittelyä", accepted: "Hyväksytty", declined: "Hylätty" }, CalculationsWithSalaryDateSelectComponent: { salaryDate: "Palkkapäivä", start: "Aloitus", end: "Lopetus" }, CalcNewIntroComponent: { instruction: "Klikkaa yläreunan laatikoita yksi kerrallaan käydäksesi askeleet läpi.", stepFour: { description: "... ja vähennykset.", title: "Kulut, edut,..." }, stepOne: { description: "Tilinumero, verokortti ja henkilötiedot.", title: "Kenelle maksetaan?" }, stepThree: { description: "Myös lomat ja palkan lisät.", title: "Paljonko palkkaa?" }, stepTwo: { description: "Palkkajakso, työpäivät, lomat ja poissaolot.", title: "Miltä ajalta?" }, title: "Palkkalaskelman tekemisessä on neljä askelta" }, CalcResultsComponent: { calculation: "Laskelma", calculationSalary: "Palkkalaskelma", employerReport: "Työnantajan laskelma", finalCost: "Lopullinen kustannus", html: "Palkkaus.fi-palvelulle <strong>maksettava summa on {{totalPayment}}€.</strong> Palvelu tilittää sivukulut eteenpäin ja tekee tulorekisteri-ilmoitukset. Nettopalkka tilittyy työntekijälle 2-4 pankkipäivässä tai valitsemanasi palkkapäivänä.", isPaidDate: "Tämä palkkalaskelma on maksettu", nowPaying: "Maksetaan nyt", societyReport: "Yhteiskunnan laskelma", totalCost: "Kokonaiskustannus", workerGetsPaid: "Työntekijälle maksetaan", workerReport: "Työntekijän laskelma", sharedWaiting: "Odottaa käsittelyä", sharedWaitingInfo: "Voit maksaa palkkalaskelman hyväksyttyäsi sen.", sharedApproved: "Hyväksytty laskelma", sharedRejected: "Hylätty laskelma", sharedRejectedInfo: "Voit poistaa laskelman tai hyväksyä ja maksaa", payrollDraft: "Palkka on osa palkkalistaa.", payrollDraftInfo: 'Tämä palkka on osa palkkalistaa ja se maksetaan ja tallennetaan palkkalistan yhteydessä. Laskelman voi irroittaa palkkalistasta ("Irroita linkitys"), jos haluat maksaa sen erillisenä.', waitingApproval: "Tarkista laskelma", waitingApprovalInfo: "Tarkista laskelman tiedot, tee tarvittavat muutokset ja lähetä laskelma maksuun tilitoimistollesi.", sendToProBtn: "Tarkistettu: Lähetä", draft: "Luonnoslaskelma", draftInfo: "Vie palkka maksuun painamalla alla olevaa Maksa-nappia.", paymentStarted: "Tämä palkka on siirretty maksuun", paymentStartedInfo: "Jos et vienyt palkanmaksua loppuun, voit jatkaa maksua tästä.", paymentCanceled: "Tämä palkka on peruttu", paymentRefunded: "Tämä palkka on peruttu", paymentError: "Maksettaessa tapahtui virhe", paymentChannelText: "Tämä palkka on siirretty maksuun", showPaymentDialog: "Näytä maksun tiedot", cancelPaymentOrChangeChannelBtn: "Peru maksu tai vaihda maksutapaa", paymentChannelTextPartial: "maksutapa", cancelDialogTitle: "Peru maksuun siirto", cancelDialogDescr: "Maksun tila  muutetaan luonnokseksi ja laskelmaan mahdollisesti liittyvät laskut perutaan. Voit maksaa palkan myös uudella maksutavalla.", cancelDialogYes: "Kyllä, peru maksuun siirto", cancelDialogNo: "Ei", messageToAccountant: "Viesti tilitoimistoon", otherActions: "Muut toiminnot", sendEmployeeEmail: "Lähetä viesti työnantajalle", time: "Ajasta", prints: "Tulosteet", status: "Tila" }, CalcReportsComponent: { reportType: "Tyyppi", reportLanguage: "Kieli", reportLanguageWorker: "Oletus (Työntekijä)", reportLanguageCompany: "Oletus (Yritys)", reportViewPartial: "Vain taulukko", reportViewPage1: "Ensimmäinen sivu", reportViewFull: "Koko raportti", calcReports: "Laskelman raportit", irRows: "Tulorekisteririvit", irFull: "Palkkatietoilmoitus", rowsReport: "Rivilistaus", showDownloadDialog: { waitHeading: "Odota..", readyHeading: "Valmis!", waitText: "Tiedostoa luodaan.", readyText: "Tiedosto on nyt valmis ladattavaksi.", openText: "Avaa" } }, CalcReportComponent: { palkkausFeeInfo: "Huom: Tämä laskelma ei sisällä palvelumaksuja ja todellinen työnantajan TyEL-prosentti saattaa poiketa käytetystä." }, SummaryReportComponent: { summaryReport: "Yhteenvetoraportti", loadingReport: "Ladataan raporttia" }, CalcSharingComponent: { backBtn: "Palaa laskelmalle", intro: { html: "Voit jakaa valmiin palkkalaskelman työnantajallesi suoraan ohjelman sisällä tai lähettämällä linkin laskelmaan esimerkiksi sähköpostitse. Maksaakseen palkan, työnantajasi tulee rekisteröityä käyttäjäksi.</a>" }, sharing: { title: "Palkkalaskelman linkin jakaminen", description: "Voit luoda linkin palkkalaskelmaan ja jakaa sen sähköpostilla tai muulla sovelluksella (WhatsApp, tekstiviesti).", createLinkBtn: "Luo palkkalaskelman linkki jakamista varten" }, select: { title: "Valitse työnantaja", description: "Työnantajalistassa näkyvät vain ne työnantajat, jotka ovat lisänneet sinut omiin työntekijöihinsä. Valitsemalla työnantajan, laskelma lähetetetään hänelle. Jos työnantajasi ei ole listassa, voit pyytää häntä lisäämään sinut omiin työntekijöihinsä." }, sharingTargets: { email: "Sähköposti", device: "Jaa laitteessasi" }, emailSendSuccess: "Sähköpostiviesti on nyt lähetetty onnistuneesti työnantajalle", emailSent: "Sähköpostiviesti on nyt lähetetty työnantajalle", sharingMessage: { calculationSent: "Olen lähettänyt sinulle palkkalaskelman", login: "Kirjaudu sisään palveluun linkin kautta" }, sharingTitle: "Uusi palkkalaskelma", missingSignatureAlert: { missingSignature: "Valtakirjan allekirjoitus puuttuu", finishAccountCreation: "Ennen kuin jaat palkkalaskelman, sinun täytyy viedä tilin luonti loppuun asti", signAuthorization: "ja allekirjoittaa valtakirja", continueToSigning: "Jatka allekirjoitukseen (vaatii pankkitunnukset)", continue: "Jatka", close: "Sulje" }, missingTaxCardAlert: { heading: "Jaettu verokortti puuttuu", text: "Laskelman linkkiä ei voi lähettää ilman jaettua verokorttia. Lisää jaettu verokortti." } }, CalcSharingInfoComponent: { sharedViaLink: "Laskelmalle on luotu linkki", sharedViaEmail: "Lähetetty sähköpostilla:", shareToEmployer: "Lähetä linkki työnantajalle käyttämällä alapuolella olevia painikkeita.", linkCopied: "Kopioitu", deleteLinkBtn: "Poista linkki", cancelDeliveryBtn: "Peruuta lähetys", paidDate: "Tämä palkkalaskelma on maksettu", statusText: { workerRequestAccepted: "Laskelma on lähetetty työnantajalle ja hyväksytty", workerRequestDeclined: "Laskelma on lähetetty työnantajalle ja hylätty", workerRequested: "Laskelma on lähetetty suoraan työnantajallesi ja odottaa hyväksyntää", workerRequestedAlt: "Laskelma on lähetetty työnantajallesi" }, sendToEmployerBtn: "Lähetä työnantajalle", copyToClipBoard: "Kopioi työpöydälle" }, CalcSharingReceiptActionComponent: { approveBtn: "Hyväksy", approveBtnTitle: "Hyväksy laskelma. Voit hyväksymisen jälkeen maksaa laskelman.", rejectBtn: "Hylkää", rejectBtnTitle: "Hylkää laskelma. Hylättyä laskelmaa ei poisteta automaattisesti, ja voit vielä myöhemmin hyväksyä sen tai poistaa kokonaan.", alertUnknown: "Error: Unknown action for sharing" }, CalcWorktimeComponent: { salaryDateTitle: "Palkkapäivä", salaryDateDescription: { html: " Päivä, jolloin palkka on työntekijän tilillä. Tyhjä päivä tarkoittaa <strong>heti</strong>: Käytännössä 0-4 päivää maksutavasta riippuen." }, salaryDateLabel: "Palkkapäivä", salaryDatePlaceholder: "Heti: 1-3 päivää maksusta", worktime: { title: "Milloin työ tehdään?", description: "Valitse palkkakausi ja työpäivien määrä kaudella. Tarkat alku- ja loppupäivät voi antaa, kun valitsee Muu periodi.", periodShortcut: { label: "Palkkakausi", labelDaysCount: "Työpäiviä kaudella", labelWorkDaysCount: "Työpäivien määrä", labelStartDate: "Alkupäivä", labelStartAndEndDate: "Alku- ja loppupäivät" } }, absences: { title: "Lomat ja poissaolot", descriptionNoWorker: "Kun valitset laskelmalle työntekijän ja palkkajakson, haemme tähän ko. periodin lomat ja poissaolot.", descriptionNoWorkerAnonTodo: "Kun valitset laskelmalle työntekijän ja palkkajakson, palvelu hakee työntekijän tietoihin ko. palkkakaudelle talletetut lomat lomapalkan laskentaa varten.\r", descriptionNoPeriod: "Kun valitset työn päivämäärät, haemme tähän ko. periodin lomat poissaolot.", loadingText: "Ladataan lomia ja poissaoloja.", calculationTabHeading: "Laskelma", calculationLegend: "Tässä palkassa maksettavat lomat ja poissaolot", calculationDescription: "Palkasta vähennettävät poissaolot:", calculationDescriptionUndefined: { html: "<strong>Lomalaskenta ei ole käytössä:</strong> Lisää lomat tarvittaessa riveinä Palkat-kohdassa." }, calculationDescriptionNoHolidays: "Työntekijällä ei ole lomaoikeutta.", calculationDescriptionHolidayCompensation: "Lomakorvausta lisätään:", calculationDescriptionHolidayBonus: "lomaraha:", calculationDescriptionNoHolidayBonus: "Ei erillistä lomarahaa.", calculationDescriptionLeavesDays: "Pidetyt / maksettavat lomapäivät:", link: "Lomaa kerryttämättömät poissaolot", absencesTabHeading: "Poissaolot", absencesAttention: "HUOM: Yhteensä-summat näyttävät koko periodin. Jos periodi katkeaa kesken palkkakauden, se huomioidaan vasta varsinaisessa laskennassa.", leavesTabHeading: "Lomat", calculateButtonText: "Laske lomat ja poissaolot palkkoihin", proTabTitle: "Lisätoiminnot tilitoimistoille" }, holidays: { headerHolidays: "Lomakertymät", headerDays: "Päivät" }, anonDemoText: { html: "<strong>HUOM:</strong> Anonyymi demoversio, data tyhjentyy, kun vaihdat periodia." }, periodStartDateErrorFormat: "Syötä muodossa 'pv.kk.'", periodStartDateErrorNotDate: " ei ole päivämäärä.", submitWorktimeTitle: "Lasketaan ajanjaksoa", getAccrualMonthText: { permanent14Days: "Lomia kertyy kalenterikuukaudelle, jos työpäiviä vähintään 14 päivää. Korjaa tarvittaessa työntekijätietoihin palkanmaksun jälkeen.", permanent35Hours: "Lomia kertyy kalenterikuukaudelle, jos työtunteja vähintään 35. Korjaa tarvittaessa työntekijätietoihin palkanmaksun jälkeen.", temporaryTimeOff: "Lomia kertyy kalenterikuukaudelle aina 2 päivää.", other: "Kertymä päivitetään käsin tai integraatiolla toisesta järjestelmästä.", default: "Ei lomakertymää (#err)" }, lists: { details: { lead: "Muokkaa laskelmalla maksettavia lomia ja lomarahoja. Muutokset eivät vaikuta suunniteltuihin lomiin." }, absencePeriods: { absencesDailySalary: "Poissaolon päiväpalkka", noAbsences: "Ei poissaoloja kuluvalle palkkakaudelle", absencesToUse: "Poissaolot tässä laskelmassa", absenceTime: "Poissaoloaika", absencesToReject: "Ajanjakson poissaolot", cause: "Syy" }, annualLeaves: { summerHoliday: "Kesäloma", winterHoliday: "Talviloma", noAnnualLeaves: "Ei vuosilomia kuluvalle palkkakaudelle", bonuses: "Lomarahat", holidaySalariesAndCompensations: "Lomat (vuosilomapalkat ja lomakorvaukset)", accrualRemaining: "Käytettävissä olevat lomat", paidInThisSalary: "Maksetaan tässä palkassa", newAccrualRemaining: "Jäljelle jäävä kertymä", plannedHolidays: "Suunnitellut lomat", days: "Päiviä", bonusDays: "Päiviä (Lomaraha)", holidayPeriod: "Loma-aika", startDate: "Alku", endDate: "Loppu" } }, availableHolidays: { legend: "Käytettävissä olevat lomat", holidayPayAccrualRemaining: "Vuosilomapalkkaa/lomakorvausta maksamatta (pv)", holidayBonusAccrualRemaining: "Lomarahaa maksamatta (pv)" } }, AbsencePeriodsComponent: { selectWorker: "Työntekijää / poissaoloja ei ole valittu...", headerDays: "Päivät", headerAbsence: "Poissaolot", isPaid: "Palkallinen.", notPaid: "Ei palkkaa.", isAccrual: "Työssäolon veroinen.", notAccrual: "Ei työssäolon veroinen.", noAbsences: "Ei poissaoloja", noAbsencesDescription: "Poissaolokirjanpitoon voit listata muut poissaolot: palkattomat ja palkalliset. Tänne voit listata myös palkattomat lomat / vapaat.", noAbsencesDescription2: "Palkattomien poissaolojen päivät otetaan huomioon kuukausipalkan maksun yhteydessä ja ehdotettaessa lomapäivien kertymää.", totalPaid: "Yhteensä, palkalliset", totalUnpaid: "Yhteensä, palkattomat", totalNoHolidayAccrual: "Yhteensä, lomakertymää vähentävät", totalAll: "Yhteensä, kaikki", addAbsenceButtonText: "Lisää poissaolo", wholeAbsence: "Koko poissaolo", periodDaysCount: { html: "Palkattomat palkkakaudelle<br /> Lomakertymää vähentää" } }, AbsencePeriodsEditDialog: { panelHeading: "Muokkaa poissaoloa", label: { causeCode: "Syy", startDate: "Alku", endDate: "Loppu", workDays: "Työpäivät", daysCount: "Päivien määrä", isPaid: "Palkallinen", isPaidLabelTrue: "Poissaolo on palkallinen", isAccrual: "Lomakertymät", isAccrualLabelTrue: "Työssäolon veroista aikaa lomapäivien kertymää laskettaessa", notes: "Huomiot" }, saveButtonText: "Tallenna", cancelButtonText: "Peruuta", deleteButtonText: "Poista", editDatesButtonText: "Muokkaa" }, WorkerAbsencesComponent: { legend: "Poissaolot", legendInstructions: "Poissaolojen kirjaaminen", instructions: { html: `<p> Palkattomat poissaolot vähentävät kuukausipalkan määrää automaattisesti. Tuntipalkkojen osalta sinun tulee huomioida poissaolot suoraan tunneissa.
</p>
<p>
Pitkät poissaolot vaikuttavat myös lomalaskentaan, jos käytössä on 14 päivän lomapäivien kertymissääntö.
</p>
<p>
Lisäksi poissaolojen tietoja saatetaan tarvita viranomaisraportointiin, palkkatodistuksiin ja esim. työttömyyskassoille.
</p>` }, addButtonText: "Lisää poissaolo", calendarButtonText: "Kalenteri", listButtonText: "Lista" }, AbsencesComponent: { first: "Ensimmäinen", lastest: "Viimeisin", salaried: "Palkalliset", unpaid: "Palkattomat", absence: "poissaoloa", day: "päivää", error: "Virhe: Ei työsuhdetta", d: "pv", pce: "kpl" }, HolidayYearComponent: { dialog: { creatingYearHolidays: "Luodaan lomavuosia...", loadingDefaults: "Haetaan oletuksia...", notToSave: "Ei tallennettavaa", nothingHaveChanged: "Mikään tietueista ei ole muuttunut", saving: "Tallennetaan", record: "tietuetta" }, planned: "Suunnitellut", date: "pv", accumulation: "kertymä", dateYear: "pv (koko vuosi)", holiday: "Loma", days: "päivää" }, WorkerAbsencesCrudComponent: { absencesPaid: "Palkallisia", absencesUnpaid: "palkattomia", days: "päivää", notToSave: "Ei tallennettavaa", nothingHaveChanged: "Mikään tietueista ei ole muuttunut", saving: "Tallennetaan", record: "tietuetta", workerAndAbsenceList: "Työntekijä on jo poissaololistassa", worker: "Työntekijä", workerExistOnList: "on jo poissaolojen listassa. Valitse työntekijät uudestaan" }, HolidayYearAccrualComponent: { accumulated: "Kertyneet", futureEstimate: "Arvio tulevasta", holidayAccrualSource: { manual: "Muokattu käsin", calcDraft: "Palkkalaskelma (luonnos)", calcPaid: "Maksettu palkka", defaultThisMonth: "Kuluva kuukausi", defaultEstimate: "Arvio tulevasta (lomavuoden luonti)", default: "Lomavuoden luonnista" } }, HolidayPayReportQueryComponent: { calculationsTab: "Palkkalaskelmat", calculation: "Palkkalaskelma", description: "Selite", count: "Määrä", price: "Hinta", toHolidayPay: "Vuosilomapalkkaan", toWorkingHours: "Työtunteihin", toOvertimeHours: "Ylityötunteihin", workingDays: "Työpäivät", absenceDays: "Poissaolopäivät", holidayPaySelection: "Vuosilomapalkan poiminta", workingHoursSelection: "Työtuntien poiminta", overtimeHoursSelection: "Ylityötuntien poiminta", total: "Yhteensä", parametersTab: "Rivityypit ja kertoimet", holidayPayRowTypes: "Vuosilomapalkan poiminnan rivityypit", workingHoursRowTypes: "Työtuntien poiminnan rivityypit", overtimeHoursRowTypes: "Ylityötuntien poiminnan rivityypit", accrualWorkingTimeRowTypes: "Työaikakertymän rivityypit" }, HolidayReportComponent: { info: { html: "Lomalaskentaraportti toimii apuna työntekijöiden lomakertymien seurannassa. <br/>Haetut raportit voidaan tallentaa Exceliin ja käyttää niitä loma-ajan palkkojen laskennassa.<br/>Raportilla näkyvät maksetut palkkalaskelmat valitulta ajanjaksolta palkkapäivän mukaisesti.<br/>Mukana ovat ne työntekijät, joilla on käytössä Lomakirjanpito ja -laskenta.<br/>Raportin kertymätietoihin vaikuttavat työntekijän työsuhdetiedot, oletuspalkkariveihin tallennetut kuukausi- tai tuntipalkkatiedot, Lomat-osioon kirjatut tiedot ja palkkalaskelmilla käytetyt palkkarivit." }, title: "Lomalaskentaraportti", holidayYear: "Lomavuosi", holidayYears: "Lomavuodet", holidayPayDebt: "Lomapalkkavelka", holidayPayDebtDate: "Päivämäärä", calculateHolidayPayDebt: "Laske lomapalkkavelka", yearAccruedDebt: "Lomapalkkavelka lomavuodelle", allAccruedDebt: "Kaikkien lomavuosien lomapalkkavelka", exportToExcel: "Vie Exceliin", noNeededDataFound: "Yritykseltä ei löytynyt tarvittavia tietoja raportin luomiseen", employeeNoHolidays: "Työnantajalla ei ole tallennettuja lomavuosia", salaryPaymentMonths: "Palkanmaksu kuukaudet", salaryPaymentWorkingHours: "Työtunnit", accrualReport: "Kertymäraportti", accrualReportInfo: "Palkkalaskelmat haettu ajalta", irIncomeTypeReport: "Tulo- ja palkkalajiraportti", irIncomeTypeReportInfo: "Palkkalaskelmat haettu ajalta", salaryPaymentReport: "Palkanmaksujen erittely", salaryPaymentReportInfo: "Palkkalaskelmat haettu ajalta", accrualReportNotUsableInfo: "Kertymäraportti ei ole käytettävissä kun valittu kausi ei ole lomavuosi", holidayYearReportRow: { startSaldo: "Aikaisempien kausien kertymä", total: "Lomavuoden kertymä", paid: "Käytetty (Maksettu)", available: "Jäljellä (Maksamatta)", holidaySalary: "Maksetut loma-ajan palkat", holidayCompensation: "Maksetut lomakorvaukset", paidBonus: "Käytetty (Maksettu) lomarahaa", availableBonus: "Jäljellä (Maksamatta) lomarahaa", holidayBonus: "Maksetut lomarahat", holidayPayDailySalary: "Lomapäivän palkka", totalAccruedHolidayPay: "Kertyneet lomapalkat ja lomakorvaukset", totalAccruedHolidayBonus: "Kertyneet lomarahat", totalAccruedHolidaySocialSecurity: "Kertyneet lomapalkkojen sairausvakuutusmaksut", totalAccruedHolidayPension: "Kertyneet lomapalkkojen eläkemaksut", totalAccruedHolidayUnemployment: "Kertyneet lomapalkkojen työttömyysvakuutusmaksut", totalAccruedHolidayAccidentInsurance: "Kertyneet lomapalkkojen työtapaturma- ja ammattitautivakuutusmaksut", totalAccruedHolidayGroupLifeInsurance: "Kertyneet lomapalkkojen ryhmähenkivakuutusmaksut", totalAccruedHolidayTotal: "Kertyneet yhteensä" }, table: { startDate: "Aloituspäivä", endDate: "Lopetuspäivä", employment: "Työsuhde", holidayCode: "Loman kertyminen", holidayPayCalculation: "Vuosilomapalkan laskentatapa", salary: "Palkka", monthlySalariesTotal: "Kuukausipalkat yhteensä", monthlyCount: "Kuukaudet", averageMonthlySalary: "Keskimääräinen kuukausipalkka", hourlySalariesTotal: "Tuntipalkat yhteensä", hourCount: "Tunnit", averageHourlySalary: "Keskimääräinen tuntipalkka", previousPeriodAccrual: "Aikaisempien kausien kertymä", currentPeriodAccrual: "Lomavuoden kertymä", currentPeriodUsedAccrual: "Käytetty (Maksettu)", currentPeriodAvailableAccrual: "Jäljellä (Maksamatta)", currentPeriodPaidHolidayBonus: "Maksetut lomarahat", currentPeriodPaidHolidaySalary: "Maksetut loma-ajan palkat", currentPeriodPaidHolidayCompensation: "Maksetut lomakorvaukset", nextPeriodAccrual: "Seuraavalla lomanmääräytymisvuodella kertyneet", periodDefaultAccrual: "Kertymä/kk" }, modal: { title: "Valitse kausi", periodLabel: "Kausi", holidayYear: "Lomavuosi", custom: "Muu aikaväli", periodDateKindLabel: "Kauden määräytyminen", selectHolidayYear: "Valitse lomavuosi", startDateCustomLabel: "Valitse kauden aloituspäivä", endDateCustomLabel: "Valitse kauden päättymispäivä" } }, WorkerHolidaysComponent: { alert: { undefined: "VIRHE: Lomalaskennan tyyppiä ei ole määritetty.", holidayCompensationIncluded: "VIRHE: Tätä lomalaskennan tyyppiä ei tueta: holidayCompensationIncluded." }, InitDialog: { panelHeading: "Lomakirjanpito ja -laskenta", intro: "Ota lomakirjanpito käyttöön valitsemalla sääntö lomien kertymiselle ja lomarahan maksamiselle", alert: { html: `<strong>HUOM:</strong> Tämä käyttöliittymä poistaa muokkaukset lomakertymiin ja luo ne uudestaan.\r
          <strong>Tarkista siis lomakertymät tämän jälkeen!</strong>` }, legendSelectHolidayType: "Lomapäivien kertymisen ja laskennan perusta", label: { permanent14Days: { html: `<strong>Vähintään 14 päivää kuukaudessa.</strong><br />\r
Työtä tehdään kaikkina kuukausina vähintään 14 pv/kk.` }, permanent35Hours: { html: `<strong>Vähintään 35 tuntia kuukaudessa.</strong><br />
Ainakin yhtenä kuukautena vuodessa tehdään vähintään 35 tuntia työtä.` }, holidayCompensation: { html: ` <strong>Lomakorvaus palkanmaksun yhteydessä.</strong><br />\r
  Lomapäiviä ei kerrytetä vaan lomakorvaus maksetaan heti palkan yhteydessä.` }, temporaryTimeOff: { html: `<strong>Vapaan ansaintasääntö.</strong><br />\r
Työntekijä ei kuulu 14 päivän tai 35 tunnin säännön piiriin, mutta saa pidetyltä vapaalta lomakorvauksen.` }, holidayCompensationIncluded: { html: `<strong>Lomakorvaus osa kokonaispalkkaa.</strong><br />\r
Lomia ei kerrytetä, vaan lomakorvaus on sovittu osaksi kokonaispalkkaa. Tämä on mahdollista vain poikkeustilanteissa, lähinnä kotitalouksilla.` }, noHolidays: { html: `<strong>Ei lomaoikeutta.</strong><br />
Palkan tai korvauksen saajalla ei ole lomaoikeutta.` }, other: { html: `<strong>Manuaalinen.</strong><br />\r
Kertymä päivitetään käsin tai integraatiolla toisesta järjestelmästä.` }, accrualByLaw: "Kertymä", accrualByLawLabelTrue: "Lomalain mukaan: 2 tai 2,5 pv/kk (riippuen työsuhteen pituudesta).", accrualByLawLabelTrue2: "Lomalain mukaan 2 pv/kk", accrualFixed: "Päivää / kuukausi", compensation: "Lomakorvaus", bonusMethod: "Lomarahan maksu", bonusMethodNone: "Ei erillistä lomarahaa.", bonusMethodPayForHolidaySalary: "Erillinen lomaraha", bonusPercent: "Lomaraha, prosenttia", wageBasis: "Palkkaustapa (työsuhteessa)", holidayPayCalculationReport: "Vuosilomapalkan laskentaraportti", calculationReport: "Laskentaraportti" }, moreInfo: { html: ` Voit tutustua esimerkkeihin
<a href="https://www.palkkaus.fi/abc/loma-ajan-palkka-ja-lomalaskenta/" target="_blank">täällä</a>.` }, legendDetails: "Lomalaskennan yksityiskohdat", submitButtonText: "Ota lomakirjanpito käyttöön" }, undefined: { title: "Lomakirjanpito ja -laskenta", intro: "Tuomme kevään aikana asteittain paljon kysytyn lomakirjanpidon ja -laskennan osaksi palvelua. Tavoitteenamme on tehdä markkinoiden helppokäyttöisin palvelu lomien ja poissaolojen kirjaamiseen ja maksamiseen.", subtitleLeft: "Tässä versiossa", introLeft: `<li>Lomapäivien kertyminen</li>
<li>Lomakirjanpito</li>
<li>Lomapäivien maksaminen kuukausipalkkalaisille</li>
<li>Lomarahat</li>`, subtitleRight: "Tulevat ominaisuudet", introRight: `<li>Lomapäivien maksaminen tunti- ja urakkapalkoista</li>\r
<li>Keskituntiansion laskeminen</li>\r
<li>Lomakorvauksen erikoistilanteet</li>\r
<li>Kesä- ja talvilomalistat (monelle työntekijälle)</li>`, showInitHolidaysButtonText: "Ota käyttöön tälle työntekijälle" }, noHolidays: { legend: "Ei lomaoikeutta, lomavuosi", intro: "Työsuhteen / lomavuoden tietoihin on merkitty, ettei tällä työntekijällä ole lomaoikeutta.", intro2: "Jos haluat muuttaa työntekijä lomakäsittelyn, ", introShowInitHolidays: "luo lomakirjanpito uudestaan" }, holidayCompensation: { overview: { legend: "Lomakorvaus palkanmaksun yhteydessä ", legendYear: "lomavuosi", intro: "Työntekijän / lomavuoden tiedoissa on merkitty, että työntekijän lomat maksetaan suoraan jokaisen palkanmaksun yhteydessä. Tämä on tyypillistä tilapäisillä työntekijöillä.", intro2: "Palkkalaskuri lisää lomakorvauksen ja -rahan prosentteina bruttopalkasta:", introCompensation: "Lomakorvaus:", introBonus: "Lomaraha:", introNoBonus: "Ei lomarahaa tai lomaraha osa lomakorvauksen kokonaisprosenttia", introUseCalendar: { html: `<strong>Voit halutessasi käyttää lomakalenteria</strong><br />
<small>
Yleensä tällaisilla tilapäisillä työntekijöillä ei ole varsinaista lomaa.
Lomakalenteriin voit kuitenkin halutessasi syöttää milloin henkilö on poissa loma-aikaan.
Kalenteri ei vaikuta palkanmaksuun.</small>` } } }, accrual: { overview: { legend: "Yleiskuva, lomavuosi", introTitle: "Lomien kirjaaminen ja maksaminen:", introList: { html: `<strong>Tarkista lomapäivien kertymä</strong><br /> Tarkista, kuinka monta lomapäivää työntekijälläsi on käytettävissä edelliseltä lomanmääräytymisvuodelta. Jos sitä edeltävältä vuodelta on käyttämättömiä lomia, voit lisätä ne alkusaldoksi
                    samassa yhteydessä.` }, introList2: { html: "<strong>Suunnittele ja kirjaa kesä- ja talvilomat</strong><br /> Lisäämällä pidettävät lomat lomakalenteriin etukäteen, sinun on helppo maksaa loma-ajan palkka ja lomarahat kyseisten palkkakausien palkanmaksun yhteydessä." }, introList3: { html: "<strong>Laske vuosilomapalkka</strong><br /> Tuntipalkkalaisten osalta vuosilomapalkka lasketaan edellisen vuoden ansioden perusteella. Tämä tulee tehdä, kun lomanmääräytymisvuosi on päättynyt (huhtikuussa)." }, introList4: { html: "<strong>Maksa loma-ajan palkka ja lomaraha</strong><br /> Palkanmaksun yhteydessä palvelu hakee automaattisesti valitulle palkkakaudelle suunnitellut lomat ja ehdottaa niitä laskelmalle. Tarvittaessa muutoksia voi tehdä myös palkanlaskennan yhteydessä ja tiedot tallentuvat lomakirjanpitoon." } }, paidSalaries: { legend: "Maksetut lomat", description: "Lista pidetyistä (ja maksetuista) tai korvatuista lomista sekä lomarahoista.", descriptionList: { html: `<li><strong>Lomapalkka</strong> (Loma-ajan palkka) maksetaan, kun lomapäivät pidetään (oletus).</li>\r
<li><strong>Lomakorvaus</strong> maksetaan, jos lomia ei voida pitää esim. työsuhteen päättyessä.</li>\r
<li><strong>Lomaraha</strong> maksetaan joka tapauksessa. Usein kaikki kesäloman yhteydessä.</li>` } }, accrualHolidays: { legend: "Lomapäivien kertymä", description: "Lomapäivien kertymä lomanmääräytymisvuodelta", description2: "Lomat pidetään seuraavana lomakautena" }, hourlySalaries: { legend: "Vuosilomapalkka ajalta", description: "Tunti- ja suorituspalkkaiselle vuosilomapalkka lasketaan pääsääntöisesti kolmella eri menetelmällä:", descriptionList: { html: `<li>
<strong>Prosenttipohjaisena:</strong> 35h-säännön alaisille (ainakin osa kuukausista alle 14 työpäivää), jos TES ei muuta määrää 9% tai 11,5% (työsuhde yli alle vuoden). Joissain työehtosopimuksissa myös muita prosentteja.
 </li>
<li>
<strong>Keskipäiväpalkka:</strong> 14 päivän säännön alaisille lomalain mukaan, jos TES ei muuta määrää.
</li>
<li>
<strong>Keskituntiansion mukaan </strong> Erityisesti SAK:n ja EK:n välisen lomapalkkasopimuksen mukaan, mutta käytössä yhä useammassa työehtosopimuksessa. Työehtosopimuskohtaisia taulukoita.
</li>` }, description2: "Seuraavissa versioissa tuomme laskentaan erilaisia työkaluja. Tässä versiossa vuosilomapalkka on laskettava esim. Excelissä. Asiakaspalvelumme tai tilitoimistosi auttaa sinua mielellään." } }, HolidayYearPaid: { tableHead: { paidHolidays: "Maksetut lomat", holidaysCount: "Lomapäiviä", holidaySalary: "Lomapalkka", compensation: "Lomakorvaus", bonus: "Lomaraha" } }, HolidayYearHolidays: { tableHead: { period: "Lomajakso", daysCount: "Päivät", bonusDaysCount: "Päivät (lomaraha)" }, tableBody: { availableHolidays: "Käytettävissä olevat", availableHolidaysMore: "Päättyneellä lomanmääräytymisvuodella kertyneet lomat", total: "Yhteensä", totalMore: "Palkkakaudelle osuvat lomat", total2: "Yhteensä", total2More: "Lomavuodelle suunnitellut lomat.", unusedHolidays: "Sunnittelemattomat lomat", unusedHolidaysMore: "Lomapäivät, jotka tulee suunnitella tai maksaa lomakorvauksena.", noHolidaysTitle: "Ei suunniteltuja lomia", noHolidaysDescription: ` Lomakalenterissa voit suunnitella vuoden lomat. 
 Syötetyt lomat otetaan automaattisesti huomioon, kun maksat kuukausi- tai tuntipalkkaa.`, noHolidaysDescription2: `Menneet lomat voit halutessasi myös kirjata lomakirjanpitoon.\r
Siellä ne säilyvät tallessa lain vaatiman säilytysajan.`, addFirstHolidayButtonText: "Lisää ensimmäinen loma" }, addHolidayButtonText: "Lisää loma" }, HolidayYearHolidaysEditDialog: { panelHeading: "Muokkaa lomaa", labelStartDate: "Alku", labelEndDate: "Loppu", labelHolidaysCount: "Lomapäivät", editDatesButtonText: "Muokkaa", labelDescription: "Huomiot", dialogHeading: "Loman lisääminen", dialogText: "Oletko varma, että haluat sijoittaa loman yleisen lomakauden ulkopuolelle?" }, HolidayYearAccrual: { tableHead: { month: "Kuukausi", daysCount: "Päiviä" }, tableBody: { startSaldo: "Alkusaldo", startSaldoMore: "Edelliseltä vuodelta", daysAccruedLabel: "kertymä", daysAccrued: "Kertyneet lomapäivät", total: "Yhteensä", estimatedHolidaysNexYear: "Arvio ensi vuoden lomapäivistä" } }, HolidayYearPaidEditDialog: { panelHeading: "Muokkaa pidettyä / maksettua lomaa", kind: "Maksun tyyppi", undefined: { labelAnnualLeavePaymentKind: "Valitse maksun tyyppi:" }, manualSalary: { title: "Korjaus loma-ajan palkkaan", description: "Loma-ajan palkka, joka on maksettu Palkkaus.fi-palvelun ulkopuolella tai halutaan muuten korjata käsin.", labelPaidAt: "Maksupäivä", labelStartDate: "Loman alku", labelEndDate: "Loman loppu", labelDaysCount: "Laskennallinen päivien määrä", labelUsedHolidays: "Käytetyt lomapäivät", labelHolidaySalary: "Loma-ajan palkka", labelBonus: "Lomaraha", labelDescription: "Huomiot" }, manualCompensation: { title: "Korjaus lomakorvauksiin", description: "Lomakorvaus, joka on maksettu Palkkaus.fi-palvelun ulkopuolella tai halutaan muuten korjata käsin.", labelPaidAt: "Maksupäivä", labelStartDate: "Loman alku", labelEndDate: "Loman loppu", labelDaysCount: "Laskennallinen päivien määrä", labelPaidHolidays: "Maksetut lomapäivät", labelCompensation: "Lomakorvaus", labelBonus: "Lomaraha", labelDescription: "Huomiot" }, manualBonus: { title: "Korjaus lomarahoihin", description: "Lomaraha, joka on maksettu Palkkaus.fi-palvelun ulkopuolella tai halutaan muuten korjata käsin.", labelPaidAt: "Maksupäivä", labelBonus: "Lomaraha", labelDescription: "Huomiot" }, paidCalc: { title: "Maksettu palkkalaskelma", description: "Liitä Palkkaus.fi-palvelussa jo maksettu palkka lomakirjanpitoon. Samalla voit lisätä palkkalaskelmaan lomalaskennan tietoja, joita palkkalaskelmalla ei alunperin ollut.", labelPaidHolidays: "Maksetut lomapäivät", labelHolidaySalary: "Loma-ajan palkka", labelCompensation: "Lomakorvaus", labelBonus: "Lomaraha" }, draftCalc: { title: "Palkkalaskelman luonnos", description: "Liitä palkkalaskelman luonnos lomakirjanpitoon. Tätä käytetään lähinnä testauksessa, sillä järjestelmä liittää kaikki uudet maksettavat palkat automaattisesti lomakirjanpitoon, jos lomakirjanpito on otettu käyttöön", labelPaidHolidays: "Maksetut lomapäivät", labelHolidaySalary: "Loma-ajan palkka", labelCompensation: "Lomakorvaus", labelBonus: "Lomaraha" } }, UI: { buttonSummer: "Kesä", buttonWinter: "Talvi", buttonAll: "Muokkaa / kaikki lomat", calendarTitle: "Lomakalenteri", summerHolidaysTitle: "Kesälomat", winterHolidaysTitle: "Talvilomat", dropdown: { selectedYear: "Lomavuosi", selectYear: "Valitse vuosi", showInitHolidays: "Luo lomakirjanpito uudestaan" }, sidebar: { buttonOverview: "Yleiskuva", buttonHolidays: "Lomakalenteri", buttonAccrual: "Lomapäivien kertymä", buttonHourlySalaries: "Laske vuosilomapalkka", buttonPaidHolidays: "Maksetut lomat", buttonSettings: "Asetukset", info: "Tiedot: ", periodSelectedYear: "Kesä- ja talvilomakausi:", periodDefaultAccrual: "Lomapäiviä per kk:", compensation: "Lomakorvaus:", bonus: "Lomaraha:", periodAccrual: "Lomanmääräytymisvuosi:" }, inputs: { type: "Tyyppi", multiplier: "Kerroin", days: "Päiviä", incomeType: "Tulolaji", rowType: "Rivin päätyyppi", wageType: "Palkkalaji", exclusive: "Poissulkeva", unit: "Yksikkö", typeNotSupported: "Tyyppiä ei tueta" } } }, HolidaysComponent: { holidayType: { html: "Lomatyyppi<br /> Lomaraha" }, year: "Vuosi", holidays: { html: "Lomat<br /> Kertymä" }, error: "Virhe: Ei työsuhdetta" }, HouseHoldYearsComponent: { year: "Vuosi", answer: "Vastaus", latestSaving: "Viimeisin tallennus", backOfficeStatus: "Käsittelyn tila" }, CertificatesComponent: { name: "Nimi", id: "Id", title: "Varmenteet", newCertificate: "Uusi varmenne" }, CertificateAddComponent: { title: "Uusi sertifikaatti", createdSertificate: "Luotu sertifikaatti", createSertificate: "Luo sertifikaatti", base64: "BASE64-enkoodattu", downloadBase64: "Lataa sertifikaatti tiedostona", copyBase64: "Kopioi BASE64-enkoodattu sertifikaatti", html: `<legend>Sertifikaatti</legend>\r
    <p>\r
        Voit luoda uuden sertifikaatin syöttämällä nimen ja salasanan, ja painamalla "Luo sertifikaatti"-nappia. Salasanalla suojataan muodostuva sertifikaattitiedosto (vain .pfx).\r
    </p>\r
    <p>\r
        <b>HUOM:</b> Ota sertifikaattitiedoston (vain .pfx) suojaava salasana talteen, emme tallenna sitä palveluun.\r
    </p>\r
    <p>Sertifikaatin luonti kestää hetken, odota kunnes sertifikaatti on valmis ja kopioi sertifikaatin tiedot omalle koneellesi.</p>\r
\r
    <p>\r
        <b>HUOM:</b> Älä sulje dialogia, ennen kuin olet kopioinut sertifikaatin tiedot. Emme tallenna sertifikaattia palveluumme.\r
    </p>`, password: "Salasana", format: { pfx: "Windows-sertifikaatti (pfx / pkcs12)", pem: "Yleinen sertifikaatti (zip / pem)" } }, CmsArticleComponent: { author: "Kirjoittaja", date: "päiväys" }, ContractComponent: { additionalInfo: "Muut tiedot", annualLeave: "Vuosiloma", collectiveContract: "Sovellettava työehtosopimus", createNew: "Luo uusi sopimus", employmentRelationship: "Työsuhteen tyyppi", employmentRelationshipAlt: "Työsuhde ja kuvaus", worker: "Työntekijä", fullTime: "Toistaiseksi voimassaoleva", fullTimeInfo: 'HUOM: sinulla pitää olla voimassa lakisääteinen tapaturmavakuutus. Voit ottaa sen Palkkaus.fi:n kautta menemällä ylävalikosta kohtaan "3. Vakuutus ". Sinulla tulisi olla myös työeläkevakuutussopimus työeläkeyhtiön kanssa.', hoursPerDay: "Tuntia/vuorokaudessa", hoursPerThreeWeeks: "3 viikon jaksossa", hoursPerTwoWeeks: "2 viikon jaksossa", hoursPerWeek: "Tuntia/viikkossa", infoEmployer: "Työnantajan tiedot", job: "Kertaluonteinen työ", mainWorkAssignment: "Pääasialliset työtehtävät", noticePeriod: "Irtisaomisaika", noticePeriodAssignment: "Irtisanomisaika määräytyy", other: "Muut", otherTerms: "Muut sopimusehdot", parties: "Osapuolet", partTime: "Määräaikainen", payDays: "Palkanmaksupäivät", preview: "Esikatselu", probationM: "Koeaika (kk)", salaryAmount: "Palkan määrä", salaryBasis: "Palkan määräytymisen peruste", salaryOther: "Muu palkka", salarySimple: "Työstä maksettava kertakorvaus", timeAndPayment: "Työaika ja palkanmaksu", timeAndSalary: "Aika ja palkka", TODO: "This translation is not ready", workAssignment: "Työtehtävät", workEndDate: "Työsuhde päättyy", workEndDateAlt: "Loppupäivä", workPeriod: "Työajan jakso", workStartDate: "Työsuhde alkaa", workStartDateAlt: "Aloituspäivä", workTime: "Työaika" }, CredentialsComponent: { title: "Käyttäjätunnukset", intro: "Infoteksti", userId: "Käyttäjätunnus", authenticationMethod: "Kirjautumistapa", firstName: "Etunimi", lastName: "Sukunimi", email: "Sähköposti", telephone: "Puhelinnumero", avatar: { label: "Kuvan tyyppi", optionChoose: "Valitse kuvan tyyppi", optionIcon: "Kuvake", optionUploaded: "Kuva omalta koneelta", optionGravatar: "Gravatar", gravatarInfo: { html: "Gravatar-kuva on linkitetty sähköpostiosoitteeseen ja sähköpostiosoitteen omistaja voi itse vaihtaa kuvan osoitteessa www.gravatar.com. Sitä käytetään myös monissa muissa palveluissa: blogeissa, keskustelufoorumeilla jne." }, labelInitials: "Nimikirjaimet", labelColor: "Väri", labelUploadImage: "Lataa kuva koneelta", uploadImage: { html: "Klikkaa tästä ja lataa kuva<br>(maks. 10MB)<br />" } }, color: { brown: "Ruskea", lime: "Lime", darkGreen: "Tummanvihreä", pink: "Pinkki" } }, CreditTransferComponent: { receiverIban: { html: "Saajan<br>tilinumero<br>Mottagarens<br>kontonummer" }, receiver: { html: "Saaja<br>Mottagare" }, payerInfo: { html: "Maksajan<br>nimi ja<br>osoite<br>Betalarens<br>namn och<br>adress</div>" }, creditTransfer: "TILISIIRTO. GIRERING", signature: { html: "Allekirjoitus<br>Underskrift" }, fromAccount: { html: "Tililtä nro<br>Från konto nr" }, iban: "IBAN", refNumber: { html: " Viitenumero<br>Ref. nr" }, dueDate: { html: "Eräpäivä<br>Förfallodag" }, euro: "Euro", transferDescription: "Huomaa, että alla olevasta tekstikentästä voit myös kopioida viivakoodin useimpiin verkkopankkeihin, joten sinun ei tarvitse syöttää maksun tietoja.", barcodeLabel: "Viivakoodi verkkopankkiin" }, CurrentTaxCardComponent: { salaryDate: "Maksupäivä", addSSNumber: "Nähdäksesi tai syöttääksesi verokortin, lisää henkilötunnus työntekijän tietoihin.", addTaxCard: "Lisää verokortti", searchTaxCard: "Hae verokortti", chooseNoTaxCard: "Ei verokorttia, 60% ennakonpidätys", incomeLimit: "Tuloraja", incomeLimit2: "Tuloraja, euroa", incomeLimitSpan: "...ylittävä %", loading: "Ladataan...", mainTaxPercent: "Perusprosentti", mainTaxPercent2: "Ennakonpidätysprosentti", mainTaxPercent3: "Ennakonpidätys (%)", newTaxCard: "Uusi verokortti", noTaxCardAdded: "Työntekijän verokorttia ei ole määritetty. Syötä verokortti tai valitse työsuhteessa käytettäväksi verokortiksi automaattinen verokortti, jolloin verokortin tiedot haetaan verottajalta automaattisesti palkanmaksun yhteydessä, eikä verokorttia tarvitse erikseen käsin syöttää.", noTaxCardAddedWorker: "Jos työnantajasi on yritys, toimita verokortti työnantajalle, joka lisää sen palveluun. Voit lisätä verokorttisi tiedot tästä, jos työnantajasi on kotitalous.", previousSalaries: "Palkat vuoden alusta", previousSalariesForTaxCard: { label: "Tälle verokortille aiemmin maksetut palkat, €", tooltip: "Tällä verokortille jo aiemmin maksamasi palkat. Summa voi olla nolla, jos et vielä ole tälle kortille mitään maksanut." }, progressPreview: "Muodostetaan esikatselua...", salariesPaid: "Palkkoja maksettu", stepsTaxCardInfo: "Portaikkoverokortin tulorajat vuonna 2017", taxCardAsFile: "Verokortti tiedostona", taxCardExpiration: "Verokortti vanhenee kuun lopussa", taxCardExpired: "Työntekijän aiempi verokortti on vanhentunut, joten työntekijälle ei voida maksaa palkkaa.", taxPercent2: { html: "<b>Lisäprosentti</b><br /> (tulorajan jälkeen)", name: "Lisäprosentti", nameAlt: "Perus-/Lisäprosentti" }, taxPercentMin: { title: "Minimiprosentti" }, uploadError: "Tiedoston lataamisessa tapahtui virhe.", uploadErrorFormat: "Valitsemasi tiedosto ei ole kuva tai pdf.", uploadErrorLarge: "Valitsemasi tiedoston koko on yli sallitun 10MB.", uploadErrorSmall: "Valitsemasi tiedoston koko on alle sallitun 5KB.", uploadTaxCard: { html: "Klikkaa tästä ja lataa verokortti palveluun<br>(pdf tai kuva, maks. 10MB)<br />" }, validDate: "Voimassa", validFromDate: "Voimaantulopäivä", validFromDate2: "Voimassa alkaen", validTillDate: "...asti", validFromDateACard: "Voimassaolopäivä tai työsuhteen alkamispäivä (valitse näistä myöhäisempi)", year: "Vuosi", yearlyIncomeLimit: "Vuosituloraja", yearlyIncomeLimitACard: "Laskennallinen tuloraja ATK-järjestelmää varten", yearlyIncomeLimitBCard: "Tuloraja", detailsInfo: { loadedByWorker: { html: "<strong>Työntekijän lataama verokortti</strong>" }, noFileUploaded: "Ei liitetiedostoa, pyydä verokortti nähtäväksesi työntekijältä.", auto: "Tämä verokortti on tarkistettu verottajan uudesta ennakonpidätysrajapinnasta. Tarkistamme tiedot jokaisen palkanmaksun yhteydessä: Sinun ei itse tarvitse tarkistaa verokorttia." }, taxCardKind: "Verokortin tyyppi", selectCardKind: "Valitse verokortin tyyppi", inJanuary: "Tammikuussa:", inPalkkaus: "Palkkaus.fi-palvelussa", beforeIncomeLimit: "Jäljellä ennen tulorajaa", taxCardAdded: "Lisätty", noIncomeLimit: "Ei tulorajaa / lisäprosenttia", after: "jälkeen", edit: "Muokkaa...", basicPercent: "Perusprosentti", newTaxCardTitle: "Verokortin tiedot", taxCardChecked: "Verokortti on tarkistettu", checkAutomaticTaxCard: "Tarkista autom. verokortti", noTaxCard: { description: "Ellei työnantajalla ole käytettävissään maksuvuoden verokorttitietoja, pidätys toimitetaan 60 %:n suuruisena" }, noWithholdingHousehold: { description: "Kun yksityinen henkilö tai kuolinpesä maksaa palkkaa alle 1500 € vuodessa, ennakonpidätys tarvitsee suorittaa vain jos työntekijä näin pyytää. Jos aiot maksat yhdelle työntekijälle vuoden aikana enemmän kuin 1500 € vuodessa, sinun tulee valita toinen verokortti." }, fileUploadRequired: "Verokortin lataaminen on pakollista, jotta työnantaja voi tarkistaa verokortin ennen palkan maksamista. ", customerServiceHelp: "Kysy verokortin tyypin valinnasta asiakaspalvelustamme", exampleTaxCardFileTitle: "Syötä nämä tiedot", commitDiffBtn: "Tallenna laskelmat", commitDiffNote: "HUOM: Työntekijälle maksetut laskelmat verokortin ajalta eroavat verokorttiin merkittyistä laskelmista. Voit päivittää muuttuneet", noPersonalIdError: "VIRHE: Uuden verokortin lisääminen vaatii henkilötunnuksen.", changePaymentDate: "Vaihda maksupäivää", taxCards: { worker: "Työntekijä", year: "Vuosi", valid: "Voimassa", invalid: "..loppu", paid: "Maksettu", incomeLimit: "Tuloraja", ssNumberAlt: "Henkilötunnus", unknown: "tuntematon", taxPercentAdditional: "Lisäprosentti:", taxCardDetails: { downloaded: "ladattu", enterThisInformation: "Syötä nämä tiedot", changeThisDate: "TODAY: Vaihda tämä päivä", incomeType: { label: "Verokortin tulolaji", value: "Palkkaa", tooltip: { html: "Alkuvaiheessa käytössä on vain palkkalaji 'Palkkaa' (24). Jos työntekijällä on erillinen verokortti esim. käyttökorvaukseen, työkorvaukseen tai kertatuloon, se tulee syöttää käsin." } }, automaticTaxcard: { legend: "Automaattinen verokortin haku", mainTaxPercentApi: "Palkkaus.fi-palvelussa on nyt käytössä verottajan Ennakonpidätys-rajapinta.", taxPercentInfoText: { html: "<p>Veroprosentit tarkistetaan automattisesti suoraan verottajalta jokaisen palkanmaksun yhteydessä, eikä sinun tarvitse enää syöttää verokortin tietoja.</p><p class='text-danger' sxy-if-role='test'><strong>HUOM:</strong> Valitse tämä verokortti vain henkilöille, joille aiot maksaa palkkaa (ei testityöntekijöille).</p><p>Verokortin haku näkyy työntekijälle ja verotietojen hakeminen ilman aietta palkanmaksuun loukkaa henkilön yksityisyyden suojaa.</p><p>Alkuvaiheessa käytössä on vain palkkalaji 'Palkkaa'. Jos työntekijällä on erillinen verokortti esim. käyttökorvaukseen, työkorvaukseen tai kertatuloon, se tulee syöttää käsin.</p><p class='strong'>HUOM: Automaattinen verokortti on suositeltu tapa hoitaa verokorttirumba uusille työntekijöille. Voit erikoistilanteissa syöttää myös verokortin tiedot erikseen.</p>" } } } }, previousSalariesRow: "Muualla maksetut palkat (verokortin lisäys).", saveCheckDiffSaving: "Tallennetaan laskelmia...", taxcardKindOptions: { auto: "Automaattinen verokortti", defaultYearly: "Alkuperäinen verokortti", replacement: "Muutosverokortti", noTaxCard: "Ei verokorttia (60%)", noWithholdingHousehold: "Ei ennakonpidätystä: Kotitalous alle 1500€" }, uploadTaxCardAlertDescr: "Tiedoston tallennus palvelimelle epäonnistui." }, TaxCardIncomeLogComponent: { addedForTaxCard: "Verokortille kirjattu", salaryPeriod: "Palkkakausi", mainTaxPercent: "Ennakonpidätys", salaryAmount: "Palkkasumma", calculation: "Laskelma", removedCalc: "Poistettu laskelma", newCalcPopover: "Tätä laskelmaa ei ole tallennettu verokortille.", newCalcBtn: "Uusi!", taxCardChangedPopover: "Verokortille tallennettu tieto, laskelman tieto on alla.", taxCardChangedBtn: "Muutos: Verokortilla", calcChangedPopover: "Laskelman tieto: Päivitä tämä verokorttiin klikkaamalla 'Tallenna laskelmat'.", calcChangedBtn: "Muutos: Laskelmalla", calcRemovedPopover: "Tämä laskelma on poistettu, mutta se on edelleen verokortilla.", calcRemovedBtn: "Poistettu laskelma", noCalcsTitle: "Ei maksettuja palkkoja", noCalcsDescription: "Verokortille ei ole merkitty maksettuja palkkoja.", totalTaxes: "Ennakonpidätys, yhteensä", totalIncome: "Palkkasumma, yhteensä", addRow: "Lisää rivi" }, TaxCardIncomeLogEditDialogComponent: { title: "Muokkaa verokortille maksettua palkkaa", incomeType: "Maksun tyyppi", paymentDate: "Maksupäivä", periodStart: "Palkkakauden alku", periodEnd: "...loppu", tax: "Ennakonpidätys", taxableIncome: "Ennakonpidätyksen alainen tulo", calcId: "Laskelman ID", notes: "Huomautuksia" }, ExamplePersons: { example17: "Laura Lukiolainen", exampleDefault: "Erkki Esimerkki", examplePensioner: "Tanja Eläkeläinen" }, GeneralCalcDetailLabels: { abbrDays: "pv", calculation: "Laskelma", calculationSalary: "Palkkalaskelma", description: "Kuvaus", descriptionMilage: "Matkan kuvaus", lessThan: "alle", moreThan: "Yli", optionalDetail: "Mahdollinen lisäselvitys", pension: "Työeläkemaksu", price: "Hinta", salaryAmount: "Rahapalkka", salaryTotalGross: "Bruttopalkka", sum: "Summa", total: "Yhteensä", tyel: "TYEL", unitCurrency: "Euroa", unitCurrencyAlt: "euroa", unitPrice: "A-hinta", unitPriceDays: "Korvaus per päivä", unitPriceMilage: "€ / km", units: "Määrä", unitsDays: "Päivien määrä", unitsDaysAlt: "päivää", unitsMilage: "Kilometriä", yel: "YEL" }, GenericOnboardingComponent: { modalTitle: "Tilin luonti", roleTitle: "Mihin käytät Palkkaus.fi-palvelua?", roleCompany: "Yrityksen tai yhdistyksen palkanmaksuun", roleWorker: "Työntekijänä", launchBtn: "Aloita tilin luonti" }, LoginButtonComponent: { authenticating: "Tunnistus käynnissä...", companyType1: "Yhdistyksen", companyType2: "Yrityksen", info: "tiedot", searching: "Haetaan...", userInfo: "Käyttäjän tiedot", accountSettings: "Tilin tiedot", authAndCerti: "Valtuutukset", paymentChannel: "Maksukanava" }, PaymentCancelDialogComponent: { paymentCancelled: "Maksu keskeytettiin", paymentCancelledBank: "Palkanmaksu on keskeytetty verkkopankissa." }, PaymentChannelSelectComponent: { exportDefinition: "Viennin määrittely", targetChannel: "Kohde / kanava" }, PaymentChannelSettingsComponent: { title: "Käytössä olevat maksutavat", settingsBtn: "Asetukset", defaultChannel: "(oletus)", addNewTitle: "Lisää uusi maksutapa", addBtn: "Lisää", notAvailableTitle: "Ei valittavissa", test: "Testi", notAvailableText: "Nämä maksutavat eivät ole käytössä nykyisessä ympäristössäsi tai kumppanitilitoimistollasi. Esim. Holvi, Finago Solo, Easor App ovat käytössä vain kyseisissä palveluissa." }, PaymentConfirmDialogComponent: { paymentConfirmed: "Palkka on maksettu", paymentConfirmedInfo: "Palkanmaksu on nyt hoidettu. Työntekijän nettopalkka tilittyy työntekijän tilille 2-4 pankkipäivän kuluessa tai valitsemanasi palkkapäivänä. Palvelu tekee automaattisesti tarvittavat tulorekisteri-ilmoitukset ja tilittää maksut eteenpäin." }, PaymentDialogComponent: { afterPayment: { html: "Kun olet maksanut kokonaissumman <strong>{{totalPayment}}</strong>, työntekijälle maksetaan nettopalkka ja hänelle lähetetään tieto palkkalaskelmasta. Voit myös itse tulostaa sen palvelusta. Palkkaus.fi tekee palkkaan liittyvät ilmoitukset ja maksut yo. tahoille." }, alert: { html: " <span class='text-danger'>Et voi vielä maksaa palkkalaskelmaa, koska työntekijän tiedot ovat puutteelliset.</span><span>Tarkempia tietoja alla.</span>" }, childCare: "Jatkuva lastenhoitaja ja siihen liittyvät tuet", cleaning: "Siivous-ja kiinteistöalan työ", construction: "Työtä rakennusalan työehtosopimuksen mukaan", entrepreneur: "Yrittäjän oma palkka", giveTaxCardType: "Ilmoita verokortin tyyppi!", household: { html: "Palveluun talletettuihin työnantajan laskelmiin on merkitty mukaan <strong>kotitalousvähennyksen</strong> osuus <strong>{{householdDeduction}}</strong>. Saat palvelusta yhteenvetoraportin kotitalousvähennykseen oikeuttavista palkanmaksuistasi verotusta varten." }, info: "Olet maksamassa palkkaa Palkkaus.fi-palvelun kautta.", instructions: "Tarkista alla olevat tiedot ja jatka pankkien maksupalveluun.", checkPayment: "Tarkista alla olevat tiedot.", label: "palkan maksaminen", title: "Palkan maksaminen", changeMethod: "Vaihda maksutapaa", mll: "MLL:n lastenhoitajan palkka", noEmail: "Ei sähköpostiosoitetta!", noEmailInfo: "Työntekijälle ei voida lähettää ilmoitusta palkanmaksusta sähköpostitse.", noIban: "Ei tilinumeroa", noIbanInfo: "Syötä työntekijän tilinumero ennen maksamista!", noSSNumber: "Ei henkilötunnusta!", noTaxPercent: "Ei veroprosenttia!", notDefined: "Työehtosopimusta tai suositusta ei ole määritetty", noTel: "Ei puhelinnumeroa", other: "Muu työ - ei työehtosopimusta", santaClaus: "Joulupukin kotikäynti jouluaattona", nullPaymentAlert: "Huom! Maksun yhteissumma on nolla. Maksu kuitataan välittömästi ja laskelmat siirtyvät maksettu-tilaan, kun siirryt maksamaan. Tulorekisteriraportointi tehdään Palkkaus.fi:n toimesta." }, NewPaymentComponent: { method: { transfer: "Tilisiirtolomake", einvoice: "Verkkolasku", test: "Testimaksu", paytrail: "Verkkopankkimaksu" }, creditTransfer: { transferDescription: "Huomaa, että alla olevasta tekstikentästä voit myös kopioida viivakoodin useimpiin verkkopankkeihin, joten sinun ei tarvitse syöttää maksun tietoja.", barcodeLabel: "Viivakoodi verkkopankkiin", title: "Tilisiirto viitenumerolla", description: "Voit maksaa palkan viitteellisellä tilisiirrolla Suomen Palkanlaskenta Oy:n asiakasvaratilille.", instruction: 'Luo viitenumeron ja pankkiyhteystiedot sisältävä tilisiirtolomake palkanmaksua varten painamalla "Luo tilisiirtolomake" -nappia.', transferCreate: "Luo tilisiirtolomake", mainContent: "Palkanmaksu Suomen Palkanlaskenta Oy:n asiakasvaratilille.", paymentPerWorkerTable: { total: "Yhteensä:", palkkausFee: "josta Palkkaus.fi-palvelumaksu (sis. alv):" }, securePrint: "Tulosta ilman henkilötietoja", calcsBreakdown: "Erittely laskelmittain", worker: "Työntekijä", totalGrossSalary: "Bruttopalkka", payNow: "Maksetaan nyt", paymentTable: "Maksutaulukko" }, selectPaymentMethod: "Valitse maksutapa", paytrail: { title: "Verkkopankkimaksu", description: "Verkkopankkimaksamiseen liittyvän maksunvälityspalvelun toteuttaa Paytrail Oyj (2122839-7) yhteistyössä suomalaisten pankkien ja luottolaitosten kanssa.", startPayment: "Aloita verkkomaksaminen" }, einvoice: { title: "Tarkista vastaanottajan tiedot ja lähetä lasku", description: "Lasku välitetään annettuun verkkolaskuosoitteeseen", receiverLabel: "Verkkolaskuosoite", intermediatorLabel: "Välittäjä" }, selection: { title: "Valitse maksutapa", description: "Jos haluat käyttää samaa verkkopankkimaksua kuin ennenkin, klikkaa", description2: "Voit aina vaihtaa maksutapaa myöhemmin tämän sivun yläkulmassa olevasta nappulasta.", link: `Verkkopankkimaksu (Paytrail)
`, paytrailTitle: `Verkkopankkimaksu (Paytrail).
`, paytrailDescription: "Verkkopankkimaksamiseen liittyvän maksunvälityspalvelun toteuttaa Paytrail Oyj (2122839-7) yhteistyössä suomalaisten pankkien ja luottolaitosten kanssa.", creditTransferTitle: "Tilisiirto viitenumerolla", creditTransferDescription: "Voit maksaa palkan viitteellisellä tilisiirrolla Suomen Palkanlaskenta Oy:n asiakasvaratilille.", einvoiceTitle: "Verkkolasku", einvoiceDescription: "Lähetä maksu verkkolaskuna." }, siirto: { title: "Siirto-maksu", description: `Nordean Siirto –sovellus hyödyntää Automatian ylläpitämää Siirto-maksujärjestelmää, johon myös muut pankit ja maksupalvelutarjoajat kytkeytyvät. Maksu näkyy vastaanottajalla välittömästi pankista riippumatta. Siirto –sovelluksella voidaan maksaa vain suomalaisille Siirto-maksujärjestelmässä mukana oleville pankkitileille.\r
`, instruction: "Syötä Siirto-sovellukseen liitetty puhelinnumerosi ja klikkaa Lähetä maksupyyntö. Käy hyväksymässä maksupyyntö Siirto-mobiilisovelluksessa.", notice: `HUOM: Nettopalkan saapuminen työntekijän tilille kestää 1-2 pankkipäivää maksusta. Maksunvälitysaika riippuu käytettävästä pankista.
`, giveNumber: "Syötä maksajan puhelinnumero", sendRequest: "Lähetä maksupyyntö" } }, OwnerSettingsComponent: { tabs: { editing: "Muokkaus", beneficiaries: "Edunsaajat", printable: "Tuloste" }, shareAmountTitle: "Osakkeiden lukumäärä", ownerInfoTitle: "Omistajien tiedot", noOwnersTitle: "Omistajat", beneficiariesInfoTitle: "Edunsaajien tiedot", noBeneficiariesTitle: "Edunsaajat", addOwnerBtn: "Lisää omistaja", addBeneficiaryBtn: "Lisää omistaja", sharesBy: "Ilmoitan osakkuudet", byPercent: "Prosentteina", byAmount: "Kappalemäärinä", shareAmount: "Osakkeiden lukumäärä", ownerName: "Omistajan nimi", ownerOfficialId: "Y-tunnus / Hetu", ownerEmail: "Sähköpostiosoite", ownerAddress: "Osoite (myös maa)", ownerShareAmount: "Osakkeita (kpl)", ownerSharePercent: "Osakkeita (%)", totalShares: "Yhteensä", beneficiaryName: "Nimi", beneficiaryOfficialId: "Hetu", beneficiaryNationality: "Kansalaisuus", shareHoldersTitle: "Osakasluettelo", shareHolder: "Osakas", shares: "Osakkeet", sharesPercent: "Omistusosuus" }, ProductInfoHeadersComponent: { accountingLabel: "Palkkaus.fi lähettää kirjanpitäjällesi automaattisesti kirjanpitoraportin kuukauden alussa.", baseLabel: "Palkkaus.fi-palvelun avulla hoidat kaiken palkanmaksuun liittyvän yhdellä verkkopankkimaksulla. Helposti ja nopeasti!", baseTail: "Per palkanmaksu.", baseTail2: "Palvelumaksu on 1% maksetusta palkasta mutta enintään 10€", healthcareCost: "Mitä työterveyshuolto maksaa?", healthcareLabel: "Laki vaatii, että työnantajan tulee järjestää työterveyshuolto työntekijöillensä. Pääkaupunkiseudulla, Tampereen ja Oulun alueilla saat työterveyshuollon kk-maksulla kumppaniltamme Heltti.fi:ltä.", healthcareTail: "Per työntekijä kuukaudessa", insuranceCost: "Mitä työtapaturmavakuutus maksaa?", insuranceLabel: "Tarvitset lakisääteisen työtapaturmavakuutuksen, kun maksat työntekijöille palkkoja yhteensä vähintään 1400€ vuodessa. Vakuutus tulee ottaa ennen työn aloittamista.", insuranceTail: "Työtapaturmavakuutuksen suuruus työntekijän palkasta", serviceCost: "Mitä palvelu maksaa?", taxLabel: { html: 'Palkkaus.fi-palvelu hoitaa automaattisesti verovirastoon tarvittavat lakisääteiset ilmoitukset ja maksut palvelussa maksettujen palkkojen perusteella kuukausittain. Palvelusta ei lähde nollailmoituksia kuukausilta, joilta ei ole palkanmaksua. Jos olet työnantajasuorituksissa neljännesvuosi-ilmoittaja, ole yhteydessä asiakaspalveluun <a href="mailto:aspa@palkkaus.fi">aspa@palkkaus.fi</a>. <br/><small>Huomaathan, että ilmoituskausi voi olla eri arvonlisäveroissa ja työnantajasuorituksissa. Jos et ole ilmoittautunut työnantajarekisteriin, olet työnantajasuorituksissa satunnaisilmoittaja. Tällöin ilmoitukset voivat mennä palvelussa kuukausittain automaattisesti.</small>' }, taxTail: "Ei erillistä veloitusta.", taxTail2: "Osa Palkkaus.fi-palvelumaksua", tvrCost: "Mitä TVR maksaa?", tvrLabel: "Palkkaus.fi-palvelu hoitaa automaattisesti työttömyysvakuutusrahastoon tarvittavat lakisääteiset ilmoitukset ja maksut palvelussa maksetuista palkoista.", tvrLabelTVR: "Palkkaus.fi tekee automaattisesti palkkailmoituksen palvelussa maksetuista palkoista Työttömyysvakuutusrahastolle, mutta ei tilitä TVR-maksuja. TVR lähettää ennakko- ja tasauslaskut erikseen yrityksellesi.", tvrTail: "TVR-maksun suuruus työntekijän palkasta", tyelCost: "Mitä TyEL maksaa", tyelLabel: "Työnantajan pitää hoitaa työeläke (TyEL) työntekijöilleen. Jos palkkaat vain satunnaisesti, niin et tarvitse työnantajan TyEL-sopimusta. Satunnaiselle työnantajalle palvelu hoitaa TyEL-ilmoitukset ja -maksut automaattisesti (ns. tilapäinen työnantaja).", tyelTail: "TyEL-maksu palkasta", yelCost: "Mitä YEL maksaa?", yelLabel: "Tarvitset YEL-vakuutuksen, kun toimit yrittäjänä yrityksessäsi. Palkkaus.fi:n kautta otat YEL-vakuutuksen helposti ja hoidat myös työntekijöidesi eläkkeet (TyEL) osana palkanmaksuja.", yelTail: "YEL-maksu yrittäjän työtulosta" }, InsuranceSettingsComponent: { pension: { title: "Työeläke", titleLong: "Työeläkesopimus", description: "Lisää TyEL-sopimuksen tiedot alle. Työeläkemaksu ei tility osana palkanmaksua palvelulle. Palvelu tekee ilmoituksen tulorekisteriin ja työeläkeyhtiösi lähettää laskun työeläkemaksuista. Jos sinulla ei ole sopimusta, valitse 'Ei yhtiötä', jolloin ilmoitukset menevät Varmaan.", tyelQuestion: "Onko sinulla voimassa oleva TyEL-sopimus?", alertHeader: "Työeläke", alertMessage: "Tarkista työeläkeyhtiö ja sopimusnumero.", varmaLegend: "Tee työeläkesopimus Varman kanssa", varmaDescription: "Jos sinulla on vakituisia työntekijöitä ja palkanmaksu on jatkuvaa, sinun tulee tehdä sopimus. Työnantajista 3/4 saa TyEL-vakuutuksen edullisimmin Varmasta. Saat vakuutuksen tästä heti voimaan.", varmaCta: "Tee työeläkesopimus", temporaryLegend: "Oletko yrittäjä tai palkkaat vain tilapäisesti?", temporaryDescription: { html: "Et tarvitse työeläkesopimusta, jos olet yrittäjä (sinulla on YEL-sopimus) ja sinulla ei ole vakituisia työntekijöitä eikä palkanmaksu ole jatkuvaa. Tällöin eläkkeet hoidetaan tilapäisenä ilmoituksena Varmaan.<br/>Jos olet yrittäjä ja maksat vain YEL-palkkaa, merkitse työntekijän tiedoissa, että kyse on yrittäjän palkasta, niin työeläkemaksuja ei makseta osana palkanmaksua. YEL-maksut maksetaan suoraan vakuutusyhtiöön. YEL-sopimusnumeroa ei tarvitse ilmoittaa palvelussa. Voit myös tilata Varman YEL-vakuutuksen palvelun kautta." }, temporaryVarma: "Hoidetaan tilapäisenä Varmaan", selfhandle: "Hoidan TyEL-maksut itse", selfhandleDescription: "Työeläkemaksu ei tility osana palkanmaksua palvelulle. Palvelu tekee ilmoituksen tulorekisteriin ja työeläkeyhtiösi lähettää laskun työeläkemaksuista.", currentContractLegend: "Anna voimassa olevan sopimuksen tiedot", currentContractCompany: "Valitse yhtiö", currentContractNumber: "TyEl-sopimusnumero", errors: { sxyPensionContractNumber: { html: `Työeläkesopimuksen numero on 11 merkkiä pitkä ja se on muotoa:
 <span class="emphasis"><strong>nn-nnnnnnnT</strong> (Varma, Ilmarinen, Elo tai Veritas) tai <br><strong>nnnnn-nnnnT</strong> (Eläkekassa Verso, Apteekkien Eläkekassa tai Valion Eläkekassa)</span> jossa n on numero ja T on tarkistusmerkki (numero tai iso kirjain).<br>Viivan jälkeen voi lisätä nollia, jos loppuosa on lyhyempi.` }, sxyTemporaryPensionContractNumber: { html: "Syötit tilapäisen sopimuksen numeron. Jos sinulla ei ole työ&shy;eläke&shy;sopimusta, voit maksaa työ&shy;eläke&shy;maksut tilapäisenä työnantajana valitsemalla asetuksissa, että sinulla ei ole sopimusta. Työ&shy;eläke&shy;maksut tilitetään tällöin Varmaan." } }, moveContractLegend: "Tai siirrä olemassa oleva sopimus Varmaan", moveContractDescription: "Työnantajista 3/4 saa TyEL-vakuutuksen edullisimmin Varmasta. TyELin voi siirtää Varmaan, jos nykyinen sopimus on ollut voimassa vähintään vuoden. Siirron jälkeen TyEL-maksut ja -ilmoitukset välittyvät automaattisesti Varmaan.", moveContractCta: "Siirrä työeläkesopimus" }, yelPension: { title: "YEL-vakuutus", description: "Jos yrityksessä on YEL-yrittäjiä, pitää jokaisella heistä olla oma henkilökohtainen YEL-vakuutus. Yrittäjä tarvitsee yhden YEL-vakuutuksen, jolle maksetaan yrittäjäpalkoista koituvat eläkemaksut. Tästä voi ottaa yrittäjälle uuden YEL-vakuutuksen, jos sellaista ei vielä ole. Voit myös siirtää olemassa olevan vakuutuksen Varmaan.", takeInsuranceBtn: "Ota YEL-vakuutus" }, insurance: { title: "Tapaturmavakuutus", description: "Lisää työtapaturmavakuutuksen tiedot, niin ne näkyvät palkkalaskelmalla.", insuranceQuestion: "Onko yritykselläsi voimassa oleva työtapaturmavakuutus? ", insuranceComment: "Työtapaturmavakuutusyhtiön yhtiötunnus ja työtapaturma- ja ammattitautivakuutuksen vakuutusnumero pitää merkitä tulorekisterin palkkatietoilmoitukseen, jos suorituksen maksaja on vakuuttanut työntekijöitään useammalla kuin yhdellä työtapaturma- ja ammattitautivakuutuksella. Muissa tilanteissa yhtiötunnus ja vakuutusnumero ovat vapaaehtoisesti annettavia tietoja.", alertHeader: "Tapaturmavakuutus", alertMessage: "Tarkista vakuutusyhtiö ja vakuutusnumero.", currentContractLegend: "Anna voimassa olevan vakuutuksen tiedot", currentContractCompany: "Valitse yhtiö", warning: "Huomio! Työtapaturmavakuutus on lain mukaan pakollinen, jos maksat työntekijöiden palkkoja yhteensä vähintään 1400€ vuodessa.", moveContractDescription: "Vakuutuksen voi siirtää, jos nykyinen vakuutus on ollut voimassa vähintään kalenterivuoden.", currentContractNumber: "Vakuutusnumero", moveToLocalTapiolaLegend: "Tai siirrä vakuutus LähiTapiolaan", moveToLocalTapiolaBtn: "Siirrä tapaturmavakuutus", takeFromLocalTapiolaLegend: "Ota vakuutus LähiTapiolasta", takeFromLocalTapiolaBtn: "Ota tapaturmavakuutus" } }, PaymentSettingsComponent: { accounting: { title: "Kirjanpitoraportit", description: "Täytä kirjanpitäjäsi yhteystiedot. Lähetämme kuukausiraportin kirjanpitäjällesi sähköpostitse. Emme luovuta palkanmaksun tietoja muille ulkopuolisille, kuin tässä ilmoitetulle henkilölle.", accountantName: "Kirjanpitäjän nimi", accountantEmail: "Sähköposti", accountantTel: "Puhelinnumero" }, einvoice: { title: "Verkkolasku", description: "Täytä verkkolaskutuksesi tiedot, jos haluat käyttää verkkolaskua palkkojen maksamiseen.", intermediatorName: "Välittäjä", invoiceAddress: "Verkkolaskuosoite" }, tax: { title: "Tulorekisteri", intro: `Palkkaus.fi ilmoittaa palkkatiedot tulorekisteriin jokaisesta palkanmaksusta. Lisäksi Palkkaus.fi lähettää tulorekisteriin pakollisen työnantajan erillisilmoituksen kuukausittain.\r
Palkkaus.fi lähettää erillisilmoituksen myös koskien kalenterikuukausia, jolloin palkkaa ei ole maksettu, jos työnantaja kuuluu Verohallinnon työnantajarekisteriin.\r
Jos käytät Palkkaus.fi-palvelun lisäksi toista palkanmaksupalvelua tai -ohjelmistoa, voit poistaa erillisilmoituksen lähetyksen Palkkaus.fi-palvelun kautta ja antaa työnantajan erillisilmoituksen itse tulorekisteriin.\r
`, selectionLabel: "Kuukausittainen ilmoittaminen", selectionOption: { default: "Palkkaus.fi lähettää kaikki ilmoitukset. Ei palkanmaksua -ilmoitus lähetetään 12 kuukauden ajan viimeisimmästä palkanmaksusta.", noZeroSalaryReport: "Palkkaus.fi ei lähetä Nollailmoitusta", noMonthlyReport: "Palkkaus.fi ei lähetä työnantajan erillisilmoitusta", always: "Palkkaus.fi lähettää työnantajan erillisilmoituksen siinäkin tapauksessa, jossa työnantaja ei ole maksanut palkkoja viimeisen 12 kuukauden aikana" } }, unemployment: { title: "Työttömyysvakuutusmaksut", intro: `Palkkaus.fi ilmoittaa palkkatiedot tulorekisteriin, josta Työllisyysrahasto hakee ajantasaiset tiedot.
Työllisyysrahasto lähettää laskun työttömyysvakuutusmaksuista yrityksellesi.` }, sepa: { title: "SEPA-maksatustunnus ja tilinumero, miltä erät maksetaan", intro: "Jos käytät laskujen luontitoimintoa ja hoidat erien maksun itse, syötä tilinumero, miltä erät maksetaan. Tilinumeroa käyteään SEPA- ja viitesiirtoaineiston luonnissa.", iban: "Tilinumero (IBAN)", sepaId: "SEPA-maksatustunnus" }, taxSelfHandling: { title: "Ennakonpidätyksen maksaminen", intro: "Palkkaus.fi toimii oletusarvoisesti niin, että jokainen palkka maksetaan kaikkine sivukuluineen Palkkaus.fi-palvelun asiakasvaratilille.", intro2: "Täältä hoidamme maksun eräpäivänä verottajalle. Vaihtoehtoisesti voit maksaa maksun itse suoraan verottajalle eräpäivänä.", taxSelfHandlingTrue: "Hoidan ennakonpidätyksen maksun itse" }, workerSelfHandling: { title: "Nettopalkan maksaminen", intro: "Palkkaus.fi toimii oletusarvoisesti niin, että jokainen palkka maksetaan kaikkine sivukuluineen Palkkaus.fi-palvelun asiakasvaratilille.", intro2: "Heti kun raha on saapunut asiakasvaratilillemme, maksamme nettopalkan työntekijälle. Vaihtoehtoisesti voit maksaa nettopalkan itse työntekijälle.", workerSelfHandlingTrue: "Hoidan nettopalkan maksun itse" }, salarySlipDeliveryMethods: { payslip: { title: "Palkkalaskelman toimitustapa työntekijälle", description: "Palkkalaskelma muodostuu oletuksena Palkkaus.fi-ohjelmaan, josta työntekijä voi hakea laskelman halutessaan. Tämän lisäksi voit valita toimitetaanko palkkalaskelma myös työntekijän verkkopankkiin verkkopalkkalaskelmana. Verkkopalkan toimittamisesta peritään voimassa olevan hinnaston mukainen palvelumaksu. Verkkopalkkaoperaattorina toimii Apix." }, omapalkka: { title: "Omapalkka", label: "Jo maksetut laskelmat", sendToOmapalkkaButtonText: "Lähetä työntekijöiden maksetut laskelmat Omapalkkaan" } } }, ProSettingsComponent: { tabs: { defaultRows: "Oletusrivit", messagingAndLayout: "Viestintä ja ulkoasu", paymentChannels: "Maksaminen", dimensions: "Laskentakohteet", accounting: "Kirjanpito", other: "Muut", "read-only": "Palvelumalli" }, fileUpload: { previewLabel: "Ladattava kuva", uploadMethod: "Lataustapa", manualUpload: "Syötä käsin (SVG tai data URI)", uploadFromDevice: "Lataa kuva koneelta" }, activeServices: "Aktivoidut palvelut", pricing: "Hinnoittelu", webApp: "Asiakassivusto", branding: "Brändi", messaging: "Viestintä", reporting: "Tulosteiden ulkoasu", paymentChannels: "Maksukanavat", accounting: "Kirjanpito", usecases: "Räätälöinnit", selfHandling: "Asvara", invoices: "Laskut", incomesRegister: "Tulorekisteri", insurances: "Vakuutukset", insurance: "Tapaturmavakuutus", serviceModelBadge: "Palvelumalli", customMessages: "Räätälöidyt viestintäasetukset palvelumallissa", customReporting: "Räätälöidyt tulosteet palvelumallissa", customPaymentChannels: "Räätälöidyt maksukanavat palvelumallissa", customAccounting: "Räätälöidyt kirjanpitoasetukset palvelumallissa", customCostAccounting: "Räätälöidyt laskentakohteet palvelumallissa", customUsecases: "Räätälöinnit käytössä palvelumallissa", customForms: "Räätälöidyt työnkulut palvelumallissa", customHoliday: "Räätälöity lomalaskenta palvelumallissa", customCalc: "Räätälöity Tulorekisterivarmenteen käyttö palvelumallissa", overwriteServiceModel: "Ohita palvelumalli", defaultTarget: "Oletuskohde", defaultChannel: "Oletuskanava", layoutTemplateId: "Ulkoasun tunniste", templateIdPalkkaus: "Palkkaus.fi", templateIdNoLogo: "Ilman logoa", templateIdLogo: "Yrityksen oma logo", messagesPayment: "Viestit palkanmaksusta työntekijälle", messagesAccountant: "Viestit tilitoimistolle", customReportLogo: "Logo (SVG tai data URI)", accountingTarget: "Kirjanpitokohde", workerSalarySlipDeliveryMethods: "Palkkalaskelman toimitustapa työntekijälle", unemploymentInsurance: "Työttömyysvakuutusmaksut" }, ProSettingsListComponent: { noPensionCompany: "Yhtiötä ei ilmoitettu" }, ArrayUsecase: { table: { usecaseLabel: "Räätälöinnit" } }, SalaryReportsComponent: { calculations: "Palkkalaskelmat", noCalculations: "Ei palkkalaskelmia", payment: "Maksu", grossSalary: "Brutto", notSelected: "(Työntekijää ei ole valittu)" }, SmsMessageComponent: { sendSms: "Lähetä SMS" }, TaxcardsListComponent: { worker: "Työntekijä", year: "Vuosi", valid: "Voimassa", validTill: "..loppu", paid: "Maksettu", incomeLimit: "Tuloraja", personalId: "Henkilötunnus", unknown: "tuntematon", taxPercent2: "Lisäprosentti", taxcard: "Verokortti" }, UserInfoComponent: { panelTitle: "Käyttäjätunnuksen tiedot", authType: "Tunnistus", email: "Sähköposti", description: { html: "Tunnuksen tietoja ei voi vielä muuttaa käyttöliittymästä. Jos haluat vaihtaa toiseen tunnukseen ota yhteyttä asiakaspalveluumme <a href='mailto:aspa@palkkaus.fi'>aspa@palkkaus.fi</a> tai 09 425 50603." }, name: "Nimi", palkkausAccount: "Palkkaus.fi-tili", personTitle: "Allekirjoittanut henkilö", userName: "Tunnus", userNameTitle: "Käyttäjätunnus" }, WelcomeComponent: { taxcard: "Verokortti", showAnon: { main: { html: ` <p><strong>Kirjaudu palveluun!</strong> 
Et ole vielä kirjautunut palveluun: Voit kokeilla palkkalaskuria, mutta monet toiminnallisuudet, esim. työntekijän luominen, eivät toimi.</p>` } }, showAddWorker: { main: { cta: "Lisää uusi työntekijä", html: `Aloita palkanmaksu lisäämällä työntekijä ja verokorttitiedot.<br /> Työntekijän\r
                lisäämisen jälkeen voit laskea ja maksaa palkan.` }, tryPayroll: { cta: "Palkkalistat" } }, showAddCalculation: { main: { html: "Aloita palkanmaksu valitsemalla työntekijä <strong>tai</strong> luo uusi työntekijä" }, selectWorkerPlaceholder: "Valitse työntekijä...", selectWorker: "Valitse työntekijä" }, showSettings: { lead: { html: "<strong>HUOM!</strong> Nämä tiedot pitää täyttää ennen palkanmaksua:" }, main: "Työeläkevakuutus, tapaturmavakuutus", pension: { html: '<strong>Työeläke:</strong>  <span class="text-muted">Lisää nykyisen työeläkesopimuksesi tiedot tai ota uusi sopimus Varmasta.</span>', success: "Työeläke OK", pending: "Uusi sopimus käsittelyssä (voimassa).", successCompany: "Yhtiö", successContractNumber: "Sopimusnumero" }, insurance: { html: '<strong>Tapaturmavakuutus:</strong>  <span class="text-muted">Lisää nykyisen tapaturmavakuutuksesi tiedot tai ota uusi sopimus Ifistä. </span>', success: "Tapaturmavakuutus OK", pending: "Uusi sopimus käsittelyssä.", successCompany: "Yhtiö", successContractNumber: "Sopimusnumero" }, settings: { cta: "Lisää tiedot" } }, showSign: { lead: "Allekirjoita valtakirja", main: { html: `<span class="text-muted">
Maksaaksesi palkan, sinun tulee valtuuttaa Palkkaus.fi hoitamaan palkanmaksuun liittyviä velvollisuuksia puolestasi. Voit allekirjoittaa valtakirjan helposti pankkitunnuksillasi. </span>`, cta: "Lisää allekirjoitus" } }, showTryPayroll: { main: "Palkkalistan avulla voi maksaa useita palkkoja samalla kertaa.", cta: "Kokeile palkkalistaa!" }, showPaymentStarted: { holvi: { html: "<p><strong>Huom!</strong> Sinulla on yksi tai useampi laskelma Maksu aloitettu -tilassa. Käythän maksamassa nettolaskun Holvissa, jotta tulorekisteri-ilmoitukset lähtevät ajoissa. Huomaathan, että palkka kirjataan laskelmalla olevalle alkuperäiselle palkkapäivälle. Voit myös perua laskun, jolloin laskelma palautuu luonnokseksi.</p>" }, palkkausManual: { html: "<p><strong>Huom!</strong> Sinulla on yksi tai useampi laskelma Maksu aloitettu -tilassa. Käythän kuittaamassa nettolaskun maksetuksi Maksuaineiston lähetys -näkymässä, jotta tulorekisteri-ilmoitukset lähtevät ajoissa. Huomaathan, että palkka kirjataan laskelmalla olevalle alkuperäiselle palkkapäivälle. Voit myös perua laskun, jolloin laskelma palautuu luonnokseksi.</p>" }, talenomOnline: { html: "<p><strong>Huom!</strong> Sinulla on yksi tai useampi laskelma Maksu aloitettu -tilassa. Käythän maksamassa nettolaskun Easor App -sovelluksessa, jotta tulorekisteri-ilmoitukset lähtevät ajoissa. Huomaathan, että palkka kirjataan laskelmalla olevalle alkuperäiselle palkkapäivälle. Voit myös perua laskun, jolloin laskelma palautuu luonnokseksi.</p>" } }, welcome: "Tervetuloa!", intro: "Näin maksat ensimmäisen palkan", checkTyel: "Tarkista TyEL", addWorker: "Lisää työntekijä", createCalculation: "Luo palkkalaskelma", allWithOne: "Maksa kaikki yhdellä verkkopankkimaksulla", feedback: { title: { html: "Onko sinulla kysyttävää palvelusta? <small>Jätä viesti asiakaspalveluun. </small>" }, emailTitle: "Palaute Y-tunnusten työpöydältä", alert: "Kiitos viestistäsi! Palkkaus.fi:n asiakaspalvelu on sinuun yhteydessä." }, loadWorkerDataPanelTitle: "Lataamasi verokortti", loadWorkerDataPanelTitle2: "Lähetä verokortti työnantajallesi", autoTaxcard: { lead: { html: "<b>Ota käyttöön automaattiset verokortit</b> <br>Päivitä työsuhteisiin uusi verokortti suoraan verottajan rajapinnasta." } } }, WorkerCalculationsComponent: { date: "Päivämäärä", finalCost: "Kustannus", salary: "Palkka", status: "Tila" }, WorkerWizardComponent: { workerType: { title: "Mitä korvausta maksetaan", entrepreneurTmiWarning: `Yksityinen elinkeinonharjoittaja eli toiminimi ei voi maksaa itselleen palkkaa. Palkanmaksu hoidetaan yksityisnostoina. Kirjanpitäjäsi voi neuvoa sinua miten toimia.
Voit maksaa työsuhteessa oleville työntekijöille palkkaa ihan kuten muissakin yritysmuodoissa. Huomaa kuitenkin, että puolisollesi et voi maksaa palkkaa toiminimiyrityksestä. Myöskään alaikäistä lastaan ei voi palkata työntekijäksi.`, entrepreneurRyWarning: "Palkkaus.fi -tilisi mukainen yritysmuoto on yhdistys / yksityishenkilö, etkä voi maksaa yrittäjälle palkkaa näissä yritysmuodoissa.", entrepreneurPrivateWarning: "Palkkaus.fi -tilisi mukainen yritysmuoto on yhdistys / yksityishenkilö, etkä voi maksaa yrittäjälle palkkaa näissä yritysmuodoissa.", compensationCta: "Lisätietoa", compensationLink: "https://www.palkkaus.fi/abc/palkkaa-vai-tyokorvausta/", compensationDescription: "Jossain tapauksissa työstä voidaan maksaa palkan sijaan työkorvausta. Työkorvausta voidaan maksaa silloin, jos työ ostetaan joltain itsenäiseltä ammattilaiselta, johon ei voi katsoa syntyvän varsinaista työsuhdetta." }, employment: { isFixedTerm: "Määräaikainen työsuhde", isTerminated: "Työsuhde päättynyt", employmentRegCode: "Palvelussuhteen rekisteröinti", pension: { title: "Sovellettava eläketurva", compensation: "Työkorvaus", tyel: "TyEL", yel: "YEL", myel: "MyEL", athlete: "Urheilijan eläke", missingPension: "Työeläkevakuutuksen tiedot puuttuvat. Lisää tiedot Vakuutukset-osiossa ennen ensimmäistä palkanmaksua tai ota uusi TyEL-vakuutus.", takeInsuranceBtn: "Ota TyEL-vakuutus" }, pensionRule: "Eläkemaksun laskentasääntö", group: { title: "Työsuhteen", startDate: "Alku pvm", endDate: "Loppu pvm", legend: "Työsuhteen alku ja loppu" }, title: "Työsuhteen tiedot", work: { occupationCode: "Ammattiluokka vakuutukseen", occupationCode2: "Keva:n ammattiluokka", description: "Kuvaus palkkalaskelmaan", salaryDefaults: { title: "Oletusrivit palkkalaskelmaa varten", rowType: "Tyyppi", count: "Määrä", price: "Hinta", addRow: "Lisää oletusrivi laskelmaan", info: { md: `Voit määritellä oletusrivit työntekijän palkkalaskelmalle.

Nämä rivit tulevat valmiiksi palkkalaskuriin, kun lasket tälle työntekijälle palkkaa.

Esimerkiksi kuukausipalkka tai luontoisedut kannattaa merkitä.` } } }, info: { cbaCode: "Työehtosopimus", cbaCodeInfo: "Työehtosopimustieto tiedoksi palkanlaskentaa varten. Työehtosopimusta ei ilmoiteta tulorekisteriin eikä valittu työehtosopimus vaikuta palkkalaskurin toimintaan." } }, finishButtons: { newWorker: "Uusi työntekijä", ready: "Valmis" }, step1: { title: "Nimi ja henkilötunnus" }, step2: { title: "Työntekijän tiedot" }, step3: { title: "Työsuhde" }, step4: { title: "Oletuspalkkarivit" }, step5: { title: "Verokortti" }, wizard: { step: "Vaihe", title: "Uusi työntekijä" } }, WorkerOnboardingComponent: { title: "Uusi Palkkaus.fi-tunnus työntekijälle", step: "Vaihe", stepUserInfo: { title: "Käyttäjän tiedot", heading: "Tervetuloa, työntekijä!", registerText: "Olet rekisteröitymässä Palkkaus.fi-palveluun työntekijänä. Työntekijälle palvelu on aina ilmainen. Tarvitset kuitenkin matkapuhelimen ja pankkitunnukset tunnistautumista varten. Aloita täyttämällä omat henkilötietosi.", firstName: "Etunimi", lastName: "Sukunimi", email: "Sähköposti", language: "Kieli", phoneNumber: "Puhelinnumero", confirmNumber: "Vahvistamme antamasi numeron" }, stepPhoneNumberVerify: { title: "Puhelinnumeron vahvistaminen", heading: "Puhelinnumeron vahvistaminen", intro: "Olemme lähettäneet sinulle SMS-viestin varmistaaksemme numerosi. Syötä viestissä oleva vahvistuskoodi tähän.", confirmationCode: "Vahvistuskoodi", testEnvironment: { html: "<b>Testiympäristö</b><br/> Vahvistuskoodia ei tarkisteta, jatka painamalla seuraava." } }, stepContract: { stepTitle: "Sähköinen tunnistautuminen", heading: "Tilisopimus ja valtuutus", intro: " Valtuuta pankkitunnuksillasi Palkkaus.fi-palvelu hoitamaan palkanmaksuun liittyviä asioita puolestasi. Tarvitsemme valtakirjan, jotta voimme antaa esim. verokorttisi työnantajalle ja hoitaa asioita viranomaisten suuntaan puolestasi. Valtuutus pitää tehdä vain kerran.", title: "Käyttäjätilisi on melkein valmis!", signatureText: "Jotta voimme hoitaa palkkalaskelmia ja palkanmaksuun liittyviä velvoitteita, tarvitsemme siihen valtakirjan. Se pitää allekirjoittaa vain kerran.", signatureText2: "Anna henkilötunnuksesi, valitse pankkisi ja paina 'Allekirjoita'-nappia. Siirryt allekirjoittamaan valtakirjan tietoturvallisesti verkkopankkitunnuksillasi. Tämän jälkeen palaat Palkkaus.fi-palveluun ja näet laskelmasi.", personalId: "Henkilötunnuksesi", personalIdExample: "PPKKVV-NNNX", termsText: { html: 'Hyväksyn <a href="https://www.palkkaus.fi/kayttoehdot/" target="_blank">käyttöehdot</a>,' }, termsText2: "Valtakirjan", termsText3: { html: 'ja <a href="https://www.palkkaus.fi/sopimus-henkilotietojen-kasittelysta/" target="_blank">sopimuksen henkilötietojen käsittelystä</a>.' }, chooseBank: "Valitse verkkopankkisi", privacyPolicy: { html: '<a href="https://www.palkkaus.fi/tietosuoja/" target="_blank">Lue palvelun tietosuojasta</a>' }, savePdfText: "Tallennamme tiedon sähköisestä tunnistautumisestasi ", savePdfLink: " PDF-tiedostona", savePdfText2: " palveluun." }, signBtn: "Allekirjoita" }, WorkerDetailsCalc: { payrollDetails: "Palkanlaskennan yksityiskohdat", wageBasis: "Peruste", monthlyHours: "Tuntien määrä / kk", integrations: "Integraatiot", ssNumber: "Henkilönumero", irIncomeEarnerTypes: "Tulonsaajatyyppi" }, CompanyPro: { tabs: { editNew: "Rivit", charts: "Yleiskuva", calcReports: "Raportit", ir: "Tulorekisteri", worker: "Työntekijä", taxcards: "Verokortit", calcs: "Laskelmat", versions: "Versiot" }, calcRows: "Laskelman rivit" }, WorkerDetailsComponent: { isAccountOwnerWarning: { title: "Palkanmaksu ei mahdollista", message: `Yksityinen elinkeinonharjoittaja eli toiminimi ei voi maksaa itselleen palkkaa.
Palkanmaksu hoidetaan yksityisnostoina.
Kirjanpitäjäsi voi neuvoa sinua miten toimia.` }, addressInfo: "Osoite ei ole pakollinen palkanmaksussa.", addressInfoOtherIdentifier: "Työntekijällä on keinohenkilötunnus, jonka ilmoittaminen tulorekisteriin edellyttää työntekijän osoitetietoja.", address: "Osoite", street: "Katuosoite", city: "Kaupunki", details: "Henkilötiedot", workerId: "Työntekijän ID", salaryPaymentMethod: "Palkanmaksutapa", email: "Sähköpostiosoite", emailError: "Sähköposti on virheellinen.", year: "Vuosi", contactInfo: "Yhteystiedot", firstName: "Etunimi", ibanNumber: "Tilinumero (IBAN)", ibanNumberError: "Tilinumero on virheellinen", addIban: "Lisää tilinumero", lastName: "Sukunimi", accept: "Hyväksy", decline: "Hylkää", validHtml: "Voimassa<br /> Otettu käyttöön", unRealPersonalIndenficationNumer: "Työntekijällä on keinohenkilötunnus, jonka ilmoittaminen tulorekisteriin edellyttää työntekijän osoitetietoja.", nameDecription: { html: "Nimen muokkaaminen vaatii aina pankki&shy;tunnistuksen. Tämä hoidetaan rekisteröinnin ohjatulla toiminnolla." }, paymentDetails: "Maksutiedot", postalCode: "Postinumero", work_description: "Kuvaus palkkalaskelmaan", readOnlyUser: { html: "<h3>Työntekijä on tunnistautunut pankkitunnuksin</h3><p>Tämä työntekijä on kirjautunut Palkkaus.fi-palveluun ja hallinnoi itse henkilötietojaan ja tilinumeroaan. Hän voi itse muuttaa niitä kirjautumalla palveluun omilla tunnuksillaan.</p><p>Jos näet tässä vääriä tietoja, ole yhteydessä työntekijään tai ota yhteyttä asiakaspalveluumme.</p>" }, ssNumber: "Henkilötunnus", ssNumberDescription: { html: "Palkkaus.fi-tili on aina kiinnitetty henkilötunnukseen. Jos henkilötunnuksesi muuttuu, kirjaudu ulos ja luo uusi Palkkaus.fi-tili uudella henkilötunnuksella tai ota yhteys asiakaspalveluumme." }, avatarDescription: { html: "Kuva ei ole pakollinen tieto palkanmaksussa." }, taxCard: { cardType: "Verokortin tyyppi", example: "Esimerkkiverokortti", exampleAlt: "Esimerkkiverokortti (kysy tieto myöhemmin)", freelancer: "Freelancer", noTaxCard: "Ei verokorttia (60%)", noTaxCardText: "Ei verokorttia, 60% ennakonpidätys", noTaxPrepayment: "Ei ennakonpidätystä (alle 1500 €/vuosi)", other: "Muu", others: "Muut tyypit", sideIncome: "Sivutulon verokortti", steps: "Portaikkoverokortti", stepsAlt: "(portaikkoverokortti)", taxCardA: "Verokortti A", taxCardB: "Verokortti B", unknown: "Tuntematon", sharedTaxCard: "Työntekijä on jakanut verokortin", wantToEnableTaxCard: "Haluatko ottaa verokortin käyttöön?", taxCardExists: "Verokortti on jo syötetty", taxCardExistsInfo: "Työntekijälle henkilötunnuksella {{ personalId }} on jo syötetty verokortti.Voit muokata sitä myöhemmin työntekijän tiedoissa.", sharedTaxCardExistsInfo: "Työntekijä henkilötunnuksella {{ personalId }} on jo rekisteröitynyt Palkkaus.fi-palveluun ja hän on myös jakanut verokortin: {{kind}}, voimassa: {{ validity }}. Verokortti sisältää henkilötietoja, joita saat katsoa vain, jos aiot todella maksaa palkkaa ko. henkilölle. Tieto verokortin avaamisesta välittyy työntekijälle.", typeAreYouSure: `Verokortin tyypin muutos tallennetaan työsuhteeseen heti. 
Haluatko varmasti tehdä tämän muutoksen?`, status: { waiting: "Odottaa", waitingForAcception: "Odottaa hyväksyntää", declined: "Hylätty", accepted: "Hyväksytty", notSeen: "Sisältöä ei nähty" }, setSharedAutoForSelf: { loadingTitle: "Haetaan verokorttia", loadingText: "Haetaan ennakonpidätyksen prosentteja ja tulorajaa Veron rajapinnasta.", alertTitle: "Ei verokorttia", alertText: "Verottajan tiedoista ei pystytty hakemaan uutta veroprosenttia. Tämä voi olla tilapäinen ongelma. Käytämme toistaiseksi vanhoja prosentteja.", alertTextAutoCard: "Verottajan tiedoista ei löydy verokorttia tälle henkilötunnukselle. Tarkista verokorttisi Omavero-palvelusta tai Veron asiakaspalvelusta." } }, taxPercent: "Veroprosentti", taxPercentAdditional: "Lisäprosentti", tel: "Puhelinnumero", language: "Kieli", workerEdit: { title: "Muokkaa työntekijää" }, newCalculation: "Uusi palkkalaskelma", workerInfo: "Perustiedot", calculations: "Palkkalaskelmat", taxcards: "Verokortti", currentTaxCard: "Nykyinen verokortti", historyTaxCard: "Historia", employment: "Työsuhde", contracts: "Työsopimukset", usecase: "Tehtävä työ", calcRows: "Palkkarivit", noCalcRows: "Työntekijälle ei ole lisätty palkkarivejä", defaultCalcRows: "Oletuspalkkarivit", holidays: "Lomat", absences: "Poissaolot", calculationsWorker: { status: "Tila", date: "Pvm", salary: "Palkka", payment: "Maksu", calculation: "Laskelma", payroll: "Palkkalista" }, workerEmployment: { keyEmployeeAlert: { html: "Työsuhteeksi on valittu avainhenkilö. Palvelu ei toistaiseksi tue lähdeveroa. Valitse jokin muu työsuhdetyyppi ja tallenna." } }, employmentTaxcard: "Työsuhteessa käytettävä verokortti", records: { label: "Muistiot", recordType: "Tyyppi", title: "Otsikko", text: "Teksti", attachments: "Liitteet", startDate: "Päiväys", badge: "Huom!", createTypeInfo: "Voit luoda ja tallentaa uuden Tyypin kirjoittamalla tekstikenttään.", badgeInfo: "Täyttämällä huomiokentät tästä liitetiedosta tulee huomiomerkintä laskelmalle ja listauksiin.", noTypes: "Ei tallennettuja tyyppejä, luo uusi kirjoittamalla tekstikenttään" } }, WorkFlowEventEditComponent: { description: "Kuvaus", ui: "Tila" }, WorkerTaxCardsComponent: { instruction: "Nähdäksesi kaikki verokortit, lisää henkilötunnus työntekijän tietoihin tai valitse työntekijä.", error: "Error: No employment / account found", noTaxCards: "Työntekijällä ei ole yhtään verokorttia", percentAfterIncomeLimit: "(Veroprosentti tulorajan jälkeen)", percentAfterIncomeLimit2: { html: "Veroprosentti<br />tulorajan<br />jälkeen" }, type: "Tyyppi", incomeLimit: "Tuloraja", incomeLimitSpan: "...ylittävä %" }, AuthoringAccountComponent: { authoringIntro: "Palkkaus.fi tilit, jotka ovat antaneet valtuutuksen", authorizeIntro: "Palkkaus.fi tilit, joille olet antanut valtuutuksen", authorizeIntroDescription: "Infoteksti", authorize: "Anna valtuutus", authorizedAddNew: "Lisää uusi tili", authoringAddNew: "Lisää uusi tili", authorizeTitle: "Valtuutuksen antaminen", authorizeDescription: "Kirjoita kenttään sen Palkkaus.fi-tilin numero, jolle haluat antaa valtuutuksen ja paina 'Anna valtuutus'.", palkkausAccount: "Palkkaus.fi-tili", status: "Tila", date: "Päivämäärä", signeratureOk: "Allekirjoitus OK", signeratureNo: "Ei allekirjoitusta", invite: "Lähetä kutsu", signIn: "Kirjaudu tilille", scope: "Valtuuden laajuus", defaultScope: "Vakio-oikeudet" }, CompanyOnboardingComponent: { modalTitle: "Palkkaus.fi – Käyttöönotto", step: "Vaihe", step1: { title: "Henkilön tiedot", intro: "Saat palvelun käyttöön, kun luot Palkkaus.fi-tilin. Palvelun käyttöönotto on ilmaista. Maksat palvelusta vain käytön mukaan ilman sitoumuksia. Työntekijälle palvelu on aina ilmainen. Aloita täyttämällä omat henkilötietosi.", personInfo: "Henkilötiedot", personFirstName: "Etunimi", personLastName: "Sukunimi", personContact: "Henkilön yhteystiedot", personEmail: "Sähköposti", personPhone: "Puhelinnumero" }, stepSuomiFi: { title: "Nimenkirjoitusoikeus", intro: "Luodaksesi tilitoimistotilin Palkkaus.fi-palveluun sinulla pitää olla yrityksen nimenkirjoitusoikeus. Tarkistamme tämän Suomi.fi-palvelusta. Suomi.fi-palvelu vaatii tarkistukseen henkilötunnuksen. Käyttöönoton kohdassa 5. allekirjoitat palvelusopimuksen / valtakirjan tämän henkilötunnuksen pankkitunnuksin.", infoText: "Valitse Suomi.fi-palvelussa yritys, jolle haluat luoda tilin Palkkaus.fi-palveluun.", personalId: "Henkilötunnuksesi", goToSuomiFiBtn: "Siirry Suomi.fi-palveluun" }, stepCompanyInfo: { title: "Yrityksen tiedot", intro: "Ilmoita tässä yrityksen sähköpostiosoite ja puhelinnumero, josta Palkkaus.fi:n asiakaspalvelu tavoittaa henkilön, joka vastaa palkanmaksuista yrityksessä.", existingCompanyAlert: "HUOM! Yrityksellä on jo Palkkaus.fi-tili. Jos jatkat käyttöönottoa, käyttämäsi tunnus lisätään tilin omistajaksi, jos se tilitä puuttuu. Vanhat käyttäjätunnukset säilyvät. Halutessasi voit poistaa käyttäjätunnuksen kohdasta Asetukset => Valtuutukset => Käyttäjätunnukset.", existingBusinessIdAlert: "Tällä Y-tunnuksella ({{businessId}}) on jo luotu käyttäjätili Palkkaus.fi-palveluun.", existingBusinessIdAlert2: "Jos sinulla on tämän yrityksen nimenkirjoitusoikeus, otathan yhteyttä asiakaspalveluumme joko sähköpostitse (aspa@palkkaus.fi) tai puhelimitse (09 425 50603).", loginLink: "Voit kirjautua palveluun täältä.", loginLink2: "Kirjaudu palveluun", companyInfo: "Yrityksen perustiedot", companyBusinessId: "Y-tunnus", companyName: "Yrityksen nimi", businessIdPopOver: "Tarvitset käyttäjätilin luomiseen Y-tunnuksen. Jos käytät palveluamme yhdistyksen palkanmaksuun, yhdistyksellä on oltava Y-tunnus. Yhdistys voi hakea Y-tunnuksen tekemällä perustamisilmoituksen Verohallintoon (lomakkeella Y1).", companyName2: "Nimi", ytjSearchTitle: "YTJ-haku", ytjPopOver: "Voit hakea yrityksesi tiedot YTJ:stä Y-tunnuksen perusteella. YTJ on Patentti- ja rekisterihallituksen ylläpitämä tietokanta, johon tuodaan tietoja esimerkiksi kaupparekisteristä. Kirjoita Y-tunnuksesi, paina tätä nappia ja valitse yrityksesi hakutuloksista.", ytjSearchBtn: "Hae", ytjSearchBtn2: "YTJ:stä", companyInfoAlt: "Yrityksen tiedot", companyContact: "Yrityksen yhteystiedot", companyStreet: "Katusoite", companyPostalCode: "Postinumero", companyCity: "Postitoimipaikka", companyEmail: "Sähköposti", companyPhone: "Puhelinnumero", companyType: "Yritysmuoto", companyType2: "Yrityksen tyyppi", companyTypeFiOy: "Osakeyhtiö (Oy, Oyj, asunto-osakeyhtiö)", companyTypeFiTm: "Yksityinen elinkeinonharjoittaja (toiminimi tai maatalousyrittäjä)", companyTypeFiRy: "Yhdistys", companyTypeFiYy: "Muu (kommandiittiyhtiö, avoin yhtiö, säätiö, pankki, liikelaitos tai osuuskunta)", ytjSearchResultTitle: "YTJ-haun tulos", ytjSearchResultText: "Haullasi löytyi yksi tulos, organisaation tiedot täytetty automaattisesti kenttiin." }, stepCompanyLegal: { title: "Viranomaisten kysymykset", legalLegend: "Viranomaisten kysymykset", pep: "Onko yrityksen edustaja poliittisesti vaikutusvaltainen henkilö (PEP)?", pepTitle: "PEP", pepPopOver: "Jos olet jossain toisessa valtiossa poliittisesti vaikutusvaltainen henkilö tai lähipiiriisi kuuluu poliittisesti vaikutusvaltainen henkilö (Politically Exposed Person, PEP), laki edellyttää, että kerrot siitä meille ennen palvelun käytön aloittamista. Palvelun käyttöön tämä ei vaikuta.  Poliittisesti vaikutusvaltaiseksi henkilöksi ei Suomessa katsota suomalaista poliitikkoa, joka toimii Suomessa.", owner: "Omistaako joku henkilö vähintään 25% tästä yrityksestä suoraan tai välillisesti?", ownerTitle: "Tosiasialliset edunsaajat eli omistajat", ownerPopOver: "Lain mukaan tosiasiallisella edunsaajalla tarkoitetaan henkilöä, joka omistaa yli 25% yrityksen osakkeiden tai osuuksien tuottamasta äänimäärästä tai jolla on muutoin määräysvalta yrityksessä. Kysymme tätä tietoa, koska Finanssivalvonta ja rahanpesulaki velvoittavat meitä tuntemaan asiakkaamme.", procura: "Onko sinulla yrityksen tai yhdistyksen nimenkirjoitusoikeus?", procuraTitle: "Nimenkirjoitusoikeus", procuraPopOver: "Käyttääksesi palvelua, sinulla pitää olla yrityksen tai yhdistyksen nimenkirjoitusoikeus. Yleensä se on yrityksen toimitusjohtajalla ja hallituksen jäsenillä tai yhdistyksen hallituksen jäsenillä. Jos olet epävarma, tarkista asia yrityksen tai yhdistyksen johdolta.", procuraText: "Palvelun käyttöönotto edellyttää nimenkirjoitusoikeudellisen henkilön valtuutusta. Pyydä yrityksesi vastuullista henkilöä luomaan tili yritykselle tai ota yhteyttä asiakaspalveluumme.", shareHolderTitle: "Yrityksen omistajat", shareHolderText: "Seuraavat henkilöt omistavat vähintään 25% yhtiön osakkeista suoraan tai välillisesti", shareHolder: "Omistaja", fiva: "Miksi kysymme näitä tietoja?", fivaText: "Palkkaus.fi on maksupalvelun tarjoajia koskevassa Finanssivalvonnan (Fiva) rekisterissä. Laki edellyttää meiltä asiakkaan tuntemista. Siksi kysymme vielä seuraavat tiedot. Tiedot eivät ole julkisia ja voimme luovuttaa niitä vain voimassaolevan lainsäädännön velvoittamissa rajoissa." }, stepContract: { title: "Valtakirja", signatureText: "Jotta voimme hoitaa palkanmaksuun liittyviä velvoitteita ja maksuja, tarvitsemme siihen valtakirjan. Se pitää allekirjoittaa vain kerran.", selectBankText: 'Valitse pankkisi ja paina "Allekirjoita"-nappia. Siirryt VismaSign-palveluun ja teet allekirjoituksen verkkopankkitunnuksillasi. Tämän jälkeen palaat Palkkaus.fi-palveluun ja olet valmis maksamaan palkkaa.', signatureByPersonalIdText: 'Anna henkilötunnuksesi, valitse pankkisi ja paina "Allekirjoita"-nappia. Siirryt VismaSign-palveluun ja teet allekirjoituksen verkkopankkitunnuksillasi. Tämän jälkeen palaat Palkkaus.fi-palveluun ja olet valmis maksamaan palkkaa.', yourPersonalId: "Henkilötunnuksesi", personalIdExample: "PPKKVV-NNNX", selectBank: "Valitse verkkopankkisi", usePersonalBank: "Et voi käyttää yrityksen tai yhdistyksen tunnuksia valtakirjan allekirjoittamiseen. Allekirjoitus tehdään henkilökohtaisilla pankkitunnuksilla.", termsText: { html: ' Hyväksyn <a href="https://www.palkkaus.fi/kayttoehdot/" target="_blank">käyttöehdot</a>, ' }, termsText2: "valtakirjan", termsText3: { html: 'ja <a href="https://www.palkkaus.fi/sopimus-henkilotietojen-kasittelysta/" target="_blank">sopimuksen henkilötietojen käsittelystä</a>.' }, otherBanks: "Muut verkkopankit", privacyPolicy: { html: '<a href="https://www.palkkaus.fi/tietosuoja/" target="_blank">Lue palvelun tietosuojasta</a>' }, pdfPreviewTitle: "Valtakirjan esikatselu", downloadHereLink: "Lataa tästä, jos et näe esikatselua", pdfPreviewLink: "Valtakirjan esikatselu", signBtn: "Allekirjoita" } }, CustomerOnboardingComponent: { modalTitle: "Luo uusi yritystili", step: "Vaihe", steps: { newAccount: "Luo uusi yritystili", phase: "Vaihe", userInfo: "Yrityksen edustajan tiedot", companyInfo: "Yrityksen tiedot", legal: "Viranomaisten kysymykset", insurance: "Vakuutukset", ready: "Valmis tili" }, stepUserInfo: { title: "Yrityksen edustajan tiedot", userInfo: "Yrityksen edustajan tiedot", userFirstName: "Etunimi", userLastName: "Sukunimi", userEmail: "Sähköposti", userPhone: "Puhelinnumero", signeratureTitle: "Nimenkirjoitusoikeus", signeratureText: "Yrityksen edustajan tulee olla henkilö, jolla on yrityksen nimenkirjoitusoikeus. Yrityksen edustaja allekirjoittaa Palkanmaksun valtakirjan omilla pankkitunnuksillaan.", userPersonalId: "Henkilötunnus", businessId: "Y-tunnus", personalIdExample: "PPKKVV-NNNX", checkSignatureAlert: "Tarkista yrityksen edustajan nimenkirjoitusoikeus ennen palkanmaksun aloittamista." }, stepCompanyInfo: { title: "Yrityksen tiedot", existingCompanyAlert: "HUOM! Yrityksellä on jo Palkkaus.fi-tili. Varmista, että tilin omistaja on antanut sinulle valtuutuksen.", companyInfo: "Yrityksen perustiedot", companyBusinessId: "Y-tunnus", companyName: "Yrityksen nimi", companyInfoAlt: "Yrityksen tiedot", companyContact: "Yrityksen yhteystiedot", companyType: "Yritysmuoto", companyStreet: "Katusoite", companyPostalCode: "Postinumero", companyCity: "Postitoimipaikka", companyEmail: "Sähköposti", companyPhone: "Puhelinnumero", shareHolder: "Omistaja" }, stepCompanyLegal: { title: "Viranomaisten kysymykset", legalTitle: "Viranomaisten kysymykset", pep: "Onko yrityksen edustaja poliittisesti vaikutusvaltainen henkilö (PEP)?", pepTitle: "PEP", pepPopOver: "Jos olet jossain toisessa valtiossa poliittisesti vaikutusvaltainen henkilö tai lähipiiriisi kuuluu poliittisesti vaikutusvaltainen henkilö (Politically Exposed Person, PEP), laki edellyttää, että kerrot siitä meille ennen palvelun käytön aloittamista. Palvelun käyttöön tämä ei vaikuta.  Poliittisesti vaikutusvaltaiseksi henkilöksi ei Suomessa katsota suomalaista poliitikkoa, joka toimii Suomessa.", owner: "Omistaako joku henkilö vähintään 25% tästä yrityksestä suoraan tai välillisesti?", ownerTitle: "Tosiasialliset edunsaajat eli omistajat", ownerPopOver: "Lain mukaan tosiasiallisella edunsaajalla tarkoitetaan henkilöä, joka omistaa yli 25% yrityksen osakkeiden tai osuuksien tuottamasta äänimäärästä tai jolla on muutoin määräysvalta yrityksessä. Kysymme tätä tietoa, koska Finanssivalvonta ja rahanpesulaki velvoittavat meitä tuntemaan asiakkaamme.", shareHolderTitle: "Yrityksen omistajat", shareHolderText: "Seuraavat henkilöt omistavat vähintään 25% yhtiön osakkeista suoraan tai välillisesti:", shareHolder: "Omistaja", fiva: "Miksi kysymme näitä tietoja?", fivaText: "Palkkaus.fi on maksupalvelun tarjoajia koskevassa Finanssivalvonnan (Fiva) rekisterissä. Laki edellyttää meiltä asiakkaan tuntemista. Siksi kysymme vielä seuraavat tiedot. Tiedot eivät ole julkisia ja voimme luovuttaa niitä vain voimassaolevan lainsäädännön velvoittamissa rajoissa." }, stepInsurance: { title: "Palkanmaksun asetukset", pensionTitle: "Työeläkevakuutus (TyEL)", pensionText: "Onko yrityksellä jo voimassa oleva TyEL-sopimus?", hasPension: "Yritys voi aloittaa palkanmaksun palvelussa. TyEL tulee hoidetuiksi lain vaatimalla tavalla ns. tilapäisenä työnantajana automaattisesti. Jos palkkaat vakituisia työntekijöitä, niin voit ottaa TyEL-sopimuksen palvelussa myöhemmin.", pensionCompany: "Yhtiö", pensionContractNumber: "Sopimusnumero", testOnly: "Test only:", testGenerateNumberBtn: "Generoi numero", pensionContractNumberToolTip: { html: `Työeläkesopimuksen numero on 11 merkkiä pitkä ja se on muotoa:\r
  <strong>nn-nnnnnnnT</strong> (Varma, Ilmarinen, Elo tai Veritas) tai <br>\r
 <strong>nnnnn-nnnnT</strong> (Eläkekassa Verso, Apteekkien Eläkekassa tai Valion Eläkekassa)\r
 </span> jossa n on numero ja T on tarkistusmerkki (numero tai iso kirjain).\r
 <br>Viivan jälkeen voi lisätä nollia, jos loppuosa on lyhyempi.` }, pensionContractNumberTemporaryToolTip: { html: `Työeläkesopimuksen numero on 11 merkkiä pitkä ja se on muotoa:\r
  <strong>nn-nnnnnnnT</strong> (Varma, Ilmarinen, Elo tai Veritas) tai <br>\r
 <strong>nnnnn-nnnnT</strong> (Eläkekassa Verso, Apteekkien Eläkekassa tai Valion Eläkekassa)\r
 </span> jossa n on numero ja T on tarkistusmerkki (numero tai iso kirjain).\r
 <br>Viivan jälkeen voi lisätä nollia, jos loppuosa on lyhyempi.` }, insuranceTitle: "Työtapaturmavakuutus", insuranceText: "Onko yrityksellä jo tapaturmavakuutus työntekijöille?", insuranceCompany: "Yhtiö", insuranceContractNumber: "Sopimusnumero", noInsuranceAlert: "Huomio! Työtapaturmavakuutus on lain mukaan pakollinen, jos yritys maksaa työntekijöilleen palkkoja yhteensä vähintään 1400 € vuodessa.", pensionNotAutomated: "Valitettavasti palvelusta ei tility työeläkemaksut tähän työeläkeyhtiöön. Palkkaa voi maksaa ja teemme ilmoituksen tulorekisteriin. Työeläkeyhtiö laskuttaa yritystä työeläkemaksujen osalta.", pensionHandling: "TyEL-maksujen maksaminen", pensionSelfHandling: "Yritys/kirjanpitäjä hoitaa TyEL-maksut itse", pensionSelfHandleDescription: "Työeläkemaksu ei tility osana palkanmaksua palvelulle. Palvelu tekee ilmoituksen tulorekisteriin ja työeläkeyhtiö lähettää laskun työeläkemaksuista.", taxTitle: "Verohallinto", taxText: "Oletusarvoisesti Palkkaus.fi tekee ilmoituksen jokaisesta palkanmaksusta verottajalle sekä kuukausittaisen Työnantajan erillisilmoituksen. Teemme myös nollailmoituksen, jos kuussa ei ole palkanmaksua, mutta työnantaja on Työnantajarekisterissä ja on maksanut palkkoja viimeisen puolen vuoden aikana. Jos valitset 'Palkkaus.fi lähettää Erillisilmoituksen aina', niin teemme nollailmoituksen siinäkin tapauksessä, jossa työnantaja ei ole maksanut palkkoja viimeisen puolen vuoden aikana.", irReporting: "Kuukausittainen ilmoittaminen", irReportingDefault: "Palkkaus.fi hoitaa kaiken", irReportingNoMonthlyReport: "Palkkaus.fi ei lähetä Erillisilmoitusta", irReportingAlways: "Palkkaus.fi lähettää Erillisilmoituksen aina", employmentTitle: "Työttömyysvakuutus", employmentText: "Palkkaus.fi ei tilitä työttömyysvakuutusmaksuja vaan Työllisyysrahasto laskuttaa asiakasyritystä neljännesvuosittain tehtyjen tulorekisteri-ilmoitusten perusteella.", reportTitle: "Kirjanpitoraportin lähettäminen", reportText: "Anna tilitoimiston sähköpostiosoite kirjanpitoraportin automaattista lähettämistä varten", accountantEmail: "Sähköpostiosoite" }, stepInviteCompany: { title: "Kutsu yritys", html: `<p>Lähetä tästä kutsu sähköpostilla yrityksen vastuuhenkilölle. Kun hän on allekirjoittanut valtakirjan henkilökohtaisilla verkkopankkitunnuksillaan, palvelulla voi maksaa yrityksen palkkoja.</p>\r
<p>Valtakirjalla Palkkaus.fi voi hoitaa yrityksen puolesta palkanmaksuun liittyviä asioita mm. Verohallintoon, työeläkeyhtiöön ja Työttömyysvakuutusrahastoon liittyen.</p>\r
\r
 <p><strong>Lähetä tämä linkki valtakirjan allekirjoitukseen yrityksen edustajalle:</strong>\r
 <pre>{{sharingLink}}</pre>\r
 </p>\r
 <p>Voit myös klikata tästä avataksesi valmiin sähköpostipohjan sähköpostiohjelmassasi. HUOM: Tarkista teksti ja lisää loppuun oma viestisi.\r
 </p>\r
<a href="{{mailToLink}}">Kutsu yritys käyttämään palvelua</a>` }, newAccountBtn: "Luo toinen tili", invitation: { title: "Kutsu yritys", html: `<p>Lähetä tästä kutsu sähköpostilla yrityksen vastuuhenkilölle. Kun hän on allekirjoittanut valtakirjan henkilökohtaisilla verkkopankkitunnuksillaan, palvelulla voi maksaa yrityksen palkkoja.</p>\r
<p>Valtakirjalla Palkkaus.fi voi hoitaa yrityksen puolesta palkanmaksuun liittyviä asioita mm. Verohallintoon, työeläkeyhtiöön ja Työttömyysvakuutusrahastoon liittyen.</p>\r
\r
 <p><strong>Lähetä tämä linkki valtakirjan allekirjoitukseen yrityksen edustajalle:</strong>\r
 <pre>{{signingLink}}</pre>\r
 </p>` } }, ContactInfoComponent: { defaultContent: { html: `Palvelun käyttöohjeet ja usein kysytyt kysymykset löydät oikean alakulman Apua-painikkeen kautta. Voit myös lähettää viestin Palkkaus.fi:n asiakaspalveluun sen kautta. Tukisivustomme löytyy myös osoitteesta <a href="https://help.palkkaus.fi/hc/fi" target='_blank'>help.palkkaus.fi</a>` }, contactInfo: { html: "Voit laittaa sähköpostia asiakaspalveluumme osoitteeseen <strong>aspa@palkkaus.fi</strong> tai soittaa numeroon <strong>09 425 50603</strong>." }, shortContent: { html: "Palkankorjauksiin liittyvissä asioissa voit olla suoraan yhteydessä Palkkaus.fi:n asiakaspalveluun: <strong>aspa@palkkaus.fi</strong> tai <strong>09 425 50603</strong>." } }, BatchProcessComponent: { title: "Eräajo", processing: "Prosessoidaan...", employer: "Työnantaja", worker: "Työntekijä", status: "Tila", processed: "Prosessoitu", dialog: { done: "Valmis", processing: "Prosessoidaan", errors: "Virheitä", canceling: "Ajo peruttu!", count: "Lukumäärä", stopProcessing: "Keskeytä ajo!" } }, PayrollComponent: { newVersion: "Uusi versio", newVersionInfo: "Uusi versio: Käyttöliittymä isoille palkkalistoille", newPayrollInfo: { html: "Julkaisemme uuden version palkkalistasta, joka on suunniteltu käsittelemään <strong>jopa tuhansia palkkoja</strong> nopeasti ja tehokkaasti. Suosittelemme uutta versiota <strong>erityisesti, jos sinulla on yli 20 työntekijän palkkalistoja</strong>. Voit ottaa palkkalistan käyttöön kytkimestä oikealta yläkulmasta ja halutessasi vaihtaa takaisin vanhaan versioon. Asetus on selainkohtainen." }, payrollVersions: { header: "Palkkalistan versiot", html: `Olemme julkaisseet uudistuneen palkkalistan, mikä mahdollistaa entistä paremmin isojen palkkalistojen käsittelyn. Voit lukea uudesta palkkalistasta lisää täältä: <a href="https://help.palkkaus.fi/hc/fi/articles/21922663363997-Uusi-p%C3%A4ivitetty-palkkalista" target='_blank'>Uusi päivitetty palkkalista</a>. Halutessasi voit vaihtaa palkkalistan version oikean yläkulman kytkimestä. Asetus on selainkohtainen. Vanha palkkalista poistuu käytöstä syksyllä 2025. Suosittelemme lämpimästi uuden palkkalistan käyttämistä etenkin, jos maksat yli 20 palkkaa kerralla.` }, mergePayroll: { title: "Valitse tuotavat palkkalista", batchProcessTitle: "Yhdistetään palkkalistoja" }, calcViews: { rows: "Rivit", calculator: "Laskuri", costAccounting: "Kustannuspaikat", employment: "Työsuhde", reports: "Raportit" }, headerViews: { header: "Palkkalista", calculations: "Laskelmat", rows: "Rivit", reports: "Raportit", ports: "Vienti/Tuonti", messages: "Viestit" }, showEditEvent: { title: "Automaattinen palkkalista: Ajastus ja muistutukset" }, commitAllCalcs: { heading: "Tallennetaan laskelmia..." }, showDateRangeTitle: "Palkkakausi", showDateRangeDialogTitle: "Muutetaanko kaikki laskelmat?", showDateRangeDialogDescr: "Muutetaanko periodi kaikissa laskelmissa? Vaihtoehtona on vaihtaa periodi vain palkkalistaan ja jättää laskelmiin nykyiset päivämäärät.", showEditCalcDialog: "Muokkaa palkalaskelmaa", showEditWorkerDialogUpdating: "Päivitetään laskelmaa...", showNewTaxcardDialog: "Työntekijää ei ole valittuna tai työntekijällä ei ole henkilötunnusta.", importEmploymentDataAllAlertTitle: "Ei laskelmia", importEmploymentDataAllAlertDescr: "Palkkalistassa ei ole laskelmia. Työntekijöitä ei ole päivitetty.", importEmploymentDataAllConfirmTitle: "Päivitä laskelmat työsuhteen tiedoista", importEmploymentDataAllConfirmDescr: "Kaikkien laskelmien kaikki lisätyt rivit nollautuvat ja laskelmat päivittyvät suoraan työsuhteen tiedoista. Samalla päivittyvät myös ammattiluokka ja 'kuvaus palkkalaskelmaan'.", importEmploymentDataAllLoading: "Haetaan tietoja...", importEmploymentDataTitle: "Päivitä laskelma työsuhteen tiedoista", importEmploymentDataDescr: "Laskelman kaikki lisätyt rivit nollautuvat ja rivit päivittyvät suoraan työsuhteen tiedoista. Samalla päivittyvät myös ammattiluokka ja 'kuvaus palkkalaskelmaan'.", importEmploymentDataLoading: "Haetaan tietoja...", exportEmploymentDataTitle: "Vie rivit työntekijän tietoihin", exportEmploymentDataDescr: "Työsuhteen tietoihin tallennetaan tämän laskelman rivit ja ne tulevat jatkossa uusiin laskelmiin ja palkkalistoihin. Samalla päivittyvät myös ammattiluokka ja 'kuvaus palkkalaskelmaan'.", exportEmploymentDataLoading: "Viedään tietoja...", exportEmploymentDataAllAlertTitle: "Ei laskelmia", exportEmploymentDataAllAlertDescr: "Palkkalistassa ei ole laskelmia. Työntekijöitä ei ole päivitetty.", exportEmploymentDataAllConfirmTitle: "Vie rivit työntekijän tietoihin", exportEmploymentDataAllConfirmDescr: "Kaikkien laskelmien työsuhteen tietoihin tallennetaan tämän palkkalistan rivit. Tämän palkkalistan rivit tulevat siis jatkossa uusiin laskelmiin ja palkkalistoihin. Samalla päivittyvät myös ammattiluokka ja 'kuvaus palkkalaskelmaan'.", exportEmploymentDataAllLoading: "Viedään tietoja...", addSalaryDefaultsToAllCalcsAlertTitle: "Palkkalistassa ei ole laskelmia. Oletuspalkkarivejä ei ole päivitetty.", addSalaryDefaultsToAllCalcsTitle: "Päivitä oletuspalkkarivit työsuhteen tiedoista", addSalaryDefaultsToAllCalcsDescr: "Kaikkien laskelmien riveihin lisätään oletuspalkkarivit työsuhteen tiedoista.", createNewCalcLoading: "Luodaan laskelmia...", addExistingCalcCopy: "Valitse maksetut palkat (kopioidaan)", addExistingCalcMove: "Valitse luonnokset (siirretään)", addExistingCalcMoveShared: "Valitse lähetetyt (siirretään)", addExistingCalcLoading: "Siirretään laskelmia...", sendPayroll: "TODO: Palkkalistan lähetys", sendToProSending: "Lähetetään", sendToProSendingDescr: "Lähetetään palkkalistaa tilitoimistolle.", sendToProMessage: "Viesti yritykseltä: ", sendToProMessageChecked: "Yritys tarkistanut", createNewCalcDialog: "Valitse työntekijät", newEvent: { summaryPre: "Palkkalista: ", descriptionPre: "Toistuva palkkalista: ", createSummary: "Palkkalista luodaan", createDescription: "Automaattinen ajastus luo palkkalistan" }, payrollCalcs: { additionalInformation: "Lisätiedot", calcImport: "Laskelmien tuonti", toolbar: { addCalculation: "Lisää laskelma", addWorker: "Lisää työntekijä (uusi laskelma)", addDraft: "Lisää laskelmaluonnos", addShared: "Lisää lähetetty laskelma", mergeDraft: "Yhdistä laskelmaluonnos", mergeShared: "Yhdistä lähetetty laskelma", addCopy: "Lisää kopio maksetusta laskelmasta", addPayroll: "Yhdistä palkkalista", open: "Avaa", edit: "Muokkaa rivejä", save: "Tallenna muokatut", cancel: "Peruuta muutokset", close: "Sulje", nextPage: "Seuraava sivu", previousPage: "Edellinen sivu", nextCalc: "Seuraava laskelma", previousCalc: "Edellinen laskelma", searchByName: "Hae nimellä" }, placeholder: { title: "Aloita lisäämällä työntekijöitä tai laskelmia palkkalistaan" }, calculation: { actions: { toggle: "Sulje / avaa", options: "Valinnat", edit: "Muokkaa", editCalculation: "Muokkaa laskelmaa", editRows: "Muokkaa rivejä", openCalculator: "Avaa laskuri (uusi ikkuna)", openIrRows: "Avaa Tulorekisteri-rivit", save: "Tallenna", saveWorktime: "Päivitä lomat ja poissaolot", cancel: "Peruuta", rowsEmployment: "Palkkarivit Työsuhteen tiedoissa", import: "Tuo rivit: Työntekijä => Lista", delete: "Poista laskelma", deletePayrollCalc: "Poista palkkalistan laskelma", unlink: "Poista linkitys (käsittele erillisenä)", viewReports: "Katso koko laskelma", employerReport: "Työnantajan laskelma", paymentReport: "Yhteiskunnan laskelma", salarySlip: "Työntekijän laskelma", copyAsNew: "Kopioi laskelma ja käsittele erillisenä", pay: "Maksa tämä laskelma" }, workerInfo: { noIban: "Tilinumero puuttuu", editWorker: "Muokkaa työntekijää", noTaxcard: "Ei verokorttia", addTaxcard: "Lisää verokortti", salaryPeriod: "Palkkakausi:", salaryPeriodDaysCount: "päivää", taxPercent: "veroprosentti" } }, deleteCalcDialog: { heading: "Poista laskelma?", introChanges: "Haluatko varmasti poistaa palkkalaskelman? HUOM: Sinulla on tallentamattomia muokkauksia. Tallenna muokkaukset ennen laskelman poistamista.", introNoChanges: "Haluatko varmasti poistaa palkkalaskelman?", cancelButton: "Peruuta", confirmButton: "Poista", loading: "Poistetaan laskelmia..." }, unlinkCalcDialog: { heading: "Poista laskelman linkitys?", intro: "Haluatko varmasti poistaa palkkalaskelman linkityksen? HUOM: Muutokset palkkalistaan tallentuvat samalla.", cancelButton: "Peruuta", confirmButton: "Poista linkitys", loading: "Poistetaan laskelman linkitystä..." }, calcRowEditor: { title: "Laskelman rivit" }, payrollTotals: { finalCost: "Kokonaiskustannus:", grossSalary: "Bruttopalkka:", totalPayment: "Maksetaan nyt:" }, taxCard: { taxCardChecked: "Verokortti on tarkistettu", refreshAutoTaxCard: "Tarkista autom. verokortti" }, validation: { noValidationFound: "Virhe: Validointia ei löytynyt." } }, payrollEdit: { toolbar: { options: "Valinnat", importEmploymentCalc: "Päivitä kaikille laskelmille työntekijöiden tiedot ja palkkarivit", addSalaryDefaults: "Lisää oletuspalkkarivit", copyAsNew: "Kopioi uudeksi", cancel: "Peruuta muutokset", delete: "Poista", save: "Tallenna", saved: "Tallennettu", sendPayroll: "Lähetä palkkalista", showWorkflowMessage: "Lisää viesti tilitoimistoon", showWorkflowMessageOff: "Poista tilitoimiston viesti", createSchedule: "Ajasta", editSchedule: "Ajastettu (muokkaa)", showPaymentInfo: "Näytä maksun tiedot", workFlowMessage: "Viesti tilitoimistoon" }, payrollInfo: { readyForPayment: "valmis maksuun", notReadyForPayment: "tarkista laskelmat", salaryPeriod: "Palkkakausi", salaryPeriodDaysCount: "päivää", salaryDate: "Palkkapäivä", salaryDateEstimate: "arvio", salaryDateNote: "huom!", wageBasis: "Palkan peruste", calcCount: "Laskelmia", finalCost: "Kokonaiskustannus", grossSalary: "Bruttopalkka", totalPayment: "Maksetaan nyt", template: { html: "Perustuu <a ng-href=#/payroll/details/{{ template }}>toistuvaan palkkalistaan</a></span>" }, reporting: "Raportointi", costCenter: "Kustannuspaikka", scheduling: "Ajastus" }, editProperties: { title: "Otsikko", status: "Status", wageBasis: "Työsuhteen tyyppi (lomalaskennassa)", wageBasisUndefined: "Ei määritelty", salaryDate: "Palkkapäivä", salaryPeriod: "Palkkakausi", salaryPeriodDaysCount: "päivää", paymentChannel: "Maksumenetelmä", new: { heading: "Luo uusi palkkalista", intro: "Luo eri palkkalistat kuukausi- ja tuntipalkkaisille (työsuhteen tyyppi). Tulemme käyttämään tätä jaottelua tulevien versioiden lomalaskennassa.", copyingCalcs: "Kopioidaan laskelmia", updateCalcs: "Päivitä laskelmat", updateCalcsTrue: "Älä päivitä: Pidä palkkalistan tiedot", updateCalcsFalse: "Päivitä tiedot työsuhteista", createPayrollButton: "Luo palkkalista", updateReports: "Päivitä raportit", importRowsToPayroll: "Tuo rivejä palkkalistalle", downloadPayrollRowsToExcel: "Lataa palkkalistan rivit Exceliin" } }, tabs: { editProperties: "Perustiedot", calculations: "Laskelmat", holidays: "Lomat", absences: "Poissaolot", reports: "Raportit" }, buttons: { updateHolidaysAndAbsences: "Päivitä lomat ja poissaolot laskelmaan" } }, payrollPayButton: "Siirry maksamaan", payrollCommentButton: "Kommentoi", payrollList: { createNew: "Luo uusi", intro: "Palkkalistan avulla voi maksaa useita palkkoja kerralla.", introWithVideo: { html: 'Palkkalistan avulla voi maksaa useita palkkoja kerralla. Katso ohje <a href="https://youtu.be/FQJ-l6pDWEU" target="_blank" class="btn-link">videolta</a> (youtube).' }, info: { html: "Tuomme vuoden loppuun mennessä toistuvat palkkalistat, jotka palvelu luo automaattisesti valitun aikataulun mukaisesti." }, tabs: { latest: "Viimeisimmät palkkalistat", repeated: "Toistuvat palkkalistat", paid: "Maksettu", paidSalaries: "Maksetut palkat", draftCalcs: "Keskeneräiset laskelmat" } }, validate: { validating: "Tarkistetaan palkkalaskelmia...", isReadyForPayment: "Palkkalista on valmis maksuun", notReadyForPayment: "Laskelmissa on ongelmia, katso alla", noTel: "Ei puhelinnumeroa", noIban: "Ei tilinumeroa", noTaxcard: "Ei verokorttia", noWorker: "Työntekijä puuttuu", editWorker: "Muokkaa työntekijää", addWorker: "Lisää työntekijä", addWorkerTaxcard: "Lisää työntekijälle verokortti", viewCalculation: "Katso koko laskelma", total: "Yhteensä", totalGrossSalary: "Bruttopalkka", totalPayment: "Maksetaan nyt" }, edit: { createNew: "Luo uusi lista", info: "Listan perustiedot", rows: "Palkkalistan rivit", next: "Jatka (rivit)", removeRows: "Poista valitut rivit", import: "Tuo aineisto", importPalkka: "Tuo Palkka.fi-aineisto", validate: "Tarkista", paste: "Liitä (copy-paste)", instructions: "Ohjeet" }, editGrid: { worker: "Työntekijä", createWorker: "Luo työntekijä", taxcard: "Verokortti", ssNumber: "Hetu / Palkkaus.fi-ID", type: "Tyyppi", amount: "Määrä", price: "Hinta", total: "Yhteensä", description: "Kuvaus" }, editProperties: { title: "Otsikko", period: "Palkkakausi", paymentDate: "Palkkapäivä", paymentDateAlt: "Maksupäivä", startDate: "Alku", startDateAlt: "Palkkakauden alku", endDate: "Loppu", endDateAlt: "...loppu", workDays: "Työpäivien määrä" } }, PayrollListComponent: { readyForPayment: "Valmis maksuun", notReadyForPayment: "Tietoja puuttuu", latestPayrolls: "Viimeisimmät palkkalistat", templates: "Toistuvat pohjat (templates)", description: "Kuvaus", salaryDate: "Palkkapäivä", status: "Status", period: "Palkkakausi", paymentDate: "Maksupäivä", dueDate: "Eräpäivä", calculations: "Palkkalaskelmat", grossSalaries: "Bruttopalkat", calendarEvent: "Ajastettu", calendarOccurence: "Luotu ajastuksessa", template: "Toistuva palkkalista", noSalaryDate: "Ei palkkapäivää" }, EmploymentContractsComponent: { employmentStart: "Työsuhteen alku", end: "loppu", phone: "Puh", editWorker: "Muokkaa työntekijää", addIban: "Lisää tilinumero" }, CalcDetailsComponent: { classic: "Palkkalaskuri", pro: "Tilitoimistolaskuri" }, ShopCardsComponent: { intro: "Palkanmaksun palvelut" }, LanguageSelectionComponent: { panelTitle: "Kielivalinta", languageSelectionLabel: "Kieli:", changeLanguage: "Vaihda kieli", changeLanguageInfo: "Voit vaihtaa tästä käyttöliittymän kielen tämän istunnon ajaksi, jos haluat testata muita kieliversioita.", changeCompanyDefaultLanguage: "Vaihda yhtiön oletuskieli", changeCompanyDefaultLanguageInfo: "Voit vaihtaa tästä yhtiön oletuskielen kaikille yrityksen käyttäjätunnuksille (Palkkaus.fi yrityksen käyttöliittymä) ja rekisteröimättömille työntekijöille.", warning: { html: "<strong>HUOM:</strong> Kielen vaihtaminen vaihtaa myös kaikkien rekistereröimättömien työntekijöiden oletuskielen (esim. palkkalaskelma PDF ja sähköpostit)." } }, WorkerInfo: { noSelection: "Työntekijää ei ole valittu", ibanOk: "Tilinumero OK", noIbanNumber: "Ei tilinumeroa" }, DateRange: { labelDaysCount: "Päivien määrä", labelStartAndEndDate: "Alku- ja loppupäivät", salaryPeriod: "Palkkakausi", startDate: "Alkupäivä", endDate: "Loppupäivä", otherMonth: "Muu kuukausi", periodStartDateError: "Syötä muodossa 'pv.kk.'", periodStartDateError2: " ei ole päivämäärä." }, CalcRowsComponent: { editor: { action: "Toiminto", addNewRow: "Lisää uusi rivi", amount: "Määrä", price: "Hinta", total: "Yhteensä", calcRow: "Palkkarivi", calcRowTypePlaceholder: "Valitse rivin tyyppi tai...", totals: { total: "Yhteensä", grossTotal: "Bruttopalkka", netSalary: "Nettopalkka", finalCost: "Kokonaiskustannus", totalPayment: "Nyt maksetaan" }, buttons: { readMore: "Lue lisää", okIcon: "Ok", cancelIcon: "Peruuta", editIcon: "Muokkaa riviä", deleteIcon: "Poista rivi", infoIcon: "Katso tiedot" }, validation: { edit: "Muokkaa", note: "HUOM:" } }, editDialog: { showInfo: "Näytä ohje", hideInfo: "Piilota ohje", incomeTypesInfo: "Palkkalajiin liittyvät tulolajit", unionPayment: { label: "Maksun tyyppi", enumOther: "Yleinen", fixedSum: "Kiinteä summa", fixedSumTrue: "Kyllä: älä päivitä palkkasummasta.", minimumPayment: "Jäsenmaksun vähimmäismäärä, euroa", maximumPayment: "Jäsenmaksun enimmäismäärä, euroa" }, carBenefit: { carBenefitCode: "Autoedun tyyppi", ageGroupCode: "Auton ikäryhmä", kilometersBased: "Kilometripohjainen", kilometersBasedTrue: "Kyllä: autoetu lasketaan kilometrien perusteella (ajopäiväkirjasta).", kilometers: "Kilometrit", emissionsValue: "Auton päästöarvo (0-100)", deduction: "Vähennys palkasta" }, subsidisedCommute: { info: { html: " <b>HUOM:</b> Tämä Työsuhdematkalippu-laskuri tukee vain vuoden ainoata / ensimmäistä työsuhdematkalippua. Jos syötät toista lippua, käytä Tulorekisteri-välilehteä. Tuomme uuden version pian." }, subsidisedCommuteKind: "Vähennys työntekijän palkasta", deduction: "Palkasta peritty korvaus", taxable: "Palkaksi katsottu osuus", taxfree: "Verovapaa osuus", periodDivider: "Kausien määrä (oletus 12kk)" }, bicycleBenefit: { bicycleBenefitKind: "Vähennys työntekijän palkasta", deduction: "Palkasta peritty korvaus", taxable: "Palkaksi katsottu osuus", taxfree: "Verovapaa osuus", periodDivider: "Kausien määrä (oletus 12kk)" }, nonProfitOrg: { profitOrgKind: "Korvauksen tyyppi" }, dailyAllowance: { allowanceKind: "Korvauksen tyyppi", internationalDailyAllowanceCount: "Päivärahojen enimmäismäärät" }, mealBenefit: { mealBenefitKind: "Edun tyyppi", mealPrice: "Korvaus / ateria", mealTaxablePrice: "Verotusarvo / kpl", mealTicketPrice: "Nimellisarvo / kpl", mealPriceAmount: "Verotusarvo yhteensä", workerDeduction: "Peritäänkö työntekijältä korvausta ravintoedusta?", taxValueTrue: "Työntekijältä peritään verotusarvon määrä", taxValueFalse: "Työntekijältä ei peritä korvausta lainkaan tai muu määrä kuin verotusarvo", isTaxValueDeductionDone: "Verotusarvoa vastaava vähennys", isTaxValueDeductionDoneTrue: "Ei vähennetä tällä laskelmalla", isTaxValueDeductionDoneFalse: "Vähennetään tällä laskelmalla", deduction: "Määrä yhteensä, joka peritään työntekijältä" }, remuneration: { remunerationKind: "Tulolaji" }, otherCompensation: { compensationKind: "Tulolaji" }, workingTimeCompensation: { compensationKind: "Tulolaji" }, employmentTermination: { employmentTerminationKind: "Tulolaji" }, paidSickLeave: { paidSickLeaveKind: "Palkan/palkkion laji" }, training: { trainingKind: "Palkan/palkkion laji" }, additionalRows: { description: "Kuvaus", additionalRow: "Lisärivi palkkalaskelmaan" }, milageOwnCar: { vehicleType: "Kulkuneuvon tyyppi", additions: "Lisät", passangerCount: "Lisähenkilöiden määrä" }, buttons: { save: "OK", cancel: "Peruuta", delete: "Poista", close: "Sulje" }, accounting: { vatPercent: { label: "Arvonlisävero-%" }, vatPercents: { p255: { label: "25,5 % - Yleinen verokanta", description: "Yleinen verokanta. Tämä on useimpien tavaroiden ja palveluiden verokanta." }, p24: { label: "24 % - Yleinen verokanta", description: "Yleinen verokanta. Tämä on useimpien tavaroiden ja palveluiden verokanta." }, p14: { label: "14 % - Elintarvikkeet, ravintola- ja ateriapalvelut", description: "Elintarvikkeet, rehut, ravintola- ja ateriapalvelut. Huomaa, että alempi 14 %:n verokanta ei koske alkoholijuomien ja tupakkatuotteiden myyntiä eikä tarjoilua." }, p10: { label: "10 % - Kirjat, kulttuuri, henkilökuljetus ja majoitus", description: "Kirjat, sanoma- ja aikakauslehdet, lääkkeet, liikuntapalvelut, elokuvanäytökset, kulttuuri- ja viihdetilaisuuksien sisäänpääsymaksut, henkilökuljetukset, majoituspalvelut, televisio- ja yleisradiotoiminnasta saadut korvaukset." }, p0: { label: "0 % - Nollaverokanta", description: "Arvonlisäverottomien vesialusten myynti, vuokraus ja rahtaus sekä näihin aluksiin kohdistuvat työsuoritukset, jäsenlehtien ja mainosten veroton myynti yleishyödyllisille yhteisöille, varastointimenettelyihin liittyvä veroton myynti (verovarasto alvissa), vienti EU-alueen ulkopuolelle, tavaran myynti EU-maihin arvonlisäverovelvollisille ostajille (ohje alv eu-tavarakaupassa), muut kansainväliseen kauppaan liittyvät tavaroiden ja palvelujen myynnit, esim. veroton myynti diplomaateille ja kansainvälisille järjestöille." }, pempty: { label: "Arvonlisäveroa ei määritetty" } }, vatPercentsTable: { taxableAmountInPercent: "Verollinen summa prosenteittain", vatRate: "Verokanta", exemptFromTaxation: "Veroton", tax: "Vero", taxable: "Verollinen" }, date: "Päivämäärä" }, receiptUrlAddress: "Kuitin URL-osoite", unionPaymentLabel: "Jäsenmaksu", raksaInfo: "Käytössä toistaiseksi vain näissä palveluissa: Rakennusliitto", percentOfSalary: "Prosenttia palkasta", unionPaymentCount: "Jäsenmaksun määrä", underTaxSalary: "Ennakonpidätyksen alainen palkka", fillUnionPaymentInformation: "Täytä ammattiyhdistyksen nimi ja pankkitili, jos sinulla on käytössä maksuaineiston luonti. Viitetiedon voit syöttää käsin tai käyttää automaattisesti palkanmaksukuukauden ja hetun:n perusteella luotua viitenumeroa.", unionLabel: "Ammattiyhdistys", unionIbanLabel: "Pankkitili (iban) maksun luontia varten", unionReferenceNumberLabel: "Pankkiviite maksun luontia varten", foreclosureKindLabel: "Summan määräytyminen", foreclosurePeriodLengthLabel: "Palkanmaksukauden pituus", foreclosureprotectedPortionBaseLabel: "Velallisen suojaosuus", foreclosureprotectedPortionDependantLabel: "Suojaosuuden lisä/huollettava", foreclosuredependantsCountLabel: "Huollettavien määrä", foreclosureincomeFromOtherSourcesLabel: "Muualta saatu tulo/kk", foreclosureadditionalAmountLeftToDebtorLabel: "Velalliselle jätettävä määrä/kk", foreclosureReferenceNumberInfo: "Täytä pankkiviitetiedot, jos sinulla on käytössä maksuaineiston luonti.", foreclosureReferenceNumberLabel: "RF-pankkiviite maksun luontia varten", hourlySalaryWithWorkingTimeCompensationRowLabel: "Lisä", totalWorkerPaymentKindLabel: "Summan sisältämät erät", totalWorkerSumLabel: "Summa", totalWorkerCalculationRowTypeLabel: "Palkkalaji", totalWorkerCalculationMessage: "Palkkarivin kuvaus", WorkingTimeCompensationKind: "Tuntipohjainen korvaus", hourlySalaryWithWorkingTimeCompensationRowMessageLabel: "Lisän kuvaus", hourlySalaryWithWorkingTimeCompensationRowCountLabel: "Lisätunnit" }, irRows: { headerIrCode: "Tulorekisteri-koodi", headerRowDescription: "Rivin kuvaus", headerCalc: "Laskelma", headerSum: "Summa", updateCalc: "Päivitä laskelma", addNewRow: "Lisää uusi rivi", chosenRowInfo: "Valitun rivin tiedot", chooseRowOrAddNew: "Valitse rivi talukosta yllä tai lisää uusi nähdäksesi yksityiskohdat tässä.", basicInfo: "Perustiedot", textAndType: "Teksti ja tyyppi", typeLabel: "Tyyppi", messageLabel: "Viesti", groupingLabel: "Ryhmittely", baseSalary: "Peruspalkka", benefits: "Luontoisedut", deductions: "Vähennykset", disabled: "Ei käytössä", expenses: "Kulukorvaukset", otherNoPayment: "Muu - ei maksua", salaryAdditions: "Palkan lisät", totals: "Summat ja ryhmittelyt", creditTransferLabel: "Maksu asiakasvaratilille", payment: "Maksetaan", deduction: "Vähennetään", noPayment: "Ei maksua", calc: "Laskelma", countLabel: "Määrä", unitLabel: "Yksikkö", priceLabel: "Hinta", totalLabel: "Yhteensä", carBenefitInfo: "Autoedun lisävalinnat", carBenefitInfoHtml: "<strong>HUOM:</strong> Muistathan lisätä myös rivin<br />'Autoedusta peritty korvaus (401)'.", carBenefitTypeLabel: "Autoedun tyyppi", carBenefitAgeGroupLabel: "Ikäryhmä", carBenefitKilometersLabel: "Kilometrit", carBenefitEmissionsValueLabel: "Auton päästöarvo (0-100)", dailyAllowanceAdditionalSelections: "Päivärahan lisävalinnat", dailyAllowanceTypeLabel: "Päivärahan tyyppi", mealBenefitAdditionalSelections: "Ravintoedun lisävalinnat", mealBenefitTaxInfo: "Valitse, jos työntekijältä peritty korvaus vastaa verotusarvoa.", mealBenefitIsTaxValueLabel: "Vastaa verotusarvoa", irFlagsInfo: "Lisävalinnat ja ansaintakausi", irFlagsLabel: "Lisävalinnat", negativeSupportedLabel: "Miinusmerkkinen arvo", allowed: "Sallittu", notAllowed: "Ei sallittu", earningPeriod: "Ansaintakausi", earningPeriodInfo: "Ansaintakausi (tulon ansainta-/kertymä aika) voi olla eri kuin palkanmaksukausi. Ansaintakausi on ajanjakso, jolta tulo on kertynyt. Ansaintakausi voi olla pidempi tai lyhyempi kuin palkanmaksukausi, esimerkiksi vuoden pituinen tai pidempi.", earningPeriodStartDateLabel: "Ansaintakauden alkamispäivä", earningPeriodEndDateLabel: "Ansaintakauden päättymispäivä", taxAndSideCosts: "Ennakonpidätys ja vakuutukset", tax: "Ennakonpidätys", withheld: "Pidätetään", deductionAlt: "Vähennys", notwithheld: "Ei pidätystä", socialSecurityPayment: "Maksettava sosiaalivakuutusmaksu", toBePaid: "Maksetaan (oletus)", occupationPension: "Työeläkemaksu", insurancePayment: "Tapaturmavak. maksu", unemploymentInsurancePayment: "Työttömyysvakuutusmaksu", healtInsurancePayment: "SAVA-maksu", insuranceInformationAllowed: "Vakuutustiedolle ei voi asettaa poikkeusta tälle tietotyypille", IrInsuranceExceptions: "Vakuutuksen poikkeukset", textAndIncomeType: "Teksti ja tulolaji", incomeTypeLabel: "Tulolaji", paymentToCreditTransferLabel: "Maksu asiakasvaratilille" } }, CalcRowTypeComponent: { rowType: "Rivin päätyyppi", rowDescription: "Kuvaus", rowTypeEn: "type", rowKind: "Alalaji", rowKindEn: "kind", wageType: "Palkkalaji" }, CalcRowDocumentationComponent: { noExamplesForRowType: "Tälle palkkalajille ei ole esimerkkejä", noExamplesForRowTypeSubtype: "Valitun palkkalajin alalajille ei ole esimerkkejä" }, ODataImportComponent: { heading: "Tietojen tuonti", step1: { pasteFromDesktop: "Liitä työpöydältä", downloadFile: "Lataa tiedosto", copyExcelFileFromClipboard: "Kopioi Excel-taulukko leikepöydältä (COPY-PASTE)" }, step2: { error: "Tiedoissa on virheitä", emptyRow: "tyhjää riviä", chooseMaterial: "Valitse aineisto", chooseFiletype: "Valitse tiedostotyyppi" }, step3: { error: "Validointi huomasi virheitä, katso rivikohtaiset virheilmoitukset alla.", check: "Tarkista", okey: "Ok" }, step4: { error: "Tallennuksessa tapahtui virheitä, katso rivikohtaiset virheilmoitukset alla", okey: "Ok" } }, ODataExportComponent: { heading: "Tietojen vienti", createMaterial: "Luo aineisto", rows: "riviä" }, ActionButtonComponent: { createNewWorker: "Luo uusi työntekijä", newWorker: "Uusi työntekijä", createWorker: "Luo työntekijä", createNewPayroll: "Luo uusi palkkalista", createPayroll: "Luo palkkalista", newPayroll: "Uusi palkkalista", createCalculation: "Luo palkkalaskelma", newCalculation: "Uusi palkkalaskelma", newCalculationAlt: "Uusi laskelma", createNewCalculation: "Luo uusi palkkalaskelma", createCalculationForWorker: "Luo laskelma työntekijälle", newMessage: "Uusi viestiketju", sendTaxcard: "Lähetä verokortti", startNewMessage: "Aloita uusi viestiketju", addCalcTypes: "Lisää laskelmatyyppejä", commonCalc: "Yleinen laskuri", historicalCalc: "Historiallinen laskuri", sendTaxCard: "Lähetä verokortti", error: "Virhe: tuntematon toiminta nappulalle", newRepair: "Uusi korjaus" }, ImportComponent: { dataImport: "Tietojen tuonti", pasteFromDesktop: "Liitä työpöydältä", downloadFile: "Lataa tiedosto", copyExcelFromClipBoard: "Kopioi Excel-taulukko leikepöydältä (COPY-PASTE)", step1: { next: "Asetukset (seuraava)" }, step2: {}, step3: {}, step4: {} }, PayerSummaryComponent: { common: { addScheduling: "Ajasta lähetys", removeScheduling: "Poista ajastus", cancel: "Mitätöi", validate: "Validoi", basicInfo: "Perustiedot", payer: "Maksaja", payerInfo: "Ilmoitettavat tiedot", noErrors: "Ei virheitä", rowsTitle: "Rivit", historyTitle: "Historia", calculationsTitle: "Palkkalaskelmat", deliveryDataTitle: "Aineiston tiedot", deliveryDataCreator: "Aineiston muodostaja (Palkkaus.fi)", deliveryDataSender: "Aineiston lähettäjä (Palkkaus.fi)", deliveryDataOwner: "Aineiston omistaja", payerTitle: "Maksajan tiedot", payerAddressTitle: "Maksajan osoite", sendFailureTitle: "Lähetys epäonnistui", validationErrorText: "Ilmoituksella on validointivirheitä eikä sitä voida lähettää. Korjaa virheet ja yritä uudelleen.", replacementFailureText: "Ilmoitusta ei voida lähettää korvaavana. Mitätöi ja lähetä uudelleen.", loaderTextSending: "Lähetetään...", loaderTextValidating: "Validoidaan...", loaderTextWait: "Odota...", loaderTextCanceling: "Mitätöidään...", loaderTextRemoving: "Poistetaan..." }, transactions: { incomeTypes: "Tulolajit", incomeType: "Tulolaji", count: "Määrä" } }, PayCertificateComponent: { step: "Vaihe", choose26Weeks: "Valitse 26 viikkoa", choose34Weeks: "Valitse 34 viikkoa", clear: "Tyhjennä", creatingPayCertificate: "Palkkatodistusta luodaan...", payCertificateReadyForDownload: "Palkkatodistus on valmis ladattavaksi", open: "Avaa", payCertificate: "Palkkatodistus", createNewPayCertificate: "Luo uusi palkkatodistus", alertHeading: "Palkkatodistuksessa on kohtia, jotka vaativat lisähuomiota", wizard: { stepSelectWorkerTitle: "Työntekijän valinta", stepSelectPeriodCalcsTitle: "Valitse kauden laskelmat", stepAdditionalInfoTitle: "Lisätiedot ja tulostettava PDF" } }, ServiceModelsComponent: { serviceModel: "Palvelumalli", defaultModel: "Vakiomalli", nameless: "Nimetön" }, ServiceModelDetailsComponent: { name: "Nimi", basicInfo: "Perustiedot", exports: "Maksu ja kirjanpito", branding: "Brändäys", sitemap: "Sivuston rakenne", messaging: "Viestintä", i18n: "Tekstit", workflow: "Työnkulku", usecases: "Räätälöinnit", serviceModelTitle: "Palvelumalli", serviceModelId: "ID", serviceModelIcon: "Palvelumallin ikoni", productPackageTitle: "Tuotepaketti", productBasic: "Tilitoimisto Basic", productBasicInfo: { html: "<p><b>Sisältää tilitoimiston, yrityksen ja työntekijän käyttöliittymät</b></p><p>Ominaisuudet:</p><ul><li>Palkanlaskenta (tilitoimisto)</li><li>Tulorekisteri</li></ul>" }, productPro: "Tilitoimisto PRO", productProInfo: { html: "<p><b>Ominaisuudet Basic-paketin lisäksi</b></p><ul><li>Viestintä</li><li>Aineistonvälitys</li><li>Työnkulun hallinta</li><li>Massanäkymät ja tilitoimistotyökalut</li><li>Automaatio ja ajastus</li><li>Oma brändi (white label)</li></ul>" }, productSelfService: "Yritys itsepalvelu", productSelfServiceInfo: { html: "<p><b>Yritys voi helppokäyttöisellä laskurilla laskea ja maksaa palkat itse.</b></p><p>Ominaisuudet:</p><ul><li>Maksuliikenne (palkat halutessaan yhdellä maksulla)</li><li>Automaattinen tulorekisteri-ilmoitus</li></ul>" }, endUserPricing: "Loppuasiakkaan hinnoittelu / laskutus", paymentChannelsTitle: "Maksukanavat", customPaymentChannels: "Räätälöidyt maksukanavat käytössä", defaultChannel: "Oletuskanava", accountingTarget: "Kirjanpitokohde", accountingTitle: "Kirjanpito", customAccounting: "Räätälöity kirjanpito käytössä", customCostAccounting: "Räätälöidyt laskentakohteet käytössä", customHoliday: "Räätälöity lomalaskenta käytössä", defaultTarget: "Oletuskohde", webAppTitle: "Sivusto", reportingTitle: "Tulosteet", customReporting: "Räätälöidyt tulosteet käytössä", layoutTemplateId: "Ulkoasun tunniste", customReportLogo: "Logo (SVG tai data URI)", templateIdPalkkaus: "Palkkaus.fi", templateIdNoLogo: "Ilman logoa", templateIdLogo: "Yrityksen oma logo", templateIdTalenom: "Talenom Kevytyrittäjä", templateIdTilijaska: "Tilijaska", templateIdTreamer: "Treamer", brandingTitle: "Palkkaus.fi ulkoasu", sitemapTitle: "Navigaatio", hidden: "Piilotettu", readOnly: "Vain luku", url: "Osoite", messagingTitle: "Viestintä", messagingActive: "Viestitoiminto käytössä", workflowTitle: "Työnkulut ja ajastukset", workflowInfo: { html: " <p><strong>Tulossa:</strong>Laajemmat mahdollisuudet määrittää työnkulkuja, ajastuksia jne. myös palvelumallissa. Nykyisessä versiossa:</p><ul><li>Ajastukset määritetään yhtiökohtaisesti</li><li>Työnkulkuja voi muokata räätälöinneillä</li></ul>" }, customUsecases: "Räätälöinnit käytössä" }, SigningComponent: { welcome: "Palkanlaskennan käyttöönotto", customerAuthorizationIntro: "Tilitoimistosi hoitaa palkanlaskennan Palkkaus.fi-palvelun avulla. Palvelun käyttöönottoa varten sinun tulee allekirjoittaa sähköinen valtakirja. Se hoituu helposti tästä pankkitunnuksilla.", heading: "Ota palkat käyttöön allekirjoittamalla valtakirja", accountantSigningAlert: "Ota palvelu käyttöön rekisteröitymällä tilitoimistona ja aloita hoitamaan asiakkaittesi palkanmaksuja.", accountantSigningSuccessAlert: "Sulje tämä ikkuna ja päivitä tilitoimiston rekisteröitymissivu.", accountantMissingCustomersAlert: "Sinulla ei vielä ole asiakkaita hoidettavana.", signerInformation: "Allekirjoittajan tiedot", name: "Nimi", email: "Sähköposti", tel: "Puhelinnumero", ssNumber: "Henkilötunnus", isProcuraLabel: "Nimenkirjoitus­oikeus", isProcuraLabelTrue: "Minulla on yrityksen / yhdistyksen nimenkirjoitusoikeus.", signBtn: "Allekirjoita", attorney: { info: "Valtakirjaan tarvittavat tiedot", infoText: "Jotta palkanmaksuun liittyviä velvotteita voidaan hoitaa puolestasi, sinun täytyy allekirjoittaa", linkText: "oheinen valtakirja", linkTextInfo: "Valtakirja pitää allekirjoittaa vain kerran.", signingConfirmationInfo: "Kun olet kirjoittanut nimesi ja henkilötunnuksesi ja klikannut pankkisi logoa, siirryt pankkisi verkkopalveluun, jossa sinut tunnistetaan sähköisesti. Tunnistautumisen jälkeen palaat takaisin ja allekirjoitat valtakirjan. Tämän jälkeen palkanlaskenta on aktivoitu." }, salaryPaymentContactInformation: "Yhteystiedot palkanmaksuasioissa", salaryPaymentContanctInformationToAuthoritiesInfo: "Yhteystiedot voidaan välittää viranomaisille.", contactPersonLabel: "Yhteyshenkilö", contactPersonLabelTrue: "Olen myös yhteyshenkilö yrityksen palkanmaksuasioissa.", postalAddress: "Postiosoite", streetAddress: "Katuosoite", postalNumber: "Postinumero", postOffice: "Postitoimipaikka", authoritativeQuestions: { title: "Viranomaisten kysymykset", politicalPerson: "Oletko poliittisesti vaikutusvaltainen henkilö (PEP)?*", politicalPersonPopover: "Jos olet jossain toisessa valtiossa poliittisesti vaikutusvaltainen henkilö tai lähipiiriisi kuuluu poliittisesti vaikutusvaltainen henkilö (Politically Exposed Person, PEP), laki edellyttää, että kerrot siitä meille ennen palvelun käytön aloittamista. Palvelun käyttöön tämä ei vaikuta.  Poliittisesti vaikutusvaltaiseksi henkilöksi ei Suomessa katsota suomalaista poliitikkoa, joka toimii Suomessa.", companyOwnership: "Omistaako joku henkilö vähintään 25% tästä yrityksestä suoraan tai välillisesti?*", companyOwnershipPopoverTitle: "Tosiasialliset edunsaajat eli omistajat", companyOwnershipPopover: "Lain mukaan tosiasiallisella edunsaajalla tarkoitetaan henkilöä, joka omistaa yli 25% yrityksen osakkeiden tai osuuksien tuottamasta äänimäärästä tai jolla on muutoin määräysvalta yrityksessä. Kysymme tätä tietoa, koska Finanssivalvonta ja rahanpesulaki velvoittavat meitä tuntemaan asiakkaamme.", shareHolderTitle: "Yrityksen omistajat", shareHolderText: "Seuraavat henkilöt omistavat vähintään 25% yhtiön osakkeista suoraan tai välillisesti", shareHolder: "Omistaja", whyAsked: "Miksi kysymme näitä tietoja?", whyAskedInfo: "Palkkaus.fi on maksupalvelun tarjoajia koskevassa Finanssivalvonnan (Fiva) rekisterissä. Laki edellyttää meiltä asiakkaan tuntemista. Siksi joudumme kysymään sinulta vielä seuraavat tiedot. Tiedot eivät ole julkisia ja voimme luovuttaa niitä vain voimassaolevan lainsäädännön velvoittamissa rajoissa.", chooseMobileBankingAndSign: "Valitse verkkopankkisi ja allekirjoita valtakirja", error: "(pakollisia tietoja puuttuu)", usePersonalMobileBanking: "Et voi käyttää yrityksen tai yhdistyksen verkkopankkitunnuksia valtakirjan allekirjoittamiseen. Sinun täytyy käyttää henkilökohtaisia verkkopankkitunnuksiasi.", bySigningAcceptTermsOfUse: { html: 'Allekirjoittamalla valtakirjan hyväksyt samalla <a href="https://www.palkkaus.fi/kayttoehdot/" target="_blank">palvelun käyttöehdot</a>.' }, downloadPDF: "Lataa PDF", updateForPreview: "Päivitä tiedot esikatseluun", previewAttorney: "Valtakirjan esikatselu" }, dialog: { header: "Digitaalinen allekirjoitus", descr: "Siirrytään allekirjoitukseen" }, thankyou: { title: "Allekirjoitus onnistui", instructions: "Olet nyt allekirjoittanut sähköisen valtakirjan. Tilitoimisto voi tämän jälkeen ottaa palvelun puolestasi käyttöön.", adv1: "Jo yli 5000 yritystä käyttää Palkkaus.fi-palvelua!" } }, EarningsPaymentComponent: { common: { addScheduling: "Ajasta lähetys", removeScheduling: "Poista ajastus", cancel: "Mitätöi", validate: "Validoi", basicInfo: "Perustiedot", noErrors: "Ei virheitä", insurances: "Vakuutukset", absences: "Poissaolot", rows: "Rivit", history: "Historia", readOnlyInfo: "Ilmoitus on lukutilassa. Sitä ei voi tallentaa tai lähettää tulorekisteriin.", sendFailureTitle: "Lähetys epäonnistui", validationErrorText: "Ilmoituksella on validointivirheitä eikä sitä voida lähettää. Korjaa virheet ja yritä uudelleen.", replacementFailureText: "Ilmoitusta ei voida lähettää korvaavana. Mitätöi ja lähetä uudelleen.", loaderTextSending: "Lähetetään...", loaderTextValidating: "Validoidaan...", loaderTextWait: "Odota...", loaderTextCanceling: "Mitätöidään...", loaderTextRemoving: "Poistetaan...", loaderTextFetchingCalc: "Haetaan laskelmaa...", loaderTextSaving: "Tallennetaan...", time: "klo", worker: "Työntekijä", selectAbsences: "Valitse poissaolot raportille", calcRows: "Laskelman rivit", allRows: "Kaikki rivit" }, statuses: { new: { text: "Uusi", smallText: "Palkkatietoilmoitusta ei ole vielä lähetetty/ajastettu" }, succeeded: { text: "Onnistuneesti lähetetty" }, canceled: { text: "Mitätöity", smallText: "Voit lähettää ilmoituksen uudelleen" }, error: { text: "Virheellinen", sending: "Tulorekisterin lähetys", gaveError: "antoi virheen" }, invalid: { text: "Tarkastettava", smallText: "Tarkista alla olevat virheet ennen lähetystä" }, scheduled: { text: "Ajastettu" } }, substitutePayer: { employerIdType: { title: "Varsinaisen työnantajan tunnisteen tyyppi" }, employerIdCode: { title: "Varsinaisen työnantajan tunniste" }, employerIdCountryCode: { title: "Varsinaisen työnantajan maakoodi" }, employerIdCountryName: { title: "Varsinaisen työnantajan maan nimi" } }, deliveryData: { tabHeading: "Aineisto", title: "Aineiston tiedot", timestamp: "Aineiston muodostamishetki", source: "Tietolähde", deliveryId: "Aineiston omistajan (maksajan) aineistoviite", productionEnvironment: "Tuotantoympäristö", deliveryDataOwner: "Aineiston omistaja", ownerIdType: "Tunnisteen tyyppi", countryCode: "Maakoodi", deliveryDataCreator: "Aineiston muodostaja (Palkkaus.fi, Y-tunnus)", deliveryDataSender: "Aineiston lähettäjä (Palkkaus.fi, Y-tunnus)", contactPersons: "Yhteyshenkilöt" }, paymentPeriod: { title: "Palkanmaksukausi", paymentDate: "Suorituksen maksupäivä tai muu ilmoituspäivä\r", startDate: "Alkupäivä", endDate: "Loppupäivä" }, payer: { tabHeading: "Maksajan tiedot", title: "Maksajan tiedot", payerId: "Tunniste", payerIdType: "Tunnisteen tyyppi", countryCode: "Maakoodi", companyName: "Yrityksen nimi", lastName: "Sukunimi", firstName: "Etunimi", birthDate: "Syntymäaika" }, address: { title: "Maksajan osoite", co: "c/o-tarkenne", street: "Katuosoite", poBox: "PL", postalCode: "Postinumero", postOffice: "Postitoimipaikka", countryCode: "Maakoodi", countryName: "Maan nimi" }, incomeEarner: { tabHeading: "Tulonsaaja", title: "Tulonsaajan tiedot", earnerId: "Tulonsaajan tunniste", earnerIdType: "Tunnisteen tyyppi", countryCode: "Maakoodi", companyName: "Yrityksen nimi", lastName: "Sukunimi", firstName: "Etunimi", birthDate: "Syntymäaika", gender: "Sukupuoli", addressTitle: "Tulonsaajan osoite", addressType: "Osoitteen tyyppi", street: "Katuosoite", postalCode: "Postinumero", postOffice: "Postitoimipaikka", addressCountryCode: "Maakoodi", professionTitle: "Ammattiluokka tai -nimike", noProfession: "Ei ammattiluokkaa", professionType: `Ammattiluokan tai nimikkeistön tyyppi
`, professionCode: `Ammattiluokan tai nimikkeistön tunniste\r
`, professionTitleLabel: "Ammattinimike" }, pensionAndInsurance: { tabHeading: "Työeläke- ja tapaturmavakuutus" }, pensionInsurance: { title: "Työeläkevakuutus", noPension: "Ei tyeläkevakuutusta", pensionActCode: "Tieto työeläkevakuutuksesta", pensionProvIdCode: "Työeläkelaitoksen yhtiötunnus", pensionPolicyNo: "Eläkejärjestelynumero" }, accidentInsurance: { title: "Työtapaturmavakuutus", noAccidentInsurance: "Ei työtapaturmavakuutusta" }, insuranceExceptions: { title: "Muut", insuranceException: "Muut vakuuttamistiedot" }, incomeEarnerOther: { insurancePayment: "Maksun tiedot", insurancePaymentType: "Maksutiedon tyyppi", insurancePaymentRef: "Maksun viitenumero", insurancePaymentSpecifier: "Maksun tarkenne " }, professions: { caption: "Ammattiluokka", type: "Ammattiluokan tai nimikkeistön tyyppi", code: "Ammattiluokan tai nimikkeen tunniste", title: "Ammattinimike (vapaamuotoinen)" }, transactions: { code: "Koodi", count: "Määrä" } }, EmploymentTaxcardsComponent: { checkTaxCard: "Tarkista verokortti", waitingApproval: { title: "Uusi verokortti!", approveBtnLong: "Katso ja tarkista", approveBtn: "Hyväksy", rejectBtnLong: "Ohita", rejectBtnSpan: "(oma verokortti)", rejectBtn: "Hylkää", notFullCard: { alertText: { html: "Työntekijä <strong>{{name}}</strong> on ladannut uuden verokortin", span2: "ja toivoo, että sitä käytetään palkanmaksuun." }, alertTextUnconfirmed: { html: `<strong>HUOM:</strong>
Verokortti sisältää henkilötietoja, joita saat katsoa vain, jos aiot todella maksaa palkkaa ko. henkilölle.
Tieto verokortin avaamisesta välittyy työntekijälle.` } }, fullCard: { alertText: { html: "HUOM: Työntekijä <strong>{{ name }}</strong> on ladannut tämän verokortin ja toivoo, että sitä käytetään palkanmaksuun, mutta et ole vielä hyväksynyt sitä." } } }, taxCardIncomeLog: { addPaidSalaries: "Lisätäänkö jo maksetut palkat verokortille", addSalaries: "Lisää palkat", addSalariesToTaxCard: "  HUOM: Verokortin voimassa-ajalla {{ validity }} on jo maksettuja palkkoja. Haluatko lisätä nämä palkat verokorttiin?", addElseWherePaidSalary: "Lisää muualla maksettu palkka" }, taxCardMinPercent: { minimumPercent: "Minimiprosentti", lead: { html: "Suosittelemme, että työntekijä päivittää verokorttinsa suoraan <a href='https://www.vero.fi/OmaVero' target='_blank'>Omavero-palvelussa</a> ja että <strong>automaattinen verokortin haku</strong> otetaan käyttöön työntekijän (jaettu verokortti) taityönantajan toimesta. Näin verokortti on aina ajantasainen." }, biggerTaxPercentThanInTaxCard: "Työntekijä voi kuitenkin myös pyytää, että työnantaja vähentää palkasta suuremman ennakonpidätyksen kuin mitä verokortin perusteella pidätettäisiin. Tämä on tyypillistä, jos työntekijällä on tuloja, joita ei ole merkitty verokorttiin tai tuloja on useiltatyönantajilta.", taxPercentMinimum: "Ennakonpidätykselle voi syöttää tällaisen minimiprosentin alla." }, taxCardNew: { addTaxCard: "Lisää verokortti" }, workerEdit: { updateWorkerInfo: "Päivitä vain työntekijän tiedot", updateWorkerInfoAndSalaryRows: "Päivitä työntekijän tiedot ja palkkarivit", addSalaryDefaults: "Lisää oletuspalkkarivit" } }, HouseholdUsecaseComponent: { datePickerPlaceHolder: "Heti: 1-3 päivää maksusta", base: { dailyExpenses: "Työkalukorvaus (€/pv)", dailyTravelExpenses: "Matkakorvaus (€/pv)", dailyTravelExpensesKm: "Matkat kotoa työpaikalle (km/pv)", defaultPriceLabel: "Hinta", eurPerH: "€/h", eurPerMonth: "€/kk", expensesCustom: "Työkalu- ja matkakorvaus", hourCount: "Tuntien määrä", hoursPerPriceWithSunday: " +100% sunnuntailisä", householdDeduction: "Kotitalousvähennys", householdDeductionTrue: "Kyllä: Haluan, että palvelu tekee kotitalousvähennysilmoituksen puolestani", householdDeductionFalse: "Ei: En halua, että palvelu tekee kotitalousvähennysilmoitusta puolestani", isHouseholdDeductible: "- kotitalousvähennys", isSunday: "Sunnuntai tai pyhäpäivä?", longInfoText: { html: "<p>Laskelma ehdottaa kotitalousvähennystä työn tyypin mukaan, mutta ei automaattisesti laske lomakorvauksia yms. lisiä.</p><p>Voit lisätä tarvittavat lisät riveinä seuraavasta näkymästä. Lue lisää työnantajan velvollisuuksista osoitteesta Palkkaus.fi.</p><p>Teemme puolestasi kotitalousvähennysilmoituksen olettamuksella, että työ on tehty kotona tai vapaa-ajan asunnolla. Jos haluat tehdä ilmoituksen itse, poista valinta.</p>" }, noByTes: "TES-taulukon perusteella", noCalcAuto: "Lasketaan automaattisesti", periodText: "Palkka ajalta (työpäivien määrä)", pleaseInput: "Syötä", pricePerMonth: " / kk", salaryKind: "Palkkatyyppi", salaryMessage: "Viesti palkkalaskelmaan", shortInfoText: { html: "Yleinen palkkalaskelma ilman TES-sääntöjä." }, tesInclusions: "TES-erät", updatingCalc: "Päivitetään laskelmaa", workDescription: "Työn kuvaus", yesAgreedPerDay: "Erikseen sovittu (per päivä)", yesAgreedTotalPayment: "Sovittu kokonaiskorvaukseen", taxDeductionCategories: "Työn tyyppi (vähennyksen peruste)", totalEmployerPaymentAlert: "HUOM: Kokonaiskustannus lasketaan huomioiden yo. kotitalousvähennysvalinta. Voit laskea kokonaiskustannuksen ensin ilman kotitalousvähennystä ja sen jälkeen lisätä kotitalousväehnnyksen erikseen.", salaryAlert: "Valitse palkkatyypiksi urakkapalkka, jos olet sopinut korvauksen työstä kiinteänä summana eikä aikaan sidottuna (vrt. esim. tuntipalkka). Voit lisäksi valita lisätäänkö urakkapalkkaan TES-lisät vai sisältyykö ne sovittuun palkkaan. Palkan päälle lasketaan pakolliset sivukulut." }, childCare: { childCareSubsidy: "Yksityisen hoidon tuki", isChildCareSubsidy: "€ yksityisen hoidon tuki ", footnoteIschildCareSubsidy: "Sivukulut lasketaan kokonaissummasta. Laskuri olettaa, että maksat palkan loma-ajalta erikseen. Voit myös lisätä loma-ajan palkan rivinä laskuriin. Kotitalousvähennystä ei voi käyttää, jos yksityisen hoidon tuki on mukana palkassa.", footnoteIsNotchildCareSubsidy: "Laskuri olettaa, että maksat palkan loma-ajalta erikseen. Voit myös lisätä loma-ajan palkan rivinä laskuriin.", longInfoTextIfchildCareSubsidy: { html: "<p>Laskurilla voit laskea pitkäaikaisen lastenhoitajan palkan.</p><p>Laskuri ottaa huomioon myös yksityisen hoidon tuen. Tuki vaikuttaa sivukuluihin, vaikka Kela maksaa sen suoraan työntekijälle. Tuen kanssa ei voi samaan aikaan käyttää kotitalousvähennystä.</p>" }, longInfoTextIfNotchildCareSubsidy: { html: "<p>Laskurilla voit laskea pitkäaikaisen lastenhoitajan palkan.</p><p>Jos valitset alla, teemme puolestasi kotitalousvähennysilmoituksen olettamuksella, että työ on tehty kotona tai vapaa-ajan asunnolla. Jos haluat tehdä ilmoituksen itse, poista valinta.</p>" }, shortInfoText: { html: "Oma lastenhoitaja kotona." }, wageInAdditionToBenefits: "Rahapalkka tuen lisäksi", inAdditionToBenefits: " tuen lisäksi", workerTotalPayment: "Työntekijän palkka yhteensä:" }, cleaning: { contractLastedLessThanYear: "Työsuhde kestänyt alle vuoden", footnote: { html: "HUOM: Sinun tulee maksaa myös loma-ajan palkka ja sen lisäksi 50% lomarahaa loma-ajan palkasta. Voit lisätä ne riveinä tähän laskelmaan tai tehdä erillisen palkanmaksun.<a href='https://www.palkkaus.fi/abc/siivous-ja-kiinteistoalan-tyoehtosopimus/' target='_blank'>Lue lisää täältä</a>." }, fullTime: "Työtä yli 14pv/kk tai yli 35h/kk", longInfoText: { html: "<p>Laskuri laskee automaattisesti lomakorvauksen maksettavaksi prosentteina palkasta.</p><p>Jos työtä tehdään yli 14pv/kk tai yli 35h/kk, pitää työntekijälle antaa mahdollisuus pitää loma. Tällöin maksetaan loma-ajalta palkka (jäljelle jäänyt osuus maksetaan työsuhteen päättyessä).</p>" }, shortInfoText: { html: "Kodin tai vapaa-ajan asunnon siivous ja kunnossapito. Ilmoitetaan kotitalousvähennykseen." } }, construction: { dailyExpenses: "Työkalukorvaus (€/pv)", dailyTravelExpenses: "Matkakorvaus (€/pv)", dailyTravelExpensesKm: "Matkat kotoa työpaikalle (km/pv)", expensesCustom: "Työkalu- ja matkakorvaus", longInfoText: { html: "<p>Lisäksi työehtosopimuksissa on määritelmät työkalukorvauksista ja matkakorvauksista. Laskurissa nämä voi laskea TES-taulukoiden mukaan tai vaihtoehtoisesti erikseen työntekijän kanssa sovittuina päiväkorvauksina.</p><p>Teemme puolestasi kotitalousvähennysilmoituksen olettamuksella, että työ on tehty kotona tai vapaa-ajan asunnolla. Jos haluat tehdä ilmoituksen itse, poista valinta.</p>" }, noByTes: "TES-taulukon perusteella", noCalcAuto: "Lasketaan automaattisesti", shortInfoText: { html: '<p>Laskuri huomioi yleissitovat työehtosopimukset rakennusalalla.<br>TES-eriä ovat lomakorvaus ja erillinen palkan osa (entinen "pekkaset").</p>' }, subtitlePlusExpenses: " + TES-lisät ja korvaukset", tesInclusions: "TES-erät", yesAgreedPerDay: "Erikseen sovittu (per päivä)", yesAgreedTotalPayment: "Sovittu kokonaiskorvaukseen", taxFreeMilageAlert: "HUOM: Voit lisäksi tai vaihtoehtoisesti maksaa verottomia kilometrikorvauksia lisäämällä rivin 'Kilometrikorvaus, oma auto'. Ne ilmoitetaan verottajalle todellisten kilometrien mukaan, ei päiväkohtaisena." }, mll: { longInfoText: { html: 'Perhe maksaa lasten hoitajalle palkkana 9,50 €/tunti (sunnuntaina 19,00). Tämä on kokonaiskorvaus, joka sisältää lomakorvauksen. Tunnit ilmoitetaan puolen tunnin tarkkuudella, minimi 2 tuntia. Yhdellä hoitajalla voi olla hoidettavana enintään neljä lasta.<br>Huom! Kello 23 jälkeen perheen tulee huolehtia hoitajan turvallisesta kotimatkasta joko tarjoamalla autokyyti tai kustantamalla taksi.<br>Teemme puolestasi kotitalousvähennysilmoituksen olettamuksella,että työ on tehty kotona tai vapaa-ajan asunnolla. Jos haluat poistaa kotitalousvähennyksen tai tehdä ilmoituksen itse, käytä "Muu lastenhoito"-laskuria.' }, shortInfoText: { html: "<p>Palkka maksetaan Mannerheimin Lasten&shy;suojelu&shy;liiton suo&shy;si&shy;tus&shy;ten mukaan.</p>" }, useCustomPrice: "Muu kuin MLL:n palkkasuositus (9,50€/h)?" }, santaClaus: { agreedPayment: "Sovittu palkkiosumma", fixedPaymentAtChristmas: "Kertakorvaus jouluaattona.", longInfoText: { html: "Kotitalousväehnnystä joulupukin palkkiosta ei verottajan mukaan saa." }, shortInfoText: { html: "Joulupukkikin ansaitsee laillisen palkan. Palkkaus.fi ja Nordea tarjoavat sen tänä jouluna <strong>ilman palvelumaksua</strong>" } }, ui: { backToSelection: "Takaisin valintaan", changeSelection: "Vaihda työn tyyppi", selectionTitle: "Valitse työn tyyppi", salaryDate: "Palkkapäivä", salaxyDateInfo: { html: "Päivä, jolloin palkka on työntekijän tilillä. Tyhjä päivä tarkoittaa <strong>heti</strong>: Käytännössä 0-4 päivää maksutavasta riippuen." } } }, MessageThreadComponent: { ui: { newMessageThreadBtn: "Aloita uusi viestiketju" }, newMessage: { headerTitle: "Aloita uusi viestiketju", headerDescription: { html: "Aloita uusi viestiketju, kun haluat olla yhteydessä palkanlaskijaasi. Voit liittää viestiin myös tiedostoja. Viestit kulkevat tietoturvallisesti ja viestiketju jää talteen." } }, messageContent: { notSelected: "(Työntekijää ei ole valittu)", salary: "Palkka", payment: "Maksu", report: "Palkkalaskelma (PDF)", payroll: "Palkkalista", editPay: "Muokkaa / maksa", showCalc: "Näytä laskelma", toEmail: "Ilmoitus sähköpostiin" }, error: "Viestiketjun lataamisessa tapahtui virhe.", salaryDate: "Palkkapäivä", read: "luettu", unread: "ei luettu", markAsReadBtn: "Merkitse luetuksi", markAsUnreadBtn: "Merkitse lukemattomaksi", sendtoEmailBtn: "Lähetä ilmoitus sähköpostiin", reloadBtn: "Lataa uudelleen", handledInfo: "Palkanlaskija / tilitoimisto on merkinnyt viestiketjun käsitellyksi.", title: "Otsikko", receiver: "Vastaanottaja", subject: "Aihe", replyDate: "Toivon vastausta mennessä...", subjectOptionSalary: "Palkanmaksu", subjectOptionOther: "Muu palkka-asia", writeOrPaste: "Kirjoita viesti tai liitä leikepöydältä", fileBtn: "Tiedosto", moreFeaturesBtn: "Lisätoiminnot", deleteThread: "Poista koko ketju", addDraft: "Laskelmaluonnos", addPaid: "Maksettu laskelma", deleteThreadAlert: "Haluatko varmasti poistaa koko viestiketjun", sendNotificationSubject: "Uusi viesti palkanlaskennasta -", sendNotificationBody: `Hei,

palkanlaskija on lähettänyt sinulle viestin.

Kirjaudu palveluun ja löydät saapuneen viestin viestit-osiosta.`, saveNoToField: "Viestin vastaanottajaa ei ole määritetty.", uploadFilesSaving: "Tallennetaan tiedostoja...", uploadFilesError: "Tiedoston tallennus palvelimelle epäonnistui.", addWorkersTitle: "Valitse työntekijät", addWorkersLoading: "Lisätään työntekijöitä...", addExistingCalcCopy: "Valitse maksetut palkat (kopioidaan)", addExistingCalcMove: "Valitse luonnokset (siirretään)", addExistingCalcLoading: "Lisätään laskelmia..." }, MessageThreadsComponent: { title: "Otsikko", salaryDate: "Palkkapäivä", answered: "Vastattu", status: "Tila", sender: "Lähettäjä", message: "Viesti", waiting: "Odottaa", pce: "kpl" }, VarmaBannerComponent: { pensionPopup: { tyel: { title: "TyEL-vakuutus puuttuu", html: "Yritykselläsi ei ole <b>TyEL-vakuutusta</b> merkittynä tietoihin. Työeläkevakuutus on lain mukaan oltava yrityksellä, kun maksaa työntekijöille palkkaa. <br><br>Haluatko ottaa vakuutuksen Varmalta? Saat vakuutusnumeron suoraan meidän kauttamme verkossa ja työeläkemaksut tulee hoidettua oikein.", btnText: "Hanki TyEL yritykselle" }, yel: { title: "Ota YEL-vakuutus", html: "Jos yrityksessä on <b>YEL-yrittäjiä</b>, pitää jokaisella heistä olla oma henkilökohtainen YEL-vakuutus. Yrittäjä tarvitsee yhden YEL-vakuutuksen, jolle maksetaan yrittäjäpalkoista koituvat eläkemaksut.<br><br> Tästä voi ottaa yrittäjälle uuden YEL-vakuutuksen, jos sellaista ei vielä ole. Voit myös siirtää olemassa olevan vakuutuksen Varmaan.", btnText: "Ota YEL-vakuutus" }, moveTyel: { title: "Siirrä TyEL-vakuutus?", html: "Yritykselläsi on TyEL-vakuutus {{pensionCompany}}:ssa. Haluatko siirtää sen Varmaan, joka on Palkkaus.fi:n kumppani eläkevakuutuksissa? Se ei maksa mitään ja siirron voi tehdä helposti suoraan ohjelmassa.", btnText: "Siirrä TyEL-vakuutus" } } }, WorkerListComponent: { registeredUser: "Palkkaus.fi rekisteröitynyt käyttäjä", workers: "Työntekijät", editWorker: "Muokkaa työntekijää", addIban: "Lisää tilinumero", showFilters: "Näytä suodattimet", okButtonText: "Ota käyttöön automaattinen verokortti", infoText: { html: "<strong>Automaattinen verokortin haku</strong> <p class='small'>Voit aktivoida automaattisen verokortin työntekijöille, jolloin ohjelma hakee Verohallinnon rajapinnasta ajantasaisen verokortin aina palkanmaksun yhteydessä. Valitse automaattinen verokortti vain työntekijöille, joille aiot maksaa palkkaa. Jos työntekijällä on palkanmaksusta poikkeava verokortti erikoistilanteisiin, voit syöttää sen käsin työntekijän tiedoissa.</p>" }, active: "Aktiiviset", all: "Kaikki", selectAll: "Valitse kaikki", employment: "Työsuhde", employments: "Työsuhteet", autoTaxcard: "Auto-verokortti", activeAutoTaxcard: "Aktivoi automattinen verokortti", taxcard: "Verokortti", employmentDeletion: { confirmText: "Haluatko varmasti poistaa työsuhteen?", existingtCalculationsHeading: "Työsuhteella on laskelmia", existingtCalculationsText: "Poista palkkalaskelmaluonnokset ennen työsuhteen poistoa. Työsuhdetta, jolla on maksettuja palkkoja, ei voi poistaa, voit merkitä sen päättyneeksi, jolloin se ei näy aktiivisena." } }, WorkerReportComponent: { selectYearLabel: "Valitse vuosi:", noPaidSalaries: { title: "Ei maksettuja palkkoja vuonna {{year}}", description: " Sinulle ei ole maksettu Palkkaus.fi-palvelussa palkkaa vuonna {{ year }}. Kun sinulle maksetaan palkkaa, edellisten vuosien palkat ja niistä tehdyt raportit jäävät arkistoon tälle sivulle." }, contactCustomerService: "Jos sinulla pitäisi näkyä Palkkaus.fi-palvelun kautta maksettuja palkkoja vuodelle {{ year }}, otathan yhteyttä asiakaspalveluumme. Huomaathan kuitenkin, että olet kirjautunut työntekijänä. Jos etsit työnantajana maksamiasi palkkoja, vaihda työnantajaprofiiliin oikeasta yläkulmasta.", paidSalariesText: "Alla näet kaikki palkanmaksut, joita sinulle on maksettu Palkkaus.fi-palvelun kautta vuonna {{ year }}.", table: { employer: "Työnantaja", grossSalary: "Bruttopalkka", totalTaxable: "Verotettava", compensation: "Kulukorvaukset", summary: "Yhteenveto", taxPercent: "Ennakonpidätys", householdDeduction: "Kotitalousvähennys", workerYearlySummaryTitle: "Työntekijän vuosiyhteenveto", workerYearlySummaryLink: "Tästä vuosiyhteenvedosta", workerYearlySummaryText: "näet koko vuoden kaikki palkat ja muut maksut.", calculationBtn: "Palkkalaskelma", printBtn: "Tuloste", yearlyReport: "Vuosiraportti" } }, WorkFlowIssueComponent: { buttons: { showEditor: "Luo ongelman kuvaus" }, showWorkflowEventEditorTitle: "Ongelman kuvaus", deleteConfirmations: { close: 'Haluatko varmasti poistaa "Tarkastettu"-merkinnän?', issue: "Haluatko varmasti poistaa ongelman kuvauksen?" } }, SxyInputComponent: { addNewRow: "Lisää uusi rivi", editRow: "Muokkaa riviä" }, InputDurationComponent: { labelTrue: "Ennen (-)", labelFalse: "Jälkeen (+)" }, ValidationSummaryComponent: { checkForErrors: "Tarkista syötetyt tiedot", missingRequired: "Pakollisia tietoja puuttuu", loadingHtml: "Ladataan validointi-tietoa..." }, ValidationSummaryDetailsComponent: { moreInfoTitle: "Lisätietoja" }, PayButtonComponent: { paymentChannelLabel: "Maksutapa", moreOptionsLink: "Asetukset: Lisää maksutapoja" }, ReportListComponent: { noReportsToShow: "Ei raportteja vielä näytettävissä", report: "Raportti", links: "Linkit", reportDate: "Raporttipäivä", updated: "Päivitetty", note: "Huom", preview: "Esikatselu" }, EInvoiceAddressListComponent: { name: "Nimi", receiver: "Verkkolaskuosoite", intermediator: "Välittäjä", receiverNotFound: "Haku ei löytänyt yhtään osoitetta", dontUseAnyAddress: "Älä käytä mitään osoitetta", useSelectedAddress: "Käytä valittua osoitetta" }, PrimaryPartnerComponent: { moreInfo: "Lisätietoja", notAuthorized: { text: "Käyttöoikeuden myöntämisen jälkeen palvelutarjoajasi aktivoi palveluasiakkuuden, minkä jälkeen voit alkaa käyttämään palvelua. Palvelutarjoajasta riippuen aktivointi voi kestää muutaman päivän.", html: "<strong>HUOM: </strong>Merkitsemällä tilitoimiston palvelutarjoajaksesi annat tilitoimistolle käyttöoikeuden Palkkaus.fi-tilin tietoihisi. Huomaathan, että tämä tarkoittaa että silloin tilitoimistolla on pääsy kaikkiin tietoihin, kuten työntekijöiden tietoihin ja palkkalaskelmiin." }, authorized: { text: "Käyttöoikeuden myöntämisen jälkeen palvelutarjoajasi aktivoi palveluasiakkuuden, minkä jälkeen voit alkaa käyttämään palvelua. Palvelutarjoajasta riippuen aktivointi voi kestää muutaman päivän. Voit poistaa myöntämäsi käyttöoikeuden palvelutarjoajaltasi milloin vain.", html: "<strong>HUOM: </strong>Olet merkinnyt tämän tilitoimiston palvelutarjoajaksesi ja antanut tilitoimistolle käyttöoikeuden Palkkaus.fi-tilin tietoihisi. Huomaathan, että tämä tarkoittaa että silloin tilitoimistolla on pääsy kaikkiin tietoihin, kuten työntekijöiden tietoihin ja palkkalaskelmiin." }, setPrimaryPartner: "Aseta palvelutarjoajaksi", removePrimaryPartnerCredential: "Poista palvelutarjoajan käyttöoikeus" }, PalkkausPersonalPaymentOverviewComponent: { title: "Palkan maksaminen", titleInspect: "Maksetut laskut", loadingPayment: "Ladataan: Maksun yleiskuva", invalidCalc: "Laskelmassa on virheitä", printInvoices: "Tulosta laskut", notPaidInfo: "Ei maksettu, älä ilmoita tulorekisteriin", cancelInfo: "Peru maksu ja tulorekisteri-ilmoitus", paidInfo: "Maksettu, ilmoita tulorekisteriin", statuses: { canceled: { lead: "Palkanmaksu on peruttu. Laskelma ja siitä tehdyt tulorekisteri-ilmoitukset on peruttu.", salaryAlreadyPaid: "Jos palkka ja sen sivukulut on ehditty jo maksaa:", salaryAlreadyPaidInfo1: "työntekijä palauttaa nettopalkan työnantajalle", salaryAlreadyPaidInfo2: "työeläkeyhtiö palauttaa työeläkemaksut työnantajalle tai hyvittää seuraavassa laskussa", salaryAlreadyPaidInfo3: "työllisyysrahasto palauttaa työttömyysvakuutusmaksut työnantajalle tai hyvittää seuraavassa laskussa", salaryAlreadyPaidInfo4: "työnantajasuoritukset palautuvat työnantajan Omaveroon, jossa voi tehdä palautuspyynnön" }, paid: { lead: "Palkka on nyt kuitattu maksetuksi.", infoText1: "Tulorekisteri-ilmoitukset tehdään automaattisesti palkkapäivän perusteella.", infoText2: "Muistithan maksaa nettopalkan työntekijälle verkkopankissasi sekä työnantajasuoritukset Verohallinnolle oheisilla laskuilla!", infoText3: "Saat kotiin erikseen laskun työeläkemaksuista palkanmaksua seuraavassa kuussa sekä työttömyysvakuutusmaksuista palkanmaksua seuraavan vuosineljänneksen aikana.", paidInspectNet: "Nettopalkka on kuitattu maksetuksi", paidInspectTax: "Ennakonpidätys on kuitattu maksetuksi" }, preview: { lead: "Maksa heti omassa verkkopankissasi nettopalkka työntekijälle ja työnantajasuoritukset verohallinnolle. Näitä varten alla maksutiedot, jotka voit kopioida verkkopankiisi.", infoText: "Kun olet tehnyt maksut, kuittaa ne maksetuiksi, jolloin teemme palkasta tulorekisteri-ilmoitukset. Työllisyysrahasto ja työeläkeyhtiö lähettävät erillisen laskun työttömyysvakuutusmaksusta ja TyEL-maksusta.", receiver: "Saaja", iban: "Tilinumero", reference: "Viite / viesti", dueDate: "Eräpäivä", sum: "Summa", salary: "Palkkaa", checkReference: "Tarkista viite Omaverosta!", cfaInfo: { html: "<strong>Työllisyysrahasto ja työeläkeyhtiö</strong> lähettävät erillisen laskun työttömyysvakuutusmaksusta ja TyEL-maksusta. Mahdolliset laskelmalla olevat ay-jäsenmaksut tai ulosmittaukset pitää myös maksaa itse oikeille tahoille näiltä saamiesi maksuohjeiden mukaan." } }, mobileBanking: { heading: "Maksa laskut verkkopankissasi", lead: "Maksa alla olevat 2 laskua verkkopankissasi. Kun olet tehnyt maksut, kuittaa ne maksetuiksi, jolloin teemme palkasta tulorekisteri-ilmoitukset. Työllisyysrahasto ja työeläkeyhtiö lähettävät erillisen laskun työttömyysvakuutusmaksusta ja TyEL-maksusta.", salary: "1. Palkka", salaryInfo: { html: "Työntekijän nettopalkka maksetaan suoraan työntekijälle.<br /> Kirjoita viestiksi 'Palkka' tai maksetun palkan tarkempi kuvaus." }, tax: "2. Ennakonpidätys", taxInfo: { html: "Työnantajasuoritukset verottajalle (ennakonpidätys ja sava).<br />Käytä viitenumeroa!" }, sideCosts: "3. Muut sivukulut laskutetaan", sideCostsInfo1: "Työllisyysrahasto ja työeläkeyhtiö lähettävät erillisen laskun työttömyysvakuutusmaksusta ja TyEL-maksusta.", sideCostsInfo2: "Mahdolliset laskelmalla olevat ay-jäsenmaksut tai ulosmittaukset pitää myös maksaa itse oikeille tahoille näiltä saamiesi maksuohjeiden mukaan." } }, steps: { step1: { heading: "Nettopalkka", title: "Nettopalkan maksaminen verkkopankissasi", text: { html: "Avaa uusi välilehti selaimessa ja <strong>kirjaudu verkkopankkiisi</strong>. Maksa tämä maksu <strong>verkkopankissasi heti</strong>, jolloin työntekijäsi saa nettopalkan ajoissa tililleen." } }, step2: { heading: "Ennakonpidätys", title: "Ennakonpidätyksen maksaminen verkkopankissasi", text: { html: "Avaa uusi välilehti selaimessa ja <strong>kirjaudu verkkopankkiisi</strong>. Maksa tämä maksu <strong>verkkopankissasi heti</strong>, jolloin palkanmaksuun liittyvä ennakonpidätys ja työnantajasuoritukset tulevat maksetuiksi oikein." } }, step3: { heading: "Sivukulut", title: "Sivukulujen maksaminen", text: "Nettopalkan ja ennakonpidätyksen lisäksi palkanmaksuun liittyy muitakin kuluja:", textAlt: "Sivukulujen summat näet palkkalaskurista, kun lasket palkkaa. Maksetut palkkalaskelmat löytyvät Palkkamyllyn työpöydältä", listItem1: "Työeläkeyhtiö lähettää sinulle erikseen laskun työeläkemaksusta (TyEL).", listItem2: "Työllisyysrahasto lähettää sinulle erikseen laskun työttömyysvakuutusmaksusta. Se tulee neljännesvuosittain.", listItem3: "Mahdolliset ulosmittaukset ja ay-jäsenmaksut pitää hoitaa itse, niitä Palkkamylly ei voi tilittää puolestasi." }, step4: { heading: "Tulorekisteri", title: "Palkkamylly hoitaa tulorekisteri-ilmoitukset", text: "Jos olet maksanut nettopalkan, palkasta pitää tehdä tulorekisteri-ilmoitus. Palkkamylly hoitaa sen puolestasi.", buttonInfoText: "Voiko ilmoituksen lähettää?", irInfo: "Tulorekisteri-ilmoitus tehdään viiden päivän kuluessa laskelmalla ilmoitetusta palkkapäivästä.", acceptButton: "Kyllä, tulorekisteri-ilmoitukset voi lähettää", declineButton: "Ei, maksan ja kuittaan maksut myöhemmin" } }, alerts: { headingPaid: "Palkkalaskelma on kuitattu maksetuksi", headingCancelled: "Palkkalaskelman maksaminen on peruttu", paid: { text: "Palkkalaskelma on nyt kuitattu maksetuksi ja tulorekisteri-ilmoitukset lähtevät automaattisesti.", infoText1: " - Olet ilmoittanut nettopalkan ja työnantajasuoritukset verottajalle maksetuiksi.", infoText2: " - Saat työeläke- ja työttömyysvakuutusmaksuista laskut erikseen postitse.", infoText3: " - Mahdolliset ulosmittausten ja ay-jäsenmaksujen tilitykset tulee hoitaa erikseen." }, cancel: { text: "Palkkalaskelmaa ei ole kuitattu maksetuksi eikä tulorekisteri-ilmoituksia tehdä.", infotext1: " - Palkkalaskelmaa ei ole kuitattu maksetuksi eikä tulorekisteri-ilmoituksia tehdä.", infotext2: " - Voit ilmoittaa palkan maksetuksi myöhemmin siirtämällä laskelman uudestaan maksuun valitsemalla laskelmalta Siirry maksamaan." } } }, AccountantSelectionComponent: { heading: "Kirjanpitäjä/tilitoimisto", accountantType: "Tilitoimiston/kirjanpitäjän tyyppi", companyOrPerson: "Yhtiö vai henkilö", noAccountantEnum: "Ei kirjanpitäjää/tilitoimistoa", companyEnum: "Yhtiö", personEnum: "Henkilö", personAccountantForm: { firstName: "Etunimi", lastName: "Sukunimi", email: "Sähköposti", telephone: "Puhelin" }, searchAccountingFirm: "Hae tilitoimiston nimellä tai Y-tunnuksella", name: "Nimi", officialId: "Y-tunnus", noSearchResult: "Haku ei löytänyt yhtään yhtiötä", companyAccountantForm: { search: "Haku", notPrimaryPartner: { lead: "Näet tulevan kirjanpitäjäsi/tilitoimistosi tiedot alla", partnerInfo: "HUOM: Jotta kirjanpitäjäsi voi auttaa sinua palkanlaskennassa ja kirjanpidossa, rekisteröidylle tilitoimistokumppanille annetaan oletusarvoisesti luku- ja kirjoitusoikeudet kaikkiin palvelun tietoihin, esim. työntekijä- ja palkkatietoihin, kirjanpitoaineistoon. Jos et halua antaa näin laajoja oikeuksia, voit antaa vain yhteystiedot.", notPartnerInfo: 'Suosittelemme, että teet kirjanpitäjästäsi ns. "tilitoimistokumppanin". Tällöin hänellä on oikeudet kaikkeen palkkaus.fi-tietoon. Hän voi ongelmatilanteessa tarkastella palkkoja ja jopa muokata niitä. Kirjanpitäjä saa tällöin kirjanpitoaineiston konekielisessä muodossa ja voi viedä sen useimpiin kirjanpito-ohjelmiin.' }, primaryPartner: { lead: "Näet tilitoimistokumppanisi tiedot alla", partnerInfo: "HUOM: Jotta kirjanpitäjäsi voi auttaa sinua palkanlaskennassa ja kirjanpidossa, rekisteröidylle tilitoimistokumppanille on annettu luku- ja kirjoitusoikeudet kaikkiin palvelun tietoihin, esim. työntekijä- ja palkkatietoihin, kirjanpitoaineistoon" }, accountantPermissions: "Tilitoimiston oikeudet", unlinkedPrimaryPartnerEnum: 'Anna kirjanpitäjälle "tilitoimistokumppani" oikeudet', unlinkedAccountingOnlyEnum: "Tilitoimistokumppani ilman pääsyä Palkkaus.fi palveluun", pendingPrimaryPartnerEnum: 'Anna kirjanpitäjälle "tilitoimistokumppani" oikeudet', primaryPartnerEnum: "Tilitoimistokumppanin oikeudet", accountingDataEmail: "Kirjanpitoaineiston lähetys sähköpostitse", deletePrimaryPartner: "Poista tilitoimistokumppani" } }, BrandSelectionComponent: { title: "Valitse kumppani ja tyyli", useDefaultStyle: "Käytä vakiotyyliä" }, PaymentChannelDialogComponent: { palkkausCfaFinvoice: { legend: "Finvoice", eInvoiceAddress: "Verkkolaskuosoite", intermediator: "Välittäjä" }, palkkausCfaPaytrail: { legend: "Asiakasvaratilin kautta maksetaan", infoText: "Oletuksena asiakasvaratilin kautta maksetaan nettopalkka ja ennakonpidätys. Alta voit halutessasi muuttaa näitä asetuksia", selfhandle: "Hoidan TyEL-maksut itse", isTaxAndSocialSecuritySelfHandling: "Hoidan ennakonpidätyksen maksun itse", isWorkerSelfHandling: "Hoidan nettopalkan maksun itse", alert: { html: "<strong>HUOM: </strong> Muutokset vaikuttavat kaikkiin asiakasvaratilin kautta tehtyihin maksuihin: <strong>Paytrail verkkomaksu, Yksi tilisiirto viitenumerolla ja Finvoice verkkolasku (verkkolasku)</strong>." } }, palkkausManual: { legend: "SEPA-materiaalin asetukset", ibanNumber: "Tilinumero (IBAN)", sepaBankPartyId: "SEPA-maksatustunnus" }, palkkausInvoices: { legend: "Palvelun maksutiedot", creditCard: "Luottokortti" }, default: { info: "Maksutavalla ei ole muutettavia asetuksia" } }, CalendarEventEditComponent: { setTimingsAndCreatePayrolls: "Aseta ajastus ja luo palkkalistat" }, FeedbackAddCorrectionComponent: { types: { common: { compensations: "Päivärahat ja ateriakorvaukset", milageCompensation: "Kilometrikorvaukset", phoneBenefit: "Puhelinetu", benefitsInKindWithoutPhone: "Muut luontoisedut" }, external: { lead: { html: "Ulkopuolinen palkka on maksettu esim. kirjanpitäjäsi toimesta. Jos lisäät palkan tähän, ilmoitamme myös tällaisen palkan verottajalle. <strong>Näin kirjanpitäjäsi ei tarvitse tehdä vuosi-ilmoitusta</strong>" }, heading: "Perustiedot", infoText: "Ilmoitusta varten tarvitaan ainakin päivämäärä, palkka ja ennakonpidätys, joka on vähennetty työntekijän palkasta", dateLabel: "Päivämäärä:", tyelEnum: "Palkka (TyEL)", yelEnum: "Yrittäjän palkka (YEL)", compensationEnum: "Työkorvaus", grossSalaryLabel: "Bruttopalkka", taxLabel: "Ennakon­pidätys (euroa)", calculateSideCosts: "Laske sivukulut", sideCostsHeading: "Sivukulut veroilmoitukseen", sideCostsInfoText: " Voit halutessasi laskea sivukulut palkasta, mutta ne olisi syytä tarkistaa alkuperäisestä palkkalaskelmasta.", entrepreneurSideCosts: "Työnantaja­kulut", socialInsuranceDeductionsFromEmployee: "Työntekijän osuus TyEL ­ja TVR -maksuista (euroa)", compensationsHeading: "Kulut, luontoisedut ja muut palkkarivit", compensationsInfoText: "Voit lisätä tähän muita verottajalle ilmoitettavia kuluja ja luontoisetuja, jos niitä on maksetussa palkassa", messagePlaceholder: "Jos jotain laskelmassa olevaa palkkaerää ei ole yllä, kuvaa se tässä kentässä mahdollisimman tarkasti" }, correction: { lead: { infoText: "Korjaus Palkkaus.fi-palvelun kautta tehtyyn palkkaan on yleensä", calculationError: "Virheellisesti laskettu palkka: (otamme sinuun puhelimitse yhteyttä)", missingCostOrCompensation: "Ilmoittamatta jätetty kulu tai luontoisetu: Nämä voimme yleensä lisätä ilmoitukseen suoraan", taxInfo: "Ilmoitamme nämä tiedot puolestasi verottajalle, TVR:ään sekä Ifiin, jos vakuutuksesi on siellä" }, errorSalaryHeading: "1. Virheellinen palkka TAI", messagePlaceholder: "Kerro virheestä tarkemmin, olemme sinuun tarvittaessaa yhteydessä.", missingCostOrCompensationHeader: "2. Puuttuva kulu tai luontoisetu", missingCostOrCompensationInfoText: "Voit lisätä tähän muita verottajalle ilmoitettavia kuluja ja luontoisetuja, jos niitä on maksetussa palkassa", dateLabel: "Päivämäärä" } } }, FeedbackSubmitComponent: { iban: "Tilinumero", ibanPlaceholder: "IBAN-muodossa" }, InsuranceComponent: { common: { addAddressBtn: "Lisää osoite", insuranceContactPerson: "Edustaja vakuutusasioissa", name: "Nimi", ssNumber: "Henkilötunnus", nationality: "Kansalaisuus", telephone: "Puhelinnumero", email: "Sähköpostiosoite", companyName: "Yrityksen nimi", vatNumber: "Y-tunnus", streetAddress: "Katuosoite", postalCode: "Postinumero", city: "Kaupunki", country: "Maa", oldInsuranceCompany: "Nykyisen vakuutusyhtiön nimi", startDate: "Vakuutuksen alkamisajankohta", startDateToolTip: "Huomioithan, että vakuutus voi astua voimaan aikaisintaan vakuutuksen allekirjoituspäivästä", billingInterval: "Vakuutuksen maksuerä vuodessa", occupationCode: "Ammattiluokka", industry: { label: "Toimiala", html: 'Löydät toimialaluokitukset <a href="https://www.stat.fi/fi/luokitukset/toimiala/?code=SSSSS&name=Toimialat%20yhteens%C3%A4" target="blank">täältä</a>.' }, salaryLabel: "Palkat (arvio 12 kk)", addOccupation: "Lisää ammattiluokka", procura: "Valtuutuksen peruste" }, enums: { procurationEnum: "Nimenkirjoitusoikeus", powerOfAttorneyEnum: "Valtakirja", apparentAuthorityEnum: "Asemavaltuutus", otherEnum: "Jokin muu", authorizationTypeLabel: "Valtuutuksen peruste" }, beneficiaryInfo: { wizard: { title: "Uusi työtapaturmavakuutus", titleAlt: "Yrittäjien tapaturmavakuutus", titleMoveInsurance: "Työtapaturmavakuutuksen siirto LähiTapiolaan", heading: "Tunnistaminen", intro: "Yrityksen tosiasialliset edunsaajat", label: "Tosiasiallisten edunsaajien tiedot" }, beneficiariesAdd: "Lisää edunsaaja" }, principalBusinessAddress: { label: { html: "Pääasiallisen liiketoimintapaikan osoite, <small>jos eri kuin yrityksen osoite</small>" } }, contactInfoEntrepreneur: { wizard: { title: "Uusi työtapaturmavakuutus", heading: "Perustiedot" } }, contactInfo: { wizard: { title: "Uusi työtapaturmavakuutus", titleAlt: "Työtapaturmavakuutuksen siirto LähiTapiolaan", heading: "Perustiedot", intro: "Perustiedot" }, moveInsuranceInfo: "Vakuutuksen voi siirtää toiseen vakuutusyhtiöön, kun vakuutus on ollut voimassa kokonaisen kalenterivuoden vakuutusyhtiössä. Esimerkiksi 1.7.2020 alkaneen vakuutuksen voi siirtää toiseen vakuutusyhtiöön 1.1.2022 alkaen." }, entrepreneur: { wizard: { title: "Yrittäjien tapaturmavakuutus", heading: "Täydennä vakuutuksen tiedot" }, companyInfo: "Yrityksen tiedot", entrepreneurInsuranceInfo: "Yrittäjän ja vakuutuksen tiedot", entrepreneurName: "Yrittäjän nimi", newEntrepreneurInsuranceEnum: "Uusi yrittäjän tapaturmavakuutus", moveEntrepreneurInsuranceEnum: "Vakuutuksen siirto toisesta vakuutusyhtiöstä", insuranceLabel: "Vakuutus on", estimatedIncome: "Vahvistettu YEL-työtulo", addEntrepreneur: "Lisää yrittäjä" }, insuranceMove: { wizard: { title: "Työtapaturmavakuutuksen siirto LähiTapiolaan" }, intro: "Vakuutuksen voi siirtää toisesta vakuutusyhtiöstä LähiTapiolaan, kun vakuutus on ollut voimassa kalenterivuoden toisessa vakuutusyhtiössä. Esimerkiksi 1.7.2020 alkaneen vakuutuksen voi siirtää LähiTapiolaan aikaisintaan 1.1.2022" }, insuranceInfoNew: { wizard: { title: "Uusi työtapaturmavakuutus", heading: "Täydennä vakuutuksen tiedot" } }, ownerInfo: { wizard: { title: "Uusi työtapaturmavakuutus", titleAlt: "Yrittäjien tapaturmavakuutus", titleMoveInsurance: "Työtapaturmavakuutuksen siirto LähiTapiolaan", heading: "Tunnistaminen", intro: "Selvitys yrityksen omistusrakenteesta" }, intro: "Selvennä omistajat ja omistusrakenne", introInfo: "Jos omistajana on toinen yritys, selvennä omistajayrityksen omistajat niin pitkälle, että lopulta kaikki yrityksen taustalla olevat henkilöomistukset on selvitetty. Jos omistusrakenne on monimutkaisempi, liitä mukaan erillinen omistusrakenteen kuvaus tai selvennä omistusrakenne Lisätietoja-kohdassa. Jos omistaja on ulkomainen, ilmoita syntymäaika ja ulkomaiselta yritykseltä ulkomainen rekisterinumero", ownerInfo: "Omistajien tiedot", displayName: "Omistajan nimi", officialId: "Henkilötunnus / Y-tunnus", address: "Osoite (myös maa)", percentOfShares: "Omistusosuus (%)", addOwner: "Lisää omistaja", additionalOwnerInfo: "Lisätietoja", additionalOwnerInfoLabel: "Omistusrakenne on liian monimutkainen täytettäväksi lomakkeella. Haluan, että LähiTapiola ottaa minuun yhteyttä." }, start: { wizard: { title: "Turvaamme yrityksesi jotta voit keskittyä tärkeimpään", heading: "Pyydä tarjous", title2: "Jokainen yritys ja sen ihmiset ovat ainutlaatuisia." }, heading: "Pyydä tarjous", infoText: "Keräämme tällä lomakkeella/sivustolla tiedot työtapaturmavakuutusta varten, jotka lähetetään LähiTapiolalle käsiteltäväksi", newInsurance: "Uusi työtapaturmavakuutus työntekijöille", moveInsurance: "Työtapaturmavakuutuksen siirto", newInsuranceForEntrepreneur: "Yrittäjien tapaturmavakuutus" }, thankYou: { wizard: { title: "Kiitos!" }, intro: "LähiTapiola lähettää vakuutustarjouksen sähköpostilla, jonka hyväksymällä saat vakuutuksen voimaan. Vakuutus tulee aikaisintaan voimaan hyväksymispäivästä", notNewInsuranceForEntrepreneur: { text: "Otan työtapaturmavakuutuksen", html: 'Entä Yrittäjien tapaturmavakuutus? Yrittäjien tapaturmavakuutus on laajin mahdollinen vakuutusturva yrittäjälle tapaturman varalta. Lisätietoja tapaturmavakuutuksesta <a href=" https://www.lahitapiola.fi/yritys/vakuutukset/lakisaateiset-henkilovakuutukset/yrittajien-tapaturmavakuutus" target="_blank">lahitapiola.fi –sivulta</a>.' }, newInsuranceForEntrepreneur: { text: "Otan Yrittäjien tapaturmavakuutuksen", html: 'Entä työtapaturmavakuutus työntekijälle? Lisätietoja tapaturmavakuutuksesta <a href=" https://www.lahitapiola.fi/yritys/vakuutukset/lakisaateiset-henkilovakuutukset/yrittajien-tapaturmavakuutus" target="_blank">lahitapiola.fi –sivulta</a>.' } } }, UsecaseDetailsComponent: { createSchemaName: "Mikä on lisättävän tietueen tekninen nimi (a-z, 0-1, ei välejä eikä erikoismerkkejä)?", createSchemaTitle: "Uusi tyyppi", createAction: "Käynnistä" }, FilterFunctions: { sxyOccupation: { occupationMissing: "Ei työn tyyppiä!" }, sxyCount: { period: "jakso", periods: "jaksoa" } }, CalcCostAccountingComponent: { title: "Laskentakohteet", percent: "Prosenttia", defaultLabel: "Kustannuspaikka" }, RaksaCalculationWizardComponent: { title: "Uusi laskelma", step1Title: "Valitse työntekijä", step2Title: "Palkkapäivä ja työpäivät", step3Title: "Työn tyyppi", step4Title: "Kotitalousvähennys" }, DataImport: { badgeUnit: "riviä", messageInvalid: "Virheellinen", columnImportStatus: "Tila", columnValidation: "Viestit", badgeUndoneLabel: "Ei tarkistettuja", badgeErrorLabel: "Virheellisiä", badgeSuccessLabel: "Ok", badgeFinishedLabel: "Valmis", badgeIgnoredLabel: "Ei käsiteltyjä", badgeWarningLabel: "Varoituksia", badgeUploadedLabel: "Tuotu", errorLabel: "Virhe", successLabel: "Ok", ignoredLabel: "Ei käsitelty", warningLabel: "Varoitus", help: { fields: { title: "Sarakkeet", id: "ID", type: "Tyyppi", name: "Nimi", description: "Kuvaus" }, values: { title: "Arvolistat", type: "Tyyppi", value: "Arvo", description: "Kuvaus" } }, stepUpload: { title: "Tuo Excel-tiedosto", intro: "Tuo Excel-tiedosto koneeltasi napsauttamalla 'Valitse tiedosto...' -painiketta. Voit kopioida myös Excelin sisällön leikepöydältä taulukkoon napsauttamalla 'Liitä leikepöydältä' -painiketta.", buttonHelp: "Lue ohjeet...", buttonUpload: "Valitse tiedosto...", buttonPaste: "Liitä leikepöydältä", buttonReset: "Tyhjennä taulukko" }, stepValidate: { title: "Tarkista rivit", intro: "Tarkista tuotujen rivien tiedot napsauttamalla 'Tarkista taulukon tiedot' -painiketta.", buttonValidate: "Tarkista taulukon tiedot" }, stepImport: { title: "Tallenna tiedot", intro: "Aloita tietojen tallennus napsauttamalla 'Aloita tietojen tuonti' -painiketta.", buttonCancel: "Keskeytä", buttonImport: "Aloita tietojen tuonti" } }, CalcImport: { validateWorkersButton: "Tarkista työntekijöiden työsuhteet", messageMissingEmployment: "Virhe, työntekijää ei ole luotu", messageExistingEmployment: "Ok, työntekijä on olemassa", messageSeveralEmployments: "Varoitus: usea työsuhde mahdollista", help: { title: "Laskelmien tuonti", overview: { title: "Yleistä", row1: "Taulukkoon voi syöttää useampia rivejä per työntekijä. Työntekijät identifioidaan henkilötunnuksen perusteella.", row2: "Kun rivit tallennetaan, luodaan uusi palkkalista tai päivitetään olemassa olevaa palkkalistaa. Palkkalista määräytyy yrityksen, palkkapäivän ja palkkalistan nimen perusteella." } }, options: { title: "Palkkalistan tuonnin asetukset", addRows: "Lisää rivit laskelmille", removeImportedRows: "Korvaa laskelmien tästä aineistosta tuodut rivit", removeAllRows: "Korvaa laskelmien kaikki rivit", applyEmploymentDefaultRows: "Lisää työntekijöiden oletusrivit", sourceId: "Aineistotunnus" } }, WorkerImport: { validateWorkersButton: "Tarkista työntekijöiden työsuhteet", messageMissingEmployment: "Työntekijää ei ole luotu", messageExistingEmployment: "Ok, työntekijä on olemassa", messageSeveralEmployments: "Varoitus, usea työsuhde mahdollista", help: { title: "Työntekijöiden tuonti", overview: { title: "Yleistä", row1: "Työntekijät identifioidaan henkilötunnuksen perusteella.", row2: "HUOM! Tallennus luo vain uusia työntekijöitä, olemassa olevien työntekijöiden tietoihin ei tehdä muutoksia." } } }, CompanyImport: { enrichEInvoiceAddressesButton: "Täydennä verkkolaskuosoitteet", enrichEInvoiceAddressesMessage: "Haetaan puuttuvia verkkolaskuosoitteita...", enrichEInvoiceAddressesSelectionMessage: "Valitse verkkolaskuosoite", help: { title: "Asiakkaiden tuonti", overview: { title: "Yleistä", row1: "Yritykset identifioidaan Y-tunnuksen perusteella.", row2: "Kun rivit tallennetaan, uusi yritys luodaan, jos sitä ei ole vielä luotu. Samalla syntyy asiakkuus uuteen yritykseen. Jos yritys on jo ennestään olemassa ja valtuus annettu, luodaan myös asiakkuus." } } }, InvoiceAlertsComponent: { header: "Sinulla on keskeneräisiä palkkalaskelmia {{ channel }} -maksukanavassa", description: "Sinulla on yksi tai useampi laskelma Maksu aloitettu -tilassa. Keskeneräisiä palkkalaskelmia ei ilmoiteta tulorekisteriin.", openHelp: "Avaa ohjeet", calculationLink: { html: 'Näet keskeneräiset laskelmat <a href="{{ calculationUrl }}">Laskelmat-sivulta</a>' }, payrollLink: { html: ' ja palkkalistat <a href="{{ payrollUrl }}">Palkkalistat-sivulta</a>' }, palkkausManual: { instructionText: { html: "Kuittaa ne nettopalkkojen laskut maksetuksi <b>Maksuaineiston lähetys -näkymässä</b>, jotka olet maksanut. Huomaathan, että palkka kirjataan laskelmalla olevalle alkuperäiselle palkkapäivälle. Voit myös perua laskun, jolloin laskelma palautuu luonnokseksi." } }, holvi: { instructionText: { html: "Kuittaa ne nettopalkkojen laskut maksetuksi <b>Holvin Saapuneet verkkolaskut -näkymässä</b>, jotka olet maksanut. Huomaathan, että palkka kirjataan laskelmalla olevalle alkuperäiselle palkkapäivälle. Voit myös perua laskun, jolloin laskelma palautuu luonnokseksi." } }, talenomOnline: { instructionText: { html: "Kuittaa ne nettopalkkojen laskut maksetuksi <b>Easor App -sovelluksen Maksut-näkymässä</b>, jotka olet maksanut. Huomaathan, että palkka kirjataan laskelmalla olevalle alkuperäiselle palkkapäivälle. Voit myös perua laskun, jolloin laskelma palautuu luonnokseksi." } } }, InvoiceDialog: { paymentInformation: "Maksuaineiston tiedot", paymentReceiver: "Maksun saaja", payer: "Maksaja", noIban: "Ei tilinumeroa", invoiceStatus: "Aineiston tila", paymentChannel: "Maksukanava", changeStatus: "Vaihda tilaa", change: "Vaihda", downloadInvoice: "Lataa aineisto", download: "Lataa", statuses: { paidPaymentStartedRead: { html: "<strong>HUOM</strong>: Aineisto on jo merkitty maksetuksi!<br /> Jos maksat tai lähetät aineiston / maksun uudelleen, varmistathan, ettei maksua makseta kahteen kertaan." }, canceled: { html: "Aineisto maksut on merkitty perutuksi.<br />" }, canceledErrorsInfo: { html: "Aineiston edellisessä maksussa on tapahtunut virheitä.<br />" }, forecast: { html: "<strong>HUOM</strong>: Aineisto on <strong>Arvio</strong><br /> Tyypillisesti nämä aineistot ovat vain kassavirran suunnittelua varten. Niitä ei ole tarkoitus maksaa, vaan lopullinen lasku tulee laskuttajalta (esim. Työllisyysrahasto)." }, preview: { html: "<strong>HUOM</strong>: Aineisto on <strong>Esikatselu</strong>-tilassa.<br /> Aineistoon (esim. ennakonpidätys) voi olla vielä tulossa muutoksia. Jos maksat aineiston, varmistathan ettei aineistoon tule enää muutoksia (esim. lisää palkkoja samassa kuussa)." } }, table: { receiver: "Saajan nimi", receiverIban: "Saajan IBAN", reference: "Viite", message: "Viesti", amount: "Summa", dueDate: "Eräpäivä", barcode: "Viivakoodi" } }, ValidationErrors: { sxyPensionContractNumber: "Tarkista sopimusnumero. Jos sinulla ei ole työntekijöiden työeläkevakuutusta (TyEL), voit valita Ei yhtiötä. YEL-sopimuksen numeroa ei tarvitse ilmoittaa." }, EmploymentDetails: { taxAtSource: { title: "Lähdeverokortin tiedot", info: { html: "<strong>HUOM:</strong> Lähdeverokorttia voi tyypillisesti käyttää vain, jos työntekijä on rajoitetusti verovelvollisen (asuinvaltio muu kuin Suomi).<br />Tee tarvittavat muutokset Työsuhde-välilehden alta." } }, percent: "Prosentti", monthlyDeduction: "Vähennys (kuukaudessa)", deductionDaily: "Vähennys (päivässä)" }, EmploymentRelation: { taxAtSourceInfo: "Lähdeverokortin tiedot", socSec: "Sosiaaliturva", employmentRelation: "Työsuhde", isInternational: { title: "Rajoitetusti verovelvollisen tiedot", info: { html: "Syötä tähän tiedot rajoitetusti verovelvollisen <b>vakituisessa asuinvaltiossa (ei koskaan Suomi)</b>. Yleisesti verovelvollisen palkka maksetaan kuten suomalaisille." } }, taxation: { label: "Verotus", taxAtSource: "Lähdevero", auto: "Ennakonpidätys, auto (progressiivinen)", manual: "Ennakonpidätys, manual (progressiivinen)" }, percent: "Prosentti", monthlyDeduction: "Vähennys (kuukaudessa)", deductionDaily: "Vähennys (päivässä)", calcDetails: { title: "Palkanlaskennan yksityiskohdat", wageBases: "Peruste", monthlyHours: "Tuntien määrä / kk", irIncomeEarnerTypes: "Tulonsaajatyyppi", integrations: "Integraatiot", personId: "Henkilönumero" } }, InvoiceReportComponent: { invoice: { title: "Lasku" } }, InvoicesCompany: { companyInvoiceDialog: { buttons: { cancel: "Sulje perumatta", save: "Ok, peru lasku" } }, selectInvoices: "Valitse laskut", markingAsPaid: "Merkitään maksetuksi..", markingAsCanceled: "Perutaan maksua..", gettingsInvoices: "Haetaan laskuja..", heading: "Maksua odottavat laskut", showInvoices: "Näytä laskut", receiverAndType: "Saaja ja laskun tyyppi", sum: "Summa", showInvoiceDetails: "Näytä koko lasku", qrCodeNotAvailable: "QR-koodia ei saatavilla", finishPayments: "Maksa palkat ensin", iban: "IBAN", name: "Nimi", dueDate: "Eräpäivä", message: "Viesti:", reference: "Viite:", alreadyPaid: "Jo maksettu", payable: "Maksettavaa", setAsPaid: "Merkitse valitut maksetuksi", cancelPayment: "Peru maksu", cancelInfoText: "HUOM: Maksun peruminen peruu myös tulorekisteri-ilmoituksen.", unpaidNetSalaries: "maksettua nettopalkkaa", editPaid: "Muokkaa maksettua", copyVirtualBarcode: "Kopioi virtuaaliviivakoodi", paidNetPaymentInfo: "Valmis - Maksettu palkka - Raportoidaan tulorekisteriin automaattisesti", unPaidNetPaymentInfo: "HUOM - Maksamaton palkka - Ei raportoitu tulorekisteriin", openCalculation: "Avaa laskelma", netPaymentCount: "Palkkojen lukumäärä", queryFilterDateAll: "Kaikki", queryFilterDateOther: "Muu", dateFilterDialogHeading: "Päivämäärähaku", dateFilterDialogStart: "Aloitus", dateFilterDialogEnd: "Lopetus", markAsPaidOptions: { all: "Kaikki", netInvoices: "Nettopalkat", taxInvoices: "Verolaskut", unionInvoices: "AY-maksut", foreclosureInvoices: "Ulosottolaskut", removeAll: "Poista valinnat" }, invoiceReader: { eprWarningHeading: "Huomioi palkkatietoilmoitukset!", eprWarningTextCanceled: `Palkanmaksusta tehdyt tulorekisteri-ilmoitukset perutaan automaattisesti.

Jos maksat palkan uudestaan samalle palkkapäivälle, ota huomioon, että uudesta palkkatietoilmoituksesta saattaa seurata myöhästymismaksu. Haluatko varmasti perua maksut?`, eprWarningTextPaid: "Annetulle palkkapäivälle tehtävä palkkatietoilmoitus myöhästyy, koska ilmoitus pitää tehdä 5 päivän kuluessa palkkapäivästä. Ota huomioon, että tästä saattaa seurata myöhästymismaksu. Haluatko varmasti merkitä palkan maksetuiksi?", cancellationTexts: { invoiceCancelingHeading: "Laskun peruminen", invoiceCancelingNetInvoiceText: "Jos perut laskun, laskelma siirtyy takaisin luonnostilaan. Voit halutessasi muokata laskelmaa ja siirtää sen uudestaan maksuun.", invoiceCancelingTax: "Jos perut verolaskun maksukuittauksen, se palautuu avoimeksi ja lasketetaan uudestaan. Verolaskun peruminen ei vaikuta laskelmien tai nettolaskujen tilaan.", invoiceCancelingInvoiceText: "Haluatko varmasti perua maksun?" } } } }, NG1_Other: { Roles: { employer: "Työnantaja", worker: "Työntekijä", company: "Yritys tai yhteisö", accountant: "Tilitoimisto" }, Register: { title: "Miten käytät palvelua?", text: "Valitse rooli, jolla kirjaudut palveluun." } }, NG1_Pages: { CompanyNotCompany: { title: "Tämä sivusto vaatii kirjautumisen", registerBtn: "Luo tunnus", loginBtn: "Kirjaudu" }, Info: { abcHelp: { html: `<h2 class="page-header">Näin käytät Palkkaus.fi-palvelua</h2>
<div class="videoWrapper" style="margin-bottom:30px;">
<iframe src="https://www.youtube.com/embed/utQeebqpyU0" frameborder="0" allowfullscreen></iframe>
</div>
<p>Mitä tahansa kysymyksiä sinulla on palvelun käyttöön liittyen, voit olla meihin yhteydessä ja autamme sinua mielellämme.</p>
<p>Ohje ensimmäisen palkan maksamiseen löytyy <a href="https://www.palkkaus.fi/abc/miten-palkanmaksu-tehdaan/">tämän linkin kautta</a>.</p> <p>Voit lähettää kysymyksesi tai yhteydenottopyynnön asiakaspalvelumme sähköpostiosoitteeseen <a href="&#x6D;&#x61;&#x69;&#x6C;&#x74;&#x6F;&#x3A;&#x61;&#x73;&#x70;&#x61;&#x40;&#x70;&#x61;&#x6C;&#x6B;&#x6B;&#x61;&#x75;&#x73;&#x2E;&#x66;&#x69;">aspa@palkkaus.fi</a> milloin tahansa ja otamme sinuun yhteyttä mahdollisimman nopeasti. Voit myös soittaa asiakaspalveluumme arkisin klo 9-16 välillä. Asiakaspalvelun numero on 020 798 0230</p>` }, abc: { description: "Täältä löydät lisää tietoa yrittämiseen ja palkanmaksuun liittyvistä asioista.", entrepreneur: "Yrittäjä", businessOwner: "Yritys ja yhteistyö", salary: "Palkanlaskenta ja palkanmaksu", employment: "Työsuhde ja työsopimus", documentTemplates: "Dokumenttipohjat ja lomakkeet", palkkausInstructions: "Käyttöohjeet" }, customerService: { title: "Yhteys asiakaspalveluun" }, instructions: "Käyttöohjeet", infoText: { html: "Ohjelman käyttöohjeet löytyvät tukisivustolta osoitteesta <a href='https://help.palkkaus.fi/hc/fi' target='_blank'>help.palkkaus.fi</a>.", info: "Pääset ohjeisiin myös oikean alakulman Apua-napin kautta. Kirjoita hakusana hakukenttään niin saat listauksen siihen liittyvistä ohjeista. Voit siirtyä tukisivustolle ohjeen yläkulmassa olevan nuoli-ikonin kautta. Jos et löydä sopivaa ohjetta, voit olla yhteydessä asiakaspalveluumme Apua-napin kautta, sähköpostitse tai puhelimitse, niin autamme sinua!" }, buttons: { web: { html: '<a href="https://www.palkkaus.fi/" target="_blank" class="btn btn-default">Palkkaus.fi verkossa</a>' }, dataProtection: { html: '<a href="https://www.palkkaus.fi/tietosuoja/" target="_blank" class="btn btn-default">Palvelun tietosuoja</a>' }, termsOfService: { html: '<a href="https://www.palkkaus.fi/kayttoehdot/" target="_blank" class="btn btn-default">Palvelun käyttöehdot</a>' } } }, Calc: { History: { heading: "Muualla maksettu palkka", lead: "Tällä lomakkeella lisätä tai muokata muissa palkanmaksuohjelmissa laskettu ja maksettuja palkkoja, jotka on jo ilmoitettu tulorekisteriin.", workerJobLabel: "Työntekijä / työsuhde", workerError: "VIRHE: Työntekijää ei ole määritetty", workerLabel: "Työntekijä", payrollInfo: "Palkka-aineiston tiedot", salaryDateLabel: "Laskennallinen palkkapäivä", workStartDateLabel: "Kauden alku", workEndDateLabel: "...loppu", statusLabel: "Tila", fixedTaxAmountLabel: "Ennakonpidätys (euroa)", rows: "Rivit", payrollRows: "Palkkalaskelmien rivit", reCalculate: "Laske uudelleen", cumulativePayrollRows: "Kumulatiivisen palkkalaskelman rivit", cumulativePayrollInfo: { html: "Alla näet kumulatiivisen palkkalaskelman rivit <strong>Vuoden alusta</strong>. Tähdellä* merkityt ovat näkyvissä myös edelliselle vuodelle." }, totalGrossSalary: "Bruttopalkka ilman luontoisetuja", benefits: "Luontoisedut", holidayCompensation: "Lomakorvaus", holidayBonus: "Lomaraha", holidaySalary: "Loma-ajan palkka", totalTaxable: "Ennakonpid. alainen ansio", tax: "Ennakonpidätys", pension: "Työeläkemaksu", unemploymentInsurance: "Työttömyysvakuutusmaksu", deductions: "Kaikki vähennykset palkasta", totalExpenses: "Verovapaat kustannukset", salaryPayment: "Rahana maksettu palkka" } }, Calendar: { heading: "Luo uusi kalenteritapahtuma", Occurences: { accountantCalendar: "Palkanlaskijan kalenteri", periodLabel: "Periodi", listHeading: "Lista", dailyHeading: "Päivänäkymä", weekHeading: "Viikkonäkymä" }, categorySelections: { calendarEvent: "Palkanlaskijan kalenteri", calculation: "Laskelmat (draft)", calculationPaid: "Maksetut laskelmat", payrollDetails: "Palkkalistat", messageThread: "Viestit", calculationsAndPayrolls: "Laskelmat ja palkkalistat", all: "Kaikki tietueet", none: "Ei mitään", default: "Oletus (ei mitään)" }, calendarSeriesPeriods: "Periodit", calendarSeriesActions: "Tapahtumat" }, Home: { copyRight: "Copyright Suomen Palkanlaskenta Oy", Error: { pageNotFound: "Sivua ei löytynyt", lead: { html: "Tätä sivua ei ole määritetty <code>$routeProvider</code>-komponentille (<code>angular.module.config</code>)." } } }, Invoices: { preview: "Esikatselu", calcs: "Laskelma(t)", chooseCalc: "Valitse laskelma", update: "Päivitä", printAndBarCode: "Tuloste ja viivakoodi", actions: "Toiminnot" }, Messages: { newMessage: { title: "Viestit", description: { html: "Aloita uusi viestiketju, kun haluat olla yhteydessä palkanlaskijaasi. Voit liittää viestiin myös tiedostoja. Viestit kulkevat tietoturvallisesti ja viestiketju jää talteen." } }, newMessageDetails: { title: "Lähetä uusi viesti", description: { html: "Aloita uusi viestiketju, kun haluat olla yhteydessä palkanlaskijaasi. Voit liittää viestiin myös tiedostoja. Viestit kulkevat tietoturvallisesti ja viestiketju jää talteen." } } }, Reports: { accountingIntro: "Täältä löydät kuukausi- ja vuosiraportit palkanmaksuista kirjanpitoa varten. Voit lisätä kirjanpitäjäsi sähköpostiosoitteen Asetuksissa palveluun, niin lähetämme kirjanpitoraportit kirjanpitäjällesi automaattisesti.", accountingMonthly: "Kuukausiraportit", accountingYearly: "Vuosiraportit", yearlySummary: "Lain mukaan työnantajan pitää toimittaa työntekijälle yhteenveto kaikista palkoista, joita on maksanut vuoden aikana.", yearlyTitle: "Vuosiyhteenvedot", latestReports: "Viimeisimmät raportit", Absences: { heading: "Poissaolot", calendar: "Kalenteri", list: "Lista", thisYear: "Tämä vuosi", lastYear: "Viime vuosi", thisMonth: "Tämä kuukausi", lastMonth: "Viime kuukausi", dates: "Päivämäärät", addWorker: "Lisää työntekijä", employeeNoAnsences: "Työnantajalla ei ole tallennettuja poissaoloja", first: "Ensimmäinen", latest: "Viimeisin", absencesPaid: "Palkalliset", absencesUnpaid: "Palkattomat", absencesHolidayAccrual: "Lasketaan lomakertymään", absencesNoHolidayAccrual: "Ei lasketa", absence: "poissaoloa" }, Archive: { heading: "Arkisto: Ennen vuotta 2019 lähetetyt raportit", lead: "Tässä arkistossa on raportit palkoista, jotka on maksettu ennen Tulorekisteriä: Vuonna 2018 tai aiemmin. Vuodesta 2019 lähtien tulorekisteri muutti ilmoituskäytännötä täysin ja tämä sivu on vain arkisointitarkoituksiin.", unemploymentInsuranceFund: "Työttömyysvakuutusrahasto", taxYearlyNotification: "Verottaja, vuosi-ilmoitus", taxMonthlyNotification: "Verottaja, kuukausi-ilmoitus", pension: "Työeläkevakuutus (TyEL)" }, Holidays: { holidayList: "Lomalista", holidayYear: "Lomavuosi", show: "Näytä", summerPeriod: "Kesälomakausi", otherPeriod: "Muut kausi", winterPeriod: "Talvilomakausi", list: "Lista", employeeNoHolidays: "Työnantajalla ei ole tallennettuja lomavuosia", holidayCompensation: { html: "Lomatyyppi<br /> Lomaraha" }, year: "Vuosi", planned: { html: "Suunnitellut lomat<br />Jaksot" }, summerWinter: { html: "Kesä<br />Talvi" }, endSaldo: "Kertymä", addWorker: "Lisää työntekijä" }, PayCertificate: { intro: { text: "Voit tulostaa palvelusta työntekijän palkkatodistuksen ja täydentää sitä puuttuvin osin. Lomake liitetään ansiopäivärahahakemukseen. Työnantaja täyttää lomakkeen vähintään 26/34 viikon ajalta.", html: "Katso myös <a href='https://www.tyj.fi/ukk-palkanlaskijoille/' target='_blank'>UKK palkanlaskijoille</a>" } } }, Service: { heading: "Aineiston lähetys tilitoimistolle / palkanlaskijalle", lead: "Aineiston lähetys -osiossa voit tarkistaa palkanlaskijasi sinulle luomia laskelmia ja palkkalistoja tai tehdä niihin muutoksia.", waitingApprovalPayrolls: "Tarkistettavat palkkalistat", waitingApprovalCalculations: "Tarkistettavat laskelmat", sendMaterials: "Lähetä aineistoja", temporalWorker: "Tilapäinen työntekijä", temporalWorkerInfoText: "Lähetä tästä palkanmaksupyynnöt tilapäisistä työntekijöistä. Palkanlaskija tarkistaa palkan.", sendCalc: "Lähetä laskelma", entrepreneurSalary: "Yrittäjän palkka", entrepreneurSalaryInfoText: "Maksa yrittäjän oma palkka silloin kun se sinulle parhaiten sopii.", paySalary: "Maksa palkka", boardRewards: "Hallituspalkkiot", boardRewardsInfoText: "Maksa hallituspalkkiot helposti heti kokousten jälkeen tai sovittuina aikoina.", payBoardReward: "Maksa hallituspalkkio", travelInvoices: "Matkalaskut", travelInvoicesInfoText: "Kilometrikorvaukset, päivärahat ja kulukorvaukset matkoista.", payTravelInvoice: "Maksa matkalasku", expenses: "Kulukorvaukset", expensesInfoText: "Kulukorvaukset kuittien perusteella mukaan lukien kilometrikorvaukset.", payExpense: "Maksa kulukorvaus", ApproveCalculationList: { nothingToReview: "Ei tarkastettavaa", status: "Tila", payment: "Maksu", salary: "Palkka", notSelected: "(Työntekijää ei ole valittu)", checkAndSend: "Tarkista ja lähetä" }, ApprovePayroll: { acceptAndSendPayroll: "Hyväksy ja lähetä palkkalista" }, ApprovePayrollList: { nothingToReview: "Ei tarkastettavaa", period: "Palkkakausi", payment: "Maksu", calculations: "Palkkalaskelmat", moveToPayroll: "Siirry palkkalistaan", checkAndSend: "Tarkista ja lähetä" }, Board: { heading: "Hallituspalkkion maksaminen", lead: "Tällä lomakkeella voit laittaa hallituspalkkion suoraan maksuun ilman palkanlaskijan tarkistusta.", boardMember: "Hallituksen jäsen", chooseWorker: "Valitse työntekijä", loadingWorkers: "Ladataan työntekijöitä...", newMember: "Uusi jäsen", createWorker: "Luo työntekijä", worker: "Työntekijä", change: "Vaihda", salaryDate: "Palkkapäivä", salaryDateTooEarly: "Palkkapäivä on liian aikaisin", weekday: "arkipäivää", noGuaranteeSalaryDate: "Teemme parhaamme, mutta emme takaa palkkapäivää.", period: "Palkkakausi", daysCount: "Työpäiviä kaudella", noEmploymentType: "Työsuhteen tyyppiä ei ole määritetty", monthlySalary: "Kuukausipalkka", hourCount: "Tuntien määrä", hourlySalary: "Tuntipalkka", entrepreneurSalary: "Yrittäjän palkka", salaryType: "Palkan tyyppi", salary: "Palkka / palkkio", otherRows: "Muut rivit", otherRowsMessage: "Palkan lisät", message: "Muita lisätietoja", sendMaterial: "Lähetä aineisto" }, Calculation: { heading: "Lähetä aineisto", lead: "Tällä lomakkeella voit lähettää perusmuotoisen palkka-aineiston palkanlaskijalle, joka tarkastaa tiedot ja laskee palkan puolestasi. Ilmoita palkkatiedot viimeistään 6 arkipäivää ennen palkkapäivää (palkkapäivä = päivä, jolloin rahat ovat työntekijän tilillä).", worker: "Työntekijä", chooseWorker: "Valitse työntekijä", loadingWorkers: "Ladataan työntekijöitä...", newWorker: "Uusi työntekijä", createWorker: "Luo työntekijä", change: "Vaihda", salaryDate: "Palkkapäivä", salaryDateTooEarly: "Palkkapäivä on liian aikaisin", weekday: "arkipäivää", noGuaranteeSalaryDate: "Teemme parhaamme, mutta emme takaa palkkapäivää.", period: "Palkkakausi", daysCount: "Työpäiviä kaudella", noEmploymentType: "Työsuhteen tyyppiä ei ole määritetty", monthlySalary: "Kuukausipalkka", hourCount: "Tuntien määrä", hourlySalary: "Tuntipalkka", entrepreneurSalary: "Yrittäjän palkka", salaryType: "Palkan tyyppi", salary: "Palkka / palkkio", otherRows: "Muut rivit", otherRowsMessage: "Palkan lisät", message: "Muita lisätietoja", sendMaterial: "Lähetä aineisto" }, Entrepreneur: { heading: "Yrittäjän palkka", lead: "Tällä lomakkeella voit laittaa yrittäjän (tai yrittäjän perheenjäsenen) palkan suoraan maksuun ilman palkanlaskijan tarkistusta.", entrepreneur: "Yrittäjä", chooseWorker: "Valitse työntekijä", loadingWorkers: "Ladataan työntekijöitä...", newEntrepreneur: "Uusi yrittäjä", createWorker: "Luo työntekijä", worker: "Työntekijä", change: "Vaihda", salaryDate: "Palkkapäivä", salaryDateTooEarly: "Palkkapäivä on liian aikaisin", weekday: "arkipäivää", noGuaranteeSalaryDate: "Teemme parhaamme, mutta emme takaa palkkapäivää.", period: "Palkkakausi", daysCount: "Työpäiviä kaudella", noEmploymentType: "Työsuhteen tyyppiä ei ole määritetty", monthlySalary: "Kuukausipalkka", hourCount: "Tuntien määrä", hourlySalary: "Tuntipalkka", entrepreneurSalary: "Yrittäjän palkka", salaryType: "Palkan tyyppi", salary: "Palkka / palkkio", otherRows: "Muut rivit", otherRowsMessage: "Palkan lisät", message: "Muita lisätietoja", sendMaterial: "Lähetä aineisto" } }, ServiceModels: { addServiceModel: "Lisää palvelumalli", lead: "Palvelumallit määrittelevät tavan, jolla tilitoimistona palvelet asiakkaitasi. Voit määrittää Palkkaus.fi-sivuston ulkoasun, rakenteen, ominaisuudet erittäin laajasti palvelumallikohtaisesti. Tilitoimistolla voi olla useita palvelumalleja ja kukin asiakasyritys kuuluu niistä yhteen. Palvelumallin luominen vaatii tilitoimistosopimusta.", Current: { lead: "Palvelumalli määrittää miten tilitoimisto palvelee asiakkaitaan (yrityksiä). Palvelumalliin kuuluu hinnoittelu, sivuston ja raporttien ulkoasu (brändäys), yrityssivuston rakenne ja ominaisuudet, kalenterit ja ajastukset, räätälöidyt toiminnallisuudet, työnkulku sekä automaatio (Palkkaus skriptit)." } }, Settings: { Authorizations: { lead: "Palkkaus.fi tilit, joille olet antanut valtuutuksen" }, Integrations: { lead: "Tällä sivulla näet kaikki ohjelmistokumppanipalvelut, jotka sinulla on käytössä. Aktivoi lisäpalveluita klikkaamalla kumppanikorttia" }, ServiceSettings: { heading: "Palkkaus.fi-tilin tiedot" }, SigningSuccess: { success: "Allekirjoitus onnistui" }, accountTitle: "Tili ja käyttäjä", contactLabel: "Yhteystiedot", userLabel: "Käyttäjä", insurancesTitle: "Vakuutukset", accountantTitle: "Tilitoimisto / Kirjanpitäjä", noAccountant: "Ei kirjanpitäjää / tilitoimistoa", insuranceMissing: "Puuttuu", paymentChannelsTitle: "Maksutavat", defaultChannelLabel: "Oletusmaksutapa", languageLabel: "Kieli" }, Taxcards: { heading: "Lataamasi verokortit", lead: { noWorkerHtml: "Listaus näyttää kaikki lataamasi verokortit päivitysjärjestyksessä. Useimpiin tarkoituksiin parempi listaus on <a href='#/workers/taxcards'>verokortit työntekijöittäin</a>.", workerHtml: "Listaus näyttää kaikki lataamasi verokortit päivitysjärjestyksessä. Useimpiin tarkoituksiin parempi näkymä <a href='#/taxcards'>on omat aktiiviset verokortit</a> näkymä." }, Details: { heading: "Verokortit (PRO)", lead: "Tilitoimiston ja palkanlaskijan näkymä verokortteihin.", overview: "Yleiskuva (yrityksen)", noAttachment: "Ei liitetiedostoa", download: "Lataa", editing: "Muokkaus (PRO)", allTaxcards: "Kaikki verokortit", deleteButton: "Poista (test)", deleteButtonInfo: "Verokortin poistaminen testissä: Tästä voit poistaa laskelman testissä vaikka se ei olisikaan mahdollista tuotantoympäristössä. Normaalisti verokortti poistetaan tuotantoympäristössä työntekijäkohtaisesta verokorttilistasta, jossa 'Poista' on näkyvissä vain, jos verokortin voi poistaa." } }, Usecases: { createNewUsecase: "Luo uusi räätälöinti", usecase: "Räätälöinti (usecase)", lead: "Räätälöinti on yrityskohtainen käyttöliittymä ja/tai liiketoimintalogiikka, joka voidaan liittää esim. laskelmaan, palkkalistaan, työsuhteeseen, lomavuoteen tai poissaoloihin. Räätälöinnillä voidaan automatisoida prosesseja tai lisätä uusia laskentalogiikoita tai tarkistuksia." }, Workers: { newWorker: "Uusi työntekijä", Taxcards: { lead: "Verokorttilistaus näyttää kaikki työsuhteet ja voimassa olevat verokortit tietylle palkanmaksupäivälle." } } }, NG1_PagesPersonal: { index: { account: { iban: "IBAN", phone: "Puh", showAccountInfoBtn: "Omat tiedot" }, alert: { anon: { html: "<strong>Et ole kirjautunut</strong> Tämä sivu vaatii kirjautumisen" }, company: { html: "<strong>Tämä on kotitalouden / työntekijän sivu!</strong> Olet kirjautunut sisään yrityksenä. Kirjaudu ulos ja uudelleen kotitaloutena tai työntekijänä. Jos yrität päästä yrityspalveluun, tai et muuten tiedä mitä tehdä, ota yhteys asiakaspalveluun." } }, taxcard: { incomeLimit: "Tuloraja", leftBeforeLimit: "Jäljellä ennen tulorajaa", taxPercent: "Veroprosentti", taxPercent2: "Lisäprosentti", totalIncome: "Palkkoja maksettu", validTill: { html: "<span class='text-success'>Voimassa</span> <span class='small'>({{validityEnd}} asti)</span>" }, buttons: { sendTaxcardBtn: "Lähetä verokortti", showFileBtn: "Näytä tiedosto", showTaxcardsBtn: "Näytä verokortit" }, addTaxcardText: { html: "Työnantaja <strong>{{employer}}</strong> on maksanut sinulle palkkaa <strong>{{salary}}</strong> euroa. <br /> Jotta voimme maksaa tämän palkan sinulle, sinun täytyy syöttää verokortti." }, addTaxcardTitle: "Lisää verokortti", sendTaxcardTitle: "Lähetä verokortti työnantajillesi", sendTaxcardText: " Voit ladata jaetun verokortin, jolle työnantajasi voivat maksaa palkkaa. Verokortti näkyy työnantajalle seuraavan palkanmaksun yhteydessä." }, workerInvitation: { workerInvitationText: "Työnantaja on maksanut sinulle palkkaa", workerInvitationText2: "Jotta voimme maksaa tämän palkan sinulle, sinun täytyy syöttää verokortti.", showTaxcardsBtn: "Näytä verokortit" }, sendCalculation: { panelHeading: "Lähetä laskelma", panelTitle: "Lähetä laskelma työnantajallesi", panelText: "Voit lähettää valmiin palkkalaskelman työnantajallesi maksettavaksi. Täytä tarvittavat tiedot laskelmalle laskurilla ja jaa laskelma työnantajallesi.", button: "Tee uusi laskelma" }, calculation: { grossSalary: "Bruttopalkka", netSalary: "Nettopalkka", taxes: "Verot", buttons: { openCalculationBtn: "Avaa laskelma", showCalculationBtn: "Näytä laskelma", downloadPdfBtn: "Lataa PDF" } } }, error404: "VIRHE: Sivupohjaa ei löytynyt", taxcards: { intro: { html: '<p class="lead">Palkkaus.fi-palvelu tarkistaa nykyisen verokortin tiedot aina verottajan rajapinnasta. Teemme tarkistuksen myös jokaisen palkanmaksun yhteydessä, joten sinun ei tarvitse lisätä uutta verokorttia: Riittää, että huolehdit, että verottajalla olevassa verokortissa on sopivat tulotiedot / prosentti.</p><p><strong>Jos sinulla on useita työnantajia, kaikki palkat näkyvät samalla verokortilla,</strong> joten voit kätevästi seurata tulorajan ylittämistä etkä saa veromätkyjä.</p>' }, introGetAutoTaxcard: { html: "Palkkaus.fi-palvelussa on nyt käytössä verottajan automaattinen Ennakonpidätys-rajapinta. <strong>Veroprosentit tarkistetaan automattisesti suoraan verottajalta jokaisen palkanmaksun yhteydessä, eikä sinun tarvitse enää syöttää verokortin tietoja.</strong> Klikkaa nappulaa ottaaksesi automaattinen haku käyttöön." }, buttons: { getTaxPercentsBtn: "Hae veroprosentit verottajalta", checkTaxPercentsBtn: "Hae veroprosentit verottajalta", addManualTaxcardBtn: "Lisää manuaalinen verokortti", updateCalcsBtn: "Päivitä laskelmat" }, addSharedCardTitle: "Lisää jaettu verokortti", updateCalcsNote: { html: 'HUOM: Kaikkia palkkojasi ei ole merkitty tälle verokortille. Tämä voi johtua siitä, että jollain työnantajalla on erikseen lisätty verokortti. Päivitä kaikki maksetut laskelmat verokorttiin klikkaamalla "Päivitä laskelmat".' }, calcsPaidForCardTabHeading: "Verokortille maksetut laskelmat", employersTabHeading: "Työnantajat", cardStatusTableHeading: "Jaetun kortin tila", yearTableHeading: "Vuosi", cardStatus2TableHeading: "Tila", employerTableHeading: "Työnantaja", typeTableHeading: "Tyyppi", taxPercentTableHeading: "Veroprosentti", taxPercent2TableHeading: "Lisäprosentti", salariesPaidTableHeading: "Palkkoja maksettu", incomeLimitTableHeading: "Tuloraja", validDateTableHeading: "Voimassa", startDateTableHeading: "Otettu käyttöön", earlierTaxCardsTabHeading: "Aikaisemmat verokortit", incomeLimitSpanTableHeading: "...ylittävä %", approveBtn: "Hyväksy" }, employmentContracts: { intro: "Palkkaus.fi -kotitalouspalvelussa oli mahdollista luoda työsopimuksia kotitalouden ja työntekijän välillä (vain suomeksi). Koska kotitalouspalvelu on päätetty lopettaa vuoden 2020 lopussa, uusia sopimuksia ei voi enää luoda eikä vanhoja muokata. Vanhat sopimukset säilyvät kuitenkin arkistossa." }, employerArchive: { intro: { html: 'Palkkaus.fi -kotitalouspalvelussa myös kotitaloudet pystyivät maksamaan palkkaa (vain suomeksi) ja Palkkaus.fi hoiti kotitalousvähennysten ilmoittamisesta verottajalle. <strong>Kotitalouspalvelu suljettiin vuoden 2020 lopussa</strong>, Rakentamisen ja remontoinnin palkkoja voi maksaa edelleen <a href="https://palkkamylly.palkkaus.fi/" target="_blank">Rakennusliiton Palkkamylly-palvelussa</a>. <strong>Näille sivuille on kerätty arkistoon dokumentteja kotitaloustyöntantajien palkanmaksuun liittyen.</strong>' } } }, NG1_Services: { UiCrudHelpers: { taxcards: { noTaxcardTitle: "Verokortin tallennus epäonnistui!", noTaxcardText: 'Verokortin tietoja ei ole tallennettu. Tyypillisesti tämä johtuu siitä, että verottajalla ei ole verokorttia tälle henkilötunnukselle. Lisää verokortin tiedot työntekijän tiedoissa. Kysy tarvittaessa verokorttia työntekijältä tai käytä valintaa "Ei verokorttia (60% ennakonpidätys)".' } }, AuthorizedAccountService: { partnerIntegrationSiteList: { askelma: { title: "Askelma", description: "Palkanmaksupalvelu Askelmassa" }, domus: { title: "Domus", description: "Domus-isännöintijärjestelmä" }, easoft: { title: "Easoft", description: "Palkanmaksupalvelu Easoftissa" }, ecom: { title: "Ecom", description: "Ecom - Rakennusalan toiminnanohjaus" }, holvi: { title: "Holvi", description: "Palkanmaksupalvelu Holvissa" }, isolta: { title: "Isolta", description: "Isolta Arkhimedes -palkanmaksu" }, finago: { title: "Procountor Solo", description: "Sooloyrittäjän kirjanpito- ja laskutusohjelma" }, accountor: { title: "Accountor Go", description: "Accountor Go palvelu pienyrityksillä" }, briox: { title: "Briox", description: "Palkanmaksupalvelu Brioxissa" }, nocfo: { title: "NOCFO", description: "Helppokäyttöinen kirjanpito-ohjelma pienyrityksille ja yhdistyksille" }, passeliMerit: { title: "Passeli Merit", description: "Taloushallinnon kokonaisuus kaikkiin tarpeisiin" } } } }, NG1_Sitemap: { home: "Yleiskuva", calculations: { main: "Palkanmaksu", index: "Viimeisimmät", paid: "Maksetut", "paid-ir": "Maksetut", draft: "Luonnokset", received: "Vastaanotetut", shared: "Lähetetyt", repairs: "Korjaukset", repair: "Korjaus", details: "Palkkalaskelma", copyAsNew: "Uusi laskelma (kopio)", newForWorker: "Uusi laskelma", sharing: "Jaa laskelma", sepaInvoices: "Maksuaineiston lähetys", companyInvoices: "Maksamattomat laskut", payroll: { main: "Palkkalistat", details: "Palkkalistan muokkaus/maksu", import: "Datan tuonti" }, importCalcs: "Palkkalistan tuonti" }, payroll: { main: "Palkkalistat", details: "Palkkalistan muokkaus/maksu", import: "Datan tuonti" }, sendCalculation: "Lähetä aineisto", messages: { main: "Viestit", index: "Kaikki viestit", new: "Uusi viestiketju", details: "Viestiketju" }, workers: { main: "Työntekijät", index: "Kaikki työntekijät", employments: "Kaikki työntekijät", taxcards: "Verokortit", details: "Työntekijän tiedot", workerDetails: "Työntekijän tiedot", importWorkers: "Työntekijöiden tuonti" }, reports: { main: "Raportit", index: "Yleiskuva", accounting: { main: "Kirjanpito", details: "Kirjanpidon tiedot" }, accountingQuery: "Kirjanpitokyselyt", accountingEditor: "Kirjanpitoasetukset", accountingReports: "Kirjanpidon raportit", accountingHolidayPayDebtQuery: "Lomapalkkavelka", holidayReport: "Lomalaskennan yhteenveto", holidayPayReportQuery: "Lomapalkan laskenta", summaryReportQuery: "Palkkojen yhteenvetoraportti", salaryReports: "Palkkalaskelmat", employerPayments: "Maksut, jotka työnantaja hoitaa", yearlySummary: "Työntekijöiden vuosiyhteenvedot", earningsReports: "Palkkatietoilmoitukset", accountingLegacy: "Arkisto", archive: "Arkisto (-2018)", invoices: { main: "Maksut", details: "Laskun tiedot" }, "ad-hoc": { main: "Raporttikone", details: "Raporttikone" }, irepr: { main: "Palkkatietoilmoitukset", details: "Palkkatietoilmoitus" }, irpsr: { main: "Erillisilmoitukset", details: "Erillisilmoitus" }, payCertificate: "Palkkatodistus" }, worktime: { main: "Lomat ja poissaolot", holidays: "Lomalista", absences: "Poissaolot" }, service: { main: "Aineiston lähetys" }, settings: { main: "Asetukset", index: "Yleiskuva", paymentSettings: "Palkanmaksun asetukset", insurances: "Vakuutukset", paymentChannelSettings: "Maksutavat", accountingTargetSettings: "Kirjanpitokohteet", serviceSettings: "Tilin tiedot", ownerSettings: "Osakasluettelo", authorizations: "Valtuutukset", accountants: "Tilitoimisto", integrations: "Integraatiot", assureWorkerAccount: "Luo uusi työntekijätili", accountReset: "Demotilin data", paymentChannel: "Maksukanava", proSettings: "Pro - asetukset", rowTypesSettings: "Palkkalajit", accountingEditor: "Kirjanpitoasetukset" }, "pro-service": { main: "Palvelumalli (PRO)", proSettings: "Pro - asetukset", usecases: { main: "Räätälöinnit", details: "Räätälöinti" }, "worktime-imports": { main: "Työajan tuonti (import)", details: "Työajan tuonti (import)", upload: "Työajan tuonti -lomake" }, "calendar-occurences": { main: "Palkanlaskijan kalenteri", details: "Kalenteritapahtuma" }, calendar: { main: "Ajastukset", details: "Ajastus" }, accountingTargets: { main: "Kirjanpidon tiliöinnit", details: "Kirjanpidon tiliöinti" }, customerInvoices: { main: "Palvelun laskut", details: "Palvelun laskut" }, serviceModels: { main: "Palvelumallit", details: "Palvelumallit" } }, info: { main: "Ohjeet ja tuki", abc: "Palkkauksen abc", index: "Asiakaspalvelu", invite: "Kutsu käyttäjäksi", aboutUs: "Tietoa palvelusta" }, personalWeb: { home: "Etusivu", taxcards: "Verokortit", calculations: { main: "Palkkalaskelmat", paid: "Maksetut", sent: "Lähetetyt", draft: "Luonnokset", error: "Perutut ja virheet", new: "Uusi laskelma", calc: "Palkkalaskelma", share: "Jaa laskelma" }, archive: { main: "Arkisto", workerReport: "Työntekijän yhteenveto", employmentContracts: "Työsopimukset", householdDeductionReport: "Kotitalousvähennys" }, employerArchive: { main: "Työnantajan arkisto", employerPaid: "Maksetut palkat", employerReport: "Kotitalouden yhteenveto", householdYears: { main: "Kotitalousvähennys", details: "Kotitalousvähennyksen tiedot" } }, account: "Omat tiedot", abc: "Ohjeet" } }, omapalkka: { AccountView: { personalInfoHeading: "Henkilötiedot", contactInfoHeading: "Yhteystiedot", avatarHeading: "Kuva", authorizationHeading: "Tunnistautuminen" }, AccountAvatarEditPerson: { avatarLabel: "Kuva", avatarTypeLabel: "Kuvan tyyppi", initialsLabel: "Nimikirjaimet", optionChoose: "Valitse kuvan tyyppi", optionIcon: "Kuvake", optionUploaded: "Kuva omalta koneelta", optionGravatar: "Gravatar", gravatarInfo: { html: "Gravatar-kuva on linkitetty sähköpostiosoitteeseen ja sähköpostiosoitteen omistaja voi itse vaihtaa kuvan osoitteessa www.gravatar.com. Sitä käytetään myös monissa muissa palveluissa: blogeissa, keskustelufoorumeilla jne." }, uploadImageLabel: "Lataa kuva koneelta", avatarDescription: { html: "Kuva ei ole pakollinen tieto palkanmaksussa." } }, AccountAuthorizationPerson: { privacyStatementBtn: { html: '<a href="https://www.palkkaus.fi/tietosuoja/" target="_blank">Lue</a>' }, privacyStatementLabel: "Palkkaus.fi:n tietosuojaseloste", privacyBtn: { html: '<a href="https://www.palkkaus.fi/sopimus-henkilotietojen-kasittelysta/" target="_blank">Lue</a>' }, privacyLabel: "Sopimus henkilötietojen käsittelystä", termsBtn: { html: '<a href="https://www.palkkaus.fi/kayttoehdot/" target="_blank">Lue</a>' }, termsLabel: "Palkkaus.fi:n käyttöehdot", termsAndPrivacyTitle: "Tietosuoja ja käyttöehdot", authMethodLabel: "Kirjautumistapa", userNameLabel: "Käyttäjätunnus:", userInfoTitle: "Käyttäjätiedot", authorizationTypeLabel: "Valtuutus:", credentialLabel: "Tunniste:", haveIdentified: "Olet tunnistautunut", identifyBtn: "Tunnistaudu", notIdentified: "Et ole vielä tunnistautunut", identificationTitle: "Tunnistautuminen" }, AccountContactEditPerson: { verificationPinInfo: "Puhelinnumeroa käytetään kevyeen tunnistautumiseen. Siksi numeron vaihtaminen vaatii varmistuksen tekstiviestillä.", orderVerificationBtn: "Tilaa koodi", addressInfo: "Osoite ei ole pakollinen palkanmaksussa." }, AccountDetailsEditPerson: { languageSelectionLabel: "Kieli:", nameDescription: { html: "Nimen muokkaaminen vaatii aina pankki&shy;tunnistuksen. Tämä hoidetaan rekisteröinnin ohjatulla toiminnolla." }, personalIdDescription: { html: "Palkkaus.fi-tili on aina kiinnitetty henkilötunnukseen. Jos henkilötunnuksesi muuttuu, kirjaudu ulos ja luo uusi Palkkaus.fi-tili uudella henkilötunnuksella tai ota yhteys asiakaspalveluumme." } } }, REPORTS: { document: { footerInfo: { html: "Tämä dokumentti on tuotettu {{date}} palvelussa Palkkaus.fi<br />aspa@palkkaus.fi, puh: 09 425 50603 (ark. 9–12)" }, noLogoFooterInfo: "Tämä dokumentti on tuotettu {{date}}", preview: "Esikatselu" }, ENUM: { CalcGroup: { baseSalary: { label: "Rahapalkka" }, benefits: { label: "Edut ja tuet" }, deductions: { label: "Vähennykset" }, disabled: { label: "Ei otettu huomioon" }, expenses: { label: "Kulukorvaukset" }, otherNoPayment: { label: "Muut erät" }, salaryAdditions: { label: "Lisät" }, totals: { label: "Yhteensä" } } }, employer: { title: "Työnantajan laskelma" }, payment: { title: "Yhteiskunnan laskelma", summaryTitle: "Yhteiskunnan laskelma (kooste)", summarySubTitle: "Palkkapäivä" }, salary: { title: "Palkkalaskelma", subtitle: "Palkkapäivä", heading: { accidentInsurancePayment: "Työtapaturmavakuutus", amount: "Määrä", aPrice: "A-hinta", bankAccountNumber: "Tilinumero", description: "Kuvaus", employer: "Työnantaja", employerHandledPensionPayment: "Työeläke (TyEL)", employerHandledUnemploymentInsurancePayment: "Työttömyysvakuutusmaksu", employerHandledUnionPayment: "Työnantaja tilittää AY-jäsenmaksun", employerPaidForeclosure: "Työnantaja maksaa suoraan ulosottomiehelle", employerPaidOtherDeduction: "Työnantajan maksama muu vähennys", employerPaidPension: "Työnantaja maksaa itse TyEL-maksun", employerPaidSalaryAdvance: "Työnantaja on maksanut palkkaennakkoa", employerPaidUnemploymentInsurance: "Työnantaja maksaa itse työttömyysvakuutusmaksun", employerPaidUnion: "Työnantajan maksaa itse AY-maksun", employerPaidTaxAndSocialSecurity: "Työnantaja maksaa itse ennakonpidätyksen ja työnantajan sairausvakuutusmaksun", employerPaidWorker: "Työnantaja maksaa itse nettopalkan", euros: "Euroa", foreclosure: "Ulosotto", foreclosureExecutor: "Ulosottomies", framework: "Työehtosopimus", fromEmployer: "Työnantajalta", fromSum: "Summasta", fromWorker: "Työntekijältä", grossSalaryLikeBaseSalaryAbove: "Bruttopalkka (rahapalkka yllä)", householdDeduction: "Kotitalousvähennys verotuksessa", incomesRegister: "Tulorekisteri", insufficientSalary: "Palkka ei riitä työntekijän osuuteen sivukuluista", mandatorySideCosts: "Pakolliset sivukulut", moreInfoOnNextPage: "Lisätietoja seuraavalla sivulla", netSalary: "Nettopalkka", noAccidentInsurancePayment: "Työtapaturmavakuutus", noPensionPayment: "Ei TyEL-maksua", noSocialInsurancePayment: "Ei sairausvakuutusmaksua", noUnemploymentInsurancePayment: "Ei työttömyysvakuutusmaksua", nullPensionPayment: "Työeläke (TyEL)", nullSocialInsurancePayment: "Sairausvakuutusmaksu", nullUnemploymentInsurancePayment: "Työttömyysvakuutusmaksu", taxSelfPayment: "Ennakonpidätyksen maksaminen", workerSelfPayment: "Nettopalkan maksaminen", numberOfWorkDays: "Työpäiviä", otherDeductions: "Muut vähennykset", paidAt: "Maksupäivä", palkkausFee: "Maksu Palkkaus.fi-palvelulle", palkkausfi: "Palkkaus.fi", palkkausHandledPensionPayment: "Työeläke (TyEL)", palkkausHandledTempPensionPayment: "Työeläke (TyEL)", palkkausHandledUnemploymentInsurancePayment: "Työttömyysvakuutusmaksu", palkkausHandledUnionPayment: "Palkkaus.fi hoitaa AY-jäsenmaksun", paymentPart: "Maksettavat erät", pensionPayment: "Työeläkemaksu", percentOf: "Prosenttia", prepaidExpenses: "Ennakkoon maksetut kulukorvaukset", raksa: "Rakennusliitto", receiver: "Vastaanottaja", salaryAdditionalInfo: "Lisätiedot palkkalaskelmaan", salaryAdvance: "Palkkaennakko", salaryCost: "Palkkakustannus", salaryDate: "Palkkapäivä", requestedSalaryDate: "Palkkapäivä", sideCosts: "Sivukulut", socialInsurancePayment: "Sairausvakuutusmaksu", socialSecurityNumber: "Henkilötunnus", taxAtSource: "Lähdevero", taxcardTaxPercent: "Perusprosentti", taxcardTaxPercent2: "Lisäprosentti", taxman: "Verottaja", toBePaid: "Maksetaan", total: "Yhteensä", totalCost: "Kokonaiskustannus", totalCostAfterTax: "Kokonaiskustannus kotitalousvähennyksen jälkeen", tvr: "Työllisyysrahasto", unemploymentInsurancePayment: "Työttömyysvakuutusmaksu", union: "Ammattiliitto", unionPayment: "AY-jäsenmaksu", withholdingTax: "Ennakonpidätys", workDescription: "Kuvaus", worker: "Työntekijä", workersEmployerHandledUnionPayment: "HUOM: Työnantaja maksaa suoraan ammattiliitolle", workersAccidentInsurancePayment: "Työtapaturmavakuutus", workersEmployerHandledPensionPayment: "Työeläke (TyEL)", workersEmployerHandledUnemploymentInsurancePayment: "Työttömyysvakuutusmaksu", workersNullSocialInsurancePayment: "Sairausvakuutusmaksu", workersPalkkausHandledPensionPayment: "Työeläke (TyEL)", workersPalkkausHandledUnemploymentInsurancePayment: "Työttömyysvakuutusmaksu", workersSocialInsurancePayment: "Sairausvakuutusmaksu", employmentPeriodStart: "Työsuhteen alku", employmentPeriodStartAndEnd: "Työsuhteen alku ja loppu", workPeriod: "Ajalta", totalGrossSalary: "Bruttopalkka ilman luontoisetuja", benefits: "Luontoisedut", annualHolidayCompensation: "Lomakorvaus", holidayBonus: "Lomaraha", holidaySalary: "Loma-ajan palkka", totalTaxable: "Ennakonpid. alainen ansio", tax: "Ennakonpidätys", pension: "Työeläkemaksu", unemploymentInsurance: "Työttömyysvakuutusmaksu", deductions: "Kaikki vähennykset palkasta", totalExpenses: "Verovapaat kustannukset", salaryPayment: "Rahana maksettu palkka", cumulativeData: "Kumulatiiviset tiedot", thisYear: "Kuluva vuosi", previousYear: "Edellinen vuosi", workerCount: "Työntekijöitä", calculationCount: "Laskelmia", totalGrossSalaryAlt: "Bruttopalkka", totalWorkerPayment: "Työntekijöille maksetaan", taxAtSourceComment: "Lähdeverovähennys", accrualTotalDays: "Päättyneeltä loman ansaintavuodelta kertynyt loma yhteensä", holidayPayAccrualUsedDays: "Lomaa käytetty/maksettu", holidayPayAccrualRemainingDays: "Lomaa jäljellä/maksamatta", holidayBonusAccrualUsedDays: "Lomarahaa käytetty/maksettu", holidayBonusAccrualRemainingDays: "Lomarahaa jäljellä/maksamatta", newAccrualTotalDays: "Kuluvalta loman ansaintavuodelta kertynyt loma yhteensä" }, text: { accidentInsurancePayment: { html: "Työtapaturmavakuutus ei sisälly laskelmaan. Työnantajan työtapaturmavakuutus on yhtiössä <strong>{{company}}</strong>, vakuutusnumero <strong>{{contractNo}}</strong>. Ilmoitamme tämän tulorekisteriin." }, athletePension: "Tämä palkka on urheilijan palkkaa, eikä siitä siksi makseta TyEL-maksuja.", athleteUnemploymentInsurance: "Tämä on urheilijan palkkaa, eikä siitä siksi makseta työttömyysvakuutusmaksua.", compensationPension: "Tämä on työkorvausta, eikä siitä siksi makseta TyEL-maksuja.", compensationSocialInsurance: "Tämä on työkorvausta, eikä siitä siksi makseta työnantajan sairausvakuutusmaksua.", compensationUnemploymentInsurance: "Tämä on työkorvausta, eikä siitä siksi makseta työttömyysvakuutusmaksua.", employerHandledPartialOwnerUnemploymentInsurancePayment: "Tämä on osaomistajan palkkaa.Työnantajan osuus työttömyysvakuutusmaksusta on {{employerAmount}} € ja työntekijän osuus on {{workerAmount}} €. Palvelu ei tilitä työttömysvakuutusmaksua vaan Työllisyysrahasto laskuttaa suoraan työnantajaa neljännesvuosittain.", employerHandledPensionPayment: { html: "Työnantaja on ilmoittanut työeläkeyhtiökseen <strong>{{company}}</strong>, vakuutusnumero <strong>{{contractNo}}</strong> ja hoitaa työeläkemaksut itse. Palvelu tekee tulorekisteri-ilmoituksen ja työeläkeyhtiö laskuttaa asiakasta." }, employerHandledUnemploymentInsurancePayment: "Työnantajan osuus työttömyysvakuutusmaksusta on {{employerAmount}} € ja työntekijän osuus on {{workerAmount}} €. Palvelu ei tilitä työttömyysvakuutusmaksua vaan Työllisyysrahasto laskuttaa työnantajaa neljännesvuosittain.", employerHandledUnionPayment: "Työntekijän palkasta on vähennetty AY-jäsenmaksu {{paymentRound}} euroa ({{percent}}). HUOM: Työnantaja maksaa tämän suoraan ammattiliitolle.", entrepreneurPension: "Tämä palkka on YEL-palkkaa, eikä siitä siksi makseta TyEL-maksuja.", entrepreneurUnemploymentInsurance: "Tämä on YEL-palkkaa, eikä siitä siksi makseta työttömyysvakuutusmaksua.", farmerPension: "Tämä palkka on MYEL-palkkaa, eikä siitä siksi makseta TyEL-maksuja.", farmerUnemploymentInsurance: "Tämä on MYEL-palkkaa, eikä siitä siksi makseta työttömyysvakuutusmaksua.", followsRaksaFramework: "Erillinen palkan osa ja lomakorvaus ovat laskettu Rakennusalan työehtosopimuksen mukaan.", householdDeduction: "Huomioithan, että kotitalousvähennyksessä on 100 euron omavastuu / henkilö. Tätä ei ole huomioitu laskelmassa, koska omavastuu vähennetään pois vain kerran vuodessa. Kotitalousvähennyksessä on myös enimmäismäärä 2 400 euroa henkilöä kohti. Pariskunnalle omavastuu on 100 euroa 2 400 euroon asti ja 200 euroa 4 800 euron enimmmäismäärään asti.", householdDeductionVar: "Huomioithan, että kotitalousvähennyksessä on {{ownRisk}} euron omavastuu / henkilö. Tätä ei ole huomioitu laskelmassa, koska omavastuu vähennetään pois vain kerran vuodessa. Kotitalousvähennyksessä on myös enimmäismäärä {{max}} euroa henkilöä kohti. Pariskunnalle omavastuu on {{ownRisk}} euroa {{max}} euroon asti ja {{ownRiskDouble}} euroa {{maxDouble}} euron enimmmäismäärään asti.", incomesRegisterNote: "Palvelu tekee ilmoituksen tulorekisteriin viiden päivän kuluessa palkanmaksusta.", missingAccidentInsurance: "Työtapaturmavakuutus ei sisälly laskelmaan. Jos maksat palkkoja yli 1400€/vuosi, tulee ottaa työtapaturmavakuutus ennen työn aloittamista. Jos sinulla on jo vakuutus, lisää tieto palvelun asetuksissa. Voi myös ottaa vakuutuksen Palkkaus.fi:n kautta.", taxcardCumulativeIncome: "Tuloraja (käytetty)", taxcardNoCumulativeIncome: "Tuloraja", noAccidentInsurance: "Tämä ei ole työtapaturmavakuutuksen alaista palkkaa.", noEmployerDetails: "Työnantajan tietoja ei ole syötetty", noTaxcard: "Ei verokorttia (60%)", noWithholdingHousehold: "Ei verokorttia (kotitalous, alle 1500€ / vuosi)", percents: "Verokortin prosentit", noWorkerDetails: "Työntekijän tietoja ei ole syötetty", nullPensionPayment: "Tästä palkasta ei makseta työelämaksuja. Työeläke on pakollinen, jos työntekijälle maksetaan kuukaudessa yli {{amount}} € ja työntekijä on 17-67-vuotias.", nullSocialInsurancePayment: "Tästä palkasta ei makseta työnantajan sairausvakuutusmaksua. Sairausvakuutusmaksua maksetaan, jos työntekijä on 16-67-vuotias.", nullUnemploymentInsurancePayment: "Tästä palkasta ei makseta työttömyysvakuutusmaksua. Työttömyysvakuutusmaksua maksetaan, jos työntekijä on 18-64-vuotias.", taxSelfPayment: "Työnantaja maksaa ennakonpidätyksen suoraan verottajalle.", socialSecuritySelfPayment: "Työnantaja maksaa työnantajan sairausvakuutusmaksun verottajalle osana työnantajasuorituksia.", workerSelfPayment: "Työnantaja maksaa nettopalkan suoraan työtekijälle.", otherDeductionsError: { html: "Jo maksetuksi muuksi vähennykseksi on merkitty {{fullAmount}} euroa, mutta palkka ei riitä tämän maksamiseen.<br><strong>{{differenceAmount}} euroa maksetusta muusta vähennyksestä jää seuraavalle kuukaudelle.</strong>" }, palkkausHandledPensionPayment: { html: "Työnantaja on ilmoittanut työeläkeyhtiökseen <strong>{{company}}</strong>, sopimusnumero <strong>{{contractNo}}</strong>. Palvelu tekee tulorekisteri-ilmoituksen ja tilittää työeläkemaksun työeläkeyhtiöön." }, palkkausHandledTempPensionPayment: { html: "Palkkaus.fi hoitaa TyEL-maksun tilapäisenä työnantajana. Työeläkeyhtiö on <strong>{{company}}</strong>." }, palkkausHandledUnemploymentInsurancePayment: "Työnantajan osuus työttömyysvakuutusmaksusta on {{employerAmount}} € ja työntekijän osuus on {{workerAmount}} €. Palvelu tilittää työttömysvakuutusmaksun Työllisyysrahastolle neljännesvuosittain.", palkkausHandledUnionPayment: "Työntekijän palkasta on vähennetty AY-jäsenmaksu {{paymentRound}} euroa ({{percent}}). Palkkaus.fi-palvelu tilittää tämä suoraan ammattiliitolle.", pensionError: { html: "Työntekijän osuus TyEL-maksusta on {{fullAmount}} euroa, mutta palkka ei riitä tämän maksamiseen<br><strong>{{differenceAmount}} euroa jää työnantajan maksettavaksi.</strong>" }, prepaidExpensesError: { html: "Ennakkoon maksetuiksi kulukorvauksiksi on merkitty {{fullAmount}} euroa, mutta kulukorvausten määrä ei riitä tämän maksamiseen." }, salaryAdvanceError: { html: "Jo maksetuksi palkkaennakoksi on merkitty {{fullAmount}} euroa, mutta palkka ei riitä tämän maksamiseen<br><strong>{{differenceAmount}} euroa palkkaennakosta jää seuraavalle kuukaudelle.</strong>" }, socialInsurancePayment: "Palvelu tilittää työnantajan sairausvakuutusmaksun verottajalle osana työnantajasuorituksia.", unemploymentInsuranceError: { html: "Työntekijän osuus Työttömyysvakuutusmaksusta on {{fullAmount}} euroa, mutta palkka ei riitä tämän maksamiseen.<br><strong>{{differenceAmount}} euroa jää työnantajan maksettavaksi.</strong>" }, unionPaymentError: { html: "Palkasta piti maksaa AY-jäsenmaksua {{fullAmount}} euroa, mutta palkka ei riitä ennakoiden ja sivukulujen jälkeen tämän maksamiseen.<br><strong>AY-jäsenmaksua ei ole tilitetty - työntekijän tulee maksaa se itse.</strong>" }, workersAccidentInsurancePayment: { html: "Työtapaturmavakuutus ei sisälly laskelmaan. Työnantajan työtapaturmavakuutus on yhtiössä <strong>{{company}}</strong>, vakuutusnumero <strong>{{contractNo}}</strong>." }, workersEmployerHandledPartialOwnerUnemploymentInsurancePayment: "Tämä on osaomistajan palkkaa.", workersEmployerHandledPensionPayment: { html: "Työnantajalla on työeläkesopimus yhtiössä <strong>{{company}}</strong>, vakuutusnumero <strong>{{contractNo}}</strong>." }, workersEmployerHandledUnemploymentInsurancePayment: "Tämä on työttömyysvakuutusmaksun alaista palkkaa.", workersMissingAccidentInsurance: "Työtapaturmavakuutus ei sisälly laskelmaan. Työnantaja ei ole ilmoittanut työtapaturmavakuutuksen tietoja.", workersNullSocialInsurancePayment: "Tästä palkasta ei makseta sairausvakuutusmaksua. Sairausvakuutusmaksua maksetaan, jos työntekijä on 16-67-vuotias.", workersPalkkausHandledPensionPayment: { html: "Työnantajalla on työeläkesopimus yhtiössä <strong>{{company}}</strong>, vakuutusnumero <strong>{{contractNo}}</strong>." }, workersPalkkausHandledUnemploymentInsurancePayment: "Tämä on työttömyysvakuutusmaksun alaista palkkaa.", workersSocialInsurancePayment: "Ennakonpidätys sisältää Vakuutetun sairausvakuutusmaksun, joka vuonna {{year}} on {{percent}} prosenttia {{totalBaseRound}} euron tulosta, eli {{amountRound}} euroa." } }, accounting: { title: "Kirjanpitoraportti", head: { name: "Nimi", officialId: "Y-tunnus", email: "Sähköposti", workerCount: "Työntekijöitä", calculationCount: "Laskelmia", totalGrossSalary: "Bruttopalkka", totalWorkerPayment: "Työntekijöille maksetaan", period: "Ajalta", tax: "Ennakonpidätykset" }, heading: { accountNumber: "Ehdotustili", accountName: "Selite", vatPercent: "ALV%", sum: "Summa", costCenter: "Kustannuspaikka" } }, summary: { header: { title: "Palkanmaksujen erittely", subtitle: "Työnantajan Palkkaus.fi:lle maksamat laskelmat ajalta" }, heading: { name: "Nimi", businessId: "Y-tunnus", email: "Sähköposti" }, table: { workStartDate: "Työn. aloitus", workStartEndDate: "Työn lopetus", totalGrossSalary: "Raha- palkka", totalRowCategory: "Lo.*", benefits: "Luont. edut", irCode: "Väh. vero", totalTaxable: "Verot. tulot", tax: "Ennak. pidät.", pension: "TyEL (TT)", unemploymentInsurance: "TVR (TT)", unionPayment: "AY-maksu", foreclosure: "Ulos-otto", otherDeductions: "Muut väh.", totalExpenses: "Kulu-korv.", totalWorkerPayment: "Maks.(TT)", totalPayment: "Maks. Palkkaus.fi", palkkaus: "Palkk. sis ALV", service: "Palvelumaksu", socialSecurity: "Sava", totalPensions: "TyEL yht.", employerPension: "TyEL (TA)", unemployment: "TVR yht.", employerUnemployment: "TVR (TA)", workerSalary: "Työntekijöiden palkka (TyEL)", entrepreneurSalary: "Yrittäjäpalkka (YEL)", total: "Yhteensä" }, infoText: { tt: "TT = Työntekijän palkasta vähennettävä osuus", ta: "TA = Työnantajan osuus", lo: "*Lo. sisältää vuosilomapalkat, vuosilomakorvaukset sekä loma(ltapaluu)rahat." } }, authorization: { heading: { title: "Palkkaus.fi valtakirja" }, attorney: "Valtakirja", authorizer: "Valtuuttaja", authorized: "Valtuutettu", palkkausfi: "Suomen Palkanlaskenta Oy (Palkkaus.fi)", companyId: "Y-tunnus", contactInfo: "Yhteystiedot valtakirjan alareunassa", signature: "Allekirjoitus", time: "Aika", lists: { employeeAndEmployer: "Työntekijä ja työnantaja", taxAndIr: "Verohallinto ja tulorekisteri (sisältäen myös kotitalousvähennys)", pensions: "Työeläkeyhtiöt", insurances: "Vakuutusyhtiöt", employmentFund: "Työllisyysrahasto", unEmploymentFund: "Työttömyyskassat", workers: "Työntekijät", taxIr: "Verohallinto ja tulorekisteri", banksAndPaymentIntermediaries: "Pankit ja maksuvälittäjät (liittyen tarvittaviin tilityksiin ja maksuihin)", workerUnions: "Työntekijäjärjestöt (työntekijän jäsenmaksu)" }, person: { name: "Nimi", personalId: "Henkilötunnus", telephone: "Puhelinnumero", email: "Sähköposti", authorizedInfo: "Valtuutettu voi hoitaa puolestani palkkaamiseen, palkanmaksuun ja mahdollisesti saamiini palkkoihin liittyviä velvoitteita ja maksuja suhteessa viranomaisiin ja muihin tahoihin kuten esimerkiksi:", authorizationValid: "Valtuutus on voimassa toistaiseksi alkaen", palkkausSite: "Palkkaus.fi-sivustolla" }, company: { name: "Yrityksen toiminimi", address: "Lähiosoite", email: "Sähköpostiosoite", authorizerName: "Yrityksen valtuuttajan nimi", authorizerPersonalId: "Yrityksen valtuuttajan henkilötunnnus", authorizerPhone: "Yrityksen valtuuttajan puhelinnumero", authorizedInfo: "Valtuutettu voi hoitaa valtuuttajan puolesta palkkaamiseen, palkanmaksuun ja palkkoihin liittyviä velvoitteita ja maksuja suhteessa viranomaisiin ja muihin palkkaamiseen liittyviin tahoihin kuten:", authorizationValid: "Allekirjoituksellani vakuutan, että minulla on oikeus antaa tämä valtuutus valtuutetulle. Valtuutus on voimassa toistaiseksi alkaen", palkkausService: "Palkkaus.fi-palvelussa" } }, invoice: { title: "Lasku", heading: { payer: "Maksaja", recipient: "Maksunsaaja", date: "Laskun päivämäärä", dueDate: "Eräpäivä", referenceNumber: "Viitenumero", iban: "Saajan pankkitili (IBAN)", bic: "Saajan pankki (BIC)", message: "Kuvaus", preview: "Arviolasku, älä maksa" }, table: { message: "Kuvaus", articleName: "Tuotteen nimi", count: "Määrä", price: "Hinta", vat0: "ALV0", total: "Yht", vatPercent: "ALV%", accounting: "Tiliöinti", taxSocialSecurity: "SAVA-maksut yhteensä", taxWithholding: "Ennakonpidätys yhteensä", totalExVat: "Yhteensä ALV 0%", totalVat: "ALV Yhteensä", totalPayment: "Maksettava yhteensä", totalPaid: "Maksettu", toBePaid: "Jäljellä" }, footer: { html: "Tulostettu palvelussa Palkkaus.fi {{date}} " } }, eSalary: { headerData: { documentTitle: "Palkkalaskelma", netPayment: { label: "Maksetaan" }, partyIdentifications: { officialId: "Y-tunnus", salaxy: "Salaxy" } }, payPeriod: { heading: "Palkkakausi", dateOfPayment: { label: "Maksupäivä" }, period: { label: "Selite" }, periodDates: { label: "Palkka ajalta", startDate: { label: "Alkupäivä" }, termDate: { label: "Loppupäivä" } } }, delivery: { sender: { heading: "Työnantaja" }, recipient: { heading: "Saaja" } }, employee: { heading: "Palkansaajan tunnistetiedot", identity: { label: "Henkilötunnus" }, employmentDate: { label: "Työsuhteen alkamispäivä" }, classification: { heading: "Tehtävätiedot", jobTitle: { label: "Tehtävänimike" } } }, bankAccount: { heading: "Pankkitili", label: "Tilinumero" }, calculationBases: { heading: "Palkanlaskennan perustiedot", salaryRates: { heading: "Palkkaustiedot" }, taxationRates: { heading: "Verotustiedot", recordLabels: { taxPercent: "Perusprosentti", taxPercent2: "Lisäprosentti" } }, incomeLimitLabel: "Tuloraja", taxcardValidityLabel: "Verokortti voimassa" }, payDetails: { heading: "ERITTELYOSA" }, messages: { heading: "Viestit", transient: { heading: "Virhe" } }, cumulative: { heading: "PALKKATODISTUSOSA", current: { heading: "Kuluvavuosi" }, previous: { heading: "Edellinen vuosi" } } }, totals: { total: "Yhteensä", heading: { employer: "Työnantaja" }, table: { company: "Yritys", officialId: "Y-tunnus", salaryPeriod: "Palkkakausi", salaryDate: "Palkkapäivä", worker: "Työntekijä", baseSalary: "Rahapalk.", benefits: "Luont. ed.", totalTaxable: "Veronal.", tax: "Enn. pid.", totalExpenses: "Korv.", unionPayment: "AY", pension: "Eläkem.", unemploymentInsurance: "Tyött.", otherDeductions: "M. väh.", earnings: "Tulot", totalDeductions: "Väh. yht.", totalWorkerPayment: "Maks. yht.", foreclosure: "Ulosotto", salaryAdvance: "Palkkaennakko" } }, workerSummaryReport: { title: "Työntekijän vuosiyhteenveto", heading: { noWorker: "Työntekijän tietoja ei ole syötetty", employer: "Työnantaja", noEmployer: "Työnantajan tietoja ei ole syötetty", workerName: "Työntekijä", workerSocialSecurityNumber: "Henkilötunnus", workerIban: "Tilinumero" }, table: { count: "Määrä", aPrice: "A-hinta", total: "Euroa", percent: "Prosenttia", sum: "Summasta", totals: "Yhteensä", paid: "Maksettu", salary: { heading: "Rahapalkka" }, benefits: { heading: "Edut ja tuet" }, deductions: { title: "Vähennykset" }, expenses: { title: "Korvaukset", heading: "Kulukorvauksia" }, totalTaxable: "Ennakonpid. alainen ansio", tax: "Ennakonpidätys*", pension: "Työeläkemaksu", unemploymentInsurancePayment: "Työttömyysvakuutusmaksu", unionPayment: "AY-jäsenmaksu", foreclosure: "Ulosotto", prepaidExpenses: "Ennakkoon maksetut kulukorvaukset", otherDeductions: "Muut vähennykset" } }, rowsReport: { worker: "Työntekijä", socsec: "Henkilötunnus", message: "Viesti", rowType: "Palkkalaji", rowTypeKind: "Alalaji", type: "Tyyppi", sourceId: "Lähde (id)", dimensions: "Kustannuspaikat", count: "Määrä", price: "Hinta", total: "Yhteensä" }, calcsIrRowsReport: { worker: "Työntekijä", irCode: "Tulorekisteri-koodi", incomeType: "Tulolaji", rowType: "Palkkalaji", kind: "Alalaji", type: "Tyyppi", message: "Rivin kuvaus", count: "Määrä", price: "Hinta", unit: "Yksikkö", total: "Yhteensä" }, kycCompany: { heading: "Asiakkaan tuntemisen tiedot", createdAt: "Luotu", principalActivity: "Toimiala", companyType: "Yhtiön tyyppi", contactInfo: "Yhteystiedot", suomifiHeading: "Suomi.fi-tarkistus", socsec: "HETU", session: "Sessio", state: "Tila", roles: "Roolit", time: "Aika", reporterAdmin: "Ilmoittaja (admin)", beneficialBeneficiariesNote: "HUOM: Tosiasialliset edunsaajat sivulla 2", beneficialBeneficiaries: "Tosiasialliset edunsaajat" }, iamPerson: { dateOfBirth: "Syntymäpäivä", updatedAt: "Päivitetty", pep: "PEP-henkilö", yes: "Kyllä", no: "Ei", ownership: "Omistusosuus", citizenship: "Kansalaisuus", contactInfo: "Yhteystiedot" }, invoiceList: { receiverAndType: "Saaja ja laskun tyyppi", sum: "Summa", qrCodeNotAvailable: "QR-koodia ei saatavilla", finishPayments: "Maksa palkat ensin", iban: "IBAN", name: "Nimi", dueDate: "Eräpäivä", alreadyPaid: "Jo maksettu", payable: "Maksettavaa", virtualBarcode: "Virtuaaliviivakoodi", message: "Viesti", reference: "Viite", unpaidNetSalaries: "maksamatonta nettopalkkaa" }, CalendarReport: { week: "Viikko" } }, SERVER_VIEWS: { Roles: { employer: "Työnantaja", worker: "Työntekijä", company: "Yritys tai yhteisö", accountant: "Tilitoimisto" }, Register: { title: "Miten käytät palvelua?", text: "Valitse rooli, jolla kirjaudut palveluun.", registerTitle: "Rekisteröidy palveluun", registering: "Rekisteröidytään... ", cancel: "keskeytä" }, Onboarding: { registeringTitle: "Rekisteröidytään...", registeringInstruction: "Mikäli rekisteröitymisikkuna ei aukea, ", registeringInstructionLink: "palaa alkuun" }, Login: { login: "Kirjaudu", createAccount: "Luo tunnus" }, Invite: { title: "Tervetuloa Palkkaus.fi-palveluun", titleForHtml: "Tervetuloa<br />Palkkaus.fi-palveluun", defaultMsg: "<strong>Sinulle on maksettu palkkaa palvelumme kautta.</strong><br><br>Palkkatiedot ovat henkilökohtaisia ja haluamme varmistaa, että tiedot näkyvät vain sinulle. Siksi pyydämme sinua kirjautumaan ja tunnistautumaan pankkitunnuksin. <strong>Tämä sinun pitää tehdä vain kerran ja palvelu on työntekijälle ilmainen.</strong>", missingCalculationMsg: "<strong>Tätä palkkalaskelmaa ei löydy.</strong><br><br>Saat kaikki palkkalaskelmasi näkyviin, kun luot itsellesi tunnuksen (tai kirjaudut olemassa olevalla) ja tunnistaudut pankkitunnuksilla. Tällöin tuomme kaikki palkkalaskelmasi sinulle henkilötunnuksen perusteella.", forAnotherAccountMsg: "<strong>Palkkalaskelma on lähetetty eri henkilötunnuksella</strong><br><br>Profiilissasi on käyttäjätunnus {0} ja palkkalaskelmassa on <strong>työntekijällä eri henkilötunnus</strong>. Jos palkkalaskelma on tarkoitettu sinulle, on parasta, että otat yhteyttä asiakaspalveluumme, niin selvitetään asia.", verifiedAccountMsg: "<strong>Sinulle on maksettu palkkaa palvelumme kautta.</strong><br><br> Palkkalaskelmat löytyvät nyt työpöydältäsi.", unverifiedAccountMsg: "<strong>Sinulle on maksettu palkkaa palvelumme kautta.</strong><br><br>Palkkatiedot ovat henkilökohtaisia ja haluamme varmistaa, että tiedot näkyvät vain sinulle. Siksi pyydämme sinua kirjautumaan ja tunnistautumaan pankkitunnuksin. <strong>Tämä sinun pitää tehdä vain kerran ja palvelu on työntekijälle ilmainen.</strong>", existingUser: "Minulla on jo tunnus", newUser: "Uusi käyttäjä", gotoHome: "Siirry etusivulle", reregister: "Tunnistaudu uudestaan", register: "Luo itsellesi tunnus", register2: "...ja määritä salasana, jolla pääset jatkossa sivuillemme.", authenticationByBank: "Pankki&shy;tunnistautuminen", authenticationReason: "Jotta voimme olla varmoja, että sinä olet sinä.", calcsOnDesktop: "Palkkalaskelmat työpöydällä", calcsViewingInfo: "Näet Palkkaus.fi-palvelun kautta maksetut palkat heti.", nextTimeInfo: "Jatkossa näet helposti", nextTimeInfo2: " ...palvelustamme kaikki palkkalaskelmat ja voit muuttaa tietojasi.", inviteAlertTitle: "HUOM!", inviteInfoName: "Palkkalaskelma on lähetetty nimellä", inviteInfoSsn: "ja henkilötunnuksen alkuosalla", inviteInfoContact: "Jos nämä tiedot ovat väärin, otathan meihin yhteyttä - meillä on sinusta vääriä tietoja.", inviteServiceDescription: "Palvelu pyytää tekemään pankkitunnistautumisen ja sen jälkeen palvelussa olevat palkkalaskelmasi näkyvät palvelun työpöydällä.", inviteDeclineLogin: "En halua kirjautua", inviteDeclineLoginContactEmployer: "Jos et halua kirjautua Palkkaus.fi-palveluun, emme voi lähettää sinulle palkkalaskelmia sähköisesti, vaan sinun täytyy pyytää ne työnantajaltasi. Palkkalaskelmassa olevia tietojasi käytetään palkkaan liittyviä lakisääteisiä raportointeja ja tilityksiä varten.", inviteDeclineLoginContactPalkkaus: "Jos et halua kirjautua palveluumme, etkä halua saada viestejä, kun sinulle on maksettu palkkaa, ota yhteyttä asiakaspalveluumme. Yhteystiedot löytyvät sivun alaosasta." }, Paytrail: { payInvoiceTitle: "Palkan maksaminen", proceedToPaymentInfo: "Siirry maksamaan alla olevasta nappulasta.", proceedToPaymentInfoNew: "Siirry maksamaan klikkaamalla valitsemasi pankin kuvaa.", proceedToPaymentButton: "Siirry maksamaan", paytrailInfo: "Maksunvälityspalvelun toteuttajana ja maksupalveluntarjoajana toimii Paytrail Oyj (2122839-7) yhteistyössä suomalaisten pankkien ja luottolaitosten kanssa. Paytrail Oyj näkyy maksun saajana tiliotteella tai korttilaskulla ja välittää maksun kauppiaalle. Paytrail Oyj:llä on maksulaitoksen toimilupa.", paymentDelayInfo: "HUOM: nettopalkan saapuminen työntekijän tilille saattaa kestää 3 pankkipäivää, riippuen vastaanottajan pankista. Huomioithan nämä ajat maksaessasi. Ajat johtuvat pankkien välisistä palveluista ja sopimuksista, eikä Palkkaus.fi pysty vaikuttamaan niihin." }, VismaSignBegin: { waitTitle: "Ohjataan allekirjoitukseen, odota hetki...", backBtn: "Takaisin", signBtn: "Allekirjoita" }, VismaSignFailure: { failureTitle: "Allekirjoitus ei onnistunut", failureText: { html: '<p>Sähköinen allekirjoitus epäonnistui tai keskeytettiin Visma Sign - palvelussa. Voit kokeilla allekirjoitusta uudelleen tai jos se ei onnistu, ota yhteyttä asiakaspalveluumme. </p> <p>Autamme mielellämme ja jos mikään muu ei onnistu voimme hoitaa allekirjoituksen jopa paperilla. </p> <p>Asiakaspavelumme vastaa puhelimeen Puh.09 425 50603 tai sähköpostilla <a href="mailto:aspa@palkkaus.fi">aspa@palkkaus.fi</a></p>' }, vismaFailure: "Virheilmoitus Visma Sign-pavelusta:", backBtn: "Takaisin" }, Reports: { SalarySlip: { userFriendlyName: "Palkkalaskelma {0} {1}" }, PaymentReport: { userFriendlyName: "Yhteiskunnan laskelma {0} {1}" }, EmployerReport: { userFriendlyName: "Työnantajan laskelma {0} {1}" }, ESalarySpecification: { userFriendlyName: "Verkkopalkka {0} {1}" }, AccountingReport: { userFriendlyName: "Kirjanpitoraportti {0}" }, MonthlyDetails: { userFriendlyName: "Palkanmaksujen erittely {0}" }, YearlyDetails: { userFriendlyName: "Palkanmaksujen erittely vuosi {0}" }, Insurance: { userFriendlyName: "TyEL ja tapaturmavakuutusraportti {0}" }, Unemployment: { userFriendlyName: "TVR Palkkasummailmoitus {0}" }, YearlyWorkerSummary: { userFriendlyName: "Työntekijän vuosiyhteenveto {0} {1}" } } }, sxy_palkkaus: { SxyLoginButton: { searching: "Haetaan..." }, SxyCalcReports: { reportLanguageWorker: "Oletus (Työntekijä)", reportLanguageCompany: "Oletus (Yritys)", reportType: "Tyyppi", reportLanguage: "Kieli", reportViewPartial: "Vain taulukko", reportViewPage1: "Ensimmäinen sivu", reportViewFull: "Koko raportti" }, SxyCalcRowsEditor: { calcRow: "Palkkarivi", total: "Yhteensä", validation: { note: "HUOM:", edit: "Muokkaa" }, buttons: { infoIcon: "Katso tiedot" }, Foreclosure: { referenceNumberInfo: "Täytä pankkiviitetiedot, jos sinulla on käytössä maksuaineiston luonti." } }, SxyCalcWorkerInfo: { noSelection: "Työntekijää ei ole valittu", noIbanNumber: "Ei tilinumeroa", noSSNumber: "Ei henkilötunnusta!", noTel: "Ei puhelinnumeroa", noEmail: "Ei sähköpostiosoitetta!", noEmailInfo: "Työntekijälle ei voida lähettää ilmoitusta palkanmaksusta sähköpostitse." }, SxyCalcRowsEditDialog: { accounting: { vatPercent: { label: "Arvonlisävero-%" } }, showInfo: "Näytä ohje", hideInfo: "Piilota ohje", incomeTypesInfo: "Palkkalajiin liittyvät tulolajit", UnionPayment: { fillUnionPaymentInfo: "Täytä ammattiyhdistyksen nimi, pankkitili ja viitetiedot, jos sinulla on käytössä maksuaineiston luonti." }, SubsidisedCommute: { info: { html: " <b>HUOM:</b> Tämä Työsuhdematkalippu-laskuri tukee vain vuoden ainoata / ensimmäistä työsuhdematkalippua. Jos syötät toista lippua, käytä Tulorekisteri-välilehteä. Tuomme uuden version pian." }, calculateTaxable: "Palkaksi katsottu osuus", taxFree: "Verovapaa osuus" }, BicycleBenefit: { calculatedTaxable: "Palkaksi katsottu osuus", taxFree: "Verovapaa osuus" }, HourlySalaryWithWorkingTimeCompensation: { CompensationRowLabel: "Lisä" }, MealBenefit: { mealTaxablePrice: "Verotusarvo / kpl", mealPrice: "Korvaus / ateria", mealTicketPrice: "Nimellisarvo / kpl", taxValueTrue: "Työntekijältä peritään verotusarvon määrä", taxValueFalse: "Työntekijältä ei peritä korvausta lainkaan tai muu määrä kuin verotusarvo", isTaxValueDeductionsDone: "Verotusarvoa vastaava vähennys", isTaxValueDeductionsDoneTrue: "Ei vähennetä tällä laskelmalla", isTaxValueDeductionsDoneFalse: "Vähennetään tällä laskelmalla" }, MilageOwnCar: { vehicleType: "Kulkuneuvon tyyppi", additions: "Lisät", passangerCount: "Lisähenkilöiden määrä" }, DailyAllowance: { internationalDailyAllowanceCount: "Päivärahojen enimmäismäärät" } }, SxyCalcrowsEditDialog: { dailyAllowance: { allowanceKind: "Korvauksen tyyppi", selectCountry: "Valitse maa.." }, additionalRows: { description: "Kuvaus", additionalRow: "Lisärivi palkkalaskelmaan" } }, SxyActionButton: { newCalculation: "Uusi palkkalaskelma", addCalcTypes: "Lisää laskelmatyyppejä", commonCalc: "Yleinen laskuri", historicalCalc: "Historiallinen laskuri", startNewMessage: "Aloita uusi viestiketju", newPayroll: "Uusi palkkalista", sendTaxCard: "Lähetä verokortti", error: "Virhe: tuntematon toiminta nappulalle" }, SxyCalcChart: { workerChart: { salaryPayment: "Työntekijän nettopalkka ", tax: "Ennakonpidätys ", workerSideCosts: "Työntekijän sivukulut ", totalExpenses: "Kulut ja edut " }, employerChart: { totalGrossSalary: "Palkka ", salaryAdditions: "Palkan lisät ", allSideCosts: "Sivukulut ", totalExpenses: "Kulut " } }, Roles: { worker: "Työntekijä" }, SxyHourlyReport: { heading: { hourlyReport: "Tuntiraportti", timeReport: "Työaikaraportti" }, hourlyReportContent: "Tuntikirjaus", timeReportContent: "Työaikakirjaus", week: "Viikko", total: "yhteensä" }, SxyHourlyReportEditDialog: { heading: "Muokkaa tuntikirjausta", costAccounting: "Kustannuspaikka", projectText: "Kommentti", totalTime: "Työaika" }, SxyTimeReportEditDialog: { heading: "Muokkaa tuntikirjausta", costAccounting: "Kustannuspaikka", projectText: "Kommentti", startTime: "Aloitusaika", endTime: "Lopetusaika" }, SxyDimensions: { costCenter: "Kustannuspaikka", legend: { title: "Laskentakohteet" }, percent: "Prosenttia" }, SxyTaxcards: { ActivateAutoTaxcard: { loadingTitle: "Haetaan verokorttia", loadingText: "Haetaan ennakonpidätyksen prosentteja ja tulorajaa Veron rajapinnasta.", alertTitle: "Ei verokorttia", alertText: "Verottajan tiedoista ei pystytty hakemaan uutta veroprosenttia. Tämä voi olla tilapäinen ongelma. Käytämme toistaiseksi vanhoja prosentteja." }, taxcard: { status: { waiting: "Odottaa", notSeen: "Sisältöä ei nähty", declined: "Hylätty", waitingForAcception: "Odottaa hyväksyntää", accepted: "Hyväksytty" } }, taxcards: { introGetAutoTaxcard: { html: "Palkkaus.fi-palvelussa on nyt käytössä verottajan automaattinen Ennakonpidätys-rajapinta. <strong>Veroprosentit tarkistetaan automattisesti suoraan verottajalta jokaisen palkanmaksun yhteydessä, eikä sinun tarvitse enää syöttää verokortin tietoja.</strong> Klikkaa nappulaa ottaaksesi automaattinen haku käyttöön." }, addSharedCardTitle: "Lisää jaettu verokortti", activateAutoTaxcard: "Aktivoi automaattinen verokortti", introShort: { html: "Täältä voit lisätä <strong>jaetun verokortin, joka näkyy kaikille työnantajille</strong>, jotka käyttävät Palkkaus.fi-palvelua." }, intro: { html: `<p class="lead"> Täältä voit lisätä <strong>jaetun verokortin, joka näkyy kaikille työnantajille</strong>, jotka käyttävät Palkkaus.fi-palvelua.           Uusi verokortti näkyy työnantajalle ilmoituksena, kun hän maksaa seuraavaa palkkaasi tai lisää sinut uutena työntekijänä.           <strong>Jos sinulla on useita työnantajia, kaikki palkat näkyvät samalla verokortilla,</strong>            joten voit kätevästi seurata tulorajan ylittämistä etkä saa veromätkyjä.         </p>         <p>           Palkkaus.fi-palvelu tarkistaa nykyisen verokortin tiedot aina verottajan rajapinnasta.           Teemme tarkistuksen myös jokaisen palkanmaksun yhteydessä, joten sinun ei tarvitse lisätä uutta verokorttia:           Riittää, että huolehdit, että verottajalla olevassa verokortissa on sopivat tulotiedot / prosentti.</p><p>Voit kuitenkin ilmoittaa palvelussamme verokortin perusprosenttia suuremman veroprosentin, jos haluat että sinulta vähennetään enemmän kuin verokortin perusprosentti / lisäprosentti. Tämä 'minimiprosentti' on voimassa kunnes verottajan rajapinnasta tulee uusi verokortti: kun haet uutta verokorttia tai viimeistään vuoden vaihteessa.</p><p>Samoin työnantaja hyväksyy jaetun verokortin ja voi valita käyttää hänelle suoraan toimitettua verokorttia. Näin ollen voit lähettää esim. sähköpostilla tai postilla työnantajalle suoraan erillisen verokortin,           jos haluat että joku työnantaja käyttää eri korttia, kuin muut.</p><p>Huomaathan, että jaettua verokorttia ja palkkojen kokonaissummaa voi pyytää nähtäväkseen kuka tahansa työnantaja, jolla on henkilötunnuksesi.           Alla olevasta listasta voit tarkistaa ketkä työnantajat ovat nähneet verokorttisi.           Työnantajat on myös tunnistettu pankkitunnuksin.           Jos kuitenkin olet erityisen tarkka yksityisyydestäsi voit antaa kortin suoraan työnantajallesi tai lähettää sen postissa.           Tällöin työnantaja lisää sen työnantajakohtaisena (ei jaettuna) verokorttina.         </p>` }, employerTableHeading: "Työnantaja", typeTableHeading: "Tyyppi", validDateTableHeading: "Voimassa", startDateTableHeading: "Otettu käyttöön", cardStatus2TableHeading: "Tila", salariesPaid: "Palkkoja maksettu", incomeLimit: "Tuloraja" }, currentTaxCard: "Nykyinen verokortti", tabs: { calcsPaidForCard: "Verokortille maksetut laskelmat", employers: "Työnantajat", earlierTaxcards: "Aikaisemmat verokortit" } }, SxyTaxcardDetails: { savingTaxcard: "Tallennetaan verokorttia", checkingTaxcard: "Verokorttia tarkistetaan", activateAutoTaxcard: "Aktivoi automaattinen verokortti", updateAutoTaxcard: { loadingTitle: "Haetaan verokorttia", loadingText: "Haetaan ennakonpidätyksen prosentteja ja tulorajaa Veron rajapinnasta.", alertTitle: "Ei verokorttia", alertText: "Verottajan tiedoista ei pystytty hakemaan uutta veroprosenttia. Tämä voi olla tilapäinen ongelma. Käytämme toistaiseksi vanhoja prosentteja.", noTaxcard: "Verottajan tiedoista ei löydy verokorttia tälle henkilötunnukselle. Tarkista verokorttisi Omavero-palvelusta tai Veron asiakaspalvelusta." }, taxcardExpired: "Työntekijän aiempi verokortti on vanhentunut, joten työntekijälle ei voida maksaa palkkaa.", chooseNoTaxcard: "Ei verokorttia, 60% ennakonpidätys", validDate: "Voimassa", taxcardAdded: "Lisätty", taxPercent: "Ennakonpidätysprosentti", basicPercent: "Perusprosentti", noIncomeLimit: "Ei tulorajaa / lisäprosenttia", additionalPercent: "Lisäprosentti", after: "jälkeen", taxcardChecked: "Verokortti on tarkistettu", checkAutomaticTaxcard: "Tarkista autom. verokortti", incomeLimit: "Tuloraja", salariesPaid: "Palkkoja maksettu", beforeIncomeLimit: "Jäljellä ennen tulorajaa", newTaxcard: "Uusi verokortti" }, SxyTaxcardIncomeLog: { addedForTaxcard: "Verokortille kirjattu", salaryPeriod: "Palkkakausi", mainTaxPercent: "Ennakonpidätys", salaryAmount: "Palkkasumma", calculation: "Laskelma", removedCalc: "Poistettu laskelma", noCalcsTitle: "Ei maksettuja palkkoja", noCalcsDescription: "Verokortille ei ole merkitty maksettuja palkkoja.", totalTaxes: "Ennakonpidätys, yhteensä", totalIncome: "Palkkasumma, yhteensä" }, TotalWorkerPaymentUsecase: { sum: "Summa" }, SxyCalcRowsEditdialog: { CarBenefitUsecase: { kilometersBasedTrue: "Kyllä: autoetu lasketaan kilometrien perusteella (ajopäiväkirjasta)." } }, SxyTaxcard: { noTaxcard: "Ei verokorttia" }, SxyAbsencePeriods: { absence: "Poissaolo", absences: "Poissaolot", headerDays: "Päivät", isPaid: "Palkallinen.", notPaid: "Ei palkkaa.", isAccrual: "Työssäolon veroinen.", notAccrual: "Ei työssäolon veroinen.", noAbsences: "Ei poissaoloja", noAbsencesDescription: "Poissaolokirjanpitoon voit listata muut poissaolot: palkattomat ja palkalliset. Tänne voit listata myös palkattomat lomat / vapaat.", noAbsencesDescription2: "Palkattomien poissaolojen päivät otetaan huomioon kuukausipalkan maksun yhteydessä ja ehdotettaessa lomapäivien kertymää.", totalUnpaid: "Yhteensä, palkattomat              ", totalNoHolidayAccrual: "Yhteensä, lomakertymää vähentävät", totalAll: "Yhteensä, kaikki", addAbsenceButtonText: "Lisää poissaolo" }, SxyAbsencePeriodsEditDialog: { editAbsence: "Muokkaa poissaoloa", startDate: "Alku", endDate: "Loppu", daysCount: "Päivien määrä", isPaidLabelTrue: "Poissaolo on palkallinen", isAccrualLabelTrue: "Työssäolon veroista aikaa lomapäivien kertymää laskettaessa" }, SxyHolidayYearHolidays: { tableHeader: { period: "Lomajakso", daysCount: "Päivät" }, tableBody: { availableHolidays: "Käytettävissä olevat", availableHolidaysMore: "Päättyneellä lomanmääräytymisvuodella kertyneet lomat", total: "Yhteensä", totalMore: "Palkkakaudelle osuvat lomat", noHolidaysTitle: "Ei suunniteltuja lomia", noHolidaysDescription: ` Lomakalenterissa voit suunnitella vuoden lomat. 
 Syötetyt lomat otetaan automaattisesti huomioon, kun maksat kuukausi- tai tuntipalkkaa.`, noHolidaysDescription2: `Menneet lomat voit halutessasi myös kirjata lomakirjanpitoon.\r
Siellä ne säilyvät tallessa lain vaatiman säilytysajan.`, addFirstHolidayButtonText: "Lisää ensimmäinen loma", total2: "Yhteensä", total2More: "Lomavuonna käytetyt lomat.", unusedHolidays: "Pitämättömät lomapäivät", unusedHolidaysMore: "Lomapäivät, jotka tulee suunnitella tai maksaa lomakorvauksena.", addHolidayButtonText: "Lisää loma" } }, SxyWorkerAbsences: { calendarButtonText: "Kalenteri", listButtonText: "Lista", legendInstructions: "Poissaolojen kirjaaminen", instructions: { html: `<p> Palkattomat poissaolot vähentävät kuukausipalkan määrää automaattisesti. Tuntipalkkojen osalta sinun tulee huomioida poissaolot suoraan tunneissa.
</p>
<p>
Pitkät poissaolot vaikuttavat myös lomalaskentaan, jos käytössä on 14 päivän lomapäivien kertymissääntö.
</p>
<p>
Lisäksi poissaolojen tietoja saatetaan tarvita viranomaisraportointiin, palkkatodistuksiin ja esim. työttömyyskassoille.
</p>` } }, SxyHolidayYearHolidaysEditDialog: { heading: "Muokkaa lomaa", startDateLabel: "Alku", endDateLabel: "Loppu", holidaysCountLabel: "Lomapäivät", notesLabel: "Huomiot" }, SxyHolidayYearAccrual: { holidayAccrualSource: { manual: "Muokattu käsin", calcDraft: "Palkkalaskelma (luonnos)", calcPaid: "Maksettu palkka", defaultThisMonth: "Kuluva kuukausi", defaultEstimate: "Arvio tulevasta (lomavuoden luonti)", default: "Lomavuoden luonnista" }, accumulated: "Kertyneet", futureEstimate: "Arvio tulevasta", tableHead: { month: "Kuukausi", daysCount: "Päiviä", startDaldo: "Alkusaldo", startSaldoMore: "Edelliseltä vuodelta" }, tableBody: { daysAccrued: "Kertyneet lomapäivät", total: "Yhteensä", estimatedHolidaysNexYear: "Arvio ensi vuoden lomapäivistä" } }, SxyWorkerHolidays: { planned: "Suunnitellut", date: "pv", accumulation: "kertymä", dateYear: "pv (koko vuosi)", holiday: "Loma", days: "päivää", undefined: { title: "Lomakirjanpito ja -laskenta", intro: "Tuomme kevään aikana asteittain paljon kysytyn lomakirjanpidon ja -laskennan osaksi palvelua. Tavoitteenamme on tehdä markkinoiden helppokäyttöisin palvelu lomien ja poissaolojen kirjaamiseen ja maksamiseen.", subtitleLeft: "Tässä versiossa", introLeft: `<li>Lomapäivien kertyminen</li>
<li>Lomakirjanpito</li>
<li>Lomapäivien maksaminen kuukausipalkkalaisille</li>
<li>Lomarahat</li>`, showInitHolidaysButtonText: "Ota käyttöön tälle työntekijälle", subtitleRight: "Tulevat ominaisuudet", introRight: `<li>Lomapäivien maksaminen tunti- ja urakkapalkoista</li>\r
<li>Keskituntiansion laskeminen</li>\r
<li>Lomakorvauksen erikoistilanteet</li>\r
<li>Kesä- ja talvilomalistat (monelle työntekijälle)</li>` }, overview: { legend: "Lomakorvaus palkanmaksun yhteydessä ", legendYear: "lomavuosi", intro: "Työntekijän / lomavuoden tiedoissa on merkitty, että työntekijän lomat maksetaan suoraan jokaisen palkanmaksun yhteydessä. Tämä on tyypillistä tilapäisillä työntekijöillä.", intro2: "Palkkalaskuri lisää lomakorvauksen ja -rahan prosentteina bruttopalkasta:", introCompensation: "Lomakorvaus:", introBonus: "Lomaraha:", introNoBonus: "Ei lomarahaa tai lomaraha osa lomakorvauksen kokonaisprosenttia", introUseCalendar: { html: `<strong>Voit halutessasi käyttää lomakalenteria</strong><br />
<small>
Yleensä tällaisilla tilapäisillä työntekijöillä ei ole varsinaista lomaa.
Lomakalenteriin voit kuitenkin halutessasi syöttää milloin henkilö on poissa loma-aikaan.
Kalenteri ei vaikuta palkanmaksuun.</small>` } }, buttonSummer: "Kesä", buttonWinter: "Talvi", calendarTitle: "Lomakalenteri", buttonAll: "Muokkaa / kaikki lomat", summerHolidaysTitle: "Kesälomat", winterHolidaysTitle: "Talvilomat", selectYear: "Valitse vuosi", showInitHolidays: "Luo lomakirjanpito uudestaan", buttonOverview: "Yleiskuva", buttonHolidays: "Lomakalenteri", sidebar: { info: "Tiedot: ", periodSelectYear: "Kesä- ja talvilomakausi:", compensation: "Lomakorvaus:", bonus: "Lomaraha:" }, accrual: { overview: { legend: "Yleiskuva, lomavuosi", introTitle: "Lomien kirjaaminen ja maksaminen:", introList: { html: `<strong>Tarkista lomapäivien kertymä</strong><br /> Tarkista, kuinka monta lomapäivää työntekijälläsi on käytettävissä edelliseltä lomanmääräytymisvuodelta. Jos sitä edeltävältä vuodelta on käyttämättömiä lomia, voit lisätä ne alkusaldoksi
                    samassa yhteydessä.` }, introList2: { html: "<strong>Suunnittele ja kirjaa kesä- ja talvilomat</strong><br /> Lisäämällä pidettävät lomat lomakalenteriin etukäteen, sinun on helppo maksaa loma-ajan palkka ja lomarahat kyseisten palkkakausien palkanmaksun yhteydessä." }, introList3: { html: "<strong>Laske vuosilomapalkka</strong><br /> Tuntipalkkalaisten osalta vuosilomapalkka lasketaan edellisen vuoden ansioden perusteella. Tämä tulee tehdä, kun lomanmääräytymisvuosi on päättynyt (huhtikuussa)." }, introList4: { html: "<strong>Maksa loma-ajan palkka ja lomaraha</strong><br /> Palkanmaksun yhteydessä palvelu hakee automaattisesti valitulle palkkakaudelle suunnitellut lomat ja ehdottaa niitä laskelmalle. Tarvittaessa muutoksia voi tehdä myös palkanlaskennan yhteydessä ja tiedot tallentuvat lomakirjanpitoon." } }, paidSalaries: { legend: "Maksetut lomat", description: "Lista pidetyistä (ja maksetuista) tai korvatuista lomista sekä lomarahoista.", descriptionList: { html: `<li><strong>Lomapalkka</strong> (Loma-ajan palkka) maksetaan, kun lomapäivät pidetään (oletus).</li>\r
<li><strong>Lomakorvaus</strong> maksetaan, jos lomia ei voida pitää esim. työsuhteen päättyessä.</li>\r
<li><strong>Lomaraha</strong> maksetaan joka tapauksessa. Usein kaikki kesäloman yhteydessä.</li>` } }, accrualHolidays: { legends: "Lomapäivien kertymä", description: "Lomapäivien kertymä lomanmääräytymisvuodelta", description2: "Lomat pidetään seuraavana lomakautena" }, hourlySalaries: { legend: "Vuosilomapalkka ajalta", description: "Tunti- ja suorituspalkkaiselle vuosilomapalkka lasketaan pääsääntöisesti kolmella eri menetelmällä:", descriptionList: { html: `<li>
<strong>Prosenttipohjaisena:</strong> 35h-säännön alaisille (ainakin osa kuukausista alle 14 työpäivää), jos TES ei muuta määrää 9% tai 11,5% (työsuhde yli alle vuoden). Joissain työehtosopimuksissa myös muita prosentteja.
 </li>
<li>
<strong>Keskipäiväpalkka:</strong> 14 päivän säännön alaisille lomalain mukaan, jos TES ei muuta määrää.
</li>
<li>
<strong>Keskituntiansion mukaan </strong> Erityisesti SAK:n ja EK:n välisen lomapalkkasopimuksen mukaan, mutta käytössä yhä useammassa työehtosopimuksessa. Työehtosopimuskohtaisia taulukoita.
</li>` }, description2: "Seuraavissa versioissa tuomme laskentaan erilaisia työkaluja. Tässä versiossa vuosilomapalkka on laskettava esim. Excelissä. Asiakaspalvelumme tai tilitoimistosi auttaa sinua mielellään." } }, buttonAccrual: "Lomapäivien kertymä", holidayCompensation: { overview: { legendYear: "lomavuosi" } }, buttonHourlySalaries: "Laske vuosilomapalkka", buttonPaidHolidays: "Maksetut lomat", periodAccrual: "Lomanmääräytymisvuosi:", periodSelectedYear: "Kesä- ja talvilomakausi:", periodDefaultAccrual: "Lomapäiviä per kk:", noHolidays: { legend: "Ei lomaoikeutta, lomavuosi", intro: "Työsuhteen / lomavuoden tietoihin on merkitty, ettei tällä työntekijällä ole lomaoikeutta.", intro2: "Jos haluat muuttaa työntekijä lomakäsittelyn, " }, alert: { undefined: "VIRHE: Lomalaskennan tyyppiä ei ole määritetty.", holidayCompensationIncluded: "VIRHE: Tätä lomalaskennan tyyppiä ei tueta: holidayCompensationIncluded." } }, SxyWorkerHolidaysInitDialog: { permanent14Days: { html: `<strong>Vähintään 14 päivää kuukaudessa.</strong><br />\r
Työtä tehdään kaikkina kuukausina vähintään 14 pv/kk.` }, permanent35Hours: { html: `<strong>Vähintään 35 tuntia kuukaudessa.</strong><br />
Ainakin yhtenä kuukautena vuodessa tehdään vähintään 35 tuntia työtä.` }, holidayCompensation: { html: ` <strong>Lomakorvaus palkanmaksun yhteydessä.</strong><br />\r
  Lomapäiviä ei kerrytetä vaan lomakorvaus maksetaan heti palkan yhteydessä.` }, temporaryTimeOff: { html: `<strong>Vapaan ansaintasääntö.</strong><br />\r
Työntekijä ei kuulu 14 päivän tai 35 tunnin säännön piiriin, mutta saa pidetyltä vapaalta lomakorvauksen.` }, noHolidays: { html: `<strong>Ei lomaoikeutta.</strong><br />
Palkan tai korvauksen saajalla ei ole lomaoikeutta.` }, other: { html: `<strong>Manuaalinen.</strong><br />\r
Kertymä päivitetään käsin tai integraatiolla toisesta järjestelmästä.` }, panelHeading: "Lomakirjanpito ja -laskenta", intro: "Ota lomakirjanpito käyttöön valitsemalla sääntö lomien kertymiselle ja lomarahan maksamiselle", alert: { html: `<strong>HUOM:</strong> Tämä käyttöliittymä poistaa muokkaukset lomakertymiin ja luo ne uudestaan.\r
          <strong>Tarkista siis lomakertymät tämän jälkeen!</strong>` }, legendSelectHolidayType: "Lomapäivien kertymisen ja laskennan perusta", moreInfo: { html: ` Voit tutustua esimerkkeihin
<a href="https://www.palkkaus.fi/abc/loma-ajan-palkka-ja-lomalaskenta/" target="_blank">täällä</a>.` }, legendDetails: "Lomalaskennan yksityiskohdat", accrualByLaw: "Kertymä", accrualByLawLabelTrue2: "Lomalain mukaan 2 pv/kk", accrualByLawLabelTrue: "Lomalain mukaan: 2 tai 2,5 pv/kk (riippuen työsuhteen pituudesta).", accrualFixed: "Päivää / kuukausi", label: { compensation: "Lomakorvaus", bonusMethod: "Lomarahan maksu", bonusMethodNone: "Ei erillistä lomarahaa.", bonusMethodForHolidaySalary: "Erillinen lomaraha", bonusPercent: "Lomaraha, prosenttia", wageBasis: "Palkkaustapa (työsuhteessa)", startDate: "Alku pvm", endDate: "Loppu pvm" }, submitButtonText: "Ota lomakirjanpito käyttöön" }, SxyWorkerDetails: { workerInfo: "Perustiedot", employment: "Työsuhde", detailsInfo: { noIbanNumber: "Ei tilinumeroa", noSSNumber: "Ei henkilötunnusta!", noEmail: "Ei sähköpostiosoitetta!", noEmailInfo: "Työntekijälle ei voida lähettää ilmoitusta palkanmaksusta sähköpostitse." } }, SxyWorkerDetailsEdit: { details: "Henkilötiedot", firstName: "Etunimi", lastName: "Sukunimi", email: "Sähköpostiosoite", language: "Kieli", employmentTitle: "Työsuhteen", employment: { startDate: "Alku pvm", endDate: "Loppu pvm", isFixedTerm: "Määräaikainen työsuhde", isTerminated: "Työsuhde päättynyt" }, paymentDetails: { title: "Maksutiedot", salaryPaymentMethod: "Palkanmaksutapa", ibanNumber: "Tilinumero (IBAN)" }, ssNumber: "Henkilötunnus", address: "Osoite", addressInfoOtherIndentifier: "Työntekijällä on keinohenkilötunnus, jonka ilmoittaminen tulorekisteriin edellyttää työntekijän osoitetietoja.", addressInfo: "Osoite ei ole pakollinen palkanmaksussa.", street: "Katuosoite", postalCode: "Postinumero", city: "Kaupunki", readOnlyUser: { html: "<h3>Työntekijä on tunnistautunut pankkitunnuksin</h3><p>Tämä työntekijä on kirjautunut Palkkaus.fi-palveluun ja hallinnoi itse henkilötietojaan ja tilinumeroaan. Hän voi itse muuttaa niitä kirjautumalla palveluun omilla tunnuksillaan.</p><p>Jos näet tässä vääriä tietoja, ole yhteydessä työntekijään tai ota yhteyttä asiakaspalveluumme.</p>" }, tel: "Puhelinnumero" }, SxyWorkerEmployment: { pension: { title: "Sovellettava eläketurva", pensionRule: "Eläkemaksun laskentasääntö" }, insurance: { title: "Tapaturmavakuutus" }, work: { description: "Kuvaus palkkalaskelmaan", occupationCode: "Ammattiluokka vakuutukseen" }, employment: { title: "Työsuhteen", startDate: "Alku pvm", endDate: "Loppu pvm", isFixedTerm: "Määräaikainen työsuhde", isTerminated: "Työsuhde päättynyt" }, salaryPaymentMethod: "Palkanmaksutapa" }, DataImport: { badgeUnit: "riviä", messageInvalid: "Virheellinen", columnImportStatus: "Tila", columnValidation: "Viestit", badgeUndoneLabel: "Ei tarkistettuja", badgeErrorLabel: "Virheellisiä", badgeSuccessLabel: "Ok", badgeFinishedLabel: "Valmis", badgeIgnoredLabel: "Ei käsiteltyjä", badgeWarningLabel: "Varoituksia", badgeUploadedLabel: "Tuotu", errorLabel: "Virhe", successLabel: "Ok", ignoredLabel: "Ei käsitelty", warningLabel: "Varoitus", help: { fields: { title: "Sarakkeet", id: "ID", type: "Tyyppi", name: "Nimi", description: "Kuvaus" }, values: { title: "Arvolistat", type: "Tyyppi", value: "Arvo", description: "Kuvaus" } }, stepUpload: { title: "Tuo Excel-tiedosto", intro: "Tuo Excel-tiedosto koneeltasi napsauttamalla 'Valitse tiedosto...' -painiketta. Voit kopioida myös Excelin sisällön leikepöydältä taulukkoon napsauttamalla 'Liitä leikepöydältä' -painiketta.", buttonHelp: "Lue ohjeet...", buttonUpload: "Valitse tiedosto...", buttonPaste: "Liitä leikepöydältä", buttonReset: "Tyhjennä taulukko" }, stepValidate: { title: "Tarkista rivit", intro: "Tarkista tuotujen rivien tiedot napsauttamalla 'Tarkista taulukon tiedot' -painiketta.", buttonValidate: "Tarkista taulukon tiedot" }, stepImport: { title: "Tallenna tiedot", intro: "Aloita tietojen tallennus napsauttamalla 'Aloita tietojen tuonti' -painiketta.", buttonCancel: "Keskeytä", buttonImport: "Aloita tietojen tuonti" } }, CalcImport: { validateWorkersButton: "Tarkista työntekijöiden työsuhteet", messageMissingEmployment: "Virhe, työntekijää ei ole luotu", messageExistingEmployment: "Ok, työntekijä on olemassa", messageSeveralEmployments: "Varoitus: usea työsuhde mahdollista", help: { title: "Laskelmien tuonti", overview: { title: "Yleistä", row1: "Taulukkoon voi syöttää useampia rivejä per työntekijä. Työntekijät identifioidaan henkilötunnuksen perusteella.", row2: "Kun rivit tallennetaan, luodaan uusi palkkalista tai päivitetään olemassa olevaa palkkalistaa. Palkkalista määräytyy yrityksen, palkkapäivän ja palkkalistan nimen perusteella." } }, options: { title: "Palkkalistan tuonnin asetukset", addRows: "Lisää rivit laskelmille", removeImportedRows: "Korvaa laskelmien tästä aineistosta tuodut rivit", removeAllRows: "Korvaa laskelmien kaikki rivit", applyEmploymentDefaultRows: "Lisää työntekijöiden oletusrivit", sourceId: "Aineistotunnus" } }, WorkerImport: { validateWorkersButton: "Tarkista työntekijöiden työsuhteet", messageMissingEmployment: "Työntekijää ei ole luotu", messageExistingEmployment: "Ok, työntekijä on olemassa", messageSeveralEmployments: "Varoitus, usea työsuhde mahdollista", help: { title: "Työntekijöiden tuonti", overview: { title: "Yleistä", row1: "Työntekijät identifioidaan henkilötunnuksen perusteella.", row2: "HUOM! Tallennus luo vain uusia työntekijöitä, olemassa olevien työntekijöiden tietoihin ei tehdä muutoksia." } } }, CompanyImport: { enrichEInvoiceAddressesButton: "Täydennä verkkolaskuosoitteet", enrichEInvoiceAddressesMessage: "Haetaan puuttuvia verkkolaskuosoitteita...", enrichEInvoiceAddressesSelectionMessage: "Valitse verkkolaskuosoite", help: { title: "Asiakkaiden tuonti", overview: { title: "Yleistä", row1: "Yritykset identifioidaan Y-tunnuksen perusteella.", row2: "Kun rivit tallennetaan, uusi yritys luodaan, jos sitä ei ole vielä luotu. Samalla syntyy asiakkuus uuteen yritykseen. Jos yritys on jo ennestään olemassa ja valtuus annettu, luodaan myös asiakkuus." } } }, AccountAvatarEdit: { optionChoose: "Valitse kuvan tyyppi", optionIcon: "Kuvake", optionUploaded: "Kuva omalta koneelta", avatarTypeLabel: "Kuvan tyyppi", initialsLabel: "Nimikirjaimet", colorLabel: "Väri" }, InvoiceSettings: { legend: "Laskut" }, AccountInfo: { palkkausAccount: "Palkkaus.fi-tili", email: "Sähköposti", companyName: "Yrityksen nimi", phone: "Puhelinnumero", officialId: "Y-tunnus", address: "Osoite", companyType: "Yhtiömuoto", ibanNumber: "Pankkitili", authorizationType: "Valtuutus" }, CalcOverview: { getDatesRangeText: "Täytä työn alku- ja loppupäivät!", ibanOk: "Tilinumero OK", noIbanNumber: "Ei tilinumeroa", getUsecaseTextNumberOfDays: "päivää", calcRows: "Palkkarivit", salary: "Palkka", benefits: "Luontoisedut", deductions: "Vähennykset", total: "Yht.", totalGrossSalary: "Bruttopalkka", summary: "Yhteenveto", worker: "Työntekijä", worktime: "Työaika", salaryDate: "Palkkapäivä", now: "Heti", leavesDays: "Lomapäivät", absencesDays: "Palkatt. poissaolot", paidAbsencesDays: "Palkall. poissaolot", d: "pv", paymentMethod: "Maksutapa", noPaymentMethod: "Maksutapaa ei valittu" }, DateRange: { labelDaysCount: "Päivien määrä", labelStartAndEndDate: "Alku- ja loppupäivät", salaryPeriod: "Palkkakausi", startDate: "Alkupäivä", otherMonth: "Muu kuukausi", periodStartDateError: "Syötä muodossa 'pv.kk.'", periodStartDateError2: " ei ole päivämäärä.", getDatesRangeText: "Täytä työn alku- ja loppupäivät!", numberOfDays: " päivää" }, CalcReports: { reportType: "Tyyppi", reportLanguage: "Kieli", reportViewPartial: "Vain taulukko", reportViewPage1: "Ensimmäinen sivu", reportViewFull: "Koko raportti", irRows: "Tulorekisteririvit", irFull: "Palkkatietoilmoitus", rowsReport: "Rivilistaus" }, CalcWorktime: { title: "Milloin työ tehdään?", otherMonth: "Muu kuukausi", periodStartDateErrorFormat: "Syötä muodossa 'pv.kk.'", periodStartDateErrorNotDate: " ei ole päivämäärä.", getDatesRangeText: "Täytä työn alku- ja loppupäivät!", getUsecaseTextNumberOfDays: "päivää", salaryDateTitle: "Palkkapäivä", salaryDateDescription: { html: " Päivä, jolloin palkka on työntekijän tilillä. Tyhjä päivä tarkoittaa <strong>heti</strong>: Käytännössä 0-3 päivää maksutavasta riippuen." }, salaryDateLabel: "Palkkapäivä", worktime: { placeholder: "Työaika", description: "Valitse palkkakausi ja työpäivien määrä kaudella. Tarkat alku- ja loppupäivät voi antaa, kun valitsee Muu periodi.", startAndEndDates: "Alku- ja loppupäivät" } }, ProCalculator: { work: "Tehtävä työ:", workInfo: "Työn tiedot", workerInfo: "Perustiedot", employment: "Työsuhde", calcRows: "Palkkarivit", taxcard: "Verokortti", worktimeAndAbsences: "Työaika ja lomat", paymentMethods: "Maksutavat", reports: "Raportit" }, AccountingReportRows: { accountNumber: "Ehdotustili", accountName: "Selite", saldo: "Yhteensä", calculation: "Laskelma", description: "Kuvaus", vatPercent: "Alv %", sum: "Summa", projectNumber: "Projektinumero", costCenter: "Kustannuspaikka" }, BatchProcess: { status: "Tila", importStatuses: { ignored: "Ei käsitelty", success: "Ok", error: "Virhe", warning: "Varoitus" }, messages: "Viestit", cols: { owner: "Työnantaja", shortText: "Kuvaus", salaryDate: "Palkkapäivä", grossSalary: "Bruttopalkat" }, processing: "Käsitellään", cancelProcess: "Keskeytä ajo", processCancelled: "Ajo peruttu", ready: "Valmis", errors: "Virheitä", count: "Lukumäärä" } }, TABULATOR: { pagination: { first: "Ensimmäinen", last: "Viimeinen", prev: "Edellinen", next: "Seuraava", counter: { showing: "Näytetään", rows: "rivistä", pages: "pages" } } }, UI_Terms: { all: "Kaikki", abc: "Abc", add: "Lisää", addAttachment: "Lisää liite", approve: "Hyväksy", approveAndSave: "Hyväksy ja tallenna", addNew: "Lisää uusi", addRow: "Lisää rivi", deleteRow: "Poista rivi", areYouSure: "Oletko varma?", back: "Takaisin", backAlt: "Peruuta", backToFront: "Takaisin etusivulle", calculate: "Laske", calculations: "Laskelmat", cancel: "Peruuta", cancelAlt: "Peru", cancelEditing: "Peru muokkaaminen", change: "Vaihda", check: "Tarkista", checked: "Tarkastettu", choose: "Valitse...", chooseAll: "Valitse kaikki", chosen: "Valittu", continue: "Jatka", notChosen: "Ei valittu", createAccount: "Luo tunnus", createTestAccount: "Luo testitunnus", chooseWorkDateRange: "Määritä työn alku- ja loppupäivät", chooseWorkDuration: "Määritä työn kesto...", clear: "Tyhjennä", close: "Sulje", confirm: "Vahvista", copy: "Kopio", copyed: "Kopioitu", copyAsNew: "Kopioi uudeksi", copyAsRequest: "Kopio pyynnöksi", copyToClipboard: "Kopioi", copiedToClipboard: "Kopioitu", createNew: "Lisää uusi", dateFormats: { dm: "pv.kk.", dmyyyy: "p.k.vvvv" }, dateNotChosen: "päivämäärä ei valittuna", days: "pv", delete: "Poista", units: { pce: "kpl" }, unselect: "Poista valinta", unselectAll: "Poista valinnat", demo: "KOKEILUVERSIO", unenable: "Poista käytöstä", dismiss: "Hylkää", done: "Valmis", download: "Lataa", downloadPdf: "Lataa PDF", downloadExcel: "Lataa Excel-tiedosto", edit: "Muokkaa", enable: "Ota käyttöön", error: "Virhe", gotIt: "Ymmärrän", hours: "h", isDeleting: "Poistetaan...", isSaving: "Tallennetaan...", isCalculating: "Lasketaan", learnMore: "Lue lisää", loading: "Ladataan...", loginInProgress: "Kirjaudutaan...", login: "Kirjaudu", logout: "Kirjaudu ulos", logoutAlt: "Päätä nykyinen sessio", makeOrder: "Tee tilaus", markChecked: "Merkitse tarkastetuksi", minCharacters: "Kirjoita vähintään 3 merkkiä...", minutes: "min", monthHalf: "½ kuukautta", months: "kk", moreInfo: "Lisätietoja", name: "Nimi", navigation: "Navigaatio", newCalculation: "Uusi laskelma", next: "Seuraava", new: "Uusi", no: "Ei", noteRequiredField: "* Pakollinen kenttä", noThanks: "Ei kiitos", ok: "OK", oldVersion: "vanha versio", open: "Avaa", orChoose: "...tai valitse...", otherPeriod: "Muu periodi", pay: "Maksa", payAll: "Ohita ja maksa - Työnantaja maksaa työntekijän osuuden sivukuluista", payAllShort: "Ohita ja maksa", personalId: "Henkilötunnus", pleaseWait: "Ole hyvä ja odota...", postpone: "Ei nyt", previous: "Edellinen", print: "Tulosta", printable: "Tuloste", read: "Lue", readMore: "Lue lisää", recalculate: "Päivitä laskelma", recalculateAlt: "Laske uudelleen", refresh: "Päivitä", register: "Rekisteröidy", reject: "Hylkää", removeAttachment: "Poista liite", save: "Tallenna", saveAndProceed: "Tallenna ja jatka", saveEdited: "Tallenna muutokset", search: "Hae...", searchByName: "Hae nimeltä...", seePreview: "Katsele", seePreviewAlt: "Esikatsele", select: "Valitse", selectAll: "Valitse kaikki", selectAlt: "Valitse...", sendEmail: "Lähetä sähköposti", setDefault: "Aseta oletukseksi", send: "Lähetä", show: "Näytä", showMore: "Näytä ohje", showMore2: "Näytä lisää", showAll: "Näytä kaikki", skip: "Ohita", sureToDeleteRecord: "Haluatko varmasti poistaa tämän tietueen?", textSearch: "Tekstihaku", today: "Tämä päivä", timeToday: "Tänään", timeYesterday: "Eilen", total: "Yhteensä", updateCalculation: "Päivitä laskelma", updatingCalculation: "Päivitetään laskelmaa...", use: "Ota käyttöön", wait: "Odota...", week2: "2 viikkoa", years: "vuotta", year: "Vuosi", yes: "Kyllä", created: "Luotu", updated: "Päivitetty", inspect: "Katsele", salaryPayment: "Palkanmaksu", incomeLimit: "Tuloraja", withholdingTax: "Ennakonpidätys", amount: "Määrä", price: "Hinta", menu: "Valikko", sessionExpired: "Istunto on vanhentunut", sessionExpiredEmbedded: "Palkkaus.fi-istuntosi on vanhentunut tai tulit sivulle ilman kirjautumista. Siirry johonkin toiseen osioon päänavigaatiosta ja palaa takaisin Palkanmaksu-osioon.", pcs: "kpl", pageDisabledAlert: "Tämä ominaisuus ei ole käytössä palvelupaketissasi.", downloadMaterial: "Lataa aineisto", downloadSelected: "Lataa valitut", downLoadableMaterialTypes: { invoice: "Lasku", invoices: "Laskut", payment: "Maksu", payments: "Maksut", accounting: "Kirjanpito", calculation: "Palkkalaskelma", calculations: "Palkkalaskelmat" }, status: "Tila" }, VALIDATION: { _notes: "Please note that all calc or payroll specific messages shoud be placed under Calc or Payroll -nodes. Messages in the Validation-root are obsolete.", Files: { ContentTypeError: "Tiedostomuotoa ei hyväksytä", Empty: "Ladattava tiedosto on tyhjä", MaxFileSize: "Ladattava tiedosto on liian suuri", NoFiles: "Kutsun mukana ei tullut yhtään tiedostoa.", SaveError: "Tuntematon virhe tiedoston tallennuksessa." }, IllegalWorkerForCompanyType: { description: "Yksityinen elinkeinonharjoittaja eli toiminimi ei voi maksaa itselleen palkkaa. Palkanmaksu hoidetaan yksityisnostoina. Kirjanpitäjäsi voi neuvoa sinua miten toimia.", label: "Ei-sallittu palkka" }, IncompleteAdvancePayment: { description: "Palkkaennakko laskelmalla on liian suuri. Korjaa palkkaennakko pienemmäksi tai bruttopalkka suuremmaksi. Mahdolliset ennakkoon maksetut kulukorvaukset tulee ilmoittaa omalla palkkalajilla.", label: "Palkka ei riitä ilmoitettuun palkkaennakkoon" }, IncompleteForeclosure: { description: "Rahapalkka ei riitä ulosmittauksen tekemiseen. Tarkista ulosmittauksen määrä maksukiellosta ja muista huomioida maksukiellossa ilmoitettu suojaosuus.", label: "Palkka ei riitä ulosmittauksen tekemiseen" }, IncompleteOtherDeductions: { description: "Palkka ei riitä ilmoitettuihin muihin vähennyksiin", label: "Palkka ei riitä" }, IncompletePensionPayment: { description: "Palkka ei riitä työntekijän osuuteen TyEL-maksusta", label: "Palkka ei riitä" }, IncompletePrepaidExpenses: { description: "Ennakkoon maksettu kulukorvaus laskelmalla on liian suuri. Ennakkoon maksettu kulukorvaus ylittää laskelmalle lisätyt kulukorvaukset.", label: "Ennakkoon maksettu kulukorvaus laskelmalla on liian suuri" }, IncompleteUnemploymentInsurancePayment: { description: "Palkka ei riitä työntekijän osuuteen työttömyysvakuutusmaksusta", label: "Palkka ei riitä" }, IncompleteUnionPayment: { description: "Palkka ei riitä AY-jäsenmaksuun", label: "Palkka ei riitä" }, MissingOccupationCode: { description: "Työn tyyppi puuttuu. Lisää se kohdassa 1 hakemalla Tilastokeskuksen luokituksesta. Ammattiluokitus on pakollinen tieto Tulorekisterin palkkatietoilmoituksessa.", label: "Ammattiluokitus puuttuu" }, MissingWorkerIbanNumber: { label: "Tilinumero puuttuu", description: "Työntekijän tiedoista puuttuu tilinumero (IBAN-muodossa)." }, NegativeRowTotalNotSupported: { description: "Rivin yhteenlaskettu summa on negatiivinen. Rivillä ei sallita negatiivista summaa.", label: "Rivillä ei sallita negatiivista summaa" }, TimeSheetInput: { isOverlapping: { label: "Päivälle on päällekkäisiä kirjauksia", description: "Päivälle kirjatut kellokorttikirjaukset menevät päällekäin." } }, Calc: { IllegalWorkerForCompanyType: { description: "Yksityinen elinkeinonharjoittaja eli toiminimi ei voi maksaa itselleen palkkaa. Palkanmaksu hoidetaan yksityisnostoina. Kirjanpitäjäsi voi neuvoa sinua miten toimia.", label: "Ei-sallittu palkka" }, IncompleteAdvancePayment: { description: "Palkkaennakko laskelmalla on liian suuri. Korjaa palkkaennakko pienemmäksi tai bruttopalkka suuremmaksi. Mahdolliset ennakkoon maksetut kulukorvaukset tulee ilmoittaa omalla palkkalajilla.", label: "Palkka ei riitä ilmoitettuun palkkaennakkoon" }, IncompleteForeclosure: { description: "Rahapalkka ei riitä ulosmittauksen tekemiseen. Tarkista ulosmittauksen määrä maksukiellosta ja muista huomioida maksukiellossa ilmoitettu suojaosuus.", label: "Palkka ei riitä ulosmittauksen tekemiseen" }, IncompleteOtherDeductions: { description: "Palkka ei riitä ilmoitettuihin muihin vähennyksiin", label: "Palkka ei riitä" }, IncompletePensionPayment: { description: "Palkka ei riitä työntekijän osuuteen TyEL-maksusta", label: "Palkka ei riitä" }, IncompletePrepaidExpenses: { description: "Ennakkoon maksettu kulukorvaus laskelmalla on liian suuri. Ennakkoon maksettu kulukorvaus ylittää laskelmalle lisätyt kulukorvaukset.", label: "Ennakkoon maksettu kulukorvaus laskelmalla on liian suuri" }, IncompleteUnemploymentInsurancePayment: { description: "Palkka ei riitä työntekijän osuuteen työttömyysvakuutusmaksusta", label: "Palkka ei riitä" }, IncompleteUnionPayment: { description: "Palkka ei riitä AY-jäsenmaksuun", label: "Palkka ei riitä" }, MissingOccupationCode: { description: "Työn tyyppi puuttuu. Lisää se kohdassa 1 hakemalla Tilastokeskuksen luokituksesta. Ammattiluokitus on pakollinen tieto Tulorekisterin palkkatietoilmoituksessa.", label: "Ammattiluokitus puuttuu" }, MissingWorkerIbanNumber: { label: "Työntekijän tilinumero puuttuu", description: "Työntekijän tiedoista puuttuu tilinumero (IBAN-muodossa)." }, InvalidWorkerIbanNumber: { label: "Työntekijän tilinumero on virheellinen", description: "Työntekijän tiedoissa on virheellinen tilinumero (IBAN-muodossa)." }, NegativeRowTotalNotSupported: { description: "Rivin yhteenlaskettu summa on negatiivinen. Rivillä ei sallita negatiivista summaa.", label: "Rivillä ei sallita negatiivista summaa" }, MissingWorkerContactStreet: { description: "Työntekijän osoitetiedot ovat pakollisia, jos työntekijällä on keinotekoinen henkilötunnus. Keinotekoisen henkilötunnuksen loppuosa alkaa numerolla 9.", label: "Työntekijän osoitteen katuosoite puuttuu" }, MissingWorkerContactCity: { description: "Työntekijän osoitetiedot ovat pakollisia, jos työntekijällä on keinotekoinen henkilötunnus. Keinotekoisen henkilötunnuksen loppuosa alkaa numerolla 9.", label: "Työntekijän osoitteen postitoimipaikka puuttuu" }, MissingWorkerContactPostalCode: { description: "Työntekijän osoitetiedot ovat pakollisia, jos työntekijällä on keinotekoinen henkilötunnus. Keinotekoisen henkilötunnuksen loppuosa alkaa numerolla 9.", label: "Työntekijän osoitteen postinumero puuttuu" }, MissingEmployerContactStreet: { description: "Työnantajan osoite vaaditaan tulorekisterin palkkatietoilmoitukseen. Lisää osoite asetuksissa ohjatun toiminnon kautta (vaatii nimenkirjoitusoikeudellisen henkilön pankkitunnukset) tai ilmoita osoite asiakaspalvelulle sähköpostitse osoitteeseen aspa@palkkaus.fi.", label: "Työnantajan osoitteen katuosoite puuttuu" }, MissingEmployerContactCity: { description: "Työnantajan osoite vaaditaan tulorekisterin palkkatietoilmoitukseen. Lisää osoite asetuksissa ohjatun toiminnon kautta (vaatii nimenkirjoitusoikeudellisen henkilön pankkitunnukset) tai ilmoita osoite asiakaspalvelulle sähköpostitse osoitteeseen aspa@palkkaus.fi.", label: "Työnantajan osoitteen postitoimipaikka puuttuu" }, MissingEmployerContactPostalCode: { description: "Työnantajan osoite vaaditaan tulorekisterin palkkatietoilmoitukseen. Lisää osoite asetuksissa ohjatun toiminnon kautta (vaatii nimenkirjoitusoikeudellisen henkilön pankkitunnukset) tai ilmoita osoite asiakaspalvelulle sähköpostitse osoitteeseen aspa@palkkaus.fi.", label: "Työnantajan osoitteen postinumero puuttuu" }, MissingWorker: { label: "Laskelmalta puuttuu työntekijä" }, MissingWorkerFirstName: { label: "Työntekijän etunimi puuttuu" }, MissingWorkerLastName: { label: "Työntekijän sukunimi puuttuu" }, MissingWorkerSocialSecurityNumber: { label: "Työntekijän henkilötunnus puuttuu" }, MissingWorkerSocialSecurityNumber_InTest: { label: "Työntekijän henkilötunnus puuttuu. Testissä voit käyttää tarkistusnumerona tähteä ('*')" }, InvalidWorkerSocialSecurityNumber: { label: "Työntekijän henkilötunnus on virheellinen" }, InvalidWorkerSocialSecurityNumber_InTest: { label: "Työntekijän henkilötunnus on virheellinen. Testissä voit käyttää tarkistusnumerona tähteä ('*')" }, InvalidCarBenefitRow: { label: "Autoedusta puuttuu auton ikäryhmä ja/tai autoedun tyyppi" }, InvalidCarBenefitEmissionValues: { label: "Auton päästöarvon tulee olla 0 - 100" }, InvalidRemunerationRow: { label: "Kertaluontoisen palkkion tulolaji puuttuu" }, InvalidPaidSickLeaveRow: { label: "Palkallisen sairauspoissaolon laji puuttuu" }, InvalidTrainingRow: { label: "Koulutusajan palkan laji puuttuu" }, SalaryDateInPast: { label: "Palkkapäivä on menneisyydessä ja palkka käsitellään takautuvana palkkana", description: "Takautuvan palkan työnantajasuoritusten (vero) ja työeläkkeen määrät ovat arvioita. Todellinen määrä voi poiketa arviosta. Takautuvan palkan eriä (nettopalkka, työnantajasuoritukset (vero) ja työeläkkeet ) ei voi maksaa asiakasvaratilin kautta, vaan työnantajan pitää maksaa ne suoraan itse. Palkkatietoilmoitus lähetetään myös takautuvasta palkasta Tulorekisteriin, mutta menneisyydessä oleva palkkapäivä voi aiheuttaa myöhästymismaksun, jonka Tulorekisteri perii työnantajalta." }, MissingSalaryDate: { label: "Vuodenvaihteesta johtuen palkkapäivän valinta on tilapäisesti pakollinen laskelmalle", description: "Vuodenvaihteesta johtuen palkkapäivän valinta on tilapäisesti pakollinen laskelmalle, jotta palkka kirjataan oikealle vuodelle ja sivukulujen laskenta menee oikein. Valitse palkkapäivä laskelmalle sen mukaan mille vuodelle haluat palkat kirjattavan työntekijän verotukseen. Ole tarvittaessa yhteydessä asiakaspalveluun, jos tarvitset apua palkkapäivän määrittämisessä." }, MissingRequiredSalaryDate: { label: "Palkkapäivää  ei ole valittu", description: "Palkkapäivää ei ole valittu. Valitse palkkalaskelmalle palkkapäivä. Jos käytät palkkalistaa, valitse palkkalistalle palkkapäivä." }, MissingRequiredWorkingPeriod: { label: "Palkkakautta ei ole valittu", description: "Palkkakautta ei ole valittu. Valitse palkkalaskelmalle palkkakausi. Jos käytät palkkalistaa, valitse palkkalistalle palkkakausi." }, SalaryDateConstraint: { label: "Nettopalkka ei välttämättä ehdi työntekijän tilille laskelmalle valittuna palkkapäivänä", description: "Huomaathan, että nettopalkka ei välttämättä ehdi työntekijän tilille laskelmalle valittuna palkkapäivänä. Voit kuitenkin poikkeuksellisesti vuodenvaihteessa valita kyseisen palkkapäivän, jos haluat palkan kohdistuvan työntekijän verotuksessa tälle vuodelle.  Nettopalkka tilitetään työntekijälle pankkien aikataulujen mukaisesti. Ole tarvittaessa yhteydessä asiakaspalveluun, jos tarvitset apua palkkapäivän määrittämisessä." }, SalaryDateChanged: { label: "Laskelman/palkkalistan palkkapäivä on muuttunut.", description: "Tarkista laskelman/palkkalistan palkkapäivä ja tallenna." }, InvalidCompensationRow: { label: "Palkkalaskelma voi sisältää Työkorvauksen vain siinä tapauksessa, että työsuhdetyyppinä/eläketietona on Työkorvaus.", description: "Huomioithan että työkorvausta ei saa maksaa työsuhteessa olevalle työntekijälle! Tarkista työntekijän tiedoista Työsuhde-valinta ennen palkan maksamista tai valitse toinen palkkalaji." }, InvalidRowForCompensation: { label: "Työsuhdetyyppinä/eläketietona on Työkorvaus, jolloin laskelmalla voi olla vain tulolajeja 336 Työkorvaus, 357 Yleishyödyllisen yhteisön maksama kilometrikorvaus  tai 358 Yleishyödyllisen yhteisön maksama päiväraha.", description: "Päivitä työntekijän Työsuhde-valinta tai vaihda palkkarivi Työkorvaus-palkkalajiksi. " }, InvalidRowWhenCompensationRow: { label: "Työkorvauksen sisältämällä palkkalaskelmalla ei voi olla tulolajeja 311 Kilometrikorvaus tai 331 Päiväraha.", description: "Työkorvauksen yhteydessä maksetut kustannusten korvaukset eivät ole verovapaita ja ne tulee kirjata Työkorvaus-palkkalajilla." }, InvalidBenefitDeduction: { label: "Muista luontoiseduista peritty korvaus ei voi olla suurempi kuin luontoisetujen kokonaismäärä." }, InvalidTaxAtSourceRow: { label: "Lähdeveron käyttö edellyttää työsuhteen tyyppiä Ulkomainen työntekijä (Suomessa)", description: "Lähdeverokorttia voi tyypillisesti käyttää vain, jos työntekijä on rajoitetusti verovelvollisen (asuinvaltio muu kuin Suomi). Tee tarvittavat muutokset Työsuhde-välilehden alta valitsemalla työsuhteen muodoksi Ulkomaalainen työntekijä tai käytä tavallista verokorttia. Ohjelma ei tue vielä tapausta suomalainen ulkomailla." }, CalculationCorrectionNewEpr: { label: "Uusi palkkatietoilmoitus pitää lähettää Tulorekisteriin", description: "Palkkalaskelmasta ei ole tehty palkkatietoilmoitusta tai lähetetty palkkatietoilmoitus on peruttu. Lähetä uusi palkkatietoilmoitus." }, CalculationCorrectionReplaceEpr: { label: "Korvaava palkkatietoilmoitus pitää lähettää Tulorekisteriin", description: "Palkkalaskelman muutokset edellyttävät korvaavan palkkatietoilmoituksen lähettämistä Tulorekisteriin." }, CalculationCorrectionReNewEpr: { label: "Palkkatietoilmoitus pitää mitätöidä ja lähettää uusi palkkatietoilmoitus Tulorekisteriin", description: "Palkkalaskelman muutokset edellyttävät jo lähetetyn palkkatietoilmoituksen mitätöimistä ja uuden palkkatietoilmoituksen lähettämistä Tulorekisteriin." }, CalculationCorrectionKeepEpr: { label: "Tulorekisterissä oleva palkkatietoilmoitus vastaa palkkalaskelman tietoja", description: "Palkkalaskelman muutokset eivät sisällä Tulorekisteriin ilmoitettavia tietoja." }, InvalidReferenceNumberInForeclosureRow: { label: "Ulosmittauksen viitenumero on virheellinen", description: "Ulosmittauksen viitenumero on virheellinen. Tarkista viitenumero ja korjaa se." }, InvalidReferenceNumberInUnionPaymentRow: { label: "AY-jäsenmaksun viitenumero on virheellinen", description: "AY-jäsenmaksun viitenumero on virheellinen. Tarkista viitenumero ja korjaa se." }, January2025Taxcard: { label: "Työntekijän verokortin voimassaolo on päättynyt. Lisää vuoden 2025 verokortti työntekijän tietoihin.", description: "Työntekijän verokortin voimassaolo on päättynyt. Lisää vuoden 2025 verokortti työntekijän tietoihin. Voit halutessasi käyttää automaattista verokortin hakua. Jos haluat käyttää vuoden 2024 verokorttia, voit ohittaa tämän virheilmoituksen." }, InvalidIrIncomeTypeDailyAllowanceRow: { label: "Päivärahan tyyppi puuttuu" } }, Payroll: { Calc: { EmailAddress: { label: "Sähköposti on virheellinen" }, FirstNameNotEmpty: { label: "Työntekijän etunimi puuttuu" }, IbanInvalid: { label: "Tilinumero on virheellinen (IBAN-muoto)" }, IbanNotEmpty: { label: "Tilinumero puuttuu" }, InvalidStatusForPayroll: { label: "Palkkalistan laskelmalla väärä status." }, LastNameNotEmpty: { label: "Työntekijän sukunimi puuttuu" }, PayrollIdConflict: { label: "Laskelman palkkalista-tunnus on virheellinen." }, SocialSecurityNumber_InTest: { label: "Henkilötunnus on virheellinen. Testissä voit käyttää tarkistusnumerona tähteä ('*')" }, SocialSecurityNumber: { label: "Henkilötunnus on virheellinen." }, TaxCardType: { label: "Verokortti puuttuu tai tyyppiä ei ole määritetty." }, TaxPercent: { label: "Veroprosenttia ei ole määritetty" }, TelephoneOrEmailNotEmpty: { label: "Anna jompikumpi tai molemmat yhteystiedot (puhelinnumero ja sähköposti)." }, TotalGreaterThan0: { label: "Palkkalaskelman summa on nolla" } }, NoCalculations: { label: "Ei yhtään laskelmaa." } }, SharedTaxcard: { description: "Työntekijäsi on jakanut uuden verokortin ja toivoo, että sitä käytetään palkanmaksuun. Tarkista ja hyväksy verokortti palkkalaskurin ruudun 1. Työntekijä kautta ennen palkan maksamista, jotta ennakonpidätys päivittyy laskelmalle oikein.", label: "Uusi jaettu verokortti!" }, Usecases: { noKind: "Rivin tyyppi puuttuu tai ei ole tuettu", noIrIncomeType: "Tulolaji puuttuu tai ei ole tuettu.", negativeRow: "Hinta ei voi olla negatiivinen: Tulorekisteriin ei voi ilmoittaa miinusmerkkisiä arvoja.", negativeAmount: "Määrä ei voi olla negatiivinen: Tulorekisteriin ei voi ilmoittaa miinusmerkkisiä arvoja.", carBenefit: { default: "Pakollisia tietoja puuttuu! Autoetu lasketaan todennäköisesti väärin.", kilometerBased: ", kilometripohjainen laskenta:", deduction: "Vähennys:", noDeduction: ". Ei vähennystä palkasta.", limitedCarBenefit: "Auton käyttöetu, ", fullCarBenefit: "Vapaa autoetu, ", noTypeSelected: "Autoetu, ei tyyppivalintaa, ", invalidEmissionValues: "Auton päästöarvon tulee olla 0 - 100" }, compensation: { noCompensationData: "Korvauksen laji puuttuu.", compensation: "Lisä ", compensation2: "/ tunti, lisä yhteensä " }, expensesValidation: { noVat: "Arvonlisäveroa ei määritetty", vat0: "Arvonlisävero 0 % - Nollaverokanta", vat10: "Arvonlisävero 10 % - Kirjat, kulttuuri, henkilökuljetus ja majoitus", vat14: "Arvonlisävero 14 % - Elintarvikkeet, ravintola- ja ateriapalvelut", vat24: "Arvonlisävero 24 % - Yleinen verokanta", vat255: "Arvonlisävero 25,5 % - Yleinen verokanta", vatCustom: "Arvonlisävero " }, mealBenefit: { default: "verotusarvo", deduction: "vähennys palkasta", taxValueDeduction: "vähennys palkasta vastaa verotusarvoa", allowance: "arvo", undefined: "HUOM: Ravintoedun tyyppiä ei ole määritetty. Oletus: verotusarvo, ei korvausta työntekijän palkasta." }, subsidisedCommute: { singleDeduction: "Työsuhdematkalippu, vähennys palkasta:", periodicalDeduction: "Työsuhdematkalippu, vähennys palkasta:", periodicalDeduction2: " jaettuna ", periodicalDeduction3: " osaan.", noDeduction: "Työsuhdematkalippu, ei vähennystä palkasta." }, bicycleBenefit: { singleDeduction: "Polkupyöräetu, vähennys palkasta:", periodicalDeduction: "Polkupyöräetu, vähennys palkasta:", periodicalDeduction2: " jaettuna ", periodicalDeduction3: " osaan.", noDeduction: "Polkupyöräetu, ei vähennystä palkasta." }, nonProfitOrg: { noKind: "HUOM: Määritä korvauksen tyyppi. Oletuksena käytetään kilometrikorvausta.", default: "Yleishyödyllisen yhteisön ", accomodationAllowance: "Majoittumiskorvaus", kilometerAllowance: "Kilometrikorvaus", dailyAllowance: "Päiväraha" }, dailyAllowance: "Kotimaan kokopäiväraha", foreclosure: { default: "Ulosottosumma päivitetään automaattisesti, työnantaja tilittää maksun itse.", noPrice: "HUOM: Ulosoton summaa ei ole annettu." }, totalWorkerPayment: { default: " lasketaan annetun summan ", default2: " perusteella. Summan sisältämät erät: " }, unionPayment: { fixed: "Kiinteä AY-jäsenmaksun määrä. Työnantaja tilittää maksun itse.", fixedError: "HUOM: Jäsenmaksua ei ole määritetty.", percentage: "AY-jäsenmaksu on %-osuus palkasta, palkkasumma päivitetään automaattisesti. Työnantaja tilittää maksun itse.", percentageError: "HUOM: Jäsenmaksu-%:ia ei ole määritetty.", raksa: "AY-jäsenmaksu on %-osuus palkasta, palkkasumma päivitetään automaattisesti. Työnantaja tilittää maksun itse.", raksaError: "HUOM: Jäsenmaksu-%:ia ei ole määritetty.", default: "Tuntematon AY-jäsenmaksun tyyppi." } }, WorktimeImport: { EmploymentNotResolved: { label: "Työsuhdetta ei löydy" }, InvalidPersonalId: { label: "Henkilötunnuksen muoto on väärä" } }, ValidationErrors: { unknown: "Validointivirhe: {{error}}", maxlength: "Pituus enintään {{maxlength}} merkkiä", minlength: "Pituus vähintään {{minlength}} merkkiä", required: "Kenttä on pakollinen", sxyCompanyIdFi: "Y-tunnuksen muoto on väärä", sxyCurrency: "Rahamäärän muoto on väärä", sxyEmail: "Sähköpostin muoto on väärä", sxyIban: "TIlinumeron (IBAN) muoto on väärä", sxyInteger: "Kentän pitää olla kokonaisluku", sxyMobilePhone: "Puhelinnumeron muoto on väärä", sxyNumber: "Kentän pitää olla numero", sxyBankReferenceFi: "Tarkista viitenumero", sxyPensionContractNumber: "Tarkista sopimusnumero. Jos sinulla ei ole työntekijöiden työeläkevakuutusta (TyEL), voit valita Ei yhtiötä. YEL-sopimuksen numeroa ei tarvitse ilmoittaa.", sxyPersonalIdFi: "Henkilötunnuksen muoto on väärä", sxyOfficialIdFi: "Y-tunnuksen tai henkilötunnuksen muoto on väärä", sxyPostalCodeFi: "Postinumeron muoto on väärä", sxySmsVerificationCode: "Tarkista varmennuskoodi", sxyTaxPercent: "Veroprosentin muoto on väärä", sxyTemporaryPensionContractNumber: "Syötit tilapäisen sopimuksen numeron.", patternMismatch: "Anna arvo pyydetyssä muodossa", tooLong: "Arvo on liian pitkä", tooShort: "Arvo on liian lyhyt", rangeOverflow: "Arvo on liian suuri", rangeUnderflow: "Arvo on liian pieni", typeMismatch: "Anna kelvollinen arvo" } } } };
class vr {
  /**
   * Creates a new ConfigLogic based on a Config in env file.
   * @param config Raw config in env file.
   */
  constructor(e) {
    Object.assign(this, e);
  }
  /** Gets the type of the environment. */
  getEnv() {
    return (this.apiServer?.indexOf("localhost") ?? -1) > -1 ? "local" : (this.apiServer?.indexOf("rc") ?? -1) > -1 ? "rc" : (this.integrationsServer?.indexOf("test") ?? -1) > -1 ? "test" : this.isTestData ? "demo" : "prod";
  }
  /** Gets the server address for the Omapalkka service based on environment. */
  getOmapalkkaServer() {
    switch (this.getEnv()) {
      case "prod":
        return "https://www.omapalkka.fi";
      case "local":
        return "http://localhost:3000";
      case "test":
        return "https://test-www.omapalkka.fi";
      case "rc":
      case "demo":
      default:
        return "https://demo-www.omapalkka.fi";
    }
  }
  /** Gets the API server address for the Omapalkka service based on environment. */
  getOmapalkkaApiServer() {
    switch (this.getEnv()) {
      case "prod":
        return "https://secure.omapalkka.fi";
      case "local":
        return "https://localhost:7270";
      case "test":
        return "https://test-secure.omapalkka.fi";
      case "rc":
      case "demo":
      default:
        return "https://demo-secure.omapalkka.fi";
    }
  }
}
class pe {
  static get defaultConfig() {
    return {
      wwwServer: "https://test.palkkaus.fi",
      apiServer: "https://test-api.salaxy.com",
      proServer: "https://demo-pro.palkkaus.fi/server",
      reportServer: "https://test-reports.salaxy.com",
      integrationsServer: "https://test-integrations.salaxy.com",
      codeEditor: "https://test-code-editor.salaxy.com",
      isTestData: !0,
      useCookie: !0
    };
  }
  static getGlobalConfig() {
    const e = this.getGlobal();
    return e.salaxy && e.salaxy.config ? e.salaxy.config : null;
  }
  static setGlobalConfig(e) {
    const t = this.getGlobal();
    t.salaxy = t.salaxy || {}, t.salaxy.config = e;
  }
  static getGlobal() {
    if (typeof globalThis < "u")
      return globalThis;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof global < "u")
      return global;
    throw new Error("unable to locate global object");
  }
  /**
   * Returns current configuration.
   * If global (salaxy.config) configuration is null, default config (demo) is returned
   */
  static get current() {
    return new vr(this.getGlobalConfig() ?? this.defaultConfig);
  }
  /**
   * Set current configuration.
   */
  static set current(e) {
    this.setGlobalConfig(e);
  }
  /** Get global, globalThis object */
  static get global() {
    return this.getGlobal();
  }
}
class fe {
  /**
   * Returns true if an object has a property with specified name.
   * Using hasOwnProperty in a safe, easy and concise way.
   * @param obj Object to check
   * @param key String key to look for.
   */
  static has(e, t) {
    return e ? Object.prototype.hasOwnProperty.call(e, t) : !1;
  }
  /**
   * Gets a property based on multi-level property path.
   * Null / undefined at any level will return null as in AngularJS expressions.
   * @param obj Object from which to fetch a property.
   * @param propertyPath Path to the property to fetch.
   */
  static getProperty(e, t) {
    if (!t || !e)
      return null;
    const n = t.split(/\.|\[/).map((i) => i.endsWith("]") ? parseInt(i.substring(0, i.length - 1)) : i);
    for (; n.length; ) {
      const i = n.shift();
      if (i === void 0 || (e = e[i], !e && n.length))
        return null;
    }
    return e;
  }
  /**
   * Sets a property of an object based on property path.
   * Will create the entire path even if the intermittent objects do not exist.
   * @param obj Object whose property should be set.
   * @param propertyPath Dot-delimited property path to the property that should be set.
   * @param value The value that should be set.
   * @returns True if the property is set. Value is not set if there is no propertyPath/obj or
   * if the value is already set to new value (currently strict equality check "===",
   * but may be changed without it being a breaking change).
   */
  static setProperty(e, t, n) {
    if (!t || !e)
      return !1;
    const i = t.split(/\.|\[/).map((r) => r.endsWith("]") ? parseInt(r.substring(0, r.length - 1)) : r);
    for (; i.length > 1; ) {
      const r = i.shift();
      if (r === void 0)
        return !1;
      e[r] || (Number.isInteger(i[0]) ? e[r] = [] : e[r] = {}), e = e[r];
    }
    const s = i[0];
    return e[s] === void 0 && n === void 0 || e[s] === n ? !1 : (e[s] = n, !0);
  }
  /**
   * Uses JSON Serialization / Deserialization to deep clone an object.
   * @param value Object to clone
   * @returns A cloned object.
   */
  static copy(e) {
    return JSON.parse(JSON.stringify(e, (t, n) => n === void 0 ? null : n));
  }
  /**
   * Extends one object with another using Intersection types.
   * https://www.typescriptlang.org/docs/handbook/advanced-types.html
   * @param first First object.
   * @param second Second object.
   */
  static extend(e, t) {
    const n = {};
    for (const i in e)
      fe.has(e, i) && (n[i] = e[i]);
    for (const i in t)
      fe.has(t, i) && !fe.has(n, i) && (n[i] = t[i]);
    return n;
  }
  /**
   * Compares objects a and b.
   * Returns true if the objects are equal using value-to-value comparison.
   *
   * @param a - Any object.
   * @param b - Any object to compare with.
   */
  static equal(e, t) {
    if (e === t)
      return !0;
    if (e && t && typeof e == "object" && typeof t == "object") {
      const n = Array.isArray(e), i = Array.isArray(t);
      let s, r, l;
      if (n && i) {
        if (r = e.length, r !== t.length)
          return !1;
        for (s = r; s-- !== 0; )
          if (!this.equal(e[s], t[s]))
            return !1;
        return !0;
      }
      if (n !== i)
        return !1;
      const o = e instanceof Date, u = t instanceof Date;
      if (o !== u)
        return !1;
      if (o && u)
        return e.getTime() === t.getTime();
      const m = e instanceof RegExp, p = t instanceof RegExp;
      if (m !== p)
        return !1;
      if (m && p)
        return e.toString() === t.toString();
      const y = Object.keys(e);
      if (r = y.length, r !== Object.keys(t).length)
        return !1;
      for (s = r; s-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(t, y[s]))
          return !1;
      for (s = r; s-- !== 0; )
        if (l = y[s], !this.equal(e[l], t[l]))
          return !1;
      return !0;
    }
    return e !== e && t !== t;
  }
}
class fr {
  /**
   * Creates a new TranslationsInstance
   * @param dict Optional dictionary object that contains the translations.
   * The default Finnish dictionary is added in any case (for fallback) unless the Config has the
   * noCache attribute set (used in dev-mode to get the templates and i18n directly from files instead of dist).
   */
  constructor(e = null) {
    this.localesPath = "locales", this.loadedLanguages = [], this.dictionary = e || {}, this.dictionary.fi = this.dictionary.fi || (pe.current?.noCache ? {} : ui), this.dictionary.sv = this.dictionary.sv || {}, this.dictionary.en = this.dictionary.en || {}, this.dictionary.fi.SALAXY && (this.loadedLanguages.push("fi"), this.lang = "fi"), this.dictionary.sv.SALAXY && this.loadedLanguages.push("sv"), this.dictionary.en.SALAXY && this.loadedLanguages.push("en");
  }
  /**
   * Translates given key to the current language.
   * @param key - Key for the text.
   * @param interpolateParams - Variables for the interpolation.
   * @param lang Language to fetch. Default is the current language.
   * @param templateOnly If true, will fetch the template directly without the interpolation.
   * @returns The translated value in current/given language, potentially interpolated.
   * If none is found...
   *
   * - If the key does not start with "SALAXY." (plain text, not a key), returns the text as-is.
   * - If the Finnish translation is found, returns it. Prefixed with red exclamation mark in test only.
   * - If fi translation not found, returns the key - always prefixed with red exclamation mark (prod and test).
   */
  get(e, t, n, i = !1) {
    let s = this.getWithDefault(e, void 0, n);
    if (!s && e?.startsWith("SALAXY.")) {
      if (n != "fi" && (s = this.getWithDefault(e, void 0, "fi")), !s) {
        const l = e.split(".");
        let o = l[l.length - 1];
        return (o == "label" || o == "description" || o == "title") && l.length > 2 && (o = l[l.length - 2]), "❗" + o;
      }
      pe.current?.isTestData && (s = "❗" + s);
    }
    if (!s)
      return e;
    if (i)
      return s;
    const r = /\{\{\s*(\S+)\s*\}\}/g;
    return s.replace(r, (l, o) => this.readValue(t, o, ""));
  }
  /**
   * Translates given key to the current language with default value.
   * @param key - Key for the text.
   * @param defaultValue - The default value that is returned if the key is not found. Null is the default.
   * @param lang Language to fetch. Default is the current language.
   * @returns The translated value in current language or if none is found the key.
   */
  getWithDefault(e, t = "", n) {
    if (!e)
      return t;
    const i = this.getAny(e, n);
    return i && typeof i == "string" ? i : t;
  }
  /**
   * Gets any object (string or dictionary) with the given property path.
   * @param key Key for the text.
   * @param lang Language to fetch. Default is the current language.
   * @returns The object if found using the key, null if none is found.
   */
  getAny(e, t) {
    if (!e)
      return null;
    const n = e.split(".");
    let i = this.getCurrentDictionary()[t || this.lang];
    for (const s of n)
      if (fe.has(i, s))
        i = i[s];
      else
        return null;
    return i;
  }
  /**
   * Loads a language bundle from the server on-demand.
   * The method will check the loadedLanguages collection, so it will load a language only once => Can be called every time the user language changes.
   * This method is designed to fail outside browser. Browser is recognized based on having globalThis.fetch.
   * The default Finnish dictionary is added added from code lib (not http) unless the Config has the
   * noCache attribute set (used in dev-mode to get the templates and i18n directly from files instead of dist).
   * @param lang Language to load.
   */
  async loadLanguage(e) {
    if (!this.isBrowser()) {
      const n = "Language resources can be loaded on-demand only in browser environments!";
      return console.error(n), Promise.reject(n);
    }
    if (!this.dictionary?.[e]) {
      const n = `Cannot load the requested language (${e}), the language is not supported!`;
      return console.error(n), Promise.reject(n);
    }
    if (this.loadedLanguages.includes(e))
      return Promise.resolve();
    if (e == "fi" && !pe.current?.noCache)
      return this.loadedLanguages.push(e), this.addDictionary(e, ui), Promise.resolve();
    const t = await this.fetchLanguage(e);
    this.loadedLanguages.push(e), this.addDictionary(e, t);
  }
  /**
   * Adds a dictionary. Note that adding is really merge: non-existent keys will not be removed.
   * @param lang - ISO language code for the dictionary to be added: fi, en or sv.
   * @param translations - A translations object (json).
   */
  addDictionary(e, t) {
    const n = {};
    n[e] = t, this.dictionary = this.mergeDeep(this.dictionary, n);
  }
  /**
   * Add all dictionaries from a single language object.
   * Note that adding is really merge: non-existent keys will not be removed.
   * @param translations - A translations object (json).
   * This object must have language codes as first level keys.
   */
  addDictionaries(e) {
    for (const t in e)
      fe.has(e, t) && this.addDictionary(t, e[t]);
  }
  /**
   * Sets a collection of terms (potentially different languages) that can be used in
   * ad-hoc changes of terms or when loading customized texts in service model.
   * @param terms An object with terms in format { [key: string]: string } where key
   * is a full key starting from the language, e.g. "fi.SALAXY.NG1_Sitemap.home"
   * and value is always an indidivual text (never an object).
   */
  setTerms(e) {
    if (e)
      return Object.keys(e).forEach((t) => {
        fe.setProperty(this.dictionary, t, e[t]);
      });
  }
  /**
   * Sets the Salaxy user interface language.
   * @param lang - One of the supported languages: "fi", "en" or "sv".
   */
  setLanguage(e) {
    this.lang = e;
  }
  /**
   * Gets the current user interface language
   * @returns One of the supported languages: "fi", "en" or "sv".
   */
  getLanguage() {
    return this.lang;
  }
  /** Gets the current core dictionary (all languages). */
  getCurrentDictionary() {
    return this.dictionary;
  }
  /**
   * Loads all languages from server using the locales path.
   * @returns The full dictionary (this is not stored to current dictionary - just fetched).
   */
  async getBaseDictionary() {
    const e = [];
    ["fi", "sv", "en"].forEach((i) => {
      e.push(this.fetchLanguage(i));
    });
    const t = await Promise.all(e), n = {};
    return n.fi = t[0], n.sv = t[1], n.en = t[2], n;
  }
  /**
   * Fetches a single language from server language This method fails outside browser.
   * @param lang url param
   * @returns One language as dictionary object (this is not stored to current dictionary - just fetched).
   */
  async fetchLanguage(e) {
    if (this.localesFunc)
      return this.localesFunc(e);
    const t = `${this.localesPath}/${e}.json?t=${(/* @__PURE__ */ new Date()).getTime()}`, n = await fetch(t);
    if (n.ok)
      return await n.json();
    throw new Error(`Unable to fetch language "${t}"`);
  }
  /**
   * Merges objects.
   * @param objects - Objects to merge.
   */
  mergeDeep(...e) {
    const t = (n) => n && typeof n == "object";
    return e.reduce((n, i) => (Object.keys(i).forEach((s) => {
      const r = i[s], l = n[s];
      Array.isArray(l) && Array.isArray(r) ? n[s] = l.concat(...r) : t(l) && t(r) ? n[s] = this.mergeDeep(l, r) : n[s] = r;
    }), n), {});
  }
  readValue(e, t, n) {
    if (!e || !t)
      return n;
    const i = t.split(".");
    let s = e;
    for (const r of i)
      if (fe.has(s, r))
        s = s[r];
      else
        return n;
    return s;
  }
  isBrowser() {
    return typeof globalThis.fetch < "u";
  }
}
const yn = class yn {
  /**
   * Sets the locales path from which the locales will loaded.
   * @param path The path to the directory in wwwroot where locales can be found. Default is "locales".
   */
  static setLocalesPath(e) {
    this.instance.localesPath = e?.replace(/[/]*$/gm, "") || this.instance.localesPath;
  }
  /**
   * Sets the function which is responsible for loading a dictionary for the given language.
   * This is an alternative to the default locales path functionality.
   * @param localesFunc The function that will be called to load the dictionary for the given language.
   */
  static setLocalesFunc(e) {
    this.instance.localesFunc = e;
  }
  /**
   * Translates given key to the current language.
   * @param key - Key for the text.
   * @param interpolateParams - Variables for the interpolation.
   * @param lang Language to fetch. Default is the current language.
   * @param templateOnly If true, will fetch the template directly without the interpolation.
   * @returns The translated value in current/given language, potentially interpolated.
   * If none is found...
   *
   * - If the key does not start with "SALAXY." (plain text, not a key), returns the text as-is.
   * - If the Finnish translation is found, returns it. Prefixed with red exclamation mark in test only.
   * - If fi translation not found, returns the key - always prefixed with red exclamation mark (prod and test).
   */
  static get(e, t, n, i = !1) {
    return this.instance.get(e, t, n, i);
  }
  /**
   * Translates given key to the current language with default value.
   * @param key - Key for the text.
   * @param defaultValue - The default value that is returned if the key is not found. Null is the default.
   * @param lang Language to fetch. Default is the current language.
   * @returns The translated value in current language or if none is found the key.
   */
  static getWithDefault(e, t = "", n) {
    return this.instance.getWithDefault(e, t, n);
  }
  /**
   * Gets any object (string or dictionary) with the given property path.
   * @param key Key for the text.
   * @param lang Language to fetch. Default is the current language.
   * @returns The object if found using the key, null if none is found.
   */
  static getAny(e, t) {
    return this.instance.getAny(e, t);
  }
  /**
   * Loads a language bundle from the server on-demand.
   * The method will check the loadedLanguages collection, so it will load a language only once => Can be called every time the user language changes.
   * This method is designed to fail outside browser. Browser is recognized based on having globalThis.fetch.
   * The default Finnish dictionary is added added from code lib (not http) unless the Config has the
   * noCache attribute set (used in dev-mode to get the templates and i18n directly from files instead of dist).
   * @param lang Language to load.
   */
  static loadLanguage(e) {
    return this.instance.loadLanguage(e);
  }
  /**
   * Adds a dictionary.
   * @param lang - ISO language code for the dictionary to be added: fi, en or sv.
   * @param translations - A translations object (json).
   */
  static addDictionary(e, t) {
    return this.instance.addDictionary(e, t);
  }
  /**
   * Add all dictionaries from a single language object.
   * @param translations - A translations object (json).
   * This object must have language codes as first level keys.
   */
  static addDictionaries(e) {
    return this.instance.addDictionaries(e);
  }
  /**
   * Sets the Salaxy user interface language.
   * @param lang - One of the supported languages: "fi", "en" or "sv".
   */
  static setLanguage(e) {
    return this.instance.setLanguage(e);
  }
  /**
   * Gets the current user interface language
   * @returns One of the supported languages: "fi", "en" or "sv".
   */
  static getLanguage() {
    return this.instance.getLanguage();
  }
};
yn.instance = new fr();
let d = yn;
class Fe {
  /**
   * Searches the income type texts (supportedTypes) using the current language version.
   * Returns all types if the search string is less than 2 chars.
   * @param searchString Search text - will be used as case-insensitive. Will be trimmed. Minimum length 2.
   */
  static search(e) {
    const t = Fe.getAll().filter((n) => n.isSupported);
    return !e || e.trim().length < 2 ? t : (e = e.trim().toLowerCase(), t.filter((n) => n.code.toString().indexOf(e) >= 0 || n.label.toLowerCase().indexOf(e) >= 0));
  }
  /**
   * Gets all codes in Incomes register reporting.
   * This also includes the Salaxy internal codes eg. 1: "Ignored" / "Not reported"
   * For normal language-versioned behavior use cached allTypes field.
   * @param language Language for the label.
   */
  static getAll(e = void 0) {
    return e = e || d.getLanguage() || Ee.Fi, [{
      code: 1,
      label: e === Ee.En ? "No IR reporting" : e === Ee.Sv ? "Ingen IR reporting" : "Ei ilmoiteta tulorekisteriin",
      isNegativeSupported: !0,
      pensionInsurance: !1,
      accidentInsurance: !1,
      unemploymentInsurance: !1,
      healthInsurance: !1,
      insuranceInformationAllowed: !0,
      taxDefault: 0,
      notSupportedError: null,
      description: d.get("SALAXY.CORE.IncomeTypesLogic.incomeTypeMetaData.desription"),
      taxAndSidecostsDescr: d.get("SALAXY.CORE.IncomeTypesLogic.incomeTypeMetaData.taxAndSidecostsDescr"),
      isSupported: !0,
      paymentDefault: 1,
      calcGrouping: "expenses"
    }].concat(this.getOriginal(e));
  }
  /**
   * Gets the original codes in Incomes register.
   * This does not include virtual codes, eg. 1: "Ignored" / "Not reported"
   * For normal language-versioned behavior use cached originalTypes field.
   * @param language Language for the label. Typically use null for automatic language versioning.
   */
  static getOriginal(e = void 0) {
    return yr.map((t) => ({
      code: t.code,
      label: e === Ee.En ? t.nameEn : e === Ee.Sv ? t.nameSv : t.nameFi,
      isNegativeSupported: t.isNegativeSupported,
      pensionInsurance: t.pensionInsurance,
      accidentInsurance: t.accidentInsurance,
      unemploymentInsurance: t.unemploymentInsurance,
      healthInsurance: t.healthInsurance,
      insuranceInformationAllowed: t.insuranceInformationAllowed,
      taxDefault: t.taxDefault,
      notSupportedError: t.notSupportedError,
      description: e === Ee.En ? t.descriptionEn : e === Ee.Sv ? t.descriptionSv : t.descriptionFi,
      taxAndSidecostsDescr: e === Ee.En ? t.taxAndSideCostsDescrEn : e === Ee.Sv ? t.taxAndSideCostsDescrSv : t.taxAndSideCostsDescrFi,
      isSupported: t.isSupported,
      paymentDefault: t.paymentDefault,
      calcGrouping: t.calcGrouping,
      transactionCode: t.transactionCode
    }));
  }
}
const gr = [
  {
    name: "AbcSection",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "doNotShow"
      },
      {
        order: 10,
        name: "employment"
      },
      {
        order: 20,
        name: "insurance"
      },
      {
        order: 30,
        name: "salary"
      },
      {
        order: 40,
        name: "examples"
      },
      {
        order: 50,
        name: "palkkausGeneral"
      },
      {
        order: 60,
        name: "palkkausInstructions"
      },
      {
        order: 100,
        name: "blog"
      },
      {
        order: 110,
        name: "press"
      },
      {
        order: 200,
        name: "personEmployer"
      },
      {
        order: 201,
        name: "householdEmployer"
      },
      {
        order: 210,
        name: "worker"
      },
      {
        order: 211,
        name: "employee"
      },
      {
        order: 220,
        name: "entrepreneur"
      },
      {
        order: 221,
        name: "association"
      },
      {
        order: 222,
        name: "businessOwner"
      },
      {
        order: 301,
        name: "productLongDescription"
      },
      {
        order: 302,
        name: "documentTemplates"
      },
      {
        order: 303,
        name: "instructionsAndExamples"
      }
    ]
  },
  {
    name: "AbsenceCauseCode",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 10,
        name: "unpaidLeave"
      },
      {
        order: 11,
        name: "personalReason"
      },
      {
        order: 1001,
        name: "illness"
      },
      {
        order: 1002,
        name: "partTimeSickLeave"
      },
      {
        order: 1003,
        name: "parentalLeave"
      },
      {
        order: 1004,
        name: "specialMaternityLeave"
      },
      {
        order: 1005,
        name: "rehabilitation"
      },
      {
        order: 1006,
        name: "childIllness"
      },
      {
        order: 1007,
        name: "partTimeChildCareLeave"
      },
      {
        order: 1008,
        name: "training"
      },
      {
        order: 1009,
        name: "jobAlternationLeave"
      },
      {
        order: 1010,
        name: "studyLeave"
      },
      {
        order: 1011,
        name: "industrialAction"
      },
      {
        order: 1012,
        name: "interruptionInWorkProvision"
      },
      {
        order: 1013,
        name: "leaveOfAbsence"
      },
      {
        order: 1014,
        name: "militaryRefresherTraining"
      },
      {
        order: 1015,
        name: "militaryService"
      },
      {
        order: 1016,
        name: "layOff"
      },
      {
        order: 1017,
        name: "childCareLeave"
      },
      {
        order: 1018,
        name: "midWeekHoliday"
      },
      {
        order: 1019,
        name: "accruedHoliday"
      },
      {
        order: 1020,
        name: "occupationalAccident"
      },
      {
        order: 1021,
        name: "annualLeave"
      },
      {
        order: 1022,
        name: "partTimeAbsenceDueToRehabilitation"
      },
      {
        order: 1099,
        name: "other"
      }
    ]
  },
  {
    name: "AccountantType",
    description: null,
    values: [
      {
        order: 0,
        name: "unknown"
      },
      {
        order: 1,
        name: "unlinkedPrimaryPartner"
      },
      {
        order: 2,
        name: "unlinkedAccountingOnly"
      },
      {
        order: 3,
        name: "pendingPrimaryPartner"
      },
      {
        order: 10,
        name: "primaryPartner"
      },
      {
        order: 99,
        name: "none"
      }
    ]
  },
  {
    name: "AccountingChannel",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 2010,
        name: "procountor"
      },
      {
        order: 2020,
        name: "vismaNetvisor"
      },
      {
        order: 2060,
        name: "vismaFivaldi"
      }
    ]
  },
  {
    name: "AccountingPeriodClosingOption",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 1,
        name: "accounting"
      },
      {
        order: 2,
        name: "periodicInvoices"
      },
      {
        order: 3,
        name: "accountingAndPeriodicInvoices"
      },
      {
        order: 4,
        name: "irReports"
      },
      {
        order: 5,
        name: "accountingAndIrReports"
      },
      {
        order: 6,
        name: "periodicInvoicesAndIrReports"
      },
      {
        order: 7,
        name: "accountingAndPeriodicInvoicesAndIrReports"
      }
    ]
  },
  {
    name: "AccountingReportRowType",
    description: null,
    values: [
      {
        order: 0,
        name: "debit"
      },
      {
        order: 1,
        name: "credit"
      },
      {
        order: 2,
        name: "total"
      },
      {
        order: 3,
        name: "groupHeader"
      },
      {
        order: 4,
        name: "groupTotal"
      },
      {
        order: 5,
        name: "childRow"
      }
    ]
  },
  {
    name: "AccountingReportTableType",
    description: null,
    values: [
      {
        order: 0,
        name: "classic"
      },
      {
        order: 1,
        name: "simple"
      },
      {
        order: 2,
        name: "mapped"
      }
    ]
  },
  {
    name: "AccountingTargetStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "ownedTarget"
      },
      {
        order: 2,
        name: "productTarget"
      },
      {
        order: 3,
        name: "sharedTarget"
      }
    ]
  },
  {
    name: "AgeGroupCode",
    description: null,
    values: [
      {
        order: 1,
        name: "a"
      },
      {
        order: 2,
        name: "b"
      },
      {
        order: 3,
        name: "c"
      },
      {
        order: 4,
        name: "u"
      }
    ]
  },
  {
    name: "AgeRange",
    description: null,
    values: [
      {
        order: 0,
        name: "unknown"
      },
      {
        order: 15,
        name: "age_15"
      },
      {
        order: 16,
        name: "age16"
      },
      {
        order: 17,
        name: "age17"
      },
      {
        order: 18,
        name: "age18_52"
      },
      {
        order: 53,
        name: "age53_62"
      },
      {
        order: 63,
        name: "age63_64"
      },
      {
        order: 65,
        name: "age65_67"
      },
      {
        order: 68,
        name: "age68AndOVer"
      }
    ]
  },
  {
    name: "AllowanceCode",
    description: null,
    values: [
      {
        order: 1,
        name: "mealAllowance"
      },
      {
        order: 2,
        name: "partialDailyAllowance"
      },
      {
        order: 3,
        name: "fullDailyAllowance"
      },
      {
        order: 4,
        name: "internationalDailyAllowance"
      },
      {
        order: 5,
        name: "taxExemptReimbursementsAbroad"
      }
    ]
  },
  {
    name: "AnnualLeavePaymentKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "planned"
      },
      {
        order: 101,
        name: "manualSalary"
      },
      {
        order: 102,
        name: "manualCompensation"
      },
      {
        order: 103,
        name: "manualBonus"
      },
      {
        order: 201,
        name: "paidCalc"
      },
      {
        order: 202,
        name: "draftCalc"
      }
    ]
  },
  {
    name: "ApiCheckStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "ignored"
      },
      {
        order: 1,
        name: "success"
      },
      {
        order: 2,
        name: "warning"
      },
      {
        order: 3,
        name: "error"
      }
    ]
  },
  {
    name: "ApiImportStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "ignored"
      },
      {
        order: 1,
        name: "success"
      },
      {
        order: 2,
        name: "warning"
      },
      {
        order: 3,
        name: "error"
      }
    ]
  },
  {
    name: "ApiListItemType",
    description: null,
    values: [
      {
        order: 0,
        name: "unknown"
      },
      {
        order: 10,
        name: "accountBase"
      },
      {
        order: 11,
        name: "companyAccount"
      },
      {
        order: 12,
        name: "personAccount"
      },
      {
        order: 13,
        name: "workerAccount"
      },
      {
        order: 14,
        name: "certificate"
      },
      {
        order: 15,
        name: "sessionUserCredential"
      },
      {
        order: 16,
        name: "onboarding"
      },
      {
        order: 17,
        name: "profile"
      },
      {
        order: 20,
        name: "calculation"
      },
      {
        order: 21,
        name: "calculationPaid"
      },
      {
        order: 22,
        name: "eSalaryPayment"
      },
      {
        order: 23,
        name: "payment"
      },
      {
        order: 24,
        name: "earningsPayment"
      },
      {
        order: 30,
        name: "employment"
      },
      {
        order: 31,
        name: "workerAbsences"
      },
      {
        order: 32,
        name: "holidayYear"
      },
      {
        order: 40,
        name: "taxcard"
      },
      {
        order: 50,
        name: "payrollDetails"
      },
      {
        order: 61,
        name: "invoice"
      },
      {
        order: 62,
        name: "report"
      },
      {
        order: 63,
        name: "blobFile"
      },
      {
        order: 64,
        name: "payerSummary"
      },
      {
        order: 71,
        name: "calendarEvent"
      },
      {
        order: 72,
        name: "usecase"
      },
      {
        order: 73,
        name: "dataset"
      },
      {
        order: 81,
        name: "article"
      },
      {
        order: 82,
        name: "messageThread"
      },
      {
        order: 83,
        name: "emailMessage"
      },
      {
        order: 91,
        name: "accountProducts"
      },
      {
        order: 92,
        name: "varmaPensionOrder"
      },
      {
        order: 93,
        name: "ifInsuranceOrder"
      },
      {
        order: 9999,
        name: "historical"
      }
    ]
  },
  {
    name: "ApiTestErrorType",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 10,
        name: "userFriendly"
      }
    ]
  },
  {
    name: "ApiItemType",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "calculation"
      },
      {
        order: 2,
        name: "calculationPaid"
      },
      {
        order: 5,
        name: "dataset"
      },
      {
        order: 10,
        name: "payrollDetails"
      },
      {
        order: 20,
        name: "invoice"
      },
      {
        order: 30,
        name: "earningsPaymentReport"
      },
      {
        order: 40,
        name: "payerSummaryReport"
      },
      {
        order: 50,
        name: "employment"
      },
      {
        order: 100,
        name: "messageThread"
      },
      {
        order: 110,
        name: "calendarEvent"
      },
      {
        order: 500,
        name: "listItems"
      }
    ]
  },
  {
    name: "ApiValidationErrorType",
    description: null,
    values: [
      {
        order: 0,
        name: "general"
      },
      {
        order: 10,
        name: "required"
      },
      {
        order: 20,
        name: "invalid"
      },
      {
        order: 30,
        name: "warning"
      }
    ]
  },
  {
    name: "AuthenticationMethod",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "emailPwdLocal"
      },
      {
        order: 11,
        name: "facebook"
      },
      {
        order: 12,
        name: "google"
      },
      {
        order: 13,
        name: "microsoft"
      },
      {
        order: 14,
        name: "linkedIn"
      },
      {
        order: 15,
        name: "auth0Database"
      },
      {
        order: 16,
        name: "x509"
      },
      {
        order: 17,
        name: "salaxy"
      },
      {
        order: 18,
        name: "test"
      },
      {
        order: 19,
        name: "webAuthn"
      },
      {
        order: 20,
        name: "microsoftOAuth"
      },
      {
        order: 21,
        name: "googleOAuth"
      },
      {
        order: 1e3,
        name: "internalLocalhost"
      }
    ]
  },
  {
    name: "AuthorizationStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "oK"
      },
      {
        order: -40,
        name: "accessDenied"
      },
      {
        order: -30,
        name: "expiredOauthToken"
      },
      {
        order: -20,
        name: "invalidOAuthToken"
      },
      {
        order: -10,
        name: "noOauthToken"
      }
    ]
  },
  {
    name: "AuthorizationType",
    description: null,
    values: [
      {
        order: 0,
        name: "none"
      },
      {
        order: 1,
        name: "employerAuthorization"
      },
      {
        order: 2,
        name: "workerContract"
      },
      {
        order: 3,
        name: "companyContract"
      },
      {
        order: 4,
        name: "partnerContract"
      },
      {
        order: 100,
        name: "manual"
      },
      {
        order: 999,
        name: "temporary"
      }
    ]
  },
  {
    name: "AvatarPictureType",
    description: null,
    values: [
      {
        order: 0,
        name: "icon"
      },
      {
        order: 1,
        name: "uploaded"
      },
      {
        order: 2,
        name: "gravatar"
      }
    ]
  },
  {
    name: "BankPaymentType",
    description: null,
    values: [
      {
        order: 0,
        name: "unknown"
      },
      {
        order: 1,
        name: "error"
      },
      {
        order: 10,
        name: "paytrailBatch"
      },
      {
        order: 11,
        name: "netvisorPayment"
      },
      {
        order: 20,
        name: "salaryGrossPayment"
      },
      {
        order: 21,
        name: "refundPayment"
      },
      {
        order: 22,
        name: "partialRefundPayment"
      },
      {
        order: 23,
        name: "doubleRefundPayment"
      },
      {
        order: 24,
        name: "transferToEcfaPayment"
      },
      {
        order: 30,
        name: "insuranceGrossPayment"
      },
      {
        order: 50,
        name: "netSalary"
      },
      {
        order: 51,
        name: "salaryAdvance"
      },
      {
        order: 52,
        name: "netSalaryRepayment"
      },
      {
        order: 53,
        name: "netSalaryCorrection"
      },
      {
        order: 100,
        name: "taxAccount"
      },
      {
        order: 200,
        name: "tvr"
      },
      {
        order: 210,
        name: "tvrRfnd"
      },
      {
        order: 300,
        name: "palkkausFees"
      },
      {
        order: 310,
        name: "bankFees"
      },
      {
        order: 320,
        name: "paytrailFees"
      },
      {
        order: 501,
        name: "insuranceLahiTapiola"
      },
      {
        order: 1e3,
        name: "tyel"
      },
      {
        order: 1101,
        name: "tyelEteraContract"
      },
      {
        order: 1102,
        name: "tyelEteraTemp"
      },
      {
        order: 1103,
        name: "tyelEteraUnknown"
      },
      {
        order: 1201,
        name: "tyelEloContract"
      },
      {
        order: 1202,
        name: "tyelEloTemp"
      },
      {
        order: 1203,
        name: "tyelEloInitialImport"
      },
      {
        order: 1301,
        name: "tyelVarmaContract"
      },
      {
        order: 1302,
        name: "tyelVarmaTemp"
      },
      {
        order: 1401,
        name: "tyelIlmarinenContract"
      },
      {
        order: 1402,
        name: "tyelIlmarinenTemp"
      },
      {
        order: 2e3,
        name: "union"
      },
      {
        order: 2001,
        name: "unionRaksa"
      },
      {
        order: 2010,
        name: "foreclosure"
      },
      {
        order: 10001,
        name: "saldoYearBegin"
      },
      {
        order: 10002,
        name: "saldoYearEnd"
      }
    ]
  },
  {
    name: "BenefitCode",
    description: null,
    values: [
      {
        order: 1,
        name: "accommodationBenefit"
      },
      {
        order: 2,
        name: "telephoneBenefit"
      },
      {
        order: 3,
        name: "mealBenefit"
      },
      {
        order: 4,
        name: "otherBenefits"
      }
    ]
  },
  {
    name: "BlobFileType",
    description: null,
    values: [
      {
        order: 0,
        name: "unknown"
      },
      {
        order: 1,
        name: "authorizationPdf"
      },
      {
        order: 2,
        name: "avatar"
      },
      {
        order: 3,
        name: "taxCard"
      },
      {
        order: 4,
        name: "expensesReceipt"
      },
      {
        order: 5,
        name: "raksaloki"
      },
      {
        order: 6,
        name: "template"
      },
      {
        order: 7,
        name: "eInvoice"
      },
      {
        order: 8,
        name: "temporary"
      },
      {
        order: 9,
        name: "settings"
      },
      {
        order: 20,
        name: "messages"
      },
      {
        order: 21,
        name: "record"
      },
      {
        order: 100,
        name: "monthlyReport"
      },
      {
        order: 101,
        name: "yearlyReport"
      },
      {
        order: 102,
        name: "calcReport"
      }
    ]
  },
  {
    name: "BlobRepository",
    description: null,
    values: [
      {
        order: 1,
        name: "userFiles"
      },
      {
        order: 2,
        name: "versionHistory"
      },
      {
        order: 3,
        name: "systemFiles"
      },
      {
        order: 4,
        name: "payload"
      },
      {
        order: 5,
        name: "reports"
      },
      {
        order: 6,
        name: "cdnImages"
      },
      {
        order: 7,
        name: "iam"
      },
      {
        order: 100,
        name: "gitContent"
      },
      {
        order: 200,
        name: "fileSystemContent"
      }
    ]
  },
  {
    name: "BootstrapStyle",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 1,
        name: "primary"
      },
      {
        order: 2,
        name: "success"
      },
      {
        order: 3,
        name: "info"
      },
      {
        order: 4,
        name: "warning"
      },
      {
        order: 5,
        name: "danger"
      }
    ]
  },
  {
    name: "CalcGroup",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "baseSalary"
      },
      {
        order: 2,
        name: "salaryAdditions"
      },
      {
        order: 3,
        name: "benefits"
      },
      {
        order: 4,
        name: "expenses"
      },
      {
        order: 5,
        name: "deductions"
      },
      {
        order: 6,
        name: "otherNoPayment"
      },
      {
        order: 100,
        name: "totals"
      },
      {
        order: 200,
        name: "disabled"
      }
    ]
  },
  {
    name: "CalculationFlag",
    description: null,
    values: [
      {
        order: 0,
        name: "exclude"
      },
      {
        order: 1,
        name: "pensionInsurance"
      },
      {
        order: 2,
        name: "accidentInsurance"
      },
      {
        order: 3,
        name: "unemploymentInsurance"
      },
      {
        order: 4,
        name: "healthInsurance"
      },
      {
        order: 10,
        name: "insurancesDeduction"
      },
      {
        order: 100,
        name: "noTax"
      },
      {
        order: 101,
        name: "tax"
      },
      {
        order: 102,
        name: "taxDeduction"
      },
      {
        order: 200,
        name: "cfNoPayment"
      },
      {
        order: 201,
        name: "cfPayment"
      },
      {
        order: 202,
        name: "cfDeduction"
      },
      {
        order: 203,
        name: "cfDeductionAtSalaxy"
      }
    ]
  },
  {
    name: "CalculationRefresh",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 1,
        name: "worker"
      },
      {
        order: 2,
        name: "employer"
      },
      {
        order: 3,
        name: "employment"
      },
      {
        order: 4,
        name: "taxcard"
      },
      {
        order: 5,
        name: "insurances"
      }
    ]
  },
  {
    name: "CalculationResultRowType",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "totalBenefits"
      },
      {
        order: 2,
        name: "totalExpenses"
      },
      {
        order: 3,
        name: "totalSocialSecurityEmployer"
      },
      {
        order: 4,
        name: "totalSocialSecurityEmployerDebt"
      },
      {
        order: 5,
        name: "totalSocialSecurityEmployerPayment"
      },
      {
        order: 6,
        name: "totalPension"
      },
      {
        order: 7,
        name: "totalPensionPayment"
      },
      {
        order: 8,
        name: "totalPensionEmployer"
      },
      {
        order: 9,
        name: "totalPensionEmployerDebt"
      },
      {
        order: 10,
        name: "totalPensionWorker"
      },
      {
        order: 11,
        name: "totalUnemployment"
      },
      {
        order: 12,
        name: "totalUnemploymentPayment"
      },
      {
        order: 13,
        name: "totalUnemploymentEmployer"
      },
      {
        order: 14,
        name: "totalUnemploymentEmployerDebt"
      },
      {
        order: 15,
        name: "totalUnemploymentWorker"
      },
      {
        order: 16,
        name: "totalPalkkaus"
      },
      {
        order: 17,
        name: "totalSalary"
      },
      {
        order: 18,
        name: "totalTax"
      },
      {
        order: 19,
        name: "totalTaxPayment"
      },
      {
        order: 20,
        name: "totalPayment"
      },
      {
        order: 21,
        name: "totalWorkerPayment"
      },
      {
        order: 22,
        name: "totalService"
      }
    ]
  },
  {
    name: "CalculationRowSource",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "disabled"
      },
      {
        order: 2,
        name: "manualRow"
      },
      {
        order: 100,
        name: "worktimeImport"
      },
      {
        order: 200,
        name: "priceEmployment"
      },
      {
        order: 201,
        name: "priceCompany"
      },
      {
        order: 210,
        name: "copyEmployment"
      },
      {
        order: 211,
        name: "copyCompany"
      },
      {
        order: 300,
        name: "customRowtype"
      }
    ]
  },
  {
    name: "CalculationRowType",
    description: null,
    values: [
      {
        order: 0,
        name: "unknown"
      },
      {
        order: 1,
        name: "salary"
      },
      {
        order: 2,
        name: "hourlySalary"
      },
      {
        order: 3,
        name: "monthlySalary"
      },
      {
        order: 4,
        name: "totalWorkerPayment"
      },
      {
        order: 5,
        name: "totalEmployerPayment"
      },
      {
        order: 9,
        name: "compensation"
      },
      {
        order: 10,
        name: "overtime"
      },
      {
        order: 11,
        name: "tesWorktimeShortening"
      },
      {
        order: 12,
        name: "eveningAddition"
      },
      {
        order: 13,
        name: "nightimeAddition"
      },
      {
        order: 14,
        name: "saturdayAddition"
      },
      {
        order: 15,
        name: "sundayWork"
      },
      {
        order: 19,
        name: "otherAdditions"
      },
      {
        order: 31,
        name: "paidSickLeaveSalary"
      },
      {
        order: 32,
        name: "paidSickLeaveHourlySalary"
      },
      {
        order: 33,
        name: "paidSickLeaveMonthlySalary"
      },
      {
        order: 34,
        name: "trainingSalary"
      },
      {
        order: 35,
        name: "trainingHourlySalary"
      },
      {
        order: 36,
        name: "trainingMonthlySalary"
      },
      {
        order: 101,
        name: "accomodationBenefit"
      },
      {
        order: 102,
        name: "mealBenefit"
      },
      {
        order: 103,
        name: "phoneBenefit"
      },
      {
        order: 104,
        name: "carBenefit"
      },
      {
        order: 105,
        name: "bicycleBenefit"
      },
      {
        order: 199,
        name: "otherBenefit"
      },
      {
        order: 201,
        name: "holidayCompensation"
      },
      {
        order: 202,
        name: "holidayBonus"
      },
      {
        order: 203,
        name: "holidaySalary"
      },
      {
        order: 301,
        name: "dailyAllowance"
      },
      {
        order: 302,
        name: "dailyAllowanceHalf"
      },
      {
        order: 303,
        name: "mealCompensation"
      },
      {
        order: 304,
        name: "milageOwnCar"
      },
      {
        order: 305,
        name: "toolCompensation"
      },
      {
        order: 306,
        name: "expenses"
      },
      {
        order: 307,
        name: "milageDaily"
      },
      {
        order: 308,
        name: "milageOther"
      },
      {
        order: 401,
        name: "unionPayment"
      },
      {
        order: 402,
        name: "foreclosure"
      },
      {
        order: 403,
        name: "advance"
      },
      {
        order: 404,
        name: "foreclosureByPalkkaus"
      },
      {
        order: 405,
        name: "prepaidExpenses"
      },
      {
        order: 406,
        name: "otherDeductions"
      },
      {
        order: 407,
        name: "deductibleOfExerciseAndCultureBenefit"
      },
      {
        order: 901,
        name: "childCareSubsidy"
      },
      {
        order: 902,
        name: "chainsawReduction"
      },
      {
        order: 1010,
        name: "nonProfitOrg"
      },
      {
        order: 1020,
        name: "subsidisedCommute"
      },
      {
        order: 1030,
        name: "irIncomeType"
      },
      {
        order: 1040,
        name: "board"
      },
      {
        order: 1050,
        name: "remuneration"
      },
      {
        order: 1060,
        name: "otherCompensation"
      },
      {
        order: 1070,
        name: "workingTimeCompensation"
      },
      {
        order: 1080,
        name: "employmentTermination"
      },
      {
        order: 1090,
        name: "hourlySalaryWithWorkingTimeCompensation"
      },
      {
        order: 1100,
        name: "paidSickLeave"
      },
      {
        order: 1110,
        name: "training"
      },
      {
        order: 2010,
        name: "taxAtSource"
      },
      {
        order: 2011,
        name: "taxWithholding"
      },
      {
        order: 3e3,
        name: "absencePeriod"
      },
      {
        order: 8e3,
        name: "serviceCharge"
      },
      {
        order: 8001,
        name: "service"
      },
      {
        order: 9999,
        name: "totals"
      }
    ]
  },
  {
    name: "CalculationRowUnit",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "count"
      },
      {
        order: 2,
        name: "percent"
      },
      {
        order: 3,
        name: "days"
      },
      {
        order: 4,
        name: "kilometers"
      },
      {
        order: 5,
        name: "hours"
      }
    ]
  },
  {
    name: "CalculationStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "draft"
      },
      {
        order: 1,
        name: "paymentStarted"
      },
      {
        order: 2,
        name: "paymentSucceeded"
      },
      {
        order: 3,
        name: "paymentCanceled"
      },
      {
        order: 4,
        name: "paymentError"
      },
      {
        order: 5,
        name: "paymentWorkerCopy"
      },
      {
        order: 6,
        name: "workerRequested"
      },
      {
        order: 7,
        name: "workerRequestAccepted"
      },
      {
        order: 8,
        name: "workerRequestDeclined"
      },
      {
        order: 9,
        name: "paymentRefunded"
      },
      {
        order: 10,
        name: "paymentRepaired"
      },
      {
        order: 100,
        name: "waitingApproval"
      },
      {
        order: 200,
        name: "payrollDraft"
      },
      {
        order: 210,
        name: "repair"
      },
      {
        order: 220,
        name: "proDraft"
      },
      {
        order: 300,
        name: "sharedWaiting"
      },
      {
        order: 310,
        name: "sharedApproved"
      },
      {
        order: 320,
        name: "sharedRejected"
      },
      {
        order: 400,
        name: "history"
      },
      {
        order: 1e3,
        name: "template"
      }
    ]
  },
  {
    name: "CalculationStatusCategory",
    description: null,
    values: [
      {
        order: 0,
        name: "all"
      },
      {
        order: 1,
        name: "readonly"
      },
      {
        order: 2,
        name: "editable"
      },
      {
        order: 3,
        name: "sent"
      },
      {
        order: 4,
        name: "shared"
      },
      {
        order: 5,
        name: "received"
      },
      {
        order: 6,
        name: "error"
      }
    ]
  },
  {
    name: "CalendarActionType",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "display"
      },
      {
        order: 2,
        name: "email"
      },
      {
        order: 3,
        name: "audio"
      },
      {
        order: 10,
        name: "createItem"
      },
      {
        order: 11,
        name: "script"
      },
      {
        order: 20,
        name: "paymentDate"
      }
    ]
  },
  {
    name: "CalendarEventStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 100,
        name: "cancelled"
      },
      {
        order: 101,
        name: "confirmed"
      },
      {
        order: 102,
        name: "tentative"
      },
      {
        order: 111,
        name: "needsAction"
      },
      {
        order: 112,
        name: "completed"
      },
      {
        order: 113,
        name: "inProcess"
      }
    ]
  },
  {
    name: "CarBenefitCode",
    description: null,
    values: [
      {
        order: 1,
        name: "limitedCarBenefit"
      },
      {
        order: 2,
        name: "fullCarBenefit"
      }
    ]
  },
  {
    name: "CompanyType",
    description: null,
    values: [
      {
        order: 0,
        name: "unknown"
      },
      {
        order: 100,
        name: "fiOy"
      },
      {
        order: 101,
        name: "fiTm"
      },
      {
        order: 102,
        name: "fiRy"
      },
      {
        order: 103,
        name: "fiYy"
      }
    ]
  },
  {
    name: "ContractPartyType",
    description: null,
    values: [
      {
        order: 0,
        name: "person"
      },
      {
        order: 1,
        name: "customContact"
      }
    ]
  },
  {
    name: "ContactType",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 1,
        name: "workerAccount"
      },
      {
        order: 2,
        name: "employerOverride"
      },
      {
        order: 11,
        name: "foreign"
      }
    ]
  },
  {
    name: "CostAccountingDimensionScope",
    description: null,
    values: [
      {
        order: 0,
        name: "none"
      },
      {
        order: 1,
        name: "calculation"
      },
      {
        order: 2,
        name: "row"
      },
      {
        order: 999,
        name: "hidden"
      }
    ]
  },
  {
    name: "Country",
    description: null,
    values: [
      {
        order: 0,
        name: "fi"
      },
      {
        order: 1,
        name: "ae"
      },
      {
        order: 2,
        name: "at"
      },
      {
        order: 3,
        name: "ba"
      },
      {
        order: 4,
        name: "bg"
      },
      {
        order: 5,
        name: "by"
      },
      {
        order: 6,
        name: "cn"
      },
      {
        order: 7,
        name: "de"
      },
      {
        order: 8,
        name: "eg"
      },
      {
        order: 9,
        name: "fr"
      },
      {
        order: 10,
        name: "gg"
      },
      {
        order: 11,
        name: "hr"
      },
      {
        order: 12,
        name: "ie"
      },
      {
        order: 13,
        name: "in"
      },
      {
        order: 14,
        name: "je"
      },
      {
        order: 15,
        name: "kr"
      },
      {
        order: 16,
        name: "lk"
      },
      {
        order: 17,
        name: "lv"
      },
      {
        order: 18,
        name: "me"
      },
      {
        order: 19,
        name: "mx"
      },
      {
        order: 20,
        name: "no"
      },
      {
        order: 21,
        name: "pk"
      },
      {
        order: 22,
        name: "rs"
      },
      {
        order: 23,
        name: "sg"
      },
      {
        order: 24,
        name: "th"
      },
      {
        order: 25,
        name: "tr"
      },
      {
        order: 26,
        name: "us"
      },
      {
        order: 27,
        name: "vg"
      },
      {
        order: 28,
        name: "zm"
      },
      {
        order: 29,
        name: "am"
      },
      {
        order: 30,
        name: "au"
      },
      {
        order: 31,
        name: "bb"
      },
      {
        order: 32,
        name: "bm"
      },
      {
        order: 33,
        name: "ca"
      },
      {
        order: 34,
        name: "cy"
      },
      {
        order: 35,
        name: "dk"
      },
      {
        order: 36,
        name: "es"
      },
      {
        order: 37,
        name: "gb"
      },
      {
        order: 38,
        name: "gr"
      },
      {
        order: 39,
        name: "hu"
      },
      {
        order: 40,
        name: "il"
      },
      {
        order: 41,
        name: "is"
      },
      {
        order: 42,
        name: "jp"
      },
      {
        order: 43,
        name: "ky"
      },
      {
        order: 44,
        name: "lt"
      },
      {
        order: 45,
        name: "ma"
      },
      {
        order: 46,
        name: "mk"
      },
      {
        order: 47,
        name: "my"
      },
      {
        order: 48,
        name: "nz"
      },
      {
        order: 49,
        name: "pl"
      },
      {
        order: 50,
        name: "ru"
      },
      {
        order: 51,
        name: "si"
      },
      {
        order: 52,
        name: "tj"
      },
      {
        order: 53,
        name: "tz"
      },
      {
        order: 54,
        name: "uy"
      },
      {
        order: 55,
        name: "vn"
      },
      {
        order: 56,
        name: "ar"
      },
      {
        order: 57,
        name: "az"
      },
      {
        order: 58,
        name: "be"
      },
      {
        order: 59,
        name: "br"
      },
      {
        order: 60,
        name: "ch"
      },
      {
        order: 61,
        name: "cz"
      },
      {
        order: 62,
        name: "ee"
      },
      {
        order: 63,
        name: "ge"
      },
      {
        order: 64,
        name: "hk"
      },
      {
        order: 65,
        name: "id"
      },
      {
        order: 66,
        name: "im"
      },
      {
        order: 67,
        name: "it"
      },
      {
        order: 68,
        name: "kg"
      },
      {
        order: 69,
        name: "kz"
      },
      {
        order: 70,
        name: "lu"
      },
      {
        order: 71,
        name: "md"
      },
      {
        order: 72,
        name: "mt"
      },
      {
        order: 73,
        name: "nl"
      },
      {
        order: 74,
        name: "ph"
      },
      {
        order: 75,
        name: "ro"
      },
      {
        order: 76,
        name: "se"
      },
      {
        order: 77,
        name: "sk"
      },
      {
        order: 78,
        name: "tm"
      },
      {
        order: 79,
        name: "ua"
      },
      {
        order: 80,
        name: "uz"
      },
      {
        order: 81,
        name: "za"
      },
      {
        order: 82,
        name: "other"
      }
    ]
  },
  {
    name: "CustomerInvoiceStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 20,
        name: "forecast"
      },
      {
        order: 30,
        name: "preview"
      },
      {
        order: 50,
        name: "waitingPalkkaus"
      },
      {
        order: 100,
        name: "unread"
      },
      {
        order: 110,
        name: "read"
      },
      {
        order: 130,
        name: "paymentStarted"
      },
      {
        order: 135,
        name: "warning"
      },
      {
        order: 140,
        name: "paid"
      },
      {
        order: 150,
        name: "canceled"
      },
      {
        order: 160,
        name: "error"
      }
    ]
  },
  {
    name: "CustomerWebApp",
    description: null,
    values: [
      {
        order: 0,
        name: "palkkaus"
      },
      {
        order: 1,
        name: "customSso"
      },
      {
        order: 2,
        name: "customPalkkaus"
      },
      {
        order: 999,
        name: "noCustomerUi"
      }
    ]
  },
  {
    name: "EarningsPaymentReportStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "new"
      },
      {
        order: 1,
        name: "scheduled"
      },
      {
        order: 2,
        name: "succeeded"
      },
      {
        order: 3,
        name: "canceled"
      },
      {
        order: 4,
        name: "error"
      },
      {
        order: 5,
        name: "invalid"
      }
    ]
  },
  {
    name: "EmploymentRelationSalaryPaymentMethod",
    description: null,
    values: [
      {
        order: 0,
        name: "bankAccount"
      },
      {
        order: 1,
        name: "external"
      }
    ]
  },
  {
    name: "EmploymentRelationStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "unknown"
      },
      {
        order: 1,
        name: "primary"
      },
      {
        order: 2,
        name: "secondaryCurrent"
      },
      {
        order: 100,
        name: "archived"
      }
    ]
  },
  {
    name: "EmploymentRelationTaxcard",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "auto"
      },
      {
        order: 2,
        name: "manual"
      },
      {
        order: 3,
        name: "noTaxCard"
      },
      {
        order: 11,
        name: "taxAtSource"
      }
    ]
  },
  {
    name: "EmploymentRelationType",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "salary"
      },
      {
        order: 2,
        name: "hourlySalary"
      },
      {
        order: 3,
        name: "monthlySalary"
      },
      {
        order: 100,
        name: "compensation"
      },
      {
        order: 101,
        name: "boardMember"
      },
      {
        order: 200,
        name: "entrepreneur"
      },
      {
        order: 201,
        name: "farmer"
      },
      {
        order: 301,
        name: "employedByStateEmploymentFund"
      },
      {
        order: 308,
        name: "athlete"
      },
      {
        order: 309,
        name: "performingArtist"
      },
      {
        order: 401,
        name: "foreignWorker"
      },
      {
        order: 402,
        name: "workingAbroad"
      }
    ]
  },
  {
    name: "ExportMethod",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "fileExcel"
      },
      {
        order: 2,
        name: "fileCsv"
      },
      {
        order: 3,
        name: "filePdf"
      },
      {
        order: 4,
        name: "fileText"
      },
      {
        order: 101,
        name: "copyExcel"
      },
      {
        order: 102,
        name: "copyCsv"
      },
      {
        order: 104,
        name: "copyText"
      },
      {
        order: 200,
        name: "paymentChannel"
      },
      {
        order: 201,
        name: "api"
      }
    ]
  },
  {
    name: "DatasetStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "draft"
      },
      {
        order: 1,
        name: "instance"
      },
      {
        order: 1e3,
        name: "template"
      }
    ]
  },
  {
    name: "DatasetType",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "reportAdHoc"
      },
      {
        order: 11,
        name: "import"
      },
      {
        order: 21,
        name: "export"
      },
      {
        order: 31,
        name: "batch"
      }
    ]
  },
  {
    name: "DateOfBirthAccuracy",
    description: null,
    values: [
      {
        order: 0,
        name: "assumption"
      },
      {
        order: 1,
        name: "ageBased"
      },
      {
        order: 2,
        name: "ageGroupBased"
      },
      {
        order: 3,
        name: "monthCorrect"
      },
      {
        order: 10,
        name: "exact"
      },
      {
        order: 20,
        name: "verified"
      }
    ]
  },
  {
    name: "FrameworkAgreement",
    description: null,
    values: [
      {
        order: 0,
        name: "notDefined"
      },
      {
        order: 1,
        name: "construction"
      },
      {
        order: 3,
        name: "mll"
      },
      {
        order: 4,
        name: "childCare"
      },
      {
        order: 8,
        name: "cleaning"
      },
      {
        order: 10,
        name: "santaClaus"
      },
      {
        order: 1e3,
        name: "entrepreneur"
      },
      {
        order: 9999,
        name: "other"
      }
    ]
  },
  {
    name: "Gender",
    description: null,
    values: [
      {
        order: 0,
        name: "unknown"
      },
      {
        order: 1,
        name: "male"
      },
      {
        order: 2,
        name: "female"
      }
    ]
  },
  {
    name: "HelttiIndustry",
    description: null,
    values: [
      {
        order: 0,
        name: "notDefined"
      },
      {
        order: 100,
        name: "i"
      },
      {
        order: 110,
        name: "j"
      },
      {
        order: 120,
        name: "k"
      },
      {
        order: 140,
        name: "m"
      },
      {
        order: 160,
        name: "o"
      },
      {
        order: 170,
        name: "n"
      },
      {
        order: 170,
        name: "n"
      },
      {
        order: 180,
        name: "q"
      },
      {
        order: 190,
        name: "r"
      },
      {
        order: 200,
        name: "s"
      },
      {
        order: 999,
        name: "other"
      }
    ]
  },
  {
    name: "HelttiProductPackage",
    description: null,
    values: [
      {
        order: 0,
        name: "notDefined"
      },
      {
        order: 10,
        name: "small"
      },
      {
        order: 20,
        name: "medium"
      },
      {
        order: 30,
        name: "large"
      }
    ]
  },
  {
    name: "IncomeEarnerType",
    description: null,
    values: [
      {
        order: 1,
        name: "employedByStateEmploymentFund"
      },
      {
        order: 2,
        name: "jointOwnerWithPayer"
      },
      {
        order: 3,
        name: "partialOwner"
      },
      {
        order: 4,
        name: "keyEmployee"
      },
      {
        order: 5,
        name: "leasedEmployeeLivingAbroad"
      },
      {
        order: 6,
        name: "personWorkingInFrontierDistrict"
      },
      {
        order: 7,
        name: "personWorkingAbroad"
      },
      {
        order: 8,
        name: "athlete"
      },
      {
        order: 9,
        name: "performingArtist"
      },
      {
        order: 10,
        name: "restrictedPeriodInFinland"
      },
      {
        order: 11,
        name: "netOfTaxContract"
      },
      {
        order: 12,
        name: "organization"
      },
      {
        order: 13,
        name: "personWorkingOnAlandFerry"
      },
      {
        order: 14,
        name: "entrepreneurOrFarmerNoPensionRequired"
      },
      {
        order: 15,
        name: "dimplomaticMission"
      },
      {
        order: 16,
        name: "eppo"
      },
      {
        order: 17,
        name: "lightEntrepreneur"
      }
    ]
  },
  {
    name: "IncomeLogDiff",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 1,
        name: "new"
      },
      {
        order: 2,
        name: "changed"
      },
      {
        order: 3,
        name: "removed"
      }
    ]
  },
  {
    name: "InternationalIdentifier",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 5,
        name: "taxIdentificationNumber"
      },
      {
        order: 9,
        name: "foreignPersonalIdentificationNumber"
      },
      {
        order: 99,
        name: "other"
      }
    ]
  },
  {
    name: "InvoiceStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 20,
        name: "forecast"
      },
      {
        order: 30,
        name: "preview"
      },
      {
        order: 50,
        name: "waitingPalkkaus"
      },
      {
        order: 100,
        name: "unread"
      },
      {
        order: 110,
        name: "read"
      },
      {
        order: 120,
        name: "waitingConfirmation"
      },
      {
        order: 130,
        name: "paymentStarted"
      },
      {
        order: 135,
        name: "warning"
      },
      {
        order: 140,
        name: "paid"
      },
      {
        order: 150,
        name: "canceled"
      },
      {
        order: 160,
        name: "error"
      }
    ]
  },
  {
    name: "InvoiceType",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 100,
        name: "net"
      },
      {
        order: 110,
        name: "tax"
      },
      {
        order: 111,
        name: "taxWithholding"
      },
      {
        order: 112,
        name: "taxSocialSecurity"
      },
      {
        order: 113,
        name: "taxAtSource"
      },
      {
        order: 120,
        name: "unemployment"
      },
      {
        order: 130,
        name: "pension"
      },
      {
        order: 140,
        name: "union"
      },
      {
        order: 150,
        name: "foreclosure"
      },
      {
        order: 160,
        name: "payroll"
      },
      {
        order: 170,
        name: "service"
      },
      {
        order: 180,
        name: "fee"
      },
      {
        order: 200,
        name: "gross"
      },
      {
        order: 300,
        name: "verification"
      }
    ]
  },
  {
    name: "Holiday",
    description: null,
    values: [
      {
        order: 0,
        name: "newYearsDay"
      },
      {
        order: 1,
        name: "epiphany"
      },
      {
        order: 2,
        name: "goodFriday"
      },
      {
        order: 3,
        name: "easterSunday"
      },
      {
        order: 4,
        name: "easterSaturday"
      },
      {
        order: 5,
        name: "easterMonday"
      },
      {
        order: 6,
        name: "mayDay"
      },
      {
        order: 7,
        name: "ascensionDay"
      },
      {
        order: 8,
        name: "pentecost"
      },
      {
        order: 9,
        name: "midsummerEve"
      },
      {
        order: 10,
        name: "midsummerDay"
      },
      {
        order: 11,
        name: "allSaintsDay"
      },
      {
        order: 12,
        name: "independenceDay"
      },
      {
        order: 13,
        name: "christmasEve"
      },
      {
        order: 14,
        name: "christmasDay"
      },
      {
        order: 15,
        name: "stStephensDay"
      }
    ]
  },
  {
    name: "HolidayAccrualSource",
    description: null,
    values: [
      {
        order: 0,
        name: "initial"
      },
      {
        order: 1,
        name: "manual"
      },
      {
        order: 10,
        name: "calcDraft"
      },
      {
        order: 11,
        name: "calcPaid"
      }
    ]
  },
  {
    name: "HolidayBonusPaymentMethod",
    description: null,
    values: [
      {
        order: 0,
        name: "none"
      },
      {
        order: 1,
        name: "payForHolidaySalary"
      },
      {
        order: 2,
        name: "paySummerBonus"
      },
      {
        order: 3,
        name: "paySelectedDays"
      },
      {
        order: 24,
        name: "pay24Days"
      },
      {
        order: 100,
        name: "payAllBonus"
      }
    ]
  },
  {
    name: "HolidayCode",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 10,
        name: "permanent14Days"
      },
      {
        order: 11,
        name: "permanent35Hours"
      },
      {
        order: 20,
        name: "temporaryTimeOff"
      },
      {
        order: 21,
        name: "holidayCompensation"
      },
      {
        order: 22,
        name: "holidayCompensationIncluded"
      },
      {
        order: 99,
        name: "noHolidays"
      },
      {
        order: 100,
        name: "other"
      }
    ]
  },
  {
    name: "HolidayGroup",
    description: null,
    values: [
      {
        order: 1,
        name: "official"
      },
      {
        order: 2,
        name: "nonBanking"
      },
      {
        order: 4,
        name: "holiday"
      }
    ]
  },
  {
    name: "HolidayPayCalculation",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "normalMonthlyPay"
      },
      {
        order: 2,
        name: "averageDailyPay"
      },
      {
        order: 3,
        name: "percentageBasedPay"
      },
      {
        order: 4,
        name: "averageHourlyPay"
      },
      {
        order: 5,
        name: "holidayCompensation"
      },
      {
        order: 100,
        name: "otherPay"
      }
    ]
  },
  {
    name: "HouseholdYearProcessingStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "open"
      },
      {
        order: 100,
        name: "closed"
      },
      {
        order: 200,
        name: "printed"
      }
    ]
  },
  {
    name: "HouseholdYearStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "ok"
      },
      {
        order: 2,
        name: "okWithModifications"
      },
      {
        order: 3,
        name: "willHandleMyself"
      }
    ]
  },
  {
    name: "InsuranceCompany",
    description: null,
    values: [
      {
        order: 0,
        name: "none"
      },
      {
        order: 1,
        name: "lähiTapiola"
      },
      {
        order: 2,
        name: "pohjola"
      },
      {
        order: 3,
        name: "if"
      },
      {
        order: 4,
        name: "fennia"
      },
      {
        order: 5,
        name: "aVakuutus"
      },
      {
        order: 6,
        name: "aktia"
      },
      {
        order: 7,
        name: "pohjantähti"
      },
      {
        order: 8,
        name: "tryg"
      },
      {
        order: 9,
        name: "ålands"
      },
      {
        order: 10,
        name: "turva"
      },
      {
        order: 11,
        name: "redarnas"
      },
      {
        order: 12,
        name: "folksam"
      },
      {
        order: 13,
        name: "alandia"
      },
      {
        order: 14,
        name: "protector"
      },
      {
        order: 999999,
        name: "other"
      },
      {
        order: 1e6,
        name: "pending"
      }
    ]
  },
  {
    name: "InternationalSocialSecurityException",
    description: null,
    values: [
      {
        order: 7,
        name: "notSubjectToEarningsRelatedPensionInsurance"
      },
      {
        order: 8,
        name: "notSubjectToAccidentAndOccupationalDiseaseInsurance"
      },
      {
        order: 9,
        name: "notSubjectToUnemploymentInsurance"
      },
      {
        order: 10,
        name: "notSubjectToHealthInsurance"
      },
      {
        order: 11,
        name: "voluntaryEarningsRelatedPensionInsurance"
      },
      {
        order: 100,
        name: "noObligationToHealthInsuranceDailyAllowanceContribution"
      }
    ]
  },
  {
    name: "InternationalSocialSecurityType",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 1,
        name: "foreign"
      },
      {
        order: 3,
        name: "mixed"
      }
    ]
  },
  {
    name: "InvoiceDateKind",
    description: null,
    values: [
      {
        order: 0,
        name: "invoiceDate"
      },
      {
        order: 1,
        name: "dueDate"
      },
      {
        order: 2,
        name: "logicalDate"
      }
    ]
  },
  {
    name: "InvoicePaymentType",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 1,
        name: "salary"
      },
      {
        order: 2,
        name: "salaryInPast"
      }
    ]
  },
  {
    name: "IrFlags",
    description: null,
    values: [
      {
        order: 10,
        name: "noMoney"
      },
      {
        order: 20,
        name: "oneOff"
      },
      {
        order: 30,
        name: "unjustEnrichment"
      }
    ]
  },
  {
    name: "IrInsuranceExceptions",
    description: null,
    values: [
      {
        order: 501,
        name: "includeAll"
      },
      {
        order: 502,
        name: "includePension"
      },
      {
        order: 503,
        name: "includeHealthInsurance"
      },
      {
        order: 505,
        name: "includeUnemployment"
      },
      {
        order: 506,
        name: "includeAccidentInsurance"
      },
      {
        order: 601,
        name: "excludeAll"
      },
      {
        order: 602,
        name: "excludePension"
      },
      {
        order: 603,
        name: "excludeHealthInsurance"
      },
      {
        order: 605,
        name: "excludeUnemployment"
      },
      {
        order: 606,
        name: "excludeAccidentInsurance"
      }
    ]
  },
  {
    name: "IrRowSourceType",
    description: null,
    values: [
      {
        order: 0,
        name: "manual"
      },
      {
        order: 1,
        name: "usecase"
      },
      {
        order: 2,
        name: "usecaseV02"
      }
    ]
  },
  {
    name: "Language",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 1,
        name: "fi"
      },
      {
        order: 2,
        name: "sv"
      },
      {
        order: 3,
        name: "en"
      }
    ]
  },
  {
    name: "LegalEntityType",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "person"
      },
      {
        order: 2,
        name: "company"
      },
      {
        order: 3,
        name: "personCreatedByEmployer"
      },
      {
        order: 4,
        name: "partner"
      }
    ]
  },
  {
    name: "LocalTapiolaInsuranceOrderAuthorizationType",
    description: null,
    values: [
      {
        order: 0,
        name: "procuration"
      },
      {
        order: 1,
        name: "powerOfAttorney"
      },
      {
        order: 2,
        name: "apparentAuthority"
      },
      {
        order: 3,
        name: "other"
      }
    ]
  },
  {
    name: "LocalTapiolaInsuranceOrderStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "draft"
      },
      {
        order: 1,
        name: "waitingApproval"
      },
      {
        order: 2,
        name: "checked"
      },
      {
        order: 3,
        name: "sent"
      },
      {
        order: 4,
        name: "handled"
      },
      {
        order: 5,
        name: "canceled"
      }
    ]
  },
  {
    name: "LocalTapiolaInsuranceOrderType",
    description: null,
    values: [
      {
        order: 0,
        name: "newWorkerInsurance"
      },
      {
        order: 1,
        name: "moveWorkerInsurance"
      },
      {
        order: 2,
        name: "newEntrepreneurInsurance"
      },
      {
        order: 3,
        name: "moveEntrepreneurInsurance"
      },
      {
        order: 4,
        name: "other"
      }
    ]
  },
  {
    name: "MessageFrom",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 10,
        name: "owner"
      },
      {
        order: 20,
        name: "otherParty"
      },
      {
        order: 90,
        name: "system"
      }
    ]
  },
  {
    name: "MessageThreadStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "draft"
      },
      {
        order: 1,
        name: "active"
      },
      {
        order: 21,
        name: "approved"
      },
      {
        order: 22,
        name: "rejected"
      },
      {
        order: 100,
        name: "archived"
      },
      {
        order: 1e3,
        name: "template"
      }
    ]
  },
  {
    name: "MessageType",
    description: null,
    values: [
      {
        order: 0,
        name: "email"
      },
      {
        order: 1,
        name: "sms"
      }
    ]
  },
  {
    name: "OnboardingStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "created"
      },
      {
        order: 10,
        name: "open"
      },
      {
        order: 20,
        name: "error"
      },
      {
        order: 30,
        name: "cancel"
      },
      {
        order: 100,
        name: "done"
      },
      {
        order: 110,
        name: "expired"
      }
    ]
  },
  {
    name: "PayerSummaryReportStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "new"
      },
      {
        order: 1,
        name: "scheduled"
      },
      {
        order: 2,
        name: "succeeded"
      },
      {
        order: 3,
        name: "canceled"
      },
      {
        order: 4,
        name: "error"
      },
      {
        order: 5,
        name: "invalid"
      }
    ]
  },
  {
    name: "PaymentChannel",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "test"
      },
      {
        order: 10,
        name: "zeroPayment"
      },
      {
        order: 20,
        name: "external"
      },
      {
        order: 101,
        name: "palkkausManual"
      },
      {
        order: 102,
        name: "palkkausWS"
      },
      {
        order: 103,
        name: "palkkausPersonal"
      },
      {
        order: 104,
        name: "palkkausInvoices"
      },
      {
        order: 105,
        name: "palkkausPSD"
      },
      {
        order: 201,
        name: "palkkausCfaPaytrail"
      },
      {
        order: 203,
        name: "palkkausCfaReference"
      },
      {
        order: 204,
        name: "palkkausCfaFinvoice"
      },
      {
        order: 205,
        name: "palkkausEcfaPaytrail"
      },
      {
        order: 206,
        name: "palkkausEcfaReference"
      },
      {
        order: 207,
        name: "palkkausEcfaFinvoice"
      },
      {
        order: 210,
        name: "palkkausCfaTest"
      },
      {
        order: 1010,
        name: "accountorGo"
      },
      {
        order: 1020,
        name: "talenomOnline"
      },
      {
        order: 1021,
        name: "talenomCfa"
      },
      {
        order: 1030,
        name: "holviCfa"
      },
      {
        order: 1040,
        name: "finagoSolo"
      },
      {
        order: 1050,
        name: "procountor"
      },
      {
        order: 1060,
        name: "kevytyrittaja"
      },
      {
        order: 1070,
        name: "vismaNetvisor"
      },
      {
        order: 1080,
        name: "askelma"
      },
      {
        order: 1090,
        name: "briox"
      },
      {
        order: 1100,
        name: "lemonaid"
      },
      {
        order: 1110,
        name: "laskupiste"
      },
      {
        order: 1120,
        name: "holvi"
      },
      {
        order: 1130,
        name: "kompassi"
      },
      {
        order: 1140,
        name: "domus"
      },
      {
        order: 1150,
        name: "passeliMerit"
      },
      {
        order: 1160,
        name: "odoo"
      },
      {
        order: 1170,
        name: "ecom"
      },
      {
        order: 1180,
        name: "kitsas"
      },
      {
        order: 1190,
        name: "talenomManual"
      },
      {
        order: 1200,
        name: "hausvise"
      }
    ]
  },
  {
    name: "PaymentMethod",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "sepa"
      },
      {
        order: 2,
        name: "siirto"
      },
      {
        order: 3,
        name: "test"
      }
    ]
  },
  {
    name: "PaymentStatus",
    description: null,
    values: [
      {
        order: 1,
        name: "new"
      },
      {
        order: 100,
        name: "sentToBank"
      },
      {
        order: 101,
        name: "bankTechApproval"
      },
      {
        order: 102,
        name: "bankDelivered"
      },
      {
        order: 109,
        name: "bankPartialError"
      },
      {
        order: 110,
        name: "bankError"
      },
      {
        order: 1e3,
        name: "paid"
      },
      {
        order: 8999,
        name: "unknown"
      },
      {
        order: 9999,
        name: "cancelled"
      }
    ]
  },
  {
    name: "PayrollStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "draft"
      },
      {
        order: 1,
        name: "paymentStarted"
      },
      {
        order: 2,
        name: "paymentSucceeded"
      },
      {
        order: 3,
        name: "paymentCanceled"
      },
      {
        order: 4,
        name: "paymentError"
      },
      {
        order: 11,
        name: "paymentAllowed"
      },
      {
        order: 100,
        name: "waitingApproval"
      },
      {
        order: 101,
        name: "waitingPartnerApproval"
      },
      {
        order: 500,
        name: "handled"
      },
      {
        order: 1e3,
        name: "template"
      }
    ]
  },
  {
    name: "PensionCalculation",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "employee"
      },
      {
        order: 2,
        name: "entrepreneur"
      },
      {
        order: 3,
        name: "farmer"
      },
      {
        order: 4,
        name: "partialOwner"
      },
      {
        order: 5,
        name: "athlete"
      },
      {
        order: 6,
        name: "compensation"
      },
      {
        order: 7,
        name: "boardRemuneration"
      },
      {
        order: 8,
        name: "smallEntrepreneur"
      },
      {
        order: 9,
        name: "smallFarmer"
      },
      {
        order: 10,
        name: "publicSector"
      }
    ]
  },
  {
    name: "PensionCompany",
    description: null,
    values: [
      {
        order: 0,
        name: "none"
      },
      {
        order: 2,
        name: "etera"
      },
      {
        order: 3,
        name: "ilmarinen"
      },
      {
        order: 4,
        name: "elo"
      },
      {
        order: 5,
        name: "pensionsAlandia"
      },
      {
        order: 6,
        name: "varma"
      },
      {
        order: 7,
        name: "veritas"
      },
      {
        order: 8,
        name: "apteekkien"
      },
      {
        order: 9,
        name: "verso"
      },
      {
        order: 20,
        name: "kevaMunicipal"
      },
      {
        order: 24,
        name: "kevaAland"
      },
      {
        order: 25,
        name: "kevaChurch"
      },
      {
        order: 29,
        name: "kevaKela"
      },
      {
        order: 30,
        name: "kevaState"
      },
      {
        order: 80001,
        name: "valio"
      },
      {
        order: 999999,
        name: "other"
      }
    ]
  },
  {
    name: "PensionRule",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 1,
        name: "monthlyLowerLimit"
      }
    ]
  },
  {
    name: "PeriodDateKind",
    description: null,
    values: [
      {
        order: 0,
        name: "paidAtDate"
      },
      {
        order: 1,
        name: "salaryDate"
      },
      {
        order: 2,
        name: "workDate"
      },
      {
        order: 3,
        name: "workDateStart"
      },
      {
        order: 4,
        name: "workDateEnd"
      }
    ]
  },
  {
    name: "PeriodType",
    description: null,
    values: [
      {
        order: 0,
        name: "month"
      },
      {
        order: 1,
        name: "quarter"
      },
      {
        order: 2,
        name: "year"
      },
      {
        order: 99,
        name: "custom"
      }
    ]
  },
  {
    name: "PricingModel",
    description: null,
    values: [
      {
        order: 0,
        name: "palkkausFee"
      },
      {
        order: 1,
        name: "noFee"
      },
      {
        order: 2,
        name: "fixedFee"
      }
    ]
  },
  {
    name: "ProductPackage",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 1,
        name: "partnerBasic"
      },
      {
        order: 2,
        name: "partnerPro"
      }
    ]
  },
  {
    name: "ProductListFilter",
    description: null,
    values: [
      {
        order: 0,
        name: "available"
      },
      {
        order: 1,
        name: "all"
      }
    ]
  },
  {
    name: "RecurringEventCreateMode",
    description: null,
    values: [
      {
        order: 1,
        name: "default"
      },
      {
        order: 2,
        name: "createRecurrence"
      }
    ]
  },
  {
    name: "ReportCategory",
    description: null,
    values: [
      {
        order: 0,
        name: "all"
      },
      {
        order: 1,
        name: "monthly"
      },
      {
        order: 2,
        name: "yearly"
      }
    ]
  },
  {
    name: "ReportType",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "example"
      },
      {
        order: 100,
        name: "monthlyDetails"
      },
      {
        order: 110,
        name: "taxMonthly4001"
      },
      {
        order: 111,
        name: "payerSummaryReport"
      },
      {
        order: 120,
        name: "monthlyPension"
      },
      {
        order: 190,
        name: "monthlyLiikekirjuri"
      },
      {
        order: 191,
        name: "monthlyLiikekirjuriLegacy"
      },
      {
        order: 200,
        name: "monthlyRapko"
      },
      {
        order: 201,
        name: "monthlyAccounting"
      },
      {
        order: 202,
        name: "monthlyAccountingExcel"
      },
      {
        order: 1e3,
        name: "yearlyDetails"
      },
      {
        order: 1001,
        name: "yearEndReport"
      },
      {
        order: 1010,
        name: "yearlyWorkerSummary"
      },
      {
        order: 1100,
        name: "taxYearly7801"
      },
      {
        order: 1200,
        name: "unemployment"
      },
      {
        order: 1210,
        name: "insurance"
      },
      {
        order: 1800,
        name: "householdDeduction"
      },
      {
        order: 1814,
        name: "taxHouseholdDeduction14B"
      },
      {
        order: 1815,
        name: "taxHouseholdDeduction14BSpouseA"
      },
      {
        order: 1816,
        name: "taxHouseholdDeduction14BSpouseB"
      },
      {
        order: 2e3,
        name: "salarySlip"
      },
      {
        order: 2001,
        name: "salarySlipPaid"
      },
      {
        order: 2002,
        name: "salarySlipCopy"
      },
      {
        order: 2006,
        name: "eSalarySpecification"
      },
      {
        order: 2010,
        name: "employerReport"
      },
      {
        order: 2020,
        name: "paymentReport"
      },
      {
        order: 2021,
        name: "paymentSummaryReport"
      },
      {
        order: 2022,
        name: "totalsReport"
      },
      {
        order: 2030,
        name: "earningsPaymentReport"
      },
      {
        order: 2040,
        name: "accountingReport"
      },
      {
        order: 2050,
        name: "invoice"
      },
      {
        order: 2060,
        name: "invoiceList"
      },
      {
        order: 2200,
        name: "employmentContract"
      },
      {
        order: 2300,
        name: "authorization"
      }
    ]
  },
  {
    name: "Role",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "accountant"
      },
      {
        order: 2,
        name: "trustedPartner"
      },
      {
        order: 3,
        name: "accountantCandidate"
      },
      {
        order: 4,
        name: "pricingPartner"
      },
      {
        order: 5,
        name: "sepaPartner"
      }
    ]
  },
  {
    name: "SalaryDateKind",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 1,
        name: "inPast"
      }
    ]
  },
  {
    name: "SalaryKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "fixedSalary"
      },
      {
        order: 2,
        name: "hourlySalary"
      },
      {
        order: 3,
        name: "monthlySalary"
      },
      {
        order: 50,
        name: "compensation"
      },
      {
        order: 100,
        name: "totalWorkerPayment"
      },
      {
        order: 101,
        name: "totalEmployerPayment"
      }
    ]
  },
  {
    name: "SalaryType",
    description: null,
    values: [
      {
        order: 0,
        name: "tyel"
      },
      {
        order: 1,
        name: "yel"
      },
      {
        order: 2,
        name: "compensation"
      }
    ]
  },
  {
    name: "LegacyServiceModel",
    description: null,
    values: [
      {
        order: 0,
        name: "shared"
      },
      {
        order: 1,
        name: "partnerOnly"
      }
    ]
  },
  {
    name: "SettingsStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "checked"
      },
      {
        order: 10,
        name: "pending"
      }
    ]
  },
  {
    name: "SharingUriType",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "url"
      },
      {
        order: 3,
        name: "employer"
      }
    ]
  },
  {
    name: "TaxcardApiIncomeType",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 24,
        name: "salary"
      },
      {
        order: 27,
        name: "dividendsForWorkAsSalary"
      },
      {
        order: 28,
        name: "personnelFundIncome"
      },
      {
        order: 29,
        name: "salaryOneOff"
      },
      {
        order: 33,
        name: "compensationForUseEarnedIncome"
      },
      {
        order: 34,
        name: "compensationForUseCapitalIncome"
      },
      {
        order: 35,
        name: "compensationVatResponsible"
      },
      {
        order: 36,
        name: "compensation"
      },
      {
        order: 37,
        name: "dividendsForWorkAsCompensation"
      },
      {
        order: 38,
        name: "athletePay"
      },
      {
        order: 39,
        name: "otherTaxableIncome"
      },
      {
        order: 40,
        name: "otherTaxableIncomeOneOff"
      },
      {
        order: 42,
        name: "employeeStockOption"
      }
    ]
  },
  {
    name: "TaxcardApprovalMethod",
    description: null,
    values: [
      {
        order: 0,
        name: "assureWaiting"
      },
      {
        order: 1,
        name: "approve"
      },
      {
        order: 2,
        name: "reject"
      }
    ]
  },
  {
    name: "TaxcardCalcDiffCheck",
    description: null,
    values: [
      {
        order: 0,
        name: "getDiff"
      },
      {
        order: 1,
        name: "noCheck"
      },
      {
        order: 2,
        name: "commitDiff"
      }
    ]
  },
  {
    name: "TaxCardIncomeType",
    description: null,
    values: [
      {
        order: 0,
        name: "unknown"
      },
      {
        order: 1,
        name: "salaxyCalculation"
      },
      {
        order: 2,
        name: "previousEmployerSalaries"
      },
      {
        order: 3,
        name: "externalSalaries"
      },
      {
        order: 10,
        name: "sharedCardExtSum"
      },
      {
        order: 100,
        name: "diff"
      }
    ]
  },
  {
    name: "TaxcardState",
    description: null,
    values: [
      {
        order: 0,
        name: "new"
      },
      {
        order: 10,
        name: "approved"
      },
      {
        order: 100,
        name: "employerAdded"
      },
      {
        order: 200,
        name: "verifiedVero"
      },
      {
        order: 300,
        name: "sharedWaiting"
      },
      {
        order: 310,
        name: "sharedApproved"
      },
      {
        order: 320,
        name: "sharedRejected"
      },
      {
        order: 330,
        name: "sharedRejectedWithoutOpen"
      },
      {
        order: 500,
        name: "shared"
      }
    ]
  },
  {
    name: "TaxcardKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "noTaxCard"
      },
      {
        order: 2,
        name: "auto"
      },
      {
        order: 10,
        name: "defaultYearly"
      },
      {
        order: 11,
        name: "replacement"
      },
      {
        order: 20,
        name: "noWithholdingHousehold"
      },
      {
        order: 99,
        name: "others"
      },
      {
        order: 900,
        name: "historical"
      }
    ]
  },
  {
    name: "TaxcardValidity",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "valid"
      },
      {
        order: 2,
        name: "validJanuary"
      },
      {
        order: 3,
        name: "future"
      },
      {
        order: 4,
        name: "expired"
      }
    ]
  },
  {
    name: "TaxAtSourceKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 10,
        name: "noDeduction"
      },
      {
        order: 20,
        name: "monthlyDeduction"
      },
      {
        order: 30,
        name: "dailyDeduction"
      },
      {
        order: 40,
        name: "fixedValues"
      }
    ]
  },
  {
    name: "TaxDeductionWorkCategories",
    description: null,
    values: [
      {
        order: 0,
        name: "none"
      },
      {
        order: 1,
        name: "householdwork"
      },
      {
        order: 2,
        name: "carework"
      },
      {
        order: 4,
        name: "homeImprovement"
      },
      {
        order: 8,
        name: "ownPropety"
      },
      {
        order: 16,
        name: "relativesProperty"
      },
      {
        order: 32,
        name: "oilHeatingReplacementWork"
      }
    ]
  },
  {
    name: "TaxReportHandling",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 1,
        name: "noZeroSalaryReport"
      },
      {
        order: 2,
        name: "noMonthlyReport"
      },
      {
        order: 3,
        name: "always"
      }
    ]
  },
  {
    name: "TaxWithholdingKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "percentage"
      },
      {
        order: 2,
        name: "fixedValue"
      }
    ]
  },
  {
    name: "TesSubtype",
    description: null,
    values: [
      {
        order: 0,
        name: "notSelected"
      },
      {
        order: 100,
        name: "constructionCarpenter"
      },
      {
        order: 101,
        name: "constructionFloor"
      },
      {
        order: 105,
        name: "constructionOther"
      },
      {
        order: 109,
        name: "constructionFreeContract"
      }
    ]
  },
  {
    name: "TestEnum",
    description: null,
    values: [
      {
        order: 0,
        name: "valueZero"
      },
      {
        order: 1,
        name: "valueOne"
      },
      {
        order: 2,
        name: "valueTwo"
      },
      {
        order: 3,
        name: "valueThree"
      },
      {
        order: 4,
        name: "valueFour"
      },
      {
        order: 5,
        name: "valueFive"
      },
      {
        order: 6,
        name: "valueSix"
      },
      {
        order: 7,
        name: "valueSeven"
      },
      {
        order: 8,
        name: "valueEight"
      },
      {
        order: 9,
        name: "valueNine"
      },
      {
        order: 10,
        name: "valueTen"
      }
    ]
  },
  {
    name: "ThreadedMessageType",
    description: null,
    values: [
      {
        order: 0,
        name: "text"
      },
      {
        order: 1,
        name: "blobFile"
      },
      {
        order: 10,
        name: "calculation"
      },
      {
        order: 20,
        name: "payroll"
      },
      {
        order: 30,
        name: "workerAccount"
      },
      {
        order: 500,
        name: "email"
      },
      {
        order: 501,
        name: "salaxyEmail"
      },
      {
        order: 510,
        name: "sms"
      },
      {
        order: 511,
        name: "salaxySms"
      },
      {
        order: 512,
        name: "timer"
      },
      {
        order: 513,
        name: "timerEdited"
      },
      {
        order: 514,
        name: "hourlyReport"
      },
      {
        order: 515,
        name: "timeReport"
      },
      {
        order: 516,
        name: "absence"
      },
      {
        order: 517,
        name: "annualLeave"
      },
      {
        order: 518,
        name: "calcRow"
      },
      {
        order: 519,
        name: "travel"
      },
      {
        order: 520,
        name: "expense"
      }
    ]
  },
  {
    name: "UnemploymentPayrollLimitStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 2,
        name: "higher"
      }
    ]
  },
  {
    name: "UnionPaymentType",
    description: null,
    values: [
      {
        order: 0,
        name: "notSelected"
      },
      {
        order: 100,
        name: "raksaNormal"
      },
      {
        order: 101,
        name: "raksaUnemploymentOnly"
      },
      {
        order: 9999,
        name: "other"
      }
    ]
  },
  {
    name: "Unit",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "hours"
      },
      {
        order: 2,
        name: "days"
      },
      {
        order: 3,
        name: "weeks"
      },
      {
        order: 5,
        name: "period"
      },
      {
        order: 1e3,
        name: "one"
      },
      {
        order: 1001,
        name: "count"
      },
      {
        order: 1002,
        name: "percent"
      },
      {
        order: 1004,
        name: "kilometers"
      },
      {
        order: 2e3,
        name: "euro"
      }
    ]
  },
  {
    name: "UsecaseActionType",
    description: null,
    values: [
      {
        order: 0,
        name: "clientScript"
      },
      {
        order: 1,
        name: "clientScriptAsync"
      },
      {
        order: 2,
        name: "serverScript"
      },
      {
        order: 3,
        name: "serverScriptAsync"
      },
      {
        order: 4,
        name: "webServiceCall"
      },
      {
        order: 5,
        name: "powerAutomateFlow"
      }
    ]
  },
  {
    name: "UsecaseStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "active"
      },
      {
        order: 2,
        name: "default"
      },
      {
        order: 3,
        name: "inactive"
      }
    ]
  },
  {
    name: "VarmaPensionOrderAction",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "newYel"
      },
      {
        order: 2,
        name: "newTyel"
      },
      {
        order: 3,
        name: "move"
      }
    ]
  },
  {
    name: "VarmaPensionOrderYelPayer",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "entrepreneur"
      },
      {
        order: 2,
        name: "company"
      }
    ]
  },
  {
    name: "VatRate",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "none"
      },
      {
        order: 1e4,
        name: "vat0000"
      },
      {
        order: 11e3,
        name: "vat1000"
      },
      {
        order: 11400,
        name: "vat1400"
      },
      {
        order: 12400,
        name: "vat2400"
      },
      {
        order: 12550,
        name: "vat2550"
      },
      {
        order: 99999,
        name: "other"
      }
    ]
  },
  {
    name: "WageBasis",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 10,
        name: "monthly"
      },
      {
        order: 20,
        name: "hourly"
      },
      {
        order: 30,
        name: "performanceBased"
      },
      {
        order: 999,
        name: "other"
      }
    ]
  },
  {
    name: "WebSiteUserRole",
    description: null,
    values: [
      {
        order: 0,
        name: "none"
      },
      {
        order: 1,
        name: "household"
      },
      {
        order: 2,
        name: "worker"
      },
      {
        order: 4,
        name: "company"
      }
    ]
  },
  {
    name: "WorkerSalaryNotification",
    description: null,
    values: [
      {
        order: 0,
        name: "always"
      },
      {
        order: 1,
        name: "silent"
      }
    ]
  },
  {
    name: "WorkerSalarySlipDeliveryMethod",
    description: null,
    values: [
      {
        order: 0,
        name: "default"
      },
      {
        order: 1,
        name: "payslip"
      },
      {
        order: 2,
        name: "omapalkka"
      }
    ]
  },
  {
    name: "WorkflowEventFeatures",
    description: null,
    values: [
      {
        order: 0,
        name: "none"
      },
      {
        order: 1,
        name: "isActive"
      },
      {
        order: 2,
        name: "isEditable"
      },
      {
        order: 4,
        name: "isRemovable"
      },
      {
        order: 8,
        name: "isOnHold"
      }
    ]
  },
  {
    name: "WorktimeImportAction",
    description: null,
    values: [
      {
        order: 0,
        name: "none"
      },
      {
        order: 10,
        name: "parse"
      },
      {
        order: 20,
        name: "validate"
      },
      {
        order: 30,
        name: "preview"
      },
      {
        order: 31,
        name: "previewWithEmployments"
      },
      {
        order: 40,
        name: "import"
      },
      {
        order: 41,
        name: "startImport"
      }
    ]
  },
  {
    name: "WorktimeImportStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "uploaded"
      },
      {
        order: 1,
        name: "parsed"
      },
      {
        order: 2,
        name: "processing"
      },
      {
        order: 3,
        name: "processed"
      },
      {
        order: 4,
        name: "error"
      },
      {
        order: 5,
        name: "archived"
      }
    ]
  },
  {
    name: "WorktimeImportKnownUsecase",
    description: null,
    values: [
      {
        order: 0,
        name: "unknown"
      },
      {
        order: 100,
        name: "mepco"
      },
      {
        order: 100,
        name: "mepco"
      },
      {
        order: 110,
        name: "tyovuorovelho"
      },
      {
        order: 111,
        name: "maraPlan"
      },
      {
        order: 9999,
        name: "other"
      }
    ]
  },
  {
    name: "YearEndAdminCheck",
    description: null,
    values: [
      {
        order: 0,
        name: "notChecked"
      },
      {
        order: 1,
        name: "ok"
      },
      {
        order: 2,
        name: "okWithWarning"
      },
      {
        order: 3,
        name: "errors"
      }
    ]
  },
  {
    name: "YearEndFeedbackCalculationType",
    description: null,
    values: [
      {
        order: 0,
        name: "unknown"
      },
      {
        order: 1,
        name: "salaxyPayment"
      },
      {
        order: 10,
        name: "external"
      },
      {
        order: 100,
        name: "correction"
      }
    ]
  },
  {
    name: "YearEndUserFeedback",
    description: null,
    values: [
      {
        order: 0,
        name: "notChecked"
      },
      {
        order: 1,
        name: "ok"
      },
      {
        order: 2,
        name: "okWithModifications"
      },
      {
        order: 3,
        name: "willHandleMyself"
      },
      {
        order: 4,
        name: "noYearlyReports"
      }
    ]
  },
  {
    name: "YtjCompanyType",
    description: null,
    values: [
      {
        order: 0,
        name: "noCompanyType"
      },
      {
        order: 1,
        name: "housingCooperative"
      },
      {
        order: 2,
        name: "condominium"
      },
      {
        order: 4,
        name: "asoAssociation"
      },
      {
        order: 5,
        name: "openCompany"
      },
      {
        order: 6,
        name: "association"
      },
      {
        order: 9,
        name: "hypoAssociation"
      },
      {
        order: 10,
        name: "mutualRealEstateCompany"
      },
      {
        order: 13,
        name: "ky"
      },
      {
        order: 14,
        name: "osuuskunta"
      },
      {
        order: 15,
        name: "cooperativeBank"
      },
      {
        order: 16,
        name: "oy"
      },
      {
        order: 17,
        name: "publicLimitedCompany"
      },
      {
        order: 18,
        name: "foundation"
      },
      {
        order: 19,
        name: "branch"
      },
      {
        order: 20,
        name: "savingsBank"
      },
      {
        order: 21,
        name: "financialAssociation"
      },
      {
        order: 22,
        name: "stateEstablishment"
      },
      {
        order: 25,
        name: "insuranceAssociation"
      },
      {
        order: 26,
        name: "privateEntrepreneur"
      },
      {
        order: 29,
        name: "otherAssociation"
      },
      {
        order: 31,
        name: "specialPurposeAssociation"
      },
      {
        order: 35,
        name: "forestCareAssociation"
      },
      {
        order: 38,
        name: "otherFinancialAssociation"
      },
      {
        order: 46,
        name: "religiousCommunity"
      },
      {
        order: 50,
        name: "jointInterestGroups"
      },
      {
        order: 51,
        name: "taxableGrouping"
      },
      {
        order: 53,
        name: "deathEstate"
      },
      {
        order: 58,
        name: "mutualInsuranceAssociation"
      },
      {
        order: 60,
        name: "foreignOrganisation"
      },
      {
        order: 61,
        name: "municipalEstablishment"
      },
      {
        order: 62,
        name: "federationOfMunicipalitiesEstablishment"
      },
      {
        order: 64,
        name: "alandFederation"
      },
      {
        order: 83,
        name: "europeanCooperative"
      },
      {
        order: 84,
        name: "europeanCooperativeBank"
      },
      {
        order: 90,
        name: "reindeerHerdingCooperative"
      },
      {
        order: 999,
        name: "unknown"
      }
    ]
  },
  {
    name: "CarBenefitKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "limitedCarBenefit"
      },
      {
        order: 2,
        name: "fullCarBenefit"
      }
    ]
  },
  {
    name: "BicycleBenefitKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "noDeduction"
      },
      {
        order: 2,
        name: "singleDeduction"
      },
      {
        order: 10,
        name: "periodicalDeduction"
      }
    ]
  },
  {
    name: "UnionPaymentKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "fixed"
      },
      {
        order: 2,
        name: "percentage"
      },
      {
        order: 3,
        name: "percentageAndLimits"
      },
      {
        order: 100,
        name: "raksaNormal"
      },
      {
        order: 101,
        name: "raksaUnemploymentOnly"
      },
      {
        order: 9999,
        name: "other"
      }
    ]
  },
  {
    name: "NonProfitOrgKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 357,
        name: "kilometreAllowance"
      },
      {
        order: 358,
        name: "dailyAllowance"
      },
      {
        order: 1358,
        name: "accomodationAllowance"
      }
    ]
  },
  {
    name: "SubsidisedCommuteKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "noDeduction"
      },
      {
        order: 2,
        name: "singleDeduction"
      },
      {
        order: 10,
        name: "periodicalDeduction"
      }
    ]
  },
  {
    name: "MealBenefitKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "cateringContract"
      },
      {
        order: 2,
        name: "mealTicket"
      },
      {
        order: 3,
        name: "taxableAmount"
      },
      {
        order: 4,
        name: "mealAllowance"
      },
      {
        order: 5,
        name: "institute"
      },
      {
        order: 6,
        name: "teacher"
      },
      {
        order: 7,
        name: "restaurantWorker"
      },
      {
        order: 8,
        name: "collectedReimbursement"
      }
    ]
  },
  {
    name: "DailyAllowanceKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "fullDailyAllowance"
      },
      {
        order: 2,
        name: "partialDailyAllowance"
      },
      {
        order: 3,
        name: "internationalDailyAllowance"
      },
      {
        order: 4,
        name: "mealAllowance"
      }
    ]
  },
  {
    name: "BoardKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      }
    ]
  },
  {
    name: "RemunerationKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 202,
        name: "initiativeFee"
      },
      {
        order: 203,
        name: "bonusPay"
      },
      {
        order: 220,
        name: "commission"
      },
      {
        order: 223,
        name: "performanceBonus"
      },
      {
        order: 226,
        name: "shareIssueForEmployees"
      },
      {
        order: 233,
        name: "profitSharingBonus"
      }
    ]
  },
  {
    name: "OtherCompensationKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 210,
        name: "meetingFee"
      },
      {
        order: 214,
        name: "lectureFee"
      },
      {
        order: 215,
        name: "positionOfTrustCompensation"
      },
      {
        order: 225,
        name: "accruedTimeOffCompensation"
      },
      {
        order: 308,
        name: "membershipOfGoverningBodyCompensation"
      },
      {
        order: 310,
        name: "monetaryGiftForEmployees"
      },
      {
        order: 313,
        name: "useCompensationAsEarnedIncome"
      },
      {
        order: 314,
        name: "useCompensationAsCapitalIncome"
      },
      {
        order: 316,
        name: "otherTaxableIncomeAsEarnedIncome"
      },
      {
        order: 320,
        name: "stockOptionsAndGrants"
      },
      {
        order: 326,
        name: "employeeInventionCompensation"
      },
      {
        order: 332,
        name: "capitalIncomePayment"
      },
      {
        order: 339,
        name: "workEffortBasedDividendsAsWage"
      },
      {
        order: 340,
        name: "workEffortBasedDividendsAsNonWage"
      },
      {
        order: 343,
        name: "employeeStockOption"
      },
      {
        order: 361,
        name: "employeeStockOptionWithLowerPrice"
      },
      {
        order: 366,
        name: "copyrightRoyaltiesEarnedIncome"
      },
      {
        order: 367,
        name: "stockGrantPaidInMoney"
      },
      {
        order: 368,
        name: "employeeStockOptionPaidInMoney"
      }
    ]
  },
  {
    name: "PaidSickLeaveKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "paidSickLeaveSalary"
      },
      {
        order: 2,
        name: "paidSickLeaveHourlySalary"
      },
      {
        order: 3,
        name: "paidSickLeaveMonthlySalary"
      }
    ]
  },
  {
    name: "WorkingTimeCompensationKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 205,
        name: "emergencyWorkCompensation"
      },
      {
        order: 206,
        name: "eveningWorkCompensation"
      },
      {
        order: 207,
        name: "eveningShiftAllowance"
      },
      {
        order: 211,
        name: "saturdayPay"
      },
      {
        order: 212,
        name: "extraWorkPremium"
      },
      {
        order: 216,
        name: "otherCompensation"
      },
      {
        order: 217,
        name: "waitingTimeCompensation"
      },
      {
        order: 221,
        name: "sundayWorkCompensation"
      },
      {
        order: 230,
        name: "standByCompensation"
      },
      {
        order: 232,
        name: "weeklyRestCompensation"
      },
      {
        order: 235,
        name: "overtimeCompensation"
      },
      {
        order: 236,
        name: "nightWorkAllowance"
      },
      {
        order: 237,
        name: "nightShiftCompensation"
      }
    ]
  },
  {
    name: "EmploymentTerminationKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 208,
        name: "noticePeriodCompensation"
      },
      {
        order: 224,
        name: "monetaryWorkingTimeBankCompensation"
      },
      {
        order: 229,
        name: "terminationAndLayOffDamages"
      },
      {
        order: 231,
        name: "voluntaryTerminationCompensation"
      },
      {
        order: 338,
        name: "pensionPaidByEmployer"
      }
    ]
  },
  {
    name: "ForeclosureKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "fixed"
      },
      {
        order: 2,
        name: "periodic"
      },
      {
        order: 3,
        name: "nonPeriodic"
      }
    ]
  },
  {
    name: "TotalWorkerPaymentKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "totalWorkerPayment"
      },
      {
        order: 2,
        name: "totalWorkerWorkerPaymentExcludingExpenses"
      },
      {
        order: 3,
        name: "totalWorkerPaymentAndTax"
      },
      {
        order: 4,
        name: "totalWorkerWorkerPaymentAndTaxExcludingExpenses"
      }
    ]
  },
  {
    name: "TransactionCode",
    description: null,
    values: [
      {
        order: 0,
        name: "unknown"
      },
      {
        order: 1,
        name: "ignored"
      },
      {
        order: 201,
        name: "timeRatePay"
      },
      {
        order: 202,
        name: "initiativeFee"
      },
      {
        order: 203,
        name: "bonusPay"
      },
      {
        order: 204,
        name: "complementaryWagePaidDuringBenefitPeriod"
      },
      {
        order: 205,
        name: "emergencyWorkCompensation"
      },
      {
        order: 206,
        name: "eveningWorkCompensation"
      },
      {
        order: 207,
        name: "eveningShiftAllowance"
      },
      {
        order: 208,
        name: "noticePeriodCompensation"
      },
      {
        order: 209,
        name: "kilometreAllowanceTaxable"
      },
      {
        order: 210,
        name: "meetingFee"
      },
      {
        order: 211,
        name: "saturdayPay"
      },
      {
        order: 212,
        name: "extraWorkPremium"
      },
      {
        order: 213,
        name: "holidayBonus"
      },
      {
        order: 214,
        name: "lectureFee"
      },
      {
        order: 215,
        name: "compensationForTrustPosition"
      },
      {
        order: 216,
        name: "otherCompensation"
      },
      {
        order: 217,
        name: "waitingTimeCompensation"
      },
      {
        order: 218,
        name: "workingConditionCompensation"
      },
      {
        order: 219,
        name: "partialPayDuringSickLeave"
      },
      {
        order: 220,
        name: "commission"
      },
      {
        order: 221,
        name: "sundayWorkCompensation"
      },
      {
        order: 222,
        name: "benefitArisingFromSyntheticOption"
      },
      {
        order: 223,
        name: "performanceBonus"
      },
      {
        order: 224,
        name: "monetaryCompensationFromWorkingTimeBank"
      },
      {
        order: 225,
        name: "compensationForAccruedTimeOff"
      },
      {
        order: 226,
        name: "shareIssueForEmployees"
      },
      {
        order: 227,
        name: "contractPay"
      },
      {
        order: 229,
        name: "damagesInConjunctionWithTermination"
      },
      {
        order: 230,
        name: "standByCompensation"
      },
      {
        order: 231,
        name: "voluntaryCompensationInConjunctionWithTermination"
      },
      {
        order: 232,
        name: "weeklyRestCompensation"
      },
      {
        order: 233,
        name: "profitSharingBonus"
      },
      {
        order: 234,
        name: "annualHolidayCompensation"
      },
      {
        order: 235,
        name: "overtimeCompensation"
      },
      {
        order: 236,
        name: "nightWorkAllowance"
      },
      {
        order: 237,
        name: "nightShiftCompensation"
      },
      {
        order: 238,
        name: "otherRegularCompensation"
      },
      {
        order: 239,
        name: "compensationForUnusedCompensatoryLeave"
      },
      {
        order: 301,
        name: "accommodationBenefit"
      },
      {
        order: 302,
        name: "interestBenefitForHousingLoan"
      },
      {
        order: 303,
        name: "mealAllowance"
      },
      {
        order: 304,
        name: "carBenefit"
      },
      {
        order: 308,
        name: "compensationForGoverningBodyMembership"
      },
      {
        order: 309,
        name: "shareOfReserveDrawnFromPersonnelFund"
      },
      {
        order: 310,
        name: "monetaryGiftForEmployees"
      },
      {
        order: 311,
        name: "kilometreAllowanceTaxExempt"
      },
      {
        order: 312,
        name: "treatmentFeeForMunicipalVeterinarian"
      },
      {
        order: 313,
        name: "compensationForUseEarnedIncome"
      },
      {
        order: 314,
        name: "compensationForUseCapitalIncome"
      },
      {
        order: 315,
        name: "otherTaxableBenefitForEmployees"
      },
      {
        order: 316,
        name: "otherTaxableIncomeDeemedEarnedIncome"
      },
      {
        order: 317,
        name: "otherFringeBenefit"
      },
      {
        order: 319,
        name: "kinshipCarersFee"
      },
      {
        order: 320,
        name: "stockOptions"
      },
      {
        order: 321,
        name: "wagesPaidBySubstitutePayerIncludingSocialInsurance"
      },
      {
        order: 322,
        name: "wagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance"
      },
      {
        order: 323,
        name: "wagesPaidBySubstitutePayerIncludingUnemploymentInsurance"
      },
      {
        order: 324,
        name: "wagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance"
      },
      {
        order: 325,
        name: "wagesPaidBySubstitutePayerIncludingHealthInsurance"
      },
      {
        order: 326,
        name: "compensationForEmployeeInvention"
      },
      {
        order: 327,
        name: "reimbursementOfPrivateCaretakersExpenses"
      },
      {
        order: 328,
        name: "privateCaretakersFee"
      },
      {
        order: 329,
        name: "reimbursementOfFamilyDayCareProvidersExpenses"
      },
      {
        order: 330,
        name: "telephoneBenefit"
      },
      {
        order: 331,
        name: "dailyAllowance"
      },
      {
        order: 332,
        name: "capitalIncomePayment"
      },
      {
        order: 334,
        name: "mealBenefit"
      },
      {
        order: 335,
        name: "reimbursementOfCostsPaidToConciliator"
      },
      {
        order: 336,
        name: "nonWageCompensationForWork"
      },
      {
        order: 337,
        name: "supplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund"
      },
      {
        order: 338,
        name: "pensionPaidByEmployer"
      },
      {
        order: 339,
        name: "dividendsBasedOnWages"
      },
      {
        order: 340,
        name: "dividendsBasedOnNonWage"
      },
      {
        order: 341,
        name: "employerSubsidisedCommuterTicketTaxExempt"
      },
      {
        order: 342,
        name: "employerSubsidisedCommuterTicketTaxable"
      },
      {
        order: 343,
        name: "employeeStockOption"
      },
      {
        order: 350,
        name: "wagesTransferredToAthletesSpecialFund"
      },
      {
        order: 351,
        name: "wagesPaidFromAthletesSpecialFund"
      },
      {
        order: 352,
        name: "wagesForInsurancePurposes"
      },
      {
        order: 353,
        name: "taxableReimbursementOfExpenses"
      },
      {
        order: 354,
        name: "privateDayCareAllowanceMunicipalSupplement"
      },
      {
        order: 355,
        name: "privateDayCareAllowanceWages"
      },
      {
        order: 356,
        name: "privateDayCareAllowanceNonWage"
      },
      {
        order: 357,
        name: "kilometreAllowancePaidByNonProfitOrganisation"
      },
      {
        order: 358,
        name: "dailyAllowancePaidByNonProfitOrganisation"
      },
      {
        order: 359,
        name: "unjustEnrichment"
      },
      {
        order: 361,
        name: "employeeStockOptionLowerMarketPrice"
      },
      {
        order: 362,
        name: "royaltyPaidToNonResidentTaxpayer"
      },
      {
        order: 363,
        name: "bicycleBenefitTaxExempt"
      },
      {
        order: 364,
        name: "bicycleBenefitTaxable"
      },
      {
        order: 365,
        name: "conditionalStockOptions"
      },
      {
        order: 366,
        name: "copyrightRoyaltiesEarnedIncome"
      },
      {
        order: 367,
        name: "stockGrantPaidInMoney"
      },
      {
        order: 368,
        name: "employeeStockOptionPaidInMoney"
      },
      {
        order: 369,
        name: "earningsFromJuELEmployerToLightEntrepreneur"
      },
      {
        order: 401,
        name: "compensationCollectedForCarBenefit"
      },
      {
        order: 402,
        name: "withholdingTax"
      },
      {
        order: 403,
        name: "electedOfficialFee"
      },
      {
        order: 404,
        name: "taxAtSource"
      },
      {
        order: 405,
        name: "taxAtSourceDeduction"
      },
      {
        order: 406,
        name: "wagesPaid"
      },
      {
        order: 407,
        name: "reimbursementCollectedForOtherFringeBenefits"
      },
      {
        order: 408,
        name: "otherItemDeductibleFromNetWage"
      },
      {
        order: 409,
        name: "netWage"
      },
      {
        order: 410,
        name: "employerPaidPremiumForCollectiveAdditionalPensionInsurance"
      },
      {
        order: 411,
        name: "employerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution"
      },
      {
        order: 412,
        name: "employeesHealthInsuranceContribution"
      },
      {
        order: 413,
        name: "employeesPensionInsuranceContribution"
      },
      {
        order: 414,
        name: "employeesUnemploymentInsuranceContribution"
      },
      {
        order: 415,
        name: "reimbursementForEmployerSubsidisedCommuterTicket"
      },
      {
        order: 416,
        name: "taxPaidAbroad"
      },
      {
        order: 417,
        name: "distraint"
      },
      {
        order: 418,
        name: "voluntaryIndividualPensionInsurancePremium"
      },
      {
        order: 419,
        name: "deductionBeforeWithholding"
      },
      {
        order: 420,
        name: "reimbursementCollectedForBicycleBenefit"
      }
    ]
  },
  {
    name: "TrainingKind",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "trainingSalary"
      },
      {
        order: 2,
        name: "trainingHourlySalary"
      },
      {
        order: 3,
        name: "trainingMonthlySalary"
      }
    ]
  }
], br = [
  {
    name: "ActionCode",
    description: null,
    values: [
      {
        order: 1,
        name: "newReport"
      },
      {
        order: 2,
        name: "replacementReport"
      }
    ]
  },
  {
    name: "AddressType",
    description: null,
    values: [
      {
        order: 1,
        name: "addressInHomeCountry"
      },
      {
        order: 2,
        name: "addressInTheCountryOfWork"
      }
    ]
  },
  {
    name: "AgeGroupCode",
    description: null,
    values: [
      {
        order: 1,
        name: "a"
      },
      {
        order: 2,
        name: "b"
      },
      {
        order: 3,
        name: "c"
      },
      {
        order: 4,
        name: "u"
      }
    ]
  },
  {
    name: "AllowanceCode",
    description: null,
    values: [
      {
        order: 1,
        name: "mealAllowance"
      },
      {
        order: 2,
        name: "partialDailyAllowance"
      },
      {
        order: 3,
        name: "fullDailyAllowance"
      },
      {
        order: 4,
        name: "internationalDailyAllowance"
      },
      {
        order: 5,
        name: "taxExemptReimbursementsAbroad"
      }
    ]
  },
  {
    name: "ApiValidationErrorType",
    description: null,
    values: [
      {
        order: 0,
        name: "general"
      },
      {
        order: 10,
        name: "required"
      },
      {
        order: 20,
        name: "invalid"
      },
      {
        order: 30,
        name: "warning"
      }
    ]
  },
  {
    name: "BenefitCode",
    description: null,
    values: [
      {
        order: 1,
        name: "accommodationBenefit"
      },
      {
        order: 2,
        name: "telephoneBenefit"
      },
      {
        order: 3,
        name: "mealBenefit"
      },
      {
        order: 4,
        name: "otherBenefits"
      }
    ]
  },
  {
    name: "CalcGroup",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "baseSalary"
      },
      {
        order: 2,
        name: "salaryAdditions"
      },
      {
        order: 3,
        name: "benefits"
      },
      {
        order: 4,
        name: "expenses"
      },
      {
        order: 5,
        name: "deductions"
      },
      {
        order: 6,
        name: "otherNoPayment"
      },
      {
        order: 100,
        name: "totals"
      },
      {
        order: 200,
        name: "disabled"
      }
    ]
  },
  {
    name: "CarBenefitCode",
    description: null,
    values: [
      {
        order: 1,
        name: "limitedCarBenefit"
      },
      {
        order: 2,
        name: "fullCarBenefit"
      }
    ]
  },
  {
    name: "DeliveryDataType",
    description: null,
    values: [
      {
        order: 100,
        name: "earningsPaymentReports"
      },
      {
        order: 101,
        name: "employersSeparateReports"
      },
      {
        order: 102,
        name: "benefitsPaymentReports"
      },
      {
        order: 103,
        name: "recordSubscription"
      },
      {
        order: 104,
        name: "messages"
      },
      {
        order: 105,
        name: "cancellationOfEarningsPaymentReports"
      },
      {
        order: 106,
        name: "cancellationOfEmployersSeparateReports"
      },
      {
        order: 107,
        name: "cancellationOfBenefitsPaymentReports"
      },
      {
        order: 108,
        name: "cancellationOfARecordSubscription"
      },
      {
        order: 109,
        name: "cancellationOfARecordContainingEarningsPaymentReports"
      },
      {
        order: 110,
        name: "cancellationOfARecordContainingEmployersSeparateReports"
      },
      {
        order: 111,
        name: "cancellationOfARecordContainingBenefitsPaymentReports"
      },
      {
        order: 112,
        name: "cancellationOfARecordContainingARecordSubscription"
      }
    ]
  },
  {
    name: "EarningsPaymentReportStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "new"
      },
      {
        order: 1,
        name: "scheduled"
      },
      {
        order: 2,
        name: "succeeded"
      },
      {
        order: 3,
        name: "canceled"
      },
      {
        order: 4,
        name: "error"
      },
      {
        order: 5,
        name: "invalid"
      }
    ]
  },
  {
    name: "EmploymentCode",
    description: null,
    values: [
      {
        order: 1,
        name: "fullTime"
      },
      {
        order: 2,
        name: "partTime"
      },
      {
        order: 3,
        name: "notAvailable"
      }
    ]
  },
  {
    name: "EmploymentEndingCode",
    description: null,
    values: [
      {
        order: 1,
        name: "employeesResignation"
      },
      {
        order: 2,
        name: "other"
      },
      {
        order: 3,
        name: "terminationGroundsRelatedToEmployeesPerson"
      },
      {
        order: 4,
        name: "financialAndProductionRelatedGrounds"
      },
      {
        order: 5,
        name: "jointAgreement"
      },
      {
        order: 6,
        name: "retirement"
      },
      {
        order: 7,
        name: "terminationOfaFixedTermEmployment"
      }
    ]
  },
  {
    name: "EmploymentEndingType",
    description: null,
    values: [
      {
        order: 1,
        name: "kevaCodes"
      },
      {
        order: 2,
        name: "bankOfFinlandCodes"
      },
      {
        order: 3,
        name: "incomesRegisterCodes"
      }
    ]
  },
  {
    name: "EmploymentRegType",
    description: null,
    values: [
      {
        order: 1,
        name: "kevasGroundsForRegistration"
      },
      {
        order: 2,
        name: "bankOfFinlandsGroundsForRegistration"
      }
    ]
  },
  {
    name: "ExceptionCode",
    description: null,
    values: [
      {
        order: 1,
        name: "noObligationToSocialInsurance"
      },
      {
        order: 2,
        name: "noObligationToHealthInsurance"
      },
      {
        order: 3,
        name: "noObligationToEarningsRelatedPensionInsurance"
      },
      {
        order: 4,
        name: "noObligationToAccidentAndOccupationalDiseaseInsurance"
      },
      {
        order: 5,
        name: "noObligationToUnemploymentInsurance"
      },
      {
        order: 6,
        name: "notSubjectToSocialInsurance"
      },
      {
        order: 7,
        name: "notSubjectToEarningsRelatedPensionInsurance"
      },
      {
        order: 8,
        name: "notSubjectToAccidentAndOccupationalDiseaseInsurance"
      },
      {
        order: 9,
        name: "notSubjectToUnemploymentInsurance"
      },
      {
        order: 10,
        name: "notSubjectToHealthInsurance"
      },
      {
        order: 11,
        name: "voluntaryEarningsRelatedPensionInsurance"
      }
    ]
  },
  {
    name: "FaultyControl",
    description: null,
    values: [
      {
        order: 1,
        name: "onlyInvalidItems"
      },
      {
        order: 2,
        name: "entireRecordIsRejected"
      }
    ]
  },
  {
    name: "Gender",
    description: null,
    values: [
      {
        order: 1,
        name: "male"
      },
      {
        order: 2,
        name: "female"
      }
    ]
  },
  {
    name: "IdType",
    description: null,
    values: [
      {
        order: 1,
        name: "businessId"
      },
      {
        order: 2,
        name: "personalIdentificationNumber"
      },
      {
        order: 3,
        name: "vat"
      },
      {
        order: 4,
        name: "giin"
      },
      {
        order: 5,
        name: "taxIdentificationNumber"
      },
      {
        order: 6,
        name: "finnishTradeRegistrationNumber"
      },
      {
        order: 7,
        name: "foreignBusinessRegistrationNumber"
      },
      {
        order: 9,
        name: "foreignPersonalIdentificationNumber"
      },
      {
        order: 99,
        name: "other"
      }
    ]
  },
  {
    name: "IncomeEarnerType",
    description: null,
    values: [
      {
        order: 1,
        name: "employedByStateEmploymentFund"
      },
      {
        order: 2,
        name: "jointOwnerWithPayer"
      },
      {
        order: 3,
        name: "partialOwner"
      },
      {
        order: 4,
        name: "keyEmployee"
      },
      {
        order: 5,
        name: "leasedEmployeeLivingAbroad"
      },
      {
        order: 6,
        name: "personWorkingInFrontierDistrict"
      },
      {
        order: 7,
        name: "personWorkingAbroad"
      },
      {
        order: 8,
        name: "athlete"
      },
      {
        order: 9,
        name: "performingArtist"
      },
      {
        order: 10,
        name: "restrictedPeriodInFinland"
      },
      {
        order: 11,
        name: "netOfTaxContract"
      },
      {
        order: 12,
        name: "organization"
      },
      {
        order: 13,
        name: "personWorkingOnAlandFerry"
      },
      {
        order: 14,
        name: "entrepreneurOrFarmerNoPensionRequired"
      },
      {
        order: 15,
        name: "dimplomaticMission"
      },
      {
        order: 16,
        name: "eppo"
      },
      {
        order: 17,
        name: "lightEntrepreneur"
      }
    ]
  },
  {
    name: "InsuranceCode",
    description: null,
    values: [
      {
        order: 1,
        name: "subjectToSocialInsuranceContributions"
      },
      {
        order: 2,
        name: "subjectToEarningsRelatedPensionInsuranceContribution"
      },
      {
        order: 3,
        name: "subjectToHealthInsuranceContribution"
      },
      {
        order: 5,
        name: "subjectToUnemploymentInsuranceContribution"
      },
      {
        order: 6,
        name: "subjectToAccidentInsuranceAndOccupationalDiseaseInsuranceContribution"
      }
    ]
  },
  {
    name: "IrScheduleAction",
    description: null,
    values: [
      {
        order: 1,
        name: "send"
      },
      {
        order: 2,
        name: "cancel"
      }
    ]
  },
  {
    name: "Language",
    description: null,
    values: [
      {
        order: 1,
        name: "fi"
      },
      {
        order: 2,
        name: "sv"
      },
      {
        order: 3,
        name: "en"
      }
    ]
  },
  {
    name: "PaidAbsenceCauseCode",
    description: null,
    values: [
      {
        order: 1,
        name: "illness"
      },
      {
        order: 2,
        name: "partTimeSickLeave"
      },
      {
        order: 3,
        name: "parentalLeave"
      },
      {
        order: 4,
        name: "specialMaternityLeave"
      },
      {
        order: 5,
        name: "rehabilitation"
      },
      {
        order: 6,
        name: "childIllness"
      },
      {
        order: 7,
        name: "partTimeChildCareLeave"
      },
      {
        order: 8,
        name: "training"
      },
      {
        order: 13,
        name: "leaveOfAbsence"
      },
      {
        order: 14,
        name: "militaryRefresherTraining"
      },
      {
        order: 18,
        name: "midWeekHoliday"
      },
      {
        order: 19,
        name: "accruedHoliday"
      },
      {
        order: 20,
        name: "occupationalAccident"
      },
      {
        order: 21,
        name: "annualLeave"
      },
      {
        order: 22,
        name: "partTimeAbsenceDueToRehabilitation"
      },
      {
        order: 99,
        name: "other"
      }
    ]
  },
  {
    name: "PayerSubOrgType",
    description: null,
    values: [
      {
        order: 1,
        name: "kevasSubmitterCodes"
      },
      {
        order: 2,
        name: "payersOwnCodes"
      },
      {
        order: 3,
        name: "governmentAgencyIdentifier"
      }
    ]
  },
  {
    name: "PayerSummaryReportStatus",
    description: null,
    values: [
      {
        order: 0,
        name: "new"
      },
      {
        order: 1,
        name: "scheduled"
      },
      {
        order: 2,
        name: "succeeded"
      },
      {
        order: 3,
        name: "canceled"
      },
      {
        order: 4,
        name: "error"
      },
      {
        order: 5,
        name: "invalid"
      }
    ]
  },
  {
    name: "PayerType",
    description: null,
    values: [
      {
        order: 1,
        name: "publicSector"
      },
      {
        order: 2,
        name: "household"
      },
      {
        order: 3,
        name: "temporaryEmployer"
      },
      {
        order: 4,
        name: "foreignEmployer"
      },
      {
        order: 6,
        name: "state"
      },
      {
        order: 7,
        name: "unincorporatedStateEnterpriseOrGovernmentalInstitution"
      },
      {
        order: 8,
        name: "specialisedAgency"
      },
      {
        order: 9,
        name: "foreignGroupCompany"
      },
      {
        order: 10,
        name: "poolOfHouseholdEmployers"
      }
    ]
  },
  {
    name: "PaymentType",
    description: null,
    values: [
      {
        order: 1,
        name: "monthly"
      },
      {
        order: 2,
        name: "hourly"
      },
      {
        order: 3,
        name: "contractPay"
      }
    ]
  },
  {
    name: "PensionActCode",
    description: null,
    values: [
      {
        order: 1,
        name: "employeesEarningsRelatedPensionInsurance"
      },
      {
        order: 2,
        name: "pensionInsuranceForFarmers"
      },
      {
        order: 3,
        name: "pensionInsuranceForTheSelfEmployed"
      }
    ]
  },
  {
    name: "PensionProvIdCode",
    description: null,
    values: [
      {
        order: 0,
        name: "none"
      },
      {
        order: 10,
        name: "finnishCentreForPensions"
      },
      {
        order: 16,
        name: "clergyOfTheOrthodoxChurch"
      },
      {
        order: 20,
        name: "kevaMemberOrganisations"
      },
      {
        order: 24,
        name: "kevaÅlandLandskapsregeringsPensionssystem"
      },
      {
        order: 25,
        name: "kevaChurch"
      },
      {
        order: 27,
        name: "bankOfFinland"
      },
      {
        order: 29,
        name: "kevaKelaEmploymentPensions"
      },
      {
        order: 30,
        name: "kevaState"
      },
      {
        order: 34,
        name: "seafarers"
      },
      {
        order: 35,
        name: "farmers"
      },
      {
        order: 40,
        name: "alandia"
      },
      {
        order: 46,
        name: "ilmarinen"
      },
      {
        order: 54,
        name: "elo"
      },
      {
        order: 55,
        name: "varma"
      },
      {
        order: 56,
        name: "veritas"
      },
      {
        order: 90,
        name: "etera"
      },
      {
        order: 70014,
        name: "uPM"
      },
      {
        order: 70047,
        name: "sanoma"
      },
      {
        order: 70072,
        name: "sandvik"
      },
      {
        order: 70076,
        name: "kontino"
      },
      {
        order: 70078,
        name: "yleisradio"
      },
      {
        order: 70088,
        name: "aBB"
      },
      {
        order: 70093,
        name: "lFashionGroup"
      },
      {
        order: 70109,
        name: "honeywell"
      },
      {
        order: 70199,
        name: "telia"
      },
      {
        order: 70200,
        name: "yaraSuomi"
      },
      {
        order: 70202,
        name: "orion"
      },
      {
        order: 80001,
        name: "valio"
      },
      {
        order: 80005,
        name: "oP"
      },
      {
        order: 80008,
        name: "verso"
      },
      {
        order: 80009,
        name: "apteekkien"
      },
      {
        order: 80012,
        name: "viabek"
      },
      {
        order: 80014,
        name: "reka"
      }
    ]
  },
  {
    name: "ProfessionType",
    description: null,
    values: [
      {
        order: 1,
        name: "statisticsFinland"
      },
      {
        order: 2,
        name: "keva"
      },
      {
        order: 3,
        name: "bankOfFinland"
      },
      {
        order: 4,
        name: "trafi"
      }
    ]
  },
  {
    name: "RefPaymentType",
    description: null,
    values: [
      {
        order: 2,
        name: "earningsRelatedPensionProvider"
      }
    ]
  },
  {
    name: "ReimbPaymentType",
    description: null,
    values: [
      {
        order: 1,
        name: "kelaDailyAllowanceApplication"
      },
      {
        order: 2,
        name: "kelaFamilyLeaveCompensation"
      }
    ]
  },
  {
    name: "RemunerationCode",
    description: null,
    values: [
      {
        order: 1,
        name: "dailyAllowance"
      },
      {
        order: 2,
        name: "accommodationBenefit"
      },
      {
        order: 3,
        name: "carBenefit"
      },
      {
        order: 4,
        name: "otherBenefit"
      }
    ]
  },
  {
    name: "ReportLogEventType",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 1,
        name: "sent"
      },
      {
        order: 2,
        name: "canceled"
      },
      {
        order: 3,
        name: "error"
      }
    ]
  },
  {
    name: "ResponsibilityCode",
    description: null,
    values: [
      {
        order: 1,
        name: "contentIssues"
      },
      {
        order: 2,
        name: "technicalIssues"
      }
    ]
  },
  {
    name: "SummaryTransactionCode",
    description: null,
    values: [
      {
        order: 0,
        name: "undefined"
      },
      {
        order: 101,
        name: "noWagesPayable"
      },
      {
        order: 102,
        name: "employersHealthInsuranceContribution"
      },
      {
        order: 103,
        name: "deductionsToBeMadeFromTheEmployersHealthInsuranceContribution"
      }
    ]
  },
  {
    name: "TermCode",
    description: null,
    values: [
      {
        order: 1,
        name: "untilFurtherNotice"
      },
      {
        order: 2,
        name: "fixedTerm"
      }
    ]
  },
  {
    name: "TransactionCode",
    description: null,
    values: [
      {
        order: 0,
        name: "unknown"
      },
      {
        order: 1,
        name: "ignored"
      },
      {
        order: 201,
        name: "timeRatePay"
      },
      {
        order: 202,
        name: "initiativeFee"
      },
      {
        order: 203,
        name: "bonusPay"
      },
      {
        order: 204,
        name: "complementaryWagePaidDuringBenefitPeriod"
      },
      {
        order: 205,
        name: "emergencyWorkCompensation"
      },
      {
        order: 206,
        name: "eveningWorkCompensation"
      },
      {
        order: 207,
        name: "eveningShiftAllowance"
      },
      {
        order: 208,
        name: "noticePeriodCompensation"
      },
      {
        order: 209,
        name: "kilometreAllowanceTaxable"
      },
      {
        order: 210,
        name: "meetingFee"
      },
      {
        order: 211,
        name: "saturdayPay"
      },
      {
        order: 212,
        name: "extraWorkPremium"
      },
      {
        order: 213,
        name: "holidayBonus"
      },
      {
        order: 214,
        name: "lectureFee"
      },
      {
        order: 215,
        name: "compensationForTrustPosition"
      },
      {
        order: 216,
        name: "otherCompensation"
      },
      {
        order: 217,
        name: "waitingTimeCompensation"
      },
      {
        order: 218,
        name: "workingConditionCompensation"
      },
      {
        order: 219,
        name: "partialPayDuringSickLeave"
      },
      {
        order: 220,
        name: "commission"
      },
      {
        order: 221,
        name: "sundayWorkCompensation"
      },
      {
        order: 222,
        name: "benefitArisingFromSyntheticOption"
      },
      {
        order: 223,
        name: "performanceBonus"
      },
      {
        order: 224,
        name: "monetaryCompensationFromWorkingTimeBank"
      },
      {
        order: 225,
        name: "compensationForAccruedTimeOff"
      },
      {
        order: 226,
        name: "shareIssueForEmployees"
      },
      {
        order: 227,
        name: "contractPay"
      },
      {
        order: 229,
        name: "damagesInConjunctionWithTermination"
      },
      {
        order: 230,
        name: "standByCompensation"
      },
      {
        order: 231,
        name: "voluntaryCompensationInConjunctionWithTermination"
      },
      {
        order: 232,
        name: "weeklyRestCompensation"
      },
      {
        order: 233,
        name: "profitSharingBonus"
      },
      {
        order: 234,
        name: "annualHolidayCompensation"
      },
      {
        order: 235,
        name: "overtimeCompensation"
      },
      {
        order: 236,
        name: "nightWorkAllowance"
      },
      {
        order: 237,
        name: "nightShiftCompensation"
      },
      {
        order: 238,
        name: "otherRegularCompensation"
      },
      {
        order: 239,
        name: "compensationForUnusedCompensatoryLeave"
      },
      {
        order: 301,
        name: "accommodationBenefit"
      },
      {
        order: 302,
        name: "interestBenefitForHousingLoan"
      },
      {
        order: 303,
        name: "mealAllowance"
      },
      {
        order: 304,
        name: "carBenefit"
      },
      {
        order: 308,
        name: "compensationForGoverningBodyMembership"
      },
      {
        order: 309,
        name: "shareOfReserveDrawnFromPersonnelFund"
      },
      {
        order: 310,
        name: "monetaryGiftForEmployees"
      },
      {
        order: 311,
        name: "kilometreAllowanceTaxExempt"
      },
      {
        order: 312,
        name: "treatmentFeeForMunicipalVeterinarian"
      },
      {
        order: 313,
        name: "compensationForUseEarnedIncome"
      },
      {
        order: 314,
        name: "compensationForUseCapitalIncome"
      },
      {
        order: 315,
        name: "otherTaxableBenefitForEmployees"
      },
      {
        order: 316,
        name: "otherTaxableIncomeDeemedEarnedIncome"
      },
      {
        order: 317,
        name: "otherFringeBenefit"
      },
      {
        order: 319,
        name: "kinshipCarersFee"
      },
      {
        order: 320,
        name: "stockOptions"
      },
      {
        order: 321,
        name: "wagesPaidBySubstitutePayerIncludingSocialInsurance"
      },
      {
        order: 322,
        name: "wagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance"
      },
      {
        order: 323,
        name: "wagesPaidBySubstitutePayerIncludingUnemploymentInsurance"
      },
      {
        order: 324,
        name: "wagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance"
      },
      {
        order: 325,
        name: "wagesPaidBySubstitutePayerIncludingHealthInsurance"
      },
      {
        order: 326,
        name: "compensationForEmployeeInvention"
      },
      {
        order: 327,
        name: "reimbursementOfPrivateCaretakersExpenses"
      },
      {
        order: 328,
        name: "privateCaretakersFee"
      },
      {
        order: 329,
        name: "reimbursementOfFamilyDayCareProvidersExpenses"
      },
      {
        order: 330,
        name: "telephoneBenefit"
      },
      {
        order: 331,
        name: "dailyAllowance"
      },
      {
        order: 332,
        name: "capitalIncomePayment"
      },
      {
        order: 334,
        name: "mealBenefit"
      },
      {
        order: 335,
        name: "reimbursementOfCostsPaidToConciliator"
      },
      {
        order: 336,
        name: "nonWageCompensationForWork"
      },
      {
        order: 337,
        name: "supplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund"
      },
      {
        order: 338,
        name: "pensionPaidByEmployer"
      },
      {
        order: 339,
        name: "dividendsBasedOnWages"
      },
      {
        order: 340,
        name: "dividendsBasedOnNonWage"
      },
      {
        order: 341,
        name: "employerSubsidisedCommuterTicketTaxExempt"
      },
      {
        order: 342,
        name: "employerSubsidisedCommuterTicketTaxable"
      },
      {
        order: 343,
        name: "employeeStockOption"
      },
      {
        order: 350,
        name: "wagesTransferredToAthletesSpecialFund"
      },
      {
        order: 351,
        name: "wagesPaidFromAthletesSpecialFund"
      },
      {
        order: 352,
        name: "wagesForInsurancePurposes"
      },
      {
        order: 353,
        name: "taxableReimbursementOfExpenses"
      },
      {
        order: 354,
        name: "privateDayCareAllowanceMunicipalSupplement"
      },
      {
        order: 355,
        name: "privateDayCareAllowanceWages"
      },
      {
        order: 356,
        name: "privateDayCareAllowanceNonWage"
      },
      {
        order: 357,
        name: "kilometreAllowancePaidByNonProfitOrganisation"
      },
      {
        order: 358,
        name: "dailyAllowancePaidByNonProfitOrganisation"
      },
      {
        order: 359,
        name: "unjustEnrichment"
      },
      {
        order: 361,
        name: "employeeStockOptionLowerMarketPrice"
      },
      {
        order: 362,
        name: "royaltyPaidToNonResidentTaxpayer"
      },
      {
        order: 363,
        name: "bicycleBenefitTaxExempt"
      },
      {
        order: 364,
        name: "bicycleBenefitTaxable"
      },
      {
        order: 365,
        name: "conditionalStockOptions"
      },
      {
        order: 366,
        name: "copyrightRoyaltiesEarnedIncome"
      },
      {
        order: 367,
        name: "stockGrantPaidInMoney"
      },
      {
        order: 368,
        name: "employeeStockOptionPaidInMoney"
      },
      {
        order: 369,
        name: "earningsFromJuELEmployerToLightEntrepreneur"
      },
      {
        order: 401,
        name: "compensationCollectedForCarBenefit"
      },
      {
        order: 402,
        name: "withholdingTax"
      },
      {
        order: 403,
        name: "electedOfficialFee"
      },
      {
        order: 404,
        name: "taxAtSource"
      },
      {
        order: 405,
        name: "taxAtSourceDeduction"
      },
      {
        order: 406,
        name: "wagesPaid"
      },
      {
        order: 407,
        name: "reimbursementCollectedForOtherFringeBenefits"
      },
      {
        order: 408,
        name: "otherItemDeductibleFromNetWage"
      },
      {
        order: 409,
        name: "netWage"
      },
      {
        order: 410,
        name: "employerPaidPremiumForCollectiveAdditionalPensionInsurance"
      },
      {
        order: 411,
        name: "employerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution"
      },
      {
        order: 412,
        name: "employeesHealthInsuranceContribution"
      },
      {
        order: 413,
        name: "employeesPensionInsuranceContribution"
      },
      {
        order: 414,
        name: "employeesUnemploymentInsuranceContribution"
      },
      {
        order: 415,
        name: "reimbursementForEmployerSubsidisedCommuterTicket"
      },
      {
        order: 416,
        name: "taxPaidAbroad"
      },
      {
        order: 417,
        name: "distraint"
      },
      {
        order: 418,
        name: "voluntaryIndividualPensionInsurancePremium"
      },
      {
        order: 419,
        name: "deductionBeforeWithholding"
      },
      {
        order: 420,
        name: "reimbursementCollectedForBicycleBenefit"
      }
    ]
  },
  {
    name: "UnpaidAbsenceCauseCode",
    description: null,
    values: [
      {
        order: 1,
        name: "illness"
      },
      {
        order: 2,
        name: "partTimeSickLeave"
      },
      {
        order: 3,
        name: "parentalLeave"
      },
      {
        order: 4,
        name: "specialMaternityLeave"
      },
      {
        order: 5,
        name: "rehabilitation"
      },
      {
        order: 6,
        name: "childIllness"
      },
      {
        order: 7,
        name: "partTimeChildCareLeave"
      },
      {
        order: 8,
        name: "training"
      },
      {
        order: 9,
        name: "jobAlternationLeave"
      },
      {
        order: 10,
        name: "studyLeave"
      },
      {
        order: 11,
        name: "industrialAction"
      },
      {
        order: 12,
        name: "interruptionInWorkProvision"
      },
      {
        order: 13,
        name: "leaveOfAbsence"
      },
      {
        order: 14,
        name: "militaryRefresherTraining"
      },
      {
        order: 15,
        name: "militaryService"
      },
      {
        order: 16,
        name: "layOff"
      },
      {
        order: 17,
        name: "childCareLeave"
      },
      {
        order: 99,
        name: "other"
      }
    ]
  },
  {
    name: "WageUnitCode",
    description: null,
    values: [
      {
        order: 1,
        name: "hour"
      },
      {
        order: 2,
        name: "day"
      },
      {
        order: 3,
        name: "week"
      },
      {
        order: 5,
        name: "period"
      }
    ]
  }
], vn = class vn {
  /**
   * Gets a label text for an enumeration value.
   * @param enumType Name of the Type of the enumeration with or without the namespace. The default namespace for the type is SALAXY.ENUM.
   * @param memberName Name of the member for which the label is fetched.
   * Also supports the value of the member if there is only difference in casing (which is the normal convention).
   * @param defaultValue The default value if the translation is not found.
   * Supports special keys "#name" and "name" to return the member name either with or without hash in the beginning.
   * Default is "#name", which returns "#[MemberName]" if the translation is not found.
   * @param language Optional language, for forcing the result as given language.
   * @returns Language specific text form translations or the memberName text if no translation is found.
   */
  static getEnumLabel(e, t, n = "#name", i = null) {
    if (!e || !t)
      return `#err ${e || "NoEnumType"}.${t || "NoEnumValue"}`;
    t = this.lowerCamelCase(t), n === "name" ? n = this.upperCamelCase(t) : n === "#name" && (n = this.upperCamelCase(t));
    const s = d.getWithDefault(`${this.getFullEnumType(e)}.${t}.label`, void 0, i) || n;
    return s || this.upperCamelCase(t);
  }
  /**
   * Gets a description text for an enumeration value in current language.
   * @param enumType - Name of the Type of the enumeration with or without the namespace. The default namespace for the type is SALAXY.ENUM.
   * @param memberName Name of the member for which the description is fetched.
   * Also supports the value of the member if there is only difference in casing (which is the normal convention).
   * @param defaultValue The default value if the translation is not found. Default is null.
   * Supports special keys "#name" and "name" to return the member name either with or without hash in the beginning.
   * @param language Optional language, for forcing the result as given language.
   * @returns Language specific text form translations or null if none is found.
   */
  static getEnumDescr(e, t, n, i = null) {
    return !e || !t ? `#err ${e || "NoEnumType"}.${t || "NoEnumValue"}` : (t = this.lowerCamelCase(t), n === "name" ? n = this.upperCamelCase(t) : n === "#name" && (n = this.upperCamelCase(t)), d.getWithDefault(`${this.getFullEnumType(e)}.${t}.description`, void 0, i) || n);
  }
  /**
   * Gets a very short user interface text for an enumeration.
   * Currently only suppotrted for Unit, but we expect more of these.
   * If the texts will be language-versioned, that logic will be here as well.
   * @param enumType - Name of the Type of the enumeration.
   * @param enumValue - Value for which the text is fetched.
   */
  static getEnumShortText(e, t) {
    if (!e || !t)
      return `#err ${e || "NoEnumType"}.${t || "NoEnumValue"}`;
    switch (e = this.upperCamelCase(e), t = this.lowerCamelCase(t), e) {
      case "Unit":
        return {
          undefined: "kpl?",
          hour: "h",
          day: "pv",
          week: "vko",
          period: "jaksoa",
          one: "",
          count: "kpl",
          percent: "%",
          kilometers: "km"
        }[t];
      default:
        throw new Error(`Enum type ${e} is not supported in getEnumShortText().`);
    }
  }
  /**
   * Gets the metadata (texts etc.) for an enumeration value.
   * @param enumType -  Name of the Type of the enumeration with or without the namespace. The default namespace for the type is SALAXY.ENUM.
   * @param enumValue - Value for which the label is fetched.
   * @param language Optional language, for forcing the result as given language.
   */
  static getEnumValueMetadata(e, t, n = null) {
    const i = this.getEnumMetadata(e, n);
    return !t || !i ? void 0 : (t = this.lowerCamelCase(t), i.values.filter((r) => r.name === t)[0]);
  }
  /**
   * Gets the metadata (texts etc.) for an enumeration and its values.
   * @param enumType -  Name of the Type of the enumeration with or without the namespace. The default namespace for the type is SALAXY.ENUM.
   * @param language Optional language, for forcing the result as given language.
   */
  static getEnumMetadata(e, t = null) {
    if (!e)
      return;
    const n = this.getFullEnumType(e), i = n.split(".");
    if (i.length !== 3) {
      console.warn(`Invalid enum type ${e}`);
      return;
    }
    const s = i[2], r = this.getGeneratedEnumData(`${i[0]}.${i[1]}`);
    if (!r) {
      console.warn(`Invalid enum namespace ${e}`);
      return;
    }
    let l = r.filter((m) => m.name === s)[0];
    if (l = this.enumDataOverride.filter((m) => m.name === s)[0] || l, !l) {
      console.warn(`No enum metadata for  ${e}`);
      return;
    }
    return {
      name: l.name,
      descr: l.description,
      values: l.values.map((m) => ({
        name: m.name,
        order: m.order,
        label: this.getEnumLabel(n, m.name, void 0, t),
        descr: this.getEnumDescr(n, m.name, void 0, t)
      }))
    };
  }
  /**
   * Gets the currently known enumerations.
   * @param ns - Namespace for the enumeration. By default this is SALAXY.ENUM
   */
  static getEnums(e = "SALAXY.ENUM") {
    return (this.getGeneratedEnumData(e) ?? []).map((t) => t.name);
  }
  static getGeneratedEnumData(e = "SALAXY.ENUM") {
    switch (e) {
      case "SALAXY.ENUM":
        return gr;
      case "SALAXY.ENUM_IR":
        return br;
      default:
        return null;
    }
  }
  static getFullEnumType(e) {
    return e.indexOf(".") >= 0 ? e : `SALAXY.ENUM.${this.upperCamelCase(e)}`;
  }
  static lowerCamelCase(e) {
    return e = "" + e, e.substr(0, 1).toLowerCase() + e.substr(1);
  }
  static upperCamelCase(e) {
    return e = "" + e, e.substr(0, 1).toUpperCase() + e.substr(1);
  }
};
vn.enumDataOverride = [
  {
    name: "NewEnumName",
    description: null,
    values: [
      { order: 0, name: "undefined" },
      { order: 1, name: "enum1" }
    ]
  },
  {
    name: "Culture",
    description: "Defines the supported cultures in the user interfaces and logic.",
    values: [
      { order: 0, name: "fi" },
      { order: 1, name: "en" }
    ]
  },
  {
    name: "SitemapVisibility",
    description: "Different values for visibility of sitemap node.",
    values: [
      { order: 0, name: "default" },
      { order: 1, name: "visible" },
      { order: 2, name: "hidden" },
      { order: 3, name: "readOnly" },
      { order: 4, name: "hiddenReadOnly" },
      { order: 5, name: "disabled" }
    ]
  },
  {
    name: "WorkflowEventUi",
    description: "This is really 'BootstrapStyle' on server-side code. WorkflowEventUi is autogen. Should be fixed: Added to GetApiEnumTypes.",
    values: [
      { order: 0, name: "default" },
      { order: 1, name: "primary" },
      { order: 2, name: "success" },
      { order: 3, name: "info" },
      { order: 4, name: "warning" },
      { order: 5, name: "danger" }
    ]
  },
  {
    name: "ExpensesVatRate",
    description: "VAT rates for expenses",
    values: [
      { order: 0, name: "undefined" },
      { order: 1, name: "tax255" },
      { order: 2, name: "tax24" },
      { order: 3, name: "tax14" },
      { order: 4, name: "tax10" },
      { order: 5, name: "tax0" },
      { order: 6, name: "none" },
      { order: 7, name: "other" },
      { order: 8, name: "multiple" }
    ]
  }
];
let H = vn;
var w = /* @__PURE__ */ ((a) => (a.Salary = "salary", a.SalaryAdditions = "salaryAdditions", a.SalaryCalc = "salaryCalc", a.Holidays = "holidays", a.Benefits = "benefits", a.Expenses = "expenses", a.Deductions = "deductions", a.Other = "other", a))(w || {}), sa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ra(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
var jr = { exports: {} };
(function(a, e) {
  (function(t, n) {
    a.exports = n();
  })(sa, function() {
    var t = 1e3, n = 6e4, i = 36e5, s = "millisecond", r = "second", l = "minute", o = "hour", u = "day", m = "week", p = "month", y = "quarter", S = "year", x = "date", v = "Invalid Date", T = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, L = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, K = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(A) {
      var j = ["th", "st", "nd", "rd"], f = A % 100;
      return "[" + A + (j[(f - 20) % 10] || j[f] || j[0]) + "]";
    } }, I = function(A, j, f) {
      var P = String(A);
      return !P || P.length >= j ? A : "" + Array(j + 1 - P.length).join(f) + A;
    }, se = { s: I, z: function(A) {
      var j = -A.utcOffset(), f = Math.abs(j), P = Math.floor(f / 60), g = f % 60;
      return (j <= 0 ? "+" : "-") + I(P, 2, "0") + ":" + I(g, 2, "0");
    }, m: function A(j, f) {
      if (j.date() < f.date())
        return -A(f, j);
      var P = 12 * (f.year() - j.year()) + (f.month() - j.month()), g = j.clone().add(P, p), C = f - g < 0, M = j.clone().add(P + (C ? -1 : 1), p);
      return +(-(P + (f - g) / (C ? g - M : M - g)) || 0);
    }, a: function(A) {
      return A < 0 ? Math.ceil(A) || 0 : Math.floor(A);
    }, p: function(A) {
      return { M: p, y: S, w: m, d: u, D: x, h: o, m: l, s: r, ms: s, Q: y }[A] || String(A || "").toLowerCase().replace(/s$/, "");
    }, u: function(A) {
      return A === void 0;
    } }, q = "en", O = {};
    O[q] = K;
    var E = "$isDayjsObject", b = function(A) {
      return A instanceof W || !(!A || !A[E]);
    }, V = function A(j, f, P) {
      var g;
      if (!j)
        return q;
      if (typeof j == "string") {
        var C = j.toLowerCase();
        O[C] && (g = C), f && (O[C] = f, g = C);
        var M = j.split("-");
        if (!g && M.length > 1)
          return A(M[0]);
      } else {
        var Y = j.name;
        O[Y] = j, g = Y;
      }
      return !P && g && (q = g), g || !P && q;
    }, N = function(A, j) {
      if (b(A))
        return A.clone();
      var f = typeof j == "object" ? j : {};
      return f.date = A, f.args = arguments, new W(f);
    }, D = se;
    D.l = V, D.i = b, D.w = function(A, j) {
      return N(A, { locale: j.$L, utc: j.$u, x: j.$x, $offset: j.$offset });
    };
    var W = function() {
      function A(f) {
        this.$L = V(f.locale, null, !0), this.parse(f), this.$x = this.$x || f.x || {}, this[E] = !0;
      }
      var j = A.prototype;
      return j.parse = function(f) {
        this.$d = function(P) {
          var g = P.date, C = P.utc;
          if (g === null)
            return /* @__PURE__ */ new Date(NaN);
          if (D.u(g))
            return /* @__PURE__ */ new Date();
          if (g instanceof Date)
            return new Date(g);
          if (typeof g == "string" && !/Z$/i.test(g)) {
            var M = g.match(T);
            if (M) {
              var Y = M[2] - 1 || 0, ne = (M[7] || "0").substring(0, 3);
              return C ? new Date(Date.UTC(M[1], Y, M[3] || 1, M[4] || 0, M[5] || 0, M[6] || 0, ne)) : new Date(M[1], Y, M[3] || 1, M[4] || 0, M[5] || 0, M[6] || 0, ne);
            }
          }
          return new Date(g);
        }(f), this.init();
      }, j.init = function() {
        var f = this.$d;
        this.$y = f.getFullYear(), this.$M = f.getMonth(), this.$D = f.getDate(), this.$W = f.getDay(), this.$H = f.getHours(), this.$m = f.getMinutes(), this.$s = f.getSeconds(), this.$ms = f.getMilliseconds();
      }, j.$utils = function() {
        return D;
      }, j.isValid = function() {
        return this.$d.toString() !== v;
      }, j.isSame = function(f, P) {
        var g = N(f);
        return this.startOf(P) <= g && g <= this.endOf(P);
      }, j.isAfter = function(f, P) {
        return N(f) < this.startOf(P);
      }, j.isBefore = function(f, P) {
        return this.endOf(P) < N(f);
      }, j.$g = function(f, P, g) {
        return D.u(f) ? this[P] : this.set(g, f);
      }, j.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, j.valueOf = function() {
        return this.$d.getTime();
      }, j.startOf = function(f, P) {
        var g = this, C = !!D.u(P) || P, M = D.p(f), Y = function(Ve, ye) {
          var De = D.w(g.$u ? Date.UTC(g.$y, ye, Ve) : new Date(g.$y, ye, Ve), g);
          return C ? De : De.endOf(u);
        }, ne = function(Ve, ye) {
          return D.w(g.toDate()[Ve].apply(g.toDate("s"), (C ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ye)), g);
        }, ue = this.$W, he = this.$M, Pe = this.$D, oa = "set" + (this.$u ? "UTC" : "");
        switch (M) {
          case S:
            return C ? Y(1, 0) : Y(31, 11);
          case p:
            return C ? Y(1, he) : Y(0, he + 1);
          case m:
            var Ye = this.$locale().weekStart || 0, _e = (ue < Ye ? ue + 7 : ue) - Ye;
            return Y(C ? Pe - _e : Pe + (6 - _e), he);
          case u:
          case x:
            return ne(oa + "Hours", 0);
          case o:
            return ne(oa + "Minutes", 1);
          case l:
            return ne(oa + "Seconds", 2);
          case r:
            return ne(oa + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, j.endOf = function(f) {
        return this.startOf(f, !1);
      }, j.$set = function(f, P) {
        var g, C = D.p(f), M = "set" + (this.$u ? "UTC" : ""), Y = (g = {}, g[u] = M + "Date", g[x] = M + "Date", g[p] = M + "Month", g[S] = M + "FullYear", g[o] = M + "Hours", g[l] = M + "Minutes", g[r] = M + "Seconds", g[s] = M + "Milliseconds", g)[C], ne = C === u ? this.$D + (P - this.$W) : P;
        if (C === p || C === S) {
          var ue = this.clone().set(x, 1);
          ue.$d[Y](ne), ue.init(), this.$d = ue.set(x, Math.min(this.$D, ue.daysInMonth())).$d;
        } else
          Y && this.$d[Y](ne);
        return this.init(), this;
      }, j.set = function(f, P) {
        return this.clone().$set(f, P);
      }, j.get = function(f) {
        return this[D.p(f)]();
      }, j.add = function(f, P) {
        var g, C = this;
        f = Number(f);
        var M = D.p(P), Y = function(he) {
          var Pe = N(C);
          return D.w(Pe.date(Pe.date() + Math.round(he * f)), C);
        };
        if (M === p)
          return this.set(p, this.$M + f);
        if (M === S)
          return this.set(S, this.$y + f);
        if (M === u)
          return Y(1);
        if (M === m)
          return Y(7);
        var ne = (g = {}, g[l] = n, g[o] = i, g[r] = t, g)[M] || 1, ue = this.$d.getTime() + f * ne;
        return D.w(ue, this);
      }, j.subtract = function(f, P) {
        return this.add(-1 * f, P);
      }, j.format = function(f) {
        var P = this, g = this.$locale();
        if (!this.isValid())
          return g.invalidDate || v;
        var C = f || "YYYY-MM-DDTHH:mm:ssZ", M = D.z(this), Y = this.$H, ne = this.$m, ue = this.$M, he = g.weekdays, Pe = g.months, oa = g.meridiem, Ye = function(ye, De, qe, la) {
          return ye && (ye[De] || ye(P, C)) || qe[De].slice(0, la);
        }, _e = function(ye) {
          return D.s(Y % 12 || 12, ye, "0");
        }, Ve = oa || function(ye, De, qe) {
          var la = ye < 12 ? "AM" : "PM";
          return qe ? la.toLowerCase() : la;
        };
        return C.replace(L, function(ye, De) {
          return De || function(qe) {
            switch (qe) {
              case "YY":
                return String(P.$y).slice(-2);
              case "YYYY":
                return D.s(P.$y, 4, "0");
              case "M":
                return ue + 1;
              case "MM":
                return D.s(ue + 1, 2, "0");
              case "MMM":
                return Ye(g.monthsShort, ue, Pe, 3);
              case "MMMM":
                return Ye(Pe, ue);
              case "D":
                return P.$D;
              case "DD":
                return D.s(P.$D, 2, "0");
              case "d":
                return String(P.$W);
              case "dd":
                return Ye(g.weekdaysMin, P.$W, he, 2);
              case "ddd":
                return Ye(g.weekdaysShort, P.$W, he, 3);
              case "dddd":
                return he[P.$W];
              case "H":
                return String(Y);
              case "HH":
                return D.s(Y, 2, "0");
              case "h":
                return _e(1);
              case "hh":
                return _e(2);
              case "a":
                return Ve(Y, ne, !0);
              case "A":
                return Ve(Y, ne, !1);
              case "m":
                return String(ne);
              case "mm":
                return D.s(ne, 2, "0");
              case "s":
                return String(P.$s);
              case "ss":
                return D.s(P.$s, 2, "0");
              case "SSS":
                return D.s(P.$ms, 3, "0");
              case "Z":
                return M;
            }
            return null;
          }(ye) || M.replace(":", "");
        });
      }, j.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, j.diff = function(f, P, g) {
        var C, M = this, Y = D.p(P), ne = N(f), ue = (ne.utcOffset() - this.utcOffset()) * n, he = this - ne, Pe = function() {
          return D.m(M, ne);
        };
        switch (Y) {
          case S:
            C = Pe() / 12;
            break;
          case p:
            C = Pe();
            break;
          case y:
            C = Pe() / 3;
            break;
          case m:
            C = (he - ue) / 6048e5;
            break;
          case u:
            C = (he - ue) / 864e5;
            break;
          case o:
            C = he / i;
            break;
          case l:
            C = he / n;
            break;
          case r:
            C = he / t;
            break;
          default:
            C = he;
        }
        return g ? C : D.a(C);
      }, j.daysInMonth = function() {
        return this.endOf(p).$D;
      }, j.$locale = function() {
        return O[this.$L];
      }, j.locale = function(f, P) {
        if (!f)
          return this.$L;
        var g = this.clone(), C = V(f, P, !0);
        return C && (g.$L = C), g;
      }, j.clone = function() {
        return D.w(this.$d, this);
      }, j.toDate = function() {
        return new Date(this.valueOf());
      }, j.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, j.toISOString = function() {
        return this.$d.toISOString();
      }, j.toString = function() {
        return this.$d.toUTCString();
      }, A;
    }(), ee = W.prototype;
    return N.prototype = ee, [["$ms", s], ["$s", r], ["$m", l], ["$H", o], ["$W", u], ["$M", p], ["$y", S], ["$D", x]].forEach(function(A) {
      ee[A[1]] = function(j) {
        return this.$g(j, A[0], A[1]);
      };
    }), N.extend = function(A, j) {
      return A.$i || (A(j, W, N), A.$i = !0), N;
    }, N.locale = V, N.isDayjs = b, N.unix = function(A) {
      return N(1e3 * A);
    }, N.en = O[q], N.Ls = O, N.p = {}, N;
  });
})(jr);
var Ro = jr.exports;
const J = /* @__PURE__ */ ra(Ro);
var Sr = { exports: {} };
(function(a, e) {
  (function(t, n) {
    a.exports = n();
  })(sa, function() {
    var t = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, n = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, i = /\d\d/, s = /\d\d?/, r = /\d*[^-_:/,()\s\d]+/, l = {}, o = function(v) {
      return (v = +v) + (v > 68 ? 1900 : 2e3);
    }, u = function(v) {
      return function(T) {
        this[v] = +T;
      };
    }, m = [/[+-]\d\d:?(\d\d)?|Z/, function(v) {
      (this.zone || (this.zone = {})).offset = function(T) {
        if (!T || T === "Z")
          return 0;
        var L = T.match(/([+-]|\d\d)/g), K = 60 * L[1] + (+L[2] || 0);
        return K === 0 ? 0 : L[0] === "+" ? -K : K;
      }(v);
    }], p = function(v) {
      var T = l[v];
      return T && (T.indexOf ? T : T.s.concat(T.f));
    }, y = function(v, T) {
      var L, K = l.meridiem;
      if (K) {
        for (var I = 1; I <= 24; I += 1)
          if (v.indexOf(K(I, 0, T)) > -1) {
            L = I > 12;
            break;
          }
      } else
        L = v === (T ? "pm" : "PM");
      return L;
    }, S = { A: [r, function(v) {
      this.afternoon = y(v, !1);
    }], a: [r, function(v) {
      this.afternoon = y(v, !0);
    }], S: [/\d/, function(v) {
      this.milliseconds = 100 * +v;
    }], SS: [i, function(v) {
      this.milliseconds = 10 * +v;
    }], SSS: [/\d{3}/, function(v) {
      this.milliseconds = +v;
    }], s: [s, u("seconds")], ss: [s, u("seconds")], m: [s, u("minutes")], mm: [s, u("minutes")], H: [s, u("hours")], h: [s, u("hours")], HH: [s, u("hours")], hh: [s, u("hours")], D: [s, u("day")], DD: [i, u("day")], Do: [r, function(v) {
      var T = l.ordinal, L = v.match(/\d+/);
      if (this.day = L[0], T)
        for (var K = 1; K <= 31; K += 1)
          T(K).replace(/\[|\]/g, "") === v && (this.day = K);
    }], M: [s, u("month")], MM: [i, u("month")], MMM: [r, function(v) {
      var T = p("months"), L = (p("monthsShort") || T.map(function(K) {
        return K.slice(0, 3);
      })).indexOf(v) + 1;
      if (L < 1)
        throw new Error();
      this.month = L % 12 || L;
    }], MMMM: [r, function(v) {
      var T = p("months").indexOf(v) + 1;
      if (T < 1)
        throw new Error();
      this.month = T % 12 || T;
    }], Y: [/[+-]?\d+/, u("year")], YY: [i, function(v) {
      this.year = o(v);
    }], YYYY: [/\d{4}/, u("year")], Z: m, ZZ: m };
    function x(v) {
      var T, L;
      T = v, L = l && l.formats;
      for (var K = (v = T.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(V, N, D) {
        var W = D && D.toUpperCase();
        return N || L[D] || t[D] || L[W].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(ee, A, j) {
          return A || j.slice(1);
        });
      })).match(n), I = K.length, se = 0; se < I; se += 1) {
        var q = K[se], O = S[q], E = O && O[0], b = O && O[1];
        K[se] = b ? { regex: E, parser: b } : q.replace(/^\[|\]$/g, "");
      }
      return function(V) {
        for (var N = {}, D = 0, W = 0; D < I; D += 1) {
          var ee = K[D];
          if (typeof ee == "string")
            W += ee.length;
          else {
            var A = ee.regex, j = ee.parser, f = V.slice(W), P = A.exec(f)[0];
            j.call(N, P), V = V.replace(P, "");
          }
        }
        return function(g) {
          var C = g.afternoon;
          if (C !== void 0) {
            var M = g.hours;
            C ? M < 12 && (g.hours += 12) : M === 12 && (g.hours = 0), delete g.afternoon;
          }
        }(N), N;
      };
    }
    return function(v, T, L) {
      L.p.customParseFormat = !0, v && v.parseTwoDigitYear && (o = v.parseTwoDigitYear);
      var K = T.prototype, I = K.parse;
      K.parse = function(se) {
        var q = se.date, O = se.utc, E = se.args;
        this.$u = O;
        var b = E[1];
        if (typeof b == "string") {
          var V = E[2] === !0, N = E[3] === !0, D = V || N, W = E[2];
          N && (W = E[2]), l = this.$locale(), !V && W && (l = L.Ls[W]), this.$d = function(f, P, g) {
            try {
              if (["x", "X"].indexOf(P) > -1)
                return new Date((P === "X" ? 1e3 : 1) * f);
              var C = x(P)(f), M = C.year, Y = C.month, ne = C.day, ue = C.hours, he = C.minutes, Pe = C.seconds, oa = C.milliseconds, Ye = C.zone, _e = /* @__PURE__ */ new Date(), Ve = ne || (M || Y ? 1 : _e.getDate()), ye = M || _e.getFullYear(), De = 0;
              M && !Y || (De = Y > 0 ? Y - 1 : _e.getMonth());
              var qe = ue || 0, la = he || 0, ot = Pe || 0, lt = oa || 0;
              return Ye ? new Date(Date.UTC(ye, De, Ve, qe, la, ot, lt + 60 * Ye.offset * 1e3)) : g ? new Date(Date.UTC(ye, De, Ve, qe, la, ot, lt)) : new Date(ye, De, Ve, qe, la, ot, lt);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(q, b, O), this.init(), W && W !== !0 && (this.$L = this.locale(W).$L), D && q != this.format(b) && (this.$d = /* @__PURE__ */ new Date("")), l = {};
        } else if (b instanceof Array)
          for (var ee = b.length, A = 1; A <= ee; A += 1) {
            E[1] = b[A - 1];
            var j = L.apply(this, E);
            if (j.isValid()) {
              this.$d = j.$d, this.$L = j.$L, this.init();
              break;
            }
            A === ee && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          I.call(this, se);
      };
    };
  });
})(Sr);
var Bo = Sr.exports;
const Tr = /* @__PURE__ */ ra(Bo);
var xr = { exports: {} };
(function(a, e) {
  (function(t, n) {
    a.exports = n();
  })(sa, function() {
    return function(t, n) {
      var i = n.prototype, s = i.format;
      i.format = function(r) {
        var l = this, o = this.$locale();
        if (!this.isValid())
          return s.bind(this)(r);
        var u = this.$utils(), m = (r || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(p) {
          switch (p) {
            case "Q":
              return Math.ceil((l.$M + 1) / 3);
            case "Do":
              return o.ordinal(l.$D);
            case "gggg":
              return l.weekYear();
            case "GGGG":
              return l.isoWeekYear();
            case "wo":
              return o.ordinal(l.week(), "W");
            case "w":
            case "ww":
              return u.s(l.week(), p === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return u.s(l.isoWeek(), p === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return u.s(String(l.$H === 0 ? 24 : l.$H), p === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(l.$d.getTime() / 1e3);
            case "x":
              return l.$d.getTime();
            case "z":
              return "[" + l.offsetName() + "]";
            case "zzz":
              return "[" + l.offsetName("long") + "]";
            default:
              return p;
          }
        });
        return s.bind(this)(m);
      };
    };
  });
})(xr);
var Vo = xr.exports;
const Er = /* @__PURE__ */ ra(Vo);
var Ar = { exports: {} };
(function(a, e) {
  (function(t, n) {
    a.exports = n();
  })(sa, function() {
    var t, n, i = 1e3, s = 6e4, r = 36e5, l = 864e5, o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, m = 2628e6, p = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, y = { years: u, months: m, days: l, hours: r, minutes: s, seconds: i, milliseconds: 1, weeks: 6048e5 }, S = function(O) {
      return O instanceof se;
    }, x = function(O, E, b) {
      return new se(O, b, E.$l);
    }, v = function(O) {
      return n.p(O) + "s";
    }, T = function(O) {
      return O < 0;
    }, L = function(O) {
      return T(O) ? Math.ceil(O) : Math.floor(O);
    }, K = function(O) {
      return Math.abs(O);
    }, I = function(O, E) {
      return O ? T(O) ? { negative: !0, format: "" + K(O) + E } : { negative: !1, format: "" + O + E } : { negative: !1, format: "" };
    }, se = function() {
      function O(b, V, N) {
        var D = this;
        if (this.$d = {}, this.$l = N, b === void 0 && (this.$ms = 0, this.parseFromMilliseconds()), V)
          return x(b * y[v(V)], this);
        if (typeof b == "number")
          return this.$ms = b, this.parseFromMilliseconds(), this;
        if (typeof b == "object")
          return Object.keys(b).forEach(function(A) {
            D.$d[v(A)] = b[A];
          }), this.calMilliseconds(), this;
        if (typeof b == "string") {
          var W = b.match(p);
          if (W) {
            var ee = W.slice(2).map(function(A) {
              return A != null ? Number(A) : 0;
            });
            return this.$d.years = ee[0], this.$d.months = ee[1], this.$d.weeks = ee[2], this.$d.days = ee[3], this.$d.hours = ee[4], this.$d.minutes = ee[5], this.$d.seconds = ee[6], this.calMilliseconds(), this;
          }
        }
        return this;
      }
      var E = O.prototype;
      return E.calMilliseconds = function() {
        var b = this;
        this.$ms = Object.keys(this.$d).reduce(function(V, N) {
          return V + (b.$d[N] || 0) * y[N];
        }, 0);
      }, E.parseFromMilliseconds = function() {
        var b = this.$ms;
        this.$d.years = L(b / u), b %= u, this.$d.months = L(b / m), b %= m, this.$d.days = L(b / l), b %= l, this.$d.hours = L(b / r), b %= r, this.$d.minutes = L(b / s), b %= s, this.$d.seconds = L(b / i), b %= i, this.$d.milliseconds = b;
      }, E.toISOString = function() {
        var b = I(this.$d.years, "Y"), V = I(this.$d.months, "M"), N = +this.$d.days || 0;
        this.$d.weeks && (N += 7 * this.$d.weeks);
        var D = I(N, "D"), W = I(this.$d.hours, "H"), ee = I(this.$d.minutes, "M"), A = this.$d.seconds || 0;
        this.$d.milliseconds && (A += this.$d.milliseconds / 1e3, A = Math.round(1e3 * A) / 1e3);
        var j = I(A, "S"), f = b.negative || V.negative || D.negative || W.negative || ee.negative || j.negative, P = W.format || ee.format || j.format ? "T" : "", g = (f ? "-" : "") + "P" + b.format + V.format + D.format + P + W.format + ee.format + j.format;
        return g === "P" || g === "-P" ? "P0D" : g;
      }, E.toJSON = function() {
        return this.toISOString();
      }, E.format = function(b) {
        var V = b || "YYYY-MM-DDTHH:mm:ss", N = { Y: this.$d.years, YY: n.s(this.$d.years, 2, "0"), YYYY: n.s(this.$d.years, 4, "0"), M: this.$d.months, MM: n.s(this.$d.months, 2, "0"), D: this.$d.days, DD: n.s(this.$d.days, 2, "0"), H: this.$d.hours, HH: n.s(this.$d.hours, 2, "0"), m: this.$d.minutes, mm: n.s(this.$d.minutes, 2, "0"), s: this.$d.seconds, ss: n.s(this.$d.seconds, 2, "0"), SSS: n.s(this.$d.milliseconds, 3, "0") };
        return V.replace(o, function(D, W) {
          return W || String(N[D]);
        });
      }, E.as = function(b) {
        return this.$ms / y[v(b)];
      }, E.get = function(b) {
        var V = this.$ms, N = v(b);
        return N === "milliseconds" ? V %= 1e3 : V = N === "weeks" ? L(V / y[N]) : this.$d[N], V || 0;
      }, E.add = function(b, V, N) {
        var D;
        return D = V ? b * y[v(V)] : S(b) ? b.$ms : x(b, this).$ms, x(this.$ms + D * (N ? -1 : 1), this);
      }, E.subtract = function(b, V) {
        return this.add(b, V, !0);
      }, E.locale = function(b) {
        var V = this.clone();
        return V.$l = b, V;
      }, E.clone = function() {
        return x(this.$ms, this);
      }, E.humanize = function(b) {
        return t().add(this.$ms, "ms").locale(this.$l).fromNow(!b);
      }, E.valueOf = function() {
        return this.asMilliseconds();
      }, E.milliseconds = function() {
        return this.get("milliseconds");
      }, E.asMilliseconds = function() {
        return this.as("milliseconds");
      }, E.seconds = function() {
        return this.get("seconds");
      }, E.asSeconds = function() {
        return this.as("seconds");
      }, E.minutes = function() {
        return this.get("minutes");
      }, E.asMinutes = function() {
        return this.as("minutes");
      }, E.hours = function() {
        return this.get("hours");
      }, E.asHours = function() {
        return this.as("hours");
      }, E.days = function() {
        return this.get("days");
      }, E.asDays = function() {
        return this.as("days");
      }, E.weeks = function() {
        return this.get("weeks");
      }, E.asWeeks = function() {
        return this.as("weeks");
      }, E.months = function() {
        return this.get("months");
      }, E.asMonths = function() {
        return this.as("months");
      }, E.years = function() {
        return this.get("years");
      }, E.asYears = function() {
        return this.as("years");
      }, O;
    }(), q = function(O, E, b) {
      return O.add(E.years() * b, "y").add(E.months() * b, "M").add(E.days() * b, "d").add(E.hours() * b, "h").add(E.minutes() * b, "m").add(E.seconds() * b, "s").add(E.milliseconds() * b, "ms");
    };
    return function(O, E, b) {
      t = b, n = b().$utils(), b.duration = function(D, W) {
        var ee = b.locale();
        return x(D, { $l: ee }, W);
      }, b.isDuration = S;
      var V = E.prototype.add, N = E.prototype.subtract;
      E.prototype.add = function(D, W) {
        return S(D) ? q(this, D, 1) : V.bind(this)(D, W);
      }, E.prototype.subtract = function(D, W) {
        return S(D) ? q(this, D, -1) : N.bind(this)(D, W);
      };
    };
  });
})(Ar);
var Ko = Ar.exports;
const Pr = /* @__PURE__ */ ra(Ko);
var wr = { exports: {} };
(function(a, e) {
  (function(t, n) {
    a.exports = n();
  })(sa, function() {
    var t = "day";
    return function(n, i, s) {
      var r = function(u) {
        return u.add(4 - u.isoWeekday(), t);
      }, l = i.prototype;
      l.isoWeekYear = function() {
        return r(this).year();
      }, l.isoWeek = function(u) {
        if (!this.$utils().u(u))
          return this.add(7 * (u - this.isoWeek()), t);
        var m, p, y, S, x = r(this), v = (m = this.isoWeekYear(), p = this.$u, y = (p ? s.utc : s)().year(m).startOf("year"), S = 4 - y.isoWeekday(), y.isoWeekday() > 4 && (S += 7), y.add(S, t));
        return x.diff(v, "week") + 1;
      }, l.isoWeekday = function(u) {
        return this.$utils().u(u) ? this.day() || 7 : this.day(this.day() % 7 ? u : u - 7);
      };
      var o = l.startOf;
      l.startOf = function(u, m) {
        var p = this.$utils(), y = !!p.u(m) || m;
        return p.p(u) === "isoweek" ? y ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : o.bind(this)(u, m);
      };
    };
  });
})(wr);
var Uo = wr.exports;
const Fr = /* @__PURE__ */ ra(Uo);
var Dr = { exports: {} };
(function(a, e) {
  (function(t, n) {
    a.exports = n();
  })(sa, function() {
    return function(t, n) {
      n.prototype.isSameOrBefore = function(i, s) {
        return this.isSame(i, s) || this.isBefore(i, s);
      };
    };
  });
})(Dr);
var Ho = Dr.exports;
const Cr = /* @__PURE__ */ ra(Ho);
var Ir = { exports: {} };
(function(a, e) {
  (function(t, n) {
    a.exports = n();
  })(sa, function() {
    return function(t, n) {
      n.prototype.isSameOrAfter = function(i, s) {
        return this.isSame(i, s) || this.isAfter(i, s);
      };
    };
  });
})(Ir);
var Wo = Ir.exports;
const Lr = /* @__PURE__ */ ra(Wo);
var Mr = { exports: {} };
(function(a, e) {
  (function(t, n) {
    a.exports = n();
  })(sa, function() {
    var t = "minute", n = /[+-]\d\d(?::?\d\d)?/g, i = /([+-]|\d\d)/g;
    return function(s, r, l) {
      var o = r.prototype;
      l.utc = function(v) {
        var T = { date: v, utc: !0, args: arguments };
        return new r(T);
      }, o.utc = function(v) {
        var T = l(this.toDate(), { locale: this.$L, utc: !0 });
        return v ? T.add(this.utcOffset(), t) : T;
      }, o.local = function() {
        return l(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var u = o.parse;
      o.parse = function(v) {
        v.utc && (this.$u = !0), this.$utils().u(v.$offset) || (this.$offset = v.$offset), u.call(this, v);
      };
      var m = o.init;
      o.init = function() {
        if (this.$u) {
          var v = this.$d;
          this.$y = v.getUTCFullYear(), this.$M = v.getUTCMonth(), this.$D = v.getUTCDate(), this.$W = v.getUTCDay(), this.$H = v.getUTCHours(), this.$m = v.getUTCMinutes(), this.$s = v.getUTCSeconds(), this.$ms = v.getUTCMilliseconds();
        } else
          m.call(this);
      };
      var p = o.utcOffset;
      o.utcOffset = function(v, T) {
        var L = this.$utils().u;
        if (L(v))
          return this.$u ? 0 : L(this.$offset) ? p.call(this) : this.$offset;
        if (typeof v == "string" && (v = function(q) {
          q === void 0 && (q = "");
          var O = q.match(n);
          if (!O)
            return null;
          var E = ("" + O[0]).match(i) || ["-", 0, 0], b = E[0], V = 60 * +E[1] + +E[2];
          return V === 0 ? 0 : b === "+" ? V : -V;
        }(v), v === null))
          return this;
        var K = Math.abs(v) <= 16 ? 60 * v : v, I = this;
        if (T)
          return I.$offset = K, I.$u = v === 0, I;
        if (v !== 0) {
          var se = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (I = this.local().add(K + se, t)).$offset = K, I.$x.$localOffset = se;
        } else
          I = this.utc();
        return I;
      };
      var y = o.format;
      o.format = function(v) {
        var T = v || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return y.call(this, T);
      }, o.valueOf = function() {
        var v = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * v;
      }, o.isUTC = function() {
        return !!this.$u;
      }, o.toISOString = function() {
        return this.toDate().toISOString();
      }, o.toString = function() {
        return this.toDate().toUTCString();
      };
      var S = o.toDate;
      o.toDate = function(v) {
        return v === "s" && this.$offset ? l(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : S.call(this);
      };
      var x = o.diff;
      o.diff = function(v, T, L) {
        if (v && this.$u === v.$u)
          return x.call(this, v, T, L);
        var K = this.local(), I = l(v).local();
        return x.call(K, I, T, L);
      };
    };
  });
})(Mr);
var Yo = Mr.exports;
const Nr = /* @__PURE__ */ ra(Yo);
var Or = { exports: {} };
(function(a, e) {
  (function(t, n) {
    a.exports = n();
  })(sa, function() {
    var t = "month", n = "quarter";
    return function(i, s) {
      var r = s.prototype;
      r.quarter = function(u) {
        return this.$utils().u(u) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (u - 1));
      };
      var l = r.add;
      r.add = function(u, m) {
        return u = Number(u), this.$utils().p(m) === n ? this.add(3 * u, t) : l.bind(this)(u, m);
      };
      var o = r.startOf;
      r.startOf = function(u, m) {
        var p = this.$utils(), y = !!p.u(m) || m;
        if (p.p(u) === n) {
          var S = this.quarter() - 1;
          return y ? this.month(3 * S).startOf(t).startOf("day") : this.month(3 * S + 2).endOf(t).endOf("day");
        }
        return o.bind(this)(u, m);
      };
    };
  });
})(Or);
var $o = Or.exports;
const Rr = /* @__PURE__ */ ra($o), Br = [
  {
    year: 2014,
    holidays: {
      newYearsDay: {
        date: "2014-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2014-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2014-04-18",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2014-04-19",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2014-04-20",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2014-04-21",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2014-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2014-05-29",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2014-06-08",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2014-06-20",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2014-06-21",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2014-11-22",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2014-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2014-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2014-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2014-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  },
  {
    year: 2015,
    holidays: {
      newYearsDay: {
        date: "2015-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2015-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2015-04-03",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2015-04-04",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2015-04-05",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2015-04-06",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2015-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2015-05-14",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2015-05-24",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2015-06-19",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2015-06-20",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2015-11-21",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2015-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2015-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2015-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2015-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  },
  {
    year: 2016,
    holidays: {
      newYearsDay: {
        date: "2016-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2016-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2016-03-25",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2016-03-26",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2016-03-27",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2016-03-28",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2016-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2016-05-05",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2016-05-15",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2016-06-24",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2016-06-25",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2016-11-19",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2016-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2016-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2016-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2016-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  },
  {
    year: 2017,
    holidays: {
      newYearsDay: {
        date: "2017-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2017-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2017-04-14",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2017-04-15",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2017-04-16",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2017-04-17",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2017-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2017-05-25",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2017-06-04",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2017-06-23",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2017-06-24",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2017-11-25",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2017-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2017-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2017-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2017-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  },
  {
    year: 2018,
    holidays: {
      newYearsDay: {
        date: "2018-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2018-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2018-03-30",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2018-03-31",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2018-04-01",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2018-04-02",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2018-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2018-05-10",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2018-05-20",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2018-06-22",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2018-06-23",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2018-11-24",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2018-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2018-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2018-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2018-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  },
  {
    year: 2019,
    holidays: {
      newYearsDay: {
        date: "2019-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2019-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2019-04-19",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2019-04-20",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2019-04-21",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2019-04-22",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2019-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2019-05-30",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2019-06-09",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2019-06-21",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2019-06-22",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2019-11-23",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2019-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2019-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2019-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2019-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  },
  {
    year: 2020,
    holidays: {
      newYearsDay: {
        date: "2020-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2020-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2020-04-10",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2020-04-11",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2020-04-12",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2020-04-13",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2020-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2020-05-21",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2020-05-31",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2020-06-19",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2020-06-20",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2020-11-21",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2020-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2020-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2020-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2020-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  },
  {
    year: 2021,
    holidays: {
      newYearsDay: {
        date: "2021-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2021-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2021-04-02",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2021-04-03",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2021-04-04",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2021-04-05",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2021-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2021-05-13",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2021-05-23",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2021-06-25",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2021-06-26",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2021-11-20",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2021-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2021-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2021-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2021-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  },
  {
    year: 2022,
    holidays: {
      newYearsDay: {
        date: "2022-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2022-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2022-04-15",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2022-04-16",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2022-04-17",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2022-04-18",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2022-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2022-05-26",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2022-06-05",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2022-06-24",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2022-06-25",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2022-11-19",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2022-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2022-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2022-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2022-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  },
  {
    year: 2023,
    holidays: {
      newYearsDay: {
        date: "2023-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2023-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2023-04-07",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2023-04-08",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2023-04-09",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2023-04-10",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2023-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2023-05-18",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2023-05-28",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2023-06-23",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2023-06-24",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2023-11-25",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2023-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2023-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2023-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2023-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  },
  {
    year: 2024,
    holidays: {
      newYearsDay: {
        date: "2024-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2024-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2024-03-29",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2024-03-30",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2024-03-31",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2024-04-01",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2024-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2024-05-09",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2024-05-19",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2024-06-21",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2024-06-22",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2024-11-23",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2024-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2024-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2024-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2024-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  },
  {
    year: 2025,
    holidays: {
      newYearsDay: {
        date: "2025-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2025-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2025-04-18",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2025-04-19",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2025-04-20",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2025-04-21",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2025-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2025-05-29",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2025-06-08",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2025-06-20",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2025-06-21",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2025-11-22",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2025-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2025-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2025-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2025-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  },
  {
    year: 2026,
    holidays: {
      newYearsDay: {
        date: "2026-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2026-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2026-04-03",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2026-04-04",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2026-04-05",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2026-04-06",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2026-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2026-05-14",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2026-05-24",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2026-06-19",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2026-06-20",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2026-11-21",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2026-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2026-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2026-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2026-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  },
  {
    year: 2027,
    holidays: {
      newYearsDay: {
        date: "2027-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2027-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2027-03-26",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2027-03-27",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2027-03-28",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2027-03-29",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2027-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2027-05-06",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2027-05-16",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2027-06-25",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2027-06-26",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2027-11-20",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2027-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2027-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2027-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2027-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  },
  {
    year: 2028,
    holidays: {
      newYearsDay: {
        date: "2028-01-01",
        holiday: "newYearsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "uudenvuodenpäivä",
        name: "New Year's Day"
      },
      epiphany: {
        date: "2028-01-06",
        holiday: "epiphany",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "loppiainen",
        name: "Epiphany"
      },
      goodFriday: {
        date: "2028-04-14",
        holiday: "goodFriday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pitkäperjantai",
        name: "Good Friday"
      },
      easterSaturday: {
        date: "2028-04-15",
        holiday: "easterSaturday",
        holidayGroups: [
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäislauantai",
        name: "Easter Saturday"
      },
      easterSunday: {
        date: "2028-04-16",
        holiday: "easterSunday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pääsiäispäivä",
        name: "Easter Sunday"
      },
      easterMonday: {
        date: "2028-04-17",
        holiday: "easterMonday",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. pääsiäispäivä",
        name: "Easter Monday"
      },
      mayDay: {
        date: "2028-05-01",
        holiday: "mayDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "vappu",
        name: "May Day"
      },
      ascensionDay: {
        date: "2028-05-25",
        holiday: "ascensionDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "helatorstai",
        name: "Ascension Day"
      },
      pentecost: {
        date: "2028-06-04",
        holiday: "pentecost",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "helluntaipäivä",
        name: "Pentecost"
      },
      midsummerEve: {
        date: "2028-06-23",
        holiday: "midsummerEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "juhannusaatto",
        name: "Midsummer Eve"
      },
      midsummerDay: {
        date: "2028-06-24",
        holiday: "midsummerDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "juhannuspäivä",
        name: "Midsummer Day"
      },
      allSaintsDay: {
        date: "2028-11-25",
        holiday: "allSaintsDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "pyhäinpäivä",
        name: "All Saints' Day"
      },
      independenceDay: {
        date: "2028-12-06",
        holiday: "independenceDay",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "itsenäisyyspäivä",
        name: "Independence Day"
      },
      christmasEve: {
        date: "2028-12-24",
        holiday: "christmasEve",
        holidayGroups: [
          "official",
          "holiday"
        ],
        localName: "jouluaatto",
        name: "Christmas Eve"
      },
      christmasDay: {
        date: "2028-12-25",
        holiday: "christmasDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "joulupäivä",
        name: "Christmas Day"
      },
      stStephensDay: {
        date: "2028-12-26",
        holiday: "stStephensDay",
        holidayGroups: [
          "official",
          "nonBanking",
          "holiday"
        ],
        localName: "2. joulupäivä",
        name: "St. Stephen's Day"
      }
    }
  }
];
J.extend(Tr);
J.extend(Er);
J.extend(Pr);
J.extend(Fr);
J.extend(Cr);
J.extend(Lr);
J.extend(Nr);
J.extend(Rr);
class c {
  /**
   * Gets an object and returns it as the date format that is stored in the data structure with ISO 8601 format.
   *
   * @param datelyObject - Object that should be converted to Salaxy date: A string, JS Date object, Day.js etc.
   *
   * @returns The date in simplest possible ISO 8601 compliant format "YYYY-MM-DD", undefined if empty, not valid date etc.
   */
  static asDate(e) {
    const t = this.getDayJs(e);
    return t ? t.format("YYYY-MM-DD") : void 0;
  }
  /**
   * Gets a date based on year, month and day (1-based).
   * NOTE: Unlike Date() constructor or dayjs() constructor, all numbers are 1-based:
   * (2017, 2, 2) results to "2017-02-02" and not "2017-01-01T22:00:00.000Z" like in those constructors.
   *
   * @param year Year component of the date or "today" for today's year.
   * @param month Month component of the date (1-12) or "today" for today's month.
   * @param day Day of month component of the date (1-31) or "today" for today's day of month.
   */
  static getDate(e, t, n) {
    if (e = e === "today" ? c.getDayJs("today").year() : e, t = t === "today" ? c.getDayJs("today").month() : t - 1, n = n === "today" ? c.getDayJs("today").date() : n, !(!n || t == null || t < 0 || t > 11 || !e))
      return this.asDate([e, t, n]);
  }
  /**
   * Constructs a DatelyObject (DayJs) from any DayJs compatible object
   * @param timestamp any DayJs compatible object to construct a DatelyObject.
   * @returns DatelyObject
   */
  static getDatelyObject(e) {
    return c.getDayJs(e);
  }
  /**
   * Converts the date to a JavaScript Date. Please note, that also time part is returned.
   * @param  datelyObject - Object that should be converted: A string, JS Date object, DayJs etc.
   *
   * @returns JavaScript date corresponding to input or null.
   */
  static asJSDate(e) {
    const t = this.getDayJs(e);
    return t ? t.toDate() : void 0;
  }
  /**
   * Checks whether a string is in ISO format.
   *
   * @param dateProspect Value that is evaluated.
   * @param required If set to true, the value is required. If required is null the false will be returned.
   * @param format Date or datetime format. Default is ISO_8601 (ISO datetime). TODO other supported formats.
   *
   * @returns True if the given date is in the correct format.
   */
  static isValidDateTime(e, t = !1, n = void 0) {
    if (!e)
      return !t;
    let i;
    return n ? i = J(e, n, !0) : i = J(e), i ? i.isValid() : !1;
  }
  /**
   * Parses a date. In ISO format by default.
   *
   * @param dateProspect Value that is parsed.
   * @param format Date or datetime format. Default is ISO_8601 (ISO datetime).
   * Note that result is just a date (not datetime).
   *
   * @returns True if the given date is in the correct format.
   */
  static parseDate(e, t = void 0) {
    if (e) {
      let n;
      return t ? n = J(e, t, !0) : n = J(e), c.asDate(n);
    } else
      return;
  }
  /** Get the date of today as ISO 8601 string format (YYYY-MM-DD)  */
  static getToday() {
    return this.asDate(J());
  }
  /**
   * Returns Day.Js -object.
   *
   * @param datelyObject Object that should be converted to Day.js -object: A string, JS Date object, Day.js, Number[3] etc.
   * @param allowInvalid If true and datelyObject is faulty string, returns invalid Day.js -object object. By default returns undefined, if parameter cannot be parsed.
   *
   * @returns A Day.js -object or undefined.
   */
  static getDayJs(e, t = !1) {
    if (!e)
      return;
    let n;
    if (e instanceof Date)
      n = J(e);
    else if (Number.isInteger(e))
      n = J(e);
    else if (Array.isArray(e)) {
      let i;
      switch (e.length) {
        case 3:
          i = new Date(e[0], e[1], e[2]);
          break;
        case 5:
          i = new Date(e[0], e[1], e[2], e[3], e[4]);
          break;
        case 6:
          i = new Date(e[0], e[1], e[2], e[3], e[4], e[5]);
          break;
        default:
          return;
      }
      n = J(i);
    } else
      e === "today" ? (n = J(/* @__PURE__ */ new Date()), n = n.startOf("day")) : e === "yesterday" ? (n = J(/* @__PURE__ */ new Date()), n = n.startOf("day"), n = n.add(-1, "day")) : e === "tomorrow" ? (n = J(/* @__PURE__ */ new Date()), n = n.startOf("day"), n = n.add(1, "day")) : n = J(e);
    if (n.isValid() || t)
      return n;
  }
  /**
   * Returns the duration  object. If parameter is empty or null, defaults to Today (not Now).
   *
   * @param startDatelyObject Duration start that is parsed using getDayJs().
   * Null before conversion defaults to today. Invalid objects result to invalid duration.
   * @param endDatelyObject Duration start that is parsed using getDayJs().
   * Null before conversion defaults to today. Invalid objects result to invalid duration.
   *
   * @returns A Duration object, which may also be invalid
   */
  static getDuration(e, t) {
    const n = this.getDayJs(e, !0) || this.getDayJs("today"), i = this.getDayJs(t, !0) || this.getDayJs("today");
    return J.duration(i.diff(n));
  }
  /**
   * Gets a date range based on start and end dates.
   * Days count is calculated using getWorkdays() (Add parameter if you need other day count methods).
   *
   * @param start DateRange start, DatelyObject that should be converted to Salaxy date: A string, JS Date object, Day.js  etc.
   * @param end DateRange end, DatelyObject that should be converted to Salaxy date: A string, JS Date object, Day.js etc.
   *
   * @returns DateRange based on start and end dates.
   */
  static getDateRange(e, t) {
    const n = {
      start: this.asDate(e),
      end: this.asDate(t)
    };
    return n.daysCount = this.getWorkdays(n.start, n.end).length, n;
  }
  /**
   * Returns earliest workday counted from startDate parameter. If startDate is workday, it is returned.
   * @param startDate start date, where to start searching a work day
   * @returns Workday in simple ISO format YYYY-MM-DD
   */
  static getWorkday(e) {
    let t = c.getDayJs(c.asDate(e));
    if (!t)
      return;
    let n = 365;
    for (; n > 0; ) {
      if (c.isWorkday(t))
        return c.asDate(t);
      if (n -= 1, n == 0)
        return;
      t = t.add(1, "day");
    }
  }
  /**
   * Gets the workdays between two dates including both days.
   * Returns empty array if there is no start or if end is before start.
   * Returns 1 day if there is no end: we assume that the user selected just one day.
   *
   * @param start A dately value as the start date (a string, JS Date object, DayJs etc.).
   * @param end Corresponding end date.
   * @param holidayGroup The holiday group for defining which days not to count as working day. The default group is Holiday.
   *
   * @returns The work days between the two dates (inclusive).
   */
  static getWorkdays(e, t, n = ma.Holiday) {
    let i = this.asDate(e);
    const s = this.asDate(t) || i;
    if (!i)
      return [];
    const r = [];
    for (; i <= s; )
      this.isWorkday(i, n) && r.push(i), i = this.asDate(this.getDayJs(i).add(1, "day"));
    return r;
  }
  /**
   * Gets the vacation days (6 day week Mon-Sat) between two dates including both days.
   * Returns empty array if there is no start or if end is before start.
   * Returns 1 day if there is no end: we assume that the user selected just one day.
   *
   * @param start A dately value as the start date (a string, JS Date object, DayJs etc.).
   * @param end Corresponding end date.
   * @param holidayGroup The holiday group for defining which days not to count as working day. The default group is Holiday.
   *
   * @returns The work days between the two dates (inclusive).
   */
  static getVacationDays(e, t, n = ma.Holiday) {
    let i = this.asDate(e);
    const s = this.asDate(t) || i;
    if (!i)
      return [];
    const r = [];
    for (; i && s && i <= s; )
      this.isVacationday(i, n) && r.push(i), i = this.asDate(this.getDayJs(i).add(1, "day"));
    return r;
  }
  /**
   * Gets a formatted range of two dates.
   *
   * @param startDate A dately value as the start date (a string, JS Date object, DayJs etc.).
   * @param endDate Corresponding end date.
   *
   * @returns A date range string with possible formats:
   * "12. - 25.11.2019", "12.11. - 02.12.2019", "12.11.2019 - 12.01.2020", "12.01.2020 -" or "- 12.01.2020".
   */
  static getFormattedRange(e, t) {
    const n = "DD.MM.YYYY", i = this.getDayJs(e), s = this.getDayJs(t);
    if (!i && !s)
      return "-";
    if (!i && s)
      return " - " + s.format(n);
    if (i && !s)
      return i.format(n) + " - ";
    if (i.isSame(s))
      return i.format(n);
    const r = "DD.MM.", l = "DD.", o = i.year() === s.year(), u = i.month() === s.month();
    return i.format(o ? u ? l : r : n) + " - " + s.format(n);
  }
  /**
   * Output a formatted date with default date format (may later be localized).
   * @param date A dately value (a string, JS Date object, DayJs etc.) that is formatted.
   * @returns A Simple date string e.g. "12.11.2019", if the value is empty or null returns "-".
   */
  static getFormattedDate(e) {
    return this.format(e, "DD.MM.YYYY", "-");
  }
  /**
   * Formats a dately object using DayJs formatting:
   * Default is "DD.MM.YYYY"
   * For all format string options, see https://day.js.org/docs/en/display/format
   */
  static format(e, t = "DD.MM.YYYY", n = void 0) {
    const i = this.getDayJs(e);
    return i ? i.format(t) : n;
  }
  /**
   * Gets the day of month as 1-based number: 1-31.
   *
   * @param datelyObject - Object that represents date: A string, JS Date object, DayJs etc.
   * Special string "today" can be used for fetching today's date.
   *
   * @returns Day of month between 1-31 or undefined if the object is not a dately object.
   */
  static getDay(e) {
    const t = this.getDayJs(e);
    return t ? t.date() : void 0;
  }
  /**
   * Sets the day of month as 1-based number: 1-31.
   *
   * @param datelyObject - Object that represents date: A string, JS Date object, DayJs etc.
   * Special string "today" can be used for fetching today's date.
   * @param dayOfMonth - day of the month to be set (1-31 depending on month, will bubble to next if beyond endof month)
   * @returns Day of month between 1-31 or undefined if the object is not a dately object.
   */
  static setDay(e, t) {
    const n = this.getDayJs(e);
    return n ? this.asDate(n.date(t)) : void 0;
  }
  /**
   * Gets the day of week as ISO 1-based number: 1-7.
   *
   * @param datelyObject - Object that represents date: A string, JS Date object, DayJs etc.
   * Special string "today" can be used for fetching today's date.
   *
   * @returns Day of week
   */
  static getWeekday(e) {
    const t = this.getDayJs(e);
    return t ? t.isoWeekday() : void 0;
  }
  /**
   * Gets isoWeek-number for provided date
   * @param date Base date for week number
   * @returns week number
   */
  static getWeekNumber(e) {
    const t = this.getDayJs(e);
    return t ? t.isoWeek() : void 0;
  }
  /**
   * Gets number of day in month in given datelyObject.
   * @param date Base date for getting the month
   * @returns numbber of days in the month of the given base date.
   */
  static getDaysInMonth(e) {
    const t = this.getDayJs(e);
    return t ? t.daysInMonth() : void 0;
  }
  /**
   * Gets the month as 1-based number: 1-12.
   *
   * @param datelyObject - Object that represents month: A string, JS Date object, DayJs etc.
   * Special string "today" can be used for fetching today's date.
   *
   * @returns Month between 1-12 or undefined if the object is not a dately object.
   */
  static getMonth(e) {
    const t = this.getDayJs(e);
    return t ? t.month() + 1 : void 0;
  }
  /**
   * Gets the year of a date or today.
   *
   * @param datelyObject - Object that represents month: A string, JS Date object, DayJs etc.
   * Special string "today" can be used for fetching today's date.
   *
   * @returns Year, e.g. 2019 or null if the object is not a dately object.
   */
  static getYear(e) {
    const t = this.getDayJs(e);
    return t ? t.year() : void 0;
  }
  /**
   * Returns true if the given dately object is a holiday.
   * Please note that the weekend days are not by default holidays
   *
   * @param datelyObject - Object that should be converted to date: A string, JS Date object, DayJs etc.
   * @param holidayGroup - The holiday group for defining which days to count as holiday day. The default group is Holiday.
   *
   * @returns True, if the given dately object is a holiday.
   */
  static isHoliday(e, t = ma.Holiday) {
    const n = this.getDayJs(e);
    return !n || !t ? !1 : !!Object.values(this.getYearlyHolidays(n) ?? {}).find((s) => s.date == this.asDate(n) && s.holidayGroups && s.holidayGroups.indexOf(t) >= 0);
  }
  /**
   * Returns true if the given dately object is a working day (5 day week).
   * The day must not be Saturday or Sunday or not any day in the given holiday categoria.
   *
   * @param datelyObject - Object that should be converted to date: A string, JS Date object, DayJs etc.
   * @param holidayGroup - The holiday group for defining which days to count as holiday day. The default group is Holiday.
   *
   * @returns True, if the given dately object is a working day.
   */
  static isWorkday(e, t = ma.Holiday) {
    const n = this.getDayJs(e);
    return !n || n.isoWeekday() === 6 || // Saturday
    n.isoWeekday() === 7 ? !1 : t ? !this.isHoliday(n, t) : !0;
  }
  /**
   * Returns true if the given dately object is a vacation day (6 day week).
   * The day must not be Sunday or not any day in the given holiday categoria.
   *
   * @param datelyObject - Object that should be converted to date: A string, JS Date object, DayJs etc.
   * @param holidayGroup - The holiday group for defining which days to count as holiday day. The default group is Holiday.
   *
   * @returns True, if the given dately object is a working day.
   */
  static isVacationday(e, t = ma.Holiday) {
    const n = this.getDayJs(e);
    return !n || n.isoWeekday() === 7 ? !1 : t ? !this.isHoliday(n, t) : !0;
  }
  /**
   * Adds given amount of working days to given day.
   *
   * @param datelyObject - Object that should be converted to date: A string, JS Date object, DatyJs etc.
   * @param days - Working days to add (positive or negative number).
   * If zero or not set, returns datelyObject or next workday if datelyObject is not a workday.
   * @param holidayGroup - The holiday group for defining which days to count as holiday day. The default group is Holiday.
   *
   * @returns New working day with amount of given working days ahead.
   */
  static addWorkdays(e, t, n = ma.Holiday) {
    let i = this.getDayJs(e);
    if (!i)
      return;
    if (!t)
      for (; ; ) {
        if (this.isWorkday(i, n))
          return this.asDate(i);
        i = i.add(1, "d");
      }
    let s = 0;
    const r = t > 0 ? 1 : -1;
    for (; ; )
      if (i = i.add(r, "d"), this.isWorkday(i, n) && (s += r, s === t))
        return this.asDate(i);
  }
  /**
   * Adds (or substracts) days, months or years to a dately object.
   * @param datelyObject Base date for the addition.
   * @param amount Number of days/months/years to add
   * @param unit Unit for the addition: day,month,year
   */
  static add(e, t, n) {
    const i = this.getDayJs(e);
    if (i)
      switch (n) {
        case "day":
          return this.asDate(i.add(t, "d"));
        case "week":
          return this.asDate(i.add(t, "w"));
        case "month":
          return this.asDate(i.add(t, "M"));
        case "quarter":
          return this.asDate(i.add(t, "Q"));
        case "year":
          return this.asDate(i.add(t, "y"));
        default:
          throw new Error(`Unit "${n}" is not supported.`);
      }
  }
  /**
   * Changes a date to start/end of week/month/quarter/year
   * @param datelyObject Base date that is converted.
   * @param type Type of change: start-week, start-month, start-quarter, start-year, end-week, end-month, end-quarter, end-year
   */
  static startEnd(e, t) {
    const n = this.getDayJs(e);
    if (n)
      switch (t) {
        case "start-week":
          return this.asDate(n.startOf("isoWeek"));
        case "start-month":
          return this.asDate(n.startOf("month"));
        case "start-quarter":
          return this.asDate(n.startOf("quarter"));
        case "start-year":
          return this.asDate(n.startOf("year"));
        case "end-week":
          return this.asDate(n.endOf("isoWeek"));
        case "end-month":
          return this.asDate(n.endOf("month"));
        case "end-quarter":
          return this.asDate(n.endOf("quarter"));
        case "end-year":
          return this.asDate(n.endOf("year"));
        default:
          throw new Error(`Start/end type "${t}" is not supported.`);
      }
  }
  /**
   * Parses the given date range string to a DateRange. Parsing is implemented for optimized date
   * range inputs. Optimized date range means that dates can be given in a shorter/truncated form,
   * for improved user efficiency, by omitting some components from the date strings:
   *
   * - For the end date the day is the only mandatory component, if month and/or year are omitted
   * they default to current month and year respectively
   * - For the start date all components are optional, any omitted components default to the
   * respective components from the end date.
   *
   * For example the result of parsing a user inputted optimized date range string "1 - 20" would be
   * { start: 2021-04-01, end: 2021-04-20, }.
   *
   * @param dateRange The optimized date range string to be parsed. The dates in the date range
   * should be in finnish format (dd.mm.yyyy or without leading zeros d.m.yyyy). Start and end dates
   * should be separated by a hyphen (-). Examples of valid date range strings could be e.g.
   * "1.4 - 1.5.2021" or "1" which would be parsed as { start: 2021-04-01, end: 2021-05-01 } and
   * { start: 2021-04-01, end: 2021-05-01 } respectively (at the time of writing this documentation).
   * @returns The parsed DateRange.
   */
  static parseOptimizedDateRange(e) {
    if (!this.validateDaterangeInput(e))
      return;
    const t = this.parseDateRange(e);
    if (t && this.validateDaterangeOrder(t))
      return t;
  }
  /**
   * Parses a start date from an optimized date range string. Uses the end date as the default if
   * start date or some of its components are not given.
   * @param dateRange - String to be parsed as start of DateRange
   * @returns string
   */
  static parseStartDateFrom(e) {
    if (e.indexOf("-") < 0)
      return this.parseEndDateFrom(e);
    const t = e.substring(0, e.indexOf("-")).trim();
    return this.parseOptimizedDate(t, this.parseEndDateFrom(e));
  }
  /**
   * Parses an end date from an optimized date range string. Uses the current date as the default if
   * month and/or year are not given.
   * @param dateRange - String to be parsed as end of DateRange
   * @returns string
   */
  static parseEndDateFrom(e) {
    const t = e.substring(e.indexOf("-") + 1).trim();
    return this.parseOptimizedDate(t);
  }
  /**
   * Parses an optimized date string. The date string should be in finnish format (dd.mm.yyyy with
   * or without leading zeros). Month and/or year component can be omitted from the date string
   * (optimized date string...) in which case they are taken from the default date. If default date
   * is not given the current date is used
   * @param date - String to be parsed as DateRange
   * @param defaultDate default date, fallbacks to today
   * @returns string
   */
  static parseOptimizedDate(e, t = this.getToday()) {
    const n = e.split(".");
    n[0] = this.parseDay(n[0]), n[1] = this.parseMonth(n[1], t), n[2] = this.parseYear(n[2], t);
    const i = n.reverse().join("-");
    if (this.isValidDateTime(i, !0, "YYYY-MM-DD"))
      return i;
  }
  static parseDay(e) {
    return !e || e.length > 2 ? "" : e.length === 1 ? "0" + e : e;
  }
  /**
   * Parses an optimized month string. If the month is not given it is taken from the default date.
   */
  static parseMonth(e, t) {
    return e?.length > 2 ? "" : (e || (e = this.getMonth(t)?.toString() ?? ""), e.length === 1 ? "0" + e : e);
  }
  /**
   * Parses an optimized year string. Defaults to the 3rd millenium, if the given year doesn't
   * contain the millenia e.g. "21" --> "2021". If the year is not given at all, it is taken from
   * the default date.
   */
  static parseYear(e, t) {
    return e?.length > 4 ? "" : e ? (parseInt(e) % 2e3 + 2e3).toString() : this.getYear(t)?.toString() ?? "";
  }
  /**
   * Parses DateRange from a string
   * @param dateRange string to be parsed as date range
   * @returns DateRange
   */
  static parseDateRange(e) {
    return { start: this.parseStartDateFrom(e), end: this.parseEndDateFrom(e) };
  }
  /**
   * Validates that the given date range string only contains allowed character (numbers, periods,
   * dashes, spaces).
   */
  static validateDaterangeInput(e) {
    return e.match(/^[0-9 -.]*$/) != null;
  }
  /**
   * Validates a date range by checking that the start date is not after the end date.
   * This method does not validate start and end dates strictly, so 30.2.2023 will be translated internally dy Day.js to
   * 2.3.2023.
   * @param dateRange - date range to be validated
   */
  static validateDaterangeOrder(e) {
    const t = this.getDayJs(e.start);
    if (!t || !t.isValid())
      return;
    const n = this.getDayJs(e.end);
    if (n && n.isValid())
      return !t.isAfter(n);
  }
  /**
   * Gets holidays for the given year.
   *
   * @param forYear - Dately object (JavaScript date, ISO string formatted date, or DayJs-object) for which the holidays are fetched.
   *
   * @returns The holidays for the given year.
   */
  static getYearlyHolidays(e) {
    const t = c.getYear(e), n = Br.find((i) => i.year === t);
    if (!n)
      throw new Error(`Year ${t} not supported.`);
    return n.holidays;
  }
  /**
   * Checks if date1 is after date2
   * @param date1 comparable date1
   * @param date2 comparable date1
   * @param granularity granularity for isAfter, default is date
   * @returns true if date1 is after date2
   */
  static isAfter(e, t, n = "date") {
    const i = this.getDayJs(e), s = this.getDayJs(t);
    return i && s ? i.isAfter(this.getDayJs(s), n) : !1;
  }
  /**
   * Checks if date1 is before date2
   * @param date1 comparable date1
   * @param date2 comparable date1
   * @param granularity granularity for isBefore, default is date
   * @returns true if date1 is before date2
   */
  static isBefore(e, t, n = "date") {
    const i = this.getDayJs(e), s = this.getDayJs(t);
    return i && s ? i.isBefore(this.getDayJs(s), n) : !1;
  }
  /**
   * Checks if date1 is same or after date2
   * @param date1 comparable date1
   * @param date2 comparable date1
   * @param granularity granularity for isAfter, default is date
   * @returns true if date1 is is same or after date2
   */
  static isSameOrAfter(e, t, n = "date") {
    const i = this.getDayJs(e), s = this.getDayJs(t);
    return i && s ? i.isSameOrAfter(this.getDayJs(s), n) : !1;
  }
  /**
   * Checks if date1 is same or before date2
   * @param date1 comparable date1
   * @param date2 comparable date1
   * @param granularity granularity for isAfter, default is date
   * @returns true if date1 is same or before date2
   */
  static isSameOrBefore(e, t, n = "date") {
    const i = this.getDayJs(e), s = this.getDayJs(t);
    return i && s ? i.isSameOrBefore(this.getDayJs(s), n) : !1;
  }
}
const Go = {
  baseService: {
    campaignCode: null,
    id: "baseService",
    title: "Palkkaus.fi-tili",
    status: "Palkkaamisen peruspalvelut",
    description: "Digiajan palkanmaksupalvelu",
    img: "https://cdn.salaxy.com/img/elems/product-logos/palkkaus.png",
    articleId: "product_baseService",
    enabled: !0,
    visible: !0
  },
  tax: {
    paymentReferenceNumber: null,
    isSalariesPaidThisYear: !1,
    isMonthlyReportingEnabled: !0,
    isYearlyReportingEnabled: !0,
    isNotificationsSelfHandling: !1,
    isPaymentsSelfHandling: !1,
    id: "tax",
    title: "Yhteydet verottajaan",
    status: "Ennakonpidätys ja ilmoitukset",
    description: "Ennakonpidätykset ja Sotu-maksut",
    img: "https://cdn.salaxy.com/img/elems/product-logos/tax.png",
    articleId: "product_tax",
    enabled: !0,
    visible: !0
  },
  unemployment: {
    isSalariesPaidThisYear: !1,
    isPrepayments: !1,
    isNotificationsSelfHandling: !1,
    id: "unemployment",
    title: "Työttömyysvakuutus (TVR)",
    status: "Maksut ja ilmoitukset TVR:ään",
    description: "Työttömyysturva rahoitetaan TVR-maksuilla",
    img: "https://cdn.salaxy.com/img/elems/product-logos/tvr.png",
    articleId: "product_unemployment",
    enabled: !0,
    visible: !0
  },
  pension: {
    status: "Ei sopimusta: TyEL maksetaan tilapäisenä työnantajana",
    isPensionContractDone: !1,
    pensionCompany: "none",
    pensionContractNumber: null,
    isPensionSelfHandling: !1,
    isPendingContract: !1,
    enabled: !0,
    id: "pension",
    title: "TyEL-eläkevakuutus",
    description: "TyEL-vakuutus on työntekijän eläketurva",
    img: "https://cdn.salaxy.com/img/elems/product-logos/varma-tyel.png",
    articleId: "product_pension",
    visible: !0
  },
  insurance: {
    status: "Ei sopimusta - Huom! 1200 € :n sääntö.",
    isPartnerInsurance: !1,
    isInsuranceContractDone: !1,
    insuranceCompany: "none",
    insuranceContractNumber: null,
    enabled: !1,
    id: "insurance",
    title: "Työtapaturmavakuutus",
    description: "Tapaturmavakuutus vakuuttaa työntekijäsi",
    img: "https://cdn.salaxy.com/img/elems/product-logos/if.png",
    articleId: "product_insurance",
    visible: !0
  },
  accounting: {
    status: "Ei käytössä",
    accountantName: null,
    accountantEmail: null,
    accountantPhone: null,
    enabled: !1,
    id: "accounting",
    title: "Kirjanpitoraportit",
    description: "Palkkalaskelmien tiedot helposti kirjanpitäjälle",
    img: "https://cdn.salaxy.com/img/elems/product-logos/accounting.png",
    articleId: "product_accounting",
    visible: !0
  },
  healthCareHeltti: {
    package: "notDefined",
    industry: "notDefined",
    status: "Ei sopimusta",
    enabled: !1,
    id: "healthCareHeltti",
    title: "Työterveyshuolto",
    description: "Tuottavammat ja terveemmät työntekijät",
    img: "https://cdn.salaxy.com/img/elems/product-logos/heltti.png",
    articleId: "product_healthCareHeltti",
    visible: !0
  },
  pensionEntrepreneur: {
    status: "Ei YEL-sopimusta",
    tempContractMarker: !1,
    enabled: !1,
    id: "pensionEntrepreneur",
    title: "Yrittäjän eläke",
    description: "YEL-vakuutus on yrittäjän eläketurva",
    img: "https://cdn.salaxy.com/img/elems/product-logos/varma-yel.png",
    articleId: "product_pensionEntrepreneur",
    visible: !0
  },
  taxCard: {
    currentCard: null,
    status: "Ei verokorttia",
    id: "taxCard",
    title: "Verokortti (TT)",
    description: "Työntekijän verokortti ja sen käsittely",
    img: "https://cdn.salaxy.com/img/elems/product-logos/palkkaus.png",
    articleId: "product_taxCard",
    enabled: !1,
    visible: !0
  }
}, Vr = [
  {
    identifier: "tupas-osuuspankki",
    name: "Osuuspankki",
    image: "https://www.onnistuu.fi/img/banks/op_white_bgr-14.gif"
  },
  {
    identifier: "tupas-nordea",
    name: "Nordea",
    image: "https://www.onnistuu.fi/img/banks/nordea_button_70x70px.gif"
  },
  {
    identifier: "tupas-danske",
    name: "Danske Bank",
    image: "https://www.onnistuu.fi/img/banks/danskebank.png"
  },
  {
    identifier: "tupas-spankki",
    name: "S-Pankki",
    image: "https://www.onnistuu.fi/img/banks/s-pankki.png"
  },
  {
    identifier: "tupas-handelsbanken",
    name: "Handelsbanken",
    image: "https://www.onnistuu.fi/img/banks/handelsbanken_painike.jpg"
  },
  {
    identifier: "tupas-elisa",
    name: "Mobiilivarmenne",
    image: "https://www.onnistuu.fi/img/banks/elisa.png"
  },
  {
    identifier: "tupas-aktia",
    name: "Aktia",
    image: "https://www.onnistuu.fi/img/banks/aktia.png"
  },
  {
    identifier: "tupas-poppankki",
    name: "POP Pankki",
    image: "https://www.onnistuu.fi/img/banks/POPmaksunappi.png"
  },
  {
    identifier: "tupas-sp",
    name: "Säästöpankki",
    image: "https://www.onnistuu.fi/img/banks/Spmaksunappi.png"
  },
  {
    identifier: "tupas-omasp",
    name: "Oma Säästöpankki",
    image: "https://www.onnistuu.fi/img/banks/omasp.png"
  },
  {
    identifier: "tupas-alandsbanken",
    name: "Ålandsbanken",
    image: "https://www.onnistuu.fi/img/banks/alandsbanken.gif"
  }
], Kr = (a) => [
  {
    year: 2014,
    sideCosts: {
      unemploymentEmployerPercent: 75e-4,
      unemploymentHigherEmployerPercent: 0.0295,
      unemploymentWorkerPercent: 5e-3,
      unemploymentPartialOwnerWorkerPercent: 19e-4,
      tyelIncomeLimit: 56.55,
      tyelBasePercent: 0.242,
      tyelWorkerPercent: 0.0555,
      tyel53Percent: 0.0705,
      tyelContractEmployerLimit: 8100,
      socSecPercent: 0.0214,
      illnessInsurancePercent: 0.0216,
      healthInsuranceMedicalCareContribution: 0.0132,
      healthInsuranceDailyAllowanceContribution: 84e-4
    }
  },
  {
    year: 2015,
    sideCosts: {
      unemploymentEmployerPercent: 8e-3,
      unemploymentHigherEmployerPercent: 0.0315,
      unemploymentWorkerPercent: 65e-4,
      unemploymentPartialOwnerWorkerPercent: 24e-4,
      tyelIncomeLimit: 57.1,
      tyelBasePercent: 0.247,
      tyelWorkerPercent: 0.057,
      tyel53Percent: 0.072,
      tyelContractEmployerLimit: 8178,
      socSecPercent: 0.0208,
      illnessInsurancePercent: 0.021,
      healthInsuranceMedicalCareContribution: 0.0132,
      healthInsuranceDailyAllowanceContribution: 78e-4
    }
  },
  {
    year: 2016,
    sideCosts: {
      unemploymentEmployerPercent: 0.01,
      unemploymentHigherEmployerPercent: 0.039,
      unemploymentWorkerPercent: 0.0115,
      unemploymentPartialOwnerWorkerPercent: 46e-4,
      tyelIncomeLimit: 57.51,
      tyelBasePercent: 0.251,
      tyelWorkerPercent: 0.057,
      tyel53Percent: 0.072,
      tyelContractEmployerLimit: 8238,
      socSecPercent: 0.0212,
      illnessInsurancePercent: 0.0212,
      healthInsuranceMedicalCareContribution: 0.013,
      healthInsuranceDailyAllowanceContribution: 82e-4
    }
  },
  {
    year: 2017,
    sideCosts: {
      unemploymentEmployerPercent: 8e-3,
      unemploymentHigherEmployerPercent: 0.033,
      unemploymentWorkerPercent: 0.016,
      unemploymentPartialOwnerWorkerPercent: 7e-3,
      tyelIncomeLimit: 58.19,
      tyelBasePercent: 0.251,
      tyelWorkerPercent: 0.0615,
      tyel53Percent: 0.0765,
      tyelContractEmployerLimit: 8334,
      socSecPercent: 0.0108,
      illnessInsurancePercent: 0.0158,
      healthInsuranceMedicalCareContribution: 0,
      healthInsuranceDailyAllowanceContribution: 0.0158
    }
  },
  {
    year: 2018,
    sideCosts: {
      unemploymentEmployerPercent: 65e-4,
      unemploymentHigherEmployerPercent: 0.026,
      unemploymentWorkerPercent: 0.019,
      unemploymentPartialOwnerWorkerPercent: 78e-4,
      tyelIncomeLimit: 58.27,
      tyelBasePercent: 0.253,
      tyelWorkerPercent: 0.0635,
      tyel53Percent: 0.0785,
      tyelContractEmployerLimit: 8346,
      socSecPercent: 86e-4,
      illnessInsurancePercent: 0.0153,
      healthInsuranceMedicalCareContribution: 0,
      healthInsuranceDailyAllowanceContribution: 0.0153,
      taxFreeDailyAllowance: 42,
      taxFreeDailyHalfAllowance: 19,
      taxFreeMealAllowance: 10.5,
      taxFreeKmAllowance: 0.42,
      unionPaymentRaksaA: 0.0155,
      unionPaymentRaksaAoTa: 55e-4,
      stepsTaxCardLimit1: 10500,
      stepsTaxCardLimit2: 17950,
      householdDeduction: 0.2
    }
  },
  {
    year: 2019,
    sideCosts: {
      unemploymentEmployerPercent: 5e-3,
      unemploymentHigherEmployerPercent: 0.0205,
      unemploymentWorkerPercent: 0.015,
      unemploymentPartialOwnerWorkerPercent: 78e-4,
      tyelIncomeLimit: 59.36,
      tyelBasePercent: 0.252,
      tyelWorkerPercent: 0.0675,
      tyel53Percent: 0.0825,
      tyelContractEmployerLimit: 8502,
      socSecPercent: 77e-4,
      illnessInsurancePercent: 0.0154,
      healthInsuranceMedicalCareContribution: 0,
      healthInsuranceDailyAllowanceContribution: 0.0154,
      taxFreeDailyAllowance: 42,
      taxFreeDailyHalfAllowance: 19,
      taxFreeMealAllowance: 10.5,
      taxFreeKmAllowance: 0.43,
      unionPaymentRaksaA: 0.0149,
      unionPaymentRaksaAoTa: 52e-4,
      stepsTaxCardLimit1: 10500,
      stepsTaxCardLimit2: 17950,
      householdDeduction: 0.2
    }
  },
  {
    year: 2020,
    sideCosts: {
      unemploymentEmployerPercent: 45e-4,
      unemploymentHigherEmployerPercent: 0.017,
      unemploymentWorkerPercent: 0.0125,
      unemploymentPartialOwnerWorkerPercent: 65e-4,
      tyelIncomeLimit: 60.57,
      tyelBasePercent: 0.253,
      tyelWorkerPercent: 0.0715,
      tyel53Percent: 0.0865,
      tyelContractEmployerLimit: 8676,
      socSecPercent: 0.0134,
      illnessInsurancePercent: 0.0186,
      healthInsuranceMedicalCareContribution: 68e-4,
      healthInsuranceDailyAllowanceContribution: 0.0118,
      taxFreeDailyAllowance: 43,
      taxFreeDailyHalfAllowance: 20,
      taxFreeMealAllowance: 10.75,
      taxFreeKmAllowance: 0.43,
      unionPaymentRaksaA: 0.0149,
      unionPaymentRaksaAoTa: 52e-4,
      palkkausVatPercent: 0.24,
      householdDeduction: 0.15,
      mealBenefitCateringContract: 6.8,
      mealBenefitInstitute: 5.1,
      mealBenefitRestaurantWorker: 5.78,
      mealBenefitTeacher: 4.08,
      mealTicketLowerLimit: 6.8,
      mealTicketUpperLimit: 10.7,
      mealTicketTaxable: 0.75,
      protectedPortionBase: 22.63,
      protectedPortionDependant: 8.12
    }
  },
  {
    year: 2021,
    sideCosts: {
      unemploymentEmployerPercent: 5e-3,
      unemploymentHigherEmployerPercent: 0.019,
      unemploymentWorkerPercent: 0.014,
      unemploymentPartialOwnerWorkerPercent: 65e-4,
      tyelIncomeLimit: 61.37,
      tyelBasePercent: 0.248,
      tyelWorkerPercent: 0.0715,
      tyel53Percent: 0.0865,
      tyelContractEmployerLimit: 8790,
      socSecPercent: 0.0153,
      illnessInsurancePercent: 0.0204,
      healthInsuranceMedicalCareContribution: 68e-4,
      healthInsuranceDailyAllowanceContribution: 0.0136,
      taxFreeDailyAllowance: 44,
      taxFreeDailyHalfAllowance: 20,
      taxFreeMealAllowance: 11,
      taxFreeKmAllowance: 0.44,
      unionPaymentRaksaA: 0.0149,
      unionPaymentRaksaAoTa: 52e-4,
      palkkausVatPercent: 0.24,
      householdDeduction: 0.15,
      householdDeductionMaxAmount: 2250,
      householdDeductionDeductible: 100,
      mealBenefitCateringContract: 6.9,
      mealBenefitInstitute: 5.18,
      mealBenefitRestaurantWorker: 5.87,
      mealBenefitTeacher: 4.14,
      mealTicketLowerLimit: 6.9,
      mealTicketUpperLimit: 10.9,
      mealTicketTaxable: 0.75,
      protectedPortionBase: 22.71,
      protectedPortionDependant: 8.15
    }
  },
  {
    year: 2022,
    sideCosts: {
      unemploymentEmployerPercent: 5e-3,
      unemploymentHigherEmployerPercent: 0.0205,
      unemploymentWorkerPercent: 0.015,
      unemploymentPartialOwnerWorkerPercent: 74e-4,
      tyelIncomeLimit: 62.88,
      tyelBasePercent: 0.2585,
      tyelWorkerPercent: 0.0715,
      tyel53Percent: 0.0865,
      tyelContractEmployerLimit: 9006,
      socSecPercent: 0.0134,
      illnessInsurancePercent: 0.0171,
      healthInsuranceMedicalCareContribution: 53e-4,
      healthInsuranceDailyAllowanceContribution: 0.0118,
      taxFreeBicycleBenefit: 1200,
      taxFreeDailyAllowance: 45,
      taxFreeDailyHalfAllowance: 20,
      taxFreeMealAllowance: 11.25,
      taxFreeKmAllowance: 0.46,
      taxFreeSubsidisedCommute: 3400,
      unionPaymentRaksaA: 0.0149,
      unionPaymentRaksaAoTa: 52e-4,
      palkkausVatPercent: 0.24,
      householdDeduction: 0.15,
      householdDeductionExtended: 0.3,
      householdDeductionMaxAmount: 2250,
      householdDeductionMaxAmountExtended: 3500,
      householdDeductionDeductible: 100,
      householdDeductionCategoriesExtended: [
        te.Householdwork,
        te.Carework,
        te.OilHeatingReplacementWork
      ],
      mealBenefitCateringContract: 7.15,
      mealBenefitInstitute: 5.36,
      mealBenefitRestaurantWorker: 6.08,
      mealBenefitTeacher: 4.29,
      mealTicketLowerLimit: 7.15,
      mealTicketUpperLimit: 11.3,
      mealTicketTaxable: 0.75,
      protectedPortionBase: 23.2,
      protectedPortionDependant: 8.34
    }
  },
  {
    year: 2023,
    sideCosts: {
      unemploymentEmployerPercent: 52e-4,
      unemploymentHigherEmployerPercent: 0.0206,
      unemploymentWorkerPercent: 0.015,
      unemploymentPartialOwnerWorkerPercent: 75e-4,
      tyelIncomeLimit: 65.26,
      tyelBasePercent: 0.262,
      tyelWorkerPercent: 0.0715,
      tyel53Percent: 0.0865,
      tyelContractEmployerLimit: 9348,
      socSecPercent: 0.0153,
      illnessInsurancePercent: 0.0196,
      healthInsuranceMedicalCareContribution: 6e-3,
      healthInsuranceDailyAllowanceContribution: 0.0136,
      taxFreeBicycleBenefit: 1200,
      taxFreeDailyAllowance: 48,
      taxFreeDailyHalfAllowance: 22,
      taxFreeMealAllowance: 12,
      taxFreeKmAllowance: 0.53,
      taxFreeSubsidisedCommute: 3400,
      unionPaymentRaksaA: 0.0149,
      unionPaymentRaksaAoTa: 52e-4,
      palkkausVatPercent: 0.24,
      householdDeduction: 0.15,
      householdDeductionExtended: 0.3,
      householdDeductionMaxAmount: 2250,
      householdDeductionMaxAmountExtended: 3500,
      householdDeductionDeductible: 100,
      householdDeductionCategoriesExtended: [
        te.Householdwork,
        te.Carework,
        te.OilHeatingReplacementWork
      ],
      mealBenefitCateringContract: 8,
      mealBenefitInstitute: 6,
      mealBenefitRestaurantWorker: 6.8,
      mealBenefitTeacher: 4.8,
      mealTicketLowerLimit: 8,
      mealTicketUpperLimit: 12.7,
      mealTicketTaxable: 0.75,
      protectedPortionBase: 30.75,
      protectedPortionDependant: 8.99
    }
  },
  {
    year: 2024,
    sideCosts: {
      unemploymentEmployerPercent: 27e-4,
      unemploymentHigherEmployerPercent: 0.0109,
      unemploymentWorkerPercent: 79e-4,
      unemploymentPartialOwnerWorkerPercent: 43e-4,
      tyelIncomeLimit: 68.57,
      tyelBasePercent: 0.2612,
      tyelWorkerPercent: 0.0715,
      tyel53Percent: 0.0865,
      tyelContractEmployerLimit: 9822,
      socSecPercent: 0.0116,
      illnessInsurancePercent: 0.0152,
      healthInsuranceMedicalCareContribution: 51e-4,
      healthInsuranceDailyAllowanceContribution: 0.0101,
      taxFreeDailyAllowance: 51,
      taxFreeDailyHalfAllowance: 24,
      taxFreeMealAllowance: 12.75,
      taxFreeBicycleBenefit: 1200,
      taxFreeSubsidisedCommute: 3400,
      taxFreeKmAllowance: 0.57,
      unionPaymentRaksaA: 0.0149,
      unionPaymentRaksaAoTa: 52e-4,
      palkkausVatPercent: c.isSameOrAfter(a, "2024-09-01") ? 0.255 : 0.24,
      palkkausVatRate: c.isSameOrAfter(a, "2024-09-01") ? de.Vat2550 : de.Vat2400,
      householdDeduction: 0.15,
      householdDeductionExtended: 0.3,
      householdDeductionMaxAmount: 2250,
      householdDeductionMaxAmountExtended: 3500,
      householdDeductionCategoriesExtended: [
        te.Householdwork,
        te.Carework,
        te.OilHeatingReplacementWork
      ],
      householdDeductionDeductible: 100,
      mealBenefitCateringContract: 8.5,
      mealBenefitInstitute: 6.37,
      mealBenefitRestaurantWorker: 7.22,
      mealBenefitTeacher: 5.1,
      mealTicketLowerLimit: 8.5,
      mealTicketUpperLimit: 13.5,
      mealTicketTaxable: 0.75,
      protectedPortionBase: 32.56,
      protectedPortionDependant: 9.52
    }
  },
  {
    year: 2025,
    sideCosts: {
      unemploymentEmployerPercent: 2e-3,
      unemploymentHigherEmployerPercent: 8e-3,
      unemploymentWorkerPercent: 59e-4,
      unemploymentPartialOwnerWorkerPercent: 3e-3,
      tyelIncomeLimit: 70.08,
      tyelBasePercent: 0.2628,
      tyelWorkerPercent: 0.0715,
      tyel53Percent: 0.0865,
      tyelContractEmployerLimit: 10038,
      socSecPercent: 0.0187,
      illnessInsurancePercent: 0.019,
      healthInsuranceMedicalCareContribution: 0.0106,
      healthInsuranceDailyAllowanceContribution: 84e-4,
      taxFreeDailyAllowance: 53,
      taxFreeDailyHalfAllowance: 24,
      taxFreeMealAllowance: 13.25,
      taxFreeBicycleBenefit: 1200,
      taxFreeSubsidisedCommute: 3400,
      taxFreeKmAllowance: 0.59,
      unionPaymentRaksaA: 0.0149,
      unionPaymentRaksaAoTa: 52e-4,
      palkkausVatPercent: 0.255,
      palkkausVatRate: de.Vat2550,
      householdDeduction: 0.13,
      householdDeductionExtended: 0.3,
      householdDeductionMaxAmount: 1600,
      householdDeductionMaxAmountExtended: 3500,
      householdDeductionCategoriesExtended: [
        te.OilHeatingReplacementWork
      ],
      householdDeductionDeductible: 150,
      mealBenefitCateringContract: 8.6,
      mealBenefitInstitute: 6.45,
      mealBenefitRestaurantWorker: 7.31,
      mealBenefitTeacher: 5.16,
      mealTicketLowerLimit: 8.6,
      mealTicketUpperLimit: 13.7,
      mealTicketTaxable: 0.75,
      protectedPortionBase: 32.88,
      protectedPortionDependant: 9.61
    }
  }
], Da = [
  {
    year: 2022,
    milage: {
      car: 46,
      carAdditions: {
        trailer: 8,
        caravan: 12,
        canteen: 23,
        largeMachinery: 3,
        docInTheCar: 3,
        contstructionSite: 10
      },
      carLimitedBenefit: 10,
      passanger: 3,
      other: {
        motorboatUpTo50Hp: 80,
        motorboatOver50Hp: 116,
        snowMobile: 110,
        quadbike: 104,
        motorcycle: 35,
        moped: 19,
        otherTransport: 11
      }
    },
    countries: {
      Afghanistan: 47,
      Albania: 67,
      Algeria: 60,
      Andorra: 59,
      Angola: 57,
      AntiquaAndBarbuda: 78,
      Argentina: 37,
      Armenia: 54,
      Aruba: 60,
      Australia: 69,
      Austria: 68,
      Azerbaidzhan: 54,
      Azores: 61,
      Bahamas: 76,
      Bahrain: 73,
      Bangladesh: 66,
      Barbados: 73,
      Belarus: 51,
      Belgium: 67,
      Belize: 46,
      Benin: 43,
      Bermuda: 75,
      Bhutan: 44,
      Bolivia: 41,
      BosniaAndHercegovina: 51,
      Botswana: 43,
      Brazil: 59,
      Brunei: 40,
      Bulgaria: 57,
      BurkinaFaso: 38,
      Burundi: 43,
      Cambodia: 59,
      Cameroon: 54,
      Canada: 71,
      CanaryIslands: 63,
      CapeVerde: 43,
      CentralAfricanRepublic: 92,
      Chad: 56,
      Chile: 48,
      China: 73,
      HongKong: 76,
      Colombia: 48,
      Comoros: 33,
      CongoBrazzaville: 61,
      CongoKinshasa: 40,
      CookIslands: 68,
      CostaRica: 49,
      Croatia: 63,
      Cuba: 44,
      Curaçao: 50,
      Cyprus: 61,
      CzechRepublic: 68,
      Denmark: 71,
      Djibouti: 71,
      Dominica: 54,
      DominicanRepublic: 53,
      EastTimor: 46,
      Ecuador: 55,
      Egypt: 72,
      ElSalvador: 48,
      Eritrea: 77,
      Estonia: 58,
      Eswatini: 41,
      Ethiopia: 41,
      FaroeIslands: 55,
      Fiji: 50,
      France: 70,
      Gabon: 87,
      Gambia: 43,
      Georgia: 42,
      Germany: 66,
      Ghana: 52,
      Greece: 59,
      Greenland: 56,
      Grenada: 64,
      Guadeloupe: 51,
      Guatemala: 64,
      Guinea: 69,
      GuineaBissau: 37,
      Guyana: 43,
      Haiti: 48,
      Honduras: 48,
      Hungary: 56,
      Iceland: 75,
      India: 56,
      Indonesia: 51,
      Iran: 80,
      Iraq: 51,
      Ireland: 67,
      Israel: 87,
      Italy: 66,
      IvoryCoast: 73,
      Jamaica: 51,
      Japan: 76,
      Jordania: 80,
      Kazakhstan: 45,
      Kenya: 74,
      NorthKorea: 63,
      SouthKorea: 81,
      Kosovo: 50,
      Kuwait: 72,
      Kyrgystan: 39,
      Laos: 47,
      Latvia: 57,
      Lebanon: 92,
      Lesotho: 36,
      Liberia: 53,
      Libya: 47,
      Liechtenstein: 66,
      Lithuania: 55,
      Luxembourg: 69,
      Madagascar: 40,
      Madeira: 60,
      Malawi: 68,
      Malaysia: 49,
      Maldives: 60,
      Mali: 41,
      Malta: 66,
      MarshallIslands: 55,
      Martinique: 53,
      Mauritania: 46,
      Mauritius: 45,
      Mexico: 55,
      Micronesia: 50,
      Moldova: 56,
      Monaco: 92,
      Mongolia: 39,
      Montenegro: 59,
      Morocco: 69,
      Mozambique: 45,
      Myanmar: 57,
      Namibia: 39,
      Nepal: 47,
      Netherlands: 72,
      NewZealand: 72,
      Nicaragua: 42,
      Niger: 46,
      Nigeria: 76,
      NorthMacedonia: 54,
      Norway: 71,
      Oman: 66,
      Pakistan: 33,
      Palau: 77,
      Palestinianterritory: 77,
      Panama: 54,
      PapuaNewGuinea: 64,
      Paraguay: 32,
      Peru: 49,
      Philippines: 65,
      Poland: 57,
      Portugal: 62,
      PuertoRico: 57,
      Qatar: 67,
      Romania: 59,
      RussianFederation: 56,
      Moscow: 79,
      StPetersburg: 64,
      Rwanda: 36,
      SaintKittsAndNevis: 59,
      SaintLucia: 71,
      SaintVincentAndTheGrenadines: 71,
      Samoa: 53,
      SanMarino: 61,
      SaoTomeAndPrincipe: 85,
      SaudiArabia: 68,
      Senegal: 53,
      Serbia: 63,
      Seychelles: 74,
      SierraLeone: 57,
      Singapore: 68,
      Slovakia: 64,
      Slovenia: 61,
      SolomonIslands: 53,
      Somalia: 67,
      SouthAfrica: 53,
      SouthSudan: 92,
      Spain: 65,
      SriLanka: 39,
      Sudan: 25,
      Suriname: 72,
      Sweden: 63,
      Switzerland: 78,
      Syria: 84,
      Tadzhikistan: 35,
      Taiwan: 67,
      Tanzania: 49,
      Thailand: 60,
      Togo: 52,
      Tonga: 53,
      TrinidadAndTobago: 70,
      Tunisia: 54,
      Turkey: 37,
      Istanbul: 39,
      Turkmenistan: 80,
      Uganda: 43,
      Ukraine: 70,
      UnitedArabEmirates: 73,
      UnitedKingdom: 68,
      LondonAndEdinburgh: 72,
      UnitedStates: 72,
      NewYorkLosAngelesWashington: 78,
      Uruguay: 51,
      Uzbekistan: 31,
      Vanuatu: 60,
      Venezuela: 85,
      Vietnam: 64,
      VirginIslands: 51,
      Yemen: 92,
      Zimbabwe: 51,
      Zambia: 58,
      Other: 46
    }
  },
  {
    year: 2023,
    milage: {
      car: 53,
      carAdditions: {
        trailer: 9,
        caravan: 14,
        canteen: 27,
        largeMachinery: 4,
        docInTheCar: 4,
        contstructionSite: 11
      },
      carLimitedBenefit: 14,
      passanger: 4,
      other: {
        motorboatUpTo50Hp: 93,
        motorboatOver50Hp: 135,
        snowMobile: 129,
        quadbike: 121,
        motorcycle: 41,
        moped: 22,
        otherTransport: 13
      }
    },
    countries: {
      Afghanistan: 55,
      Albania: 71,
      Algeria: 74,
      Andorra: 59,
      Angola: 73,
      AntiquaAndBarbuda: 95,
      Argentina: 45,
      Armenia: 62,
      Aruba: 74,
      Australia: 77,
      Austria: 75,
      Azerbaidzhan: 68,
      Azores: 67,
      Bahamas: 92,
      Bahrain: 86,
      Bangladesh: 68,
      Barbados: 90,
      Belarus: 66,
      Belgium: 74,
      Belize: 54,
      Benin: 45,
      Bermuda: 94,
      Bhutan: 52,
      Bolivia: 49,
      BosniaAndHercegovina: 52,
      Botswana: 46,
      Brazil: 77,
      Brunei: 46,
      Bulgaria: 59,
      BurkinaFaso: 40,
      Burundi: 54,
      Cambodia: 72,
      Cameroon: 55,
      Canada: 86,
      CanaryIslands: 70,
      CapeVerde: 44,
      CentralAfricanRepublic: 96,
      Chad: 56,
      Chile: 55,
      China: 82,
      HongKong: 92,
      Colombia: 55,
      Comoros: 38,
      CongoBrazzaville: 62,
      CongoKinshasa: 50,
      CookIslands: 69,
      CostaRica: 60,
      Croatia: 65,
      Cuba: 52,
      Curaçao: 60,
      Cyprus: 63,
      CzechRepublic: 82,
      Denmark: 77,
      Djibouti: 85,
      Dominica: 64,
      DominicanRepublic: 58,
      EastTimor: 51,
      Ecuador: 65,
      Egypt: 73,
      ElSalvador: 59,
      Eritrea: 95,
      Estonia: 72,
      Eswatini: 41,
      Ethiopia: 43,
      FaroeIslands: 60,
      Fiji: 56,
      France: 74,
      Gabon: 88,
      Gambia: 50,
      Georgia: 48,
      Germany: 71,
      Ghana: 41,
      Greece: 66,
      Greenland: 61,
      Grenada: 76,
      Guadeloupe: 51,
      Guatemala: 78,
      Guinea: 82,
      GuineaBissau: 38,
      Guyana: 53,
      Haiti: 55,
      Honduras: 59,
      Hungary: 56,
      Iceland: 89,
      India: 64,
      Indonesia: 61,
      Iran: 122,
      Iraq: 65,
      Ireland: 73,
      Israel: 100,
      Italy: 72,
      IvoryCoast: 77,
      Jamaica: 64,
      Japan: 70,
      Jordania: 96,
      Kazakhstan: 51,
      Kenya: 85,
      NorthKorea: 75,
      SouthKorea: 85,
      Kosovo: 52,
      Kuwait: 86,
      Kyrgystan: 42,
      Laos: 35,
      Latvia: 69,
      Lebanon: 122,
      Lesotho: 37,
      Liberia: 71,
      Libya: 53,
      Liechtenstein: 77,
      Lithuania: 68,
      Luxembourg: 74,
      Madagascar: 46,
      Madeira: 66,
      Malawi: 69,
      Malaysia: 54,
      Maldives: 71,
      Mali: 43,
      Malta: 67,
      MarshallIslands: 67,
      Martinique: 54,
      Mauritania: 53,
      Mauritius: 53,
      Mexico: 71,
      Micronesia: 60,
      Moldova: 64,
      Monaco: 92,
      Mongolia: 44,
      Montenegro: 61,
      Morocco: 69,
      Mozambique: 55,
      Myanmar: 61,
      Namibia: 40,
      Nepal: 53,
      Netherlands: 80,
      NewZealand: 75,
      Nicaragua: 51,
      Niger: 49,
      Nigeria: 81,
      NorthMacedonia: 56,
      Norway: 76,
      Oman: 79,
      Pakistan: 31,
      Palau: 94,
      Palestinianterritory: 86,
      Panama: 65,
      PapuaNewGuinea: 79,
      Paraguay: 39,
      Peru: 51,
      Philippines: 70,
      Poland: 64,
      Portugal: 68,
      PuertoRico: 72,
      Qatar: 81,
      Romania: 62,
      RussianFederation: 69,
      Moscow: 85,
      StPetersburg: 78,
      Rwanda: 40,
      SaintKittsAndNevis: 70,
      SaintLucia: 86,
      SaintVincentAndTheGrenadines: 86,
      Samoa: 60,
      SanMarino: 62,
      SaoTomeAndPrincipe: 101,
      SaudiArabia: 83,
      Senegal: 55,
      Serbia: 66,
      Seychelles: 93,
      SierraLeone: 53,
      Singapore: 79,
      Slovakia: 73,
      Slovenia: 68,
      SolomonIslands: 63,
      Somalia: 87,
      SouthAfrica: 55,
      SouthSudan: 119,
      Spain: 72,
      SriLanka: 34,
      Sudan: 50,
      Suriname: 74,
      Sweden: 66,
      Switzerland: 91,
      Syria: 98,
      Tadzhikistan: 39,
      Taiwan: 73,
      Tanzania: 59,
      Thailand: 65,
      Togo: 54,
      Tonga: 59,
      TrinidadAndTobago: 84,
      Tunisia: 59,
      Turkey: 38,
      Istanbul: 39,
      Turkmenistan: 92,
      Uganda: 50,
      Ukraine: 62,
      UnitedArabEmirates: 84,
      UnitedKingdom: 73,
      LondonAndEdinburgh: 77,
      UnitedStates: 92,
      NewYorkLosAngelesWashington: 100,
      Uruguay: 56,
      Uzbekistan: 35,
      Vanuatu: 70,
      Venezuela: 100,
      Vietnam: 74,
      VirginIslands: 66,
      Yemen: 122,
      Zimbabwe: 75,
      Zambia: 70,
      Other: 53
    }
  },
  {
    year: 2024,
    milage: {
      car: 57,
      carAdditions: {
        trailer: 10,
        caravan: 15,
        canteen: 29,
        largeMachinery: 4,
        docInTheCar: 4,
        contstructionSite: 12
      },
      carLimitedBenefit: 13,
      passanger: 4,
      other: {
        motorboatUpTo50Hp: 100,
        motorboatOver50Hp: 145,
        snowMobile: 138,
        quadbike: 130,
        motorcycle: 44,
        moped: 23,
        otherTransport: 14
      }
    },
    countries: {
      Afghanistan: 59,
      Albania: 81,
      Algeria: 78,
      Andorra: 63,
      Angola: 71,
      AntiquaAndBarbuda: 94,
      Argentina: 38,
      Armenia: 61,
      Aruba: 70,
      Australia: 74,
      Austria: 80,
      Azerbaidzhan: 70,
      Azores: 69,
      Bahamas: 91,
      Bahrain: 80,
      Bangladesh: 57,
      Barbados: 83,
      Belarus: 63,
      Belgium: 77,
      Belize: 52,
      Benin: 47,
      Bermuda: 90,
      Bhutan: 49,
      Bolivia: 48,
      BosniaAndHercegovina: 54,
      Botswana: 41,
      Brazil: 80,
      Brunei: 45,
      Bulgaria: 64,
      BurkinaFaso: 40,
      Burundi: 46,
      Cambodia: 67,
      Cameroon: 59,
      Canada: 82,
      CanaryIslands: 71,
      CapeVerde: 45,
      CentralAfricanRepublic: 101,
      Chad: 47,
      Chile: 56,
      China: 74,
      HongKong: 86,
      Colombia: 64,
      Comoros: 42,
      CongoBrazzaville: 64,
      CongoKinshasa: 51,
      CookIslands: 70,
      CostaRica: 65,
      Croatia: 69,
      Cuba: 68,
      Curaçao: 58,
      Cyprus: 65,
      CzechRepublic: 89,
      Denmark: 79,
      Djibouti: 83,
      Dominica: 61,
      DominicanRepublic: 53,
      EastTimor: 46,
      Ecuador: 53,
      Egypt: 66,
      ElSalvador: 60,
      Eritrea: 95,
      Estonia: 75,
      Eswatini: 37,
      Ethiopia: 49,
      FaroeIslands: 61,
      Fiji: 52,
      France: 78,
      Gabon: 92,
      Gambia: 46,
      Georgia: 49,
      Germany: 76,
      Ghana: 47,
      Greece: 68,
      Greenland: 63,
      Grenada: 73,
      Guadeloupe: 53,
      Guatemala: 76,
      Guinea: 83,
      GuineaBissau: 41,
      Guyana: 51,
      Haiti: 62,
      Honduras: 58,
      Hungary: 69,
      Iceland: 82,
      India: 62,
      Indonesia: 57,
      Iran: 102,
      Iraq: 70,
      Ireland: 78,
      Israel: 88,
      Italy: 76,
      IvoryCoast: 80,
      Jamaica: 62,
      Japan: 66,
      Jordania: 90,
      Kazakhstan: 59,
      Kenya: 70,
      NorthKorea: 70,
      SouthKorea: 87,
      Kosovo: 58,
      Kuwait: 84,
      Kyrgystan: 41,
      Laos: 32,
      Latvia: 73,
      Lebanon: 102,
      Lesotho: 34,
      Liberia: 60,
      Libya: 52,
      Liechtenstein: 79,
      Lithuania: 72,
      Luxembourg: 77,
      Madagascar: 45,
      Madeira: 68,
      Malawi: 77,
      Malaysia: 50,
      Maldives: 68,
      Mali: 47,
      Malta: 71,
      MarshallIslands: 65,
      Martinique: 55,
      Mauritania: 52,
      Mauritius: 53,
      Mexico: 81,
      Micronesia: 59,
      Moldova: 73,
      Monaco: 92,
      Mongolia: 42,
      Montenegro: 66,
      Morocco: 71,
      Mozambique: 53,
      Myanmar: 58,
      Namibia: 36,
      Nepal: 51,
      Netherlands: 83,
      NewZealand: 74,
      Nicaragua: 51,
      Niger: 50,
      Nigeria: 78,
      NorthMacedonia: 64,
      Norway: 70,
      Oman: 74,
      Pakistan: 29,
      Palau: 99,
      Palestinianterritory: 76,
      Panama: 61,
      PapuaNewGuinea: 76,
      Paraguay: 36,
      Peru: 52,
      Philippines: 69,
      Poland: 72,
      Portugal: 70,
      PuertoRico: 70,
      Qatar: 78,
      Romania: 68,
      RussianFederation: 66,
      Moscow: 82,
      StPetersburg: 76,
      Rwanda: 37,
      SaintKittsAndNevis: 68,
      SaintLucia: 86,
      SaintVincentAndTheGrenadines: 85,
      Samoa: 61,
      SanMarino: 59,
      SaoTomeAndPrincipe: 102,
      SaudiArabia: 80,
      Senegal: 58,
      Serbia: 75,
      Seychelles: 87,
      SierraLeone: 47,
      Singapore: 79,
      Slovakia: 79,
      Slovenia: 72,
      SolomonIslands: 63,
      Somalia: 86,
      SouthAfrica: 50,
      SouthSudan: 102,
      Spain: 74,
      SriLanka: 29,
      Sudan: 83,
      Suriname: 78,
      Sweden: 64,
      Switzerland: 93,
      Syria: 91,
      Tadzhikistan: 35,
      Taiwan: 69,
      Tanzania: 54,
      Thailand: 63,
      Togo: 58,
      Tonga: 62,
      TrinidadAndTobago: 83,
      Tunisia: 61,
      Turkey: 35,
      Istanbul: 37,
      Turkmenistan: 92,
      Uganda: 49,
      Ukraine: 64,
      UnitedArabEmirates: 73,
      UnitedKingdom: 79,
      LondonAndEdinburgh: 83,
      UnitedStates: 89,
      NewYorkLosAngelesWashington: 97,
      Uruguay: 59,
      Uzbekistan: 32,
      Vanuatu: 70,
      Venezuela: 102,
      Vietnam: 69,
      VirginIslands: 64,
      Yemen: 102,
      Zimbabwe: 102,
      Zambia: 55,
      Other: 52
    }
  },
  {
    year: 2025,
    milage: {
      car: 59,
      carAdditions: {
        trailer: 10,
        caravan: 15,
        canteen: 30,
        largeMachinery: 4,
        docInTheCar: 4,
        contstructionSite: 13
      },
      carLimitedBenefit: 12,
      passanger: 4,
      other: {
        motorboatUpTo50Hp: 103,
        motorboatOver50Hp: 149,
        snowMobile: 142,
        quadbike: 134,
        motorcycle: 45,
        moped: 24,
        otherTransport: 14
      }
    },
    countries: {
      Afghanistan: 61,
      Albania: 89,
      Algeria: 82,
      Andorra: 65,
      Angola: 69,
      AntiquaAndBarbuda: 95,
      Argentina: 45,
      Armenia: 59,
      Aruba: 69,
      Australia: 77,
      Austria: 82,
      Azerbaidzhan: 69,
      Azores: 70,
      Bahamas: 89,
      Bahrain: 78,
      Bangladesh: 56,
      Barbados: 79,
      Belarus: 50,
      Belgium: 79,
      Belize: 52,
      Benin: 47,
      Bermuda: 89,
      Bhutan: 37,
      Bolivia: 48,
      BosniaAndHercegovina: 62,
      Botswana: 42,
      Brazil: 70,
      Brunei: 45,
      Bulgaria: 66,
      BurkinaFaso: 41,
      Burundi: 55,
      Cambodia: 66,
      Cameroon: 62,
      Canada: 80,
      CanaryIslands: 73,
      CapeVerde: 45,
      CentralAfricanRepublic: 102,
      Chad: 52,
      Chile: 55,
      China: 73,
      HongKong: 83,
      Colombia: 61,
      Comoros: 46,
      CongoBrazzaville: 66,
      CongoKinshasa: 58,
      CookIslands: 73,
      CostaRica: 64,
      Croatia: 71,
      Cuba: 64,
      Curaçao: 57,
      Cyprus: 66,
      CzechRepublic: 89,
      Denmark: 80,
      Djibouti: 83,
      Dominica: 60,
      DominicanRepublic: 50,
      EastTimor: 47,
      Ecuador: 62,
      Egypt: 51,
      ElSalvador: 58,
      Eritrea: 97,
      Estonia: 78,
      Eswatini: 40,
      Ethiopia: 46,
      FaroeIslands: 62,
      Fiji: 54,
      France: 79,
      Gabon: 95,
      Gambia: 44,
      Georgia: 46,
      Germany: 77,
      Ghana: 41,
      Greece: 70,
      Greenland: 63,
      Grenada: 72,
      Guadeloupe: 54,
      Guatemala: 77,
      Guinea: 85,
      GuineaBissau: 45,
      Guyana: 51,
      Haiti: 79,
      Honduras: 58,
      Hungary: 69,
      Iceland: 93,
      India: 61,
      Indonesia: 56,
      Iran: 119,
      Iraq: 71,
      Ireland: 79,
      Israel: 89,
      Italy: 77,
      IvoryCoast: 83,
      Jamaica: 61,
      Japan: 69,
      Jordania: 88,
      Kazakhstan: 60,
      Kenya: 80,
      NorthKorea: 67,
      SouthKorea: 85,
      Kosovo: 61,
      Kuwait: 84,
      Kyrgystan: 43,
      Laos: 34,
      Latvia: 73,
      Lebanon: 95,
      Lesotho: 37,
      Liberia: 59,
      Libya: 52,
      Liechtenstein: 81,
      Lithuania: 72,
      Luxembourg: 79,
      Madagascar: 46,
      Madeira: 69,
      Malawi: 61,
      Malaysia: 54,
      Maldives: 66,
      Mali: 49,
      Malta: 72,
      MarshallIslands: 67,
      Martinique: 57,
      Mauritania: 49,
      Mauritius: 49,
      Mexico: 73,
      Micronesia: 60,
      Moldova: 76,
      Monaco: 92,
      Mongolia: 44,
      Montenegro: 68,
      Morocco: 72,
      Mozambique: 52,
      Myanmar: 71,
      Namibia: 39,
      Nepal: 51,
      Netherlands: 86,
      NewZealand: 77,
      Nicaragua: 50,
      Niger: 56,
      Nigeria: 68,
      NorthMacedonia: 66,
      Norway: 70,
      Oman: 72,
      Pakistan: 33,
      Palau: 107,
      Palestinianterritory: 89,
      Panama: 60,
      PapuaNewGuinea: 67,
      Paraguay: 34,
      Peru: 50,
      Philippines: 70,
      Poland: 81,
      Portugal: 72,
      PuertoRico: 71,
      Qatar: 75,
      Romania: 71,
      RussianFederation: 73,
      Moscow: 91,
      StPetersburg: 83,
      Rwanda: 33,
      SaintKittsAndNevis: 65,
      SaintLucia: 83,
      SaintVincentAndTheGrenadines: 85,
      Samoa: 61,
      SanMarino: 60,
      SaoTomeAndPrincipe: 119,
      SaudiArabia: 78,
      Senegal: 57,
      Serbia: 78,
      Seychelles: 81,
      SierraLeone: 58,
      Singapore: 82,
      Slovakia: 81,
      Slovenia: 73,
      SolomonIslands: 62,
      Somalia: 88,
      SouthAfrica: 54,
      SouthSudan: 119,
      Spain: 75,
      SriLanka: 31,
      Sudan: 119,
      Suriname: 104,
      Sweden: 68,
      Switzerland: 96,
      Syria: 78,
      Tadzhikistan: 35,
      Taiwan: 67,
      Tanzania: 49,
      Thailand: 65,
      Togo: 63,
      Tonga: 65,
      TrinidadAndTobago: 80,
      Tunisia: 65,
      Turkey: 41,
      Istanbul: 42,
      Turkmenistan: 86,
      Uganda: 49,
      Ukraine: 57,
      UnitedArabEmirates: 72,
      UnitedKingdom: 83,
      LondonAndEdinburgh: 87,
      UnitedStates: 88,
      NewYorkLosAngelesWashington: 95,
      Uruguay: 55,
      Uzbekistan: 33,
      Vanuatu: 72,
      Venezuela: 119,
      Vietnam: 69,
      VirginIslands: 63,
      Yemen: 97,
      Zimbabwe: 119,
      Zambia: 46,
      Other: 52
    }
  }
], Ur = [
  { pensionCompany: "kevaMunicipal", code: "01", labelFi: "virka-/työsuhde", labelSv: "tjänste-/arbetsavtalsförhållande" },
  { pensionCompany: "kevaMunicipal", code: "05", labelFi: "toimeksiantosuhde", labelSv: "uppdragsförhållande" },
  { pensionCompany: "kevaMunicipal", code: "06", labelFi: "perhehoitaja", labelSv: "familjevårdare" },
  { pensionCompany: "kevaMunicipal", code: "07", labelFi: "luottamushenkilö", labelSv: "förtroendevald" },
  { pensionCompany: "kevaMunicipal", code: "08", labelFi: "omaishoitaja", labelSv: "närståendevårdare" },
  { pensionCompany: "kevaMunicipal", code: "13", labelFi: "eläinlääkärin toimenpidepalkkiot", labelSv: "veterinärers åtgärdsarvoden" },
  { pensionCompany: "kevaState", code: "01", labelFi: "virkasuhde", labelSv: "tjänsteförhållande" },
  { pensionCompany: "kevaState", code: "02", labelFi: "sotilas", labelSv: "militär" },
  { pensionCompany: "kevaState", code: "03", labelFi: "rajavartija", labelSv: "gränsbevakare" },
  { pensionCompany: "kevaState", code: "04", labelFi: "lentäjä", labelSv: "flygare" },
  { pensionCompany: "kevaState", code: "05", labelFi: "ilma-aluksen päällikkö", labelSv: "luftfartygs befälhavare" },
  { pensionCompany: "kevaState", code: "06", labelFi: "aliupseeri", labelSv: "underofficer" },
  { pensionCompany: "kevaState", code: "07", labelFi: "merivartija", labelSv: "sjöbevakare" },
  { pensionCompany: "kevaState", code: "08", labelFi: "lakkautuspalkka-aika (palkka maksettu kokonaan)", labelSv: "tid med lön på indragningsstat (hela lönen betald)" },
  { pensionCompany: "kevaState", code: "09", labelFi: "lakkautuspalkka-aika (palkka pid. osaksi tai kokonaan)", labelSv: "tid med lön på indragningsstat (lönen indr. helt eller delvis)" },
  { pensionCompany: "kevaState", code: "10", labelFi: "työsuhde", labelSv: "anställning" },
  { pensionCompany: "kevaState", code: "12", labelFi: "erikoisupseerit ja sotilaspapit", labelSv: "specialofficerare och militärpräster" },
  { pensionCompany: "kevaState", code: "13", labelFi: "RVL:n sotilasteknikot ja sotilasyliteknikot", labelSv: "KBV:s militärtekniker och militärövertekniker" },
  { pensionCompany: "kevaState", code: "14", labelFi: "siviili (entinen värvätty)", labelSv: "civil (tidigare värvad)" },
  { pensionCompany: "kevaState", code: "15", labelFi: "siviili (entinen erikoisupseeri)", labelSv: "civil (tidigare specialofficer)" },
  { pensionCompany: "kevaState", code: "16", labelFi: "määräaikainen sotilas", labelSv: "militär för viss tid" },
  { pensionCompany: "kevaState", code: "17", labelFi: "työllistetty", labelSv: "sysselsatt" },
  { pensionCompany: "kevaState", code: "18", labelFi: "vajaakuntoinen työntekijä", labelSv: "handikappad arbetstagare" },
  { pensionCompany: "kevaState", code: "20", labelFi: "kansanedustaja", labelSv: "riksdagsledamot" },
  { pensionCompany: "kevaState", code: "21", labelFi: "VN:n jäsen", labelSv: "medlem i statsrådet" },
  { pensionCompany: "kevaState", code: "24", labelFi: "EU-parlamentaarikko", labelSv: "EU-parlamentariker" },
  { pensionCompany: "kevaState", code: "37", labelFi: "toimeksiantosuhde", labelSv: "uppdragsförhållande" },
  { pensionCompany: "kevaState", code: "38", labelFi: "luottamushenkilö", labelSv: "förtroendevald" },
  { pensionCompany: "kevaState", code: "40", labelFi: "kunnan koululaitoksen palvelus", labelSv: "anställning vid kommunal skolinrättning" },
  { pensionCompany: "kevaState", code: "51", labelFi: "VALTAVA-palvelus", labelSv: "VALTAVA-anställning" },
  { pensionCompany: "kevaState", code: "52", labelFi: "yksityinen VAEL-palvelus", labelSv: "privat StaPL-anställning" },
  { pensionCompany: "kevaState", code: "53", labelFi: "yksityinen oppilaitos/perus- tai lukio-opetus", labelSv: "privat läroanstalt/grundläggande eller gymnasieundervisning" },
  { pensionCompany: "kevaState", code: "54", labelFi: "Pohjoismaisen instituutin palvelus", labelSv: "anställning vid nordisk institution" },
  { pensionCompany: "kevaState", code: "55", labelFi: "asemamaasta palkattu", labelSv: "anställd från stationeringslandet" },
  { pensionCompany: "kevaChurch", code: "V", labelFi: "virkasuhde", labelSv: "tjänsteförhållande" },
  { pensionCompany: "kevaChurch", code: "T", labelFi: "työsuhde", labelSv: "arbetsavtalsförhållande" },
  { pensionCompany: "kevaChurch", code: "L", labelFi: "luottamustoimi", labelSv: "förtroendeuppdrag" },
  { pensionCompany: "kevaChurch", code: "K", labelFi: "konsultti/toimeksianto", labelSv: "konsult/uppdrag" },
  { pensionCompany: "kevaAland", code: "91", labelFi: "Ahvenanmaan palvelus virkasuhteisena", labelSv: "Ålands tjänst i tjänsteförhållande" },
  { pensionCompany: "kevaAland", code: "92", labelFi: "Ahvenanmaan palvelus työsuhteisena", labelSv: "Ålands tjänst i arbetsavtalsförhållande" },
  { pensionCompany: "kevaAland", code: "20", labelFi: "maakuntapäivien edustajat", labelSv: "lagtingsledamöter" },
  { pensionCompany: "kevaAland", code: "21", labelFi: "ministerit, valtioneuvoston jäsenet", labelSv: "ministrar, medlemmar av statsrådet" },
  { pensionCompany: "kevaKela", code: "01", labelFi: "Kelan työsuhde", labelSv: "Anställning hos FPA" },
  { pensionCompany: "kevaKela", code: "02", labelFi: "Palkkionsaaja", labelSv: "Arvodesmottagare" }
], Jo = [
  {
    code: 1,
    labelFi: "Ahtausalan teknisten toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Technical Salaried Stevedoring Personnel",
    labelSv: "Kollektivavtal för tekniska tjänstemän i stuveribranschen"
  },
  {
    code: 2,
    labelFi: "Ahtausalan toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Stedoring Sector",
    labelSv: "Kollektivavtal för tjänstemän i stuveribranschen"
  },
  {
    code: 3,
    labelFi: "Ahtausalan työehtosopimus",
    labelEn: "Collective Agreement for the Stevedoring Sector",
    labelSv: "Kollektivavtal för stuveribranschen"
  },
  {
    code: 4,
    labelFi: "Ammatillisten aikuiskoulutuskeskusten työehtosopimus",
    labelEn: "Collective Agreement for Vocational Adult Education Centres",
    labelSv: "Kollektivavtal för yrkesinriktade vuxenutbildningscenter"
  },
  {
    code: 5,
    labelFi: "Ammattikorkeakoulujen opiskelijakuntien työehtosopimus",
    labelEn: "Collective Agreement for the Student Unions of Universities of Applied Sciences",
    labelSv: "Kollektivavtalet för yrkeshögskolornas studerandekårer"
  },
  {
    code: 6,
    labelFi: "Apteekkien työntekijöiden työehtosopimus",
    labelEn: "Collective Agreement for Pharmacy Employees",
    labelSv: "Kollektivavtal för arbetstagare på apotek"
  },
  {
    code: 10,
    labelFi: "Arkkitehtisuunnittelualan ylempien toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Senior Salaried Employees in the Architectural Sector",
    labelSv: "Kollektivavtal för högre tjänstemän inom arkitektplaneringsbranschen"
  },
  {
    code: 11,
    labelFi: "Asfalttialan työehtosopimus",
    labelEn: "Collective Agreement for the Asphalting Sector",
    labelSv: "Kollektivavtal för asfaltbranschen"
  },
  {
    code: 12,
    labelFi: "Asiakaspalvelua, liikenteenhoitoa ja -ohjausta sekä hallinnollisia ja muita toimistotehtäviä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Customer Service, Traffic Management and Control and Administrative and Other Office Work",
    labelSv: "Kollektivavtal gällande kundtjänst, trafikskötsel och -ledning samt administration och andra kontorsuppgifter"
  },
  {
    code: 13,
    labelFi: "Autoalan kaupan ja korjaamotoiminnan työehtosopimus",
    labelEn: "Collective Agreement for Trade and Repair Workshop Activities in the Automotive Sector",
    labelSv: "Kollektivavtal för handel och verkstadsverksamhet inom bilbranschen"
  },
  {
    code: 14,
    labelFi: "Autoalan toimihenkilöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Automotive Sector",
    labelSv: "Kollektivavtal för bilbranschens tjänstemän"
  },
  {
    code: 15,
    labelFi: "Autoliikennealojen toimihenkilöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in Road Transport Sectors",
    labelSv: "Kollektivavtal för tjänstemän i biltrafikbranscherna"
  },
  {
    code: 16,
    labelFi: "Autonrengasalan työehtosopimus",
    labelEn: "Collective Agreement for the Vehicle Tire Sector",
    labelSv: "Kollektivavtal för bildäcksbranschen"
  },
  {
    code: 17,
    labelFi: "Avaintyönantajat AVAINTA ry:n ja Terveys- ja sosiaalialan neuvottelujärjestö TSN ry:n välinen työehtosopimus",
    labelEn: "Collective Agreement between Avaintyönantajat AVAINTA Association and the TSN Association of the Health and Social Services Sector",
    labelSv: "Kollektivavtal mellan Serviceinrättningarnas arbetsgivarförening rf och Hälso- och socialvårdens förhandlingsorganisation TSN rf"
  },
  {
    code: 18,
    labelFi: "Avaintyönantajat AVAINTA ry:n opetusalan työehtosopimus",
    labelEn: "Collective Agreement for Education of the Avaintyönantajat AVAINTA Association",
    labelSv: "Kollektivavtal för AVAINTA Arbetsgivarna rf (Kollektivavtal för undervisningssektorn inom Serviceinrättningarnas arbetsgivarförening)"
  },
  {
    code: 19,
    labelFi: "Avaintyönantajat AVAINTA ry:n työehtosopimus",
    labelEn: "Collective Agreement for the Avaintyönantajat AVAINTA Association",
    labelSv: "Kollektivavtal gällande Serviceinrättningarnas arbetsgivarförening"
  },
  {
    code: 20,
    labelFi: "Bingotyöntekijöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Bingo Employees",
    labelSv: "Kollektivavtal för bingoanställda"
  },
  {
    code: 21,
    labelFi: "Bioenergiateollisuuden palveluyritysten työehtosopimus",
    labelEn: "Collective Agreement for Service Companies in the Bioenergy Industry",
    labelSv: "Kollektivavtal för serviceföretag inom torv- och pelletindustrin"
  },
  {
    code: 22,
    labelFi: "Elintarvikealan automiesten työehtosopimus",
    labelEn: "Collective Agreement for Road Haulage Workers in the Food Sector",
    labelSv: "Kollektivavtal för bilmän inom livsmedelsbranschen"
  },
  {
    code: 23,
    labelFi: "Elintarviketeollisuusliitto ry:n ja Suomen elintarviketyöläisten liitto SEL ry:n välinen elintarvikealojen työehtosopimus",
    labelEn: "Collective Agreement for Food Sectors between the Finnish Food and Drink Industries' Federation and the Finnish Food Workers' Union SEL",
    labelSv: "Kollektivavtal för livsmedelbranschen mellan Finlands livsmedelindustriförbund rf och Finlands livsmedelsarbetareförbund SEL rf"
  },
  {
    code: 24,
    labelFi: "Elintarviketeollisuuden sähkömiesten työehtosopimus",
    labelEn: "Collective Agreement for Electricians in the Food Industry",
    labelSv: "Kollektivavtal för elektriker inom livsmedelsindustrin"
  },
  {
    code: 25,
    labelFi: "Elintarviketeollisuuden toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Food Industry",
    labelSv: "Kollektivavtal för tjänstemän inom livsmedelsindustrin"
  },
  {
    code: 26,
    labelFi: "Elokuva- ja tv-tuotantoa koskeva työehtosopimus",
    labelEn: "Collective Agreement for Cinema and TV Production",
    labelSv: "Kollektivavtal för film- och tv-produktionen"
  },
  {
    code: 27,
    labelFi: "Energiateollisuuden toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Energy Industry",
    labelSv: "Kollektivavtal för tjänstemän i energibranschen"
  },
  {
    code: 28,
    labelFi: "Energiateollisuuden ylempien toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Senior Salaried Employees in the Energy Industry",
    labelSv: "Kollektivavtal för högre tjänstemän i energibranschen"
  },
  {
    code: 29,
    labelFi: "Ensihoitopalvelualan työehtosopimus ",
    labelEn: "Collective Agreement for the Emergency Care Services Industry ",
    labelSv: "Kollektivavtal för den prehospitala akutsjukvården"
  },
  {
    code: 30,
    labelFi: "Farmaseuttisen henkilöstön työehtosopimus",
    labelEn: "Collective Agreement for Pharmaceutical Personnel",
    labelSv: "Kollektivavtal för farmaceutisk personal"
  },
  {
    code: 31,
    labelFi: "Golf-alan työehtosopimus",
    labelEn: "Collective Agreement for the Golf Sector",
    labelSv: "Kollektivavtal för golfbranschen"
  },
  {
    code: 32,
    labelFi: "Hammaslaboratorioalan työehtosopimus ",
    labelEn: "Collective Agreement for the Dental Laboratory Sector ",
    labelSv: "Kollektivavtal för tandlaboratoriebranschen"
  },
  {
    code: 33,
    labelFi: "Hammaslääkärien työnantajayhdistys ry:n ja Tehy ry:n välinen työehtosopimus",
    labelEn: "Collective Agreement between the Employer's Association of Dentists and the Union of Health and Social Care Professionals in Finland",
    labelSv: "Kollektivavtal för personalen inom munhälsovården"
  },
  {
    code: 34,
    labelFi: "Harja- ja sivellinalojen työehtosopimus",
    labelEn: "Collective Agreement for the Sweeper and Brush Sectors",
    labelSv: "Kollektivavtal för borst- och penselbranscherna"
  },
  {
    code: 35,
    labelFi: "Henkilökohtaisia avustajia koskeva työehtosopimus",
    labelEn: "Collective Agreement for Personal Assistants",
    labelSv: "Kollektivavtal för personlig assistans"
  },
  {
    code: 37,
    labelFi: "Hiihtokeskusalan työehtosopimus",
    labelEn: "Collective Agreement for the Skiing Centre Sector",
    labelSv: "Kollektivavtal för skidcenterbranschen"
  },
  {
    code: 39,
    labelFi: "Huolinta-alan toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Forwarding Sector",
    labelSv: "Kollektivavtal för tjänstemän i speditionsbranschen"
  },
  {
    code: 40,
    labelFi: "Huolinta-alan varastoterminaali- ja satamatyöntekijöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Warehouse Terminal and Port Employees in the Forwarding Sector",
    labelSv: "Kollektivavtal för lagerterminal- och hamnarbetstagarna inom speditionsbranschen"
  },
  {
    code: 41,
    labelFi: "Huolto- ja kunnossapitoalan työehtosopimus",
    labelEn: "Collective Agreement for the Servicing and Maintenance Sector",
    labelSv: "Kollektivavtal för service- och underhållsbranschen"
  },
  {
    code: 42,
    labelFi: "Huoltokorjaamoiden työehtosopimus",
    labelEn: "Collective Agreement for Service Workshops",
    labelSv: "Kollektivavtal för serviceverkstäder"
  },
  {
    code: 43,
    labelFi: "Huvi-, teema- ja elämyspuistoja koskeva työehtosopimus",
    labelEn: "Collective Agreement for Amusement, Theme and Experience Parks",
    labelSv: "Kollektivavtal som gäller nöjes-, tema- och äventyrsparker"
  },
  {
    code: 44,
    labelFi: "ICT-alan työehtosopimus toimihenkilöille",
    labelEn: "Collective Agreement for Salaried Employees in the ICT Sector",
    labelSv: "Kollektivavtal för tjänstemän i ICT-branschen"
  },
  {
    code: 45,
    labelFi: "ICT-alan työehtosopimus ylemmille toimihenkilöille",
    labelEn: "Collective Agreement for Senior Salaried Employees in the ICT Sector",
    labelSv: "Kollektivavtal för högre tjänstemän i ICT-branschen"
  },
  {
    code: 46,
    labelFi: "Jakelua koskeva työehtosopimus",
    labelEn: "Collective Agreement for Deliveries",
    labelSv: "Kollektivavtal för utdelning"
  },
  {
    code: 47,
    labelFi: "Jalometallialan työehtosopimus",
    labelEn: "Collective Agreement for the Precious Metal Sector",
    labelSv: "Kollektivavtal för ädelmetallbranschen"
  },
  {
    code: 48,
    labelFi: "Kansipäällystöä ja sairaanhoitajia koskeva työehtosopimus",
    labelEn: "Collective Agreement for Deck Officers and Nurses",
    labelSv: "Kollektivavtal för däcksbefäl och sjukskötare"
  },
  {
    code: 49,
    labelFi: "Kaupan automiesten työehtosopimus",
    labelEn: "Collective Agreement for Commercial Road Haulage Workers",
    labelSv: "Kollektivavtal för chaufförer inom handelsbranschen"
  },
  {
    code: 50,
    labelFi: "Kaupan työehtosopimus",
    labelEn: "Collective Agreement for Trade",
    labelSv: "Handelns kollektivavtal"
  },
  {
    code: 51,
    labelFi: "Kemian perusteollisuuden työehtosopimus",
    labelEn: "Collective Agreement for Basic Chemical Industry",
    labelSv: "Kollektivavtal för den kemiska basindustrin"
  },
  {
    code: 52,
    labelFi: "Kemianalan toimihenkilösopimus",
    labelEn: "Agreement for Salaried Employees in the Chemical Sector",
    labelSv: "Kollektivavtal för tjänstemän inom den kemiska branschen"
  },
  {
    code: 53,
    labelFi: "Kemianteollisuuden ylempien toimihenkilöiden pöytäkirja",
    labelEn: "Protocol for Senior Salaried Employees in the Chemical Industry",
    labelSv: "Protokoll gällande högre tjänstemän inom kemiindustrin"
  },
  {
    code: 54,
    labelFi: "Kenkä- ja nahkateollisuuden ja kultaseppäteollisuuden sekä harja- ja sivellinalojen toimihenkilösopimus",
    labelEn: "Agreement for Salaried Employees in the Leather and Shoe Industry, the Goldsmith Industry and the Sweeper and Brush Sectors",
    labelSv: "Tjänstemannaavtal för sko- och läderindustrin och guldsmedsindustrin samt borst- och penselbranschen"
  },
  {
    code: 55,
    labelFi: "Kenkä- ja nahkateollisuuden työehtosopimus",
    labelEn: "Collective Agreement for the Shoe and Leather Industry",
    labelSv: "Kollektivavtal för sko- och läderindustrin"
  },
  {
    code: 56,
    labelFi: "Kiinteistöalan toimihenkilöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Real Property Sector",
    labelSv: "Kollektivavtal för tjänstemän i fastighetsbranschen"
  },
  {
    code: 57,
    labelFi: "Kiinteistöpalvelualan työntekijöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Employees in the Real Property Services Sector",
    labelSv: "Kollektivavtal för arbetstagare i fastighetsservicebranschen"
  },
  {
    code: 58,
    labelFi: "Konepäällystöä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Engine Officers",
    labelSv: "Kollektivavtal för maskinbefäl"
  },
  {
    code: 60,
    labelFi: "Kotimaan matkustaja-alusliikenteen työehtosopimus",
    labelEn: "Collective Agreement for Domestic Passenger Vessel Traffic",
    labelSv: "Kollektivavtal för passagerarfartyg i inrikestrafiken"
  },
  {
    code: 61,
    labelFi: "Kotitalouskone- ja kodintekniikkahuoltoa sekä palveluautomaattialaa koskeva työehtosopimus",
    labelEn: "Collective Agreement for Domestic Appliance and Home Technology Service and the Service Automation Sector",
    labelSv: "Kollektivavtal för hushållsmaskin- och hemelektronikservice samt serviceautomatbranschen"
  },
  {
    code: 62,
    labelFi: "Kristillisiä järjestöjä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Christian Organisations",
    labelSv: "Kollektivavtal för kristliga organisationer"
  },
  {
    code: 63,
    labelFi: "Kemianteollisuus ry:n, Kumiteollisuus ry:n ja Sähköalojen ammattiliitto ry:n välinen sähköalan työntekijöiden työehtosopimus",
    labelEn: "Collective Agreement for Electrical Employees between the Chemical Industry Federation of Finland, the Rubber Manufacturers' Association of Finland and the Finnish Electrical Workers' Union",
    labelSv: "Kollektivavtal mellan Kemiindustrin rf, Gummiindustrin rf och Elbranschernas fackförbund rf för arbetstagare i elbranschen"
  },
  {
    code: 64,
    labelFi: "Kumiteollisuuden toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Rubber Industry",
    labelSv: "Kollektivavtal för tjänstemän inom gummiindustrin"
  },
  {
    code: 65,
    labelFi: "Kumiteollisuuden työntekijöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Employees in the Rubber Industry",
    labelSv: "Kollektivavtal för arbetstagare inom gummiindustrin"
  },
  {
    code: 66,
    labelFi: "Kuorma-autoalan työehtosopimus",
    labelEn: "Collective Agreement for Truck Drivers",
    labelSv: "Kollektivavtal för lastbilsbranschen"
  },
  {
    code: 67,
    labelFi: "Kuvanvalmistamoita koskeva työehtosopimus",
    labelEn: "Collective Agreement for Photographic Development Studios",
    labelSv: "Kollektivavtal för bildframställningsbranschen"
  },
  {
    code: 68,
    labelFi: "Lasikeraamisen teollisuuden sähkömiesten työehtosopimus",
    labelEn: "Collective Agreement for Electricians in the Glass-Ceramic Industry",
    labelSv: "Kollektivavtal för elektriker inom den glaskeramiska industrin"
  },
  {
    code: 69,
    labelFi: "Lasikeraamisen teollisuuden toimihenkilöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Glass-Ceramic Industry",
    labelSv: "Kollektivavtal för tjänstemän inom den glaskeramiska industrin"
  },
  {
    code: 70,
    labelFi: "Lasikeraamisen teollisuuden työehtosopimus",
    labelEn: "Collective Agreement for the Glass-Ceramic Industry",
    labelSv: "Kollektivavtal för den glaskeramiska industrin"
  },
  {
    code: 71,
    labelFi: "Lasitus-, rakennuslasitus- ja lasinjalostusalan työehtosopimus",
    labelEn: "Collective Agreement for the Glazing, Building Glazing and Glass Processing Industry",
    labelSv: "Kollektivavtal för glasnings-, byggnadsglasnings- och glasförädlingsindustrin"
  },
  {
    code: 72,
    labelFi: "Lattianpäällystysalan työehtosopimus",
    labelEn: "Collective Agreement for the Flooring Industry",
    labelSv: "Kollektivavtal för golvbeläggningsbranschen"
  },
  {
    code: 73,
    labelFi: "Losseja koskeva työehtosopimus",
    labelEn: "Collective Agreement for Cable Ferries",
    labelSv: "Kollektivavtal för färjör mellan Arbetsgivarna för servicebranscherna PALTA rf samt Förbundet för den offentliga sektorn och välfärdsområdena JHL rf och Finlands Sjömans-Union FSU rf"
  },
  {
    code: 74,
    labelFi: "Leipomoiden työntekijöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Bakery Employees",
    labelSv: "Kollektivavtal för bageriarbetstagare"
  },
  {
    code: 75,
    labelFi: "Lentoliikenteen palveluja koskeva työehtosopimus ",
    labelEn: "Collective Agreement for Air Transport Services ",
    labelSv: "Kollektivavtal gällande tjänster inom flygtrafiken"
  },
  {
    code: 76,
    labelFi: "Lentoliikenteen toimihenkilöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in Air Transport",
    labelSv: "Kollektivavtal för tjänstemän inom flygtrafiken"
  },
  {
    code: 77,
    labelFi: "Liha-alan työehtosopimus",
    labelEn: "Collective Agreement for the Meat Industry",
    labelSv: "Kollektivavtal för köttbranschen"
  },
  {
    code: 79,
    labelFi: "Liikenneopetusalan työehtosopimus",
    labelEn: "Collective Agreement for the Driving Instructor Industry",
    labelSv: "Kollektivavtal för trafikundervisningsbranschen"
  },
  {
    code: 80,
    labelFi: "Linja-autohenkilökunnan työehtosopimus",
    labelEn: "Collective Agreement for the Bus and Coach Personnel",
    labelSv: "Kollektivavtal för busspersonalen"
  },
  {
    code: 81,
    labelFi: "Luottotieto- ja perintäalan työehtosopimus",
    labelEn: "Collective Agreement for the Credit Information and Debt Recovery Sector",
    labelSv: "Kollektivavtal för kreditupplysnings- och inkassobranschen"
  },
  {
    code: 82,
    labelFi: "Infra-alan työehtosopimus",
    labelEn: "Collective agreement for the infrastructural sector",
    labelSv: "Infrastrukturbranschens kollektivavtal"
  },
  {
    code: 83,
    labelFi: "Maalausalan työehtosopimus urakkahinnoitteluineen",
    labelEn: "Collective Agreement for the Painting Sector, with Contract Rates",
    labelSv: "Kollektivavtal för målningsbranschen inklusive entreprenadprissättning"
  },
  {
    code: 84,
    labelFi: "Maarakennusalan työehtosopimus (Koneyrittäjien liitto)",
    labelEn: "Collective Agreement for the Earthworks Sector (the Trade Association of Finnish Forestry and Earth Moving Contractors)",
    labelSv: "Kollektivavtal för markbyggnadsbranschen (Maskinföretagarnas förbund)"
  },
  {
    code: 85,
    labelFi: "Maaseutuelinkeinojen työehtosopimus",
    labelEn: "Collective Agreement for Rural Industries",
    labelSv: "Kollektivavtal för landsbygdsnäringarna"
  },
  {
    code: 87,
    labelFi: "Malmikaivosten työehtosopimus",
    labelEn: "Collective Agreement for Ore Mines",
    labelSv: "Kollektivavtal för arbetstagare i malmgruvor"
  },
  {
    code: 89,
    labelFi: "Matkailu-, ravintola ja vapaa-ajan palveluita koskeva työehtosopimus - työntekijät",
    labelEn: "Collective Agreement for Tourism, Restaurant and Recreational Services - Employees",
    labelSv: "Kollektivavtal för arbetstagare i branschen för turism-, restaurang- och fritidstjänster"
  },
  {
    code: 90,
    labelFi: "Matkatoimistoja koskeva työehtosopimus",
    labelEn: "Collective Agreement for Travel Agencies",
    labelSv: "Kollektivavtal för resebyråer"
  },
  {
    code: 91,
    labelFi: "Matkustamohenkilöstöä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Cabin Crew",
    labelSv: "Kollektivavtal för kabinpersonal"
  },
  {
    code: 92,
    labelFi: "Meijereiden erikoiskoulutuksen saaneiden ja teknisten toimihenkilöiden työehtosopimus ",
    labelEn: "Collective Agreement for Salaried Employees with Special or Technical Education in Dairies ",
    labelSv: "Kollektivavtal för meijeriernas specialutbildade och tekniska funktionärer"
  },
  {
    code: 93,
    labelFi: "Meijerityöntekijöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Dairy Employees",
    labelSv: "Kollektivavtal för mejeriarbetstagare"
  },
  {
    code: 98,
    labelFi: "Metsäalan työehtosopimus",
    labelEn: "Collective Agreement for the Forestry Sector",
    labelSv: "Kollektivavtal för skogsbranschen"
  },
  {
    code: 99,
    labelFi: "Metsäkonealan työehtosopimus",
    labelEn: "Collective Agreement for the Forestry Machine Sector",
    labelSv: "Kollektivavtal för skogsmaskinbranschen"
  },
  {
    code: 100,
    labelFi: "Metsänhoitoyhdistysten toimihenkilöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in Forest Management Associations",
    labelSv: "Kollektivavtal för skogsvårdsföreningarnas tjänstemän"
  },
  {
    code: 103,
    labelFi: "Muovituoteteollisuuden ja kemian tuoteteollisuuden työehtosopimus",
    labelEn: "Collective Agreement for the Plastics Product Industry and the Chemical Product Industry",
    labelSv: "Kollektivavtal för plastproduktindustrin och kemiproduktindustrin"
  },
  {
    code: 104,
    labelFi: "Museoiden työehtosopimus",
    labelEn: "Collective Agreement for Museums",
    labelSv: "Kollektivavtal gällande museer"
  },
  {
    code: 105,
    labelFi: "Neuvonta-alan runkosopimus",
    labelEn: "Framework Agreement for the Counselling Sector",
    labelSv: "Ramavtal för rådgivningsbranschen"
  },
  {
    code: 106,
    labelFi: "Näyttelijöiden teatterityöehtosopimus",
    labelEn: "Collective Agreement for Theatrical Actors",
    labelSv: "Kollektivavtal för skådespelare"
  },
  {
    code: 107,
    labelFi: "Ohjelmapalvelualan työehtosopimus",
    labelEn: "Collective Agreement for the Programme Services Industry",
    labelSv: "Kollektivavtal för programservicebranschen"
  },
  {
    code: 108,
    labelFi: "Optikoiden työehtosopimus",
    labelEn: "Collective Agreement for Opticians",
    labelSv: "Kollektivavtal för optiker"
  },
  {
    code: 110,
    labelFi: "Pahvin- ja paperinjalostusalan toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Board and Paper Processing Sector",
    labelSv: "Kollektivavtal för tjänstemän inom kartong- och pappersförädlingsbranschen"
  },
  {
    code: 111,
    labelFi: "Pahvin- ja paperinjalostusalan työehtosopimus",
    labelEn: "Collective Agreement for the Board and Paper Processing Sector",
    labelSv: "Kollektivavtal för kartong- och pappersförädlingsbranschen"
  },
  {
    code: 113,
    labelFi: "PALTAn toimihenkilöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Palta's Salaried Employees",
    labelSv: "Kollektivavtal för tjänstemän hos medlemsföretag i PALTA"
  },
  {
    code: 116,
    labelFi: "Panimoiden ja virvoitusjuomatehtaiden työehtosopimus",
    labelEn: "Collective Agreement for Breweries and Beverage Plants",
    labelSv: "Kollektivavtal för bryggerier och läskedrycksfabriker"
  },
  {
    code: 119,
    labelFi: "Pelti- ja teollisuuseristysalan työehtosopimus",
    labelEn: "Collective Agreement for the Sheet Metal and Industrial Insulation Sector",
    labelSv: "Kollektivavtal för plåt- och industriisoleringsbranschen"
  },
  {
    code: 120,
    labelFi: "Puusepänteollisuuden toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Carpentry Industry",
    labelSv: "Kollektivavtal för tjänstemän inom snickeriindustrin"
  },
  {
    code: 121,
    labelFi: "Puusepänteollisuuden työehtosopimus",
    labelEn: "Collective Agreement for the Carpentry Industry",
    labelSv: "Kollektivavtal för snickeriindustrin"
  },
  {
    code: 122,
    labelFi: "Puutarha-alan työehtosopimus",
    labelEn: "Collective Agreement for the Gardening Sector",
    labelSv: "Kollektivavtal för trädgårdsbranschen"
  },
  {
    code: 124,
    labelFi: "Rahoitusalan siivoojia koskeva työehtosopimus",
    labelEn: "Collective Agreement for Cleaners in the Financial Sector",
    labelSv: "Kollektivavtal för städare i finansieringsbranschen"
  },
  {
    code: 125,
    labelFi: "Rahoitusalan työehtosopimus",
    labelEn: "Collective Agreement for the Financial Sector",
    labelSv: "Kollektivavtal för finansbranschen"
  },
  {
    code: 126,
    labelFi: "Rakennusaine- ja betoniteollisuuden toimihenkilöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Construction Material and Concrete Industry",
    labelSv: "Kollektivavtal för tjänstemän i byggämnes- och betongindustrin"
  },
  {
    code: 127,
    labelFi: "Rakennusalan toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Construction Sector",
    labelSv: "Kollektivavtal för tjänstemän i byggbranschen"
  },
  {
    code: 128,
    labelFi: "Rakennusalan työehtosopimus urakkahinnoitteluineen",
    labelEn: "Collective Agreement for the Construction Sector, with Contract Rates",
    labelSv: "Kollektivavtal för byggbranschen"
  },
  {
    code: 129,
    labelFi: "Rakennustuoteteollisuuden työehtosopimus",
    labelEn: "Collective Agreement for the Construction Product Industry",
    labelSv: "Kollektivavtal för byggproduktindustrin"
  },
  {
    code: 130,
    labelFi: "Rautatiealan työehtosopimus",
    labelEn: "Collective Agreement for the Railway Sector",
    labelSv: "Kollektivavtal för järnvägsbranschen"
  },
  {
    code: 131,
    labelFi: "Seminologien ja keinosiemennysasemien työehtosopimus ",
    labelEn: "Collective Agreement for Seminologists and Artificial Insemination Stations ",
    labelSv: "Kollektivavtal för seminologer och stationer för artificiell"
  },
  {
    code: 132,
    labelFi: "Sosiaalialan järjestöjä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Social Services Organisations",
    labelSv: "Kollektivavtal för organisationer inom det sociala området"
  },
  {
    code: 133,
    labelFi: "Suunnittelu- ja konsulttialan toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Design and Consultancy Sector",
    labelSv: "Kollektivavtal för tjänstemän I planerings- och konsultbranschen"
  },
  {
    code: 134,
    labelFi: "Suunnittelu- ja konsulttialan ylempien toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Senior Salaried Employees in the Design and Consultancy Sector",
    labelSv: "Kollektivavtal för högre tjänstemän i planerings- och konsultbranschen"
  },
  {
    code: 135,
    labelFi: "Sähköalan tes - energia - ICT - verkosto -työehtosopimus ",
    labelEn: "Collective Agreement for the Electricity Sector - Energy - ICT - Network - Collective Agreement ",
    labelSv: "Kollektivavtal för elbranschen - energi - ICT - nätverk"
  },
  {
    code: 136,
    labelFi: "Sähköistys- ja sähköasennusalan työehtosopimus",
    labelEn: "Collective Agreement for the Electrification and Electrical Installations Sector",
    labelSv: "Kollektivavtal för elektrifierings- och elinstallationsbranchen"
  },
  {
    code: 137,
    labelFi: "Säiliöauto- ja öljytuotealaa sekä niihin liittyviä toimintoja koskeva työehtosopimus",
    labelEn: "Collective Agreement for the Tank Truck and Oil Product Sector and Related Functions",
    labelSv: "Kollektivavtal för tankbil- och oljeproduktbranschen och för funktioner med anknytning till dessa"
  },
  {
    code: 138,
    labelFi: "Taimitarha-alan työehtosopimus",
    labelEn: "Collective Agreement for the Nursery Garden Sector",
    labelSv: "Kollektivavtal för plantskolebranschen"
  },
  {
    code: 139,
    labelFi: "Taksiliikenteen työehtosopimus",
    labelEn: "Collective Agreement for Taxi Transport",
    labelSv: "Kollektivavtal gällande taxitrafiken"
  },
  {
    code: 140,
    labelFi: "Talotekniikka-alan LVI-toimialan työehtosopimus",
    labelEn: "Collective Agreement for the HVAC Sector of Building Services Engineering",
    labelSv: "Kollektivavtal för VVS-branschen inom husteknikbranschen"
  },
  {
    code: 142,
    labelFi: "Talotekniikka-alan toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Building Services Engineering Sector",
    labelSv: "Kollektivavtal för tjänstemän i husteknikbranschen"
  },
  {
    code: 143,
    labelFi: "Taloushallintoalaa koskeva työehtosopimus",
    labelEn: "Collective Agreement for the Financial Management Sector",
    labelSv: "Kollektivavtal för ekonomiförvaltningsbranschen"
  },
  {
    code: 144,
    labelFi: "Tanssinopettajien työehtosopimus",
    labelEn: "Collective Agreement for Dance Instructors",
    labelSv: "Kollektivavtal för danslärare"
  },
  {
    code: 145,
    labelFi: "Teatterialan työehtosopimus",
    labelEn: "Collective Agreement for the Theatre Sector",
    labelSv: "Kollektivavtal för teaterbranschen"
  },
  {
    code: 146,
    labelFi: "Teknisen huollon ja kunnossapidon työehtosopimus",
    labelEn: "Collective Agreement for Technical Servicing and Maintenance",
    labelSv: "Kollektivavtal för tekniska service- och underhållsuppgifter"
  },
  {
    code: 148,
    labelFi: "Teknologiateollisuuden toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Technology Industry",
    labelSv: "Kollektivavtal för tjänstemän inom teknologiindustrin"
  },
  {
    code: 150,
    labelFi: "Teknologiateollisuuden ylempien toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Senior Salaried Employees in the Technology Industry",
    labelSv: "Kollektivavtal för teknologiindustrins högre tjänstemän"
  },
  {
    code: 151,
    labelFi: "Tekstiilihuoltoalan työehtosopimus ",
    labelEn: "Collective Agreement for the Textile Care Sector ",
    labelSv: "Kollektivavtal för textilservicebranschen"
  },
  {
    code: 152,
    labelFi: "Tekstiili- ja muotialan toimihenkilösopimus",
    labelEn: "Agreement for Salaried Employees in the Textile and Fashion Sector",
    labelSv: "Kollektivavtal för tjänstemän i textil- och modelbranchen"
  },
  {
    code: 153,
    labelFi: "Tekstiili- ja muotialan työehtosopimus ",
    labelEn: "Collective Agreement for the Textile and Fashion Sector ",
    labelSv: "Kollektivavtal för textil- och modebranchen"
  },
  {
    code: 154,
    labelFi: "Terminaalitoimintaa koskeva työehtosopimus",
    labelEn: "Collective Agreement for Terminal Operations",
    labelSv: "Kollektivavtal gällande terminalverksamhet"
  },
  {
    code: 155,
    labelFi: "Terveyspalvelualan työehtosopimus",
    labelEn: "Collective Agreement for the Health Services Sector",
    labelSv: "Kollektivavtal för hälsovårdsbranchen"
  },
  {
    code: 156,
    labelFi: "Terveyspalvelualan työehtosopimus (Unioni) ",
    labelEn: "Collective Agreement for the Health Services Sector (Union) ",
    labelSv: "Kollektivavtal gällande hälsoservicebranschen (Unioni)"
  },
  {
    code: 157,
    labelFi: "Tietotekniikan palvelualan työehtosopimus",
    labelEn: "Collective Agreement for the Information Technology Services Sector",
    labelSv: "Kollektivavtal för den datatekniska servicebranschen"
  },
  {
    code: 158,
    labelFi: "Tilapäisten teatterimuusikkojen työehtosopimus",
    labelEn: "Collective Agreement for Temporary Theatre Musicians",
    labelSv: "Kollektivavtal för tillfälliga teatermusiker"
  },
  {
    code: 159,
    labelFi: "Turkistuotantoalan työehtosopimus",
    labelEn: "Collective Agreement for the Fur Production Sector",
    labelSv: "Kollektivavtal för pälsproduktion"
  },
  {
    code: 160,
    labelFi: "Turvetuotantoalan työehtosopimus",
    labelEn: "Collective Agreement for the Peat Mining Sector",
    labelSv: "Kollektivavtal för torvproduktionsbranschen"
  },
  {
    code: 162,
    labelFi: "Ulkomaanliikenteen kauppa-aluksia koskeva työehtosopimus ",
    labelEn: "Collective Agreement for Merchant Vessels in International Traffic ",
    labelSv: "Kollektivavtal för utrikesfartens handelsfartyg"
  },
  {
    code: 163,
    labelFi: "Ulkomaanliikenteen matkustaja-alussopimus",
    labelEn: "Agreement for Passenger Vessels in International Traffic",
    labelSv: "Kollektivavtal för passagerarfartyg i utrikestrafik"
  },
  {
    code: 164,
    labelFi: "Ulkomaanliikenteen pientonniston kansipäällystöä koskeva työehtosopimus",
    labelEn: "Collective Agreement for the Deck Officers of Small-Tonnage Vessels in International Traffic",
    labelSv: "Kollektivavtal för småtonnage i utrikesfart som gäller däcksbefäl"
  },
  {
    code: 165,
    labelFi: "Ulkomaanliikenteen pientonniston konepäällystöä koskeva työehtosopimus",
    labelEn: "Collective Agreement for the Engine Officers of Small-Tonnage Vessels in International Traffic",
    labelSv: "Kollektivavtal för småtonnage i utrikesfart som gäller maskinbefäl"
  },
  {
    code: 166,
    labelFi: "Urheilujärjestöjen valmentajia koskeva työehtosopimus",
    labelEn: "Collective Agreement for the Coaches of Sports Organisations",
    labelSv: "Kollektivavtal för tränare i idrottsorganisationer"
  },
  {
    code: 167,
    labelFi: "Urheilujärjestöjä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Sports Organisations",
    labelSv: "Kollektivavtal gällande idrottsorganisationer"
  },
  {
    code: 168,
    labelFi: "Vakinaisten teatterimuusikkojen työehtosopimus",
    labelEn: "Collective Agreement for Permanent Theatre Musicians",
    labelSv: "Kollektivavtal för ordinarie teatermusiker"
  },
  {
    code: 169,
    labelFi: "Vakuutusalan työehto- ja palkkasopimukset",
    labelEn: "Collective and Salary Agreements for the Insurance Sector",
    labelSv: "Försäkringsbranschens kollektiv- och löneavtal"
  },
  {
    code: 171,
    labelFi: "Vartiointialan työehtosopimus",
    labelEn: "Collective Agreement for the Security Services Sector",
    labelSv: "Kollektivavtal för bevakningsbranschen"
  },
  {
    code: 172,
    labelFi: "Vedeneristysalan työehtosopimus",
    labelEn: "Collective Agreement for the Waterproofing Sector",
    labelSv: "Kollektivavtal för vattenisoleringsbranschen"
  },
  {
    code: 173,
    labelFi: "Veneenrakennusteollisuuden työehtosopimus",
    labelEn: "Collective Agreement for the Boat Construction Industry",
    labelSv: "Kollektivavtal för båtbyggnadsindustrin"
  },
  {
    code: 174,
    labelFi: "Veturimiestehtäviä rautatieliikenteessä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Train Driver Duties in Rail Traffic",
    labelSv: "Kollektivavtal för lokmannauppgifter inom järnvägstrafiken"
  },
  {
    code: 175,
    labelFi: "Medialiiton ja Ammattiliitto Pron välinen toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees between the Finnish Media Federation and Trade Union Pro",
    labelSv: "Kollektivavtal för tjänstemän mellan Medieförbundet rf och Fackförbundet Pro"
  },
  {
    code: 176,
    labelFi: "Medialiiton ja Ammattiliitto Pron välinen viestintäalan teknisiä toimihenkilöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Technical Salaried Communication Employees between the Finnish Media Federation and Trade Union Pro",
    labelSv: "Kollektivavtal för tekniska tjänstemän mellan Medieförbundet och Fackförbundet Pro"
  },
  {
    code: 177,
    labelFi: "Medialiiton ja Suomen Journalistiliiton välinen kustannustoimittajien työehtosopimus",
    labelEn: "Collective Agreement for Editors between the Finnish Media Federation and the Union of Journalists in Finland",
    labelSv: "Kollektivavtal för förlagsredaktörer mellan Mediernas cetralförbund och Finlands Journalistförbund"
  },
  {
    code: 178,
    labelFi: "Medialiiton ja Suomen Journalistiliiton välinen työehtosopimus",
    labelEn: "Collective Agreement between the Finnish Media Federation and the Union of Journalists in Finland",
    labelSv: "Kollektivavtal mellan Medieförbundet och Finlands journalistförbund"
  },
  {
    code: 179,
    labelFi: "Medialiiton ja Teollisuusliiton sekä Viestintäalan toimihenkilöt Grafinet ry:n välinen toimihenkilöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees between the Finnish Media Federation, the Industrial Union and the Grafinet Association for Salaried Employees in the Media Industry",
    labelSv: "Kollektivavtal för tjänstemän mellan Medieförbundet och Industrifacket samt Viestintäalan toimihenkilöt Grafinet ry"
  },
  {
    code: 180,
    labelFi: "Medialiiton ja Teollisuusliiton välinen media- ja painoalan työntekijöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Employees in the Media and Printing Industries between the Finnish Media Federation and the Industrial Union",
    labelSv: "Kollektivavtal för arbetstargare inom medie- och tryckeribranchen mellan Medieförbundet och Industrifacket"
  },
  {
    code: 181,
    labelFi: "Viestinvälitys- ja logistiikka-alan työehtosopimus",
    labelEn: "Collective Agreement for the Messaging and Logistics Sector",
    labelSv: "Kollektivavtal för kommunikationsförmedlings- och logistikbranschen"
  },
  {
    code: 182,
    labelFi: "Viestinvälitys- ja logistiikka-alan ylempien toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Senior Salaried Employees in the Messaging and Logistics Sector",
    labelSv: "Kollektivavtal för högre tjänstemän i kommunikationsförmedlings- och logistikbranschen"
  },
  {
    code: 183,
    labelFi: "Viher- ja ympäristörakentamisalan työehtosopimus ",
    labelEn: "Collective Agreement for Green Area and Environmental Construction Sector ",
    labelSv: "Kollektivavtal för grön- och miljöanläggningsbranschen"
  },
  {
    code: 186,
    labelFi: "Yksityisen laboratorioalan toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Private Laboratory Sector",
    labelSv: "Kollektivavtal för tjänstemän inom den privata laboratoriebranschen"
  },
  {
    code: 187,
    labelFi: "Yksityisen opetusalan työehtosopimus",
    labelEn: "Collective Agreement for the Private Education Sector",
    labelSv: "Kollektivavtal för den privata undervisningssektorn"
  },
  {
    code: 188,
    labelFi: "Yksityisen sosiaalipalvelualan työehtosopimus",
    labelEn: "Collective Agreement for the Private Social Services Sector",
    labelSv: "Kollektivavtal för den privata socialservicebranschen"
  },
  {
    code: 189,
    labelFi: "Yliopistojen yleinen työehtosopimus",
    labelEn: "General Collective Agreement for Universities",
    labelSv: "Allmänt kollektivavtal för universitet"
  },
  {
    code: 190,
    labelFi: "Ylioppilaskuntien työehtosopimus",
    labelEn: "Collective Agreement for Student Unions",
    labelSv: "Kollektivavtal för studentkårer"
  },
  {
    code: 191,
    labelFi: "Yrityskehitysorganisaatioiden työehtosopimus",
    labelEn: "Collective Agreement for Business Development Organisations",
    labelSv: "Kollektivavtal för organisationer inom företagsutvecklingen"
  },
  {
    code: 192,
    labelFi: "Äänilevytuottajayhtiöiden palveluksessa olevia muusikkoja, laulajia ja kapellimestareita koskeva työehtosopimus",
    labelEn: "Collective Agreement for Musicians, Singers and Conductors in the Service of Record Producer Companies",
    labelSv: "Kollektivavtal för musiker, sångare och kapellmästare i tjänst hos skivproducentbolag"
  },
  {
    code: 193,
    labelFi: "Öljy-, maakaasu- ja petrokemianteollisuuden työehtosopimus",
    labelEn: "Collective Agreement for the Oil, Natural Gas and Petrochemical Industry",
    labelSv: "Kollektivavtal för olje-, naturgas- och petrokemiska industrin"
  },
  {
    code: 194,
    labelFi: "Muu työehtosopimus",
    labelEn: "Other collective agreement",
    labelSv: "Annat kollektivavtal"
  },
  {
    code: 195,
    labelFi: "Alalla ei ole valtakunnallista työehtosopimusta",
    labelEn: "No national collective agreement for the field",
    labelSv: "Branschen saknar riksomfattande kollektivavtal"
  },
  {
    code: 196,
    labelFi: "Kunnan työehtosopimukset",
    labelEn: "Municipal collective agreements",
    labelSv: "Kommunens kollektivavtal"
  },
  {
    code: 197,
    labelFi: "Valtion työehtosopimukset",
    labelEn: "State collective agreements",
    labelSv: "Statens kollektivavtal"
  },
  {
    code: 198,
    labelFi: "Kirkon työehtosopimukset",
    labelEn: "Church collective agreements",
    labelSv: "Kyrkans kollektivavtal"
  },
  {
    code: 199,
    labelFi: "Asiakaspalvelu- ja telemarkkinointialaa koskeva työehtosopimus",
    labelEn: "Collective Agreement for the Customer Service and Telemarketing Sector",
    labelSv: "Kollektivavtal för kundservice- och telemarketingbranschen"
  },
  {
    code: 200,
    labelFi: "Avaintyönantajat AVAINTA ry:n ja Suomen Muusikkojen liiton välinen työehtosopimus",
    labelEn: "Collective Agreement between Avaintyönantajat AVAINTA Association and the Finnish Musicians’ Union",
    labelSv: "Kollektivavtal mellan AVAINTA Arbetsgivarna rf och och Finlands musikers förbund rf"
  },
  {
    code: 201,
    labelFi: "Elokuvateattereita koskeva työehtosopimus",
    labelEn: "Collective Agreement for Cinemas",
    labelSv: "Kollektivavtal för biografteatrar"
  },
  {
    code: 202,
    labelFi: "Huolto- ja kunnossapitopalvelualan työehtosopimus ylemmille toimihenkilöille",
    labelEn: "Collective Agreement for Senior Salaried Employees in the Repair and Maintenance Service Sector",
    labelSv: "Kollektivavtal för högre tjänstemän i service- och underhållsbranschen"
  },
  {
    code: 204,
    labelFi: "Muuttopalvelualan työehtosopimus",
    labelEn: "Collective Agreement for the Removal Services Sector",
    labelSv: "Kollektivavtal för flyttservicebranschen"
  },
  {
    code: 207,
    labelFi: "Tarkastusalan työehtosopimus",
    labelEn: "Collective Agreement for the Inspection Sector",
    labelSv: "Kollektivavtal för inspektionsbranschen"
  },
  {
    code: 208,
    labelFi: "Rakennustuoteteollisuuden sähkömiesten työehtosopimus",
    labelEn: "Collective Agreement for Electricians in the Construction Product Industry",
    labelSv: "Kollektivavtal för elektriker inom byggproduktindustrin"
  },
  {
    code: 209,
    labelFi: "Tullaajien ja huolintatyönjohtajien työehtosopimus",
    labelEn: "Collective Agreement for Customs Brokers and Freight Forwarding Supervisors",
    labelSv: "Kollektivavtal för förtullare och speditionsarbetsledare"
  },
  {
    code: 210,
    labelFi: "Tekstiilihuoltoalan toimihenkilöitä koskeva työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Textile Care Sector",
    labelSv: "Kollektivavtal för tjänstemän inom textilvårdsbranschen"
  },
  {
    code: 211,
    labelFi: "Suorajakelua koskeva työehtosopimus",
    labelEn: "Collective Agreement for the Delivery of Unaddressed Direct Mail",
    labelSv: "Kollektivavtal för direktutdelning"
  },
  {
    code: 212,
    labelFi: "Partiotyönantajia koskeva työehtosopimus",
    labelEn: "Collective agreement for Scout associations as employers",
    labelSv: "Kollektivavtal för scoutarbetsgivare"
  },
  {
    code: 213,
    labelFi: "Rautatiealan toimihenkilöitä koskeva työehtosopimus",
    labelEn: "Collective agreement for salaried employees in the rail sector",
    labelSv: "Kollektivavtal för tjänstemän inom järnvägsbranschen"
  },
  {
    code: 214,
    labelFi: "Satama-alan työehtosopimus",
    labelEn: "Collective Agreement for the Ports Sector",
    labelSv: "Kollektivavtal för hamnbranschen"
  },
  {
    code: 215,
    labelFi: "Urheiluseuroja koskeva liityntäpöytäkirja",
    labelEn: "Protocol on adherence for sports associations",
    labelSv: "Anslutningsprotokoll gällande idrottsföreningar"
  },
  {
    code: 216,
    labelFi: "Teknologiateollisuuden työntekijät työehtosopimus",
    labelEn: "Collective agreement for employees in technology industry",
    labelSv: "Kollektivavtal för arbetstagare inom teknologiindustrin"
  },
  {
    code: 217,
    labelFi: "Hirsitaloteollisuuden työehtosopimus",
    labelEn: "Collective Agreement for the Log House Industry",
    labelSv: "Kollektivavtal för timmerhusindustrin"
  },
  {
    code: 218,
    labelFi: "Hirsitaloteollisuuden toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Log House Industry",
    labelSv: "Kollektivavtal för tjänstemän inom timmerhusindustrin"
  },
  {
    code: 219,
    labelFi: "Metsäkonealan toimihenkilöiden työehtosopimus",
    labelEn: "Collective Agreement for Salaried Employees in the Forest Machinery sector",
    labelSv: "Kollektivavtal för tjänstemän inom skogsmaskinbranschen"
  },
  {
    code: 220,
    labelFi: "Matkailu-, ravintola- ja vapaa-ajan palveluita koskeva työehtosopimus – esihenkilöt",
    labelEn: "Collective agreement for supervisors in hotel, restaurant and leisure industry ",
    labelSv: "Kollektivavtal för chefer i branschen för turism-, restaurang- och fritidstjänster"
  },
  {
    code: 221,
    labelFi: "Kaupan logistiikan esihenkilöiden työehtosopimus ",
    labelEn: "Collective Agreement for Supervisors in Trade Logistics",
    labelSv: "Kollektivavtal för chefer inom logistik inom handeln"
  },
  {
    code: 222,
    labelFi: "Vähittäiskaupan esihenkilöiden työehtosopimus",
    labelEn: "Collective agreement for retail supervisors",
    labelSv: "Kollektivavtal för chefer inom detaljhandeln"
  },
  {
    code: 223,
    labelFi: "Henkilöstöalan työehtosopimus ",
    labelEn: "Collective Agreement for Employment Industry",
    labelSv: "Kollektivavtal för personalbranschen"
  },
  {
    code: 224,
    labelFi: "Ammattikorkeakoulujen työehtosopimus",
    labelEn: "Collective Agreement for Universities of Applied Sciences",
    labelSv: "Kollektivavtal för yrkeshögskolor"
  }
];
class be {
  /**
   * Gets salary calculation parameters that are changing yearly and holidays of the year.
   * The method is designed for the end-of-year and as such it only supports 2 years:
   * the current / previous year (from Jan to Nov) OR current / next year (in approx. December).
   *
   * @param refDate - Dately object (JavaScript date, ISO string formatted date, or DayJS-object) for which the numbers are fetched.
   * @param nullIfNotSupported - Boolean indicating whether to return null if the year is not supported. By default the method throws an error if no year for the date found.
   *
   * @returns The yearly changing numbers if year supported. Error if year not supported.
   */
  static getYearlyChangingNumbers(e, t = !1) {
    if (!e)
      return;
    const n = c.getYear(e), i = Kr(e).find((s) => s.year === n);
    if (!i) {
      if (t)
        return;
      throw new Error(`Year ${n} not supported.`);
    }
    return i.holidays = this.getYearlyHolidays(e), i;
  }
  /**
   * Gets holidays for the given year.
   *
   * @param forYear - Dately object (JavaScript date, ISO string formatted date, or DayJS-object
   * @returns The holidays for the given year.
   */
  static getYearlyHolidays(e) {
    return c.getYearlyHolidays(e);
  }
  /**
   * Gets the yearly tax-free numbers from the tax authorities.
   * @param forYear - Dately object (JavaScript date, ISO string formatted date, or DayJS-object) for which the numbers are fetched.
   * @returns The numbers for the given year or current year. If given year is not supported, gives an error in the console (does not fail).
   */
  static getYearlyTaxFreeNumbers(e) {
    const t = c.getYear(e);
    let n = Da.find((i) => i.year == t);
    return n || (console.error(`getYearlyTaxFreeNumbers does not support year ${e || "-"}`), n = Da[Da.length - 1]), n;
  }
}
const Hr = [
  {
    order: 1,
    name: "salary",
    category: w.Salary,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: "hidden"
    },
    total: { input: "hidden" },
    price: {},
    incomeTypes: [227]
  },
  {
    order: 2,
    name: "hourlySalary",
    category: w.Salary,
    color: "#4a92e9",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [201]
  },
  {
    order: 3,
    name: "monthlySalary",
    category: w.Salary,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: "hidden"
    },
    total: { input: "hidden" },
    price: {},
    incomeTypes: [201]
  },
  {
    order: 4,
    name: "compensation",
    category: w.Salary,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: "hidden"
    },
    total: { input: "hidden" },
    price: {},
    incomeTypes: [336]
  },
  {
    order: 5,
    name: "totalWorkerPayment",
    category: w.SalaryCalc,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: "hidden"
    },
    total: { input: "hidden" },
    price: {}
  },
  {
    order: 6,
    name: "totalEmployerPayment",
    category: w.SalaryCalc,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: "hidden"
    },
    total: { input: "hidden" },
    price: {}
  },
  {
    order: 7,
    name: "board",
    category: w.Salary,
    kind: { name: "BoardKind", values: null },
    color: "#4a92e9",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [308]
  },
  {
    order: 9,
    name: "hourlySalaryWithWorkingTimeCompensation",
    category: w.SalaryAdditions,
    kind: { name: "WorkingTimeCompensationKind", values: null },
    color: "#15535d",
    amount: { default: 1 },
    total: {},
    price: {}
  },
  {
    order: 10,
    name: "overtime",
    category: w.SalaryAdditions,
    color: "#15535d",
    amount: {
      default: 0.5,
      unit: G.Percent
    },
    total: {},
    price: {},
    incomeTypes: [235]
  },
  {
    order: 11,
    name: "tesWorktimeShortening",
    category: w.SalaryAdditions,
    color: "#15535d",
    favorite: 90,
    amount: {
      default: 0.077,
      unit: G.Percent
    },
    total: {},
    price: {},
    incomeTypes: [216]
  },
  {
    order: 12,
    name: "eveningAddition",
    category: w.SalaryAdditions,
    color: "#15535d",
    amount: {
      unit: G.Hours
    },
    total: {},
    price: {},
    incomeTypes: [206]
  },
  {
    order: 13,
    name: "nightimeAddition",
    category: w.SalaryAdditions,
    color: "#15535d",
    amount: {
      unit: G.Hours
    },
    total: {},
    price: {},
    incomeTypes: [236]
  },
  {
    order: 14,
    name: "saturdayAddition",
    category: w.SalaryAdditions,
    color: "#15535d",
    amount: {
      default: 0.5,
      unit: G.Percent
    },
    total: {},
    price: {},
    incomeTypes: [211]
  },
  {
    order: 15,
    name: "sundayWork",
    category: w.SalaryAdditions,
    color: "#15535d",
    favorite: 10,
    amount: {},
    total: {},
    price: {},
    incomeTypes: [221]
  },
  {
    order: 19,
    name: "otherAdditions",
    category: w.SalaryAdditions,
    color: "#15535d",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [216]
  },
  {
    order: 20,
    name: "remuneration",
    category: w.SalaryAdditions,
    kind: { name: "RemunerationKind", values: null },
    color: "#15535d",
    amount: { default: 1, unit: G.Percent, units: [G.Percent, G.Count] },
    total: {},
    price: {},
    incomeTypes: [202, 203, 220, 223, 226, 233]
  },
  {
    order: 21,
    name: "otherCompensation",
    category: w.SalaryAdditions,
    kind: { name: "OtherCompensationKind", values: null },
    color: "#15535d",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [210, 214, 215, 225, 308, 310, 313, 314, 316, 320, 326, 332, 339, 340, 343, 361, 366, 367, 368]
  },
  {
    order: 22,
    name: "workingTimeCompensation",
    category: w.SalaryAdditions,
    kind: { name: "WorkingTimeCompensationKind", values: null },
    color: "#15535d",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [205, 206, 207, 211, 212, 216, 217, 221, 230, 232, 235, 236, 237]
  },
  {
    order: 23,
    name: "employmentTermination",
    category: w.SalaryAdditions,
    kind: { name: "EmploymentTerminationKind", values: null },
    color: "#15535d",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [208, 224, 229, 231, 338]
  },
  {
    order: 101,
    name: "accomodationBenefit",
    category: w.Benefits,
    color: "#4fcdc4",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [301]
  },
  {
    order: 102,
    name: "mealBenefit",
    category: w.Benefits,
    kind: { name: "MealBenefitKind", values: null },
    // TODO: Add support for marking kinds/rowTypes as obsolete (must be invisible in searches but supported older calculations)
    color: "#4fcdc4",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [303, 334, 407, 408]
  },
  {
    order: 103,
    name: "phoneBenefit",
    category: w.Benefits,
    color: "#4fcdc4",
    amount: { default: 1 },
    price: { default: 20 },
    total: {},
    incomeTypes: [330]
  },
  {
    order: 104,
    name: "carBenefit",
    category: w.Benefits,
    kind: { name: "CarBenefitKind", values: null },
    color: "#4fcdc4",
    amount: {
      default: 1,
      input: "hidden"
    },
    total: {},
    price: {},
    incomeTypes: [304, 401]
  },
  {
    order: 105,
    name: "bicycleBenefit",
    category: w.Benefits,
    kind: { name: "BicycleBenefitKind", values: null },
    color: "#4fcdc4",
    amount: {
      default: 1,
      input: "hidden"
    },
    total: {},
    price: {},
    incomeTypes: [363, 364, 420]
  },
  {
    order: 199,
    name: "otherBenefit",
    category: w.Benefits,
    color: "#4fcdc4",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [317]
  },
  {
    order: 201,
    name: "holidayCompensation",
    category: w.Holidays,
    color: "#ffe66d",
    favorite: 80,
    amount: {
      default: 0.115,
      unit: G.Percent,
      units: [G.Percent, G.Count]
    },
    total: {},
    price: {},
    incomeTypes: [234]
  },
  {
    order: 202,
    name: "holidayBonus",
    category: w.Holidays,
    color: "#ffe66d",
    amount: {
      unit: G.Percent,
      units: [G.Percent, G.Count]
    },
    total: {},
    price: {},
    incomeTypes: [213]
  },
  {
    order: 203,
    name: "holidaySalary",
    category: w.Holidays,
    color: "#ffe66d",
    amount: {
      default: 1,
      unit: G.Count
    },
    total: {},
    price: {},
    incomeTypes: [201]
  },
  {
    order: 301,
    name: "dailyAllowance",
    category: w.Expenses,
    kind: { name: "DailyAllowanceKind", values: null },
    color: "#ffa900",
    favorite: 100,
    price: { default: be.getYearlyChangingNumbers(/* @__PURE__ */ new Date(), !0).sideCosts.taxFreeDailyAllowance },
    amount: {},
    total: {},
    incomeTypes: [331]
  },
  {
    order: 302,
    name: "dailyAllowanceHalf",
    category: w.Expenses,
    color: "#ffa900",
    price: { default: be.getYearlyChangingNumbers(/* @__PURE__ */ new Date(), !0).sideCosts.taxFreeDailyHalfAllowance },
    amount: { unit: G.Days },
    total: {},
    incomeTypes: [331]
  },
  {
    order: 303,
    name: "mealCompensation",
    category: w.Expenses,
    color: "#ffa900",
    price: { default: be.getYearlyChangingNumbers(/* @__PURE__ */ new Date(), !0).sideCosts.taxFreeMealAllowance },
    amount: { unit: G.Days },
    total: {},
    incomeTypes: [303]
  },
  {
    order: 304,
    name: "milageOwnCar",
    category: w.Expenses,
    color: "#ffa900",
    favorite: 20,
    price: { default: be.getYearlyChangingNumbers(/* @__PURE__ */ new Date(), !0).sideCosts.taxFreeKmAllowance },
    amount: { unit: G.Kilometers },
    total: {},
    incomeTypes: [311]
  },
  {
    order: 305,
    name: "toolCompensation",
    category: w.Expenses,
    color: "#ffa900",
    favorite: 60,
    amount: { unit: G.Days },
    total: {},
    price: {},
    incomeTypes: [353]
  },
  {
    order: 306,
    name: "expenses",
    category: w.Expenses,
    color: "#ffa900",
    favorite: 70,
    amount: {},
    total: {},
    price: {},
    incomeTypes: [1]
  },
  {
    order: 307,
    name: "milageDaily",
    category: w.Expenses,
    color: "#ffa900",
    favorite: 30,
    amount: { unit: G.Days },
    total: {},
    price: {},
    incomeTypes: [311]
  },
  {
    order: 308,
    name: "milageOther",
    category: w.Expenses,
    color: "#ffa900",
    amount: { unit: G.Days },
    total: {},
    price: {},
    incomeTypes: [311]
  },
  {
    order: 401,
    name: "unionPayment",
    category: w.Deductions,
    kind: { name: "UnionPaymentKind", values: null },
    color: "#ff6738",
    amount: { input: "hidden" },
    total: { input: "hidden" },
    price: { input: "hidden" },
    incomeTypes: [408]
  },
  {
    order: 402,
    name: "foreclosure",
    category: w.Deductions,
    kind: { name: "ForeclosureKind", values: null },
    color: "#ff6738",
    amount: { input: "hidden" },
    total: { input: "hidden" },
    price: { input: "hidden" },
    incomeTypes: [417]
  },
  {
    order: 403,
    name: "advance",
    category: w.Deductions,
    color: "#ff6738",
    favorite: 40,
    amount: { input: "hidden" },
    total: { input: "hidden" },
    price: {},
    incomeTypes: [1]
  },
  {
    order: 405,
    name: "prepaidExpenses",
    category: w.Deductions,
    color: "#ff6738",
    amount: { input: "hidden" },
    total: { input: "hidden" },
    price: {},
    incomeTypes: [1]
  },
  {
    order: 406,
    name: "otherDeductions",
    category: w.Deductions,
    color: "#ff6738",
    amount: { input: "hidden" },
    total: { input: "hidden" },
    price: {},
    incomeTypes: [408]
  },
  {
    order: 407,
    name: "deductibleOfExerciseAndCultureBenefit",
    category: w.Deductions,
    color: "#ff6738",
    amount: { input: "hidden" },
    total: { input: "hidden" },
    price: {},
    incomeTypes: [408]
  },
  {
    order: 500,
    name: "taxAtSource",
    category: w.Deductions,
    kind: { name: "TaxAtSourceKind", values: null },
    color: "#ff6738",
    amount: {
      unit: G.Percent,
      input: "hidden"
    },
    total: {},
    price: {
      input: "hidden"
    },
    incomeTypes: [404, 405, 412]
  },
  {
    order: 501,
    name: "taxWithholding",
    category: w.Deductions,
    kind: { name: "TaxWithholdingKind", values: null },
    color: "#ff6738",
    amount: {
      unit: G.Percent,
      input: "hidden"
    },
    total: {},
    price: {
      input: "hidden"
    },
    incomeTypes: [402]
  },
  {
    order: 505,
    name: "absencePeriod",
    category: w.Deductions,
    kind: { name: "AbsenceCauseCode", values: null },
    color: "#ff6738",
    amount: {},
    total: {},
    price: {
      input: "hidden"
    },
    incomeTypes: []
  },
  {
    order: 901,
    name: "childCareSubsidy",
    category: w.Deductions,
    color: "#4fcdc4",
    favorite: 50,
    amount: { input: "hidden" },
    total: { input: "hidden" },
    price: {},
    incomeTypes: [321]
  },
  {
    order: 1010,
    name: "nonProfitOrg",
    category: w.Expenses,
    kind: { name: "NonProfitOrgKind", values: null },
    color: "#ffa900",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [357, 358]
  },
  {
    order: 1020,
    name: "subsidisedCommute",
    category: w.Benefits,
    kind: { name: "SubsidisedCommuteKind", values: null },
    color: "#4fcdc4",
    amount: {
      default: 1,
      input: "hidden"
    },
    total: {},
    price: {},
    incomeTypes: [341, 342, 415]
  },
  {
    order: 1100,
    name: "paidSickLeave",
    category: w.Salary,
    kind: { name: "PaidSickLeaveKind", values: null },
    color: "#4a92e9",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [201, 227]
  },
  {
    order: 1110,
    name: "training",
    category: w.Salary,
    kind: { name: "TrainingKind", values: null },
    color: "#4a92e9",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [201, 227]
  },
  {
    order: 3001,
    name: "paidSickLeaveSalary",
    category: w.Salary,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: "hidden"
    },
    total: { input: "hidden" },
    price: {},
    incomeTypes: [227]
  },
  {
    order: 3002,
    name: "paidSickLeaveHourlySalary",
    category: w.Salary,
    color: "#4a92e9",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [201]
  },
  {
    order: 3003,
    name: "paidSickLeaveMonthlySalary",
    category: w.Salary,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: "hidden"
    },
    total: { input: "hidden" },
    price: {},
    incomeTypes: [201]
  },
  {
    order: 3004,
    name: "trainingSalary",
    category: w.Salary,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: "hidden"
    },
    total: { input: "hidden" },
    price: {},
    incomeTypes: [227]
  },
  {
    order: 3005,
    name: "trainingHourlySalary",
    category: w.Salary,
    color: "#4a92e9",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [201]
  },
  {
    order: 3003,
    name: "trainingMonthlySalary",
    category: w.Salary,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: "hidden"
    },
    total: { input: "hidden" },
    price: {},
    incomeTypes: [201]
  },
  {
    order: 9999,
    name: "irIncomeType",
    category: w.Salary,
    kind: { name: "TransactionCode", values: null },
    color: "#4a92e9",
    amount: { default: 1 },
    total: {},
    price: {}
  },
  {
    order: 1e4,
    name: "serviceCharge",
    category: w.Other,
    color: "#289548",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [1]
  },
  {
    order: 10001,
    name: "service",
    category: w.Other,
    color: "#289548",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [1]
  }
], Te = class Te {
};
Te.baseSalary = [
  k.Salary,
  k.HourlySalary,
  k.MonthlySalary,
  k.TotalWorkerPayment,
  k.TotalEmployerPayment,
  k.Compensation,
  // CalculationRowType.IrIncomeType,
  k.Board
], Te.salaryAdditions = [
  k.Overtime,
  k.TesWorktimeShortening,
  k.EveningAddition,
  k.NightimeAddition,
  k.SaturdayAddition,
  k.SundayWork,
  k.HolidayCompensation,
  k.HolidayBonus,
  k.HolidaySalary,
  k.OtherAdditions
  // CalculationRowType.Remuneration,
  // CalculationRowType.OtherCompensation,
  // CalculationRowType.WorkingTimeCompensation,
  // CalculationRowType.EmploymentTermination,
], Te.salary = Te.baseSalary.concat(Te.salaryAdditions), Te.benefits = [
  k.AccomodationBenefit,
  k.MealBenefit,
  k.PhoneBenefit,
  k.OtherBenefit
], Te.expenses = [
  k.Expenses,
  k.MilageOwnCar,
  k.DailyAllowance,
  k.DailyAllowanceHalf,
  k.MealCompensation,
  k.ToolCompensation,
  k.MilageDaily,
  k.MilageOther,
  k.ChildCareSubsidy
], Te.deductions = [
  k.Advance,
  k.Foreclosure,
  k.OtherDeductions,
  k.PrepaidExpenses,
  k.UnionPayment,
  k.AbsencePeriod
], Te.holidays = [
  k.HolidayCompensation,
  k.HolidayBonus,
  k.HolidaySalary
  // CalculationRowType.HolidayDays
], Te.expensesSection = Te.expenses.concat(Te.benefits, Te.deductions);
let $a = Te;
class zo {
}
var $ = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.Anon = "anon", a.Auth = "auth", a.Init = "init", a.Worker = "worker", a.Employer = "employer", a.Household = "household", a.Company = "company", a.Person = "person", a.Hidden = "hidden", a.Test = "test", a.Prod = "prod", a.FiTm = "fiTm", a.FiOy = "fiOy", a.FiRy = "fiRy", a.Any = "any", a.NonVerified = "nonVerified", a.PartnerMessaging = "partnerMessaging", a))($ || {}), ke = /* @__PURE__ */ ((a) => (a.Undefined = "undefined", a.None = "none", a.Tax255 = "tax255", a.Tax24 = "tax24", a.Tax14 = "tax14", a.Tax10 = "tax10", a.Tax0 = "tax0", a.Other = "other", a.Multiple = "multiple", a))(ke || {});
const Le = class Le {
  /**
   * Gets a single UI configuration for Calculation row (built-in row types only).
   * Searches through all row types without role filtering.
   * @param type Type for which the configuration is fetched.
   */
  static getRowConfig(e) {
    return e ? e == k.Unknown ? this.getUnknownConfig() : Le.getBuiltInRowConfigs().find((n) => n.name === e) : void 0;
  }
  /**
   * Gets an indicator string (1-2 characters) for a unit.
   * @param unit Unit that should be described.
   * @returns Given unit indicator or undefined if none is matched (convert to empty string if necessary).
   */
  static getUnitIndicator(e, t = void 0) {
    switch (t = t || d.getLanguage() || Ee.Fi, e) {
      case "eur":
      case "euros":
      case "€":
        e = ce.Euro;
        break;
      case "day":
        e = ce.Days;
        break;
      case "hour":
        e = ce.Hours;
        break;
      case "km":
        e = ce.Kilometers;
        break;
      case "%":
        e = ce.Percent;
        break;
      case "week":
        e = ce.Weeks;
        break;
    }
    if (!(!e || e == ce.Undefined || e == ce.One))
      return d.get(`SALAXY.ENUM.Unit.${e}.shortIndicator`, void 0, t || void 0);
  }
  /** Gets the row configuration for row type "unknown". */
  static getUnknownConfig() {
    return this.unknownRowConfig || (this.unknownRowConfig = this.getRowConfigInternal({
      order: 0,
      name: "unknown",
      category: w.Other,
      color: "#ccc",
      amount: {
        default: 1,
        input: "hidden"
      },
      total: { input: "hidden" },
      price: { input: "hidden" },
      group: "builtIn"
    })), this.unknownRowConfig;
  }
  /**
   * Creates a new CalcRowsLogic helper wichh adapts to role logic (company/household).
   * @param settings The company account settings that may contain company specific roles or just a role marker for "household".
   */
  constructor(e = "company") {
    this.role = e === "household" ? "household" : "company", typeof e == "object" && (this.settings = e);
  }
  /**
   * Gets the custom row configs from company settings if provided in the constructor.
   */
  getCustomRowConfigs() {
    return this.settings?.calc?.salaryDefaults ? this.settings?.calc?.salaryDefaults?.filter((e) => e.source == pa.CustomRowtype).map((e) => e.config) ?? [] : [];
  }
  /**
   * Gets the row types by category.
   * The instance methods filter types based on role.
   * @param category Category to fetch
   */
  getRowTypesByCategory(e) {
    return Le.rowsByCategory[e] || [];
  }
  /**
   * Gets the row configurations by category(ies).
   * The instance methods filter types based on role.
   * @param categories List of categories to filter by.
   */
  getRowConfigsByCategory(e) {
    const t = [];
    for (const n of e || [])
      t.push(...this.getRowTypesByCategory(n));
    return this.getRowConfigsByType(t);
  }
  /**
   * Gets the row configurations based on a list of row types.
   * The instance methods filter types based on role.
   * @param types List of types to filter by.
   */
  getRowConfigsByType(e) {
    return e = e || [], this.getRowConfigs().filter((t) => e.indexOf(t.rowType) >= 0);
  }
  /**
   * Gets a single UI configuration for Calculation row.
   * This method filters for user role. Use static method to return any row configuration (also faster).
   * The instance methods filter types based on role.
   * @param type Type for which the configuration is fetched.
   */
  getRowConfig(e) {
    return e ? e == k.Unknown ? Le.getUnknownConfig() : this.getRowConfigs().find((n) => n.name === e) : void 0;
  }
  /**
   * Gets all the UI configuration objects for calculation rows.
   * Caches the data based on role and language.
   */
  getRowConfigs() {
    return this.role === "household" ? Le.getBuiltInRowConfigs().filter(
      (e) => e.name !== k.Compensation && e.name !== k.Board && e.name !== k.IrIncomeType && e.name !== k.OtherCompensation && e.name !== k.NonProfitOrg
    ) : this.getCustomRowConfigs().concat(Le.getBuiltInRowConfigs().filter((e) => e.name !== k.ChildCareSubsidy)).sort((e, t) => e.order * 100 + (e.group == "builtIn" ? 1 : 0) - (t.order * 100 + (t.group == "builtIn" ? 1 : 0)));
  }
  /** Gets all the row configs cached for each language if language changes. */
  static getBuiltInRowConfigs() {
    const e = d.getLanguage();
    return Le.rowsCache[e] || (Le.rowsCache[e] = Hr.map((t) => Le.getRowConfigInternal(t))), Le.rowsCache[e];
  }
  /** Converts a raw excel generated row configuration to language-versioned JSON object. */
  static getRowConfigInternal(e) {
    if (!e)
      return;
    let t = e.kind?.name ? H.getEnumMetadata(e.kind.name) : void 0;
    if (t?.name === "TransactionCode") {
      const n = Fe.getAll();
      for (const i of t.values)
        i.label = n.find((s) => s.transactionCode === i.name)?.label, i.descr = n.find((s) => s.transactionCode === i.name)?.description;
    }
    return (t?.values?.length ?? 0) < 2 && (t = void 0), {
      name: e.name,
      rowType: e.name,
      type: "/builtIn/" + e.name,
      order: e.order ?? 0,
      kind: t,
      label: d.get("SALAXY.ENUM.CalculationRowType." + e.name + ".label"),
      descr: d.get("SALAXY.ENUM.CalculationRowType." + e.name + ".description"),
      moreInfo: d.getWithDefault("SALAXY.ENUM.CalculationRowType." + e.name + ".moreInfo", void 0),
      category: e.category,
      favorite: e.favorite || 0,
      color: e.color || "#eee",
      iconText: d.getWithDefault("SALAXY.ENUM.CalculationRowType." + e.name + ".iconText", void 0) || "€",
      price: {
        label: d.getWithDefault("SALAXY.ENUM.CalculationRowType." + e.name + ".priceLabel", void 0) || d.get("SALAXY.UI_Terms.price"),
        input: e.price?.input || "number",
        default: e.price?.default || void 0
      },
      amount: {
        label: d.getWithDefault("SALAXY.ENUM.CalculationRowType." + e.name + ".amountLabel", void 0) || d.get("SALAXY.UI_Terms.amount"),
        input: e?.amount?.input || "number",
        default: e?.amount?.default || void 0,
        unit: e?.amount?.unit || void 0,
        units: e?.amount?.units || void 0
      },
      total: {
        input: e?.total?.input || "readOnly"
      },
      incomeTypes: e?.incomeTypes || void 0,
      group: "builtIn"
    };
  }
};
Le.rowsByCategory = {
  /** Base salary types: the ones that you define directly */
  salary: [
    k.Salary,
    k.HourlySalary,
    k.MonthlySalary,
    k.Compensation,
    k.IrIncomeType,
    k.Board,
    k.PaidSickLeave,
    k.PaidSickLeaveSalary,
    k.PaidSickLeaveHourlySalary,
    k.PaidSickLeaveMonthlySalary,
    k.Training
  ],
  /** Additions to base salary - typically a percentage of base salary */
  salaryAdditions: [
    k.Overtime,
    k.TesWorktimeShortening,
    k.EveningAddition,
    k.NightimeAddition,
    k.SaturdayAddition,
    k.SundayWork,
    k.OtherAdditions,
    k.Remuneration,
    k.OtherCompensation,
    k.WorkingTimeCompensation,
    k.EmploymentTermination,
    k.HourlySalaryWithWorkingTimeCompensation
  ],
  /** Benefits: Not paid as money but taxable income */
  benefits: [
    k.MealBenefit,
    k.PhoneBenefit,
    k.SubsidisedCommute,
    k.CarBenefit,
    k.BicycleBenefit,
    k.AccomodationBenefit,
    k.OtherBenefit,
    k.ChildCareSubsidy
  ],
  /** Expenses and other non-taxed compensations */
  expenses: [
    k.DailyAllowance,
    k.Expenses,
    k.MilageOwnCar,
    k.MealCompensation,
    k.ToolCompensation,
    k.MilageDaily,
    k.MilageOther,
    k.NonProfitOrg,
    k.DailyAllowanceHalf
  ],
  /** Holidays */
  holidays: [
    k.HolidayCompensation,
    k.HolidayBonus,
    k.HolidaySalary
  ],
  /** Deductions */
  deductions: [
    k.UnionPayment,
    k.Advance,
    k.Foreclosure,
    k.OtherDeductions,
    k.DeductibleOfExerciseAndCultureBenefit,
    k.PrepaidExpenses,
    k.TaxAtSource,
    k.TaxWithholding,
    k.AbsencePeriod
  ],
  /** Types that are used only as temporary / input types in Calculations - not in the results. */
  salaryCalc: [
    k.TotalWorkerPayment,
    k.TotalEmployerPayment
  ],
  /** Other row types */
  other: [
    // CalculationRowType.ChildCareSubsidy,
    k.Service
  ]
}, Le.rowsCache = {};
let Ga = Le;
class h {
  /**
   * Parses a user input to a float taking into consideration the Finnish culture.
   * Main case is that decimal separator is usually a comma (,).
   * If there is both comma (,) and point (.) in the same string, NaN is returned.
   * Whitespaces are removed and if string contains commas they are replaced with points before conversion to Number.
   * Null, undefined return original value, empty strings (or whitespace only) return null.
   *
   * @param numCandidate - text that should be converted to a number if possible.
   */
  static parseNumber(e) {
    return e == null || typeof e == "number" ? e : typeof e == "string" ? e.indexOf(",") >= 0 && e.indexOf(".") >= 0 ? Number.NaN : (e = e.replace(/\s/, ""), e === "" ? void 0 : Number(e.replace(",", "."))) : Number(e);
  }
  /**
   * Formats a number as a euro price. Uses comma as decimal separator.
   * @param value - Numeric value to format
   * @param addSuffix - If true (default), adds the €-suffix.
   * @param nullChar The character or string for null or Nan value, the default is '-'.
   */
  static formatPrice(e, t = !0, n = "-") {
    return h.formatNumber(e, 2, t ? "€" : "", n);
  }
  /**
   * Rounds a JavaScript number in a reliable way.
   * @param value Number that is rounded. If null given, returns null.
   * @param decimals Number of decimals after the decimal separator. Default is 2 as in money.
   * @returns Number properly rounded, Null/undefined as null, Non-numeric values return Number.NaN
   */
  static round(e, t = 2) {
    if (e == null || t == null)
      return;
    if (e < 0)
      return -1 * h.round(-1 * e, t);
    let n = `${e}`;
    return n.indexOf("e") >= 0 && (n = `${e.toFixed(15)}`), +(Math.round(`${n}e${t}`).toString() + `e-${t}`);
  }
  /**
   * Fixes floating point problems in typical number.toString() scenarios.
   * E.g. `console.debug((0.07 * 100).toString());` returns "7.000000000000001".
   * Null/undefined returns empty string, numbers fixed and otherwise toString() is called.
   * @param value Number to show as string.
   * @returns Number rounded to specified number of decimals. Null/undefined returns empty string.
   * @example
   * console.debug(Numeric.toString(0.07 * 100)); // returns "7"
   * console.debug((0.07 * 100).toString());      // returns "7.000000000000001"
   */
  static toString(e) {
    return e == null ? "" : e.toFixed ? parseFloat(e.toFixed(12)).toString() : e.toString();
  }
  /**
   * Fixes floating point problems in typical number.toFixed() scenarios.
   * E.g. `console.debug((1.005).toFixed(2));` returns "1.00"
   * @param value Number to show as string. Supports null/undefined, but otherwise should be a number.
   * @param fractionDigits Number of digits after the decimal point. Must be in the range 0 - 20, inclusive.
   * @returns Number rounded to specified number of decimals. Null/undefined returns empty string.
   * @example
   * console.debug(Numeric.toFixed(1.005, 2)) // returns "1.01"
   * console.debug((1.005).toFixed(2))        // returns 1.00
   */
  static toFixed(e, t = 0) {
    return e = h.round(e, t), e == null ? "" : e.toFixed(t);
  }
  /**
   * Rounds a JavaScript number in a reliable way in percentage format.
   *
   * @param value Number that is rounded.
   * @param decimals Number of decimals after the decimal separator. Default is 2 as in money.
   * If decimals is null, no rounding is done.
   * @param addSuffix If true, adds '%' sign at the end.
   * @param nullChar The character or string for null or Nan value, the default is '-'.
   */
  static formatPercent(e, t = 2, n = !0, i = "-") {
    return h.formatNumber(e, t, n ? "%" : "", i);
  }
  /**
   * Rounds a JavaScript number and formats it using comma as a separator and optional suffix.
   *
   * @param value Number that is rounded.
   * @param decimals Number of decimals after the decimal separator. Default is 2 as in money. If decimals is null, no rounding is done.
   * @param suffix The suffix to add to the number.
   * @param nullChar The character or string for null or Nan value, the default is '-'.
   */
  static formatNumber(e, t = 2, n = "", i = "-") {
    const s = parseFloat(e);
    if (isNaN(s))
      return i;
    let r = h.toFixed(s, t ?? 10);
    return t == null && (r = `${parseFloat(r)}`), r.replace(/\./, ",") + n;
  }
  /**
   * Formats a number as count optionally taking into account the related unit
   * @param input Input to format
   * @param unit Unit that is used in formatting
   * @param decimals Number of decimals to show
   * @param nullText Text to show if the value is null / undefined. By default returns null, which can then be cought by another filter or logical or ("||")
   * @param zeroText If specified, will use this text without the Unit formatting if the value is zero. By default zero is formatted as "0 [unitText]"
   * @returns formatted input
   */
  static formatUnit(e, t = void 0, n = void 0, i = void 0, s = void 0) {
    if (e == null)
      return i;
    if (s != null && e === 0)
      return s;
    const r = h.round(e, n || 2);
    switch (t) {
      case ce.One:
        return "";
      case ce.Period:
        return r + d.get("SALAXY.NG1.FilterFunctions.sxyCount.period" + (r === 1 ? "" : "s"));
      case ce.Percent:
        return h.round(e * 100, n || 2) + "%";
      case ce.Hours:
      case ce.Days:
      case ce.Weeks:
      case ce.Count:
      case ce.Kilometers:
      case ce.Undefined:
      default:
        return r + " " + (Ga.getUnitIndicator(t) || "");
    }
  }
  /**
   * Checks if the given object is a number.
   * @param numberCandidate Object to check
   */
  static isNumber(e) {
    return !isNaN(parseFloat(e)) && isFinite(e);
  }
}
class Se {
  /**
   * Checks if the given object can be rendered/parsed as a table:
   * All properties are single values: type != "object".
   * NOTE: The function may later consider some known object types (e.g. Avatar, DateRange)
   * as single values without that being a breaking change.
   * @param schema The schema to evaluate.
   * @returns True if the schema can be rendered as a non-hierarchical table.
   */
  static isTable(e) {
    return e?.properties ? Object.getOwnPropertyNames(e.properties).filter((t) => !t.startsWith("$")).every((t) => (e?.properties?.[t] && e.properties[t])?.type != "object") : !1;
  }
  /**
   * Gets all the properties (the entire tree) from the schema
   * @param schema Schema from which to fetch the properties
   * @param prefix Prefix to add to property path: Mainly used in recursion.
   * @returns InputEnumOptions (typically used in UI) where value and text are
   * the property path, e.g. "owner.avatar.sortableName" and title shows the title or description from the schema.
   */
  static getAllProperties(e, t = "") {
    const n = [];
    return Object.keys(e.properties || {}).forEach((i) => {
      const s = e.properties?.[i];
      s && (n.push({
        value: t + i,
        text: t + i,
        title: s.title || s.description
      }), s.type == "object" && n.push(...this.getAllProperties(s, t + i + ".")));
    }), n;
  }
  /**
   * Guesses the schema based on a data object.
   * @param data A data object, e.g. the first line (after header) of incoming data.
   */
  static guessSchema(e, t = "guess") {
    if (!e)
      return;
    const n = {
      description: `Schema generated based on data: ${JSON.stringify(e)}.`,
      type: "object",
      format: "table",
      properties: {}
    };
    return Object.keys(e).forEach((i) => {
      let s = "string";
      if (t == "guess") {
        const r = e[i];
        h.isNumber(r) && (s = "number"), ["true", "false"].indexOf(r) > -1 && (s = "boolean");
      }
      n.properties ?? (n.properties = {}), n.properties[i] = {
        type: s
      };
    }), n;
  }
  /**
   * Gets a property from a schema document. Supports single property names or longer property paths.
   * @param schema The root type from which the property is found.
   * @param path Property path starting with the root schema.
   */
  static getProperty(e, t) {
    if (!e || !t?.trim())
      return;
    const n = t.split(".");
    let i = e, s, r, l = !1;
    for (; n.length; ) {
      if (r = n.shift()?.trim(), !r)
        return;
      const o = i.properties ? i.properties?.[r] : null;
      if (s = i.format, l = (i.required?.indexOf(r) ?? -1) >= 0 || !1, o && Se.isReferenceObject(o))
        throw new Error(`Unresolved reference in ${r}`);
      if (!o)
        return;
      i = o;
    }
    return {
      parentName: s ?? "",
      propertyName: r ?? "",
      schema: i,
      isRequired: l
    };
  }
  /**
   * Checks if the given schema is defined in the current usecase: Exists and has any properties.
   * @param schemaDoc Schema document, typically Usecase.Schema
   * @param schemaNames One or several names of the schema to check whether they are defined.
   * If any schema is exists and has properties, returns true.
   */
  static isDefined(e, ...t) {
    if (t.length === 1) {
      const n = e?.components?.schemas?.[t[0]];
      return n ? Object.keys(n.properties).length > 0 : !1;
    }
    return !!t.find((n) => this.isDefined(e, n));
  }
  /** Typeguard for OpenAPIV2 */
  static isOpenAPIV3(e) {
    return e?.openapi?.startsWith("3.") || !1;
  }
  /** Typeguard for OpenAPIV3 */
  static isOpenAPIV2(e) {
    return e?.swagger?.startsWith("2.") || !1;
  }
  /** Typeguard for JSON schema (TODO: consider adding more generic Schema typing).) */
  static isSchemaDocument(e) {
    return !!e?.$schema;
  }
  /** Typeguard for OpenAPIV3.ReferenceObject  */
  static isReferenceObject(e) {
    return !!e?.$ref;
  }
  /** Typeguard for OpenAPIV3.NonArraySchemaObject  */
  static isNonArraySchemaObject(e) {
    return ["boolean", "object", "number", "string", "integer"].indexOf(e.type) >= 0;
  }
  /** Typeguard for OpenAPIV3.ArraySchemaObject  */
  static isArraySchemaObject(e) {
    return e.type === "array";
  }
}
class Xo {
  constructor(e) {
    this.schemaCache = [], this.ajax = e;
  }
  /**
   * Adds a local schema document and derefernces it.
   * @param url URL that identifies the schema
   * @param doc The schema document as object.
   * @returns A promise of the object.
   */
  addSchemaDocument(e, t) {
    if (e = this.getAbsoluteUrl(e).toLowerCase().trim(), this.schemaCache = this.schemaCache.filter((n) => n.url !== e), Se.isOpenAPIV2(t) && (t = {
      openapi: "3.0.1",
      info: t.info,
      paths: t.paths,
      components: {
        // HACK: There are differneces in two schema objects. Go through what they are exactly and migrate/mitigate if possible.
        schemas: t.definitions
      }
    }), Se.isSchemaDocument(t) && (t = {
      openapi: "3.0.1",
      info: {
        title: t.title,
        version: "1.0",
        description: t.description
      },
      paths: {},
      components: {
        // TODO: There may be differneces in two schema objects (depending on the version). Go through what they are exactly and migrate/mitigate if possible.
        schemas: t.definitions
      }
    }), Se.isOpenAPIV3(t))
      return this.prepareSchema(t), this.schemaCache.push({
        url: e.toLowerCase(),
        doc: t,
        type: "OpenAPIV3"
      }), t;
    throw new Error("Unsupported JSON schema / open api: " + e);
  }
  /**
   * Prepares the scehma for our use:
   * Dereferences the internal references ($ref-attribute) as JavaScript references.
   * Also adds the schema names to the format attribute of schema.
   * External references are currently not handled.
   */
  prepareSchema(e) {
    Object.keys(e.components?.schemas ?? {}).forEach((t) => {
      const n = e.components?.schemas?.[t];
      n && (n.format = t, Se.isNonArraySchemaObject(n) && n.type === "object" && n.properties && (Object.keys(n.properties).forEach((i) => {
        const s = n.properties?.[i];
        let r = s.$ref;
        if (!r && s.oneOf && (r = s.oneOf[0].$ref), r)
          r.startsWith("#/components/schemas/") ? n.properties[i] = e.components?.schemas?.[r.replace("#/components/schemas/", "")] : r.startsWith("#/definitions/") ? n.properties[i] = e.components?.schemas?.[r.replace("#/definitions/", "")] : console.error(`Unhandled $ref: ${r}`);
        else if (Se.isArraySchemaObject(s)) {
          const l = s.items?.$ref;
          l && (l.startsWith("#/components/schemas/") ? s.items = e.components?.schemas?.[l.replace("#/components/schemas/", "")] : l.startsWith("#/definitions/") ? s.items = e.components?.schemas?.[l.replace("#/definitions/", "")] : console.error(`Unhandled array items $ref in ${i}: ${r}`));
        }
      }), Object.keys(n.properties).forEach((i) => {
        const s = n.properties?.[i];
        s.readonly != null ? s.readOnly = s.readonly : s["x-readonly"] != null && (s.readOnly = s["x-readonly"]);
      })));
    });
  }
  /**
   * Sorts the properties in JSON schema according to some misc. logic rules
   * (e.g. id first, objects and arrays lower and unknown last).
   * TODO: We could potentially put this in another place: Server-side? UI framework?
   */
  static sortSchemaProperties(e) {
    if (e.properties) {
      const t = Object.keys(e.properties).map((i) => {
        const s = e.properties?.[i], r = {
          key: i,
          prop: s,
          sort: 50
        };
        switch (s.type) {
          case "number":
          case "integer":
          case "boolean":
            break;
          case "string":
            i.endsWith("At") ? r.sort = 20 : i === "id" && (r.sort = 10);
            break;
          case "array":
            r.sort = 70;
            break;
          case "object":
            switch (s.format) {
              case "DateRange":
              case "Avatar":
                r.sort = 50;
                break;
              default:
                r.sort = 60;
                break;
            }
            break;
          default:
            r.sort = 80;
            break;
        }
        return r;
      }), n = {};
      t.sort((i, s) => (i.sort.toString() + i.key).localeCompare(s.sort.toString() + s.key)).forEach((i) => {
        n[i.key] = i.prop;
      }), e.properties = n;
    }
  }
  /**
   * Assures that a schema document identified by URL is loaded from server to the cache.
   * Currently, supports only OpenApi 3, but we may later support OpenApi 2 and/or plain JSON schema.
   * @param openApiUrl URL to the open API document.
   * @returns A promise that resolves when the document has been loaded and you can call other methods on it.
   */
  assureSchemaDocument(e) {
    e = this.getAbsoluteUrl(e);
    const t = this.schemaCache.find((i) => i.url === e);
    if (t)
      return t.loadingDonePromise != null ? t.loadingDonePromise : Promise.resolve(t.doc);
    const n = new Promise((i, s) => {
      this.ajax.getJSON(e).then((r) => {
        if (!r)
          throw new Error("No data from the schema: " + e);
        i(this.addSchemaDocument(e, r));
      }).catch((r) => {
        s(r);
      });
    });
    return this.schemaCache.push({
      url: e,
      type: "OpenAPIV3",
      doc: void 0,
      loadingDonePromise: n
    }), n;
  }
  /**
   * Finds a schema document from the cache.
   * This method is syncronous base method for other schema operations
   * Make sure that the schme document has been loaded before calling as this will not load the document,
   * but will fail instead if the schema document is not there.
   * @param openApiUrl URL to the open API document.
   * @param throwIfNotFound If true, will throw an error if the document is not found in the cache.
   */
  findSchemaDoc(e, t) {
    if (e = this.getAbsoluteUrl(e).toLowerCase().trim(), !e)
      throw new Error("Empty Open API URL.");
    const n = this.schemaCache.find((i) => i.url === e);
    if (!n && t)
      throw new Error("Schema document not loaded: " + e);
    return n;
  }
  /**
   * Finds a single schema (Data model) within a schema document
   * Make sure that the schema document has been loaded before calling as this will not load the document,
   * but will fail instead if the schema document is not there.
   * @param openApiUrl URL to the open API document.
   * @param name Name of the schema (data model)
   */
  findSchema(e, t) {
    e = this.getAbsoluteUrl(e);
    const n = this.findSchemaDoc(e, !0)?.doc?.components?.schemas?.[t];
    if (!n)
      return null;
    if (Se.isReferenceObject(n))
      throw new Error(`Unresolved reference in ${e} - ${t}`);
    return n;
  }
  /**
   * Gets an absolute, environment-specific URL for a relative URL:
   * Directs "salaxy-secure/[...rest of url]" to the API server specified by Ajax and
   * "/[...rest of url]" to the root of window.location.href (requires browser context).
   * @param url URL that is potentially relative either to current site or API server.
   */
  getAbsoluteUrl(e) {
    if (e.startsWith("/")) {
      if (!window)
        throw new Error(`Relative url not supported outside browser scope: '${e}'.`);
      const t = window.location.href.split("/");
      e = `${t[0]}//${t[2]}${e}`;
    } else
      e = e.replace(/^salaxy-secure\//g, `${this.ajax.getServerAddress()}/`);
    return e;
  }
}
class Be {
  /**
   * Takes in an array or string or null and always returns an array.
   * If the incoming value is a string, splits it by commas. This is especaially useful for HTML attributes.
   * Note that null (or other falsy objects) are returned as an empty array.
   *
   * @param arrayCandidate - A string array or string that is split by comma.
   */
  static assureArray(e) {
    return e ? Array.isArray(e) ? e : e.split(",") : [];
  }
  /**
   * Calculates a sum of array items.
   * Null items will be added as zero.
   * @param array Array to sum
   * @param selector Selector for a number to sum.
   */
  static sum(e, t) {
    return e.reduce((n, i, s) => i ? n + (t(i) || 0) : 0, 0);
  }
  /**
   * Sequence generator function gets an array between two numbers (inclusive).
   * (commonly referred to as "range", e.g. Clojure, PHP etc)
   * @param start Start number of the sequence
   * @param stop End number of the sequence
   * @param step Step between the numbers, default is 1.
   * @example
   * Arrays.getRange(2019, 2023);
   * // [2019, 2020, 2021, 2022, 2023]
   */
  static getRange(e, t, n = 1) {
    return ((s, r, l) => Array.from({ length: (r - s) / l + 1 }, (o, u) => s + u * l))(e, t, n);
  }
  /**
   * Does a group-by of an array of objects with given key.
   * @param source The source array.
   * @param selector Selector for the key in the array.
   * @returns An object that is the array grouped by the keys.
   */
  static groupBy(e, t) {
    return e.reduce((n, i) => {
      const s = t(i);
      return s != null && (n[s] ?? (n[s] = [])).push(i), n;
    }, {});
  }
  /**
   * Returns distinct elements from an array based on a selector function.
   * @param source The source array to filter
   * @param selector Function to select the key to compare for uniqueness
   * @returns Array with duplicate elements removed
   */
  static distinct(e, t) {
    return e.filter((n, i, s) => s.findIndex((r) => t(n) === t(r)) === i);
  }
}
const Wr = "3.7.7", _o = Wr, Aa = typeof Buffer == "function", ki = typeof TextDecoder == "function" ? new TextDecoder() : void 0, mi = typeof TextEncoder == "function" ? new TextEncoder() : void 0, qo = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Pa = Array.prototype.slice.call(qo), Ra = ((a) => {
  let e = {};
  return a.forEach((t, n) => e[t] = n), e;
})(Pa), Zo = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/, ge = String.fromCharCode.bind(String), di = typeof Uint8Array.from == "function" ? Uint8Array.from.bind(Uint8Array) : (a) => new Uint8Array(Array.prototype.slice.call(a, 0)), Yr = (a) => a.replace(/=/g, "").replace(/[+\/]/g, (e) => e == "+" ? "-" : "_"), $r = (a) => a.replace(/[^A-Za-z0-9\+\/]/g, ""), Gr = (a) => {
  let e, t, n, i, s = "";
  const r = a.length % 3;
  for (let l = 0; l < a.length; ) {
    if ((t = a.charCodeAt(l++)) > 255 || (n = a.charCodeAt(l++)) > 255 || (i = a.charCodeAt(l++)) > 255)
      throw new TypeError("invalid character found");
    e = t << 16 | n << 8 | i, s += Pa[e >> 18 & 63] + Pa[e >> 12 & 63] + Pa[e >> 6 & 63] + Pa[e & 63];
  }
  return r ? s.slice(0, r - 3) + "===".substring(r) : s;
}, un = typeof btoa == "function" ? (a) => btoa(a) : Aa ? (a) => Buffer.from(a, "binary").toString("base64") : Gr, mt = Aa ? (a) => Buffer.from(a).toString("base64") : (a) => {
  let t = [];
  for (let n = 0, i = a.length; n < i; n += 4096)
    t.push(ge.apply(null, a.subarray(n, n + 4096)));
  return un(t.join(""));
}, Ba = (a, e = !1) => e ? Yr(mt(a)) : mt(a), Qo = (a) => {
  if (a.length < 2) {
    var e = a.charCodeAt(0);
    return e < 128 ? a : e < 2048 ? ge(192 | e >>> 6) + ge(128 | e & 63) : ge(224 | e >>> 12 & 15) + ge(128 | e >>> 6 & 63) + ge(128 | e & 63);
  } else {
    var e = 65536 + (a.charCodeAt(0) - 55296) * 1024 + (a.charCodeAt(1) - 56320);
    return ge(240 | e >>> 18 & 7) + ge(128 | e >>> 12 & 63) + ge(128 | e >>> 6 & 63) + ge(128 | e & 63);
  }
}, el = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g, Jr = (a) => a.replace(el, Qo), ci = Aa ? (a) => Buffer.from(a, "utf8").toString("base64") : mi ? (a) => mt(mi.encode(a)) : (a) => un(Jr(a)), ja = (a, e = !1) => e ? Yr(ci(a)) : ci(a), pi = (a) => ja(a, !0), al = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g, tl = (a) => {
  switch (a.length) {
    case 4:
      var e = (7 & a.charCodeAt(0)) << 18 | (63 & a.charCodeAt(1)) << 12 | (63 & a.charCodeAt(2)) << 6 | 63 & a.charCodeAt(3), t = e - 65536;
      return ge((t >>> 10) + 55296) + ge((t & 1023) + 56320);
    case 3:
      return ge((15 & a.charCodeAt(0)) << 12 | (63 & a.charCodeAt(1)) << 6 | 63 & a.charCodeAt(2));
    default:
      return ge((31 & a.charCodeAt(0)) << 6 | 63 & a.charCodeAt(1));
  }
}, zr = (a) => a.replace(al, tl), Xr = (a) => {
  if (a = a.replace(/\s+/g, ""), !Zo.test(a))
    throw new TypeError("malformed base64.");
  a += "==".slice(2 - (a.length & 3));
  let e, t = "", n, i;
  for (let s = 0; s < a.length; )
    e = Ra[a.charAt(s++)] << 18 | Ra[a.charAt(s++)] << 12 | (n = Ra[a.charAt(s++)]) << 6 | (i = Ra[a.charAt(s++)]), t += n === 64 ? ge(e >> 16 & 255) : i === 64 ? ge(e >> 16 & 255, e >> 8 & 255) : ge(e >> 16 & 255, e >> 8 & 255, e & 255);
  return t;
}, kn = typeof atob == "function" ? (a) => atob($r(a)) : Aa ? (a) => Buffer.from(a, "base64").toString("binary") : Xr, _r = Aa ? (a) => di(Buffer.from(a, "base64")) : (a) => di(kn(a).split("").map((e) => e.charCodeAt(0))), qr = (a) => _r(Zr(a)), nl = Aa ? (a) => Buffer.from(a, "base64").toString("utf8") : ki ? (a) => ki.decode(_r(a)) : (a) => zr(kn(a)), Zr = (a) => $r(a.replace(/[-_]/g, (e) => e == "-" ? "+" : "/")), dt = (a) => nl(Zr(a)), il = (a) => {
  if (typeof a != "string")
    return !1;
  const e = a.replace(/\s+/g, "").replace(/={0,2}$/, "");
  return !/[^\s0-9a-zA-Z\+/]/.test(e) || !/[^\s0-9a-zA-Z\-_]/.test(e);
}, Qr = (a) => ({
  value: a,
  enumerable: !1,
  writable: !0,
  configurable: !0
}), eo = function() {
  const a = (e, t) => Object.defineProperty(String.prototype, e, Qr(t));
  a("fromBase64", function() {
    return dt(this);
  }), a("toBase64", function(e) {
    return ja(this, e);
  }), a("toBase64URI", function() {
    return ja(this, !0);
  }), a("toBase64URL", function() {
    return ja(this, !0);
  }), a("toUint8Array", function() {
    return qr(this);
  });
}, ao = function() {
  const a = (e, t) => Object.defineProperty(Uint8Array.prototype, e, Qr(t));
  a("toBase64", function(e) {
    return Ba(this, e);
  }), a("toBase64URI", function() {
    return Ba(this, !0);
  }), a("toBase64URL", function() {
    return Ba(this, !0);
  });
}, sl = () => {
  eo(), ao();
}, ha = {
  version: Wr,
  VERSION: _o,
  atob: kn,
  atobPolyfill: Xr,
  btoa: un,
  btoaPolyfill: Gr,
  fromBase64: dt,
  toBase64: ja,
  encode: ja,
  encodeURI: pi,
  encodeURL: pi,
  utob: Jr,
  btou: zr,
  decode: dt,
  isValid: il,
  fromUint8Array: Ba,
  toUint8Array: qr,
  extendString: eo,
  extendUint8Array: ao,
  extendBuiltins: sl
};
class ct {
  /**
   * Encodes a string with Base64 encoding.
   * @param text The text that should be encoded.
   * @returns The base64 encoded string.
   */
  static encode(e) {
    return ha.encode(e);
  }
  /**
   * Encodes a string with Base64 URL encoding.
   * @param text The text that should be encoded.
   * @returns The base64 URL encoded string.
   */
  static encodeUrl(e) {
    return ha.encodeURL(e);
  }
  /**
   * Decodes a Base64 encoded string. Wrapper around js-base64 library.
   * @param text The Base64 encoded string to be decoded
   * @returns The decoded string.
   */
  static decode(e) {
    return ha.decode(e);
  }
  /**
   * Creates a Base64-encoded ASCII string from a binary string (i.e., a string in which each character in the string is treated as a byte of binary data).
   * Corresponds to browser btoa() method.
   * @param text The binary array that should be encoded.
   * @returns The base64 encoded string.
   */
  static btoa(e) {
    return ha.btoa(e);
  }
  /**
   * Decodes a Base64 encoded string as binary bytes. The same as browser atob.
   * @param text The Base64 encoded string to be decoded
   * @returns The decoded bytes array.
   */
  static atob(e) {
    return ha.atob(e);
  }
  /**
   * Creates a Base64-encoded ASCII string from a Uint8Array (e.g. `new Uint8Array()` of `ArrayBuffer`).
   * @param array The ASCII int array that should be encoded.
   * @returns The base64 encoded string.
   */
  static fromUint8Array(e) {
    return ha.fromUint8Array(e);
  }
  /**
   * Decodes a Base64 encoded string as an ASCII array.
   * @param text The Base64 encoded string to be decoded
   * @returns The result as an ASCII array.
   */
  static toUint8Array(e) {
    return ha.toUint8Array(e);
  }
}
class ve {
  /**
   * Returns the brand color defined as a global variable.
   *
   * @param color - Named brand color to get.
   * @param format - Color format: hex like '#289548', rgb like 'rgb(40, 149, 72)' or rgba like 'rgba(40, 149, 72, 1.0'. Default value is hex.
   */
  static getBrandColor(e, t = "hex") {
    let n = ve.getStylePropertyValue("--salaxy-brand-" + e);
    if (!n)
      switch (e) {
        case "primary":
          n = "#009fd8";
          break;
        case "success":
          n = "#289548";
          break;
        case "info":
          n = "#91d214";
          break;
        case "warning":
          n = "#ff911e";
          break;
        case "danger":
          n = "#d55552";
          break;
      }
    switch (t) {
      case "rgb":
        return ve.hex2rgb(n);
      case "rgba":
        return ve.hex2rgba(n);
      case "hex":
      default:
        return n;
    }
  }
  /**
   * Returns the css global style variable.
   * E.g. --salaxy-brand-primary
   * @param variableName - Variable name.
   */
  static getStylePropertyValue(e) {
    const t = getComputedStyle(document.body);
    if (!t)
      return;
    let n = t.getPropertyValue(e);
    if (n)
      return n = n.trim(), n;
  }
  /**
   * Returns the hex color value as rgb css function.
   * For example:  value '#289548' as 'rgba(40, 149, 72)'
   *
   * @param hexValue - Hex value.
   */
  static hex2rgb(e) {
    const t = this.hex2rgbaValues(e);
    if (t)
      return `rgb(${t[0]}, ${t[1]}, ${t[2]})`;
  }
  /**
   * Returns the hex color value as rgba css function.
   * For example:  value '#289548ff' as 'rgba(40, 149, 72, 1)'
   *
   * @param hexValue - Hex value.
   */
  static hex2rgba(e) {
    const t = this.hex2rgbaValues(e);
    if (t)
      return `rgba(${t[0]}, ${t[1]}, ${t[2]}, ${t[3].toFixed(2)})`;
  }
  /**
   * Returns the rgb value as hex string.
   * For example: 40, 149, 72 as #289548.
   *
   * @param r - red parameter.
   * @param g - green parameter.
   * @param b - blue parameter.
   */
  static rgb2hex(e, t, n) {
    return "#" + (n | t << 8 | e << 16 | 1 << 24).toString(16).substring(1);
  }
  /**
   * Returns the rgba value as hex string.
   * For example: 40, 149, 72, 1 as #289548ff.
   *
   * @param r - red parameter.
   * @param g - green parameter.
   * @param b - blue parameter.
   * @param a - alpha parameter.
   */
  static rgba2hex(e, t, n, i) {
    const s = (Math.round(255 * i) | 256).toString(16).substring(1);
    return ve.rgb2hex(e, t, n) + s;
  }
  static hex2rgbaValues(e) {
    if (!e || (e = e.trim().toLowerCase(), e.length === 0) || (e.charAt(0) === "#" && (e = e.substring(1)), e.length === 3 && (e += "f"), e.length === 4 && (e = e.charAt(0) + e.charAt(0) + e.charAt(1) + e.charAt(1) + e.charAt(2) + e.charAt(2) + e.charAt(3) + e.charAt(3)), e.length === 6 && (e += "ff"), e.length !== 8))
      return;
    const t = parseInt(e.substring(0, 2), 16), n = parseInt(e.substring(2, 4), 16), i = parseInt(e.substring(4, 6), 16), s = (0 + parseInt(e.substring(6, 8), 16)) / 255;
    return [t, n, i, s];
  }
}
class pt {
  /**
   * Gets a cookie value by a key
   * @param key - CName / key to look for.
   */
  get(e) {
    const n = document.cookie.split(";");
    for (const i of n) {
      const s = decodeURIComponent(i).trim();
      if (s.indexOf(e + "=") === 0)
        return s.substring(e.length + 1);
    }
  }
  /**
   * Sets a cookie value for the specified CName
   * @param cname - CName for the cookie value. Name is uri encoded as a fallback, but generally, you should make sure this is a valid cname.
   * @param value - Value to set for the cookie. Value is uri encoded.
   * @param expirationDays - Days until the cookie expires.
   * Set this to null or 0 to not set the expiration date at all.
   * This defaults the behavior where cookie is deleted when browser is closed.
   */
  setCookie(e, t, n) {
    if (e = encodeURIComponent(e), t = encodeURIComponent(t), n && n > 0) {
      const i = /* @__PURE__ */ new Date();
      i.setTime(i.getTime() + n * 24 * 60 * 60 * 1e3);
      const s = "expires=" + i.toUTCString();
      document.cookie = e + "=" + t + ";" + s + ";path=/";
    } else
      document.cookie = e + "=" + t + ";path=/";
  }
}
J.extend(Tr);
J.extend(Er);
J.extend(Pr);
J.extend(Fr);
J.extend(Cr);
J.extend(Lr);
J.extend(Nr);
J.extend(Rr);
class va {
  /**
   * Adds (or substracts) hours, minutes or seconds to a dately object.
   * @param datelyObject Base timestamp for the addition.
   * @param amount Number of units to add
   * @param unit Unit for the addition: hour,minute,second
   * @returns DatelyObject
   */
  static add(e, t, n) {
    const i = c.getDayJs(e);
    if (!(!i || !t || !n))
      switch (n) {
        case "hour":
          return i.add(t, "hour");
        case "minute":
          return i.add(t, "minute");
        case "second":
          return i.add(t, "second");
        default:
          throw new Error(`Unit "${n}" is not supported.`);
      }
  }
  /**
   * Gets date in HH:mm formatted string
   * @param date Object that should be formatted
   * @returns HH:mm formatted string
   */
  static asTime(e) {
    const t = c.getDayJs(e);
    return t ? t.format("HH:mm") : void 0;
  }
  /**
   * Gets hours and minutes from date and convert them to minutes integer
   * @param date Date used to get hours and minutes
   * @returns Minutes as integer
   */
  static asMinutes(e) {
    const t = c.getDayJs(e);
    return t ? t.hour() * 60 + t.minute() : void 0;
  }
  /**
   * Convert time to ISO datetime string.
   * @param time Timestamp, HH:mm
   * @returns Iso datetime
   */
  static fromTime(e) {
    return e ? /* @__PURE__ */ new Date(`${c.getToday()}T${e}:00`) : /* @__PURE__ */ new Date();
  }
  /**
   * Converts minutes to JSDate object. Adds minutes to start of current day.
   * @param minutes Used minutes to create JSDate
   * @returns JSDate
   */
  static fromMinutes(e) {
    return c.asJSDate(c.getDayJs("today").minute(e));
  }
  /**
   * Formats a datetime ISO string (or other dately object)
   * as time with texts "Today", "Yesterday", "D.M. HH:mm" for this year
   * and "D.M.YYYY" for other years (if necessary, add option for adding time to previous years).
   *
   * @param time Dately object to format
   */
  static format(e) {
    const t = c.getDayJs(e);
    return t ? c.getDayJs("today").isSame(t, "date") ? d.getWithDefault("SALAXY.UI_Terms.timeToday", "Today") + " " + t.format("HH:mm") : c.getDayJs("yesterday").isSame(t, "date") ? d.getWithDefault("SALAXY.UI_Terms.timeYesterday", "Yesterday") + " " + t.format("HH:mm") : c.getDayJs("today").isSame(t, "y") ? t.format("D.M. HH:mm") : t.format("D.M.YYYY") : "-";
  }
  /**
   * Formats a date/time range to an end-user friendly duration text. Note that durations are not context bound.
   * So translation of longer durations depend on context (years, months)
   * @param start Start of the range as ISO string.
   * @param end End of the range as ISO string.
   * @param nullValue Value if start or end is missing or cannot be parsed.
   */
  static formatRangeToDuration(e, t, n = "-") {
    return !e || !t ? n : t < e ? this.formatDurationFromDayJs(c.getDuration(t, e), n) + " ennen" : this.formatDurationFromDayJs(c.getDuration(e, t), n);
  }
  /**
   * Formats a date/time range to an end-user friendly duration text.
   * @param duration Duration as ISO duration string (e.g. P3Y6M4DT12H30M5S)
   * @param nullValue Value if duration is missing or cannot be parsed.
   */
  static formatDuration(e, t = "-") {
    if (!e)
      return t;
    let n = "";
    return e.startsWith("-") && (n = " ennen", e = e.substr(1)), this.formatDurationFromDayJs(J.duration(e), t) + n;
  }
  static formatDurationFromDayJs(e, t) {
    if (!e || !J.isDuration(e))
      return t;
    let n = "";
    return e.years() !== 0 && (n += e.years() + " " + d.getWithDefault("SALAXY.UI_Terms.years", "vuotta") + " "), e.months() !== 0 && (n += e.months() + " " + d.getWithDefault("SALAXY.UI_Terms.months", "kk") + " "), e.days() !== 0 && (n += e.days() + " " + d.getWithDefault("SALAXY.UI_Terms.days", "pv") + " "), e.hours() !== 0 && (n += e.hours() + " " + d.getWithDefault("SALAXY.UI_Terms.hours", "h") + " "), e.minutes() !== 0 && (n += e.minutes() + " " + d.getWithDefault("SALAXY.UI_Terms.minutes", "min") + " "), n.trim();
  }
  /**
   * Gets the hour as 0-based number: 0-23.
   *
   * @param datelyObject - Object that represents datetime: A string, JS Date object, DayJs etc.
   *
   * @returns hour as 0-23 or undefined if the object is not a dately object.
   */
  static getHour(e) {
    const t = c.getDayJs(e);
    return t ? t.hour() : void 0;
  }
  /**
   * Gets the minute as 0-based number: 0-59.
   *
   * @param datelyObject - Object that represents datetime: A string, JS Date object, DayJs etc.
   *
   * @returns hour as 0-59 or undefined if the object is not a dately object.
   */
  static getMinute(e) {
    const t = c.getDayJs(e);
    return t ? t.minute() : void 0;
  }
  /**
   * Gets the second as 0-based number: 0-59.
   *
   * @param datelyObject - Object that represents datetime: A string, JS Date object, DayJs etc.
   *
   * @returns second as 0-59 or undefined if the object is not a dately object.
   */
  static getSecond(e) {
    const t = c.getDayJs(e);
    return t ? t.second() : void 0;
  }
  /**
   * WARNING: Don't use this method. This may be refactored away.
   * Wraps DayJs UTC offset (minutes).
   * See: https://day.js.org/docs/en/manipulate/utc-offset
   * @param timestamp any DayJs compatible DatelyObject
   * @returns number UTC offset in minutes
   */
  static getUTCOffset(e) {
    const t = c.getDayJs(e);
    return t ? t.utcOffset() : void 0;
  }
}
class Ea {
  /**
   * Format an Iban number in 4 digits segments and trim out other than alphanum characters.
   * @param value - String value to format
   * @returns string value
   */
  static formatIban(e) {
    if (!e)
      return e;
    const t = e.toUpperCase().replace(/ /g, ""), n = [];
    for (let i = 0; i < t.length; i += 4)
      n.push(t.substr(i, 4));
    return n.join(" ");
  }
  /**
   * Returns true if the value is a valid IBAN number.
   * Checks for the country specific length as well as checksum.
   * @param value IBAN number number candidate.
   */
  static isIban(e) {
    if (!e)
      return !1;
    const t = {
      AD: 24,
      AE: 23,
      AT: 20,
      AZ: 28,
      BA: 20,
      BE: 16,
      BG: 22,
      BH: 22,
      BR: 29,
      CH: 21,
      CR: 21,
      CY: 28,
      CZ: 24,
      DE: 22,
      DK: 18,
      DO: 28,
      EE: 20,
      ES: 24,
      FI: 18,
      FO: 18,
      FR: 27,
      GB: 22,
      GI: 23,
      GL: 18,
      GR: 27,
      GT: 28,
      HR: 21,
      HU: 28,
      IE: 22,
      IL: 23,
      IS: 26,
      IT: 27,
      JO: 30,
      KW: 30,
      KZ: 20,
      LB: 28,
      LI: 21,
      LT: 20,
      LU: 20,
      LV: 21,
      MC: 27,
      MD: 24,
      ME: 22,
      MK: 19,
      MR: 27,
      MT: 31,
      MU: 30,
      NL: 18,
      NO: 15,
      PK: 24,
      PL: 28,
      PS: 29,
      PT: 25,
      QA: 29,
      RO: 24,
      RS: 22,
      SA: 24,
      SE: 24,
      SI: 19,
      SK: 24,
      SM: 27,
      TN: 24,
      TR: 26
    }, n = e.toUpperCase().replace(/ /g, ""), i = n.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);
    if (!i || n.length !== t[i[1]])
      return !1;
    const s = (i[3] + i[1] + i[2]).replace(/[A-Z]/g, (r) => r.charCodeAt(0) - 55);
    return Ea.mod97(s) === 1;
  }
  /** Gets a dummy iban using random numbers. */
  static getDummyIban() {
    const e = 1e5 + Math.round(Math.random() * 99999), t = 1e5 + Math.round(Math.random() * 99999), n = `${e}00${t}`, i = n + "151800", s = 98 - this.mod97(i), r = s < 10 ? "0" + s.toString() : s.toString();
    return Ea.formatIban("FI" + r + n);
  }
  /**
   * Checks if the given value is an international IBAN.
   * @param value - The value to check.
   * @returns `true` if the value is an international IBAN, `false` otherwise.
   */
  static isInternationalIban(e) {
    return e ? !e.toUpperCase().startsWith("FI") : !1;
  }
  static mod97(e) {
    let t = e.slice(0, 2);
    for (let n = 2; n < e.length; n += 7) {
      const i = String(t) + e.substring(n, n + 7);
      t = parseInt(i, 10) % 97;
    }
    return t;
  }
}
class Z {
  /**
   * Makes an OData query to the the given service URL.
   * @param baseUrl The service URL that is used, e.g. "/v03/api/taxcards/current".
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   * @param ajax The Ajax implementation that is used for HTTP get.
   */
  static getOData(e, t, n) {
    let i;
    return typeof t == "string" ? (t = t.trim(), t.length > 0 && t.substr(0, 1) === "?" && (t = t.substr(1)), i = t.length === 0 ? e : e + "?" + t) : (t = t || {}, i = Z.getUrl(e, t)), n.getJSON(i).then((s) => Z.getODataResult(s));
  }
  /**
   * Export items: Fetches multiple pages (of 50 items) from the storage to achieve high $top (all if zero / null).
   * @param baseUrl The service URL that is used, e.g. "/v03/api/taxcards/current".
   * @param options The options for the query: Filter, search sort etc.
   * @param ajax The Ajax implementation that is used for HTTP get.
   * @param notify Function for notifying progress.
   */
  static exportItems(e, t, n, i) {
    const s = [];
    t = t ? fe.copy(t) : {};
    const l = t.$top || 0;
    t.$top = 50, t.$skip = t.$skip || 0;
    const o = () => this.getOData(e, t, n).then((u) => (s.push(...u.items), i && i(d.get("SALAXY.UI_Terms.wait"), s.length - 1, void 0), !u.items.length || l > 0 && l === s.length ? Promise.resolve() : (t.$skip = s.length, t.$top = l <= 0 || l - s.length > 50 ? 50 : l - s.length, o())));
    return o().then(() => s);
  }
  /**
   * Export items: Fetches multiple pages (server default page size) from the storage to achieve high $top (all if zero / null).
   * @param odataMethod The OData method that is called. Note that Salaxy API methods need the this, so you will need to pass
   * e.g. `(options) => srv.getOData(options)`, not simply `srv.getOData` because the call needs `this`.
   * @param options The options for the query: Filter, search sort etc.
   * Use $top to restrict the amount of items
   * Note that $top currently only restricts within page size (e.g. 50, 100), not exactly to the number of items. This may later change without being a breaking change.
   * @param notify Optional function for notifying progress. Called before each page await.
   */
  static async getAllItems(e, t, n) {
    return (await this.getAllPages(e, t, n)).items;
  }
  /**
   * Export items: Fetches multiple pages (server default page size) from the storage to achieve high $top (all if zero / null).
   * @param odataMethod The OData method that is called. Note that Salaxy API methods need the this, so you will need to pass
   * e.g. `(options) => srv.getOData(options)`, not simply `srv.getOData` because the call needs `this`.
   * @param options The options for the query: Filter, search sort etc.
   * Use $top to restrict the amount of items
   * Note that $top currently only restricts within page size (e.g. 50, 100), not exactly to the number of items. This may later change without being a breaking change.
   * @param notify Optional function for notifying progress. Called before each page await.
   */
  static async getAllPages(e, t, n) {
    t = t ? fe.copy(t) : {};
    const i = t.$top || 0;
    t.$top && delete t.$top, n && n(d.get("SALAXY.UI_Terms.wait"), 0);
    const s = await e(t);
    for (; s.nextPageLink; ) {
      t.$skip = s.items.length, n && n(d.get("SALAXY.UI_Terms.wait"), s.items.length - 1, s.count);
      const r = await e(t);
      if (s.count = r.count, s.items = [...s.items, ...r.items], s.nextPageLink = r.nextPageLink, !r.items.length || i > 0 && i <= s.items.length)
        return s;
    }
    return s;
  }
  /**
   * Gets the result from Ajax result (json) to strongly typed result.
   * @param data Result data coming from the ajax call.
   * This may be either an OData object with count and next page link or just an array depending on the call.
   */
  static getODataResult(e) {
    const t = {
      items: []
    };
    if (e.items)
      e = e, t.items = e.items, t.count = e.count || void 0, t.nextPageLink = e.nextPageLink || void 0;
    else if (e.value) {
      const n = e;
      t.items = n.value, t.count = n["@odata.count"] || void 0, t.nextPageLink = n["@odata.nextLink"] || void 0;
    } else if (Array.isArray(e))
      t.items = e, t.count = void 0, t.nextPageLink = void 0;
    else
      throw Error("Unexpected result: " + typeof e);
    return t;
  }
  /**
   * Escapes the Lucene search language special characters in search text values.
   * Special characters in Lucene Full syntax are: "+-&|!(){}[]^"~*?:\/"
   * and in simple syntax: "-*+|"()'\"
   * @param searchValue Search text value to escape for Lucene.
   * @param isSimpleSyntax If true, only escapes the necessary characters for simple syntax.
   */
  static escapeSearchValue(e, t = !1) {
    return t ? e.replace(/[\-\*\+\|\(\)\'\\]/g, (n) => "\\" + n) : e.replace(/[\+\-\&\|\!\(\)\{\}\[\]\^\"\~\*\?\:\\\/]/g, (n) => "\\" + n);
  }
  /**
   * Gets the URL including the query string using the provided OData query options.
   * @param baseUrl Base URL of the service to which the query is added.
   * If null, the returned URL is the query string part starting with the question mark
   * ...or if none of the options is set, returns just an empty string.
   * @param queryOptions options based on which the query is constructed.
   */
  static getUrl(e, t) {
    t = t || {}, e = (e || "").trim();
    const n = [];
    if (t.$count && n.push("$count=true"), t.$expand && n.push("$expand=" + t.$expand), t.$filter && n.push("$filter=" + t.$filter), t.$orderby && n.push("$orderby=" + t.$orderby), t.$select && n.push("$select=" + t.$select), t.$skip && n.push(`$skip=${t.$skip}`), t.$top && n.push(`$top=${t.$top}`), t.fullSearch)
      n.push("$search=" + encodeURIComponent(t.fullSearch));
    else if (t.$search) {
      let i = t.$search;
      i.indexOf('"') >= 0 ? n.push("$search=" + encodeURIComponent(`${i}`)) : (i = this.escapeSearchValue(t.$search, !0), i = i.endsWith("*") ? i.substring(0, i.length - 1) : i, n.push("$search=" + encodeURIComponent(`"${i}" | ${i} | ${i}*`)));
    }
    return e + (n.length === 0 ? "" : (e.indexOf("?") >= 0 ? "&" : "?") + n.join("&"));
  }
}
class rl {
  /**
   * Escapes HTML
   * @param html HTML text to escape
   * @returns HTML escaped (&<>!'/)
   */
  static escapeHtml(e) {
    const t = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "/": "&#x2F;"
    };
    return String(e).replace(/[&<>"'\/]/g, (n) => t[n]);
  }
  /**
   * Replaces characters in strings that are illegal/unsafe for filenames.
   * Unsafe characters are either removed or replaced by a substitute set
   * in the optional `options` object.
   *
   * Illegal Characters on Various Operating Systems
   * / ? < > \ : * | "
   * https://kb.acronis.com/content/39790
   *
   * Unicode Control codes
   * C0 0x00-0x1f & C1 (0x80-0x9f)
   * http://en.wikipedia.org/wiki/C0_and_C1_control_codes
   *
   * Reserved filenames on Unix-based systems (".", "..")
   * Reserved filenames in Windows ("CON", "PRN", "AUX", "NUL", "COM1",
   * "COM2", "COM3", "COM4", "COM5", "COM6", "COM7", "COM8", "COM9",
   * "LPT1", "LPT2", "LPT3", "LPT4", "LPT5", "LPT6", "LPT7", "LPT8", and
   * "LPT9") case-insesitively and with or without filename extensions.
   *
   * Capped at 255 characters in length.
   * http://unix.stackexchange.com/questions/32795/what-is-the-maximum-allowed-filename-and-folder-size-with-ecryptfs
   *
   * @param name File name to escape.
   */
  static escapeFileName(e) {
    const t = /[\/\?<>\\:\*\|"]/g, n = /[\x00-\x1f\x80-\x9f]/g, i = /^\.+$/, s = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i, r = /[\. ]+$/, l = "_";
    return e && e.replace(t, l).replace(n, l).replace(i, l).replace(s, l).replace(r, l);
  }
}
class to {
  /**
   * Validates the JWT token. Please note that the method does not check the signature.
   * Returns:
   * noToken - the token is null,
   * invalid - the token has invalid format, or some payload values (e.g. exp) are missing,
   * expired - the token has expired,
   * ok - token is valid.
   */
  static validate(e) {
    if (!e)
      return "noToken";
    const t = this.parsePayload(e);
    return !t || !t.exp ? "invalid" : t.exp * 1e3 <= (/* @__PURE__ */ new Date()).getTime() ? "expired" : "ok";
  }
  /**
   * Decodes and parses the payload from the string formatted token.
   * @param token Token as a string.
   * @returns Payload of the token as JSON object.
   */
  static parsePayload(e) {
    const t = e.split(".");
    if (t.length === 3) {
      let n = t[1];
      return n = ct.decode(unescape(n)), JSON.parse(n);
    }
    return null;
  }
  /**
   * Decodes and parses the header from the string formatted token.
   * @param token Token as a string.
   * @returns Payload of the token as JSON object.
   */
  static parseHeader(e) {
    const t = e.split(".");
    if (t.length === 3) {
      let n = t[0];
      return n = ct.decode(unescape(n)), JSON.parse(n);
    }
    return null;
  }
}
class je {
  /**
   * Converts a validation error to a string that is in the same format as the messages in ApiList items.
   * Used in moving validatiaon errors to list items.
   */
  static validationErrorAsMessage(e) {
    if (!e)
      return;
    let t, n = "UnknownValidationError";
    switch (e.type) {
      case Ae.Warning:
        t = "Warning", n = "ValidationWarning";
        break;
      case Ae.General:
        t = "Danger", n = "ValidationErrorGeneral";
        break;
      case Ae.Invalid:
        t = "Danger", n = "ValidationErrorInvalid";
        break;
      case Ae.Required:
        t = "Danger", n = "ValidationErrorRequired";
        break;
      default:
        t = "Danger";
        break;
    }
    return `${n} (Ui${t}): ${e.msg} (ANON at ${c.getToday()} 00:00)`;
  }
  /**
   * Returns true if the given value is a valid Finnish Personal ID (HETU / SSN).
   * Checks the format and checksum.
   * @param value Candidate for Finnish Personal ID.
   */
  static isPersonalIdFi(e) {
    if (!e)
      return !0;
    const n = /^(\d{6})([+\-ABCDEFUVWXY])(\d{3})([a-zA-Z0-9*])$/.exec(e);
    if (!n)
      return !1;
    const i = n[1], s = n[2], r = n[3], l = n[4], o = ["A", "B", "C", "D", "E", "F"].includes(s) ? "20" : ["-", "U", "V", "W", "X", "Y"].includes(s) ? "19" : ["+"].includes(s) ? "18" : null;
    if (o == null)
      return !1;
    if (i[0] !== "4") {
      if (!c.isValidDateTime(i.substr(0, 4) + o + i.substr(4, 2), !0, "DDMMYYYY"))
        return !1;
    } else if (!c.isValidDateTime("0101" + o + i.substr(4, 2), !0, "DDMMYYYY"))
      return !1;
    return l === "*" ? !0 : "0123456789ABCDEFHJKLMNPRSTUVWXY"[parseInt(i + r, 10) % 31] === l.toUpperCase();
  }
  /**
   * Returns true if the value is a valid e-mail.
   * Currently uses a simple regex (source?).
   * @param value E-mail candidate.
   */
  static isEmail(e) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e);
  }
  /**
   * Returns true if the value is a valid mobile phone number: 5-16 numbers and spaces (5-18 if there is a "+" in the beginning).
   * Currently uses a naive regex, but we could extend this to take into account the regional differences.
   * @param value Mobile phone number candidate.
   */
  static isMobilePhone(e) {
    return /^(\+[\d ]{1,3}[\d ]{4,15})$|^([\d ]{5,16})$/.test(e);
  }
  /**
   * Returns true if the value is a valid currency amount with maximum two decimals.
   * @param value Currency amount candidate
   */
  static isCurrency(e) {
    return /^\d+(([.]|[,])\d{1,2})?$/.test(e);
  }
  /**
   * Returns true if the value is a valid number.
   * @param value Number candidate
   */
  static isNumber(e) {
    return /^\d+(([.]|[,])\d+)?$/.test(e);
  }
  /**
   * Returns true if the value is a valid integer.
   * @param value Number candidate
   */
  static isInteger(e) {
    return /^\d+$/.test(e);
  }
  /**
   * Returns true if the value is a valid tax percent amount with maximum one decimal.
   * @param value Tax percent candidate
   */
  static isTaxPercent(e) {
    return /^\d{1,2}(([.]|[,])\d{1})?$/.test(e);
  }
  /** Returns true if the value is a valid Finnish Postal code: 5 numbers. */
  static isPostalCodeFi(e) {
    return /^\d{5}$/.test(e);
  }
  /**
   * Returns true if the value is a valid Finnish Company ID. If the format is not correct, will return false.
   * @param companyIdCandidate String to validate / format
   * @param allowStarAsChecksum If true, allows the checksum character (the last char) to be an asterix (*).
   * @returns boolean
   */
  static formatCompanyIdFi(e, t = !0) {
    if (!e || (e = e.toUpperCase().trim().replace("-", "").replace("–", "").replace("—", ""), e.substr(0, 2) === "FI" && (e = e.substr(2)), e.length === 7 && (e = "0" + e), e.length !== 8))
      return !1;
    const n = [7, 9, 10, 5, 8, 4, 2];
    let i = 0;
    for (let l = 0; l < 7; l++) {
      const o = Number(e.charAt(l));
      if (o < 0 || o > 9)
        return !1;
      i += o * n[l];
    }
    const s = i % 11;
    if (s === 1)
      return !1;
    const r = s === 0 ? 0 : 11 - s;
    return t && e.charAt(7) === "*" || Number(e[7]) === r;
  }
  /**
   * Returns true if the value is a valid IBAN number.
   * Checks for the country specific length as well as checksum.
   * @param value IBAN number number candidate.
   */
  static isIban(e) {
    return Ea.isIban(e);
  }
  /**
   * For validating (RF) reference number.
   * @param value - (RF) reference number.
   *
   * In Finland, the RF reference is formed on the basis of the Finnish reference number. Structure of the RF reference is as follows:
   * RFXX1234561, in which
   * RF is the identifier
   * XX are the two check digits
   * 1234561 is the Finnish reference number, which can be freely formed by the customer.
   * Maximum length of the number is 20 digits, and the final number is a check digit calculated using the algorithm for Finnish reference numbers.
   * The Finnish reference number is appended with the numbers "2715" (the letters RF converted into integers) and "00"
   * The modulo 97 operation is performed on the resulting figure.
   * The remainder is then deducted from 98, which then results in the checksum. If the checksum is smaller than 10, a leading zero is added.
   */
  static isFinnishBankReferenceNumber(e) {
    if (e == null)
      return !1;
    e = e.split(" ").join("");
    const t = e.toUpperCase().startsWith("RF");
    if (t) {
      if (e.slice(0, 2) !== "RF")
        return !1;
      const n = e.slice(2, 4);
      let i = e.slice(4);
      i = i.replace(/^0+/, "");
      const s = i.substring(0, i.length - 1), r = parseInt(i.slice(-1)), l = e.slice(4) + "271500";
      let o;
      try {
        o = BigInt(l);
      } catch (p) {
        return console.error(p), !1;
      }
      let u = Number(o % 97n);
      u = 98 - u;
      let m = u.toString();
      return u < 10 && (m = m.padStart(2, "0")), m == n && je.getCheckNumber(s) == r;
    } else if (!t) {
      const n = e.replace(/^0+/, ""), i = n.substring(0, n.length - 1), s = parseInt(n.slice(-1));
      return je.getCheckNumber(i) == s;
    }
    return !1;
  }
  /**
   * For calculating bank reference checksum number.
   * @param value - Reference number without checksum.
   *
   * The reference number must always include a checksum. The checksum is calculated as follows:
   * All digits of the reference number are multiplied from right to left with the values 7, 3, 1.
   * The products are then summed up and the sum is subtracted from the following full ten.
   * The resulting difference is the checksum, the final digit in the reference number.
   * If the difference is 10, the checksum is 0.
   */
  static getCheckNumber(e) {
    const t = [7, 3, 1], n = e.split("").reverse();
    if (n.length > 19)
      return;
    let i = 0;
    for (let s = 0; s < n.length; s++) {
      const r = parseInt(n[s]);
      i += r * t[s % 3];
    }
    return (10 - i % 10) % 10;
  }
  /**
   * Returns PensionCompany for the given pension contract number.
   * @param value - Pension contract number.
   */
  static isPensionContractNumber(e) {
    if (e == null)
      return;
    let t;
    e.startsWith("7") || e.startsWith("8") ? t = /^(\d{5})\-?(\d{4})([a-zA-Z0-9\*])$/ : t = /^(\d{2})\-?(\d{7})([a-zA-Z0-9\*])$/;
    const n = t.exec(e);
    if (!n)
      return;
    const i = n[1], s = n[2], r = n[3];
    if ("0123456789ABCDEFHJKLMNPRSTUVWXY"[parseInt(i + s, 10) % 31] === r)
      switch (i) {
        case "80009":
          return U.Apteekkien;
        case "80008":
          return U.Verso;
        case "54":
          return U.Elo;
        case "90":
          return U.Etera;
        case "46":
          return s?.startsWith("4") ? void 0 : U.Ilmarinen;
        case "40":
          return U.PensionsAlandia;
        case "55":
          return s?.startsWith("2") ? void 0 : U.Varma;
        case "56":
          return U.Veritas;
        case "20":
          return U.KevaMunicipal;
        case "24":
          return U.KevaAland;
        case "25":
          return U.KevaChurch;
        case "29":
          return U.KevaKela;
        case "30":
          return U.KevaState;
        case "80001":
          return U.Valio;
      }
  }
  /**
   * Returns PensionCompany for the given *temporary* pension contract number.
   * @param value - TemporaryPension contract number.
   */
  static isTemporaryPensionContractNumber(e) {
    if (e != null)
      switch (e) {
        case "55-3999990D":
          return U.Varma;
        case "46-3000000V":
          return U.Ilmarinen;
        case "54-0000000U":
          return U.Elo;
        case "56-0049990P":
          return U.Veritas;
      }
  }
}
class ol {
  /**
   * Runs promises in sequence (not paralles as in Promise.all)
   * @param promiseTasks Tasks creating promises to resolve in sequence.
   * @returns Result array of promises.
   */
  static async sequence(e) {
    const t = [];
    for (const n of e)
      t.push(await n());
    return t;
  }
}
class _ {
  /** Constructor creates a new CRUD api with given Ajax-implementation */
  constructor(e) {
    this.ajax = e;
  }
  /**
   * Makes an OData query to the service's main OData method.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  getOData(e) {
    const t = this.getODataUrl();
    return Z.getOData(t, e, this.ajax);
  }
  /**
   * Makes an OData query to the the given service URL.
   * @param baseUrl The service URL that is used, e.g. "/v03/api/taxcards/current".
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   * @deprecated You should use the OData.getOData() static util method instead.
   */
  getODataBase(e, t) {
    return Z.getOData(e, t, this.ajax);
  }
  /**
   * Retrieves the Ajax instance used by this CRUD API.
   * @returns {Ajax} The Ajax instance that is used for making HTTP requests.
   */
  getAjax() {
    return this.ajax;
  }
  /**
   * Gets a single item based on identier
   * @param id - Unique identifier for the object
   * @returns A Promise with result data.
   */
  getSingle(e) {
    return this.ajax.getJSON(`${this.baseUrl}/${e}`);
  }
  /**
   * Deletes an single item from the sotrage
   * @param id - Unique identifier for the object
   * @returns A Promise with result data "Object deleted".
   */
  delete(e) {
    return this.ajax.remove(`${this.baseUrl}/${e}`);
  }
  /**
   * Saves an item to the storage.
   * If id is null, this is add/insert. If id exists, this is update.
   * @param itemToSave - The item that is updated/inserted.
   * @param options - Additional options for the save operation. Can be any object with fields that are used as query parameters.
   * @returns A Promise with result data as saved to the storage (contains id, createAt, owner etc.).
   */
  save(e, t = void 0) {
    return this.ajax.postJSON(this.getUrlWithOptions(this.baseUrl, t), e);
  }
  /** Gets the OData URL for v03 compatible services */
  getODataUrl() {
    if (this.baseUrl.startsWith("/v03") || this.baseUrl.startsWith("/v04"))
      return this.baseUrl;
    if (this.baseUrl.startsWith("http"))
      return this.baseUrl;
    throw new Error(`Service ${this.baseUrl} does not support OData interface.`);
  }
  /** Returns the base url for this api. */
  getBaseUrl() {
    return this.baseUrl;
  }
  /**
   * Adds/updates the workflow event for the item.
   *
   * @param item - Item for which to set the workflow event.
   * @param wfEvent - Event to add or update.
   * @returns Workflow data for the item.
   */
  saveWorkflowEvent(e, t) {
    const n = e.id;
    return this.ajax.postJSON(`${this.baseUrl}/${n}/workflows`, t);
  }
  /**
   * Deletes the workflow item or items from the item.
   * @param item - Item for which to delete workflow events.
   * @param wfIdOrType - Event id or type.
   * @returns A Promise with result data "Object deleted".
   */
  deleteWorkflowEvent(e, t) {
    const n = e.id;
    return this.ajax.remove(`${this.baseUrl}/${n}/workflows/${t}`);
  }
  /**
   * Gets a single workflow event for the item.
   * @param item - Item for which to get the single event.
   * @param wfId - Event id.
   * @returns A Promise with event data.
   */
  getWorkflowEvent(e, t) {
    const n = e.id;
    return this.ajax.getJSON(`${this.baseUrl}/${n}/workflows/events/${t}`);
  }
  /**
   * Lists versions for the object.
   * @param id - Unique identifier for the object
   * @returns A Promise with result data.
   */
  getVersions(e) {
    return this.ajax.getJSON(`${this.baseUrl}/${e}/versions`);
  }
  /**
   * Get the given version for the object.
   * @param id - Unique identifier for the object
   * @param versionId - Version identifier
   * @returns A Promise with result data.
   */
  getVersion(e, t) {
    return this.ajax.getJSON(`${this.baseUrl}/${e}/versions/${t}`);
  }
  getUrlWithOptions(e, t) {
    const n = [];
    t ?? (t = {}), Object.keys(t).forEach((s) => {
      const r = t[s];
      r != null && n.push(`${s}=${encodeURIComponent(r)}`);
    });
    const i = n.join("&");
    return `${e}${i ? "?" + i : ""}`;
  }
}
const fn = class fn {
  constructor(e) {
    this.ajax = e;
  }
  /**
   * Token endpoint.
   *
   * @param msg - OAuth 2.0 authorization request.
   *
   * @returns A Promise with OAuthMessage.
   */
  token(e) {
    return this.ajax.postJSON(this.ajax.getServerAddress() + "/oauth2/token", e);
  }
  /**
   * Gets a federation message for the currently signed-in account as OpenID Connect UserInfo Response
   * (http://openid.net/specs/openid-connect-core-1_0.html#UserInfo).
   * This message can be used by trusted authentication providers (mainly Banks) to federate authentication and authorization information to Salaxy.
   * In such a flow this service end-point provides an example that could be used in testing.
   *
   * @returns A Promise with federation message {OpenIdUserInfoSupportedClaims}.
   */
  getFederationMessage() {
    return this.ajax.getJSON(this.ajax.getServerAddress() + "/oauth2/federationMessage");
  }
};
fn.$inject = ["AjaxNg1"];
let Ja = fn;
class mn {
  /** Constructor creates a new CRUD api with given Ajax-implementation */
  constructor(e) {
    this.ajax = e;
  }
  /**
   * Gets a single settings object.
   * @returns A Promise with settings object.
   */
  get() {
    return this.ajax.getJSON(this.baseUrl);
  }
  /**
   * Saves the settings to the storage.
   * @param settings - The settings that is saved.
   * @returns A Promise with settings object.
   */
  save(e) {
    return this.ajax.postJSON(`${this.baseUrl}/`, e);
  }
}
class no {
  /**
   * Creates a new instance of AjaxFetch
   */
  constructor() {
    this.useCookie = !0, this.serverAddress = "https://test-api.salaxy.com";
    const e = pe.current;
    e && (e.apiServer && (this.serverAddress = e.apiServer), e.useCredentials != null && (this.useCredentials = e.useCredentials), e.useCookie != null && (this.useCookie = e.useCookie));
  }
  /**
   * Gets the API address with version information. E.g. 'https://test-api.salaxy.com/v03/api'.
   * Default version, as of writing 2.0
   */
  getApiAddress() {
    return this.serverAddress + "/v03/api";
  }
  /** Gets the Server address that is used as bases to the HTML queries. E.g. 'https://test-api.salaxy.com' */
  getServerAddress() {
    return this.serverAddress;
  }
  /**
   * Gets the current token.
   * Will check the salaxy-token cookie if the token is persisted there
   */
  getCurrentToken() {
    return !this.token && this.useCookie && (this.token = new pt().get("salaxy-token") || ""), this.token;
  }
  /** Gets the status of the current token. */
  getTokenStatus() {
    const e = this.getCurrentToken();
    return to.validate(e);
  }
  /**
   * Sets the current token. Persists it to cookie until the browser window
   *
   * @param token - the authentication token to persist.
   */
  setCurrentToken(e) {
    this.useCookie && new pt().setCookie("salaxy-token", e || ""), this.token = e;
  }
  /**
   * POSTS data to server and receives back a JSON-message.
   *
   * @param method - The API method is the url path after the api version segments (e.g. '/v03/api')
   * and starts with a forward slash, e.g. '/calculator/new'.
   * @param data - The data that is posted to the server.
   *
   * @returns A Promise with result data. Standard Promise rejection to be used for error handling.
   */
  async postJSON(e, t) {
    const n = this.setAuthorization({
      method: "POST",
      body: JSON.stringify(t),
      headers: {
        Accept: "application/json, text/plain, */*; charset=UTF-8",
        "Content-Type": "application/json;charset=UTF-8"
      }
    }), i = await fetch(this.getUrl(e), n);
    return i.ok ? await i.json() : this.handleErrors(i);
  }
  /**
   * Gets a JSON-message from server using the API
   *
   * @param method The API method is the url path after the api version segments (e.g. '/v03/api')
   * and starts with a forward slash, e.g. '/calculator/new'.
   *
   * @returns A Promise with result data. Standard Promise rejection to be used for error handling.
   */
  async getJSON(e) {
    const t = this.setAuthorization({
      method: "GET",
      headers: {
        Accept: "application/json, text/plain, */*; charset=UTF-8",
        "Content-Type": "application/json; charset=UTF-8"
      }
    }), n = await fetch(this.getUrl(e), t);
    return n.ok ? await n.json() : this.handleErrors(n);
  }
  /**
   * POSTS data to server and receives back a blob (binary data).
   *
   * @param method - The API method is the url path after the api version segments (e.g. '/v03/api')
   * and starts with a forward slash, e.g. '/calculator/new', or a full URL address.
   * @param data - The data that is posted to the server.
   * @returns A Promise that resolves to an object containing:
   * - data: The blob data from the response
   * - headers: An object containing the response headers as key-value pairs
   */
  async postBlob(e, t) {
    const n = this.setAuthorization({
      method: "POST",
      body: JSON.stringify(t),
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json; charset=UTF-8"
      }
    }), i = await fetch(this.getUrl(e), n);
    if (!i.ok)
      return this.handleErrors(i);
    const s = {};
    return i.headers.forEach((r, l) => {
      s[l] = r;
    }), { data: await i.blob(), headers: s };
  }
  /**
   * Gets a Blob from server using the API
   *
   * @param method The API method is the url path after the api version segments (e.g. '/v03/api')
   * and starts with a forward slash, e.g. '/calculator/new'.
   *
   * @returns A Promise with result blob. Standard Promise rejection to be used for error handling.
   */
  async getBlob(e) {
    const t = this.setAuthorization({
      method: "GET",
      headers: {
        Accept: "*/*"
      }
    }), n = await fetch(this.getUrl(e), t);
    if (!n.ok)
      return this.handleErrors(n);
    const i = {};
    return n.headers.forEach((s, r) => {
      i[r] = s;
    }), { data: await n.blob(), headers: i };
  }
  /**
   * POSTS data to server and receives back HTML.
   *
   * @param method - The API method is the url path after the api version segments (e.g. '/v03/api')
   * and starts with a forward slash, e.g. '/calculator/new'.
   * @param data - The data that is posted to the server.
   *
   * @returns A Promise with result data. Standard Promise rejection to be used for error handling.
   */
  async postHTML(e, t) {
    const n = this.setAuthorization({
      method: "POST",
      body: !t || typeof t == "string" ? t : JSON.stringify(t),
      headers: {
        Accept: "text",
        "Content-Type": "text/plain"
      }
    }), i = await fetch(this.getUrl(e), n);
    return i.ok ? await i.text() : this.handleErrors(i);
  }
  /**
   * Gets a HTML-message from server using the API
   *
   * @param method - The API method is the url path after the api version segments (e.g. '/v03/api')
   * and starts with a forward slash, e.g. '/calculator/new'.
   *
   * @returns A Promise with result data. Standard Promise rejection to be used for error handling.
   */
  async getHTML(e) {
    const t = this.setAuthorization({
      method: "GET",
      headers: {
        Accept: "text"
      }
    }), n = await fetch(this.getUrl(e), t);
    return n.ok ? await n.text() : this.handleErrors(n);
  }
  /**
   * Sends a DELETE-message to server using the API
   *
   * @param method - The API method is the url path after the api version segments (e.g. '/v03/api')
   * and starts with a forward slash, e.g. '/calculator/new'.
   *
   * @returns A Promise with result data. Standard Promise rejection to be used for error handling.
   */
  async remove(e) {
    const t = this.setAuthorization({
      method: "DELETE",
      headers: {
        Accept: "application/json; charset=UTF-8"
      }
    }), n = await fetch(this.getUrl(e), t);
    return n.ok ? await n.json() : this.handleErrors(n);
  }
  /** If missing, append the API server address to the given url method string */
  getUrl(e) {
    return !e || e.trim() === "" ? "" : e.toLowerCase().startsWith("http") ? e : e.toLowerCase().startsWith("/v") ? this.getServerAddress() + e : this.getApiAddress() + e;
  }
  setAuthorization(e) {
    const t = this.getCurrentToken();
    return t ? e.headers.Authorization = "Bearer " + t : this.useCredentials && (e.credentials = "include"), e;
  }
  handleErrors(e) {
    return e.data = {
      error: `HTTP error: ${e.statusText} (${e.status})`,
      messageHtml: ""
    }, e.json().then((t) => (t && (e.data = t), Promise.reject(e)));
  }
}
const gn = class gn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/absences";
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank(e, t) {
    return {
      employmentId: e ?? "",
      workerId: t,
      periods: []
    };
  }
  /**
   * Gets all the Worker absences objects of specified year.
   * @returns A Promise with result data: The full absences objects.
   */
  getLatest() {
    return this.ajax.getJSON(`${this.baseUrl}/latest`);
  }
  /**
   * Gets the Absences for a specific employment relation.
   * @param employmentId Identifier for the Employment relation.
   * @returns A Promise with Absences.
   */
  getForEmployment(e) {
    return this.ajax.getJSON(`${this.baseUrl}/employment/${e}`);
  }
  /**
   * Gets the Absences for the given employment relations.
   * @param employmentIds Identifiers for the Employment relations.
   * @returns A Promise with result data array.
   */
  getForEmployments(e) {
    if (e.length === 0)
      return Promise.resolve([]);
    let t = `${this.baseUrl}/employment/set?`;
    return e.forEach((n) => {
      t += "employmentIds=" + encodeURIComponent("" + n) + "&";
    }), t = t.replace(/[?&]$/, ""), this.ajax.getJSON(t);
  }
};
gn.$inject = ["AjaxNg1"];
let ht = gn;
const bn = class bn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/accounting-target";
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return {
      info: {
        availableMethods: [],
        target: {
          avatar: {}
        },
        data: {}
      },
      ruleSet: {
        accounts: [],
        rows: [],
        targetCoA: []
      },
      workflowData: {
        events: []
      }
    };
  }
};
bn.$inject = ["AjaxNg1"];
let yt = bn;
const jn = class jn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/accounts/authorizedAccount";
  }
  /**
   * Returns an empty avatar without any values.
   */
  getBlank() {
    return {};
  }
  /**
   * Lists all accounts on behalf of which this account has been authorized to act.
   *
   * @returns A Promise with result data (list of account objects).
   */
  getAuthorizingAccounts() {
    return this.ajax.getJSON("/accounts/authorizingAccount");
  }
  /**
   * Lists all accounts that have authorized the current account to act on their behalf.
   * Makes a GET request to the API base URL using the configured Ajax instance.
   * @returns A Promise that resolves to an array of PersonAccount and CompanyAccount objects
   */
  getAll() {
    return this.ajax.getJSON(this.baseUrl);
  }
  /**
   * OData query is not supported for authorized accounts.
   * @param _query OData query parameters (not used)
   * @throws Error indicating operation is not supported
   */
  getOData(e) {
    throw new Error("Not supported.");
  }
  /**
   * Getting a single authorized account is not supported.
   * @param _id Identifier of the account (not used)
   * @throws Error indicating operation is not supported
   */
  getSingle(e) {
    throw new Error("Not supported.");
  }
};
jn.$inject = ["AjaxNg1"];
let vt = jn;
class na {
  /**
   * Gets a UI cache object that is used for storing UI properties
   * to the calculation until a roundtrip to server (technically calc.$ui).
   * When a round-trip to server occurs (typically recalculate or save),
   * then the property is set to null => empty object.
   */
  static getUiCache(e) {
    return e ? (e.$ui = e.$ui || {}, e.$ui) : null;
  }
  /**
   * Gets the first row of the calculation assuring that it exists
   * AND that it is a known Salary row or Unknown.
   * This should be the main row of the calculation that replaces the Salary object.
   * @param calc Calculation from which the row is fetched.
   * @param defaultType Default type for the new item if new item needs to be added.
   */
  static getSalaryRow(e, t = k.Unknown) {
    if (!e)
      return;
    const n = [
      k.Unknown,
      k.Compensation,
      k.Salary,
      k.HourlySalary,
      k.MonthlySalary,
      k.TotalEmployerPayment,
      k.TotalWorkerPayment
    ];
    return this.moveSalaryToRows(e), e.rows?.find((i) => i.rowType && n.indexOf(i.rowType) >= 0) || (e.rows ?? (e.rows = []), e.rows.unshift({
      rowType: t
    })), e.rows.find((i) => i.rowType && n.indexOf(i.rowType) >= 0);
  }
  /**
   * Gets the first row of the calculation assuring that it exists.
   * This should be the main row of the calculation that replaces the Salary object.
   * @param calc Calculation from which the row is fetched.
   */
  static getFirstRow(e) {
    if (e)
      return this.moveSalaryToRows(e), e.rows?.length && e.rows.push({
        rowType: k.Unknown
      }), e.rows?.[0];
  }
  /**
   * Gets a new blank object with default values, suitable for UI binding.
   * This is a synchronous method - does not go to the server.
   */
  static getBlank() {
    return {
      employer: {
        avatar: {
          entityType: me.Undefined,
          initials: "?"
        },
        isSelf: !0
      },
      framework: {
        type: en.NotDefined
      },
      info: {
        applicationId: pe.current?.applicationId
      },
      rows: [],
      salary: {
        kind: Re.Undefined,
        price: 0
      },
      worker: {
        avatar: {
          entityType: me.Person,
          initials: "?"
        },
        paymentData: {},
        tax: {}
      },
      usecase: {
        data: {}
      },
      workflow: {
        status: ia.Draft
      },
      result: {
        irRows: []
      }
    };
  }
  /**
   * Returns true if calculation totals should be shown:
   * If there are any such rows that the calculation result makes sense.
   */
  static shouldShowTotals(e) {
    return !e || !e.result || !e.result.totals ? !1 : (e.result?.totals?.total ?? 0) > 0;
  }
  /**
   * Moves the salary defined in Salary object to rows collection.
   * This is needed in old calculations for backward compatibility until moving to v03.
   * NOTE: In v03 this will be done server-side: The Salary will be removed completely.
   * @param calc Calculation to modify
   */
  static moveSalaryToRows(e) {
    const t = e.salary;
    if (t && t.price > 0) {
      let n = k.Salary;
      switch (t.kind) {
        case Re.Compensation:
        case Re.HourlySalary:
        case Re.MonthlySalary:
          n = t.kind;
          break;
        case Re.FixedSalary:
          n = k.Salary;
          break;
        case Re.TotalEmployerPayment:
        case Re.TotalWorkerPayment:
        case Re.Undefined:
        default:
          n = k.Unknown;
          break;
      }
      if (n !== k.Unknown) {
        const i = {
          count: t.amount,
          message: t.message,
          price: t.price,
          rowIndex: -1,
          rowType: n,
          unit: n === k.HourlySalary ? G.Hours : G.Count
        };
        e.rows ?? (e.rows = []), e.rows.push(i), t.price = 0, t.amount = 0, t.kind = Re.Undefined;
      }
    }
  }
  /**
   * Gets the Avatar of other party in a calculation:
   * Employer or Worker
   */
  static getOtherParty(e, t) {
    if (t) {
      const n = t.id;
      if (e.worker && e.worker.accountId !== n)
        return e.worker.avatar;
      if (e.employer && e.employer.accountId !== n)
        return e.employer.avatar;
    }
    return {
      id: void 0,
      displayName: "?",
      sortableName: "?",
      initials: "?",
      firstName: "n",
      lastName: "n",
      entityType: me.Undefined
    };
  }
  /**
   * Gets a total sum for a row category from calculation results.
   * @param calc - Calculation object
   * @param category - Row category (collection of row types)
   */
  static getTotalForCategory(e, t) {
    let n = 0;
    return this.getResultRowsByCategory(e, t).forEach((i) => n += i.total ?? 0), n;
  }
  /**
   * Gets a total sum for a row category from calculation results.
   * @param calc - Calculation object
   * @param types - Array of row types that are included in the result
   */
  static getTotalForRowsByType(e, ...t) {
    let n = 0;
    return this.getResultRowsByType(e, ...t).forEach((i) => n += i.total ?? 0), n;
  }
  /**
   * Filter the result rows of a calculation based on the type
   * @param calc - Calculation object
   * @param types - Array of row types that are included in the result
   */
  static getResultRowsByType(e, ...t) {
    return !e.result || !e.result.rows ? [] : e.result.rows.filter((n) => n.rowType && t.indexOf(n.rowType) !== -1);
  }
  /**
   * Filter the result rows of a calculation based on a row category
   * @param calc - Calculation object
   * @param category - Row category (collection of row types)
   */
  static getResultRowsByCategory(e, t) {
    const n = $a[t];
    return this.getResultRowsByType(e, ...n);
  }
  /**
   * Returns true if there is no net salary payment to worker at all.
   * @param calc - Calculation object
   */
  static isZeroPayment(e) {
    const t = h.round(Math.max(0, e?.result?.workerCalc?.totalWorkerPayment ?? 0)), n = h.round(Math.max(0, e?.result?.totals?.total ?? 0));
    return (t ?? 0) <= 0 && (n ?? 0) >= 0;
  }
}
const Sn = class Sn {
  constructor(e) {
    this.ajax = e;
  }
  /**
   * OBSOLETE: use CalculatorLogic.getBlank() instead.
   * @deprecated Factory method to create a new calculation on server-side.
   * Typically, you do not need to call server-side factory methods in JavaScript.
   * Instead, you can use client-side factory methods under logic. This saves you one round-trip to server.
   * @ignore
   */
  createNew() {
    return this.ajax.getJSON("/calculator/new");
  }
  /**
   * Creates a new calucation with simple salary
   *
   * @param kind The type of the salary.
   * @param amount The amount of typically hours (could be months etc.). Defaults to 1 if left as null.
   * @param price The price of one unit of amount.
   * @param message Message text for end user - used in salary calculation
   * @param calc The calculation object that should be updated. This is optional - often null, but can be set if you are updating an existing calculation.
   *
   * @returns A Promise with the recalculated Calculation.
   */
  calculateSalary(e, t, n, i, s = null) {
    const r = `/calculator/salary?kind=${e}&amount=${h.parseNumber(t)}&price=${h.parseNumber(n)}&message=${i}`;
    return this.ajax.postJSON(r, s);
  }
  /**
   * Sets a household deduction to a calculation
   *
   * @param calc The calculation object to which household deduction is added
   * @param setHouseHoldDeductionTo Boolean to which household
   *
   * @returns A Promise with the recalculated Calculation.
   */
  setTaxDeduction(e, t) {
    const n = `/calculator/taxdeduction?setHouseHoldDeduction=${t}`;
    return this.ajax.postJSON(n, e);
  }
  /**
   * Takes in a calculation - typically with modified parameters - and recalculates it.
   *
   * @param calc The salary calculation that should be recalculated
   *
   * @returns A Promise with the recalculated Calculation.
   */
  recalculate(e) {
    return this.ajax.postJSON("/calculator/recalculate", e);
  }
  /**
   * Recalculates a calculation taking into account holiday year and absences from the worktime property.
   * This is an anonymous method that can be used for unit testing: Does not read / write from database.
   * @param calc The salary calculation that should be recalculated.
   * Worktime property should contian the bases for the recalculation.
   *
   * @returns A Promise with the recalculated Calculation.
   */
  recalculateWorktime(e) {
    return this.ajax.postJSON("/calculator/recalculate-worktime", e);
  }
  /**
   * Gets the worktime data for Period recalculation from raw calc, holidays andabsences data.
   * This is an anonymous method that can be used for unit testing: Does not read / write from database.
   *
   * @param calc The salary calculation that should be recalculated.
   * @param holidayYear Holiday year with holidays that should be added as salary rows. If not provided, holidays are not calculated.
   * @param absences Absences that should be deducted from monthly salary. If not provided, absences are not calculated.
   *
   * @returns A Promise with Worktime data.
   */
  getWorktimeData(e, t, n) {
    return this.ajax.postJSON("/calculator/worktime", {
      calc: e,
      holidayYear: t,
      absences: n
    });
  }
  /**
   * Sets a unionPayment to a calculation
   *
   * @param calc The calculation object to which union payment is added
   * @param paymentType Type of union payment, options are 'notSelected', 'raksaNormal', 'raksaUnemploymentOnly' and 'other'
   * @param unionPaymentPercent How many percents the union payment is from the salary
   *
   * @returns A Promise with the recalculated Calculation.
   */
  setUnionPayment(e, t, n) {
    const i = `/calculator/setunionpayment?paymentType=${t}&unionPaymentPercent=${h.parseNumber(n)}`;
    return this.ajax.postJSON(i, e);
  }
  /**
   * Adds a calculation row: An expenses, benefits or other such row and returns the recalculated calculation with full data.
   *
   * @param calc The salary calculation that should be modified.
   * @param rowType Type of the calculation row that should be added.
   * @param message Message text for end user - used in salary calculation
   * @param price Price for the row (e.g. €/h, €/km, €/month. Default is 0.
   * @param count Count of the items - default is 1.
   *
   * @returns A Promise with the recalculated Calculation.
   */
  addRow(e, t, n, i, s) {
    const r = `/calculator/addrow?rowType=${t}&message=${n}&price=${h.parseNumber(i)}&count=${h.parseNumber(s)}`;
    return this.ajax.postJSON(r, e);
  }
  /**
   * Deletes a calculation row: Expenses, benefits etc. item and returns the recalculated calculation with full data.
   *
   * @param calc The salary calculation that should be modified.
   * @param rowIndex Zero based row index of the row that should be deleted.
   *
   * @returns A Promise with the recalculated Calculation.
   */
  deleteRow(e, t) {
    return this.ajax.postJSON(`/calculator/deleterow?rowIndex=${t}`, e);
  }
  /**
   * Gets salary calculation parameters that are changing yearly.
   * The method is designed for the end-of-year and as such it only supports 2 years:
   * the current / previous year (from Jan to Nov) OR current / next year (in approx. December).
   *
   * @param forYear Date for which the numbers are fetched.
   *
   * @returns The yearly changing numbers if year supported. Error if year not supported.
   */
  getYearlyChangingNumbers(e) {
    return be.getYearlyChangingNumbers(e);
  }
  /**
   * Experimental: Returns a new Finvoice object for the given calculations.
   * @param calculations Calculations for the Finvoice.
   * @param tableType Accounting table type for the generated Finvoice.
   * @ignore
   */
  getFinvoice(e, t = ba.Classic) {
    const n = `/calculator/finvoice/new?tableType=${encodeURIComponent("" + t)}`;
    return this.ajax.postJSON(n, e);
  }
};
Sn.$inject = ["AjaxNg1"];
let Ma = Sn;
const Tn = class Tn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/calculations", this.calculator = new Ma(e);
  }
  /**
   * Saves an item to the storage.
   * If id is null, this is add/insert. If id exists, this is update.
   * @param itemToSave - The item that is updated/inserted.
   * @returns A Promise with result data as saved to the storage (contains id, createAt, owner etc.).
   */
  save(e) {
    return e?.info && (e.info.applicationId = pe.current?.applicationId), super.save(e);
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return na.getBlank();
  }
  /**
   * Takes in a calculation - typically with modified parameters - and recalculates it.
   * @param calc The salary calculation that should be recalculated
   * @returns A Promise with the recalculated Calculation.
   */
  recalculate(e) {
    return this.calculator.recalculate(e);
  }
  /**
   * Recalculates a calculation taking into account holiday year and absences from the worktime property.
   * This is an anonymous method that can be used for unit testing: Does not read / write from database.
   * @param calc The salary calculation that should be recalculated.
   * Worktime property should contian the bases for the recalculation.
   *
   * @returns A Promise with the recalculated Calculation.
   */
  recalculateWorktime(e) {
    return this.calculator.recalculateWorktime(e);
  }
  /**
   * Gets the worktime data for Period recalculation based on given calculation
   * but fetching absences and holidays from the database.
   *
   * @param calc The salary calculation that should be recalculated.
   * It may potentially have changes to compared to the one in database or the calc may not have even been saved.
   * The calculation MUST have emloymentId and period set for calculation to work properly.
   * @returns A Promise with Worktime data.
   */
  getWorktimeData(e) {
    return this.ajax.postJSON(`${this.baseUrl}/worktime`, e);
  }
  /**
   * Gets the Calculation objects for the given ids.
   * @param ids Identifiers for the Calculation objects.
   * @returns A Promise with result data array.
   */
  getMulti(e) {
    if (e == null || e.length === 0)
      return Promise.resolve([]);
    let t = this.baseUrl + "/set?";
    return e.forEach((n) => {
      t += "ids=" + encodeURIComponent("" + n) + "&";
    }), t = t.replace(/[?&]$/, ""), this.ajax.getJSON(t);
  }
  /**
   * Gets the Calculations for a specific employment relation.
   * @param employmentId Identifier for the Employment relation.
   * @returns A Promise with Calculations.
   */
  getForEmployment(e) {
    return this.ajax.getJSON(`${this.baseUrl}/employment/${e}`);
  }
  /**
   * Gets the Calculations for the given employment relations.
   * @param employmentIds Identifiers for the Employment relations.
   * @returns A Promise with Calculations.
   */
  getForEmployments(e) {
    if (e == null || e.length === 0)
      return Promise.resolve([]);
    let t = `${this.baseUrl}/employment/set?`;
    return e.forEach((n) => {
      t += "employmentIds=" + encodeURIComponent("" + n) + "&";
    }), t = t.replace(/[?&]$/, ""), this.ajax.getJSON(t);
  }
  /**
   * Updates a calculation from employment relation by deleting all the rows and re-setting the employment.
   * @param calc Calculation to update.
   * @param save If true, saves the calculation. If false, only recalculates. Returns the result in any case.
   * @param updateRows If true, updates also the default salary rows from employment data to calculation.
   * False updates only other employment data IBAN, phone, E-mail, pension insurance code message etc.
   * @returns The updated and saved or recalculated calculation
   */
  updateFromEmployment(e, t, n) {
    return this.ajax.postJSON(`${this.baseUrl}/update-from-employment?save=${t}&updateRows=${n}`, e);
  }
  /**
   * Updates (saves) the employment related information from Calculation to Employment relation.
   * Currently only updates rows, OccupationCode and WorkDescription.
   * @param calc Calculation to update.
   */
  updateToEmployment(e) {
    return this.ajax.postJSON(`${this.baseUrl}/update-to-employment`, e);
  }
  /**
   * Shares the calculation.
   * @param id Id for the calculation to share.
   * @param type Type of the sharing action or link.
   * @param employerId Id of the employer to share the calculation with.
   * @param to Email address of the employer.
   * @param cc Cc address for the email.
   * @param message Message to the employer.
   * @returns Sharing object of the calculation.
   */
  share(e, t = sn.Undefined, n = null, i = null, s = null, r = null) {
    let l = `${this.baseUrl}/sharing/${e}?type=${encodeURIComponent(t)}${n ? "&employerId=" + encodeURIComponent(n) : ""}`;
    return l += `${i ? "&to=" + encodeURIComponent(i) : ""}${s ? "&cc=" + encodeURIComponent(s) : ""}${r ? "&message=" + encodeURIComponent(r) : ""}`, this.ajax.postJSON(l, null);
  }
  /**
   * Notifies the employer from the shared calculation.
   * @param id Id of the shared calculation.
   * @param to Email address of the employer.
   * @param cc Cc address for the email.
   * @param message Message to the employer.
   * @returns True, if the send action was successful.
   */
  notifySharing(e, t = null, n = null, i = null) {
    let s = `${this.baseUrl}/sharing/${e}/notification?`;
    return s += `${t ? "&to=" + encodeURIComponent(t) : ""}${n ? "&cc=" + encodeURIComponent(n) : ""}${i ? "&message=" + encodeURIComponent(i) : ""}`, this.ajax.postJSON(s, null);
  }
  /**
   * Cancels the invoice or payment processing for the given calculation.
   * Please note that this is possible only if the channel supports the cancel action.
   * @param id Calculation for which the cancellation is requested.
   * @returns Calculation which have been cancelled.
   */
  cancel(e) {
    const t = `${this.baseUrl}/cancel/${e}`;
    return this.ajax.getJSON(t);
  }
  /**
   * Creates a copy of an existing calculation.
   * @param id The ID of the calculation to copy.
   * @returns A Promise containing the newly created copy of the calculation.
   */
  copy(e) {
    const t = `${this.baseUrl}/copy/${e}`;
    return this.ajax.getJSON(t);
  }
  /**
   * Saves the IR -related data of the calculation.
   * This operation can be done even if the calculation otherwise is in read only state.
   * @param calculation Calculation object to save.
   */
  saveIr(e) {
    return this.ajax.postJSON(`${this.baseUrl}/ir`, e);
  }
  /**
   * Converts the given calculation to an earnings payment report.
   * @param calculation - Calculation object.
   * @returns A Promise with earnings payment report data.
   */
  convertToEpr(e) {
    return this.ajax.postJSON(`${this.baseUrl}/epr`, e);
  }
  /**
   * Returns the earnings payment report for the given calculation.
   * @param id Id of the calculation for the earnings payment report.
   * @returns Earnings payment report for the calculation.
   */
  getEpr(e) {
    return this.ajax.getJSON(`${this.baseUrl}/epr/${e}`);
  }
  /**
   * Starts the repair process for the calculation.
   * Returns a new modifiable copy of the calculation to be repaired.
   * @param id Calculation for which the repair is requested.
   * @returns A modifiable copy of the calculation to be repaired.
   */
  startRepair(e) {
    const t = `${this.baseUrl}/repair/${e}`;
    return this.ajax.getJSON(t);
  }
  /**
   * Commits the repairs for the calculation.
   * @param calculation Calculation which contains the repaired data.
   * @returns A repaired version of the calculation which was repaired.
   */
  commitRepair(e) {
    const t = `${this.baseUrl}/repair/commit`;
    return this.ajax.postJSON(t, e);
  }
  /**
   * Saves the repairs for the calculation.
   * @param calculation Calculation which contains the repaired data.
   * @returns The saved repair calculation.
   */
  saveRepair(e) {
    const t = `${this.baseUrl}/repair`;
    return this.ajax.postJSON(t, e);
  }
  /**
   * Recalculates the repair for the calculation.
   * @param calculation Calculation which contains the repaired data.
   * @returns The recalculated repair calculation.
   */
  recalculateRepair(e) {
    const t = `${this.baseUrl}/repair/recalculate`;
    return this.ajax.postJSON(t, e);
  }
  /**
   * Returns the document flow for the given calculation.
   * Documentflow contains invoices, earnings payment reports, payer suymmary reports and payrolls refering to the calculation.
   * @param id Id of the calculation for the document flow.
   * @returns Document flow for the calculation.
   */
  getDocumentFlow(e) {
    return this.ajax.getJSON(`${this.baseUrl}/${e}/document-flow`);
  }
};
Tn.$inject = ["AjaxNg1"];
let Na = Tn;
const xn = class xn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03-rc/api/calendar/events", this.calendarBaseUrl = "/v03-rc/api/calendar";
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return {
      event: {
        isAllDay: !0,
        // By default, we have all-day events of one day.
        start: c.getToday(),
        end: c.getToday(),
        duration: "1",
        actions: [],
        attachments: [],
        attendees: [],
        categories: [],
        recurrenceRules: []
      }
    };
  }
  /**
   * Recalculates the occurence info based on the event.
   * This is an anonymous method that does not commit anything to database.
   * @param event Calendar event to recalculate.
   * @param start Start of the period for which the events are fetched and occurences are calculated.
   * If null, period is set 1 year before today. Max history/future 3 years. Max period 24 months.
   * @param end End of the period for which the occurences are calculated.
   * @returns A Promise with result data: The calendar event with occurenceInfo recalculated.
   */
  recalculate(e, t = null, n = null) {
    return this.ajax.postJSON(`${this.baseUrl}/recalculate?start=${c.asDate(t) || ""}&end=${c.asDate(n) || ""}`, e);
  }
  /**
   * Gets the occurences for calendar events stored in the Salaxy calendar database.
   * @param categories Categories of occurences to fetch.
   * @param start Start of the period for which the events are fetched and occurences are calculated.
   * If null, period is set 1 year before today. Max history/future 3 years. Max period 24 months.
   * @param end End of the period for which the occurences are calculated.
   * @returns The occurences based on the given filters.
   */
  getOccurences(e = null, t = null, n = null) {
    const i = e?.length ? e.filter((r) => r?.trim()).map((r) => encodeURIComponent(r.trim())) : "", s = `${this.calendarBaseUrl}/occurences?categories=${i}&start=${c.asDate(t) || ""}&end=${c.asDate(n) || ""}`;
    return this.ajax.getJSON(s);
  }
  /**
   * Gets a Recurring event based on a business object that may be CalendarEvent of some other type that has potential recurrence.
   * @param id Unique identifier for the object.
   * The id may contain the payload type of the item, e.g. "09ddcb40-1c06-48cd-be07-ab16a6bdfccf/payrollDetails".
   * @param type Payload type as API object. This is only used, if the ID is simple ID without the
   * type (e.g. "09ddcb40-1c06-48cd-be07-ab16a6bdfccf").
   * If neither id nor type defines the Payload type, ApiItemType.CalendarEvent is the default.
   * @param mode Defines what kind of object is created if the existing object supports recurrence, but currently is not recurring.
   * Possibility to add the default recurrence rules, actions etc.
   * @returns The recurring event, potentially creating the default recurrence.
   */
  getRecurringEvent(e, t = null, n = nn.Default) {
    t && e.indexOf("/") < 0 && (e = e + "/" + t);
    const i = `${this.calendarBaseUrl}/recurring/${e}?mode=${n}`;
    return this.ajax.getJSON(i);
  }
};
xn.$inject = ["AjaxNg1"];
let ft = xn;
const En = class En extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/accounts/certificate";
  }
  /**
   * Returns an empty certificate without any values.
   */
  getBlank() {
    return {};
  }
  /**
   * Issues a new certificate for the account
   * @param certificate The certificate to issue
   * @param options Optional parameters for the issue operation
   * @returns A Promise containing the issued certificate
   */
  issueSertificate(e, t = void 0) {
    return this.save(e, t);
  }
  /**
   * Issues a new certificate for the account and provides the certificate in PEM format.
   * For this method, also the Certificate Signing Request (CSR) may be passed in the certificate Text field.
   * @param certificate A certificate object containing title for the new certificate.
   * You may also pass the Certificate Signing Request (CSR) in the Password field. In this case the private key is not returned by the method.
   * @returns PEM files in zip: crt (public key / certificate), key (private key) and (both in one pem file).
   */
  issuePemCertificate(e) {
    return this.ajax.postJSON(this.getUrlWithOptions(this.baseUrl + "/pem", void 0), e);
  }
  /**
   * Gets all certificates from the API.
   * @returns A Promise that resolves to an array of Certificate objects.
   */
  getAll() {
    return this.ajax.getJSON(this.baseUrl);
  }
  /**
   * OData query is not supported for certificates.
   * @param _query OData query parameters (not used)
   * @throws Error indicating operation is not supported
   */
  getOData(e) {
    throw new Error("Not supported.");
  }
  /**
   * Getting a single certificate is not supported.
   * @param _id Identifier of the certificate (not used)
   * @throws Error indicating operation is not supported
   */
  getSingle(e) {
    throw new Error("Not supported.");
  }
};
En.$inject = ["AjaxNg1"];
let gt = En;
const An = class An extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/accounts/credential";
  }
  /**
   * Returns an empty credential without any values.
   */
  getBlank() {
    return {};
  }
  /**
   * Returns the url where to post the avatar file
   */
  getAvatarUploadUrl(e) {
    return this.ajax.getServerAddress() + this.baseUrl + (e ? `/${e}` : "") + "/avatar";
  }
  /**
   * Gets all credentials from the API.
   * @returns A Promise that resolves to an array of SessionUserCredential objects.
   */
  getAll() {
    return this.ajax.getJSON(this.baseUrl);
  }
  /**
   * OData query is not supported for credentials.
   * @param _query OData query parameters (not used)
   * @throws Error indicating operation is not supported
   */
  getOData(e) {
    throw new Error("Not supported.");
  }
  /**
   * Getting a single credential is not supported.
   * @param _id Identifier of the credential (not used)
   * @throws Error indicating operation is not supported
   */
  getSingle(e) {
    throw new Error("Not supported.");
  }
};
An.$inject = ["AjaxNg1"];
let bt = An;
const Pn = class Pn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03-rc/api/customer-invoices";
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return {
      info: {},
      bases: [],
      invoice: {
        rows: []
      }
    };
  }
  /**
   * Saves an item to the storage.
   * NOTE: Access to this method is very restricted by design as invoces are created by Palkkaus and cannot be modified by the Customer.
   * Typically, you will not be able to save customer invoices in the production environment.
   * @param itemToSave - The item that is updated/inserted.
   * @returns A Promise with result data as saved to the storage (contains id, createAt, owner etc.).
   */
  save(e) {
    return super.save(e);
  }
};
Pn.$inject = ["AjaxNg1"];
let jt = Pn;
const wn = class wn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/datasets";
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return {
      info: {
        status: Qt.Draft
      },
      data: [],
      workflowData: {
        events: []
      },
      usecase: {
        data: {}
      }
    };
  }
};
wn.$inject = ["AjaxNg1"];
let St = wn;
var Xe = /* @__PURE__ */ ((a) => (a.Fi = "fi", a.En = "en", a))(Xe || {});
class ua {
  constructor() {
    this.$cache = {};
  }
  /**
   * Gets the schema either based on the defined schema or based on set data value if explicit schema is defined.
   * @param typeResolve If "guess" will attempt to guess the data type/format based on the value.
   * Otherwise, uses string type for all items.
   */
  getSchema(e = "guess") {
    if (this.schema)
      return this.schema;
    if (this.value?.length)
      return Se.guessSchema(this.value[0], e);
  }
  /**
   * Gets the keys of first-level items in the data based on getSchema (cached).
   */
  get keys() {
    return this.assureKeys(), this.$cache.keys;
  }
  /**
   * Gets all the properties (the entire tree) from the schema.
   * Values are InputEnumOptions (typically used in UI) where value and text are
   * the property path, e.g. "owner.avatar.sortableName" and title shows the title or description from the schema.
   */
  get allKeys() {
    return this.assureKeys(), this.$cache.allKeys;
  }
  assureKeys() {
    if (!fe.equal(this.schema || this.value?.[0], this.$cache.schema)) {
      const e = this.getSchema();
      e?.properties ? (this.$cache.keys = Object.keys(e.properties), this.$cache.allKeys = Se.getAllProperties(e)) : (this.$cache.keys = [], this.$cache.allKeys = []), this.$cache.schema = this.schema || this.value?.[0];
    }
  }
}
class ze {
  /**
   * Default constructor creates a new DataMapperSelector.
   * @param source The source field / path
   * @param target The target field / path
   * @param func Optional function that maps from source to target.
   */
  constructor(e = void 0, t = void 0, n = void 0) {
    this.source = e, this.target = t, this.func = n;
  }
  /**
   * Resolves the selector, i.e. sets the sourceProp and targetProp for types.
   * @param sourceRootSchema Root source schema of the DataMapper or Item schema for flatten selector.
   * @param targetRootSchema Root target schema of the DataMapper
   */
  resolve(e, t) {
    if (this.sourceProp = e && this.source ? Se.getProperty(e, this.source) : void 0, this.targetProp = t && this.target ? Se.getProperty(t, this.target) : void 0, this.flatten?.length) {
      const n = (this.sourceProp?.schema).items;
      this.flatten.forEach((i) => i.resolve(n, t));
    }
  }
  /** Does the mapping from source to target */
  doMap(e, t) {
    if (this.flatten)
      return;
    let n = null;
    if (this.func ? n = this.func(e, t, this) : this.source?.trim() && (n = fe.getProperty(e, this.source)), this.target?.trim())
      try {
        fe.setProperty(t, this.target, n);
      } catch {
      }
  }
}
class He {
  /**
   * Constructor creates a new empty DataMapper.
   * You typically need to call at least setSchema() (source or target) and ten create the map using one of the methods.
   * @param uri Unique URI for the mapper
   * @param title Translated end-user title for the mapper
   */
  constructor(e, t) {
    this.title = "", this.isSourceAList = !1, this.uri = e, this.title = t;
  }
  /** Resolves all the schemas in the selectors. */
  resolve() {
    this.map.forEach((e) => {
      e.sourceProp = void 0, e.targetProp = void 0, e.resolve(this.source?.getSchema(), this.target?.getSchema());
    });
  }
  /**
   * Does the mapping from source to target.
   * @param sourceValue Optional source value that is mapped. If not specified, existing source.value is used.
   * @returns The results of the mapping.
   */
  doMap(e = void 0) {
    return this.target ?? (this.target = new ua()), this.target.value = [], this.source ?? (this.source = new ua()), e && (this.source.value = e), this.source.value = this.source.value || [], this.source.value.forEach((t) => {
      const n = this.map.find((i) => i.flatten?.length);
      if (n)
        fe.getProperty(t, n.source).forEach((s) => {
          const r = {};
          this.target.value.push(r), this.map.forEach((l) => l.doMap(t, r)), n.flatten.forEach((l) => l.doMap(s, r));
        });
      else {
        const i = {};
        this.target.value.push(i), this.map.forEach((s) => s.doMap(t, i));
      }
    }), this.target.value;
  }
  /**
   * Gets a simple key-to-key mapper for a schema object: no field conversion, just defining the columns and types.
   * @param schema The schema that defineses the columns for the mapping.
   * @param type The row type name (technical).
   */
  setStringToSchemaMapping(e, t) {
    this.setSchema(e, t, "target");
    const n = {};
    Object.keys(e?.properties || {}).forEach((i) => {
      n[i] = i;
    }), this.setPaths(n), this.generateSchema(t + "Import", "source");
  }
  /**
   * Sets a schema in one of the members using the schema cache.
   * Creates the member if none exists and also sets the isTable based on the schema.
   * @param schemaCache The schema cache from which the schema is fetched.
   * @param schemaDoc The URL for the Schema document that contains the schema
   * @param schemaName Name of the schema
   * @param member If set to "target", sets the target schema. Sets the source schema by default.
   */
  async setSchemaFromCache(e, t, n, i = "source") {
    await e.assureSchemaDocument(t);
    const s = e.findSchema(t, n);
    this.setSchema(s, n, i);
  }
  /**
   * Sets the schema for the given member.
   * Creates the member if none exists and also sets the isTable based on the schema.
   * @param schema Schema to set into a member
   * @param schemaName Name of the schema
   * @param member Member to set.
   */
  setSchema(e, t, n = "source") {
    let i;
    n == "target" ? i = this.target = this.target || new ua() : i = this.source = this.source || new ua(), i.schema = e, i.name = t, i.isTable = Se.isTable(e);
  }
  /**
   * Generates one schema based on another using the paths as mappers.
   * @param name Name for the new schema
   * @param member The member that is being generated based on the other member.
   */
  generateSchema(e, t = "target") {
    let n, i;
    t == "target" ? (this.target = this.target || new ua(), i = this.target, n = this.source) : (this.source = this.source || new ua(), i = this.source, n = this.target), i.name = e, i.isTable = !0, i.schema = {
      description: `Schema ${e} generated based on ${n.name} and paths mapper.`,
      type: "object",
      format: i.isTable ? "table" : i.name,
      properties: {}
    }, this.map.forEach((s) => {
      if (s.flatten?.length) {
        if (t == "source")
          throw new Error(`Only target generation supported for selectors with flatten ${e}.`);
        s.flatten.forEach((r) => {
          var o;
          r.targetProp = r.sourceProp;
          const l = r.target || r.source;
          l && l.indexOf(".") > -1 ? (i.schema.sxyERROR = `Schema generation does not support hierarchical paths, e.g. ${l}. See console for all errors.`, console.error(`Schema generation (flatten) does not support hierarchical paths: ${l}`)) : ((o = i.schema).properties ?? (o.properties = {}), l && (i.schema.properties[l] = r.sourceProp?.schema ?? {}));
        });
      } else {
        t == "target" ? s.targetProp = s.sourceProp : s.sourceProp = s.targetProp;
        const r = t == "target" ? s.target : s.source;
        r && (r.indexOf(".") > -1 ? (i.schema.sxyERROR = `Schema generation does not support hierarchical paths, e.g. ${r}. See console for all errors.`, console.error(`Schema generation does not support hierarchical paths: ${r}`)) : (i.schema.properties = i.schema.properties ?? {}, i.schema.properties[r] = s.sourceProp?.schema ?? {}, s.sourceProp && (i.schema.properties[r]["x-salaxy-title"] = `SALAXY.MODEL.${s.sourceProp?.parentName}.${s.sourceProp?.propertyName}.title`, i.schema.properties[r]["x-salaxy-description"] = `SALAXY.MODEL.${s.sourceProp?.parentName}.${s.sourceProp?.propertyName}.description`)));
      }
    });
  }
  /**
   * Sets selectors with paths to both target and source using a key-value pair object.
   * @param paths Paths as object where each key is a source path and value is
   * either a target path or selector (key is selector source if not set in the selector).
   */
  setPaths(e) {
    e && (this.map = [], Object.keys(e).forEach((t) => {
      let n = new ze();
      e[t] && typeof e[t] == "object" ? n = e[t] : n.target = e[t], n.source = n.source || t, this.map.push(n);
    }), this.target || (this.target = new ua()), this.resolve());
  }
  /**
   * Reverses the source / target.
   * Can be used for creating two mappers from the same definition: One for import, one for export.
   * @param uri Uri for the new reversed object.
   * @param title Treanslated end-user title for the new object.
   * @param isSourceAList If true, the reversed mapper is a list item mapper: Exportable.list() is used directly instead of
   * calling Exportable.getSingle() when exporting and export is done directly without wizard and preview.
   * RowType is also ApiListItem or derived from it.
   */
  reverse(e, t, n = !1) {
    const i = new He(e, t);
    return i.target = this.source, i.source = this.target, i.isSourceAList = n, i.map = this.reverseChildren(this.map || []), i;
  }
  /**
   * Creates the Map based on source schema and property paths within that schema.
   * Also the target schema is created based these two.
   * Before calling this method, the source schema must be set or the method fails.
   * @param paths Array of paths that are used in creating the mapper
   * @param targetSchemaName Name for the new target schema.
   */
  setPathsFromSourceSchema(e, t = void 0) {
    if (!this.source?.schema)
      throw new Error("Schema not set in setPathsFromSourceSchema().");
    const n = t || this.source.name + "_mapperTarget", i = {
      description: `Schema ${n} generated based on ${this.source.name} and paths mapper.`,
      type: "object",
      format: "table",
      properties: {}
    };
    this.map = [], e.forEach((s) => {
      const r = new ze();
      r.source = s;
      const l = Se.getProperty(this.source.schema, s);
      l?.propertyName && (r.target = l.propertyName, i.properties = i.properties ?? {}, i.properties[l.propertyName] = l.schema, this.map.push(r));
    }), this.setSchema(i, n, "target"), this.resolve();
  }
  reverseChildren(e) {
    return (e || []).map((t) => {
      const n = new ze();
      if (n.func = void 0, n.source = t.target, n.sourceProp = t.targetProp, n.target = t.source, n.targetProp = t.sourceProp, t.flatten?.length)
        throw new Error("Not supported: Cannot reverse a DataMapperSelector with flatten");
      return n;
    });
  }
}
class ll {
  /**
   * Gets the MapperInfo from a full DataMapper.
   * @param mapper The full mapper.
   * @returns The info part of the mapper.
   */
  static getInfo(e) {
    if (e)
      return {
        sourceSchema: e.source.name,
        targetSchema: e.target.name,
        title: e.title,
        uri: e.uri
      };
  }
  /** Gets the mappers for specific sources / targets. */
  static getMappers(e, t) {
    return this.getBuiltInMappers().filter(
      (n) => (!e?.length || e.find((i) => i == n.sourceSchema)) && (!t?.length || t.find((i) => i == n.targetSchema))
    );
  }
  /** Gets the listing of all in-built data mappers in @salaxy/core library. */
  static getBuiltInMappers() {
    return [
      {
        uri: "@salaxy/core/WorkerListItem_Default",
        title: d.get("SALAXY.CORE.WorkerMappers.preview"),
        sourceSchema: "WorkerListItem",
        targetSchema: void 0
      },
      {
        uri: "@salaxy/core/WorkerObjectExport",
        title: d.get("SALAXY.CORE.WorkerMappers.defaultMaterial") + " (export)",
        sourceSchema: "WorkerAccount",
        targetSchema: "WorkersDataRow"
      },
      {
        uri: "@salaxy/core/EmploymentListItem_Default",
        title: d.get("SALAXY.CORE.WorkerMappers.preview"),
        sourceSchema: "EmploymentListItem",
        targetSchema: void 0
      },
      {
        uri: "@salaxy/core/EmploymentExport",
        title: d.get("SALAXY.CORE.WorkerMappers.defaultMaterial") + " (export)",
        sourceSchema: "Employment",
        targetSchema: "WorkersDataRow"
      },
      {
        uri: "@salaxy/core/CalculationExport",
        title: d.get("SALAXY.CORE.CalculationMappers.defaultMaterial") + " (export)",
        sourceSchema: "Calculation",
        targetSchema: "CalculationsDataRow"
      },
      {
        uri: "@salaxy/core/CalculationListItem_Default",
        title: d.get("SALAXY.CORE.CalculationMappers.preview"),
        sourceSchema: "CalculationListItem",
        targetSchema: void 0
      },
      {
        uri: "@salaxy/core/CalculationListItem_Pro",
        title: "PRO Export",
        sourceSchema: "CalculationListItem",
        targetSchema: void 0
      }
    ];
  }
  /**
   * Gets an export DataMapper, potentially loading the schema / mapping from the storage.
   * @param id Identifier or URI for the mapper.
   * URI starts with "@salaxy/core/", e.g. "@salaxy/core/Calculation_Default".
   * Id is just the last part of the path, e.g. "Calculation_Default".
   * @returns The mapper that maps the source to target. Null if none is found.
   */
  static async getBuiltInMapper(e, t) {
    if (e)
      switch (e = this.getMapperUri(e), e) {
        case "EmploymentExport": {
          const n = [
            "id",
            "personalInfo.avatar.firstName",
            "personalInfo.avatar.lastName",
            "personalInfo.email",
            "personalInfo.telephone",
            "personalInfo.ibanNumber",
            "personalInfo.officialId",
            "info.startDate",
            "info.endDate",
            "info.isFixedTerm",
            "info.taxcard",
            "info.type",
            "info.pensionCalculation",
            "work.occupationCode",
            "info.irIncomeEarnerTypes",
            "isRegistered",
            "info.workerAccountId",
            "holidays.code",
            "holidays.bonusMethod",
            "updatedAt",
            "createdAt"
          ], i = new He("EmploymentExport", d.get("SALAXY.CORE.WorkerMappers.defaultMaterial") + " (export)");
          return await i.setSchemaFromCache(t, "salaxy-secure/schemas/v02.json", "Employment"), i.setPathsFromSourceSchema(n), i;
        }
        case "EmploymentListItem_Default": {
          const n = [
            "otherPartyInfo.avatar.firstName",
            "otherPartyInfo.avatar.lastName",
            "otherPartyInfo.email",
            "otherPartyInfo.telephone",
            "otherPartyInfo.ibanNumber",
            "otherPartyInfo.officialId",
            "data.startDate",
            "data.endDate",
            "data.isFixedTerm",
            "data.taxcard",
            "data.type",
            "data.pensionCalculation"
          ], i = new He("EmploymentListItem_Default", d.get("SALAXY.CORE.WorkerMappers.preview"));
          return await i.setSchemaFromCache(t, "salaxy-secure/schemas/v02.json", "EmploymentListItem"), i.setPathsFromSourceSchema(n), i.isSourceAList = !0, i;
        }
        case "WorkerObjectExport": {
          const n = [
            "id",
            "avatar.firstName",
            "avatar.lastName",
            "contact.email",
            "contact.telephone",
            "ibanNumber",
            "officialId"
          ], i = new He("WorkerObjectExport", d.get("SALAXY.CORE.WorkerMappers.defaultMaterial") + " (export)");
          return await i.setSchemaFromCache(t, "salaxy-secure/schemas/v02.json", "WorkerAccount"), i.setPathsFromSourceSchema(n), i;
        }
        case "WorkerListItem_Default": {
          const n = [
            "otherPartyInfo.avatar.firstName",
            "otherPartyInfo.avatar.lastName",
            "otherPartyInfo.email",
            "otherPartyInfo.telephone",
            "otherPartyInfo.ibanNumber",
            "otherPartyInfo.officialId"
          ], i = new He("WorkerListItem_Default", d.get("SALAXY.CORE.WorkerMappers.preview"));
          return await i.setSchemaFromCache(t, "salaxy-secure/schemas/v02.json", "WorkerListItem"), i.setPathsFromSourceSchema(n), i.isSourceAList = !0, i;
        }
        case "CalculationListItem_Default": {
          const n = [
            "status",
            "otherPartyInfo.avatar.displayName",
            "otherPartyInfo.officialId",
            "data.workStartDate",
            "data.workEndDate",
            "shortText",
            "salaryDate",
            "data.workerPayment",
            "data.taxPayment",
            "grossSalary"
          ], i = new He("CalculationListItem_Default", d.get("SALAXY.CORE.CalculationMappers.preview"));
          return await i.setSchemaFromCache(t, "salaxy-secure/schemas/v02.json", "CalculationListItem"), i.setPathsFromSourceSchema(n), i.isSourceAList = !0, i;
        }
        case "CalculationListItem_Pro": {
          const n = new He("CalculationListItem_Pro", "PRO export");
          n.isSourceAList = !0, await n.setSchemaFromCache(t, "salaxy-secure/schemas/v02.json", "CalculationListItem");
          const i = {
            "ownerInfo.avatar.displayName": d.get("SALAXY.NG1_Other.Roles.employer"),
            "ownerInfo.officialId": d.get("SALAXY.NG1_Other.Roles.employer") + " ID",
            status: new ze(
              void 0,
              d.get("SALAXY.MODEL.CalculationListItem.status.title"),
              (s) => H.getEnumLabel("CalculationStatus", s.status ?? "")
            ),
            "otherPartyInfo.avatar.displayName": d.get("SALAXY.NG1_Other.Roles.worker"),
            "otherPartyInfo.officialId": d.get("SALAXY.NG1_Other.Roles.worker") + " ID",
            "data.workStartDate": d.get("SALAXY.MODEL.CalculationData.workStartDate.title"),
            "data.workEndDate": d.get("SALAXY.MODEL.CalculationData.workEndDate.title"),
            shortText: d.get("SALAXY.MODEL.CalculationListItem.shortText.title"),
            salaryDate: d.get("SALAXY.MODEL.CalculationListItem.salaryDate.title"),
            "data.workerPayment": d.get("SALAXY.MODEL.CalculationData.workerPayment.title"),
            "data.taxPayment": d.get("SALAXY.MODEL.CalculationData.taxPayment.title"),
            grossSalary: d.get("SALAXY.MODEL.CalculationListItem.grossSalary.title")
          };
          return n.setPaths(i), n.generateSchema("CalculationListItem_Pro", "target"), n.isSourceAList = !0, n;
        }
        case "CalculationExport": {
          const n = new ze("rows");
          n.flatten = [
            new ze("rowType", "rowType"),
            new ze("message", "message"),
            new ze("count", "count"),
            new ze("price", "price")
          ];
          const i = {
            id: "id",
            "workflow.status": "status",
            "worker.paymentData.socialSecurityNumber": "personalId",
            "worker.avatar.firstName": "firstName",
            "worker.avatar.lastName": "lastName",
            "worker.paymentData.email": "email",
            "worker.paymentData.telephone": "telephone",
            "worker.paymentData.ibanNumber": "ibanNumber",
            "info.occupationCode": "occupationCode",
            "info.workStartDate": "periodStart",
            "info.workEndDate": "periodEnd",
            "info.workDescription": "workDescription",
            "info.salarySlipMessage": "salarySlipMessage",
            "info.costCenter": "costCenter",
            "workflow.salaryDate": "salaryDate",
            "worker.tax.fixedTaxAmount": "fixedTaxAmount",
            rows: n
          }, s = new He("CalculationExport", d.get("SALAXY.CORE.WorkerMappers.defaultMaterial") + " (export)");
          return await s.setSchemaFromCache(t, "salaxy-secure/schemas/v02.json", "Calculation", "source"), s.setPaths(i), s.generateSchema("CalculationsDataRow", "target"), s;
        }
        default:
          return;
      }
  }
  /** TODO: try to figure out why this is required? */
  static getMapperUri(e) {
    return e && e.replace("@salaxy/core/", "");
  }
}
var Ie = /* @__PURE__ */ ((a) => (a.Comma = ",", a.Semicolon = ";", a.Tab = "	", a.Unknown = "", a))(Ie || {}), we = /* @__PURE__ */ ((a) => (a.Txt = "txt", a.Csv = "csv", a.Xlsx = "xlsx", a))(we || {});
class ul {
  /**
   * Return file extension from filename
   * @param fileName import file name as string
   * @returns TableFormat or null
   */
  static getExtensionFromFileName(e) {
    return /(?:\.([^.]+))?$/.exec(e)?.[1];
  }
  /**
   * Return delimiter from provided data
   * @param data import data as string
   * @returns returns FileDelimiter
   */
  static getFileDelimiter(e) {
    if (e) {
      const n = [...(/* @__PURE__ */ new Map([
        [Ie.Comma, e.split(Ie.Comma).length],
        [Ie.Semicolon, e.split(Ie.Semicolon).length],
        [Ie.Tab, e.split(Ie.Tab).length]
      ])).entries()].reduce((i, s) => s[1] > i[1] ? s : i);
      return n[1] > 0 ? n[0] : Ie.Unknown;
    }
    return Ie.Unknown;
  }
  /**
   * Returns locale
   * @param csv input csv data
   * @returns returns locale as string
   */
  static getCsvLocale(e) {
    return e === Ie.Semicolon ? "fi" : "en";
  }
  /**
   * return table format
   * @param fileDelimiter delimeter used to figure table format
   * @returns table format
   */
  static getTableFormatByDelimeter(e) {
    return e === Ie.Comma || e === Ie.Semicolon ? we.Csv : we.Txt;
  }
}
class dn {
  /**
   * Exports table data as in defined format. The default is csv formatted table.
   * @param rows  Rows as an array of objects with properties specified as headers.
   * @param format File format for a table export.
   * @param localeId Locale for data export. Defaults to Finnish (fi). Affects  separator (; vs ,), formatting of date (D.M.YYYY vs YYYY-MM-DD) and numeric fields (, vs . as decimal separator).
   */
  static export(e, t = we.Csv, n = Xe.Fi) {
    if (!e || e.length === 0)
      return null;
    const i = this.exportAsArrays(e);
    switch (t) {
      case we.Csv:
        return this.objectToSeparated(i, n, n === "fi" ? ";" : ",");
      case we.Txt:
        return this.objectToSeparated(i, n, "	");
      default:
        throw new Error(`Table format ${t} not supported.`);
    }
  }
  /**
   * Exports data as an array of rows, each of which consists of an array of cell values.
   * @param rows Array of row objects.
   */
  static exportAsArrays(e) {
    const t = [], n = Object.getOwnPropertyNames(e[0]).filter((i) => i !== "validation");
    t.push(n);
    for (const i of e) {
      const s = [];
      for (const r of n)
        s.push(i[r]);
      t.push(s);
    }
    return t;
  }
  /**
   * Imports table from the given data and format.
   * @param data Table data.
   * @param format Format for the table data.
   * @param localeId Locale for data import. Defaults to Finnish (fi).
   * Affects formatting of date (D.M.YYYY vs YYYY-MM-DD)and numeric fields (, vs . as decimal separator).
   * @returns An import result which has the imported data as well as headers of the file, errors and number of ignored lines (typically empty lines).
   */
  static import(e, t = we.Csv, n = Xe.Fi, i = void 0) {
    switch (t) {
      case we.Csv:
        return this.objectFromSeparated(e, n, n === "fi" ? ";" : ",", i);
      case we.Txt:
        return this.objectFromSeparated(e, n, "	", i);
      default:
        throw new Error(`Table format ${t} not supported.`);
    }
  }
  /**
   * Gets first row of data or a new object
   * @param data from where to get first line
   * @param separator file separator
   * @returns Returns first row as object or {}
   */
  static getFirstRow(e, t) {
    let n = {};
    if (!e)
      return n;
    const i = e.split(/\r\n|\n/);
    return i.length === 0 ? n : n = i[0].split(t).map(this.fromHeaderField());
  }
  static objectToSeparated(e, t, n) {
    const i = this.toRow(t, n), s = e.map(i);
    return (n !== "	" ? "\uFEFF" : "") + s.join(`\r
`);
  }
  static toRow(e, t, n = !0) {
    const i = this.toField(e, n);
    return (s, r, l) => s.map(i).join(t);
  }
  static toField(e, t = !0) {
    return (n, i, s) => {
      if (n == null)
        return "";
      if (typeof n == "number")
        return e === "fi" ? n.toString().replace(".", ",") : n;
      if (typeof n == "boolean")
        return n ? "TRUE" : "FALSE";
      if (typeof n == "string")
        return c.isValidDateTime(n, !0, "YYYY-MM-DD") ? e === "fi" ? c.format(n, "D.M.YYYY") : c.format(n, "YYYY-MM-DD") : t ? '"' + n.replace(/"/g, '""') + '"' : n;
      if (Array.isArray(n)) {
        const r = n.map((l) => this.toField(e, !1)(l, i, s)).join(",");
        return t ? '"' + r.replace(/"/g, '""') + '"' : r;
      }
      return typeof n == "object" ? n instanceof Date ? e === "fi" ? c.format(n, "D.M.YYYY") : c.format(n, "YYYY-MM-DD") : t ? '"' + JSON.stringify(n).replace(/"/g, '""') + '"' : JSON.stringify(n) : JSON.stringify(n);
    };
  }
  static objectFromSeparated(e, t, n, i = void 0) {
    const s = {
      ignoredLines: 0,
      data: [],
      headers: [],
      errors: []
    };
    if (!e)
      return s;
    const r = e.split(/\r\n|\n/);
    if (r.length === 0)
      return s;
    if (i)
      s.headers = i;
    else {
      const m = r[0].split(n);
      if (s.headers = m.map(this.fromHeaderField()), s.headers.some((p) => !p))
        return s.errors.push({
          key: void 0,
          type: Ae.General,
          code: "InvalidHeader",
          msg: "Some header field contains no value. This is not allowed."
        }), s;
    }
    if (r.length === 1)
      return s;
    const l = r.slice(i ? 0 : 1), o = this.fromRow(s, t, n), u = l.map(o);
    return s.data = u.filter((m) => m != null), s.ignoredLines = u.filter((m) => m == null).length, s.data.filter((m) => m.validation && m.validation.errors).forEach((m) => {
      s.errors.push(...m.validation?.errors ?? []);
    }), s;
  }
  static fromRow(e, t, n) {
    const i = this.fromField(t);
    return (s, r, l) => {
      const o = s.split(n);
      let u;
      if (o.length !== e.headers.length)
        o.length === 1 && o[0] === "" ? u = void 0 : (u = u || {}, u.validation = u.validation || { isValid: !1, errors: [] }, u.validation.errors?.push({
          key: null,
          type: Ae.General,
          code: "InvalidColAmount",
          msg: `PARSE ERROR: Row ${r} has ${o.length} columns whereas the header row has ${e.headers.length}.`
        }));
      else {
        const m = o.map(i);
        if (m.every((p) => !p))
          u = void 0;
        else
          for (let p = 0; p < e.headers.length; p++)
            u = u || {}, u[e.headers[p]] = m[p];
      }
      return u;
    };
  }
  static fromHeaderField() {
    return (e, t, n) => e && (e = e.trim(), e = e.replace(/""/g, '"'), e = e.replace(/^"+/, ""), e = e.replace(/"+$/, ""), e);
  }
  static fromField(e) {
    return (t, n, i) => {
      if (!t)
        return null;
      if (t = t.trim(), t = t.replace(/""/g, '"'), t = t.replace(/^"+/, ""), t = t.replace(/"+$/, ""), t.toLowerCase() === "true")
        return !0;
      if (t.toLowerCase() === "false")
        return !1;
      const s = e === "fi" ? "D.M.YYYY" : "YYYY-MM-DD";
      if (c.isValidDateTime(t, !0, s))
        return c.parseDate(t, s);
      const r = e === "fi" ? t.replace(",", ".") : t;
      return h.isNumber(r) ? h.parseNumber(r) : t;
    };
  }
}
class Ca {
  constructor(e, t, n, i = !1) {
    this.id = e, this.label = t, this.format = n, this.hasLocales = i;
  }
  /**
   * Does the actual parsing. In custom FileParsers, override this method
   * @param data Incoming data as a string
   * @param locale Optional locale selected by the user if supported by the parser.
   */
  parse(e, t) {
    return dn.import(e, this.format, this.hasLocales ? t : void 0);
  }
  /**
   * Guesses the parser and locale that may be correct for the given data.
   * @param parsers Available parsers
   * @param data Data to be imported.
   * @returns Guessed parser and locale based on data or null if the parser cannot be guessed.
   */
  static guessParser(e, t) {
    if (!t)
      return;
    const n = /\r\n|\n/.exec(t)?.index, i = n ? t.substring(0, n) : t, s = n ? t.substring(n) : "";
    if (i.indexOf("	") > 0) {
      const r = e.find((o) => o.id == ae.CopyExcel), l = /(^|\t|\n)-?\d+([.|,])\d+(\n|\t|$)/.exec(s)?.[2];
      return r ? {
        parser: r,
        locale: l == "." ? Xe.En : Xe.Fi
      } : void 0;
    }
    if (i.indexOf(";") > 0) {
      const r = e.find((l) => l.id == ae.FileCsv);
      return r ? {
        parser: r,
        locale: Xe.Fi
      } : void 0;
    }
    if (i.indexOf(",") > 0) {
      const r = e.find((l) => l.id == ae.FileCsv);
      return r ? {
        parser: r,
        locale: Xe.En
      } : void 0;
    }
  }
  /** Gets the standard methods that are typically supported. */
  static getDefaultParsers() {
    return [
      new Ca(ae.CopyExcel, d.get("SALAXY.NG1.ODataActionsComponent.getDefaults.copyExcel"), we.Txt, !0),
      new Ca(ae.FileExcel, d.get("SALAXY.NG1.ODataActionsComponent.getDefaults.fileExcel"), we.Txt),
      new Ca(ae.FileCsv, d.get("SALAXY.NG1.ODataActionsComponent.getDefaults.fileCsv"), we.Csv, !0)
    ];
  }
}
class cn {
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  static getBlank() {
    return {
      input: {
        period: {},
        calculations: []
      },
      info: {
        applicationId: pe.current?.applicationId
      },
      calcs: [],
      validations: [],
      workflowData: {}
    };
  }
}
const Fn = class Fn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/payroll";
  }
  /**
   * Saves an item to the storage.
   * If id is null, this is add/insert. If id exists, this is update.
   * @param itemToSave - The item that is updated/inserted.
   * @returns A Promise with result data as saved to the storage (contains id, createAt, owner etc.).
   */
  save(e) {
    return e?.info && (e.info.applicationId = pe.current?.applicationId), super.save(e);
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return cn.getBlank();
  }
  /** Because of historical reasons, Payrolls v03 has a non-standard endpoint for OData methods. */
  getODataUrl() {
    return this.baseUrl + "/odata";
  }
  /**
   * Validates a PayrollDetails object for payment.
   * @param payrollToValidate PayrollDetails that should be validated.
   * @returns The PayrollDetails object with Calculations added to the Result object and Validated.
   */
  validate(e) {
    return this.ajax.postJSON(`${this.baseUrl}/validate`, e);
  }
  /**
   * Saves changes to to a Calculation that is part of a Payroll and returns the Paryoll validation data.
   * @param calc The calculation object that is updated.
   * @param payrollId Payroll ID where calculation belongs to.
   * Note, that the current implementation does not assure that the calculation is within a Payroll.
   * The ID is simply used for assuring corrrect data in Calculation.
   * @returns The Saved Payroll object with Calculations added to the Result object and Validated.
   */
  calculationSave(e, t) {
    const n = `${this.baseUrl}/${t}/calcs`;
    return this.ajax.postJSON(n, e);
  }
  /**
   * Adds existing calculations to the the payroll and saves the payroll object.
   * If calculation is read-only, a copy is made. If it is draft, the calculation is moved.
   * @param payroll The Payroll object to update and save.
   * @param calculationIds Array of calculation id's that are copied / moved to the Payroll list.
   * @returns The Saved Payroll object with Calculations added to the Result object and Validated.
   */
  addCalculations(e, t) {
    let n = `${this.baseUrl}/add-calc?`;
    return n += "ids=" + t.join(","), this.ajax.postJSON(n, e);
  }
  /**
   * Remove calculations from the payroll and saves the payroll object.
   * The calculations are completely deleted.
   * This can only be done if the calculations and the payroll have not been paid yet.
   * @param payroll The Payroll  object.
   * @param calculationIds Array of calculation id's that are deleted.
   * @returns The Saved Payroll object with Calculations removed from the Result object and Validated.
   */
  deleteCalculations(e, t) {
    let n = `${this.baseUrl}/delete-calc?`;
    return n += "ids=" + t.join(","), this.ajax.postJSON(n, e);
  }
  /**
   * Remove calculations from the payroll and saves the payroll object.
   * The calculations are unlinked and they become individual calculations in the draft list (and can then be processed individually).
   * This can only be done if the calculations and the payroll have not been paid yet.
   * @param payroll The Payroll  object.
   * @param calculationIds Array of calculation id's that are unlinked from the Payroll list.
   * @returns The Saved Payroll object with Calculations removed from the Result object and Validated.
   */
  unlinkCalculations(e, t) {
    let n = `${this.baseUrl}/unlink-calc?`;
    return n += "ids=" + t.join(","), this.ajax.postJSON(n, e);
  }
  /**
   * Adds new calculations to the the payroll and saves the payroll object.
   * The calculations are added based on employment relation ID's.
   * @param payroll The Payroll object to update and save.
   * @param employmentIds Array of employment relation id's for which the a new calculation is added to the Payroll list.
   * @returns The Saved Payroll object with Calculations added to the Result object and Validated.
   */
  addEmployments(e, t) {
    let n = `${this.baseUrl}/add-employment?`;
    return n += "ids=" + t.join(","), this.ajax.postJSON(n, e);
  }
  /**
   * Cancels the invoice or payment processing for the given payroll.
   * Please note that this is possible only if the channel supports the cancel action.
   * @param id Payroll for which the cancellation is requested.
   * @returns Payroll which have been cancelled.
   */
  cancel(e) {
    const t = `${this.baseUrl}/cancel/${e}`;
    return this.ajax.getJSON(t);
  }
};
Fn.$inject = ["AjaxNg1"];
let Oa = Fn;
class Ia {
  constructor(e) {
    if (this.validation = void 0, !e)
      throw new Error("Validation object is null.");
    this.validation = e, e.errors = e.errors || [];
  }
  /**
   * Add a warning to the validations object
   * @param message Required warning message
   * @param code Optional unique code for the validation error
   * @param field Full path to Name of the property / field (Member name in JSON).
   */
  warn(e, t = void 0, n = void 0) {
    this.validation ?? (this.validation = {}), this.validation.errors?.push({
      msg: e,
      type: Ae.Warning,
      code: t,
      key: n
    }), this.recalc();
  }
  /** Add a error to the validations object */
  error(e, t = void 0, n = void 0) {
    this.validation ?? (this.validation = {}), this.validation.errors?.push({
      msg: e,
      type: Ae.General,
      code: t,
      key: n
    }), this.recalc();
  }
  /** Adds a missing required field to validations object */
  missing(e, t = void 0) {
    this.validation ?? (this.validation = {}), this.validation.errors?.push({
      msg: t || "Kenttä puuttuu",
      // TODO: Add language versioned message.
      type: Ae.Required,
      code: "missing",
      // TODO: Check what is the best practice for this.
      key: e
    }), this.recalc();
  }
  /**
   * Checks that the required item is not null / empty.
   * If it is adds a required field missing error.
   */
  checkNotEmpty(e, t, n = void 0) {
    const i = fe.getProperty(e, t);
    return !i && i !== 0 ? (this.missing(t, n), !1) : !0;
  }
  /**
   * Clears any existing validation errors
   * @param code If specified clears only errors with specified code. May be a string or regexp.
   */
  clear(e = void 0) {
    let t = [];
    this.validation ?? (this.validation = {}), e && (e.test ? t = this.validation.errors?.filter((n) => n.code && !e.test(n.code)) : t = this.validation.errors?.filter((n) => n.code != e)), this.validation.errors = t, this.recalc();
  }
  /**
   * Merges the errors of another validation error to this validation.
   * @param validation Another api validation object with potential errors.
   * May also be null or with null error array without raising errors.
   */
  merge(e) {
    e?.errors && e?.errors?.length > 0 && (this.validation?.errors?.push(...e.errors), this.recalc());
  }
  /** Recalculates the read-only helper properties based on the errors list. */
  recalc() {
    const e = this.validation;
    e.errors = this.validation?.errors || [], e.hasAllRequiredFields = !this.validation?.errors?.find((t) => t.type == Ae.Required), e.isValid = !this.validation?.errors?.find((t) => t.type != Ae.Warning);
  }
}
const Dn = class Dn {
  /**
   * Adds a collection of salary bases rows to a given payroll.
   * @param payrollId Identifier for the payroll where the calculations should be updated.
   * @param salaryBases The rows that should be added.
   * @param employments List of employments that are available in the current account.
   * @param ajax Instance of Ajax that is use in connecting to the server.
   * @returns A payroll object that is refreshed from the server.
   */
  static async addToPayroll(e, t, n, i) {
    const s = new Oa(i), r = new Na(i);
    let l = await s.getSingle(e);
    const o = t.reduce((y, S) => {
      const x = S.employmentId;
      return x && (y[x] = y[x] ?? [], y[x].push(S)), y;
    }, {}), u = Object.keys(o).filter((y) => !!y);
    console.debug("empIds", u);
    const m = u.filter((y) => !l.calcs?.find((S) => S.worker && S.worker.employmentId == y));
    m.length && (console.log("Adding employments: " + m), l = await s.addEmployments(l, m));
    let p = 0;
    return u.forEach(async (y) => {
      p++;
      const S = o[y], x = l.calcs?.find((T) => T.worker && T.worker.employmentId == y) ?? {};
      x.rows = x.rows ?? [], x.rows.length = 0;
      const v = n.find((T) => T.id == y);
      if (v) {
        const T = v.work?.salaryDefaults?.filter(
          (L) => (
            // TODO: Vaihda toisin päin: Kuukausi-/tuntipalkka otetaan suoraan ja sen arvot haetaan datasta.
            //       Myös AY-jäsenmaksu jne. fiksatut rivit tähän logiikkaan?
            L.rowType != k.MonthlySalary && L.rowType != k.HourlySalary
          )
        );
        T?.length && (T.forEach((L) => {
          L.sourceId = "employment";
        }), x.rows.push(...T));
      }
      S.forEach((T) => {
        const L = {
          count: T.count,
          data: T.data || {},
          message: T.message,
          price: T.price,
          rowType: T.rowType,
          sourceId: "import"
        };
        T.costCenter && (L.accounting = L.accounting ?? {}, L.accounting.dimensions = L.accounting.dimensions ?? [], L.accounting.dimensions.push({
          id: "costCenter",
          value: T.costCenter
        })), x.rows = x.rows ?? [], x.rows.push(L);
      }), console.log(`Saving calculation for ${y}, (${p}/${u.length})`), await r.save(x);
    }), console.log("Saving done!"), l = await s.getSingle(e), l;
  }
  /**
   * Does the full import for the given arrays
   * @param input Original input from the HRSuunti software
   * @param salaryBases The salary bases that are the target of this import before creating the Payroll objects
   * @param employments The employment relations that have been created for the import.
   */
  static doImport(e, t, n) {
    const i = e.map((s) => this.mapToSalaryBases(s));
    i.forEach((s) => this.resolveEmployment(s, n)), this.resolveTypesAndPrices(i, this.getRowTypeMapperEditable()), t.length = 0, t.push(...i);
  }
  /**
   * Logic to resolve the employment relation.
   * @param row A salary bases row where we attempt to fing an employment relation.
   * @param employments All employment relations that are available for this account.
   */
  static resolveEmployment(e, t) {
    const n = (e.srcEmploymentId || "").toString().trim().toLowerCase();
    n && (e.employment = t.find(
      (i) => i?.id?.toLowerCase() == n || i?.personalInfo?.officialId?.toLowerCase() == n || i?.personalInfo?.avatar?.id?.toLowerCase() == n || i?.info?.sourceId?.toLowerCase() == n
    ), e.employment && (e.employmentId = e.employment.id));
  }
  /**
   * Resolves the row types and prices based on
   * raw data that has already been mapped to SalaryBasesRow and employments have been resolved.
   * @param rows Incoming data where employments have already been resolved.
   * @param mapper The mapper that is used in mapping source row types to Salaxy row types.
   */
  static resolveTypesAndPrices(e, t) {
    e.forEach((s) => {
      s.srcEmploymentId = s.srcEmploymentId?.toString(), s.srcRowTypeId = s.srcRowTypeId?.toString(), s.costCenter = s.costCenter?.toString();
    });
    const n = this.getRowTypeMapper(t);
    e.forEach((s) => this.resolveTypesAndPricesForRow(s, n));
    const i = Be.groupBy(e, (s) => s.employmentId);
    Object.keys(i).forEach((s) => {
      i[s].filter((r) => r.data?.kind == "monthlySalary").forEach((r, l) => {
        r.data = r.data ?? {}, r.data.kind = void 0, l > 0 && (r.rowType = void 0, r.message = "Useita kk-palkkoja, vain 1. laskelmaan");
      });
    });
  }
  /** Temp method for getting the editable row type mapper. */
  static getRowTypeMapperEditable() {
    const e = dn.import(this.rowTypeRaw, we.Txt, Xe.Fi);
    return e.data.forEach((t) => {
      t.data = t.data || {}, t.rowType && (t.rowType = t.rowType.substring(0, 1).toLowerCase() + t.rowType.substring(1)), t.rowKind && (t.data.kind = t.rowKind.substring(0, 1).toLowerCase() + t.rowKind.substring(1), delete t.rowKind);
    }), e.data;
  }
  /** Gets and prepares a row type mapper for mapping */
  static getRowTypeMapper(e) {
    const t = new Ia({});
    return e.forEach((n) => {
      if (n.searchType == "regExp" && typeof n.search == "string")
        try {
          n.search = new RegExp(n.search);
        } catch (i) {
          t.error("Invalid regex: " + i.message), n.search = void 0;
        }
      n.search && n.type == "row" && t.checkNotEmpty(n, "rowType", `Match of type "row" must have a rowType (${n.search})`);
    }), e;
  }
  /**
   * Modifies existing SalaryBasesRow that has preliminary data from the source
   * @param row Row to modify as part of mapping process
   */
  static resolveTypesAndPricesForRow(e, t) {
    if (!e.employment)
      return;
    const n = e.employment.work?.salaryDefaults?.find((l) => l.rowType == k.MonthlySalary)?.price;
    let i = e.employment.work?.salaryDefaults?.find((l) => l.rowType == k.HourlySalary)?.price;
    if (!i && n) {
      const l = e.employment.work?.monthlyHours || 160;
      i = n / l;
    }
    const s = n ? k.MonthlySalary : i ? k.HourlySalary : k.Salary;
    if (e.srcRowTypeId = (e.srcRowTypeId || "").toString().trim(), !e.srcRowTypeId) {
      e.rowType = k.Unknown, e.message = "Error: source row type is null/empty";
      return;
    }
    const r = t.filter((l) => !!l.search).find(
      (l) => l.searchType == "regExp" ? l.search.test(e.srcRowTypeId || "") : (l.search || "").toString().trim().toLowerCase() == (e.srcRowTypeId || "").trim().toLowerCase()
    );
    if (!r) {
      e.rowType = k.Unknown, e.message = "No match for " + e.srcRowTypeId;
      return;
    }
    switch (r.type) {
      case "ignore":
        e.rowType = null, e.message = r.message || r.comment;
        break;
      case "hourlyRow":
        e.rowType = r.rowType || s, e.data = e.data || {}, e.data.kind = r.data?.kind, e.message = r.message || r.comment, e.price = (r.price || 1) * (i ?? 0), e.count = (r.count == null ? 1 : r.count) * (e.count == null ? 1 : e.count);
        break;
      case "monthlySalary":
        e.rowType = k.MonthlySalary, e.data = e.data || {}, e.data.kind = "monthlySalary", e.message = r.message || r.comment, e.price = r.price || n, e.count = r.count || e.count || 1;
        break;
      case "row": {
        e.rowType = r.rowType, e.data = e.data || {}, e.data.kind = r.data?.kind, e.message = r.message || r.comment;
        const l = e.employment.work?.salaryDefaults?.filter((o) => o.rowType == e.rowType);
        e.price = l?.find((o) => o.rowType == e.rowType && o.data?.kind == e.data?.kind)?.price || l?.find((o) => o.rowType == e.rowType && !o.data?.kind)?.price || r.price;
      }
    }
    e.price && (e.price = h.round(e.price, 6));
  }
  /**
   * Does the basic mapping from HrSuuntiInput to SalaryBases object.
   * @param inputRow Input row from HR Suunti
   * @returns The input mapped as SalaryBasesRow
   */
  static mapToSalaryBases(e) {
    return {
      date: e.PVM,
      srcEmploymentId: e.TYNRO?.toString(),
      srcRowTypeId: e.PLNRO?.toString(),
      message: null,
      count: e["KPL/MISTÄ"],
      price: null,
      rowType: k.Unknown,
      costCenter: e.OSASTO?.toString()
    };
  }
};
Dn.rowTypeRaw = `search	searchType	type	rowType	rowKind	count	price	message	comment
^[0-9]$	regExp	ignore						PLNRO 1-9 ei tuoda.
140		hourlyRow	HolidaySalary				Muu lomapalkka	Muu lomapalkka (perhevapaa ym)
177		row	WorkingTimeCompensation	EmergencyWorkCompensation			Hälytysraha	Tuntien tasaus TX => ei tuoda.
11		ignore						
31		row	Salary			50	Uinninvalvonta palkkio (krt)	
59		hourlyRow	PaidSickLeaveHourlySalary					Sairasajan palkka/tt
60		hourlyRow	HourlySalary					Tuntityö (ATP)
64		ignore						Tehtäväkoht. lisä => ei tuoda.
^85|94$	regExp	hourlyRow	SundayWork					Sunnuntaityö 100 %/tt OR /kk
^87|96$	regExp	hourlyRow	SaturdayAddition			0,2		Lauantaityö 20 %/tt OR Lauantaityö 20% /kk
90		hourlyRow	Overtime			0,5	Ylityöt 50%	Ylityö 50%/kk
91		hourlyRow	Overtime			1	Ylityöt 100%	Ylityö 100%/kk
99		hourlyRow	WorkingTimeCompensation	ExtraWorkPremium			Lisätyökorvaus	Lisätyökorvaus/kk
102		hourlyRow	SaturdayAddition			0,2	Aattolisä	Aattolisä/kk
108		hourlyRow				-1	Väh. kk-palkka/tunti	Väh. kk-palkka/tunti
109		hourlyRow	PaidSickLeaveMonthlySalary					Sairasajan palkka/kk/tunti
188		hourlyRow	NightimeAddition			0,45		Yötyökorvaus %/kk
^189|191$	regExp	hourlyRow	EveningAddition			0,15		Iltatyökorvaus %/kk OR %/tt
513		hourlyRow					Koulutusajan palkka/kk/tunti	Koulutusajan palkka/kk/tunti
997		monthlySalary	MonthlySalary		1			Kk-palkka
`;
let Tt = Dn;
class kl {
  /**
   * Creates a new batch for data import.
   * @param mapper Mapper object for table to objects transformations.
   * Preselected from the Importable API.
   * @param api Api object for validting and posting data to API.
   */
  constructor(e, t) {
    this.api = t, this.setMapper(e);
  }
  /** Result data of the current operation (map, validate, import). */
  get data() {
    return this.mapper?.target?.value;
  }
  /**
   * Sets the mapper for the batch.
   * @param mapper The new data mapper.
   */
  setMapper(e) {
    this.mapper = e, this.resetParserMapper();
  }
  /** Resets the parser mapper according unmappedData (source) and mapper source (target) */
  resetParserMapper() {
    const e = this.mapper?.source?.getSchema();
    if (!e) {
      this.parserMapper = void 0;
      return;
    }
    const t = this.parserMapper = new He("temp/parserMapper", "Parser mapper: From text file to defined source.");
    t.setSchema(e, this.mapper?.source.name, "target");
    const n = Se.guessSchema(this.unmappedData?.data[0]);
    if (!n)
      return;
    t.setSchema(n, "inputFileSource", "source");
    const i = {}, s = t.target.keys;
    t.source.keys.forEach((r) => {
      i[r] = s.indexOf(r) >= 0 ? r : null;
    }), t.setPaths(i), t.source.value = this.unmappedData?.data;
  }
  /**
   * Read data into batch from the import file content (to unmappedData).
   * @param rawData File content, e.g. csv or tab separated data.
   * @param parser Parser for parsing data to tabular format.
   * @param localeId If 'fi', the number and date formats are parsed using Finnish formats.
   * @returns the status of the read.
   */
  read(e = void 0, t, n = Xe.Fi) {
    this.rawData = e || this.rawData, this.unmappedData = t.parse(this.rawData, n), this.resetParserMapper();
    const i = new Ia({
      errors: this.unmappedData.errors
    });
    return this.unmappedData.data.length || i.warn("WARNING: Import contains no data!", "import.warning.noData"), this.unmappedData.ignoredLines && i.warn(`${this.unmappedData.ignoredLines} ${d.get("SALAXY.NG1.ODataImportComponent.step2.emptyRow")}`, "import.ignoredLines.warning"), i.recalc(), i.validation;
  }
  /**
   * Maps the source format to the target format using the mapper.
   */
  map() {
    this.mapper && (this.parserMapper ? (this.parserMapper.source.value = this.unmappedData.data, this.parserMapper.doMap(), this.mapper.source.value = this.parserMapper.target.value) : this.mapper.source.value = this.unmappedData.data, this.mapper.doMap());
  }
  /** Returns true if the import data is valid */
  get isDataValid() {
    return (this.data?.length ?? 0) > 0 && this.data.every((e) => this.getMeta(e).validation?.isValid);
  }
  /** Returns true if the import data contains validation errors */
  get hasDataValidationErrors() {
    return (this.data?.length ?? 0) > 0 && this.data.some((e) => this.getMeta(e).validation && this.getMeta(e).validation?.errors && !!(this.getMeta(e).validation?.errors?.length ?? 0));
  }
  /** Clears validation from the rows */
  clearValidation() {
    for (const e of this.mapper.source.value) {
      const t = this.getMeta(e);
      t.validation = void 0, t.object = void 0;
    }
    for (const e of this.data) {
      const t = this.getMeta(e);
      t.validation = void 0, t.object = void 0;
    }
  }
  getMeta(e) {
    return e || {};
  }
  /**
   * Validates the batch data.
   * @param notify Function for notifying progress to caller.
   * @returns A validation object with potential errors.
   */
  validate(e = void 0) {
    const t = (l, o, u) => {
      try {
        return this.api.validate(l, o, u).then((m) => m?.validation);
      } catch (m) {
        return Promise.resolve({
          isValid: !1,
          errors: [{
            key: null,
            type: Ae.General,
            code: m.name || "Server error",
            msg: m.message || JSON.stringify(m, Object.getOwnPropertyNames(m))
          }]
        });
      }
    }, n = new Ia({});
    this.clearValidation();
    const i = this.data;
    let s = 0;
    const r = () => {
      if (s === i.length)
        return Promise.resolve();
      const l = i[s];
      return t(l, s, i).then((o) => (e && e("validate", s, i.length, o), this.updateValidation(s, o), n.merge(o), s++, r()));
    };
    return r().then(() => (n.recalc(), n.validation));
  }
  /**
   * Imports the batch data.
   * @param notify Function for notifying progress to caller.
   */
  import(e = void 0) {
    const t = (l) => {
      try {
        return this.api.importItem(l).then((o) => ({ object: o, validation: { isValid: !0 } }));
      } catch (o) {
        return Promise.resolve({
          object: l,
          validation: {
            isValid: !1,
            errors: [{
              key: null,
              type: Ae.General,
              code: o.name || "Server error",
              msg: o.message || JSON.stringify(o, Object.getOwnPropertyNames(o))
            }]
          }
        });
      }
    };
    this.clearValidation();
    const n = new Ia({}), i = this.data;
    let s = 0;
    const r = () => {
      if (s === i.length || !this.api.importItem)
        return Promise.resolve();
      const l = i[s];
      return t(l).then((o) => (e && e("import", s, i.length, o.validation), this.updateValidation(s, o.validation), n.merge(o.validation), s++, r()));
    };
    return n.recalc(), r().then(() => (this.api.finalize && this.api.finalize(i).then(() => n.validation), n.validation));
  }
  updateValidation(e, t) {
    this.getMeta(this.mapper.source.value[e]).validation = t, this.getMeta(this.data[e]).validation = t;
  }
}
class ml {
  /**
   * Gets the export data and does the mapping potentially asynchronously and emitting notifications to the user interface.
   * NOTE: This method is for EXPORT functionality. If there are more methods like this, create a separate ExportHelpers.
   * @param exportApi The API that implements the Exportable interface: Fetching of the data.
   * @param mapper The preloaded mapper that is selected and resoplved.
   * @param maxCount Maximum count of items. null/0 for all items.
   * @param notify Optional progress notification function
   * @returns Result DataRows as mapped.
   */
  static getExportData(e, t, n, i = void 0) {
    if (t.isSourceAList)
      return e.list(n, i).then((s) => t.doMap(s));
    {
      const s = (r, l) => {
        const o = [];
        let u = 0;
        const m = () => u === r.length ? Promise.resolve() : e.getSingle(r[u]).then((p) => (o.push(...t.doMap([p])), l && l(d.get("SALAXY.NG1.ExportComponent.creatingRows"), u, r.length), u++, m()));
        return m().then(() => o);
      };
      return e.list(n, i).then((r) => s(r, i).then((l) => Promise.resolve(l)));
    }
  }
}
var io = /* @__PURE__ */ ((a) => (a.Unknown = "unknown", a.Palkkaus = "palkkaus", a.Mepco = "mepco", a.Tyovuorovelho = "tyovuorovelho", a.MaraPlan = "maraPlan", a.Other = "other", a))(io || {});
class dl {
}
var pn = /* @__PURE__ */ ((a) => (a.Uploaded = "uploaded", a.Parsed = "parsed", a.Processing = "processing", a.Processed = "processed", a.Error = "error", a.Archived = "archived", a))(pn || {}), so = /* @__PURE__ */ ((a) => (a.Hours = "hours", a.Days = "days", a))(so || {}), ro = /* @__PURE__ */ ((a) => (a.Default = "default", a.Saldo = "saldo", a))(ro || {}), oo = /* @__PURE__ */ ((a) => (a.HolidayAccrual = "holidayAccrual", a.AccruedDaysOff = "accruedDaysOff", a))(oo || {});
class lo {
  constructor(e, t, n) {
    this.serviceUrl = e, this.ajax = t, this.getBlank = n, this.currentJson = "", this.list = [], this.error = "";
  }
  /** Sets the current item */
  setCurrent(e) {
    if (!e) {
      this.currentJson = "", this.current = void 0;
      return;
    }
    this.current = e, this.currentJson = JSON.stringify(e, null, 2);
  }
  /** Shows the details view */
  showDetails(e) {
    this.ajax.getJSON(this.serviceUrl + "/" + e).then((t) => {
      this.setCurrent(t);
    });
  }
  /**
   * Gets an item by ID. This does not set the current item.
   * @param id Item ID to get.
   */
  async getItem(e) {
    return await this.ajax.getJSON(this.serviceUrl + "/" + e);
  }
  /**
   * Save any item to the server: Not connected to current item in any way.
   * @param item Item to save.
   */
  async saveItem(e) {
    return await this.ajax.postJSON(this.serviceUrl, e);
  }
  /**
   * Saves changes to the current item.
   * @returns The saved item after save done.
   */
  async saveCurrent() {
    if (!this.current)
      throw new Error("Current item is not set");
    const e = await this.saveItem(this.current);
    return this.setCurrent(e), e;
  }
  /** Creates a new item */
  createNew() {
    this.setCurrent(this.getBlank());
  }
  /**
   * Reloads the list. Also sets the current item to undefined.
   * @returns The list of items after reload.
   */
  async reloadList() {
    this.setCurrent(void 0);
    const e = await this.ajax.getJSON(this.serviceUrl);
    return this.list = e.value, this.list;
  }
  /** Saves the current JSON. */
  saveJson() {
    this.ajax.postJSON(this.serviceUrl, JSON.parse(this.currentJson)).then((e) => {
      this.setCurrent(e), this.reloadList();
    }).catch((e) => {
      this.error = e.data || e;
    });
  }
  /** Deletes an item */
  delete(e) {
    this.ajax.remove(this.serviceUrl + "/" + e).then(() => {
      this.setCurrent(void 0), this.reloadList();
    });
  }
  /**
   * Calls the Update worktime method in the API (like the integrating services would).
   * @param worktimeImportData Data that is sent to the API.
   * This data may contain rows or employment relations or both and they are parsed, validated and saved in the API
   * as one set of rows employment. Employments are created / updated as necessary.
   */
  async callUpdateWorktime(e) {
    return await this.ajax.postJSON(this.serviceUrl + "/update-worktime", e);
  }
}
class hn extends lo {
  constructor(e, t) {
    super(e, t, hn.getBlank), this.filteredRows = [], this.editableRows = [], this.rowsOutsidePayrollCount = 0, this.payrolls = void 0, this._detailsPayrollId = void 0;
  }
  /**
   * Current payroll id in the details view (typically employment relations specific, but may carry out from one employment to another when swtiching).
   * This is different from payrollId which is the payroll id in the list view.
   */
  get detailsPayrollId() {
    return this._detailsPayrollId;
  }
  set detailsPayrollId(e) {
    this._detailsPayrollId = e, this.setFiltersForDetailsPayroll();
  }
  /**
   * Gets the current payroll (metadata) in details view based on the detailsPayrollId.
   * @returns The payroll metadata if found or undefined.
   */
  get detailsPayroll() {
    return this.payrolls?.find((e) => e.value == this.detailsPayrollId);
  }
  /** Current calc is the main preview calculation if available. */
  get currentCalc() {
    if (!(!this.current?.preview?.calculations?.length || !this.detailsPayrollId))
      return this.current.preview.calculations.find((e) => e.info?.payrollId == this.detailsPayrollId);
  }
  /**
   * Gets the worktime imports filtered by payroll.
   * @param payrollId - The payroll id to filter by.
   * @returns The filtered list of worktime imports.
   */
  getFilteredList(e) {
    return e ? this.list.filter((t) => t.payrolls[e]) : this.list;
  }
  /**
   * Fetches all payrolls and stores them in the payrolls property.
   * The calling components should typically call this method in init.
   * It is not in the constructor because AngularJS needs to get the promise and call timeout to get the UI to update.
   */
  async fetchAllPayrolls() {
    const e = await Z.getAllItems((t) => new Oa(this.ajax).getOData(t), {});
    this.payrolls = e.map((t) => ({
      value: t.id,
      text: t.data?.title,
      ui: {
        start: t.data?.periodStart,
        end: t.data?.periodEnd,
        date: t.salaryDate,
        calcCount: t.data?.calcCount,
        // Not sure if this is really needed.
        rangeText: c.getFormattedRange(t.data?.periodStart || this.current?.header?.period?.start || "1900-01-01", t.data?.periodEnd || this.current?.header?.period?.end || "2100-01-01")
      }
    })), this.payrolls?.splice(0, 0, {
      value: "unknown",
      text: "Rivit palkkalistojen ulkopuolella",
      ui: {
        start: c.getToday(),
        end: c.getToday(),
        date: c.getToday(),
        calcCount: 0,
        rowCount: 0,
        previewCalcId: void 0,
        previewCalcRowCount: 0
      }
    }), this.payrolls = this.payrolls?.sort((t, n) => (n.ui?.start ?? "").localeCompare(t.ui?.start ?? ""));
  }
  /**
   * Marks the selected rows with given state.
   * @param rows - The rows to mark.
   * @param status - The status to set.
   * Status "new" is essentially reverting the state from "ignored" => final state may be "preview", "new" or "error" depending on other properties of the row.
   */
  async setStatus(e, t) {
    if (!this.current?.id)
      throw new Error("No current item to update status for.");
    const n = await this.ajax.postJSON(this.serviceUrl + "/update-worktime-status", {
      id: this.current.id,
      status: t,
      rows: e
    });
    return this.setCurrent(n), n;
  }
  /**
   * Moves the selected rows to the given payroll.
   * @param rows - The rows to move.
   * @param payrollId - The payroll id to move to.
   * @returns The updated worktime import.
   */
  async moveToPayroll(e, t) {
    if (!this.current?.id)
      throw new Error("No current item to update status for.");
    if (!t || !e.length)
      throw new Error("Payroll ID and rows are required.");
    const n = await this.ajax.postJSON(this.serviceUrl + "/move-to-payroll", {
      id: this.current.id,
      payrollId: t,
      rows: e
    });
    return this.setCurrent(n), n;
  }
  /** Sets the current item in the UI. */
  setCurrent(e) {
    if (super.setCurrent(e), !e?.preview?.calculations?.length) {
      this.rowsOutsidePayrollCount = 0, this.setFiltersForDetailsPayroll();
      return;
    }
    this.rowsOutsidePayrollCount = e.rows?.filter((t) => (t.data?.payrollId || "unknown") == "unknown").length ?? 0, this.payrolls?.forEach((t) => {
      if (t.value == "unknown")
        t.text = "Rivit palkkalistojen ulkopuolella", t.ui.rowCount = this.rowsOutsidePayrollCount, t.ui.previewCalcId = void 0, t.ui.previewCalcRowCount = 0;
      else {
        t.ui.rowCount = e.rows?.filter((i) => i.data?.payrollId == t.value).length ?? 0;
        const n = e.preview?.calculations?.find((i) => i.info?.payrollId == t.value);
        t.ui.previewCalcId = n?.id, t.ui.previewCalcRowCount = n?.rows?.length ?? 0;
      }
    }), this.setFiltersForDetailsPayroll();
  }
  /**
   * Client-side (synchronous) method for getting a new blank item as bases for UI binding.
   * TODO: Move to helpers.
   */
  static getBlank() {
    return {
      rows: [],
      files: [],
      header: {
        period: {},
        status: pn.Uploaded
      },
      usecase: {
        data: {}
      },
      workflowData: {
        events: []
      }
    };
  }
  /**
   * Recalculates a worktime item in storage.
   * @param id Identifier of the worktime item to recalculate. If none, is specified recaculates the current (current is also set).
   * @returns The recalculated worktime item or undefined if not found / no current & id.
   */
  async recalculateWorktime(e) {
    const t = !e;
    if (e = (e || this.current?.id) ?? void 0, !e)
      return;
    const n = await this.ajax.postJSON(this.serviceUrl + "/recalculate/" + e, {});
    return t && this.setCurrent(n), n;
  }
  /**
   * Saves the manual rows to the server.
   * @returns The updated worktime import.
   */
  async saveManualRows() {
    var e;
    if (!this.detailsPayrollId)
      throw new Error("No payroll selected for manual rows.");
    this.current ?? (this.current = {}), (e = this.current).rows ?? (e.rows = []), this.current.rows = this.current.rows.filter((t) => t.source != pa.ManualRow), this.editableRows?.forEach((t) => {
      t.employmentId = this.current?.id, t.source = pa.ManualRow, t.status = "edited", t.data ?? (t.data = {}), t.data.payrollId = this.detailsPayrollId, t.period = t.period || {}, t.period.start = t.period.start || this.detailsPayroll?.ui?.start, t.period.end = t.period.end || this.detailsPayroll?.ui?.start, this.current?.rows?.push(t);
    }), this.setFiltersForDetailsPayroll(), await this.saveCurrent();
  }
  setFiltersForDetailsPayroll() {
    if (!this.current) {
      this.filteredRows = [], this.editableRows = [];
      return;
    }
    if (this.detailsPayrollId) {
      this.filteredRows = this.current.rows?.filter((e) => e.data?.payrollId == this.detailsPayrollId), this.editableRows = this.filteredRows?.filter((e) => e.source == pa.ManualRow);
      return;
    }
    this.filteredRows = this.current.rows?.filter((e) => !e.data?.payrollId), this.editableRows = [];
  }
}
class cl {
  /**
   * Get supported TargetOptions
   * @returns All supported export TargetOptions
   */
  static getSupportedTargets() {
    return {
      // Palkkaus.fi
      "36dff2e2-e181-4f0d-9004-0e4aa92f5e17": {
        getExportData: (e, t) => this.getPalkkausExportData(e, t),
        schemes: [
          {
            id: "default",
            label: d.get("SALAXY.NG1.AccountingReportToolsComponent.schemes.default.label")
          },
          {
            id: "compact",
            label: d.get("SALAXY.NG1.AccountingReportToolsComponent.schemes.compact.label")
          },
          {
            id: "extended",
            label: d.get("SALAXY.NG1.AccountingReportToolsComponent.schemes.extended.label")
          }
        ],
        defaultExportMethod: ae.FileExcel
      },
      // Palkkaus.fi ja lomat
      "8fd494ba-f98d-45e2-ae70-3570e16dfa3c": {
        getExportData: (e, t) => this.getPalkkausExportData(e, t),
        schemes: [
          {
            id: "default",
            label: d.get("SALAXY.NG1.AccountingReportToolsComponent.schemes.default.label")
          },
          {
            id: "compact",
            label: d.get("SALAXY.NG1.AccountingReportToolsComponent.schemes.compact.label")
          },
          {
            id: "extended",
            label: d.get("SALAXY.NG1.AccountingReportToolsComponent.schemes.extended.label")
          }
        ],
        defaultExportMethod: ae.FileExcel
      },
      // Fennoa
      "0db4e85f-93a8-46f1-b6d2-f7523d289d88": {
        getExportData: (e) => this.getFennoaExportData(e),
        defaultExportMethod: ae.FileCsv
      },
      // Finago Procountor
      "8613f133-3fce-4611-b372-51f6a2e007dd": {
        getExportData: (e) => this.getProcountorExportData(e),
        defaultExportMethod: ae.CopyExcel
      },
      // Accountor Go
      "4b3335ad-dfd2-48f5-a088-6449874a0732": {
        getExportData: (e) => this.getProcountorExportData(e),
        defaultExportMethod: ae.CopyExcel
      },
      // Passeli Merit
      "e62c10b0-222a-4170-b8b4-b1e02d9a7644": {
        getExportData: (e) => this.getPasseliMeritExportData(e),
        defaultExportMethod: ae.FileCsv,
        noCsvQuotedStrings: !0
      },
      // Heeros
      "53fd3863-b8f9-4909-86c9-cb4597595181": {
        getExportData: (e, t) => this.getHeerosExportData(e, t),
        defaultExportMethod: ae.FileCsv,
        noCsvQuotedStrings: !0,
        schemes: [
          {
            id: "default",
            label: d.get("SALAXY.NG1.AccountingReportToolsComponent.schemes.default.label")
          },
          {
            id: "extended",
            label: d.get("SALAXY.NG1.AccountingReportToolsComponent.schemes.extended.label")
          }
        ]
      },
      // Asteri
      "2fc7899c-7a3d-4d56-ad2f-05d52782bbbc": {
        getExportData: (e) => this.getAsteriExportData(e),
        defaultExportMethod: ae.CopyExcel
      },
      // Maestro
      "0a2bd312-06da-4862-aef5-75166e0bf461": {
        getExportData: (e) => this.getMaestroExportData(e),
        defaultExportMethod: ae.FileCsv,
        noCsvQuotedStrings: !0
      },
      // Visma Fivaldi
      "c04e0757-63f3-420d-a183-3427710fc954": {
        getExportData: (e) => this.getVismaFivaldiExportData(e),
        defaultExportMethod: ae.FileCsv,
        noCsvBom: !0
      },
      // Netvisor
      "ba271dac-dd63-4036-9d70-053a09ca4d9e": {
        getExportData: (e) => this.getVismaNetvisorExportData(e),
        defaultExportMethod: ae.FileCsv
      },
      // Lemonsoft
      "27e271d5-41f5-4319-ab29-4d5d9eb945c6": {
        getExportData: (e) => this.getLemonsoftExportData(e),
        defaultExportMethod: ae.CopyExcel
      },
      // Tampuuri
      "d311f9d3-8c3a-4fd8-a665-8e3698e41e87": {
        getExportData: (e) => this.getTampuuriExportData(e),
        defaultExportMethod: ae.CopyExcel
      },
      // Domus
      "d58e95b7-d0b5-40ac-992b-6d3b29efc45e": {
        getExportData: (e) => this.getDomusExportData(e),
        defaultExportMethod: ae.FileCsv
      },
      //Oscar Software
      "54e93c5f-bd74-4157-8a74-3515be7f585d": {
        getExportData: (e) => this.getOscarSoftwareExportData(e),
        defaultExportMethod: ae.FileExcel,
        noCsvQuotedStrings: !0
      },
      //Digia Enterprise / Envision
      "0e4f0a71-dcb9-43ba-9028-0239e674711f": {
        getExportData: (e) => this.getDigiaExportData(e),
        defaultExportMethod: ae.FileText,
        noCsvQuotedStrings: !0,
        formatAsText: (e, t) => this.formatAsDigiaText(e, t)
      },
      //Vilpe Digia Enterprise / Envision
      "2ccefa46-7992-46c5-9d87-b88336935916": {
        getExportData: (e) => this.getVilpeDigiaExportData(e),
        defaultExportMethod: ae.FileText,
        noCsvQuotedStrings: !0,
        formatAsText: (e, t) => this.formatAsVilpeDigiaText(e, t)
      }
    };
  }
  static getPalkkausExportData(e, t) {
    return t === "extended" || t === "compact" ? this.getPalkkausExtendedExportData(e, t == "extended") : this.getPalkkausDefaultExportData(e);
  }
  /** Data exports for targets */
  static getPalkkausDefaultExportData(e) {
    const t = [], n = ["Ehdotustili", "Selite", "ALV-%"], i = [], s = (r, l) => {
      r && !i.includes(l) && l !== "costCenter" && (i.push(l), n.push(l));
    };
    for (const r of e?.ledgerAccounts ?? [])
      for (const l of r?.entries ?? []) {
        const o = l.dimension?.costCenter || l.dimension?.dimensions?.costCenter;
        s(o, "Kustannuspaikka");
        const u = l.dimension?.projectNumber || l.dimension?.dimensions?.projectNumber;
        if (s(u, "projectNumber"), l.dimension?.dimensions)
          for (const [m, p] of this.getEntryDimensions(l))
            s(p, m);
      }
    n.push("Saldo"), t.push(n);
    for (const r of e?.ledgerAccounts ?? []) {
      const l = [];
      for (const o of r?.entries ?? []) {
        const u = [];
        for (const y of i)
          if (y === "Kustannuspaikka") {
            const S = o.dimension?.costCenter || o.dimension?.dimensions?.costCenter || "";
            u.push(S);
          } else if (y === "projectNumber") {
            const S = o.dimension?.projectNumber || o.dimension?.dimensions?.projectNumber || "";
            u.push(S);
          } else
            u.push(o.dimension?.dimensions && o.dimension.dimensions[y] || "");
        const m = o.vatPercent;
        let p = l.find((y) => y.vatPercent === m && y.dimensionsId === u.join("-"));
        p == null && (p = { entries: [], vatPercent: m, dimensions: u, dimensionsId: u.join("-") }, l.push(p)), p.entries.push(o);
      }
      for (const o of l) {
        const u = [];
        u.push(r.accountNumber), u.push(r.accountName), u.push(o.vatPercent ?? 0 * 100);
        for (let p = 0; p < i.length; p++)
          u.push(o.dimensions[p]);
        const m = h.round(o.entries.reduce((p, y) => p + (y.isDebit ? y.amount ?? 0 : -1 * (y.amount ?? 0)), 0));
        u.push(m), t.push(u);
      }
    }
    return t;
  }
  static getPalkkausExtendedExportData(e, t) {
    const n = [], i = [], s = ["accountNumber", "saldo", "accountName"], r = ["Tilinumero", "Summa", "Tilin nimi"], l = ["description", "isDebit", "amount", "vatPercent"], o = ["Kuvaus", "Debet", "Arvo", "ALV-prosentti"], u = ["calculationOwner", "calculationId", "calculationTitle", "projectNumber", "costCenter", "workerName"], m = ["Laskelman tili", "Laskelman id", "Laskelman kuvaus", "Projektinumero", "Kustannuspaikka", "Työntekijä"];
    for (const p of r)
      i.push(p);
    if (t) {
      for (const p of o)
        i.push(p);
      for (const p of m)
        i.push(p);
    }
    n.push(i);
    for (const p of e?.ledgerAccounts ?? []) {
      let y = [];
      for (const S of s)
        switch (S) {
          case "saldo":
            y.push(h.round(p[S]));
            break;
          default:
            y.push(p[S]);
            break;
        }
      if (t) {
        let S = !0;
        for (const x of p?.entries ?? []) {
          S ? S = !1 : y = new Array(s.length);
          for (const v of l)
            switch (v) {
              case "vatPercent":
                y.push((x[v] ?? 0) * 100);
                break;
              case "amount":
                y.push(h.round(x[v]));
                break;
              default:
                y.push(x[v]);
                break;
            }
          for (const v of u)
            v === "costCenter" ? y.push(x.dimension?.costCenter || x.dimension?.dimensions?.costCenter) : v == "projectNumber" ? y.push(x.dimension?.projectNumber || x.dimension?.dimensions?.projectNumber) : y.push(x.dimension?.[v]);
          n.push(y);
        }
      } else
        n.push(y);
    }
    return n;
  }
  /**
   * https://procountor.finago.com/hc/fi/articles/360000254997-Tallennusty%C3%B6kalu-uusi-#LIIT%C3%84VIENTEJ%C3%84-TOIMINTO
   */
  static getProcountorExportData(e) {
    const t = [], n = ["Kp-tili", "Brutto", "ALV-%", "ALV-väh.%", "ALV-tyyppi", "ALV-status", "Vientiselite"];
    t.push(n);
    for (const i of e?.ledgerAccounts ?? []) {
      const s = [];
      for (const r of i?.entries ?? []) {
        const l = r.vatPercent ?? 0;
        let o = s.find((u) => u.vatPercent === l);
        o == null && (o = { vatPercent: l, entries: [] }, s.push(o)), o.entries.push(r);
      }
      for (const r of s) {
        const l = [];
        l.push(i.accountNumber), l.push(h.round(r.entries.reduce((o, u) => o + (u.isDebit ? u.amount ?? 0 : -1 * (u.amount ?? 0)), 0))), l.push(r.vatPercent ? r.vatPercent * 100 : ""), l.push(r.vatPercent ? 100 : ""), l.push(r.vatPercent ? "P" : ""), l.push(r.vatPercent ? "vat_1" : ""), l.push(i.accountName), t.push(l);
      }
    }
    return t;
  }
  /**
   * Merit aktiva format
   */
  static getPasseliMeritExportData(e) {
    const t = [], n = ["T", e.officialId, e.employer?.displayName, c.asJSDate(e.period?.end), null, c.asJSDate(e.period?.start), c.asJSDate(e.period?.end)];
    t.push(n);
    for (const i of e?.ledgerAccounts ?? []) {
      const s = [];
      s.push("V"), s.push(i.accountNumber), s.push(i.accountName), s.push(h.round(i.saldo)), s.push(null), s.push(null), s.push(null), t.push(s);
    }
    return t;
  }
  /**
   * https://asteri.fi/aineistojen-tuonti-asteri-kirjanpitoon/
   */
  static getAsteriExportData(e) {
    const t = [], n = ["Tosno", "Päivämäärä", "Laji", "Kustp", "Lsno", "Selite 1", "Selite 2", "Debet", "Kredit", "Summa"];
    t.push(n);
    const i = this.getEntryDate(e);
    for (const s of e?.ledgerAccounts ?? []) {
      const r = [];
      for (const l of s?.entries ?? []) {
        const o = l.dimension?.costCenter || l.dimension?.dimensions?.costCenter || "";
        let u = r.find((m) => m.costCenter === o);
        u == null && (u = { costCenter: o, entries: [] }, r.push(u)), u.entries.push(l);
      }
      for (const l of r) {
        const o = [];
        o.push(null), o.push(c.asJSDate(i)), o.push("Palkkaus"), o.push(l.costCenter), o.push(null), o.push(s.accountName), o.push(null);
        const u = h.round(l.entries.reduce((m, p) => m + (p.isDebit ? p.amount ?? 0 : -1 * (p.amount ?? 0)), 0)) ?? 0;
        u >= 0 ? (o.push(s.accountNumber), o.push("****"), o.push(u)) : (o.push("****"), o.push(s.accountNumber), o.push(u * -1)), t.push(o);
      }
    }
    return t;
  }
  /**
   * Maestro
   * +----------+--------------+-----------------------------------------+
   * | Otsikko  |    Muoto     |                 Selite                  |
   * +----------+--------------+-----------------------------------------+
   * | TOSITE   | VVVV/L/NNNNN | Tositenumero                            |
   * | PAIVAYS  | PP.KK.VVVV   | Kirjauspäivä                            |
   * | ERN      | NUM          | Erityisraporttinro                      |
   * | KAAVA    | NUM          | Tulos/Tasekaavanumero                   |
   * | TNRO     | NUM          | Tilinumero                              |
   * | RNRO     |              | Raporttinumero                          |
   * | TILINIMI | AN           | Tilin Nimi                              |
   * | TUPA     | NUM          | Tulospaikkanumero                       |
   * | ATP      |              | Aputulospaikkanumero                    |
   * | SELITE   | AN           | Vientiselite                            |
   * | VARA1    |              | Varalla/1                               |
   * | VARA2    |              | Varalla/2                               |
   * | VARA3    |              | Varalla/3                               |
   * | VARA4    |              | Varalla/4                               |
   * | SUMMA    |              | Summa (2-desimaalisena erotin on piste) |
   * +----------+--------------+-----------------------------------------+
   */
  static getMaestroExportData(e) {
    const t = [], n = ["TOSITE", "PAIVAYS", "ERN", "KAAVA", "TNRO", "RNRO", "TILINIMI", "TUPA", "ATP", "SELITE", "VARA1", "VARA2", "VARA3", "VARA4", "SUMMA"];
    t.push(n);
    const i = this.getEntryDate(e);
    for (const s of e?.ledgerAccounts ?? []) {
      const r = [];
      for (const l of s?.entries ?? []) {
        const o = l.dimension?.costCenter || l.dimension?.dimensions?.costCenter || "";
        let u = r.find((m) => m.costCenter === o);
        u == null && (u = { costCenter: o, entries: [] }, r.push(u)), u.entries.push(l);
      }
      for (const l of r) {
        const o = [], u = h.round(l.entries.reduce((m, p) => m + (p.isDebit ? p.amount ?? 0 : -1 * (p.amount ?? 0)), 0)) ?? 0;
        o.push(null), o.push(c.asJSDate(i)), o.push(null), o.push(null), o.push(h.parseNumber(s.accountNumber ?? "")), o.push(null), o.push(s.accountName), o.push(null), o.push(l.costCenter), o.push(s.accountName), o.push(null), o.push(null), o.push(null), o.push(null), o.push(u), t.push(o);
      }
    }
    return t;
  }
  /**
   * https://support.netvisor.fi/hc/fi/articles/235300547-Kirjanpitotietojen-tuonti
   */
  static getVismaNetvisorExportData(e) {
    const t = [], n = [
      "TositeLaji",
      "Tositenumero",
      "Päivämäärä (PVM)",
      "Selite 1",
      "Selite 2",
      "Selite 3",
      "Selite 4",
      "Selite 5",
      "Tilinumero",
      "Debet",
      "Kredit",
      "Summa",
      "Summa",
      "ALV-tunnus",
      "ALV-prosentti"
    ];
    t.push(n);
    const i = this.getEntryDate(e);
    for (const s of e?.ledgerAccounts ?? []) {
      const r = [];
      for (const l of s?.entries ?? []) {
        const o = l.vatPercent ?? 0;
        let u = r.find((m) => m.vatPercent === o);
        u == null && (u = { vatPercent: o, entries: [] }, r.push(u)), u.entries.push(l);
      }
      for (const l of r) {
        const o = [];
        o.push(null), o.push(null), o.push(c.asJSDate(i)), o.push(s.accountName), o.push(null), o.push(null), o.push(null), o.push(null), o.push(s.accountNumber);
        const u = h.round(l.entries.reduce((m, p) => m + (p.isDebit ? p.amount ?? 0 : -1 * (p.amount ?? 0)), 0)) ?? 0;
        u >= 0 ? (o.push(u), o.push(0), o.push(u), o.push(u * -1)) : (o.push(0), o.push(u * -1), o.push(u), o.push(u * -1)), o.push(l.vatPercent ? "KOOS" : ""), o.push(l.vatPercent ? l.vatPercent * 100 : ""), t.push(o);
      }
    }
    return t;
  }
  /**
   * Fennoa export data format.
   * Tuetut sarakkeet:
   *
   * - PVM - Tositepäivä. Ensimmäiseltä riviltä otetaan Fennoan tositteelle päivämäärä.
   * - TILI - Kirjanpidon tili
   * - SELITE - Vientirivin selite
   * - SUMMA (Debet +, Kredit -)
   * - ALV-KOODI
   * - tyhjä tarkoittaa tilikartasta tilin takaa haetaan oletus alv-koodi
   * - viiva ”-” tarkoittaa ei alv-koodia
   * - 1 = 24
   * - 2 = 14
   * - 3 = 10
   * - numero on vientiriville halutun alv-koodin id numero, jotka löytyvät ohjekannastamme ALV-kooditaulukosta (3.9.5 ALV-koodit / Arvonlisäverokoodit Fennoassa).
   * - LK1 - Laskentakohde 1
   * - LK2 - Laskentakohde 2
   * - LK… jne
   */
  static getFennoaExportData(e) {
    const t = [], n = [
      "PVM",
      "TILI",
      "SELITE",
      "SUMMA",
      "ALV-KOODI",
      "LK1"
    ];
    t.push(n);
    const i = this.getEntryDate(e);
    for (const s of e?.ledgerAccounts ?? []) {
      const r = [];
      for (const l of s?.entries ?? []) {
        const o = l.vatPercent ?? 0, u = l.dimension?.costCenter || l.dimension?.dimensions?.costCenter || "";
        let m = r.find((p) => p.vatPercent === o && p.costCenter === u);
        m == null && (m = { vatPercent: o, costCenter: u, entries: [] }, r.push(m)), m.entries.push(l);
      }
      for (const l of r) {
        const o = [];
        o.push(c.asJSDate(i)), o.push(s.accountNumber), o.push(s.accountName);
        const u = h.round(l.entries.reduce((m, p) => m + (p.isDebit ? p.amount ?? 0 : -1 * (p.amount ?? 0)), 0)) ?? 0;
        o.push(u), o.push(l.vatPercent ? l.vatPercent * 100 === 24 || l.vatPercent * 100 === 25.5 ? 1 : l.vatPercent * 100 === 14 ? 2 : l.vatPercent * 100 === 10 ? 3 : "" : ""), o.push(l.costCenter), t.push(o);
      }
    }
    return t;
  }
  /**
   * Domus export data format.
   * Tuetut sarakkeet:
   * - Y-TUNNUS - Yrityksen y-tunnus
   * - PVM - Tositepäivä. Ensimmäiseltä riviltä otetaan Domus tositteelle päivämäärä.
   * - TILI - Kirjanpidon tili
   * - SELITE - Vientirivin selite
   * - SUMMA (Debet +, Kredit -)
   */
  static getDomusExportData(e) {
    const t = [], n = [
      "Y-TUNNUS",
      "PVM",
      "TILI",
      "SELITE",
      "SUMMA"
    ];
    t.push(n);
    const i = this.getEntryDate(e);
    for (const s of e?.ledgerAccounts ?? []) {
      const r = [];
      r.push(e.officialId), r.push(c.asJSDate(i)), r.push(s.accountNumber), r.push(s.accountName), r.push(h.round(s.saldo)), t.push(r);
    }
    return t;
  }
  /**
   * Oscar Software
   * Aineisto on oltava Excel taulukosta muodossa "Tabuloinnilla erotettu teksti (*.txt)" tallennettu tiedosto. Excel taulukon on noudatettava seuraavia sääntöjä:
   * Yhdessä taulukossa on aina yhden tositteen viennit. Vientien lukumäärä ei ole rajoitettu. Viennit ovat jokainen omalla rivillään ja vientejä edeltää sarakeotsikot sisältävä rivi.
   * Ennen tätä riviä tiedostossa saa olla mitä tahansa tietoa, jota ohjelma ei mitenkään käsittele. Sarakeotsikoilla voidaan kertoa tiedoston sisältävän seuraavia tietoja:
   * +--------------------------------------+-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------+
   * | Sarakeotsikko                        | Kuvaus                                                                                                                                                                                                          |
   * +--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------+
   * | Tositelaji                           |Oltava perustettuna kirjanpitoon, annetaan ensimmäisellä vientirivillä. Jos tietoa ei ole, ohjelma käyttää oletustositelajia. Tositenumero määräytyy tositelajin perusteella kuten tositteita käsin syötettäessä.|                                                                       |
   * | Pvm tai Pv                           | Tositteen päiväys, annetaan ensimmäisellä vientirivillä. Päivämäärä anneteen muodossa ppkkvv. Pakollinen tieto.                                                                                                 |
   * | Selite tai Vientiselite              | Viennin selite. Tositekohtainen selite voidaan antaa rivillä, jolla ei anneta lainkaan tilinumeroa.                                                                                                             |
   * | Tili                                 | Tilinumero, pakollinen tieto (lukuun ottamatta tositeselitettä).                                                                                                                                                |
   * | Kp, Kust.paikka tai Kustannuspaikka  | Kustannuspaikka                                                                                                                                                                                                 |
   * | Tunniste tai Projekti                | Tunniste/projekti                                                                                                                                                                                               |
   * | Alv-menetelmä tai Alv-men            | Alv-menetelmä (käytössä vain tietyillä Tisma-käyttäjillä).                                                                                                                                                      |
   * | Debet, Debetvienti tai Debetsumma    | Debet viennin summa                                                                                                                                                                                             |
   * | Kredit, Kreditvienti tai Kreditsumma | Kredit viennin summa. Yhdellä rivillä ei voi olla sekä debet että kredit -vientiä. Jompi kumpi kuitenkin pitää olla.                                                                                            |
   * +--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------+
   * Sarakeotsikoiden kirjoitusasu isojen ja pienten kirjainten suhteen on vapaa. Jos yllä on esitetty useampi kuin yksi kirjoitusasu, mikä tahansa näistä kelpaa.
   * Vähintään sarakkeet "Pvm", "Tili", "Debet" ja "Kredit"on aineistosta löydyttävä. Sarakkeiden keskinäinen järjestys on vapaa.
   * Jos tiedosto sisältää muitakin kuin kuvatut sarakkeet, ohjelma ei käsittele näitä mitenkään. Ohjelman käsittelemät tiedot täytyy sijaita 12 ensimmäisen sarakkeen joukossa.
   * Selitteiden merkistö pitää olla ISO-Latin merkistöä
   */
  static getOscarSoftwareExportData(e) {
    const t = [], n = ["Tositelaji", "Pvm", "Selite", "Tili", "Kp", "Projekti", "Debet", "Kredit"];
    t.push(n);
    const i = this.getEntryDate(e);
    for (const s of e?.ledgerAccounts ?? []) {
      const r = [];
      for (const l of s?.entries ?? []) {
        const o = l.dimension?.costCenter || l.dimension?.dimensions?.costCenter || "", u = l.dimension?.projectNumber || l.dimension?.dimensions?.projectNumber || l.dimension?.dimensions?.project || "";
        let m = r.find((p) => p.costCenter == o && p.projectNumber == u);
        m == null && (m = { costCenter: o, projectNumber: u, entries: [] }, r.push(m)), m.entries.push(l);
      }
      for (const l of r) {
        const o = [];
        o.push(null), o.push(c.format(i, "DDMMYY")), o.push(s.accountName), o.push(s.accountNumber), o.push(l.costCenter), o.push(l.projectNumber);
        const u = h.round(l.entries.reduce((m, p) => m + (p.isDebit ? p.amount ?? 0 : -1 * (p.amount ?? 0)), 0)) ?? 0;
        u >= 0 ? (o.push(u), o.push(null)) : (o.push(null), o.push(u * -1)), t.push(o);
      }
    }
    return t;
  }
  /**
   * Lemonsoft
   * https://doc.lemonsoft.eu/lemonnethelp/default.htm#!Documents/excelcsv.htm
   * +----------+--------------+---------------------------------------------------+
   * | Otsikko  |    Muoto     |                 Selite                            |
   * +----------+--------------+---------------------------------------------------+
   * | Tosite   | 0            | Vakio = 0                                         |
   * | Tlaji    | NUM          | Tositelaji                                        |
   * | Tnro     | NUM          | Tositenumero                                      |
   * | Pvm      | VVVV-KK-PP   | Päivämäärä muodossa VVVV-KK-PP (esim. 2009-10-20) |
   * | Selite   | AN(60)       | Vientiselite                                      |
   * | Kpaikka  | AN(40)       | Kustannuspaikka                                   |
   * | LTA      | AN(40)       | Liiketoiminta-alue                                |
   * | Tunniste | AN(30)       | Tunniste                                          |
   * | Projekti | NUM          | Projektinumero                                    |
   * | Tili     | AN(10)       | Kirjanpitotili                                    |
   * | Debet    | NUM          | Debet                                             |
   * | Kredit   | NUM          | Kredit                                            |
   * | Vero     | NUM          | Veron määrä                                       |
   * +----------+--------------+---------------------------------------------------+
   */
  static getLemonsoftExportData(e) {
    const t = [], n = [
      "Tosite",
      "Tlaji",
      "Tnro",
      "Pvm",
      "Selite",
      "Kpaikka",
      "LTA",
      "Tunniste",
      "Projekti",
      "Tili",
      "Debet",
      "Kredit",
      "Vero"
    ];
    t.push(n);
    const i = this.getEntryDate(e);
    for (const s of e?.ledgerAccounts ?? []) {
      const r = [];
      for (const l of s?.entries ?? []) {
        const o = l.dimension?.costCenter || l.dimension?.dimensions?.costCenter || "", u = l.dimension?.projectNumber || l.dimension?.dimensions?.projectNumber || l.dimension?.dimensions?.project || "";
        let m = r.find((p) => p.costCenter == o && p.projectNumber == u);
        m == null && (m = { costCenter: o, projectNumber: u, entries: [] }, r.push(m)), m.entries.push(l);
      }
      for (const l of r) {
        const o = [];
        o.push(0), o.push(null), o.push(null), o.push(c.asJSDate(i)), o.push(s.accountName), o.push(l.costCenter), o.push(null), o.push(null), o.push(l.projectNumber), o.push(s.accountNumber);
        const u = h.round(l.entries.reduce((m, p) => m + (p.isDebit ? p.amount ?? 0 : -1 * (p.amount ?? 0)), 0)) ?? 0;
        u >= 0 ? (o.push(u), o.push(0)) : (o.push(0), o.push(u * -1)), o.push(h.round(l.entries.reduce((m, p) => m + (p.vatAmount ?? 0), 0))), t.push(o);
      }
    }
    return t;
  }
  /**
   * | Nimi             | Tositepäivä             | Tositelaji | Tositenumero | Tili    | Alv-Koodi | Summa              | Kustannuspaikka | Laskentakohde1 | Laskentakohde2 | Laskentakohde3 | Laskentakohde4 | Laskentakohde5 | Laskentakohde6 | Laskentakohde7 | Laskentakohde8 | Laskentakohde9 | Laskentakohde10 | Laskentakohde11 | Laskentakohde12 | Laskunumero | Vientiselite |
   * |------------------|-------------------------|------------|--------------|---------|-----------|--------------------|-----------------|----------------|----------------|----------------|----------------|----------------|----------------|----------------|----------------|----------------|-----------------|-----------------|-----------------|-------------|--------------|
   * | Tyyppi           | Date                    | varchar    | biginit      | varchar | varchar   | desimal            | varchar         | varchar        | varchar        | varchar        | varchar        | varchar        | varchar        | varchar        | varchar        | varchar        | varchar         | varchar         | varchar         | varchar     | varchar      |
   * |                  | Päivämäärä              | Teksti     | Kokonaisluku |         |           | Luku, 2 desimaalia |                 |                |                |                |                |                |                |                |                |                |                 |                 |                 |             |              |
   * | Pituus           |                         | 10         | 20           | 6       | 10        | 13,2               | 30              | 30             | 30             | 30             | 30             | 30             | 30             | 30             | 30             | 30             | 30              | 30              | 30              | 30          | 100          |
   * | Muoto            | pp.kk.vvvv tai p.k.vvvv |            |              |         |           |                    |                 |                |                |                |                |                |                |                |                |                |                 |                 |                 |             |              |
   * | Pakollisuus      | V                       | V          | V            | P       | V         | P                  | V               | V              | V              | V              | V              | V              | V              | V              | V              | V              | V               | V               | V               | V           | V            |
   * | Järjestys        | 1.00                    | 2.00       | 3.00         | 4.00    | 5.00      | 6.00               | 7.00            | 8.00           | 9.00           | 10.00          | 11.00          | 12.00          | 13.00          | 14.00          | 15.00          | 16.00          | 17.00           | 18.00           | 19.00           | 20.00       | 21.00        |
   * | Sarake Excelissä | A                       | B          | C            | D       | E         | F                  | G               | H              | I              | J              | K              | L              | M              | N              | O              | P              | Q               | R               | S               | T           | U            |
   */
  static getHeerosExportData(e, t) {
    const n = [], i = [
      "Tositepvm",
      "Tositelaji",
      "Tositenro",
      "Tili",
      "Alv-koodi",
      "Summa",
      "Kustp",
      "Proj",
      "Lask2",
      "Lask3",
      "Lask4",
      "Lask5",
      "Lask6",
      "Lask7",
      "Lask8",
      "Lask9",
      "Lask10",
      "Lask11",
      "Lask12",
      "LaskuNro",
      "Selite"
    ];
    if (n.push(i), t === "extended")
      for (const s of e?.ledgerAccounts ?? [])
        for (const r of s?.entries ?? []) {
          const l = [];
          l.push(c.asJSDate(r.entryDate)), l.push(null), l.push(null), l.push(s.accountNumber), l.push(r.vatPercent ? r.vatPercent * 100 === 24 || r.vatPercent * 100 === 25.5 ? 1 : r.vatPercent * 100 === 14 ? 2 : r.vatPercent * 100 === 10 ? 3 : "" : ""), l.push(h.round(r?.isDebit ? r?.amount ?? 0 : -1 * (r?.amount ?? 0))), l.push(r?.dimension?.costCenter || r?.dimension?.dimensions?.costCenter || ""), l.push(r?.dimension?.projectNumber || r?.dimension?.dimensions?.projectNumber || r?.dimension?.dimensions?.project || ""), l.push(null), l.push(null), l.push(null), l.push(null), l.push(null), l.push(null), l.push(null), l.push(null), l.push(null), l.push(null), l.push(null), l.push(null), l.push(r.description), n.push(l);
        }
    else {
      const s = this.getEntryDate(e);
      for (const r of e?.ledgerAccounts ?? []) {
        const l = [];
        for (const o of r?.entries ?? []) {
          const u = o.vatPercent ?? 0, m = o.dimension?.costCenter || o.dimension?.dimensions?.costCenter || "", p = o.dimension?.projectNumber || o.dimension?.dimensions?.projectNumber || o.dimension?.dimensions?.project || "";
          let y = l.find((S) => S.vatPercent == u && S.costCenter == m && S.projectNumber == p);
          y == null && (y = { vatPercent: u, costCenter: m, projectNumber: p, entries: [] }, l.push(y)), y.entries.push(o);
        }
        for (const o of l) {
          const u = [];
          u.push(c.asJSDate(s)), u.push(null), u.push(null), u.push(r.accountNumber), u.push(o.vatPercent ? o.vatPercent * 100 === 24 || o.vatPercent * 100 === 25.5 ? 1 : o.vatPercent * 100 === 14 ? 2 : o.vatPercent * 100 === 10 ? 3 : "" : "");
          const m = h.round(o.entries.reduce((p, y) => p + (y.isDebit ? y.amount ?? 0 : -1 * (y.amount ?? 0)), 0)) ?? 0;
          u.push(m), u.push(o.costCenter), u.push(o.projectNumber), u.push(null), u.push(null), u.push(null), u.push(null), u.push(null), u.push(null), u.push(null), u.push(null), u.push(null), u.push(null), u.push(null), u.push(null), u.push(r.accountName), n.push(u);
        }
      }
    }
    return n;
  }
  /*
  Url: https://community.visma.com/t5/Visma-Fivaldi-kayttovinkit/Visma-Fivaldi-Kasikirja-RAJAPINNAT/ta-p/35780?attachment-id=11454 - Sivu 66
  PVM Pakollinen N8 Kirjauspäivä tositteelle, muoto VVVVKKPP
  TILI Pakollinen AN8 Kirjanpidon tili
  TOSITE AN16 Tositenumero jolla tositteet erotetaan. Jos tositenumeroa ei ole, päiväyksen muuttuminen vaihtaa seuraavaan tositteeseen
  SK1 AN8 Seurantakohde 1
  SK2 AN8 Seurantakohde 2
  SK3 AN8 Seurantakohde 3
  SK4 AN8 Seurantakohde 4
  SUMMA Pakollinen N15,2 Summa yrityksen valuutassa etumerkkeineen
  SENTIT N15 Summa sentteinä etumerkkeineen
  SELITE AN179 Vientiselite
  VEROKANTA AN10 Verokantakoodi
  VEROTILI AN8 Verotili
  VEROTILI2 AN8 Verotili 2 (vastakirjaus)
  VEROSUMMA N15,2 Veron määrä yrityksen valuutassa etumerkkeineen
  VEROSENTIT N15 Veron määrä sentteinä etumerkkeineen
  STATUS AN1 Viennin erikoiskäsittely
  NETTOPVM N8 Laskun eräpäivä VVVVKKPP
  ASIAKASTUNNUS AN10 Asiakkaan/toimittajan tunnus
  VIENTILAJI AN2 Vientilajin tunnus
  LASKUNO AN16 Laskun numero
  YT N6 Fivaldi-yritysnumero jolle aineisto tuodaan
  LAJI N3 Tositelajin numero jolle aineisto tuodaan
  */
  static getVismaFivaldiExportData(e) {
    const t = [], n = [
      "PVM",
      "TILI",
      "TOSITE",
      "SK1",
      "SK2",
      "SK3",
      "SK4",
      "SUMMA",
      "SENTIT",
      "SELITE",
      "VEROKANTA",
      "VEROTILI",
      "VEROTILI2",
      "VEROSUMMA",
      "VEROSENTIT",
      "STATUS",
      "NETTOPVM",
      "ASIAKASTUNNUS",
      "VIENTILAJI",
      "LASKUNO",
      "YT",
      "LAJI"
    ];
    t.push(n);
    const i = this.getEntryDate(e);
    for (const s of e?.ledgerAccounts ?? []) {
      const r = [];
      for (const l of s?.entries ?? []) {
        const o = l.dimension?.costCenter || l.dimension?.dimensions?.costCenter || "";
        let u = r.find((m) => m.costCenter == o);
        u == null && (u = { costCenter: o, entries: [] }, r.push(u)), u.entries.push(l);
      }
      for (const l of r) {
        const o = [];
        o.push(c.format(i, "YYYYMMDD")), o.push(s?.accountNumber), o.push(null), o.push(l.costCenter), o.push(null), o.push(null), o.push(null);
        const u = h.round(l.entries.reduce((p, y) => p + (y.isDebit ? y.amount ?? 0 : -1 * (y.amount ?? 0)), 0)) ?? 0;
        o.push(u), o.push(u * 100), o.push(s.accountName), o.push(null), o.push(null), o.push(null);
        const m = h.round(l.entries.reduce((p, y) => p + (y.isDebit ? y.vatAmount ?? 0 : -1 * (y.vatAmount ?? 0)), 0));
        o.push(m), o.push(m ? m * 100 : 0), o.push(null), o.push(null), o.push(null), o.push(null), o.push(null), o.push(null), o.push(null), t.push(o);
      }
    }
    return t;
  }
  /**
   * Tampuuri
   * https://eteinen.tampuuri.fi/s/artikkelit?article=Tuonti-Excelista
   * +--------------------------+-------------------+----------------------------------------------------------------------------------------------------------------------------------------------------------------+
   * | Sarakeotsikko            |    Pakollinen     |                 Kuvaus                                                                                                                                         |
   * +---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------+
   * | Tositenro                | Ei                | Mikäli tositenumeroa ei anna, järjestelmä generoi sen tositelajin laskurin   mukaan.                                                                           |
   * | Pvm                      | Kyllä             | Tositepäivä.                                                                                                                                                   |
   * | Tositeselite             | Kyllä             | Tositeotsikon selite                                                                                                                                           |
   * | Tili                     | Kyllä             | Kirjanpidon tili                                                                                                                                               |
   * | Alvluokka                | Ei                | Arvolisäverokoodi, esim 024                                                                                                                                    |
   * | Alvvähennysoikeus pros   | Ei                | Mikäli tositerivillä olevasta arvolisäverosta voidaan vain osa   vähentää, tässä annetaan vähennysoikeusprosentti                                              |
   * | Vientiselite             | Ei                | Tositerivin selite.                                                                                                                                            |
   * | Debet                    | (Kyllä)           | Viennille annettava debet-summa                                                                                                                                |
   * | Kredit                   | (Kyllä)           | Viennille annettava kredit-summa (positiivisena, kuten tositteen   syötössä). Joko debet- tai -kredit kentässä on oltava arvo.                                 |
   * | Tositelaji               | Ei                | Käytetty tositelaji, esimerkiksi Muistiotosite. Mikäli tietoa ei anna,   tositelajina käytetään sitä tositelajia, jonka tyypiksi on   merkitty Tositeliittymä. |
   * +---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------+
   */
  static getTampuuriExportData(e) {
    const t = [], n = ["Tositenro", "Pvm", "Tositeselite", "Tili", "Alvluokka", "Alvvähennysoikeus pros", "Vientiselite", "Debet", "Kredit", "Tositelaji"], i = [], s = (l, o) => {
      l && (i.includes(o) || (i.push(o), n.push(o)));
    };
    for (const l of e?.ledgerAccounts ?? [])
      for (const o of l?.entries ?? []) {
        const u = o?.dimension?.costCenter || o?.dimension?.dimensions?.costCenter;
        s(u, "costCenter");
        const m = o?.dimension?.projectNumber || o?.dimension?.dimensions?.projectNumber;
        if (s(m, "projectNumber"), o?.dimension?.dimensions)
          for (const [p, y] of this.getEntryDimensions(o))
            s(y, p);
      }
    t.push(n);
    const r = this.getEntryDate(e);
    for (const l of e?.ledgerAccounts ?? []) {
      const o = [];
      for (const u of l?.entries ?? []) {
        const m = [];
        for (const S of i)
          if (S === "costCenter") {
            const x = u?.dimension?.costCenter || u?.dimension?.dimensions?.costCenter || "";
            m.push(x);
          } else if (S === "projectNumber") {
            const x = u?.dimension?.projectNumber || u?.dimension?.dimensions?.projectNumber || "";
            m.push(x);
          } else
            m.push(u?.dimension?.dimensions && u?.dimension?.dimensions[S] || "");
        const p = u.vatPercent ?? 0;
        let y = o.find((S) => S.vatPercent === p && S.dimensionsId === m.join("-"));
        y == null && (y = { entries: [], vatPercent: p, dimensions: m, dimensionsId: m.join("-") }, o.push(y)), y.entries.push(u);
      }
      for (const u of o) {
        const m = [];
        m.push(null), m.push(c.asJSDate(r)), m.push("PALKAT"), m.push(l.accountNumber), m.push(u.vatPercent ? h.toFixed(1e3 + u.vatPercent * 100, 0).substring(1) : null), m.push(null), m.push(l.accountName);
        const p = h.round(u.entries.reduce((y, S) => y + (S.isDebit ? S.amount ?? 0 : -1 * (S.amount ?? 0)), 0)) ?? 0;
        p >= 0 ? (m.push(p), m.push(0)) : (m.push(0), m.push(p * -1)), m.push(null);
        for (let y = 0; y < i.length; y++)
          m.push(u.dimensions[y]);
        t.push(m);
      }
    }
    return t;
  }
  static getDigiaExportData(e) {
    const t = [], n = ["Kirjauspäivä", "Tositelaji", "Tositeno", "Kp-tili", "DebetKredit", "Rahamäärä", "Valuuttakoodi", "Valuuttakurssi", "Selite", "Alv", "Tulosyksikkö", "Seurantakohde1", "Seurantakohde2", "Seurantakohde3", "Seurantakohde4", "Seurantakohde5", "Seurantakohde6", "Seurantakohde7", "Seurantakohde8", "Seurantakohde9"];
    t.push(n);
    const i = this.getEntryDate(e);
    for (const s of e?.ledgerAccounts ?? []) {
      const r = [];
      for (const l of s?.entries ?? []) {
        const o = l.vatPercent ?? 0, u = l.dimension?.costCenter || l.dimension?.dimensions?.costCenter || "", m = l.dimension?.projectNumber || l.dimension?.dimensions?.projectNumber || l.dimension?.dimensions?.project || "";
        let p = r.find((y) => y.vatPercent == o && y.costCenter == u && y.projectNumber == m);
        p == null && (p = { vatPercent: o, costCenter: u, projectNumber: m, entries: [] }, r.push(p)), p.entries.push(l);
      }
      for (const l of r) {
        const o = [];
        o.push(c.asJSDate(i)), o.push(null), o.push(null), o.push(s.accountNumber);
        const u = h.round(l.entries.reduce((m, p) => m + (p.isDebit ? p.amount ?? 0 : -1 * (p.amount ?? 0)), 0)) ?? 0;
        o.push(u >= 0 ? "+" : "-"), o.push(u < 0 ? u * -1 : u), o.push("EUR"), o.push(1), o.push(s.accountName), o.push(l.vatPercent * 100), o.push(null), o.push(l.costCenter), o.push(l.projectNumber), o.push(null), o.push(null), o.push(null), o.push(null), o.push(null), o.push(null), o.push(null), t.push(o);
      }
    }
    return t;
  }
  static formatAsDigiaText(e, t) {
    const n = [];
    e = e.slice(1);
    for (const i of e)
      i[0] = this.padRight(i[0] ? c.format(i[0], "DDMMYY") : "", 6), i[1] = this.padRight(i[1], 4), i[2] = this.padLeft(i[2], 8), i[3] = this.padRight(i[3], 8), i[4] = this.padLeft(i[4], 1), i[5] = this.padLeft(h.toString(h.round((i[5] ?? 0) * 100, 0)), 11, "0"), i[6] = this.padRight(i[6], 3), i[7] = this.padLeft(h.toString(h.round((i[7] ?? 0) * 1e9, 0)), 17, "0"), i[8] = this.padRight(i[8], 30), i[9] = this.padRight(null, 6), i[10] = this.padRight(i[10], 3), i[11] = this.padRight(i[11], 8), i[12] = this.padRight(i[12], 8), i[13] = this.padRight(i[13], 8), i[14] = this.padRight(i[14], 8), i[15] = this.padRight(i[15], 8), i[16] = this.padRight(i[16], 8), i[17] = this.padRight(i[17], 8), i[18] = this.padRight(i[18], 8), i[19] = this.padRight(i[19], 8), n.push(i.join(""));
    return n.length > 0 && n.push(""), n.join(`\r
`);
  }
  static getVilpeDigiaExportData(e) {
    const t = (r) => r == null ? "" : `Os${r * 100}`, n = [], i = ["Kirjauspäivä", "Tositelaji", "Tositeno", "Kp-tili", "DebetKredit", "Rahamäärä", "Valuuttakoodi", "Valuuttakurssi", "Selite", "Alv", "Tulosyksikkö", "Seurantakohde1", "Projekti", "Kustannuspaikka", "Seurantakohde4", "Seurantakohde5", "Seurantakohde6", "Seurantakohde7", "Seurantakohde8", "Seurantakohde9"];
    n.push(i);
    const s = this.getEntryDate(e);
    for (const r of e?.ledgerAccounts ?? []) {
      const l = [];
      for (const o of r?.entries ?? []) {
        const u = o.vatPercent ?? void 0, m = o.dimension?.costCenter || o.dimension?.dimensions?.costCenter || "";
        let p = (o.dimension?.dimensions?.project_work || "").trim();
        p === "0" && (p = "");
        const y = o.dimension?.dimensions?.Tulosyksikkö || o.dimension?.dimensions?.tulosyksikkö || "";
        let S = l.find((x) => x.vatPercent == u && x.costCenter == m && x.vilpeProjectNumber == p && x.vilpeProfitCenter == y);
        S == null && (S = { vatPercent: u, costCenter: m, vilpeProjectNumber: p, vilpeProfitCenter: y, entries: [] }, l.push(S)), S.entries.push(o);
      }
      for (const o of l) {
        const u = [];
        u.push(c.asJSDate(s)), u.push(null), u.push(null), u.push(r.accountNumber);
        const m = h.round(o.entries.reduce((p, y) => p + (y.isDebit ? y.amount ?? 0 : -1 * (y.amount ?? 0)), 0)) ?? 0;
        u.push(m >= 0 ? "+" : "-"), u.push(m < 0 ? m * -1 : m), u.push("EUR"), u.push(1), u.push(r.accountName), u.push(t(o.vatPercent)), u.push(o.vilpeProfitCenter), u.push(null), u.push(null), u.push(o.costCenter), u.push(o.vilpeProjectNumber), u.push(null), u.push(null), u.push(null), u.push(null), u.push(null), n.push(u);
      }
    }
    return n;
  }
  static formatAsVilpeDigiaText(e, t) {
    const n = [];
    e = e.slice(1);
    for (const i of e)
      i[0] = this.padRight(i[0] ? c.format(i[0], "DDMMYY") : "", 6), i[1] = this.padRight(i[1], 4), i[2] = this.padLeft(i[2], 8), i[3] = this.padRight(i[3], 8), i[4] = this.padLeft(i[4], 1), i[5] = this.padLeft(h.toString(h.round((i[5] ?? 0) * 100, 0)), 11, "0"), i[6] = this.padRight(i[6], 3), i[7] = this.padLeft(h.toString(h.round((i[7] ?? 0) * 1e9, 0)), 17, "0"), i[8] = this.padRight(i[8], 30), i[9] = this.padRight(i[9], 6), i[10] = this.padRight(i[10], 3), i[11] = this.padRight(i[11], 8), i[12] = this.padRight(i[12], 8), i[13] = this.padRight(i[13], 8), i[14] = this.padRight(i[14], 8), i[15] = this.padRight(i[15], 8), i[16] = this.padRight(i[16], 8), i[17] = this.padRight(i[17], 8), i[18] = this.padRight(i[18], 8), i[19] = this.padRight(i[19], 8), n.push(i.join(""));
    return n.length > 0 && n.push(""), n.join(`\r
`);
  }
  static padRight(e, t, n = " ") {
    const i = e ?? "";
    return i.length > t ? i.substring(0, t) : i + n.repeat(t - i.length);
  }
  static padLeft(e, t, n = " ") {
    const i = e ?? "";
    return i.length > t ? i.substring(0, t) : n.repeat(t - i.length) + i;
  }
  static getEntryDate(e) {
    if (e.period?.end)
      return e.period.end;
    let t = "";
    for (const n of e?.ledgerAccounts ?? [])
      for (const i of n?.entries ?? [])
        i.entryDate && (!t || c.isAfter(i.entryDate, t)) && (t = i.entryDate);
    return t;
  }
  static getEntryDimensions(e) {
    return Object.entries(e?.dimension?.dimensions ?? {}).filter((t) => !(t[0] ?? "_").startsWith("_"));
  }
}
class pl {
  /** Gets the type string for an API item type enumeration. */
  static getType(e) {
    if (!e || e.trim().length < 2)
      return null;
    switch (e) {
      case ka.Calculation:
      case ka.CalculationPaid:
        return "Calculation";
      case ka.EarningsPaymentReport:
        return "EarningsPayment";
      case ka.PayerSummaryReport:
        return "PayerSummary";
      case ka.ListItems:
        return "ApiListItem[]";
      case ka.Undefined:
        return null;
      default:
        return e.substring(0, 1).toUpperCase() + e.substring(1);
    }
  }
}
class hl {
  /**
   * Adds Calculation Results together and returns a new CalculationResult
   * @param calculationResults CalculationResults to add.
   * @returns A new CalculationResult.
   */
  static add(e) {
    return e == null || e.length === 0 ? this.addResults(null, null) : e.reduce((t, n) => this.addResults(t, n), this.safeObj(null));
  }
  /**
   * Calculates the difference between two results and returns a new CalculationResult
   * @param original - The original result.
   * @param modified - The modified result.
   * @returns The difference between the result sets.
   */
  static diff(e, t) {
    return this.addResults(t, e, !0);
  }
  static addResults(e, t, n = !1) {
    return e = this.safeObj(e), t = this.safeObj(t), {
      totals: this.addTotals(e?.totals, t?.totals, n),
      workerCalc: this.addWorkerCalc(e?.workerCalc, t?.workerCalc, n),
      employerCalc: this.addEmployerCalc(e?.employerCalc, t?.employerCalc, n),
      rows: n ? this.safeArr(null) : this.safeArr(e?.rows).concat(this.safeArr(t?.rows)),
      responsibilities: this.safeObj(e?.responsibilities),
      irRows: n ? this.safeArr(null) : this.safeArr(e?.irRows).concat(this.safeArr(t?.irRows))
    };
  }
  static addTotals(e, t, n = !1) {
    return e = this.safeObj(e), t = this.safeObj(t), {
      pension: this.safeNum(e?.pension) + this.safeNum(t?.pension, n),
      total: this.safeNum(e?.total) + this.safeNum(t?.total, n),
      totalBaseSalary: this.safeNum(e?.totalBaseSalary) + this.safeNum(t?.totalBaseSalary, n),
      totalExpenses: this.safeNum(e?.totalExpenses) + this.safeNum(t?.totalExpenses, n),
      totalGrossSalary: this.safeNum(e?.totalGrossSalary) + this.safeNum(t?.totalGrossSalary, n),
      totalSocialSecurityBase: this.safeNum(e?.totalSocialSecurityBase) + this.safeNum(t?.totalSocialSecurityBase, n),
      totalTaxable: this.safeNum(e?.totalTaxable) + this.safeNum(t?.totalTaxable, n),
      unemployment: this.safeNum(e?.unemployment) + this.safeNum(t?.unemployment, n),
      totalAccidentInsuranceBase: this.safeNum(e?.totalAccidentInsuranceBase) + this.safeNum(t?.totalAccidentInsuranceBase, n),
      totalHealthInsuranceBase: this.safeNum(e?.totalHealthInsuranceBase) + this.safeNum(t?.totalHealthInsuranceBase, n),
      totalPayable: this.safeNum(e?.totalPayable) + this.safeNum(t?.totalPayable, n),
      totalPensionInsuranceBase: this.safeNum(e?.totalPensionInsuranceBase) + this.safeNum(t?.totalPensionInsuranceBase, n),
      totalUnemploymentInsuranceBase: this.safeNum(e?.totalUnemploymentInsuranceBase) + this.safeNum(t?.totalUnemploymentInsuranceBase, n)
    };
  }
  static addWorkerCalc(e, t, n = !1) {
    return e = this.safeObj(e), t = this.safeObj(t), {
      benefits: this.safeNum(e?.benefits) + this.safeNum(t?.benefits, n),
      deductions: this.safeNum(e?.deductions) + this.safeNum(t?.deductions, n),
      fullTax: this.safeNum(e?.fullTax) + this.safeNum(t?.fullTax, n),
      fullOtherDeductions: this.safeNum(e?.fullOtherDeductions) + this.safeNum(t?.fullOtherDeductions, n),
      fullPension: this.safeNum(e?.fullPension) + this.safeNum(t?.fullPension, n),
      fullPrepaidExpenses: this.safeNum(e?.fullPrepaidExpenses) + this.safeNum(t?.fullPrepaidExpenses, n),
      fullSalaryAdvance: this.safeNum(e?.fullSalaryAdvance) + this.safeNum(t?.fullSalaryAdvance, n),
      fullUnemploymentInsurance: this.safeNum(e?.fullUnemploymentInsurance) + this.safeNum(t?.fullUnemploymentInsurance, n),
      fullUnionPayment: this.safeNum(e?.fullUnionPayment) + this.safeNum(t?.fullUnionPayment, n),
      otherDeductions: this.safeNum(e?.otherDeductions) + this.safeNum(t?.otherDeductions, n),
      pension: this.safeNum(e?.pension) + this.safeNum(t?.pension, n),
      prepaidExpenses: this.safeNum(e?.prepaidExpenses) + this.safeNum(t?.prepaidExpenses, n),
      foreclosure: this.safeNum(e?.foreclosure) + this.safeNum(t?.foreclosure, n),
      salaryAdvance: this.safeNum(e?.salaryAdvance) + this.safeNum(t?.salaryAdvance, n),
      salaryAfterTax: this.safeNum(e?.salaryAfterTax) + this.safeNum(t?.salaryAfterTax, n),
      salaryAfterTaxAndForeclosure: this.safeNum(e?.salaryAfterTaxAndForeclosure) + this.safeNum(t?.salaryAfterTaxAndForeclosure, n),
      salaryPayment: this.safeNum(e?.salaryPayment) + this.safeNum(t?.salaryPayment, n),
      tax: this.safeNum(e?.tax) + this.safeNum(t?.tax, n),
      totalWorkerPayment: this.safeNum(e?.totalWorkerPayment) + this.safeNum(t?.totalWorkerPayment, n),
      unemploymentInsurance: this.safeNum(e?.unemploymentInsurance) + this.safeNum(t?.unemploymentInsurance, n),
      unionPayment: this.safeNum(e?.unionPayment) + this.safeNum(t?.unionPayment, n),
      workerSideCosts: this.safeNum(e?.workerSideCosts) + this.safeNum(t?.workerSideCosts, n),
      totalWorkerPaymentLegacy: this.safeNum(e?.totalWorkerPaymentLegacy) + this.safeNum(t?.totalWorkerPaymentLegacy, n)
    };
  }
  static addEmployerCalc(e, t, n = !1) {
    return e = this.safeObj(e), t = this.safeObj(t), {
      allSideCosts: this.safeNum(e?.allSideCosts) + this.safeNum(t?.allSideCosts, n),
      deductionPensionSelfPayment: this.safeNum(e?.deductionPensionSelfPayment) + this.safeNum(t?.deductionPensionSelfPayment, n),
      deductionUnemploymentSelfPayment: this.safeNum(e?.deductionUnemploymentSelfPayment) + this.safeNum(t?.deductionUnemploymentSelfPayment, n),
      deductionSalaryAdvance: this.safeNum(e?.deductionSalaryAdvance) + this.safeNum(t?.deductionSalaryAdvance, n),
      deductionForeclosure: this.safeNum(e?.deductionForeclosure) + this.safeNum(t?.deductionForeclosure, n),
      foreclosureByPalkkaus: this.safeNum(e?.foreclosureByPalkkaus) + this.safeNum(t?.foreclosureByPalkkaus, n),
      deductionUnionPayment: this.safeNum(e?.deductionUnionPayment) + this.safeNum(t?.deductionUnionPayment, n),
      deductionOtherDeductions: this.safeNum(e?.deductionOtherDeductions) + this.safeNum(t?.deductionOtherDeductions, n),
      deductionTaxAndSocialSecuritySelfPayment: this.safeNum(e?.deductionTaxAndSocialSecuritySelfPayment) + this.safeNum(t?.deductionTaxAndSocialSecuritySelfPayment, n),
      deductionWorkerSelfPayment: this.safeNum(e?.deductionWorkerSelfPayment) + this.safeNum(t?.deductionWorkerSelfPayment, n),
      finalCost: this.safeNum(e?.finalCost) + this.safeNum(t?.finalCost, n),
      householdDeduction: this.safeNum(e?.householdDeduction) + this.safeNum(t?.householdDeduction, n),
      mandatorySideCosts: this.safeNum(e?.mandatorySideCosts) + this.safeNum(t?.mandatorySideCosts, n),
      palkkaus: this.safeNum(e?.palkkaus) + this.safeNum(t?.palkkaus, n),
      service: this.safeNum(e?.service) + this.safeNum(t?.service, n),
      pension: this.safeNum(e?.pension) + this.safeNum(t?.pension, n),
      socialSecurity: this.safeNum(e?.socialSecurity) + this.safeNum(t?.socialSecurity, n),
      totalDeductions: this.safeNum(e?.totalDeductions) + this.safeNum(t?.totalDeductions, n),
      totalPayment: this.safeNum(e?.totalPayment) + this.safeNum(t?.totalPayment, n),
      totalSalaryCost: this.safeNum(e?.totalSalaryCost) + this.safeNum(t?.totalSalaryCost, n),
      unemployment: this.safeNum(e?.unemployment) + this.safeNum(t?.unemployment, n),
      totalPaymentLegacy: this.safeNum(e?.totalPaymentLegacy) + this.safeNum(t?.totalPaymentLegacy, n)
    };
  }
  static safeNum(e, t = !1) {
    const n = e ?? 0;
    return t ? h.round(n * -1) : n;
  }
  static safeArr(e) {
    return fe.copy(e ?? []);
  }
  static safeObj(e) {
    return fe.copy(e ?? {});
  }
}
class yl {
  /**
   * Gets a new blank Contact with default values, suitable for UI binding.
   */
  static getBlank() {
    return {
      avatar: {
        entityType: null,
        lastName: null,
        pictureType: We.Icon,
        isReadOnly: !1
      },
      contact: {
        countryCode: "fi"
      },
      isSelf: !1,
      isSigned: !1,
      contractPartyType: Ka.CustomContact,
      isEmployer: !1
    };
  }
  /** Converts a WorkerAccount object to a ContractParty object. */
  static getFromWorker(e) {
    return {
      avatar: e.avatar,
      contact: e.contact,
      contractPartyType: Ka.CustomContact,
      iban: e.ibanNumber,
      id: e.id,
      isEmployer: !1,
      isSelf: !1,
      isSigned: !1,
      officialId: e.officialPersonId
    };
  }
  /** Gets sample contacts for demonstration user interfaces. */
  static getSampleContacts() {
    return [
      {
        id: "example-default",
        avatar: {
          entityType: me.Person,
          firstName: "Erkki",
          lastName: "Esimerkki",
          displayName: "Erkki Esimerkki",
          sortableName: "Esimerkki, Erkki",
          pictureType: We.Icon,
          color: "lime",
          initials: "EE",
          url: null,
          description: "Esimerkkityöntekijä, oletus: 18-52 vuotta, veroprosentti 25%.",
          id: "example-default"
        },
        contact: {
          email: "erkki@esimerkki.fi",
          telephone: "555-5555555",
          street: "Mallikatu 3",
          postalCode: "333333",
          city: "Jokupaikka",
          countryCode: "fi"
        }
      },
      {
        id: "example-17",
        avatar: {
          entityType: me.Person,
          firstName: "Laura",
          lastName: "Lukiolainen",
          displayName: "Laura Lukiolainen",
          sortableName: "Lukiolainen, Laura",
          pictureType: We.Icon,
          color: "pink",
          initials: "LL",
          url: null,
          description: "Esimerkki nuoresta työntekijästä: 17 vuotias, veroprosentti 0.",
          id: "example-17"
        },
        contact: {
          email: "laura@esimerkki.fi",
          telephone: "222-2222222",
          street: "Lukiolaisenkatu 5",
          postalCode: "222222",
          city: "Jokupaikka",
          countryCode: "fi"
        }
      },
      {
        id: "example-company",
        avatar: {
          entityType: me.Company,
          firstName: "Mallitakomo Oy",
          lastName: null,
          displayName: "Mallitakomo Oy",
          sortableName: "Mallitakomo Oy",
          pictureType: We.Icon,
          color: "red",
          initials: "MT",
          url: null,
          description: "Esimerkkiyritys Tampereelta",
          id: "example-company"
        },
        contact: {
          email: "takomo@esimerkki.fi",
          telephone: "888-88888888",
          street: "Takomokatu 8",
          postalCode: "8888888",
          city: "Tampere",
          countryCode: "fi"
        }
      },
      {
        id: "example-pensioner",
        avatar: {
          entityType: me.Person,
          firstName: "Tanja",
          lastName: "Eläkeläinen",
          displayName: "Tanja Eläkeläinen",
          sortableName: "Eläkeläinen, Tanja",
          pictureType: We.Icon,
          color: "blue",
          initials: "TE",
          url: null,
          description: "Esimerkki eläkeläisestä: 65-67 vuotias, veroprosentti 10%.",
          id: "example-pensioner"
        },
        contact: {
          email: "tanja@esimerkki.fi",
          telephone: "777-7777777",
          street: "Eläkeläisenkatu 7",
          postalCode: "111111",
          city: "Jokupaikka",
          countryCode: "fi"
        }
      }
    ];
  }
}
class st {
  /** Gets a new blank item as bases for UI binding. */
  static getBlank() {
    return {
      info: {
        irIncomeEarnerTypes: [],
        salaryPaymentMethod: nt.BankAccount
      },
      identity: {
        language: Ee.Default
      },
      contacts: [
        {
          type: fa.Default,
          country: Ua.Fi
        }
      ],
      work: {
        salaryDefaults: []
      },
      personalInfo: {
        avatar: {}
      },
      holidays: {},
      usecase: {
        data: {}
      },
      international: {
        socialSecurityExceptions: [],
        taxAtSource: {}
      }
    };
  }
  /**
   * Gets a description text for an Employment.
   * @param account The account info
   * @param type Type of employment relation
   * @param pensionCalculation Type of pension calculation.
   */
  static getDescription(e, t, n) {
    if (!e || (t || B.Undefined) == B.Undefined)
      return e?.email || "-";
    let i = H.getEnumLabel("EmploymentRelationType", t);
    switch (t) {
      case B.Entrepreneur:
        n === R.Entrepreneur ? i += " (" + d.get("SALAXY.ENUM.PensionCalculation.entrepreneur.label") + ")" : n === R.PartialOwner ? i += " (" + d.get("SALAXY.ENUM.PensionCalculation.partialOwner.label") + ")" : n === R.SmallEntrepreneur ? i += " (" + d.get("SALAXY.ENUM.PensionCalculation.smallEntrepreneur.label") + ")" : n === R.Employee && (i += " (" + d.get("SALAXY.ENUM.PensionCalculation.employee.label") + ")");
        break;
      case B.Farmer:
        n === R.Farmer ? i += " (" + d.get("SALAXY.ENUM.PensionCalculation.farmer.label") + ")" : n === R.SmallFarmer ? i += " (" + d.get("SALAXY.ENUM.PensionCalculation.smallFarmer.label") + ")" : n === R.Employee && (i += " (" + d.get("SALAXY.ENUM.PensionCalculation.employee.label") + ")");
        break;
    }
    return i;
  }
  /**
   * Gets a descriptive text on whether the employment is active or not.
   * @param employment Employment relation to get the text for.
   * @returns A text that describes whether the employment is active or not with the dates (start and end).
   */
  static getActiveText(e) {
    if (!e)
      return;
    const t = c.getToday(), n = this.isListItem(e) ? e.data?.startDate : e.info?.startDate, i = this.isListItem(e) ? e.data?.endDate : e.info?.endDate;
    return !n && !i ? "Aktiivinen, ei päivämääriä" : `${(!n || c.isSameOrBefore(n, t)) && (!i || c.isSameOrAfter(i, t)) ? "Aktiiviinen" : "Ei aktiivinen"}: ${c.getFormattedRange(n, i)}`;
  }
  /**
   * Type guard for EmploymentListItem (as opposed to Employment) .
   * @param employment An item that mey be Employment or EmploymentListItem (or undefined / null).
   * @returns True if the item is an EmploymentListItem (based on data property).
   */
  static isListItem(e) {
    return !!e?.data;
  }
  /**
   * Gets an AccountInIndex object based on WorkerAccount.
   * This can be used in employmetn logic methods (e.g. getDescription()) if the source is WorkerAccount and not Employment.
   */
  static getAccountInIndex(e) {
    if (e?.avatar)
      return {
        avatar: e.avatar,
        email: e.contact?.email,
        ibanNumber: e.ibanNumber,
        officialId: e.officialPersonId,
        telephone: e.contact?.telephone
      };
  }
  /**
   * Returns options object for PensionCalculation selection by employment relation type.
   * @param employmentRelationType Employment relation type of the worker.
   */
  static getPensionCalculationOptions(e, t) {
    const n = [];
    switch (e) {
      case B.EmployedByStateEmploymentFund:
        n.push(R.Employee);
        break;
      case B.PerformingArtist:
        n.push(R.Employee, R.Compensation);
        break;
      case B.Entrepreneur:
        n.push(R.Entrepreneur, R.SmallEntrepreneur, R.PartialOwner, R.Employee);
        break;
      case B.Farmer:
        n.push(R.Farmer, R.SmallFarmer, R.Employee);
        break;
      case B.Compensation:
        n.push(R.Compensation);
        break;
      case B.BoardMember:
        n.push(R.BoardRemuneration);
        break;
      case B.Athlete:
        n.push(R.Athlete);
        break;
      case B.ForeignWorker:
      case B.WorkingAbroad:
        n.push(R.Employee, R.Compensation, R.Entrepreneur);
        break;
      case B.HourlySalary:
      case B.MonthlySalary:
      case B.Salary:
      default:
        n.push(R.Employee);
        break;
    }
    return n.some((i) => i == R.Employee) && t.some((i) => i.company?.startsWith("keva")) && n.push(R.PublicSector), n.map((i) => {
      const s = H.getEnumLabel("PensionCalculation", i), r = H.getEnumDescr("PensionCalculation", i);
      return { value: i, text: s, title: r && r !== i ? r : void 0 };
    });
  }
  /**
   * Sets the income earner types accordingly based on employment type.
   * Called when the type of employment changes
   * @param model Employment relation to update.
   */
  static resetModelFromType(e) {
    e.work ?? (e.work = {}), e.info ?? (e.info = {}), e.work.description = void 0, e.work.occupationCode = void 0, e.info.taxcard = xa.Auto;
    const t = [];
    switch (e.info.type) {
      case B.EmployedByStateEmploymentFund:
        e.info.pensionCalculation = R.Employee, t.push(Ze.EmployedByStateEmploymentFund);
        break;
      case B.PerformingArtist:
        e.info.pensionCalculation = R.Employee, t.push(Ze.PerformingArtist);
        break;
      case B.Entrepreneur:
        e.info.pensionCalculation = R.Entrepreneur;
        break;
      case B.Farmer:
        e.info.pensionCalculation = R.Farmer;
        break;
      case B.Compensation:
        e.info.pensionCalculation = R.Compensation;
        break;
      case B.BoardMember:
        e.info.pensionCalculation = R.BoardRemuneration, e.work.description = d.get("SALAXY.ENUM.EmploymentRelationType.boardMember.label");
        break;
      case B.Athlete:
        e.info.pensionCalculation = R.Athlete, e.work.occupationCode = "34210", e.work.description = d.get("SALAXY.ENUM.EmploymentRelationType.athlete.label"), t.push(Ze.Athlete);
        break;
      case B.ForeignWorker:
      case B.WorkingAbroad:
        e.info.pensionCalculation = R.Employee, e.info.taxcard = xa.TaxAtSource;
        break;
      case B.MonthlySalary:
      case B.HourlySalary:
      case B.Salary:
      default:
        e.info.pensionCalculation = R.Employee;
        break;
    }
    e.info.irIncomeEarnerTypes = t;
  }
  /**
   * Sets the income earner types accordingly based on pension calculation.
   * Called when the pension calculation changes.
   * @param model Employment relation to update.
   */
  static resetModelFromPensionCalculation(e) {
    const t = e.info?.irIncomeEarnerTypes?.filter(
      (n) => n != Ze.EntrepreneurOrFarmerNoPensionRequired && n != Ze.PartialOwner
    ) ?? [];
    switch (e.info?.pensionCalculation) {
      case R.PartialOwner:
        t.push(Ze.PartialOwner);
        break;
      case R.SmallEntrepreneur:
      case R.SmallFarmer:
        t.push(Ze.EntrepreneurOrFarmerNoPensionRequired);
        break;
    }
    e.info ?? (e.info = {}), e.info.irIncomeEarnerTypes = t;
  }
  /**
   * Sets the salary default rows (rows that are used when creating new claculations)
   * based on the employment type.
   * @param type Employment type
   * @param work Work description that contains the salary defaults (will be reset).
   */
  static setSalaryDefaultRows(e, t) {
    t.salaryDefaults = [];
    const n = {
      rowIndex: 0,
      rowType: null,
      count: null,
      price: null,
      message: null
    };
    switch (n.message = null, e) {
      case B.MonthlySalary:
        n.rowType = k.MonthlySalary, n.count = 1, n.price = 0, n.unit = null;
        break;
      case B.HourlySalary:
        n.rowType = k.HourlySalary, n.count = 1, n.price = 0, n.unit = G.Hours;
        break;
      case B.Salary:
        n.rowType = k.Salary, n.count = 1, n.price = 0, n.unit = null;
        break;
      case B.EmployedByStateEmploymentFund:
        n.rowType = k.HourlySalary, n.count = 1, n.price = 0, n.unit = G.Hours;
        break;
      case B.PerformingArtist:
        n.rowType = k.Salary, n.count = 1, n.price = 0, n.unit = null;
        break;
      case B.Entrepreneur:
      case B.Farmer:
        break;
      case B.Compensation:
        n.rowType = k.Compensation, n.count = 1, n.price = 0, n.unit = null;
        break;
      case B.BoardMember:
        n.rowType = k.Board, n.message = d.get("SALAXY.ENUM.CalculationRowType.board.label"), n.count = 1, n.price = 0, n.unit = null;
        break;
      case B.Athlete:
        n.rowType = k.Salary, n.message = d.get("SALAXY.ENUM.EmploymentRelationType.athlete.salaryRowMessage"), n.count = 1, n.price = 0, n.unit = null;
        break;
    }
    n.rowType != null && t.salaryDefaults.push(n);
  }
  /**
   * Gets the social security pensions model (available options) for the current selections.
   * @param settings Account settings in the session
   * @param type Type of employment relation selected
   * @param socialSecurity Whether the person is in Finnish or foregion social security - or mixed
   * @param pensionCalculation Type of Pension calculation: employee/TyEL or others (YEL, farmer etc.)
   * @param pensionCompany Pension company (if several) that is selected.
   * @param insuranceCompany Insurance company (if several) that is selected.
   * @param socSecExceptions The selected social security exceptions (not subject to)
   */
  static getSocialSecurityModel(e, t, n, i, s, r, l) {
    const o = this.getValidContractNumbers(r, e.insuranceContracts ?? []).map((I) => ({ value: I, text: I }));
    let u = this.getValidCompanies(e.pensionContracts ?? []).map((I) => {
      const se = H.getEnumLabel("PensionCompany", I), q = H.getEnumDescr("PensionCompany", I);
      return { value: I, text: se, title: q && q !== I ? q : void 0 };
    });
    u = i == R.PublicSector ? u.filter((I) => I.value.startsWith("keva")) : u.filter((I) => !I.value.startsWith("keva"));
    const m = this.getValidContractNumbers(s, e.pensionContracts ?? []).map((I) => ({ value: I, text: I })), p = this.getValidCompanies(e.insuranceContracts ?? []).map((I) => {
      const se = H.getEnumLabel("InsuranceCompany", I), q = H.getEnumDescr("InsuranceCompany", I);
      return { value: I, text: se, title: q && q !== I ? q : void 0 };
    }), y = n != "foreign", S = y && l.indexOf(Wa.NotSubjectToEarningsRelatedPensionInsurance) < 0 ? st.getPensionCalculationOptions(t, e.pensionContracts ?? []) : null, x = (S && (i == R.Employee || i == R.PublicSector)) ?? !1, v = x && this.getValidContracts(e.pensionContracts ?? []).length > 1, T = y && l.indexOf(Wa.NotSubjectToAccidentAndOccupationalDiseaseInsurance) < 0, L = T && this.getValidContracts(e.insuranceContracts ?? []).length > 1, K = (I) => [{ value: "", text: d.get("SALAXY.UI_Terms.notChosen"), title: void 0 }, ...I];
    return {
      pensionCalculationOptions: S,
      showPension: x,
      pensionCompanies: K(u),
      pensionContractNumbers: x && m.length > 1 ? K(m) : null,
      showPensionCompanySelection: v,
      showInsurance: T,
      insuranceCompanies: K(p),
      insuranceContractNumbers: T && o.length > 1 ? K(o) : null,
      showInsuranceCompanySelection: L,
      isInternational: t == B.ForeignWorker || t == B.WorkingAbroad,
      showSocialSecurity: y,
      employmentRegCodes: K(this.getEmploymentRegCodeOptions(s))
    };
  }
  /**
   * Gets the companies that are valid for today (insurance or pension companies).
   * @param contracts Collection of contracts
   * @returns Those companies (id's) that have contracts that are valid today.
   */
  static getValidCompanies(e) {
    const t = this.getValidContracts(e), n = [];
    return t.forEach((i) => {
      i.company && n.indexOf(i.company) === -1 && n.push(i.company);
    }), n;
  }
  /**
   * Gets the contract numbers (for a sepcific insurance company) that are valid for today.
   * @param company Insurance company for which the numers are fetched.
   * @param contracts Collection of contracts
   * @returns Those contract numbers that are valid for today (for the given company).
   */
  static getValidContractNumbers(e, t) {
    return e ? this.getValidContracts(t).filter((n) => n.company == e).map((n) => n.contractNumber).filter((n) => n != null) : [];
  }
  /**
   * Gets the contracts that are valid for today.
   * @param contracts Collection of contracts
   * @returns Those contracts that are valid for today.
   */
  static getValidContracts(e) {
    const t = c.getToday();
    return (e ?? []).filter(
      (i) => (!i.startDate || c.isSameOrBefore(i.startDate, t)) && (!i.endDate || c.isSameOrAfter(i.endDate, t))
    );
  }
  /**
   * Gets a contact of specific type.
   * @param model Employment relation to get the contact from.
   * @param type Type of contact to get. Use null to fetch any contact type (creates Default if requested).
   * @param createIfNotExists If true creates the contact of given type if one does not exist.
   * @returns Contact of given type or undefined if one is not found AND createIfNotExists is false.
   */
  static getContact(e, t, n = !0) {
    if (!e)
      return;
    e.contacts || (e.contacts = []);
    let i = e.contacts.find((s) => !t || s.type == t);
    return !i && n && (t = t || fa.Default, i = {
      type: t,
      country: t == fa.Default ? Ua.Fi : null
    }, e.contacts.push(i)), i;
  }
  /**
   * Populates given user with test data.
   * Sets values only if the firstName and lastName have been given.
   * @param employment - Employment relation to populate with test data.
   * @param useRealPersonaIdRange - If true, uses the real personal id range instead of artificial ID range ("keinohetu": last 3 numbers start with 9).
   */
  static populateWithTestData(e, t = !1) {
    if (!e?.identity?.firstName || !e.identity.lastName)
      return;
    const n = this.getContact(e, fa.Default, !0) ?? {};
    n.email = this.cleanupEmailPart(e.identity.firstName) + "." + this.cleanupEmailPart(e.identity.lastName) + "@palkkaus.fi", n.telephone = "040 " + (1e6 + Math.round(Math.random() * 8999999)).toString();
    const i = (/* @__PURE__ */ new Date()).getFullYear() - (20 + Math.round(Math.random() * 40)), s = new Date(new Date(i, 0, 1).getTime() + Math.round(Math.random() * (new Date(i + 1, 11, 31).getTime() - new Date(i, 0, 1).getTime()))), r = i >= 2e3 ? "A" : "-", l = t ? Math.round(Math.random() * 899) : 900 + Math.round(Math.random() * 99), o = "0123456789ABCDEFHJKLMNPRSTUVWXY", u = c.format(s, "DDMMYY"), m = o[parseInt(u + l.toString(), 10) % 31];
    e.identity.personalId = u + r + l.toString() + m, e.info ?? (e.info = {}), e.info.ibanNumber = Ea.getDummyIban(), t || (n.city = "PALKKALA", n.postalCode = "01337", n.street = "Ansionkatu 1");
  }
  /**
   * Returns true if the personal ID is other identifier than Finnish Personal Identification Number (keinohetu).
   * @param ssn Personal ID to check.
   */
  static isPersonalIdOther(e) {
    return /^.{7}[9]/.test((e || "").trim());
  }
  /**
   * Returns valid employment reg codes for the selected pensions company.
   * @param pensionCompany - Keva pension company.
   * @returns Options for the employment reg codes.
   */
  static getEmploymentRegCodeOptions(e) {
    return Ur.filter((t) => t.pensionCompany === e).map((t) => ({ value: t.code, text: d.getLanguage() === Ee.Sv ? t.labelSv : t.labelFi }));
  }
  static cleanupEmailPart(e) {
    return e && (e = e.toLowerCase(), e = e.normalize("NFD").replace(/[\u0300-\u036f]/g, ""), e = e.replace(/[^a-z]+/g, ""), e);
  }
}
class le {
  /**
   * Gets the multiplier that is used in Average Daily Salary calculation (keskipäiväpalkka).
   * @param holidays Number of holidays for the year.
   */
  static getDailySalaryMultiplier(e) {
    const t = [0, 0, 1.8, 2.7, 3.6, 4.5, 5.4, 6.3, 7.2, 8.1, 9, 9.9, 10.8, 11.8, 12.7, 13.6, 14.5, 15.5, 16.4, 17.4, 18.3, 19.3, 20.3, 21.3, 22.2, 23.2, 24.1, 25, 25.9, 26.9, 27.8];
    return e > 30 ? t[30] + (e - 30) * 0.9 : t[e];
  }
  /**
   * Gets a new blank holiday year.
   * @param year Holiday accrual year (e.g. 2019) or 0 for current year and -1 for previous year (from -10 to 10).
   * Current year is always from 1.4. until 31.3. e.g. year 2019 is 1.4.2019 until 31.3.2020.
   * The main part of the holidays from holiday accrual year 2019 are kept on summer 2020.
   */
  static getBlank(e = 0) {
    e < 11 && (e = (c.getMonth(c.getToday()) < 4 ? c.getYear("today") - 1 : c.getYear("today")) + e);
    const t = {
      year: e,
      workerId: null,
      employmentId: "",
      period: {
        start: `${e}-04-01`,
        end: `${e + 1}-03-31`,
        daysCount: 0
      },
      accrual: {
        months: []
      },
      leaves: {
        paid: [],
        planned: []
      },
      spec: {
        code: Ha.Undefined
      }
    };
    return t.period.daysCount = c.getDuration(t.period.start, t.period.end).asDays(), t;
  }
  /** Gets the salary payable type or default type if both are possible. */
  static getSalaryPayableType(e) {
    return {
      unpaidLeave: "unpaid",
      personalReason: "defaultUnpaid",
      illness: "defaultPaid",
      partTimeSickLeave: "defaultUnpaid",
      parentalLeave: "defaultUnpaid",
      specialMaternityLeave: "defaultUnpaid",
      rehabilitation: "defaultUnpaid",
      childIllness: "defaultPaid",
      partTimeChildCareLeave: "defaultUnpaid",
      training: "defaultPaid",
      jobAlternationLeave: "unpaid",
      studyLeave: "unpaid",
      industrialAction: "unpaid",
      interruptionInWorkProvision: "unpaid",
      leaveOfAbsence: "defaultUnpaid",
      militaryRefresherTraining: "defaultUnpaid",
      militaryService: "unpaid",
      layOff: "unpaid",
      childCareLeave: "unpaid",
      midWeekHoliday: "paid",
      accruedHoliday: "paid",
      occupationalAccident: "paid",
      annualLeave: "paid",
      partTimeAbsenceDueToRehabilitation: "paid",
      other: "defaultUnpaid"
    }[e];
  }
  /** Gets the needed logic for Absences Period Edit dialog */
  static getAbsencesEditDialogLogic() {
    const e = (t) => {
      t.isHolidayAccrual = t.isPaid;
    };
    return {
      canSelectIsPaid: (t) => {
        if (!t.causeCode)
          return !1;
        const n = le.getSalaryPayableType(t.causeCode);
        return n === "defaultPaid" || n === "defaultUnpaid";
      },
      updateIsPaid: (t) => {
        switch (le.getSalaryPayableType(t.causeCode)) {
          case "defaultPaid":
          case "paid":
            t.isPaid = !0, e(t);
            break;
          case "defaultUnpaid":
          case "unpaid":
            t.isPaid = !1, e(t);
            break;
        }
      },
      updateIsHolidayAccrual: e,
      updatePeriodDays: (t) => {
        const n = t?.period;
        n?.start && n?.end && n.start > n.end && (n.end = n.start), n?.start && n?.end && (n.days ? (n.days = c.getWorkdays(n.start, n.end), n.daysCount = n.days.length) : n.daysCount = c.getWorkdays(n.start, n.end).length);
      },
      setDaysSelection: (t) => {
        const n = t?.period ?? {};
        n.days = c.getWorkdays(n.start ?? "", n.end ?? ""), n.daysCount = n.days.length;
      }
    };
  }
  /** Gets different total days calculation of planned leaves. */
  static getPlannedLeavesCount(e, t = "all") {
    const n = e.year, i = e.leaves?.planned ?? [];
    switch (t) {
      case "all":
        return Be.sum(i, (s) => s.period?.daysCount ?? 0);
      case "summer":
        return Be.sum(i.filter((s) => s.period?.start && s.period.start < `${n}-10-1`), (s) => s.period?.daysCount ?? 0);
      case "winter":
        return Be.sum(i.filter((s) => s.period?.start && s.period.start >= `${n}-10-1`), (s) => s.period?.daysCount ?? 0);
      case "holidaysSaldoStart":
        return Be.sum(e.accrual?.months ?? [], (s) => s.daysAccrued ?? 0) + (e.accrual?.startSaldo ?? 0);
      case "holidaysSaldoEnd":
        return (le.getPlannedLeavesCount(e, "holidaysSaldoStart") ?? 0) - (le.getPlannedLeavesCount(e, "all") ?? 0);
    }
  }
  /** Gets a calculated total or saldo row for paid holiday pays */
  static getPaidHolidaysCalculation(e, t = "total") {
    switch (t) {
      case "total":
        return {
          avatar: le.getPaidCalculationAvatar("total", void 0),
          holidayBonus: null,
          holidayCompensation: Be.sum(e.leaves?.paid?.filter((n) => !n.isDisabled && (n.kind == Ce.PaidCalc || n.kind == Ce.ManualCompensation)) ?? [], (n) => n.holidayCompensation ?? 0),
          holidayDays: Be.sum(e.leaves?.paid?.filter(
            (n) => n.kind == Ce.PaidCalc && ((n.holidayCompensation ?? 0) > 0 || (n.holidaySalary ?? 0) > 0) && !n.isDisabled || (n.kind == Ce.ManualSalary || n.kind == Ce.ManualCompensation) && !n.isDisabled
          ) ?? [], (n) => n.holidayDays ?? 0),
          holidaySalary: Be.sum(e.leaves?.paid?.filter((n) => !n.isDisabled && (n.kind == Ce.PaidCalc || n.kind == Ce.ManualSalary)) ?? [], (n) => n.holidaySalary ?? 0)
        };
      case "startSaldo":
        return {
          avatar: le.getPaidCalculationAvatar("startSaldo", void 0),
          holidayBonus: null,
          holidayDays: e.accrual?.endSaldo ?? 0,
          holidayCompensation: null,
          holidaySalary: null
        };
      case "endSaldo": {
        const n = le.getPaidHolidaysCalculation(e, "total"), i = le.getPaidHolidaysCalculation(e, "startSaldo");
        return {
          avatar: le.getPaidCalculationAvatar("endSaldo", void 0),
          holidayBonus: null,
          holidayCompensation: null,
          holidayDays: (i?.holidayDays ?? 0) - (n?.holidayDays ?? 0),
          holidaySalary: null
        };
      }
    }
  }
  /** Gets a calculated total or saldo row for paid bonus */
  static getPaidBonusCalculation(e, t = "total") {
    switch (t) {
      case "total":
        return {
          avatar: le.getPaidBonusAvatar("total", void 0),
          holidayBonus: Be.sum(e.leaves?.paid?.filter((n) => !n.isDisabled && (n.kind == Ce.PaidCalc || n.kind == Ce.ManualBonus)) ?? [], (n) => n.holidayBonus ?? 0),
          holidayCompensation: null,
          holidayDays: Be.sum(e.leaves?.paid?.filter(
            (n) => n.kind == Ce.PaidCalc && (n.holidayBonus ?? 0) > 0 && !n.isDisabled || n.kind == Ce.ManualBonus && !n.isDisabled
          ) ?? [], (n) => n.holidayDays ?? 0),
          holidaySalary: null
        };
      case "startSaldo":
        return {
          avatar: le.getPaidBonusAvatar("startSaldo", void 0),
          holidayBonus: null,
          holidayDays: e.accrual?.endSaldo ?? 0,
          holidayCompensation: null,
          holidaySalary: null
        };
      case "endSaldo": {
        const n = le.getPaidBonusCalculation(e, "total"), i = le.getPaidBonusCalculation(e, "startSaldo");
        return {
          avatar: le.getPaidBonusAvatar("endSaldo", void 0),
          holidayBonus: null,
          holidayCompensation: null,
          holidayDays: (i?.holidayDays ?? 0) - (n?.holidayDays ?? 0),
          holidaySalary: null
        };
      }
    }
  }
  /** Gets a display avatar for a paid calculation */
  static getPaidCalculationAvatar(e = "row", t) {
    switch (e) {
      case "row":
        return {
          displayName: `${d.get("SALAXY.CORE.HolidaysLogic.paid")} ${c.getFormattedDate(t?.date)}`,
          description: `${d.get("SALAXY.CORE.HolidaysLogic.salaryPeriod")} ${c.getFormattedRange(t?.period?.start ?? "", t?.period?.end ?? "")}`,
          color: "#ffe66d",
          initials: d.getWithDefault("SALAXY.ENUM.CalculationRowType.holidaySalary.iconText", void 0),
          entityType: me.Company
        };
      case "startSaldo":
        return {
          displayName: d.get("SALAXY.CORE.HolidaysLogic.startSaldo.displayName"),
          description: d.get("SALAXY.CORE.HolidaysLogic.startSaldo.description"),
          color: "gray",
          initials: "saldo",
          entityType: me.Company
        };
      case "total":
        return {
          displayName: d.get("SALAXY.CORE.HolidaysLogic.total.displayName"),
          description: d.get("SALAXY.CORE.HolidaysLogic.total.description"),
          color: "#ffe66d",
          initials: "=",
          entityType: me.Company
        };
      case "endSaldo":
        return {
          displayName: d.get("SALAXY.CORE.HolidaysLogic.endSaldo.displayName"),
          description: d.get("SALAXY.CORE.HolidaysLogic.endSaldo.description"),
          color: "gray",
          initials: "saldo",
          entityType: me.Company
        };
    }
  }
  /** Gets a display avatar for a paid calculation */
  static getPaidBonusAvatar(e = "row", t) {
    switch (e) {
      case "row":
        return {
          displayName: `${d.get("SALAXY.CORE.HolidaysLogic.paid")} ${c.getFormattedDate(t?.date)}`,
          description: `${d.get("SALAXY.CORE.HolidaysLogic.salaryPeriod")} ${c.getFormattedRange(t?.period?.start ?? "", t?.period?.end ?? "")}`,
          color: "#ffe66d",
          initials: d.getWithDefault("SALAXY.ENUM.CalculationRowType.holidayBonus.iconText", void 0),
          entityType: me.Company
        };
      case "startSaldo":
        return {
          displayName: d.get("SALAXY.CORE.HolidaysLogic.bonusStartSaldo.displayName"),
          description: d.get("SALAXY.CORE.HolidaysLogic.bonusStartSaldo.description"),
          color: "gray",
          initials: "saldo",
          entityType: me.Company
        };
      case "total":
        return {
          displayName: d.get("SALAXY.CORE.HolidaysLogic.bonusTotal.displayName"),
          description: d.get("SALAXY.CORE.HolidaysLogic.bonusTotal.description"),
          color: "#ffe66d",
          initials: "=",
          entityType: me.Company
        };
      case "endSaldo":
        return {
          displayName: d.get("SALAXY.CORE.HolidaysLogic.bonusEndSaldo.displayName"),
          description: d.get("SALAXY.CORE.HolidaysLogic.bonusEndSaldo.description"),
          color: "gray",
          initials: "saldo",
          entityType: me.Company
        };
    }
  }
  /**
   * Gets the visualisation data for the a holiday year.
   * @param holidayYear The holiday year to visualize
   */
  static getYearVisualisation(e) {
    const t = e.year, n = c.getYear("today"), i = c.getMonth("today") - 4, s = n < t ? i : n > t ? i + 24 : i + 12;
    return {
      year: t,
      employmentId: e.employmentId,
      currentMonthIx: s,
      years: [
        { text: t - 1, months: 9, style: "default" },
        { text: t, months: 12, style: "primary" },
        { text: t + 1, months: 4, style: "default" }
      ],
      months: [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4],
      items: [
        { text: `${d.get("SALAXY.CORE.HolidaysLogic.holidayYear.accrualEndSaldo")}: ${e.accrual?.endSaldo ?? 0} ${d.get("SALAXY.CORE.HolidaysLogic.holidayYear.day")}`, months: 12, start: 0, style: "default", view: "accrual" },
        { text: `${d.get("SALAXY.CORE.HolidaysLogic.holidayYear.plannedSummerLeaves")}: ${le.getPlannedLeavesCount(e, "summer")} ${d.get("SALAXY.CORE.HolidaysLogic.holidayYear.day")}`, months: 5, start: 13, style: "default", view: "holidays-summer" },
        { text: `${d.get("SALAXY.CORE.HolidaysLogic.holidayYear.plannedWinterLeaves")}: ${le.getPlannedLeavesCount(e, "winter")} ${d.get("SALAXY.CORE.HolidaysLogic.holidayYear.day")}`, months: 7, start: 18, style: "default", view: "holidays-winter" },
        { text: d.get("SALAXY.CORE.HolidaysLogic.holidayYear.paidHolidays"), months: 12, start: 13, style: "default", view: "paidHolidays" }
      ]
    };
  }
  /**
   * Method for checking if holidays are active
   */
  static isWorkerHolidaysActive(e) {
    return e && e.code !== Ha.Undefined;
  }
  /** Returns holiday pay daily salary */
  static getHolidayPayDailySalary(e) {
    if (e?.spec == null || e?.holidayPay == null)
      return 0;
    switch (e.spec.holidayPayCalculation) {
      case da.NormalMonthlyPay:
        return e.holidayPay?.normalMonthlyPayDailySalary ?? 0;
      case da.AverageDailyPay:
        return e.holidayPay?.averageDailyPayDailySalary ?? 0;
      case da.AverageHourlyPay:
        return e.holidayPay?.averageHourlyPayDailySalary ?? 0;
      case da.PercentageBasedPay:
        return e.holidayPay?.percentageBasedPayDailySalary ?? 0;
      case da.OtherPay:
        return e.holidayPay?.otherPay ?? 0;
      case da.HolidayCompensation:
        return e.holidayPay?.compensationPayDailySalary ?? 0;
      default:
        return 0;
    }
  }
}
const Cn = class Cn {
  /**
   * Custom type guard that determines whether the payment object is a payroll (based on whether it calcs collection).
   * @param paymentObject Payment object that is either PayrollDetails or Calculation OR does not have calcs / employer properites that is used to determine the type.
   */
  static isPayroll(e) {
    return e && e.calcs !== void 0;
  }
  /**
   * Custom type guard that determines whether the payment object is a calculation (based on whether it employer property).
   * @param paymentObject Payment object that is either PayrollDetails or Calculation OR does not have calcs / employer properites that is used to determine the type.
   */
  static isCalculation(e) {
    return e && e.employer !== void 0;
  }
  /**
   * Gets and avatar image for a payment channel
   * Enum name is id, label as displayName, descr as description and sort order as 6-char string in sortableName.
   * Picture is either color-initials combination or pic as usual.
   * @param channel The channel to fetch avatar for.
   */
  static getChannelAvatar(e) {
    return this.getAllChannels().find((t) => t.id === e);
  }
  /**
   * Gets all the supported payment channels defined in PaymentChannel as avatars.
   * Enum name is id, label as displayName, descr as description and sort order as 6-char string in sortableName.
   * Picture is either color-initials combination or pic as usual.
   */
  static getAllChannels() {
    return this.avatars || (this.avatars = H.getEnumMetadata("PaymentChannel").values.map((e) => {
      const t = this.avatarPics[e.name] || this.avatarPics[F.Undefined];
      return {
        id: e.name,
        displayName: e.label,
        firstName: e.label,
        sortableName: ("000000" + e.order).slice(-6),
        description: e.descr,
        color: t.color,
        entityType: t.entityType || me.Company,
        initials: t.initials,
        pictureType: t.url === "default" ? We.Uploaded : t.pictureType,
        url: t.url === "default" ? `https://cdn.salaxy.com/ng1/img/paymentmethod/${e.name}.png` : t.url
      };
    })), this.avatars;
  }
  /**
   * Returns true if the channel is for customer funds account (cfa).
   * @param channel Any payment channel.
   * @returns True for customer funds account channels.
   */
  static isCfa(e) {
    switch (e = e ?? F.Undefined, e) {
      case F.Undefined:
      case F.PalkkausCfaFinvoice:
      case F.PalkkausEcfaFinvoice:
      case F.PalkkausCfaPaytrail:
      case F.PalkkausEcfaPaytrail:
      case F.PalkkausCfaReference:
      case F.PalkkausEcfaReference:
      case F.PalkkausCfaTest:
      case F.HolviCfa:
      case F.TalenomCfa:
        return !0;
      default:
        return !1;
    }
  }
  /**
   * Returns true if the channel is for customer funds account (ecfa).
   */
  static isEcfa(e) {
    switch (e = e ?? F.Undefined, e) {
      case F.PalkkausEcfaFinvoice:
      case F.PalkkausEcfaPaytrail:
      case F.PalkkausEcfaReference:
        return !0;
      default:
        return !1;
    }
  }
  /**
   * Returns true if the channel is like PalkkausInvoices.
   */
  static isPalkkausInvoicesLike(e) {
    if (!e)
      return !1;
    switch (e) {
      case F.PalkkausInvoices:
      case F.Kitsas:
        return !0;
      default:
        return !1;
    }
  }
  /**
   * Returns true if the channel is like PalkkausInvoices.
   */
  static isPalkkausManualLike(e) {
    if (!e)
      return !1;
    switch (e) {
      case F.PalkkausManual:
      case F.TalenomManual:
        return !0;
      default:
        return !1;
    }
  }
};
Cn.avatarPics = {
  [F.Undefined]: { color: "gray", initials: "?" },
  [F.Test]: { url: "default" },
  [F.ZeroPayment]: { url: "default" },
  [F.PalkkausManual]: { url: "default" },
  [F.PalkkausWS]: { color: "#005f81", initials: "WS" },
  [F.PalkkausPSD]: { color: "#005f81", initials: "PSD" },
  [F.PalkkausPersonal]: { url: "default" },
  [F.PalkkausInvoices]: { url: "default" },
  [F.PalkkausCfaPaytrail]: { url: "default" },
  [F.PalkkausCfaReference]: { url: "default" },
  [F.PalkkausCfaFinvoice]: { url: "default" },
  [F.PalkkausEcfaPaytrail]: { url: "default" },
  [F.PalkkausEcfaReference]: { url: "default" },
  [F.PalkkausEcfaFinvoice]: { url: "default" },
  [F.PalkkausCfaTest]: { url: "default" },
  [F.AccountorGo]: { url: "default" },
  [F.TalenomOnline]: { url: "default" },
  [F.TalenomCfa]: { url: "default" },
  [F.TalenomManual]: { url: "default" },
  [F.HolviCfa]: { url: "default" },
  [F.FinagoSolo]: { url: "default" },
  [F.Procountor]: { url: "default" },
  [F.Kevytyrittaja]: { url: "default" },
  [F.VismaNetvisor]: { url: "default" },
  [F.Askelma]: { url: "default" },
  [F.Briox]: { url: "default" },
  [F.Lemonaid]: { url: "default" },
  [F.Laskupiste]: { url: "default" },
  [F.PasseliMerit]: { url: "default" },
  [F.Odoo]: { url: "default" },
  [F.Ecom]: { url: "default" },
  [F.Kitsas]: { url: "default" },
  [F.Kompassi]: { url: "default" },
  [F.Domus]: { url: "default" },
  [F.Holvi]: { url: "default" },
  [F.Hausvise]: { url: "default" }
};
let Sa = Cn;
const vl = [
  {
    id: "01100",
    code: "01100",
    labelFi: "Upseerit",
    labelEn: "Commissioned armed forces officers",
    labelSv: "Officerare",
    searchFi: "01100 upseerit",
    searchEn: "01100 commissioned armed forces officers",
    searchSv: "01100 officerare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "02100",
    code: "02100",
    labelFi: "Aliupseerit",
    labelEn: "Non-commissioned armed forces officers",
    labelSv: "Underofficerare",
    searchFi: "02100 aliupseerit",
    searchEn: "02100 non-commissioned armed forces officers",
    searchSv: "02100 underofficerare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "03100",
    code: "03100",
    labelFi: "Sotilasammattihenkilöstö",
    labelEn: "Armed forces occupations, other ranks",
    labelSv: "Yrkesutbildad personal inom militären",
    searchFi: "03100 sotilasammattihenkilöstö",
    searchEn: "03100 armed forces occupations, other ranks",
    searchSv: "03100 yrkesutbildad personal inom militären",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "11110",
    code: "11110",
    labelFi: "Lainsäätäjät",
    labelEn: "Legislators",
    labelSv: "Lagstiftare",
    searchFi: "11110 lainsäätäjät",
    searchEn: "11110 legislators",
    searchSv: "11110 lagstiftare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "11121",
    code: "11121",
    labelFi: "Valtion keskushallinnon johtajat",
    labelEn: "Senior central government officials",
    labelSv: "Direktörer inom statens centralförvaltning",
    searchFi: "11121 valtion keskushallinnon johtajat",
    searchEn: "11121 senior central government officials",
    searchSv: "11121 direktörer inom statens centralförvaltning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "11122",
    code: "11122",
    labelFi: "Alue- ja paikallishallinnon johtajat ja ylimmät virkamiehet",
    labelEn: "Senior district and local government officials and senior officials",
    labelSv: "Direktörer och högre tjänstemän inom statlig distrikts- och lokalförvaltning",
    searchFi: "11122 alue- ja paikallishallinnon johtajat ja ylimmät virkamiehet",
    searchEn: "11122 senior district and local government officials and senior officials",
    searchSv: "11122 direktörer och högre tjänstemän inom statlig distrikts- och lokalförvaltning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "11141",
    code: "11141",
    labelFi: "Työmarkkina- ja elinkeinoelämän järjestöjen johtajat",
    labelEn: "Senior officials of employers', workers' and other economic-interest organisations",
    labelSv: "Chefer i arbetsmarknads- och näringslivsorganisationer",
    searchFi: "11141 työmarkkina- ja elinkeinoelämän järjestöjen johtajat",
    searchEn: "11141 senior officials of employers', workers' and other economic-interest organisations",
    searchSv: "11141 chefer i arbetsmarknads- och näringslivsorganisationer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "11142",
    code: "11142",
    labelFi: "Muiden järjestöjen johtajat",
    labelEn: "Senior officials of humanitarian and other special-interest organisations",
    labelSv: "Chefer i andra organisationer",
    searchFi: "11142 muiden järjestöjen johtajat",
    searchEn: "11142 senior officials of humanitarian and other special-interest organisations",
    searchSv: "11142 chefer i andra organisationer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "11200",
    code: "11200",
    labelFi: "Toimitusjohtajat ja pääjohtajat",
    labelEn: "Managing directors and chief executives",
    labelSv: "Verkställande direktörer och verkschefer",
    searchFi: "11200 toimitusjohtajat ja pääjohtajat tj ceo",
    searchEn: "11200 managing directors and chief executives",
    searchSv: "11200 verkställande direktörer och verkschefer",
    freeTextFi: "tj ceo",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "11200-bm",
    code: "11200",
    labelFi: "Hallituksen jäsen",
    labelEn: "Board member",
    labelSv: "Styrelsemedlem",
    searchFi: "11200 hallituksen jäsen",
    searchEn: "11200 board member",
    searchSv: "11200 styrelsemedlem",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "12110",
    code: "12110",
    labelFi: "Talousjohtajat",
    labelEn: "Finance managers",
    labelSv: "Ekonomichefer",
    searchFi: "12110 talousjohtajat",
    searchEn: "12110 finance managers",
    searchSv: "12110 ekonomichefer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "12120",
    code: "12120",
    labelFi: "Henkilöstöjohtajat",
    labelEn: "Human resource managers",
    labelSv: "Personalchefer",
    searchFi: "12120 henkilöstöjohtajat",
    searchEn: "12120 human resource managers",
    searchSv: "12120 personalchefer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "12130",
    code: "12130",
    labelFi: "Politiikka- ja suunnittelujohtajat",
    labelEn: "Policy and planning managers",
    labelSv: "Politik- och planeringschefer",
    searchFi: "12130 politiikka- ja suunnittelujohtajat",
    searchEn: "12130 policy and planning managers",
    searchSv: "12130 politik- och planeringschefer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "12190",
    code: "12190",
    labelFi: "Muut hallintojohtajat ja kaupalliset johtajat",
    labelEn: "Business services and administration managers not elsewhere classified",
    labelSv: "Övriga chefer inom företagstjänster och administration",
    searchFi: "12190 muut hallintojohtajat ja kaupalliset johtajat",
    searchEn: "12190 business services and administration managers not elsewhere classified",
    searchSv: "12190 övriga chefer inom företagstjänster och administration",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "12210",
    code: "12210",
    labelFi: "Myynti- ja markkinointijohtajat",
    labelEn: "Sales and marketing managers",
    labelSv: "Försäljnings- och marknadsföringschefer",
    searchFi: "12210 myynti- ja markkinointijohtajat sales",
    searchEn: "12210 sales and marketing managers",
    searchSv: "12210 försäljnings- och marknadsföringschefer",
    freeTextFi: "sales",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "12220",
    code: "12220",
    labelFi: "Mainos- ja tiedotusjohtajat",
    labelEn: "Advertising and public relations managers",
    labelSv: "Reklam- och kommunikationschefer, PR-chefer",
    searchFi: "12220 mainos- ja tiedotusjohtajat",
    searchEn: "12220 advertising and public relations managers",
    searchSv: "12220 reklam- och kommunikationschefer, pr-chefer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "12230",
    code: "12230",
    labelFi: "Tutkimus- ja kehitysjohtajat",
    labelEn: "Research and development managers",
    labelSv: "Forsknings- och utvecklingschefer",
    searchFi: "12230 tutkimus- ja kehitysjohtajat",
    searchEn: "12230 research and development managers",
    searchSv: "12230 forsknings- och utvecklingschefer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "13110",
    code: "13110",
    labelFi: "Maa- ja metsätalouden johtajat",
    labelEn: "Agricultural and forestry production managers",
    labelSv: "Chefer inom jord- och skogsbruk",
    searchFi: "13110 maa- ja metsätalouden johtajat",
    searchEn: "13110 agricultural and forestry production managers",
    searchSv: "13110 chefer inom jord- och skogsbruk",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "13120",
    code: "13120",
    labelFi: "Vesiviljely- ja kalatalouden johtajat",
    labelEn: "Aquaculture and fisheries production managers",
    labelSv: "Chefer inom vattenbruk och fiske",
    searchFi: "13120 vesiviljely- ja kalatalouden johtajat",
    searchEn: "13120 aquaculture and fisheries production managers",
    searchSv: "13120 chefer inom vattenbruk och fiske",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "13210",
    code: "13210",
    labelFi: "Teollisuuden tuotantojohtajat",
    labelEn: "Manufacturing managers",
    labelSv: "Produktionschefer inom industri",
    searchFi: "13210 teollisuuden tuotantojohtajat",
    searchEn: "13210 manufacturing managers",
    searchSv: "13210 produktionschefer inom industri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "13220",
    code: "13220",
    labelFi: "Kaivostoiminnan tuotantojohtajat",
    labelEn: "Mining managers",
    labelSv: "Produktionschefer inom gruvdrift",
    searchFi: "13220 kaivostoiminnan tuotantojohtajat",
    searchEn: "13220 mining managers",
    searchSv: "13220 produktionschefer inom gruvdrift",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "13230",
    code: "13230",
    labelFi: "Rakennustoiminnan tuotantojohtajat",
    labelEn: "Construction managers",
    labelSv: "Produktionschefer inom byggverksamhet",
    searchFi: "13230 rakennustoiminnan tuotantojohtajat",
    searchEn: "13230 construction managers",
    searchSv: "13230 produktionschefer inom byggverksamhet",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "13240",
    code: "13240",
    labelFi: "Hankinta- ja jakelujohtajat",
    labelEn: "Supply, distribution and related managers",
    labelSv: "Inköps- och distributionschefer m.fl.",
    searchFi: "13240 hankinta- ja jakelujohtajat",
    searchEn: "13240 supply, distribution and related managers",
    searchSv: "13240 inköps- och distributionschefer m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "13300",
    code: "13300",
    labelFi: "Tieto- ja viestintäteknologiajohtajat",
    labelEn: "Information and communications technology service managers",
    labelSv: "Chefer inom informations- och kommunikationsteknik (IKT)",
    searchFi: "13300 tieto- ja viestintäteknologiajohtajat",
    searchEn: "13300 information and communications technology service managers",
    searchSv: "13300 chefer inom informations- och kommunikationsteknik (ikt)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "13410",
    code: "13410",
    labelFi: "Lastenhoidon johtajat",
    labelEn: "Child care services managers",
    labelSv: "Chefer inom barnomsorg",
    searchFi: "13410 lastenhoidon johtajat",
    searchEn: "13410 child care services managers",
    searchSv: "13410 chefer inom barnomsorg",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "13420",
    code: "13420",
    labelFi: "Terveydenhuollon johtajat",
    labelEn: "Health services managers",
    labelSv: "Chefer inom hälso- och sjukvård",
    searchFi: "13420 terveydenhuollon johtajat",
    searchEn: "13420 health services managers",
    searchSv: "13420 chefer inom hälso- och sjukvård",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "13430",
    code: "13430",
    labelFi: "Vanhustenhuollon johtajat",
    labelEn: "Aged care services managers",
    labelSv: "Chefer inom äldrevård",
    searchFi: "13430 vanhustenhuollon johtajat",
    searchEn: "13430 aged care services managers",
    searchSv: "13430 chefer inom äldrevård",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "13440",
    code: "13440",
    labelFi: "Sosiaalihuollon johtajat",
    labelEn: "Social welfare managers",
    labelSv: "Chefer inom socialvård",
    searchFi: "13440 sosiaalihuollon johtajat",
    searchEn: "13440 social welfare managers",
    searchSv: "13440 chefer inom socialvård",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "13450",
    code: "13450",
    labelFi: "Opetusalan johtajat",
    labelEn: "Education managers",
    labelSv: "Chefer inom utbildning",
    searchFi: "13450 opetusalan johtajat",
    searchEn: "13450 education managers",
    searchSv: "13450 chefer inom utbildning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "13460",
    code: "13460",
    labelFi: "Rahoitus- ja vakuutuspalvelujen johtajat",
    labelEn: "Financial and insurance services branch managers",
    labelSv: "Chefer inom bank- och försäkringstjänster",
    searchFi: "13460 rahoitus- ja vakuutuspalvelujen johtajat",
    searchEn: "13460 financial and insurance services branch managers",
    searchSv: "13460 chefer inom bank- och försäkringstjänster",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "13490",
    code: "13490",
    labelFi: "Muut yhteiskunnan palvelujen johtajat",
    labelEn: "Professional services managers not elsewhere classified",
    labelSv: "Övriga chefer inom samhälleliga tjänster",
    searchFi: "13490 muut yhteiskunnan palvelujen johtajat",
    searchEn: "13490 professional services managers not elsewhere classified",
    searchSv: "13490 övriga chefer inom samhälleliga tjänster",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "14110",
    code: "14110",
    labelFi: "Hotellinjohtajat",
    labelEn: "Hotel managers",
    labelSv: "Hotellchefer",
    searchFi: "14110 hotellinjohtajat",
    searchEn: "14110 hotel managers",
    searchSv: "14110 hotellchefer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "14120",
    code: "14120",
    labelFi: "Ravintolanjohtajat",
    labelEn: "Restaurant managers",
    labelSv: "Restaurangchefer",
    searchFi: "14120 ravintolanjohtajat",
    searchEn: "14120 restaurant managers",
    searchSv: "14120 restaurangchefer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "14200",
    code: "14200",
    labelFi: "Vähittäis- ja tukkukaupan johtajat",
    labelEn: "Retail and wholesale trade managers",
    labelSv: "Chefer inom detalj- och partihandel",
    searchFi: "14200 vähittäis- ja tukkukaupan johtajat",
    searchEn: "14200 retail and wholesale trade managers",
    searchSv: "14200 chefer inom detalj- och partihandel",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "14310",
    code: "14310",
    labelFi: "Urheilu-, vapaa-aika- ja kulttuurikeskusten johtajat",
    labelEn: "Sports, recreation and cultural centre managers",
    labelSv: "Chefer för sport-, fritids- och kulturcenter",
    searchFi: "14310 urheilu-, vapaa-aika- ja kulttuurikeskusten johtajat",
    searchEn: "14310 sports, recreation and cultural centre managers",
    searchSv: "14310 chefer för sport-, fritids- och kulturcenter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "14390",
    code: "14390",
    labelFi: "Muut palvelualojen johtajat",
    labelEn: "",
    labelSv: "Övriga chefer inom servicenäringar",
    searchFi: "14390 muut palvelualojen johtajat",
    searchEn: "14390",
    searchSv: "14390 övriga chefer inom servicenäringar",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21110",
    code: "21110",
    labelFi: "Fyysikot ja astronomit",
    labelEn: "Physicists and astronomers",
    labelSv: "Fysiker och astronomer",
    searchFi: "21110 fyysikot ja astronomit",
    searchEn: "21110 physicists and astronomers",
    searchSv: "21110 fysiker och astronomer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21120",
    code: "21120",
    labelFi: "Meteorologit",
    labelEn: "Meteorologists",
    labelSv: "Meteorologer",
    searchFi: "21120 meteorologit",
    searchEn: "21120 meteorologists",
    searchSv: "21120 meteorologer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21130",
    code: "21130",
    labelFi: "Kemistit",
    labelEn: "Chemists",
    labelSv: "Kemister",
    searchFi: "21130 kemistit",
    searchEn: "21130 chemists",
    searchSv: "21130 kemister",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21140",
    code: "21140",
    labelFi: "Geologit ja geofyysikot",
    labelEn: "Geologists and geophysicists",
    labelSv: "Geologer och geofysiker",
    searchFi: "21140 geologit ja geofyysikot",
    searchEn: "21140 geologists and geophysicists",
    searchSv: "21140 geologer och geofysiker",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21200",
    code: "21200",
    labelFi: "Matemaatikot, aktuaarit ja tilastotieteilijät",
    labelEn: "Mathematicians, actuaries and statisticians",
    labelSv: "Matematiker, aktuarier och statistiker",
    searchFi: "21200 matemaatikot, aktuaarit ja tilastotieteilijät",
    searchEn: "21200 mathematicians, actuaries and statisticians",
    searchSv: "21200 matematiker, aktuarier och statistiker",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21310",
    code: "21310",
    labelFi: "Biologit, kasvi- ja eläintieteilijät ym. erityisasiantuntijat",
    labelEn: "Biologists, botanists, zoologists and related professionals",
    labelSv: "Biologer, botanister, zoologer m.fl.",
    searchFi: "21310 biologit, kasvi- ja eläintieteilijät ym. erityisasiantuntijat",
    searchEn: "21310 biologists, botanists, zoologists and related professionals",
    searchSv: "21310 biologer, botanister, zoologer m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21321",
    code: "21321",
    labelFi: "Maa- ja kalatalouden erityisasiantuntijat",
    labelEn: "Agronomists and fishery professionals",
    labelSv: "Specialister inom jordbruk och fiske",
    searchFi: "21321 maa- ja kalatalouden erityisasiantuntijat",
    searchEn: "21321 agronomists and fishery professionals",
    searchSv: "21321 specialister inom jordbruk och fiske",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21322",
    code: "21322",
    labelFi: "Metsätalouden erityisasiantuntijat",
    labelEn: "Forestry professionals",
    labelSv: "Specialister inom skogsbruk",
    searchFi: "21322 metsätalouden erityisasiantuntijat",
    searchEn: "21322 forestry professionals",
    searchSv: "21322 specialister inom skogsbruk",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21330",
    code: "21330",
    labelFi: "Ympäristön- ja luonnonsuojelun erityisasiantuntijat",
    labelEn: "Environmental protection professionals",
    labelSv: "Specialister inom miljö- och naturskydd",
    searchFi: "21330 ympäristön- ja luonnonsuojelun erityisasiantuntijat",
    searchEn: "21330 environmental protection professionals",
    searchSv: "21330 specialister inom miljö- och naturskydd",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21410",
    code: "21410",
    labelFi: "Teollisen valmistuksen ja tuotantotekniikan erityisasiantuntijat",
    labelEn: "Industrial and production engineers",
    labelSv: "Specialister inom industriell produktion och produktionsteknik",
    searchFi: "21410 teollisen valmistuksen ja tuotantotekniikan erityisasiantuntijat",
    searchEn: "21410 industrial and production engineers",
    searchSv: "21410 specialister inom industriell produktion och produktionsteknik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21420",
    code: "21420",
    labelFi: "Maa- ja vesirakentamisen erityisasiantuntijat",
    labelEn: "Civil engineers",
    labelSv: "Specialister inom anläggningsarbeten",
    searchFi: "21420 maa- ja vesirakentamisen erityisasiantuntijat",
    searchEn: "21420 civil engineers",
    searchSv: "21420 specialister inom anläggningsarbeten",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21430",
    code: "21430",
    labelFi: "Ympäristötekniikan erityisasiantuntijat",
    labelEn: "Environmental engineers",
    labelSv: "Specialister inom miljöteknik",
    searchFi: "21430 ympäristötekniikan erityisasiantuntijat",
    searchEn: "21430 environmental engineers",
    searchSv: "21430 specialister inom miljöteknik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21440",
    code: "21440",
    labelFi: "Konetekniikan erityisasiantuntijat",
    labelEn: "Mechanical engineers",
    labelSv: "Specialister inom maskinteknik",
    searchFi: "21440 konetekniikan erityisasiantuntijat",
    searchEn: "21440 mechanical engineers",
    searchSv: "21440 specialister inom maskinteknik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21450",
    code: "21450",
    labelFi: "Puunjalostuksen ja kemian prosessitekniikan erityisasiantuntijat",
    labelEn: "Chemical engineers",
    labelSv: "Specialister inom träförädling och kemisk processteknik",
    searchFi: "21450 puunjalostuksen ja kemian prosessitekniikan erityisasiantuntijat",
    searchEn: "21450 chemical engineers",
    searchSv: "21450 specialister inom träförädling och kemisk processteknik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21460",
    code: "21460",
    labelFi: "Kaivosteollisuuden, metallurgian ym. erityisasiantuntijat",
    labelEn: "Mining engineers, metallurgists and related professionals",
    labelSv: "Specialister inom gruvindustri, metallurgi m.fl.",
    searchFi: "21460 kaivosteollisuuden, metallurgian ym. erityisasiantuntijat",
    searchEn: "21460 mining engineers, metallurgists and related professionals",
    searchSv: "21460 specialister inom gruvindustri, metallurgi m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21490",
    code: "21490",
    labelFi: "Muut tekniikan erityisasiantuntijat",
    labelEn: "Engineering professionals not elsewhere classified",
    labelSv: "Övriga specialister inom teknik",
    searchFi: "21490 muut tekniikan erityisasiantuntijat",
    searchEn: "21490 engineering professionals not elsewhere classified",
    searchSv: "21490 övriga specialister inom teknik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21510",
    code: "21510",
    labelFi: "Sähkötekniikan erityisasiantuntijat",
    labelEn: "Electrical engineers",
    labelSv: "Specialister inom elteknik",
    searchFi: "21510 sähkötekniikan erityisasiantuntijat",
    searchEn: "21510 electrical engineers",
    searchSv: "21510 specialister inom elteknik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21520",
    code: "21520",
    labelFi: "Elektroniikan erityisasiantuntijat",
    labelEn: "Electronics engineers",
    labelSv: "Specialister inom elektronik",
    searchFi: "21520 elektroniikan erityisasiantuntijat",
    searchEn: "21520 electronics engineers",
    searchSv: "21520 specialister inom elektronik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21531",
    code: "21531",
    labelFi: "Tietoliikenneteknologian tutkijat",
    labelEn: "Telecommunications researchers",
    labelSv: "Forskare inom teleteknik",
    searchFi: "21531 tietoliikenneteknologian tutkijat",
    searchEn: "21531 telecommunications researchers",
    searchSv: "21531 forskare inom teleteknik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21532",
    code: "21532",
    labelFi: "Tietotekniikka-alan tutkijat",
    labelEn: "Information technology researchers",
    labelSv: "Forskare inom informationsteknik",
    searchFi: "21532 tietotekniikka-alan tutkijat",
    searchEn: "21532 information technology researchers",
    searchSv: "21532 forskare inom informationsteknik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21610",
    code: "21610",
    labelFi: "Talonrakennuksen arkkitehdit",
    labelEn: "Building architects",
    labelSv: "Arkitekter inom husbyggande",
    searchFi: "21610 talonrakennuksen arkkitehdit",
    searchEn: "21610 building architects",
    searchSv: "21610 arkitekter inom husbyggande",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21620",
    code: "21620",
    labelFi: "Maisema-arkkitehdit",
    labelEn: "Landscape architects",
    labelSv: "Landskapsarkitekter",
    searchFi: "21620 maisema-arkkitehdit",
    searchEn: "21620 landscape architects",
    searchSv: "21620 landskapsarkitekter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21630",
    code: "21630",
    labelFi: "Tuote- ja vaatesuunnittelijat",
    labelEn: "Product and garment designers",
    labelSv: "Produkt- och modedesigner",
    searchFi: "21630 tuote- ja vaatesuunnittelijat",
    searchEn: "21630 product and garment designers",
    searchSv: "21630 produkt- och modedesigner",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21640",
    code: "21640",
    labelFi: "Yhdyskunta- ja liikennesuunnittelijat",
    labelEn: "Town and traffic planners",
    labelSv: "Samhälls- och trafikplanerare",
    searchFi: "21640 yhdyskunta- ja liikennesuunnittelijat",
    searchEn: "21640 town and traffic planners",
    searchSv: "21640 samhälls- och trafikplanerare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21650",
    code: "21650",
    labelFi: "Kartoituksen ja maanmittauksen erityisasiantuntijat",
    labelEn: "Cartographers and surveyors",
    labelSv: "Specialister inom kartläggning och lantmäteri",
    searchFi: "21650 kartoituksen ja maanmittauksen erityisasiantuntijat",
    searchEn: "21650 cartographers and surveyors",
    searchSv: "21650 specialister inom kartläggning och lantmäteri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "21660",
    code: "21660",
    labelFi: "Graafiset ja multimediasuunnittelijat",
    labelEn: "Graphic and multimedia designers",
    labelSv: "Grafiska designer och multimediadesigner",
    searchFi: "21660 graafiset ja multimediasuunnittelijat",
    searchEn: "21660 graphic and multimedia designers",
    searchSv: "21660 grafiska designer och multimediadesigner",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "22110",
    code: "22110",
    labelFi: "Yleislääkärit",
    labelEn: "Generalist medical practitioners",
    labelSv: "Allmänläkare",
    searchFi: "22110 yleislääkärit",
    searchEn: "22110 generalist medical practitioners",
    searchSv: "22110 allmänläkare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "22121",
    code: "22121",
    labelFi: "Ylilääkärit",
    labelEn: "Senior physicians",
    labelSv: "Överläkare",
    searchFi: "22121 ylilääkärit",
    searchEn: "22121 senior physicians",
    searchSv: "22121 överläkare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "22122",
    code: "22122",
    labelFi: "Erikoislääkärit",
    labelEn: "Specialists",
    labelSv: "Specialistläkare",
    searchFi: "22122 erikoislääkärit",
    searchEn: "22122 specialists",
    searchSv: "22122 specialistläkare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "22211",
    code: "22211",
    labelFi: "Ylihoitajat",
    labelEn: "Matrons",
    labelSv: "Överskötare",
    searchFi: "22211 ylihoitajat",
    searchEn: "22211 matrons",
    searchSv: "22211 överskötare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "22212",
    code: "22212",
    labelFi: "Osastonhoitajat",
    labelEn: "Ward sisters",
    labelSv: "Avdelningsskötare",
    searchFi: "22212 osastonhoitajat",
    searchEn: "22212 ward sisters",
    searchSv: "22212 avdelningsskötare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "22500",
    code: "22500",
    labelFi: "Eläinlääkärit",
    labelEn: "Veterinarians",
    labelSv: "Veterinärer",
    searchFi: "22500 eläinlääkärit",
    searchEn: "22500 veterinarians",
    searchSv: "22500 veterinärer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "22610",
    code: "22610",
    labelFi: "Hammaslääkärit",
    labelEn: "Dentists",
    labelSv: "Tandläkare",
    searchFi: "22610 hammaslääkärit",
    searchEn: "22610 dentists",
    searchSv: "22610 tandläkare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "22620",
    code: "22620",
    labelFi: "Proviisorit",
    labelEn: "Pharmacists",
    labelSv: "Provisorer",
    searchFi: "22620 proviisorit",
    searchEn: "22620 pharmacists",
    searchSv: "22620 provisorer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "22630",
    code: "22630",
    labelFi: "Ympäristöterveyden ja työsuojelun erityisasiantuntijat",
    labelEn: "Environmental and occupational health and hygiene professionals",
    labelSv: "Specialister inom miljöhälsa och arbetarskydd",
    searchFi: "22630 ympäristöterveyden ja työsuojelun erityisasiantuntijat",
    searchEn: "22630 environmental and occupational health and hygiene professionals",
    searchSv: "22630 specialister inom miljöhälsa och arbetarskydd",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "22650",
    code: "22650",
    labelFi: "Ravitsemusalan erityisasiantuntijat",
    labelEn: "Dieticians and nutritionists",
    labelSv: "Specialister inom näringslära",
    searchFi: "22650 ravitsemusalan erityisasiantuntijat",
    searchEn: "22650 dieticians and nutritionists",
    searchSv: "22650 specialister inom näringslära",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "22660",
    code: "22660",
    labelFi: "Kuulontutkijat ja puheterapeutit",
    labelEn: "Audiologists and speech therapists",
    labelSv: "Audiologer och logopeder",
    searchFi: "22660 kuulontutkijat ja puheterapeutit",
    searchEn: "22660 audiologists and speech therapists",
    searchSv: "22660 audiologer och logopeder",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "22690",
    code: "22690",
    labelFi: "Muut muualla luokittelemattomat terveydenhuollon erityisasiantuntijat",
    labelEn: "Health professionals not elsewhere classified",
    labelSv: "Övriga specialister inom hälso- och sjukvården utan annan klassificering",
    searchFi: "22690 muut muualla luokittelemattomat terveydenhuollon erityisasiantuntijat",
    searchEn: "22690 health professionals not elsewhere classified",
    searchSv: "22690 övriga specialister inom hälso- och sjukvården utan annan klassificering",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23101",
    code: "23101",
    labelFi: "Professorit",
    labelEn: "Professors",
    labelSv: "Professorer",
    searchFi: "23101 professorit",
    searchEn: "23101 professors",
    searchSv: "23101 professorer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23102",
    code: "23102",
    labelFi: "Lehtorit ja yliassistentit (yliopisto)",
    labelEn: "Lecturers and senior assistants (university)",
    labelSv: "Lektorer och överassistenter (universitet)",
    searchFi: "23102 lehtorit ja yliassistentit (yliopisto)",
    searchEn: "23102 lecturers and senior assistants (university)",
    searchSv: "23102 lektorer och överassistenter (universitet)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23103",
    code: "23103",
    labelFi: "Assistentit ja tuntiopettajat (yliopisto)",
    labelEn: "Assistants and part-time lecturers (university)",
    labelSv: "Assistenter och timlärare (universitet)",
    searchFi: "23103 assistentit ja tuntiopettajat (yliopisto)",
    searchEn: "23103 assistants and part-time lecturers (university)",
    searchSv: "23103 assistenter och timlärare (universitet)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23104",
    code: "23104",
    labelFi: "Yliopettajat (AMK)",
    labelEn: "Head teachers (polytechnics)",
    labelSv: "Överlärare (yrkeshögskolor)",
    searchFi: "23104 yliopettajat (amk)",
    searchEn: "23104 head teachers (polytechnics)",
    searchSv: "23104 överlärare (yrkeshögskolor)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23105",
    code: "23105",
    labelFi: "Lehtorit (AMK)",
    labelEn: "Lecturers (polytechnics)",
    labelSv: "Lektorer (yrkeshögskolor)",
    searchFi: "23105 lehtorit (amk)",
    searchEn: "23105 lecturers (polytechnics)",
    searchSv: "23105 lektorer (yrkeshögskolor)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23106",
    code: "23106",
    labelFi: "Tuntiopettajat ym. (AMK)",
    labelEn: "Part-time lecturers, etc. (polytechnics)",
    labelSv: "Timlärare m.fl. (yrkeshögskolor)",
    searchFi: "23106 tuntiopettajat ym. (amk)",
    searchEn: "23106 part-time lecturers, etc. (polytechnics)",
    searchSv: "23106 timlärare m.fl. (yrkeshögskolor)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23200",
    code: "23200",
    labelFi: "Ammatillisen koulutuksen opettajat",
    labelEn: "Vocational education teachers",
    labelSv: "Lärare i yrkesämnen",
    searchFi: "23200 ammatillisen koulutuksen opettajat",
    searchEn: "23200 vocational education teachers",
    searchSv: "23200 lärare i yrkesämnen",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23301",
    code: "23301",
    labelFi: "Matemaattisten aineiden opettajat",
    labelEn: "Teachers in mathematical subjects",
    labelSv: "Lärare i matematiska ämnen",
    searchFi: "23301 matemaattisten aineiden opettajat",
    searchEn: "23301 teachers in mathematical subjects",
    searchSv: "23301 lärare i matematiska ämnen",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23302",
    code: "23302",
    labelFi: "Äidinkielen ja kirjallisuuden opettajat",
    labelEn: "Native language and literature teachers",
    labelSv: "Lärare i modersmål och litteratur",
    searchFi: "23302 äidinkielen ja kirjallisuuden opettajat",
    searchEn: "23302 native language and literature teachers",
    searchSv: "23302 lärare i modersmål och litteratur",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23303",
    code: "23303",
    labelFi: "Taito- ja taideaineiden opettajat",
    labelEn: "Crafts and art teachers",
    labelSv: "Lärare i konst- och färdighetsämnen",
    searchFi: "23303 taito- ja taideaineiden opettajat",
    searchEn: "23303 crafts and art teachers",
    searchSv: "23303 lärare i konst- och färdighetsämnen",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23304",
    code: "23304",
    labelFi: "Muut peruskoulun yläluokkien ja lukion opettajat",
    labelEn: "Other secondary education teaching professionals",
    labelSv: "Övriga högstadie- och gymnasielärare",
    searchFi: "23304 muut peruskoulun yläluokkien ja lukion opettajat",
    searchEn: "23304 other secondary education teaching professionals",
    searchSv: "23304 övriga högstadie- och gymnasielärare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23411",
    code: "23411",
    labelFi: "Luokanopettajat",
    labelEn: "Primary education teaching professionals",
    labelSv: "Klasslärare",
    searchFi: "23411 luokanopettajat",
    searchEn: "23411 primary education teaching professionals",
    searchSv: "23411 klasslärare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23412",
    code: "23412",
    labelFi: "Aineenopettajat (peruskoulun alaluokat)",
    labelEn: "Primary education teaching professionals",
    labelSv: "Ämneslärare (lågstadiet)",
    searchFi: "23412 aineenopettajat (peruskoulun alaluokat)",
    searchEn: "23412 primary education teaching professionals",
    searchSv: "23412 ämneslärare (lågstadiet)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23420",
    code: "23420",
    labelFi: "Lastentarhanopettajat",
    labelEn: "Early childhood educators",
    labelSv: "Barnträdgårdslärare",
    searchFi: "23420 lastentarhanopettajat",
    searchEn: "23420 early childhood educators",
    searchSv: "23420 barnträdgårdslärare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23510",
    code: "23510",
    labelFi: "Opetusmenetelmien erityisasiantuntijat",
    labelEn: "Education methods specialists",
    labelSv: "Specialister i pedagogiska metoder",
    searchFi: "23510 opetusmenetelmien erityisasiantuntijat",
    searchEn: "23510 education methods specialists",
    searchSv: "23510 specialister i pedagogiska metoder",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23520",
    code: "23520",
    labelFi: "Erityisopettajat",
    labelEn: "Special needs teachers",
    labelSv: "Speciallärare",
    searchFi: "23520 erityisopettajat",
    searchEn: "23520 special needs teachers",
    searchSv: "23520 speciallärare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23530",
    code: "23530",
    labelFi: "Muut kieltenopettajat",
    labelEn: "Other language teachers",
    labelSv: "Övriga språklärare",
    searchFi: "23530 muut kieltenopettajat",
    searchEn: "23530 other language teachers",
    searchSv: "23530 övriga språklärare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23540",
    code: "23540",
    labelFi: "Muut musiikin opettajat",
    labelEn: "Other music teachers",
    labelSv: "Övriga musiklärare",
    searchFi: "23540 muut musiikin opettajat",
    searchEn: "23540 other music teachers",
    searchSv: "23540 övriga musiklärare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23550",
    code: "23550",
    labelFi: "Muut taideaineiden opettajat",
    labelEn: "Other arts teachers",
    labelSv: "Övriga lärare i konstnärliga ämnen",
    searchFi: "23550 muut taideaineiden opettajat",
    searchEn: "23550 other arts teachers",
    searchSv: "23550 övriga lärare i konstnärliga ämnen",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23560",
    code: "23560",
    labelFi: "Muut tietotekniikan opettajat ja kouluttajat",
    labelEn: "Information technology trainers",
    labelSv: "Övriga lärare och utbildare inom informationsteknik",
    searchFi: "23560 muut tietotekniikan opettajat ja kouluttajat",
    searchEn: "23560 information technology trainers",
    searchSv: "23560 övriga lärare och utbildare inom informationsteknik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23591",
    code: "23591",
    labelFi: "Opinto-ohjaajat",
    labelEn: "Career counsellors",
    labelSv: "Studiehandledare",
    searchFi: "23591 opinto-ohjaajat",
    searchEn: "23591 career counsellors",
    searchSv: "23591 studiehandledare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "23592",
    code: "23592",
    labelFi: "Muut opetuksen erityisasiantuntijat",
    labelEn: "Other teaching professionals",
    labelSv: "Övriga specialister inom undervisning",
    searchFi: "23592 muut opetuksen erityisasiantuntijat",
    searchEn: "23592 other teaching professionals",
    searchSv: "23592 övriga specialister inom undervisning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "24110",
    code: "24110",
    labelFi: "Laskentatoimen erityisasiantuntijat ja tilintarkastajat",
    labelEn: "Accountants",
    labelSv: "Specialister inom redovisning och revision",
    searchFi: "24110 laskentatoimen erityisasiantuntijat ja tilintarkastajat",
    searchEn: "24110 accountants",
    searchSv: "24110 specialister inom redovisning och revision",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "24120",
    code: "24120",
    labelFi: "Rahoitus- ja sijoitusneuvojat",
    labelEn: "Financial and investment advisers",
    labelSv: "Finans- och investeringsrådgivare",
    searchFi: "24120 rahoitus- ja sijoitusneuvojat",
    searchEn: "24120 financial and investment advisers",
    searchSv: "24120 finans- och investeringsrådgivare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "24130",
    code: "24130",
    labelFi: "Rahoitusanalyytikot",
    labelEn: "Financial analysts",
    labelSv: "Finansanalytiker",
    searchFi: "24130 rahoitusanalyytikot",
    searchEn: "24130 financial analysts",
    searchSv: "24130 finansanalytiker",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "24210",
    code: "24210",
    labelFi: "Johtamisen ja organisaatioiden erityisasiantuntijat",
    labelEn: "Management and organization analysts",
    labelSv: "Specialister inom ledarskap och organisationer",
    searchFi: "24210 johtamisen ja organisaatioiden erityisasiantuntijat",
    searchEn: "24210 management and organization analysts",
    searchSv: "24210 specialister inom ledarskap och organisationer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "24220",
    code: "24220",
    labelFi: "Hallinnon ja elinkeinojen kehittämisen erityisasiantuntijat",
    labelEn: "Policy administration professionals",
    labelSv: "Specialister inom utveckling av administration och näringar",
    searchFi: "24220 hallinnon ja elinkeinojen kehittämisen erityisasiantuntijat",
    searchEn: "24220 policy administration professionals",
    searchSv: "24220 specialister inom utveckling av administration och näringar",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "24230",
    code: "24230",
    labelFi: "Henkilöstöhallinnon erityisasiantuntijat ja urasuunnittelijat",
    labelEn: "Personnel and careers professionals",
    labelSv: "Specialister inom personaladministration och karriärplanering",
    searchFi: "24230 henkilöstöhallinnon erityisasiantuntijat ja urasuunnittelijat",
    searchEn: "24230 personnel and careers professionals",
    searchSv: "24230 specialister inom personaladministration och karriärplanering",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "24240",
    code: "24240",
    labelFi: "Henkilöstön kehittämisen erityisasiantuntijat ja kouluttajat",
    labelEn: "Training and staff development professionals",
    labelSv: "Specialister inom personalutveckling och utbildning",
    searchFi: "24240 henkilöstön kehittämisen erityisasiantuntijat ja kouluttajat",
    searchEn: "24240 training and staff development professionals",
    searchSv: "24240 specialister inom personalutveckling och utbildning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "24310",
    code: "24310",
    labelFi: "Mainonnan ja markkinoinnin erityisasiantuntijat",
    labelEn: "Advertising and marketing professionals",
    labelSv: "Specialister inom reklam och marknadsföring",
    searchFi: "24310 mainonnan ja markkinoinnin erityisasiantuntijat",
    searchEn: "24310 advertising and marketing professionals",
    searchSv: "24310 specialister inom reklam och marknadsföring",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "24320",
    code: "24320",
    labelFi: "Tiedottajat",
    labelEn: "Public relations professionals",
    labelSv: "Informatörer",
    searchFi: "24320 tiedottajat",
    searchEn: "24320 public relations professionals",
    searchSv: "24320 informatörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "24330",
    code: "24330",
    labelFi: "Myynti-insinöörit ja lääke-esittelijät (pl. tieto- ja viestintätekniikka)",
    labelEn: "Technical and medical sales professionals (excluding ICT)",
    labelSv: "Försäljningsingenjörer och läkemedelsrepresentanter (utom IKT)",
    searchFi: "24330 myynti-insinöörit ja lääke-esittelijät (pl. tieto- ja viestintätekniikka)",
    searchEn: "24330 technical and medical sales professionals (excluding ict)",
    searchSv: "24330 försäljningsingenjörer och läkemedelsrepresentanter (utom ikt)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "24340",
    code: "24340",
    labelFi: "Tieto- ja viestintätekniikan myynnin erityisasiantuntijat",
    labelEn: "Information and communications technology sales professionals",
    labelSv: "Specialister inom försäljning av informations- och kommunikationsteknik (IKT)",
    searchFi: "24340 tieto- ja viestintätekniikan myynnin erityisasiantuntijat",
    searchEn: "24340 information and communications technology sales professionals",
    searchSv: "24340 specialister inom försäljning av informations- och kommunikationsteknik (ikt)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "25110",
    code: "25110",
    labelFi: "Sovellusarkkitehdit",
    labelEn: "Systems analysts",
    labelSv: "Specialister inom applikationsarkitektur",
    searchFi: "25110 sovellusarkkitehdit",
    searchEn: "25110 systems analysts",
    searchSv: "25110 specialister inom applikationsarkitektur",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "25120",
    code: "25120",
    labelFi: "Sovellussuunnittelijat",
    labelEn: "Software developers",
    labelSv: "Applikationsplanerare",
    searchFi: "25120 sovellussuunnittelijat ohjelmoija koodaaja",
    searchEn: "25120 software developers",
    searchSv: "25120 applikationsplanerare",
    freeTextFi: "ohjelmoija koodaaja",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "25130",
    code: "25130",
    labelFi: "Web- ja multimediakehittäjät",
    labelEn: "Web and multimedia developers",
    labelSv: "Webb- och multimediautvecklare",
    searchFi: "25130 web- ja multimediakehittäjät www html java php",
    searchEn: "25130 web and multimedia developers",
    searchSv: "25130 webb- och multimediautvecklare",
    freeTextFi: "www html java php",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "25140",
    code: "25140",
    labelFi: "Sovellusohjelmoijat",
    labelEn: "Applications programmers",
    labelSv: "Applikationsprogrammerare",
    searchFi: "25140 sovellusohjelmoijat",
    searchEn: "25140 applications programmers",
    searchSv: "25140 applikationsprogrammerare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "25190",
    code: "25190",
    labelFi: "Muut ohjelmisto- ja sovelluskehittäjät",
    labelEn: "Software and applications developers and analysts not elsewhere classified",
    labelSv: "Övriga program- och applikationsutvecklare",
    searchFi: "25190 muut ohjelmisto- ja sovelluskehittäjät",
    searchEn: "25190 software and applications developers and analysts not elsewhere classified",
    searchSv: "25190 övriga program- och applikationsutvecklare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "25210",
    code: "25210",
    labelFi: "Tietokantasuunnittelijat ja -vastaavat",
    labelEn: "Database designers and administrators",
    labelSv: "Databasutvecklare och databasansvariga",
    searchFi: "25210 tietokantasuunnittelijat ja -vastaavat",
    searchEn: "25210 database designers and administrators",
    searchSv: "25210 databasutvecklare och databasansvariga",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "25220",
    code: "25220",
    labelFi: "Tietojärjestelmien ylläpitäjät",
    labelEn: "Systems administrators",
    labelSv: "Systemadministratörer",
    searchFi: "25220 tietojärjestelmien ylläpitäjät",
    searchEn: "25220 systems administrators",
    searchSv: "25220 systemadministratörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "25230",
    code: "25230",
    labelFi: "Tietoverkkojen erityisasiantuntijat",
    labelEn: "Computer network professionals",
    labelSv: "Nätverksspecialister",
    searchFi: "25230 tietoverkkojen erityisasiantuntijat",
    searchEn: "25230 computer network professionals",
    searchSv: "25230 nätverksspecialister",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "25290",
    code: "25290",
    labelFi: "Muut tietokanta- ja tietoverkkojen erityisasiantuntijat",
    labelEn: "Database and network professionals not elsewhere classified",
    labelSv: "Övriga databas- och nätverksspecialister",
    searchFi: "25290 muut tietokanta- ja tietoverkkojen erityisasiantuntijat",
    searchEn: "25290 database and network professionals not elsewhere classified",
    searchSv: "25290 övriga databas- och nätverksspecialister",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26110",
    code: "26110",
    labelFi: "Asianajajat",
    labelEn: "Lawyers",
    labelSv: "Advokater",
    searchFi: "26110 asianajajat",
    searchEn: "26110 lawyers",
    searchSv: "26110 advokater",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26120",
    code: "26120",
    labelFi: "Tuomioistuinlakimiehet",
    labelEn: "Judges",
    labelSv: "Domare",
    searchFi: "26120 tuomioistuinlakimiehet",
    searchEn: "26120 judges",
    searchSv: "26120 domare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26190",
    code: "26190",
    labelFi: "Muut lainopilliset erityisasiantuntijat",
    labelEn: "Legal professionals not elsewhere classified",
    labelSv: "Övriga specialister inom juridik",
    searchFi: "26190 muut lainopilliset erityisasiantuntijat",
    searchEn: "26190 legal professionals not elsewhere classified",
    searchSv: "26190 övriga specialister inom juridik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26211",
    code: "26211",
    labelFi: "Arkistonhoitajat",
    labelEn: "Archivists",
    labelSv: "Arkivarier",
    searchFi: "26211 arkistonhoitajat",
    searchEn: "26211 archivists",
    searchSv: "26211 arkivarier",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26212",
    code: "26212",
    labelFi: "Museoalan erityisasiantuntijat",
    labelEn: "Curators",
    labelSv: "Specialister inom museisektorn",
    searchFi: "26212 museoalan erityisasiantuntijat",
    searchEn: "26212 curators",
    searchSv: "26212 specialister inom museisektorn",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26220",
    code: "26220",
    labelFi: "Kirjastonhoitajat, informaatikot ym.",
    labelEn: "Librarians and related information professionals",
    labelSv: "Bibliotekarier, informatiker m.fl.",
    searchFi: "26220 kirjastonhoitajat, informaatikot ym.",
    searchEn: "26220 librarians and related information professionals",
    searchSv: "26220 bibliotekarier, informatiker m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26310",
    code: "26310",
    labelFi: "Ekonomistit",
    labelEn: "Economists",
    labelSv: "Nationalekonomer",
    searchFi: "26310 ekonomistit",
    searchEn: "26310 economists",
    searchSv: "26310 nationalekonomer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26320",
    code: "26320",
    labelFi: "Yhteiskunta- ja kulttuuritutkijat",
    labelEn: "Sociologists, anthropologists and related professionals",
    labelSv: "Samhälls- och kulturforskare",
    searchFi: "26320 yhteiskunta- ja kulttuuritutkijat",
    searchEn: "26320 sociologists, anthropologists and related professionals",
    searchSv: "26320 samhälls- och kulturforskare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26330",
    code: "26330",
    labelFi: "Historioitsijat, politiikan tutkijat ja filosofit",
    labelEn: "Philosophers, historians and political scientists",
    labelSv: "Historiker, statsvetare och filosofer",
    searchFi: "26330 historioitsijat, politiikan tutkijat ja filosofit",
    searchEn: "26330 philosophers, historians and political scientists",
    searchSv: "26330 historiker, statsvetare och filosofer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26340",
    code: "26340",
    labelFi: "Psykologit",
    labelEn: "Psychologists",
    labelSv: "Psykologer",
    searchFi: "26340 psykologit",
    searchEn: "26340 psychologists",
    searchSv: "26340 psykologer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26351",
    code: "26351",
    labelFi: "Sosiaalityöntekijät ym.",
    labelEn: "Social workers, etc.",
    labelSv: "Socialarbetare m.fl.",
    searchFi: "26351 sosiaalityöntekijät ym.",
    searchEn: "26351 social workers, etc.",
    searchSv: "26351 socialarbetare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26352",
    code: "26352",
    labelFi: "Sosiaalialan suunnittelijat ym.",
    labelEn: "Social planners, etc.",
    labelSv: "Planerare inom socialsektorn m.fl.",
    searchFi: "26352 sosiaalialan suunnittelijat ym.",
    searchEn: "26352 social planners, etc.",
    searchSv: "26352 planerare inom socialsektorn m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26360",
    code: "26360",
    labelFi: "Papit ym. uskonnollisen elämän erityisasiantuntijat",
    labelEn: "Religious professionals",
    labelSv: "Präster och övriga specialister inom religion",
    searchFi: "26360 papit ym. uskonnollisen elämän erityisasiantuntijat",
    searchEn: "26360 religious professionals",
    searchSv: "26360 präster och övriga specialister inom religion",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26410",
    code: "26410",
    labelFi: "Kirjailijat ym.",
    labelEn: "Authors and related writers",
    labelSv: "Författare m.fl.",
    searchFi: "26410 kirjailijat ym.",
    searchEn: "26410 authors and related writers",
    searchSv: "26410 författare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26421",
    code: "26421",
    labelFi: "Toimituspäälliköt ja -sihteerit, ohjelmapäälliköt",
    labelEn: "Managing editors and subeditors",
    labelSv: "Redaktionschefer och redaktionssekreterare, programchefer",
    searchFi: "26421 toimituspäälliköt ja -sihteerit, ohjelmapäälliköt",
    searchEn: "26421 managing editors and subeditors",
    searchSv: "26421 redaktionschefer och redaktionssekreterare, programchefer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26422",
    code: "26422",
    labelFi: "Lehtien yms. toimittajat",
    labelEn: "Journalists",
    labelSv: "Redaktörer vid tidningar m.fl.",
    searchFi: "26422 lehtien yms. toimittajat",
    searchEn: "26422 journalists",
    searchSv: "26422 redaktörer vid tidningar m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26423",
    code: "26423",
    labelFi: "Radio- ja tv-toimittajat",
    labelEn: "Radio and television journalists",
    labelSv: "Radio- och TV-redaktörer",
    searchFi: "26423 radio- ja tv-toimittajat",
    searchEn: "26423 radio and television journalists",
    searchSv: "26423 radio- och tv-redaktörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26430",
    code: "26430",
    labelFi: "Kääntäjät, tulkit ja muut kielitieteilijät",
    labelEn: "Translators, interpreters and other linguists",
    labelSv: "Översättare, tolkar och andra språkvetare",
    searchFi: "26430 kääntäjät, tulkit ja muut kielitieteilijät",
    searchEn: "26430 translators, interpreters and other linguists",
    searchSv: "26430 översättare, tolkar och andra språkvetare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26510",
    code: "26510",
    labelFi: "Kuvataiteilijat",
    labelEn: "Visual artists",
    labelSv: "Bildkonstnärer",
    searchFi: "26510 kuvataiteilijat",
    searchEn: "26510 visual artists",
    searchSv: "26510 bildkonstnärer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26520",
    code: "26520",
    labelFi: "Muusikot, laulajat ja säveltäjät",
    labelEn: "Musicians, singers and composers",
    labelSv: "Musiker, sångare och kompositörer",
    searchFi: "26520 muusikot, laulajat ja säveltäjät",
    searchEn: "26520 musicians, singers and composers",
    searchSv: "26520 musiker, sångare och kompositörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26530",
    code: "26530",
    labelFi: "Tanssitaiteilijat ja koreografit",
    labelEn: "Dancers and choreographers",
    labelSv: "Danskonstnärer och koreografer",
    searchFi: "26530 tanssitaiteilijat ja koreografit",
    searchEn: "26530 dancers and choreographers",
    searchSv: "26530 danskonstnärer och koreografer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26540",
    code: "26540",
    labelFi: "Ohjaajat ja tuottajat",
    labelEn: "Film, stage and related directors and producers",
    labelSv: "Regissörer och producenter",
    searchFi: "26540 ohjaajat ja tuottajat",
    searchEn: "26540 film, stage and related directors and producers",
    searchSv: "26540 regissörer och producenter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26550",
    code: "26550",
    labelFi: "Näyttelijät",
    labelEn: "Actors",
    labelSv: "Skådespelare",
    searchFi: "26550 näyttelijät",
    searchEn: "26550 actors",
    searchSv: "26550 skådespelare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26560",
    code: "26560",
    labelFi: "Juontajat, kuuluttajat ym.",
    labelEn: "Announcers on radio, television and other media",
    labelSv: "Presentatörer, konferencierer m.fl.",
    searchFi: "26560 juontajat, kuuluttajat ym.",
    searchEn: "26560 announcers on radio, television and other media",
    searchSv: "26560 presentatörer, konferencierer m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "26590",
    code: "26590",
    labelFi: "Muut taiteilijat",
    labelEn: "Creative and performing artists not elsewhere classified",
    labelSv: "Övriga konstnärer",
    searchFi: "26590 muut taiteilijat",
    searchEn: "26590 creative and performing artists not elsewhere classified",
    searchSv: "26590 övriga konstnärer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31110",
    code: "31110",
    labelFi: "Luonnontieteen tekniset asiantuntijat",
    labelEn: "Chemical and physical science technicians",
    labelSv: "Tekniska experter inom naturvetenskap",
    searchFi: "31110 luonnontieteen tekniset asiantuntijat",
    searchEn: "31110 chemical and physical science technicians",
    searchSv: "31110 tekniska experter inom naturvetenskap",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31121",
    code: "31121",
    labelFi: "Talonrakentamisen asiantuntijat",
    labelEn: "Building construction technicians",
    labelSv: "Experter inom husbyggnad",
    searchFi: "31121 talonrakentamisen asiantuntijat",
    searchEn: "31121 building construction technicians",
    searchSv: "31121 experter inom husbyggnad",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31122",
    code: "31122",
    labelFi: "Maa- ja vesirakentamisen asiantuntijat",
    labelEn: "Civil engineering technicians",
    labelSv: "Experter inom anläggningsarbeten",
    searchFi: "31122 maa- ja vesirakentamisen asiantuntijat",
    searchEn: "31122 civil engineering technicians",
    searchSv: "31122 experter inom anläggningsarbeten",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31123",
    code: "31123",
    labelFi: "Kartoituksen ja maanmittauksen asiantuntijat",
    labelEn: "Cartographic and surveying technicians",
    labelSv: "Experter inom kartläggning och lantmäteri",
    searchFi: "31123 kartoituksen ja maanmittauksen asiantuntijat",
    searchEn: "31123 cartographic and surveying technicians",
    searchSv: "31123 experter inom kartläggning och lantmäteri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31130",
    code: "31130",
    labelFi: "Sähkötekniikan asiantuntijat",
    labelEn: "Electrical engineering technicians",
    labelSv: "Experter inom elteknik",
    searchFi: "31130 sähkötekniikan asiantuntijat",
    searchEn: "31130 electrical engineering technicians",
    searchSv: "31130 experter inom elteknik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31140",
    code: "31140",
    labelFi: "Elektroniikan asiantuntijat",
    labelEn: "Electronics engineering technicians",
    labelSv: "Experter inom elektronik",
    searchFi: "31140 elektroniikan asiantuntijat",
    searchEn: "31140 electronics engineering technicians",
    searchSv: "31140 experter inom elektronik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31150",
    code: "31150",
    labelFi: "Konetekniikan asiantuntijat",
    labelEn: "Mechanical engineering technicians",
    labelSv: "Experter inom maskinteknik",
    searchFi: "31150 konetekniikan asiantuntijat",
    searchEn: "31150 mechanical engineering technicians",
    searchSv: "31150 experter inom maskinteknik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31160",
    code: "31160",
    labelFi: "Kemian prosessitekniikan asiantuntijat",
    labelEn: "Chemical engineering technicians",
    labelSv: "Experter inom kemisk processteknik",
    searchFi: "31160 kemian prosessitekniikan asiantuntijat",
    searchEn: "31160 chemical engineering technicians",
    searchSv: "31160 experter inom kemisk processteknik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31170",
    code: "31170",
    labelFi: "Kaivosteollisuuden ja metallurgian asiantuntijat",
    labelEn: "Mining and metallurgical technicians",
    labelSv: "Experter inom gruvindustri och metallurgi",
    searchFi: "31170 kaivosteollisuuden ja metallurgian asiantuntijat",
    searchEn: "31170 mining and metallurgical technicians",
    searchSv: "31170 experter inom gruvindustri och metallurgi",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31180",
    code: "31180",
    labelFi: "Tekniset piirtäjät",
    labelEn: "Draughtspersons",
    labelSv: "Tekniska ritare",
    searchFi: "31180 tekniset piirtäjät",
    searchEn: "31180 draughtspersons",
    searchSv: "31180 tekniska ritare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31190",
    code: "31190",
    labelFi: "Muut fysiikan, kemian ja teknisten alojen asiantuntijat",
    labelEn: "Physical and engineering science technicians not elsewhere classified",
    labelSv: "Övriga experter inom fysik, kemi och teknik",
    searchFi: "31190 muut fysiikan, kemian ja teknisten alojen asiantuntijat",
    searchEn: "31190 physical and engineering science technicians not elsewhere classified",
    searchSv: "31190 övriga experter inom fysik, kemi och teknik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31210",
    code: "31210",
    labelFi: "Kaivostyönjohtajat",
    labelEn: "Mining supervisors",
    labelSv: "Arbetsledare inom gruvdrift",
    searchFi: "31210 kaivostyönjohtajat",
    searchEn: "31210 mining supervisors",
    searchSv: "31210 arbetsledare inom gruvdrift",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31220",
    code: "31220",
    labelFi: "Teollisuuden työnjohtajat",
    labelEn: "Manufacturing supervisors",
    labelSv: "Arbetsledare inom industri",
    searchFi: "31220 teollisuuden työnjohtajat",
    searchEn: "31220 manufacturing supervisors",
    searchSv: "31220 arbetsledare inom industri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31230",
    code: "31230",
    labelFi: "Rakennusalan työnjohtajat",
    labelEn: "Construction supervisors",
    labelSv: "Arbetsledare inom byggverksamhet",
    searchFi: "31230 rakennusalan työnjohtajat",
    searchEn: "31230 construction supervisors",
    searchSv: "31230 arbetsledare inom byggverksamhet",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31310",
    code: "31310",
    labelFi: "Voimalaitosten prosessinhoitajat",
    labelEn: "Power production plant operators",
    labelSv: "Processövervakare, kraftverk",
    searchFi: "31310 voimalaitosten prosessinhoitajat",
    searchEn: "31310 power production plant operators",
    searchSv: "31310 processövervakare, kraftverk",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31320",
    code: "31320",
    labelFi: "Jätteenpoltto- ja vedenpuhdistuslaitosten prosessinhoitajat",
    labelEn: "Incinerator and water treatment plant operators",
    labelSv: "Processövervakare, förbränningsstationer och vattenreningsverk",
    searchFi: "31320 jätteenpoltto- ja vedenpuhdistuslaitosten prosessinhoitajat",
    searchEn: "31320 incinerator and water treatment plant operators",
    searchSv: "31320 processövervakare, förbränningsstationer och vattenreningsverk",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31330",
    code: "31330",
    labelFi: "Kemianteollisuuden prosessinhoitajat",
    labelEn: "Chemical processing plant controllers",
    labelSv: "Processövervakare, kemisk industri",
    searchFi: "31330 kemianteollisuuden prosessinhoitajat",
    searchEn: "31330 chemical processing plant controllers",
    searchSv: "31330 processövervakare, kemisk industri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31340",
    code: "31340",
    labelFi: "Öljy- ja maakaasujalostamon prosessinhoitajat",
    labelEn: "Petroleum and natural gas refining plant operators",
    labelSv: "Processövervakare, raffinering av petroleum och naturgas",
    searchFi: "31340 öljy- ja maakaasujalostamon prosessinhoitajat",
    searchEn: "31340 petroleum and natural gas refining plant operators",
    searchSv: "31340 processövervakare, raffinering av petroleum och naturgas",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31350",
    code: "31350",
    labelFi: "Metallien jalostuksen prosessinhoitajat",
    labelEn: "Metal production process controllers",
    labelSv: "Processövervakare, metallframställning",
    searchFi: "31350 metallien jalostuksen prosessinhoitajat",
    searchEn: "31350 metal production process controllers",
    searchSv: "31350 processövervakare, metallframställning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31390",
    code: "31390",
    labelFi: "Muut prosessinvalvonnan asiantuntijat",
    labelEn: "Process control technicians not elsewhere classified",
    labelSv: "Övriga experter inom processövervakning",
    searchFi: "31390 muut prosessinvalvonnan asiantuntijat",
    searchEn: "31390 process control technicians not elsewhere classified",
    searchSv: "31390 övriga experter inom processövervakning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31410",
    code: "31410",
    labelFi: "Laborantit ym.",
    labelEn: "Life science technicians (excluding medical)",
    labelSv: "Laboranter m.fl.",
    searchFi: "31410 laborantit ym.",
    searchEn: "31410 life science technicians (excluding medical)",
    searchSv: "31410 laboranter m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31420",
    code: "31420",
    labelFi: "Maa- ja kalatalousteknikot",
    labelEn: "Agricultural technicians",
    labelSv: "Jordbruks- och fiskeritekniker",
    searchFi: "31420 maa- ja kalatalousteknikot",
    searchEn: "31420 agricultural technicians",
    searchSv: "31420 jordbruks- och fiskeritekniker",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31430",
    code: "31430",
    labelFi: "Metsätalousteknikot",
    labelEn: "Forestry technicians",
    labelSv: "Skogsbrukstekniker",
    searchFi: "31430 metsätalousteknikot",
    searchEn: "31430 forestry technicians",
    searchSv: "31430 skogsbrukstekniker",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31510",
    code: "31510",
    labelFi: "Laivojen konepäälliköt ja -mestarit",
    labelEn: "Ships' engineers",
    labelSv: "Maskinchefer och -mästare på fartyg",
    searchFi: "31510 laivojen konepäälliköt ja -mestarit",
    searchEn: "31510 ships' engineers",
    searchSv: "31510 maskinchefer och -mästare på fartyg",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31521",
    code: "31521",
    labelFi: "Isojen alusten päälliköt ja perämiehet",
    labelEn: "Large ships' officers and mates",
    labelSv: "Fartygsbefäl och styrmän (stora fartyg)",
    searchFi: "31521 isojen alusten päälliköt ja perämiehet",
    searchEn: "31521 large ships' officers and mates",
    searchSv: "31521 fartygsbefäl och styrmän (stora fartyg)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31522",
    code: "31522",
    labelFi: "Pienten alusten päälliköt",
    labelEn: "Small ships' officers",
    labelSv: "Befäl (mindre fartyg)",
    searchFi: "31522 pienten alusten päälliköt",
    searchEn: "31522 small ships' officers",
    searchSv: "31522 befäl (mindre fartyg)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31523",
    code: "31523",
    labelFi: "Satamaliikenteen ohjaajat ja satamakapteenit",
    labelEn: "Harbour traffic controllers and harbour masters",
    labelSv: "Hamntrafikledare och hamnkaptener",
    searchFi: "31523 satamaliikenteen ohjaajat ja satamakapteenit",
    searchEn: "31523 harbour traffic controllers and harbour masters",
    searchSv: "31523 hamntrafikledare och hamnkaptener",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31530",
    code: "31530",
    labelFi: "Lentokapteenit ja -perämiehet",
    labelEn: "Aircraft pilots and related associate professionals",
    labelSv: "Flygkaptener och -styrmän",
    searchFi: "31530 lentokapteenit ja -perämiehet",
    searchEn: "31530 aircraft pilots and related associate professionals",
    searchSv: "31530 flygkaptener och -styrmän",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31540",
    code: "31540",
    labelFi: "Lennonjohtajat",
    labelEn: "Air traffic controllers",
    labelSv: "Flygledare",
    searchFi: "31540 lennonjohtajat",
    searchEn: "31540 air traffic controllers",
    searchSv: "31540 flygledare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "31550",
    code: "31550",
    labelFi: "Lennonvalvonnan tekniset asiantuntijat",
    labelEn: "Air traffic safety electronics technicians",
    labelSv: "Tekniska experter inom flygövervakning",
    searchFi: "31550 lennonvalvonnan tekniset asiantuntijat",
    searchEn: "31550 air traffic safety electronics technicians",
    searchSv: "31550 tekniska experter inom flygövervakning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32110",
    code: "32110",
    labelFi: "Lääketieteellisen kuvantamis- ja laitetekniikan asiantuntijat",
    labelEn: "Medical imaging and therapeutic equipment technicians",
    labelSv: "Experter, bilddiagnostik och medicinteknisk utrustning",
    searchFi: "32110 lääketieteellisen kuvantamis- ja laitetekniikan asiantuntijat",
    searchEn: "32110 medical imaging and therapeutic equipment technicians",
    searchSv: "32110 experter, bilddiagnostik och medicinteknisk utrustning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32120",
    code: "32120",
    labelFi: "Bioanalyytikot (terveydenhuolto)",
    labelEn: "Medical and pathology laboratory technicians",
    labelSv: "Bioanalytiker (hälsovården)",
    searchFi: "32120 bioanalyytikot (terveydenhuolto)",
    searchEn: "32120 medical and pathology laboratory technicians",
    searchSv: "32120 bioanalytiker (hälsovården)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32130",
    code: "32130",
    labelFi: "Farmaseutit",
    labelEn: "Pharmaceutical technicians and assistants",
    labelSv: "Farmaceuter",
    searchFi: "32130 farmaseutit",
    searchEn: "32130 pharmaceutical technicians and assistants",
    searchSv: "32130 farmaceuter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32141",
    code: "32141",
    labelFi: "Hammasteknikot",
    labelEn: "Dental technicians",
    labelSv: "Tandtekniker",
    searchFi: "32141 hammasteknikot",
    searchEn: "32141 dental technicians",
    searchSv: "32141 tandtekniker",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32142",
    code: "32142",
    labelFi: "Apuvälineteknikot",
    labelEn: "Prosthetist-orthotists",
    labelSv: "Hjälpmedelstekniker",
    searchFi: "32142 apuvälineteknikot",
    searchEn: "32142 prosthetist-orthotists",
    searchSv: "32142 hjälpmedelstekniker",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32211",
    code: "32211",
    labelFi: "Sairaanhoitajat",
    labelEn: "Nurses",
    labelSv: "Sjukskötare",
    searchFi: "32211 sairaanhoitajat",
    searchEn: "32211 nurses",
    searchSv: "32211 sjukskötare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32212",
    code: "32212",
    labelFi: "Terveydenhoitajat",
    labelEn: "Public health nurses",
    labelSv: "Hälsovårdare",
    searchFi: "32212 terveydenhoitajat",
    searchEn: "32212 public health nurses",
    searchSv: "32212 hälsovårdare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32220",
    code: "32220",
    labelFi: "Kätilöt",
    labelEn: "Midwifery associate professionals",
    labelSv: "Barnmorskor",
    searchFi: "32220 kätilöt",
    searchEn: "32220 midwifery associate professionals",
    searchSv: "32220 barnmorskor",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32300",
    code: "32300",
    labelFi: "Luontais- ja vaihtoehtohoitajat",
    labelEn: "Traditional and complementary medicine associate professionals",
    labelSv: "Utövare av naturmedicin och alternativ medicin",
    searchFi: "32300 luontais- ja vaihtoehtohoitajat",
    searchEn: "32300 traditional and complementary medicine associate professionals",
    searchSv: "32300 utövare av naturmedicin och alternativ medicin",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32400",
    code: "32400",
    labelFi: "Seminologit ym.",
    labelEn: "Veterinary technicians and assistants",
    labelSv: "Seminörer m.fl.",
    searchFi: "32400 seminologit ym.",
    searchEn: "32400 veterinary technicians and assistants",
    searchSv: "32400 seminörer m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32510",
    code: "32510",
    labelFi: "Suuhygienistit",
    labelEn: "Dental assistants and therapists",
    labelSv: "Munhygienister",
    searchFi: "32510 suuhygienistit",
    searchEn: "32510 dental assistants and therapists",
    searchSv: "32510 munhygienister",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32540",
    code: "32540",
    labelFi: "Optikot",
    labelEn: "Dispensing opticians",
    labelSv: "Optiker",
    searchFi: "32540 optikot",
    searchEn: "32540 dispensing opticians",
    searchSv: "32540 optiker",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32550",
    code: "32550",
    labelFi: "Fysioterapeutit ym.",
    labelEn: "Physiotherapy technicians and assistants",
    labelSv: "Fysioterapeuter m.fl.",
    searchFi: "32550 fysioterapeutit ym.",
    searchEn: "32550 physiotherapy technicians and assistants",
    searchSv: "32550 fysioterapeuter m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32570",
    code: "32570",
    labelFi: "Terveys- ja työsuojelutarkastajat",
    labelEn: "Environmental and occupational health inspectors and associates",
    labelSv: "Hälso- och arbetarskyddsinspektörer",
    searchFi: "32570 terveys- ja työsuojelutarkastajat",
    searchEn: "32570 environmental and occupational health inspectors and associates",
    searchSv: "32570 hälso- och arbetarskyddsinspektörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32580",
    code: "32580",
    labelFi: "Sairaankuljetuksen ensihoitajat",
    labelEn: "Ambulance workers",
    labelSv: "Akutvårdare inom sjuktransporten",
    searchFi: "32580 sairaankuljetuksen ensihoitajat",
    searchEn: "32580 ambulance workers",
    searchSv: "32580 akutvårdare inom sjuktransporten",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32591",
    code: "32591",
    labelFi: "Toimintaterapeutit",
    labelEn: "Occupational therapists",
    labelSv: "Ergoterapeuter",
    searchFi: "32591 toimintaterapeutit",
    searchEn: "32591 occupational therapists",
    searchSv: "32591 ergoterapeuter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "32592",
    code: "32592",
    labelFi: "Muut terapeutit",
    labelEn: "Other therapists",
    labelSv: "Övriga terapeuter",
    searchFi: "32592 muut terapeutit",
    searchEn: "32592 other therapists",
    searchSv: "32592 övriga terapeuter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33110",
    code: "33110",
    labelFi: "Arvopaperi- ja valuuttakauppiaat",
    labelEn: "Securities and finance dealers and brokers",
    labelSv: "Värdepappers- och valutamäklare",
    searchFi: "33110 arvopaperi- ja valuuttakauppiaat",
    searchEn: "33110 securities and finance dealers and brokers",
    searchSv: "33110 värdepappers- och valutamäklare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33120",
    code: "33120",
    labelFi: "Luotto- ja laina-asiantuntijat",
    labelEn: "Credit and loans officers",
    labelSv: "Kredit- och låneexperter",
    searchFi: "33120 luotto- ja laina-asiantuntijat",
    searchEn: "33120 credit and loans officers",
    searchSv: "33120 kredit- och låneexperter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33130",
    code: "33130",
    labelFi: "Kirjanpidon ja laskentatoimen asiantuntijat",
    labelEn: "Accounting associate professionals",
    labelSv: "Experter inom bokföring och redovisning",
    searchFi: "33130 kirjanpidon ja laskentatoimen asiantuntijat",
    searchEn: "33130 accounting associate professionals",
    searchSv: "33130 experter inom bokföring och redovisning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33140",
    code: "33140",
    labelFi: "Tilastointi- ja matematiikka-asiantuntijat",
    labelEn: "Statistical, mathematical and related associate professionals",
    labelSv: "Experter inom statistik och matematik",
    searchFi: "33140 tilastointi- ja matematiikka-asiantuntijat",
    searchEn: "33140 statistical, mathematical and related associate professionals",
    searchSv: "33140 experter inom statistik och matematik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33150",
    code: "33150",
    labelFi: "Arvioitsijat ja vahinkotarkastajat",
    labelEn: "Valuers and loss assessors",
    labelSv: "Värderare och skadeinspektörer",
    searchFi: "33150 arvioitsijat ja vahinkotarkastajat",
    searchEn: "33150 valuers and loss assessors",
    searchSv: "33150 värderare och skadeinspektörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33210",
    code: "33210",
    labelFi: "Vakuutusalan palvelumyyjät",
    labelEn: "Insurance representatives",
    labelSv: "Försäljare av försäkringstjänster",
    searchFi: "33210 vakuutusalan palvelumyyjät",
    searchEn: "33210 insurance representatives",
    searchSv: "33210 försäljare av försäkringstjänster",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33220",
    code: "33220",
    labelFi: "Myyntiedustajat",
    labelEn: "Commercial sales representatives",
    labelSv: "Försäljningsrepresentanter",
    searchFi: "33220 myyntiedustajat sales",
    searchEn: "33220 commercial sales representatives",
    searchSv: "33220 försäljningsrepresentanter",
    freeTextFi: "sales",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "33230",
    code: "33230",
    labelFi: "Sisäänostajat",
    labelEn: "Buyers",
    labelSv: "Inköpare",
    searchFi: "33230 sisäänostajat",
    searchEn: "33230 buyers",
    searchSv: "33230 inköpare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33240",
    code: "33240",
    labelFi: "Kaupanvälittäjät",
    labelEn: "Trade brokers",
    labelSv: "Affärsförmedlare",
    searchFi: "33240 kaupanvälittäjät",
    searchEn: "33240 trade brokers",
    searchSv: "33240 affärsförmedlare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33310",
    code: "33310",
    labelFi: "Huolitsijat, tulli- ja laivanselvittäjät",
    labelEn: "Clearing and forwarding agents",
    labelSv: "Speditörer, tull- och fartygsklarerare",
    searchFi: "33310 huolitsijat, tulli- ja laivanselvittäjät",
    searchEn: "33310 clearing and forwarding agents",
    searchSv: "33310 speditörer, tull- och fartygsklarerare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33320",
    code: "33320",
    labelFi: "Konferenssi- ja tapahtumajärjestäjät",
    labelEn: "Conference and event planners",
    labelSv: "Konferens- och evenemangsarrangörer",
    searchFi: "33320 konferenssi- ja tapahtumajärjestäjät",
    searchEn: "33320 conference and event planners",
    searchSv: "33320 konferens- och evenemangsarrangörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33330",
    code: "33330",
    labelFi: "Työnvälittäjät",
    labelEn: "Employment agents and contractors",
    labelSv: "Arbetsförmedlare",
    searchFi: "33330 työnvälittäjät",
    searchEn: "33330 employment agents and contractors",
    searchSv: "33330 arbetsförmedlare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33341",
    code: "33341",
    labelFi: "Kiinteistönvälittäjät",
    labelEn: "Estate agents",
    labelSv: "Fastighetsmäklare",
    searchFi: "33341 kiinteistönvälittäjät",
    searchEn: "33341 estate agents",
    searchSv: "33341 fastighetsmäklare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33342",
    code: "33342",
    labelFi: "Isännöitsijät",
    labelEn: "Property managers",
    labelSv: "Disponenter",
    searchFi: "33342 isännöitsijät",
    searchEn: "33342 property managers",
    searchSv: "33342 disponenter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33390",
    code: "33390",
    labelFi: "Muut liike-elämän asiantuntijat",
    labelEn: "Business services agents not elsewhere classified",
    labelSv: "Övriga experter inom affärslivet",
    searchFi: "33390 muut liike-elämän asiantuntijat",
    searchEn: "33390 business services agents not elsewhere classified",
    searchSv: "33390 övriga experter inom affärslivet",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33410",
    code: "33410",
    labelFi: "Toimistotyön esimiehet",
    labelEn: "Office supervisors",
    labelSv: "Arbetsledare för kontorspersonal",
    searchFi: "33410 toimistotyön esimiehet",
    searchEn: "33410 office supervisors",
    searchSv: "33410 arbetsledare för kontorspersonal",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33420",
    code: "33420",
    labelFi: "Asianajosihteerit",
    labelEn: "Legal secretaries",
    labelSv: "Juristsekreterare",
    searchFi: "33420 asianajosihteerit",
    searchEn: "33420 legal secretaries",
    searchSv: "33420 juristsekreterare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33430",
    code: "33430",
    labelFi: "Johdon sihteerit ja osastosihteerit",
    labelEn: "Administrative and executive secretaries",
    labelSv: "Ledningsassistenter och avdelningssekreterare",
    searchFi: "33430 johdon sihteerit ja osastosihteerit",
    searchEn: "33430 administrative and executive secretaries",
    searchSv: "33430 ledningsassistenter och avdelningssekreterare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33440",
    code: "33440",
    labelFi: "Toimistosihteerit (terveydenhuolto)",
    labelEn: "Medical secretaries",
    labelSv: "Byråsekreterare, hälso- och sjukvård",
    searchFi: "33440 toimistosihteerit (terveydenhuolto)",
    searchEn: "33440 medical secretaries",
    searchSv: "33440 byråsekreterare, hälso- och sjukvård",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33510",
    code: "33510",
    labelFi: "Tulli- ja rajavirkamiehet",
    labelEn: "Customs and border inspectors",
    labelSv: "Tull- och gränstjänstemän",
    searchFi: "33510 tulli- ja rajavirkamiehet",
    searchEn: "33510 customs and border inspectors",
    searchSv: "33510 tull- och gränstjänstemän",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33520",
    code: "33520",
    labelFi: "Verovalmistelijat ja -tarkastajat",
    labelEn: "Government tax and excise officials",
    labelSv: "Skatteberedare och -inspektörer",
    searchFi: "33520 verovalmistelijat ja -tarkastajat",
    searchEn: "33520 government tax and excise officials",
    searchSv: "33520 skatteberedare och -inspektörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33530",
    code: "33530",
    labelFi: "Sosiaaliturvaetuuksien käsittelijät",
    labelEn: "Government social benefits officials",
    labelSv: "Handläggare av socialskyddsförmåner",
    searchFi: "33530 sosiaaliturvaetuuksien käsittelijät",
    searchEn: "33530 government social benefits officials",
    searchSv: "33530 handläggare av socialskyddsförmåner",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33540",
    code: "33540",
    labelFi: "Lupavirkamiehet",
    labelEn: "Government licensing officials",
    labelSv: "Tillståndstjänstemän",
    searchFi: "33540 lupavirkamiehet",
    searchEn: "33540 government licensing officials",
    searchSv: "33540 tillståndstjänstemän",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33550",
    code: "33550",
    labelFi: "Komisariot ja ylikonstaapelit",
    labelEn: "Police inspectors and detectives",
    labelSv: "Kommissarier och överkonstaplar",
    searchFi: "33550 komisariot ja ylikonstaapelit",
    searchEn: "33550 police inspectors and detectives",
    searchSv: "33550 kommissarier och överkonstaplar",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "33590",
    code: "33590",
    labelFi: "Muut julkishallinnon valmistelu- ja valvontavirkamiehet",
    labelEn: "Regulatory government associate professionals not elsewhere classified",
    labelSv: "Övriga tjänstemän inom beredning och tillsyn inom offentlig förvaltning",
    searchFi: "33590 muut julkishallinnon valmistelu- ja valvontavirkamiehet",
    searchEn: "33590 regulatory government associate professionals not elsewhere classified",
    searchSv: "33590 övriga tjänstemän inom beredning och tillsyn inom offentlig förvaltning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34111",
    code: "34111",
    labelFi: "Oikeudenkäyntiasiamiehet ja ulosottomiehet",
    labelEn: "Legal and related business associate professionals",
    labelSv: "Rättegångsombud och utsökningsmän",
    searchFi: "34111 oikeudenkäyntiasiamiehet ja ulosottomiehet",
    searchEn: "34111 legal and related business associate professionals",
    searchSv: "34111 rättegångsombud och utsökningsmän",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34112",
    code: "34112",
    labelFi: "Asiamiehet, toimitsijat ym. järjestöalan asiantuntijat",
    labelEn: "Agents, officials and other organisation associate professionals",
    labelSv: "Ombud, funktionärer m.fl. experter inom organisationssektorn",
    searchFi: "34112 asiamiehet, toimitsijat ym. järjestöalan asiantuntijat",
    searchEn: "34112 agents, officials and other organisation associate professionals",
    searchSv: "34112 ombud, funktionärer m.fl. experter inom organisationssektorn",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34113",
    code: "34113",
    labelFi: "Kuluttajaneuvojat ym.",
    labelEn: "Consumer advisers, etc.",
    labelSv: "Konsumentrådgivare m.fl.",
    searchFi: "34113 kuluttajaneuvojat ym.",
    searchEn: "34113 consumer advisers, etc.",
    searchSv: "34113 konsumentrådgivare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34121",
    code: "34121",
    labelFi: "Sosiaalialan ohjaajat",
    labelEn: "Social instructors",
    labelSv: "Handledare inom socialsektorn",
    searchFi: "34121 sosiaalialan ohjaajat",
    searchEn: "34121 social instructors",
    searchSv: "34121 handledare inom socialsektorn",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34122",
    code: "34122",
    labelFi: "Nuorisotyön ohjaajat (ei srk.)",
    labelEn: "Youth leaders (not parishes)",
    labelSv: "Ungdomsledare (ej församl.)",
    searchFi: "34122 nuorisotyön ohjaajat (ei srk.)",
    searchEn: "34122 youth leaders (not parishes)",
    searchSv: "34122 ungdomsledare (ej församl.)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34123",
    code: "34123",
    labelFi: "Työn- ja askarteluohjaajat",
    labelEn: "Work and craft leaders",
    labelSv: "Handledare och sysselsättningsledare",
    searchFi: "34123 työn- ja askarteluohjaajat",
    searchEn: "34123 work and craft leaders",
    searchSv: "34123 handledare och sysselsättningsledare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34131",
    code: "34131",
    labelFi: "Diakonit ja diakonissat",
    labelEn: "Deacons and deaconesses",
    labelSv: "Diakoner och diakonissor",
    searchFi: "34131 diakonit ja diakonissat",
    searchEn: "34131 deacons and deaconesses",
    searchSv: "34131 diakoner och diakonissor",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34139",
    code: "34139",
    labelFi: "Muut seurakuntatyöntekijät",
    labelEn: "Other religious associate professionals",
    labelSv: "Övriga församlingsarbetare",
    searchFi: "34139 muut seurakuntatyöntekijät",
    searchEn: "34139 other religious associate professionals",
    searchSv: "34139 övriga församlingsarbetare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34210",
    code: "34210",
    labelFi: "Urheilijat",
    labelEn: "Athletes and sports players",
    labelSv: "Idrottare",
    searchFi: "34210 urheilijat",
    searchEn: "34210 athletes and sports players",
    searchSv: "34210 idrottare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34220",
    code: "34220",
    labelFi: "Urheiluvalmentajat ja toimitsijat",
    labelEn: "Sports coaches, instructors and officials",
    labelSv: "Idrottstränare och funktionärer",
    searchFi: "34220 urheiluvalmentajat ja toimitsijat",
    searchEn: "34220 sports coaches, instructors and officials",
    searchSv: "34220 idrottstränare och funktionärer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34230",
    code: "34230",
    labelFi: "Liikunnan ja vapaa-ajan ohjaajat",
    labelEn: "Fitness and recreation instructors and program leaders",
    labelSv: "Idrottsinstruktörer och fritidsledare",
    searchFi: "34230 liikunnan ja vapaa-ajan ohjaajat",
    searchEn: "34230 fitness and recreation instructors and program leaders",
    searchSv: "34230 idrottsinstruktörer och fritidsledare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34310",
    code: "34310",
    labelFi: "Valokuvaajat",
    labelEn: "Photographers",
    labelSv: "Fotografer",
    searchFi: "34310 valokuvaajat",
    searchEn: "34310 photographers",
    searchSv: "34310 fotografer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34320",
    code: "34320",
    labelFi: "Sisustussuunnittelijat ym.",
    labelEn: "Interior designers and decorators",
    labelSv: "Inredningsplanerare m.fl.",
    searchFi: "34320 sisustussuunnittelijat ym.",
    searchEn: "34320 interior designers and decorators",
    searchSv: "34320 inredningsplanerare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34330",
    code: "34330",
    labelFi: "Gallerioiden, museoiden ja kirjastojen tekniset työntekijät",
    labelEn: "Gallery, museum and library technicians",
    labelSv: "Galleri-, musei- och bibliotekstekniker",
    searchFi: "34330 gallerioiden, museoiden ja kirjastojen tekniset työntekijät",
    searchEn: "34330 gallery, museum and library technicians",
    searchSv: "34330 galleri-, musei- och bibliotekstekniker",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34340",
    code: "34340",
    labelFi: "Keittiöpäälliköt",
    labelEn: "Chefs",
    labelSv: "Kökschefer",
    searchFi: "34340 keittiöpäälliköt",
    searchEn: "34340 chefs",
    searchSv: "34340 kökschefer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34351",
    code: "34351",
    labelFi: "Kuvaussihteerit ja muut näyttämötekniset asiantuntijat",
    labelEn: "Producer's assistants and other stagecraft associate professionals",
    labelSv: "Scriptor och övriga experter inom scenteknik",
    searchFi: "34351 kuvaussihteerit ja muut näyttämötekniset asiantuntijat",
    searchEn: "34351 producer's assistants and other stagecraft associate professionals",
    searchSv: "34351 scriptor och övriga experter inom scenteknik",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "34359",
    code: "34359",
    labelFi: "Muut taide- ja kulttuurialan tekniset asiantuntijat",
    labelEn: "Other artistic and cultural associate professionals",
    labelSv: "Övriga experter inom konst- och konstindustrisektorn",
    searchFi: "34359 muut taide- ja kulttuurialan tekniset asiantuntijat",
    searchEn: "34359 other artistic and cultural associate professionals",
    searchSv: "34359 övriga experter inom konst- och konstindustrisektorn",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "35110",
    code: "35110",
    labelFi: "Käytön operaattorit",
    labelEn: "Information and communications technology operations technicians",
    labelSv: "Driftoperatörer",
    searchFi: "35110 käytön operaattorit",
    searchEn: "35110 information and communications technology operations technicians",
    searchSv: "35110 driftoperatörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "35120",
    code: "35120",
    labelFi: "Käytön tukihenkilöt",
    labelEn: "Information and communications technology user support technicians",
    labelSv: "Datasupportpersonal",
    searchFi: "35120 käytön tukihenkilöt",
    searchEn: "35120 information and communications technology user support technicians",
    searchSv: "35120 datasupportpersonal",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "35130",
    code: "35130",
    labelFi: "Tietoverkkoteknikot",
    labelEn: "Computer network and systems technicians",
    labelSv: "Nätverkstekniker",
    searchFi: "35130 tietoverkkoteknikot",
    searchEn: "35130 computer network and systems technicians",
    searchSv: "35130 nätverkstekniker",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "35140",
    code: "35140",
    labelFi: "Webmasterit ja -teknikot",
    labelEn: "Web technicians",
    labelSv: "Webbmaster och webbtekniker",
    searchFi: "35140 webmasterit ja -teknikot",
    searchEn: "35140 web technicians",
    searchSv: "35140 webbmaster och webbtekniker",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "35210",
    code: "35210",
    labelFi: "Lähetys- ja audiovisuaaliteknikot",
    labelEn: "Broadcasting and audio-visual technicians",
    labelSv: "Sändnings- och AV-tekniker",
    searchFi: "35210 lähetys- ja audiovisuaaliteknikot",
    searchEn: "35210 broadcasting and audio-visual technicians",
    searchSv: "35210 sändnings- och av-tekniker",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "35220",
    code: "35220",
    labelFi: "Televiestinnän tekniset asiantuntijat",
    labelEn: "Telecommunications engineering technicians",
    labelSv: "Tekniska experter inom telekommunikation",
    searchFi: "35220 televiestinnän tekniset asiantuntijat",
    searchEn: "35220 telecommunications engineering technicians",
    searchSv: "35220 tekniska experter inom telekommunikation",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "41100",
    code: "41100",
    labelFi: "Toimistoavustajat",
    labelEn: "General office clerks",
    labelSv: "Kontorsassistenter",
    searchFi: "41100 toimistoavustajat",
    searchEn: "41100 general office clerks",
    searchSv: "41100 kontorsassistenter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "41200",
    code: "41200",
    labelFi: "Yleissihteerit",
    labelEn: "Secretaries (general)",
    labelSv: "Kontorssekreterare",
    searchFi: "41200 yleissihteerit",
    searchEn: "41200 secretaries (general)",
    searchSv: "41200 kontorssekreterare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "41310",
    code: "41310",
    labelFi: "Tekstinkäsittelijät",
    labelEn: "Typists and word processing operators",
    labelSv: "Textbehandlare",
    searchFi: "41310 tekstinkäsittelijät",
    searchEn: "41310 typists and word processing operators",
    searchSv: "41310 textbehandlare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "41320",
    code: "41320",
    labelFi: "Tallentajat",
    labelEn: "Data entry clerks",
    labelSv: "Dataregistrerare",
    searchFi: "41320 tallentajat",
    searchEn: "41320 data entry clerks",
    searchSv: "41320 dataregistrerare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "42110",
    code: "42110",
    labelFi: "Pankki- ym. toimihenkilöt",
    labelEn: "Bank tellers and related clerks",
    labelSv: "Banktjänstemän m.fl.",
    searchFi: "42110 pankki- ym. toimihenkilöt",
    searchEn: "42110 bank tellers and related clerks",
    searchSv: "42110 banktjänstemän m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "42120",
    code: "42120",
    labelFi: "Vedonvälittäjät, bingo- ja kasinopelin hoitajat ym.",
    labelEn: "Bookmakers, croupiers and related gaming workers",
    labelSv: "Vadförmedlare, croupierer m.fl.",
    searchFi: "42120 vedonvälittäjät, bingo- ja kasinopelin hoitajat ym.",
    searchEn: "42120 bookmakers, croupiers and related gaming workers",
    searchSv: "42120 vadförmedlare, croupierer m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "42130",
    code: "42130",
    labelFi: "Panttilainaajat",
    labelEn: "Pawnbrokers and money-lenders",
    labelSv: "Pantlånare",
    searchFi: "42130 panttilainaajat",
    searchEn: "42130 pawnbrokers and money-lenders",
    searchSv: "42130 pantlånare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "42140",
    code: "42140",
    labelFi: "Maksujenperijät",
    labelEn: "Debt-collectors and related workers",
    labelSv: "Inkasserare",
    searchFi: "42140 maksujenperijät",
    searchEn: "42140 debt-collectors and related workers",
    searchSv: "42140 inkasserare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "42210",
    code: "42210",
    labelFi: "Matkatoimistovirkailijat",
    labelEn: "Travel consultants and clerks",
    labelSv: "Resebyråtjänstemän",
    searchFi: "42210 matkatoimistovirkailijat",
    searchEn: "42210 travel consultants and clerks",
    searchSv: "42210 resebyråtjänstemän",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "42220",
    code: "42220",
    labelFi: "Puhelinpalveluneuvojat",
    labelEn: "Contact centre information clerks",
    labelSv: "Telefonservicerådgivare",
    searchFi: "42220 puhelinpalveluneuvojat",
    searchEn: "42220 contact centre information clerks",
    searchSv: "42220 telefonservicerådgivare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "42230",
    code: "42230",
    labelFi: "Puhelinvaihteenhoitajat",
    labelEn: "Telephone switchboard operators",
    labelSv: "Växeltelefonister",
    searchFi: "42230 puhelinvaihteenhoitajat",
    searchEn: "42230 telephone switchboard operators",
    searchSv: "42230 växeltelefonister",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "42240",
    code: "42240",
    labelFi: "Hotellin vastaanottovirkailijat",
    labelEn: "Hotel receptionists",
    labelSv: "Hotellreceptionister",
    searchFi: "42240 hotellin vastaanottovirkailijat",
    searchEn: "42240 hotel receptionists",
    searchSv: "42240 hotellreceptionister",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "42250",
    code: "42250",
    labelFi: "Informaatiopisteen asiakasneuvojat",
    labelEn: "Enquiry clerks",
    labelSv: "Kundrådgivare vid informationsdisk",
    searchFi: "42250 informaatiopisteen asiakasneuvojat",
    searchEn: "42250 enquiry clerks",
    searchSv: "42250 kundrådgivare vid informationsdisk",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "42260",
    code: "42260",
    labelFi: "Vastaanoton ja neuvonnan hoitajat",
    labelEn: "Receptionists (general)",
    labelSv: "Receptions- och rådgivningspersonal",
    searchFi: "42260 vastaanoton ja neuvonnan hoitajat",
    searchEn: "42260 receptionists (general)",
    searchSv: "42260 receptions- och rådgivningspersonal",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "42270",
    code: "42270",
    labelFi: "Tutkimus- ja markkinatutkimushaastattelijat",
    labelEn: "Survey and market research interviewers",
    labelSv: "Undersöknings- och marknadsundersökningsintervjuare",
    searchFi: "42270 tutkimus- ja markkinatutkimushaastattelijat",
    searchEn: "42270 survey and market research interviewers",
    searchSv: "42270 undersöknings- och marknadsundersökningsintervjuare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "42291",
    code: "42291",
    labelFi: "Hälytyspäivystäjät",
    labelEn: "Emergency officers",
    labelSv: "Nödcentraloperatörer",
    searchFi: "42291 hälytyspäivystäjät",
    searchEn: "42291 emergency officers",
    searchSv: "42291 nödcentraloperatörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "42299",
    code: "42299",
    labelFi: "Muut muualla luokittelemattomat asiakaspalvelutyöntekijät",
    labelEn: "Other client information clerks not elsewhere classified",
    labelSv: "Övrig kundtjänstpersonal utan annan klassificering",
    searchFi: "42299 muut muualla luokittelemattomat asiakaspalvelutyöntekijät",
    searchEn: "42299 other client information clerks not elsewhere classified",
    searchSv: "42299 övrig kundtjänstpersonal utan annan klassificering",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "43110",
    code: "43110",
    labelFi: "Taloushallinnon toimistotyöntekijät",
    labelEn: "Accounting and bookkeeping clerks",
    labelSv: "Kontorspersonal inom ekonomiförvaltning",
    searchFi: "43110 taloushallinnon toimistotyöntekijät",
    searchEn: "43110 accounting and bookkeeping clerks",
    searchSv: "43110 kontorspersonal inom ekonomiförvaltning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "43120",
    code: "43120",
    labelFi: "Tilasto-, rahoitus- ja vakuutusalan toimistotyöntekijät",
    labelEn: "Statistical, finance and insurance clerks",
    labelSv: "Kontorspersonal inom statistik-, finansierings- och försäkringssektorn",
    searchFi: "43120 tilasto-, rahoitus- ja vakuutusalan toimistotyöntekijät",
    searchEn: "43120 statistical, finance and insurance clerks",
    searchSv: "43120 kontorspersonal inom statistik-, finansierings- och försäkringssektorn",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "43130",
    code: "43130",
    labelFi: "Palkanlaskijat",
    labelEn: "Payroll clerks",
    labelSv: "Löneräknare",
    searchFi: "43130 palkanlaskijat",
    searchEn: "43130 payroll clerks",
    searchSv: "43130 löneräknare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "43210",
    code: "43210",
    labelFi: "Varastonhoitajat ym.",
    labelEn: "Stock clerks",
    labelSv: "Lagerförvaltare m.fl.",
    searchFi: "43210 varastonhoitajat ym.",
    searchEn: "43210 stock clerks",
    searchSv: "43210 lagerförvaltare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "43220",
    code: "43220",
    labelFi: "Tuotannon valmistelijat",
    labelEn: "Production clerks",
    labelSv: "Produktionsassistenter",
    searchFi: "43220 tuotannon valmistelijat",
    searchEn: "43220 production clerks",
    searchSv: "43220 produktionsassistenter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "43231",
    code: "43231",
    labelFi: "Raideliikenteen ohjaajat, ajojärjestelijät ym.",
    labelEn: "Rail traffic controllers, traffic co-ordinators, etc.",
    labelSv: "Spårtrafikledare, trafiksamordnare m.fl.",
    searchFi: "43231 raideliikenteen ohjaajat, ajojärjestelijät ym.",
    searchEn: "43231 rail traffic controllers, traffic co-ordinators, etc.",
    searchSv: "43231 spårtrafikledare, trafiksamordnare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "43239",
    code: "43239",
    labelFi: "Muut kuljetuksen ja huolinnan toimistotyöntekijät",
    labelEn: "Other transport clerks",
    labelSv: "Övriga kontorstjänstemän inom transport och spedition",
    searchFi: "43239 muut kuljetuksen ja huolinnan toimistotyöntekijät",
    searchEn: "43239 other transport clerks",
    searchSv: "43239 övriga kontorstjänstemän inom transport och spedition",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "44110",
    code: "44110",
    labelFi: "Kirjastotyöntekijät",
    labelEn: "Library clerks",
    labelSv: "Bibliotekspersonal",
    searchFi: "44110 kirjastotyöntekijät",
    searchEn: "44110 library clerks",
    searchSv: "44110 bibliotekspersonal",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "44121",
    code: "44121",
    labelFi: "Postinkantajat",
    labelEn: "Mail carriers",
    labelSv: "Brevbärare",
    searchFi: "44121 postinkantajat",
    searchEn: "44121 mail carriers",
    searchSv: "44121 brevbärare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "44122",
    code: "44122",
    labelFi: "Toimistovahtimestarit",
    labelEn: "Porters",
    labelSv: "Kontorsvaktmästare",
    searchFi: "44122 toimistovahtimestarit",
    searchEn: "44122 porters",
    searchSv: "44122 kontorsvaktmästare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "44130",
    code: "44130",
    labelFi: "Koodaajat, oikolukijat ym.",
    labelEn: "Coding, proof-reading and related clerks",
    labelSv: "Kodare, korrekturläsare m.fl.",
    searchFi: "44130 koodaajat, oikolukijat ym.",
    searchEn: "44130 coding, proof-reading and related clerks",
    searchSv: "44130 kodare, korrekturläsare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "44150",
    code: "44150",
    labelFi: "Arkistotyöntekijät",
    labelEn: "Filing and copying clerks",
    labelSv: "Arkivanställda",
    searchFi: "44150 arkistotyöntekijät",
    searchEn: "44150 filing and copying clerks",
    searchSv: "44150 arkivanställda",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "44160",
    code: "44160",
    labelFi: "Henkilöstöhallinnon avustavat toimistotyöntekijät",
    labelEn: "Personnel clerks",
    labelSv: "Assisterande kontorspersonal inom personalförvaltning",
    searchFi: "44160 henkilöstöhallinnon avustavat toimistotyöntekijät",
    searchEn: "44160 personnel clerks",
    searchSv: "44160 assisterande kontorspersonal inom personalförvaltning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "44190",
    code: "44190",
    labelFi: "Muut muualla luokittelemattomat toimisto- ja asiakaspalvelutyöntekijät",
    labelEn: "Clerical support workers not elsewhere classified",
    labelSv: "Övrig kontors- och kundtjänstpersonal utan annan klassificering",
    searchFi: "44190 muut muualla luokittelemattomat toimisto- ja asiakaspalvelutyöntekijät",
    searchEn: "44190 clerical support workers not elsewhere classified",
    searchSv: "44190 övrig kontors- och kundtjänstpersonal utan annan klassificering",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51110",
    code: "51110",
    labelFi: "Lentoemännät, purserit ym.",
    labelEn: "Travel attendants and travel stewards",
    labelSv: "Flygvärdinnor, purser m.fl.",
    searchFi: "51110 lentoemännät, purserit ym.",
    searchEn: "51110 travel attendants and travel stewards",
    searchSv: "51110 flygvärdinnor, purser m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51120",
    code: "51120",
    labelFi: "Konduktöörit, lipuntarkastajat ym.",
    labelEn: "Transport conductors",
    labelSv: "Konduktörer, biljettkontrollanter m.fl.",
    searchFi: "51120 konduktöörit, lipuntarkastajat ym.",
    searchEn: "51120 transport conductors",
    searchSv: "51120 konduktörer, biljettkontrollanter m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51130",
    code: "51130",
    labelFi: "Matkaoppaat",
    labelEn: "Travel guides",
    labelSv: "Guider",
    searchFi: "51130 matkaoppaat",
    searchEn: "51130 travel guides",
    searchSv: "51130 guider",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51201",
    code: "51201",
    labelFi: "Kokit, keittäjät ja kylmäköt",
    labelEn: "Cooks",
    labelSv: "Kockar, kokerskor och kallskänkor",
    searchFi: "51201 kokit, keittäjät ja kylmäköt ravintola kahvila",
    searchEn: "51201 cooks",
    searchSv: "51201 kockar, kokerskor och kallskänkor",
    freeTextFi: "ravintola kahvila",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "51202",
    code: "51202",
    labelFi: "Ravintolaesimiehet ja vuoropäälliköt",
    labelEn: "Restaurant services supervisors and shift managers",
    labelSv: "Restaurangföreståndare och skiftledare",
    searchFi: "51202 ravintolaesimiehet ja vuoropäälliköt ravintola kahvila",
    searchEn: "51202 restaurant services supervisors and shift managers",
    searchSv: "51202 restaurangföreståndare och skiftledare",
    freeTextFi: "ravintola kahvila",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51310",
    code: "51310",
    labelFi: "Tarjoilijat",
    labelEn: "Waiters",
    labelSv: "Servitörer",
    searchFi: "51310 tarjoilijat ravintola kahvila",
    searchEn: "51310 waiters",
    searchSv: "51310 servitörer",
    freeTextFi: "ravintola kahvila",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "51320",
    code: "51320",
    labelFi: "Baarimestarit",
    labelEn: "Bartenders",
    labelSv: "Bartendrar",
    searchFi: "51320 baarimestarit ravintola kahvila",
    searchEn: "51320 bartenders",
    searchSv: "51320 bartendrar",
    freeTextFi: "ravintola kahvila",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51410",
    code: "51410",
    labelFi: "Kampaajat ja parturit",
    labelEn: "Hairdressers",
    labelSv: "Frisörer",
    searchFi: "51410 kampaajat ja parturit",
    searchEn: "51410 hairdressers",
    searchSv: "51410 frisörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51420",
    code: "51420",
    labelFi: "Kosmetologit ym.",
    labelEn: "Beauticians and related workers",
    labelSv: "Kosmetologer m.fl.",
    searchFi: "51420 kosmetologit ym.",
    searchEn: "51420 beauticians and related workers",
    searchSv: "51420 kosmetologer m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51510",
    code: "51510",
    labelFi: "Siivoustyön esimiehet toimistoissa, hotelleissa ja muissa laitoksissa",
    labelEn: "Cleaning and housekeeping supervisors in offices, hotels and other establishments",
    labelSv: "Arbetsledare inom städning på kontor, hotell m.fl.",
    searchFi: "51510 siivoustyön esimiehet toimistoissa, hotelleissa ja muissa laitoksissa",
    searchEn: "51510 cleaning and housekeeping supervisors in offices, hotels and other establishments",
    searchSv: "51510 arbetsledare inom städning på kontor, hotell m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51520",
    code: "51520",
    labelFi: "Yksityiskotien taloudenhoitajat",
    labelEn: "Domestic housekeepers",
    labelSv: "Hushållerskor i privata hem",
    searchFi: "51520 yksityiskotien taloudenhoitajat",
    searchEn: "51520 domestic housekeepers",
    searchSv: "51520 hushållerskor i privata hem",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51530",
    code: "51530",
    labelFi: "Kiinteistöhuollon työntekijät",
    labelEn: "Building caretakers",
    labelSv: "Fastighetsskötare",
    searchFi: "51530 kiinteistöhuollon työntekijät talonmies huolto siivous",
    searchEn: "51530 building caretakers",
    searchSv: "51530 fastighetsskötare",
    freeTextFi: "talonmies huolto siivous",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company household"
  },
  {
    id: "51610",
    code: "51610",
    labelFi: "Astrologit, ennustajat ym.",
    labelEn: "Astrologers, fortune-tellers and related workers",
    labelSv: "Astrologer, siare m.fl.",
    searchFi: "51610 astrologit, ennustajat ym.",
    searchEn: "51610 astrologers, fortune-tellers and related workers",
    searchSv: "51610 astrologer, siare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51631",
    code: "51631",
    labelFi: "Hautaustoimistonhoitajat ym.",
    labelEn: "Undertakers and related funeral workers",
    labelSv: "Begravningsbyråföreståndare m.fl.",
    searchFi: "51631 hautaustoimistonhoitajat ym.",
    searchEn: "51631 undertakers and related funeral workers",
    searchSv: "51631 begravningsbyråföreståndare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51632",
    code: "51632",
    labelFi: "Muut hautaustyöntekijät",
    labelEn: "Other funeral workers",
    labelSv: "Övrig begravningspersonal",
    searchFi: "51632 muut hautaustyöntekijät",
    searchEn: "51632 other funeral workers",
    searchSv: "51632 övrig begravningspersonal",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51640",
    code: "51640",
    labelFi: "Eläintenhoitajat ja lemmikkieläinten trimmaajat",
    labelEn: "Pet groomers and animal care workers",
    labelSv: "Djurskötare och djurfrisörer",
    searchFi: "51640 eläintenhoitajat ja lemmikkieläinten trimmaajat",
    searchEn: "51640 pet groomers and animal care workers",
    searchSv: "51640 djurskötare och djurfrisörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51650",
    code: "51650",
    labelFi: "Ajo-opettajat",
    labelEn: "Driving instructors",
    labelSv: "Trafiklärare",
    searchFi: "51650 ajo-opettajat",
    searchEn: "51650 driving instructors",
    searchSv: "51650 trafiklärare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "51690",
    code: "51690",
    labelFi: "Muualla luokittelemattomat henkilökohtaisen palvelun työntekijät",
    labelEn: "Personal services workers not elsewhere classified",
    labelSv: "Övrig servicepersonal inom personliga tjänster utan annan klassificering",
    searchFi: "51690 muualla luokittelemattomat henkilökohtaisen palvelun työntekijät",
    searchEn: "51690 personal services workers not elsewhere classified",
    searchSv: "51690 övrig servicepersonal inom personliga tjänster utan annan klassificering",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "52110",
    code: "52110",
    labelFi: "Kioski- ja torimyyjät",
    labelEn: "Stall and market salespersons",
    labelSv: "Kiosk- och torgförsäljare",
    searchFi: "52110 kioski- ja torimyyjät",
    searchEn: "52110 stall and market salespersons",
    searchSv: "52110 kiosk- och torgförsäljare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "52120",
    code: "52120",
    labelFi: "Katumyyjät (elintarvikkeet)",
    labelEn: "Street food salespersons",
    labelSv: "Gatuförsäljare (livsmedel)",
    searchFi: "52120 katumyyjät (elintarvikkeet)",
    searchEn: "52120 street food salespersons",
    searchSv: "52120 gatuförsäljare (livsmedel)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "52210",
    code: "52210",
    labelFi: "Kauppiaat (pienyrittäjät)",
    labelEn: "Shop keepers",
    labelSv: "Butiksinnehavare (småföretagare)",
    searchFi: "52210 kauppiaat (pienyrittäjät) kauppa",
    searchEn: "52210 shop keepers",
    searchSv: "52210 butiksinnehavare (småföretagare)",
    freeTextFi: "kauppa",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "52220",
    code: "52220",
    labelFi: "Myymäläesimiehet",
    labelEn: "Shop supervisors",
    labelSv: "Butiksföreståndare",
    searchFi: "52220 myymäläesimiehet kauppa",
    searchEn: "52220 shop supervisors",
    searchSv: "52220 butiksföreståndare",
    freeTextFi: "kauppa",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "52230",
    code: "52230",
    labelFi: "Myyjät",
    labelEn: "Shop sales assistants",
    labelSv: "Försäljare",
    searchFi: "52230 myyjät kauppa",
    searchEn: "52230 shop sales assistants",
    searchSv: "52230 försäljare",
    freeTextFi: "kauppa",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "52300",
    code: "52300",
    labelFi: "Kassanhoitajat ja lipunmyyjät",
    labelEn: "Cashiers and ticket clerks",
    labelSv: "Butikskassörer, biljettförsäljare m.fl.",
    searchFi: "52300 kassanhoitajat ja lipunmyyjät kauppa",
    searchEn: "52300 cashiers and ticket clerks",
    searchSv: "52300 butikskassörer, biljettförsäljare m.fl.",
    freeTextFi: "kauppa",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "52410",
    code: "52410",
    labelFi: "Mallit",
    labelEn: "Fashion and other models",
    labelSv: "Modeller",
    searchFi: "52410 mallit",
    searchEn: "52410 fashion and other models",
    searchSv: "52410 modeller",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "52420",
    code: "52420",
    labelFi: "Tuote-esittelijät",
    labelEn: "Sales demonstrators",
    labelSv: "Varudemonstratörer",
    searchFi: "52420 tuote-esittelijät",
    searchEn: "52420 sales demonstrators",
    searchSv: "52420 varudemonstratörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "52430",
    code: "52430",
    labelFi: "Suoramyyjät",
    labelEn: "Door to door salespersons",
    labelSv: "Direktförsäljare",
    searchFi: "52430 suoramyyjät",
    searchEn: "52430 door to door salespersons",
    searchSv: "52430 direktförsäljare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "52440",
    code: "52440",
    labelFi: "Puhelin- ja asiakaspalvelukeskusten myyjät",
    labelEn: "Contact centre salespersons",
    labelSv: "Försäljare, telefonförsäljning och kontaktcenter",
    searchFi: "52440 puhelin- ja asiakaspalvelukeskusten myyjät",
    searchEn: "52440 contact centre salespersons",
    searchSv: "52440 försäljare, telefonförsäljning och kontaktcenter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "52450",
    code: "52450",
    labelFi: "Huoltamotyöntekijät",
    labelEn: "Service station attendants",
    labelSv: "Bensinstationspersonal",
    searchFi: "52450 huoltamotyöntekijät",
    searchEn: "52450 service station attendants",
    searchSv: "52450 bensinstationspersonal",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "52460",
    code: "52460",
    labelFi: "Kahvila- ja baarimyyjät",
    labelEn: "Food service counter attendants",
    labelSv: "Försäljare, kaféer och barer",
    searchFi: "52460 kahvila- ja baarimyyjät",
    searchEn: "52460 food service counter attendants",
    searchSv: "52460 försäljare, kaféer och barer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "52490",
    code: "52490",
    labelFi: "Muut muualla luokittelemattomat myyntityöntekijät",
    labelEn: "Sales workers not elsewhere classified",
    labelSv: "Övrig försäljningspersonal utan annan klassificering",
    searchFi: "52490 muut muualla luokittelemattomat myyntityöntekijät",
    searchEn: "52490 sales workers not elsewhere classified",
    searchSv: "52490 övrig försäljningspersonal utan annan klassificering",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "53111",
    code: "53111",
    labelFi: "Päiväkotien ja muiden laitosten lastenhoitajat ym.",
    labelEn: "Childminders in kindergartens and other institutions",
    labelSv: "Barnskötare, daghem och andra institutioner m.fl.",
    searchFi: "53111 päiväkotien ja muiden laitosten lastenhoitajat ym.",
    searchEn: "53111 childminders in kindergartens and other institutions",
    searchSv: "53111 barnskötare, daghem och andra institutioner m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "53112",
    code: "53112",
    labelFi: "Perhepäivähoitajat",
    labelEn: "Private childminders",
    labelSv: "Familjedagvårdare",
    searchFi: "53112 perhepäivähoitajat lastenhoito",
    searchEn: "53112 private childminders",
    searchSv: "53112 familjedagvårdare",
    freeTextFi: "lastenhoito",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "household"
  },
  {
    id: "53112-temp",
    code: "53112",
    labelFi: "Tilapäinen lastenhoito",
    labelEn: "Tilapäinen lastenhoito EN",
    labelSv: "Tilapäinen lastenhoito SV",
    searchFi: "53112 tilapäinen lastenhoito mll",
    searchEn: "53112 tilapäinen lastenhoito en",
    searchSv: "53112 tilapäinen lastenhoito sv",
    freeTextFi: "mll",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "household"
  },
  {
    id: "53113",
    code: "53113",
    labelFi: "Lastenkerhojen ohjaajat ym.",
    labelEn: "Children's club leaders",
    labelSv: "Barnklubbsledare m.fl.",
    searchFi: "53113 lastenkerhojen ohjaajat ym.",
    searchEn: "53113 children's club leaders",
    searchSv: "53113 barnklubbsledare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "53120",
    code: "53120",
    labelFi: "Koulunkäyntiavustajat",
    labelEn: "Teachers' aides",
    labelSv: "Skolgångsbiträden",
    searchFi: "53120 koulunkäyntiavustajat",
    searchEn: "53120 teachers' aides",
    searchSv: "53120 skolgångsbiträden",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "53211",
    code: "53211",
    labelFi: "Mielenterveyshoitajat",
    labelEn: "Practical mental nurses",
    labelSv: "Mentalhälsovårdare",
    searchFi: "53211 mielenterveyshoitajat",
    searchEn: "53211 practical mental nurses",
    searchSv: "53211 mentalhälsovårdare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "53212",
    code: "53212",
    labelFi: "Kehitysvammaisten hoitajat",
    labelEn: "Mental handicap nurses",
    labelSv: "Vårdare av utvecklingshämmade",
    searchFi: "53212 kehitysvammaisten hoitajat",
    searchEn: "53212 mental handicap nurses",
    searchSv: "53212 vårdare av utvecklingshämmade",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "household"
  },
  {
    id: "53213",
    code: "53213",
    labelFi: "Sosiaalialan hoitajat",
    labelEn: "Social work assistants",
    labelSv: "Vårdare inom socialsektorn",
    searchFi: "53213 sosiaalialan hoitajat",
    searchEn: "53213 social work assistants",
    searchSv: "53213 vårdare inom socialsektorn",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "household"
  },
  {
    id: "53219",
    code: "53219",
    labelFi: "Muut lähihoitajat",
    labelEn: "Other practical nurses",
    labelSv: "Övriga närvårdare",
    searchFi: "53219 muut lähihoitajat",
    searchEn: "53219 other practical nurses",
    searchSv: "53219 övriga närvårdare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "53221",
    code: "53221",
    labelFi: "Kotityöpalvelutyöntekijät",
    labelEn: "Household service workers",
    labelSv: "Hemvårdspersonal",
    searchFi: "53221 kotityöpalvelutyöntekijät kodinhoitaja",
    searchEn: "53221 household service workers",
    searchSv: "53221 hemvårdspersonal",
    freeTextFi: "kodinhoitaja",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "household"
  },
  {
    id: "53222",
    code: "53222",
    labelFi: "Henkilökohtaiset avustajat, omaishoitajat ym.",
    labelEn: "Personal care workers, family carers, etc.",
    labelSv: "Personliga assistenter, närståendevårdare m.fl.",
    searchFi: "53222 henkilökohtaiset avustajat, omaishoitajat ym. kodinhoitaja",
    searchEn: "53222 personal care workers, family carers, etc.",
    searchSv: "53222 personliga assistenter, närståendevårdare m.fl.",
    freeTextFi: "kodinhoitaja",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "household"
  },
  {
    id: "53291",
    code: "53291",
    labelFi: "Hammashoitajat",
    labelEn: "Dental assistants",
    labelSv: "Tandskötare",
    searchFi: "53291 hammashoitajat",
    searchEn: "53291 dental assistants",
    searchSv: "53291 tandskötare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "53292",
    code: "53292",
    labelFi: "Välinehuoltajat",
    labelEn: "Equipment maintenance assistants",
    labelSv: "Instrumentvårdare",
    searchFi: "53292 välinehuoltajat",
    searchEn: "53292 equipment maintenance assistants",
    searchSv: "53292 instrumentvårdare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "53293",
    code: "53293",
    labelFi: "Apteekkien lääketyöntekijät",
    labelEn: "Pharmaceutical assistants",
    labelSv: "Läkemedelsarbetare på apotek",
    searchFi: "53293 apteekkien lääketyöntekijät",
    searchEn: "53293 pharmaceutical assistants",
    searchSv: "53293 läkemedelsarbetare på apotek",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "53294",
    code: "53294",
    labelFi: "Hierojat ja kuntohoitajat",
    labelEn: "Massage therapists and practical rehabilitation nurses",
    labelSv: "Massörer och konditionsskötare",
    searchFi: "53294 hierojat ja kuntohoitajat",
    searchEn: "53294 massage therapists and practical rehabilitation nurses",
    searchSv: "53294 massörer och konditionsskötare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "54110",
    code: "54110",
    labelFi: "Palomiehet",
    labelEn: "Fire-fighters",
    labelSv: "Brandmän",
    searchFi: "54110 palomiehet",
    searchEn: "54110 fire-fighters",
    searchSv: "54110 brandmän",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "54120",
    code: "54120",
    labelFi: "Poliisit",
    labelEn: "Police officers",
    labelSv: "Poliser",
    searchFi: "54120 poliisit",
    searchEn: "54120 police officers",
    searchSv: "54120 poliser",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "54130",
    code: "54130",
    labelFi: "Vanginvartijat",
    labelEn: "Prison guards",
    labelSv: "Fångvaktare",
    searchFi: "54130 vanginvartijat",
    searchEn: "54130 prison guards",
    searchSv: "54130 fångvaktare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "54140",
    code: "54140",
    labelFi: "Vartijat",
    labelEn: "Security guards",
    labelSv: "Väktare",
    searchFi: "54140 vartijat",
    searchEn: "54140 security guards",
    searchSv: "54140 väktare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "54190",
    code: "54190",
    labelFi: "Muut suojelu- ja vartiointityöntekijät",
    labelEn: "Protective services workers not elsewhere classified",
    labelSv: "Övrig säkerhetspersonal",
    searchFi: "54190 muut suojelu- ja vartiointityöntekijät",
    searchEn: "54190 protective services workers not elsewhere classified",
    searchSv: "54190 övrig säkerhetspersonal",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "61111",
    code: "61111",
    labelFi: "Peltoviljelijät",
    labelEn: "Crop growers",
    labelSv: "Åkerodlare",
    searchFi: "61111 peltoviljelijät",
    searchEn: "61111 crop growers",
    searchSv: "61111 åkerodlare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "61112",
    code: "61112",
    labelFi: "Peltoviljelytyönjohtajat ja -työntekijät",
    labelEn: "Field crop supervisors and workers",
    labelSv: "Arbetsledare och arbetare inom åkerodling",
    searchFi: "61112 peltoviljelytyönjohtajat ja -työntekijät",
    searchEn: "61112 field crop supervisors and workers",
    searchSv: "61112 arbetsledare och arbetare inom åkerodling",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "household"
  },
  {
    id: "61120",
    code: "61120",
    labelFi: "Hedelmäpuiden ja pensaiden yms. kasvattajat",
    labelEn: "Tree and shrub crop growers",
    labelSv: "Odlare av fruktträd och buskar m.fl.",
    searchFi: "61120 hedelmäpuiden ja pensaiden yms. kasvattajat",
    searchEn: "61120 tree and shrub crop growers",
    searchSv: "61120 odlare av fruktträd och buskar m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "61131",
    code: "61131",
    labelFi: "Puutarhurit ja kasvihuoneviljelijät",
    labelEn: "Gardeners, horticultural and nursery growers",
    labelSv: "Trädgårds- och växthusodlare",
    searchFi: "61131 puutarhurit ja kasvihuoneviljelijät",
    searchEn: "61131 gardeners, horticultural and nursery growers",
    searchSv: "61131 trädgårds- och växthusodlare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "61132",
    code: "61132",
    labelFi: "Puutarha- ja kasvihuonetyönjohtajat ja - työntekijät",
    labelEn: "Gardeners, horticultural and nursery growers and workers",
    labelSv: "Arbetsledare och anställda inom trädgårds- och växthusodling",
    searchFi: "61132 puutarha- ja kasvihuonetyönjohtajat ja - työntekijät ruohonleikkuu",
    searchEn: "61132 gardeners, horticultural and nursery growers and workers",
    searchSv: "61132 arbetsledare och anställda inom trädgårds- och växthusodling",
    freeTextFi: "ruohonleikkuu",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "household"
  },
  {
    id: "61140",
    code: "61140",
    labelFi: "Yhdistetyn maan- ja vihannesviljelyn tai puutarhanhoidon ym. harjoittajat",
    labelEn: "Mixed crop growers",
    labelSv: "Odlare av blandade växtslag",
    searchFi: "61140 yhdistetyn maan- ja vihannesviljelyn tai puutarhanhoidon ym. harjoittajat",
    searchEn: "61140 mixed crop growers",
    searchSv: "61140 odlare av blandade växtslag",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "61211",
    code: "61211",
    labelFi: "Karjankasvattajat ym.",
    labelEn: "Dairy and livestock producers",
    labelSv: "Boskapsuppfödare m.fl.",
    searchFi: "61211 karjankasvattajat ym.",
    searchEn: "61211 dairy and livestock producers",
    searchSv: "61211 boskapsuppfödare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "61212",
    code: "61212",
    labelFi: "Karjanhoitajat ym.",
    labelEn: "Dairy and livestock workers",
    labelSv: "Boskapsskötare m.fl.",
    searchFi: "61212 karjanhoitajat ym.",
    searchEn: "61212 dairy and livestock workers",
    searchSv: "61212 boskapsskötare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "61213",
    code: "61213",
    labelFi: "Lemmikkieläinten kasvattajat",
    labelEn: "Pet producers",
    labelSv: "Sällskapsdjursuppfödare",
    searchFi: "61213 lemmikkieläinten kasvattajat",
    searchEn: "61213 pet producers",
    searchSv: "61213 sällskapsdjursuppfödare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "61214",
    code: "61214",
    labelFi: "Maatalouslomittajat",
    labelEn: "Farm relief workers",
    labelSv: "Lantbruksavbytare",
    searchFi: "61214 maatalouslomittajat",
    searchEn: "61214 farm relief workers",
    searchSv: "61214 lantbruksavbytare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "61220",
    code: "61220",
    labelFi: "Siipikarjankasvattajat",
    labelEn: "Poultry producers",
    labelSv: "Fjäderfäuppfödare",
    searchFi: "61220 siipikarjankasvattajat",
    searchEn: "61220 poultry producers",
    searchSv: "61220 fjäderfäuppfödare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "61230",
    code: "61230",
    labelFi: "Mehiläistenhoitajat ym.",
    labelEn: "Apiarists and sericulturists",
    labelSv: "Biodlare m.fl.",
    searchFi: "61230 mehiläistenhoitajat ym.",
    searchEn: "61230 apiarists and sericulturists",
    searchSv: "61230 biodlare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "61291",
    code: "61291",
    labelFi: "Turkiseläinten ja porojen kasvattajat",
    labelEn: "Fur and reindeer producers",
    labelSv: "Pälsdjurs- och renskötare",
    searchFi: "61291 turkiseläinten ja porojen kasvattajat",
    searchEn: "61291 fur and reindeer producers",
    searchSv: "61291 pälsdjurs- och renskötare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "61299",
    code: "61299",
    labelFi: "Muualla luokittelemattomat eläintenhoitajat",
    labelEn: "Animal workers not elsewhere classified",
    labelSv: "Övriga djurskötare utan annan klassificering",
    searchFi: "61299 muualla luokittelemattomat eläintenhoitajat",
    searchEn: "61299 animal workers not elsewhere classified",
    searchSv: "61299 övriga djurskötare utan annan klassificering",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "61300",
    code: "61300",
    labelFi: "Yhdistetyn maanviljelyn ja eläintenkasvatuksen harjoittajat",
    labelEn: "Mixed crop and animal producers",
    labelSv: "Växtodlare och djuruppfödare, blandad drift",
    searchFi: "61300 yhdistetyn maanviljelyn ja eläintenkasvatuksen harjoittajat",
    searchEn: "61300 mixed crop and animal producers",
    searchSv: "61300 växtodlare och djuruppfödare, blandad drift",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "62100",
    code: "62100",
    labelFi: "Metsurit ja metsätyöntekijät",
    labelEn: "Forestry and related workers",
    labelSv: "Skogsbrukare och skogsarbetare",
    searchFi: "62100 metsurit ja metsätyöntekijät",
    searchEn: "62100 forestry and related workers",
    searchSv: "62100 skogsbrukare och skogsarbetare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "household"
  },
  {
    id: "62211",
    code: "62211",
    labelFi: "Kalanviljely-yrittäjät",
    labelEn: "Fish farmers",
    labelSv: "Fiskodlingsföretagare",
    searchFi: "62211 kalanviljely-yrittäjät",
    searchEn: "62211 fish farmers",
    searchSv: "62211 fiskodlingsföretagare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "62212",
    code: "62212",
    labelFi: "Kalanviljelytyönjohtajat ja -työntekijät",
    labelEn: "Fishery supervisors and workers",
    labelSv: "Arbetsledare och arbetare inom fiskodling",
    searchFi: "62212 kalanviljelytyönjohtajat ja -työntekijät",
    searchEn: "62212 fishery supervisors and workers",
    searchSv: "62212 arbetsledare och arbetare inom fiskodling",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "62220",
    code: "62220",
    labelFi: "Kalastajat",
    labelEn: "Inland and coastal waters fishery workers",
    labelSv: "Fiskare",
    searchFi: "62220 kalastajat",
    searchEn: "62220 inland and coastal waters fishery workers",
    searchSv: "62220 fiskare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "62240",
    code: "62240",
    labelFi: "Riistanhoitajat ja metsästäjät",
    labelEn: "Hunters and trappers",
    labelSv: "Viltvårdare och jägare",
    searchFi: "62240 riistanhoitajat ja metsästäjät",
    searchEn: "62240 hunters and trappers",
    searchSv: "62240 viltvårdare och jägare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "71110",
    code: "71110",
    labelFi: "Talonrakentajat",
    labelEn: "House builders",
    labelSv: "Byggnadsarbetare",
    searchFi: "71110 talonrakentajat rakennus remontti",
    searchEn: "71110 house builders",
    searchSv: "71110 byggnadsarbetare",
    freeTextFi: "rakennus remontti",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company household"
  },
  {
    id: "71120",
    code: "71120",
    labelFi: "Muurarit ym.",
    labelEn: "Bricklayers and related workers",
    labelSv: "Murare m.fl.",
    searchFi: "71120 muurarit ym. rakennus remontti",
    searchEn: "71120 bricklayers and related workers",
    searchSv: "71120 murare m.fl.",
    freeTextFi: "rakennus remontti",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "71130",
    code: "71130",
    labelFi: "Kivenhakkaajat ja -leikkaajat ym.",
    labelEn: "Stonemasons, stone cutters, splitters and carvers",
    labelSv: "Stenhuggare m.fl.",
    searchFi: "71130 kivenhakkaajat ja -leikkaajat ym.",
    searchEn: "71130 stonemasons, stone cutters, splitters and carvers",
    searchSv: "71130 stenhuggare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "71140",
    code: "71140",
    labelFi: "Betonirakentajat ja raudoittajat",
    labelEn: "Concrete placers, concrete finishers and related workers",
    labelSv: "Betongarbetare och armerare",
    searchFi: "71140 betonirakentajat ja raudoittajat rakennus remontti",
    searchEn: "71140 concrete placers, concrete finishers and related workers",
    searchSv: "71140 betongarbetare och armerare",
    freeTextFi: "rakennus remontti",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "71150",
    code: "71150",
    labelFi: "Kirvesmiehet ja rakennuspuusepät",
    labelEn: "Carpenters and joiners",
    labelSv: "Timmermän och byggnadssnickare",
    searchFi: "71150 kirvesmiehet ja rakennuspuusepät rakennus remontti",
    searchEn: "71150 carpenters and joiners",
    searchSv: "71150 timmermän och byggnadssnickare",
    freeTextFi: "rakennus remontti",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company household"
  },
  {
    id: "71190",
    code: "71190",
    labelFi: "Muut rakennustyöntekijät",
    labelEn: "Building frame and related trades workers not elsewhere classified",
    labelSv: "Övriga byggnadsarbetare",
    searchFi: "71190 muut rakennustyöntekijät rakennus remontti",
    searchEn: "71190 building frame and related trades workers not elsewhere classified",
    searchSv: "71190 övriga byggnadsarbetare",
    freeTextFi: "rakennus remontti",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "71210",
    code: "71210",
    labelFi: "Kattoasentajat ja -korjaajat",
    labelEn: "Roofers",
    labelSv: "Takmontörer och takreparatörer",
    searchFi: "71210 kattoasentajat ja -korjaajat rakennus remontti",
    searchEn: "71210 roofers",
    searchSv: "71210 takmontörer och takreparatörer",
    freeTextFi: "rakennus remontti",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "household"
  },
  {
    id: "71220",
    code: "71220",
    labelFi: "Lattianpäällystystyöntekijät",
    labelEn: "Floor layers and tile setters",
    labelSv: "Golvläggare",
    searchFi: "71220 lattianpäällystystyöntekijät rakennus remontti",
    searchEn: "71220 floor layers and tile setters",
    searchSv: "71220 golvläggare",
    freeTextFi: "rakennus remontti",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "71230",
    code: "71230",
    labelFi: "Rappaajat",
    labelEn: "Plasterers",
    labelSv: "Rappare",
    searchFi: "71230 rappaajat rakennus remontti",
    searchEn: "71230 plasterers",
    searchSv: "71230 rappare",
    freeTextFi: "rakennus remontti",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "71240",
    code: "71240",
    labelFi: "Eristäjät",
    labelEn: "Insulation workers",
    labelSv: "Isoleringsmontörer",
    searchFi: "71240 eristäjät rakennus remontti",
    searchEn: "71240 insulation workers",
    searchSv: "71240 isoleringsmontörer",
    freeTextFi: "rakennus remontti",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "71250",
    code: "71250",
    labelFi: "Lasinasentajat",
    labelEn: "Glaziers",
    labelSv: "Glasmästare",
    searchFi: "71250 lasinasentajat rakennus remontti",
    searchEn: "71250 glaziers",
    searchSv: "71250 glasmästare",
    freeTextFi: "rakennus remontti",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "71260",
    code: "71260",
    labelFi: "Putkiasentajat",
    labelEn: "Plumbers and pipe fitters",
    labelSv: "Rörläggare",
    searchFi: "71260 putkiasentajat rakennus remontti",
    searchEn: "71260 plumbers and pipe fitters",
    searchSv: "71260 rörläggare",
    freeTextFi: "rakennus remontti",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "71270",
    code: "71270",
    labelFi: "Ilmastointi- ja jäähdytyslaiteasentajat",
    labelEn: "Air conditioning and refrigeration mechanics",
    labelSv: "Ventilations- och kylmontörer",
    searchFi: "71270 ilmastointi- ja jäähdytyslaiteasentajat",
    searchEn: "71270 air conditioning and refrigeration mechanics",
    searchSv: "71270 ventilations- och kylmontörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "71310",
    code: "71310",
    labelFi: "Rakennusmaalarit ym.",
    labelEn: "Painters and related workers",
    labelSv: "Byggnadsmålare m.fl.",
    searchFi: "71310 rakennusmaalarit ym. rakennus remontti",
    searchEn: "71310 painters and related workers",
    searchSv: "71310 byggnadsmålare m.fl.",
    freeTextFi: "rakennus remontti",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "household"
  },
  {
    id: "71320",
    code: "71320",
    labelFi: "Ruiskumaalaajat ja -lakkaajat",
    labelEn: "Spray painters and varnishers",
    labelSv: "Sprutlackerare",
    searchFi: "71320 ruiskumaalaajat ja -lakkaajat",
    searchEn: "71320 spray painters and varnishers",
    searchSv: "71320 sprutlackerare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "71330",
    code: "71330",
    labelFi: "Rakennuspuhdistajat ja nuohoojat",
    labelEn: "Building structure cleaners",
    labelSv: "Saneringsarbetare och sotare",
    searchFi: "71330 rakennuspuhdistajat ja nuohoojat",
    searchEn: "71330 building structure cleaners",
    searchSv: "71330 saneringsarbetare och sotare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "72110",
    code: "72110",
    labelFi: "Muotin- ja keernantekijät",
    labelEn: "Metal moulders and coremakers",
    labelSv: "Formare och kärnmakare",
    searchFi: "72110 muotin- ja keernantekijät",
    searchEn: "72110 metal moulders and coremakers",
    searchSv: "72110 formare och kärnmakare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "72120",
    code: "72120",
    labelFi: "Hitsaajat ja kaasuleikkaajat",
    labelEn: "Welders and flamecutters",
    labelSv: "Svetsare och gasskärare",
    searchFi: "72120 hitsaajat ja kaasuleikkaajat",
    searchEn: "72120 welders and flamecutters",
    searchSv: "72120 svetsare och gasskärare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "72130",
    code: "72130",
    labelFi: "Ohutlevysepät",
    labelEn: "Sheet-metal workers",
    labelSv: "Tunnplåtslagare",
    searchFi: "72130 ohutlevysepät",
    searchEn: "72130 sheet-metal workers",
    searchSv: "72130 tunnplåtslagare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "72140",
    code: "72140",
    labelFi: "Paksulevysepät ja rautarakennetyöntekijät",
    labelEn: "Structural-metal preparers and erectors",
    labelSv: "Grovplåtslagare och stålkonstruktionsmontörer",
    searchFi: "72140 paksulevysepät ja rautarakennetyöntekijät",
    searchEn: "72140 structural-metal preparers and erectors",
    searchSv: "72140 grovplåtslagare och stålkonstruktionsmontörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "72150",
    code: "72150",
    labelFi: "Kaapelin- ja köysienasentajat",
    labelEn: "Riggers and cable splicers",
    labelSv: "Kabelläggare och riggare",
    searchFi: "72150 kaapelin- ja köysienasentajat",
    searchEn: "72150 riggers and cable splicers",
    searchSv: "72150 kabelläggare och riggare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "72210",
    code: "72210",
    labelFi: "Sepät",
    labelEn: "Blacksmiths, hammersmiths and forging press workers",
    labelSv: "Smeder",
    searchFi: "72210 sepät",
    searchEn: "72210 blacksmiths, hammersmiths and forging press workers",
    searchSv: "72210 smeder",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "72220",
    code: "72220",
    labelFi: "Työkaluntekijät ja lukkosepät",
    labelEn: "Toolmakers and related workers",
    labelSv: "Verktygsmakare och låssmeder",
    searchFi: "72220 työkaluntekijät ja lukkosepät",
    searchEn: "72220 toolmakers and related workers",
    searchSv: "72220 verktygsmakare och låssmeder",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "72230",
    code: "72230",
    labelFi: "Koneenasettajat ja koneistajat",
    labelEn: "Metal working machine tool setters and operators",
    labelSv: "Maskinställare och verkstadsmekaniker",
    searchFi: "72230 koneenasettajat ja koneistajat",
    searchEn: "72230 metal working machine tool setters and operators",
    searchSv: "72230 maskinställare och verkstadsmekaniker",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "72240",
    code: "72240",
    labelFi: "Konehiojat, kiillottajat ja teroittajat",
    labelEn: "Metal polishers, wheel grinders and tool sharpeners",
    labelSv: "Maskinslipare, -polerare och -vässare",
    searchFi: "72240 konehiojat, kiillottajat ja teroittajat",
    searchEn: "72240 metal polishers, wheel grinders and tool sharpeners",
    searchSv: "72240 maskinslipare, -polerare och -vässare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "72310",
    code: "72310",
    labelFi: "Moottoriajoneuvojen asentajat ja korjaajat",
    labelEn: "Motor vehicle mechanics and repairers",
    labelSv: "Motorfordonsmontörer och -reparatörer",
    searchFi: "72310 moottoriajoneuvojen asentajat ja korjaajat korjaamo auto",
    searchEn: "72310 motor vehicle mechanics and repairers",
    searchSv: "72310 motorfordonsmontörer och -reparatörer",
    freeTextFi: "korjaamo auto",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "72320",
    code: "72320",
    labelFi: "Lentokoneasentajat ja -korjaajat",
    labelEn: "Aircraft engine mechanics and repairers",
    labelSv: "Flygmontörer och flygreparatörer",
    searchFi: "72320 lentokoneasentajat ja -korjaajat",
    searchEn: "72320 aircraft engine mechanics and repairers",
    searchSv: "72320 flygmontörer och flygreparatörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "72330",
    code: "72330",
    labelFi: "Maatalous- ja teollisuuskoneasentajat ja -korjaajat",
    labelEn: "Agricultural and industrial machinery mechanics and repairers",
    labelSv: "Maskinmontörer och -reparatörer (jordbruks- och industrimaskiner)",
    searchFi: "72330 maatalous- ja teollisuuskoneasentajat ja -korjaajat",
    searchEn: "72330 agricultural and industrial machinery mechanics and repairers",
    searchSv: "72330 maskinmontörer och -reparatörer (jordbruks- och industrimaskiner)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "72340",
    code: "72340",
    labelFi: "Polkupyöränkorjaajat ym.",
    labelEn: "Bicycle and related repairers",
    labelSv: "Cykelreparatörer m.fl.",
    searchFi: "72340 polkupyöränkorjaajat ym.",
    searchEn: "72340 bicycle and related repairers",
    searchSv: "72340 cykelreparatörer m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "73110",
    code: "73110",
    labelFi: "Kellosepät ja muut hienomekaanisten instrumenttien tekijät ja korjaajat",
    labelEn: "Precision-instrument makers and repairers",
    labelSv: "Urmakare och övriga tillverkare av finmekaniska instrument",
    searchFi: "73110 kellosepät ja muut hienomekaanisten instrumenttien tekijät ja korjaajat",
    searchEn: "73110 precision-instrument makers and repairers",
    searchSv: "73110 urmakare och övriga tillverkare av finmekaniska instrument",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "73120",
    code: "73120",
    labelFi: "Soittimien tekijät ja virittäjät",
    labelEn: "Musical instrument makers and tuners",
    labelSv: "Musikinstrumentmakare och -stämmare",
    searchFi: "73120 soittimien tekijät ja virittäjät",
    searchEn: "73120 musical instrument makers and tuners",
    searchSv: "73120 musikinstrumentmakare och -stämmare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "73130",
    code: "73130",
    labelFi: "Koru-, kulta- ja hopeasepät",
    labelEn: "Jewellery and precious-metal workers",
    labelSv: "Juvel-, guld- och silversmeder",
    searchFi: "73130 koru-, kulta- ja hopeasepät",
    searchEn: "73130 jewellery and precious-metal workers",
    searchSv: "73130 juvel-, guld- och silversmeder",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "73140",
    code: "73140",
    labelFi: "Saven- ja tiilenvalajat ja dreijaajat",
    labelEn: "Potters and related workers",
    labelSv: "Ler- och tegelgjutare, drejare",
    searchFi: "73140 saven- ja tiilenvalajat ja dreijaajat",
    searchEn: "73140 potters and related workers",
    searchSv: "73140 ler- och tegelgjutare, drejare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "73150",
    code: "73150",
    labelFi: "Lasinpuhaltajat, -leikkaajat, -hiojat ja -viimeistelijät",
    labelEn: "Glass makers, cutters, grinders and finishers",
    labelSv: "Glasblåsare, -skärare, -slipare och -efterbehandlare",
    searchFi: "73150 lasinpuhaltajat, -leikkaajat, -hiojat ja -viimeistelijät",
    searchEn: "73150 glass makers, cutters, grinders and finishers",
    searchSv: "73150 glasblåsare, -skärare, -slipare och -efterbehandlare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "73160",
    code: "73160",
    labelFi: "Kaivertajat, etsaajat ja koristemaalarit",
    labelEn: "Sign writers, decorative painters, engravers and etchers",
    labelSv: "Glasgravörer, glasetsare och skyltmålare",
    searchFi: "73160 kaivertajat, etsaajat ja koristemaalarit",
    searchEn: "73160 sign writers, decorative painters, engravers and etchers",
    searchSv: "73160 glasgravörer, glasetsare och skyltmålare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "73170",
    code: "73170",
    labelFi: "Puu-, kori- yms. käsityötuotteiden tekijät",
    labelEn: "Handicraft workers in wood, basketry and related materials",
    labelSv: "Konsthantverkare i trä m.m.",
    searchFi: "73170 puu-, kori- yms. käsityötuotteiden tekijät",
    searchEn: "73170 handicraft workers in wood, basketry and related materials",
    searchSv: "73170 konsthantverkare i trä m.m.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "73180",
    code: "73180",
    labelFi: "Tekstiili-, nahka- yms. käsityötuotteiden tekijät",
    labelEn: "Handicraft workers in textile, leather and related materials",
    labelSv: "Konsthantverkare i textil, läder m.m.",
    searchFi: "73180 tekstiili-, nahka- yms. käsityötuotteiden tekijät",
    searchEn: "73180 handicraft workers in textile, leather and related materials",
    searchSv: "73180 konsthantverkare i textil, läder m.m.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "73190",
    code: "73190",
    labelFi: "Muut käsityöntekijät",
    labelEn: "Handicraft workers not elsewhere classified",
    labelSv: "Övriga konsthantverkare",
    searchFi: "73190 muut käsityöntekijät",
    searchEn: "73190 handicraft workers not elsewhere classified",
    searchSv: "73190 övriga konsthantverkare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "73210",
    code: "73210",
    labelFi: "Painopinnanvalmistajat",
    labelEn: "Pre-press technicians",
    labelSv: "Prepressoperatörer",
    searchFi: "73210 painopinnanvalmistajat",
    searchEn: "73210 pre-press technicians",
    searchSv: "73210 prepressoperatörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "73220",
    code: "73220",
    labelFi: "Painajat",
    labelEn: "Printers",
    labelSv: "Tryckare",
    searchFi: "73220 painajat",
    searchEn: "73220 printers",
    searchSv: "73220 tryckare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "73230",
    code: "73230",
    labelFi: "Jälkikäsittelijät ja sitomotyöntekijät",
    labelEn: "Print finishing and binding workers",
    labelSv: "Efterbehandlare och bokbinderiarbetare",
    searchFi: "73230 jälkikäsittelijät ja sitomotyöntekijät",
    searchEn: "73230 print finishing and binding workers",
    searchSv: "73230 efterbehandlare och bokbinderiarbetare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "74110",
    code: "74110",
    labelFi: "Rakennussähköasentajat",
    labelEn: "Building and related electricians",
    labelSv: "Byggnadselmontörer",
    searchFi: "74110 rakennussähköasentajat",
    searchEn: "74110 building and related electricians",
    searchSv: "74110 byggnadselmontörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "74120",
    code: "74120",
    labelFi: "Muut sähköasentajat",
    labelEn: "Electrical mechanics and fitters",
    labelSv: "Övriga elmontörer",
    searchFi: "74120 muut sähköasentajat",
    searchEn: "74120 electrical mechanics and fitters",
    searchSv: "74120 övriga elmontörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "74130",
    code: "74130",
    labelFi: "Linja-asentajat ja -korjaajat",
    labelEn: "Electrical line installers and repairers",
    labelSv: "Linjemontörer och -reparatörer",
    searchFi: "74130 linja-asentajat ja -korjaajat",
    searchEn: "74130 electrical line installers and repairers",
    searchSv: "74130 linjemontörer och -reparatörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "74211",
    code: "74211",
    labelFi: "Elektroniikka-asentajat ja -korjaajat",
    labelEn: "Electronics installers and repairers",
    labelSv: "Elektronikmontörer och -reparatörer",
    searchFi: "74211 elektroniikka-asentajat ja -korjaajat tietokone kodinkone",
    searchEn: "74211 electronics installers and repairers",
    searchSv: "74211 elektronikmontörer och -reparatörer",
    freeTextFi: "tietokone kodinkone",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "74212",
    code: "74212",
    labelFi: "Automaatioasentajat ja -korjaajat",
    labelEn: "Automation installers and repairers",
    labelSv: "Automationsmontörer och -reparatörer",
    searchFi: "74212 automaatioasentajat ja -korjaajat",
    searchEn: "74212 automation installers and repairers",
    searchSv: "74212 automationsmontörer och -reparatörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "74220",
    code: "74220",
    labelFi: "Tieto- ja viestintäteknologian asentajat ja korjaajat",
    labelEn: "Information and communications technology installers and servicers",
    labelSv: "Montörer och reparatörer, IKT",
    searchFi: "74220 tieto- ja viestintäteknologian asentajat ja korjaajat tietokone kodinkone",
    searchEn: "74220 information and communications technology installers and servicers",
    searchSv: "74220 montörer och reparatörer, ikt",
    freeTextFi: "tietokone kodinkone",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75110",
    code: "75110",
    labelFi: "Lihanleikkaajat, kalankäsittelijät ym.",
    labelEn: "Butchers, fishmongers and related food preparers",
    labelSv: "Slaktare, fiskberedare m.fl.",
    searchFi: "75110 lihanleikkaajat, kalankäsittelijät ym.",
    searchEn: "75110 butchers, fishmongers and related food preparers",
    searchSv: "75110 slaktare, fiskberedare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75120",
    code: "75120",
    labelFi: "Leipurit ja kondiittorit",
    labelEn: "Bakers, pastry-cooks and confectionery makers",
    labelSv: "Bagare och konditorer",
    searchFi: "75120 leipurit ja kondiittorit",
    searchEn: "75120 bakers, pastry-cooks and confectionery makers",
    searchSv: "75120 bagare och konditorer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75130",
    code: "75130",
    labelFi: "Meijeristit, juustomestarit ym.",
    labelEn: "Dairy-products makers",
    labelSv: "Mejerister, ostmästare m.fl.",
    searchFi: "75130 meijeristit, juustomestarit ym.",
    searchEn: "75130 dairy-products makers",
    searchSv: "75130 mejerister, ostmästare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75140",
    code: "75140",
    labelFi: "Hedelmä- ja vihannestuotteiden valmistajat",
    labelEn: "Fruit, vegetable and related preservers",
    labelSv: "Tillverkare av frukt- och grönsaksprodukter",
    searchFi: "75140 hedelmä- ja vihannestuotteiden valmistajat",
    searchEn: "75140 fruit, vegetable and related preservers",
    searchSv: "75140 tillverkare av frukt- och grönsaksprodukter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75150",
    code: "75150",
    labelFi: "Ruokien ja juomien laaduntarkkailijat",
    labelEn: "Food and beverage tasters and graders",
    labelSv: "Kvalitetsbedömare (mat och dryck)",
    searchFi: "75150 ruokien ja juomien laaduntarkkailijat",
    searchEn: "75150 food and beverage tasters and graders",
    searchSv: "75150 kvalitetsbedömare (mat och dryck)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75160",
    code: "75160",
    labelFi: "Tupakkatuotteiden valmistajat",
    labelEn: "Tobacco preparers and tobacco products makers",
    labelSv: "Tillverkare av tobaksprodukter",
    searchFi: "75160 tupakkatuotteiden valmistajat",
    searchEn: "75160 tobacco preparers and tobacco products makers",
    searchSv: "75160 tillverkare av tobaksprodukter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75210",
    code: "75210",
    labelFi: "Raakapuun käsittelijät",
    labelEn: "Wood treaters",
    labelSv: "Trävaruhanterare",
    searchFi: "75210 raakapuun käsittelijät",
    searchEn: "75210 wood treaters",
    searchSv: "75210 trävaruhanterare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75220",
    code: "75220",
    labelFi: "Huonekalupuusepät ym.",
    labelEn: "Cabinet-makers and related workers",
    labelSv: "Möbelsnickare m.fl.",
    searchFi: "75220 huonekalupuusepät ym.",
    searchEn: "75220 cabinet-makers and related workers",
    searchSv: "75220 möbelsnickare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75230",
    code: "75230",
    labelFi: "Konepuusepät",
    labelEn: "Woodworking-machine tool setters and operators",
    labelSv: "Maskinsnickare",
    searchFi: "75230 konepuusepät",
    searchEn: "75230 woodworking-machine tool setters and operators",
    searchSv: "75230 maskinsnickare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75310",
    code: "75310",
    labelFi: "Vaatturit, pukuompelijat, turkkurit ja hatuntekijät",
    labelEn: "Tailors, dressmakers, furriers and hatters",
    labelSv: "Skräddare, ateljésömmerskor, körsnärer och modister",
    searchFi: "75310 vaatturit, pukuompelijat, turkkurit ja hatuntekijät",
    searchEn: "75310 tailors, dressmakers, furriers and hatters",
    searchSv: "75310 skräddare, ateljésömmerskor, körsnärer och modister",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75320",
    code: "75320",
    labelFi: "Leikkaajat ja mallimestarit",
    labelEn: "Garment and related pattern-makers and cutters",
    labelSv: "Tillskärare och modellmästare",
    searchFi: "75320 leikkaajat ja mallimestarit",
    searchEn: "75320 garment and related pattern-makers and cutters",
    searchSv: "75320 tillskärare och modellmästare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75330",
    code: "75330",
    labelFi: "Koru- ja muut tekstiiliompelijat",
    labelEn: "Sewing, embroidery and related workers",
    labelSv: "Broderare och andra textilsömmare",
    searchFi: "75330 koru- ja muut tekstiiliompelijat",
    searchEn: "75330 sewing, embroidery and related workers",
    searchSv: "75330 broderare och andra textilsömmare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75340",
    code: "75340",
    labelFi: "Verhoilijat",
    labelEn: "Upholsterers and related workers",
    labelSv: "Tapetserare",
    searchFi: "75340 verhoilijat",
    searchEn: "75340 upholsterers and related workers",
    searchSv: "75340 tapetserare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75350",
    code: "75350",
    labelFi: "Turkisten muokkaajat ja nahkurit",
    labelEn: "Pelt dressers, tanners and fellmongers",
    labelSv: "Garvare och skinnberedare",
    searchFi: "75350 turkisten muokkaajat ja nahkurit",
    searchEn: "75350 pelt dressers, tanners and fellmongers",
    searchSv: "75350 garvare och skinnberedare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75360",
    code: "75360",
    labelFi: "Suutarit ym.",
    labelEn: "Shoemakers and related workers",
    labelSv: "Skomakare m.fl.",
    searchFi: "75360 suutarit ym.",
    searchEn: "75360 shoemakers and related workers",
    searchSv: "75360 skomakare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75410",
    code: "75410",
    labelFi: "Vedenalaistyöntekijät",
    labelEn: "Underwater divers",
    labelSv: "Dykare",
    searchFi: "75410 vedenalaistyöntekijät",
    searchEn: "75410 underwater divers",
    searchSv: "75410 dykare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75420",
    code: "75420",
    labelFi: "Panostajat ja räjäyttäjät",
    labelEn: "Shotfirers and blasters",
    labelSv: "Laddare och sprängare",
    searchFi: "75420 panostajat ja räjäyttäjät",
    searchEn: "75420 shotfirers and blasters",
    searchSv: "75420 laddare och sprängare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75430",
    code: "75430",
    labelFi: "Luokittelijat ja laaduntarkkailijat (pl. ruoat ja juomat)",
    labelEn: "Product graders and testers (excluding foods and beverages)",
    labelSv: "Klassificerare och kvalitetskontrollanter (utom drycker och livsmedel)",
    searchFi: "75430 luokittelijat ja laaduntarkkailijat (pl. ruoat ja juomat)",
    searchEn: "75430 product graders and testers (excluding foods and beverages)",
    searchSv: "75430 klassificerare och kvalitetskontrollanter (utom drycker och livsmedel)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75440",
    code: "75440",
    labelFi: "Savupuhdistajat, tuholais- ja rikkakasvintorjujat",
    labelEn: "Fumigators and other pest and weed controllers",
    labelSv: "Röksanerare, skadedjurs- och ogrässanerare",
    searchFi: "75440 savupuhdistajat, tuholais- ja rikkakasvintorjujat",
    searchEn: "75440 fumigators and other pest and weed controllers",
    searchSv: "75440 röksanerare, skadedjurs- och ogrässanerare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "75490",
    code: "75490",
    labelFi: "Muut pääluokkaan 7 muualla luokittelemattomat työntekijät",
    labelEn: "Craft and related workers not elsewhere classified",
    labelSv: "Övrig personal, oklassificerad under andra moment i huvudgrupp 7",
    searchFi: "75490 muut pääluokkaan 7 muualla luokittelemattomat työntekijät",
    searchEn: "75490 craft and related workers not elsewhere classified",
    searchSv: "75490 övrig personal, oklassificerad under andra moment i huvudgrupp 7",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81110",
    code: "81110",
    labelFi: "Kaivos- ja louhostyöntekijät",
    labelEn: "Miners and quarriers",
    labelSv: "Gruv- och stenbrottsarbetare",
    searchFi: "81110 kaivos- ja louhostyöntekijät",
    searchEn: "81110 miners and quarriers",
    searchSv: "81110 gruv- och stenbrottsarbetare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81120",
    code: "81120",
    labelFi: "Rikastustyöntekijät",
    labelEn: "Mineral and stone processing plant operators",
    labelSv: "Anrikningsarbetare",
    searchFi: "81120 rikastustyöntekijät",
    searchEn: "81120 mineral and stone processing plant operators",
    searchSv: "81120 anrikningsarbetare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81130",
    code: "81130",
    labelFi: "Iskuporaajat ja syväkairaajat",
    labelEn: "Well drillers and borers and related workers",
    labelSv: "Slagborrare och djupborrare",
    searchFi: "81130 iskuporaajat ja syväkairaajat",
    searchEn: "81130 well drillers and borers and related workers",
    searchSv: "81130 slagborrare och djupborrare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81140",
    code: "81140",
    labelFi: "Betonituote- ym. teollisuuden prosessityöntekijät",
    labelEn: "Cement, stone and other mineral products machine operators",
    labelSv: "Processoperatörer inom betongindustri m.fl.",
    searchFi: "81140 betonituote- ym. teollisuuden prosessityöntekijät",
    searchEn: "81140 cement, stone and other mineral products machine operators",
    searchSv: "81140 processoperatörer inom betongindustri m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81210",
    code: "81210",
    labelFi: "Metalliteollisuuden prosessityöntekijät",
    labelEn: "Metal processing plant operators",
    labelSv: "Processoperatörer inom metallindustri",
    searchFi: "81210 metalliteollisuuden prosessityöntekijät",
    searchEn: "81210 metal processing plant operators",
    searchSv: "81210 processoperatörer inom metallindustri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81220",
    code: "81220",
    labelFi: "Metallien teolliset päällystäjät ja viimeistelijät",
    labelEn: "Metal finishing, plating and coating machine operators",
    labelSv: "Ytbeläggare och efterbehandlare inom metallindustri",
    searchFi: "81220 metallien teolliset päällystäjät ja viimeistelijät",
    searchEn: "81220 metal finishing, plating and coating machine operators",
    searchSv: "81220 ytbeläggare och efterbehandlare inom metallindustri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81310",
    code: "81310",
    labelFi: "Kemianteollisuuden prosessityöntekijät ym.",
    labelEn: "Chemical products plant and machine operators",
    labelSv: "Processoperatörer, kemisk industri m.fl.",
    searchFi: "81310 kemianteollisuuden prosessityöntekijät ym.",
    searchEn: "81310 chemical products plant and machine operators",
    searchSv: "81310 processoperatörer, kemisk industri m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81320",
    code: "81320",
    labelFi: "Valokuvatuotteiden valmistuksen prosessityöntekijät",
    labelEn: "Photographic products machine operators",
    labelSv: "Processoperatörer, fotografiska produkter",
    searchFi: "81320 valokuvatuotteiden valmistuksen prosessityöntekijät",
    searchEn: "81320 photographic products machine operators",
    searchSv: "81320 processoperatörer, fotografiska produkter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81410",
    code: "81410",
    labelFi: "Kumituoteteollisuuden prosessityöntekijät",
    labelEn: "Rubber products machine operators",
    labelSv: "Processoperatörer, gummiindustri",
    searchFi: "81410 kumituoteteollisuuden prosessityöntekijät",
    searchEn: "81410 rubber products machine operators",
    searchSv: "81410 processoperatörer, gummiindustri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81420",
    code: "81420",
    labelFi: "Muovituoteteollisuuden prosessityöntekijät",
    labelEn: "Plastic products machine operators",
    labelSv: "Processoperatörer, plastindustri",
    searchFi: "81420 muovituoteteollisuuden prosessityöntekijät",
    searchEn: "81420 plastic products machine operators",
    searchSv: "81420 processoperatörer, plastindustri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81430",
    code: "81430",
    labelFi: "Paperituoteteollisuuden prosessityöntekijät",
    labelEn: "Paper products machine operators",
    labelSv: "Processoperatörer, pappersvaruindustri",
    searchFi: "81430 paperituoteteollisuuden prosessityöntekijät",
    searchEn: "81430 paper products machine operators",
    searchSv: "81430 processoperatörer, pappersvaruindustri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81510",
    code: "81510",
    labelFi: "Kuitujenkäsittely-, kehruu- ja puolauskoneiden hoitajat",
    labelEn: "Fibre preparing, spinning and winding machine operators",
    labelSv: "Maskinoperatörer, fibertillverkning, spinning och spolning",
    searchFi: "81510 kuitujenkäsittely-, kehruu- ja puolauskoneiden hoitajat",
    searchEn: "81510 fibre preparing, spinning and winding machine operators",
    searchSv: "81510 maskinoperatörer, fibertillverkning, spinning och spolning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81520",
    code: "81520",
    labelFi: "Kutoma- ja neulekoneiden hoitajat",
    labelEn: "Weaving and knitting machine operators",
    labelSv: "Maskinoperatörer, vävning och stickning",
    searchFi: "81520 kutoma- ja neulekoneiden hoitajat",
    searchEn: "81520 weaving and knitting machine operators",
    searchSv: "81520 maskinoperatörer, vävning och stickning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81530",
    code: "81530",
    labelFi: "Teollisuusompelijat",
    labelEn: "Sewing machine operators",
    labelSv: "Symaskinsoperatörer",
    searchFi: "81530 teollisuusompelijat",
    searchEn: "81530 sewing machine operators",
    searchSv: "81530 symaskinsoperatörer",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81540",
    code: "81540",
    labelFi: "Valkaisu-, värjäys- ja puhdistuskoneiden hoitajat",
    labelEn: "Bleaching, dyeing and fabric cleaning machine operators",
    labelSv: "Maskinoperatörer, tvättning, blekning och färgning",
    searchFi: "81540 valkaisu-, värjäys- ja puhdistuskoneiden hoitajat",
    searchEn: "81540 bleaching, dyeing and fabric cleaning machine operators",
    searchSv: "81540 maskinoperatörer, tvättning, blekning och färgning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81550",
    code: "81550",
    labelFi: "Turkisten ja nahkojen teolliset käsittelijät, värjääjät ym.",
    labelEn: "Fur and leather preparing machine operators",
    labelSv: "Maskinoperatörer, pälsskinnsberedning, färgning",
    searchFi: "81550 turkisten ja nahkojen teolliset käsittelijät, värjääjät ym.",
    searchEn: "81550 fur and leather preparing machine operators",
    searchSv: "81550 maskinoperatörer, pälsskinnsberedning, färgning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81560",
    code: "81560",
    labelFi: "Jalkine- ja laukkuteollisuuden prosessityöntekijät",
    labelEn: "Shoemaking and related machine operators",
    labelSv: "Processoperatörer, sko- och väskindustri",
    searchFi: "81560 jalkine- ja laukkuteollisuuden prosessityöntekijät",
    searchEn: "81560 shoemaking and related machine operators",
    searchSv: "81560 processoperatörer, sko- och väskindustri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81570",
    code: "81570",
    labelFi: "Pesulatyöntekijät",
    labelEn: "Laundry machine operators",
    labelSv: "Tvätteripersonal",
    searchFi: "81570 pesulatyöntekijät",
    searchEn: "81570 laundry machine operators",
    searchSv: "81570 tvätteripersonal",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81590",
    code: "81590",
    labelFi: "Muut tekstiili-, turkis- ja nahkatuoteteollisuuden prosessityöntekijät",
    labelEn: "Textile, fur and leather products machine operators not elsewhere classified",
    labelSv: "Övriga processoperatörer inom textil-, skinn- och läderindustri",
    searchFi: "81590 muut tekstiili-, turkis- ja nahkatuoteteollisuuden prosessityöntekijät",
    searchEn: "81590 textile, fur and leather products machine operators not elsewhere classified",
    searchSv: "81590 övriga processoperatörer inom textil-, skinn- och läderindustri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81600",
    code: "81600",
    labelFi: "Elintarviketeollisuuden prosessityöntekijät",
    labelEn: "Food and related products machine operators",
    labelSv: "Processoperatörer, livsmedelsindustri",
    searchFi: "81600 elintarviketeollisuuden prosessityöntekijät",
    searchEn: "81600 food and related products machine operators",
    searchSv: "81600 processoperatörer, livsmedelsindustri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81710",
    code: "81710",
    labelFi: "Paperimassan sekä paperin ja kartongin valmistuksen prosessityöntekijät",
    labelEn: "Pulp and papermaking plant operators",
    labelSv: "Processoperatörer, pappers-, kartong- och massaindustri",
    searchFi: "81710 paperimassan sekä paperin ja kartongin valmistuksen prosessityöntekijät",
    searchEn: "81710 pulp and papermaking plant operators",
    searchSv: "81710 processoperatörer, pappers-, kartong- och massaindustri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81720",
    code: "81720",
    labelFi: "Puu- ja sahatavaran prosessityöntekijät",
    labelEn: "Wood processing plant operators",
    labelSv: "Processoperatörer, trä- och sågvaror",
    searchFi: "81720 puu- ja sahatavaran prosessityöntekijät",
    searchEn: "81720 wood processing plant operators",
    searchSv: "81720 processoperatörer, trä- och sågvaror",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81810",
    code: "81810",
    labelFi: "Lasi- ja keramiikkateollisuuden uunienhoitajat",
    labelEn: "Glass and ceramics plant operators",
    labelSv: "Ugnsoperatörer, glas- och keramikindustri",
    searchFi: "81810 lasi- ja keramiikkateollisuuden uunienhoitajat",
    searchEn: "81810 glass and ceramics plant operators",
    searchSv: "81810 ugnsoperatörer, glas- och keramikindustri",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81821",
    code: "81821",
    labelFi: "Voima- ja jätteenkäsittelylaitosten laitosmiehet",
    labelEn: "Power-production and waste treatment plant workers",
    labelSv: "Maskinreparatörer, kraftverk och avfallsbehandlingsanläggningar",
    searchFi: "81821 voima- ja jätteenkäsittelylaitosten laitosmiehet",
    searchEn: "81821 power-production and waste treatment plant workers",
    searchSv: "81821 maskinreparatörer, kraftverk och avfallsbehandlingsanläggningar",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81822",
    code: "81822",
    labelFi: "Muut laitosmiehet ym.",
    labelEn: "Other plant workers, etc.",
    labelSv: "Övriga maskinreparatörer m.fl.",
    searchFi: "81822 muut laitosmiehet ym.",
    searchEn: "81822 other plant workers, etc.",
    searchSv: "81822 övriga maskinreparatörer m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81830",
    code: "81830",
    labelFi: "Pakkaus-, pullotus- ja etiköintikoneiden hoitajat",
    labelEn: "Packing, bottling and labelling machine operators",
    labelSv: "Maskinoperatörer, packning, påfyllning och märkning",
    searchFi: "81830 pakkaus-, pullotus- ja etiköintikoneiden hoitajat",
    searchEn: "81830 packing, bottling and labelling machine operators",
    searchSv: "81830 maskinoperatörer, packning, påfyllning och märkning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "81890",
    code: "81890",
    labelFi: "Muut muualla luokittelemattomat prosessityöntekijät",
    labelEn: "Stationary plant and machine operators not elsewhere classified",
    labelSv: "Övriga processoperatörer utan annan klassificering",
    searchFi: "81890 muut muualla luokittelemattomat prosessityöntekijät",
    searchEn: "81890 stationary plant and machine operators not elsewhere classified",
    searchSv: "81890 övriga processoperatörer utan annan klassificering",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "82110",
    code: "82110",
    labelFi: "Konepaja- ja metallituotteiden kokoonpanijat",
    labelEn: "Mechanical machinery assemblers",
    labelSv: "Hopsättare, verkstads- och metallprodukter",
    searchFi: "82110 konepaja- ja metallituotteiden kokoonpanijat",
    searchEn: "82110 mechanical machinery assemblers",
    searchSv: "82110 hopsättare, verkstads- och metallprodukter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "82120",
    code: "82120",
    labelFi: "Sähkö- ja elektroniikkalaitteiden kokoonpanijat",
    labelEn: "Electrical and electronic equipment assemblers",
    labelSv: "Hopsättare, elektrisk och elektronisk utrustning",
    searchFi: "82120 sähkö- ja elektroniikkalaitteiden kokoonpanijat",
    searchEn: "82120 electrical and electronic equipment assemblers",
    searchSv: "82120 hopsättare, elektrisk och elektronisk utrustning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "82190",
    code: "82190",
    labelFi: "Muut teollisuustuotteiden kokoonpanijat",
    labelEn: "Assemblers not elsewhere classified",
    labelSv: "Övriga hopsättare av industriprodukter",
    searchFi: "82190 muut teollisuustuotteiden kokoonpanijat",
    searchEn: "82190 assemblers not elsewhere classified",
    searchSv: "82190 övriga hopsättare av industriprodukter",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "83110",
    code: "83110",
    labelFi: "Veturinkuljettajat",
    labelEn: "Locomotive engine drivers",
    labelSv: "Lokförare",
    searchFi: "83110 veturinkuljettajat",
    searchEn: "83110 locomotive engine drivers",
    searchSv: "83110 lokförare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "83120",
    code: "83120",
    labelFi: "Jarru-, turvalaite- ja vaihdetyöntekijät",
    labelEn: "Railway brake, signal and switch operators",
    labelSv: "Bangårdspersonal m.fl.",
    searchFi: "83120 jarru-, turvalaite- ja vaihdetyöntekijät",
    searchEn: "83120 railway brake, signal and switch operators",
    searchSv: "83120 bangårdspersonal m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "83210",
    code: "83210",
    labelFi: "Moottoripyörälähetit yms.",
    labelEn: "Motorcycle drivers",
    labelSv: "Motorcykelbud m.fl.",
    searchFi: "83210 moottoripyörälähetit yms.",
    searchEn: "83210 motorcycle drivers",
    searchSv: "83210 motorcykelbud m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "83220",
    code: "83220",
    labelFi: "Henkilö-, taksi- ja pakettiautonkuljettajat",
    labelEn: "Car, taxi and van drivers",
    labelSv: "Person-, taxi- och paketbilsförare",
    searchFi: "83220 henkilö-, taksi- ja pakettiautonkuljettajat taxi",
    searchEn: "83220 car, taxi and van drivers",
    searchSv: "83220 person-, taxi- och paketbilsförare",
    freeTextFi: "taxi",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "83310",
    code: "83310",
    labelFi: "Linja-auton- ja raitiovaununkuljettajat",
    labelEn: "Bus and tram drivers",
    labelSv: "Buss- och spårvagnsförare",
    searchFi: "83310 linja-auton- ja raitiovaununkuljettajat",
    searchEn: "83310 bus and tram drivers",
    searchSv: "83310 buss- och spårvagnsförare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "83320",
    code: "83320",
    labelFi: "Kuorma-auton ja erikoisajoneuvojen kuljettajat",
    labelEn: "Heavy truck and lorry drivers",
    labelSv: "Lastbils- och specialfordonsförare",
    searchFi: "83320 kuorma-auton ja erikoisajoneuvojen kuljettajat",
    searchEn: "83320 heavy truck and lorry drivers",
    searchSv: "83320 lastbils- och specialfordonsförare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "83410",
    code: "83410",
    labelFi: "Maa- ja metsätaloustyökoneiden kuljettajat",
    labelEn: "Mobile farm and forestry plant operators",
    labelSv: "Förare av jordbruks- och skogsmaskiner",
    searchFi: "83410 maa- ja metsätaloustyökoneiden kuljettajat",
    searchEn: "83410 mobile farm and forestry plant operators",
    searchSv: "83410 förare av jordbruks- och skogsmaskiner",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "83420",
    code: "83420",
    labelFi: "Maansiirtokoneiden ym. kuljettajat",
    labelEn: "Earthmoving and related plant operators",
    labelSv: "Anläggningsmaskinförare m.fl.",
    searchFi: "83420 maansiirtokoneiden ym. kuljettajat",
    searchEn: "83420 earthmoving and related plant operators",
    searchSv: "83420 anläggningsmaskinförare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "83430",
    code: "83430",
    labelFi: "Nosturinkuljettajat",
    labelEn: "Crane, hoist and related plant operators",
    labelSv: "Kranförare",
    searchFi: "83430 nosturinkuljettajat",
    searchEn: "83430 crane, hoist and related plant operators",
    searchSv: "83430 kranförare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "83441",
    code: "83441",
    labelFi: "Ahtaajat",
    labelEn: "Stevedores",
    labelSv: "Stuveriarbetare",
    searchFi: "83441 ahtaajat",
    searchEn: "83441 stevedores",
    searchSv: "83441 stuveriarbetare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "83442",
    code: "83442",
    labelFi: "Trukinkuljettajat ym.",
    labelEn: "Lifting-truck operators, etc.",
    labelSv: "Truckförare m.fl.",
    searchFi: "83442 trukinkuljettajat ym.",
    searchEn: "83442 lifting-truck operators, etc.",
    searchSv: "83442 truckförare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "83500",
    code: "83500",
    labelFi: "Kansimiehistö ym. vesiliikenteen työntekijät",
    labelEn: "Ships' deck crews and related workers",
    labelSv: "Däckmanskap, sjötrafikarbetare m.fl.",
    searchFi: "83500 kansimiehistö ym. vesiliikenteen työntekijät",
    searchEn: "83500 ships' deck crews and related workers",
    searchSv: "83500 däckmanskap, sjötrafikarbetare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "91110",
    code: "91110",
    labelFi: "Kotiapulaiset ja -siivoojat",
    labelEn: "Domestic cleaners and helpers",
    labelSv: "Hembiträden och städare",
    searchFi: "91110 kotiapulaiset ja -siivoojat",
    searchEn: "91110 domestic cleaners and helpers",
    searchSv: "91110 hembiträden och städare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "household"
  },
  {
    id: "91121",
    code: "91121",
    labelFi: "Toimistosiivoojat ym.",
    labelEn: "Office cleaners, etc.",
    labelSv: "Kontorsstädare m.fl.",
    searchFi: "91121 toimistosiivoojat ym.",
    searchEn: "91121 office cleaners, etc.",
    searchSv: "91121 kontorsstädare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "91122",
    code: "91122",
    labelFi: "Hotellisiivoojat",
    labelEn: "Hotel cleaners",
    labelSv: "Hotellstädare",
    searchFi: "91122 hotellisiivoojat",
    searchEn: "91122 hotel cleaners",
    searchSv: "91122 hotellstädare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "91123",
    code: "91123",
    labelFi: "Sairaala- ja laitosapulaiset",
    labelEn: "Hospital and institutional helpers",
    labelSv: "Sjukhus- och vårdbiträden",
    searchFi: "91123 sairaala- ja laitosapulaiset",
    searchEn: "91123 hospital and institutional helpers",
    searchSv: "91123 sjukhus- och vårdbiträden",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "91124",
    code: "91124",
    labelFi: "Päiväkotiapulaiset",
    labelEn: "Kindergarten assistants",
    labelSv: "Daghemsbiträden",
    searchFi: "91124 päiväkotiapulaiset",
    searchEn: "91124 kindergarten assistants",
    searchSv: "91124 daghemsbiträden",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "91129",
    code: "91129",
    labelFi: "Muut muualla luokittelemattomat siivoojat",
    labelEn: "Other cleaners not elsewhere classified",
    labelSv: "Övriga städare utan annan klassificering",
    searchFi: "91129 muut muualla luokittelemattomat siivoojat",
    searchEn: "91129 other cleaners not elsewhere classified",
    searchSv: "91129 övriga städare utan annan klassificering",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "91210",
    code: "91210",
    labelFi: "Puhdistajat ja prässääjät",
    labelEn: "Hand launderers and pressers",
    labelSv: "Rengörare och pressare",
    searchFi: "91210 puhdistajat ja prässääjät",
    searchEn: "91210 hand launderers and pressers",
    searchSv: "91210 rengörare och pressare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "91220",
    code: "91220",
    labelFi: "Ajoneuvojen pesijät",
    labelEn: "Vehicle cleaners",
    labelSv: "Fordonstvättare",
    searchFi: "91220 ajoneuvojen pesijät",
    searchEn: "91220 vehicle cleaners",
    searchSv: "91220 fordonstvättare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "91230",
    code: "91230",
    labelFi: "Ikkunanpesijät",
    labelEn: "Window cleaners",
    labelSv: "Fönsterputsare",
    searchFi: "91230 ikkunanpesijät",
    searchEn: "91230 window cleaners",
    searchSv: "91230 fönsterputsare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "91290",
    code: "91290",
    labelFi: "Muut puhdistustyöntekijät",
    labelEn: "Other cleaning workers",
    labelSv: "Övriga rengöringsarbetare",
    searchFi: "91290 muut puhdistustyöntekijät",
    searchEn: "91290 other cleaning workers",
    searchSv: "91290 övriga rengöringsarbetare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "92110",
    code: "92110",
    labelFi: "Maanviljelyn avustavat työntekijät",
    labelEn: "Crop farm labourers",
    labelSv: "Medhjälpare, jordbruk",
    searchFi: "92110 maanviljelyn avustavat työntekijät",
    searchEn: "92110 crop farm labourers",
    searchSv: "92110 medhjälpare, jordbruk",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "92120",
    code: "92120",
    labelFi: "Karjankasvatuksen avustavat työntekijät",
    labelEn: "Livestock farm labourers",
    labelSv: "Medhjälpare, djuruppfödning",
    searchFi: "92120 karjankasvatuksen avustavat työntekijät",
    searchEn: "92120 livestock farm labourers",
    searchSv: "92120 medhjälpare, djuruppfödning",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "92130",
    code: "92130",
    labelFi: "Yhdistetyn maanviljelyn ja karjankasvatuksen avustavat työntekijät",
    labelEn: "Mixed crop and livestock farm labourers",
    labelSv: "Medhjälpare, växtodling och djuruppfödning, blandad drift",
    searchFi: "92130 yhdistetyn maanviljelyn ja karjankasvatuksen avustavat työntekijät",
    searchEn: "92130 mixed crop and livestock farm labourers",
    searchSv: "92130 medhjälpare, växtodling och djuruppfödning, blandad drift",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "92140",
    code: "92140",
    labelFi: "Avustavat puutarhatyöntekijät",
    labelEn: "Garden and horticultural labourers",
    labelSv: "Medhjälpare, trädgårdsodling",
    searchFi: "92140 avustavat puutarhatyöntekijät",
    searchEn: "92140 garden and horticultural labourers",
    searchSv: "92140 medhjälpare, trädgårdsodling",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "92150",
    code: "92150",
    labelFi: "Metsätalouden avustavat työntekijät",
    labelEn: "Forestry labourers",
    labelSv: "Medhjälpare, skogsbruk",
    searchFi: "92150 metsätalouden avustavat työntekijät",
    searchEn: "92150 forestry labourers",
    searchSv: "92150 medhjälpare, skogsbruk",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "92160",
    code: "92160",
    labelFi: "Kalatalouden ja vesiviljelyn avustavat työntekijät",
    labelEn: "Fishery and aquaculture labourers",
    labelSv: "Medhjälpare, fiske och vattenbruk",
    searchFi: "92160 kalatalouden ja vesiviljelyn avustavat työntekijät",
    searchEn: "92160 fishery and aquaculture labourers",
    searchSv: "92160 medhjälpare, fiske och vattenbruk",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "93110",
    code: "93110",
    labelFi: "Kaivosten avustavat työntekijät",
    labelEn: "Mining and quarrying labourers",
    labelSv: "Medhjälpare, gruvor",
    searchFi: "93110 kaivosten avustavat työntekijät",
    searchEn: "93110 mining and quarrying labourers",
    searchSv: "93110 medhjälpare, gruvor",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "93120",
    code: "93120",
    labelFi: "Maa- ja vesirakentamisen avustavat työntekijät",
    labelEn: "Civil engineering labourers",
    labelSv: "Medhjälpare, anläggningsverksamhet",
    searchFi: "93120 maa- ja vesirakentamisen avustavat työntekijät",
    searchEn: "93120 civil engineering labourers",
    searchSv: "93120 medhjälpare, anläggningsverksamhet",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "93130",
    code: "93130",
    labelFi: "Rakennusalan avustavat työntekijät",
    labelEn: "Building construction labourers",
    labelSv: "Medhjälpare, byggnadsverksamhet",
    searchFi: "93130 rakennusalan avustavat työntekijät",
    searchEn: "93130 building construction labourers",
    searchSv: "93130 medhjälpare, byggnadsverksamhet",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "93210",
    code: "93210",
    labelFi: "Käsinpakkaajat",
    labelEn: "Hand packers",
    labelSv: "Handpaketerare",
    searchFi: "93210 käsinpakkaajat",
    searchEn: "93210 hand packers",
    searchSv: "93210 handpaketerare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "93290",
    code: "93290",
    labelFi: "Muut valmistusalan avustavat työntekijät",
    labelEn: "Manufacturing labourers not elsewhere classified",
    labelSv: "Övriga medhjälpare inom industrin",
    searchFi: "93290 muut valmistusalan avustavat työntekijät",
    searchEn: "93290 manufacturing labourers not elsewhere classified",
    searchSv: "93290 övriga medhjälpare inom industrin",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "93310",
    code: "93310",
    labelFi: "Käsivetoisten- ja poljinkulkuneuvojen kuljettajat",
    labelEn: "Hand and pedal vehicle drivers",
    labelSv: "Förare av hand- och pedaldrivna bilar",
    searchFi: "93310 käsivetoisten- ja poljinkulkuneuvojen kuljettajat",
    searchEn: "93310 hand and pedal vehicle drivers",
    searchSv: "93310 förare av hand- och pedaldrivna bilar",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "93320",
    code: "93320",
    labelFi: "Eläinvetoisten kulkuneuvojen kuljettajat",
    labelEn: "Drivers of animal-drawn vehicles and machinery",
    labelSv: "Förare av djurdragna fordon",
    searchFi: "93320 eläinvetoisten kulkuneuvojen kuljettajat",
    searchEn: "93320 drivers of animal-drawn vehicles and machinery",
    searchSv: "93320 förare av djurdragna fordon",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "93330",
    code: "93330",
    labelFi: "Rahdinkäsittelijät, varastotyöntekijät ym.",
    labelEn: "Freight handlers",
    labelSv: "Godshanterare, lagerarbetare m.fl.",
    searchFi: "93330 rahdinkäsittelijät, varastotyöntekijät ym.",
    searchEn: "93330 freight handlers",
    searchSv: "93330 godshanterare, lagerarbetare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "93340",
    code: "93340",
    labelFi: "Hyllyjen täyttäjät",
    labelEn: "Shelf fillers",
    labelSv: "Varupåfyllare",
    searchFi: "93340 hyllyjen täyttäjät",
    searchEn: "93340 shelf fillers",
    searchSv: "93340 varupåfyllare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "94110",
    code: "94110",
    labelFi: "Pikaruokatyöntekijät",
    labelEn: "Fast food preparers",
    labelSv: "Personal inom snabbmatssektorn",
    searchFi: "94110 pikaruokatyöntekijät",
    searchEn: "94110 fast food preparers",
    searchSv: "94110 personal inom snabbmatssektorn",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "94120",
    code: "94120",
    labelFi: "Avustavat keittiötyöntekijät",
    labelEn: "Kitchen helpers",
    labelSv: "Köksbiträden",
    searchFi: "94120 avustavat keittiötyöntekijät",
    searchEn: "94120 kitchen helpers",
    searchSv: "94120 köksbiträden",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: "company"
  },
  {
    id: "95100",
    code: "95100",
    labelFi: "Mainosten jakajat, kengänkiillottajat ym.",
    labelEn: "Street and related service workers",
    labelSv: "Reklamutdelare, skoputsare m.fl.",
    searchFi: "95100 mainosten jakajat, kengänkiillottajat ym.",
    searchEn: "95100 street and related service workers",
    searchSv: "95100 reklamutdelare, skoputsare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "95200",
    code: "95200",
    labelFi: "Katumyyjät (pl. elintarvikkeet)",
    labelEn: "Street vendors (excluding food)",
    labelSv: "Gatuförsäljare (utom livsmedel)",
    searchFi: "95200 katumyyjät (pl. elintarvikkeet)",
    searchEn: "95200 street vendors (excluding food)",
    searchSv: "95200 gatuförsäljare (utom livsmedel)",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "96110",
    code: "96110",
    labelFi: "Jätteiden kerääjät",
    labelEn: "Garbage and recycling collectors",
    labelSv: "Avfallsinsamlare",
    searchFi: "96110 jätteiden kerääjät",
    searchEn: "96110 garbage and recycling collectors",
    searchSv: "96110 avfallsinsamlare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "96120",
    code: "96120",
    labelFi: "Jätteiden lajittelijat",
    labelEn: "Refuse sorters",
    labelSv: "Avfallssorterare",
    searchFi: "96120 jätteiden lajittelijat",
    searchEn: "96120 refuse sorters",
    searchSv: "96120 avfallssorterare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "96130",
    code: "96130",
    labelFi: "Kadunlakaisijat ym.",
    labelEn: "Sweepers and related labourers",
    labelSv: "Gatsopare m.fl.",
    searchFi: "96130 kadunlakaisijat ym.",
    searchEn: "96130 sweepers and related labourers",
    searchSv: "96130 gatsopare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "96210",
    code: "96210",
    labelFi: "Sanomalehtien jakajat, lähetit ja kantajat",
    labelEn: "Messengers, package deliverers and luggage porters",
    labelSv: "Tidnings- och reklamutdelare, bud",
    searchFi: "96210 sanomalehtien jakajat, lähetit ja kantajat",
    searchEn: "96210 messengers, package deliverers and luggage porters",
    searchSv: "96210 tidnings- och reklamutdelare, bud",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "96220",
    code: "96220",
    labelFi: "Satunnaistöiden tekijät",
    labelEn: "Odd job persons",
    labelSv: "Diversearbetare",
    searchFi: "96220 satunnaistöiden tekijät",
    searchEn: "96220 odd job persons",
    searchSv: "96220 diversearbetare",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "96230",
    code: "96230",
    labelFi: "Mittareiden lukijat ym.",
    labelEn: "Meter readers and vending-machine collectors",
    labelSv: "Mätaravläsare m.fl.",
    searchFi: "96230 mittareiden lukijat ym.",
    searchEn: "96230 meter readers and vending-machine collectors",
    searchSv: "96230 mätaravläsare m.fl.",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  },
  {
    id: "96290",
    code: "96290",
    labelFi: "Muut muualla luokittelemattomat työntekijät",
    labelEn: "Elementary workers not elsewhere classified",
    labelSv: "Övrig personal utan annan klassificering",
    searchFi: "96290 muut muualla luokittelemattomat työntekijät",
    searchEn: "96290 elementary workers not elsewhere classified",
    searchSv: "96290 övrig personal utan annan klassificering",
    freeTextFi: "",
    freeTextEn: "",
    freeTextSv: "",
    keyword: ""
  }
], fl = {
  list: vl
}, In = class In {
  /** Gets all occupations for all languages. */
  static getAllForAllLanguages() {
    if (this.data.length === 0) {
      const e = [];
      fl.list.forEach((t) => {
        e.push({
          id: t.id,
          code: t.code,
          label: t.labelFi,
          freeText: t.freeTextFi,
          search: t.searchFi,
          keyword: t.keyword,
          lang: "fi"
        }), e.push({
          id: t.id,
          code: t.code,
          label: t.labelSv,
          freeText: t.freeTextSv,
          search: t.searchSv,
          keyword: t.keyword,
          lang: "sv"
        }), e.push({
          id: t.id,
          code: t.code,
          label: t.labelEn,
          freeText: t.freeTextEn,
          search: t.searchEn,
          keyword: t.keyword,
          lang: "en"
        });
      }), this.data = e;
    }
    return this.data;
  }
  /**
   * Gets all the items of a given type.
   * @returns All occupation entries
   */
  static getAll(e) {
    return e = e || d.getLanguage() || Ee.Fi, this.getAllForAllLanguages().filter((t) => t.lang === e);
  }
  /**
   * Searches the occupations.
   * @param searchString String to search for. Typically user input.
   * @param language Language to search for.
   */
  static search(e, t) {
    return e = (e || "").toLowerCase(), e === "" && this.getAll(), this.getAll(t).filter((n) => (n.search || "").indexOf(e) >= 0);
  }
  /**
   * Gets a single occupation based on the original Statistics Finland code.
   * @param code - Statistics finland 5-number code.
   * Note that this is different than the Salaxy ID stored in Calculation.
   * Salaxy ID may specify additional suffix separated by dash. For Salaxy ID, use getById() instead.
   * @returns Occupation metadata or null if not found.
   */
  static getByCode(e) {
    return this.getAll().find((t) => t.code === e);
  }
  /**
   * Gets a single occupation based on the its Salaxy ID, which is derived from the original  Statistics Finland code.
   * @param id - Salaxy ID for the occupation.
   * This is the id stored in the calculation, but not the one that is reported to Incomes Register.
   * @returns Occupation metadata or null if not found.
   */
  static getById(e) {
    if (e)
      return this.getAll().find((t) => t.id === e);
  }
  /**
   * Fetches a list of occupations either based on list of IDs or a known keyword.
   * @param idListOrKeyword Either a comma separated list of ID's
   * or a known keyword: "household" and "company" currently supported.
   */
  static getByIds(e) {
    if (!e)
      return [];
    const t = e.split(",").map((i) => i.trim()), n = /^\d{5}/;
    return e.search(n) > -1 ? this.getAll().filter((i) => i.id && t.indexOf(i.id) > -1) ?? [] : this.getAll().filter((i) => i.keyword && t.some((s) => (i.keyword?.indexOf(s.trim()) ?? -1) > -1)) ?? [];
  }
};
In.data = [];
let xt = In;
class gl {
  /** Gets the authentication methods for digital signature. */
  static getTupasMethods() {
    const e = "https://cdn.salaxy.com/img", t = [
      "op",
      "nordea",
      "danske",
      "spankki",
      "handelsbanken",
      "mobiilivarmenne",
      "aktia",
      "pop",
      "sp",
      "omasp",
      "alandsbanken"
    ], n = Vr.map((i, s) => ({
      id: i.identifier,
      title: i.name,
      img: t[s] ? `${e}/salaxy/sign/${t[s]}.png` : i.image,
      isPopular: s < 3
    }));
    return pe.current?.isTestData && (n.splice(2, 0, {
      id: "tupas-tbank",
      img: `${e}/salaxy/sign/test-tbank.png`,
      isPopular: !0,
      title: "Testing ID"
    }), n[3].isPopular = !1), n;
  }
  /**
   * Gets the new version of authentication methods by Telia.
   * @returns Array of euthentication methods.
   */
  static getTeliaMethods() {
    const e = [
      { img: "https://cdn.salaxy.com/img/salaxy/sign/op.png", id: "saml.op.1", title: "Osuuspankki", isPopular: !0 },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/nordea.png", id: "oidc.nordea.1", title: "Nordea", isPopular: !0 },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/danske.png", id: "oidc.danskebank.1", title: "Danske Bank", isPopular: !0 },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/spankki.png", id: "oidc.spankki.1", title: "S-Pankki", isPopular: !1 },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/handelsbanken.png", id: "oidc.handelsbanken.1", title: "Handelsbanken", isPopular: !1 },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/mobiilivarmenne.png", id: "mpki.telia.1", title: "Mobiilivarmenne", isPopular: !1 },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/aktia.png", id: "oidc.aktia.1", title: "Aktia", isPopular: !1 },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/pop.png", id: "oidc.pop.1", title: "POP Pankki", isPopular: !1 },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/sp.png", id: "oidc.sp.1", title: "Säästöpankki", isPopular: !1 },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/omasp.png", id: "oidc.omasp.1", title: "Oma Säästöpankki", isPopular: !1 },
      { img: "https://cdn.salaxy.com/img/salaxy/sign/alandsbanken.png", id: "oidc.alandsbanken.1", title: "Ålandsbanken", isPopular: !1 }
    ];
    return pe.current?.isTestData && e.unshift({ img: "https://cdn.salaxy.com/img/salaxy/sign/test-tbank.png", id: "TEST", title: "Testi", isPopular: !0 }), e;
  }
}
class bl {
  /**
   * OBSOLETE
   * @deprecated This is not any more updated and should not be used.
   */
  static getEInvoiceIntermediators() {
    return {
      HELSFIHH: "Aktia - HELSFIHH",
      "003723327487": "Apix Messaging Oy - 003723327487",
      BAWCFI22: "Basware Oyj - BAWCFI22",
      "003703575029": "CGI - 003703575029",
      DABAFIHH: "Danske Bank - DABAFIHH",
      DNBAFIHX: "DNB - DNBAFIHX",
      HANDFIHH: "Handelsbanken - HANDFIHH",
      "885790000000418": "HighJump AS - 885790000000418",
      INEXCHANGE: "InExchange Factorum AB - INEXCHANGE",
      EXPSYS: "Lexmark Expert Systems AB - EXPSYS",
      "003708599126": "Liaison Technologies Oy - 003708599126",
      "003721291126": "Maventa - 003721291126",
      "003726044706": "Netbox Finland Oy - 003726044706",
      NDEAFIHH: "Nordea Pankki - NDEAFIHH",
      E204503: "OpusCapita Solutions Oy - E204503",
      OKOYFIHH: "Osuuspankit ja Pohjola Pankki - OKOYFIHH",
      PAGERO: "Pagero - PAGERO",
      PALETTE: "Palette Software - PALETTE",
      POPFFI22: "POP Pankki  - POPFFI22",
      "003710948874": "Posti Messaging Oy - 003710948874",
      "003701150617": "PostNord Strålfors Oy - 003701150617",
      "003714377140": "Ropo Capital Oy - 003714377140",
      SBANFIHH: "S-Pankki - SBANFIHH",
      TAPIFI22: "S-Pankki (ent. LähiTapiola Pankin tunnus toistaiseksi käytössä) - TAPIFI22",
      ITELFIHH: "Säästöpankit - ITELFIHH",
      "003701011385": "Tieto Oyj - 003701011385",
      "885060259470028": "Tradeshift - 885060259470028",
      AABAFI22: "Ålandsbanken - AABAFI22"
    };
  }
}
class uo {
  /**
   * Gets a link URL for a yearly report. This is a relative link from the servr root (e.g. "/ReportHtml/YearEndReportJson?year=2017").
   * Typically the environment specific implementation needs to figure out the server address and token.
   * @param type - Type of the report must be one of the yearly reports
   * @param year - Year for the report
   * @param token - Token for authentication. Adds "access_token" to the query string.
   * This is typically required from the environment specific implementation,
   * but in exceptional cases you may use some other authentication mechanism and thus leave this null.
   * @param id - Worker ID for those reports that are specific to one Worker.
   * @param id2 - Second Worker ID for those reports that have two Workers in one report
   */
  static getYearlyReportUrl(e, t, n, i, s) {
    let r;
    switch (e) {
      case xe.YearEndReport:
        r = `/ReportHtml/YearEndReportJson?year=${t}`;
        break;
      case xe.YearlyDetails:
      case xe.Insurance:
      case xe.HouseholdDeduction:
        r = `/ReportHtml/${e}?year=${t}`;
        break;
      case xe.YearlyWorkerSummary:
        r = `/ReportHtml/${e}/${i}?year=${t}`;
        break;
      case xe.Unemployment:
        r = `/ReportPdf/${e}?year=${t}`;
        break;
      case xe.TaxYearly7801:
        r = `/ReportPdf/${e}/${i}?year=${t}`;
        break;
      case xe.TaxHouseholdDeduction14B:
      case xe.TaxHouseholdDeduction14BSpouseA:
      case xe.TaxHouseholdDeduction14BSpouseB:
        r = `/ReportPdf/${e}/${i}?id2=${s || ""}&year=${t}`;
        break;
      default:
        throw new Error("Not a supported year end report: " + e);
    }
    return n && (r = r + "&access_token=" + n), r;
  }
  /**
   * Gets a URL for a calculation pdf file. This is a relative link from the servr root (e.g. "/ReportPdf/SalarySlip/CALC_ID_HERE").
   * Typically the environment specific implementation needs to figure out the server address and token.
   * @param reportType - Type of report
   * @param calcId - Identifier of the calculation. This method requires that the calculation has been saved.
   * @param inline - If true, the Content-Disposition header is returned with inline parameter.
   * @param token - Token for authentication. Adds "access_token" to the query string.
   * This is typically required from the environment specific implementation,
   * but in exceptional cases you may use some other authentication mechanism and thus leave this null.
   */
  static getCalcPdfUrl(e, t, n = !1, i) {
    if (!t)
      throw new Error("Calculation ID is required by getCalcPdfUrl");
    switch (e) {
      case "salarySlip":
      case "paymentReport":
      case "paymentSummaryReport":
      case "employerReport": {
        let s = `/ReportPdf/${e}/${t}?inline=${n ? "true" : "false"}`;
        return i && (s += "&access_token=" + i), s;
      }
      default:
        throw new Error("Unknown type in getCalcPdfUrl: " + e);
    }
  }
  /** Gets metadata about the supported report types */
  static getReportTypes() {
    const e = [
      {
        id: "undefined",
        title: "Valitse...",
        description: "Ei valintaa tai tuntematon tyyppi. ",
        roles: "",
        category: "tech"
      },
      {
        id: "example",
        title: "Esimerkki",
        description: "Esimerkki raportti kehityskäyttöön. Ei dataa, ei parametrejä.",
        roles: "",
        category: "tech"
      },
      {
        id: "monthlyDetails",
        title: "Monthly details",
        description: "The most detailed of the employer monthly reports.",
        roles: "employer",
        category: "monthly"
      },
      {
        id: "taxMonthly4001",
        title: "Monthly tax report (4001)",
        description: "Monthly tax report",
        roles: "employer",
        category: "monthly"
      },
      {
        id: "monthlyPension",
        title: "Monthly pension report",
        description: "Monthly pension report",
        roles: "employer",
        category: "monthly"
      },
      {
        id: "monthlyLiikekirjuri",
        title: "Accounting report (Liikekirjuri)",
        description: "'Liikekirjuri' - a historical monthly report that was used for 2016 and 2017. Will be replaced by Rapko.",
        roles: "company",
        category: "monthly"
      },
      {
        id: "monthlyRapko",
        title: "Accounting report (Rapko)",
        description: "Rapko / Raportointikoodisto is the Finnish standard for accounting.",
        roles: "company",
        category: "monthly"
      },
      {
        id: "yearlyDetails",
        title: "Yearly details",
        description: "Detailed list for employer - this is a general report.",
        roles: "employer",
        category: "yearly"
      },
      {
        id: "yearEndReport",
        title: "Year-end report",
        description: "The year-end report with customer feedback",
        roles: "employer",
        category: "yearly"
      },
      {
        id: "yearlyWorkerSummary",
        title: "Yearly worker summary",
        description: "Detailed report - similar to salary slip - from employer to worker. This report must be given by employer according to Finnish law.",
        roles: "employer",
        category: "yearly"
      },
      {
        id: "taxYearly7801",
        title: "Yearly tax report (7801)",
        description: "Form 7801: Yearly report for Finnish tax authorities",
        roles: "employer",
        category: "yearly"
      },
      {
        id: "unemployment",
        title: "Unemployment insurance report",
        description: "Report for Finnish Unemployment insurance TVR",
        roles: "employer",
        category: "yearly"
      },
      {
        id: "insurance",
        title: "Accident insurance report",
        description: "Report for mandatory accident insurance company",
        roles: "employer",
        category: "yearly"
      },
      {
        id: "householdDeduction",
        title: "Household deduction yearly report",
        description: "General (internal) household deduction yearly report.",
        roles: "household",
        category: "yearly"
      },
      {
        id: "taxHouseholdDeduction14B",
        title: "Household deduction report to authorities (14B)",
        description: "Form 14B: Household deduction report for Finnish tax authorities. All deductible salaries included.",
        roles: "household",
        category: "yearly"
      },
      {
        id: "taxHouseholdDeduction14BSpouseA",
        title: "Household deduction 14B, self only",
        description: "Form 14B: Household deduction report for Finnish tax authorities. Contains only deductible salaries which are attributed to self.",
        roles: "household",
        category: "yearly"
      },
      {
        id: "taxHouseholdDeduction14BSpouseB",
        title: "Household deduction 14B, spouse only",
        description: "Form 14B: Household deduction report for Finnish tax authorities. Contains only deductible salaries which are split to spouse of customer.",
        roles: "household",
        category: "yearly"
      },
      {
        id: "salarySlipCopy",
        title: "Salary slip (worker copy)",
        description: "Copy of the salary slip for the worker.",
        roles: "worker",
        category: "calc"
      },
      {
        id: "salarySlipPaid",
        title: "Salary slip (paid by employer)",
        description: "Salary slip paid by the employer",
        roles: "employer",
        category: "calc"
      },
      {
        id: "employerReport",
        title: "Employer report of salary",
        description: "Report of a single calculation from the Employer point-of-view",
        roles: "employer",
        category: "calc"
      },
      {
        id: "paymentReport",
        title: "Payment report of salary",
        description: "Report of a single calculation from the payments / society point-of-view.",
        roles: "employer",
        category: "calc"
      },
      {
        id: "paymentSummaryReport",
        title: "Payment summary report of salary/salaries",
        description: "Report of a calculation/calculations from the payments / society point-of-view.",
        roles: "employer",
        category: "calc"
      },
      {
        id: "employmentContract",
        title: "Employment contract",
        description: "Employment contract",
        roles: "all",
        category: "contract"
      }
    ];
    for (const t of e)
      t.title = d.get("SALAXY.ENUM.ReportType." + t.id + ".label"), t.description = d.get("SALAXY.ENUM.ReportType." + t.id + ".description");
    return e;
  }
  /**
   * Returns a URL for a pay certificate pdf file. This is a relative link from the server root.
   * Typically the environment specific implementation needs to figure out the server address and token.
   * @param workerId Worker id for which the certificate should be created.
   * @param calculationIds Calculation ids to include in the certificate.
   * @param inline - If true, the Content-Disposition header is returned with inline parameter.
   * @param token - Token for authentication. Adds "access_token" to the query string.
   * This is typically required from the environment specific implementation,
   * but in exceptional cases you may use some other authentication mechanism and thus leave this null.
   */
  static getPayCertificatePdfUrl(e, t, n = !1, i) {
    let s = `/ReportPdf/PayCertificate/${encodeURIComponent(e)}?`;
    return t.forEach((r) => {
      s += "calculationIds=" + encodeURIComponent("" + (r ?? "")) + "&";
    }), s += `inline=${n}`, i && (s += "&access_token=" + i), s;
  }
}
class jl {
  /**
   * Checks whether the user is in a given role
   * @param session - Session of the current account.
   * @param appStatus - Additional information about the session and application status.
   * @param role - One of the known roles or role from server.
   * You can also use exclamation mark for negative (e.g.)
   * @returns Boolean whether user is in the given role
   */
  static isInRole(e, t, n) {
    if (!n)
      return !0;
    if (n.indexOf("&&") > 0) {
      const o = n.split("&&").map((u) => u.trim());
      return this.isInAllRoles(e, t, o);
    }
    if (n.indexOf("||") > 0) {
      const o = n.split("||").map((u) => u.trim());
      return this.isInSomeRole(e, t, o);
    }
    n = n.trim();
    const i = n.startsWith("!");
    i && (n = n.substr(1)), n = (n || "any").trim(), n = n.substr(0, 1).toLowerCase() + n.substr(1);
    let s;
    const r = e ? e.currentAccount : null;
    if (r)
      if (r.entityType === me.Company)
        s = $.Company;
      else {
        const o = r;
        o.lastLoginAs === on.Worker || !o.isEmployer && o.isWorker ? s = $.Worker : s = $.Household;
      }
    const l = (o) => {
      switch (o) {
        case $.Unknown:
          return t.sessionCheckInProgress;
        case $.Anon:
          return !t.sessionCheckInProgress && (!e || !e.isAuthorized);
        case $.Init:
          return t.sessionCheckInProgress;
        case $.Hidden:
          return !1;
        case $.Test:
          return !!t.isTestData;
        case $.Prod:
          return !t.isTestData;
        case $.Any:
        case "*":
          return !0;
        case $.Auth:
          return !!(e && e.isAuthorized);
        case $.Worker:
          return s === $.Worker;
        case $.Employer:
          return s === $.Company || s === $.Household;
        case $.Household:
          return s === $.Household;
        case $.Company:
          return s === $.Company;
        case $.Person:
          return s === $.Worker || s === $.Household;
        case $.NonVerified:
          return !!(r && !r.isVerified);
        case $.FiTm:
        case $.FiOy:
        case $.FiRy:
          return s === $.Company && e.currentAccount.companyType === o;
        case $.PartnerMessaging:
          return !!e?.settings?.partnerMessages;
        default:
          return !!(r && (e?.currentAccount?.identity?.roles?.indexOf(o) ?? -1) >= 0 || t.clientRoles.indexOf(o) >= 0);
      }
    };
    return i ? !l(n) : l(n);
  }
  /**
   * Returns true if the current account is a member of all of the given roles.
   * Returns true if the roles is null or an empty array or and an empty string.
   * @param session - Session of the current account.
   * @param appStatus - Additional information about the session and application status.
   * @param roles - Array of role values.
   */
  static isInAllRoles(e, t, n) {
    return !n || n.length === 0 ? !0 : n.every((i) => this.isInRole(e, t, i));
  }
  /**
   * Returns true if the current account is a member of some of the given roles.
   * Returns true if the roles is null or an empty array or an empty string.
   * @param session Session of the current account.
   * @param appStatus State of the current application (i.e. login, session check etc.)
   * @param roles Array of role values.
   */
  static isInSomeRole(e, t, n) {
    return !n || n.length === 0 ? !0 : n.some((i) => this.isInRole(e, t, i));
  }
}
const tt = class tt {
  /**
   * Returns true, if the given date is a valid Salary date for given gross salary payment date.
   *
   * @param salaryDate - Salary date (the date when the salary is in worker).
   * @param iban - Bank account number of the worker.
   * @param paidAt - Date for the gross salary payment.
   * @param isRequestedSalaryDateSet - Boolean indicating if the salary date is the requested salary date.
   * @param channel - Payment channel.
   * @param zeroPayment - A boolean indicating if the net salary payment to worker is zero.
   * @param role - Current client role, only: pro and admin roles have effect currently
   * @returns - True if the given dates are not conflicting (salary date is possible for given paid at date).
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static isValidSalaryDate(e, t = void 0, n = null, i = !1, s = void 0, r = !1, l = void 0) {
    const o = c.getToday();
    if (c.isSameOrAfter(o, "2024-12-23") && c.isBefore(o, "2025-01-01") && c.isSameOrAfter(e, o) && c.isBefore(e, "2025-01-01"))
      return !0;
    if (!c.isWorkday(e))
      return !1;
    const u = this.calculateSalaryDate(t, n, i, s, r);
    return c.getWorkdays(u, e).length >= 1;
  }
  /**
   * Calculates the estimated salary date (the date when the salary is in worker) for the given gross salary payment date.
   *
   * @param _iban  - The iban number of the worker.
   * @param paidAt - Date for the salary gross payment.
   * @param isRequestedSalaryDateSet - Flag to indicate, if the requested salary date is set.
   * @param channel - Payment channel.
   * @param zeroPayment - A boolean indicating if the net salary payment to worker is zero.
   */
  static calculateSalaryDate(e = void 0, t = null, n = !1, i = void 0, s = !1) {
    let r = 0, l = 0, o = c.getDatelyObject(/* @__PURE__ */ new Date()), u = c.getDatelyObject(t) ?? "";
    u ? o = va.add(u, va.getUTCOffset(u) ?? 0, "minute") : u = va.add(o, -1 * (va.getUTCOffset(o) ?? 0), "minute"), c.isWorkday(u) && (i === F.PalkkausCfaPaytrail || i === F.PalkkausEcfaPaytrail ? l = 0 : l = (va.getHour(o) ?? 0) >= 17 || (c.getDay(u) ?? "") !== (c.getDay(o) ?? "") ? this.daysLatePaymentDelay : 0);
    const m = c.getWorkday(u) ?? "";
    Sa.isCfa(i) ? (r += this.daysCustomerServiceProcessing, n ? r += 2 : (r += l, (i === F.PalkkausCfaPaytrail || i === F.PalkkausEcfaPaytrail) && (r += 1))) : r += l + 1;
    const p = c.addWorkdays(m, s || Sa.isPalkkausManualLike(i) || Sa.isPalkkausInvoicesLike(i) ? 0 : r);
    return c.asDate(p);
  }
};
tt.daysCustomerServiceProcessing = 1, tt.daysLatePaymentDelay = 1;
let Et = tt;
class Sl {
  /**
   * Returns pension number for test account
   * @param company The company enumerations.
   * Only the most common pension companies are supported.
   */
  static getPensionNumberForTest(e) {
    const t = "0123456789ABCDEFHJKLMNPRSTUVWXY", n = "1111111", i = (s) => s + "-" + n + t[parseInt(s + n, 10) % 31];
    switch (e) {
      case U.Varma:
        return "55-1111111S";
      case U.Elo:
        return "54-11111114";
      case U.Ilmarinen:
        return "46-1111111Y";
      case U.Veritas:
        return "56-1111111D";
      case U.Apteekkien:
        return "80009-1111N";
      case U.Verso:
        return "80008-11113";
      case U.KevaMunicipal:
        return i("20");
      case U.KevaAland:
        return i("24");
      case U.KevaChurch:
        return i("25");
      case U.KevaKela:
        return i("29");
      case U.KevaState:
        return i("30");
      case U.Valio:
        return "80001-11111";
      default:
        return null;
    }
  }
}
class ko {
  /**
   * Gets the idAtOwner format full ID ("[id]@[owner]") for a URI.
   * IdAtOwner format is easier to use in REST API, as part of URL than URI format.
   * @param uriString URI as ("[Potentially, a server]/[PayloadType]/[Owner]/[Id]", e.g. "/CalculationDTO/FI86POYL0009461858/16ea052e-f23f-4b72-83a9-b8f6590f0dc9")
   * @returns The owner and is in "[id]@[owner]" format.
   */
  static getIdAtOwner(e) {
    const t = this.parseUri(e);
    return t.id + "@" + t.owner;
  }
  /**
   * Gets the URL in local form without the server part:
   * "/[PayloadType]/[Owner]/[Id]", e.g. "/CalculationDTO/FI86POYL0009461858/16ea052e-f23f-4b72-83a9-b8f6590f0dc9".
   * @param uriString Uri that potentially has a server in the beginning (like list item uri).
   * @param forceParse If true, the URI is parsed to URI parts even if it already seems to be a local URI (starts with "/").
   * By default URI's that start with "/" are returned as is without further conversion.
   */
  static getLocalUri(e, t = !1) {
    if (!e)
      return;
    if (e[0] == "/" && !t)
      return e;
    const n = this.parseUri(e);
    return `/${n.payloadType}/${n.owner}/${n.id}`;
  }
  /**
   * Parses a Palkkaus storage URI in list item or container to relevant parts:
   * Payload type, Owner and Id.
   * @param uriString Uri string to parse as relevant URI parts.
   * ("[Potentially, a server]/[PayloadType]/[Owner]/[Id]", e.g. "/CalculationDTO/FI86POYL0009461858/16ea052e-f23f-4b72-83a9-b8f6590f0dc9")
   * @returns Reelvant URI parts: Payload type, Owner and Id.
   */
  static parseUri(e) {
    const t = new URL(e, "https://www.palkkaus.fi").pathname.split("/");
    if (t.length < 4)
      throw new Error("Invalid URI: " + e);
    const n = {
      payloadType: t[1],
      owner: t[2],
      id: t[3]
    };
    if (!n.id || !n.owner)
      throw new Error("Invalid URI: " + e);
    return n;
  }
}
class Tl {
  /** Resolves an URL (shortened schema document URL) as an absolute URL string. */
  resolveUrl(e) {
    if (e.startsWith("/")) {
      if (!window)
        throw new Error(`Relative url not supported outside browser scope: '${e}'.`);
      const t = window.location.href.split("/");
      e = `${t[0]}//${t[2]}${e}`;
    } else
      e = e.replace(/^salaxy-secure\//g, `${new no().getServerAddress()}/`);
    return e;
  }
  /**
   * Gets a custom validator for the given element.
   * If none is returned, the default validators are used.
   * If you want to disable default validators, you should return a function that returns null.
   * @param element Element for which the validator is fetched.
   * @param element.validator Validator is a string identifying the validator (attribute in the input component).
   * @param element.getRequire Function that returns true if the input is required.
   * @returns A custom validator function or undefined if the default validators should be used.
   * Validator function takes the value (bool and nmber are currently typed) and returns and error message or null if the value is valid.
   * Message is typically a key for a translation.
   */
  getValidator(e) {
    if (!e.validator)
      return;
    const n = {
      sxyCompanyIdFi: (i) => !je.formatCompanyIdFi(i),
      sxyCurrency: (i) => !je.isCurrency(i),
      sxyEmail: (i) => !je.isEmail(i),
      sxyIban: (i) => !je.isIban(i),
      sxyInteger: (i) => !je.isInteger(i),
      sxyMobilePhone: (i) => !je.isMobilePhone(i),
      sxyNumber: (i) => !je.isNumber(i),
      sxyPensionContractNumber: (i) => !je.isPensionContractNumber(i),
      sxyPersonalIdFi: (i) => !je.isPersonalIdFi(i),
      sxyPostalCodeFi: (i) => !je.isPostalCodeFi(i),
      sxyTaxPercent: (i) => !je.isTaxPercent(i),
      sxyTemporaryPensionContractNumber: (i) => !je.isTemporaryPensionContractNumber(i)
    }[e.validator];
    if (n)
      return (i) => {
        if (e.getRequire() && !i)
          return "SALAXY.VALIDATION.ValidationErrors.required";
        if (n(i))
          return `SALAXY.VALIDATION.ValidationErrors.${e.validator}`;
      };
  }
  /**
   * Translates given key to the current language with default value.
   * @param key - Key for the text.
   * @param defaultValue - The default value that is returned if the key is not found.
   * Note that `null` and `undefined` (omitted parameter) function differently here:
   * Null returns undefined if the key is not found.
   * Undefined returns always a text: It uses the resolve logic of the translations provider.
   * Typically, this logic will attempt to find the text in the default language of the app and if not available,
   * returns the last part of the key with potential red exclamation mark.
   * @returns The translated value or default value as explained above.
   */
  getText(e, t = "") {
    return t === void 0 ? d.get(e) : d.getWithDefault(e, t);
  }
  /**
   * Gets a unit text for an input that has a given format.
   * Units are short texts in the input e.g. %, km, €, h, min, days, weeks.
   * @param format - Format of the input either in the schema or explicitly as input component attribute.
   */
  getUnitText(e) {
    return this.getText(`SALAXY.ENUM.Unit.${e}.shortIndicator`, "");
  }
  /**
   * Gets a description text for an enumeration value in current language.
   * Note that this may not be available for all enumerations by design.
   * @param enumType - Name of the Type of the enumeration.
   * @param enumValue Name/value of the member for which the description is fetched.
   * @returns Language specific text form translations or undefined if none is found.
   */
  getEnumDescr(e, t) {
    return H.getEnumDescr(e, t);
  }
  /**
   * Gets a label text for an enumeration value.
   * @param enumType Name of the Type of the enumeration.
   * @param enumValue Name/value of the member for which the label is fetched.
   * @returns Language specific text form translations or the memberName text if no translation is found.
   */
  getEnumLabel(e, t) {
    return H.getEnumLabel(e, t);
  }
  /**
   * Gets the metadata (texts etc.) for an enumeration and its values.
   * @param enumName -  Name of the Type of the enumeration.
   */
  getEnumMetadata(e) {
    return H.getEnumMetadata(e);
  }
}
class Ta {
  /**
   * Gets a new blank taxcard with default values, suitable for UI binding.
   *
   * @param personalId The personal ID that is used to connect the Taxcard to a person. This is required in save.
   * @param kind If specified, sets the type and defaults according to the type
   * @param year Specifies the year. This is used in December-January when there may be cards from both years.
   * Current year is the default.
   * @param today Allows changing the today date in unit testing etc. Default is actual today.
   */
  static getBlank(e, t = void 0, n, i) {
    var r;
    i = i || c.getToday(), n = n || c.getYear("today");
    const s = {
      worker: null,
      card: {
        personalId: e ?? "",
        forYear: n,
        taxPercent: null,
        incomeLimit: null,
        taxPercent2: null,
        kind: z.Undefined,
        fileUri: null,
        previewUri: null,
        validity: {}
      },
      incomeLog: [],
      id: null,
      createdAt: i,
      updatedAt: i,
      isReadOnly: null
    };
    if (t)
      switch (s.card.kind = t, (r = s.card).validity ?? (r.validity = {}), t) {
        case z.Undefined:
          s.card.taxPercent = 23;
          break;
        case z.NoWithholdingHousehold:
          s.card.taxPercent = 0, s.card.validity.start = i;
          break;
        case z.NoTaxCard:
          s.card.taxPercent = 60, s.card.validity.start = i;
          break;
        case z.DefaultYearly:
          s.card.validity.start = `${n}-01-01`, s.card.validity.end = `${n}-12-31`;
          break;
        case z.Replacement:
        case z.Others:
        case z.Historical:
          s.card.validity.start = c.getYear(i) < n ? `${n}-01-01` : c.getYear(i) > n ? `${n}-12-31` : i, s.card.validity.end = `${n}-12-31`;
          break;
      }
    return s;
  }
  /**
   * Gets display information and texts for taxcard within a calculation.
   * Helper for showing taxcards UI's for calculations.
   * NOTE: The data is cached to the calculation ($ui) until round-trip to server.
   * @param calc Calculation for which the data is resolved.
   */
  static getCalcTaxcardInfo(e) {
    const t = {
      status: null,
      kind: z.Undefined,
      text: void 0,
      shortText: void 0,
      percent: void 0
    };
    if (!e)
      return t;
    const n = na.getUiCache(e);
    if (n.tax)
      return n.tax;
    if (!e.worker || !e.worker.tax)
      return n.tax = t, t;
    if (e.result?.responsibilities?.employmentTaxcard == xa.TaxAtSource)
      return t.status = "ok", t.text = "Lähdeverokortti", t.shortText = "Lähdeverokortti", n.tax = t, t;
    if (e.result?.responsibilities?.employmentTaxcard == xa.NoTaxCard)
      return t.status = "ok", t.text = H.getEnumLabel("TaxcardKind", z.NoTaxCard), t.shortText = t.text, t.percent = 60, n.tax = t, t;
    if (e.rows?.some((s) => s.rowType === k.TaxWithholding))
      return t.status = "ok", t.text = "Ennakonpidätys rivillä", t.shortText = "Ennakonpidätys rivillä", n.tax = t, t;
    const i = e.worker.tax;
    switch (t.kind = (i.snapshot ? i.snapshot.kind : null) || z.Undefined, t.status = t.kind === z.Undefined ? "missing" : "ok", t.kind) {
      case z.Undefined:
        t.text = H.getEnumLabel("TaxcardKind", t.kind), t.shortText = d.get("SALAXY.CORE.Taxcard2019Logic.noTaxcard");
        break;
      case z.NoTaxCard:
        t.text = H.getEnumLabel("TaxcardKind", t.kind), t.shortText = t.text, t.percent = 60;
        break;
      case z.NoWithholdingHousehold:
        t.text = H.getEnumLabel("TaxcardKind", t.kind), t.shortText = t.text, t.percent = 0;
        break;
      default:
        t.percent = e.worker.tax.snapshot?.taxPercent, (e.result?.totals?.totalTaxable ?? 0) > 0 && (t.percent = (e.worker.tax.estimatedTax ?? 0) / (e.result?.totals?.totalTaxable ?? 0) * 100), t.text = H.getEnumLabel("TaxcardKind", t.kind) + ": " + h.formatPercent(t.percent), t.shortText = d.get("SALAXY.UI_Terms.withholdingTax") + ": " + h.formatPercent(t.percent);
        break;
    }
    return n.tax = t, t;
  }
  /**
   * Checks if the taxcard is valid for the salary date.
   * This is used when in test environment the salaryDate may be changed in UX.
   * Typically, you should get this information from the API methods.
   * @param card Taxcard to check.
   * @param salaryDate Salary date. Default is today.
   */
  static isTaxcardValid(e, t = "today") {
    return !e || !e.card || !e.card.validity ? !1 : (t = c.asDate(t) || c.getToday(), !((e.card.validity?.start ?? "") > t) && !((e.card.validity?.end ?? "") < t) || c.getMonth(t) === 1 && e.card.forYear === c.getYear(t) - 1);
  }
  /**
   * TODO: This is currently used for charting only. As such it could probably be simplified
   * and / or combined with getMainChart() / getPieChart().
   * Gets information about the the income limit and real percent.
   * Note that this method calculates the real percent i.e.
   * for examples and no tax cards 60%. If you wish to see the example percent here (23%),
   * catch it separately.
   * @param taxcard Card to analyze
   */
  static getIncomeLimitInfo(e) {
    const t = {
      type: z.Undefined,
      percent: 60,
      hasLimit: !1,
      fractionOfLimit: 0
    };
    if (!e || !e.card || !e.card.kind)
      return t;
    const n = e.card;
    switch (t.percent = n.taxPercent === 0 ? 0 : n.taxPercent || 60, t.type = n.kind ?? z.Undefined, t.type) {
      case z.Auto:
      case z.DefaultYearly:
      case z.Replacement:
      case z.Others:
        return t.hasLimit = !!(n.incomeLimit && n.taxPercent2), t.hasLimit && (t.fractionOfLimit = (e.result?.totalIncome ?? 0) / (n.incomeLimit ?? 0), (e.result?.totalIncome ?? 0) > (n.incomeLimit ?? 0) && n.taxPercent2 && (t.percent = n.taxPercent2)), t;
      case z.NoTaxCard:
      case z.NoWithholdingHousehold:
      case z.Undefined:
      default:
        return t;
    }
  }
  /** Gets the main chart for taxcards */
  static getMainChart(e) {
    const t = Ta.getIncomeLimitInfo(e), n = e.card.incomeLimit, i = e.result?.totalIncome ?? 0, s = e.card.taxPercent, r = e.card.taxPercent2;
    let l = 0, o = e.incomeLog?.sort((x, v) => (x.paidAt ?? "") < (v.paidAt ?? "") ? -1 : (x.paidAt ?? "") > (v.paidAt ?? "") ? 1 : 0).map((x) => (l += x.income, { x: x.paidAt, y: l }));
    o?.length === 0 && (o = [
      { x: e.card.validity?.start ?? "", y: 0 }
    ]);
    const u = [
      { x: e.card.validity?.start ?? "", y: 0 },
      { x: e.card.validity?.end ?? "", y: e.card.incomeLimit ?? 0 }
    ], m = ve.getBrandColor("primary", "rgba"), p = ve.getBrandColor("danger", "rgba"), y = ve.getBrandColor("warning", "rgba");
    return {
      limits: t,
      data: [
        o,
        u
      ],
      labels: [],
      datasets: [
        {
          label: d.get("SALAXY.UI_Terms.salaryPayment"),
          fill: !1,
          index: 2,
          lineTension: 0,
          backgroundColor: m,
          pointBackgroundColor: m,
          pointHoverBackgroundColor: m,
          borderColor: m,
          pointBorderColor: m,
          pointHoverBorderColor: m
        },
        {
          label: d.get("SALAXY.UI_Terms.incomeLimit"),
          backgroundColor: y,
          pointBackgroundColor: y,
          pointHoverBackgroundColor: y,
          borderColor: y,
          pointBorderColor: y,
          pointHoverBorderColor: y,
          fill: !1,
          borderDash: [5, 5],
          lineTension: 0
        }
      ],
      options: {
        maintainAspectRatio: !1,
        legend: {
          display: !0,
          position: "bottom"
        },
        title: {
          display: !0,
          text: d.get("SALAXY.CORE.Taxcard2019Logic.chartTitle")
        },
        scales: {
          yAxes: [{
            display: !0,
            ticks: {
              suggestedMax: (n ?? 0) * 1.5,
              // minimum will be 0, unless there is a lower value.
              // OR //
              beginAtZero: !0
              // minimum value will be 0.
            }
          }],
          xAxes: [{
            type: "time",
            time: {
              displayFormats: {
                millisecond: "D.M.YYYY",
                second: "D.M.YYYY",
                minute: "D.M.YYYY",
                hour: "D.M.YYYY",
                day: "D.M.YYYY",
                week: "D.M.YYYY",
                month: "D.M.YYYY",
                year: "D.M.YYYY"
              },
              minUnit: "day",
              tooltipFormat: "D.M.YYYY"
            }
          }]
        },
        annotation: {
          annotations: [
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: n,
              borderColor: p,
              borderWidth: 2,
              label: {
                position: "left",
                enabled: !0,
                content: `${n} €`,
                fontColor: "#fff",
                fontSize: 11,
                backgroundColor: p,
                yAdjust: 0,
                xAdjust: 60
              }
            },
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: n,
              borderColor: "transparent",
              borderWidth: 0,
              label: {
                position: "left",
                enabled: !0,
                content: `${r} %`,
                fontSize: 16,
                fontColor: p,
                backgroundColor: "transparent",
                yAdjust: -11,
                xAdjust: 5
              }
            },
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: n,
              borderColor: "transparent",
              borderWidth: 0,
              label: {
                position: "left",
                enabled: !0,
                content: `${s} %`,
                fontSize: 16,
                fontColor: y,
                backgroundColor: "transparent",
                yAdjust: 15,
                xAdjust: 5
              }
            },
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: 0,
              borderColor: "transparent",
              borderWidth: 0,
              label: {
                position: "right",
                enabled: !0,
                content: `31.12.${e.card.forYear}: ${h.round(i, 0)} €`,
                fontSize: 12,
                fontColor: m,
                backgroundColor: "#fff",
                yAdjust: -30,
                xAdjust: 10
              }
            }
          ]
        },
        tooltips: {
          backgroundColor: "rgba(255,255,255,1)",
          titleFontColor: "#000",
          bodyFontColor: "#000",
          borderColor: "#000",
          displayColors: !1,
          intersect: !1,
          enabled: !0,
          mode: "single",
          callbacks: {
            label: (x, v) => {
              let T = v.datasets[x.datasetIndex].label || "";
              return T && (T += ` ${x.xLabel}: `), T += Math.round(x.yLabel * 100) / 100, T;
            }
          }
        },
        events: ["mousemove", "click"]
      }
    };
  }
  /** Gets the main chart for taxcards */
  static getMainChartV2(e) {
    let t = 0, n = e.incomeLog?.sort((u, m) => (u.paidAt ?? "") < (m.paidAt ?? "") ? -1 : (u.paidAt ?? "") > (m.paidAt ?? "") ? 1 : 0).map((u) => (t += u.income, { x: u.paidAt, y: t }));
    n?.length === 0 && (n = [
      { x: e.card.validity?.start, y: 0 }
    ]);
    const i = [
      { x: e.card.validity?.start, y: 0 },
      { x: e.card.validity?.end, y: e.card.incomeLimit ?? 0 }
    ], s = ve.getBrandColor("primary", "rgba"), r = ve.getBrandColor("danger", "rgba"), l = ve.getBrandColor("warning", "rgba");
    return {
      type: "line",
      data: {
        labels: [],
        datasets: [
          {
            label: d.get("SALAXY.UI_Terms.salaryPayment"),
            data: n,
            borderColor: s,
            backgroundColor: s,
            index: 2
          },
          {
            label: d.get("SALAXY.UI_Terms.incomeLimit"),
            data: i,
            borderColor: l,
            backgroundColor: l,
            fill: !1,
            borderDash: [5, 5],
            lineTension: 0
          }
        ]
      },
      options: {
        maintainAspectRatio: !1,
        responsive: !0,
        scales: {
          x: {
            type: "time",
            time: {
              tooltipFormat: "D.M.YYYY",
              minUnit: "day",
              displayFormats: {
                millisecond: "D.M.YYYY",
                second: "D.M.YYYY",
                minute: "D.M.YYYY",
                hour: "D.M.YYYY",
                day: "D.M.YYYY",
                week: "D.M.YYYY",
                month: "D.M.YYYY",
                year: "D.M.YYYY"
              }
            }
          },
          y: {
            beginAtZero: !0,
            suggestedMax: (e?.card?.incomeLimit ?? 0) * 1.5
          }
        },
        plugins: {
          legend: {
            display: !0,
            position: "bottom"
          },
          title: {
            display: !0,
            text: d.get("SALAXY.CORE.Taxcard2019Logic.chartTitle")
          },
          tooltip: {
            backgroundColor: "rgba(255,255,255,1)",
            titleColor: "#000",
            bodyColor: "#000",
            borderColor: "#000",
            displayColors: !1,
            intersect: !1,
            enabled: !0
          },
          annotation: {
            annotations: {
              incomeLimit: {
                display: !!e.card.incomeLimit,
                type: "line",
                label: {
                  content: `${d.get("SALAXY.UI_Terms.incomeLimit")} ${e.card.incomeLimit}€`,
                  display: !0,
                  backgroundColor: r
                },
                scaleID: "y",
                value: e.card.incomeLimit,
                borderColor: r,
                color: "#000",
                borderWidth: 2
              }
            }
          }
        },
        events: ["mousemove", "click"]
      }
    };
  }
  /** Gets the pie chart for the taxcards. This is used for simplistic cases that do not have an income limit. */
  static getPieChartDataV2(e) {
    const t = Ta.getIncomeLimitInfo(e), n = 100 - t.percent, i = d.get(t.fractionOfLimit < 1 ? "SALAXY.CORE.Taxcard2019Logic.taxPercentBasic" : "SALAXY.CORE.Taxcard2019Logic.taxPercentAdditional"), s = [t.type === z.NoTaxCard || t.type === z.NoWithholdingHousehold ? ve.getBrandColor("danger", "rgba") : ve.getBrandColor("warning", "rgba"), ve.getBrandColor("primary", "rgba")];
    return {
      type: "pie",
      data: {
        labels: [
          `${d.get("SALAXY.UI_Terms.withholdingTax")} (${i}) ${h.formatPercent(t.percent)}`,
          `${d.get("SALAXY.CORE.Taxcard2019Logic.netSalary")} ${h.formatPercent(n)}`
        ],
        datasets: [{
          data: [
            t.percent,
            100 - t.percent
          ],
          backgroundColor: s,
          hoverOffset: 4
        }]
      },
      options: {
        maintainAspectRatio: !1,
        responsive: !0,
        plugins: {
          legend: {
            display: !0,
            position: "bottom"
          },
          tooltips: {
            enabled: !0
          }
        },
        events: ["mousemove", "click"]
      }
    };
  }
  /** Gets the pie chart for the taxcards. This is used for simplistic cases that do not have an income limit. */
  static getPieChartData(e) {
    const t = Ta.getIncomeLimitInfo(e), n = 100 - t.percent, i = d.get(t.fractionOfLimit < 1 ? "SALAXY.CORE.Taxcard2019Logic.taxPercentBasic" : "SALAXY.CORE.Taxcard2019Logic.taxPercentAdditional"), s = (l) => ({
      backgroundColor: l,
      pointBackgroundColor: l,
      pointHoverBackgroundColor: l,
      borderColor: l,
      pointBorderColor: l,
      pointHoverBorderColor: l
    });
    return {
      limits: t,
      data: [
        t.percent,
        100 - t.percent
      ],
      datasets: [
        {
          label: ["1", "2"]
        }
      ],
      labels: [
        `${d.get("SALAXY.UI_Terms.withholdingTax")} (${i}) ${h.formatPercent(t.percent)}`,
        `${d.get("SALAXY.CORE.Taxcard2019Logic.netSalary")} ${h.formatPercent(n)}`
      ],
      colors: [
        s(
          t.type === z.NoTaxCard || t.type === z.NoWithholdingHousehold ? ve.getBrandColor("danger", "rgba") : ve.getBrandColor("warning", "rgba")
        ),
        s(ve.getBrandColor("primary", "rgba"))
      ],
      options: {
        maintainAspectRatio: !0,
        responsive: !0,
        legend: {
          display: !0,
          position: "bottom",
          fullWidth: !0,
          reverse: !0
        },
        tooltips: {
          enabled: !0,
          mode: "single",
          bodySpacing: 6,
          callbacks: {
            label: (l, o) => o.labels[l.index]
          }
        },
        events: ["mousemove", "click"]
      }
    };
  }
}
const Me = class Me {
  /**
   * Finds an interface based on the type name.
   * @param docs Array of classes and interfaces from which to find an interface.
   * @param typeName The type name of the interface to look for. Search is case-insensitive.
   */
  static findInterface(e, t) {
    if (t = t.toLowerCase().trim(), !!t)
      return e.find((n) => (n.kind === "interface" || n.kind.toString() === "256") && n.name?.toLowerCase() === t);
  }
  /**
   * Finds an enum based on the type name.
   * @param allEnums All enumerations from which to find the enum by name.
   * @param name The enum name to look for. Search is case-insensitive.
   */
  static findEnum(e, t) {
    if (t = t.toLowerCase().trim(), !!t)
      return e.find((n) => n.name?.toLowerCase() === t);
  }
  /**
   * Gets a property from an interface supports single property names or longer property paths.
   * @param type The root type from which the property is found.
   * @param path Property path starting with the root type.
   * @param interfaces The interfaces that is used in finding types.
   * Typically, this is the full colelction of all classes and interfaces.
   */
  static getProperty(e, t, n) {
    if (!e || !t?.trim())
      return;
    const i = t.split(".");
    let s;
    for (; i.length; ) {
      const r = i.shift()?.trim();
      if (s = e?.members.find((l) => l.name?.toLowerCase() === (r && r.toLowerCase())), i.length) {
        const l = this.getTypeAsText(s?.type)?.replace("?", "");
        if (!l)
          return;
        const o = this.findInterface(n, l);
        if (!o)
          return;
        e = o;
      }
    }
    return s === void 0 ? void 0 : s;
  }
  /**
   * Gets a typedoc type formatted as text.
   * @param type Type as typedoc object model.
   */
  static getTypeAsText(e) {
    if (e != null)
      switch (e.type) {
        case "intrinsic":
          return `${e.name}`;
        case "union":
          return e.types.length === 2 && e.types[1].name === "null" ? Me.getTypeAsText(e.types[0]) + "?" : e.types.map((t) => Me.getTypeAsText(t)).join(" | ");
        case "array":
          return Me.getTypeAsText(e.elementType) + "[]";
        case "stringLiteral":
          return `"${e.value}"`;
        case "typeParameter":
          return `<${e.name}>`;
        case "reference":
          return e.name + (e.typeArguments ? "<" + e.typeArguments.map((t) => Me.getTypeAsText(t)).join(", ") + ">" : "");
        case "reflection":
          return "Reflection not supported in quick docs.";
        default:
          return `TODO: ${JSON.stringify(e)}`;
      }
  }
  /**
   * Gets a typedoc type formatted as HTML.
   * @param type Type as typedoc object model.
   * @param typeLinker Method that resolves a Typedoc type to link in the current environment.
   */
  static getTypeHtml(e, t) {
    if (e != null)
      switch (e.type) {
        case "intrinsic":
          return `<i>${e.name}</i>`;
        case "union":
          return e.types?.length === 2 && e.types[1].name === "null" ? Me.getTypeHtml(e.types[0], t) + "?" : e.types?.map((n) => Me.getTypeHtml(n, t)).join(" | ");
        case "array":
          return Me.getTypeHtml(e.elementType, t) + "[]";
        case "stringLiteral":
          return `"${e.value}"`;
        case "typeParameter":
          return `&lt;${e.name}&gt;`;
        case "reference": {
          const n = t && t(e);
          let i = n ? `<a href="${n}">${e.name}</a>` : e.name;
          return e.typeArguments && (i += "&lt;" + e.typeArguments.map((s) => Me.getTypeHtml(s, t)).join(", ") + "&gt;"), i;
        }
        case "reflection":
          return "<i>Reflection type not implemented in quick docs. See source for details.</i>";
        case "literal":
          return `"${e.value}"`;
        default:
          return `<span>${e.type}: <code>${JSON.stringify(e)}</code></span>`;
      }
  }
  /** Gets the enumerations for the given library from raw TypeDoc json. */
  static getEnums(e, t) {
    return e.children.filter((i) => i.kindString === "Enumeration" || i.kind.toString() === "8").map((i) => {
      const s = Me.getRootDeclarationReflection("enum", t, i);
      return s.names = (i.children || []).map((r) => r.name), s.values = (i.children || []).map((r) => r.defaultValue?.replace('"', "").replace('"', "")), s;
    });
  }
  /** Gets the classes and interfaces strongly typed from raw TypeDoc json */
  static getClasses(e, t) {
    return e.children.filter((i) => i.kindString === "Class" || i.kind.toString() === "128" || i.kindString === "Interface" || i.kind.toString() === "256").map((i) => {
      const s = this.getRootDeclarationReflection("class", t, i);
      return s.extendedBy = i.extendedBy || [], s.extends = i.extendedTypes || [], s.implementedBy = i.implementedBy || [], s.implements = i.implementedTypes || [], s.rawKind === "Interface" ? s.kind = "interface" : s.implements.find((r) => r.name === "IController") && (s.kind = "controllerBase"), s.group = this.getGroup(t, s.source), s.members = (i.children || []).filter((r) => r.flags.isPublic || r.flags.isExported || s.kind == "interface").map((r) => {
        const l = {
          type: r.type,
          grouping: "Other",
          parameters: [],
          returns: void 0
        };
        switch ((r.kindString === "Method" || r.kind.toString() === "2048") && r.signatures?.length ? (r.signatures[0].sources = r.sources, this.setDeclrProperties(l, r.signatures[0]), l.rawKind = "Method", l.returns = r.signatures[0].type) : this.setDeclrProperties(l, r), l.rawKind) {
          case "Accessor":
            r.setSignature ? r.setSignature?.length ? l.type = r.setSignature[0].parameters[0].type : l.type = r.setSignature.parameters[0].type : r.getSignature && (r.getSignature?.length ? l.type = r.getSignature[0].type : l.type = r.getSignature.type), l.grouping = "Property";
            break;
          case "Property":
            l.grouping = "Property";
            break;
          case "Method":
            if (l.grouping = "Method", r.signatures?.length) {
              r.signatures.length > 1 && (l.shortText += `

NOTE: method has more than one signature. See source for all signatures.`);
              const o = r.signatures[0];
              l.type = o.type, o.parameters && (l.parameters = o.parameters.map((u) => {
                const m = {
                  grouping: "Property",
                  type: u.type
                };
                return this.setDeclrProperties(m, u), m;
              }));
            } else
              l.shortText += `
ERROR: No signature was found!`;
            break;
        }
        return l;
      }), s;
    });
  }
  /**
   * Gets the common ROOT declaration reflection types from the Typedoc JSON: class, interface and enum
   * and their sub-kinds in AngularJS: controller, controllerBase and component.
   */
  static getRootDeclarationReflection(e, t, n) {
    const i = {
      id: n.id,
      kind: e,
      lib: t
    };
    return n.sources?.length && (i.source = n.sources[0].fileName), i.group = this.getGroup(t, i.source), this.setDeclrProperties(i, n), i.exampleUrls = n.comment?.tags?.filter((s) => s.tag === "exampleurl").map((s) => {
      const r = s.text.trim();
      return r.toLowerCase() === "true" ? `/ng1/examples/${i.group}/${i.name}.html` : r.trim();
    }) || [], i.screenShots = n.comment?.tags?.filter((s) => s.tag === "screenshot").map((s) => {
      const r = s.text.trim();
      return r.toLowerCase() === "true" ? `/ng1/screen-shots/${i.group}/${i.name}.png` : r.trim();
    }) || [], i;
  }
  /**
   * Sets the DeclarationReflection properties from source JSON
   * @param target Target data structure
   * @param tdSource The source object from raw typedoc JSON source.
   */
  static setDeclrProperties(e, t) {
    if (t && (e.name = t.name, e.rawKind = t.kindString, e.rawKind || (e.rawKind = this.reflectionKind[t.kind]), t.comment && (t.comment.shortText ? (e.shortText = t.comment.shortText, e.descr = t.comment.shortText + (t.comment.text ? `

` + t.comment.text : "")) : t.comment.summary?.length ? (e.shortText = t.comment.summary[0]?.text, e.descr = t.comment.summary[0]?.text) : (e.shortText = t.comment.text || "Error: No description in comments.", e.descr = t.comment.text || "Error: No description in comments."), t.comment.returns ? e.descr += `

**Returns**: ` + t.comment.returns : t.comment.blockTags?.length && t.comment.blockTags[0].tag === "@returns" && (e.descr += `

**Returns**: ` + t.comment.blockTags[0].content[0].text), t.comment.tags))) {
      const n = t.comment.tags.filter((i) => i.tag === "example");
      n.length > 0 && (e.example = n.map((i) => i.text.trim()).join(`

------------

`));
    }
  }
  /** Gets the grouping based on library and source file */
  static getGroup(e, t) {
    if (!t)
      return "err:no-source";
    const n = t.split("/");
    switch (e) {
      case "@salaxy/core":
        return n[n.length - 1] === "" ? "v01.ts" : n[0];
      case "@salaxy/ng1":
        return n.length > 5 && (n[3] === "components" || n[3] === "controllers") ? n[4] : n.length > 4 ? n[3] : n.length > 2 && (n[0] === "components" || n[0] === "controllers") || n.length > 2 && (n[0] === "components" || n[0] === "controllers") ? n[1] : n[0];
    }
  }
  /** For an array of types, gets an array type strings  */
  static getTypeStrings(e) {
    return e ? e.map((n) => Me.getTypeAsText(n)).filter((n) => n) : [];
  }
};
Me.reflectionKind = {
  1: "Project",
  2: "Module",
  4: "Namespace",
  8: "Enum",
  16: "EnumMember",
  32: "Variable",
  64: "Function",
  128: "Class",
  256: "Interface",
  512: "Constructor",
  1024: "Property",
  2048: "Method",
  4096: "CallSignature",
  8192: "IndexSignature",
  16384: "ConstructorSignature",
  32768: "Parameter",
  65536: "TypeLiteral",
  131072: "TypeParameter",
  262144: "Accessor",
  524288: "GetSignature",
  1048576: "SetSignature",
  2097152: "TypeAlias",
  4194304: "Reference"
};
let At = Me;
const Ln = class Ln {
  /**
   * Returns the Bank Identifier Code (BIC) for the given IBAN.
   * @param iban IBAN as string
   * @returns Bank Identifier Code (BIC) for the given IBAN
   */
  static getBicForIban(e) {
    if ((e ?? "").replace(/\s/g, "").toUpperCase() == "MT16FEMA16137000000000000637851")
      return "FEMAMTMA";
    const t = /FI[a-zA-Z0-9]{2}\s?([0-9]{4}\s?){3}([0-9]{2})\s?/;
    if ((e ?? "").match(t))
      return this.resolveBic(e);
  }
  static resolveBic(e) {
    if (e.substring(0, 2).toUpperCase() !== "FI")
      return;
    let n;
    const i = +e.slice(4, 5);
    switch (i) {
      case 3:
        n = +e.slice(4, 6);
        break;
      case 4:
      case 7:
        n = +e.slice(4, 7);
        break;
      default:
        n = +i;
        break;
    }
    return this.fiBics.find((s) => n >= s.min && n <= s.max)?.label;
  }
};
Ln.fiBics = [
  { min: 405, max: 405, label: "HELSFIHH" },
  { min: 497, max: 497, label: "HELSFIHH" },
  { min: 717, max: 717, label: "BIGKFIH1" },
  { min: 470, max: 479, label: "POPFFI22" },
  { min: 713, max: 713, label: "CITIFIHX" },
  { min: 34, max: 34, label: "DABAFIHH" },
  { min: 8, max: 8, label: "DABAFIHH" },
  { min: 37, max: 37, label: "DNBAFIHX" },
  { min: 31, max: 31, label: "HANDFIHH" },
  { min: 799, max: 799, label: "HOLVFIHH" },
  { min: 1, max: 2, label: "NDEAFIHH" },
  { min: 5, max: 5, label: "OKOYFIHH" },
  { min: 33, max: 33, label: "ESSEFIHX" },
  { min: 39, max: 39, label: "SBANFIHH" },
  { min: 36, max: 36, label: "SBANFIHH" },
  { min: 38, max: 38, label: "SWEDFIHH" },
  { min: 715, max: 715, label: "ITELFIHH" },
  { min: 400, max: 400, label: "ITELFIHH" },
  { min: 402, max: 403, label: "ITELFIHH" },
  { min: 406, max: 408, label: "ITELFIHH" },
  { min: 410, max: 412, label: "ITELFIHH" },
  { min: 414, max: 421, label: "ITELFIHH" },
  { min: 423, max: 432, label: "ITELFIHH" },
  { min: 435, max: 452, label: "ITELFIHH" },
  { min: 454, max: 464, label: "ITELFIHH" },
  { min: 483, max: 493, label: "ITELFIHH" },
  { min: 495, max: 496, label: "ITELFIHH" },
  { min: 6, max: 6, label: "AABAFI22" }
];
let Pt = Ln;
class xl {
  /**
   * Returns a blank UserDefinedRow object with the specified rowIndex.
   *
   * @param rowIndex - The index of the row.
   * @returns A blank UserDefinedRow object.
   */
  static getBlank(e) {
    return {
      rowIndex: e,
      rowType: null,
      count: null,
      price: null,
      message: null,
      data: {},
      accounting: {
        dimensions: []
      }
    };
  }
}
const Mn = class Mn {
  /**
   * Parses a workflow message string into an object. NOTE: Moved from WorkflowBadgeController.
   * @param messageString Message string which will be exploded into an object.
   * @returns Workflow event object.
   */
  static parseWorkflowEventString(e) {
    const t = e.indexOf("(Ui"), n = e.indexOf("):", t + 3), i = e.substring(0, t - 1) || "", s = e.substring(t + 3, n).toLowerCase();
    let r = e.substring(n + 3);
    const l = r.lastIndexOf("("), o = r.substring(0, l).trim();
    r = r.substring(l + 1), r = r.substring(0, r.length - 1);
    let u = "";
    const m = r.lastIndexOf(" id ");
    m >= 0 && (u = r.substring(m + 4), r = r.substring(0, m));
    let p = "";
    const y = r.lastIndexOf(" to ");
    y >= 0 && (p = r.substring(y + 4), r = r.substring(0, y));
    let S = "";
    const x = r.lastIndexOf(" at ");
    return x >= 0 && (S = r.substring(x + 4), r = r.substring(0, x), S = S.replace(" ", "T") + "Z"), {
      id: u,
      type: i,
      ui: s,
      user: r,
      assignedTo: p,
      message: o,
      time: S
    };
  }
};
Mn.formatWorkflowMessage = (e) => {
  const t = c.getDatelyObject(e.time);
  let n;
  t ? n = " at " + c.format(t, "DD.MM.YYYY HH.mm") : n = "";
  const i = `${e.message} (${e.user}${n} id ${e.id})`;
  return `<span class='badge bg-${e.ui}' title='${i}'>${e.message}</span>`;
};
let wt = Mn;
const Nn = class Nn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/employments";
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return st.getBlank();
  }
  /**
   * Makes an OData query to the employment relation list with helper to filter active relations.
   * @param activeDate The date for which the employment relations are fetched.
   * Use "all" for all relations (active or passive), "today" for relations that are active today or a date string for specific date.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  getODataActive(e, t) {
    e != "today" && e != "all" && (e = c.asDate(e) ?? "all");
    const n = this.getODataUrl() + "?activeDate=" + e;
    return Z.getOData(n, t, this.ajax);
  }
  /**
   * Gets the active employment relations.
   * @param date The date for which the employment relations are fetched.
   * @returns A collection of full employment relation objects.
   */
  getActiveFullObject(e) {
    let t = `${this.baseUrl}/active`;
    return e && (t += `?date=${c.asDate(e)}`), this.ajax.getJSON(t);
  }
  /**
   * Returns a list of all employing relations of existing employers for the current account.
   */
  getODataForEmployingRelations(e) {
    const t = Z.getUrl(`${this.baseUrl}/employing`, e);
    return this.ajax.getJSON(t).then((n) => Z.getODataResult(n));
  }
  /**
   * Returns the public employment profile for the worker.
   * The profile contains for example project structure for the worker.
   * @param owner Employment owner.
   * @param id Employment id.
   */
  getEmployingRelation(e, t) {
    return this.ajax.getJSON(`${this.baseUrl}/employing/${t}@${e}`);
  }
};
Nn.$inject = ["AjaxNg1"];
let Ft = Nn;
const On = class On extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/files";
  }
  /**
   * Gets a list of files - filtered by a type
   *
   * @param type Logical file type.
   *
   * @returns A Promise with result data (list of files).
   */
  filesOfType(e) {
    return this.ajax.getJSON(`${this.baseUrl}/type/${e}`);
  }
  /**
   * Returns the content url for the file id.
   * The returned does not contain access token.
   * @param id - Identifier of the file.
   */
  getContentUrl(e) {
    return `${this.ajax.getServerAddress()}/${this.baseUrl}/${e}/stream`;
  }
  /**
   * Returns the preview image url for the file id.
   * The returned url does not contain access token.
   * @param id - Identifier of the file.
   */
  getPreviewUrl(e) {
    return `${this.ajax.getServerAddress()}/${this.baseUrl}/${e}/preview`;
  }
  /**
   * Downloads the content as bytes.
   * @param id - The identifier of the file.
   */
  download(e) {
    return this.ajax.getJSON(`${this.baseUrl}/${e}/content`);
  }
  /**
   * Client-side (synchronous) method for getting a new blank CRUD item as bases for UI binding.
   * The basic idea is that all the child object properties should be non-null to avoid null reference exceptions.
   * In special cases, when null is significant it may be used: e.g. Calculation.result is null untill the recalculation has been done.
   * Strings, dates and booleans may be null (false if bool), but typically just undefined.
   */
  getBlank() {
    throw new Error("Not supported.");
  }
  /**
   * Deletes an single item from the sotrage
   * @param id - Unique identifier for the object
   * @throws Not supported
   */
  delete(e) {
    throw new Error("Not supported.");
  }
  /**
   * Saves an item to the storage.
   * If id is null, this is add/insert. If id exists, this is update.
   * @param itemToSave - The item that is updated/inserted.
   * @throws Not supported
   */
  save(e) {
    throw new Error("Not supported.");
  }
};
On.$inject = ["AjaxNg1"];
let za = On;
const Rn = class Rn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/holidays";
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return le.getBlank();
  }
  /**
   * Gets all the Holiday Year objects of specified year.
   * @param year The holiday year to filter
   * @returns A Promise with result data: The full holiday year objects.
   */
  getForYear(e) {
    return this.ajax.getJSON(`${this.baseUrl}/year/${e.toFixed()}`);
  }
  /**
   * Gets all the Holiday Year objects.
   * @returns A Promise with result data: The full holiday year objects.
   */
  getForAllYears() {
    return this.ajax.getJSON(`${this.baseUrl}/year/all`);
  }
  /**
   * Gets a default holiday specification based on employment relation information.
   * This is presented to the user before calling initForEmployment().
   * @param employmentId The employment relation ID from which the defaults are fetched.
   * @returns Holiday specification that can be used for inititalization.
   */
  getDefaultSpecForEmployment(e) {
    const t = `${this.baseUrl}/employment/${e}/default-spec`;
    return this.ajax.getJSON(t);
  }
  /**
   * Initializes the missing holiday years for an employment relation.
   * @param employmentId Identifier of the Employment relation that stores the holiday specification.
   * @param holidaySpec The holiday specification tht should be used for inititalization. The spec is also stored to the Employment relation.
   * @returns Holiday years for this employment relation - as initialized.
   */
  initForEmployment(e, t) {
    const n = `${this.baseUrl}/employment/${e}`;
    return this.ajax.postJSON(n, t);
  }
  /**
   * Gets the Holiday Years for a specific employment relation.
   * @param employmentId Identifier for the Employment relation.
   * @returns A Promise with Holiday Years.
   */
  getForEmployment(e) {
    return this.ajax.getJSON(`${this.baseUrl}/employment/${e}`);
  }
  /**
   * Gets the Holiday Years for the given employment relations.
   * @param employmentIds Identifiers for the Employment relations.
   * @returns A Promise with Holiday Years.
   */
  getForEmployments(e) {
    if (e == null || e.length === 0)
      return Promise.resolve([]);
    let t = `${this.baseUrl}/employment/set?`;
    return e.forEach((n) => {
      t += "employmentIds=" + encodeURIComponent("" + n) + "&";
    }), t = t.replace(/[?&]$/, ""), this.ajax.getJSON(t);
  }
  /**
   * Returns the  holiday pay calculation report data for a single employment.
   * @param year The holiday year for calculation.
   * @param employmentId Employment id.
   * @returns A Promise with result data containing holiday pay calculation data.
   */
  getHolidayPayCalculationReportData(e, t) {
    return this.ajax.getJSON(`${this.baseUrl}/year/${e}/${t}/holiday-pay-calc`);
  }
};
Rn.$inject = ["AjaxNg1"];
let Dt = Rn;
const Bn = class Bn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/invoices";
  }
  /**
   * Client-side (synchronous) method for getting a new blank item as bases for UI binding.
   * NOTE: At the moment, this method is pretty useless as you cannot save invoice items:
   * You need to create them using createInvoice() method based on a calculation.
   */
  getBlank() {
    return {
      header: {},
      rows: [],
      payer: {},
      recipient: {}
    };
  }
  /**
   * Saving invoices is not supported.
   * @param _item Invoice item (not used)
   * @throws Error indicating operation is not supported
   */
  save(e) {
    throw new Error("Not supported.");
  }
  /**
   * Creates invoices to pay a salary calculation.
   * @param calc Calculation for which the invoices are created.
   * @param channel Payment channel to use.
   * @returns Invoices which have been created in the Invoices queue.
   */
  createInvoices(e, t) {
    if (!t)
      throw new Error("Payment channel must be specified.");
    e.info ?? (e.info = {}), e.info.applicationId = pe.current?.applicationId;
    const n = `${this.baseUrl}/create/${t}`;
    return this.ajax.postJSON(n, e);
  }
  /**
   * Creates invoices to pay a salary calculation(s).
   * @param channel Payment channel to use.
   * @param calcIds One or several identifiers of the Calculation for which the invoices are created.
   * @returns Invoices which have been created in the Invoices queue.
   */
  createInvoicesById(e, ...t) {
    if (!e || !t || t.length < 1)
      throw new Error("One or more calculations Ids and Payment channel must be specified.");
    const n = `${this.baseUrl}/create-by-id/${e}`;
    return this.ajax.postJSON(n, t);
  }
  /**
   * Creates invoices to pay a set of salary calculation.
   * @param channel Payment channel to use.
   * @param payrollId Identifier for the Payroll for which the invoices are created.
   * @returns Invoices which have been created in the Invoices queue.
   */
  createInvoicesForPayroll(e, t) {
    if (!e || !t)
      throw new Error("The payroll ID and Payment channel must be specified.");
    const n = `${this.baseUrl}/create-for-payroll/${e}/${t}`;
    return this.ajax.postJSON(n, null);
  }
  /**
   * Previews invoices to pay a salary calculation(s) and fetches the ones that have already been created.
   * Used for payment dialog preview: Does not yet save the invoices and does not do any other storage saves.
   * @param channel Payment channel to use.
   * @param calcs The calculations for which the invoices are created as preview (not saved to storage).
   * Specified as ID's or unsaved Calculations or Payroll detail items.
   * @returns Invoices (list item + metadata) which have been created for preview (not saved) or that were previously created.
   */
  previewInvoices(e, t) {
    const n = (t.ids || []).length + (t.payrollIds || []).length + (t.calcs || []).length + (t.payrolls || []).length;
    if (!e || n < 1)
      throw new Error("One or more calculations/payroll/id and Payment channel must be specified.");
    const i = `${this.baseUrl}/preview-and-created/${e}`;
    return this.ajax.postJSON(i, t);
  }
  /**
   * Makes a request for updating the status of the invoice.
   * @param id Identifier for the invoice.
   * @param status The requested new status of the invoice.
   */
  requestStatusUpdate(e, t) {
    const n = `${this.baseUrl}/${e}/status/${t}`;
    return this.ajax.postJSON(n, null);
  }
  /**
   * Returns content (PDF) url for an invoice.
   * @param id The id of the invoice.
   * @param inline If true, returns the content as inline (disposition) in browser.
   * If false, the content is returned as an attachment (download).
   */
  getContentUrl(e, t = !1) {
    return this.ajax.getServerAddress() + `${this.baseUrl}/${e}/content?inline=${t}&access_token=${encodeURIComponent(this.ajax.getCurrentToken())}`;
  }
  /**
   * Downloads a sepa file for created invoices based on invoice IDs.
   * @param ids Ids of the invoices for the sepa payment.
   * @param payerIbanNumber Payer iban number.
   * @param bankPartyId Payer bank party id. Depends on the bank.
   * @returns A Promise with result data array.
   */
  getSepaByIds(e, t, n) {
    if (e == null || e.length === 0)
      return Promise.resolve(void 0);
    const i = e.map((r) => "ids=" + encodeURIComponent("" + r)).join("&");
    let s = `${this.baseUrl}/sepa?${i}`;
    return t && (s += "&payerIbanNumber=" + encodeURIComponent(t)), n && (s += "&bankPartyId=" + encodeURIComponent(n)), this.ajax.getHTML(s);
  }
  /**
   * Implementation of getContent() that handles both string ID and Invoice object inputs.
   * For string IDs, makes a GET request to fetch the invoice PDF.
   * For Invoice objects, makes a POST request with the full invoice data.
   * @param idOrInvoice - Either an invoice ID string or Invoice object
   * @param inline - If true, returns content inline in browser. If false, returns as download attachment.
   * @returns Promise resolving to a Blob containing the invoice PDF
   */
  getContent(e, t = !1) {
    return typeof e == "string" ? this.ajax.getBlob(`${this.baseUrl}/${e}/content?inline=${t}`).then((n) => n.data) : this.ajax.postBlob(`${this.baseUrl}/content?inline=${t}`, e).then((n) => n.data);
  }
  /**
   * Gets the URL for downloading a SEPA file for the specified invoices.
   * @param idsOrInvoices - Array of invoice IDs or Invoice objects to include in the SEPA file
   * @param payerIbanNumber - Optional IBAN number of the payer
   * @param bankPartyId - Optional bank party ID of the payer
   * @param inline - If true, returns the content as inline (disposition) in browser.
   * If false, the content is returned as an attachment (download). Defaults to false.
   * @returns The complete URL for downloading the SEPA file, including server address and access token
   */
  getSepaUrl(e, t, n, i = !1) {
    const r = e.map((o) => typeof o == "string" ? o : o.id).map((o) => `ids=${encodeURIComponent(o)}`).join("&");
    let l = `${this.baseUrl}/sepa?${r}&inline=${i}`;
    return t && (l += `&payerIbanNumber=${encodeURIComponent(t)}`), n && (l += `&bankPartyId=${encodeURIComponent(n)}`), this.ajax.getServerAddress() + `${l}&access_token=${encodeURIComponent(this.ajax.getCurrentToken())}`;
  }
  /**
   * Implementation of the SEPA file retrieval for both string IDs and Invoice objects.
   * @param idsOrInvoices - Array of invoice IDs or Invoice objects to include in the SEPA file
   * @param payerIbanNumber - Optional IBAN number of the payer
   * @param bankPartyId - Optional bank party ID of the payer
   * @param inline - If true, returns the content as inline (disposition) in browser.
   * If false, the content is returned as an attachment (download). Defaults to false.
   * @returns A Promise that resolves to a Blob containing the SEPA file content
   */
  getSepa(e, t, n, i = !1) {
    if (e.every((r) => typeof r == "string")) {
      const r = e.map((o) => `ids=${encodeURIComponent(o)}`).join("&");
      let l = `${this.baseUrl}/sepa?${r}&inline=${i}`;
      return t && (l += `&payerIbanNumber=${encodeURIComponent(t)}`), n && (l += `&bankPartyId=${encodeURIComponent(n)}`), this.ajax.getBlob(l).then((o) => o.data);
    } else {
      const r = `${this.baseUrl}/sepa?inline=${i}`;
      return this.ajax.postBlob(r, {
        idsOrInvoices: e,
        payerIbanNumber: t,
        bankPartyId: n
      }).then((l) => l.data);
    }
  }
  /**
   * Gets the URL for downloading a finvoice file for an invoice.
   * @param id - The ID of the invoice to get the finvoice URL for.
   * @param inline - If true, returns the content as inline (disposition) in browser.
   * If false, the content is returned as an attachment (download).
   * @returns The complete URL for downloading the finvoice file, including server address and access token.
   */
  getFinvoiceUrl(e, t = !1) {
    return this.ajax.getServerAddress() + `${this.baseUrl}/${e}/finvoice?inline=${t}&access_token=${encodeURIComponent(this.ajax.getCurrentToken())}`;
  }
  /**
   * Implementation of getFinvoice() that handles both string ID and Invoice object inputs.
   * @param idOrInvoice - Either an invoice ID string or Invoice object
   * @param inline - If true, returns the content as inline (disposition) in browser.
   * If false, the content is returned as an attachment (download). Defaults to false.
   * @returns A Promise that resolves to a Blob containing the finvoice file
   */
  getFinvoice(e, t = !1) {
    if (typeof e == "string") {
      const n = `${this.baseUrl}/${e}/finvoice?inline=${t}`;
      return this.ajax.getBlob(n).then((i) => i.data);
    } else {
      const n = `${this.baseUrl}/finvoice?inline=${t}`;
      return this.ajax.postBlob(n, e).then((i) => i.data);
    }
  }
  /**
   * Sends an e-invoice for an invoice.
   * @param id - The ID of the invoice to send the e-invoice for
   * @param receiver - The receiver of the e-invoice
   * @param intermediator - The intermediator of the e-invoice
   * @returns A Promise that resolves to the result of the e-invoice sending process
   */
  sendEInvoice(e, t, n) {
    const i = `${this.baseUrl}/${e}/einvoice?receiver=${encodeURIComponent(t)}&intermediator=${encodeURIComponent(n)}`;
    return this.ajax.postJSON(i, {});
  }
};
Bn.$inject = ["AjaxNg1"];
let Xa = Bn;
const Vn = class Vn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v01/api/epr", this.baseUrl = `${e.getServerAddress()}/v01/api/epr`;
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return {
      deliveryData: null
    };
  }
  /** Get odata base url */
  getODataUrl() {
    return this.baseUrl;
  }
  /** Validate */
  validate(e) {
    return this.ajax.postJSON(`${this.baseUrl}/validate`, e);
  }
  /** Send schedule item to Incomes register queue */
  sendSchedule(e) {
    return this.ajax.postJSON(`${this.baseUrl}/schedule`, e);
  }
  /** Get Service Bus queue item */
  getIrQueueItem(e) {
    return this.ajax.getJSON(`${this.baseUrl}/${e}/schedule`);
  }
  /** Remove Service Bus queue item */
  removeIrQueueItem(e) {
    return this.ajax.remove(`${this.baseUrl}/${e}/schedule`);
  }
};
Vn.$inject = ["AjaxNg1"];
let Ct = Vn;
const Kn = class Kn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v01/api/psr", this.baseUrl = `${e.getServerAddress()}/v01/api/psr`;
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return {
      deliveryData: null
    };
  }
  /** Get odata base url */
  getODataUrl() {
    return this.baseUrl;
  }
  /** Validate */
  validate(e) {
    return this.ajax.postJSON(`${this.baseUrl}/validate`, e);
  }
  /** Send schedule item to Incomes register queue */
  sendSchedule(e) {
    return this.ajax.postJSON(`${this.baseUrl}/schedule`, e);
  }
  /** Get Service Bus queue item */
  getIrQueueItem(e) {
    return this.ajax.getJSON(`${this.baseUrl}/${e}/schedule`);
  }
  /** Remove Service Bus queue item */
  removeIrQueueItem(e) {
    return this.ajax.remove(`${this.baseUrl}/${e}/schedule`);
  }
};
Kn.$inject = ["AjaxNg1"];
let It = Kn;
const Un = class Un extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/messages";
  }
  /** Gets a new blank message thread. */
  getBlank() {
    return {
      messages: []
    };
  }
  /**
   * Adds a new message with text.
   * @param id Identifier of the messages thread.
   * @param message The message to add.
   */
  addMessage(e, t) {
    const n = `${this.baseUrl}/${e}/messages`;
    return this.ajax.postJSON(n, t);
  }
  /**
   * Gets the upload URL for attachment files of a message thread.
   * This URL is compatible with the HTML forms standard multipart/form-data upload.
   * @param id Identifier of the messages thread.
   * @returns The URL for multipart/form-data upload
   */
  getUploadUrl(e) {
    return `${this.ajax.getServerAddress()}${this.baseUrl}/${e}/messages/blobFileMessage`;
  }
  /**
   * Marks all messages as read by a given party
   * @param id Identifier of the thread
   * @param readBy The party for which the messages are marked as read.
   * @returns The entire thread with the messages marked as read.
   */
  markAsRead(e, t) {
    const n = `${this.baseUrl}/${e}/read-by/${t}`;
    return this.ajax.postJSON(n, null);
  }
  /**
   * Sends an email notification to the owner of the message thread.
   * @param id Identifier of the thread
   * @param subject Subject of the notification.
   * @param body Body of the notification.
   * @returns A boolean indicating if the email was sent successfully.
   */
  sendNotification(e, t, n) {
    const i = `${this.baseUrl}/${e}/notifications?subject=${encodeURIComponent(t)}`;
    return this.ajax.postJSON(i, JSON.stringify(n));
  }
};
Un.$inject = ["AjaxNg1"];
let Lt = Un;
const Hn = class Hn extends _ {
  /** Creates a new API class for a given PaymentChannel */
  constructor(e, t) {
    super(t), this.paymentChannel = e, this.baseUrl = "", this.baseUrl = `/v03/api/payment-channel/${e}`;
  }
  /**
   * NOTE: Direct Save is currently not supported.
   * Use createInvoices and updateStatus instead.
   * This method is only for compatibility with CrudApiBase and in expectation of future needs (non-salary invoices).
   * @param itemToSave - The item that is updated/inserted.
   * @throws Not supported
   */
  save(e) {
    throw new Error("Not supported.");
  }
  /**
   * Client-side (synchronous) method for getting a new blank item as bases for UI binding.
   * NOTE: At the moment, this method is pretty useless as you cannot save invoice items:
   * You need to create them using createInvoice() method based on a calculation.
   */
  getBlank() {
    const e = new Xa(this.ajax).getBlank();
    return e.header ?? (e.header = {}), e.header.channel = this.paymentChannel, e;
  }
  /**
   * Gets invoices with their full payload - including PDF content - filtering by a status.
   * NOTE: This is designed mainly for long-running batch processes for reading unread Invoices.
   * They can read the items in one read. For browser process we suggest OData query (with list item)
   * and then fetching items one-by-one.
   * This is for more http-queries, but each taking a shorter time so you can use )
   * @param status Status filter for the query. Default is unread.
   * @param start Optional start date for the period to query the invoices. If not set, defaults to last 14 days.
   * @param end Optional end date for the period to query the invoices. If not set, today is used.
   * @param dateKind Optional date specifier for the period: invoicing date (default), due date or logical date (like salary date).
   * @returns Invoices which have been created in the Invoices queue.
   */
  getInvoicesByStatus(e = an.Unread, t = null, n = null, i = tn.InvoiceDate) {
    if (this.paymentChannel) {
      const s = c.asDate(t), r = c.asDate(n), l = `${this.baseUrl}/status/${e}?dateKind=${i}&start=${s || ""}&end=${r || ""}`;
      return this.ajax.getJSON(l);
    } else
      return Promise.resolve([]);
  }
  /**
   * Makes an OData query to the service's main OData method.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  getOData(e) {
    return this.paymentChannel ? super.getOData(e) : Promise.resolve({ items: [], count: 0 });
  }
  /**
   * Gets a single item based on identier
   * @param id - Unique identifier for the object
   * @returns A Promise with result data.
   */
  getSingle(e) {
    return this.paymentChannel ? super.getSingle(e) : Promise.resolve(void 0);
  }
  /**
   * Updates the payment statuses of invoices.
   * @param data Array of invoices to update.
   */
  updateStatus(e) {
    const t = `${this.baseUrl}/update-status`;
    return this.ajax.postJSON(t, e);
  }
  /**
   * Returns content (PDF) url for an invoice.
   * @param id The id of the invoice.
   * @param inline If true, returns the content as inline (disposition) in browser.
   * If false, the content is returned as an attachment (download).
   */
  getContentUrl(e, t = !1) {
    return `${this.ajax.getServerAddress()}${this.baseUrl}/${e}/content?inline=${t}&access_token=${encodeURIComponent(this.ajax.getCurrentToken())}`;
  }
  /**
   * Implementation of getContent() that handles string ID, string[] IDs and Invoice object inputs.
   * @param channel - The payment channel to use
   * @param idOrIdsOrInvoice - Either an invoice ID string, array of IDs, or Invoice object
   * @param inline - If true, returns the content as inline (disposition) in browser.
   * If false, the content is returned as an attachment (download). Defaults to false.
   * @returns A Promise that resolves to a Blob containing the content
   */
  getContent(e, t, n = !1) {
    if (t?.id)
      return this.ajax.postBlob(`${this.baseUrl}/${e}/content?inline=${n}`, t).then((i) => i.data);
    if (Array.isArray(t)) {
      const i = t.map((s) => "ids=" + encodeURIComponent("" + s)).join("&");
      return this.ajax.getBlob(`${this.baseUrl}/${e}/content?${i}&inline=${n}`).then((s) => s.data);
    } else
      return this.ajax.getBlob(`${this.baseUrl}/${e}/${t}/content?inline=${n}`).then((i) => i.data);
  }
  /**
   * Returns sepa url for an invoice.
   * @param channel The payment channel to use.
   * @param id The id of the invoice.
   * @param inline If true, returns the content as inline (disposition) in browser.
   * If false, the content is returned as an attachment (download).
   */
  getSepaUrl(e, t, n = !1) {
    return `${this.ajax.getServerAddress()}${this.baseUrl}/${e}/${t}/sepa?inline=${n}&access_token=${encodeURIComponent(this.ajax.getCurrentToken())}`;
  }
  /**
   * Implementation of getSepa() that handles string ID, string[] IDs, and Invoice object inputs.
   * @param channel - The payment channel to use
   * @param idOrIdsOrInvoice - Either an invoice ID string, array of IDs, or Invoice object
   * @param payerIbanNumber - Optional IBAN number of the payer
   * @param bankPartyId - Optional bank party ID
   * @param inline - If true, returns the content as inline (disposition) in browser.
   * If false, the content is returned as an attachment (download). Defaults to false.
   * @returns A Promise that resolves to a Blob containing the SEPA content
   */
  getSepa(e, t, n, i, s = !1) {
    const r = n ? `&payerIbanNumber=${encodeURIComponent(n)}` : "", l = i ? `&bankPartyId=${encodeURIComponent(i)}` : "";
    if (t?.id)
      return this.ajax.postBlob(`${this.baseUrl}/${e}/sepa?inline=${s}` + r + l, t).then((o) => o.data);
    if (Array.isArray(t)) {
      const o = t.map((u) => "ids=" + encodeURIComponent("" + u)).join("&");
      return this.ajax.getBlob(`${this.baseUrl}/${e}/sepa?${o}&inline=${s}` + r + l).then((u) => u.data);
    } else
      return this.ajax.getBlob(`${this.baseUrl}/${e}/${t}/sepa?inline=${s}` + r + l).then((o) => o.data);
  }
  /**
   * Gets a URL for accessing a report for a single invoice.
   * @param channel - The payment channel to use
   * @param id - The ID of the invoice to get the report URL for
   * @param type - The type of report to generate
   * @param isSensitive - Indicates if the report contains sensitive information
   * @param target - The target for the report
   * @param inline - If true, returns the content as inline (disposition) in browser.
   * If false, the content is returned as an attachment (download).
   * @returns A URL string for accessing the report
   */
  getReportUrl(e, t, n, i, s, r) {
    const l = i ? "&isSensitive=true" : "", o = s ? "&target=" + encodeURIComponent(s) : "";
    return `${this.ajax.getServerAddress()}${this.baseUrl}/${e}/${t}/${n}?inline=${r}` + l + o + `&access_token=${encodeURIComponent(this.ajax.getCurrentToken())}`;
  }
  /**
   * Implementation of getReport() that handles string ID and string[] IDs inputs.
   * @param channel - The payment channel to use
   * @param idOrIds - Either an invoice ID string or array of IDs
   * @param type - The type of report to generate
   * @param isSensitive - Indicates if the report contains sensitive information
   * @param target - The target for the report
   * @param inline - If true, returns the content as inline (disposition) in browser.
   * If false, the content is returned as an attachment (download). Defaults to false.
   * @returns A Promise that resolves to a Blob containing the report
   */
  getReport(e, t, n, i, s, r = !1) {
    const l = i ? "&isSensitive=true" : "", o = s ? "&target=" + encodeURIComponent(s) : "";
    if (Array.isArray(t)) {
      const u = t.map((m) => "ids=" + encodeURIComponent("" + m)).join("&");
      return this.ajax.getBlob(`${this.baseUrl}/${e}/${n}?${u}&inline=${r}` + l + o).then((m) => m.data);
    } else
      return this.ajax.getBlob(`${this.baseUrl}/${e}/${t}/${n}?inline=${r}` + l + o).then((u) => u.data);
  }
  /**
   * Implementation of getAccounting() that handles string ID and string[] IDs inputs.
   * @param channel - The payment channel to use
   * @param idOrIds - Either an invoice ID string or array of IDs
   * @param target - The target for the report
   * @param inline - If true, returns the content as inline (disposition) in browser.
   * If false, the content is returned as an attachment (download). Defaults to false.
   * @returns A Promise that resolves to a Blob containing the accounting report
   */
  getAccounting(e, t, n, i = !1) {
    const s = n ? "&target=" + encodeURIComponent(n) : "";
    if (Array.isArray(t)) {
      const r = t.map((l) => "ids=" + encodeURIComponent("" + l)).join("&");
      return this.ajax.getJSON(`${this.baseUrl}/${e}/accounting?${r}&inline=${i}` + s);
    } else
      return this.ajax.getJSON(`${this.baseUrl}/${e}/${t}/accounting?inline=${i}` + s);
  }
  /**
   * Implementation of getCalculation() that handles string ID and Calculation object inputs.
   * @param channel - The payment channel to use
   * @param id - The ID of the invoice to get the calculation for
   * @returns A Promise that resolves to a Calculation object
   */
  getCalculation(e, t) {
    return this.ajax.getJSON(`${this.baseUrl}/${e}/${t}/calculation`);
  }
  /**
   * Implementation of getCalculations() that handles string[] IDs and Calculation[] inputs.
   * @param channel - The payment channel to use
   * @param ids - Array of invoice IDs to get the calculation for
   * @returns A Promise that resolves to an array of Calculation objects
   */
  getCalculations(e, t) {
    const n = t.map((i) => "ids=" + encodeURIComponent("" + i)).join("&");
    return this.ajax.getJSON(`${this.baseUrl}/${e}/calculation?${n}`);
  }
};
Hn.$inject = ["AjaxNg1"];
let Mt = Hn;
const Wn = class Wn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v04/api/payroll";
  }
  /**
   * Saves the Payroll object to the storage.
   * If id is null, this is add. If id exists, this is update.
   * @param payroll - The Payroll object to add or update.
   * @param options - Further save options.
   * @param options.applyEmploymentDefaultRows - If true, applies the employment default rows to the calculation when creating a new payroll.
   * @returns The saved Payroll object.
   */
  save(e, t = void 0) {
    return e?.info && (e.info.applicationId = pe.current?.applicationId), super.save(e, t);
  }
  /** Client-side (synchronous) method for getting a new Payroll object as bases for UI binding. */
  getBlank() {
    return cn.getBlank();
  }
  /**
   * Adds new calculations to the the Payroll and saves the Payroll object.
   * The calculations are added based on employment relation id's.
   * @param id The Id of the Payroll object to update and save.
   * @param employmentIds Array of employment relation id's for which the a new calculation is added to the Payroll list.
   * @returns Added calculations as list items.
   */
  addEmployments(e, t) {
    const n = `${this.baseUrl}/${e}/employments`;
    return this.ajax.postJSON(n, t);
  }
  /**
   * Makes an OData query to the calculations of a single Payroll.
   * @param id The id of the payroll.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  getCalcsOData(e, t) {
    const n = `${this.baseUrl}/${e}/calcs`;
    return Z.getOData(n, t, this.ajax);
  }
  /**
   * Adds or updates the calculations to the the Payroll and saves the Payroll object.
   * If calculation is read-only, a copy is made.
   * @param id The id of the Payroll object to update and save.
   * @param calculationIds Array of calculation ids that are added or updated to the Payroll list.
   * @returns Added or updated calculations as list items.
   */
  addCalculations(e, t) {
    const n = `${this.baseUrl}/${e}/calcs`;
    return this.ajax.postJSON(n, { ids: t });
  }
  /**
   * Adds or updates the calculations to the the Payroll and saves the Payroll object.
   * If calculation is read-only, a copy is made.
   * @param id The id of the Payroll object to update and save.
   * @param calcsOrIds Array of calculations or calculation ids that are added or updated to the Payroll list.
   * @param applyWorktime If true, resolves, recalculates and updates holidays and absences to the given calculations.
   * @returns Added or updated calculations as list items.
   */
  saveCalculations(e, t, n = !1, i = !1) {
    const s = `${this.baseUrl}/${e}/calcs`, r = n || i ? { applyWorktime: n, applyEmploymentDefaultRows: i } : {};
    return this.ajax.postJSON(
      this.getUrlWithOptions(s, r),
      {
        objects: t && t.length && typeof t[0] == "object" ? t : null,
        ids: t && t.length && typeof t[0] == "string" ? t : null
      }
    );
  }
  /**
   * Merges the calculations by employment to the the Payroll and saves the Payroll object.
   * If calculation is read-only, a copy is made.
   * @param id The id of the Payroll object to update and save.
   * @param calculationIds Array of calculation ids that are added or updated to the Payroll list.
   * @param removeAllRows If true, removes all rows from the calculation.
   * @param applyEmploymentDefaultRows If true, applies the employment default rows to the calculation.
   * @returns Added or updated calculations as list items.
   */
  mergeCalculations(e, t, n = !1, i = !1) {
    const s = `${this.baseUrl}/${e}/calcs?isMerge=true&rowMergeOption=${n ? "removeAllRows" : ""}&applyEmploymentDefaultRows=${!!i}`;
    return this.ajax.postJSON(s, { ids: t });
  }
  /**
   * Removes the calculation from the Payroll and saves the Payroll object.
   * The calculation is completely deleted.
   * This can only be done if the calculation and the payroll have not been paid yet.
   * @param id The id of the Payroll  object.
   * @param calculationId The id of the calculation to be removed from the Payroll list and deleted.
   * @returns The Saved Payroll object.
   */
  deleteCalculation(e, t) {
    const n = `${this.baseUrl}/${e}/calcs/${t}?delete=true`;
    return this.ajax.remove(n);
  }
  /**
   * Removes the calculation from the Payroll and saves the Payroll object.
   * The calculation is unlinked and it becomes an individual calculation in the draft list (and can then be processed individually).
   * This can only be done if the calculation and the payroll have not been paid yet.
   * @param id The id of the Payroll object.
   * @param calculationId The id of the calculation which is unlinked from the Payroll list.
   * @returns The Saved Payroll object.
   */
  unlinkCalculation(e, t) {
    const n = `${this.baseUrl}/${e}/calcs/${t}?delete=false`;
    return this.ajax.remove(n);
  }
  /**
   * Cancels the invoice or payment processing for the given Payroll.
   * Please note that this is possible only if the channel supports the cancel action.
   * @param id The id of the Payroll for which the cancellation is requested.
   * @param calculationIds Array of calculation id's that are cancelled.
   * @param excludePeriodicInvoices If true, excludes the periodic invoice adjust operation.
   * @returns The Saved Payroll object.
   */
  cancelInvoices(e, t, n = !0) {
    const i = `${this.baseUrl}/${e}/cancel-invoices`, s = { excludePeriodicInvoices: n };
    return this.ajax.postJSON(this.getUrlWithOptions(i, s), t);
  }
  /**
   * Returns the invoice preview data for the given Payroll and calculations.
   * @param id The id of the Payroll for which the preview is requested.
   * @param calculationIds Array of calculation id's for which the preview is generated.
   * @param excludePeriodicInvoices If true, excludes the periodic invoices from the preview.
   * @returns Array of invoice preview objects.
   */
  previewInvoices(e, t, n = !0) {
    const i = `${this.baseUrl}/${e}/preview-invoices`, s = { excludePeriodicInvoices: n };
    return this.ajax.postJSON(this.getUrlWithOptions(i, s), t);
  }
  /**
   * Creates invoices for the given Payroll and calculations.
   * @param id The id of the Payroll for which the invoices are created.
   * @param calculationIds Array of calculation id's for which the invoices are created.
   * @param excludePeriodicInvoices If true, excludes the periodic invoices from the creation.
   * @returns Array of invoice objects.
   */
  createInvoices(e, t, n = !0) {
    const i = `${this.baseUrl}/${e}/create-invoices`, s = { excludePeriodicInvoices: n };
    return this.ajax.postJSON(this.getUrlWithOptions(i, s), t);
  }
};
Wn.$inject = ["AjaxNg1"];
let Nt = Wn;
const Yn = class Yn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/taxcards";
  }
  /**
   * Sets the auto-taxcard functionality on for the given personal ID.
   * Auto-taxcard fetches the widtholding data automatically from the tax authorities API every time the salary is paid.
   * NOTE: In current implementation, the income type is always Salary (00024: Palkkaa).
   * @param personalId The Personal ID for the person to whom to set the taxcard as auto.
   * @param firstSalaryDate First salary date if known: If this is close enought to the actual salary date we do not need to refetch the taxcard from the authorities.
   * @returns The saved new automatic taxcard.
   * If null, the tax authorities do not have a record for this personal id: It must be handled manually (cannot be set as shared).
   */
  setAuto(e, t = null) {
    const n = c.asDate(t);
    return this.ajax.postJSON(`${this.baseUrl}/auto-set?personalId=${e}&salaryDate=${n || ""}`, null);
  }
  /**
   * Checks automatic taxcards from the tax authorities. If the taxcard has been checked within 2 days, does nothing.
   * If there are no changes, updates the LastChecked date only. If there are changes, creates a new taxcard container and returns it instead.
   * @param taxcardIds List of identifiers of taxcards that should be checked.
   * @param salaryDate Salary date for which the taxcard is checked.
   * @param forceUpdate If true, skips the 2 day rule and always checks from the tax athorities API.
   * @returns The refreshed taxcards.
   */
  refreshAuto(e, t = null, n = !1) {
    const i = c.asDate(t);
    return this.ajax.postJSON(`${this.baseUrl}/auto-refresh?&taxcardIds=${e || ""}&salaryDate=${i || ""}&forceUpdate=${n}`, null);
  }
  /**
   * Client-side (synchronous) method for getting a new blank item as bases for UI binding.
   * You need to set the Personal ID to bind the taxcard to an account.
   */
  getBlank() {
    return Ta.getBlank("insert-personal-id");
  }
  /**
   * Saves a taxcard to the storage.
   * Removes empty incomeLog entries because they may be added by data binding in UI.
   * Entries are currently considered empty if both id and income are falsy: Typically income should be there,
   * but taxable income may be zero on a calculation (entry with id) and it makes sense to keep the entry still.
   * @param itemToSave - The item that is updated/inserted.
   * @returns A Promise with result data as saved to the storage (contains id, createAt, owner etc.).
   */
  save(e) {
    return e.incomeLog = e.incomeLog?.filter((t) => t.id || t.income) ?? [], super.save(e);
  }
  /**
   * Commits the current DIFF to the saved item.
   * Diff is the difference of income log saved in the taxcard to real paid calculations in the storage..
   * It is returned in each Save / GetSingle.
   * Modifications to non-modified items are also saved, but modifications to diff items have no effect: Diff is fetched from server.
   * Removes empty incomeLog entries because they may be added by data binding in UI (see Save for details).
   * @param itemToSave - The item that is updated/inserted with Diff saved.
   * @returns A Promise with result data as saved to the storage (contains id, createAt, owner etc.).
   */
  commitDiff(e) {
    return e.incomeLog = e.incomeLog?.filter((t) => t.id || t.income) ?? [], this.ajax.postJSON(`${this.baseUrl}?calcDiffCheck=${rn.CommitDiff}`, e);
  }
  /**
   * Calculates the widhholding tax based on a given tax card.
   *
   * @param id - Identifier of the tax card.
   * @param income - New salary or other income, for which the widthholding tax is calculated.
   *
   * @returns A Promise with result data (TaxCardResult).
   */
  calculateWithId(e, t) {
    const n = `${this.baseUrl}/calculate/${encodeURIComponent("" + (e ?? ""))}?income=${h.parseNumber(t)}`;
    return this.ajax.getJSON(n);
  }
  /**
   * Calculates the widhholding tax based on a given tax card
   *
   * @param income - New salary or other income, for which the widthholding tax is calculated.
   * @param taxCard - Tax card based on which the widthholding tax is calculated. This method will not connect to database in any way so the taxcard may or may not be stored.
   *
   * @returns A Promise with result data (TaxCardResult).
   */
  calculate(e, t) {
    const n = `${this.baseUrl}/calculate?income=${h.parseNumber(e)}`;
    return this.ajax.postJSON(n, t);
  }
  /**
   * Gets all the current taxcards for the current Worker account:
   * The cards that the account has uploaded as well as the cards created by all Employers.
   * This method can only be run for a personal account (not for a Company account).
   * @returns The cards that the account has uploaded as well as the cards created by all Employers.
   * Only current cards (not expired) are provided.
   */
  getMyTaxcards() {
    const e = `${this.baseUrl}/my`;
    return this.ajax.getJSON(e);
  }
  /**
   * Gets all the current taxcards for an employment relation:
   * All the cards by the Employer, but also the latest card uploaded by the Worker herself.
   * @param employmentId The employment id for which to search the taxcards.
   * @param paymentDate Payment date for which the validity (current card in use) is calculated. If null, Next workday is used.
   * This may be changed to next default payment date without that being a breaking change.
   * @returns The cards created by the Employer and also the latest card uploaded by the Worker herself.
   * Only current cards (not expired) are provided.
   */
  getEmploymentTaxcards(e, t) {
    let n = `${this.baseUrl}/employment/${e}`;
    const i = c.asDate(t);
    return i && (n += "?paymentDate=" + i), this.ajax.getJSON(n);
  }
  /**
   * Returns the url where to post the tax card file using form post ('multipart/form-data').
   */
  getUploadUrl() {
    return `${this.ajax.getServerAddress()}${this.baseUrl}/file`;
  }
  /**
   * Returns the url where to get the tax card file with authentication token.
   */
  getDownloadUrl(e) {
    return e && e.card && e.card.fileUri ? `${this.ajax.getServerAddress()}${this.baseUrl}/file/${e.id}?access_token=${this.ajax.getCurrentToken()}` : null;
  }
  /**
   * Returns the url where to get the tax card preview image with authentication token.
   * @param taxcard Either an API object or list item for which the preview is shown.
   * For Workers, supports Employer owned taxcards by passing owner ID in addition to just ID.
   */
  getPreviewUrl(e) {
    return (e?.card || {}).previewUri || (e?.data || {}).previewUri ? `${this.ajax.getServerAddress()}${this.baseUrl}/preview/${e.id}@${e.owner}?access_token=${this.ajax.getCurrentToken()}` : null;
  }
  /**
   * Gets a list of all non-terminated employments of the employer and resolves their current taxcards.
   * The current taxcards may be for the current year or for next year if the current date is either December or January.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   * @param paymentDate Payment date for which the validity (current card in use) is calculated. If null, Next workday is used.
   * This may be changed to next default payment date without that being a breaking change.
   */
  getCurrentCards(e, t = null) {
    const n = c.asDate(t), i = "/v03/api/taxcards/current" + (n ? "/" + n : "");
    return Z.getOData(i, e, this.ajax);
  }
};
Yn.$inject = ["AjaxNg1"];
let _a = Yn;
const $n = class $n extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v02/api/accounts/workers";
  }
  /** Gets the OData URL */
  getODataUrl() {
    return "/v03-rc/api/accounts/workers";
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return {
      avatar: {
        pictureType: We.Icon
      },
      employment: {
        irIncomeEarnerTypes: [],
        holidays: {},
        usecase: {
          data: {}
        },
        work: {
          salaryDefaults: []
        },
        salaryPaymentMethod: nt.BankAccount
      },
      contact: {},
      ageRange: Zt.Age18_52,
      entityType: me.PersonCreatedByEmployer,
      id: null,
      createdAt: c.getToday(),
      updatedAt: c.getToday(),
      isReadOnly: null
    };
  }
  /** Saves the Worker account ot the storage */
  save(e) {
    return super.save(e);
  }
  /**
   * Adds/updates the workflow event for the item.
   *
   * @param item - Item for which to set the workflow event.
   * @param wfEvent - Event to add or update.
   * @returns Workflow data for the item.
   */
  saveWorkflowEvent(e, t) {
    const n = e.employmentId;
    return this.ajax.postJSON(`/v03/api/employments/${n}/workflows`, t);
  }
  /**
   * Deletes the workflow item or items from the item.
   * @param item - Item for which to delete workflow events.
   * @param wfIdOrType - Event id or type.
   * @returns A Promise with result data "Object deleted".
   */
  deleteWorkflowEvent(e, t) {
    const n = e.employmentId;
    return this.ajax.remove(`/v03/api/employments/${n}/workflows/${t}`);
  }
  /**
   * Gets a single workflow event for the item.
   * @param item - Item for which to get the single event.
   * @param wfId - Event id or type.
   * @returns A Promise with event data".
   */
  getWorkflowEvent(e, t) {
    const n = e.employmentId;
    return this.ajax.getJSON(`/v03/api/employments/${n}/workflows/events/${t}`);
  }
};
$n.$inject = ["AjaxNg1"];
let Ot = $n;
const Gn = class Gn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/service-models";
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return {
      features: {},
      accounting: {
        targets: []
      },
      pricing: {},
      payments: {},
      branding: {},
      reporting: {},
      site: {}
    };
  }
};
Gn.$inject = ["AjaxNg1"];
let Rt = Gn;
const Jn = class Jn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/usecases";
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return {
      actions: [],
      schema: this.getTempSchema()
    };
  }
  /**
   * Saves an item to the storage.
   * If id is null, this is add/insert. If id exists, this is update.
   * @param itemToSave - The item that is updated/inserted.
   * @returns A Promise with result data as saved to the storage (contains id, createAt, owner etc.).
   */
  save(e) {
    return super.save(e);
  }
  /**
   * Gets an URL to a resource (currently HTML user interface) in the usecase.
   * @param uri Full uri of the usecase.
   * @param type Type of the resource to fetch. Only "html" is currently supported.
   * @param ix Index number of the view if there are several. Default is 0.
   */
  getResourceUrl(e, t, n = 0) {
    const i = ko.getIdAtOwner(e);
    if (t == "js")
      throw new Error("Resource URL for JavaScript is not yet supported.");
    return `${this.ajax.getServerAddress()}${this.getBaseUrl()}/${i}/views/${n.toFixed()}`;
  }
  getTempSchema() {
    return {
      openapi: "3.0.1",
      info: {
        title: "Usecase schema",
        version: "1.0"
      },
      paths: {},
      components: {
        schemas: {}
      }
    };
  }
};
Jn.$inject = ["AjaxNg1"];
let Bt = Jn;
const zn = class zn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03-rc/api/household-years";
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return {};
  }
  /**
   * Returns all the paid calculations for the given year.
   * @param year - Year for the calculations.
   * @returns Array of calculations.
   */
  getCalculationsForYear(e) {
    return this.ajax.getJSON(`${this.baseUrl}/calculations?year=${encodeURIComponent(e ?? "")}`);
  }
  /**
   * Updates the household data in the calculation
   * @param calculation - Calculation to update.
   * @returns Updated calculation.
   */
  updateCalculation(e) {
    return this.ajax.postJSON(`${this.baseUrl}/calculations`, e);
  }
  /**
   * Makes a request for updating the processing status of the household deduction.
   * @param id Identifier for the year.
   * @param processingStatus The requested new processing status of the houisehold deduction.
   */
  requestProcessingStatusUpdate(e, t) {
    const n = `${this.baseUrl}/${e}/processingStatus/${t}`;
    return this.ajax.postJSON(n, null);
  }
  /**
   * Downloads pdf reports for the yearly household deduction.
   */
  downloadPdfs(e) {
    const t = `${this.baseUrl}/${e}/pdfs`;
    return this.ajax.getJSON(t);
  }
};
zn.$inject = ["AjaxNg1"];
let Vt = zn;
const Xn = class Xn extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/records";
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return {
      attachments: [],
      usecase: {
        data: {}
      }
    };
  }
  /**
   * Returns all distinct record types from all  records.
   * @returns A Promise with result data array.
   */
  getRecordTypes() {
    return this.ajax.getJSON(`${this.baseUrl}/recordTypes`);
  }
  /**
   * Returns all records for the entity.
   * @param entityType Entity type of the business object.
   * @param entityId Optional id for the business object.
   */
  getForEntity(e, t = void 0) {
    const n = t ? `${this.baseUrl}/${e}/${t}` : `${this.baseUrl}/${e}`;
    return this.ajax.getJSON(n);
  }
  /**
   * Gets the upload URL for attachment files.
   * This URL is compatible with the HTML forms standard multipart/form-data upload.
   * @param entityType Entity type of the business object.
   * @param entityId Optional id for the business object.
   * @returns The URL for multipart/form-data upload
   */
  getRecordUploadUrl(e, t = void 0) {
    return t ? `${this.ajax.getServerAddress()}${this.baseUrl}/${e}/${t}/files` : `${this.ajax.getServerAddress()}${this.baseUrl}/${e}/files`;
  }
};
Xn.$inject = ["AjaxNg1"];
let Kt = Xn;
const _n = class _n extends _ {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/reference-objects";
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  getBlank() {
    return {
      header: {},
      events: [],
      usecase: {
        data: {}
      },
      workflowData: {
        events: []
      }
    };
  }
};
_n.$inject = ["AjaxNg1"];
let Ut = _n;
const qn = class qn {
  constructor(e) {
    this.ajax = e;
  }
  /**
   * Gets the current company account if the current account is a company.
   * NOTE: Typically the account data is fetched in Session check => You do not need to fetch it separately.
   *
   * @returns A Promise with result data (Company account or null).
   */
  getCompany() {
    return this.ajax.getJSON("/accounts/company");
  }
  /**
   * Gets the current Person account:
   * Either the current account or the Primary contact person account if the current account is a company.
   * NOTE: Typically the current account data is fetched in Session check => You do not need to fetch it separately.
   * => Only use this to fetch the Primary contact person account if the current account is a company.
   *
   * @returns A Promise with result data (Personal account).
   */
  getPerson() {
    return this.ajax.getJSON("/accounts/person");
  }
  /**
   * Saves the avatar and contact for the current Person account:
   * Either the current account or the Primary contact person account if the current account is a company.
   *
   * @returns A Promise with result data (Personal account).
   */
  savePerson(e) {
    return this.ajax.postJSON("/accounts/person", e);
  }
  /**
   * Returns the url where to post the avatar file
   */
  getAvatarUploadUrl() {
    return `${this.ajax.getApiAddress()}/accounts/avatar`;
  }
  /**
   * Switches the current web site usage role.
   *
   * @param role - household or worker. You cannot change to company at the moment using this method.
   *
   * @returns A Promise with result data (new role).
   */
  switchRole(e) {
    return this.ajax.postJSON("/accounts/switchRole?role=" + e, {});
  }
  /**
   * Adds/updates the workflow event for the item.
   *
   * @param item - Item for which to set the workflow event.
   * @param wfEvent - Event to add or update.
   * @returns Workflow data for the item.
   */
  saveWorkflowEvent(e, t) {
    return this.ajax.postJSON("/accounts/workflows", t);
  }
  /**
   * Deletes the workflow item or items from the item.
   * @param item - Item for which to delete workflow events.
   * @param wfIdOrType - Event id or type.
   * @returns A Promise with result data "Object deleted".
   */
  deleteWorkflowEvent(e, t) {
    return this.ajax.remove(`/accounts/workflows/${t}`);
  }
  /**
   * Gets a single workflow event for the item.
   * @param item - Item for which to get the single event.
   * @param wfId - Event id.
   * @returns A Promise with event data.
   */
  getWorkflowEvent(e, t) {
    return this.ajax.getJSON(`/accounts/workflows/events/${t}`);
  }
};
qn.$inject = ["AjaxNg1"];
let qa = qn;
const Zn = class Zn {
  constructor(e) {
    this.ajax = e;
  }
  /**
   * Gets a single Onboarding object based on identier
   *
   * @param id - Unique identifier for the object
   *
   * @returns A Promise with result data (Onboarding).
   */
  getOnboarding(e) {
    return this.ajax.getJSON("/onboarding/" + encodeURIComponent("" + (e ?? "")));
  }
  /**
   * Gets a single Onboarding object for authorizing account
   *
   * @param accountId - Account id of the authorizing account.
   *
   * @returns A Promise with result data (Onboarding).
   */
  getOnboardingForAccount(e) {
    return this.ajax.getJSON("/onboarding/account/" + encodeURIComponent("" + e));
  }
  /**
   * Creates or updates an Onboarding.
   *
   * @param onboarding - The Onboarding object that is updated.
   *
   * @returns A Promise with result data (saved Onboarding).
   */
  saveOnboarding(e) {
    return this.ajax.postJSON("/onboarding", e);
  }
  /**
   * Deletes an onboarding object from the storage
   *
   * @param id - Unique identifier for the object
   *
   * @returns A Promise with result data "Object deleted".
   */
  deleteOnboarding(e) {
    return this.ajax.remove("/onboarding/" + encodeURIComponent("" + (e ?? "")));
  }
  /**
   * Commits onboarding and creates/updates the account.
   *
   * @param onboarding - The Onboarding object that is to be committed..
   *
   * @returns A Promise with result data (committed Onboarding).
   */
  commitOnboarding(e) {
    return this.ajax.postJSON("/onboarding/commit", e);
  }
  /**
   * Returns the url to start the onboarding for current account (server side).
   * @param id - Optional id for the existing onboarding object.
   */
  getLaunchUrl(e = null) {
    return `${this.ajax.getServerAddress()}/onboarding/launch${e ? "/" + e : ""}?access_token=${encodeURIComponent("" + (this.ajax.getCurrentToken() ?? ""))}`;
  }
};
Zn.$inject = ["AjaxNg1"];
let Za = Zn;
const Qn = class Qn {
  constructor(e) {
    this.ajax = e;
  }
  /**
   * Gets a list of generated HTML/PDF/JSON reports by type.
   *
   * @param reportType - Type of reports to fetch.
   *
   * @returns A Promise with result data (array of reports).
   */
  getReportsByType(e) {
    return this.ajax.getJSON("/reports/type/" + e);
  }
  /**
   * Gets a single generated HTML/PDF/JSON report by type and id.
   *
   * @param reportType - Type of the report to fetch.
   * @param id - Id of the report to fetch.
   * @param wait - Optional flag to indicate whether to wait for the report to be generated.
   *
   * @returns A Promise with result data (report).
   */
  getReport(e, t, n) {
    const i = `/reports/type/${e}/encodeURIComponent(id)?wait=${n}`;
    return this.ajax.getJSON(i);
  }
  /**
   * Gets the monthly / quarterly/ yearly accounting data for the current account.
   *
   * @param refDate Reference date for the period. Please note that even if the date is not the first day of the given period, the entire period is returned.
   * @param target Accounting target name : contains  default ruleset and other parameters for creating accounting entries.
   * @param periodType Month, quarter, year or a custom period. The custom period requires endDate. Default value is the month.
   * @param endDate End date for the period. Required only for the custom period.
   * @param periodDateKind Period date type: paid at date or salary date.
   * @param minStatus Minimum status level for the calculations to include in the data. The default level is PaymentSucceeded.
   * @param ruleSet Optional additional ruleset for the target to use for creating the accounting entries.
   * @returns A Promise with result data (Raw data for accounting purposes).
   */
  getAccountingDataForPeriod(e, t, n, i, s, r, l) {
    e = c.asDate(e) || c.getToday();
    const o = [];
    t && o.push(`target=${encodeURIComponent(t)}`), l && o.push(`ruleSet=${encodeURIComponent(l)}`), n && o.push(`periodType=${n}`), i && o.push(`endDate=${i}`), r && o.push(`minStatus=${r}`), s && o.push(`periodDateKind=${s}`);
    const u = o.join("&");
    return this.ajax.getJSON(`/v03/api/reports/accounting/${e}${u ? "?" + u : ""}`);
  }
  /**
   * Gets the accounting data based on given set of calculations.
   *
   * @param calculationIds - Calculations that are the bases for the report.
   * @param target  - Accounting target name : contains  default ruleset and other parameters for creating accounting entries.
   * @param ruleSet - Optional additional ruleset for the target to use for creating the accounting entries.
   * @returns A Promise with result data (Raw data for accounting purposes).
   */
  getAccountingDataForCalculationIds(e, t, n) {
    const i = e.map((l) => `calculationIds=${l}`).join("&"), s = [];
    t && s.push(`target=${encodeURIComponent(t)}`), n && s.push(`ruleSet=${encodeURIComponent(n)}`);
    const r = s.join("&");
    return this.ajax.getJSON(`/v03/api/reports/accounting?${i}${r ? "&" + r : ""}`);
  }
  /**
   * Gets the accounting data based on given report id.
   *
   * @param id - Saved report id containing accounting data.
   * @param target  - Accounting target name : contains  default ruleset and other parameters for creating accounting entries.
   * @param ruleSet - Optional additional ruleset for the target to use for creating the accounting entries.
   * @returns A Promise with result data (Raw data for accounting purposes).
   */
  getAccountingData(e, t, n) {
    const i = [];
    t && i.push(`target=${encodeURIComponent(t)}`), n && i.push(`ruleSet=${encodeURIComponent(n)}`);
    const s = i.join("&");
    return this.ajax.getJSON(`/v03/api/reports/accounting/${e}${s ? "?" + s : ""}`);
  }
  /**
   * Gets the accounting report based on given set of calculations.
   * This method can be used anonymously.
   *
   * @param calculations - Calculations that are the bases for the report.
   * @param target  - Accounting target name : contains  default ruleset and other parameters for creating accounting entries.
   * @param ruleSet - Optional additional ruleset for the target to use for creating the accounting entries.
   * @returns A Promise with result data (Raw data for accounting purposes).
   */
  getAccountingDataForCalculations(e, t, n) {
    const i = [];
    t && i.push(`target=${encodeURIComponent(t)}`), n && i.push(`ruleSet=${encodeURIComponent(n)}`);
    const s = i.join("&");
    return this.ajax.postJSON(`/v03/api/reports/accounting${s ? "?" + s : ""}`, e);
  }
  /**
   * Closes the accounting period for the given period, and generates a report for the period.
   * @param refDate - Period reference date.
   * @param option - Closing option. Currently only default -option supported.
   * @returns Report id for the period.
   */
  closeAccountingPeriod(e, t) {
    return this.ajax.postJSON(`/v03/api/reports/accounting/${e}/close${t ? "?option=" + t : ""}`, null);
  }
  /**
   * Gets the accounting data for the holiday pay debt.
   *
   * @param refDate The date to which the holiday pay debt is calculated.
   * @param target Accounting target name : contains  default ruleset and other parameters for creating accounting entries.
   * @param employmentIds Optional list of employment ids (by official id) to include in the report.
   * @param fromHolidayYear Optional starting holiday year for the calculations.PaymentSucceeded.
   * @returns A Promise with result data. Holiday pay debt accounting data.
   */
  getAccountingDataForHolidayPayDebt(e, t, n, i) {
    e = c.asDate(e) || c.getToday();
    const s = [];
    t && s.push(`target=${encodeURIComponent(t)}`), n && n.forEach((l) => s.push(`employmentIds=${l}`)), i && s.push(`fromHolidayYear=${i}`);
    const r = s.join("&");
    return this.ajax.getJSON(`/v03/api/reports/accounting/${e}/holiday-pay-debt${r ? "?" + r : ""}`);
  }
  /**
   * Gets the monthly / quarterly/ yearly summary data for the current account.
   *
   * @param refDate Reference date for the period. Please note that even if the date is not the first day of the given period, the entire period is returned.
   * @param periodType Month, quarter, year or a custom period. The custom period requires endDate. Default value is the month.
   * @param endDate End date for the period. Required only for the custom period.
   * @param periodDateKind Period date type: paid at date or salary date.
   * @param workers List of workers (by official id) to include in the report.
   * @returns A Promise with result data (Raw data for summary reports).
   */
  getSummaryReportData(e, t, n, i, s) {
    e = c.asDate(e) || c.getToday();
    const r = [];
    t && r.push(`periodType=${t}`), n && r.push(`endDate=${n}`), i && r.push(`periodDateKind=${i}`), s && s.forEach((o) => r.push(`workers=${o}`));
    const l = r.join("&");
    return this.ajax.getJSON(`/v03/api/reports/summary/${e}${l ? "?" + l : ""}`);
  }
  /**
   * Gets the monthly / quarterly/ yearly summary for worker id
   *
   * @param refDate Reference date for the period. Please note that even if the date is not the first day of the given period, the entire period is returned.
   * @param workerId For searching summary date
   * @param employerId Optionally provided and used to search workers summary date on specific employer
   * @param periodType Month, quarter, year or a custom period. The custom period requires endDate. Default value is the month.
   * @param endDate End date for the period. Required only for the custom period.
   * @param periodDateKind Period date type: paid at date or salary date.
   * @returns A Promise with result data (Raw data for summary reports).
   */
  getWorkerSummaryReportData(e, t, n, i, s, r) {
    e = c.asDate(e) || c.getToday();
    const l = [];
    i && l.push(`periodType=${i}`), s && l.push(`endDate=${s}`), r && l.push(`periodDateKind=${r}`);
    const o = l.join("&");
    return this.ajax.getJSON(`/v03/api/reports/summary/${e}/${t}/${n || ""}${o ? "?" + o : ""}`);
  }
  /**
   * Gets the monthly / quarterly/ yearly summary data data based on given set of calculations.
   *
   * @param calculationIds - Calculations that are the bases for the report.
   * @returns A Promise with result data (Raw data for summary reports).
   */
  getSummaryReportDataForCalculationIds(e) {
    const t = e.map((n) => `calculationIds=${n}`).join("&");
    return this.ajax.getJSON(`/v03/api/reports/accounting?${t}`);
  }
  /**
   * Returns the raw data for the calculation based reports.
   *
   * @param refDate Reference date for the period. Please note that even if the date is not the first day of the given period, the entire period is returned.
   * @param periodType Month, quarter, year or a custom period. The custom period requires endDate. Default value is the month.
   * @param endDate End date for the period. Required only for the custom period.
   * @param periodDateKind Period date type: paid at date or salary date.
   * @param workers List of workers (by official id) to include in the report.
   * @returns A Promise with result data (Raw data for the calculation based reports).
   */
  getCalculationReportData(e, t, n, i, s) {
    e = c.asDate(e) || c.getToday();
    const r = [];
    t && r.push(`periodType=${t}`), n && r.push(`endDate=${n}`), i && r.push(`periodDateKind=${i}`), s && s.forEach((o) => r.push(`workers=${o}`));
    const l = r.join("&");
    return this.ajax.getJSON(`/v03/api/reports/calculation/${e}${l ? "?" + l : ""}`);
  }
  /**
   * Returns the raw data for the calculation based reports.
   *
   * @param calculationIds - Calculations that are the bases for the report.
   * @returns A Promise with result data (Raw data for the calculation based reports).
   */
  getCalculationReportDataForCalculationIds(e) {
    const t = e.map((n) => `calculationIds=${n}`).join("&");
    return this.ajax.getJSON(`/v03/api/reports/calculation?${t}`);
  }
  /**
   * Returns the raw data for the accounting row based reports.
   *
   * @param refDate Reference date for the period. Please note that even if the date is not the first day of the given period, the entire period is returned.
   * @param periodType Month, quarter, year or a custom period. The custom period requires endDate. Default value is the month.
   * @param endDate End date for the period. Required only for the custom period.
   * @param periodDateKind Period date type: paid at date or salary date.
   * @param workers List of workers (by official id) to include in the report.
   * @returns A Promise with result data (Raw data for the accounting row based reports).
   */
  getAccountingRowReportData(e, t, n, i, s) {
    e = c.asDate(e) || c.getToday();
    const r = [];
    t && r.push(`periodType=${t}`), n && r.push(`endDate=${n}`), i && r.push(`periodDateKind=${i}`), s && s.forEach((o) => r.push(`workers=${o}`));
    const l = r.join("&");
    return this.ajax.getJSON(`/v03/api/reports/accounting-row/${e}${l ? "?" + l : ""}`);
  }
  /**
   * Returns the raw data for the accounting row based reports.
   *
   * @param calculationIds - Calculations that are the bases for the report.
   * @returns A Promise with result data (Raw data for the accounting row based reports).
   */
  getAccountingRowReportDataForCalculationIds(e) {
    const t = e.map((n) => `calculationIds=${n}`).join("&");
    return this.ajax.getJSON(`/v03/api/reports/accounting-row?${t}`);
  }
  /**
   * Returns a calculation with cumulative data for reporting purposes.
   * @param id Id of the calculation.
   * @returns Calculation with cumulative data included.
   */
  getCumulativeCalculation(e) {
    return this.ajax.getJSON(`/v03/api/reports/cumulative-calculation/${e}`);
  }
  /**
   * Returns a URL for a pay certificate pdf file. This is a absolute link containing
   * both the server address and the access token.
   * @param workerId Worker id for which the certificate should be created.
   * @param calculationIds Calculation ids to include in the certificate.
   * @param inline - If true, the Content-Disposition header is returned with inline parameter.
   */
  getPayCertificatePdfUrl(e, t, n = !1) {
    const i = uo.getPayCertificatePdfUrl(e, t, n, this.ajax.getCurrentToken());
    return `${this.ajax.getServerAddress()}${i}`;
  }
  /**
   * Validates the pay certificate server side.
   * @param workerId Id of the worker in the certificate.
   * @param calculationIds Calculation ids to include in the certificate.
   * @returns Validation result.
   */
  validatePayCertificate(e, t) {
    let n = `/v03/api/reports/validate/pay-certificate/${encodeURIComponent(e)}?`;
    return t.forEach((i) => {
      n += "calculationIds=" + encodeURIComponent("" + (i ?? "")) + "&";
    }), n = n.replace(/[?&]$/, ""), this.ajax.getJSON(n);
  }
  /**
   * Gets an HTML report based on Calculation ID.
   *
   * @param reportType - Type of the report to fetch. See the HtmlReportType enumeration for possible values.
   * @param calculationId - GUID for the calculation
   *
   * @returns A Promise with result HTML.
   */
  getReportHtmlById(e, t) {
    let n;
    if (!e)
      return Promise.resolve("");
    switch (e.toLowerCase()) {
      case "employer":
        n = "/reportpartials/employerCalculation/" + t;
        break;
      case "employerpage2":
        n = "/reportpartials/employerCalculationAdditionalInfo/" + t;
        break;
      case "worker":
        n = "/reportpartials/workerCalculation/" + t;
        break;
      case "workerpage2":
        n = "/reportpartials/workerCalculationAdditionalInfo/" + t;
        break;
      case "payments":
        n = "/reportpartials/paymentCalculation/" + t;
        break;
      default:
        throw new Error("Unknown report partial type: " + e);
    }
    return this.ajax.getHTML(this.ajax.getServerAddress() + n);
  }
  /**
   * Gets the monthly / quarterly/ yearly accounting data for the current account.
   *
   * @deprecated Use new accounting/{target} -method for more detailed accounting data
   * @param refDate - Reference date for the period. Please note that even if the date is not the first day of the given period, the entire period is returned.
   * @param tableType  - Accounting table type.
   * @param periodType - Month, quarter, year or a custom period. The custom period requires endDate. Default value is the month.
   * @param endDate - End date for the period. Required only for the custom period.
   * @returns A Promise with result data (Raw data for accounting purposes).
   * @ignore
   */
  getAccountingReportTableForPeriod(e, t = ba.Classic, n = it.Month, i = null) {
    e = c.asDate(e) || c.getToday();
    let s = "/reports/data/accounting/" + t + "/" + encodeURIComponent(e) + "?";
    return s += "periodType=" + encodeURIComponent("" + n), i && (s += "&endDate=" + encodeURIComponent(i)), this.ajax.getJSON(s);
  }
  /**
   * Experimental: Gets the accounting report based on given set of calculations.
   *
   * @deprecated Use new accounting/{target} -method for more detailed accounting data
   * @param calculationIds - Calculations that are the bases for the report.
   * @param tableType  - Accounting table type.
   * @returns Account report based on the calculations.
   * @ignore
   */
  getAccountingReportTableForCalculationIds(e, t = ba.Classic) {
    let n = "/reports/data/accounting/" + t + "?";
    return e.forEach((i) => {
      n += "calculationIds=" + encodeURIComponent("" + i) + "&";
    }), n = n.replace(/[?&]$/, ""), this.ajax.getJSON(n);
  }
  /**
   * Experimental: Gets the accounting report based on given set of calculations.
   *
   * @deprecated Use new accounting/{target} -method for more detailed accounting data
   * @param calculations - Calculations that are the bases for the report.
   * @param tableType  - Accounting table type.
   * @returns Account report based on the calculations.
   * @ignore
   */
  getAccountingReportTableForCalculations(e, t = ba.Classic) {
    const n = "/reports/data/accounting/" + t;
    return this.ajax.postJSON(n, e);
  }
  /**
   * Returns the  holiday pay debt report data.
   *
   * @param refDate Reference date to which the holiday pay debt is calculated.
   * @param employmentIds Optional list of employment ids (by official id) to include in the report.
   * @returns A Promise with result data containing holiday pay debt data.
   */
  getAccountingHolidayPayDebtReportData(e, t) {
    e = c.asDate(e) || c.getToday();
    const n = [];
    t && t.forEach((s) => n.push(`employmentIds=${s}`));
    const i = n.join("&");
    return this.ajax.getJSON(`/v03/api/reports/holiday-pay-debt/${e}${i ? "?" + i : ""}`);
  }
  /**
   * Gets a calculation report in PDF format.
   * @param calculations - The calculations to generate the report for
   * @param reportType - The type of report to generate. Can be one of:
   * - "salarySlip" - Salary slip report
   * - "employerReport" - Employer report
   * - "paymentReport" - Payment report
   * - "paymentSummaryReport" - Payment summary report
   * - "accountingReport" - Accounting report
   * - "totalsReport" - Totals report
   * - "rowsReport" - Rows report
   * - "irRows" - IR rows report
   * @param employerLang - The language to use for employer-specific content
   * @param reportLang - The language to use for worker-specific content
   * @returns Promise resolving to an object containing:
   * - data: Blob - The PDF report data
   * - response: any - The full response object
   */
  getCalculationReport(e, t, n, i) {
    const s = (o, u) => u ? this.ajax.postBlob(o, u) : this.ajax.getBlob(o);
    if (["paymentSummaryReport", "accountingReport", "totalsReport", "rowsReport"].includes(t)) {
      const o = `${pe.current.reportServer}/pdf`, u = `disposition=inline&access_token=${this.ajax.getCurrentToken()}`;
      switch (t) {
        case xe.PaymentSummaryReport: {
          const m = `${o}?id=&reportType=${encodeURIComponent(t)}&template=paymentSummaryReportV2&language=${encodeURIComponent(n)}&${u}`;
          return s(m, e);
        }
        case xe.AccountingReport: {
          const m = `${o}?id=&reportType=${encodeURIComponent(t)}&template=accountingReport&language=${encodeURIComponent(n)}&${u}`;
          return this.getAccountingDataForCalculations(e).then((p) => s(m, p));
        }
        case xe.TotalsReport: {
          const m = `${o}?id=&reportType=${encodeURIComponent(t)}&template=totalsReport&language=${encodeURIComponent(n)}&${u}`;
          return s(m, e);
        }
        default:
          throw new Error(`Report type ${t} is not supported`);
      }
    }
    const r = `${this.ajax.getServerAddress()}/v03/api/reports/assure-pdf/${t}`;
    if (e.every((o) => o?.workflow?.status === ia.PaymentSucceeded)) {
      const o = e.map((m) => `ids=${encodeURIComponent(m.id)}`).join("&"), u = `${r}?disposition=inline&${o}&language=${encodeURIComponent(i)}&access_token=${this.ajax.getCurrentToken()}`;
      return s(u);
    } else {
      const o = `${r}?language=${encodeURIComponent(i)}&disposition=inline&access_token=${this.ajax.getCurrentToken()}`;
      return s(o, e);
    }
  }
};
Qn.$inject = ["AjaxNg1", "$http"];
let Qa = Qn;
const ei = class ei {
  constructor(e) {
    this.ajax = e;
  }
  /**
   * Checks whether the current browser session is authorized.
   *
   * @returns A Promise with result data (boolean).
   */
  isAuthorized() {
    return this.ajax.getJSON("/session/isAuthorized");
  }
  /**
   * Gets the current session information or null if there is no active session.
   * UserSession data is the Authorization object that provides information about the current session. Null, if there is no session.
   *
   * @returns A Promise with result data (UserSession).
   */
  getSession() {
    return this.ajax.getJSON("/session/current");
  }
  /**
   * Returns server address
   */
  getServerAddress() {
    return this.ajax.getServerAddress();
  }
  /**
   * Gets the URL for login / register UI to Salaxy API.
   *
   * @param redirectUrl The URL where the user is taken after a successfull login.
   * If not specified, uses window.location.protocol + "//" + window.location.host + window.location.pathname.
   * In non-browser environments, this must be specified.
   * @param role Optional role (household, worker or company) for the situations where it is known - mainly for new users.
   * @param partnerSite The partner site is passed as client_id to the sign-in process.
   * @param mode Salaxy login mode: "sign_in" (login screen) or "sign_up" (register as new user).
   * @param urlPostfix Additional string that is added to tha URL.
   * Used in adding other parameters to the URL, e.g. "&salaxy_language=en"
   */
  getSignInAddress(e = null, t = null, n = null, i = null, s = null) {
    const r = pe.current, l = n || r?.partnerSite || "unknown";
    if (!e) {
      if (!window)
        throw new Error("Redirect URL is required if window is not available.");
      e = window.location.protocol + "//" + window.location.host + window.location.pathname;
    }
    let o = this.getServerAddress() + "/oauth2/authorize?response_type=token&redirect_uri=" + encodeURIComponent(e || "") + "&client_id=" + encodeURIComponent(l || "") + "&salaxy_role=" + encodeURIComponent(t || "") + "&salaxy_authorize_mode=" + encodeURIComponent("" + i);
    return s && (o = o + s), o;
  }
};
ei.$inject = ["AjaxNg1"];
let et = ei;
const ai = class ai {
  constructor(e) {
    this.ajax = e;
  }
  /**
   * Basic hello world message. Echoes the given message back.
   *
   * @param message - Message.
   *
   * @returns A Promise with result data (message).
   */
  hello(e) {
    return this.ajax.getJSON("/test/hello?message=" + encodeURIComponent("" + (e ?? "")));
  }
  /**
   * Test a long lasting request.
   *
   * @param seconds - Delay in seconds.
   *
   * @returns A Promise with result data (Delay in seconds).
   */
  delay(e) {
    return this.ajax.getJSON(`/test/delay?seconds=${e}`);
  }
  /**
   * Test JSON serialization. Echoes a given object either in success callback or in the promise.
   *
   * @param testValues - TestValues object.
   *
   * @returns A Promise with result.
   */
  values(e) {
    return this.ajax.postJSON("/test/values", e);
  }
  /**
   * Creates a test account and returns test account details.
   *
   * @param onboarding - Onboarding object.
   *
   * @returns A Promise with result data (test accounts).
   */
  createTestAccount(e) {
    return this.ajax.postJSON("/test/accounts", e);
  }
  /**
   * Deletes a test account and related objects
   *
   * @param accountId - Account id to delete.
   *
   * @returns A Promise with result data "Object deleted".
   */
  deleteTestAccount(e) {
    return this.ajax.remove("/test/accounts/" + encodeURIComponent("" + (e ?? "")));
  }
  /**
   * Test methods that throws an exception on server side.
   *
   * @param errorType Type of error
   *
   * @returns A Promise if success parameter is null. For throwException,
   * the promise is always rejected after the error is thrown in the server.
   */
  throwException(e) {
    return this.ajax.getJSON("/test/exceptions/" + e);
  }
  /**
   * Delete the current account data and credentials (including Auth0 user).
   * Can be called only in a test environment.
   */
  deleteCurrentAccount() {
    return this.ajax.remove("/accounts/current");
  }
  /**
   * Remove all calculations, workers etc. user objects except products and signature from the account.
   * Can be called only in a test environment.
   */
  deleteCurrentAccountData() {
    return this.ajax.remove("/accounts/data/all");
  }
  /**
   * Remove all calculations, payrolls and payments from the account.
   * Can be called only in a test environment.
   */
  deleteCurrentAccountCalculations() {
    return this.ajax.remove("/accounts/calculation/all");
  }
  /**
   * Remove workers including calculations, employment contracts and tax cards from the account.
   * Can be called only in a test environment.
   */
  deleteCurrentAccountWorkers() {
    return this.ajax.remove("/accounts/worker/all");
  }
  /**
   * Remove all holiday year from all workers. Does not touch the default values of holidays in Worker Employment relation.
   * Can be called only in a test environment.
   */
  deleteCurrentAccountHolidays() {
    return this.ajax.remove("/accounts/holidays/all");
  }
  /**
   * Remove pension and insurance from the account.
   * Can be called only in a test environment.
   */
  deleteCurrentAccountPensionAndInsurance() {
    return this.ajax.remove("/accounts/product/pensionAndInsurance");
  }
  /**
   * Remove the signature from the account.
   * Can be called only in a test environment.
   */
  deleteCurrentAccountSignature() {
    return this.ajax.remove("/accounts/signature");
  }
  /**
   * Delete all empty accounts (company or worker) created by this account.
   * Can be called only in a test environment.
   */
  deleteCurrentAccountAuthorizingAccounts() {
    return this.ajax.remove("/accounts/authorizingAccount/all");
  }
  /**
   * Sets the data for taxcards API for a personal Id for system-wide (all users).
   * @param testData The data that is stored as test data.
   * If the taxcard kind is Undefined, the data is cleared for that taxcard.
   * If the kind is NoTaxcard, the API wil return null.
   * Other kinds will be set as Auto.
   * @returns The data as it would be returnded now from the API
   */
  setTaxcardApi(e) {
    return this.ajax.postJSON("/v03/api/test-data/taxcard-api", e);
  }
  /**
   * Gets taxcard information for a personal Id.
   * @param personalId Personal ID for which the data is fetched.
   * @returns Taxcard input or null if none is stored in the test data file.
   * Note if this APi returns null, system defaults to a fixed test taxcard.
   * If you want the system to return null, set kind to NoTaxcard.
   */
  getTaxcardApi(e) {
    return this.ajax.getJSON("/v03/api/test-data/taxcard-api/" + encodeURIComponent(e));
  }
  /**
   * Deletes the current account's KYC (Know Your Customer) information.
   * @returns A Promise that resolves to a string representing the result of the deletion.
   */
  deleteCurrentAccountKyc() {
    return this.ajax.remove("/accounts/kyc");
  }
  /**
   * Activates the current account's KYC (Know Your Customer) using the provided data.
   * @returns A Promise that resolves to the company account.
   */
  activateCurrentAccountKyc() {
    return this.ajax.postJSON("/accounts/kyc", null);
  }
};
ai.$inject = ["AjaxNg1"];
let at = ai;
class El {
  constructor(e) {
    this._ajax = e;
  }
  /** The platform (NG1, NG, jQuery etc.) dependent class that performs the actual Ajax calls */
  get ajax() {
    return this._ajax;
  }
  /** Gets the Accounts API: Access to current account, its products and workers */
  get accountsApi() {
    return this._accountsApi || (this._accountsApi = new qa(this._ajax)), this._accountsApi;
  }
  /** Gets the Calculations API: CRUD operations on calculations */
  get calculationsApi() {
    return this._calculationsApi || (this._calculationsApi = new Na(this._ajax)), this._calculationsApi;
  }
  /** Gets the Calculator API: Anonymous salary calculation methods */
  get calculatorApi() {
    return this._calculatorApi || (this._calculatorApi = new Ma(this._ajax)), this._calculatorApi;
  }
  /** Gets the Reports API: Viewing and generating reports in different formats */
  get reportsApi() {
    return this._reportsApi || (this._reportsApi = new Qa(this._ajax)), this._reportsApi;
  }
  /** Gets the Files API: Files stored by the user, thumbnails of pictures etc. */
  get filesApi() {
    return this._filesApi || (this._filesApi = new za(this._ajax)), this._filesApi;
  }
  /** Gets the Session API: Access to current session, user and roles */
  get sessionApi() {
    return this._sessionApi || (this._sessionApi = new et(this._ajax)), this._sessionApi;
  }
  /** Gets the OAuth2 API: Authentication methods */
  get oAuth2Api() {
    return this._oAuth2Api || (this._oAuth2Api = new Ja(this._ajax)), this._oAuth2Api;
  }
  /** Gets the Test API: Testing different functionalities of the API and system in general. */
  get testApi() {
    return this._testApi || (this._testApi = new at(this._ajax)), this._testApi;
  }
  /** Gets the Tax cards API */
  get taxcardsApi() {
    return this._taxcardsApi || (this._taxcardsApi = new _a(this._ajax)), this._taxcardsApi;
  }
  /** Gets the Onboarding API for creating a new user */
  get onboardingsApi() {
    return this._onboardingsApi || (this._onboardingsApi = new Za(this._ajax)), this._onboardingsApi;
  }
}
const ti = class ti extends mn {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/settings/company";
  }
  /**
   * Creates a new IR certificate.
   * @param transferId Transfer ID for the IR certificate.
   * @param transferPassword One time transfer password for the IR certificate.
   * @returns Information about the created IR certificate.
   */
  createIrCertificate(e, t) {
    const n = `/v03/api/settings/irCertificate?transferId=${encodeURIComponent(e)}&transferPassword=${encodeURIComponent(t)}`;
    return this.ajax.postJSON(n, null);
  }
  /**
   * Renews an existing IR certificate.
   * @returns Information about the created IR certificate.
   */
  renewIrCertificate() {
    return this.ajax.postJSON("/v03/api/settings/irCertificate/renew", null);
  }
  /**
   * Gets the detials of the existing IR certificate or null if no certificate exists.
   * @returns Information about the current IR certificate.
   */
  getIrCertificate() {
    return this.ajax.getJSON("/v03/api/settings/irCertificate");
  }
};
ti.$inject = ["AjaxNg1"];
let Ht = ti;
const ni = class ni extends mn {
  constructor(e) {
    super(e), this.baseUrl = "/v03/api/beneficial-owners";
  }
};
ni.$inject = ["AjaxNg1"];
let Wt = ni;
const ii = class ii {
  constructor(e) {
    this.ajax = e;
  }
  /**
   * Gets list of articles
   * @returns List of articles
   */
  getArticles() {
    return this.ajax.getJSON(`${pe.current.reportServer}/articles`);
  }
  /**
   * Gets single article by id
   * @param id article id
   * @returns article as json
   */
  getArticle(e) {
    return this.ajax.getJSON(`${pe.current.reportServer}/articles/${e}`);
  }
  /**
   * Gets single article by id
   * @param id article id
   * @returns article as text
   */
  getArticleHTML(e) {
    return this.ajax.getHTML(`${pe.current.reportServer}/articles/${e}/html`);
  }
  /**
   * Gets list of articles
   * @returns List of articles
   */
  getCategoryArticles(e) {
    return this.ajax.getJSON(`${pe.current.reportServer}/articles/category/${e}`);
  }
};
ii.$inject = ["AjaxNg1"];
let Yt = ii;
const si = class si {
  constructor(e) {
    this.ajax = e;
  }
  /**
   * Makes an OData query over all objects within the current account.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  getAllData(e) {
    return Z.getOData("/v03-rc/api/overview/all", e, this.ajax);
  }
  /**
   * Gets the welcome page data for a Worker account.
   */
  getWelcomeDataWorker() {
    return this.ajax.getJSON("/v03-rc/api/overview/welcome-worker").then((e) => {
      for (const t of e.timeline ?? [])
        t.shortText = this.getShortMessage(t);
      return e;
    });
  }
  getShortMessage(e) {
    switch (e.type) {
      case ya.Calculation:
      case ya.CalculationPaid: {
        const t = e.status;
        switch (t) {
          case ia.WorkerRequested:
            return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.calculation.workerRequested", { name: e.otherPartyInfo?.avatar?.displayName ?? "" });
          case ia.WorkerRequestDeclined:
            return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.calculation.workerRequestDeclined", { name: e.otherPartyInfo?.avatar?.displayName ?? "" });
          case ia.WorkerRequestAccepted:
            return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.calculation.workerRequestAccepted", { name: e.otherPartyInfo?.avatar?.displayName ?? "" });
          case ia.Draft:
            return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.calculation.draft");
          case ia.PaymentWorkerCopy:
            return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.calculation.paymentWorkerCopy", { name: e.otherPartyInfo?.avatar?.displayName ?? "" });
          default:
            return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.calculation.default", { status: d.get("SALAXY.ENUM.CalculationStatus." + t) });
        }
      }
      case ya.PersonAccount:
        return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.personAccount");
      case ya.Employment:
        return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.employmentDefault", { name: e.ownerInfo?.avatar?.displayName ?? "" });
      case ya.Taxcard:
        switch (e.status) {
          case $e.Shared:
            return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.taxcard.shared");
          case $e.SharedApproved:
            return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.taxcard.sharedApproved", { name: e.ownerInfo?.avatar?.displayName ?? "" });
          case $e.SharedRejected:
          case $e.SharedRejectedWithoutOpen:
            return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.taxcard.sharedRejected", { name: e.ownerInfo?.avatar?.displayName ?? "" });
          case $e.SharedWaiting:
            return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.taxcard.sharedWaiting", { name: e.ownerInfo?.avatar?.displayName ?? "" });
          case $e.EmployerAdded:
          case $e.Approved:
            return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.taxcard.approved", { name: e.ownerInfo?.avatar?.displayName ?? "" });
          case $e.VerifiedVero:
            return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.taxcard.verifiedVero", { name: e.ownerInfo?.avatar?.displayName ?? "" });
          default:
            return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.taxcard.default", { status: e.status });
        }
      default:
        return d.get("SALAXY.CORE.WorkerTimeline.shortMessages.timelineType", { type: e.type });
    }
  }
};
si.$inject = ["AjaxNg1"];
let $t = si;
const ri = class ri {
  constructor(e) {
    this.ajax = e;
  }
  /**
   * Returns a new Varma pension order with default values for the current account.
   */
  getNewVarmaPensionOrder() {
    return this.ajax.getJSON("/partner-services/varma/pension/new");
  }
  /**
   * Validate the given Varma pension order in the server.
   */
  validateVarmaPensionOrder(e) {
    return this.ajax.postJSON("/partner-services/varma/pension/validate", e);
  }
  /**
   * Send a new Varma pension order for later processing.
   */
  sendVarmaPensionOrder(e) {
    return this.ajax.postJSON("/partner-services/varma/pension/order", e);
  }
  /**
   * Returns a new Local Tapiola Insurance order with default values for the current account.
   */
  getNewLocalTapiolaInsuranceOrder() {
    return this.ajax.getJSON("/partner-services/local-tapiola/insurance/new");
  }
  /**
   * Validate the given Local Tapiola Insurance order in the server.
   */
  validateLocalTapiolaInsuranceOrder(e) {
    return this.ajax.postJSON("/partner-services/local-tapiola/insurance/validate", e);
  }
  /**
   * Send a new Local Tapiola Insurance order for later processing.
   */
  sendLocalTapiolaInsuranceOrder(e) {
    return this.ajax.postJSON("/partner-services/local-tapiola/insurance/order", e);
  }
};
ri.$inject = ["AjaxNg1"];
let Gt = ri;
const oi = class oi {
  constructor(e) {
    this.ajax = e, this.routePrefix = "/v01/api/pro";
  }
  /** Gets the PRO session for the current account (the PRO account) including the Service Model */
  getProSession() {
    const e = `${this.routePrefix}/session`;
    return this.ajax.getJSON(e);
  }
  /** Lists all accounts on behalf of which this account has been authorized to act. */
  getAccounts() {
    const e = `${this.routePrefix}/accounts`;
    return this.ajax.getJSON(e);
  }
  /**
   * Set the current account as primary partner for the account.
   * @param accountId The account id for which the primary partner is set.
   * @param serviceModelId Selected service model.
   * @returns Updated account with the partner set.
   */
  saveAccountPartner(e, t) {
    if (!e || !t)
      throw new Error("Account and service model must be provided.");
    const n = `${this.routePrefix}/accounts/${encodeURIComponent(e)}/partner?serviceModelId=${encodeURIComponent(t)}`;
    return this.ajax.postJSON(n, {});
  }
  /**
   * Remove the current primary partner (current account) from the account.
   * @param accountId The account id from which the primary partner is removed.
   * @returns Updated account with the partner removed.
   */
  deleteAccountPartner(e) {
    if (!e)
      throw new Error("Account id must be provided.");
    const t = `${this.routePrefix}/accounts/${encodeURIComponent(e)}/partner`;
    return this.ajax.remove(t);
  }
  /**
   * Lists all credentials for this partner account.
   * @returns Credentials for the partner account.
   */
  getCredentials() {
    const e = `${this.routePrefix}/credentials`;
    return this.ajax.getJSON(e);
  }
  /**
   * Returns a new JWT token for the given account.
   * The requesting user must have access to the account.
   * @param accountId The account id for which the token is requested.
   * @returns A valid Salaxy JWT token for the given account
   */
  getToken(e) {
    const t = `${this.routePrefix}/accounts/${encodeURIComponent(e)}/token`;
    return this.ajax.getJSON(t);
  }
  /**
   * Returns list of payrolls for the current partner (all customers).
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  oDataSearchPayrolls(e) {
    return Z.getOData(`${this.routePrefix}/payrolls`, e, this.ajax);
  }
  /**
   * Returns list of invoices for the current partner (all customers).
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  oDataSearchInvoices(e) {
    return Z.getOData(`${this.routePrefix}/invoices`, e, this.ajax);
  }
  /**
   * Returns list of messages for the current partner (all customers).
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  oDataSearchMessages(e) {
    return Z.getOData(`${this.routePrefix}/messages`, e, this.ajax);
  }
  /**
   * Returns list of editable calculations for the current partner.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  oDataSearchEditableCalculations(e) {
    return Z.getOData(`${this.routePrefix}/calculations/category/editable`, e, this.ajax);
  }
  /**
   * Returns list of readonly calculations for the current partner.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  oDataSearchReadonlyCalculations(e) {
    return Z.getOData(`${this.routePrefix}/calculations/category/readonly`, e, this.ajax);
  }
  /**
   * Returns list of workers for the current partner.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  oDataSearchWorkers(e) {
    return Z.getOData(`${this.routePrefix}/workers`, e, this.ajax);
  }
  /**
   * Returns list of files for the current partner.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  oDataSearchFiles(e) {
    return Z.getOData(`${this.routePrefix}/files`, e, this.ajax);
  }
  /**
   * Returns list of taxcards for the current partner.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  oDataSearchTaxcards(e) {
    return Z.getOData(`${this.routePrefix}/taxcards`, e, this.ajax);
  }
  /**
   * Returns list of Earnings Payment Reports (EPR / Palkkatietoilmoitus)
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  oDataSearchEarningsPayments(e) {
    return Z.getOData(`${this.routePrefix}/ir-epr`, e, this.ajax);
  }
  /**
   * Returns list of Payer Summary Reports (PSR / Erillisilmoitus)
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  oDataSearchPayerSummaries(e) {
    return Z.getOData(`${this.routePrefix}/ir-psr`, e, this.ajax);
  }
  /**
   * Returns household yearly list items for the current partner.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   */
  oDataSearchHouseholdYears(e) {
    return Z.getOData(`${this.routePrefix}/household-years`, e, this.ajax);
  }
  /**
   * Returns settings list items for the current partner.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   * TODO: Return type should be Promise<ODataResult<AccountSettingsListItem>> but AccountSettingsListItem is currently not available. See if the typing should be brought to project.
   */
  oDataSearchAccountSettings(e) {
    return Z.getOData(`${this.routePrefix}/settings`, e, this.ajax);
  }
  /**
   * Returns list of customers for the current partner.
   * @param query The options for the query: Filter, search sort etc.
   * This is either a strongly typed object or query string that is added directly.
   * TODO: Return type should be Promise<ODataResult<PersonListItem>>
   */
  oDataSearchCustomers(e) {
    return Z.getOData(`${this.routePrefix}/customers`, e, this.ajax);
  }
  /**
   * Returns list of customers for the current partner.
   * @param refDate Reference date for the period. Please note that even if the date is not the first day of the given period, the entire period is returned.
   * @param periodType Month, quarter, year or a custom period. The custom period requires endDate. Default value is the month.
   * @param endDate End date for the period. Required only for the custom period.
   * @returns List of customers for the current partner.
   */
  searchCustomers(e, t = it.Month, n) {
    e = c.asDate(e), n = c.asDate(n);
    const i = `${this.routePrefix}/customers/${e}?periodType=${t || ""}&endDate=${n || ""}`;
    return this.ajax.getJSON(i);
  }
  // TODO: OData methods!!!
};
oi.$inject = ["AjaxNg1"];
let Jt = oi;
const li = class li {
  constructor(e) {
    this.ajax = e, this.baseUrl = "/v03/api/import";
  }
  /**
   * Imports companies.
   *
   * @param companies The company import data.
   * @returns A Promise with result data ( PartnerCompanyAccountInfo ).
   */
  importCompanies(e) {
    return this.ajax.postJSON(`${this.baseUrl}/companies`, e);
  }
  /**
   * Imports workers.
   *
   * @param workers The worker import data.
   * @returns A Promise with result data containing worker IDs.
   */
  importWorkers(e) {
    return this.ajax.postJSON(`${this.baseUrl}/workers`, e);
  }
  /**
   * Imports calculations to a new/existing payroll.
   *
   * @param calculations The calculation import data.
   * @param options The save options for the payroll calculations.
   * @returns A Promise with result data containing payroll IDs.
   */
  importCalculations(e, t) {
    return this.ajax.postJSON(this.getUrlWithOptions(`${this.baseUrl}/calculations`, t), e);
  }
  /**
   * Creates invoices for payrolls.
   *
   * @param payrolls IDs of the payrolls to create invoices for.
   * @param channel The payment channel.
   * @returns A Promise with result data containing created invoice objects.
   */
  createInvoices(e, t) {
    return this.ajax.postJSON(`${this.baseUrl}/invoicing/${t}`, e);
  }
  /**
   * Sends invoices as e-invoices.
   *
   * @param invoices IDs of the invoices to be sent as e-invoices.
   * @returns A Promise with result data containing e-invoicing result messages.
   */
  sendEInvoices(e) {
    return this.ajax.postJSON(`${this.baseUrl}/einvoicing`, e);
  }
  /**
   * Checks the existence of the given workers.
   * The given ID can be worker's Salaxy ID, employment ID, social security number of external ID.
   *
   * @param workers The worker IDs to check.
   * @returns A Promise with result data containing worker objects.
   */
  checkWorkers(e) {
    return this.ajax.postJSON(`${this.baseUrl}/workers-check`, e);
  }
  /**
   * Checks the existence of the invoice settings for a company,
   * The given ID can be company's Salaxy ID or official ID.
   *
   * @param companies The company IDs to check.
   * @param type The type of the check: sepa or eInvoice settings.
   * @returns A Promise with result data containing settings objects.
   */
  checkInvoiceSettings(e, t) {
    return this.ajax.postJSON(`${this.baseUrl}/invoice-settings-check/${t}`, e);
  }
  /**
   * Query e-invoice addresses for a company.
   * @param officialId Official ID of the company.
   * @returns List of e-invoice addresses.
   */
  queryEInvoiceAddress(e) {
    return this.ajax.getJSON(`${this.baseUrl}/einvoice/receiver?officialId=${encodeURIComponent(e)}`);
  }
  getUrlWithOptions(e, t) {
    const n = [];
    t ?? (t = {}), Object.keys(t).forEach((s) => {
      const r = t[s];
      r != null && n.push(`${s}=${encodeURIComponent(r)}`);
    });
    const i = n.join("&");
    return `${e}${i ? "?" + i : ""}`;
  }
};
li.$inject = ["AjaxNg1"];
let zt = li;
class Al {
  /**
   * Gets an agGrid cell renderer based on the property schema.
   * @param schemaProp The schema of the property that is being rendered
   * @returns A cell renderer for AGGrid. Currently always a function: May later be a component.
   * Null, if the column should be rendered using default functionality.
   */
  static getCellRenderer(e) {
    switch (e.format) {
      case "Employment":
        return (t) => `<div>${this.getAvatar(t?.value?.personalInfo.avatar)} ${t?.value?.personalInfo.avatar.sortableName || "-"}</div>`;
      case "Avatar":
        return (t) => `<div>${this.getAvatar(t?.value)} ${t?.value?.sortableName || "-"}</div>`;
    }
  }
  /**
   * Renders an avatar as a picture / icon
   * @param avatar The avatar objec that should be rendered.
   * @param fontSize Optional font size. Default is 2em, which typically good in agGrid.
   * @returns HTML for the avatar.
   */
  static getAvatar(e, t = "2em") {
    const n = e && (e.pictureType === We.Uploaded || e.pictureType === We.Gravatar) && e.url?.substring(0, 4).toLowerCase() === "http", i = e != null && !n && e.entityType !== "company", s = e ? e.initials || "-" : "?", r = this.getColor(e.color);
    return n ? `<span class="salaxy-avatar" style="width: 1em; height: 1em; font-size: ${t}"><img src="${e.url}" /></span>` : `<span class="salaxy-avatar" style="width: 2.5em; height: 2.5em;">
      <i class="salaxy-avatar bi ${i ? "bi-person-fill" : "bi-square-fill"}" style="color: ${r || "gray"}; font-size: ${t}">
        <strong style="text-shadow: 1px 1px 0px ${r || "gray"}, -1px -1px 0px ${r || "gray"}, 1px -1px 0px ${r || "gray"}, -1px 1px 0px ${r || "gray"}">${s}</strong>
      </i>
    </span>`;
  }
  /**
   * Return the color for the avatar icon and line strokes. NOTE: identical method as in AvatarController.ts. Will be refactored at a later date.
   * If some colors require adjustments due to accessibility reasons, they can be implemented here.
   */
  static getColor(e) {
    switch (e) {
      case "yellow":
        return "#ebc000";
      case "lime":
        return "limegreen";
      case "pink":
        return "#ff8fa2";
      default:
        return e;
    }
  }
}
var mo = /* @__PURE__ */ ((a) => (a.Visible = "visible", a.Hidden = "hidden", a.ReadOnly = "readOnly", a.HiddenReadOnly = "hiddenReadOnly", a.Disabled = "disabled", a))(mo || {});
const Pl = [
  {
    id: "childCare",
    icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/childcare.svg",
    children: [
      {
        id: "childCare/mll",
        uri: "https://secure.salaxy.com/v02/api/usecases/mll",
        isHouseholdDeductible: !0,
        icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/childcare.svg",
        badge: "https://cdn.salaxy.com/ng1/household-usecases/badge/mll.png",
        occupation: "53112"
      },
      {
        id: "childCare/kela",
        uri: "https://secure.salaxy.com/v02/api/usecases/childCare",
        isChildcareSubsidy: !0,
        isHouseholdDeductible: !1,
        icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/childcare.svg",
        badge: "https://cdn.salaxy.com/ng1/household-usecases/badge/kela.png",
        occupation: "53112"
      },
      {
        id: "childCare/other",
        uri: "https://secure.salaxy.com/v02/api/usecases/childCare",
        isHouseholdDeductible: !0,
        icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/childcare.svg",
        occupation: "53112"
      }
    ]
  },
  {
    id: "construction",
    icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/construction.svg",
    children: [
      {
        id: "construction/carpenter",
        icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/construction-carpenter.svg",
        uri: "https://secure.salaxy.com/v02/api/usecases/construction",
        occupation: "71150"
      },
      {
        id: "construction/painter",
        icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/construction-painter.svg",
        uri: "https://secure.salaxy.com/v02/api/usecases/construction",
        occupation: "71310"
      },
      {
        id: "construction/renovation",
        icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/construction-renovation.svg",
        uri: "https://secure.salaxy.com/v02/api/usecases/construction",
        isHouseholdDeductible: !0,
        occupation: "71110"
      },
      {
        id: "construction/new",
        icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/construction-new.svg",
        uri: "https://secure.salaxy.com/v02/api/usecases/construction",
        isHouseholdDeductible: !1,
        occupation: "71110"
      },
      {
        id: "construction/other",
        uri: "https://secure.salaxy.com/v02/api/usecases/other",
        icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/other.svg",
        occupation: void 0
      }
    ]
  },
  {
    id: "cleaning",
    uri: "https://secure.salaxy.com/v02/api/usecases/cleaning",
    icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/cleaning.svg",
    children: [
      {
        id: "cleaning/91110",
        isHouseholdDeductible: !0,
        occupation: "91110",
        isContractLessThanYear: !0
      },
      {
        id: "cleaning/51530",
        icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/cleaning-real-estate.svg",
        isHouseholdDeductible: !0,
        occupation: "51530",
        isContractLessThanYear: !0
      },
      {
        id: "cleaning/61132",
        icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/cleaning-garden.svg",
        isHouseholdDeductible: !0,
        occupation: "61132",
        isContractLessThanYear: !0
      },
      {
        id: "cleaning/53221",
        isHouseholdDeductible: !0,
        occupation: "53221",
        isContractLessThanYear: !0
      },
      {
        id: "cleaning/other",
        icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/cleaning-other.svg",
        isHouseholdDeductible: !0,
        occupation: void 0,
        isContractLessThanYear: !0
      }
    ]
  },
  {
    id: "other",
    uri: "https://secure.salaxy.com/v02/api/usecases/other",
    icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/other.svg",
    children: [
      {
        id: "other/53222",
        isHouseholdDeductible: !0,
        taxDeductionCategories: te.Carework,
        occupation: "53222"
      },
      {
        id: "other/61112",
        occupation: "61112"
      },
      {
        id: "other/91110",
        isHouseholdDeductible: !0,
        taxDeductionCategories: te.Householdwork,
        occupation: "91110"
      },
      {
        id: "other/53213",
        isHouseholdDeductible: !0,
        taxDeductionCategories: te.Carework,
        occupation: "53213"
      },
      {
        id: "other/53212",
        isHouseholdDeductible: !0,
        taxDeductionCategories: te.Carework,
        occupation: "53212"
      },
      {
        id: "other/53112",
        isHouseholdDeductible: !0,
        taxDeductionCategories: te.Carework,
        occupation: "53112"
      },
      {
        id: "other/53221",
        isHouseholdDeductible: !0,
        taxDeductionCategories: te.Carework,
        occupation: "53221"
      },
      {
        id: "other/62100",
        icon: "https://cdn.salaxy.com/ng1/household-usecases/icon/other.svg",
        occupation: "62100"
      },
      {
        id: "other/51530",
        isHouseholdDeductible: !0,
        taxDeductionCategories: te.Householdwork,
        occupation: "51530"
      },
      {
        id: "other/61132",
        isHouseholdDeductible: !0,
        taxDeductionCategories: te.Householdwork,
        occupation: "61132"
      },
      {
        id: "other/undefined",
        occupation: void 0
      }
    ]
  }
], Ne = class Ne {
  /**
   * Finds a parent group of a given usecase node
   * @param usecaseId - The usecase whose parent is fetched.
   * If you pass a group here, the function will return null which will typically mean the tree root in the user interface.
   *
   * @example
   * ```
   * // Creates a simple calculation
   * const usecase = UsecasesLogic.findUsecaseById("childCare/mll");
   * UsecasesLogic.setUsecase(this.context.calculations.current, usecase);
   * this.context.calculations.recalculateCurrent((calc) => {
   *     calc.worker.paymentData.telephone = "+358401234567";
   * });
   * ```
   */
  static findUsecaseById(e) {
    for (const t of Ne.getUsecaseTree())
      for (const n of t.children || [])
        if (n.id === e)
          return n;
  }
  /**
   * Gets a tree of usecases (user interfaces for defining a framework) for a given role.
   */
  static getUsecaseTree() {
    const e = Pl;
    for (const t of e) {
      this.translate("HouseHoldUseCaseTree", t.id, t);
      for (const n of t.children ?? [])
        n.badge = n.badge || t.badge, n.icon = n.icon || t.icon, n.uri = n.uri || t.uri, this.translate("HouseHoldUseCaseTree", n.id, n);
    }
    return e;
  }
  /**
   * Abstract the getting of the use case for the calculation.
   * We are expecting changes to the usecase implementation.
   * @param calc Calculation into which the usecase data is stored.
   */
  static getUsecaseData(e) {
    if (!e.usecase?.uri) {
      const t = Ne.findUsecaseById("other/undefined");
      e.usecase = {
        uri: t?.uri,
        label: t?.label,
        description: t?.descr,
        data: t
      };
    }
    return e.usecase.data;
  }
  /**
   * Sets calculation properties based on selected usecase.
   * @param calc Calculation to set
   * @param usecase Usecase to apply.
   * @example
   * ```
   * // Creates a simple calculation
   * const usecase = UsecasesLogic.findUsecaseById("childCare/mll");
   * UsecasesLogic.setUsecase(this.calc, usecase);
   * this.calcApi.recalculate(this.calc).then((data) => {
   *   angular.copy(data, this.calc);
   * });
   * ```
   */
  static setUsecase(e, t) {
    return e.usecase = {
      uri: t.uri,
      label: t.label,
      description: t.descr,
      data: t
    }, this.applyUseCase(e), this.getUsecaseData(e);
  }
  /**
   * Applies the usecase to a calculation, especially to the old Framework object.
   * Should be called before sending the calculation to the server (recalculate/save).
   * @param calc Calculation where usecase is set to calc.data.usecase.
   */
  static applyUseCase(e) {
    switch (this.getUsecaseData(e).uri) {
      case Ne.knownUseCases.childCare:
        this.applyUsecaseChildCare(e);
        break;
      case Ne.knownUseCases.mll:
        this.applyUsecaseMll(e);
        break;
      case Ne.knownUseCases.cleaning:
        this.applyUsecaseCleaning(e);
        break;
      case Ne.knownUseCases.construction:
        this.applyUsecaseConstruction(e);
        break;
      case Ne.knownUseCases.santaClaus:
        this.applyUsecaseSantaClaus(e);
        break;
      case Ne.knownUseCases.other:
        this.applyCommonUsecaseProperties(e);
        break;
      case Ne.knownUseCases.notDefined:
        break;
    }
  }
  /**
   * Applies the constructions salary calculation usecase.
   * @param calc Calculation to which the usecase is applied.
   */
  static applyUsecaseConstruction(e) {
    const t = this.getUsecaseData(e), n = na.getSalaryRow(e) ?? {};
    switch (n?.rowType) {
      case k.HourlySalary:
      case k.MonthlySalary:
      case k.Salary:
        break;
      case k.TotalEmployerPayment:
        t.isTesIncludedInSalary = !0, t.isExpensesCustom = !0, t.dailyExpenses = void 0, t.dailyTravelExpenses = void 0;
        break;
      default:
        n.rowType = k.Salary;
        break;
    }
    t.taxDeductionCategories = te.HomeImprovement, t.isTesIncludedInSalary = t.isTesIncludedInSalary || !1, t.isExpensesCustom = t.isExpensesCustom || !1;
    const i = e?.framework?.numberOfDays || 0, s = (n.count ?? 0) * (n.price ?? 0);
    if (e.rows = e.rows?.filter((r) => r.data?.usecase != t.uri), t.isTesIncludedInSalary || (this.addUsecaseRow(e, t.uri, k.HolidayCompensation, 0.185, s, "Lomakorvaus"), this.addUsecaseRow(e, t.uri, k.TesWorktimeShortening, 0.077, s, "Erillinen palkan osa")), t.isExpensesCustom)
      this.addUsecaseRow(
        e,
        t.uri,
        k.MilageOther,
        i,
        t.dailyTravelExpenses,
        `Matkakustannusten korvaus ${t.dailyTravelExpenses || 0} €/päivä`
      ), this.addUsecaseRow(
        e,
        t.uri,
        k.ToolCompensation,
        i,
        t.dailyExpenses,
        `Työkalukorvaus ${t.dailyExpenses || 0} €/päivä`
      );
    else {
      const r = Ne.raksaKmChart(t.dailyTravelExpensesKm), l = 1.68;
      this.addUsecaseRow(e, t.uri, k.MilageOther, i, r, `Matkakustannusten korvaus ${r || 0} €/päivä`), this.addUsecaseRow(e, t.uri, k.ToolCompensation, i, l, `Työkalukorvaus ${l} €/päivä`);
    }
    this.applyCommonUsecaseProperties(e);
  }
  /** Applies the childCare salary calculation usecase */
  static applyUsecaseChildCare(e) {
    const t = this.getUsecaseData(e), n = na.getSalaryRow(e) ?? {};
    n.rowType === k.HourlySalary ? n.message = "Lastenhoitajan tuntipalkka" : (n.rowType = k.MonthlySalary, n.message = "Lastenhoitajan kuukausipalkka"), e.rows = e.rows?.filter((i) => i.rowType !== k.ChildCareSubsidy), t.isChildcareSubsidy ? (e.rows ?? (e.rows = []), e.rows.push({
      count: 1,
      price: t.subsidyAmount,
      rowType: k.ChildCareSubsidy
    })) : t.subsidyAmount = void 0, t.isChildcareSubsidy && (t.isHouseholdDeductible = !1, t.taxDeductionCategories = void 0), t.isHouseholdDeductible == null && (t.isHouseholdDeductible = !0), t.taxDeductionCategories = t.isHouseholdDeductible ? te.Carework : void 0, this.applyCommonUsecaseProperties(e);
  }
  /** Applies the cleaning salary calculation usecase */
  static applyUsecaseCleaning(e) {
    const t = this.getUsecaseData(e), n = na.getSalaryRow(e) ?? {};
    if (n.rowType === k.HourlySalary || n.rowType === k.MonthlySalary || (n.rowType = k.Salary), e.rows = e.rows?.filter((i) => i.rowType !== k.HolidayCompensation), !t.isFullTime) {
      const i = (n.count ?? 0) * (n.price ?? 0), s = t.isContractLessThanYear ? 0.09 : 0.115;
      e.rows ?? (e.rows = []), e.rows.push({
        count: s,
        price: i,
        rowType: k.HolidayCompensation
      });
    }
    t.isHouseholdDeductible == null && (t.isHouseholdDeductible = !0), t.taxDeductionCategories = te.Householdwork, this.applyCommonUsecaseProperties(e);
  }
  /** Applies the MLL salary calculation usecase */
  static applyUsecaseMll(e) {
    const t = this.getUsecaseData(e), n = na.getSalaryRow(e, k.HourlySalary) ?? {};
    n.rowType = k.HourlySalary, n.message = "Lastenhoitajan tuntipalkka", (!n.count || n.count < 2) && (n.count = 2), t.useCustomPrice || (n.price = 9.5), e.rows = e.rows?.filter((i) => i.rowType !== k.SundayWork), t.isSunday && (e.rows ?? (e.rows = []), e.rows.push({
      count: 1,
      price: (n.count ?? 0) * (n.price ?? 0),
      rowType: k.SundayWork
    })), e.framework ?? (e.framework = {}), e.framework.isYksityisenHoidonTuki = !1, t.isHouseholdDeductible = !0, t.taxDeductionCategories = te.Carework, e.info ?? (e.info = {}), e.info.workStartDate || (e.info.workStartDate = c.getToday(), e.info.workEndDate = null, e.framework.numberOfDays = null), e.info.workEndDate || (e.info.workEndDate = e.info.workStartDate, e.framework.numberOfDays = null), e.framework.numberOfDays || (e.framework.numberOfDays = c.getWorkdays(
      e.info.workStartDate,
      e.info.workEndDate
    ).length), this.applyCommonUsecaseProperties(e);
  }
  static applyUsecaseSantaClaus(e) {
    const t = this.getUsecaseData(e), n = na.getSalaryRow(e, k.Salary) ?? {};
    n.rowType = k.Salary, n.message = "Joulupukin palkka", t.isHouseholdDeductible = !1, t.taxDeductionCategories = void 0;
    const i = c.getMonth("today") < 6 ? c.getYear("today") - 1 : c.getYear("today"), s = c.getDate(i, 12, 24);
    e.info ?? (e.info = {}), e.info.workStartDate = s, e.info.workEndDate = s, e.framework ?? (e.framework = {}), e.framework.numberOfDays = 1, this.applyCommonUsecaseProperties(e);
  }
  static applyCommonUsecaseProperties(e) {
    const t = this.getUsecaseData(e), n = na.getSalaryRow(e) ?? {};
    e.info ?? (e.info = {}), e.info.occupationCode = t.occupation, e.salary ?? (e.salary = { kind: Re.Undefined, price: 0 }), e.salary.isHouseholdDeductible = t.isHouseholdDeductible ?? !1, e.salary.taxDeductionCategories = t.taxDeductionCategories, n.rowType === k.HourlySalary ? n.count === 0 && (n.count = null) : n.count = 1, n.rowType = n.rowType || k.Salary;
  }
  static translate(e, t, n) {
    n.label = d.get("SALAXY.ENUM." + e + "." + t.replace(/\//g, ".") + ".label") || n.label, n.descr = d.get("SALAXY.ENUM." + e + "." + t.replace(/\//g, ".") + ".description") || n.descr;
  }
  /** Adds a usecase row if price is not zero */
  static addUsecaseRow(e, t, n, i, s, r) {
    s && (e.rows ?? (e.rows = []), e.rows.push({
      rowType: n,
      price: s,
      message: r,
      count: i,
      data: { usecase: t }
    }));
  }
  /** Does the kilometers milage euros conversion */
  static raksaKmChart(e) {
    return (e ?? 0) < 5 ? 0 : e < 10 ? 1.94 : e < 20 ? 3.13 : e < 30 ? 5.63 : e < 40 ? 8.2 : e < 50 ? 10.1 : e < 60 ? 12.24 : e < 70 ? 16.08 : e < 80 ? 18.2 : e < 90 ? 20.68 : e < 100 ? 23.55 : 26.4;
  }
};
Ne.knownUseCases = {
  /** Usecase has not been defined. Note that value is null, not "https://secure.salaxy.com/v02/api/usecases/notDefined" */
  notDefined: null,
  /** Generic child care usecase */
  childCare: "https://secure.salaxy.com/v02/api/usecases/childCare",
  /** Cleaning */
  cleaning: "https://secure.salaxy.com/v02/api/usecases/cleaning",
  /** Construction (Raksa) */
  construction: "https://secure.salaxy.com/v02/api/usecases/construction",
  /** Child care according to MLL recommendations. */
  mll: "https://secure.salaxy.com/v02/api/usecases/mll",
  /**
   * Santa Claus for Christmas campaigns: By default, this is not visible in the household UI:
   * It needs to be separately enabled for chirstmas campaigns.
   */
  santaClaus: "https://secure.salaxy.com/v02/api/usecases/santaClaus",
  /** Generic household salary payment usecase user interface. */
  other: "https://secure.salaxy.com/v02/api/usecases/other"
};
let Xt = Ne;
class Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   * @param _row Row to update.
   * @param _date The reference date for which the logic is done.
   * Typically the salary date of a calculation and the typically, the information needed is just the year for which the yearly changing numbers are fetched, but may later have more extended features.
   * @param _calcData The calculation related data that is required by the more complex calculations:
   * This data is available only after first round-trip to the server (results object exists) and not all user interfaces may provide this.
   */
  updateUsecase(e, t, n) {
  }
  /**
   * Gets validation message for the usecase.
   * @param row Row to validate
   * @returns A message that is either an error or OK (default). Warnings, info etc. may later be supported.
   */
  getValidation(e) {
    if ((e.price ?? 0) < 0 && !this.canHaveNegativeRow(e.rowType ?? k.Unknown))
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.negativeRow"
      };
    if ((e.count ?? 0) < 0)
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.negativeAmount"
      };
    if (this.getUcValidation)
      return this.getUcValidation(e);
  }
  /**
   * Returns true if the row type supports negative values.
   * Typically, this means that the sum of all rows must still be zero or positive.
   * @param rowType Row type to check
   */
  canHaveNegativeRow(e) {
    return !![
      k.MonthlySalary,
      k.HourlySalary,
      k.Salary,
      k.Compensation,
      k.Expenses,
      k.IrIncomeType
    ].find((n) => n === e);
  }
}
class co extends Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   */
  updateUsecase(e) {
    const t = e.data ?? {};
    t.kind = t.kind || wa.Undefined, this.updateIsPaid(e);
  }
  /** Gets validation message for AbsencePeriodUsecaseLogic  */
  getUcValidation(e) {
    const t = e.data ?? {};
    return t.kind = t.kind ?? wa.Undefined, t.kind === wa.Undefined && e.source !== pa.PriceEmployment && e.source !== pa.PriceCompany ? {
      msg: d.get("SALAXY.VALIDATION.Usecases.noKind"),
      type: "error"
    } : {
      type: "default",
      msg: void 0
    };
  }
  /**
   * Updates the IsHolidayAccrual
   * @param row Current row that is being edited.
   */
  updateIsHolidayAccrual(e) {
    e.data.isHolidayAccrual = e.data.isPaid;
  }
  /**
   * Returns true if the select component should be shown for absence isPaid.
   * @param row Current row that is being edited.
   */
  canSelectIsPaid(e) {
    if (!e.data.kind)
      return !1;
    const t = le.getSalaryPayableType(e.data.kind);
    return t === "defaultPaid" || t === "defaultUnpaid";
  }
  /**
   * Updates the IsPaid according to absence type.
   * @param row Current row that is being edited.
   * @param isKindChange Indicates if the change is due to kind change.
   */
  updateIsPaid(e, t = !1) {
    t && (e.data.isPaid = null);
    const n = le.getSalaryPayableType(e.data.kind);
    e.data.isPaid == null ? (e.data.isPaid = n == "paid" || n == "defaultPaid", this.updateIsHolidayAccrual(e)) : e.data.isPaid == !0 && n == "unpaid" ? (e.data.isPaid = !1, this.updateIsHolidayAccrual(e)) : e.data.isPaid == !1 && n == "paid" && (e.data.isPaid = !0, this.updateIsHolidayAccrual(e));
  }
  /**
   * Updates the workdays count
   * @param row Current row that is being edited.
   */
  updatePeriodDays(e) {
    e.period && (e.period.start && e.period.end && e.period.start > e.period.end && (e.period.end = e.period.start), e.period.start && e.period.end && (e.period.days ? (e.period.days = c.getWorkdays(e.period.start, e.period.end), e.period.daysCount = e.period.days.length) : e.period.daysCount = c.getWorkdays(e.period.start, e.period.end).length), e.count = e.period.daysCount || 0);
  }
  /**
   * Sets the days array in period to enable days selection UI.
   * @param row Current row that is being edited.
   */
  setDaysSelection(e) {
    e.period ?? (e.period = {}), e.period.days = c.getWorkdays(e.period?.start ?? "", e.period?.end ?? ""), e.period.daysCount = e.period.days.length, e.count = e.period.daysCount ?? 0;
  }
}
class po extends Q {
  /** Returns calculated taxable value. */
  get calculatedTaxable() {
    return this._calculatedTaxable;
  }
  /** Returns calculated taxfree value */
  get calculatedTaxfree() {
    return this._calculatedTaxfree;
  }
  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   * @param date The reference date for which the logic is done.
   * Typically the salary date of a calculation and the typically, the information needed is just the year for which the yearly changing numbers are fetched, but may later have more extended features.
   */
  updateUsecase(e, t) {
    e = e ?? this._row, this._row = e, t = t ?? this._date, this._date = t;
    const n = e.data ?? {};
    !n.kind || n.kind == Ge.NoDeduction || n.kind == Ge.Undefined ? (n.kind = Ge.NoDeduction, n.deduction = null) : n.deduction = (n.deduction ?? 0) < 0 ? null : n.deduction, n.taxable = (n.taxable ?? 0) < 0 ? null : n.taxable, n.kind == Ge.PeriodicalDeduction ? (n.periodDivider = n.periodDivider ?? 12, n.periodDivider = n.periodDivider < 0 ? 12 : n.periodDivider, n.periodDivider == 0 && (n.kind = Ge.SingleDeduction)) : n.periodDivider = null;
    const i = be.getYearlyChangingNumbers(t)?.sideCosts?.taxFreeBicycleBenefit ?? 0;
    let s = h.round((e.price ?? 0) * (e.count ?? 1), 2) ?? 0;
    s < 0 && (s = 0);
    let r = n.deduction ?? 0;
    r > s && (r = 0, n.deduction = null), n.taxable && n.taxable > s - r && (n.taxable = null);
    const l = h.round(Math.max(0, s - r - i), 2) ?? 0;
    n.taxable && n.taxable <= l && (n.taxable = null);
    const o = h.round(Math.max(0, s - r - (n.taxable ?? l)), 2);
    this._calculatedTaxable = n.taxable ?? l, this._calculatedTaxfree = o;
  }
  /**
   * Gets validation message for the usecase.
   * @param row Row to validate
   * @returns A message that is either an error or OK (default). Warnings, info etc. may later be supported.
   */
  getUcValidation(e) {
    const t = e?.data || {};
    let n;
    switch (t.kind) {
      case Ge.SingleDeduction:
        n = `${d.get("SALAXY.VALIDATION.Usecases.bicycleBenefit.singleDeduction")} ${h.formatPrice(t.deduction || 0)}`;
        break;
      case Ge.PeriodicalDeduction:
        n = `${d.get("SALAXY.VALIDATION.Usecases.bicycleBenefit.periodicalDeduction")} ${h.formatPrice(t.deduction || 0)} ${d.get("SALAXY.VALIDATION.Usecases.bicycleBenefit.periodicalDeduction2")} ${t.periodDivider || 12} ${d.get("SALAXY.VALIDATION.Usecases.bicycleBenefit.periodicalDeduction3")}`;
        break;
      case Ge.NoDeduction:
      default:
        n = "SALAXY.VALIDATION.Usecases.bicycleBenefit.noDeduction";
        break;
    }
    return { type: "default", msg: n };
  }
}
class ho extends Q {
  /** Gets validation message for BoardUsecaseLogic  */
  getUcValidation() {
  }
}
class yo extends Q {
  /** Gets validation message for BoardUsecaseLogic  */
  getUcValidation(e) {
    const t = e.data || {};
    return t.emissionsValue && t.emissionsValue < 0 || t.emissionsValue && t.emissionsValue > 100 ? {
      type: "error",
      msg: "SALAXY.VALIDATION.Usecases.carBenefit.invalidEmissionValues"
    } : !t.kind || !t.ageGroup || t.isKilometersBased && t.kilometers == null ? {
      type: "error",
      msg: "SALAXY.VALIDATION.Usecases.carBenefit.default"
    } : { type: "default", msg: H.getEnumLabel("CarBenefitCode", t.kind) + ", " + H.getEnumLabel("AgeGroupCode", t.ageGroup) + (t.isKilometersBased ? `${d.get("SALAXY.VALIDATION.Usecases.carBenefit.kilometerBased")} ${t.kilometers || ""}km` : "") + (t.deduction ? `. ${d.get("SALAXY.VALIDATION.Usecases.carBenefit.deduction")} ${h.formatPrice(t.deduction)}.` : d.get("SALAXY.VALIDATION.Usecases.carBenefit.noDeduction")) };
  }
}
class vo extends Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   * @param date The reference date for which the logic is done.
   * Typically the salary date of a calculation and the typically, the information needed is just the year for which the yearly changing numbers are fetched, but may later have more extended features.
   */
  updateUsecase(e, t) {
    const n = e.data ?? {};
    switch (n.kind) {
      case Ue.FullDailyAllowance:
        e.price = be.getYearlyChangingNumbers(t)?.sideCosts?.taxFreeDailyAllowance;
        break;
      case Ue.PartialDailyAllowance:
        e.price = be.getYearlyChangingNumbers(t)?.sideCosts?.taxFreeDailyHalfAllowance;
        break;
      case Ue.MealAllowance:
        e.price = be.getYearlyChangingNumbers(t)?.sideCosts?.taxFreeMealAllowance;
        break;
      case Ue.InternationalDailyAllowance:
        if (n.country) {
          const i = be.getYearlyTaxFreeNumbers(t).countries[n.country];
          i && (e.price = i);
        }
        break;
      case Ue.Undefined:
    }
    e.price && n.isHalf && (e.price = h.round(e.price / 2));
  }
  /** Gets validation message for Daily allowance  */
  getUcValidation(e) {
    const t = e.data || {};
    let n;
    switch (t.kind) {
      case Ue.PartialDailyAllowance:
      case Ue.MealAllowance:
        n = H.getEnumLabel("DailyAllowanceKind", t.kind);
        break;
      case Ue.InternationalDailyAllowance: {
        n = H.getEnumLabel("DailyAllowanceKind", t.kind);
        const i = be.getYearlyTaxFreeNumbers("today");
        (t.country && i?.countries ? i.countries[t.country] : !1) && (n = n + ` (${d.get(`SALAXY.CORE.yearlyTaxfreeYears.countries.${t.country}`)})`);
        break;
      }
      case Ue.Undefined:
      default:
        n = "SALAXY.VALIDATION.Usecases.dailyAllowance";
        break;
    }
    return { type: "default", msg: n };
  }
}
class fo extends Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   */
  updateUsecase() {
  }
  /** Always returns null */
  getUcValidation() {
  }
}
class go extends Q {
  /** Gets validation message for IrIncomeTypeUsecase  */
  getUcValidation(e) {
    const t = e.data || {};
    if (!this.getCodeData(t.kind))
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.noIrIncomeType"
      };
  }
  getCodeData(e) {
    if (e) {
      let t = 0;
      switch (e) {
        case ca.NoticePeriodCompensation:
          t = 208;
          break;
        case ca.MonetaryWorkingTimeBankCompensation:
          t = 224;
          break;
        case ca.TerminationAndLayOffDamages:
          t = 229;
          break;
        case ca.VoluntaryTerminationCompensation:
          t = 231;
          break;
        case ca.PensionPaidByEmployer:
          t = 338;
          break;
        case ca.Undefined:
        default:
          t = 0;
          break;
      }
      return Fe.getAll().find((n) => n.code === t);
    }
  }
  isIrIncomeTypeLabel(e) {
    return Fe.getAll().some((t) => t.label === e);
  }
}
class _t extends Q {
  constructor() {
    super(...arguments), this.multipleRatesEditField = "gross", this.taxRates = {
      tax0: 0,
      tax10: 0.1,
      tax14: 0.14,
      tax24: 0.24,
      tax255: 0.255,
      none: 0,
      other: void 0
    };
  }
  /** Returns true if the row has gross vatEntries */
  get hasGrossVatEntries() {
    return this._hasGrossVatEntries ?? !1;
  }
  /**
   * Updates the usecase values based on user input without going to the server.
   */
  updateUsecase(e, t) {
    e = e ?? this._row, this._row = e, t = t ?? this._date, this._date = t;
    const n = e.data.vatRate;
    if (n == ke.Other ? (e.accounting?.vatPercent == null && (e.accounting ?? (e.accounting = {}), e.accounting.vatPercent = be.getYearlyChangingNumbers(t ?? c.getToday())?.sideCosts?.palkkausVatPercent), this.taxRates.other = e.accounting.vatPercent) : (e.accounting ?? (e.accounting = {}), e.accounting.vatPercent = void 0, this.taxRates.other = void 0), this.taxRates[n] != null)
      e.accounting.vatEntries = [this.getRow(e.count && e.price ? e.count * e.price : void 0, n)], e.data.total = void 0;
    else if (n == ke.Multiple) {
      if (!e.accounting.vatEntries)
        e.accounting.vatEntries = this.getEmptyVatEntries();
      else {
        const r = this.getEmptyVatEntries();
        e.accounting.vatEntries.forEach((l) => {
          switch (l.vatRate) {
            case de.Vat2400:
              r[0] = l;
              break;
            case de.Vat1400:
              r[1] = l;
              break;
            case de.Vat1000:
              r[2] = l;
              break;
            case de.Vat0000:
              r[3] = l;
              break;
            case de.Vat2550:
              r[4] = l;
              break;
          }
        }), e.accounting ?? (e.accounting = {}), e.accounting.vatEntries = r;
      }
      const s = {
        gross: 0,
        net: 0,
        tax: 0,
        taxPercent: 0,
        vatRate: de.Undefined
      };
      e.accounting?.vatEntries?.forEach((r) => {
        switch (this.multipleRatesEditField) {
          case "net":
            s.net += r.net = (r.net ? h.round(r.net) : void 0) ?? 0, s.tax += (r.tax = r.net && r.taxPercent ? h.round(r.net * r.taxPercent) : void 0) ?? 0, s.gross += r.gross = r.net ?? 0 + (r.tax ?? 0);
            break;
          case "tax":
            s.tax += r.tax = (r.tax ? h.round(r.tax) : void 0) ?? 0, s.net += r.net = h.round((r.tax ?? 0) / (r.taxPercent ?? 0)) ?? 0, s.gross += r.gross = r.net + r.tax;
            break;
          case "gross":
          default:
            s.gross += r.gross = h.round(r.gross ?? 0) ?? 0, s.net += r.net = h.round(r.gross / (1 + (r.taxPercent ?? 0))) ?? 0, s.tax += r.tax = (r.gross ?? 0) - (r.net ?? 0);
            break;
        }
      }), s.taxPercent = h.round((s.tax ?? 0) / (s.net ?? 0)), e.data.total = s;
    }
    e.data.vatRate === ke.Multiple && (this._hasGrossVatEntries = !!e.accounting.vatEntries?.find((s) => s.gross));
  }
  getEmptyVatEntries() {
    return [
      this.getRow(void 0, ke.Tax24),
      this.getRow(void 0, ke.Tax14),
      this.getRow(void 0, ke.Tax10),
      this.getRow(void 0, ke.Tax0),
      this.getRow(void 0, ke.Tax255)
    ];
  }
  getRow(e, t) {
    e && (e = h.round(e));
    const n = this.taxRates[t] || 0, i = e ? h.round(e / (1 + n)) : void 0, s = {
      tax0: de.Vat0000,
      tax10: de.Vat1000,
      tax14: de.Vat1400,
      tax24: de.Vat2400,
      tax255: de.Vat2550,
      none: de.None,
      other: de.Other
    };
    return {
      gross: e,
      tax: e && i ? h.round(e - i) : void 0,
      net: i,
      taxPercent: n,
      vatRate: s[t] ?? de.None
    };
  }
  /** Gets validation message for BoardUsecaseLogic  */
  getUcValidation(e) {
    let t = "SALAXY.VALIDATION.Usecases.expensesValidation.noVat";
    switch (e.data.vatRate) {
      case ke.Tax0:
        t = "SALAXY.VALIDATION.Usecases.expensesValidation.vat0";
        break;
      case ke.Tax10:
        t = "SALAXY.VALIDATION.Usecases.expensesValidation.vat10";
        break;
      case ke.Tax14:
        t = "SALAXY.VALIDATION.Usecases.expensesValidation.vat14";
        break;
      case ke.Tax24:
        t = "SALAXY.VALIDATION.Usecases.expensesValidation.vat24";
        break;
      case ke.Tax255:
        t = "SALAXY.VALIDATION.Usecases.expensesValidation.vat255";
        break;
      case ke.Multiple:
        t = H.getEnumLabel("ExpensesVatRate", ke.Multiple);
        break;
      case ke.Other:
        t = d.get("SALAXY.VALIDATION.Usecases.expensesValidation.vatCustom") + 100 * (e.accounting?.vatPercent ?? 0) + " %";
        break;
    }
    return { type: "default", msg: t };
  }
}
class bo extends Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   * @param date The reference date for which the logic is done.
   * Typically the salary date of a calculation and the typically, the information needed is just the year for which the yearly changing numbers are fetched, but may later have more extended features.
   * @param calcData The calculation related data that is required byt the more complex calculations:
   * This data is available only after first round-trip to the server (results object exists).
   */
  updateUsecase(e, t, n) {
    const i = e.data ?? {};
    if ((!i.kind || i.kind === aa.Undefined) && (i.kind = aa.Fixed), i.kind !== aa.Periodic && i.kind !== aa.NonPeriodic)
      return;
    const s = n?.foreclosureSalary || 0;
    if (!i.protectedPortionBase) {
      const u = be.getYearlyChangingNumbers(t);
      i.protectedPortionBase = u?.sideCosts?.protectedPortionBase, i.protectedPortionDependant = u?.sideCosts?.protectedPortionDependant;
    }
    let r = h.round(i.incomeFromOtherSources || 0, 2), l = h.round(i.additionalAmountLeftToDebtor || 0, 2), o = 0;
    if (s > 0)
      if (i.kind === aa.NonPeriodic)
        o = s / 3;
      else {
        i.periodLength = this.calculatePeriodLength(n?.period.start, n?.period.end), r = h.round(i.periodLength * ((r ?? 0) / 30), 2), l = h.round(i.periodLength * ((l ?? 0) / 30), 2) ?? 0;
        const u = h.round(
          (i.periodLength || 0) * ((i.protectedPortionBase || 0) + (i.dependantsCount || 0) * (i.protectedPortionDependant || 0)),
          2
        ) ?? 0, m = s + (r ?? 0);
        u > m ? o = 0 : m <= u * 2 ? o = 2 * (m - u) / 3 : m <= u * 4 ? o = m / 3 : (o = u * 4 / 3 + 4 * (m - u * 4) / 5, o = Math.min(o, m / 2)), o = Math.max(0, Math.min(o, s) - l);
      }
    e.count = 1, e.price = h.round(o, 2);
  }
  /** Gets validation message for UnionPaymentUsecase  */
  getUcValidation(e) {
    const t = e.data || {};
    if (t.kind === aa.NonPeriodic || t.kind === aa.Periodic)
      return {
        type: "default",
        msg: "SALAXY.VALIDATION.Usecases.foreclosure.default"
      };
    if (!e.price)
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.foreclosure.noPrice"
      };
  }
  calculatePeriodLength(e, t) {
    return e != null && t != null ? this.isOnceAMonthPeriod(e, t) ? 30 : this.isEvery2WeeksPeriod(e, t) ? 14 : this.isTwiceAMonthPeriod(e, t) ? 15 : Math.max(0, this.getDays(e, t)) : 30;
  }
  isOnceAMonthPeriod(e, t) {
    return t === c.add(c.add(e, 1, "month") ?? "", -1, "day");
  }
  isTwiceAMonthPeriod(e, t) {
    return c.getDuration(e, t).asDays() + 1 === 15 || c.getDay(e) === 15 && t === c.startEnd(e, "end-month") || c.getDay(e) === 16 && t === c.startEnd(e, "end-month");
  }
  isEvery2WeeksPeriod(e, t) {
    return t === c.add(c.add(e, 2, "week") ?? "", -1, "day");
  }
  getDays(e, t) {
    return c.getDuration(e, t).asDays() + 1;
  }
}
class jo extends Q {
  getUcValidation(e) {
  }
  /**
   * Updates the workdays count
   * @param row Current row that is being edited.
   */
  updatePeriodDays(e) {
    e.period && (e.period.start > e.period.end && (e.period.end = e.period.start), e.period.start && e.period.end && (e.period.days ? (e.period.days = c.getWorkdays(e.period.start, e.period.end), e.period.daysCount = e.period.days.length) : e.period.daysCount = c.getWorkdays(e.period.start, e.period.end).length));
  }
  /**
   * Sets the days array in period to enable days selection UI.
   * @param row Current row that is being edited.
   */
  setDaysSelection(e) {
    e.period.days = c.getVacationDays(e.period.start, e.period.end), e.period.daysCount = e.period.days.length;
  }
}
class So extends Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   */
  updateUsecase(e) {
    const t = e.data ?? {};
    (!t.compensationRows || t.compensationRows.length < 1) && (t.compensationRows = [{}]), this.harmonize(e);
    for (const n of t.compensationRows)
      switch (t.pricing) {
        case ta.Percent:
          n.price = h.round((n.percent ?? 0) * (e.price ?? 0), 10);
          break;
        case ta.Fixed:
          break;
      }
  }
  /** Gets validation message */
  getUcValidation(e) {
    const t = e.data || {};
    if (!t.compensationRows || t.compensationRows.length < 1)
      return;
    if (this.harmonize(e), !this.getCodeData(t.kind))
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.compensation.noCompensationData"
      };
    const i = [];
    for (const s of t.compensationRows) {
      const r = t.pricing === ta.Percent ? `${d.get("SALAXY.VALIDATION.Usecases.compensation.compensation")} ${h.formatPercent((s.percent ?? 0) * 100)}, ${h.formatPrice(s.price)} ${d.get("SALAXY.VALIDATION.Usecases.compensation.compensation2")} ${h.formatPrice(h.round((s.count ?? e.count ?? 1) * (s.price ?? 0), 2))}` : `${d.get("SALAXY.VALIDATION.Usecases.compensation.compensation")} ${h.formatPrice(s.price)} ${h.formatPrice(s.price)} ${d.get("SALAXY.VALIDATION.Usecases.compensation.compensation2")} ${h.formatPrice(h.round((s.count ?? e.count ?? 1) * (s.price ?? 0), 2))}`;
      i.push(r);
    }
    return { type: "default", msg: i.join(`
`) };
  }
  getCodeData(e) {
    if (e) {
      let t;
      switch (e) {
        case X.EmergencyWorkCompensation:
          t = 205;
          break;
        case X.EveningWorkCompensation:
          t = 206;
          break;
        case X.EveningShiftAllowance:
          t = 207;
          break;
        case X.SaturdayPay:
          t = 211;
          break;
        case X.ExtraWorkPremium:
          t = 212;
          break;
        case X.OtherCompensation:
          t = 216;
          break;
        case X.WaitingTimeCompensation:
          t = 217;
          break;
        case X.SundayWorkCompensation:
          t = 221;
          break;
        case X.StandByCompensation:
          t = 230;
          break;
        case X.WeeklyRestCompensation:
          t = 232;
          break;
        case X.OvertimeCompensation:
          t = 235;
          break;
        case X.NightWorkAllowance:
          t = 236;
          break;
        case X.NightShiftCompensation:
          t = 237;
          break;
        case X.Undefined:
        default:
          t = 0;
          break;
      }
      return Fe.getAll().find((n) => n.code === t);
    }
  }
  harmonize(e) {
    const t = e?.data || {};
    for (const n of t.compensationRows ?? [])
      (t.pricing == null || t.pricing == ta.Undefined) && (!n.unit || n.unit == G.Undefined || n.unit == G.Percent ? (t.pricing = ta.Percent, n.percent = n.count, n.count = null) : (t.pricing = ta.Fixed, n.percent = null, n.count = null));
  }
}
class To extends Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   */
  updateUsecase(e) {
    const t = e.data ?? {}, n = this.getCodeDataByNumber(t?.irData?.code) ?? this.getCodeDataByTransaction(t?.kind);
    n && (t.irData = t.irData ?? {}, t.irData.code = n.code, t.kind = n.transactionCode);
  }
  /** Gets validation message for IrIncomeTypeUsecase  */
  getUcValidation(e) {
    const t = e.data ?? {}, n = this.getCodeDataByNumber(t?.irData?.code) ?? this.getCodeDataByTransaction(t?.kind);
    if (!n)
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.noIrIncomeType"
      };
    if (n.transactionCode === Ya.CarBenefit) {
      const i = t.irData?.carBenefit || {};
      if (i.emissionsValue && i.emissionsValue < 0 || i.emissionsValue && i.emissionsValue > 100)
        return {
          type: "error",
          msg: "SALAXY.VALIDATION.Usecases.carBenefit.invalidEmissionValues"
        };
      if (!i.ageGroup || i.kilometers == null)
        return {
          type: "error",
          msg: "SALAXY.VALIDATION.Usecases.carBenefit.default"
        };
    }
  }
  getCodeDataByNumber(e) {
    if (e)
      return Fe.getAll().find((t) => t.code === e);
  }
  getCodeDataByTransaction(e) {
    if (!(!e || e === Ya.Unknown || e === "undefined"))
      return Fe.getAll().find((t) => t.transactionCode === e);
  }
  isIrIncomeTypeLabel(e) {
    return Fe.getAll().some((t) => t.label === e);
  }
}
class xo extends Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   * @param date The reference date for which the logic is done.
   * Typically the salary date of a calculation and the typically, the information needed is just the year for which the yearly changing numbers are fetched, but may later have more extended features.
   */
  updateUsecase(e, t) {
    this.setValues(e.data?.kind, e, t);
  }
  /** Gets validation message for MealBenefitUsecase  */
  getUcValidation(e) {
    switch (e.data = e.data ?? {}, e.data.isTaxValue = e.data.isTaxValue ?? !1, e.data.isTaxValueDeductionDone = e.data.isTaxValueDeductionDone ?? !1, e.data.kind) {
      case oe.MealAllowance:
        return {
          type: "default",
          msg: `${H.getEnumLabel("MealBenefitKind", e.data.kind)}, ${d.get("SALAXY.VALIDATION.Usecases.mealBenefit.allowance")} ${h.formatPrice((e.price ?? 0) * (e.count ?? 1))}.`
        };
      case oe.CateringContract:
      case oe.Institute:
      case oe.MealTicket:
      case oe.RestaurantWorker:
      case oe.Teacher:
      case oe.TaxableAmount:
      case oe.CollectedReimbursement:
        return e.data.isTaxValue ? {
          type: "default",
          msg: `${H.getEnumLabel("MealBenefitKind", e.data.kind)}, ${d.get("SALAXY.VALIDATION.Usecases.mealBenefit.default")} ${h.formatPrice((e.data.taxablePrice ?? 0) * (e.count ?? 1))}, ${d.get("SALAXY.VALIDATION.Usecases.mealBenefit.taxValueDeduction")}.`
        } : {
          type: "default",
          msg: `${H.getEnumLabel("MealBenefitKind", e.data.kind)}, ${d.get("SALAXY.VALIDATION.Usecases.mealBenefit.default")} ${h.formatPrice((e.data.taxablePrice ?? 0) * (e.count ?? 1))}${e.data.deduction ? ", " + d.get("SALAXY.VALIDATION.Usecases.mealBenefit.deduction") + " " + h.formatPrice(e.data.deduction) + "." : ""}`
        };
      case oe.Undefined:
      default:
        return e.data && (e.data.taxablePrice = e.price), {
          type: "error",
          msg: "SALAXY.VALIDATION.Usecases.mealBenefit.undefined"
        };
    }
  }
  setValues(e, t, n) {
    const i = be.getYearlyChangingNumbers(n)?.sideCosts;
    if (!i)
      throw new Error("No side costs found");
    t.data = t.data ?? {};
    const s = t.data;
    switch (e) {
      case oe.MealAllowance:
        t.price = Math.min(t.price ?? 0, i.taxFreeMealAllowance ?? 0), s.taxablePrice = t.price, s.deduction = null, s.isTaxValue = !1, s.isTaxValueDeductionDone = !1;
        break;
      case oe.CateringContract:
        t.price = i.mealBenefitCateringContract, s.taxablePrice = t.price;
        break;
      case oe.Institute:
        t.price = i.mealBenefitInstitute, s.taxablePrice = t.price;
        break;
      case oe.MealTicket:
        t.price ? t.price < (i.mealTicketLowerLimit ?? 0) ? t.price = i.mealTicketLowerLimit : t.price > (i.mealTicketUpperLimit ?? 0) && (t.price = i.mealTicketUpperLimit) : t.price = 0, s.taxablePrice = (i.mealTicketTaxable ?? 0) * (t.price ?? 0);
        break;
      case oe.RestaurantWorker:
        t.price = i.mealBenefitRestaurantWorker, s.taxablePrice = t.price;
        break;
      case oe.Teacher:
        t.price = i.mealBenefitTeacher, s.taxablePrice = t.price;
        break;
      case oe.CollectedReimbursement:
        s.isTaxValueDeductionDone = !1, s.isTaxValue = !0, s.deduction = null, s.taxablePrice = t.price;
        break;
      case oe.TaxableAmount:
      case oe.Undefined:
      default:
        s.taxablePrice = t.price;
    }
    e != oe.MealAllowance && s.isTaxValue && (s.deduction = null), s.isTaxValue = s.isTaxValue ?? !1, s.isTaxValueDeductionDone = s.isTaxValueDeductionDone ?? !1;
  }
}
class Eo extends Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   */
  updateUsecase(e, t) {
    const n = (s) => h.round(s / 100), i = this.getMilage(t);
    if (e.data.additionsAllowed = !1, e.data.passengersAllowed = !1, e.data.vehicleType != "custom")
      if (e.data.vehicleType == "carLimitedBenefit")
        e.price = n(i.carLimitedBenefit);
      else {
        const s = i.other[e.data.vehicleType || "nothing"];
        s ? (e.price = n(s), e.data.passengersAllowed = !0) : e.data.vehicleType === "car" || e.price === n(i.car) || !e.price ? (e.data.vehicleType = "car", e.price = n(i.car), e.data.additionsAllowed = !0, e.data.passengersAllowed = !0) : e.data.vehicleType = "custom";
      }
    e.data.passengersAllowed && (e.price ?? (e.price = 0), e.price += n((e.data.passengerCount || 0) * i.passanger) ?? 0), e.data.additionsAllowed && Be.assureArray(e.data.additions || []).forEach((s) => {
      e.price ?? (e.price = 0), e.price += n(i.carAdditions[s] || 0) ?? 0;
    }), e.price = h.round(e.price);
  }
  /** Gets validation message for BoardUsecaseLogic  */
  getUcValidation() {
  }
  /**
   * Gets the vehicle type selection.
   * @param date Date for which the selection is fetched (default: today). The prices changes yearly an also the selection may change.
   */
  getVehicleTypeSelection(e = "today") {
    const t = this.getMilage(e), n = (s) => h.round(s / 100), i = [{
      value: "car",
      text: `${d.get("SALAXY.CORE.yearlyTaxfreeYears.milage.car")} (${n(t.car)}€)`
    }, {
      value: "carLimitedBenefit",
      text: `${d.get("SALAXY.CORE.yearlyTaxfreeYears.milage.carLimitedBenefit")} (${n(t.carLimitedBenefit)}€)`
    }];
    return Object.entries(t.other).forEach(
      (s) => i.push({
        value: s[0],
        text: `${d.get(`SALAXY.CORE.yearlyTaxfreeYears.milage.other.${s[0]}`)} (${n(s[1])}€)`
      })
    ), i.push({
      value: "custom",
      text: `${d.get("SALAXY.CORE.yearlyTaxfreeYears.milage.custom")}`
    }), i;
  }
  /**
   * Gets the vehicle type selection.
   * @param date Date for which the selection is fetched (default: today). The prices changes yearly an also the selection may change.
   */
  getAdditionsSelection(e = "today") {
    const t = this.getMilage(e), n = (i) => h.round(i / 100);
    return Object.entries(t.carAdditions).map((i) => ({
      value: i[0],
      text: `${d.get(`SALAXY.CORE.yearlyTaxfreeYears.milage.carAdditions.${i[0]}`)} (${n(i[1])}€)`
    }));
  }
  getMilage(e) {
    const t = c.getYear(e), n = Da.find((i) => i.year == t)?.milage;
    if (!n)
      throw new Error(`No yearlyTaxFreeYears year for date ${e}`);
    return n;
  }
}
class Ao extends Q {
  /** Gets validation message for BoardUsecaseLogic  */
  getUcValidation(e) {
    const t = e.data || {};
    return t.kind ? { type: "default", msg: `${d.get("SALAXY.VALIDATION.Usecases.nonProfitOrg.default")} ${H.getEnumLabel("NonProfitOrgKind", t.kind)}` } : {
      type: "error",
      msg: "SALAXY.VALIDATION.Usecases.nonProfitOrg.noKind"
    };
  }
}
class Po extends Q {
  /** Gets validation message  */
  getUcValidation(e) {
    const t = e.data || {};
    if (!this.getCodeData(t.kind))
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.noIrIncomeType"
      };
  }
  getCodeData(e) {
    if (e) {
      let t = 0;
      switch (e) {
        case ie.MeetingFee:
          t = 210;
          break;
        case ie.LectureFee:
          t = 214;
          break;
        case ie.PositionOfTrustCompensation:
          t = 215;
          break;
        case ie.AccruedTimeOffCompensation:
          t = 225;
          break;
        case ie.MembershipOfGoverningBodyCompensation:
          t = 308;
          break;
        case ie.MonetaryGiftForEmployees:
          t = 310;
          break;
        case ie.UseCompensationAsEarnedIncome:
          t = 313;
          break;
        case ie.UseCompensationAsCapitalIncome:
          t = 314;
          break;
        case ie.OtherTaxableIncomeAsEarnedIncome:
          t = 316;
          break;
        case ie.StockOptionsAndGrants:
          t = 320;
          break;
        case ie.EmployeeInventionCompensation:
          t = 326;
          break;
        case ie.CapitalIncomePayment:
          t = 332;
          break;
        case ie.WorkEffortBasedDividendsAsWage:
          t = 339;
          break;
        case ie.WorkEffortBasedDividendsAsNonWage:
          t = 340;
          break;
        case ie.EmployeeStockOption:
          t = 343;
          break;
        case ie.EmployeeStockOptionWithLowerPrice:
          t = 361;
          break;
        case ie.CopyrightRoyaltiesEarnedIncome:
          t = 366;
          break;
        case ie.StockGrantPaidInMoney:
          t = 367;
          break;
        case ie.EmployeeStockOptionPaidInMoney:
          t = 368;
          break;
        case ie.Undefined:
        default:
          t = 0;
          break;
      }
      return Fe.getAll().find((n) => n.code === t);
    }
  }
  isIrIncomeTypeLabel(e) {
    return Fe.getAll().some((t) => t.label === e);
  }
}
class wo extends Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   * param row Row to update.
   */
  updateUsecase() {
  }
  /** Gets validation message for IrIncomeTypeUsecase  */
  getUcValidation(e) {
    if (!(e.data || {}).kind)
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.noKind"
      };
  }
}
class Fo extends Q {
  /** Gets validation message for IrIncomeTypeUsecase  */
  getUcValidation(e) {
    const t = e.data || {};
    if (!this.getCodeData(t.kind))
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.noIrIncomeType"
      };
  }
  getCodeData(e) {
    if (e) {
      let t = 0;
      switch (e) {
        case ea.InitiativeFee:
          t = 202;
          break;
        case ea.BonusPay:
          t = 203;
          break;
        case ea.Commission:
          t = 220;
          break;
        case ea.PerformanceBonus:
          t = 223;
          break;
        case ea.ShareIssueForEmployees:
          t = 226;
          break;
        case ea.ProfitSharingBonus:
          t = 233;
          break;
        case ea.Undefined:
        default:
          t = 0;
          break;
      }
      return Fe.getAll().find((n) => n.code === t);
    }
  }
}
class Do extends Q {
  /** Returns calculated taxable value. */
  get calculatedTaxable() {
    return this._calculatedTaxable;
  }
  /** Returns calculated taxfree value */
  get calculatedTaxfree() {
    return this._calculatedTaxfree;
  }
  /** Returns true if the date for calculation is before 2021. */
  get isBefore2021() {
    return this._isBefore2021 ?? !1;
  }
  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   * @param date The reference date for which the logic is done.
   * Typically the salary date of a calculation and the typically, the information needed is just the year for which the yearly changing numbers are fetched, but may later have more extended features.
   */
  updateUsecase(e, t) {
    e = e ?? this._row, this._row = e, t = t ?? this._date, this._date = t;
    const n = e.data ?? {};
    if (!n.kind || n.kind == Je.NoDeduction || n.kind == Je.Undefined ? (n.kind = Je.NoDeduction, n.deduction = null) : n.deduction = n.deduction && n.deduction < 0 ? null : n.deduction, n.taxable = n.taxable && n.taxable < 0 ? null : n.taxable, n.kind == Je.PeriodicalDeduction ? (n.periodDivider = n.periodDivider ?? 12, n.periodDivider = n.periodDivider < 0 ? 12 : n.periodDivider, n.periodDivider == 0 && (n.kind = Je.SingleDeduction)) : n.periodDivider = null, c.isSameOrBefore(t, "2021-01-01")) {
      n.taxable = null, this._isBefore2021 = !0;
      return;
    }
    this._isBefore2021 = !1;
    const i = be.getYearlyChangingNumbers(t)?.sideCosts?.taxFreeSubsidisedCommute ?? 0;
    let s = h.round((e.price ?? 0) * (e.count ?? 1), 2) ?? 0;
    s < 0 && (s = 0);
    let r = n.deduction ?? 0;
    r > s && (r = 0, n.deduction = null), n.taxable && n.taxable > s - r && (n.taxable = null);
    const l = h.round(Math.max(0, s - r - i), 2) ?? 0;
    n.taxable && n.taxable <= l && (n.taxable = null);
    const o = h.round(Math.max(0, s - r - (n.taxable ?? l)), 2) ?? 0;
    this._calculatedTaxable = n.taxable ?? l, this._calculatedTaxfree = o;
  }
  /**
   * Gets validation message for the usecase.
   * @param row Row to validate
   * @returns A message that is either an error or OK (default). Warnings, info etc. may later be supported.
   */
  getUcValidation(e) {
    const t = e?.data || {};
    let n;
    switch (t.kind) {
      case Je.SingleDeduction:
        n = `${d.get("SALAXY.VALIDATION.Usecases.subsidisedCommute.singleDeduction")} ${h.formatPrice(t.deduction || 0)}`;
        break;
      case Je.PeriodicalDeduction:
        n = `${d.get("SALAXY.VALIDATION.Usecases.subsidisedCommute.periodicalDeduction")} ${h.formatPrice(t.deduction || 0)} ${d.get("SALAXY.VALIDATION.Usecases.subsidisedCommute.periodicalDeduction2")} ${t.periodDivider || 12} ${d.get("SALAXY.VALIDATION.Usecases.subsidisedCommute.periodicalDeduction3")}`;
        break;
      case Je.NoDeduction:
      default:
        n = "SALAXY.VALIDATION.Usecases.subsidisedCommute.noDeduction";
        break;
    }
    return { type: "default", msg: n };
  }
}
class Co extends Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   * @param _date The reference date for which the logic is done.
   * Typically the salary date of a calculation and the typically, the information needed is just the year for which the yearly changing numbers are fetched, but may later have more extended features.
   * @param _calcData The calculation related data that is required by the more complex calculations:
   * This data is available only after first round-trip to the server (results object exists) and not all user interfaces may provide this.
   */
  updateUsecase(e, t, n) {
    const i = e.data || {};
    switch (i.kind) {
      case Oe.DailyDeduction:
      case Oe.MonthlyDeduction:
        i.deduction = (i.deductionPrice ?? 0) * (i.deductionCount ?? 0), e.price = (i.totalTaxable ?? 0) - i.deduction, e.count = i?.employmentData?.percent ?? 0, i.taxValue = e.price * e.count;
        break;
      case Oe.FixedValues:
        e.price = i.taxValue, e.count = 1;
        break;
      case Oe.Undefined:
      case Oe.NoDeduction:
        i.deduction = 0, e.price = i.totalTaxable, e.count = i.employmentData?.percent ?? 0, i.taxValue = (e.price ?? 0) * e.count;
        break;
    }
  }
  /** Gets validation message*/
  getUcValidation(e) {
    const t = e.data || {};
    let n = "-";
    switch (t.kind) {
      case Oe.DailyDeduction:
      case Oe.MonthlyDeduction:
        n = `(${h.formatPrice(e.data?.totalTaxable)} - ${h.formatPrice(e.data?.deduction)} = ${h.formatPrice(e.price)}) * ${h.formatPercent((e.count ?? 0) * 100, void 0)} = ${h.formatPrice(e.data?.taxValue)}`;
        break;
      case Oe.FixedValues:
        n = `Tulot: ${h.formatPrice(e.data?.totalTaxable)} - ${h.formatPrice(e.data?.deduction)} = ${h.formatPrice(e.data?.totalTaxable - e.data?.deduction)}, Lähdevero: ${h.formatPrice(e.data?.taxValue)}`;
        break;
      case Oe.Undefined:
      case Oe.NoDeduction:
        n = `(${h.formatPrice(e.data?.totalTaxable)} - ${h.formatPrice(e.data?.deduction)}) * ${h.formatPercent((e.count ?? 0) * 100, void 0)} = ${h.formatPrice(e.data?.taxValue)}`;
        break;
    }
    return {
      msg: n,
      // TODO: Added validation errors
      type: "default"
    };
  }
}
class Io extends Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   * @param _date The reference date for which the logic is done.
   * Typically the salary date of a calculation and the typically, the information needed is just the year for which the yearly changing numbers are fetched, but may later have more extended features.
   * @param calcData The calculation related data that is required by the more complex calculations:
   * This data is available only after first round-trip to the server (results object exists) and not all user interfaces may provide this.
   */
  updateUsecase(e, t, n) {
    const i = e.data ?? {};
    switch (i.kind = i.kind || Qe.Percentage, i.kind === Qe.Undefined && (i.kind = Qe.Percentage), i.kind) {
      case Qe.FixedValue:
        e.price = i.taxValue, e.count = 1;
        break;
      case Qe.Percentage:
        e.price = n.totalTaxable, e.count = i.taxValue && i.taxValue >= 0 && i.taxValue <= 1 ? i.taxValue : 0;
        break;
    }
  }
  /** Gets validation message*/
  getUcValidation(e) {
    const t = e.data || {};
    let n = "-";
    switch (t.kind) {
      case Qe.Percentage:
        n = `${h.formatPercent(100 * e.data?.taxValue, 1)}`;
        break;
      case Qe.FixedValue:
        n = `${h.formatPrice(e.data?.taxValue)}`;
        break;
    }
    return {
      msg: n,
      type: "default"
    };
  }
}
class Lo extends Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   */
  updateUsecase(e) {
    const t = e.data || {};
    (!t.kind || t.kind === ga.Undefined) && (t.kind = ga.TotalWorkerPayment), t.rowType || (t.rowType = k.Salary);
  }
  /** Gets validation message for BoardUsecaseLogic  */
  getUcValidation(e) {
    const t = e.data || {};
    return (!t.kind || t.kind === ga.Undefined) && (t.kind = ga.TotalWorkerPayment), t.rowType || (t.rowType = k.Salary), {
      type: "default",
      msg: `${H.getEnumLabel("CalculationRowType", t.rowType)} ${d.get("SALAXY.VALIDATION.Usecases.totalWorkerPayment.default")} ${h.formatPrice(e.price)} ${d.get("SALAXY.VALIDATION.Usecases.totalWorkerPayment.default2")} ${H.getEnumLabel("TotalWorkerPaymentKind", t.kind)}.`
    };
  }
}
class Mo extends Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   * param row Row to update.
   */
  updateUsecase() {
  }
  /** Gets validation message for IrIncomeTypeUsecase  */
  getUcValidation(e) {
    if (!(e.data || {}).kind)
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.noKind"
      };
  }
}
class No extends Q {
  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   * @param date The reference date for which the logic is done.
   * Typically the salary date of a calculation and the typically, the information needed is just the year for which the yearly changing numbers are fetched, but may later have more extended features.
   * @param calcData The calculation related data that is required by the more complex calculations:
   * This data is available only after first round-trip to the server (results object exists).
   */
  updateUsecase(e, t, n) {
    const i = e.data ?? {};
    i.kind = i.kind || re.Percentage, (!i.kind || i.kind === re.Undefined) && (i.kind = re.Percentage), i.kind === re.Other && (i.isFixedSum ? (i.kind = re.Fixed, e.price = (e.price ?? 0) * (e.count ?? 1), e.count = 1) : i.kind = re.Percentage);
    const s = be.getYearlyChangingNumbers(t), r = "FI6115553000120981", l = "Rakennusliitto", o = n?.totalTaxable ?? 0;
    switch (i.kind) {
      case re.Fixed:
        e.count = 1, e.price === o && (e.price = 0);
        break;
      case re.Percentage:
        (!e.count || e.count >= 1) && (e.count = 0), e.price = o;
        break;
      case re.PercentageAndLimits:
        if (i.paymentPercentage && i.paymentPercentage >= 1)
          i.paymentPercentage = 0, e.count = 0, e.price = o;
        else {
          const u = (i.paymentPercentage ?? 0) * (o ?? 0);
          i.minimumPayment && u < i.minimumPayment ? (e.count = 1, e.price = i.minimumPayment) : i.maximumPayment && u > i.maximumPayment ? (e.count = 1, e.price = i.maximumPayment) : (e.count = i.paymentPercentage, e.price = o);
        }
        break;
      case re.RaksaNormal:
        i.iban = r, i.recipientFullName = l, e.count = s?.sideCosts?.unionPaymentRaksaA, o != null && (e.price = o);
        break;
      case re.RaksaUnemploymentOnly:
        i.iban = r, i.recipientFullName = l, e.count = s?.sideCosts?.unionPaymentRaksaAoTa, o != null && (e.price = o);
        break;
    }
    this.setReferenceNumber(i, n?.employerOfficialId, n?.workerOfficialId, t);
  }
  /** Gets validation message for UnionPaymentUsecase  */
  getUcValidation(e) {
    const t = e.data || {};
    switch (t.kind === re.Other && (t.isFixedSum ? (t.kind = re.Fixed, e.price = (e.price ?? 0) * (e.count ?? 1), e.count = 1) : t.kind = re.Percentage), t.kind) {
      case re.Fixed:
        return e.price ? {
          type: "default",
          msg: "SALAXY.VALIDATION.Usecases.unionPayment.fixed"
        } : {
          type: "error",
          msg: "SALAXY.VALIDATION.Usecases.unionPayment.fixedError"
        };
      case re.Percentage:
        return e.count ? {
          type: "default",
          msg: "SALAXY.VALIDATION.Usecases.unionPayment.percentage"
        } : {
          type: "error",
          msg: "SALAXY.VALIDATION.Usecases.unionPayment.percentageError"
        };
      case re.PercentageAndLimits:
        return t?.paymentPercentage ? {
          type: "default",
          msg: "SALAXY.VALIDATION.Usecases.unionPayment.percentage"
        } : {
          type: "error",
          msg: "SALAXY.VALIDATION.Usecases.unionPayment.percentageError"
        };
      case re.RaksaNormal:
      case re.RaksaUnemploymentOnly:
        return e.count ? {
          type: "default",
          msg: "SALAXY.VALIDATION.Usecases.unionPayment.raksa"
        } : {
          type: "error",
          msg: "SALAXY.VALIDATION.Usecases.unionPayment.raksaError"
        };
      default:
        return {
          type: "error",
          msg: "SALAXY.VALIDATION.Usecases.unionPayment.default"
        };
    }
  }
  setReferenceNumber(e, t, n, i) {
    if (!i || !t || t.length > 9 || !n)
      return;
    const s = `8${n.substring(4, 6)}${n.substring(2, 4)}${n.substring(0, 1)}${n.substring(7, 10)}${n.substring(1, 2)}${c.format(i, "MM")}${t.substring(0, 7)}`, r = `${s}${this.getCheckNumber(s)}`;
    (!e.referenceNumber || e.referenceNumber.length == 20 && e.referenceNumber.substring(0, 10) == r.substring(0, 10) && e.referenceNumber.substring(12, 19) == r.substring(12, 19)) && (e.referenceNumber = r);
  }
  getCheckNumber(e) {
    if (!e)
      return "";
    const t = [7, 3, 1], n = e.split("").reverse();
    let i = 0;
    for (let s = 0; s < n.length; s++)
      i += Number.parseInt(n[s]) * t[s % 3];
    return `${(10 - i % 10) % 10}`;
  }
}
class Oo extends Q {
  /** Gets validation message*/
  getUcValidation(e) {
    const t = e.data || {};
    if (!this.getCodeData(t.kind))
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.noIrIncomeType"
      };
  }
  getCodeData(e) {
    if (e) {
      let t = 0;
      switch (e) {
        case X.EmergencyWorkCompensation:
          t = 205;
          break;
        case X.EveningWorkCompensation:
          t = 206;
          break;
        case X.EveningShiftAllowance:
          t = 207;
          break;
        case X.SaturdayPay:
          t = 211;
          break;
        case X.ExtraWorkPremium:
          t = 212;
          break;
        case X.OtherCompensation:
          t = 216;
          break;
        case X.WaitingTimeCompensation:
          t = 217;
          break;
        case X.SundayWorkCompensation:
          t = 221;
          break;
        case X.StandByCompensation:
          t = 230;
          break;
        case X.WeeklyRestCompensation:
          t = 232;
          break;
        case X.OvertimeCompensation:
          t = 235;
          break;
        case X.NightWorkAllowance:
          t = 236;
          break;
        case X.NightShiftCompensation:
          t = 237;
          break;
        case X.Undefined:
        default:
          t = 0;
          break;
      }
      return Fe.getAll().find((n) => n.code === t);
    }
  }
}
class rt {
  constructor() {
    this.hasValues = !1, this.period = {};
  }
  /**
   * Creates the RowUsecaseCalcData from a calculation.
   * @param calc Calculation that is used in the usecase.
   */
  static fromCalc(e) {
    const t = new rt();
    return e?.info && (t.hasValues = !0, t.period = {
      start: e.info.workStartDate,
      end: e.info.workEndDate,
      daysCount: e.framework?.numberOfDays
    }, e.result?.totals && (t.foreclosureSalary = (e.result.totals.totalTaxable ?? 0) - (e.result.workerCalc?.fullTax ?? 0) - (e.result.workerCalc?.fullTaxAtSource ?? 0) - (e.result.workerCalc?.fullPension ?? 0) - (e.result.workerCalc?.fullUnemploymentInsurance ?? 0), t.totalTaxable = e.result.totals.totalTaxable ?? 0), t.employerOfficialId = e.employer?.officialId, t.workerOfficialId = e.worker?.paymentData?.socialSecurityNumberValid), t;
  }
}
class La {
  /**
   * Gets a blank UserDefinedRow with typed usecase data and usecase specific default data.
   * @param type Type of the usecase for the row.
   */
  static getBlankUsecaseRow(e) {
    const t = {
      rowType: e,
      count: 1,
      accounting: {
        dimensions: []
      },
      data: {}
    };
    return this.getUsecaseLogic(e)?.updateUsecase(t, "today", void 0), t;
  }
  /**
   * Gets the usecase specific logic for a row type.
   * @param type Row type for which we should return the logic.
   * @returns Usecase logic for the row type.
   */
  static getUsecaseLogic(e) {
    switch (e) {
      case k.AbsencePeriod:
        return new co();
      case k.BicycleBenefit:
        return new po();
      case k.Board:
        return new ho();
      case k.CarBenefit:
        return new yo();
      case k.DailyAllowance:
        return new vo();
      case k.EmploymentTermination:
        return new go();
      case k.Expenses:
        return new _t();
      case k.Foreclosure:
        return new bo();
      case k.HourlySalaryWithWorkingTimeCompensation:
        return new So();
      case k.IrIncomeType:
        return new To();
      case k.MealBenefit:
        return new xo();
      case k.MilageOwnCar:
        return new Eo();
      case k.NonProfitOrg:
        return new Ao();
      case k.OtherCompensation:
        return new Po();
      case k.PaidSickLeave:
        return new wo();
      case k.PrepaidExpenses:
        return new _t();
      case k.Remuneration:
        return new Fo();
      case k.SubsidisedCommute:
        return new Do();
      case k.TotalWorkerPayment:
        return new Lo();
      case k.Training:
        return new Mo();
      case k.UnionPayment:
        return new No();
      case k.WorkingTimeCompensation:
        return new Oo();
      case k.TaxAtSource:
        return new Co();
      case k.TaxWithholding:
        return new Io();
      case k.HolidayBonus:
      case k.HolidaySalary:
      case k.HolidayCompensation:
        return new jo();
      default:
        return new fo();
    }
  }
  /**
   * Returns the grouping filter for a row type.
   * In the typical case each row in the group has the same rowType, type, kind, price, unit and message.
   * Rows in a group can be merged together.
   * @param type Row type for the grouping filter.
   * @param arr Array of rows to group. This is required for some grouping filters especially when there is no reason for grouping but each object should be in its own group.
   * @returns Filter for grouping the rows.
   */
  static getGroupingFilter(e, t) {
    switch (e) {
      case k.AbsencePeriod:
        return (n) => this.getRowKey(n, [n.data?.isPaid, n.data?.absenceCustomCode, n.data?.isHolidayAccrual], !0);
      case k.BicycleBenefit:
        return (n) => this.getRowId(n, t);
      case k.Board:
        return (n) => this.getRowKey(n);
      case k.CarBenefit:
        return (n) => this.getRowId(n, t);
      case k.DailyAllowance:
        return (n) => this.getRowKey(n, [n.data?.country, n.data?.isHalf]);
      case k.EmploymentTermination:
        return (n) => this.getRowKey(n);
      case k.Expenses:
        return (n) => this.getRowId(n, t);
      case k.Foreclosure:
        return (n) => this.getRowId(n, t);
      case k.HourlySalaryWithWorkingTimeCompensation:
        return (n) => {
          if ((n.data?.compensationRows?.length ?? 0) != 1)
            return this.getRowId(n, t);
          const i = { ...n.data?.compensationRows[0], count: void 0 };
          return this.getRowKey(n, [JSON.stringify(i), n.data?.pricing]);
        };
      case k.IrIncomeType:
        return (n) => this.getRowKey(n, [n.data?.unit, JSON.stringify(n.data?.irData)]);
      case k.MealBenefit:
        return (n) => this.getRowId(n, t);
      case k.MilageOwnCar:
        return (n) => this.getRowKey(n, [n.data?.vehicleType, n.data?.passengerCount, n.data?.additionsAllowed, n.data?.passengersAllowed, JSON.stringify(n.data?.additions)]);
      case k.NonProfitOrg:
        return (n) => this.getRowKey(n);
      case k.OtherCompensation:
        return (n) => this.getRowKey(n);
      case k.PaidSickLeave:
        return (n) => this.getRowKey(n);
      case k.PrepaidExpenses:
        return (n) => this.getRowId(n, t);
      case k.Remuneration:
        return (n) => this.getRowKey(n);
      case k.SubsidisedCommute:
        return (n) => this.getRowId(n, t);
      case k.TotalWorkerPayment:
        return (n) => this.getRowId(n, t);
      case k.Training:
        return (n) => this.getRowKey(n);
      case k.UnionPayment:
        return (n) => this.getRowId(n, t);
      case k.WorkingTimeCompensation:
        return (n) => this.getRowKey(n);
      case k.TaxAtSource:
        return (n) => this.getRowId(n, t);
      case k.TaxWithholding:
        return (n) => this.getRowId(n, t);
      case k.HolidayBonus:
      case k.HolidaySalary:
      case k.HolidayCompensation:
        return (n) => this.getRowKey(n);
      default:
        return (n) => this.getRowKey(n);
    }
  }
  /**
   * Returns usecase logic for a row and calculation.
   * @param row Row that the logic operates on.
   * @param calc Calculation that contains the row (used for date, potentially other things).
   * @param doUpdate If true, will run first updateUsecase on the row.
   */
  static getUsecaseLogicForCalc(e, t, n = !1) {
    e.rowType ?? (e.rowType = k.Unknown);
    const i = La.getUsecaseLogic(e.rowType);
    return n && i.updateUsecase(e, t?.workflow?.salaryDate ?? "today", rt.fromCalc(t)), i;
  }
  /**
   * Returns a validation message for a row or null if none is provided.
   * Does the common validations (price and count) and then runs usecase specific validations.
   * @param row The row that is validated.
   */
  static getValidation(e) {
    return e.rowType ?? (e.rowType = k.Unknown), La.getUsecaseLogic(e.rowType).getValidation(e);
  }
  /**
   * Returns example data for a specific calculation row type and optional kind.
   * Used to generate sample data for documentation and testing purposes.
   * @param rowType The type of calculation row to get example data for
   * @param kind Optional kind parameter to get specific variant of example data
   * @returns Example data object with default values for the specified row type
   */
  static getUsecaseExampleData(e, t) {
    const i = {
      [k.AbsencePeriod]: {
        kind: "undefined",
        isPaid: !0,
        isHolidayAccrual: !0
      },
      [k.BicycleBenefit]: {
        kind: "undefined",
        deduction: 100,
        taxable: 100,
        periodDivider: 1
      },
      [k.Board]: {
        kind: ln.Undefined
      },
      [k.CarBenefit]: {
        ageGroup: qt.A,
        deduction: 100,
        kind: "undefined",
        emissionsValue: 100,
        isKilometersBased: !0,
        kilometers: 100
      },
      [k.DailyAllowance]: {
        kind: "undefined",
        country: "undefined",
        isHalf: !1
      },
      [k.EmploymentTermination]: {
        kind: "undefined"
      },
      [k.Expenses]: {
        date: c.getToday(),
        vatRate: ke.Tax255,
        total: 100
      },
      [k.Foreclosure]: {
        kind: "undefined",
        referenceNumber: "RF341012"
      },
      [k.HourlySalaryWithWorkingTimeCompensation]: {
        compensationRows: [
          {
            count: null,
            percent: 0.5
          }
        ],
        kind: "undefined",
        pricing: ta.Percent
      },
      [k.IrIncomeType]: {
        irData: {},
        kind: "unknown"
      },
      [k.MealBenefit]: {
        kind: "undefined",
        deduction: 100,
        taxable: 100,
        periodDivider: 1
      },
      [k.MilageOwnCar]: {
        additionsAllowed: !0,
        passengersAllowed: !0,
        vehicleType: "car",
        additions: null
      },
      [k.NonProfitOrg]: {
        kind: "undefined"
      },
      [k.OtherCompensation]: {
        kind: "undefined"
      },
      [k.PaidSickLeave]: {
        kind: "undefined"
      },
      [k.PrepaidExpenses]: {
        date: c.getToday(),
        vatRate: ke.Tax255,
        total: 100
      },
      [k.Remuneration]: {
        kind: "undefined"
      },
      [k.SubsidisedCommute]: {
        kind: "undefined",
        deduction: 100,
        taxable: 100
      },
      [k.TotalWorkerPayment]: {
        kind: "undefined",
        rowType: e
      },
      [k.Training]: {
        kind: "undefined"
      },
      [k.UnionPayment]: {
        kind: "undefined",
        recipientFullName: "John Doe",
        iban: "FI1277124148815337",
        referenceNumber: "88104193810287782386"
      },
      [k.WorkingTimeCompensation]: {
        kind: "undefined"
      },
      [k.TaxAtSource]: {
        kind: "undefined",
        taxValue: 100,
        deductionPrice: 100,
        deductionCount: 1,
        deduction: 100,
        totalTaxable: 100
      },
      [k.TaxWithholding]: {
        kind: "undefined"
      }
    }[e];
    t && (i.kind = t);
    const s = La.getBlankUsecaseRow(e);
    return i && (s.data = i), this.getUsecaseLogic(e)?.updateUsecase(s, "today", void 0), s.data;
  }
  static getRowKey(e, t = [], n = !1) {
    const i = ["rowKey", e.rowType, e.data?.kind, this.getHarmonizedType(e), e.unit, e.price];
    return i.push(...t), n || i.push(e.message), i.join("-");
  }
  static getRowId(e, t) {
    return ["rowId", t.indexOf(e)].join("-");
  }
  static getHarmonizedType(e) {
    return e?.type ? e.type : `/builtIn/${e?.rowType}`;
  }
}
const hi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbcSection: ji,
  AbsenceCauseCode: wa,
  AbsencePeriodUsecaseLogic: co,
  Absences: ht,
  AccountSettings: Ht,
  AccountantType: Si,
  AccountingChannel: Ti,
  AccountingPeriodClosingOption: xi,
  AccountingReportRowType: Ei,
  AccountingReportTableType: ba,
  AccountingTargetLogic: cl,
  AccountingTargetStatus: Ai,
  AccountingTargets: yt,
  Accounts: qa,
  AgeGroupCode: qt,
  AgeRange: Zt,
  AjaxFetch: no,
  AllowanceCode: Pi,
  AnnualLeavePaymentKind: Ce,
  ApiCheckStatus: wi,
  ApiImportStatus: Fi,
  ApiItemType: ka,
  ApiListItemType: ya,
  ApiLogic: pl,
  ApiTestErrorType: Di,
  ApiValidationErrorType: Ae,
  Arrays: Be,
  AuthenticationMethod: Ci,
  AuthorizationPdfType: cr,
  AuthorizationStatus: Ii,
  AuthorizationType: Li,
  AuthorizedAccounts: vt,
  AvatarPictureType: We,
  BankPaymentType: Mi,
  Base64: ct,
  BaseUsecaseLogic: Q,
  BeneficialOwnersApi: Wt,
  BenefitCode: Ni,
  BicHelper: Pt,
  BicycleBenefitKind: Ge,
  BicycleBenefitUsecaseLogic: po,
  BlobFileType: Oi,
  BlobRepository: Ri,
  BoardKind: ln,
  BoardUsecaseLogic: ho,
  BootstrapStyle: Ke,
  Brand: ve,
  CalcGroup: Bi,
  CalcRowsLogic: Ga,
  CalculationFlag: Vi,
  CalculationRefresh: Ki,
  CalculationResultLogic: hl,
  CalculationResultRowType: Ui,
  CalculationRowCategories: $a,
  CalculationRowCategory: w,
  CalculationRowSource: pa,
  CalculationRowType: k,
  CalculationRowUnit: G,
  CalculationStatus: ia,
  CalculationStatusCategory: Hi,
  Calculations: Na,
  Calculator: Ma,
  CalculatorLogic: na,
  CalendarActionType: Wi,
  CalendarEventStatus: Yi,
  CalendarEvents: ft,
  CarBenefitCode: $i,
  CarBenefitKind: or,
  CarBenefitUsecaseLogic: yo,
  CellRenderingLogic: Al,
  Certificates: gt,
  Client: El,
  CompanyType: Gi,
  ConfigLogic: vr,
  Configs: pe,
  ContactPersonResponsibilityCode: mr,
  ContactType: fa,
  ContractPartyLogic: yl,
  ContractPartyType: Ka,
  Cookies: pt,
  CostAccountingDimensionScope: Ji,
  Country: Ua,
  Credentials: bt,
  CrudApiBase: _,
  Culture: Xe,
  CustomerInvoiceStatus: zi,
  CustomerInvoices: jt,
  CustomerWebApp: Xi,
  DailyAllowanceKind: Ue,
  DailyAllowanceUsecaseLogic: vo,
  DataMapper: He,
  DataMapperMember: ua,
  DataMapperSelector: ze,
  DataMappersLogic: ll,
  DatasetStatus: Qt,
  DatasetType: Zi,
  Datasets: St,
  DateOfBirthAccuracy: Qi,
  DateTimes: va,
  Dates: c,
  DefaultUsecaseLogic: fo,
  EarningsPaymentReportStatus: _i,
  EmploymentLogic: st,
  EmploymentRelationSalaryPaymentMethod: nt,
  EmploymentRelationStatus: qi,
  EmploymentRelationTaxcard: xa,
  EmploymentRelationType: B,
  EmploymentTerminationKind: ca,
  EmploymentTerminationUsecaseLogic: go,
  Employments: Ft,
  EnumerationsLogic: H,
  ExpensesUsecaseLogic: _t,
  ExpensesVatRate: ke,
  ExportLogic: ml,
  ExportMethod: ae,
  ExternalDialogData: zo,
  FileDelimiter: Ie,
  FileLogic: ul,
  FileParser: Ca,
  Files: za,
  ForeclosureKind: aa,
  ForeclosureUsecaseLogic: bo,
  FormHelpers: Va,
  FrameworkAgreement: en,
  Gender: es,
  HelpCenter: Yt,
  HelttiIndustry: as,
  HelttiProductPackage: ts,
  Holiday: rs,
  HolidayAccrualSource: os,
  HolidayBonusPaymentMethod: ls,
  HolidayCode: Ha,
  HolidayGroup: ma,
  HolidayPayCalculation: da,
  HolidayYears: Dt,
  HolidaysLogic: le,
  HolidaysUsecaseLogic: jo,
  HourlySalaryWithWorkingTimeCompensationUsecaseLogic: So,
  HouseholdUsecasesLogic: Xt,
  HouseholdYearProcessingStatus: us,
  HouseholdYearStatus: ks,
  HouseholdYears: Vt,
  HrSuuntiImportLogic: Tt,
  Iban: Ea,
  ImportBatch: kl,
  Imports: zt,
  IncomeEarnerType: Ze,
  IncomeLogDiff: ns,
  IncomeTypesLogic: Fe,
  InsuranceCompany: ms,
  InternationalIdentifier: is,
  InternationalSocialSecurityException: Wa,
  InternationalSocialSecurityType: ds,
  InvoiceDateKind: tn,
  InvoicePaymentType: cs,
  InvoiceStatus: an,
  InvoiceType: ss,
  Invoices: Xa,
  InvoicesLogic: Sa,
  IrEarningsPayments: Ct,
  IrFlags: ps,
  IrIncomeTypeUsecaseLogic: To,
  IrInsuranceExceptions: hs,
  IrPayerSummaries: It,
  IrRowSourceType: ys,
  JsonSchemaCache: Xo,
  JsonSchemaUtils: Se,
  Language: Ee,
  LegacyServiceModel: Bs,
  LegalEntityType: me,
  LocalTapiolaInsuranceOrderAuthorizationType: vs,
  LocalTapiolaInsuranceOrderStatus: fs,
  LocalTapiolaInsuranceOrderType: gs,
  MealBenefitKind: oe,
  MealBenefitUsecaseLogic: xo,
  MessageFrom: js,
  MessageThreadStatus: Ss,
  MessageThreads: Lt,
  MessageType: Ts,
  MilageOwnCarUsecaseLogic: Eo,
  NonProfitOrgKind: lr,
  NonProfitOrgUsecaseLogic: Ao,
  Numeric: h,
  OAuth2: Ja,
  OAuthError: gi,
  OAuthGrantType: yi,
  OAuthResponseType: vi,
  OAuthSalaxyAuthorizeMode: bi,
  OAuthTokenType: fi,
  OData: Z,
  Objects: fe,
  Occupations: xt,
  OnboardingLogic: gl,
  OnboardingStatus: xs,
  Onboardings: Za,
  OtherCompensationKind: ie,
  OtherCompensationUsecaseLogic: Po,
  Overview: $t,
  PaidSickLeaveKind: ur,
  PaidSickLeaveUsecaseLogic: wo,
  PartnerServices: Gt,
  PayerSummaryReportStatus: Es,
  PaymentChannel: F,
  PaymentChannelApi: Mt,
  PaymentLogic: bl,
  PaymentMethod: As,
  PaymentStatus: Ps,
  PayrollLogic: cn,
  PayrollStatus: ws,
  Payrolls: Oa,
  Payrolls4: Nt,
  PensionCalculation: R,
  PensionCompany: U,
  PensionRule: Fs,
  PeriodDateKind: Ds,
  PeriodType: it,
  PricingModel: Cs,
  ProApi: Jt,
  ProductListFilter: Ls,
  ProductPackage: Is,
  Promises: ol,
  Records: Kt,
  RecurringEventCreateMode: nn,
  ReferenceObjects: Ut,
  RemunerationKind: ea,
  RemunerationUsecaseLogic: Fo,
  ReportCategory: Ms,
  ReportType: xe,
  Reports: Qa,
  ReportsLogic: uo,
  Role: Ns,
  RoleLogic: jl,
  RowMergeOption: bs,
  RowUsecaseCalcData: rt,
  RowsUsecaseLogic: La,
  SalaryDateKind: Os,
  SalaryDateLogic: Et,
  SalaryKind: Re,
  SalaryType: Rs,
  ServiceModels: Rt,
  Session: et,
  SettingsLogic: Sl,
  SettingsStatus: Vs,
  SharingUriType: sn,
  SingleItemApiBase: mn,
  SitemapVisibility: mo,
  StagingApiConnector: lo,
  StorageLogic: ko,
  SubsidisedCommuteKind: Je,
  SubsidisedCommuteUsecaseLogic: Do,
  SxyFormsSettings: Tl,
  SystemRole: $,
  TableFormat: we,
  Tables: dn,
  TaxAtSourceKind: Oe,
  TaxAtSourceUsecaseLogic: Co,
  TaxCard2019Logic: Ta,
  TaxCardIncomeType: Hs,
  TaxDeductionWorkCategories: te,
  TaxReportHandling: Ys,
  TaxWithholdingKind: Qe,
  TaxWithholdingUsecaseLogic: Io,
  TaxcardApiIncomeType: Ks,
  TaxcardApprovalMethod: Us,
  TaxcardCalcDiffCheck: rn,
  TaxcardKind: z,
  TaxcardState: $e,
  TaxcardValidity: Ws,
  Taxcards: _a,
  TesSubtype: $s,
  Test: at,
  TestEnum: Gs,
  Texts: rl,
  ThreadedMessageType: Js,
  TimesheetInputModification: hr,
  Token: to,
  TotalWorkerPaymentKind: ga,
  TotalWorkerPaymentUsecaseLogic: Lo,
  TrainingKind: kr,
  TrainingUsecaseLogic: Mo,
  TransactionCode: Ya,
  Translations: d,
  TranslationsInstance: fr,
  TypedocLogic: At,
  UnemploymentPayrollLimitStatus: zs,
  UnionPaymentKind: re,
  UnionPaymentType: Xs,
  UnionPaymentUsecaseLogic: No,
  Unit: ce,
  UsecaseActionType: Fa,
  UsecaseStatus: _s,
  Usecases: Bt,
  UserDefinedRowLogic: xl,
  UserInfoApplicationRole: dr,
  Validation: je,
  ValidationHelper: Ia,
  VarmaPensionOrderAction: qs,
  VarmaPensionOrderYelPayer: Zs,
  VatRate: de,
  WageBasis: Qs,
  WebSiteAccountType: pr,
  WebSiteUserRole: on,
  WorkerSalaryNotification: er,
  WorkerSalarySlipDeliveryMethod: ar,
  Workers: Ot,
  WorkflowEventFeatures: tr,
  WorkflowLogic: wt,
  WorkingTimeCompensationKind: X,
  WorkingTimeCompensationPricing: ta,
  WorkingTimeCompensationUsecaseLogic: Oo,
  WorktimeApiConnector: hn,
  WorktimeImportAccrualKind: ro,
  WorktimeImportAccrualType: oo,
  WorktimeImportAccrualUnit: so,
  WorktimeImportKnownUsecase: io,
  WorktimeImportPreviewMetadata: dl,
  WorktimeImportStatus: pn,
  YearEndAdminCheck: nr,
  YearEndFeedbackCalculationType: ir,
  YearEndUserFeedback: sr,
  Years: be,
  YtjCompanyType: rr,
  accountProductDefaults: Go,
  calcRowsMetadata: Hr,
  cbaCodes: Jo,
  generatedEnumData: gr,
  generatedIrEnumData: br,
  getYearlyChangingNumbersYears: Kr,
  incomeTypeCodes: yr,
  get irepr() {
    return ut;
  },
  get irpsr() {
    return kt;
  },
  kevaEmploymentRegCodes: Ur,
  vismaSignOriginalMethods: Vr,
  yearlyHolidaysYears: Br,
  yearlyTaxFreeYears: Da
}, Symbol.toStringTag, { value: "Module" }));
class Fl {
  constructor(e) {
    this.action = e;
  }
  /** Returns true if the execution is asynchronous. Only asynchronous calls may make http requests to external resources. */
  get isAsync() {
    return this.action.actionType != Fa.ClientScript;
  }
  /**
   * Executes the current action.
   * !! IMPORTANT !! As of now, the method only supports client-side browser execution. Server-side / Node execution is not yet supported.
   * @param item The current item that the script processes.
   * @param session The current user session.
   * @param ajax Ajax object for HTTP calls.
   */
  execute(e, t, n) {
    switch (this.action.actionType) {
      case Fa.ClientScript:
        return Promise.resolve(this.executeSync(e, t));
      case Fa.ClientScriptAsync:
        return this.executeAsync(e, t, n);
      default:
        throw new Error(`Execution of action type ${this.action.actionType} is not yet supported.`);
    }
  }
  /**
   * Executes the current action as synchronous client-side (browser) code.
   * !! IMPORTANT !! As of now, the method only supports client-side browser execution. Server-side / Node execution is not yet supported.
   * @param item The current item that the script processes.
   * @param session The current user session.
   */
  executeSync(e, t) {
    if (!this.action.content)
      return this.status = Ke.Danger, this.result = `Ei skriptiä

Valitse skripti, jossa on ajettava koodia.`, !1;
    const n = this.action.content;
    this.status = Ke.Primary, this.result = "Skriptiä ajetaan...";
    const i = (s) => Function('"use strict";return (function(item, session, core){' + s + "})")()(
      e,
      t,
      hi
    );
    try {
      return this.result = i(n) || "Skripti ajettu: Palautettu arvo on tyhjä.", this.status = Ke.Success, !0;
    } catch (s) {
      return this.result = s.toString(), this.status = Ke.Danger, console.error(s), !1;
    }
  }
  /**
   * Executes the current action as asynchronous client-side (browser) code.
   * !! IMPORTANT !! As of now, the method only supports client-side browser execution. Server-side / Node execution is not yet supported.
   * @param item The current item that the script processes.
   * @param session The current user session.
   * @param ajax Ajax object for HTTP calls.
   */
  executeAsync(e, t, n) {
    if (!this.action.content)
      return this.status = Ke.Danger, this.result = `Ei skriptiä

Valitse skripti, jossa on ajettava koodia.`, Promise.resolve(!1);
    const i = this.action.content;
    this.status = Ke.Primary, this.result = "Skriptiä ajetaan...";
    const s = (r) => Function('"use strict";return (async function(item, session, ajax, core){' + r + "})")()(
      e,
      t,
      n,
      hi
    );
    try {
      return s(i).then((r) => (this.result = r || "Skripti ajettu: Palautettu arvo on tyhjä.", this.status = Ke.Success, !0)).catch((r) => (this.result = r?.toString() || "Tuntematon virhe!", this.status = Ke.Danger, !1));
    } catch (r) {
      return this.status = Ke.Danger, this.result = r.toString(), Promise.resolve(!1);
    }
  }
}
export {
  ji as AbcSection,
  wa as AbsenceCauseCode,
  co as AbsencePeriodUsecaseLogic,
  ht as Absences,
  Ht as AccountSettings,
  Si as AccountantType,
  Ti as AccountingChannel,
  xi as AccountingPeriodClosingOption,
  Ei as AccountingReportRowType,
  ba as AccountingReportTableType,
  cl as AccountingTargetLogic,
  Ai as AccountingTargetStatus,
  yt as AccountingTargets,
  qa as Accounts,
  Fl as ActionExecutor,
  qt as AgeGroupCode,
  Zt as AgeRange,
  no as AjaxFetch,
  Pi as AllowanceCode,
  Ce as AnnualLeavePaymentKind,
  wi as ApiCheckStatus,
  Fi as ApiImportStatus,
  ka as ApiItemType,
  ya as ApiListItemType,
  pl as ApiLogic,
  Di as ApiTestErrorType,
  Ae as ApiValidationErrorType,
  Be as Arrays,
  Ci as AuthenticationMethod,
  cr as AuthorizationPdfType,
  Ii as AuthorizationStatus,
  Li as AuthorizationType,
  vt as AuthorizedAccounts,
  We as AvatarPictureType,
  Mi as BankPaymentType,
  ct as Base64,
  Q as BaseUsecaseLogic,
  Wt as BeneficialOwnersApi,
  Ni as BenefitCode,
  Pt as BicHelper,
  Ge as BicycleBenefitKind,
  po as BicycleBenefitUsecaseLogic,
  Oi as BlobFileType,
  Ri as BlobRepository,
  ln as BoardKind,
  ho as BoardUsecaseLogic,
  Ke as BootstrapStyle,
  ve as Brand,
  Bi as CalcGroup,
  Ga as CalcRowsLogic,
  Vi as CalculationFlag,
  Ki as CalculationRefresh,
  hl as CalculationResultLogic,
  Ui as CalculationResultRowType,
  $a as CalculationRowCategories,
  w as CalculationRowCategory,
  pa as CalculationRowSource,
  k as CalculationRowType,
  G as CalculationRowUnit,
  ia as CalculationStatus,
  Hi as CalculationStatusCategory,
  Na as Calculations,
  Ma as Calculator,
  na as CalculatorLogic,
  Wi as CalendarActionType,
  Yi as CalendarEventStatus,
  ft as CalendarEvents,
  $i as CarBenefitCode,
  or as CarBenefitKind,
  yo as CarBenefitUsecaseLogic,
  Al as CellRenderingLogic,
  gt as Certificates,
  El as Client,
  Gi as CompanyType,
  vr as ConfigLogic,
  pe as Configs,
  mr as ContactPersonResponsibilityCode,
  fa as ContactType,
  yl as ContractPartyLogic,
  Ka as ContractPartyType,
  pt as Cookies,
  Ji as CostAccountingDimensionScope,
  Ua as Country,
  bt as Credentials,
  _ as CrudApiBase,
  Xe as Culture,
  zi as CustomerInvoiceStatus,
  jt as CustomerInvoices,
  Xi as CustomerWebApp,
  Ue as DailyAllowanceKind,
  vo as DailyAllowanceUsecaseLogic,
  He as DataMapper,
  ua as DataMapperMember,
  ze as DataMapperSelector,
  ll as DataMappersLogic,
  Qt as DatasetStatus,
  Zi as DatasetType,
  St as Datasets,
  Qi as DateOfBirthAccuracy,
  va as DateTimes,
  c as Dates,
  fo as DefaultUsecaseLogic,
  _i as EarningsPaymentReportStatus,
  st as EmploymentLogic,
  nt as EmploymentRelationSalaryPaymentMethod,
  qi as EmploymentRelationStatus,
  xa as EmploymentRelationTaxcard,
  B as EmploymentRelationType,
  ca as EmploymentTerminationKind,
  go as EmploymentTerminationUsecaseLogic,
  Ft as Employments,
  H as EnumerationsLogic,
  _t as ExpensesUsecaseLogic,
  ke as ExpensesVatRate,
  ml as ExportLogic,
  ae as ExportMethod,
  zo as ExternalDialogData,
  Ie as FileDelimiter,
  ul as FileLogic,
  Ca as FileParser,
  za as Files,
  aa as ForeclosureKind,
  bo as ForeclosureUsecaseLogic,
  Va as FormHelpers,
  en as FrameworkAgreement,
  es as Gender,
  Yt as HelpCenter,
  as as HelttiIndustry,
  ts as HelttiProductPackage,
  rs as Holiday,
  os as HolidayAccrualSource,
  ls as HolidayBonusPaymentMethod,
  Ha as HolidayCode,
  ma as HolidayGroup,
  da as HolidayPayCalculation,
  Dt as HolidayYears,
  le as HolidaysLogic,
  jo as HolidaysUsecaseLogic,
  So as HourlySalaryWithWorkingTimeCompensationUsecaseLogic,
  Xt as HouseholdUsecasesLogic,
  us as HouseholdYearProcessingStatus,
  ks as HouseholdYearStatus,
  Vt as HouseholdYears,
  Tt as HrSuuntiImportLogic,
  Ea as Iban,
  kl as ImportBatch,
  zt as Imports,
  Ze as IncomeEarnerType,
  ns as IncomeLogDiff,
  Fe as IncomeTypesLogic,
  ms as InsuranceCompany,
  is as InternationalIdentifier,
  Wa as InternationalSocialSecurityException,
  ds as InternationalSocialSecurityType,
  tn as InvoiceDateKind,
  cs as InvoicePaymentType,
  an as InvoiceStatus,
  ss as InvoiceType,
  Xa as Invoices,
  Sa as InvoicesLogic,
  Ct as IrEarningsPayments,
  ps as IrFlags,
  To as IrIncomeTypeUsecaseLogic,
  hs as IrInsuranceExceptions,
  It as IrPayerSummaries,
  ys as IrRowSourceType,
  Xo as JsonSchemaCache,
  Se as JsonSchemaUtils,
  Ee as Language,
  Bs as LegacyServiceModel,
  me as LegalEntityType,
  vs as LocalTapiolaInsuranceOrderAuthorizationType,
  fs as LocalTapiolaInsuranceOrderStatus,
  gs as LocalTapiolaInsuranceOrderType,
  oe as MealBenefitKind,
  xo as MealBenefitUsecaseLogic,
  js as MessageFrom,
  Ss as MessageThreadStatus,
  Lt as MessageThreads,
  Ts as MessageType,
  Eo as MilageOwnCarUsecaseLogic,
  lr as NonProfitOrgKind,
  Ao as NonProfitOrgUsecaseLogic,
  h as Numeric,
  Ja as OAuth2,
  gi as OAuthError,
  yi as OAuthGrantType,
  vi as OAuthResponseType,
  bi as OAuthSalaxyAuthorizeMode,
  fi as OAuthTokenType,
  Z as OData,
  fe as Objects,
  xt as Occupations,
  gl as OnboardingLogic,
  xs as OnboardingStatus,
  Za as Onboardings,
  ie as OtherCompensationKind,
  Po as OtherCompensationUsecaseLogic,
  $t as Overview,
  ur as PaidSickLeaveKind,
  wo as PaidSickLeaveUsecaseLogic,
  Gt as PartnerServices,
  Es as PayerSummaryReportStatus,
  F as PaymentChannel,
  Mt as PaymentChannelApi,
  bl as PaymentLogic,
  As as PaymentMethod,
  Ps as PaymentStatus,
  cn as PayrollLogic,
  ws as PayrollStatus,
  Oa as Payrolls,
  Nt as Payrolls4,
  R as PensionCalculation,
  U as PensionCompany,
  Fs as PensionRule,
  Ds as PeriodDateKind,
  it as PeriodType,
  Cs as PricingModel,
  Jt as ProApi,
  Ls as ProductListFilter,
  Is as ProductPackage,
  ol as Promises,
  Kt as Records,
  nn as RecurringEventCreateMode,
  Ut as ReferenceObjects,
  ea as RemunerationKind,
  Fo as RemunerationUsecaseLogic,
  Ms as ReportCategory,
  xe as ReportType,
  Qa as Reports,
  uo as ReportsLogic,
  Ns as Role,
  jl as RoleLogic,
  bs as RowMergeOption,
  rt as RowUsecaseCalcData,
  La as RowsUsecaseLogic,
  Os as SalaryDateKind,
  Et as SalaryDateLogic,
  Re as SalaryKind,
  Rs as SalaryType,
  Rt as ServiceModels,
  et as Session,
  Sl as SettingsLogic,
  Vs as SettingsStatus,
  sn as SharingUriType,
  mn as SingleItemApiBase,
  mo as SitemapVisibility,
  lo as StagingApiConnector,
  ko as StorageLogic,
  Je as SubsidisedCommuteKind,
  Do as SubsidisedCommuteUsecaseLogic,
  Tl as SxyFormsSettings,
  $ as SystemRole,
  we as TableFormat,
  dn as Tables,
  Oe as TaxAtSourceKind,
  Co as TaxAtSourceUsecaseLogic,
  Ta as TaxCard2019Logic,
  Hs as TaxCardIncomeType,
  te as TaxDeductionWorkCategories,
  Ys as TaxReportHandling,
  Qe as TaxWithholdingKind,
  Io as TaxWithholdingUsecaseLogic,
  Ks as TaxcardApiIncomeType,
  Us as TaxcardApprovalMethod,
  rn as TaxcardCalcDiffCheck,
  z as TaxcardKind,
  $e as TaxcardState,
  Ws as TaxcardValidity,
  _a as Taxcards,
  $s as TesSubtype,
  at as Test,
  Gs as TestEnum,
  rl as Texts,
  Js as ThreadedMessageType,
  hr as TimesheetInputModification,
  to as Token,
  ga as TotalWorkerPaymentKind,
  Lo as TotalWorkerPaymentUsecaseLogic,
  kr as TrainingKind,
  Mo as TrainingUsecaseLogic,
  Ya as TransactionCode,
  d as Translations,
  fr as TranslationsInstance,
  At as TypedocLogic,
  zs as UnemploymentPayrollLimitStatus,
  re as UnionPaymentKind,
  Xs as UnionPaymentType,
  No as UnionPaymentUsecaseLogic,
  ce as Unit,
  Fa as UsecaseActionType,
  _s as UsecaseStatus,
  Bt as Usecases,
  xl as UserDefinedRowLogic,
  dr as UserInfoApplicationRole,
  je as Validation,
  Ia as ValidationHelper,
  qs as VarmaPensionOrderAction,
  Zs as VarmaPensionOrderYelPayer,
  de as VatRate,
  Qs as WageBasis,
  pr as WebSiteAccountType,
  on as WebSiteUserRole,
  er as WorkerSalaryNotification,
  ar as WorkerSalarySlipDeliveryMethod,
  Ot as Workers,
  tr as WorkflowEventFeatures,
  wt as WorkflowLogic,
  X as WorkingTimeCompensationKind,
  ta as WorkingTimeCompensationPricing,
  Oo as WorkingTimeCompensationUsecaseLogic,
  hn as WorktimeApiConnector,
  ro as WorktimeImportAccrualKind,
  oo as WorktimeImportAccrualType,
  so as WorktimeImportAccrualUnit,
  io as WorktimeImportKnownUsecase,
  dl as WorktimeImportPreviewMetadata,
  pn as WorktimeImportStatus,
  nr as YearEndAdminCheck,
  ir as YearEndFeedbackCalculationType,
  sr as YearEndUserFeedback,
  be as Years,
  rr as YtjCompanyType,
  Go as accountProductDefaults,
  Hr as calcRowsMetadata,
  Jo as cbaCodes,
  gr as generatedEnumData,
  br as generatedIrEnumData,
  Kr as getYearlyChangingNumbersYears,
  yr as incomeTypeCodes,
  ut as irepr,
  kt as irpsr,
  Ur as kevaEmploymentRegCodes,
  Vr as vismaSignOriginalMethods,
  Br as yearlyHolidaysYears,
  Da as yearlyTaxFreeYears
};
//# sourceMappingURL=salaxy-lib-core.js.map
